
      var $parcel$global = globalThis;
    
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref326"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref326"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("gJCIb", function(module, exports) {

$parcel$export(module.exports, "Capacitor", () => $c2eee0a2243e654f$export$ab659bfd88afdf29);
$parcel$export(module.exports, "registerPlugin", () => $c2eee0a2243e654f$export$7612db19fb8beb1e);
$parcel$export(module.exports, "WebPlugin", () => $c2eee0a2243e654f$export$7c58ec35c4c5ea54);
$parcel$export(module.exports, "buildRequestInit", () => $c2eee0a2243e654f$export$bd53726ce92e1297);
/*! Capacitor: https://capacitorjs.com/ - MIT License */ var $c2eee0a2243e654f$export$f8972ddbe8205c4b;
(function(ExceptionCode) {
    /**
     * API is not implemented.
     *
     * This usually means the API can't be used because it is not implemented for
     * the current platform.
     */ ExceptionCode["Unimplemented"] = "UNIMPLEMENTED";
    /**
     * API is not available.
     *
     * This means the API can't be used right now because:
     *   - it is currently missing a prerequisite, such as network connectivity
     *   - it requires a particular platform or browser version
     */ ExceptionCode["Unavailable"] = "UNAVAILABLE";
})($c2eee0a2243e654f$export$f8972ddbe8205c4b || ($c2eee0a2243e654f$export$f8972ddbe8205c4b = {}));
class $c2eee0a2243e654f$export$12e569be5e83b9f4 extends Error {
    constructor(message, code, data){
        super(message);
        this.message = message;
        this.code = code;
        this.data = data;
    }
}
const $c2eee0a2243e654f$var$getPlatformId = (win)=>{
    var _a, _b;
    if (win === null || win === void 0 ? void 0 : win.androidBridge) return 'android';
    else if ((_b = (_a = win === null || win === void 0 ? void 0 : win.webkit) === null || _a === void 0 ? void 0 : _a.messageHandlers) === null || _b === void 0 ? void 0 : _b.bridge) return 'ios';
    else return 'web';
};
const $c2eee0a2243e654f$var$createCapacitor = (win)=>{
    const capCustomPlatform = win.CapacitorCustomPlatform || null;
    const cap = win.Capacitor || {};
    const Plugins = cap.Plugins = cap.Plugins || {};
    const getPlatform = ()=>{
        return capCustomPlatform !== null ? capCustomPlatform.name : $c2eee0a2243e654f$var$getPlatformId(win);
    };
    const isNativePlatform = ()=>getPlatform() !== 'web';
    const isPluginAvailable = (pluginName)=>{
        const plugin = registeredPlugins.get(pluginName);
        if (plugin === null || plugin === void 0 ? void 0 : plugin.platforms.has(getPlatform())) // JS implementation available for the current platform.
        return true;
        if (getPluginHeader(pluginName)) // Native implementation available.
        return true;
        return false;
    };
    const getPluginHeader = (pluginName)=>{
        var _a;
        return (_a = cap.PluginHeaders) === null || _a === void 0 ? void 0 : _a.find((h)=>h.name === pluginName);
    };
    const handleError = (err)=>win.console.error(err);
    const registeredPlugins = new Map();
    const registerPlugin = (pluginName, jsImplementations = {})=>{
        const registeredPlugin = registeredPlugins.get(pluginName);
        if (registeredPlugin) {
            console.warn(`Capacitor plugin "${pluginName}" already registered. Cannot register plugins twice.`);
            return registeredPlugin.proxy;
        }
        const platform = getPlatform();
        const pluginHeader = getPluginHeader(pluginName);
        let jsImplementation;
        const loadPluginImplementation = async ()=>{
            if (!jsImplementation && platform in jsImplementations) jsImplementation = typeof jsImplementations[platform] === 'function' ? jsImplementation = await jsImplementations[platform]() : jsImplementation = jsImplementations[platform];
            else if (capCustomPlatform !== null && !jsImplementation && 'web' in jsImplementations) jsImplementation = typeof jsImplementations['web'] === 'function' ? jsImplementation = await jsImplementations['web']() : jsImplementation = jsImplementations['web'];
            return jsImplementation;
        };
        const createPluginMethod = (impl, prop)=>{
            var _a, _b;
            if (pluginHeader) {
                const methodHeader = pluginHeader === null || pluginHeader === void 0 ? void 0 : pluginHeader.methods.find((m)=>prop === m.name);
                if (methodHeader) {
                    if (methodHeader.rtype === 'promise') return (options)=>cap.nativePromise(pluginName, prop.toString(), options);
                    else return (options, callback)=>cap.nativeCallback(pluginName, prop.toString(), options, callback);
                } else if (impl) return (_a = impl[prop]) === null || _a === void 0 ? void 0 : _a.bind(impl);
            } else if (impl) return (_b = impl[prop]) === null || _b === void 0 ? void 0 : _b.bind(impl);
            else throw new $c2eee0a2243e654f$export$12e569be5e83b9f4(`"${pluginName}" plugin is not implemented on ${platform}`, $c2eee0a2243e654f$export$f8972ddbe8205c4b.Unimplemented);
        };
        const createPluginMethodWrapper = (prop)=>{
            let remove;
            const wrapper = (...args)=>{
                const p = loadPluginImplementation().then((impl)=>{
                    const fn = createPluginMethod(impl, prop);
                    if (fn) {
                        const p = fn(...args);
                        remove = p === null || p === void 0 ? void 0 : p.remove;
                        return p;
                    } else throw new $c2eee0a2243e654f$export$12e569be5e83b9f4(`"${pluginName}.${prop}()" is not implemented on ${platform}`, $c2eee0a2243e654f$export$f8972ddbe8205c4b.Unimplemented);
                });
                if (prop === 'addListener') p.remove = async ()=>remove();
                return p;
            };
            // Some flair ✨
            wrapper.toString = ()=>`${prop.toString()}() { [capacitor code] }`;
            Object.defineProperty(wrapper, 'name', {
                value: prop,
                writable: false,
                configurable: false
            });
            return wrapper;
        };
        const addListener = createPluginMethodWrapper('addListener');
        const removeListener = createPluginMethodWrapper('removeListener');
        const addListenerNative = (eventName, callback)=>{
            const call = addListener({
                eventName: eventName
            }, callback);
            const remove = async ()=>{
                const callbackId = await call;
                removeListener({
                    eventName: eventName,
                    callbackId: callbackId
                }, callback);
            };
            const p = new Promise((resolve)=>call.then(()=>resolve({
                        remove: remove
                    })));
            p.remove = async ()=>{
                console.warn(`Using addListener() without 'await' is deprecated.`);
                await remove();
            };
            return p;
        };
        const proxy = new Proxy({}, {
            get (_, prop) {
                switch(prop){
                    // https://github.com/facebook/react/issues/20030
                    case '$$typeof':
                        return undefined;
                    case 'toJSON':
                        return ()=>({});
                    case 'addListener':
                        return pluginHeader ? addListenerNative : addListener;
                    case 'removeListener':
                        return removeListener;
                    default:
                        return createPluginMethodWrapper(prop);
                }
            }
        });
        Plugins[pluginName] = proxy;
        registeredPlugins.set(pluginName, {
            name: pluginName,
            proxy: proxy,
            platforms: new Set([
                ...Object.keys(jsImplementations),
                ...pluginHeader ? [
                    platform
                ] : []
            ])
        });
        return proxy;
    };
    // Add in convertFileSrc for web, it will already be available in native context
    if (!cap.convertFileSrc) cap.convertFileSrc = (filePath)=>filePath;
    cap.getPlatform = getPlatform;
    cap.handleError = handleError;
    cap.isNativePlatform = isNativePlatform;
    cap.isPluginAvailable = isPluginAvailable;
    cap.registerPlugin = registerPlugin;
    cap.Exception = $c2eee0a2243e654f$export$12e569be5e83b9f4;
    cap.DEBUG = !!cap.DEBUG;
    cap.isLoggingEnabled = !!cap.isLoggingEnabled;
    return cap;
};
const $c2eee0a2243e654f$var$initCapacitorGlobal = (win)=>win.Capacitor = $c2eee0a2243e654f$var$createCapacitor(win);
const $c2eee0a2243e654f$export$ab659bfd88afdf29 = /*#__PURE__*/ $c2eee0a2243e654f$var$initCapacitorGlobal(typeof globalThis !== 'undefined' ? globalThis : typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : {});
const $c2eee0a2243e654f$export$7612db19fb8beb1e = $c2eee0a2243e654f$export$ab659bfd88afdf29.registerPlugin;
/**
 * Base class web plugins should extend.
 */ class $c2eee0a2243e654f$export$7c58ec35c4c5ea54 {
    constructor(){
        this.listeners = {};
        this.retainedEventArguments = {};
        this.windowListeners = {};
    }
    addListener(eventName, listenerFunc) {
        let firstListener = false;
        const listeners = this.listeners[eventName];
        if (!listeners) {
            this.listeners[eventName] = [];
            firstListener = true;
        }
        this.listeners[eventName].push(listenerFunc);
        // If we haven't added a window listener for this event and it requires one,
        // go ahead and add it
        const windowListener = this.windowListeners[eventName];
        if (windowListener && !windowListener.registered) this.addWindowListener(windowListener);
        if (firstListener) this.sendRetainedArgumentsForEvent(eventName);
        const remove = async ()=>this.removeListener(eventName, listenerFunc);
        const p = Promise.resolve({
            remove: remove
        });
        return p;
    }
    async removeAllListeners() {
        this.listeners = {};
        for(const listener in this.windowListeners)this.removeWindowListener(this.windowListeners[listener]);
        this.windowListeners = {};
    }
    notifyListeners(eventName, data, retainUntilConsumed) {
        const listeners = this.listeners[eventName];
        if (!listeners) {
            if (retainUntilConsumed) {
                let args = this.retainedEventArguments[eventName];
                if (!args) args = [];
                args.push(data);
                this.retainedEventArguments[eventName] = args;
            }
            return;
        }
        listeners.forEach((listener)=>listener(data));
    }
    hasListeners(eventName) {
        var _a;
        return !!((_a = this.listeners[eventName]) === null || _a === void 0 ? void 0 : _a.length);
    }
    registerWindowListener(windowEventName, pluginEventName) {
        this.windowListeners[pluginEventName] = {
            registered: false,
            windowEventName: windowEventName,
            pluginEventName: pluginEventName,
            handler: (event)=>{
                this.notifyListeners(pluginEventName, event);
            }
        };
    }
    unimplemented(msg = 'not implemented') {
        return new $c2eee0a2243e654f$export$ab659bfd88afdf29.Exception(msg, $c2eee0a2243e654f$export$f8972ddbe8205c4b.Unimplemented);
    }
    unavailable(msg = 'not available') {
        return new $c2eee0a2243e654f$export$ab659bfd88afdf29.Exception(msg, $c2eee0a2243e654f$export$f8972ddbe8205c4b.Unavailable);
    }
    async removeListener(eventName, listenerFunc) {
        const listeners = this.listeners[eventName];
        if (!listeners) return;
        const index = listeners.indexOf(listenerFunc);
        this.listeners[eventName].splice(index, 1);
        // If there are no more listeners for this type of event,
        // remove the window listener
        if (!this.listeners[eventName].length) this.removeWindowListener(this.windowListeners[eventName]);
    }
    addWindowListener(handle) {
        window.addEventListener(handle.windowEventName, handle.handler);
        handle.registered = true;
    }
    removeWindowListener(handle) {
        if (!handle) return;
        window.removeEventListener(handle.windowEventName, handle.handler);
        handle.registered = false;
    }
    sendRetainedArgumentsForEvent(eventName) {
        const args = this.retainedEventArguments[eventName];
        if (!args) return;
        delete this.retainedEventArguments[eventName];
        args.forEach((arg)=>{
            this.notifyListeners(eventName, arg);
        });
    }
}
const $c2eee0a2243e654f$export$9ac0cb180b81cd43 = /*#__PURE__*/ $c2eee0a2243e654f$export$7612db19fb8beb1e('WebView');
/******** END WEB VIEW PLUGIN ********/ /******** COOKIES PLUGIN ********/ /**
 * Safely web encode a string value (inspired by js-cookie)
 * @param str The string value to encode
 */ const $c2eee0a2243e654f$var$encode = (str)=>encodeURIComponent(str).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
/**
 * Safely web decode a string value (inspired by js-cookie)
 * @param str The string value to decode
 */ const $c2eee0a2243e654f$var$decode = (str)=>str.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
class $c2eee0a2243e654f$var$CapacitorCookiesPluginWeb extends $c2eee0a2243e654f$export$7c58ec35c4c5ea54 {
    async getCookies() {
        const cookies = document.cookie;
        const cookieMap = {};
        cookies.split(';').forEach((cookie)=>{
            if (cookie.length <= 0) return;
            // Replace first "=" with CAP_COOKIE to prevent splitting on additional "="
            let [key, value] = cookie.replace(/=/, 'CAP_COOKIE').split('CAP_COOKIE');
            key = $c2eee0a2243e654f$var$decode(key).trim();
            value = $c2eee0a2243e654f$var$decode(value).trim();
            cookieMap[key] = value;
        });
        return cookieMap;
    }
    async setCookie(options) {
        try {
            // Safely Encoded Key/Value
            const encodedKey = $c2eee0a2243e654f$var$encode(options.key);
            const encodedValue = $c2eee0a2243e654f$var$encode(options.value);
            // Clean & sanitize options
            const expires = `; expires=${(options.expires || '').replace('expires=', '')}`; // Default is "; expires="
            const path = (options.path || '/').replace('path=', ''); // Default is "path=/"
            const domain = options.url != null && options.url.length > 0 ? `domain=${options.url}` : '';
            document.cookie = `${encodedKey}=${encodedValue || ''}${expires}; path=${path}; ${domain};`;
        } catch (error) {
            return Promise.reject(error);
        }
    }
    async deleteCookie(options) {
        try {
            document.cookie = `${options.key}=; Max-Age=0`;
        } catch (error) {
            return Promise.reject(error);
        }
    }
    async clearCookies() {
        try {
            const cookies = document.cookie.split(';') || [];
            for (const cookie of cookies)document.cookie = cookie.replace(/^ +/, '').replace(/=.*/, `=;expires=${new Date().toUTCString()};path=/`);
        } catch (error) {
            return Promise.reject(error);
        }
    }
    async clearAllCookies() {
        try {
            await this.clearCookies();
        } catch (error) {
            return Promise.reject(error);
        }
    }
}
const $c2eee0a2243e654f$export$702e5c97f7e4f579 = $c2eee0a2243e654f$export$7612db19fb8beb1e('CapacitorCookies', {
    web: ()=>new $c2eee0a2243e654f$var$CapacitorCookiesPluginWeb()
});
// UTILITY FUNCTIONS
/**
 * Read in a Blob value and return it as a base64 string
 * @param blob The blob value to convert to a base64 string
 */ const $c2eee0a2243e654f$var$readBlobAsBase64 = async (blob)=>new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onload = ()=>{
            const base64String = reader.result;
            // remove prefix "data:application/pdf;base64,"
            resolve(base64String.indexOf(',') >= 0 ? base64String.split(',')[1] : base64String);
        };
        reader.onerror = (error)=>reject(error);
        reader.readAsDataURL(blob);
    });
/**
 * Normalize an HttpHeaders map by lowercasing all of the values
 * @param headers The HttpHeaders object to normalize
 */ const $c2eee0a2243e654f$var$normalizeHttpHeaders = (headers = {})=>{
    const originalKeys = Object.keys(headers);
    const loweredKeys = Object.keys(headers).map((k)=>k.toLocaleLowerCase());
    const normalized = loweredKeys.reduce((acc, key, index)=>{
        acc[key] = headers[originalKeys[index]];
        return acc;
    }, {});
    return normalized;
};
/**
 * Builds a string of url parameters that
 * @param params A map of url parameters
 * @param shouldEncode true if you should encodeURIComponent() the values (true by default)
 */ const $c2eee0a2243e654f$var$buildUrlParams = (params, shouldEncode = true)=>{
    if (!params) return null;
    const output = Object.entries(params).reduce((accumulator, entry)=>{
        const [key, value] = entry;
        let encodedValue;
        let item;
        if (Array.isArray(value)) {
            item = '';
            value.forEach((str)=>{
                encodedValue = shouldEncode ? encodeURIComponent(str) : str;
                item += `${key}=${encodedValue}&`;
            });
            // last character will always be "&" so slice it off
            item.slice(0, -1);
        } else {
            encodedValue = shouldEncode ? encodeURIComponent(value) : value;
            item = `${key}=${encodedValue}`;
        }
        return `${accumulator}&${item}`;
    }, '');
    // Remove initial "&" from the reduce
    return output.substr(1);
};
/**
 * Build the RequestInit object based on the options passed into the initial request
 * @param options The Http plugin options
 * @param extra Any extra RequestInit values
 */ const $c2eee0a2243e654f$export$bd53726ce92e1297 = (options, extra = {})=>{
    const output = Object.assign({
        method: options.method || 'GET',
        headers: options.headers
    }, extra);
    // Get the content-type
    const headers = $c2eee0a2243e654f$var$normalizeHttpHeaders(options.headers);
    const type = headers['content-type'] || '';
    // If body is already a string, then pass it through as-is.
    if (typeof options.data === 'string') output.body = options.data;
    else if (type.includes('application/x-www-form-urlencoded')) {
        const params = new URLSearchParams();
        for (const [key, value] of Object.entries(options.data || {}))params.set(key, value);
        output.body = params.toString();
    } else if (type.includes('multipart/form-data') || options.data instanceof FormData) {
        const form = new FormData();
        if (options.data instanceof FormData) options.data.forEach((value, key)=>{
            form.append(key, value);
        });
        else for (const key of Object.keys(options.data))form.append(key, options.data[key]);
        output.body = form;
        const headers = new Headers(output.headers);
        headers.delete('content-type'); // content-type will be set by `window.fetch` to includy boundary
        output.headers = headers;
    } else if (type.includes('application/json') || typeof options.data === 'object') output.body = JSON.stringify(options.data);
    return output;
};
// WEB IMPLEMENTATION
class $c2eee0a2243e654f$var$CapacitorHttpPluginWeb extends $c2eee0a2243e654f$export$7c58ec35c4c5ea54 {
    /**
     * Perform an Http request given a set of options
     * @param options Options to build the HTTP request
     */ async request(options) {
        const requestInit = $c2eee0a2243e654f$export$bd53726ce92e1297(options, options.webFetchExtra);
        const urlParams = $c2eee0a2243e654f$var$buildUrlParams(options.params, options.shouldEncodeUrlParams);
        const url = urlParams ? `${options.url}?${urlParams}` : options.url;
        const response = await fetch(url, requestInit);
        const contentType = response.headers.get('content-type') || '';
        // Default to 'text' responseType so no parsing happens
        let { responseType: responseType = 'text' } = response.ok ? options : {};
        // If the response content-type is json, force the response to be json
        if (contentType.includes('application/json')) responseType = 'json';
        let data;
        let blob;
        switch(responseType){
            case 'arraybuffer':
            case 'blob':
                blob = await response.blob();
                data = await $c2eee0a2243e654f$var$readBlobAsBase64(blob);
                break;
            case 'json':
                data = await response.json();
                break;
            case 'document':
            case 'text':
            default:
                data = await response.text();
        }
        // Convert fetch headers to Capacitor HttpHeaders
        const headers = {};
        response.headers.forEach((value, key)=>{
            headers[key] = value;
        });
        return {
            data: data,
            headers: headers,
            status: response.status,
            url: response.url
        };
    }
    /**
     * Perform an Http GET request given a set of options
     * @param options Options to build the HTTP request
     */ async get(options) {
        return this.request(Object.assign(Object.assign({}, options), {
            method: 'GET'
        }));
    }
    /**
     * Perform an Http POST request given a set of options
     * @param options Options to build the HTTP request
     */ async post(options) {
        return this.request(Object.assign(Object.assign({}, options), {
            method: 'POST'
        }));
    }
    /**
     * Perform an Http PUT request given a set of options
     * @param options Options to build the HTTP request
     */ async put(options) {
        return this.request(Object.assign(Object.assign({}, options), {
            method: 'PUT'
        }));
    }
    /**
     * Perform an Http PATCH request given a set of options
     * @param options Options to build the HTTP request
     */ async patch(options) {
        return this.request(Object.assign(Object.assign({}, options), {
            method: 'PATCH'
        }));
    }
    /**
     * Perform an Http DELETE request given a set of options
     * @param options Options to build the HTTP request
     */ async delete(options) {
        return this.request(Object.assign(Object.assign({}, options), {
            method: 'DELETE'
        }));
    }
}
const $c2eee0a2243e654f$export$380134cb65b51303 = $c2eee0a2243e654f$export$7612db19fb8beb1e('CapacitorHttp', {
    web: ()=>new $c2eee0a2243e654f$var$CapacitorHttpPluginWeb()
});

});

parcelRegister("jcSJO", function(module, exports) {
module.exports = import("lSOyM").then(()=>parcelRequire('1Rp6h'));

});

parcelRegister("7GJAx", function(module, exports) {
module.exports = JSON.parse('{"locale":"de","countries":{"AF":"Afghanistan","EG":"\xc4gypten","AX":"\xc5land","AL":"Albanien","DZ":"Algerien","AS":"Amerikanisch-Samoa","VI":"Amerikanische Jungferninseln","AD":"Andorra","AO":"Angola","AI":"Anguilla","AQ":"Antarktis","AG":"Antigua und Barbuda","GQ":"\xc4quatorialguinea","AR":"Argentinien","AM":"Armenien","AW":"Aruba","AZ":"Aserbaidschan","ET":"\xc4thiopien","AU":"Australien","BS":"Bahamas","BH":"Bahrain","BD":"Bangladesch","BB":"Barbados","BY":"Belarus","BE":"Belgien","BZ":"Belize","BJ":"Benin","BM":"Bermuda","BT":"Bhutan","BO":"Bolivien","BQ":"Bonaire","BA":"Bosnien und Herzegowina","BW":"Botswana","BV":"Bouvetinsel","BR":"Brasilien","VG":"Britische Jungferninseln","IO":"Britisches Territorium im Indischen Ozean","BN":"Brunei Darussalam","BG":"Bulgarien","BF":"Burkina Faso","BI":"Burundi","CL":"Chile","CN":"China","CK":"Cookinseln","CR":"Costa Rica","CI":"Elfenbeink\xfcste","CW":"Cura\xe7ao","DK":"D\xe4nemark","DE":"Deutschland","DM":"Dominica","DO":"Dominikanische Republik","DJ":"Dschibuti","EC":"Ecuador","SV":"El Salvador","ER":"Eritrea","EE":"Estland","FK":"Falklandinseln","FO":"F\xe4r\xf6er","FJ":"Fidschi","FI":"Finnland","FR":"Frankreich","GF":"Franz\xf6sisch-Guayana","PF":"Franz\xf6sisch-Polynesien","TF":"Franz\xf6sische S\xfcd- und Antarktisgebiete","GA":"Gabun","GM":"Gambia","GE":"Georgien","GH":"Ghana","GI":"Gibraltar","GD":"Grenada","GR":"Griechenland","GL":"Gr\xf6nland","GP":"Guadeloupe","GU":"Guam","GT":"Guatemala","GG":"Guernsey","GN":"Guinea","GW":"Guinea-Bissau","GY":"Guyana","HT":"Haiti","HM":"Heard und McDonaldinseln","HN":"Honduras","HK":["Hongkong","Hong Kong"],"IN":"Indien","ID":"Indonesien","IM":"Insel Man","IQ":"Irak","IR":"Iran","IE":"Irland","IS":"Island","IL":"Israel","IT":"Italien","JM":"Jamaika","JP":"Japan","YE":"Jemen","JE":"Jersey","JO":"Jordanien","KY":"Kaimaninseln","KH":"Kambodscha","CM":"Kamerun","CA":"Kanada","CV":"Kap Verde","KZ":"Kasachstan","QA":"Katar","KE":"Kenia","KG":"Kirgisistan","KI":"Kiribati","CC":"Kokosinseln","CO":"Kolumbien","KM":"Komoren","CD":"Kongo","KP":"Nordkorea","KR":"S\xfcdkorea","HR":"Kroatien","CU":"Kuba","KW":"Kuwait","LA":"Laos","LS":"Lesotho","LV":"Lettland","LB":"Libanon","LR":"Liberia","LY":"Libyen","LI":"Liechtenstein","LT":"Litauen","LU":"Luxemburg","MO":"Macao","MG":"Madagaskar","MW":"Malawi","MY":"Malaysia","MV":"Malediven","ML":"Mali","MT":"Malta","MA":"Marokko","MH":"Marshallinseln","MQ":"Martinique","MR":"Mauretanien","MU":"Mauritius","YT":"Mayotte","MX":"Mexiko","FM":"Mikronesien","MD":"Moldawien","MC":"Monaco","MN":"Mongolei","ME":"Montenegro","MS":"Montserrat","MZ":"Mosambik","MM":"Myanmar","NA":"Namibia","NR":"Nauru","NP":"Nepal","NC":"Neukaledonien","NZ":"Neuseeland","NI":"Nicaragua","NL":"Niederlande","NE":"Niger","NG":"Nigeria","NU":"Niue","MK":"Nordmazedonien","MP":"N\xf6rdliche Marianen","NF":"Norfolkinsel","NO":"Norwegen","OM":"Oman","AT":"\xd6sterreich","TL":"Osttimor","PK":"Pakistan","PS":"Staat Pal\xe4stina","PW":"Palau","PA":"Panama","PG":"Papua-Neuguinea","PY":"Paraguay","PE":"Peru","PH":"Philippinen","PN":"Pitcairninseln","PL":"Polen","PT":"Portugal","PR":"Puerto Rico","TW":"Taiwan","CG":"Republik Kongo","RE":"R\xe9union","RW":"Ruanda","RO":"Rum\xe4nien","RU":["Russische F\xf6deration","Russland"],"BL":"Saint-Barth\xe9lemy","MF":"Saint-Martin","SB":"Salomonen","ZM":"Sambia","WS":"Samoa","SM":"San Marino","ST":"S\xe3o Tom\xe9 und Pr\xedncipe","SA":"Saudi-Arabien","SE":"Schweden","CH":"Schweiz","SN":"Senegal","RS":"Serbien","SC":"Seychellen","SL":"Sierra Leone","ZW":"Simbabwe","SG":"Singapur","SX":"Sint Maarten","SK":"Slowakei","SI":"Slowenien","SO":"Somalia","ES":"Spanien","LK":"Sri Lanka","SH":"St. Helena","KN":"St. Kitts und Nevis","LC":"St. Lucia","PM":"Saint-Pierre und Miquelon","VC":"St. Vincent und die Grenadinen","ZA":"S\xfcdafrika","SD":"Sudan","GS":"S\xfcdgeorgien und die S\xfcdlichen Sandwichinseln","SS":"S\xfcdsudan","SR":"Suriname","SJ":"Svalbard und Jan Mayen","SZ":"Eswatini","SY":"Syrien, Arabische Republik","TJ":"Tadschikistan","TZ":["Tansania, Vereinigte Republik","Tansania"],"TH":"Thailand","TG":"Togo","TK":"Tokelau","TO":"Tonga","TT":"Trinidad und Tobago","TD":"Tschad","CZ":["Tschechische Republik","Tschechien"],"TN":"Tunesien","TR":"T\xfcrkei","TM":"Turkmenistan","TC":"Turks- und Caicosinseln","TV":"Tuvalu","UG":"Uganda","UA":"Ukraine","HU":"Ungarn","UM":"United States Minor Outlying Islands","UY":"Uruguay","UZ":"Usbekistan","VU":"Vanuatu","VA":"Vatikanstadt","VE":"Venezuela","AE":"Vereinigte Arabische Emirate","US":["Vereinigte Staaten von Amerika","Vereinigte Staaten","USA"],"GB":["Vereinigtes K\xf6nigreich","Gro\xdfbritannien"],"VN":"Vietnam","WF":"Wallis und Futuna","CX":"Weihnachtsinsel","EH":"Westsahara","CF":"Zentralafrikanische Republik","CY":"Zypern","XK":"Kosovo"}}');

});

parcelRegister("hcrRu", function(module, exports) {
module.exports = JSON.parse('{"locale":"en","countries":{"AF":"Afghanistan","AL":"Albania","DZ":"Algeria","AS":"American Samoa","AD":"Andorra","AO":"Angola","AI":"Anguilla","AQ":"Antarctica","AG":"Antigua and Barbuda","AR":"Argentina","AM":"Armenia","AW":"Aruba","AU":"Australia","AT":"Austria","AZ":"Azerbaijan","BS":"Bahamas","BH":"Bahrain","BD":"Bangladesh","BB":"Barbados","BY":"Belarus","BE":"Belgium","BZ":"Belize","BJ":"Benin","BM":"Bermuda","BT":"Bhutan","BO":"Bolivia","BA":"Bosnia and Herzegovina","BW":"Botswana","BV":"Bouvet Island","BR":"Brazil","IO":"British Indian Ocean Territory","BN":"Brunei Darussalam","BG":"Bulgaria","BF":"Burkina Faso","BI":"Burundi","KH":"Cambodia","CM":"Cameroon","CA":"Canada","CV":"Cape Verde","KY":"Cayman Islands","CF":"Central African Republic","TD":"Chad","CL":"Chile","CN":["People\'s Republic of China","China"],"CX":"Christmas Island","CC":"Cocos (Keeling) Islands","CO":"Colombia","KM":"Comoros","CG":["Republic of the Congo","Congo"],"CD":["Democratic Republic of the Congo","Congo"],"CK":"Cook Islands","CR":"Costa Rica","CI":["Cote d\'Ivoire","C\xf4te d\'Ivoire","Ivory Coast"],"HR":"Croatia","CU":"Cuba","CY":"Cyprus","CZ":["Czech Republic","Czechia"],"DK":"Denmark","DJ":"Djibouti","DM":"Dominica","DO":"Dominican Republic","EC":"Ecuador","EG":"Egypt","SV":"El Salvador","GQ":"Equatorial Guinea","ER":"Eritrea","EE":"Estonia","ET":"Ethiopia","FK":"Falkland Islands (Malvinas)","FO":"Faroe Islands","FJ":"Fiji","FI":"Finland","FR":"France","GF":"French Guiana","PF":"French Polynesia","TF":"French Southern Territories","GA":"Gabon","GM":["Republic of The Gambia","The Gambia","Gambia"],"GE":"Georgia","DE":"Germany","GH":"Ghana","GI":"Gibraltar","GR":"Greece","GL":"Greenland","GD":"Grenada","GP":"Guadeloupe","GU":"Guam","GT":"Guatemala","GN":"Guinea","GW":"Guinea-Bissau","GY":"Guyana","HT":"Haiti","HM":"Heard Island and McDonald Islands","VA":"Holy See (Vatican City State)","HN":"Honduras","HK":"Hong Kong","HU":"Hungary","IS":"Iceland","IN":"India","ID":"Indonesia","IR":["Islamic Republic of Iran","Iran"],"IQ":"Iraq","IE":"Ireland","IL":"Israel","IT":"Italy","JM":"Jamaica","JP":"Japan","JO":"Jordan","KZ":"Kazakhstan","KE":"Kenya","KI":"Kiribati","KP":"North Korea","KR":["South Korea","Korea, Republic of","Republic of Korea"],"KW":"Kuwait","KG":"Kyrgyzstan","LA":"Lao People\'s Democratic Republic","LV":"Latvia","LB":"Lebanon","LS":"Lesotho","LR":"Liberia","LY":"Libya","LI":"Liechtenstein","LT":"Lithuania","LU":"Luxembourg","MO":"Macao","MG":"Madagascar","MW":"Malawi","MY":"Malaysia","MV":"Maldives","ML":"Mali","MT":"Malta","MH":"Marshall Islands","MQ":"Martinique","MR":"Mauritania","MU":"Mauritius","YT":"Mayotte","MX":"Mexico","FM":"Micronesia, Federated States of","MD":"Moldova, Republic of","MC":"Monaco","MN":"Mongolia","MS":"Montserrat","MA":"Morocco","MZ":"Mozambique","MM":"Myanmar","NA":"Namibia","NR":"Nauru","NP":"Nepal","NL":["Netherlands","The Netherlands","Netherlands (Kingdom of the)"],"NC":"New Caledonia","NZ":"New Zealand","NI":"Nicaragua","NE":"Niger","NG":"Nigeria","NU":"Niue","NF":"Norfolk Island","MK":["The Republic of North Macedonia","North Macedonia"],"MP":"Northern Mariana Islands","NO":"Norway","OM":"Oman","PK":"Pakistan","PW":"Palau","PS":["State of Palestine","Palestine"],"PA":"Panama","PG":"Papua New Guinea","PY":"Paraguay","PE":"Peru","PH":"Philippines","PN":["Pitcairn","Pitcairn Islands"],"PL":"Poland","PT":"Portugal","PR":"Puerto Rico","QA":"Qatar","RE":"Reunion","RO":"Romania","RU":["Russian Federation","Russia"],"RW":"Rwanda","SH":"Saint Helena","KN":"Saint Kitts and Nevis","LC":"Saint Lucia","PM":"Saint Pierre and Miquelon","VC":"Saint Vincent and the Grenadines","WS":"Samoa","SM":"San Marino","ST":"Sao Tome and Principe","SA":"Saudi Arabia","SN":"Senegal","SC":"Seychelles","SL":"Sierra Leone","SG":"Singapore","SK":"Slovakia","SI":"Slovenia","SB":"Solomon Islands","SO":"Somalia","ZA":"South Africa","GS":"South Georgia and the South Sandwich Islands","ES":"Spain","LK":"Sri Lanka","SD":"Sudan","SR":"Suriname","SJ":"Svalbard and Jan Mayen","SZ":"Eswatini","SE":"Sweden","CH":"Switzerland","SY":"Syrian Arab Republic","TW":["Taiwan, Province of China","Taiwan"],"TJ":"Tajikistan","TZ":["United Republic of Tanzania","Tanzania"],"TH":"Thailand","TL":"Timor-Leste","TG":"Togo","TK":"Tokelau","TO":"Tonga","TT":"Trinidad and Tobago","TN":"Tunisia","TR":["T\xfcrkiye","Turkey"],"TM":"Turkmenistan","TC":"Turks and Caicos Islands","TV":"Tuvalu","UG":"Uganda","UA":"Ukraine","AE":["United Arab Emirates","UAE"],"GB":["United Kingdom","UK","Great Britain"],"US":["United States of America","United States","USA","U.S.A.","US","U.S."],"UM":"United States Minor Outlying Islands","UY":"Uruguay","UZ":"Uzbekistan","VU":"Vanuatu","VE":"Venezuela","VN":"Vietnam","VG":"Virgin Islands, British","VI":"Virgin Islands, U.S.","WF":"Wallis and Futuna","EH":"Western Sahara","YE":"Yemen","ZM":"Zambia","ZW":"Zimbabwe","AX":["\xc5land Islands","Aland Islands"],"BQ":"Bonaire, Sint Eustatius and Saba","CW":"Cura\xe7ao","GG":"Guernsey","IM":"Isle of Man","JE":"Jersey","ME":"Montenegro","BL":"Saint Barth\xe9lemy","MF":"Saint Martin (French part)","RS":"Serbia","SX":"Sint Maarten (Dutch part)","SS":"South Sudan","XK":"Kosovo"}}');

});

parcelRegister("8XBG6", function(module, exports) {
module.exports = JSON.parse('{"locale":"fr","countries":{"AF":"Afghanistan","AL":"Albanie","DZ":"Alg\xe9rie","AS":"Samoa am\xe9ricaines","AD":"Andorre","AO":"Angola","AI":"Anguilla","AQ":"Antarctique","AG":"Antigua-et-Barbuda","AR":"Argentine","AM":"Arm\xe9nie","AW":"Aruba","AU":"Australie","AT":"Autriche","AZ":"Azerba\xefdjan","BS":"Bahamas","BH":"Bahre\xefn","BD":"Bangladesh","BB":"Barbade","BY":"Bi\xe9lorussie","BE":"Belgique","BZ":"Belize","BJ":"B\xe9nin","BM":"Bermudes","BT":"Bhoutan","BO":"Bolivie","BA":"Bosnie-Herz\xe9govine","BW":"Botswana","BV":"\xcele Bouvet","BR":"Br\xe9sil","IO":"Oc\xe9an Indien Britannique","BN":"Brunei Darussalam","BG":"Bulgarie","BF":"Burkina Faso","BI":"Burundi","KH":"Cambodge","CM":"Cameroun","CA":"Canada","CV":"Cap-Vert","KY":"\xceles Ca\xefmans","CF":"R\xe9publique Centrafricaine","TD":"Tchad","CL":"Chili","CN":"Chine","CX":"\xcele Christmas","CC":"\xceles Cocos","CO":"Colombie","KM":"Comores","CG":"R\xe9publique du Congo","CD":"R\xe9publique d\xe9mocratique du Congo","CK":"\xceles Cook","CR":"Costa Rica","CI":"C\xf4te-d\'Ivoire","HR":"Croatie","CU":"Cuba","CY":"Chypre","CZ":"R\xe9publique Tch\xe8que","DK":"Danemark","DJ":"Djibouti","DM":"Dominique","DO":"R\xe9publique Dominicaine","EC":"\xc9quateur","EG":"\xc9gypte","SV":"El Salvador","GQ":"Guin\xe9e \xe9quatoriale","ER":"\xc9rythr\xe9e","EE":"Estonie","ET":"\xc9thiopie","FK":"\xceles Malouines","FO":"\xceles F\xe9ro\xe9","FJ":"Fidji","FI":"Finlande","FR":"France","GF":"Guyane fran\xe7aise","PF":"Polyn\xe9sie fran\xe7aise","TF":"Terres australes fran\xe7aises","GA":"Gabon","GM":"Gambie","GE":"G\xe9orgie","DE":"Allemagne","GH":"Ghana","GI":"Gibraltar","GR":"Gr\xe8ce","GL":"Groenland","GD":"Grenade","GP":"Guadeloupe","GU":"Guam","GT":"Guatemala","GN":"Guin\xe9e","GW":"Guin\xe9e-Bissau","GY":"Guyana","HT":"Ha\xefti","HM":"\xceles Heard-et-MacDonald","VA":"Saint-Si\xe8ge (Vatican)","HN":"Honduras","HK":"Hong Kong","HU":"Hongrie","IS":"Islande","IN":"Inde","ID":"Indon\xe9sie","IR":"Iran","IQ":"Irak","IE":"Irlande","IL":"Isra\xebl","IT":"Italie","JM":"Jama\xefque","JP":"Japon","JO":"Jordanie","KZ":"Kazakhstan","KE":"Kenya","KI":"Kiribati","KP":"Cor\xe9e du Nord","KR":"Cor\xe9e du Sud","KW":"Kowe\xeft","KG":"Kirghizistan","LA":"Laos","LV":"Lettonie","LB":"Liban","LS":"Lesotho","LR":"Lib\xe9ria","LY":"Libye","LI":"Liechtenstein","LT":"Lituanie","LU":"Luxembourg","MO":"Macao","MK":"Mac\xe9doine du Nord","MG":"Madagascar","MW":"Malawi","MY":"Malaisie","MV":"Maldives","ML":"Mali","MT":"Malte","MH":"\xceles Marshall","MQ":"Martinique","MR":"Mauritanie","MU":"Maurice","YT":"Mayotte","MX":"Mexique","FM":"Micron\xe9sie","MD":"Moldavie","MC":"Monaco","MN":"Mongolie","MS":"Montserrat","MA":"Maroc","MZ":"Mozambique","MM":"Myanmar","NA":"Namibie","NR":"Nauru","NP":"N\xe9pal","NL":"Pays-Bas","NC":"Nouvelle-Cal\xe9donie","NZ":"Nouvelle-Z\xe9lande","NI":"Nicaragua","NE":"Niger","NG":"Nig\xe9ria","NU":"Niu\xe9","NF":"\xcele Norfolk","MP":"\xceles Mariannes du Nord","NO":"Norv\xe8ge","OM":"Oman","PK":"Pakistan","PW":"Palaos","PS":"Palestine","PA":"Panama","PG":"Papouasie-Nouvelle-Guin\xe9e","PY":"Paraguay","PE":"P\xe9rou","PH":"Philippines","PN":"\xceles Pitcairn","PL":"Pologne","PT":"Portugal","PR":"Porto Rico","QA":"Qatar","RE":"R\xe9union","RO":"Roumanie","RU":"Russie","RW":"Rwanda","SH":"Sainte-H\xe9l\xe8ne","KN":"Saint-Christophe-et-Ni\xe9v\xe8s","LC":"Sainte-Lucie","PM":"Saint-Pierre-et-Miquelon","VC":"Saint-Vincent-et-les-Grenadines","WS":"Samoa","SM":"Saint-Marin","ST":"S\xe3o Tom\xe9-et-Principe","SA":"Arabie Saoudite","SN":"S\xe9n\xe9gal","SC":"Seychelles","SL":"Sierra Leone","SG":"Singapour","SK":"Slovaquie","SI":"Slov\xe9nie","SB":"\xceles Salomon","SO":"Somalie","ZA":"Afrique du Sud","GS":"G\xe9orgie du Sud-et-les \xceles Sandwich du Sud","ES":"Espagne","LK":"Sri Lanka","SD":"Soudan","SR":"Suriname","SJ":"Svalbard et \xcele Jan Mayen","SZ":"Royaume d\'Eswatini","SE":"Su\xe8de","CH":"Suisse","SY":"Syrie","TW":"Ta\xefwan","TJ":"Tadjikistan","TZ":"R\xe9publique unie de Tanzanie","TH":"Tha\xeflande","TL":"Timor-Leste","TG":"Togo","TK":"Tokelau","TO":"Tonga","TT":"Trinit\xe9-et-Tobago","TN":"Tunisie","TR":"Turquie","TM":"Turkm\xe9nistan","TC":"\xceles Turques-et-Ca\xefques","TV":"Tuvalu","UG":"Ouganda","UA":"Ukraine","AE":"\xc9mirats Arabes Unis","GB":"Royaume-Uni","US":"\xc9tats-Unis d\'Am\xe9rique","UM":"\xceles mineures \xe9loign\xe9es des \xc9tats-Unis","UY":"Uruguay","UZ":"Ouzb\xe9kistan","VU":"Vanuatu","VE":"Venezuela","VN":"Vietnam","VG":"\xceles vierges britanniques","VI":"\xceles vierges am\xe9ricaines","WF":"Wallis-et-Futuna","EH":"Sahara occidental","YE":"Y\xe9men","ZM":"Zambie","ZW":"Zimbabwe","AX":"\xc5land","BQ":"Bonaire, Saint-Eustache et Saba","CW":"Cura\xe7ao","GG":"Guernesey","IM":"\xcele de Man","JE":"Jersey","ME":"Mont\xe9n\xe9gro","BL":"Saint-Barth\xe9lemy","MF":"Saint-Martin (partie fran\xe7aise)","RS":"Serbie","SX":"Saint-Martin (partie n\xe9erlandaise)","SS":"Soudan du Sud","XK":"Kosovo"}}');

});

parcelRegister("9Vuew", function(module, exports) {
module.exports = JSON.parse('{"locale":"sv","countries":{"AD":"Andorra","AE":"F\xf6renade Arabemiraten","AF":"Afghanistan","AG":"Antigua och Barbuda","AI":"Anguilla","AL":"Albanien","AM":"Armenien","AO":"Angola","AQ":"Antarktis","AR":"Argentina","AS":"Amerikanska Samoa","AT":"\xd6sterrike","AU":"Australien","AW":"Aruba","AX":"\xc5land","AZ":"Azerbajdzjan","BA":"Bosnien och Hercegovina","BB":"Barbados","BD":"Bangladesh","BE":"Belgien","BF":"Burkina Faso","BG":"Bulgarien","BH":"Bahrain","BI":"Burundi","BJ":"Benin","BL":"Saint-Barth\xe9lemy","BM":"Bermuda","BN":"Brunei","BO":"Bolivia","BQ":"Bonaire, Saint Eustatius och Saba","BR":"Brasilien","BS":"Bahamas","BT":"Bhutan","BV":"Bouvet\xf6n","BW":"Botswana","BY":"Belarus","BZ":"Belize","CA":"Kanada","CC":"Kokos\xf6arna","CD":"Demokratiska republiken Kongo","CF":"Centralafrikanska republiken","CG":"Kongo-Brazzaville","CH":"Schweiz","CI":"Elfenbenskusten","CK":"Cook\xf6arna","CL":"Chile","CM":"Kamerun","CN":"Kina","CO":"Colombia","CR":"Costa Rica","CU":"Kuba","CV":"Kap Verde","CW":"Curacao","CX":"Jul\xf6n","CY":"Cypern","CZ":"Tjeckien","DE":"Tyskland","DJ":"Djibouti","DK":"Danmark","DM":"Dominica","DO":"Dominikanska republiken","DZ":"Algeriet","EC":"Ecuador","EE":"Estland","EG":"Egypten","EH":"V\xe4stsahara","ER":"Eritrea","ES":"Spanien","ET":"Etiopien","FI":"Finland","FJ":"Fiji","FK":"Falklands\xf6arna","FM":"Mikronesiska federationen","FO":"F\xe4r\xf6arna","FR":"Frankrike","GA":"Gabon","GB":"Storbritannien","GD":"Grenada","GE":"Georgien","GF":"Franska Guyana","GG":"Guernsey","GH":"Ghana","GI":"Gibraltar","GL":"Gr\xf6nland","GM":"Gambia","GN":"Guinea","GP":"Guadeloupe","GQ":"Ekvatorialguinea","GR":"Grekland","GS":"Sydgeorgien och Sydsandwich\xf6arna","GT":"Guatemala","GU":"Guam","GW":"Guinea Bissau","GY":"Guyana","HK":"Hongkong","HM":"Heard- och McDonalds\xf6arna","HN":"Honduras","HR":"Kroatien","HT":"Haiti","HU":"Ungern","ID":"Indonesien","IE":"Irland","IL":"Israel","IM":"Isle of Man","IN":"Indien","IO":"Brittiska territoriet i Indiska Oceanen","IQ":"Irak","IR":"Iran","IS":"Island","IT":"Italien","JE":"Jersey","JM":"Jamaica","JO":"Jordanien","JP":"Japan","KE":"Kenya","KG":"Kirgizistan","KH":"Kambodja","KI":"Kiribati","KM":"Komorerna","KN":"Saint Kitts och Nevis","KP":"Nordkorea","KR":"Sydkorea","KW":"Kuwait","KY":"Cayman\xf6arna","KZ":"Kazakstan","LA":"Laos","LB":"Libanon","LC":"Saint Lucia","LI":"Liechtenstein","LK":"Sri Lanka","LR":"Liberia","LS":"Lesotho","LT":"Litauen","LU":"Luxemburg","LV":"Lettland","LY":"Libyen","MA":"Marocko","MC":"Monaco","MD":"Moldavien","ME":"Montenegro","MF":"Saint Martin (franska delen)","MG":"Madagaskar","MH":"Marshall\xf6arna","MK":"Nordmakedonien","ML":"Mali","MM":"Burma","MN":"Mongoliet","MO":"Macau","MP":"Nordmarianerna","MQ":"Martinique","MR":"Mauretanien","MS":"Montserrat","MT":"Malta","MU":"Mauritius","MV":"Maldiverna","MW":"Malawi","MX":"Mexiko","MY":"Malaysia","MZ":"Mo\xe7ambique","NA":"Namibia","NC":"Nya Kaledonien","NE":"Niger","NF":"Norfolk\xf6n","NG":"Nigeria","NI":"Nicaragua","NL":"Nederl\xe4nderna","NO":"Norge","NP":"Nepal","NR":"Nauru","NU":"Niue","NZ":"Nya Zeeland","OM":"Oman","PA":"Panama","PE":"Peru","PF":"Franska Polynesien","PG":"Papua Nya Guinea","PH":"Filippinerna","PK":"Pakistan","PL":"Polen","PM":"Saint-Pierre och Miquelon","PN":"Pitcairn\xf6arna","PR":"Puerto Rico","PS":"Palestinska territoriet, ockuperade","PT":"Portugal","PW":"Palau","PY":"Paraguay","QA":"Qatar","RE":"R\xe9union","RO":"Rum\xe4nien","RS":"Serbien","RU":"Ryssland","RW":"Rwanda","SA":"Saudiarabien","SB":"Salomon\xf6arna","SC":"Seychellerna","SD":"Sudan","SE":"Sverige","SG":"Singapore","SH":"Sankta Helena","SI":"Slovenien","SJ":"Svalbard och Jan Mayen","SK":"Slovakien","SL":"Sierra Leone","SM":"San Marino","SN":"Senegal","SO":"Somalia","SR":"Surinam","SS":"Sydsudan","ST":"S\xe3o Tom\xe9 och Pr\xedncipe","SV":"El Salvador","SX":"Sint Maarten (nederl\xe4ndska delen)","SY":"Syrien","SZ":"Eswatini","TC":"Turks- och Caicos\xf6arna","TD":"Tchad","TF":"Franska s\xf6dra territorierna","TG":"Togo","TH":"Thailand","TJ":"Tadzjikistan","TK":"Tokelau\xf6arna","TL":"\xd6sttimor","TM":"Turkmenistan","TN":"Tunisien","TO":"Tonga","TR":"Turkiet","TT":"Trinidad och Tobago","TV":"Tuvalu","TW":"Taiwan","TZ":"Tanzania","UA":"Ukraina","UG":"Uganda","UM":"USA:s yttre \xf6ar","US":"USA","UY":"Uruguay","UZ":"Uzbekistan","VA":"Vatikanstaten","VC":"Saint Vincent och Grenadinerna","VE":"Venezuela","VG":"Brittiska Jungfru\xf6arna","VI":"Amerikanska Jungfru\xf6arna","VN":"Vietnam","VU":"Vanuatu","WF":"Wallis- och Futuna\xf6arna","WS":"Samoa","YE":"Jemen","YT":"Mayotte","ZA":"Sydafrika","ZM":"Zambia","ZW":"Zimbabwe","XK":"Kosovo"}}');

});

parcelRegister("b9oFS", function(module, exports) {

module.exports = (parcelRequire("fFMZG"))(import.meta.resolve("2Fh3c"));

});
parcelRegister("fFMZG", function(module, exports) {
"use strict";

var $lovBw = parcelRequire("lovBw");
module.exports = $lovBw(function(bundle) {
    return new Promise(function(resolve, reject) {
        if (typeof document === 'undefined') return resolve();
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName('link');
        if (Array.from(existingLinks).some(function(existing) {
            return existing.href === link.href && existing.rel.indexOf('stylesheet') > -1;
        })) {
            resolve();
            return;
        }
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

});
parcelRegister("lovBw", function(module, exports) {
"use strict";
var $f9345ad2c034f768$var$cachedBundles = {};
var $f9345ad2c034f768$var$cachedPreloads = {};
var $f9345ad2c034f768$var$cachedPrefetches = {};
function $f9345ad2c034f768$var$getCache(type) {
    switch(type){
        case 'preload':
            return $f9345ad2c034f768$var$cachedPreloads;
        case 'prefetch':
            return $f9345ad2c034f768$var$cachedPrefetches;
        default:
            return $f9345ad2c034f768$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $f9345ad2c034f768$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("eXXR9", function(module, exports) {

module.exports = (parcelRequire("fFMZG"))(import.meta.resolve("8PMgy"));

});

parcelRegister("34ADT", function(module, exports) {
module.exports = import("jChak").then(()=>parcelRequire('a1pAY'));

});

parcelRegister("dwEVR", function(module, exports) {
module.exports = import("jzBHo").then(()=>parcelRequire('92ASX'));

});

parcelRegister("bNWYI", function(module, exports) {

$parcel$export(module.exports, "CapacitorBarcodeScannerCameraDirection", () => $898205258e1839e0$export$f34958d27362dde5);
$parcel$export(module.exports, "CapacitorBarcodeScannerScanOrientation", () => $898205258e1839e0$export$8f4ecd5312ce6f96);
$parcel$export(module.exports, "CapacitorBarcodeScannerTypeHint", () => $898205258e1839e0$export$393350ce6089fc7b);
$parcel$export(module.exports, "CapacitorBarcodeScannerAndroidScanningLibrary", () => $898205258e1839e0$export$c336f13cf125f6b);
parcelRequire("5Tkph");
var $a3hi8 = parcelRequire("a3hi8");
var $898205258e1839e0$export$f34958d27362dde5;
(function(CapacitorBarcodeScannerCameraDirection) {
    CapacitorBarcodeScannerCameraDirection[CapacitorBarcodeScannerCameraDirection["BACK"] = 1] = "BACK";
    CapacitorBarcodeScannerCameraDirection[CapacitorBarcodeScannerCameraDirection["FRONT"] = 2] = "FRONT";
})($898205258e1839e0$export$f34958d27362dde5 || ($898205258e1839e0$export$f34958d27362dde5 = {}));
var $898205258e1839e0$export$8f4ecd5312ce6f96;
(function(CapacitorBarcodeScannerScanOrientation) {
    CapacitorBarcodeScannerScanOrientation[CapacitorBarcodeScannerScanOrientation["PORTRAIT"] = 1] = "PORTRAIT";
    CapacitorBarcodeScannerScanOrientation[CapacitorBarcodeScannerScanOrientation["LANDSCAPE"] = 2] = "LANDSCAPE";
    CapacitorBarcodeScannerScanOrientation[CapacitorBarcodeScannerScanOrientation["ADAPTIVE"] = 3] = "ADAPTIVE";
})($898205258e1839e0$export$8f4ecd5312ce6f96 || ($898205258e1839e0$export$8f4ecd5312ce6f96 = {}));
var $898205258e1839e0$export$284eac3445f9ecff;
(function(CapacitorBarcodeScannerTypeHintALLOption) {
    CapacitorBarcodeScannerTypeHintALLOption[CapacitorBarcodeScannerTypeHintALLOption["ALL"] = 17] = "ALL";
})($898205258e1839e0$export$284eac3445f9ecff || ($898205258e1839e0$export$284eac3445f9ecff = {}));
const $898205258e1839e0$export$393350ce6089fc7b = Object.assign(Object.assign({}, (0, $a3hi8.Html5QrcodeSupportedFormats)), $898205258e1839e0$export$284eac3445f9ecff);
var $898205258e1839e0$export$c336f13cf125f6b;
(function(CapacitorBarcodeScannerAndroidScanningLibrary) {
    CapacitorBarcodeScannerAndroidScanningLibrary["ZXING"] = "zxing";
    CapacitorBarcodeScannerAndroidScanningLibrary["MLKIT"] = "mlkit";
})($898205258e1839e0$export$c336f13cf125f6b || ($898205258e1839e0$export$c336f13cf125f6b = {}));

});
parcelRegister("5Tkph", function(module, exports) {

$parcel$export(module.exports, "Html5Qrcode", () => (parcelRequire("jY10E")).Html5Qrcode);
$parcel$export(module.exports, "Html5QrcodeSupportedFormats", () => (parcelRequire("a3hi8")).Html5QrcodeSupportedFormats);

var $jY10E = parcelRequire("jY10E");

var $bfh1Q = parcelRequire("bfh1Q");

var $a3hi8 = parcelRequire("a3hi8");

var $lkAMB = parcelRequire("lkAMB");

});
parcelRegister("jY10E", function(module, exports) {

$parcel$export(module.exports, "Html5Qrcode", () => $e894676346bfa3f2$export$e14ced7bffd8eb7a);

var $a3hi8 = parcelRequire("a3hi8");

var $45mrT = parcelRequire("45mrT");

var $135IS = parcelRequire("135IS");

var $11SAK = parcelRequire("11SAK");

var $6tR4m = parcelRequire("6tR4m");

var $ffdwa = parcelRequire("ffdwa");

var $lkAMB = parcelRequire("lkAMB");
var $e894676346bfa3f2$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $e894676346bfa3f2$var$Constants = function(_super) {
    $e894676346bfa3f2$var$__extends(Constants, _super);
    function Constants() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Constants.DEFAULT_WIDTH = 300;
    Constants.DEFAULT_WIDTH_OFFSET = 2;
    Constants.FILE_SCAN_MIN_HEIGHT = 300;
    Constants.FILE_SCAN_HIDDEN_CANVAS_PADDING = 100;
    Constants.MIN_QR_BOX_SIZE = 50;
    Constants.SHADED_LEFT = 1;
    Constants.SHADED_RIGHT = 2;
    Constants.SHADED_TOP = 3;
    Constants.SHADED_BOTTOM = 4;
    Constants.SHADED_REGION_ELEMENT_ID = "qr-shaded-region";
    Constants.VERBOSE = false;
    Constants.BORDER_SHADER_DEFAULT_COLOR = "#ffffff";
    Constants.BORDER_SHADER_MATCH_COLOR = "rgb(90, 193, 56)";
    return Constants;
}((0, $a3hi8.Html5QrcodeConstants));
var $e894676346bfa3f2$var$InternalHtml5QrcodeConfig = function() {
    function InternalHtml5QrcodeConfig(config, logger) {
        this.logger = logger;
        this.fps = $e894676346bfa3f2$var$Constants.SCAN_DEFAULT_FPS;
        if (!config) this.disableFlip = $e894676346bfa3f2$var$Constants.DEFAULT_DISABLE_FLIP;
        else {
            if (config.fps) this.fps = config.fps;
            this.disableFlip = config.disableFlip === true;
            this.qrbox = config.qrbox;
            this.aspectRatio = config.aspectRatio;
            this.videoConstraints = config.videoConstraints;
        }
    }
    InternalHtml5QrcodeConfig.prototype.isMediaStreamConstraintsValid = function() {
        if (!this.videoConstraints) {
            this.logger.logError("Empty videoConstraints", true);
            return false;
        }
        return (0, $135IS.VideoConstraintsUtil).isMediaStreamConstraintsValid(this.videoConstraints, this.logger);
    };
    InternalHtml5QrcodeConfig.prototype.isShadedBoxEnabled = function() {
        return !(0, $a3hi8.isNullOrUndefined)(this.qrbox);
    };
    InternalHtml5QrcodeConfig.create = function(config, logger) {
        return new InternalHtml5QrcodeConfig(config, logger);
    };
    return InternalHtml5QrcodeConfig;
}();
var $e894676346bfa3f2$export$e14ced7bffd8eb7a = function() {
    function Html5Qrcode(elementId, configOrVerbosityFlag) {
        this.element = null;
        this.canvasElement = null;
        this.scannerPausedUiElement = null;
        this.hasBorderShaders = null;
        this.borderShaders = null;
        this.qrMatch = null;
        this.renderedCamera = null;
        this.qrRegion = null;
        this.context = null;
        this.lastScanImageFile = null;
        this.isScanning = false;
        if (!document.getElementById(elementId)) throw "HTML Element with id=".concat(elementId, " not found");
        this.elementId = elementId;
        this.verbose = false;
        var experimentalFeatureConfig;
        var configObject;
        if (typeof configOrVerbosityFlag == "boolean") this.verbose = configOrVerbosityFlag === true;
        else if (configOrVerbosityFlag) {
            configObject = configOrVerbosityFlag;
            this.verbose = configObject.verbose === true;
            experimentalFeatureConfig = configObject.experimentalFeatures;
        }
        this.logger = new (0, $a3hi8.BaseLoggger)(this.verbose);
        this.qrcode = new (0, $11SAK.Html5QrcodeShim)(this.getSupportedFormats(configOrVerbosityFlag), this.getUseBarCodeDetectorIfSupported(configObject), this.verbose, this.logger);
        this.foreverScanTimeout;
        this.shouldScan = true;
        this.stateManagerProxy = (0, $lkAMB.StateManagerFactory).create();
    }
    Html5Qrcode.prototype.start = function(cameraIdOrConfig, configuration, qrCodeSuccessCallback, qrCodeErrorCallback) {
        var _this = this;
        if (!cameraIdOrConfig) throw "cameraIdOrConfig is required";
        if (!qrCodeSuccessCallback || typeof qrCodeSuccessCallback != "function") throw "qrCodeSuccessCallback is required and should be a function.";
        var qrCodeErrorCallbackInternal;
        if (qrCodeErrorCallback) qrCodeErrorCallbackInternal = qrCodeErrorCallback;
        else qrCodeErrorCallbackInternal = this.verbose ? this.logger.log : function() {};
        var internalConfig = $e894676346bfa3f2$var$InternalHtml5QrcodeConfig.create(configuration, this.logger);
        this.clearElement();
        var videoConstraintsAvailableAndValid = false;
        if (internalConfig.videoConstraints) {
            if (!internalConfig.isMediaStreamConstraintsValid()) this.logger.logError("'videoConstraints' is not valid 'MediaStreamConstraints, it will be ignored.'", true);
            else videoConstraintsAvailableAndValid = true;
        }
        var areVideoConstraintsEnabled = videoConstraintsAvailableAndValid;
        var element = document.getElementById(this.elementId);
        var rootElementWidth = element.clientWidth ? element.clientWidth : $e894676346bfa3f2$var$Constants.DEFAULT_WIDTH;
        element.style.position = "relative";
        this.shouldScan = true;
        this.element = element;
        var $this = this;
        var toScanningStateChangeTransaction = this.stateManagerProxy.startTransition((0, $lkAMB.Html5QrcodeScannerState).SCANNING);
        return new Promise(function(resolve, reject) {
            var videoConstraints = areVideoConstraintsEnabled ? internalConfig.videoConstraints : $this.createVideoConstraints(cameraIdOrConfig);
            if (!videoConstraints) {
                toScanningStateChangeTransaction.cancel();
                reject("videoConstraints should be defined");
                return;
            }
            var cameraRenderingOptions = {};
            if (!areVideoConstraintsEnabled || internalConfig.aspectRatio) cameraRenderingOptions.aspectRatio = internalConfig.aspectRatio;
            var renderingCallbacks = {
                onRenderSurfaceReady: function(viewfinderWidth, viewfinderHeight) {
                    $this.setupUi(viewfinderWidth, viewfinderHeight, internalConfig);
                    $this.isScanning = true;
                    $this.foreverScan(internalConfig, qrCodeSuccessCallback, qrCodeErrorCallbackInternal);
                }
            };
            (0, $6tR4m.CameraFactory).failIfNotSupported().then(function(factory) {
                factory.create(videoConstraints).then(function(camera) {
                    return camera.render(_this.element, cameraRenderingOptions, renderingCallbacks).then(function(renderedCamera) {
                        $this.renderedCamera = renderedCamera;
                        toScanningStateChangeTransaction.execute();
                        resolve(null);
                    }).catch(function(error) {
                        toScanningStateChangeTransaction.cancel();
                        reject(error);
                    });
                }).catch(function(error) {
                    toScanningStateChangeTransaction.cancel();
                    reject((0, $45mrT.Html5QrcodeStrings).errorGettingUserMedia(error));
                });
            }).catch(function(_) {
                toScanningStateChangeTransaction.cancel();
                reject((0, $45mrT.Html5QrcodeStrings).cameraStreamingNotSupported());
            });
        });
    };
    Html5Qrcode.prototype.pause = function(shouldPauseVideo) {
        if (!this.stateManagerProxy.isStrictlyScanning()) throw "Cannot pause, scanner is not scanning.";
        this.stateManagerProxy.directTransition((0, $lkAMB.Html5QrcodeScannerState).PAUSED);
        this.showPausedState();
        if ((0, $a3hi8.isNullOrUndefined)(shouldPauseVideo) || shouldPauseVideo !== true) shouldPauseVideo = false;
        if (shouldPauseVideo && this.renderedCamera) this.renderedCamera.pause();
    };
    Html5Qrcode.prototype.resume = function() {
        if (!this.stateManagerProxy.isPaused()) throw "Cannot result, scanner is not paused.";
        if (!this.renderedCamera) throw "renderedCamera doesn't exist while trying resume()";
        var $this = this;
        var transitionToScanning = function() {
            $this.stateManagerProxy.directTransition((0, $lkAMB.Html5QrcodeScannerState).SCANNING);
            $this.hidePausedState();
        };
        if (!this.renderedCamera.isPaused()) {
            transitionToScanning();
            return;
        }
        this.renderedCamera.resume(function() {
            transitionToScanning();
        });
    };
    Html5Qrcode.prototype.getState = function() {
        return this.stateManagerProxy.getState();
    };
    Html5Qrcode.prototype.stop = function() {
        var _this = this;
        if (!this.stateManagerProxy.isScanning()) throw "Cannot stop, scanner is not running or paused.";
        var toStoppedStateTransaction = this.stateManagerProxy.startTransition((0, $lkAMB.Html5QrcodeScannerState).NOT_STARTED);
        this.shouldScan = false;
        if (this.foreverScanTimeout) clearTimeout(this.foreverScanTimeout);
        var removeQrRegion = function() {
            if (!_this.element) return;
            var childElement = document.getElementById($e894676346bfa3f2$var$Constants.SHADED_REGION_ELEMENT_ID);
            if (childElement) _this.element.removeChild(childElement);
        };
        var $this = this;
        return this.renderedCamera.close().then(function() {
            $this.renderedCamera = null;
            if ($this.element) {
                $this.element.removeChild($this.canvasElement);
                $this.canvasElement = null;
            }
            removeQrRegion();
            if ($this.qrRegion) $this.qrRegion = null;
            if ($this.context) $this.context = null;
            toStoppedStateTransaction.execute();
            $this.hidePausedState();
            $this.isScanning = false;
            return Promise.resolve();
        });
    };
    Html5Qrcode.prototype.scanFile = function(imageFile, showImage) {
        return this.scanFileV2(imageFile, showImage).then(function(html5qrcodeResult) {
            return html5qrcodeResult.decodedText;
        });
    };
    Html5Qrcode.prototype.scanFileV2 = function(imageFile, showImage) {
        var _this = this;
        if (!imageFile || !(imageFile instanceof File)) throw "imageFile argument is mandatory and should be instance of File. Use 'event.target.files[0]'.";
        if ((0, $a3hi8.isNullOrUndefined)(showImage)) showImage = true;
        if (!this.stateManagerProxy.canScanFile()) throw "Cannot start file scan - ongoing camera scan";
        return new Promise(function(resolve, reject) {
            _this.possiblyCloseLastScanImageFile();
            _this.clearElement();
            _this.lastScanImageFile = URL.createObjectURL(imageFile);
            var inputImage = new Image;
            inputImage.onload = function() {
                var imageWidth = inputImage.width;
                var imageHeight = inputImage.height;
                var element = document.getElementById(_this.elementId);
                var containerWidth = element.clientWidth ? element.clientWidth : $e894676346bfa3f2$var$Constants.DEFAULT_WIDTH;
                var containerHeight = Math.max(element.clientHeight ? element.clientHeight : imageHeight, $e894676346bfa3f2$var$Constants.FILE_SCAN_MIN_HEIGHT);
                var config = _this.computeCanvasDrawConfig(imageWidth, imageHeight, containerWidth, containerHeight);
                if (showImage) {
                    var visibleCanvas = _this.createCanvasElement(containerWidth, containerHeight, "qr-canvas-visible");
                    visibleCanvas.style.display = "inline-block";
                    element.appendChild(visibleCanvas);
                    var context_1 = visibleCanvas.getContext("2d");
                    if (!context_1) throw "Unable to get 2d context from canvas";
                    context_1.canvas.width = containerWidth;
                    context_1.canvas.height = containerHeight;
                    context_1.drawImage(inputImage, 0, 0, imageWidth, imageHeight, config.x, config.y, config.width, config.height);
                }
                var padding = $e894676346bfa3f2$var$Constants.FILE_SCAN_HIDDEN_CANVAS_PADDING;
                var hiddenImageWidth = Math.max(inputImage.width, config.width);
                var hiddenImageHeight = Math.max(inputImage.height, config.height);
                var hiddenCanvasWidth = hiddenImageWidth + 2 * padding;
                var hiddenCanvasHeight = hiddenImageHeight + 2 * padding;
                var hiddenCanvas = _this.createCanvasElement(hiddenCanvasWidth, hiddenCanvasHeight);
                element.appendChild(hiddenCanvas);
                var context = hiddenCanvas.getContext("2d");
                if (!context) throw "Unable to get 2d context from canvas";
                context.canvas.width = hiddenCanvasWidth;
                context.canvas.height = hiddenCanvasHeight;
                context.drawImage(inputImage, 0, 0, imageWidth, imageHeight, padding, padding, hiddenImageWidth, hiddenImageHeight);
                try {
                    _this.qrcode.decodeRobustlyAsync(hiddenCanvas).then(function(result) {
                        resolve((0, $a3hi8.Html5QrcodeResultFactory).createFromQrcodeResult(result));
                    }).catch(reject);
                } catch (exception) {
                    reject("QR code parse error, error = ".concat(exception));
                }
            };
            inputImage.onerror = reject;
            inputImage.onabort = reject;
            inputImage.onstalled = reject;
            inputImage.onsuspend = reject;
            inputImage.src = URL.createObjectURL(imageFile);
        });
    };
    Html5Qrcode.prototype.clear = function() {
        this.clearElement();
    };
    Html5Qrcode.getCameras = function() {
        return (0, $ffdwa.CameraRetriever).retrieve();
    };
    Html5Qrcode.prototype.getRunningTrackCapabilities = function() {
        return this.getRenderedCameraOrFail().getRunningTrackCapabilities();
    };
    Html5Qrcode.prototype.getRunningTrackSettings = function() {
        return this.getRenderedCameraOrFail().getRunningTrackSettings();
    };
    Html5Qrcode.prototype.getRunningTrackCameraCapabilities = function() {
        return this.getRenderedCameraOrFail().getCapabilities();
    };
    Html5Qrcode.prototype.applyVideoConstraints = function(videoConstaints) {
        if (!videoConstaints) throw "videoConstaints is required argument.";
        else if (!(0, $135IS.VideoConstraintsUtil).isMediaStreamConstraintsValid(videoConstaints, this.logger)) throw "invalid videoConstaints passed, check logs for more details";
        return this.getRenderedCameraOrFail().applyVideoConstraints(videoConstaints);
    };
    Html5Qrcode.prototype.getRenderedCameraOrFail = function() {
        if (this.renderedCamera == null) throw "Scanning is not in running state, call this API only when QR code scanning using camera is in running state.";
        return this.renderedCamera;
    };
    Html5Qrcode.prototype.getSupportedFormats = function(configOrVerbosityFlag) {
        var allFormats = [
            (0, $a3hi8.Html5QrcodeSupportedFormats).QR_CODE,
            (0, $a3hi8.Html5QrcodeSupportedFormats).AZTEC,
            (0, $a3hi8.Html5QrcodeSupportedFormats).CODABAR,
            (0, $a3hi8.Html5QrcodeSupportedFormats).CODE_39,
            (0, $a3hi8.Html5QrcodeSupportedFormats).CODE_93,
            (0, $a3hi8.Html5QrcodeSupportedFormats).CODE_128,
            (0, $a3hi8.Html5QrcodeSupportedFormats).DATA_MATRIX,
            (0, $a3hi8.Html5QrcodeSupportedFormats).MAXICODE,
            (0, $a3hi8.Html5QrcodeSupportedFormats).ITF,
            (0, $a3hi8.Html5QrcodeSupportedFormats).EAN_13,
            (0, $a3hi8.Html5QrcodeSupportedFormats).EAN_8,
            (0, $a3hi8.Html5QrcodeSupportedFormats).PDF_417,
            (0, $a3hi8.Html5QrcodeSupportedFormats).RSS_14,
            (0, $a3hi8.Html5QrcodeSupportedFormats).RSS_EXPANDED,
            (0, $a3hi8.Html5QrcodeSupportedFormats).UPC_A,
            (0, $a3hi8.Html5QrcodeSupportedFormats).UPC_E,
            (0, $a3hi8.Html5QrcodeSupportedFormats).UPC_EAN_EXTENSION
        ];
        if (!configOrVerbosityFlag || typeof configOrVerbosityFlag == "boolean") return allFormats;
        if (!configOrVerbosityFlag.formatsToSupport) return allFormats;
        if (!Array.isArray(configOrVerbosityFlag.formatsToSupport)) throw "configOrVerbosityFlag.formatsToSupport should be undefined or an array.";
        if (configOrVerbosityFlag.formatsToSupport.length === 0) throw "Atleast 1 formatsToSupport is needed.";
        var supportedFormats = [];
        for(var _i = 0, _a = configOrVerbosityFlag.formatsToSupport; _i < _a.length; _i++){
            var format = _a[_i];
            if ((0, $a3hi8.isValidHtml5QrcodeSupportedFormats)(format)) supportedFormats.push(format);
            else this.logger.warn("Invalid format: ".concat(format, " passed in config, ignoring."));
        }
        if (supportedFormats.length === 0) throw "None of formatsToSupport match supported values.";
        return supportedFormats;
    };
    Html5Qrcode.prototype.getUseBarCodeDetectorIfSupported = function(config) {
        if ((0, $a3hi8.isNullOrUndefined)(config)) return true;
        if (!(0, $a3hi8.isNullOrUndefined)(config.useBarCodeDetectorIfSupported)) return config.useBarCodeDetectorIfSupported !== false;
        if ((0, $a3hi8.isNullOrUndefined)(config.experimentalFeatures)) return true;
        var experimentalFeatures = config.experimentalFeatures;
        if ((0, $a3hi8.isNullOrUndefined)(experimentalFeatures.useBarCodeDetectorIfSupported)) return true;
        return experimentalFeatures.useBarCodeDetectorIfSupported !== false;
    };
    Html5Qrcode.prototype.validateQrboxSize = function(viewfinderWidth, viewfinderHeight, internalConfig) {
        var _this = this;
        var qrboxSize = internalConfig.qrbox;
        this.validateQrboxConfig(qrboxSize);
        var qrDimensions = this.toQrdimensions(viewfinderWidth, viewfinderHeight, qrboxSize);
        var validateMinSize = function(size) {
            if (size < $e894676346bfa3f2$var$Constants.MIN_QR_BOX_SIZE) throw "minimum size of 'config.qrbox' dimension value is" + " ".concat($e894676346bfa3f2$var$Constants.MIN_QR_BOX_SIZE, "px.");
        };
        var correctWidthBasedOnRootElementSize = function(configWidth) {
            if (configWidth > viewfinderWidth) {
                _this.logger.warn("`qrbox.width` or `qrbox` is larger than the width of the root element. The width will be truncated to the width of root element.");
                configWidth = viewfinderWidth;
            }
            return configWidth;
        };
        validateMinSize(qrDimensions.width);
        validateMinSize(qrDimensions.height);
        qrDimensions.width = correctWidthBasedOnRootElementSize(qrDimensions.width);
    };
    Html5Qrcode.prototype.validateQrboxConfig = function(qrboxSize) {
        if (typeof qrboxSize === "number") return;
        if (typeof qrboxSize === "function") return;
        if (qrboxSize.width === undefined || qrboxSize.height === undefined) throw "Invalid instance of QrDimensions passed for 'config.qrbox'. Both 'width' and 'height' should be set.";
    };
    Html5Qrcode.prototype.toQrdimensions = function(viewfinderWidth, viewfinderHeight, qrboxSize) {
        if (typeof qrboxSize === "number") return {
            width: qrboxSize,
            height: qrboxSize
        };
        else if (typeof qrboxSize === "function") try {
            return qrboxSize(viewfinderWidth, viewfinderHeight);
        } catch (error) {
            throw new Error("qrbox config was passed as a function but it failed with unknown error" + error);
        }
        return qrboxSize;
    };
    Html5Qrcode.prototype.setupUi = function(viewfinderWidth, viewfinderHeight, internalConfig) {
        if (internalConfig.isShadedBoxEnabled()) this.validateQrboxSize(viewfinderWidth, viewfinderHeight, internalConfig);
        var qrboxSize = (0, $a3hi8.isNullOrUndefined)(internalConfig.qrbox) ? {
            width: viewfinderWidth,
            height: viewfinderHeight
        } : internalConfig.qrbox;
        this.validateQrboxConfig(qrboxSize);
        var qrDimensions = this.toQrdimensions(viewfinderWidth, viewfinderHeight, qrboxSize);
        if (qrDimensions.height > viewfinderHeight) this.logger.warn("[Html5Qrcode] config.qrbox has height that isgreater than the height of the video stream. Shading will be ignored");
        var shouldShadingBeApplied = internalConfig.isShadedBoxEnabled() && qrDimensions.height <= viewfinderHeight;
        var defaultQrRegion = {
            x: 0,
            y: 0,
            width: viewfinderWidth,
            height: viewfinderHeight
        };
        var qrRegion = shouldShadingBeApplied ? this.getShadedRegionBounds(viewfinderWidth, viewfinderHeight, qrDimensions) : defaultQrRegion;
        var canvasElement = this.createCanvasElement(qrRegion.width, qrRegion.height);
        var contextAttributes = {
            willReadFrequently: true
        };
        var context = canvasElement.getContext("2d", contextAttributes);
        context.canvas.width = qrRegion.width;
        context.canvas.height = qrRegion.height;
        this.element.append(canvasElement);
        if (shouldShadingBeApplied) this.possiblyInsertShadingElement(this.element, viewfinderWidth, viewfinderHeight, qrDimensions);
        this.createScannerPausedUiElement(this.element);
        this.qrRegion = qrRegion;
        this.context = context;
        this.canvasElement = canvasElement;
    };
    Html5Qrcode.prototype.createScannerPausedUiElement = function(rootElement) {
        var scannerPausedUiElement = document.createElement("div");
        scannerPausedUiElement.innerText = (0, $45mrT.Html5QrcodeStrings).scannerPaused();
        scannerPausedUiElement.style.display = "none";
        scannerPausedUiElement.style.position = "absolute";
        scannerPausedUiElement.style.top = "0px";
        scannerPausedUiElement.style.zIndex = "1";
        scannerPausedUiElement.style.background = "rgba(9, 9, 9, 0.46)";
        scannerPausedUiElement.style.color = "#FFECEC";
        scannerPausedUiElement.style.textAlign = "center";
        scannerPausedUiElement.style.width = "100%";
        rootElement.appendChild(scannerPausedUiElement);
        this.scannerPausedUiElement = scannerPausedUiElement;
    };
    Html5Qrcode.prototype.scanContext = function(qrCodeSuccessCallback, qrCodeErrorCallback) {
        var _this = this;
        if (this.stateManagerProxy.isPaused()) return Promise.resolve(false);
        return this.qrcode.decodeAsync(this.canvasElement).then(function(result) {
            qrCodeSuccessCallback(result.text, (0, $a3hi8.Html5QrcodeResultFactory).createFromQrcodeResult(result));
            _this.possiblyUpdateShaders(true);
            return true;
        }).catch(function(error) {
            _this.possiblyUpdateShaders(false);
            var errorMessage = (0, $45mrT.Html5QrcodeStrings).codeParseError(error);
            qrCodeErrorCallback(errorMessage, (0, $a3hi8.Html5QrcodeErrorFactory).createFrom(errorMessage));
            return false;
        });
    };
    Html5Qrcode.prototype.foreverScan = function(internalConfig, qrCodeSuccessCallback, qrCodeErrorCallback) {
        var _this = this;
        if (!this.shouldScan) return;
        if (!this.renderedCamera) return;
        var videoElement = this.renderedCamera.getSurface();
        var widthRatio = videoElement.videoWidth / videoElement.clientWidth;
        var heightRatio = videoElement.videoHeight / videoElement.clientHeight;
        if (!this.qrRegion) throw "qrRegion undefined when localMediaStream is ready.";
        var sWidthOffset = this.qrRegion.width * widthRatio;
        var sHeightOffset = this.qrRegion.height * heightRatio;
        var sxOffset = this.qrRegion.x * widthRatio;
        var syOffset = this.qrRegion.y * heightRatio;
        this.context.drawImage(videoElement, sxOffset, syOffset, sWidthOffset, sHeightOffset, 0, 0, this.qrRegion.width, this.qrRegion.height);
        var triggerNextScan = function() {
            _this.foreverScanTimeout = setTimeout(function() {
                _this.foreverScan(internalConfig, qrCodeSuccessCallback, qrCodeErrorCallback);
            }, _this.getTimeoutFps(internalConfig.fps));
        };
        this.scanContext(qrCodeSuccessCallback, qrCodeErrorCallback).then(function(isSuccessfull) {
            if (!isSuccessfull && internalConfig.disableFlip !== true) {
                _this.context.translate(_this.context.canvas.width, 0);
                _this.context.scale(-1, 1);
                _this.scanContext(qrCodeSuccessCallback, qrCodeErrorCallback).finally(function() {
                    triggerNextScan();
                });
            } else triggerNextScan();
        }).catch(function(error) {
            _this.logger.logError("Error happend while scanning context", error);
            triggerNextScan();
        });
    };
    Html5Qrcode.prototype.createVideoConstraints = function(cameraIdOrConfig) {
        if (typeof cameraIdOrConfig == "string") return {
            deviceId: {
                exact: cameraIdOrConfig
            }
        };
        else if (typeof cameraIdOrConfig == "object") {
            var facingModeKey = "facingMode";
            var deviceIdKey = "deviceId";
            var allowedFacingModeValues_1 = {
                "user": true,
                "environment": true
            };
            var exactKey = "exact";
            var isValidFacingModeValue = function(value) {
                if (value in allowedFacingModeValues_1) return true;
                else throw "config has invalid 'facingMode' value = " + "'".concat(value, "'");
            };
            var keys = Object.keys(cameraIdOrConfig);
            if (keys.length !== 1) throw "'cameraIdOrConfig' object should have exactly 1 key," + " if passed as an object, found ".concat(keys.length, " keys");
            var key = Object.keys(cameraIdOrConfig)[0];
            if (key !== facingModeKey && key !== deviceIdKey) throw "Only '".concat(facingModeKey, "' and '").concat(deviceIdKey, "' ") + " are supported for 'cameraIdOrConfig'";
            if (key === facingModeKey) {
                var facingMode = cameraIdOrConfig.facingMode;
                if (typeof facingMode == "string") {
                    if (isValidFacingModeValue(facingMode)) return {
                        facingMode: facingMode
                    };
                } else if (typeof facingMode == "object") {
                    if (exactKey in facingMode) {
                        if (isValidFacingModeValue(facingMode["".concat(exactKey)])) return {
                            facingMode: {
                                exact: facingMode["".concat(exactKey)]
                            }
                        };
                    } else throw "'facingMode' should be string or object with" + " ".concat(exactKey, " as key.");
                } else {
                    var type_1 = typeof facingMode;
                    throw "Invalid type of 'facingMode' = ".concat(type_1);
                }
            } else {
                var deviceId = cameraIdOrConfig.deviceId;
                if (typeof deviceId == "string") return {
                    deviceId: deviceId
                };
                else if (typeof deviceId == "object") {
                    if (exactKey in deviceId) return {
                        deviceId: {
                            exact: deviceId["".concat(exactKey)]
                        }
                    };
                    else throw "'deviceId' should be string or object with" + " ".concat(exactKey, " as key.");
                } else {
                    var type_2 = typeof deviceId;
                    throw "Invalid type of 'deviceId' = ".concat(type_2);
                }
            }
        }
        var type = typeof cameraIdOrConfig;
        throw "Invalid type of 'cameraIdOrConfig' = ".concat(type);
    };
    Html5Qrcode.prototype.computeCanvasDrawConfig = function(imageWidth, imageHeight, containerWidth, containerHeight) {
        if (imageWidth <= containerWidth && imageHeight <= containerHeight) {
            var xoffset = (containerWidth - imageWidth) / 2;
            var yoffset = (containerHeight - imageHeight) / 2;
            return {
                x: xoffset,
                y: yoffset,
                width: imageWidth,
                height: imageHeight
            };
        } else {
            var formerImageWidth = imageWidth;
            var formerImageHeight = imageHeight;
            if (imageWidth > containerWidth) {
                imageHeight = containerWidth / imageWidth * imageHeight;
                imageWidth = containerWidth;
            }
            if (imageHeight > containerHeight) {
                imageWidth = containerHeight / imageHeight * imageWidth;
                imageHeight = containerHeight;
            }
            this.logger.log("Image downsampled from " + "".concat(formerImageWidth, "X").concat(formerImageHeight) + " to ".concat(imageWidth, "X").concat(imageHeight, "."));
            return this.computeCanvasDrawConfig(imageWidth, imageHeight, containerWidth, containerHeight);
        }
    };
    Html5Qrcode.prototype.clearElement = function() {
        if (this.stateManagerProxy.isScanning()) throw "Cannot clear while scan is ongoing, close it first.";
        var element = document.getElementById(this.elementId);
        if (element) element.innerHTML = "";
    };
    Html5Qrcode.prototype.possiblyUpdateShaders = function(qrMatch) {
        if (this.qrMatch === qrMatch) return;
        if (this.hasBorderShaders && this.borderShaders && this.borderShaders.length) this.borderShaders.forEach(function(shader) {
            shader.style.backgroundColor = qrMatch ? $e894676346bfa3f2$var$Constants.BORDER_SHADER_MATCH_COLOR : $e894676346bfa3f2$var$Constants.BORDER_SHADER_DEFAULT_COLOR;
        });
        this.qrMatch = qrMatch;
    };
    Html5Qrcode.prototype.possiblyCloseLastScanImageFile = function() {
        if (this.lastScanImageFile) {
            URL.revokeObjectURL(this.lastScanImageFile);
            this.lastScanImageFile = null;
        }
    };
    Html5Qrcode.prototype.createCanvasElement = function(width, height, customId) {
        var canvasWidth = width;
        var canvasHeight = height;
        var canvasElement = document.createElement("canvas");
        canvasElement.style.width = "".concat(canvasWidth, "px");
        canvasElement.style.height = "".concat(canvasHeight, "px");
        canvasElement.style.display = "none";
        canvasElement.id = (0, $a3hi8.isNullOrUndefined)(customId) ? "qr-canvas" : customId;
        return canvasElement;
    };
    Html5Qrcode.prototype.getShadedRegionBounds = function(width, height, qrboxSize) {
        if (qrboxSize.width > width || qrboxSize.height > height) throw "'config.qrbox' dimensions should not be greater than the dimensions of the root HTML element.";
        return {
            x: (width - qrboxSize.width) / 2,
            y: (height - qrboxSize.height) / 2,
            width: qrboxSize.width,
            height: qrboxSize.height
        };
    };
    Html5Qrcode.prototype.possiblyInsertShadingElement = function(element, width, height, qrboxSize) {
        if (width - qrboxSize.width < 1 || height - qrboxSize.height < 1) return;
        var shadingElement = document.createElement("div");
        shadingElement.style.position = "absolute";
        var rightLeftBorderSize = (width - qrboxSize.width) / 2;
        var topBottomBorderSize = (height - qrboxSize.height) / 2;
        shadingElement.style.borderLeft = "".concat(rightLeftBorderSize, "px solid rgba(0, 0, 0, 0.48)");
        shadingElement.style.borderRight = "".concat(rightLeftBorderSize, "px solid rgba(0, 0, 0, 0.48)");
        shadingElement.style.borderTop = "".concat(topBottomBorderSize, "px solid rgba(0, 0, 0, 0.48)");
        shadingElement.style.borderBottom = "".concat(topBottomBorderSize, "px solid rgba(0, 0, 0, 0.48)");
        shadingElement.style.boxSizing = "border-box";
        shadingElement.style.top = "0px";
        shadingElement.style.bottom = "0px";
        shadingElement.style.left = "0px";
        shadingElement.style.right = "0px";
        shadingElement.id = "".concat($e894676346bfa3f2$var$Constants.SHADED_REGION_ELEMENT_ID);
        if (width - qrboxSize.width < 11 || height - qrboxSize.height < 11) this.hasBorderShaders = false;
        else {
            var smallSize = 5;
            var largeSize = 40;
            this.insertShaderBorders(shadingElement, largeSize, smallSize, -smallSize, null, 0, true);
            this.insertShaderBorders(shadingElement, largeSize, smallSize, -smallSize, null, 0, false);
            this.insertShaderBorders(shadingElement, largeSize, smallSize, null, -smallSize, 0, true);
            this.insertShaderBorders(shadingElement, largeSize, smallSize, null, -smallSize, 0, false);
            this.insertShaderBorders(shadingElement, smallSize, largeSize + smallSize, -smallSize, null, -smallSize, true);
            this.insertShaderBorders(shadingElement, smallSize, largeSize + smallSize, null, -smallSize, -smallSize, true);
            this.insertShaderBorders(shadingElement, smallSize, largeSize + smallSize, -smallSize, null, -smallSize, false);
            this.insertShaderBorders(shadingElement, smallSize, largeSize + smallSize, null, -smallSize, -smallSize, false);
            this.hasBorderShaders = true;
        }
        element.append(shadingElement);
    };
    Html5Qrcode.prototype.insertShaderBorders = function(shaderElem, width, height, top, bottom, side, isLeft) {
        var elem = document.createElement("div");
        elem.style.position = "absolute";
        elem.style.backgroundColor = $e894676346bfa3f2$var$Constants.BORDER_SHADER_DEFAULT_COLOR;
        elem.style.width = "".concat(width, "px");
        elem.style.height = "".concat(height, "px");
        if (top !== null) elem.style.top = "".concat(top, "px");
        if (bottom !== null) elem.style.bottom = "".concat(bottom, "px");
        if (isLeft) elem.style.left = "".concat(side, "px");
        else elem.style.right = "".concat(side, "px");
        if (!this.borderShaders) this.borderShaders = [];
        this.borderShaders.push(elem);
        shaderElem.appendChild(elem);
    };
    Html5Qrcode.prototype.showPausedState = function() {
        if (!this.scannerPausedUiElement) throw "[internal error] scanner paused UI element not found";
        this.scannerPausedUiElement.style.display = "block";
    };
    Html5Qrcode.prototype.hidePausedState = function() {
        if (!this.scannerPausedUiElement) throw "[internal error] scanner paused UI element not found";
        this.scannerPausedUiElement.style.display = "none";
    };
    Html5Qrcode.prototype.getTimeoutFps = function(fps) {
        return 1000 / fps;
    };
    return Html5Qrcode;
}();

});
parcelRegister("a3hi8", function(module, exports) {

$parcel$export(module.exports, "Html5QrcodeSupportedFormats", () => $751798f15acf5aac$export$74c1f679d38d82e5);
$parcel$export(module.exports, "isValidHtml5QrcodeSupportedFormats", () => $751798f15acf5aac$export$f672fe1751f545ca);
$parcel$export(module.exports, "Html5QrcodeScanType", () => $751798f15acf5aac$export$13ed3042ed099f6a);
$parcel$export(module.exports, "Html5QrcodeConstants", () => $751798f15acf5aac$export$a4dae9b55d173e6d);
$parcel$export(module.exports, "QrcodeResultFormat", () => $751798f15acf5aac$export$96706046d68ee585);
$parcel$export(module.exports, "Html5QrcodeResultFactory", () => $751798f15acf5aac$export$ca258a9dba899828);
$parcel$export(module.exports, "Html5QrcodeErrorFactory", () => $751798f15acf5aac$export$dac571266bd01cf5);
$parcel$export(module.exports, "BaseLoggger", () => $751798f15acf5aac$export$1952c0907ffae0f2);
$parcel$export(module.exports, "isNullOrUndefined", () => $751798f15acf5aac$export$bedb7023a7733221);
$parcel$export(module.exports, "clip", () => $751798f15acf5aac$export$e0b576e7a74416cd);
var $751798f15acf5aac$export$74c1f679d38d82e5;
(function(Html5QrcodeSupportedFormats) {
    Html5QrcodeSupportedFormats[Html5QrcodeSupportedFormats["QR_CODE"] = 0] = "QR_CODE";
    Html5QrcodeSupportedFormats[Html5QrcodeSupportedFormats["AZTEC"] = 1] = "AZTEC";
    Html5QrcodeSupportedFormats[Html5QrcodeSupportedFormats["CODABAR"] = 2] = "CODABAR";
    Html5QrcodeSupportedFormats[Html5QrcodeSupportedFormats["CODE_39"] = 3] = "CODE_39";
    Html5QrcodeSupportedFormats[Html5QrcodeSupportedFormats["CODE_93"] = 4] = "CODE_93";
    Html5QrcodeSupportedFormats[Html5QrcodeSupportedFormats["CODE_128"] = 5] = "CODE_128";
    Html5QrcodeSupportedFormats[Html5QrcodeSupportedFormats["DATA_MATRIX"] = 6] = "DATA_MATRIX";
    Html5QrcodeSupportedFormats[Html5QrcodeSupportedFormats["MAXICODE"] = 7] = "MAXICODE";
    Html5QrcodeSupportedFormats[Html5QrcodeSupportedFormats["ITF"] = 8] = "ITF";
    Html5QrcodeSupportedFormats[Html5QrcodeSupportedFormats["EAN_13"] = 9] = "EAN_13";
    Html5QrcodeSupportedFormats[Html5QrcodeSupportedFormats["EAN_8"] = 10] = "EAN_8";
    Html5QrcodeSupportedFormats[Html5QrcodeSupportedFormats["PDF_417"] = 11] = "PDF_417";
    Html5QrcodeSupportedFormats[Html5QrcodeSupportedFormats["RSS_14"] = 12] = "RSS_14";
    Html5QrcodeSupportedFormats[Html5QrcodeSupportedFormats["RSS_EXPANDED"] = 13] = "RSS_EXPANDED";
    Html5QrcodeSupportedFormats[Html5QrcodeSupportedFormats["UPC_A"] = 14] = "UPC_A";
    Html5QrcodeSupportedFormats[Html5QrcodeSupportedFormats["UPC_E"] = 15] = "UPC_E";
    Html5QrcodeSupportedFormats[Html5QrcodeSupportedFormats["UPC_EAN_EXTENSION"] = 16] = "UPC_EAN_EXTENSION";
})($751798f15acf5aac$export$74c1f679d38d82e5 || ($751798f15acf5aac$export$74c1f679d38d82e5 = {}));
var $751798f15acf5aac$var$html5QrcodeSupportedFormatsTextMap = new Map([
    [
        $751798f15acf5aac$export$74c1f679d38d82e5.QR_CODE,
        "QR_CODE"
    ],
    [
        $751798f15acf5aac$export$74c1f679d38d82e5.AZTEC,
        "AZTEC"
    ],
    [
        $751798f15acf5aac$export$74c1f679d38d82e5.CODABAR,
        "CODABAR"
    ],
    [
        $751798f15acf5aac$export$74c1f679d38d82e5.CODE_39,
        "CODE_39"
    ],
    [
        $751798f15acf5aac$export$74c1f679d38d82e5.CODE_93,
        "CODE_93"
    ],
    [
        $751798f15acf5aac$export$74c1f679d38d82e5.CODE_128,
        "CODE_128"
    ],
    [
        $751798f15acf5aac$export$74c1f679d38d82e5.DATA_MATRIX,
        "DATA_MATRIX"
    ],
    [
        $751798f15acf5aac$export$74c1f679d38d82e5.MAXICODE,
        "MAXICODE"
    ],
    [
        $751798f15acf5aac$export$74c1f679d38d82e5.ITF,
        "ITF"
    ],
    [
        $751798f15acf5aac$export$74c1f679d38d82e5.EAN_13,
        "EAN_13"
    ],
    [
        $751798f15acf5aac$export$74c1f679d38d82e5.EAN_8,
        "EAN_8"
    ],
    [
        $751798f15acf5aac$export$74c1f679d38d82e5.PDF_417,
        "PDF_417"
    ],
    [
        $751798f15acf5aac$export$74c1f679d38d82e5.RSS_14,
        "RSS_14"
    ],
    [
        $751798f15acf5aac$export$74c1f679d38d82e5.RSS_EXPANDED,
        "RSS_EXPANDED"
    ],
    [
        $751798f15acf5aac$export$74c1f679d38d82e5.UPC_A,
        "UPC_A"
    ],
    [
        $751798f15acf5aac$export$74c1f679d38d82e5.UPC_E,
        "UPC_E"
    ],
    [
        $751798f15acf5aac$export$74c1f679d38d82e5.UPC_EAN_EXTENSION,
        "UPC_EAN_EXTENSION"
    ]
]);
var $751798f15acf5aac$export$ca79648743730e34;
(function(DecodedTextType) {
    DecodedTextType[DecodedTextType["UNKNOWN"] = 0] = "UNKNOWN";
    DecodedTextType[DecodedTextType["URL"] = 1] = "URL";
})($751798f15acf5aac$export$ca79648743730e34 || ($751798f15acf5aac$export$ca79648743730e34 = {}));
function $751798f15acf5aac$export$f672fe1751f545ca(format) {
    return Object.values($751798f15acf5aac$export$74c1f679d38d82e5).includes(format);
}
var $751798f15acf5aac$export$13ed3042ed099f6a;
(function(Html5QrcodeScanType) {
    Html5QrcodeScanType[Html5QrcodeScanType["SCAN_TYPE_CAMERA"] = 0] = "SCAN_TYPE_CAMERA";
    Html5QrcodeScanType[Html5QrcodeScanType["SCAN_TYPE_FILE"] = 1] = "SCAN_TYPE_FILE";
})($751798f15acf5aac$export$13ed3042ed099f6a || ($751798f15acf5aac$export$13ed3042ed099f6a = {}));
var $751798f15acf5aac$export$a4dae9b55d173e6d = function() {
    function Html5QrcodeConstants() {}
    Html5QrcodeConstants.GITHUB_PROJECT_URL = "https://github.com/mebjas/html5-qrcode";
    Html5QrcodeConstants.SCAN_DEFAULT_FPS = 2;
    Html5QrcodeConstants.DEFAULT_DISABLE_FLIP = false;
    Html5QrcodeConstants.DEFAULT_REMEMBER_LAST_CAMERA_USED = true;
    Html5QrcodeConstants.DEFAULT_SUPPORTED_SCAN_TYPE = [
        $751798f15acf5aac$export$13ed3042ed099f6a.SCAN_TYPE_CAMERA,
        $751798f15acf5aac$export$13ed3042ed099f6a.SCAN_TYPE_FILE
    ];
    return Html5QrcodeConstants;
}();
var $751798f15acf5aac$export$96706046d68ee585 = function() {
    function QrcodeResultFormat(format, formatName) {
        this.format = format;
        this.formatName = formatName;
    }
    QrcodeResultFormat.prototype.toString = function() {
        return this.formatName;
    };
    QrcodeResultFormat.create = function(format) {
        if (!$751798f15acf5aac$var$html5QrcodeSupportedFormatsTextMap.has(format)) throw "".concat(format, " not in html5QrcodeSupportedFormatsTextMap");
        return new QrcodeResultFormat(format, $751798f15acf5aac$var$html5QrcodeSupportedFormatsTextMap.get(format));
    };
    return QrcodeResultFormat;
}();
var $751798f15acf5aac$export$ca258a9dba899828 = function() {
    function Html5QrcodeResultFactory() {}
    Html5QrcodeResultFactory.createFromText = function(decodedText) {
        var qrcodeResult = {
            text: decodedText
        };
        return {
            decodedText: decodedText,
            result: qrcodeResult
        };
    };
    Html5QrcodeResultFactory.createFromQrcodeResult = function(qrcodeResult) {
        return {
            decodedText: qrcodeResult.text,
            result: qrcodeResult
        };
    };
    return Html5QrcodeResultFactory;
}();
var $751798f15acf5aac$export$ce0f3ff7a292bc54;
(function(Html5QrcodeErrorTypes) {
    Html5QrcodeErrorTypes[Html5QrcodeErrorTypes["UNKWOWN_ERROR"] = 0] = "UNKWOWN_ERROR";
    Html5QrcodeErrorTypes[Html5QrcodeErrorTypes["IMPLEMENTATION_ERROR"] = 1] = "IMPLEMENTATION_ERROR";
    Html5QrcodeErrorTypes[Html5QrcodeErrorTypes["NO_CODE_FOUND_ERROR"] = 2] = "NO_CODE_FOUND_ERROR";
})($751798f15acf5aac$export$ce0f3ff7a292bc54 || ($751798f15acf5aac$export$ce0f3ff7a292bc54 = {}));
var $751798f15acf5aac$export$dac571266bd01cf5 = function() {
    function Html5QrcodeErrorFactory() {}
    Html5QrcodeErrorFactory.createFrom = function(error) {
        return {
            errorMessage: error,
            type: $751798f15acf5aac$export$ce0f3ff7a292bc54.UNKWOWN_ERROR
        };
    };
    return Html5QrcodeErrorFactory;
}();
var $751798f15acf5aac$export$1952c0907ffae0f2 = function() {
    function BaseLoggger(verbose) {
        this.verbose = verbose;
    }
    BaseLoggger.prototype.log = function(message) {
        if (this.verbose) console.log(message);
    };
    BaseLoggger.prototype.warn = function(message) {
        if (this.verbose) console.warn(message);
    };
    BaseLoggger.prototype.logError = function(message, isExperimental) {
        if (this.verbose || isExperimental === true) console.error(message);
    };
    BaseLoggger.prototype.logErrors = function(errors) {
        if (errors.length === 0) throw "Logger#logError called without arguments";
        if (this.verbose) console.error(errors);
    };
    return BaseLoggger;
}();
function $751798f15acf5aac$export$bedb7023a7733221(obj) {
    return typeof obj === "undefined" || obj === null;
}
function $751798f15acf5aac$export$e0b576e7a74416cd(value, minValue, maxValue) {
    if (value > maxValue) return maxValue;
    if (value < minValue) return minValue;
    return value;
}

});

parcelRegister("45mrT", function(module, exports) {

$parcel$export(module.exports, "Html5QrcodeStrings", () => $2f990aee0fe0abba$export$b5652ef085dee87f);
$parcel$export(module.exports, "Html5QrcodeScannerStrings", () => $2f990aee0fe0abba$export$b9cab5abdb16545c);
$parcel$export(module.exports, "LibraryInfoStrings", () => $2f990aee0fe0abba$export$ef6635d54d6a0486);
var $2f990aee0fe0abba$export$b5652ef085dee87f = function() {
    function Html5QrcodeStrings() {}
    Html5QrcodeStrings.codeParseError = function(exception) {
        return "QR code parse error, error = ".concat(exception);
    };
    Html5QrcodeStrings.errorGettingUserMedia = function(error) {
        return "Error getting userMedia, error = ".concat(error);
    };
    Html5QrcodeStrings.onlyDeviceSupportedError = function() {
        return "The device doesn't support navigator.mediaDevices , only supported cameraIdOrConfig in this case is deviceId parameter (string).";
    };
    Html5QrcodeStrings.cameraStreamingNotSupported = function() {
        return "Camera streaming not supported by the browser.";
    };
    Html5QrcodeStrings.unableToQuerySupportedDevices = function() {
        return "Unable to query supported devices, unknown error.";
    };
    Html5QrcodeStrings.insecureContextCameraQueryError = function() {
        return "Camera access is only supported in secure context like https or localhost.";
    };
    Html5QrcodeStrings.scannerPaused = function() {
        return "Scanner paused";
    };
    return Html5QrcodeStrings;
}();
var $2f990aee0fe0abba$export$b9cab5abdb16545c = function() {
    function Html5QrcodeScannerStrings() {}
    Html5QrcodeScannerStrings.scanningStatus = function() {
        return "Scanning";
    };
    Html5QrcodeScannerStrings.idleStatus = function() {
        return "Idle";
    };
    Html5QrcodeScannerStrings.errorStatus = function() {
        return "Error";
    };
    Html5QrcodeScannerStrings.permissionStatus = function() {
        return "Permission";
    };
    Html5QrcodeScannerStrings.noCameraFoundErrorStatus = function() {
        return "No Cameras";
    };
    Html5QrcodeScannerStrings.lastMatch = function(decodedText) {
        return "Last Match: ".concat(decodedText);
    };
    Html5QrcodeScannerStrings.codeScannerTitle = function() {
        return "Code Scanner";
    };
    Html5QrcodeScannerStrings.cameraPermissionTitle = function() {
        return "Request Camera Permissions";
    };
    Html5QrcodeScannerStrings.cameraPermissionRequesting = function() {
        return "Requesting camera permissions...";
    };
    Html5QrcodeScannerStrings.noCameraFound = function() {
        return "No camera found";
    };
    Html5QrcodeScannerStrings.scanButtonStopScanningText = function() {
        return "Stop Scanning";
    };
    Html5QrcodeScannerStrings.scanButtonStartScanningText = function() {
        return "Start Scanning";
    };
    Html5QrcodeScannerStrings.torchOnButton = function() {
        return "Switch On Torch";
    };
    Html5QrcodeScannerStrings.torchOffButton = function() {
        return "Switch Off Torch";
    };
    Html5QrcodeScannerStrings.torchOnFailedMessage = function() {
        return "Failed to turn on torch";
    };
    Html5QrcodeScannerStrings.torchOffFailedMessage = function() {
        return "Failed to turn off torch";
    };
    Html5QrcodeScannerStrings.scanButtonScanningStarting = function() {
        return "Launching Camera...";
    };
    Html5QrcodeScannerStrings.textIfCameraScanSelected = function() {
        return "Scan an Image File";
    };
    Html5QrcodeScannerStrings.textIfFileScanSelected = function() {
        return "Scan using camera directly";
    };
    Html5QrcodeScannerStrings.selectCamera = function() {
        return "Select Camera";
    };
    Html5QrcodeScannerStrings.fileSelectionChooseImage = function() {
        return "Choose Image";
    };
    Html5QrcodeScannerStrings.fileSelectionChooseAnother = function() {
        return "Choose Another";
    };
    Html5QrcodeScannerStrings.fileSelectionNoImageSelected = function() {
        return "No image choosen";
    };
    Html5QrcodeScannerStrings.anonymousCameraPrefix = function() {
        return "Anonymous Camera";
    };
    Html5QrcodeScannerStrings.dragAndDropMessage = function() {
        return "Or drop an image to scan";
    };
    Html5QrcodeScannerStrings.dragAndDropMessageOnlyImages = function() {
        return "Or drop an image to scan (other files not supported)";
    };
    Html5QrcodeScannerStrings.zoom = function() {
        return "zoom";
    };
    Html5QrcodeScannerStrings.loadingImage = function() {
        return "Loading image...";
    };
    Html5QrcodeScannerStrings.cameraScanAltText = function() {
        return "Camera based scan";
    };
    Html5QrcodeScannerStrings.fileScanAltText = function() {
        return "Fule based scan";
    };
    return Html5QrcodeScannerStrings;
}();
var $2f990aee0fe0abba$export$ef6635d54d6a0486 = function() {
    function LibraryInfoStrings() {}
    LibraryInfoStrings.poweredBy = function() {
        return "Powered by ";
    };
    LibraryInfoStrings.reportIssues = function() {
        return "Report issues";
    };
    return LibraryInfoStrings;
}();

});

parcelRegister("135IS", function(module, exports) {

$parcel$export(module.exports, "VideoConstraintsUtil", () => $0c3a82b58e3c109c$export$62a0507decb17869);
var $0c3a82b58e3c109c$export$62a0507decb17869 = function() {
    function VideoConstraintsUtil() {}
    VideoConstraintsUtil.isMediaStreamConstraintsValid = function(videoConstraints, logger) {
        if (typeof videoConstraints !== "object") {
            var typeofVideoConstraints = typeof videoConstraints;
            logger.logError("videoConstraints should be of type object, the " + "object passed is of type ".concat(typeofVideoConstraints, "."), true);
            return false;
        }
        var bannedKeys = [
            "autoGainControl",
            "channelCount",
            "echoCancellation",
            "latency",
            "noiseSuppression",
            "sampleRate",
            "sampleSize",
            "volume"
        ];
        var bannedkeysSet = new Set(bannedKeys);
        var keysInVideoConstraints = Object.keys(videoConstraints);
        for(var _i = 0, keysInVideoConstraints_1 = keysInVideoConstraints; _i < keysInVideoConstraints_1.length; _i++){
            var key = keysInVideoConstraints_1[_i];
            if (bannedkeysSet.has(key)) {
                logger.logError("".concat(key, " is not supported videoConstaints."), true);
                return false;
            }
        }
        return true;
    };
    return VideoConstraintsUtil;
}();

});

parcelRegister("11SAK", function(module, exports) {

$parcel$export(module.exports, "Html5QrcodeShim", () => $0c003b39bffbb7b8$export$e24b14a4b30c7022);

var $aeC52 = parcelRequire("aeC52");

var $9G8XY = parcelRequire("9G8XY");
var $0c003b39bffbb7b8$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $0c003b39bffbb7b8$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $0c003b39bffbb7b8$export$e24b14a4b30c7022 = function() {
    function Html5QrcodeShim(requestedFormats, useBarCodeDetectorIfSupported, verbose, logger) {
        this.EXECUTIONS_TO_REPORT_PERFORMANCE = 100;
        this.executions = 0;
        this.executionResults = [];
        this.wasPrimaryDecoderUsedInLastDecode = false;
        this.verbose = verbose;
        if (useBarCodeDetectorIfSupported && (0, $9G8XY.BarcodeDetectorDelegate).isSupported()) {
            this.primaryDecoder = new (0, $9G8XY.BarcodeDetectorDelegate)(requestedFormats, verbose, logger);
            this.secondaryDecoder = new (0, $aeC52.ZXingHtml5QrcodeDecoder)(requestedFormats, verbose, logger);
        } else this.primaryDecoder = new (0, $aeC52.ZXingHtml5QrcodeDecoder)(requestedFormats, verbose, logger);
    }
    Html5QrcodeShim.prototype.decodeAsync = function(canvas) {
        return $0c003b39bffbb7b8$var$__awaiter(this, void 0, void 0, function() {
            var startTime;
            return $0c003b39bffbb7b8$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        startTime = performance.now();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4,
                            this.getDecoder().decodeAsync(canvas)
                        ];
                    case 2:
                        return [
                            2,
                            _a.sent()
                        ];
                    case 3:
                        this.possiblyLogPerformance(startTime);
                        return [
                            7
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
    };
    Html5QrcodeShim.prototype.decodeRobustlyAsync = function(canvas) {
        return $0c003b39bffbb7b8$var$__awaiter(this, void 0, void 0, function() {
            var startTime, error_1;
            return $0c003b39bffbb7b8$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        startTime = performance.now();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        return [
                            4,
                            this.primaryDecoder.decodeAsync(canvas)
                        ];
                    case 2:
                        return [
                            2,
                            _a.sent()
                        ];
                    case 3:
                        error_1 = _a.sent();
                        if (this.secondaryDecoder) return [
                            2,
                            this.secondaryDecoder.decodeAsync(canvas)
                        ];
                        throw error_1;
                    case 4:
                        this.possiblyLogPerformance(startTime);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
    };
    Html5QrcodeShim.prototype.getDecoder = function() {
        if (!this.secondaryDecoder) return this.primaryDecoder;
        if (this.wasPrimaryDecoderUsedInLastDecode === false) {
            this.wasPrimaryDecoderUsedInLastDecode = true;
            return this.primaryDecoder;
        }
        this.wasPrimaryDecoderUsedInLastDecode = false;
        return this.secondaryDecoder;
    };
    Html5QrcodeShim.prototype.possiblyLogPerformance = function(startTime) {
        if (!this.verbose) return;
        var executionTime = performance.now() - startTime;
        this.executionResults.push(executionTime);
        this.executions++;
        this.possiblyFlushPerformanceReport();
    };
    Html5QrcodeShim.prototype.possiblyFlushPerformanceReport = function() {
        if (this.executions < this.EXECUTIONS_TO_REPORT_PERFORMANCE) return;
        var sum = 0;
        for(var _i = 0, _a = this.executionResults; _i < _a.length; _i++){
            var executionTime = _a[_i];
            sum += executionTime;
        }
        var mean = sum / this.executionResults.length;
        console.log("".concat(mean, " ms for ").concat(this.executionResults.length, " last runs."));
        this.executions = 0;
        this.executionResults = [];
    };
    return Html5QrcodeShim;
}();

});
parcelRegister("aeC52", function(module, exports) {

$parcel$export(module.exports, "ZXingHtml5QrcodeDecoder", () => $7738c0226d85f7ad$export$12d67355bcc453ab);

var $eM4zy = parcelRequire("eM4zy");

var $a3hi8 = parcelRequire("a3hi8");
var $7738c0226d85f7ad$export$12d67355bcc453ab = function() {
    function ZXingHtml5QrcodeDecoder(requestedFormats, verbose, logger) {
        this.formatMap = new Map([
            [
                (0, $a3hi8.Html5QrcodeSupportedFormats).QR_CODE,
                $eM4zy.BarcodeFormat.QR_CODE
            ],
            [
                (0, $a3hi8.Html5QrcodeSupportedFormats).AZTEC,
                $eM4zy.BarcodeFormat.AZTEC
            ],
            [
                (0, $a3hi8.Html5QrcodeSupportedFormats).CODABAR,
                $eM4zy.BarcodeFormat.CODABAR
            ],
            [
                (0, $a3hi8.Html5QrcodeSupportedFormats).CODE_39,
                $eM4zy.BarcodeFormat.CODE_39
            ],
            [
                (0, $a3hi8.Html5QrcodeSupportedFormats).CODE_93,
                $eM4zy.BarcodeFormat.CODE_93
            ],
            [
                (0, $a3hi8.Html5QrcodeSupportedFormats).CODE_128,
                $eM4zy.BarcodeFormat.CODE_128
            ],
            [
                (0, $a3hi8.Html5QrcodeSupportedFormats).DATA_MATRIX,
                $eM4zy.BarcodeFormat.DATA_MATRIX
            ],
            [
                (0, $a3hi8.Html5QrcodeSupportedFormats).MAXICODE,
                $eM4zy.BarcodeFormat.MAXICODE
            ],
            [
                (0, $a3hi8.Html5QrcodeSupportedFormats).ITF,
                $eM4zy.BarcodeFormat.ITF
            ],
            [
                (0, $a3hi8.Html5QrcodeSupportedFormats).EAN_13,
                $eM4zy.BarcodeFormat.EAN_13
            ],
            [
                (0, $a3hi8.Html5QrcodeSupportedFormats).EAN_8,
                $eM4zy.BarcodeFormat.EAN_8
            ],
            [
                (0, $a3hi8.Html5QrcodeSupportedFormats).PDF_417,
                $eM4zy.BarcodeFormat.PDF_417
            ],
            [
                (0, $a3hi8.Html5QrcodeSupportedFormats).RSS_14,
                $eM4zy.BarcodeFormat.RSS_14
            ],
            [
                (0, $a3hi8.Html5QrcodeSupportedFormats).RSS_EXPANDED,
                $eM4zy.BarcodeFormat.RSS_EXPANDED
            ],
            [
                (0, $a3hi8.Html5QrcodeSupportedFormats).UPC_A,
                $eM4zy.BarcodeFormat.UPC_A
            ],
            [
                (0, $a3hi8.Html5QrcodeSupportedFormats).UPC_E,
                $eM4zy.BarcodeFormat.UPC_E
            ],
            [
                (0, $a3hi8.Html5QrcodeSupportedFormats).UPC_EAN_EXTENSION,
                $eM4zy.BarcodeFormat.UPC_EAN_EXTENSION
            ]
        ]);
        this.reverseFormatMap = this.createReverseFormatMap();
        if (!$eM4zy) throw "Use html5qrcode.min.js without edit, ZXing not found.";
        this.verbose = verbose;
        this.logger = logger;
        var formats = this.createZXingFormats(requestedFormats);
        var hints = new Map();
        hints.set($eM4zy.DecodeHintType.POSSIBLE_FORMATS, formats);
        hints.set($eM4zy.DecodeHintType.TRY_HARDER, false);
        this.hints = hints;
    }
    ZXingHtml5QrcodeDecoder.prototype.decodeAsync = function(canvas) {
        var _this = this;
        return new Promise(function(resolve, reject) {
            try {
                resolve(_this.decode(canvas));
            } catch (error) {
                reject(error);
            }
        });
    };
    ZXingHtml5QrcodeDecoder.prototype.decode = function(canvas) {
        var zxingDecoder = new $eM4zy.MultiFormatReader(this.verbose, this.hints);
        var luminanceSource = new $eM4zy.HTMLCanvasElementLuminanceSource(canvas);
        var binaryBitmap = new $eM4zy.BinaryBitmap(new $eM4zy.HybridBinarizer(luminanceSource));
        var result = zxingDecoder.decode(binaryBitmap);
        return {
            text: result.text,
            format: (0, $a3hi8.QrcodeResultFormat).create(this.toHtml5QrcodeSupportedFormats(result.format)),
            debugData: this.createDebugData()
        };
    };
    ZXingHtml5QrcodeDecoder.prototype.createReverseFormatMap = function() {
        var result = new Map();
        this.formatMap.forEach(function(value, key, _) {
            result.set(value, key);
        });
        return result;
    };
    ZXingHtml5QrcodeDecoder.prototype.toHtml5QrcodeSupportedFormats = function(zxingFormat) {
        if (!this.reverseFormatMap.has(zxingFormat)) throw "reverseFormatMap doesn't have ".concat(zxingFormat);
        return this.reverseFormatMap.get(zxingFormat);
    };
    ZXingHtml5QrcodeDecoder.prototype.createZXingFormats = function(requestedFormats) {
        var zxingFormats = [];
        for(var _i = 0, requestedFormats_1 = requestedFormats; _i < requestedFormats_1.length; _i++){
            var requestedFormat = requestedFormats_1[_i];
            if (this.formatMap.has(requestedFormat)) zxingFormats.push(this.formatMap.get(requestedFormat));
            else this.logger.logError("".concat(requestedFormat, " is not supported by") + "ZXingHtml5QrcodeShim");
        }
        return zxingFormats;
    };
    ZXingHtml5QrcodeDecoder.prototype.createDebugData = function() {
        return {
            decoderName: "zxing-js"
        };
    };
    return ZXingHtml5QrcodeDecoder;
}();

});
parcelRegister("eM4zy", function(module, exports) {
(function(global1, factory) {
    factory(module.exports);
})(module.exports, function(exports1) {
    'use strict';
    function isNullOrUndefined(obj) {
        return obj === null || obj === undefined;
    }
    /*
     * Copyright 2008 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /* global Reflect, Promise */ var extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    function __extends(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }
    function fixProto(target, prototype) {
        var setPrototypeOf = Object.setPrototypeOf;
        setPrototypeOf ? setPrototypeOf(target, prototype) : target.__proto__ = prototype;
    }
    function fixStack(target, fn) {
        if (fn === void 0) fn = target.constructor;
        var captureStackTrace = Error.captureStackTrace;
        captureStackTrace && captureStackTrace(target, fn);
    }
    var CustomError = function(_super) {
        __extends(CustomError, _super);
        function CustomError(message) {
            var _newTarget = this.constructor;
            var _this = _super.call(this, message) || this;
            Object.defineProperty(_this, 'name', {
                value: _newTarget.name,
                enumerable: false
            });
            fixProto(_this, _newTarget.prototype);
            fixStack(_this);
            return _this;
        }
        return CustomError;
    }(Error);
    /**
     * Custom Error class of type Exception.
     */ class Exception extends CustomError {
        /**
         * Allows Exception to be constructed directly
         * with some message and prototype definition.
         */ constructor(message){
            super(message);
            this.message = message;
        }
        getKind() {
            const ex = this.constructor;
            return ex.kind;
        }
    }
    /**
     * It's typed as string so it can be extended and overriden.
     */ Exception.kind = 'Exception';
    /**
     * Custom Error class of type Exception.
     */ class ArgumentException extends Exception {
    }
    ArgumentException.kind = 'ArgumentException';
    /**
     * Custom Error class of type Exception.
     */ class IllegalArgumentException extends Exception {
    }
    IllegalArgumentException.kind = 'IllegalArgumentException';
    /*
     * Copyright 2009 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ class BinaryBitmap {
        constructor(binarizer){
            this.binarizer = binarizer;
            if (binarizer === null) throw new IllegalArgumentException('Binarizer must be non-null.');
        }
        /**
         * @return The width of the bitmap.
         */ getWidth() {
            return this.binarizer.getWidth();
        }
        /**
         * @return The height of the bitmap.
         */ getHeight() {
            return this.binarizer.getHeight();
        }
        /**
         * Converts one row of luminance data to 1 bit data. May actually do the conversion, or return
         * cached data. Callers should assume this method is expensive and call it as seldom as possible.
         * This method is intended for decoding 1D barcodes and may choose to apply sharpening.
         *
         * @param y The row to fetch, which must be in [0, bitmap height)
         * @param row An optional preallocated array. If null or too small, it will be ignored.
         *            If used, the Binarizer will call BitArray.clear(). Always use the returned object.
         * @return The array of bits for this row (true means black).
         * @throws NotFoundException if row can't be binarized
         */ getBlackRow(y /*int*/ , row) {
            return this.binarizer.getBlackRow(y, row);
        }
        /**
         * Converts a 2D array of luminance data to 1 bit. As above, assume this method is expensive
         * and do not call it repeatedly. This method is intended for decoding 2D barcodes and may or
         * may not apply sharpening. Therefore, a row from this matrix may not be identical to one
         * fetched using getBlackRow(), so don't mix and match between them.
         *
         * @return The 2D array of bits for the image (true means black).
         * @throws NotFoundException if image can't be binarized to make a matrix
         */ getBlackMatrix() {
            // The matrix is created on demand the first time it is requested, then cached. There are two
            // reasons for this:
            // 1. This work will never be done if the caller only installs 1D Reader objects, or if a
            //    1D Reader finds a barcode before the 2D Readers run.
            // 2. This work will only be done once even if the caller installs multiple 2D Readers.
            if (this.matrix === null || this.matrix === undefined) this.matrix = this.binarizer.getBlackMatrix();
            return this.matrix;
        }
        /**
         * @return Whether this bitmap can be cropped.
         */ isCropSupported() {
            return this.binarizer.getLuminanceSource().isCropSupported();
        }
        /**
         * Returns a new object with cropped image data. Implementations may keep a reference to the
         * original data rather than a copy. Only callable if isCropSupported() is true.
         *
         * @param left The left coordinate, which must be in [0,getWidth())
         * @param top The top coordinate, which must be in [0,getHeight())
         * @param width The width of the rectangle to crop.
         * @param height The height of the rectangle to crop.
         * @return A cropped version of this object.
         */ crop(left /*int*/ , top /*int*/ , width /*int*/ , height /*int*/ ) {
            const newSource = this.binarizer.getLuminanceSource().crop(left, top, width, height);
            return new BinaryBitmap(this.binarizer.createBinarizer(newSource));
        }
        /**
         * @return Whether this bitmap supports counter-clockwise rotation.
         */ isRotateSupported() {
            return this.binarizer.getLuminanceSource().isRotateSupported();
        }
        /**
         * Returns a new object with rotated image data by 90 degrees counterclockwise.
         * Only callable if {@link #isRotateSupported()} is true.
         *
         * @return A rotated version of this object.
         */ rotateCounterClockwise() {
            const newSource = this.binarizer.getLuminanceSource().rotateCounterClockwise();
            return new BinaryBitmap(this.binarizer.createBinarizer(newSource));
        }
        /**
         * Returns a new object with rotated image data by 45 degrees counterclockwise.
         * Only callable if {@link #isRotateSupported()} is true.
         *
         * @return A rotated version of this object.
         */ rotateCounterClockwise45() {
            const newSource = this.binarizer.getLuminanceSource().rotateCounterClockwise45();
            return new BinaryBitmap(this.binarizer.createBinarizer(newSource));
        }
        /*@Override*/ toString() {
            try {
                return this.getBlackMatrix().toString();
            } catch (e /*: NotFoundException*/ ) {
                return '';
            }
        }
    }
    /**
     * Custom Error class of type Exception.
     */ class ChecksumException extends Exception {
        static getChecksumInstance() {
            return new ChecksumException();
        }
    }
    ChecksumException.kind = 'ChecksumException';
    /*
     * Copyright 2009 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * This class hierarchy provides a set of methods to convert luminance data to 1 bit data.
     * It allows the algorithm to vary polymorphically, for example allowing a very expensive
     * thresholding technique for servers and a fast one for mobile. It also permits the implementation
     * to vary, e.g. a JNI version for Android and a Java fallback version for other platforms.
     *
     * @author dswitkin@google.com (Daniel Switkin)
     */ class Binarizer {
        constructor(source){
            this.source = source;
        }
        getLuminanceSource() {
            return this.source;
        }
        getWidth() {
            return this.source.getWidth();
        }
        getHeight() {
            return this.source.getHeight();
        }
    }
    class System {
        // public static void arraycopy(Object src, int srcPos, Object dest, int destPos, int length)
        /**
         * Makes a copy of a array.
         */ static arraycopy(src, srcPos, dest, destPos, length) {
            // TODO: better use split or set?
            while(length--)dest[destPos++] = src[srcPos++];
        }
        /**
         * Returns the current time in milliseconds.
         */ static currentTimeMillis() {
            return Date.now();
        }
    }
    /**
     * Custom Error class of type Exception.
     */ class IndexOutOfBoundsException extends Exception {
    }
    IndexOutOfBoundsException.kind = 'IndexOutOfBoundsException';
    /**
     * Custom Error class of type Exception.
     */ class ArrayIndexOutOfBoundsException extends IndexOutOfBoundsException {
        constructor(index, message){
            super(message);
            this.index = index;
            this.message = message;
        }
    }
    ArrayIndexOutOfBoundsException.kind = 'ArrayIndexOutOfBoundsException';
    class Arrays {
        /**
         * Assigns the specified int value to each element of the specified array
         * of ints.
         *
         * @param a the array to be filled
         * @param val the value to be stored in all elements of the array
         */ static fill(a, val) {
            for(let i = 0, len = a.length; i < len; i++)a[i] = val;
        }
        /**
         * Assigns the specified int value to each element of the specified
         * range of the specified array of ints.  The range to be filled
         * extends from index {@code fromIndex}, inclusive, to index
         * {@code toIndex}, exclusive.  (If {@code fromIndex==toIndex}, the
         * range to be filled is empty.)
         *
         * @param a the array to be filled
         * @param fromIndex the index of the first element (inclusive) to be
         *        filled with the specified value
         * @param toIndex the index of the last element (exclusive) to be
         *        filled with the specified value
         * @param val the value to be stored in all elements of the array
         * @throws IllegalArgumentException if {@code fromIndex > toIndex}
         * @throws ArrayIndexOutOfBoundsException if {@code fromIndex < 0} or
         *         {@code toIndex > a.length}
         */ static fillWithin(a, fromIndex, toIndex, val) {
            Arrays.rangeCheck(a.length, fromIndex, toIndex);
            for(let i = fromIndex; i < toIndex; i++)a[i] = val;
        }
        /**
         * Checks that {@code fromIndex} and {@code toIndex} are in
         * the range and throws an exception if they aren't.
         */ static rangeCheck(arrayLength, fromIndex, toIndex) {
            if (fromIndex > toIndex) throw new IllegalArgumentException('fromIndex(' + fromIndex + ') > toIndex(' + toIndex + ')');
            if (fromIndex < 0) throw new ArrayIndexOutOfBoundsException(fromIndex);
            if (toIndex > arrayLength) throw new ArrayIndexOutOfBoundsException(toIndex);
        }
        static asList(...args) {
            return args;
        }
        static create(rows, cols, value) {
            let arr = Array.from({
                length: rows
            });
            return arr.map((x)=>Array.from({
                    length: cols
                }).fill(value));
        }
        static createInt32Array(rows, cols, value) {
            let arr = Array.from({
                length: rows
            });
            return arr.map((x)=>Int32Array.from({
                    length: cols
                }).fill(value));
        }
        static equals(first, second) {
            if (!first) return false;
            if (!second) return false;
            if (!first.length) return false;
            if (!second.length) return false;
            if (first.length !== second.length) return false;
            for(let i = 0, length = first.length; i < length; i++){
                if (first[i] !== second[i]) return false;
            }
            return true;
        }
        static hashCode(a) {
            if (a === null) return 0;
            let result = 1;
            for (const element of a)result = 31 * result + element;
            return result;
        }
        static fillUint8Array(a, value) {
            for(let i = 0; i !== a.length; i++)a[i] = value;
        }
        static copyOf(original, newLength) {
            return original.slice(0, newLength);
        }
        static copyOfUint8Array(original, newLength) {
            if (original.length <= newLength) {
                const newArray = new Uint8Array(newLength);
                newArray.set(original);
                return newArray;
            }
            return original.slice(0, newLength);
        }
        static copyOfRange(original, from, to) {
            const newLength = to - from;
            const copy = new Int32Array(newLength);
            System.arraycopy(original, from, copy, 0, newLength);
            return copy;
        }
        /*
        * Returns the index of of the element in a sorted array or (-n-1) where n is the insertion point
        * for the new element.
        * Parameters:
        *     ar - A sorted array
        *     el - An element to search for
        *     comparator - A comparator function. The function takes two arguments: (a, b) and returns:
        *        a negative number  if a is less than b;
        *        0 if a is equal to b;
        *        a positive number of a is greater than b.
        * The array may contain duplicate elements. If there are more than one equal elements in the array,
        * the returned value can be the index of any one of the equal elements.
        *
        * http://jsfiddle.net/aryzhov/pkfst550/
        */ static binarySearch(ar, el, comparator) {
            if (undefined === comparator) comparator = Arrays.numberComparator;
            let m = 0;
            let n = ar.length - 1;
            while(m <= n){
                const k = n + m >> 1;
                const cmp = comparator(el, ar[k]);
                if (cmp > 0) m = k + 1;
                else if (cmp < 0) n = k - 1;
                else return k;
            }
            return -m - 1;
        }
        static numberComparator(a, b) {
            return a - b;
        }
    }
    /**
     * Ponyfill for Java's Integer class.
     */ class Integer {
        static numberOfTrailingZeros(i) {
            let y;
            if (i === 0) return 32;
            let n = 31;
            y = i << 16;
            if (y !== 0) {
                n -= 16;
                i = y;
            }
            y = i << 8;
            if (y !== 0) {
                n -= 8;
                i = y;
            }
            y = i << 4;
            if (y !== 0) {
                n -= 4;
                i = y;
            }
            y = i << 2;
            if (y !== 0) {
                n -= 2;
                i = y;
            }
            return n - (i << 1 >>> 31);
        }
        static numberOfLeadingZeros(i) {
            // HD, Figure 5-6
            if (i === 0) return 32;
            let n = 1;
            if (i >>> 16 === 0) {
                n += 16;
                i <<= 16;
            }
            if (i >>> 24 === 0) {
                n += 8;
                i <<= 8;
            }
            if (i >>> 28 === 0) {
                n += 4;
                i <<= 4;
            }
            if (i >>> 30 === 0) {
                n += 2;
                i <<= 2;
            }
            n -= i >>> 31;
            return n;
        }
        static toHexString(i) {
            return i.toString(16);
        }
        static toBinaryString(intNumber) {
            return String(parseInt(String(intNumber), 2));
        }
        // Returns the number of one-bits in the two's complement binary representation of the specified int value. This function is sometimes referred to as the population count.
        // Returns:
        // the number of one-bits in the two's complement binary representation of the specified int value.
        static bitCount(i) {
            // HD, Figure 5-2
            i = i - (i >>> 1 & 0x55555555);
            i = (i & 0x33333333) + (i >>> 2 & 0x33333333);
            i = i + (i >>> 4) & 0x0f0f0f0f;
            i = i + (i >>> 8);
            i = i + (i >>> 16);
            return i & 0x3f;
        }
        static truncDivision(dividend, divisor) {
            return Math.trunc(dividend / divisor);
        }
        /**
         * Converts A string to an integer.
         * @param s A string to convert into a number.
         * @param radix A value between 2 and 36 that specifies the base of the number in numString. If this argument is not supplied, strings with a prefix of '0x' are considered hexadecimal. All other strings are considered decimal.
         */ static parseInt(num, radix) {
            return parseInt(num, radix);
        }
    }
    Integer.MIN_VALUE_32_BITS = -2147483648;
    Integer.MAX_VALUE = Number.MAX_SAFE_INTEGER;
    /**
     * <p>A simple, fast array of bits, represented compactly by an array of ints internally.</p>
     *
     * @author Sean Owen
     */ class BitArray {
        // For testing only
        constructor(size /*int*/ , bits){
            if (undefined === size) {
                this.size = 0;
                this.bits = new Int32Array(1);
            } else {
                this.size = size;
                if (undefined === bits || null === bits) this.bits = BitArray.makeArray(size);
                else this.bits = bits;
            }
        }
        getSize() {
            return this.size;
        }
        getSizeInBytes() {
            return Math.floor((this.size + 7) / 8);
        }
        ensureCapacity(size /*int*/ ) {
            if (size > this.bits.length * 32) {
                const newBits = BitArray.makeArray(size);
                System.arraycopy(this.bits, 0, newBits, 0, this.bits.length);
                this.bits = newBits;
            }
        }
        /**
         * @param i bit to get
         * @return true iff bit i is set
         */ get(i /*int*/ ) {
            return (this.bits[Math.floor(i / 32)] & 1 << (i & 0x1F)) !== 0;
        }
        /**
         * Sets bit i.
         *
         * @param i bit to set
         */ set(i /*int*/ ) {
            this.bits[Math.floor(i / 32)] |= 1 << (i & 0x1F);
        }
        /**
         * Flips bit i.
         *
         * @param i bit to set
         */ flip(i /*int*/ ) {
            this.bits[Math.floor(i / 32)] ^= 1 << (i & 0x1F);
        }
        /**
         * @param from first bit to check
         * @return index of first bit that is set, starting from the given index, or size if none are set
         *  at or beyond this given index
         * @see #getNextUnset(int)
         */ getNextSet(from /*int*/ ) {
            const size = this.size;
            if (from >= size) return size;
            const bits = this.bits;
            let bitsOffset = Math.floor(from / 32);
            let currentBits = bits[bitsOffset];
            // mask off lesser bits first
            currentBits &= ~((1 << (from & 0x1F)) - 1);
            const length = bits.length;
            while(currentBits === 0){
                if (++bitsOffset === length) return size;
                currentBits = bits[bitsOffset];
            }
            const result = bitsOffset * 32 + Integer.numberOfTrailingZeros(currentBits);
            return result > size ? size : result;
        }
        /**
         * @param from index to start looking for unset bit
         * @return index of next unset bit, or {@code size} if none are unset until the end
         * @see #getNextSet(int)
         */ getNextUnset(from /*int*/ ) {
            const size = this.size;
            if (from >= size) return size;
            const bits = this.bits;
            let bitsOffset = Math.floor(from / 32);
            let currentBits = ~bits[bitsOffset];
            // mask off lesser bits first
            currentBits &= ~((1 << (from & 0x1F)) - 1);
            const length = bits.length;
            while(currentBits === 0){
                if (++bitsOffset === length) return size;
                currentBits = ~bits[bitsOffset];
            }
            const result = bitsOffset * 32 + Integer.numberOfTrailingZeros(currentBits);
            return result > size ? size : result;
        }
        /**
         * Sets a block of 32 bits, starting at bit i.
         *
         * @param i first bit to set
         * @param newBits the new value of the next 32 bits. Note again that the least-significant bit
         * corresponds to bit i, the next-least-significant to i+1, and so on.
         */ setBulk(i /*int*/ , newBits /*int*/ ) {
            this.bits[Math.floor(i / 32)] = newBits;
        }
        /**
         * Sets a range of bits.
         *
         * @param start start of range, inclusive.
         * @param end end of range, exclusive
         */ setRange(start /*int*/ , end /*int*/ ) {
            if (end < start || start < 0 || end > this.size) throw new IllegalArgumentException();
            if (end === start) return;
            end--; // will be easier to treat this as the last actually set bit -- inclusive
            const firstInt = Math.floor(start / 32);
            const lastInt = Math.floor(end / 32);
            const bits = this.bits;
            for(let i = firstInt; i <= lastInt; i++){
                const firstBit = i > firstInt ? 0 : start & 0x1F;
                const lastBit = i < lastInt ? 31 : end & 0x1F;
                // Ones from firstBit to lastBit, inclusive
                const mask = (2 << lastBit) - (1 << firstBit);
                bits[i] |= mask;
            }
        }
        /**
         * Clears all bits (sets to false).
         */ clear() {
            const max = this.bits.length;
            const bits = this.bits;
            for(let i = 0; i < max; i++)bits[i] = 0;
        }
        /**
         * Efficient method to check if a range of bits is set, or not set.
         *
         * @param start start of range, inclusive.
         * @param end end of range, exclusive
         * @param value if true, checks that bits in range are set, otherwise checks that they are not set
         * 
         * @return true iff all bits are set or not set in range, according to value argument
         * @throws IllegalArgumentException if end is less than start or the range is not contained in the array
         */ isRange(start /*int*/ , end /*int*/ , value) {
            if (end < start || start < 0 || end > this.size) throw new IllegalArgumentException();
            if (end === start) return true; // empty range matches
            end--; // will be easier to treat this as the last actually set bit -- inclusive
            const firstInt = Math.floor(start / 32);
            const lastInt = Math.floor(end / 32);
            const bits = this.bits;
            for(let i = firstInt; i <= lastInt; i++){
                const firstBit = i > firstInt ? 0 : start & 0x1F;
                const lastBit = i < lastInt ? 31 : end & 0x1F;
                // Ones from firstBit to lastBit, inclusive
                const mask = (2 << lastBit) - (1 << firstBit) & 0xFFFFFFFF;
                // TYPESCRIPTPORT: & 0xFFFFFFFF added to discard anything after 32 bits, as ES has 53 bits
                // Return false if we're looking for 1s and the masked bits[i] isn't all 1s (is: that,
                // equals the mask, or we're looking for 0s and the masked portion is not all 0s
                if ((bits[i] & mask) !== (value ? mask : 0)) return false;
            }
            return true;
        }
        appendBit(bit) {
            this.ensureCapacity(this.size + 1);
            if (bit) this.bits[Math.floor(this.size / 32)] |= 1 << (this.size & 0x1F);
            this.size++;
        }
        /**
         * Appends the least-significant bits, from value, in order from most-significant to
         * least-significant. For example, appending 6 bits from 0x000001E will append the bits
         * 0, 1, 1, 1, 1, 0 in that order.
         *
         * @param value {@code int} containing bits to append
         * @param numBits bits from value to append
         */ appendBits(value /*int*/ , numBits /*int*/ ) {
            if (numBits < 0 || numBits > 32) throw new IllegalArgumentException('Num bits must be between 0 and 32');
            this.ensureCapacity(this.size + numBits);
            // const appendBit = this.appendBit;
            for(let numBitsLeft = numBits; numBitsLeft > 0; numBitsLeft--)this.appendBit((value >> numBitsLeft - 1 & 0x01) === 1);
        }
        appendBitArray(other) {
            const otherSize = other.size;
            this.ensureCapacity(this.size + otherSize);
            // const appendBit = this.appendBit;
            for(let i = 0; i < otherSize; i++)this.appendBit(other.get(i));
        }
        xor(other) {
            if (this.size !== other.size) throw new IllegalArgumentException('Sizes don\'t match');
            const bits = this.bits;
            for(let i = 0, length = bits.length; i < length; i++)// The last int could be incomplete (i.e. not have 32 bits in
            // it) but there is no problem since 0 XOR 0 == 0.
            bits[i] ^= other.bits[i];
        }
        /**
         *
         * @param bitOffset first bit to start writing
         * @param array array to write into. Bytes are written most-significant byte first. This is the opposite
         *  of the internal representation, which is exposed by {@link #getBitArray()}
         * @param offset position in array to start writing
         * @param numBytes how many bytes to write
         */ toBytes(bitOffset /*int*/ , array, offset /*int*/ , numBytes /*int*/ ) {
            for(let i = 0; i < numBytes; i++){
                let theByte = 0;
                for(let j = 0; j < 8; j++){
                    if (this.get(bitOffset)) theByte |= 1 << 7 - j;
                    bitOffset++;
                }
                array[offset + i] = /*(byte)*/ theByte;
            }
        }
        /**
         * @return underlying array of ints. The first element holds the first 32 bits, and the least
         *         significant bit is bit 0.
         */ getBitArray() {
            return this.bits;
        }
        /**
         * Reverses all bits in the array.
         */ reverse() {
            const newBits = new Int32Array(this.bits.length);
            // reverse all int's first
            const len = Math.floor((this.size - 1) / 32);
            const oldBitsLen = len + 1;
            const bits = this.bits;
            for(let i = 0; i < oldBitsLen; i++){
                let x = bits[i];
                x = x >> 1 & 0x55555555 | (x & 0x55555555) << 1;
                x = x >> 2 & 0x33333333 | (x & 0x33333333) << 2;
                x = x >> 4 & 0x0f0f0f0f | (x & 0x0f0f0f0f) << 4;
                x = x >> 8 & 0x00ff00ff | (x & 0x00ff00ff) << 8;
                x = x >> 16 & 0x0000ffff | (x & 0x0000ffff) << 16;
                newBits[len - i] = /*(int)*/ x;
            }
            // now correct the int's if the bit size isn't a multiple of 32
            if (this.size !== oldBitsLen * 32) {
                const leftOffset = oldBitsLen * 32 - this.size;
                let currentInt = newBits[0] >>> leftOffset;
                for(let i = 1; i < oldBitsLen; i++){
                    const nextInt = newBits[i];
                    currentInt |= nextInt << 32 - leftOffset;
                    newBits[i - 1] = currentInt;
                    currentInt = nextInt >>> leftOffset;
                }
                newBits[oldBitsLen - 1] = currentInt;
            }
            this.bits = newBits;
        }
        static makeArray(size /*int*/ ) {
            return new Int32Array(Math.floor((size + 31) / 32));
        }
        /*@Override*/ equals(o) {
            if (!(o instanceof BitArray)) return false;
            const other = o;
            return this.size === other.size && Arrays.equals(this.bits, other.bits);
        }
        /*@Override*/ hashCode() {
            return 31 * this.size + Arrays.hashCode(this.bits);
        }
        /*@Override*/ toString() {
            let result = '';
            for(let i = 0, size = this.size; i < size; i++){
                if ((i & 0x07) === 0) result += ' ';
                result += this.get(i) ? 'X' : '.';
            }
            return result;
        }
        /*@Override*/ clone() {
            return new BitArray(this.size, this.bits.slice());
        }
    }
    /*
     * Copyright 2009 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /*namespace com.google.zxing {*/ /**
     * Encapsulates a type of hint that a caller may pass to a barcode reader to help it
     * more quickly or accurately decode it. It is up to implementations to decide what,
     * if anything, to do with the information that is supplied.
     *
     * @author Sean Owen
     * @author dswitkin@google.com (Daniel Switkin)
     * @see Reader#decode(BinaryBitmap,java.util.Map)
     */ var DecodeHintType;
    (function(DecodeHintType) {
        /**
         * Unspecified, application-specific hint. Maps to an unspecified {@link Object}.
         */ DecodeHintType[DecodeHintType["OTHER"] = 0] = "OTHER"; /*(Object.class)*/ 
        /**
         * Image is a pure monochrome image of a barcode. Doesn't matter what it maps to;
         * use {@link Boolean#TRUE}.
         */ DecodeHintType[DecodeHintType["PURE_BARCODE"] = 1] = "PURE_BARCODE"; /*(Void.class)*/ 
        /**
         * Image is known to be of one of a few possible formats.
         * Maps to a {@link List} of {@link BarcodeFormat}s.
         */ DecodeHintType[DecodeHintType["POSSIBLE_FORMATS"] = 2] = "POSSIBLE_FORMATS"; /*(List.class)*/ 
        /**
         * Spend more time to try to find a barcode; optimize for accuracy, not speed.
         * Doesn't matter what it maps to; use {@link Boolean#TRUE}.
         */ DecodeHintType[DecodeHintType["TRY_HARDER"] = 3] = "TRY_HARDER"; /*(Void.class)*/ 
        /**
         * Specifies what character encoding to use when decoding, where applicable (type String)
         */ DecodeHintType[DecodeHintType["CHARACTER_SET"] = 4] = "CHARACTER_SET"; /*(String.class)*/ 
        /**
         * Allowed lengths of encoded data -- reject anything else. Maps to an {@code Int32Array}.
         */ DecodeHintType[DecodeHintType["ALLOWED_LENGTHS"] = 5] = "ALLOWED_LENGTHS"; /*(Int32Array.class)*/ 
        /**
         * Assume Code 39 codes employ a check digit. Doesn't matter what it maps to;
         * use {@link Boolean#TRUE}.
         */ DecodeHintType[DecodeHintType["ASSUME_CODE_39_CHECK_DIGIT"] = 6] = "ASSUME_CODE_39_CHECK_DIGIT"; /*(Void.class)*/ 
        /**
         * Assume the barcode is being processed as a GS1 barcode, and modify behavior as needed.
         * For example this affects FNC1 handling for Code 128 (aka GS1-128). Doesn't matter what it maps to;
         * use {@link Boolean#TRUE}.
         */ DecodeHintType[DecodeHintType["ASSUME_GS1"] = 7] = "ASSUME_GS1"; /*(Void.class)*/ 
        /**
         * If true, return the start and end digits in a Codabar barcode instead of stripping them. They
         * are alpha, whereas the rest are numeric. By default, they are stripped, but this causes them
         * to not be. Doesn't matter what it maps to; use {@link Boolean#TRUE}.
         */ DecodeHintType[DecodeHintType["RETURN_CODABAR_START_END"] = 8] = "RETURN_CODABAR_START_END"; /*(Void.class)*/ 
        /**
         * The caller needs to be notified via callback when a possible {@link ResultPoint}
         * is found. Maps to a {@link ResultPointCallback}.
         */ DecodeHintType[DecodeHintType["NEED_RESULT_POINT_CALLBACK"] = 9] = "NEED_RESULT_POINT_CALLBACK"; /*(ResultPointCallback.class)*/ 
        /**
         * Allowed extension lengths for EAN or UPC barcodes. Other formats will ignore this.
         * Maps to an {@code Int32Array} of the allowed extension lengths, for example [2], [5], or [2, 5].
         * If it is optional to have an extension, do not set this hint. If this is set,
         * and a UPC or EAN barcode is found but an extension is not, then no result will be returned
         * at all.
         */ DecodeHintType[DecodeHintType["ALLOWED_EAN_EXTENSIONS"] = 10] = "ALLOWED_EAN_EXTENSIONS"; /*(Int32Array.class)*/ 
    // End of enumeration values.
    /**
         * Data type the hint is expecting.
         * Among the possible values the {@link Void} stands out as being used for
         * hints that do not expect a value to be supplied (flag hints). Such hints
         * will possibly have their value ignored, or replaced by a
         * {@link Boolean#TRUE}. Hint suppliers should probably use
         * {@link Boolean#TRUE} as directed by the actual hint documentation.
         */ // private valueType: Class<?>
    // DecodeHintType(valueType: Class<?>) {
    //   this.valueType = valueType
    // }
    // public getValueType(): Class<?> {
    //   return valueType
    // }
    })(DecodeHintType || (DecodeHintType = {}));
    var DecodeHintType$1 = DecodeHintType;
    /**
     * Custom Error class of type Exception.
     */ class FormatException extends Exception {
        static getFormatInstance() {
            return new FormatException();
        }
    }
    FormatException.kind = 'FormatException';
    /*import java.util.HashMap;*/ /*import java.util.Map;*/ var CharacterSetValueIdentifiers;
    (function(CharacterSetValueIdentifiers) {
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["Cp437"] = 0] = "Cp437";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_1"] = 1] = "ISO8859_1";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_2"] = 2] = "ISO8859_2";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_3"] = 3] = "ISO8859_3";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_4"] = 4] = "ISO8859_4";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_5"] = 5] = "ISO8859_5";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_6"] = 6] = "ISO8859_6";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_7"] = 7] = "ISO8859_7";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_8"] = 8] = "ISO8859_8";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_9"] = 9] = "ISO8859_9";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_10"] = 10] = "ISO8859_10";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_11"] = 11] = "ISO8859_11";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_13"] = 12] = "ISO8859_13";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_14"] = 13] = "ISO8859_14";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_15"] = 14] = "ISO8859_15";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_16"] = 15] = "ISO8859_16";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["SJIS"] = 16] = "SJIS";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["Cp1250"] = 17] = "Cp1250";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["Cp1251"] = 18] = "Cp1251";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["Cp1252"] = 19] = "Cp1252";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["Cp1256"] = 20] = "Cp1256";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["UnicodeBigUnmarked"] = 21] = "UnicodeBigUnmarked";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["UTF8"] = 22] = "UTF8";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ASCII"] = 23] = "ASCII";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["Big5"] = 24] = "Big5";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["GB18030"] = 25] = "GB18030";
        CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["EUC_KR"] = 26] = "EUC_KR";
    })(CharacterSetValueIdentifiers || (CharacterSetValueIdentifiers = {}));
    /**
     * Encapsulates a Character Set ECI, according to "Extended Channel Interpretations" 5.3.1.1
     * of ISO 18004.
     *
     * @author Sean Owen
     */ class CharacterSetECI {
        constructor(valueIdentifier, valuesParam, name, ...otherEncodingNames){
            this.valueIdentifier = valueIdentifier;
            this.name = name;
            if (typeof valuesParam === 'number') this.values = Int32Array.from([
                valuesParam
            ]);
            else this.values = valuesParam;
            this.otherEncodingNames = otherEncodingNames;
            CharacterSetECI.VALUE_IDENTIFIER_TO_ECI.set(valueIdentifier, this);
            CharacterSetECI.NAME_TO_ECI.set(name, this);
            const values = this.values;
            for(let i = 0, length = values.length; i !== length; i++){
                const v = values[i];
                CharacterSetECI.VALUES_TO_ECI.set(v, this);
            }
            for (const otherName of otherEncodingNames)CharacterSetECI.NAME_TO_ECI.set(otherName, this);
        }
        // CharacterSetECI(value: number /*int*/) {
        //   this(new Int32Array {value})
        // }
        // CharacterSetECI(value: number /*int*/, String... otherEncodingNames) {
        //   this.values = new Int32Array {value}
        //   this.otherEncodingNames = otherEncodingNames
        // }
        // CharacterSetECI(values: Int32Array, String... otherEncodingNames) {
        //   this.values = values
        //   this.otherEncodingNames = otherEncodingNames
        // }
        getValueIdentifier() {
            return this.valueIdentifier;
        }
        getName() {
            return this.name;
        }
        getValue() {
            return this.values[0];
        }
        /**
         * @param value character set ECI value
         * @return {@code CharacterSetECI} representing ECI of given value, or null if it is legal but
         *   unsupported
         * @throws FormatException if ECI value is invalid
         */ static getCharacterSetECIByValue(value /*int*/ ) {
            if (value < 0 || value >= 900) throw new FormatException('incorect value');
            const characterSet = CharacterSetECI.VALUES_TO_ECI.get(value);
            if (undefined === characterSet) throw new FormatException('incorect value');
            return characterSet;
        }
        /**
         * @param name character set ECI encoding name
         * @return CharacterSetECI representing ECI for character encoding, or null if it is legal
         *   but unsupported
         */ static getCharacterSetECIByName(name) {
            const characterSet = CharacterSetECI.NAME_TO_ECI.get(name);
            if (undefined === characterSet) throw new FormatException('incorect value');
            return characterSet;
        }
        equals(o) {
            if (!(o instanceof CharacterSetECI)) return false;
            const other = o;
            return this.getName() === other.getName();
        }
    }
    CharacterSetECI.VALUE_IDENTIFIER_TO_ECI = new Map();
    CharacterSetECI.VALUES_TO_ECI = new Map();
    CharacterSetECI.NAME_TO_ECI = new Map();
    // Enum name is a Java encoding valid for java.lang and java.io
    // TYPESCRIPTPORT: changed the main label for ISO as the TextEncoder did not recognized them in the form from java
    // (eg ISO8859_1 must be ISO88591 or ISO8859-1 or ISO-8859-1)
    // later on: well, except 16 wich does not work with ISO885916 so used ISO-8859-1 form for default
    CharacterSetECI.Cp437 = new CharacterSetECI(CharacterSetValueIdentifiers.Cp437, Int32Array.from([
        0,
        2
    ]), 'Cp437');
    CharacterSetECI.ISO8859_1 = new CharacterSetECI(CharacterSetValueIdentifiers.ISO8859_1, Int32Array.from([
        1,
        3
    ]), 'ISO-8859-1', 'ISO88591', 'ISO8859_1');
    CharacterSetECI.ISO8859_2 = new CharacterSetECI(CharacterSetValueIdentifiers.ISO8859_2, 4, 'ISO-8859-2', 'ISO88592', 'ISO8859_2');
    CharacterSetECI.ISO8859_3 = new CharacterSetECI(CharacterSetValueIdentifiers.ISO8859_3, 5, 'ISO-8859-3', 'ISO88593', 'ISO8859_3');
    CharacterSetECI.ISO8859_4 = new CharacterSetECI(CharacterSetValueIdentifiers.ISO8859_4, 6, 'ISO-8859-4', 'ISO88594', 'ISO8859_4');
    CharacterSetECI.ISO8859_5 = new CharacterSetECI(CharacterSetValueIdentifiers.ISO8859_5, 7, 'ISO-8859-5', 'ISO88595', 'ISO8859_5');
    CharacterSetECI.ISO8859_6 = new CharacterSetECI(CharacterSetValueIdentifiers.ISO8859_6, 8, 'ISO-8859-6', 'ISO88596', 'ISO8859_6');
    CharacterSetECI.ISO8859_7 = new CharacterSetECI(CharacterSetValueIdentifiers.ISO8859_7, 9, 'ISO-8859-7', 'ISO88597', 'ISO8859_7');
    CharacterSetECI.ISO8859_8 = new CharacterSetECI(CharacterSetValueIdentifiers.ISO8859_8, 10, 'ISO-8859-8', 'ISO88598', 'ISO8859_8');
    CharacterSetECI.ISO8859_9 = new CharacterSetECI(CharacterSetValueIdentifiers.ISO8859_9, 11, 'ISO-8859-9', 'ISO88599', 'ISO8859_9');
    CharacterSetECI.ISO8859_10 = new CharacterSetECI(CharacterSetValueIdentifiers.ISO8859_10, 12, 'ISO-8859-10', 'ISO885910', 'ISO8859_10');
    CharacterSetECI.ISO8859_11 = new CharacterSetECI(CharacterSetValueIdentifiers.ISO8859_11, 13, 'ISO-8859-11', 'ISO885911', 'ISO8859_11');
    CharacterSetECI.ISO8859_13 = new CharacterSetECI(CharacterSetValueIdentifiers.ISO8859_13, 15, 'ISO-8859-13', 'ISO885913', 'ISO8859_13');
    CharacterSetECI.ISO8859_14 = new CharacterSetECI(CharacterSetValueIdentifiers.ISO8859_14, 16, 'ISO-8859-14', 'ISO885914', 'ISO8859_14');
    CharacterSetECI.ISO8859_15 = new CharacterSetECI(CharacterSetValueIdentifiers.ISO8859_15, 17, 'ISO-8859-15', 'ISO885915', 'ISO8859_15');
    CharacterSetECI.ISO8859_16 = new CharacterSetECI(CharacterSetValueIdentifiers.ISO8859_16, 18, 'ISO-8859-16', 'ISO885916', 'ISO8859_16');
    CharacterSetECI.SJIS = new CharacterSetECI(CharacterSetValueIdentifiers.SJIS, 20, 'SJIS', 'Shift_JIS');
    CharacterSetECI.Cp1250 = new CharacterSetECI(CharacterSetValueIdentifiers.Cp1250, 21, 'Cp1250', 'windows-1250');
    CharacterSetECI.Cp1251 = new CharacterSetECI(CharacterSetValueIdentifiers.Cp1251, 22, 'Cp1251', 'windows-1251');
    CharacterSetECI.Cp1252 = new CharacterSetECI(CharacterSetValueIdentifiers.Cp1252, 23, 'Cp1252', 'windows-1252');
    CharacterSetECI.Cp1256 = new CharacterSetECI(CharacterSetValueIdentifiers.Cp1256, 24, 'Cp1256', 'windows-1256');
    CharacterSetECI.UnicodeBigUnmarked = new CharacterSetECI(CharacterSetValueIdentifiers.UnicodeBigUnmarked, 25, 'UnicodeBigUnmarked', 'UTF-16BE', 'UnicodeBig');
    CharacterSetECI.UTF8 = new CharacterSetECI(CharacterSetValueIdentifiers.UTF8, 26, 'UTF8', 'UTF-8');
    CharacterSetECI.ASCII = new CharacterSetECI(CharacterSetValueIdentifiers.ASCII, Int32Array.from([
        27,
        170
    ]), 'ASCII', 'US-ASCII');
    CharacterSetECI.Big5 = new CharacterSetECI(CharacterSetValueIdentifiers.Big5, 28, 'Big5');
    CharacterSetECI.GB18030 = new CharacterSetECI(CharacterSetValueIdentifiers.GB18030, 29, 'GB18030', 'GB2312', 'EUC_CN', 'GBK');
    CharacterSetECI.EUC_KR = new CharacterSetECI(CharacterSetValueIdentifiers.EUC_KR, 30, 'EUC_KR', 'EUC-KR');
    /**
     * Custom Error class of type Exception.
     */ class UnsupportedOperationException extends Exception {
    }
    UnsupportedOperationException.kind = 'UnsupportedOperationException';
    /**
     * Responsible for en/decoding strings.
     */ class StringEncoding {
        /**
         * Decodes some Uint8Array to a string format.
         */ static decode(bytes, encoding) {
            const encodingName = this.encodingName(encoding);
            if (this.customDecoder) return this.customDecoder(bytes, encodingName);
            // Increases browser support.
            if (typeof TextDecoder === 'undefined' || this.shouldDecodeOnFallback(encodingName)) return this.decodeFallback(bytes, encodingName);
            return new TextDecoder(encodingName).decode(bytes);
        }
        /**
         * Checks if the decoding method should use the fallback for decoding
         * once Node TextDecoder doesn't support all encoding formats.
         *
         * @param encodingName
         */ static shouldDecodeOnFallback(encodingName) {
            return !StringEncoding.isBrowser() && encodingName === 'ISO-8859-1';
        }
        /**
         * Encodes some string into a Uint8Array.
         */ static encode(s, encoding) {
            const encodingName = this.encodingName(encoding);
            if (this.customEncoder) return this.customEncoder(s, encodingName);
            // Increases browser support.
            if (typeof TextEncoder === 'undefined') return this.encodeFallback(s);
            // TextEncoder only encodes to UTF8 by default as specified by encoding.spec.whatwg.org
            return new TextEncoder().encode(s);
        }
        static isBrowser() {
            return typeof window !== 'undefined' && ({}).toString.call(window) === '[object Window]';
        }
        /**
         * Returns the string value from some encoding character set.
         */ static encodingName(encoding) {
            return typeof encoding === 'string' ? encoding : encoding.getName();
        }
        /**
         * Returns character set from some encoding character set.
         */ static encodingCharacterSet(encoding) {
            if (encoding instanceof CharacterSetECI) return encoding;
            return CharacterSetECI.getCharacterSetECIByName(encoding);
        }
        /**
         * Runs a fallback for the native decoding funcion.
         */ static decodeFallback(bytes, encoding) {
            const characterSet = this.encodingCharacterSet(encoding);
            if (StringEncoding.isDecodeFallbackSupported(characterSet)) {
                let s = '';
                for(let i = 0, length = bytes.length; i < length; i++){
                    let h = bytes[i].toString(16);
                    if (h.length < 2) h = '0' + h;
                    s += '%' + h;
                }
                return decodeURIComponent(s);
            }
            if (characterSet.equals(CharacterSetECI.UnicodeBigUnmarked)) return String.fromCharCode.apply(null, new Uint16Array(bytes.buffer));
            throw new UnsupportedOperationException(`Encoding ${this.encodingName(encoding)} not supported by fallback.`);
        }
        static isDecodeFallbackSupported(characterSet) {
            return characterSet.equals(CharacterSetECI.UTF8) || characterSet.equals(CharacterSetECI.ISO8859_1) || characterSet.equals(CharacterSetECI.ASCII);
        }
        /**
         * Runs a fallback for the native encoding funcion.
         *
         * @see https://stackoverflow.com/a/17192845/4367683
         */ static encodeFallback(s) {
            const encodedURIstring = btoa(unescape(encodeURIComponent(s)));
            const charList = encodedURIstring.split('');
            const uintArray = [];
            for(let i = 0; i < charList.length; i++)uintArray.push(charList[i].charCodeAt(0));
            return new Uint8Array(uintArray);
        }
    }
    /*
     * Copyright (C) 2010 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * Common string-related functions.
     *
     * @author Sean Owen
     * @author Alex Dupre
     */ class StringUtils {
        // SHIFT_JIS.equalsIgnoreCase(PLATFORM_DEFAULT_ENCODING) ||
        // EUC_JP.equalsIgnoreCase(PLATFORM_DEFAULT_ENCODING);
        static castAsNonUtf8Char(code, encoding = null) {
            // ISO 8859-1 is the Java default as UTF-8 is JavaScripts
            // you can see this method as a Java version of String.fromCharCode
            const e = encoding ? encoding.getName() : this.ISO88591;
            // use passed format (fromCharCode will return UTF8 encoding)
            return StringEncoding.decode(new Uint8Array([
                code
            ]), e);
        }
        /**
         * @param bytes bytes encoding a string, whose encoding should be guessed
         * @param hints decode hints if applicable
         * @return name of guessed encoding; at the moment will only guess one of:
         *  {@link #SHIFT_JIS}, {@link #UTF8}, {@link #ISO88591}, or the platform
         *  default encoding if none of these can possibly be correct
         */ static guessEncoding(bytes, hints) {
            if (hints !== null && hints !== undefined && undefined !== hints.get(DecodeHintType$1.CHARACTER_SET)) return hints.get(DecodeHintType$1.CHARACTER_SET).toString();
            // For now, merely tries to distinguish ISO-8859-1, UTF-8 and Shift_JIS,
            // which should be by far the most common encodings.
            const length = bytes.length;
            let canBeISO88591 = true;
            let canBeShiftJIS = true;
            let canBeUTF8 = true;
            let utf8BytesLeft = 0;
            // int utf8LowChars = 0
            let utf2BytesChars = 0;
            let utf3BytesChars = 0;
            let utf4BytesChars = 0;
            let sjisBytesLeft = 0;
            // int sjisLowChars = 0
            let sjisKatakanaChars = 0;
            // int sjisDoubleBytesChars = 0
            let sjisCurKatakanaWordLength = 0;
            let sjisCurDoubleBytesWordLength = 0;
            let sjisMaxKatakanaWordLength = 0;
            let sjisMaxDoubleBytesWordLength = 0;
            // int isoLowChars = 0
            // int isoHighChars = 0
            let isoHighOther = 0;
            const utf8bom = bytes.length > 3 && bytes[0] === /*(byte) */ 0xEF && bytes[1] === /*(byte) */ 0xBB && bytes[2] === /*(byte) */ 0xBF;
            for(let i = 0; i < length && (canBeISO88591 || canBeShiftJIS || canBeUTF8); i++){
                const value = bytes[i] & 0xFF;
                // UTF-8 stuff
                if (canBeUTF8) {
                    if (utf8BytesLeft > 0) {
                        if ((value & 0x80) === 0) canBeUTF8 = false;
                        else utf8BytesLeft--;
                    } else if ((value & 0x80) !== 0) {
                        if ((value & 0x40) === 0) canBeUTF8 = false;
                        else {
                            utf8BytesLeft++;
                            if ((value & 0x20) === 0) utf2BytesChars++;
                            else {
                                utf8BytesLeft++;
                                if ((value & 0x10) === 0) utf3BytesChars++;
                                else {
                                    utf8BytesLeft++;
                                    if ((value & 0x08) === 0) utf4BytesChars++;
                                    else canBeUTF8 = false;
                                }
                            }
                        }
                    } // else {
                // utf8LowChars++
                // }
                }
                // ISO-8859-1 stuff
                if (canBeISO88591) {
                    if (value > 0x7F && value < 0xA0) canBeISO88591 = false;
                    else if (value > 0x9F) {
                        if (value < 0xC0 || value === 0xD7 || value === 0xF7) isoHighOther++;
                         // else {
                    } // else {
                // isoLowChars++
                // }
                }
                // Shift_JIS stuff
                if (canBeShiftJIS) {
                    if (sjisBytesLeft > 0) {
                        if (value < 0x40 || value === 0x7F || value > 0xFC) canBeShiftJIS = false;
                        else sjisBytesLeft--;
                    } else if (value === 0x80 || value === 0xA0 || value > 0xEF) canBeShiftJIS = false;
                    else if (value > 0xA0 && value < 0xE0) {
                        sjisKatakanaChars++;
                        sjisCurDoubleBytesWordLength = 0;
                        sjisCurKatakanaWordLength++;
                        if (sjisCurKatakanaWordLength > sjisMaxKatakanaWordLength) sjisMaxKatakanaWordLength = sjisCurKatakanaWordLength;
                    } else if (value > 0x7F) {
                        sjisBytesLeft++;
                        // sjisDoubleBytesChars++
                        sjisCurKatakanaWordLength = 0;
                        sjisCurDoubleBytesWordLength++;
                        if (sjisCurDoubleBytesWordLength > sjisMaxDoubleBytesWordLength) sjisMaxDoubleBytesWordLength = sjisCurDoubleBytesWordLength;
                    } else {
                        // sjisLowChars++
                        sjisCurKatakanaWordLength = 0;
                        sjisCurDoubleBytesWordLength = 0;
                    }
                }
            }
            if (canBeUTF8 && utf8BytesLeft > 0) canBeUTF8 = false;
            if (canBeShiftJIS && sjisBytesLeft > 0) canBeShiftJIS = false;
            // Easy -- if there is BOM or at least 1 valid not-single byte character (and no evidence it can't be UTF-8), done
            if (canBeUTF8 && (utf8bom || utf2BytesChars + utf3BytesChars + utf4BytesChars > 0)) return StringUtils.UTF8;
            // Easy -- if assuming Shift_JIS or at least 3 valid consecutive not-ascii characters (and no evidence it can't be), done
            if (canBeShiftJIS && (StringUtils.ASSUME_SHIFT_JIS || sjisMaxKatakanaWordLength >= 3 || sjisMaxDoubleBytesWordLength >= 3)) return StringUtils.SHIFT_JIS;
            // Distinguishing Shift_JIS and ISO-8859-1 can be a little tough for short words. The crude heuristic is:
            // - If we saw
            //   - only two consecutive katakana chars in the whole text, or
            //   - at least 10% of bytes that could be "upper" not-alphanumeric Latin1,
            // - then we conclude Shift_JIS, else ISO-8859-1
            if (canBeISO88591 && canBeShiftJIS) return sjisMaxKatakanaWordLength === 2 && sjisKatakanaChars === 2 || isoHighOther * 10 >= length ? StringUtils.SHIFT_JIS : StringUtils.ISO88591;
            // Otherwise, try in order ISO-8859-1, Shift JIS, UTF-8 and fall back to default platform encoding
            if (canBeISO88591) return StringUtils.ISO88591;
            if (canBeShiftJIS) return StringUtils.SHIFT_JIS;
            if (canBeUTF8) return StringUtils.UTF8;
            // Otherwise, we take a wild guess with platform encoding
            return StringUtils.PLATFORM_DEFAULT_ENCODING;
        }
        /**
         *
         * @see https://stackoverflow.com/a/13439711/4367683
         *
         * @param append The new string to append.
         * @param args Argumets values to be formated.
         */ static format(append, ...args) {
            let i = -1;
            function callback(exp, p0, p1, p2, p3, p4) {
                if (exp === '%%') return '%';
                if (args[++i] === undefined) return undefined;
                exp = p2 ? parseInt(p2.substr(1)) : undefined;
                let base = p3 ? parseInt(p3.substr(1)) : undefined;
                let val;
                switch(p4){
                    case 's':
                        val = args[i];
                        break;
                    case 'c':
                        val = args[i][0];
                        break;
                    case 'f':
                        val = parseFloat(args[i]).toFixed(exp);
                        break;
                    case 'p':
                        val = parseFloat(args[i]).toPrecision(exp);
                        break;
                    case 'e':
                        val = parseFloat(args[i]).toExponential(exp);
                        break;
                    case 'x':
                        val = parseInt(args[i]).toString(base ? base : 16);
                        break;
                    case 'd':
                        val = parseFloat(parseInt(args[i], base ? base : 10).toPrecision(exp)).toFixed(0);
                        break;
                }
                val = typeof val === 'object' ? JSON.stringify(val) : (+val).toString(base);
                let size = parseInt(p1); /* padding size */ 
                let ch = p1 && p1[0] + '' === '0' ? '0' : ' '; /* isnull? */ 
                while(val.length < size)val = p0 !== undefined ? val + ch : ch + val; /* isminus? */ 
                return val;
            }
            let regex = /%(-)?(0?[0-9]+)?([.][0-9]+)?([#][0-9]+)?([scfpexd%])/g;
            return append.replace(regex, callback);
        }
        /**
         *
         */ static getBytes(str, encoding) {
            return StringEncoding.encode(str, encoding);
        }
        /**
         * Returns the charcode at the specified index or at index zero.
         */ static getCharCode(str, index = 0) {
            return str.charCodeAt(index);
        }
        /**
         * Returns char for given charcode
         */ static getCharAt(charCode) {
            return String.fromCharCode(charCode);
        }
    }
    StringUtils.SHIFT_JIS = CharacterSetECI.SJIS.getName(); // "SJIS"
    StringUtils.GB2312 = 'GB2312';
    StringUtils.ISO88591 = CharacterSetECI.ISO8859_1.getName(); // "ISO8859_1"
    StringUtils.EUC_JP = 'EUC_JP';
    StringUtils.UTF8 = CharacterSetECI.UTF8.getName(); // "UTF8"
    StringUtils.PLATFORM_DEFAULT_ENCODING = StringUtils.UTF8; // "UTF8"//Charset.defaultCharset().name()
    StringUtils.ASSUME_SHIFT_JIS = false;
    class StringBuilder {
        constructor(value = ''){
            this.value = value;
        }
        enableDecoding(encoding) {
            this.encoding = encoding;
            return this;
        }
        append(s) {
            if (typeof s === 'string') this.value += s.toString();
            else if (this.encoding) // use passed format (fromCharCode will return UTF8 encoding)
            this.value += StringUtils.castAsNonUtf8Char(s, this.encoding);
            else // correctly converts from UTF-8, but not other encodings
            this.value += String.fromCharCode(s);
            return this;
        }
        appendChars(str, offset, len) {
            for(let i = offset; offset < offset + len; i++)this.append(str[i]);
            return this;
        }
        length() {
            return this.value.length;
        }
        charAt(n) {
            return this.value.charAt(n);
        }
        deleteCharAt(n) {
            this.value = this.value.substr(0, n) + this.value.substring(n + 1);
        }
        setCharAt(n, c) {
            this.value = this.value.substr(0, n) + c + this.value.substr(n + 1);
        }
        substring(start, end) {
            return this.value.substring(start, end);
        }
        /**
         * @note helper method for RSS Expanded
         */ setLengthToZero() {
            this.value = '';
        }
        toString() {
            return this.value;
        }
        insert(n, c) {
            this.value = this.value.substr(0, n) + c + this.value.substr(n + c.length);
        }
    }
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * <p>Represents a 2D matrix of bits. In function arguments below, and throughout the common
     * module, x is the column position, and y is the row position. The ordering is always x, y.
     * The origin is at the top-left.</p>
     *
     * <p>Internally the bits are represented in a 1-D array of 32-bit ints. However, each row begins
     * with a new int. This is done intentionally so that we can copy out a row into a BitArray very
     * efficiently.</p>
     *
     * <p>The ordering of bits is row-major. Within each int, the least significant bits are used first,
     * meaning they represent lower x values. This is compatible with BitArray's implementation.</p>
     *
     * @author Sean Owen
     * @author dswitkin@google.com (Daniel Switkin)
     */ class BitMatrix {
        /**
         * Creates an empty square {@link BitMatrix}.
         *
         * @param dimension height and width
         */ // public constructor(dimension: number /*int*/) {
        //   this(dimension, dimension)
        // }
        /**
         * Creates an empty {@link BitMatrix}.
         *
         * @param width bit matrix width
         * @param height bit matrix height
         */ // public constructor(width: number /*int*/, height: number /*int*/) {
        //   if (width < 1 || height < 1) {
        //     throw new IllegalArgumentException("Both dimensions must be greater than 0")
        //   }
        //   this.width = width
        //   this.height = height
        //   this.rowSize = (width + 31) / 32
        //   bits = new int[rowSize * height];
        // }
        constructor(width /*int*/ , height /*int*/ , rowSize /*int*/ , bits){
            this.width = width;
            this.height = height;
            this.rowSize = rowSize;
            this.bits = bits;
            if (undefined === height || null === height) height = width;
            this.height = height;
            if (width < 1 || height < 1) throw new IllegalArgumentException('Both dimensions must be greater than 0');
            if (undefined === rowSize || null === rowSize) rowSize = Math.floor((width + 31) / 32);
            this.rowSize = rowSize;
            if (undefined === bits || null === bits) this.bits = new Int32Array(this.rowSize * this.height);
        }
        /**
         * Interprets a 2D array of booleans as a {@link BitMatrix}, where "true" means an "on" bit.
         *
         * @function parse
         * @param image bits of the image, as a row-major 2D array. Elements are arrays representing rows
         * @return {@link BitMatrix} representation of image
         */ static parseFromBooleanArray(image) {
            const height = image.length;
            const width = image[0].length;
            const bits = new BitMatrix(width, height);
            for(let i = 0; i < height; i++){
                const imageI = image[i];
                for(let j = 0; j < width; j++)if (imageI[j]) bits.set(j, i);
            }
            return bits;
        }
        /**
         *
         * @function parse
         * @param stringRepresentation
         * @param setString
         * @param unsetString
         */ static parseFromString(stringRepresentation, setString, unsetString) {
            if (stringRepresentation === null) throw new IllegalArgumentException('stringRepresentation cannot be null');
            const bits = new Array(stringRepresentation.length);
            let bitsPos = 0;
            let rowStartPos = 0;
            let rowLength = -1;
            let nRows = 0;
            let pos = 0;
            while(pos < stringRepresentation.length){
                if (stringRepresentation.charAt(pos) === '\n' || stringRepresentation.charAt(pos) === '\r') {
                    if (bitsPos > rowStartPos) {
                        if (rowLength === -1) rowLength = bitsPos - rowStartPos;
                        else if (bitsPos - rowStartPos !== rowLength) throw new IllegalArgumentException('row lengths do not match');
                        rowStartPos = bitsPos;
                        nRows++;
                    }
                    pos++;
                } else if (stringRepresentation.substring(pos, pos + setString.length) === setString) {
                    pos += setString.length;
                    bits[bitsPos] = true;
                    bitsPos++;
                } else if (stringRepresentation.substring(pos, pos + unsetString.length) === unsetString) {
                    pos += unsetString.length;
                    bits[bitsPos] = false;
                    bitsPos++;
                } else throw new IllegalArgumentException('illegal character encountered: ' + stringRepresentation.substring(pos));
            }
            // no EOL at end?
            if (bitsPos > rowStartPos) {
                if (rowLength === -1) rowLength = bitsPos - rowStartPos;
                else if (bitsPos - rowStartPos !== rowLength) throw new IllegalArgumentException('row lengths do not match');
                nRows++;
            }
            const matrix = new BitMatrix(rowLength, nRows);
            for(let i = 0; i < bitsPos; i++)if (bits[i]) matrix.set(Math.floor(i % rowLength), Math.floor(i / rowLength));
            return matrix;
        }
        /**
         * <p>Gets the requested bit, where true means black.</p>
         *
         * @param x The horizontal component (i.e. which column)
         * @param y The vertical component (i.e. which row)
         * @return value of given bit in matrix
         */ get(x /*int*/ , y /*int*/ ) {
            const offset = y * this.rowSize + Math.floor(x / 32);
            return (this.bits[offset] >>> (x & 0x1f) & 1) !== 0;
        }
        /**
         * <p>Sets the given bit to true.</p>
         *
         * @param x The horizontal component (i.e. which column)
         * @param y The vertical component (i.e. which row)
         */ set(x /*int*/ , y /*int*/ ) {
            const offset = y * this.rowSize + Math.floor(x / 32);
            this.bits[offset] |= 1 << (x & 0x1f) & 0xFFFFFFFF;
        }
        unset(x /*int*/ , y /*int*/ ) {
            const offset = y * this.rowSize + Math.floor(x / 32);
            this.bits[offset] &= ~(1 << (x & 0x1f) & 0xFFFFFFFF);
        }
        /**
         * <p>Flips the given bit.</p>
         *
         * @param x The horizontal component (i.e. which column)
         * @param y The vertical component (i.e. which row)
         */ flip(x /*int*/ , y /*int*/ ) {
            const offset = y * this.rowSize + Math.floor(x / 32);
            this.bits[offset] ^= 1 << (x & 0x1f) & 0xFFFFFFFF;
        }
        /**
         * Exclusive-or (XOR): Flip the bit in this {@code BitMatrix} if the corresponding
         * mask bit is set.
         *
         * @param mask XOR mask
         */ xor(mask) {
            if (this.width !== mask.getWidth() || this.height !== mask.getHeight() || this.rowSize !== mask.getRowSize()) throw new IllegalArgumentException('input matrix dimensions do not match');
            const rowArray = new BitArray(Math.floor(this.width / 32) + 1);
            const rowSize = this.rowSize;
            const bits = this.bits;
            for(let y = 0, height = this.height; y < height; y++){
                const offset = y * rowSize;
                const row = mask.getRow(y, rowArray).getBitArray();
                for(let x = 0; x < rowSize; x++)bits[offset + x] ^= row[x];
            }
        }
        /**
         * Clears all bits (sets to false).
         */ clear() {
            const bits = this.bits;
            const max = bits.length;
            for(let i = 0; i < max; i++)bits[i] = 0;
        }
        /**
         * <p>Sets a square region of the bit matrix to true.</p>
         *
         * @param left The horizontal position to begin at (inclusive)
         * @param top The vertical position to begin at (inclusive)
         * @param width The width of the region
         * @param height The height of the region
         */ setRegion(left /*int*/ , top /*int*/ , width /*int*/ , height /*int*/ ) {
            if (top < 0 || left < 0) throw new IllegalArgumentException('Left and top must be nonnegative');
            if (height < 1 || width < 1) throw new IllegalArgumentException('Height and width must be at least 1');
            const right = left + width;
            const bottom = top + height;
            if (bottom > this.height || right > this.width) throw new IllegalArgumentException('The region must fit inside the matrix');
            const rowSize = this.rowSize;
            const bits = this.bits;
            for(let y = top; y < bottom; y++){
                const offset = y * rowSize;
                for(let x = left; x < right; x++)bits[offset + Math.floor(x / 32)] |= 1 << (x & 0x1f) & 0xFFFFFFFF;
            }
        }
        /**
         * A fast method to retrieve one row of data from the matrix as a BitArray.
         *
         * @param y The row to retrieve
         * @param row An optional caller-allocated BitArray, will be allocated if null or too small
         * @return The resulting BitArray - this reference should always be used even when passing
         *         your own row
         */ getRow(y /*int*/ , row) {
            if (row === null || row === undefined || row.getSize() < this.width) row = new BitArray(this.width);
            else row.clear();
            const rowSize = this.rowSize;
            const bits = this.bits;
            const offset = y * rowSize;
            for(let x = 0; x < rowSize; x++)row.setBulk(x * 32, bits[offset + x]);
            return row;
        }
        /**
         * @param y row to set
         * @param row {@link BitArray} to copy from
         */ setRow(y /*int*/ , row) {
            System.arraycopy(row.getBitArray(), 0, this.bits, y * this.rowSize, this.rowSize);
        }
        /**
         * Modifies this {@code BitMatrix} to represent the same but rotated 180 degrees
         */ rotate180() {
            const width = this.getWidth();
            const height = this.getHeight();
            let topRow = new BitArray(width);
            let bottomRow = new BitArray(width);
            for(let i = 0, length = Math.floor((height + 1) / 2); i < length; i++){
                topRow = this.getRow(i, topRow);
                bottomRow = this.getRow(height - 1 - i, bottomRow);
                topRow.reverse();
                bottomRow.reverse();
                this.setRow(i, bottomRow);
                this.setRow(height - 1 - i, topRow);
            }
        }
        /**
         * This is useful in detecting the enclosing rectangle of a 'pure' barcode.
         *
         * @return {@code left,top,width,height} enclosing rectangle of all 1 bits, or null if it is all white
         */ getEnclosingRectangle() {
            const width = this.width;
            const height = this.height;
            const rowSize = this.rowSize;
            const bits = this.bits;
            let left = width;
            let top = height;
            let right = -1;
            let bottom = -1;
            for(let y = 0; y < height; y++)for(let x32 = 0; x32 < rowSize; x32++){
                const theBits = bits[y * rowSize + x32];
                if (theBits !== 0) {
                    if (y < top) top = y;
                    if (y > bottom) bottom = y;
                    if (x32 * 32 < left) {
                        let bit = 0;
                        while((theBits << 31 - bit & 0xFFFFFFFF) === 0)bit++;
                        if (x32 * 32 + bit < left) left = x32 * 32 + bit;
                    }
                    if (x32 * 32 + 31 > right) {
                        let bit = 31;
                        while(theBits >>> bit === 0)bit--;
                        if (x32 * 32 + bit > right) right = x32 * 32 + bit;
                    }
                }
            }
            if (right < left || bottom < top) return null;
            return Int32Array.from([
                left,
                top,
                right - left + 1,
                bottom - top + 1
            ]);
        }
        /**
         * This is useful in detecting a corner of a 'pure' barcode.
         *
         * @return {@code x,y} coordinate of top-left-most 1 bit, or null if it is all white
         */ getTopLeftOnBit() {
            const rowSize = this.rowSize;
            const bits = this.bits;
            let bitsOffset = 0;
            while(bitsOffset < bits.length && bits[bitsOffset] === 0)bitsOffset++;
            if (bitsOffset === bits.length) return null;
            const y = bitsOffset / rowSize;
            let x = bitsOffset % rowSize * 32;
            const theBits = bits[bitsOffset];
            let bit = 0;
            while((theBits << 31 - bit & 0xFFFFFFFF) === 0)bit++;
            x += bit;
            return Int32Array.from([
                x,
                y
            ]);
        }
        getBottomRightOnBit() {
            const rowSize = this.rowSize;
            const bits = this.bits;
            let bitsOffset = bits.length - 1;
            while(bitsOffset >= 0 && bits[bitsOffset] === 0)bitsOffset--;
            if (bitsOffset < 0) return null;
            const y = Math.floor(bitsOffset / rowSize);
            let x = Math.floor(bitsOffset % rowSize) * 32;
            const theBits = bits[bitsOffset];
            let bit = 31;
            while(theBits >>> bit === 0)bit--;
            x += bit;
            return Int32Array.from([
                x,
                y
            ]);
        }
        /**
         * @return The width of the matrix
         */ getWidth() {
            return this.width;
        }
        /**
         * @return The height of the matrix
         */ getHeight() {
            return this.height;
        }
        /**
         * @return The row size of the matrix
         */ getRowSize() {
            return this.rowSize;
        }
        /*@Override*/ equals(o) {
            if (!(o instanceof BitMatrix)) return false;
            const other = o;
            return this.width === other.width && this.height === other.height && this.rowSize === other.rowSize && Arrays.equals(this.bits, other.bits);
        }
        /*@Override*/ hashCode() {
            let hash = this.width;
            hash = 31 * hash + this.width;
            hash = 31 * hash + this.height;
            hash = 31 * hash + this.rowSize;
            hash = 31 * hash + Arrays.hashCode(this.bits);
            return hash;
        }
        /**
         * @return string representation using "X" for set and " " for unset bits
         */ /*@Override*/ // public toString(): string {
        //   return toString(": "X, "  ")
        // }
        /**
         * @param setString representation of a set bit
         * @param unsetString representation of an unset bit
         * @return string representation of entire matrix utilizing given strings
         */ // public toString(setString: string = "X ", unsetString: string = "  "): string {
        //   return this.buildToString(setString, unsetString, "\n")
        // }
        /**
         * @param setString representation of a set bit
         * @param unsetString representation of an unset bit
         * @param lineSeparator newline character in string representation
         * @return string representation of entire matrix utilizing given strings and line separator
         * @deprecated call {@link #toString(String,String)} only, which uses \n line separator always
         */ // @Deprecated
        toString(setString = 'X ', unsetString = '  ', lineSeparator = '\n') {
            return this.buildToString(setString, unsetString, lineSeparator);
        }
        buildToString(setString, unsetString, lineSeparator) {
            let result = new StringBuilder();
            // result.append(lineSeparator);
            for(let y = 0, height = this.height; y < height; y++){
                for(let x = 0, width = this.width; x < width; x++)result.append(this.get(x, y) ? setString : unsetString);
                result.append(lineSeparator);
            }
            return result.toString();
        }
        /*@Override*/ clone() {
            return new BitMatrix(this.width, this.height, this.rowSize, this.bits.slice());
        }
    }
    /**
     * Custom Error class of type Exception.
     */ class NotFoundException extends Exception {
        static getNotFoundInstance() {
            return new NotFoundException();
        }
    }
    NotFoundException.kind = 'NotFoundException';
    /*
     * Copyright 2009 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * This Binarizer implementation uses the old ZXing global histogram approach. It is suitable
     * for low-end mobile devices which don't have enough CPU or memory to use a local thresholding
     * algorithm. However, because it picks a global black point, it cannot handle difficult shadows
     * and gradients.
     *
     * Faster mobile devices and all desktop applications should probably use HybridBinarizer instead.
     *
     * @author dswitkin@google.com (Daniel Switkin)
     * @author Sean Owen
     */ class GlobalHistogramBinarizer extends Binarizer {
        constructor(source){
            super(source);
            this.luminances = GlobalHistogramBinarizer.EMPTY;
            this.buckets = new Int32Array(GlobalHistogramBinarizer.LUMINANCE_BUCKETS);
        }
        // Applies simple sharpening to the row data to improve performance of the 1D Readers.
        /*@Override*/ getBlackRow(y /*int*/ , row) {
            const source = this.getLuminanceSource();
            const width = source.getWidth();
            if (row === undefined || row === null || row.getSize() < width) row = new BitArray(width);
            else row.clear();
            this.initArrays(width);
            const localLuminances = source.getRow(y, this.luminances);
            const localBuckets = this.buckets;
            for(let x = 0; x < width; x++)localBuckets[(localLuminances[x] & 0xff) >> GlobalHistogramBinarizer.LUMINANCE_SHIFT]++;
            const blackPoint = GlobalHistogramBinarizer.estimateBlackPoint(localBuckets);
            if (width < 3) {
                // Special case for very small images
                for(let x = 0; x < width; x++)if ((localLuminances[x] & 0xff) < blackPoint) row.set(x);
            } else {
                let left = localLuminances[0] & 0xff;
                let center = localLuminances[1] & 0xff;
                for(let x = 1; x < width - 1; x++){
                    const right = localLuminances[x + 1] & 0xff;
                    // A simple -1 4 -1 box filter with a weight of 2.
                    if ((center * 4 - left - right) / 2 < blackPoint) row.set(x);
                    left = center;
                    center = right;
                }
            }
            return row;
        }
        // Does not sharpen the data, as this call is intended to only be used by 2D Readers.
        /*@Override*/ getBlackMatrix() {
            const source = this.getLuminanceSource();
            const width = source.getWidth();
            const height = source.getHeight();
            const matrix = new BitMatrix(width, height);
            // Quickly calculates the histogram by sampling four rows from the image. This proved to be
            // more robust on the blackbox tests than sampling a diagonal as we used to do.
            this.initArrays(width);
            const localBuckets = this.buckets;
            for(let y = 1; y < 5; y++){
                const row = Math.floor(height * y / 5);
                const localLuminances = source.getRow(row, this.luminances);
                const right = Math.floor(width * 4 / 5);
                for(let x = Math.floor(width / 5); x < right; x++){
                    const pixel = localLuminances[x] & 0xff;
                    localBuckets[pixel >> GlobalHistogramBinarizer.LUMINANCE_SHIFT]++;
                }
            }
            const blackPoint = GlobalHistogramBinarizer.estimateBlackPoint(localBuckets);
            // We delay reading the entire image luminance until the black point estimation succeeds.
            // Although we end up reading four rows twice, it is consistent with our motto of
            // "fail quickly" which is necessary for continuous scanning.
            const localLuminances = source.getMatrix();
            for(let y = 0; y < height; y++){
                const offset = y * width;
                for(let x = 0; x < width; x++){
                    const pixel = localLuminances[offset + x] & 0xff;
                    if (pixel < blackPoint) matrix.set(x, y);
                }
            }
            return matrix;
        }
        /*@Override*/ createBinarizer(source) {
            return new GlobalHistogramBinarizer(source);
        }
        initArrays(luminanceSize /*int*/ ) {
            if (this.luminances.length < luminanceSize) this.luminances = new Uint8ClampedArray(luminanceSize);
            const buckets = this.buckets;
            for(let x = 0; x < GlobalHistogramBinarizer.LUMINANCE_BUCKETS; x++)buckets[x] = 0;
        }
        static estimateBlackPoint(buckets) {
            // Find the tallest peak in the histogram.
            const numBuckets = buckets.length;
            let maxBucketCount = 0;
            let firstPeak = 0;
            let firstPeakSize = 0;
            for(let x = 0; x < numBuckets; x++){
                if (buckets[x] > firstPeakSize) {
                    firstPeak = x;
                    firstPeakSize = buckets[x];
                }
                if (buckets[x] > maxBucketCount) maxBucketCount = buckets[x];
            }
            // Find the second-tallest peak which is somewhat far from the tallest peak.
            let secondPeak = 0;
            let secondPeakScore = 0;
            for(let x = 0; x < numBuckets; x++){
                const distanceToBiggest = x - firstPeak;
                // Encourage more distant second peaks by multiplying by square of distance.
                const score = buckets[x] * distanceToBiggest * distanceToBiggest;
                if (score > secondPeakScore) {
                    secondPeak = x;
                    secondPeakScore = score;
                }
            }
            // Make sure firstPeak corresponds to the black peak.
            if (firstPeak > secondPeak) {
                const temp = firstPeak;
                firstPeak = secondPeak;
                secondPeak = temp;
            }
            // If there is too little contrast in the image to pick a meaningful black point, throw rather
            // than waste time trying to decode the image, and risk false positives.
            if (secondPeak - firstPeak <= numBuckets / 16) throw new NotFoundException();
            // Find a valley between them that is low and closer to the white peak.
            let bestValley = secondPeak - 1;
            let bestValleyScore = -1;
            for(let x = secondPeak - 1; x > firstPeak; x--){
                const fromFirst = x - firstPeak;
                const score = fromFirst * fromFirst * (secondPeak - x) * (maxBucketCount - buckets[x]);
                if (score > bestValleyScore) {
                    bestValley = x;
                    bestValleyScore = score;
                }
            }
            return bestValley << GlobalHistogramBinarizer.LUMINANCE_SHIFT;
        }
    }
    GlobalHistogramBinarizer.LUMINANCE_BITS = 5;
    GlobalHistogramBinarizer.LUMINANCE_SHIFT = 8 - GlobalHistogramBinarizer.LUMINANCE_BITS;
    GlobalHistogramBinarizer.LUMINANCE_BUCKETS = 1 << GlobalHistogramBinarizer.LUMINANCE_BITS;
    GlobalHistogramBinarizer.EMPTY = Uint8ClampedArray.from([
        0
    ]);
    /*
     * Copyright 2009 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * This class implements a local thresholding algorithm, which while slower than the
     * GlobalHistogramBinarizer, is fairly efficient for what it does. It is designed for
     * high frequency images of barcodes with black data on white backgrounds. For this application,
     * it does a much better job than a global blackpoint with severe shadows and gradients.
     * However it tends to produce artifacts on lower frequency images and is therefore not
     * a good general purpose binarizer for uses outside ZXing.
     *
     * This class extends GlobalHistogramBinarizer, using the older histogram approach for 1D readers,
     * and the newer local approach for 2D readers. 1D decoding using a per-row histogram is already
     * inherently local, and only fails for horizontal gradients. We can revisit that problem later,
     * but for now it was not a win to use local blocks for 1D.
     *
     * This Binarizer is the default for the unit tests and the recommended class for library users.
     *
     * @author dswitkin@google.com (Daniel Switkin)
     */ class HybridBinarizer extends GlobalHistogramBinarizer {
        constructor(source){
            super(source);
            this.matrix = null;
        }
        /**
         * Calculates the final BitMatrix once for all requests. This could be called once from the
         * constructor instead, but there are some advantages to doing it lazily, such as making
         * profiling easier, and not doing heavy lifting when callers don't expect it.
         */ /*@Override*/ getBlackMatrix() {
            if (this.matrix !== null) return this.matrix;
            const source = this.getLuminanceSource();
            const width = source.getWidth();
            const height = source.getHeight();
            if (width >= HybridBinarizer.MINIMUM_DIMENSION && height >= HybridBinarizer.MINIMUM_DIMENSION) {
                const luminances = source.getMatrix();
                let subWidth = width >> HybridBinarizer.BLOCK_SIZE_POWER;
                if ((width & HybridBinarizer.BLOCK_SIZE_MASK) !== 0) subWidth++;
                let subHeight = height >> HybridBinarizer.BLOCK_SIZE_POWER;
                if ((height & HybridBinarizer.BLOCK_SIZE_MASK) !== 0) subHeight++;
                const blackPoints = HybridBinarizer.calculateBlackPoints(luminances, subWidth, subHeight, width, height);
                const newMatrix = new BitMatrix(width, height);
                HybridBinarizer.calculateThresholdForBlock(luminances, subWidth, subHeight, width, height, blackPoints, newMatrix);
                this.matrix = newMatrix;
            } else // If the image is too small, fall back to the global histogram approach.
            this.matrix = super.getBlackMatrix();
            return this.matrix;
        }
        /*@Override*/ createBinarizer(source) {
            return new HybridBinarizer(source);
        }
        /**
         * For each block in the image, calculate the average black point using a 5x5 grid
         * of the blocks around it. Also handles the corner cases (fractional blocks are computed based
         * on the last pixels in the row/column which are also used in the previous block).
         */ static calculateThresholdForBlock(luminances, subWidth /*int*/ , subHeight /*int*/ , width /*int*/ , height /*int*/ , blackPoints, matrix) {
            const maxYOffset = height - HybridBinarizer.BLOCK_SIZE;
            const maxXOffset = width - HybridBinarizer.BLOCK_SIZE;
            for(let y = 0; y < subHeight; y++){
                let yoffset = y << HybridBinarizer.BLOCK_SIZE_POWER;
                if (yoffset > maxYOffset) yoffset = maxYOffset;
                const top = HybridBinarizer.cap(y, 2, subHeight - 3);
                for(let x = 0; x < subWidth; x++){
                    let xoffset = x << HybridBinarizer.BLOCK_SIZE_POWER;
                    if (xoffset > maxXOffset) xoffset = maxXOffset;
                    const left = HybridBinarizer.cap(x, 2, subWidth - 3);
                    let sum = 0;
                    for(let z = -2; z <= 2; z++){
                        const blackRow = blackPoints[top + z];
                        sum += blackRow[left - 2] + blackRow[left - 1] + blackRow[left] + blackRow[left + 1] + blackRow[left + 2];
                    }
                    const average = sum / 25;
                    HybridBinarizer.thresholdBlock(luminances, xoffset, yoffset, average, width, matrix);
                }
            }
        }
        static cap(value /*int*/ , min /*int*/ , max /*int*/ ) {
            return value < min ? min : value > max ? max : value;
        }
        /**
         * Applies a single threshold to a block of pixels.
         */ static thresholdBlock(luminances, xoffset /*int*/ , yoffset /*int*/ , threshold /*int*/ , stride /*int*/ , matrix) {
            for(let y = 0, offset = yoffset * stride + xoffset; y < HybridBinarizer.BLOCK_SIZE; y++, offset += stride){
                for(let x = 0; x < HybridBinarizer.BLOCK_SIZE; x++)// Comparison needs to be <= so that black == 0 pixels are black even if the threshold is 0.
                if ((luminances[offset + x] & 0xFF) <= threshold) matrix.set(xoffset + x, yoffset + y);
            }
        }
        /**
         * Calculates a single black point for each block of pixels and saves it away.
         * See the following thread for a discussion of this algorithm:
         *  http://groups.google.com/group/zxing/browse_thread/thread/d06efa2c35a7ddc0
         */ static calculateBlackPoints(luminances, subWidth /*int*/ , subHeight /*int*/ , width /*int*/ , height /*int*/ ) {
            const maxYOffset = height - HybridBinarizer.BLOCK_SIZE;
            const maxXOffset = width - HybridBinarizer.BLOCK_SIZE;
            // tslint:disable-next-line:whitespace
            const blackPoints = new Array(subHeight); // subWidth
            for(let y = 0; y < subHeight; y++){
                blackPoints[y] = new Int32Array(subWidth);
                let yoffset = y << HybridBinarizer.BLOCK_SIZE_POWER;
                if (yoffset > maxYOffset) yoffset = maxYOffset;
                for(let x = 0; x < subWidth; x++){
                    let xoffset = x << HybridBinarizer.BLOCK_SIZE_POWER;
                    if (xoffset > maxXOffset) xoffset = maxXOffset;
                    let sum = 0;
                    let min = 0xFF;
                    let max = 0;
                    for(let yy = 0, offset = yoffset * width + xoffset; yy < HybridBinarizer.BLOCK_SIZE; yy++, offset += width){
                        for(let xx = 0; xx < HybridBinarizer.BLOCK_SIZE; xx++){
                            const pixel = luminances[offset + xx] & 0xFF;
                            sum += pixel;
                            // still looking for good contrast
                            if (pixel < min) min = pixel;
                            if (pixel > max) max = pixel;
                        }
                        // short-circuit min/max tests once dynamic range is met
                        if (max - min > HybridBinarizer.MIN_DYNAMIC_RANGE) {
                            // finish the rest of the rows quickly
                            for(yy++, offset += width; yy < HybridBinarizer.BLOCK_SIZE; yy++, offset += width)for(let xx = 0; xx < HybridBinarizer.BLOCK_SIZE; xx++)sum += luminances[offset + xx] & 0xFF;
                        }
                    }
                    // The default estimate is the average of the values in the block.
                    let average = sum >> HybridBinarizer.BLOCK_SIZE_POWER * 2;
                    if (max - min <= HybridBinarizer.MIN_DYNAMIC_RANGE) {
                        // If variation within the block is low, assume this is a block with only light or only
                        // dark pixels. In that case we do not want to use the average, as it would divide this
                        // low contrast area into black and white pixels, essentially creating data out of noise.
                        //
                        // The default assumption is that the block is light/background. Since no estimate for
                        // the level of dark pixels exists locally, use half the min for the block.
                        average = min / 2;
                        if (y > 0 && x > 0) {
                            // Correct the "white background" assumption for blocks that have neighbors by comparing
                            // the pixels in this block to the previously calculated black points. This is based on
                            // the fact that dark barcode symbology is always surrounded by some amount of light
                            // background for which reasonable black point estimates were made. The bp estimated at
                            // the boundaries is used for the interior.
                            // The (min < bp) is arbitrary but works better than other heuristics that were tried.
                            const averageNeighborBlackPoint = (blackPoints[y - 1][x] + 2 * blackPoints[y][x - 1] + blackPoints[y - 1][x - 1]) / 4;
                            if (min < averageNeighborBlackPoint) average = averageNeighborBlackPoint;
                        }
                    }
                    blackPoints[y][x] = average;
                }
            }
            return blackPoints;
        }
    }
    // This class uses 5x5 blocks to compute local luminance, where each block is 8x8 pixels.
    // So this is the smallest dimension in each axis we can accept.
    HybridBinarizer.BLOCK_SIZE_POWER = 3;
    HybridBinarizer.BLOCK_SIZE = 1 << HybridBinarizer.BLOCK_SIZE_POWER; // ...0100...00
    HybridBinarizer.BLOCK_SIZE_MASK = HybridBinarizer.BLOCK_SIZE - 1; // ...0011...11
    HybridBinarizer.MINIMUM_DIMENSION = HybridBinarizer.BLOCK_SIZE * 5;
    HybridBinarizer.MIN_DYNAMIC_RANGE = 24;
    /*
     * Copyright 2009 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /*namespace com.google.zxing {*/ /**
     * The purpose of this class hierarchy is to abstract different bitmap implementations across
     * platforms into a standard interface for requesting greyscale luminance values. The interface
     * only provides immutable methods; therefore crop and rotation create copies. This is to ensure
     * that one Reader does not modify the original luminance source and leave it in an unknown state
     * for other Readers in the chain.
     *
     * @author dswitkin@google.com (Daniel Switkin)
     */ class LuminanceSource {
        constructor(width /*int*/ , height /*int*/ ){
            this.width = width;
            this.height = height;
        }
        /**
         * @return The width of the bitmap.
         */ getWidth() {
            return this.width;
        }
        /**
         * @return The height of the bitmap.
         */ getHeight() {
            return this.height;
        }
        /**
         * @return Whether this subclass supports cropping.
         */ isCropSupported() {
            return false;
        }
        /**
         * Returns a new object with cropped image data. Implementations may keep a reference to the
         * original data rather than a copy. Only callable if isCropSupported() is true.
         *
         * @param left The left coordinate, which must be in [0,getWidth())
         * @param top The top coordinate, which must be in [0,getHeight())
         * @param width The width of the rectangle to crop.
         * @param height The height of the rectangle to crop.
         * @return A cropped version of this object.
         */ crop(left /*int*/ , top /*int*/ , width /*int*/ , height /*int*/ ) {
            throw new UnsupportedOperationException('This luminance source does not support cropping.');
        }
        /**
         * @return Whether this subclass supports counter-clockwise rotation.
         */ isRotateSupported() {
            return false;
        }
        /**
         * Returns a new object with rotated image data by 90 degrees counterclockwise.
         * Only callable if {@link #isRotateSupported()} is true.
         *
         * @return A rotated version of this object.
         */ rotateCounterClockwise() {
            throw new UnsupportedOperationException('This luminance source does not support rotation by 90 degrees.');
        }
        /**
         * Returns a new object with rotated image data by 45 degrees counterclockwise.
         * Only callable if {@link #isRotateSupported()} is true.
         *
         * @return A rotated version of this object.
         */ rotateCounterClockwise45() {
            throw new UnsupportedOperationException('This luminance source does not support rotation by 45 degrees.');
        }
        /*@Override*/ toString() {
            const row = new Uint8ClampedArray(this.width);
            let result = new StringBuilder();
            for(let y = 0; y < this.height; y++){
                const sourceRow = this.getRow(y, row);
                for(let x = 0; x < this.width; x++){
                    const luminance = sourceRow[x] & 0xFF;
                    let c;
                    if (luminance < 0x40) c = '#';
                    else if (luminance < 0x80) c = '+';
                    else if (luminance < 0xC0) c = '.';
                    else c = ' ';
                    result.append(c);
                }
                result.append('\n');
            }
            return result.toString();
        }
    }
    /*
     * Copyright 2009 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /*namespace com.google.zxing {*/ /**
     * A wrapper implementation of {@link LuminanceSource} which inverts the luminances it returns -- black becomes
     * white and vice versa, and each value becomes (255-value).
     *
     * @author Sean Owen
     */ class InvertedLuminanceSource extends LuminanceSource {
        constructor(delegate){
            super(delegate.getWidth(), delegate.getHeight());
            this.delegate = delegate;
        }
        /*@Override*/ getRow(y /*int*/ , row) {
            const sourceRow = this.delegate.getRow(y, row);
            const width = this.getWidth();
            for(let i = 0; i < width; i++)sourceRow[i] = /*(byte)*/ 255 - (sourceRow[i] & 0xFF);
            return sourceRow;
        }
        /*@Override*/ getMatrix() {
            const matrix = this.delegate.getMatrix();
            const length = this.getWidth() * this.getHeight();
            const invertedMatrix = new Uint8ClampedArray(length);
            for(let i = 0; i < length; i++)invertedMatrix[i] = /*(byte)*/ 255 - (matrix[i] & 0xFF);
            return invertedMatrix;
        }
        /*@Override*/ isCropSupported() {
            return this.delegate.isCropSupported();
        }
        /*@Override*/ crop(left /*int*/ , top /*int*/ , width /*int*/ , height /*int*/ ) {
            return new InvertedLuminanceSource(this.delegate.crop(left, top, width, height));
        }
        /*@Override*/ isRotateSupported() {
            return this.delegate.isRotateSupported();
        }
        /**
         * @return original delegate {@link LuminanceSource} since invert undoes itself
         */ /*@Override*/ invert() {
            return this.delegate;
        }
        /*@Override*/ rotateCounterClockwise() {
            return new InvertedLuminanceSource(this.delegate.rotateCounterClockwise());
        }
        /*@Override*/ rotateCounterClockwise45() {
            return new InvertedLuminanceSource(this.delegate.rotateCounterClockwise45());
        }
    }
    /**
     * @deprecated Moving to @zxing/browser
     */ class HTMLCanvasElementLuminanceSource extends LuminanceSource {
        constructor(canvas){
            super(canvas.width, canvas.height);
            this.canvas = canvas;
            this.tempCanvasElement = null;
            this.buffer = HTMLCanvasElementLuminanceSource.makeBufferFromCanvasImageData(canvas);
        }
        static makeBufferFromCanvasImageData(canvas) {
            const imageData = canvas.getContext('2d').getImageData(0, 0, canvas.width, canvas.height);
            return HTMLCanvasElementLuminanceSource.toGrayscaleBuffer(imageData.data, canvas.width, canvas.height);
        }
        static toGrayscaleBuffer(imageBuffer, width, height) {
            const grayscaleBuffer = new Uint8ClampedArray(width * height);
            for(let i = 0, j = 0, length = imageBuffer.length; i < length; i += 4, j++){
                let gray;
                const alpha = imageBuffer[i + 3];
                // The color of fully-transparent pixels is irrelevant. They are often, technically, fully-transparent
                // black (0 alpha, and then 0 RGB). They are often used, of course as the "white" area in a
                // barcode image. Force any such pixel to be white:
                if (alpha === 0) gray = 0xFF;
                else {
                    const pixelR = imageBuffer[i];
                    const pixelG = imageBuffer[i + 1];
                    const pixelB = imageBuffer[i + 2];
                    // .299R + 0.587G + 0.114B (YUV/YIQ for PAL and NTSC),
                    // (306*R) >> 10 is approximately equal to R*0.299, and so on.
                    // 0x200 >> 10 is 0.5, it implements rounding.
                    gray = 306 * pixelR + 601 * pixelG + 117 * pixelB + 0x200 >> 10;
                }
                grayscaleBuffer[j] = gray;
            }
            return grayscaleBuffer;
        }
        getRow(y /*int*/ , row) {
            if (y < 0 || y >= this.getHeight()) throw new IllegalArgumentException('Requested row is outside the image: ' + y);
            const width = this.getWidth();
            const start = y * width;
            if (row === null) row = this.buffer.slice(start, start + width);
            else {
                if (row.length < width) row = new Uint8ClampedArray(width);
                // The underlying raster of image consists of bytes with the luminance values
                // TODO: can avoid set/slice?
                row.set(this.buffer.slice(start, start + width));
            }
            return row;
        }
        getMatrix() {
            return this.buffer;
        }
        isCropSupported() {
            return true;
        }
        crop(left /*int*/ , top /*int*/ , width /*int*/ , height /*int*/ ) {
            super.crop(left, top, width, height);
            return this;
        }
        /**
         * This is always true, since the image is a gray-scale image.
         *
         * @return true
         */ isRotateSupported() {
            return true;
        }
        rotateCounterClockwise() {
            this.rotate(-90);
            return this;
        }
        rotateCounterClockwise45() {
            this.rotate(-45);
            return this;
        }
        getTempCanvasElement() {
            if (null === this.tempCanvasElement) {
                const tempCanvasElement = this.canvas.ownerDocument.createElement('canvas');
                tempCanvasElement.width = this.canvas.width;
                tempCanvasElement.height = this.canvas.height;
                this.tempCanvasElement = tempCanvasElement;
            }
            return this.tempCanvasElement;
        }
        rotate(angle) {
            const tempCanvasElement = this.getTempCanvasElement();
            const tempContext = tempCanvasElement.getContext('2d');
            const angleRadians = angle * HTMLCanvasElementLuminanceSource.DEGREE_TO_RADIANS;
            // Calculate and set new dimensions for temp canvas
            const width = this.canvas.width;
            const height = this.canvas.height;
            const newWidth = Math.ceil(Math.abs(Math.cos(angleRadians)) * width + Math.abs(Math.sin(angleRadians)) * height);
            const newHeight = Math.ceil(Math.abs(Math.sin(angleRadians)) * width + Math.abs(Math.cos(angleRadians)) * height);
            tempCanvasElement.width = newWidth;
            tempCanvasElement.height = newHeight;
            // Draw at center of temp canvas to prevent clipping of image data
            tempContext.translate(newWidth / 2, newHeight / 2);
            tempContext.rotate(angleRadians);
            tempContext.drawImage(this.canvas, width / -2, height / -2);
            this.buffer = HTMLCanvasElementLuminanceSource.makeBufferFromCanvasImageData(tempCanvasElement);
            return this;
        }
        invert() {
            return new InvertedLuminanceSource(this);
        }
    }
    HTMLCanvasElementLuminanceSource.DEGREE_TO_RADIANS = Math.PI / 180;
    /**
     * @deprecated Moving to @zxing/browser
     *
     * Video input device metadata containing the id and label of the device if available.
     */ class VideoInputDevice {
        /**
         * Creates an instance of VideoInputDevice.
         *
         * @param {string} deviceId the video input device id
         * @param {string} label the label of the device if available
         */ constructor(deviceId, label, groupId){
            this.deviceId = deviceId;
            this.label = label;
            /** @inheritdoc */ this.kind = 'videoinput';
            this.groupId = groupId || undefined;
        }
        /** @inheritdoc */ toJSON() {
            return {
                kind: this.kind,
                groupId: this.groupId,
                deviceId: this.deviceId,
                label: this.label
            };
        }
    }
    var __awaiter = (globalThis || $parcel$global || self || window || undefined) && (globalThis || $parcel$global || self || window || undefined).__awaiter || function(thisArg, _arguments, P, generator) {
        function adopt(value) {
            return value instanceof P ? value : new P(function(resolve) {
                resolve(value);
            });
        }
        return new (P || (P = Promise))(function(resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator["throw"](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    };
    /**
     * @deprecated Moving to @zxing/browser
     *
     * Base class for browser code reader.
     */ class BrowserCodeReader {
        /**
         * Creates an instance of BrowserCodeReader.
         * @param {Reader} reader The reader instance to decode the barcode
         * @param {number} [timeBetweenScansMillis=500] the time delay between subsequent successful decode tries
         *
         * @memberOf BrowserCodeReader
         */ constructor(reader, timeBetweenScansMillis = 500, _hints){
            this.reader = reader;
            this.timeBetweenScansMillis = timeBetweenScansMillis;
            this._hints = _hints;
            /**
             * This will break the loop.
             */ this._stopContinuousDecode = false;
            /**
             * This will break the loop.
             */ this._stopAsyncDecode = false;
            /**
             * Delay time between decode attempts made by the scanner.
             */ this._timeBetweenDecodingAttempts = 0;
        }
        /**
         * If navigator is present.
         */ get hasNavigator() {
            return typeof navigator !== 'undefined';
        }
        /**
         * If mediaDevices under navigator is supported.
         */ get isMediaDevicesSuported() {
            return this.hasNavigator && !!navigator.mediaDevices;
        }
        /**
         * If enumerateDevices under navigator is supported.
         */ get canEnumerateDevices() {
            return !!(this.isMediaDevicesSuported && navigator.mediaDevices.enumerateDevices);
        }
        /** Time between two decoding tries in milli seconds. */ get timeBetweenDecodingAttempts() {
            return this._timeBetweenDecodingAttempts;
        }
        /**
         * Change the time span the decoder waits between two decoding tries.
         *
         * @param {number} millis Time between two decoding tries in milli seconds.
         */ set timeBetweenDecodingAttempts(millis) {
            this._timeBetweenDecodingAttempts = millis < 0 ? 0 : millis;
        }
        /**
         * Sets the hints.
         */ set hints(hints) {
            this._hints = hints || null;
        }
        /**
         * Sets the hints.
         */ get hints() {
            return this._hints;
        }
        /**
         * Lists all the available video input devices.
         */ listVideoInputDevices() {
            return __awaiter(this, void 0, void 0, function*() {
                if (!this.hasNavigator) throw new Error('Can\'t enumerate devices, navigator is not present.');
                if (!this.canEnumerateDevices) throw new Error('Can\'t enumerate devices, method not supported.');
                const devices = yield navigator.mediaDevices.enumerateDevices();
                const videoDevices = [];
                for (const device of devices){
                    const kind = device.kind === 'video' ? 'videoinput' : device.kind;
                    if (kind !== 'videoinput') continue;
                    const deviceId = device.deviceId || device.id;
                    const label = device.label || `Video device ${videoDevices.length + 1}`;
                    const groupId = device.groupId;
                    const videoDevice = {
                        deviceId: deviceId,
                        label: label,
                        kind: kind,
                        groupId: groupId
                    };
                    videoDevices.push(videoDevice);
                }
                return videoDevices;
            });
        }
        /**
         * Obtain the list of available devices with type 'videoinput'.
         *
         * @returns {Promise<VideoInputDevice[]>} an array of available video input devices
         *
         * @memberOf BrowserCodeReader
         *
         * @deprecated Use `listVideoInputDevices` instead.
         */ getVideoInputDevices() {
            return __awaiter(this, void 0, void 0, function*() {
                const devices = yield this.listVideoInputDevices();
                return devices.map((d)=>new VideoInputDevice(d.deviceId, d.label));
            });
        }
        /**
         * Let's you find a device using it's Id.
         */ findDeviceById(deviceId) {
            return __awaiter(this, void 0, void 0, function*() {
                const devices = yield this.listVideoInputDevices();
                if (!devices) return null;
                return devices.find((x)=>x.deviceId === deviceId);
            });
        }
        /**
         * Decodes the barcode from the device specified by deviceId while showing the video in the specified video element.
         *
         * @param deviceId the id of one of the devices obtained after calling getVideoInputDevices. Can be undefined, in this case it will decode from one of the available devices, preffering the main camera (environment facing) if available.
         * @param video the video element in page where to show the video while decoding. Can be either an element id or directly an HTMLVideoElement. Can be undefined, in which case no video will be shown.
         * @returns The decoding result.
         *
         * @memberOf BrowserCodeReader
         *
         * @deprecated Use `decodeOnceFromVideoDevice` instead.
         */ decodeFromInputVideoDevice(deviceId, videoSource) {
            return __awaiter(this, void 0, void 0, function*() {
                return yield this.decodeOnceFromVideoDevice(deviceId, videoSource);
            });
        }
        /**
         * In one attempt, tries to decode the barcode from the device specified by deviceId while showing the video in the specified video element.
         *
         * @param deviceId the id of one of the devices obtained after calling getVideoInputDevices. Can be undefined, in this case it will decode from one of the available devices, preffering the main camera (environment facing) if available.
         * @param video the video element in page where to show the video while decoding. Can be either an element id or directly an HTMLVideoElement. Can be undefined, in which case no video will be shown.
         * @returns The decoding result.
         *
         * @memberOf BrowserCodeReader
         */ decodeOnceFromVideoDevice(deviceId, videoSource) {
            return __awaiter(this, void 0, void 0, function*() {
                this.reset();
                let videoConstraints;
                if (!deviceId) videoConstraints = {
                    facingMode: 'environment'
                };
                else videoConstraints = {
                    deviceId: {
                        exact: deviceId
                    }
                };
                const constraints = {
                    video: videoConstraints
                };
                return yield this.decodeOnceFromConstraints(constraints, videoSource);
            });
        }
        /**
         * In one attempt, tries to decode the barcode from a stream obtained from the given constraints while showing the video in the specified video element.
         *
         * @param constraints the media stream constraints to get s valid media stream to decode from
         * @param video the video element in page where to show the video while decoding. Can be either an element id or directly an HTMLVideoElement. Can be undefined, in which case no video will be shown.
         * @returns The decoding result.
         *
         * @memberOf BrowserCodeReader
         */ decodeOnceFromConstraints(constraints, videoSource) {
            return __awaiter(this, void 0, void 0, function*() {
                const stream = yield navigator.mediaDevices.getUserMedia(constraints);
                return yield this.decodeOnceFromStream(stream, videoSource);
            });
        }
        /**
         * In one attempt, tries to decode the barcode from a stream obtained from the given constraints while showing the video in the specified video element.
         *
         * @param {MediaStream} [constraints] the media stream constraints to get s valid media stream to decode from
         * @param {string|HTMLVideoElement} [video] the video element in page where to show the video while decoding. Can be either an element id or directly an HTMLVideoElement. Can be undefined, in which case no video will be shown.
         * @returns {Promise<Result>} The decoding result.
         *
         * @memberOf BrowserCodeReader
         */ decodeOnceFromStream(stream, videoSource) {
            return __awaiter(this, void 0, void 0, function*() {
                this.reset();
                const video = yield this.attachStreamToVideo(stream, videoSource);
                const result = yield this.decodeOnce(video);
                return result;
            });
        }
        /**
         * Continuously decodes the barcode from the device specified by device while showing the video in the specified video element.
         *
         * @param {string|null} [deviceId] the id of one of the devices obtained after calling getVideoInputDevices. Can be undefined, in this case it will decode from one of the available devices, preffering the main camera (environment facing) if available.
         * @param {string|HTMLVideoElement|null} [video] the video element in page where to show the video while decoding. Can be either an element id or directly an HTMLVideoElement. Can be undefined, in which case no video will be shown.
         * @returns {Promise<void>}
         *
         * @memberOf BrowserCodeReader
         *
         * @deprecated Use `decodeFromVideoDevice` instead.
         */ decodeFromInputVideoDeviceContinuously(deviceId, videoSource, callbackFn) {
            return __awaiter(this, void 0, void 0, function*() {
                return yield this.decodeFromVideoDevice(deviceId, videoSource, callbackFn);
            });
        }
        /**
         * Continuously tries to decode the barcode from the device specified by device while showing the video in the specified video element.
         *
         * @param {string|null} [deviceId] the id of one of the devices obtained after calling getVideoInputDevices. Can be undefined, in this case it will decode from one of the available devices, preffering the main camera (environment facing) if available.
         * @param {string|HTMLVideoElement|null} [video] the video element in page where to show the video while decoding. Can be either an element id or directly an HTMLVideoElement. Can be undefined, in which case no video will be shown.
         * @returns {Promise<void>}
         *
         * @memberOf BrowserCodeReader
         */ decodeFromVideoDevice(deviceId, videoSource, callbackFn) {
            return __awaiter(this, void 0, void 0, function*() {
                let videoConstraints;
                if (!deviceId) videoConstraints = {
                    facingMode: 'environment'
                };
                else videoConstraints = {
                    deviceId: {
                        exact: deviceId
                    }
                };
                const constraints = {
                    video: videoConstraints
                };
                return yield this.decodeFromConstraints(constraints, videoSource, callbackFn);
            });
        }
        /**
         * Continuously tries to decode the barcode from a stream obtained from the given constraints while showing the video in the specified video element.
         *
         * @param {MediaStream} [constraints] the media stream constraints to get s valid media stream to decode from
         * @param {string|HTMLVideoElement} [video] the video element in page where to show the video while decoding. Can be either an element id or directly an HTMLVideoElement. Can be undefined, in which case no video will be shown.
         * @returns {Promise<Result>} The decoding result.
         *
         * @memberOf BrowserCodeReader
         */ decodeFromConstraints(constraints, videoSource, callbackFn) {
            return __awaiter(this, void 0, void 0, function*() {
                const stream = yield navigator.mediaDevices.getUserMedia(constraints);
                return yield this.decodeFromStream(stream, videoSource, callbackFn);
            });
        }
        /**
         * In one attempt, tries to decode the barcode from a stream obtained from the given constraints while showing the video in the specified video element.
         *
         * @param {MediaStream} [constraints] the media stream constraints to get s valid media stream to decode from
         * @param {string|HTMLVideoElement} [video] the video element in page where to show the video while decoding. Can be either an element id or directly an HTMLVideoElement. Can be undefined, in which case no video will be shown.
         * @returns {Promise<Result>} The decoding result.
         *
         * @memberOf BrowserCodeReader
         */ decodeFromStream(stream, videoSource, callbackFn) {
            return __awaiter(this, void 0, void 0, function*() {
                this.reset();
                const video = yield this.attachStreamToVideo(stream, videoSource);
                return yield this.decodeContinuously(video, callbackFn);
            });
        }
        /**
         * Breaks the decoding loop.
         */ stopAsyncDecode() {
            this._stopAsyncDecode = true;
        }
        /**
         * Breaks the decoding loop.
         */ stopContinuousDecode() {
            this._stopContinuousDecode = true;
        }
        /**
         * Sets the new stream and request a new decoding-with-delay.
         *
         * @param stream The stream to be shown in the video element.
         * @param decodeFn A callback for the decode method.
         */ attachStreamToVideo(stream, videoSource) {
            return __awaiter(this, void 0, void 0, function*() {
                const videoElement = this.prepareVideoElement(videoSource);
                this.addVideoSource(videoElement, stream);
                this.videoElement = videoElement;
                this.stream = stream;
                yield this.playVideoOnLoadAsync(videoElement);
                return videoElement;
            });
        }
        /**
         *
         * @param videoElement
         */ playVideoOnLoadAsync(videoElement) {
            return new Promise((resolve, reject)=>this.playVideoOnLoad(videoElement, ()=>resolve()));
        }
        /**
         * Binds listeners and callbacks to the videoElement.
         *
         * @param element
         * @param callbackFn
         */ playVideoOnLoad(element, callbackFn) {
            this.videoEndedListener = ()=>this.stopStreams();
            this.videoCanPlayListener = ()=>this.tryPlayVideo(element);
            element.addEventListener('ended', this.videoEndedListener);
            element.addEventListener('canplay', this.videoCanPlayListener);
            element.addEventListener('playing', callbackFn);
            // if canplay was already fired, we won't know when to play, so just give it a try
            this.tryPlayVideo(element);
        }
        /**
         * Checks if the given video element is currently playing.
         */ isVideoPlaying(video) {
            return video.currentTime > 0 && !video.paused && !video.ended && video.readyState > 2;
        }
        /**
         * Just tries to play the video and logs any errors.
         * The play call is only made is the video is not already playing.
         */ tryPlayVideo(videoElement) {
            return __awaiter(this, void 0, void 0, function*() {
                if (this.isVideoPlaying(videoElement)) {
                    console.warn('Trying to play video that is already playing.');
                    return;
                }
                try {
                    yield videoElement.play();
                } catch (_a) {
                    console.warn('It was not possible to play the video.');
                }
            });
        }
        /**
         * Searches and validates a media element.
         */ getMediaElement(mediaElementId, type) {
            const mediaElement = document.getElementById(mediaElementId);
            if (!mediaElement) throw new ArgumentException(`element with id '${mediaElementId}' not found`);
            if (mediaElement.nodeName.toLowerCase() !== type.toLowerCase()) throw new ArgumentException(`element with id '${mediaElementId}' must be an ${type} element`);
            return mediaElement;
        }
        /**
         * Decodes the barcode from an image.
         *
         * @param {(string|HTMLImageElement)} [source] The image element that can be either an element id or the element itself. Can be undefined in which case the decoding will be done from the imageUrl parameter.
         * @param {string} [url]
         * @returns {Promise<Result>} The decoding result.
         *
         * @memberOf BrowserCodeReader
         */ decodeFromImage(source, url) {
            if (!source && !url) throw new ArgumentException('either imageElement with a src set or an url must be provided');
            if (url && !source) return this.decodeFromImageUrl(url);
            return this.decodeFromImageElement(source);
        }
        /**
         * Decodes the barcode from a video.
         *
         * @param {(string|HTMLImageElement)} [source] The image element that can be either an element id or the element itself. Can be undefined in which case the decoding will be done from the imageUrl parameter.
         * @param {string} [url]
         * @returns {Promise<Result>} The decoding result.
         *
         * @memberOf BrowserCodeReader
         */ decodeFromVideo(source, url) {
            if (!source && !url) throw new ArgumentException('Either an element with a src set or an URL must be provided');
            if (url && !source) return this.decodeFromVideoUrl(url);
            return this.decodeFromVideoElement(source);
        }
        /**
         * Decodes continuously the barcode from a video.
         *
         * @param {(string|HTMLImageElement)} [source] The image element that can be either an element id or the element itself. Can be undefined in which case the decoding will be done from the imageUrl parameter.
         * @param {string} [url]
         * @returns {Promise<Result>} The decoding result.
         *
         * @memberOf BrowserCodeReader
         *
         * @experimental
         */ decodeFromVideoContinuously(source, url, callbackFn) {
            if (undefined === source && undefined === url) throw new ArgumentException('Either an element with a src set or an URL must be provided');
            if (url && !source) return this.decodeFromVideoUrlContinuously(url, callbackFn);
            return this.decodeFromVideoElementContinuously(source, callbackFn);
        }
        /**
         * Decodes something from an image HTML element.
         */ decodeFromImageElement(source) {
            if (!source) throw new ArgumentException('An image element must be provided.');
            this.reset();
            const element = this.prepareImageElement(source);
            this.imageElement = element;
            let task;
            if (this.isImageLoaded(element)) task = this.decodeOnce(element, false, true);
            else task = this._decodeOnLoadImage(element);
            return task;
        }
        /**
         * Decodes something from an image HTML element.
         */ decodeFromVideoElement(source) {
            const element = this._decodeFromVideoElementSetup(source);
            return this._decodeOnLoadVideo(element);
        }
        /**
         * Decodes something from an image HTML element.
         */ decodeFromVideoElementContinuously(source, callbackFn) {
            const element = this._decodeFromVideoElementSetup(source);
            return this._decodeOnLoadVideoContinuously(element, callbackFn);
        }
        /**
         * Sets up the video source so it can be decoded when loaded.
         *
         * @param source The video source element.
         */ _decodeFromVideoElementSetup(source) {
            if (!source) throw new ArgumentException('A video element must be provided.');
            this.reset();
            const element = this.prepareVideoElement(source);
            // defines the video element before starts decoding
            this.videoElement = element;
            return element;
        }
        /**
         * Decodes an image from a URL.
         */ decodeFromImageUrl(url) {
            if (!url) throw new ArgumentException('An URL must be provided.');
            this.reset();
            const element = this.prepareImageElement();
            this.imageElement = element;
            const decodeTask = this._decodeOnLoadImage(element);
            element.src = url;
            return decodeTask;
        }
        /**
         * Decodes an image from a URL.
         */ decodeFromVideoUrl(url) {
            if (!url) throw new ArgumentException('An URL must be provided.');
            this.reset();
            // creates a new element
            const element = this.prepareVideoElement();
            const decodeTask = this.decodeFromVideoElement(element);
            element.src = url;
            return decodeTask;
        }
        /**
         * Decodes an image from a URL.
         *
         * @experimental
         */ decodeFromVideoUrlContinuously(url, callbackFn) {
            if (!url) throw new ArgumentException('An URL must be provided.');
            this.reset();
            // creates a new element
            const element = this.prepareVideoElement();
            const decodeTask = this.decodeFromVideoElementContinuously(element, callbackFn);
            element.src = url;
            return decodeTask;
        }
        _decodeOnLoadImage(element) {
            return new Promise((resolve, reject)=>{
                this.imageLoadedListener = ()=>this.decodeOnce(element, false, true).then(resolve, reject);
                element.addEventListener('load', this.imageLoadedListener);
            });
        }
        _decodeOnLoadVideo(videoElement) {
            return __awaiter(this, void 0, void 0, function*() {
                // plays the video
                yield this.playVideoOnLoadAsync(videoElement);
                // starts decoding after played the video
                return yield this.decodeOnce(videoElement);
            });
        }
        _decodeOnLoadVideoContinuously(videoElement, callbackFn) {
            return __awaiter(this, void 0, void 0, function*() {
                // plays the video
                yield this.playVideoOnLoadAsync(videoElement);
                // starts decoding after played the video
                this.decodeContinuously(videoElement, callbackFn);
            });
        }
        isImageLoaded(img) {
            // During the onload event, IE correctly identifies any images that
            // weren’t downloaded as not complete. Others should too. Gecko-based
            // browsers act like NS4 in that they report this incorrectly.
            if (!img.complete) return false;
            // However, they do have two very useful properties: naturalWidth and
            // naturalHeight. These give the true size of the image. If it failed
            // to load, either of these should be zero.
            if (img.naturalWidth === 0) return false;
            // No other way of checking: assume it’s ok.
            return true;
        }
        prepareImageElement(imageSource) {
            let imageElement;
            if (typeof imageSource === 'undefined') {
                imageElement = document.createElement('img');
                imageElement.width = 200;
                imageElement.height = 200;
            }
            if (typeof imageSource === 'string') imageElement = this.getMediaElement(imageSource, 'img');
            if (imageSource instanceof HTMLImageElement) imageElement = imageSource;
            return imageElement;
        }
        /**
         * Sets a HTMLVideoElement for scanning or creates a new one.
         *
         * @param videoSource The HTMLVideoElement to be set.
         */ prepareVideoElement(videoSource) {
            let videoElement;
            if (!videoSource && typeof document !== 'undefined') {
                videoElement = document.createElement('video');
                videoElement.width = 200;
                videoElement.height = 200;
            }
            if (typeof videoSource === 'string') videoElement = this.getMediaElement(videoSource, 'video');
            if (videoSource instanceof HTMLVideoElement) videoElement = videoSource;
            // Needed for iOS 11
            videoElement.setAttribute('autoplay', 'true');
            videoElement.setAttribute('muted', 'true');
            videoElement.setAttribute('playsinline', 'true');
            return videoElement;
        }
        /**
         * Tries to decode from the video input until it finds some value.
         */ decodeOnce(element, retryIfNotFound = true, retryIfChecksumOrFormatError = true) {
            this._stopAsyncDecode = false;
            const loop = (resolve, reject)=>{
                if (this._stopAsyncDecode) {
                    reject(new NotFoundException('Video stream has ended before any code could be detected.'));
                    this._stopAsyncDecode = undefined;
                    return;
                }
                try {
                    const result = this.decode(element);
                    resolve(result);
                } catch (e) {
                    const ifNotFound = retryIfNotFound && e instanceof NotFoundException;
                    const isChecksumOrFormatError = e instanceof ChecksumException || e instanceof FormatException;
                    const ifChecksumOrFormat = isChecksumOrFormatError && retryIfChecksumOrFormatError;
                    if (ifNotFound || ifChecksumOrFormat) // trying again
                    return setTimeout(loop, this._timeBetweenDecodingAttempts, resolve, reject);
                    reject(e);
                }
            };
            return new Promise((resolve, reject)=>loop(resolve, reject));
        }
        /**
         * Continuously decodes from video input.
         */ decodeContinuously(element, callbackFn) {
            this._stopContinuousDecode = false;
            const loop = ()=>{
                if (this._stopContinuousDecode) {
                    this._stopContinuousDecode = undefined;
                    return;
                }
                try {
                    const result = this.decode(element);
                    callbackFn(result, null);
                    setTimeout(loop, this.timeBetweenScansMillis);
                } catch (e) {
                    callbackFn(null, e);
                    const isChecksumOrFormatError = e instanceof ChecksumException || e instanceof FormatException;
                    const isNotFound = e instanceof NotFoundException;
                    if (isChecksumOrFormatError || isNotFound) // trying again
                    setTimeout(loop, this._timeBetweenDecodingAttempts);
                }
            };
            loop();
        }
        /**
         * Gets the BinaryBitmap for ya! (and decodes it)
         */ decode(element) {
            // get binary bitmap for decode function
            const binaryBitmap = this.createBinaryBitmap(element);
            return this.decodeBitmap(binaryBitmap);
        }
        /**
         * Returns true if media element is indeed a {@link HtmlVideoElement}.
         */ _isHTMLVideoElement(mediaElement) {
            const potentialVideo = mediaElement;
            return potentialVideo.videoWidth !== 0;
        }
        /**
         * Overwriting this allows you to manipulate the next frame in anyway
         * you want before decode.
         */ drawFrameOnCanvas(srcElement, dimensions, canvasElementContext) {
            if (!dimensions) dimensions = {
                sx: 0,
                sy: 0,
                sWidth: srcElement.videoWidth,
                sHeight: srcElement.videoHeight,
                dx: 0,
                dy: 0,
                dWidth: srcElement.videoWidth,
                dHeight: srcElement.videoHeight
            };
            if (!canvasElementContext) canvasElementContext = this.captureCanvasContext;
            canvasElementContext.drawImage(srcElement, dimensions.sx, dimensions.sy, dimensions.sWidth, dimensions.sHeight, dimensions.dx, dimensions.dy, dimensions.dWidth, dimensions.dHeight);
        }
        /**
         * Ovewriting this allows you to manipulate the snapshot image in anyway
         *  you want before decode.
         */ drawImageOnCanvas(srcElement, dimensions, canvasElementContext = this.captureCanvasContext) {
            if (!dimensions) dimensions = {
                sx: 0,
                sy: 0,
                sWidth: srcElement.naturalWidth,
                sHeight: srcElement.naturalHeight,
                dx: 0,
                dy: 0,
                dWidth: srcElement.naturalWidth,
                dHeight: srcElement.naturalHeight
            };
            if (!canvasElementContext) canvasElementContext = this.captureCanvasContext;
            canvasElementContext.drawImage(srcElement, dimensions.sx, dimensions.sy, dimensions.sWidth, dimensions.sHeight, dimensions.dx, dimensions.dy, dimensions.dWidth, dimensions.dHeight);
        }
        /**
         * Creates a binaryBitmap based in some image source.
         *
         * @param mediaElement HTML element containing drawable image source.
         */ createBinaryBitmap(mediaElement) {
            const ctx = this.getCaptureCanvasContext(mediaElement);
            if (this._isHTMLVideoElement(mediaElement)) this.drawFrameOnCanvas(mediaElement);
            else this.drawImageOnCanvas(mediaElement);
            const canvas = this.getCaptureCanvas(mediaElement);
            const luminanceSource = new HTMLCanvasElementLuminanceSource(canvas);
            const hybridBinarizer = new HybridBinarizer(luminanceSource);
            return new BinaryBitmap(hybridBinarizer);
        }
        getCaptureCanvasContext(mediaElement) {
            if (!this.captureCanvasContext) {
                const elem = this.getCaptureCanvas(mediaElement);
                const ctx = elem.getContext('2d');
                this.captureCanvasContext = ctx;
            }
            return this.captureCanvasContext;
        }
        getCaptureCanvas(mediaElement) {
            if (!this.captureCanvas) {
                const elem = this.createCaptureCanvas(mediaElement);
                this.captureCanvas = elem;
            }
            return this.captureCanvas;
        }
        /**
         * Call the encapsulated readers decode
         */ decodeBitmap(binaryBitmap) {
            return this.reader.decode(binaryBitmap, this._hints);
        }
        /**
         * 🖌 Prepares the canvas for capture and scan frames.
         */ createCaptureCanvas(mediaElement) {
            if (typeof document === 'undefined') {
                this._destroyCaptureCanvas();
                return null;
            }
            const canvasElement = document.createElement('canvas');
            let width;
            let height;
            if (typeof mediaElement !== 'undefined') {
                if (mediaElement instanceof HTMLVideoElement) {
                    width = mediaElement.videoWidth;
                    height = mediaElement.videoHeight;
                } else if (mediaElement instanceof HTMLImageElement) {
                    width = mediaElement.naturalWidth || mediaElement.width;
                    height = mediaElement.naturalHeight || mediaElement.height;
                }
            }
            canvasElement.style.width = width + 'px';
            canvasElement.style.height = height + 'px';
            canvasElement.width = width;
            canvasElement.height = height;
            return canvasElement;
        }
        /**
         * Stops the continuous scan and cleans the stream.
         */ stopStreams() {
            if (this.stream) {
                this.stream.getVideoTracks().forEach((t)=>t.stop());
                this.stream = undefined;
            }
            if (this._stopAsyncDecode === false) this.stopAsyncDecode();
            if (this._stopContinuousDecode === false) this.stopContinuousDecode();
        }
        /**
         * Resets the code reader to the initial state. Cancels any ongoing barcode scanning from video or camera.
         *
         * @memberOf BrowserCodeReader
         */ reset() {
            // stops the camera, preview and scan 🔴
            this.stopStreams();
            // clean and forget about HTML elements
            this._destroyVideoElement();
            this._destroyImageElement();
            this._destroyCaptureCanvas();
        }
        _destroyVideoElement() {
            if (!this.videoElement) return;
            // first gives freedon to the element 🕊
            if (typeof this.videoEndedListener !== 'undefined') this.videoElement.removeEventListener('ended', this.videoEndedListener);
            if (typeof this.videoPlayingEventListener !== 'undefined') this.videoElement.removeEventListener('playing', this.videoPlayingEventListener);
            if (typeof this.videoCanPlayListener !== 'undefined') this.videoElement.removeEventListener('loadedmetadata', this.videoCanPlayListener);
            // then forgets about that element 😢
            this.cleanVideoSource(this.videoElement);
            this.videoElement = undefined;
        }
        _destroyImageElement() {
            if (!this.imageElement) return;
            // first gives freedon to the element 🕊
            if (undefined !== this.imageLoadedListener) this.imageElement.removeEventListener('load', this.imageLoadedListener);
            // then forget about that element 😢
            this.imageElement.src = undefined;
            this.imageElement.removeAttribute('src');
            this.imageElement = undefined;
        }
        /**
         * Cleans canvas references 🖌
         */ _destroyCaptureCanvas() {
            // then forget about that element 😢
            this.captureCanvasContext = undefined;
            this.captureCanvas = undefined;
        }
        /**
         * Defines what the videoElement src will be.
         *
         * @param videoElement
         * @param stream
         */ addVideoSource(videoElement, stream) {
            // Older browsers may not have `srcObject`
            try {
                // @note Throws Exception if interrupted by a new loaded request
                videoElement.srcObject = stream;
            } catch (err) {
                // @note Avoid using this in new browsers, as it is going away.
                videoElement.src = URL.createObjectURL(stream);
            }
        }
        /**
         * Unbinds a HTML video src property.
         *
         * @param videoElement
         */ cleanVideoSource(videoElement) {
            try {
                videoElement.srcObject = null;
            } catch (err) {
                videoElement.src = '';
            }
            this.videoElement.removeAttribute('src');
        }
    }
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * <p>Encapsulates the result of decoding a barcode within an image.</p>
     *
     * @author Sean Owen
     */ class Result {
        // public constructor(private text: string,
        //               Uint8Array rawBytes,
        //               ResultPoconst resultPoints: Int32Array,
        //               BarcodeFormat format) {
        //   this(text, rawBytes, resultPoints, format, System.currentTimeMillis())
        // }
        // public constructor(text: string,
        //               Uint8Array rawBytes,
        //               ResultPoconst resultPoints: Int32Array,
        //               BarcodeFormat format,
        //               long timestamp) {
        //   this(text, rawBytes, rawBytes == null ? 0 : 8 * rawBytes.length,
        //        resultPoints, format, timestamp)
        // }
        constructor(text, rawBytes, numBits = rawBytes == null ? 0 : 8 * rawBytes.length, resultPoints, format, timestamp = System.currentTimeMillis()){
            this.text = text;
            this.rawBytes = rawBytes;
            this.numBits = numBits;
            this.resultPoints = resultPoints;
            this.format = format;
            this.timestamp = timestamp;
            this.text = text;
            this.rawBytes = rawBytes;
            if (undefined === numBits || null === numBits) this.numBits = rawBytes === null || rawBytes === undefined ? 0 : 8 * rawBytes.length;
            else this.numBits = numBits;
            this.resultPoints = resultPoints;
            this.format = format;
            this.resultMetadata = null;
            if (undefined === timestamp || null === timestamp) this.timestamp = System.currentTimeMillis();
            else this.timestamp = timestamp;
        }
        /**
         * @return raw text encoded by the barcode
         */ getText() {
            return this.text;
        }
        /**
         * @return raw bytes encoded by the barcode, if applicable, otherwise {@code null}
         */ getRawBytes() {
            return this.rawBytes;
        }
        /**
         * @return how many bits of {@link #getRawBytes()} are valid; typically 8 times its length
         * @since 3.3.0
         */ getNumBits() {
            return this.numBits;
        }
        /**
         * @return points related to the barcode in the image. These are typically points
         *         identifying finder patterns or the corners of the barcode. The exact meaning is
         *         specific to the type of barcode that was decoded.
         */ getResultPoints() {
            return this.resultPoints;
        }
        /**
         * @return {@link BarcodeFormat} representing the format of the barcode that was decoded
         */ getBarcodeFormat() {
            return this.format;
        }
        /**
         * @return {@link Map} mapping {@link ResultMetadataType} keys to values. May be
         *   {@code null}. This contains optional metadata about what was detected about the barcode,
         *   like orientation.
         */ getResultMetadata() {
            return this.resultMetadata;
        }
        putMetadata(type, value) {
            if (this.resultMetadata === null) this.resultMetadata = new Map();
            this.resultMetadata.set(type, value);
        }
        putAllMetadata(metadata) {
            if (metadata !== null) {
                if (this.resultMetadata === null) this.resultMetadata = metadata;
                else this.resultMetadata = new Map(metadata);
            }
        }
        addResultPoints(newPoints) {
            const oldPoints = this.resultPoints;
            if (oldPoints === null) this.resultPoints = newPoints;
            else if (newPoints !== null && newPoints.length > 0) {
                const allPoints = new Array(oldPoints.length + newPoints.length);
                System.arraycopy(oldPoints, 0, allPoints, 0, oldPoints.length);
                System.arraycopy(newPoints, 0, allPoints, oldPoints.length, newPoints.length);
                this.resultPoints = allPoints;
            }
        }
        getTimestamp() {
            return this.timestamp;
        }
        /*@Override*/ toString() {
            return this.text;
        }
    }
    /*
     * Direct port to TypeScript of ZXing by Adrian Toșcă
     */ /*
     * Copyright 2009 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /*namespace com.google.zxing {*/ /**
     * Enumerates barcode formats known to this package. Please keep alphabetized.
     *
     * @author Sean Owen
     */ var BarcodeFormat;
    (function(BarcodeFormat) {
        /** Aztec 2D barcode format. */ BarcodeFormat[BarcodeFormat["AZTEC"] = 0] = "AZTEC";
        /** CODABAR 1D format. */ BarcodeFormat[BarcodeFormat["CODABAR"] = 1] = "CODABAR";
        /** Code 39 1D format. */ BarcodeFormat[BarcodeFormat["CODE_39"] = 2] = "CODE_39";
        /** Code 93 1D format. */ BarcodeFormat[BarcodeFormat["CODE_93"] = 3] = "CODE_93";
        /** Code 128 1D format. */ BarcodeFormat[BarcodeFormat["CODE_128"] = 4] = "CODE_128";
        /** Data Matrix 2D barcode format. */ BarcodeFormat[BarcodeFormat["DATA_MATRIX"] = 5] = "DATA_MATRIX";
        /** EAN-8 1D format. */ BarcodeFormat[BarcodeFormat["EAN_8"] = 6] = "EAN_8";
        /** EAN-13 1D format. */ BarcodeFormat[BarcodeFormat["EAN_13"] = 7] = "EAN_13";
        /** ITF (Interleaved Two of Five) 1D format. */ BarcodeFormat[BarcodeFormat["ITF"] = 8] = "ITF";
        /** MaxiCode 2D barcode format. */ BarcodeFormat[BarcodeFormat["MAXICODE"] = 9] = "MAXICODE";
        /** PDF417 format. */ BarcodeFormat[BarcodeFormat["PDF_417"] = 10] = "PDF_417";
        /** QR Code 2D barcode format. */ BarcodeFormat[BarcodeFormat["QR_CODE"] = 11] = "QR_CODE";
        /** RSS 14 */ BarcodeFormat[BarcodeFormat["RSS_14"] = 12] = "RSS_14";
        /** RSS EXPANDED */ BarcodeFormat[BarcodeFormat["RSS_EXPANDED"] = 13] = "RSS_EXPANDED";
        /** UPC-A 1D format. */ BarcodeFormat[BarcodeFormat["UPC_A"] = 14] = "UPC_A";
        /** UPC-E 1D format. */ BarcodeFormat[BarcodeFormat["UPC_E"] = 15] = "UPC_E";
        /** UPC/EAN extension format. Not a stand-alone format. */ BarcodeFormat[BarcodeFormat["UPC_EAN_EXTENSION"] = 16] = "UPC_EAN_EXTENSION";
    })(BarcodeFormat || (BarcodeFormat = {}));
    var BarcodeFormat$1 = BarcodeFormat;
    /*namespace com.google.zxing {*/ /**
     * Represents some type of metadata about the result of the decoding that the decoder
     * wishes to communicate back to the caller.
     *
     * @author Sean Owen
     */ var ResultMetadataType;
    (function(ResultMetadataType) {
        /**
         * Unspecified, application-specific metadata. Maps to an unspecified {@link Object}.
         */ ResultMetadataType[ResultMetadataType["OTHER"] = 0] = "OTHER";
        /**
         * Denotes the likely approximate orientation of the barcode in the image. This value
         * is given as degrees rotated clockwise from the normal, upright orientation.
         * For example a 1D barcode which was found by reading top-to-bottom would be
         * said to have orientation "90". This key maps to an {@link Integer} whose
         * value is in the range [0,360).
         */ ResultMetadataType[ResultMetadataType["ORIENTATION"] = 1] = "ORIENTATION";
        /**
         * <p>2D barcode formats typically encode text, but allow for a sort of 'byte mode'
         * which is sometimes used to encode binary data. While {@link Result} makes available
         * the complete raw bytes in the barcode for these formats, it does not offer the bytes
         * from the byte segments alone.</p>
         *
         * <p>This maps to a {@link java.util.List} of byte arrays corresponding to the
         * raw bytes in the byte segments in the barcode, in order.</p>
         */ ResultMetadataType[ResultMetadataType["BYTE_SEGMENTS"] = 2] = "BYTE_SEGMENTS";
        /**
         * Error correction level used, if applicable. The value type depends on the
         * format, but is typically a String.
         */ ResultMetadataType[ResultMetadataType["ERROR_CORRECTION_LEVEL"] = 3] = "ERROR_CORRECTION_LEVEL";
        /**
         * For some periodicals, indicates the issue number as an {@link Integer}.
         */ ResultMetadataType[ResultMetadataType["ISSUE_NUMBER"] = 4] = "ISSUE_NUMBER";
        /**
         * For some products, indicates the suggested retail price in the barcode as a
         * formatted {@link String}.
         */ ResultMetadataType[ResultMetadataType["SUGGESTED_PRICE"] = 5] = "SUGGESTED_PRICE";
        /**
         * For some products, the possible country of manufacture as a {@link String} denoting the
         * ISO country code. Some map to multiple possible countries, like "US/CA".
         */ ResultMetadataType[ResultMetadataType["POSSIBLE_COUNTRY"] = 6] = "POSSIBLE_COUNTRY";
        /**
         * For some products, the extension text
         */ ResultMetadataType[ResultMetadataType["UPC_EAN_EXTENSION"] = 7] = "UPC_EAN_EXTENSION";
        /**
         * PDF417-specific metadata
         */ ResultMetadataType[ResultMetadataType["PDF417_EXTRA_METADATA"] = 8] = "PDF417_EXTRA_METADATA";
        /**
         * If the code format supports structured append and the current scanned code is part of one then the
         * sequence number is given with it.
         */ ResultMetadataType[ResultMetadataType["STRUCTURED_APPEND_SEQUENCE"] = 9] = "STRUCTURED_APPEND_SEQUENCE";
        /**
         * If the code format supports structured append and the current scanned code is part of one then the
         * parity is given with it.
         */ ResultMetadataType[ResultMetadataType["STRUCTURED_APPEND_PARITY"] = 10] = "STRUCTURED_APPEND_PARITY";
    })(ResultMetadataType || (ResultMetadataType = {}));
    var ResultMetadataType$1 = ResultMetadataType;
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /*namespace com.google.zxing.common {*/ /*import java.util.List;*/ /**
     * <p>Encapsulates the result of decoding a matrix of bits. This typically
     * applies to 2D barcode formats. For now it contains the raw bytes obtained,
     * as well as a String interpretation of those bytes, if applicable.</p>
     *
     * @author Sean Owen
     */ class DecoderResult {
        // public constructor(rawBytes: Uint8Array,
        //                      text: string,
        //                      List<Uint8Array> byteSegments,
        //                      String ecLevel) {
        //   this(rawBytes, text, byteSegments, ecLevel, -1, -1)
        // }
        constructor(rawBytes, text, byteSegments, ecLevel, structuredAppendSequenceNumber = -1, structuredAppendParity = -1){
            this.rawBytes = rawBytes;
            this.text = text;
            this.byteSegments = byteSegments;
            this.ecLevel = ecLevel;
            this.structuredAppendSequenceNumber = structuredAppendSequenceNumber;
            this.structuredAppendParity = structuredAppendParity;
            this.numBits = rawBytes === undefined || rawBytes === null ? 0 : 8 * rawBytes.length;
        }
        /**
         * @return raw bytes representing the result, or {@code null} if not applicable
         */ getRawBytes() {
            return this.rawBytes;
        }
        /**
         * @return how many bits of {@link #getRawBytes()} are valid; typically 8 times its length
         * @since 3.3.0
         */ getNumBits() {
            return this.numBits;
        }
        /**
         * @param numBits overrides the number of bits that are valid in {@link #getRawBytes()}
         * @since 3.3.0
         */ setNumBits(numBits /*int*/ ) {
            this.numBits = numBits;
        }
        /**
         * @return text representation of the result
         */ getText() {
            return this.text;
        }
        /**
         * @return list of byte segments in the result, or {@code null} if not applicable
         */ getByteSegments() {
            return this.byteSegments;
        }
        /**
         * @return name of error correction level used, or {@code null} if not applicable
         */ getECLevel() {
            return this.ecLevel;
        }
        /**
         * @return number of errors corrected, or {@code null} if not applicable
         */ getErrorsCorrected() {
            return this.errorsCorrected;
        }
        setErrorsCorrected(errorsCorrected /*Integer*/ ) {
            this.errorsCorrected = errorsCorrected;
        }
        /**
         * @return number of erasures corrected, or {@code null} if not applicable
         */ getErasures() {
            return this.erasures;
        }
        setErasures(erasures /*Integer*/ ) {
            this.erasures = erasures;
        }
        /**
         * @return arbitrary additional metadata
         */ getOther() {
            return this.other;
        }
        setOther(other) {
            this.other = other;
        }
        hasStructuredAppend() {
            return this.structuredAppendParity >= 0 && this.structuredAppendSequenceNumber >= 0;
        }
        getStructuredAppendParity() {
            return this.structuredAppendParity;
        }
        getStructuredAppendSequenceNumber() {
            return this.structuredAppendSequenceNumber;
        }
    }
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * <p>This class contains utility methods for performing mathematical operations over
     * the Galois Fields. Operations use a given primitive polynomial in calculations.</p>
     *
     * <p>Throughout this package, elements of the GF are represented as an {@code int}
     * for convenience and speed (but at the cost of memory).
     * </p>
     *
     * @author Sean Owen
     * @author David Olivier
     */ class AbstractGenericGF {
        /**
         * @return 2 to the power of a in GF(size)
         */ exp(a) {
            return this.expTable[a];
        }
        /**
         * @return base 2 log of a in GF(size)
         */ log(a /*int*/ ) {
            if (a === 0) throw new IllegalArgumentException();
            return this.logTable[a];
        }
        /**
         * Implements both addition and subtraction -- they are the same in GF(size).
         *
         * @return sum/difference of a and b
         */ static addOrSubtract(a /*int*/ , b /*int*/ ) {
            return a ^ b;
        }
    }
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * <p>Represents a polynomial whose coefficients are elements of a GF.
     * Instances of this class are immutable.</p>
     *
     * <p>Much credit is due to William Rucklidge since portions of this code are an indirect
     * port of his C++ Reed-Solomon implementation.</p>
     *
     * @author Sean Owen
     */ class GenericGFPoly {
        /**
         * @param field the {@link GenericGF} instance representing the field to use
         * to perform computations
         * @param coefficients coefficients as ints representing elements of GF(size), arranged
         * from most significant (highest-power term) coefficient to least significant
         * @throws IllegalArgumentException if argument is null or empty,
         * or if leading coefficient is 0 and this is not a
         * constant polynomial (that is, it is not the monomial "0")
         */ constructor(field, coefficients){
            if (coefficients.length === 0) throw new IllegalArgumentException();
            this.field = field;
            const coefficientsLength = coefficients.length;
            if (coefficientsLength > 1 && coefficients[0] === 0) {
                // Leading term must be non-zero for anything except the constant polynomial "0"
                let firstNonZero = 1;
                while(firstNonZero < coefficientsLength && coefficients[firstNonZero] === 0)firstNonZero++;
                if (firstNonZero === coefficientsLength) this.coefficients = Int32Array.from([
                    0
                ]);
                else {
                    this.coefficients = new Int32Array(coefficientsLength - firstNonZero);
                    System.arraycopy(coefficients, firstNonZero, this.coefficients, 0, this.coefficients.length);
                }
            } else this.coefficients = coefficients;
        }
        getCoefficients() {
            return this.coefficients;
        }
        /**
         * @return degree of this polynomial
         */ getDegree() {
            return this.coefficients.length - 1;
        }
        /**
         * @return true iff this polynomial is the monomial "0"
         */ isZero() {
            return this.coefficients[0] === 0;
        }
        /**
         * @return coefficient of x^degree term in this polynomial
         */ getCoefficient(degree /*int*/ ) {
            return this.coefficients[this.coefficients.length - 1 - degree];
        }
        /**
         * @return evaluation of this polynomial at a given point
         */ evaluateAt(a /*int*/ ) {
            if (a === 0) // Just return the x^0 coefficient
            return this.getCoefficient(0);
            const coefficients = this.coefficients;
            let result;
            if (a === 1) {
                // Just the sum of the coefficients
                result = 0;
                for(let i = 0, length = coefficients.length; i !== length; i++){
                    const coefficient = coefficients[i];
                    result = AbstractGenericGF.addOrSubtract(result, coefficient);
                }
                return result;
            }
            result = coefficients[0];
            const size = coefficients.length;
            const field = this.field;
            for(let i = 1; i < size; i++)result = AbstractGenericGF.addOrSubtract(field.multiply(a, result), coefficients[i]);
            return result;
        }
        addOrSubtract(other) {
            if (!this.field.equals(other.field)) throw new IllegalArgumentException('GenericGFPolys do not have same GenericGF field');
            if (this.isZero()) return other;
            if (other.isZero()) return this;
            let smallerCoefficients = this.coefficients;
            let largerCoefficients = other.coefficients;
            if (smallerCoefficients.length > largerCoefficients.length) {
                const temp = smallerCoefficients;
                smallerCoefficients = largerCoefficients;
                largerCoefficients = temp;
            }
            let sumDiff = new Int32Array(largerCoefficients.length);
            const lengthDiff = largerCoefficients.length - smallerCoefficients.length;
            // Copy high-order terms only found in higher-degree polynomial's coefficients
            System.arraycopy(largerCoefficients, 0, sumDiff, 0, lengthDiff);
            for(let i = lengthDiff; i < largerCoefficients.length; i++)sumDiff[i] = AbstractGenericGF.addOrSubtract(smallerCoefficients[i - lengthDiff], largerCoefficients[i]);
            return new GenericGFPoly(this.field, sumDiff);
        }
        multiply(other) {
            if (!this.field.equals(other.field)) throw new IllegalArgumentException('GenericGFPolys do not have same GenericGF field');
            if (this.isZero() || other.isZero()) return this.field.getZero();
            const aCoefficients = this.coefficients;
            const aLength = aCoefficients.length;
            const bCoefficients = other.coefficients;
            const bLength = bCoefficients.length;
            const product = new Int32Array(aLength + bLength - 1);
            const field = this.field;
            for(let i = 0; i < aLength; i++){
                const aCoeff = aCoefficients[i];
                for(let j = 0; j < bLength; j++)product[i + j] = AbstractGenericGF.addOrSubtract(product[i + j], field.multiply(aCoeff, bCoefficients[j]));
            }
            return new GenericGFPoly(field, product);
        }
        multiplyScalar(scalar /*int*/ ) {
            if (scalar === 0) return this.field.getZero();
            if (scalar === 1) return this;
            const size = this.coefficients.length;
            const field = this.field;
            const product = new Int32Array(size);
            const coefficients = this.coefficients;
            for(let i = 0; i < size; i++)product[i] = field.multiply(coefficients[i], scalar);
            return new GenericGFPoly(field, product);
        }
        multiplyByMonomial(degree /*int*/ , coefficient /*int*/ ) {
            if (degree < 0) throw new IllegalArgumentException();
            if (coefficient === 0) return this.field.getZero();
            const coefficients = this.coefficients;
            const size = coefficients.length;
            const product = new Int32Array(size + degree);
            const field = this.field;
            for(let i = 0; i < size; i++)product[i] = field.multiply(coefficients[i], coefficient);
            return new GenericGFPoly(field, product);
        }
        divide(other) {
            if (!this.field.equals(other.field)) throw new IllegalArgumentException('GenericGFPolys do not have same GenericGF field');
            if (other.isZero()) throw new IllegalArgumentException('Divide by 0');
            const field = this.field;
            let quotient = field.getZero();
            let remainder = this;
            const denominatorLeadingTerm = other.getCoefficient(other.getDegree());
            const inverseDenominatorLeadingTerm = field.inverse(denominatorLeadingTerm);
            while(remainder.getDegree() >= other.getDegree() && !remainder.isZero()){
                const degreeDifference = remainder.getDegree() - other.getDegree();
                const scale = field.multiply(remainder.getCoefficient(remainder.getDegree()), inverseDenominatorLeadingTerm);
                const term = other.multiplyByMonomial(degreeDifference, scale);
                const iterationQuotient = field.buildMonomial(degreeDifference, scale);
                quotient = quotient.addOrSubtract(iterationQuotient);
                remainder = remainder.addOrSubtract(term);
            }
            return [
                quotient,
                remainder
            ];
        }
        /*@Override*/ toString() {
            let result = '';
            for(let degree = this.getDegree(); degree >= 0; degree--){
                let coefficient = this.getCoefficient(degree);
                if (coefficient !== 0) {
                    if (coefficient < 0) {
                        result += ' - ';
                        coefficient = -coefficient;
                    } else if (result.length > 0) result += ' + ';
                    if (degree === 0 || coefficient !== 1) {
                        const alphaPower = this.field.log(coefficient);
                        if (alphaPower === 0) result += '1';
                        else if (alphaPower === 1) result += 'a';
                        else {
                            result += 'a^';
                            result += alphaPower;
                        }
                    }
                    if (degree !== 0) {
                        if (degree === 1) result += 'x';
                        else {
                            result += 'x^';
                            result += degree;
                        }
                    }
                }
            }
            return result;
        }
    }
    /**
     * Custom Error class of type Exception.
     */ class ArithmeticException extends Exception {
    }
    ArithmeticException.kind = 'ArithmeticException';
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * <p>This class contains utility methods for performing mathematical operations over
     * the Galois Fields. Operations use a given primitive polynomial in calculations.</p>
     *
     * <p>Throughout this package, elements of the GF are represented as an {@code int}
     * for convenience and speed (but at the cost of memory).
     * </p>
     *
     * @author Sean Owen
     * @author David Olivier
     */ class GenericGF extends AbstractGenericGF {
        /**
         * Create a representation of GF(size) using the given primitive polynomial.
         *
         * @param primitive irreducible polynomial whose coefficients are represented by
         *  the bits of an int, where the least-significant bit represents the constant
         *  coefficient
         * @param size the size of the field
         * @param b the factor b in the generator polynomial can be 0- or 1-based
         *  (g(x) = (x+a^b)(x+a^(b+1))...(x+a^(b+2t-1))).
         *  In most cases it should be 1, but for QR code it is 0.
         */ constructor(primitive /*int*/ , size /*int*/ , generatorBase /*int*/ ){
            super();
            this.primitive = primitive;
            this.size = size;
            this.generatorBase = generatorBase;
            const expTable = new Int32Array(size);
            let x = 1;
            for(let i = 0; i < size; i++){
                expTable[i] = x;
                x *= 2; // we're assuming the generator alpha is 2
                if (x >= size) {
                    x ^= primitive;
                    x &= size - 1;
                }
            }
            this.expTable = expTable;
            const logTable = new Int32Array(size);
            for(let i = 0; i < size - 1; i++)logTable[expTable[i]] = i;
            this.logTable = logTable;
            // logTable[0] == 0 but this should never be used
            this.zero = new GenericGFPoly(this, Int32Array.from([
                0
            ]));
            this.one = new GenericGFPoly(this, Int32Array.from([
                1
            ]));
        }
        getZero() {
            return this.zero;
        }
        getOne() {
            return this.one;
        }
        /**
         * @return the monomial representing coefficient * x^degree
         */ buildMonomial(degree /*int*/ , coefficient /*int*/ ) {
            if (degree < 0) throw new IllegalArgumentException();
            if (coefficient === 0) return this.zero;
            const coefficients = new Int32Array(degree + 1);
            coefficients[0] = coefficient;
            return new GenericGFPoly(this, coefficients);
        }
        /**
         * @return multiplicative inverse of a
         */ inverse(a /*int*/ ) {
            if (a === 0) throw new ArithmeticException();
            return this.expTable[this.size - this.logTable[a] - 1];
        }
        /**
         * @return product of a and b in GF(size)
         */ multiply(a /*int*/ , b /*int*/ ) {
            if (a === 0 || b === 0) return 0;
            return this.expTable[(this.logTable[a] + this.logTable[b]) % (this.size - 1)];
        }
        getSize() {
            return this.size;
        }
        getGeneratorBase() {
            return this.generatorBase;
        }
        /*@Override*/ toString() {
            return 'GF(0x' + Integer.toHexString(this.primitive) + ',' + this.size + ')';
        }
        equals(o) {
            return o === this;
        }
    }
    GenericGF.AZTEC_DATA_12 = new GenericGF(0x1069, 4096, 1); // x^12 + x^6 + x^5 + x^3 + 1
    GenericGF.AZTEC_DATA_10 = new GenericGF(0x409, 1024, 1); // x^10 + x^3 + 1
    GenericGF.AZTEC_DATA_6 = new GenericGF(0x43, 64, 1); // x^6 + x + 1
    GenericGF.AZTEC_PARAM = new GenericGF(0x13, 16, 1); // x^4 + x + 1
    GenericGF.QR_CODE_FIELD_256 = new GenericGF(0x011d, 256, 0); // x^8 + x^4 + x^3 + x^2 + 1
    GenericGF.DATA_MATRIX_FIELD_256 = new GenericGF(0x012d, 256, 1); // x^8 + x^5 + x^3 + x^2 + 1
    GenericGF.AZTEC_DATA_8 = GenericGF.DATA_MATRIX_FIELD_256;
    GenericGF.MAXICODE_FIELD_64 = GenericGF.AZTEC_DATA_6;
    /**
     * Custom Error class of type Exception.
     */ class ReedSolomonException extends Exception {
    }
    ReedSolomonException.kind = 'ReedSolomonException';
    /**
     * Custom Error class of type Exception.
     */ class IllegalStateException extends Exception {
    }
    IllegalStateException.kind = 'IllegalStateException';
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * <p>Implements Reed-Solomon decoding, as the name implies.</p>
     *
     * <p>The algorithm will not be explained here, but the following references were helpful
     * in creating this implementation:</p>
     *
     * <ul>
     * <li>Bruce Maggs.
     * <a href="http://www.cs.cmu.edu/afs/cs.cmu.edu/project/pscico-guyb/realworld/www/rs_decode.ps">
     * "Decoding Reed-Solomon Codes"</a> (see discussion of Forney's Formula)</li>
     * <li>J.I. Hall. <a href="www.mth.msu.edu/~jhall/classes/codenotes/GRS.pdf">
     * "Chapter 5. Generalized Reed-Solomon Codes"</a>
     * (see discussion of Euclidean algorithm)</li>
     * </ul>
     *
     * <p>Much credit is due to William Rucklidge since portions of this code are an indirect
     * port of his C++ Reed-Solomon implementation.</p>
     *
     * @author Sean Owen
     * @author William Rucklidge
     * @author sanfordsquires
     */ class ReedSolomonDecoder {
        constructor(field){
            this.field = field;
        }
        /**
         * <p>Decodes given set of received codewords, which include both data and error-correction
         * codewords. Really, this means it uses Reed-Solomon to detect and correct errors, in-place,
         * in the input.</p>
         *
         * @param received data and error-correction codewords
         * @param twoS number of error-correction codewords available
         * @throws ReedSolomonException if decoding fails for any reason
         */ decode(received, twoS /*int*/ ) {
            const field = this.field;
            const poly = new GenericGFPoly(field, received);
            const syndromeCoefficients = new Int32Array(twoS);
            let noError = true;
            for(let i = 0; i < twoS; i++){
                const evalResult = poly.evaluateAt(field.exp(i + field.getGeneratorBase()));
                syndromeCoefficients[syndromeCoefficients.length - 1 - i] = evalResult;
                if (evalResult !== 0) noError = false;
            }
            if (noError) return;
            const syndrome = new GenericGFPoly(field, syndromeCoefficients);
            const sigmaOmega = this.runEuclideanAlgorithm(field.buildMonomial(twoS, 1), syndrome, twoS);
            const sigma = sigmaOmega[0];
            const omega = sigmaOmega[1];
            const errorLocations = this.findErrorLocations(sigma);
            const errorMagnitudes = this.findErrorMagnitudes(omega, errorLocations);
            for(let i = 0; i < errorLocations.length; i++){
                const position = received.length - 1 - field.log(errorLocations[i]);
                if (position < 0) throw new ReedSolomonException('Bad error location');
                received[position] = GenericGF.addOrSubtract(received[position], errorMagnitudes[i]);
            }
        }
        runEuclideanAlgorithm(a, b, R /*int*/ ) {
            // Assume a's degree is >= b's
            if (a.getDegree() < b.getDegree()) {
                const temp = a;
                a = b;
                b = temp;
            }
            const field = this.field;
            let rLast = a;
            let r = b;
            let tLast = field.getZero();
            let t = field.getOne();
            // Run Euclidean algorithm until r's degree is less than R/2
            while(r.getDegree() >= (R / 2 | 0)){
                let rLastLast = rLast;
                let tLastLast = tLast;
                rLast = r;
                tLast = t;
                // Divide rLastLast by rLast, with quotient in q and remainder in r
                if (rLast.isZero()) // Oops, Euclidean algorithm already terminated?
                throw new ReedSolomonException('r_{i-1} was zero');
                r = rLastLast;
                let q = field.getZero();
                const denominatorLeadingTerm = rLast.getCoefficient(rLast.getDegree());
                const dltInverse = field.inverse(denominatorLeadingTerm);
                while(r.getDegree() >= rLast.getDegree() && !r.isZero()){
                    const degreeDiff = r.getDegree() - rLast.getDegree();
                    const scale = field.multiply(r.getCoefficient(r.getDegree()), dltInverse);
                    q = q.addOrSubtract(field.buildMonomial(degreeDiff, scale));
                    r = r.addOrSubtract(rLast.multiplyByMonomial(degreeDiff, scale));
                }
                t = q.multiply(tLast).addOrSubtract(tLastLast);
                if (r.getDegree() >= rLast.getDegree()) throw new IllegalStateException('Division algorithm failed to reduce polynomial?');
            }
            const sigmaTildeAtZero = t.getCoefficient(0);
            if (sigmaTildeAtZero === 0) throw new ReedSolomonException('sigmaTilde(0) was zero');
            const inverse = field.inverse(sigmaTildeAtZero);
            const sigma = t.multiplyScalar(inverse);
            const omega = r.multiplyScalar(inverse);
            return [
                sigma,
                omega
            ];
        }
        findErrorLocations(errorLocator) {
            // This is a direct application of Chien's search
            const numErrors = errorLocator.getDegree();
            if (numErrors === 1) return Int32Array.from([
                errorLocator.getCoefficient(1)
            ]);
            const result = new Int32Array(numErrors);
            let e = 0;
            const field = this.field;
            for(let i = 1; i < field.getSize() && e < numErrors; i++)if (errorLocator.evaluateAt(i) === 0) {
                result[e] = field.inverse(i);
                e++;
            }
            if (e !== numErrors) throw new ReedSolomonException('Error locator degree does not match number of roots');
            return result;
        }
        findErrorMagnitudes(errorEvaluator, errorLocations) {
            // This is directly applying Forney's Formula
            const s = errorLocations.length;
            const result = new Int32Array(s);
            const field = this.field;
            for(let i = 0; i < s; i++){
                const xiInverse = field.inverse(errorLocations[i]);
                let denominator = 1;
                for(let j = 0; j < s; j++)if (i !== j) {
                    // denominator = field.multiply(denominator,
                    //    GenericGF.addOrSubtract(1, field.multiply(errorLocations[j], xiInverse)))
                    // Above should work but fails on some Apple and Linux JDKs due to a Hotspot bug.
                    // Below is a funny-looking workaround from Steven Parkes
                    const term = field.multiply(errorLocations[j], xiInverse);
                    const termPlus1 = (term & 0x1) === 0 ? term | 1 : term & -2;
                    denominator = field.multiply(denominator, termPlus1);
                }
                result[i] = field.multiply(errorEvaluator.evaluateAt(xiInverse), field.inverse(denominator));
                if (field.getGeneratorBase() !== 0) result[i] = field.multiply(result[i], xiInverse);
            }
            return result;
        }
    }
    /*
     * Copyright 2010 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ // import java.util.Arrays;
    var Table;
    (function(Table) {
        Table[Table["UPPER"] = 0] = "UPPER";
        Table[Table["LOWER"] = 1] = "LOWER";
        Table[Table["MIXED"] = 2] = "MIXED";
        Table[Table["DIGIT"] = 3] = "DIGIT";
        Table[Table["PUNCT"] = 4] = "PUNCT";
        Table[Table["BINARY"] = 5] = "BINARY";
    })(Table || (Table = {}));
    /**
     * <p>The main class which implements Aztec Code decoding -- as opposed to locating and extracting
     * the Aztec Code from an image.</p>
     *
     * @author David Olivier
     */ class Decoder {
        decode(detectorResult) {
            this.ddata = detectorResult;
            let matrix = detectorResult.getBits();
            let rawbits = this.extractBits(matrix);
            let correctedBits = this.correctBits(rawbits);
            let rawBytes = Decoder.convertBoolArrayToByteArray(correctedBits);
            let result = Decoder.getEncodedData(correctedBits);
            let decoderResult = new DecoderResult(rawBytes, result, null, null);
            decoderResult.setNumBits(correctedBits.length);
            return decoderResult;
        }
        // This method is used for testing the high-level encoder
        static highLevelDecode(correctedBits) {
            return this.getEncodedData(correctedBits);
        }
        /**
         * Gets the string encoded in the aztec code bits
         *
         * @return the decoded string
         */ static getEncodedData(correctedBits) {
            let endIndex = correctedBits.length;
            let latchTable = Table.UPPER; // table most recently latched to
            let shiftTable = Table.UPPER; // table to use for the next read
            let result = '';
            let index = 0;
            while(index < endIndex)if (shiftTable === Table.BINARY) {
                if (endIndex - index < 5) break;
                let length = Decoder.readCode(correctedBits, index, 5);
                index += 5;
                if (length === 0) {
                    if (endIndex - index < 11) break;
                    length = Decoder.readCode(correctedBits, index, 11) + 31;
                    index += 11;
                }
                for(let charCount = 0; charCount < length; charCount++){
                    if (endIndex - index < 8) {
                        index = endIndex; // Force outer loop to exit
                        break;
                    }
                    const code = Decoder.readCode(correctedBits, index, 8);
                    result += /*(char)*/ StringUtils.castAsNonUtf8Char(code);
                    index += 8;
                }
                // Go back to whatever mode we had been in
                shiftTable = latchTable;
            } else {
                let size = shiftTable === Table.DIGIT ? 4 : 5;
                if (endIndex - index < size) break;
                let code = Decoder.readCode(correctedBits, index, size);
                index += size;
                let str = Decoder.getCharacter(shiftTable, code);
                if (str.startsWith('CTRL_')) {
                    // Table changes
                    // ISO/IEC 24778:2008 prescribes ending a shift sequence in the mode from which it was invoked.
                    // That's including when that mode is a shift.
                    // Our test case dlusbs.png for issue #642 exercises that.
                    latchTable = shiftTable; // Latch the current mode, so as to return to Upper after U/S B/S
                    shiftTable = Decoder.getTable(str.charAt(5));
                    if (str.charAt(6) === 'L') latchTable = shiftTable;
                } else {
                    result += str;
                    // Go back to whatever mode we had been in
                    shiftTable = latchTable;
                }
            }
            return result;
        }
        /**
         * gets the table corresponding to the char passed
         */ static getTable(t) {
            switch(t){
                case 'L':
                    return Table.LOWER;
                case 'P':
                    return Table.PUNCT;
                case 'M':
                    return Table.MIXED;
                case 'D':
                    return Table.DIGIT;
                case 'B':
                    return Table.BINARY;
                case 'U':
                default:
                    return Table.UPPER;
            }
        }
        /**
         * Gets the character (or string) corresponding to the passed code in the given table
         *
         * @param table the table used
         * @param code the code of the character
         */ static getCharacter(table, code) {
            switch(table){
                case Table.UPPER:
                    return Decoder.UPPER_TABLE[code];
                case Table.LOWER:
                    return Decoder.LOWER_TABLE[code];
                case Table.MIXED:
                    return Decoder.MIXED_TABLE[code];
                case Table.PUNCT:
                    return Decoder.PUNCT_TABLE[code];
                case Table.DIGIT:
                    return Decoder.DIGIT_TABLE[code];
                default:
                    // Should not reach here.
                    throw new IllegalStateException('Bad table');
            }
        }
        /**
         * <p>Performs RS error correction on an array of bits.</p>
         *
         * @return the corrected array
         * @throws FormatException if the input contains too many errors
         */ correctBits(rawbits) {
            let gf;
            let codewordSize;
            if (this.ddata.getNbLayers() <= 2) {
                codewordSize = 6;
                gf = GenericGF.AZTEC_DATA_6;
            } else if (this.ddata.getNbLayers() <= 8) {
                codewordSize = 8;
                gf = GenericGF.AZTEC_DATA_8;
            } else if (this.ddata.getNbLayers() <= 22) {
                codewordSize = 10;
                gf = GenericGF.AZTEC_DATA_10;
            } else {
                codewordSize = 12;
                gf = GenericGF.AZTEC_DATA_12;
            }
            let numDataCodewords = this.ddata.getNbDatablocks();
            let numCodewords = rawbits.length / codewordSize;
            if (numCodewords < numDataCodewords) throw new FormatException();
            let offset = rawbits.length % codewordSize;
            let dataWords = new Int32Array(numCodewords);
            for(let i = 0; i < numCodewords; i++, offset += codewordSize)dataWords[i] = Decoder.readCode(rawbits, offset, codewordSize);
            try {
                let rsDecoder = new ReedSolomonDecoder(gf);
                rsDecoder.decode(dataWords, numCodewords - numDataCodewords);
            } catch (ex) {
                throw new FormatException(ex);
            }
            // Now perform the unstuffing operation.
            // First, count how many bits are going to be thrown out as stuffing
            let mask = (1 << codewordSize) - 1;
            let stuffedBits = 0;
            for(let i = 0; i < numDataCodewords; i++){
                let dataWord = dataWords[i];
                if (dataWord === 0 || dataWord === mask) throw new FormatException();
                else if (dataWord === 1 || dataWord === mask - 1) stuffedBits++;
            }
            // Now, actually unpack the bits and remove the stuffing
            let correctedBits = new Array(numDataCodewords * codewordSize - stuffedBits);
            let index = 0;
            for(let i = 0; i < numDataCodewords; i++){
                let dataWord = dataWords[i];
                if (dataWord === 1 || dataWord === mask - 1) {
                    // next codewordSize-1 bits are all zeros or all ones
                    correctedBits.fill(dataWord > 1, index, index + codewordSize - 1);
                    // Arrays.fill(correctedBits, index, index + codewordSize - 1, dataWord > 1);
                    index += codewordSize - 1;
                } else for(let bit = codewordSize - 1; bit >= 0; --bit)correctedBits[index++] = (dataWord & 1 << bit) !== 0;
            }
            return correctedBits;
        }
        /**
         * Gets the array of bits from an Aztec Code matrix
         *
         * @return the array of bits
         */ extractBits(matrix) {
            let compact = this.ddata.isCompact();
            let layers = this.ddata.getNbLayers();
            let baseMatrixSize = (compact ? 11 : 14) + layers * 4; // not including alignment lines
            let alignmentMap = new Int32Array(baseMatrixSize);
            let rawbits = new Array(this.totalBitsInLayer(layers, compact));
            if (compact) for(let i = 0; i < alignmentMap.length; i++)alignmentMap[i] = i;
            else {
                let matrixSize = baseMatrixSize + 1 + 2 * Integer.truncDivision(Integer.truncDivision(baseMatrixSize, 2) - 1, 15);
                let origCenter = baseMatrixSize / 2;
                let center = Integer.truncDivision(matrixSize, 2);
                for(let i = 0; i < origCenter; i++){
                    let newOffset = i + Integer.truncDivision(i, 15);
                    alignmentMap[origCenter - i - 1] = center - newOffset - 1;
                    alignmentMap[origCenter + i] = center + newOffset + 1;
                }
            }
            for(let i = 0, rowOffset = 0; i < layers; i++){
                let rowSize = (layers - i) * 4 + (compact ? 9 : 12);
                // The top-left most point of this layer is <low, low> (not including alignment lines)
                let low = i * 2;
                // The bottom-right most point of this layer is <high, high> (not including alignment lines)
                let high = baseMatrixSize - 1 - low;
                // We pull bits from the two 2 x rowSize columns and two rowSize x 2 rows
                for(let j = 0; j < rowSize; j++){
                    let columnOffset = j * 2;
                    for(let k = 0; k < 2; k++){
                        // left column
                        rawbits[rowOffset + columnOffset + k] = matrix.get(alignmentMap[low + k], alignmentMap[low + j]);
                        // bottom row
                        rawbits[rowOffset + 2 * rowSize + columnOffset + k] = matrix.get(alignmentMap[low + j], alignmentMap[high - k]);
                        // right column
                        rawbits[rowOffset + 4 * rowSize + columnOffset + k] = matrix.get(alignmentMap[high - k], alignmentMap[high - j]);
                        // top row
                        rawbits[rowOffset + 6 * rowSize + columnOffset + k] = matrix.get(alignmentMap[high - j], alignmentMap[low + k]);
                    }
                }
                rowOffset += rowSize * 8;
            }
            return rawbits;
        }
        /**
         * Reads a code of given length and at given index in an array of bits
         */ static readCode(rawbits, startIndex, length) {
            let res = 0;
            for(let i = startIndex; i < startIndex + length; i++){
                res <<= 1;
                if (rawbits[i]) res |= 0x01;
            }
            return res;
        }
        /**
         * Reads a code of length 8 in an array of bits, padding with zeros
         */ static readByte(rawbits, startIndex) {
            let n = rawbits.length - startIndex;
            if (n >= 8) return Decoder.readCode(rawbits, startIndex, 8);
            return Decoder.readCode(rawbits, startIndex, n) << 8 - n;
        }
        /**
         * Packs a bit array into bytes, most significant bit first
         */ static convertBoolArrayToByteArray(boolArr) {
            let byteArr = new Uint8Array((boolArr.length + 7) / 8);
            for(let i = 0; i < byteArr.length; i++)byteArr[i] = Decoder.readByte(boolArr, 8 * i);
            return byteArr;
        }
        totalBitsInLayer(layers, compact) {
            return ((compact ? 88 : 112) + 16 * layers) * layers;
        }
    }
    Decoder.UPPER_TABLE = [
        'CTRL_PS',
        ' ',
        'A',
        'B',
        'C',
        'D',
        'E',
        'F',
        'G',
        'H',
        'I',
        'J',
        'K',
        'L',
        'M',
        'N',
        'O',
        'P',
        'Q',
        'R',
        'S',
        'T',
        'U',
        'V',
        'W',
        'X',
        'Y',
        'Z',
        'CTRL_LL',
        'CTRL_ML',
        'CTRL_DL',
        'CTRL_BS'
    ];
    Decoder.LOWER_TABLE = [
        'CTRL_PS',
        ' ',
        'a',
        'b',
        'c',
        'd',
        'e',
        'f',
        'g',
        'h',
        'i',
        'j',
        'k',
        'l',
        'm',
        'n',
        'o',
        'p',
        'q',
        'r',
        's',
        't',
        'u',
        'v',
        'w',
        'x',
        'y',
        'z',
        'CTRL_US',
        'CTRL_ML',
        'CTRL_DL',
        'CTRL_BS'
    ];
    Decoder.MIXED_TABLE = [
        // Module parse failed: Octal literal in strict mode (50:29)
        // so number string were scaped
        'CTRL_PS',
        ' ',
        '\\1',
        '\\2',
        '\\3',
        '\\4',
        '\\5',
        '\\6',
        '\\7',
        '\b',
        '\t',
        '\n',
        '\\13',
        '\f',
        '\r',
        '\\33',
        '\\34',
        '\\35',
        '\\36',
        '\\37',
        '@',
        '\\',
        '^',
        '_',
        '`',
        '|',
        '~',
        '\\177',
        'CTRL_LL',
        'CTRL_UL',
        'CTRL_PL',
        'CTRL_BS'
    ];
    Decoder.PUNCT_TABLE = [
        '',
        '\r',
        '\r\n',
        '. ',
        ', ',
        ': ',
        '!',
        '"',
        '#',
        '$',
        '%',
        '&',
        '\'',
        '(',
        ')',
        '*',
        '+',
        ',',
        '-',
        '.',
        '/',
        ':',
        ';',
        '<',
        '=',
        '>',
        '?',
        '[',
        ']',
        '{',
        '}',
        'CTRL_UL'
    ];
    Decoder.DIGIT_TABLE = [
        'CTRL_PS',
        ' ',
        '0',
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        ',',
        '.',
        'CTRL_UL',
        'CTRL_US'
    ];
    /*
     * Copyright 2012 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /*namespace com.google.zxing.common.detector {*/ /**
     * General math-related and numeric utility functions.
     */ class MathUtils {
        constructor(){}
        /**
         * Ends up being a bit faster than {@link Math#round(float)}. This merely rounds its
         * argument to the nearest int, where x.5 rounds up to x+1. Semantics of this shortcut
         * differ slightly from {@link Math#round(float)} in that half rounds down for negative
         * values. -2.5 rounds to -3, not -2. For purposes here it makes no difference.
         *
         * @param d real value to round
         * @return nearest {@code int}
         */ static round(d /*float*/ ) {
            if (d <= Number.MIN_SAFE_INTEGER) return Number.MIN_SAFE_INTEGER;
            if (d >= Number.MAX_SAFE_INTEGER) return Number.MAX_SAFE_INTEGER;
            return /*(int) */ d + (d < 0.0 ? -0.5 : 0.5) | 0;
        }
        // TYPESCRIPTPORT: maybe remove round method and call directly Math.round, it looks like it doesn't make sense for js
        /**
         * @param aX point A x coordinate
         * @param aY point A y coordinate
         * @param bX point B x coordinate
         * @param bY point B y coordinate
         * @return Euclidean distance between points A and B
         */ static distance(aX /*float|int*/ , aY /*float|int*/ , bX /*float|int*/ , bY /*float|int*/ ) {
            const xDiff = aX - bX;
            const yDiff = aY - bY;
            return /*(float) */ Math.sqrt(xDiff * xDiff + yDiff * yDiff);
        }
        /**
         * @param aX point A x coordinate
         * @param aY point A y coordinate
         * @param bX point B x coordinate
         * @param bY point B y coordinate
         * @return Euclidean distance between points A and B
         */ // public static distance(aX: number /*int*/, aY: number /*int*/, bX: number /*int*/, bY: number /*int*/): float {
        //   const xDiff = aX - bX
        //   const yDiff = aY - bY
        //   return (float) Math.sqrt(xDiff * xDiff + yDiff * yDiff);
        // }
        /**
         * @param array values to sum
         * @return sum of values in array
         */ static sum(array) {
            let count = 0;
            for(let i = 0, length = array.length; i !== length; i++){
                const a = array[i];
                count += a;
            }
            return count;
        }
    }
    /**
     * Ponyfill for Java's Float class.
     */ class Float {
        /**
         * SincTS has no difference between int and float, there's all numbers,
         * this is used only to polyfill Java code.
         */ static floatToIntBits(f) {
            return f;
        }
    }
    /**
     * The float max value in JS is the number max value.
     */ Float.MAX_VALUE = Number.MAX_SAFE_INTEGER;
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * <p>Encapsulates a point of interest in an image containing a barcode. Typically, this
     * would be the location of a finder pattern or the corner of the barcode, for example.</p>
     *
     * @author Sean Owen
     */ class ResultPoint {
        constructor(x, y){
            this.x = x;
            this.y = y;
        }
        getX() {
            return this.x;
        }
        getY() {
            return this.y;
        }
        /*@Override*/ equals(other) {
            if (other instanceof ResultPoint) {
                const otherPoint = other;
                return this.x === otherPoint.x && this.y === otherPoint.y;
            }
            return false;
        }
        /*@Override*/ hashCode() {
            return 31 * Float.floatToIntBits(this.x) + Float.floatToIntBits(this.y);
        }
        /*@Override*/ toString() {
            return '(' + this.x + ',' + this.y + ')';
        }
        /**
         * Orders an array of three ResultPoints in an order [A,B,C] such that AB is less than AC
         * and BC is less than AC, and the angle between BC and BA is less than 180 degrees.
         *
         * @param patterns array of three {@code ResultPoint} to order
         */ static orderBestPatterns(patterns) {
            // Find distances between pattern centers
            const zeroOneDistance = this.distance(patterns[0], patterns[1]);
            const oneTwoDistance = this.distance(patterns[1], patterns[2]);
            const zeroTwoDistance = this.distance(patterns[0], patterns[2]);
            let pointA;
            let pointB;
            let pointC;
            // Assume one closest to other two is B; A and C will just be guesses at first
            if (oneTwoDistance >= zeroOneDistance && oneTwoDistance >= zeroTwoDistance) {
                pointB = patterns[0];
                pointA = patterns[1];
                pointC = patterns[2];
            } else if (zeroTwoDistance >= oneTwoDistance && zeroTwoDistance >= zeroOneDistance) {
                pointB = patterns[1];
                pointA = patterns[0];
                pointC = patterns[2];
            } else {
                pointB = patterns[2];
                pointA = patterns[0];
                pointC = patterns[1];
            }
            // Use cross product to figure out whether A and C are correct or flipped.
            // This asks whether BC x BA has a positive z component, which is the arrangement
            // we want for A, B, C. If it's negative, then we've got it flipped around and
            // should swap A and C.
            if (this.crossProductZ(pointA, pointB, pointC) < 0.0) {
                const temp = pointA;
                pointA = pointC;
                pointC = temp;
            }
            patterns[0] = pointA;
            patterns[1] = pointB;
            patterns[2] = pointC;
        }
        /**
         * @param pattern1 first pattern
         * @param pattern2 second pattern
         * @return distance between two points
         */ static distance(pattern1, pattern2) {
            return MathUtils.distance(pattern1.x, pattern1.y, pattern2.x, pattern2.y);
        }
        /**
         * Returns the z component of the cross product between vectors BC and BA.
         */ static crossProductZ(pointA, pointB, pointC) {
            const bX = pointB.x;
            const bY = pointB.y;
            return (pointC.x - bX) * (pointA.y - bY) - (pointC.y - bY) * (pointA.x - bX);
        }
    }
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * <p>Encapsulates the result of detecting a barcode in an image. This includes the raw
     * matrix of black/white pixels corresponding to the barcode, and possibly points of interest
     * in the image, like the location of finder patterns or corners of the barcode in the image.</p>
     *
     * @author Sean Owen
     */ class DetectorResult {
        constructor(bits, points){
            this.bits = bits;
            this.points = points;
        }
        getBits() {
            return this.bits;
        }
        getPoints() {
            return this.points;
        }
    }
    /*
     * Copyright 2010 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * <p>Extends {@link DetectorResult} with more information specific to the Aztec format,
     * like the number of layers and whether it's compact.</p>
     *
     * @author Sean Owen
     */ class AztecDetectorResult extends DetectorResult {
        constructor(bits, points, compact, nbDatablocks, nbLayers){
            super(bits, points);
            this.compact = compact;
            this.nbDatablocks = nbDatablocks;
            this.nbLayers = nbLayers;
        }
        getNbLayers() {
            return this.nbLayers;
        }
        getNbDatablocks() {
            return this.nbDatablocks;
        }
        isCompact() {
            return this.compact;
        }
    }
    /*
     * Copyright 2010 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * <p>
     * Detects a candidate barcode-like rectangular region within an image. It
     * starts around the center of the image, increases the size of the candidate
     * region until it finds a white rectangular region. By keeping track of the
     * last black points it encountered, it determines the corners of the barcode.
     * </p>
     *
     * @author David Olivier
     */ class WhiteRectangleDetector {
        // public constructor(private image: BitMatrix) /*throws NotFoundException*/ {
        //   this(image, INIT_SIZE, image.getWidth() / 2, image.getHeight() / 2)
        // }
        /**
         * @param image barcode image to find a rectangle in
         * @param initSize initial size of search area around center
         * @param x x position of search center
         * @param y y position of search center
         * @throws NotFoundException if image is too small to accommodate {@code initSize}
         */ constructor(image, initSize /*int*/ , x /*int*/ , y /*int*/ ){
            this.image = image;
            this.height = image.getHeight();
            this.width = image.getWidth();
            if (undefined === initSize || null === initSize) initSize = WhiteRectangleDetector.INIT_SIZE;
            if (undefined === x || null === x) x = image.getWidth() / 2 | 0;
            if (undefined === y || null === y) y = image.getHeight() / 2 | 0;
            const halfsize = initSize / 2 | 0;
            this.leftInit = x - halfsize;
            this.rightInit = x + halfsize;
            this.upInit = y - halfsize;
            this.downInit = y + halfsize;
            if (this.upInit < 0 || this.leftInit < 0 || this.downInit >= this.height || this.rightInit >= this.width) throw new NotFoundException();
        }
        /**
         * <p>
         * Detects a candidate barcode-like rectangular region within an image. It
         * starts around the center of the image, increases the size of the candidate
         * region until it finds a white rectangular region.
         * </p>
         *
         * @return {@link ResultPoint}[] describing the corners of the rectangular
         *         region. The first and last points are opposed on the diagonal, as
         *         are the second and third. The first point will be the topmost
         *         point and the last, the bottommost. The second point will be
         *         leftmost and the third, the rightmost
         * @throws NotFoundException if no Data Matrix Code can be found
         */ detect() {
            let left = this.leftInit;
            let right = this.rightInit;
            let up = this.upInit;
            let down = this.downInit;
            let sizeExceeded = false;
            let aBlackPointFoundOnBorder = true;
            let atLeastOneBlackPointFoundOnBorder = false;
            let atLeastOneBlackPointFoundOnRight = false;
            let atLeastOneBlackPointFoundOnBottom = false;
            let atLeastOneBlackPointFoundOnLeft = false;
            let atLeastOneBlackPointFoundOnTop = false;
            const width = this.width;
            const height = this.height;
            while(aBlackPointFoundOnBorder){
                aBlackPointFoundOnBorder = false;
                // .....
                // .   |
                // .....
                let rightBorderNotWhite = true;
                while((rightBorderNotWhite || !atLeastOneBlackPointFoundOnRight) && right < width){
                    rightBorderNotWhite = this.containsBlackPoint(up, down, right, false);
                    if (rightBorderNotWhite) {
                        right++;
                        aBlackPointFoundOnBorder = true;
                        atLeastOneBlackPointFoundOnRight = true;
                    } else if (!atLeastOneBlackPointFoundOnRight) right++;
                }
                if (right >= width) {
                    sizeExceeded = true;
                    break;
                }
                // .....
                // .   .
                // .___.
                let bottomBorderNotWhite = true;
                while((bottomBorderNotWhite || !atLeastOneBlackPointFoundOnBottom) && down < height){
                    bottomBorderNotWhite = this.containsBlackPoint(left, right, down, true);
                    if (bottomBorderNotWhite) {
                        down++;
                        aBlackPointFoundOnBorder = true;
                        atLeastOneBlackPointFoundOnBottom = true;
                    } else if (!atLeastOneBlackPointFoundOnBottom) down++;
                }
                if (down >= height) {
                    sizeExceeded = true;
                    break;
                }
                // .....
                // |   .
                // .....
                let leftBorderNotWhite = true;
                while((leftBorderNotWhite || !atLeastOneBlackPointFoundOnLeft) && left >= 0){
                    leftBorderNotWhite = this.containsBlackPoint(up, down, left, false);
                    if (leftBorderNotWhite) {
                        left--;
                        aBlackPointFoundOnBorder = true;
                        atLeastOneBlackPointFoundOnLeft = true;
                    } else if (!atLeastOneBlackPointFoundOnLeft) left--;
                }
                if (left < 0) {
                    sizeExceeded = true;
                    break;
                }
                // .___.
                // .   .
                // .....
                let topBorderNotWhite = true;
                while((topBorderNotWhite || !atLeastOneBlackPointFoundOnTop) && up >= 0){
                    topBorderNotWhite = this.containsBlackPoint(left, right, up, true);
                    if (topBorderNotWhite) {
                        up--;
                        aBlackPointFoundOnBorder = true;
                        atLeastOneBlackPointFoundOnTop = true;
                    } else if (!atLeastOneBlackPointFoundOnTop) up--;
                }
                if (up < 0) {
                    sizeExceeded = true;
                    break;
                }
                if (aBlackPointFoundOnBorder) atLeastOneBlackPointFoundOnBorder = true;
            }
            if (!sizeExceeded && atLeastOneBlackPointFoundOnBorder) {
                const maxSize = right - left;
                let z = null;
                for(let i = 1; z === null && i < maxSize; i++)z = this.getBlackPointOnSegment(left, down - i, left + i, down);
                if (z == null) throw new NotFoundException();
                let t = null;
                // go down right
                for(let i = 1; t === null && i < maxSize; i++)t = this.getBlackPointOnSegment(left, up + i, left + i, up);
                if (t == null) throw new NotFoundException();
                let x = null;
                // go down left
                for(let i = 1; x === null && i < maxSize; i++)x = this.getBlackPointOnSegment(right, up + i, right - i, up);
                if (x == null) throw new NotFoundException();
                let y = null;
                // go up left
                for(let i = 1; y === null && i < maxSize; i++)y = this.getBlackPointOnSegment(right, down - i, right - i, down);
                if (y == null) throw new NotFoundException();
                return this.centerEdges(y, z, x, t);
            } else throw new NotFoundException();
        }
        getBlackPointOnSegment(aX /*float*/ , aY /*float*/ , bX /*float*/ , bY /*float*/ ) {
            const dist = MathUtils.round(MathUtils.distance(aX, aY, bX, bY));
            const xStep = (bX - aX) / dist;
            const yStep = (bY - aY) / dist;
            const image = this.image;
            for(let i = 0; i < dist; i++){
                const x = MathUtils.round(aX + i * xStep);
                const y = MathUtils.round(aY + i * yStep);
                if (image.get(x, y)) return new ResultPoint(x, y);
            }
            return null;
        }
        /**
         * recenters the points of a constant distance towards the center
         *
         * @param y bottom most point
         * @param z left most point
         * @param x right most point
         * @param t top most point
         * @return {@link ResultPoint}[] describing the corners of the rectangular
         *         region. The first and last points are opposed on the diagonal, as
         *         are the second and third. The first point will be the topmost
         *         point and the last, the bottommost. The second point will be
         *         leftmost and the third, the rightmost
         */ centerEdges(y, z, x, t) {
            //
            //       t            t
            //  z                      x
            //        x    OR    z
            //   y                    y
            //
            const yi = y.getX();
            const yj = y.getY();
            const zi = z.getX();
            const zj = z.getY();
            const xi = x.getX();
            const xj = x.getY();
            const ti = t.getX();
            const tj = t.getY();
            const CORR = WhiteRectangleDetector.CORR;
            if (yi < this.width / 2.0) return [
                new ResultPoint(ti - CORR, tj + CORR),
                new ResultPoint(zi + CORR, zj + CORR),
                new ResultPoint(xi - CORR, xj - CORR),
                new ResultPoint(yi + CORR, yj - CORR)
            ];
            else return [
                new ResultPoint(ti + CORR, tj + CORR),
                new ResultPoint(zi + CORR, zj - CORR),
                new ResultPoint(xi - CORR, xj + CORR),
                new ResultPoint(yi - CORR, yj - CORR)
            ];
        }
        /**
         * Determines whether a segment contains a black point
         *
         * @param a          min value of the scanned coordinate
         * @param b          max value of the scanned coordinate
         * @param fixed      value of fixed coordinate
         * @param horizontal set to true if scan must be horizontal, false if vertical
         * @return true if a black point has been found, else false.
         */ containsBlackPoint(a /*int*/ , b /*int*/ , fixed /*int*/ , horizontal) {
            const image = this.image;
            if (horizontal) for(let x = a; x <= b; x++){
                if (image.get(x, fixed)) return true;
            }
            else for(let y = a; y <= b; y++){
                if (image.get(fixed, y)) return true;
            }
            return false;
        }
    }
    WhiteRectangleDetector.INIT_SIZE = 10;
    WhiteRectangleDetector.CORR = 1;
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * Implementations of this class can, given locations of finder patterns for a QR code in an
     * image, sample the right points in the image to reconstruct the QR code, accounting for
     * perspective distortion. It is abstracted since it is relatively expensive and should be allowed
     * to take advantage of platform-specific optimized implementations, like Sun's Java Advanced
     * Imaging library, but which may not be available in other environments such as J2ME, and vice
     * versa.
     *
     * The implementation used can be controlled by calling {@link #setGridSampler(GridSampler)}
     * with an instance of a class which implements this interface.
     *
     * @author Sean Owen
     */ class GridSampler {
        /**
         * <p>Checks a set of points that have been transformed to sample points on an image against
         * the image's dimensions to see if the point are even within the image.</p>
         *
         * <p>This method will actually "nudge" the endpoints back onto the image if they are found to be
         * barely (less than 1 pixel) off the image. This accounts for imperfect detection of finder
         * patterns in an image where the QR Code runs all the way to the image border.</p>
         *
         * <p>For efficiency, the method will check points from either end of the line until one is found
         * to be within the image. Because the set of points are assumed to be linear, this is valid.</p>
         *
         * @param image image into which the points should map
         * @param points actual points in x1,y1,...,xn,yn form
         * @throws NotFoundException if an endpoint is lies outside the image boundaries
         */ static checkAndNudgePoints(image, points) {
            const width = image.getWidth();
            const height = image.getHeight();
            // Check and nudge points from start until we see some that are OK:
            let nudged = true;
            for(let offset = 0; offset < points.length && nudged; offset += 2){
                const x = Math.floor(points[offset]);
                const y = Math.floor(points[offset + 1]);
                if (x < -1 || x > width || y < -1 || y > height) throw new NotFoundException();
                nudged = false;
                if (x === -1) {
                    points[offset] = 0.0;
                    nudged = true;
                } else if (x === width) {
                    points[offset] = width - 1;
                    nudged = true;
                }
                if (y === -1) {
                    points[offset + 1] = 0.0;
                    nudged = true;
                } else if (y === height) {
                    points[offset + 1] = height - 1;
                    nudged = true;
                }
            }
            // Check and nudge points from end:
            nudged = true;
            for(let offset = points.length - 2; offset >= 0 && nudged; offset -= 2){
                const x = Math.floor(points[offset]);
                const y = Math.floor(points[offset + 1]);
                if (x < -1 || x > width || y < -1 || y > height) throw new NotFoundException();
                nudged = false;
                if (x === -1) {
                    points[offset] = 0.0;
                    nudged = true;
                } else if (x === width) {
                    points[offset] = width - 1;
                    nudged = true;
                }
                if (y === -1) {
                    points[offset + 1] = 0.0;
                    nudged = true;
                } else if (y === height) {
                    points[offset + 1] = height - 1;
                    nudged = true;
                }
            }
        }
    }
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /*namespace com.google.zxing.common {*/ /**
     * <p>This class implements a perspective transform in two dimensions. Given four source and four
     * destination points, it will compute the transformation implied between them. The code is based
     * directly upon section 3.4.2 of George Wolberg's "Digital Image Warping"; see pages 54-56.</p>
     *
     * @author Sean Owen
     */ class PerspectiveTransform {
        constructor(a11 /*float*/ , a21 /*float*/ , a31 /*float*/ , a12 /*float*/ , a22 /*float*/ , a32 /*float*/ , a13 /*float*/ , a23 /*float*/ , a33 /*float*/ ){
            this.a11 = a11;
            this.a21 = a21;
            this.a31 = a31;
            this.a12 = a12;
            this.a22 = a22;
            this.a32 = a32;
            this.a13 = a13;
            this.a23 = a23;
            this.a33 = a33;
        }
        static quadrilateralToQuadrilateral(x0 /*float*/ , y0 /*float*/ , x1 /*float*/ , y1 /*float*/ , x2 /*float*/ , y2 /*float*/ , x3 /*float*/ , y3 /*float*/ , x0p /*float*/ , y0p /*float*/ , x1p /*float*/ , y1p /*float*/ , x2p /*float*/ , y2p /*float*/ , x3p /*float*/ , y3p /*float*/ ) {
            const qToS = PerspectiveTransform.quadrilateralToSquare(x0, y0, x1, y1, x2, y2, x3, y3);
            const sToQ = PerspectiveTransform.squareToQuadrilateral(x0p, y0p, x1p, y1p, x2p, y2p, x3p, y3p);
            return sToQ.times(qToS);
        }
        transformPoints(points) {
            const max = points.length;
            const a11 = this.a11;
            const a12 = this.a12;
            const a13 = this.a13;
            const a21 = this.a21;
            const a22 = this.a22;
            const a23 = this.a23;
            const a31 = this.a31;
            const a32 = this.a32;
            const a33 = this.a33;
            for(let i = 0; i < max; i += 2){
                const x = points[i];
                const y = points[i + 1];
                const denominator = a13 * x + a23 * y + a33;
                points[i] = (a11 * x + a21 * y + a31) / denominator;
                points[i + 1] = (a12 * x + a22 * y + a32) / denominator;
            }
        }
        transformPointsWithValues(xValues, yValues) {
            const a11 = this.a11;
            const a12 = this.a12;
            const a13 = this.a13;
            const a21 = this.a21;
            const a22 = this.a22;
            const a23 = this.a23;
            const a31 = this.a31;
            const a32 = this.a32;
            const a33 = this.a33;
            const n = xValues.length;
            for(let i = 0; i < n; i++){
                const x = xValues[i];
                const y = yValues[i];
                const denominator = a13 * x + a23 * y + a33;
                xValues[i] = (a11 * x + a21 * y + a31) / denominator;
                yValues[i] = (a12 * x + a22 * y + a32) / denominator;
            }
        }
        static squareToQuadrilateral(x0 /*float*/ , y0 /*float*/ , x1 /*float*/ , y1 /*float*/ , x2 /*float*/ , y2 /*float*/ , x3 /*float*/ , y3 /*float*/ ) {
            const dx3 = x0 - x1 + x2 - x3;
            const dy3 = y0 - y1 + y2 - y3;
            if (dx3 === 0.0 && dy3 === 0.0) // Affine
            return new PerspectiveTransform(x1 - x0, x2 - x1, x0, y1 - y0, y2 - y1, y0, 0.0, 0.0, 1.0);
            else {
                const dx1 = x1 - x2;
                const dx2 = x3 - x2;
                const dy1 = y1 - y2;
                const dy2 = y3 - y2;
                const denominator = dx1 * dy2 - dx2 * dy1;
                const a13 = (dx3 * dy2 - dx2 * dy3) / denominator;
                const a23 = (dx1 * dy3 - dx3 * dy1) / denominator;
                return new PerspectiveTransform(x1 - x0 + a13 * x1, x3 - x0 + a23 * x3, x0, y1 - y0 + a13 * y1, y3 - y0 + a23 * y3, y0, a13, a23, 1.0);
            }
        }
        static quadrilateralToSquare(x0 /*float*/ , y0 /*float*/ , x1 /*float*/ , y1 /*float*/ , x2 /*float*/ , y2 /*float*/ , x3 /*float*/ , y3 /*float*/ ) {
            // Here, the adjoint serves as the inverse:
            return PerspectiveTransform.squareToQuadrilateral(x0, y0, x1, y1, x2, y2, x3, y3).buildAdjoint();
        }
        buildAdjoint() {
            // Adjoint is the transpose of the cofactor matrix:
            return new PerspectiveTransform(this.a22 * this.a33 - this.a23 * this.a32, this.a23 * this.a31 - this.a21 * this.a33, this.a21 * this.a32 - this.a22 * this.a31, this.a13 * this.a32 - this.a12 * this.a33, this.a11 * this.a33 - this.a13 * this.a31, this.a12 * this.a31 - this.a11 * this.a32, this.a12 * this.a23 - this.a13 * this.a22, this.a13 * this.a21 - this.a11 * this.a23, this.a11 * this.a22 - this.a12 * this.a21);
        }
        times(other) {
            return new PerspectiveTransform(this.a11 * other.a11 + this.a21 * other.a12 + this.a31 * other.a13, this.a11 * other.a21 + this.a21 * other.a22 + this.a31 * other.a23, this.a11 * other.a31 + this.a21 * other.a32 + this.a31 * other.a33, this.a12 * other.a11 + this.a22 * other.a12 + this.a32 * other.a13, this.a12 * other.a21 + this.a22 * other.a22 + this.a32 * other.a23, this.a12 * other.a31 + this.a22 * other.a32 + this.a32 * other.a33, this.a13 * other.a11 + this.a23 * other.a12 + this.a33 * other.a13, this.a13 * other.a21 + this.a23 * other.a22 + this.a33 * other.a23, this.a13 * other.a31 + this.a23 * other.a32 + this.a33 * other.a33);
        }
    }
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * @author Sean Owen
     */ class DefaultGridSampler extends GridSampler {
        /*@Override*/ sampleGrid(image, dimensionX /*int*/ , dimensionY /*int*/ , p1ToX /*float*/ , p1ToY /*float*/ , p2ToX /*float*/ , p2ToY /*float*/ , p3ToX /*float*/ , p3ToY /*float*/ , p4ToX /*float*/ , p4ToY /*float*/ , p1FromX /*float*/ , p1FromY /*float*/ , p2FromX /*float*/ , p2FromY /*float*/ , p3FromX /*float*/ , p3FromY /*float*/ , p4FromX /*float*/ , p4FromY /*float*/ ) {
            const transform = PerspectiveTransform.quadrilateralToQuadrilateral(p1ToX, p1ToY, p2ToX, p2ToY, p3ToX, p3ToY, p4ToX, p4ToY, p1FromX, p1FromY, p2FromX, p2FromY, p3FromX, p3FromY, p4FromX, p4FromY);
            return this.sampleGridWithTransform(image, dimensionX, dimensionY, transform);
        }
        /*@Override*/ sampleGridWithTransform(image, dimensionX /*int*/ , dimensionY /*int*/ , transform) {
            if (dimensionX <= 0 || dimensionY <= 0) throw new NotFoundException();
            const bits = new BitMatrix(dimensionX, dimensionY);
            const points = new Float32Array(2 * dimensionX);
            for(let y = 0; y < dimensionY; y++){
                const max = points.length;
                const iValue = y + 0.5;
                for(let x = 0; x < max; x += 2){
                    points[x] = x / 2 + 0.5;
                    points[x + 1] = iValue;
                }
                transform.transformPoints(points);
                // Quick check to see if points transformed to something inside the image
                // sufficient to check the endpoints
                GridSampler.checkAndNudgePoints(image, points);
                try {
                    for(let x = 0; x < max; x += 2)if (image.get(Math.floor(points[x]), Math.floor(points[x + 1]))) // Black(-ish) pixel
                    bits.set(x / 2, y);
                } catch (aioobe /*: ArrayIndexOutOfBoundsException*/ ) {
                    // This feels wrong, but, sometimes if the finder patterns are misidentified, the resulting
                    // transform gets "twisted" such that it maps a straight line of points to a set of points
                    // whose endpoints are in bounds, but others are not. There is probably some mathematical
                    // way to detect this about the transformation that I don't know yet.
                    // This results in an ugly runtime exception despite our clever checks above -- can't have
                    // that. We could check each point's coordinates but that feels duplicative. We settle for
                    // catching and wrapping ArrayIndexOutOfBoundsException.
                    throw new NotFoundException();
                }
            }
            return bits;
        }
    }
    class GridSamplerInstance {
        /**
         * Sets the implementation of GridSampler used by the library. One global
         * instance is stored, which may sound problematic. But, the implementation provided
         * ought to be appropriate for the entire platform, and all uses of this library
         * in the whole lifetime of the JVM. For instance, an Android activity can swap in
         * an implementation that takes advantage of native platform libraries.
         *
         * @param newGridSampler The platform-specific object to install.
         */ static setGridSampler(newGridSampler) {
            GridSamplerInstance.gridSampler = newGridSampler;
        }
        /**
         * @return the current implementation of GridSampler
         */ static getInstance() {
            return GridSamplerInstance.gridSampler;
        }
    }
    GridSamplerInstance.gridSampler = new DefaultGridSampler();
    /*
     * Copyright 2010 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ class Point {
        constructor(x, y){
            this.x = x;
            this.y = y;
        }
        toResultPoint() {
            return new ResultPoint(this.getX(), this.getY());
        }
        getX() {
            return this.x;
        }
        getY() {
            return this.y;
        }
    }
    /**
     * Encapsulates logic that can detect an Aztec Code in an image, even if the Aztec Code
     * is rotated or skewed, or partially obscured.
     *
     * @author David Olivier
     * @author Frank Yellin
     */ class Detector {
        constructor(image){
            this.EXPECTED_CORNER_BITS = new Int32Array([
                0xee0,
                0x1dc,
                0x83b,
                0x707
            ]);
            this.image = image;
        }
        detect() {
            return this.detectMirror(false);
        }
        /**
         * Detects an Aztec Code in an image.
         *
         * @param isMirror if true, image is a mirror-image of original
         * @return {@link AztecDetectorResult} encapsulating results of detecting an Aztec Code
         * @throws NotFoundException if no Aztec Code can be found
         */ detectMirror(isMirror) {
            // 1. Get the center of the aztec matrix
            let pCenter = this.getMatrixCenter();
            // 2. Get the center points of the four diagonal points just outside the bull's eye
            //  [topRight, bottomRight, bottomLeft, topLeft]
            let bullsEyeCorners = this.getBullsEyeCorners(pCenter);
            if (isMirror) {
                let temp = bullsEyeCorners[0];
                bullsEyeCorners[0] = bullsEyeCorners[2];
                bullsEyeCorners[2] = temp;
            }
            // 3. Get the size of the matrix and other parameters from the bull's eye
            this.extractParameters(bullsEyeCorners);
            // 4. Sample the grid
            let bits = this.sampleGrid(this.image, bullsEyeCorners[this.shift % 4], bullsEyeCorners[(this.shift + 1) % 4], bullsEyeCorners[(this.shift + 2) % 4], bullsEyeCorners[(this.shift + 3) % 4]);
            // 5. Get the corners of the matrix.
            let corners = this.getMatrixCornerPoints(bullsEyeCorners);
            return new AztecDetectorResult(bits, corners, this.compact, this.nbDataBlocks, this.nbLayers);
        }
        /**
         * Extracts the number of data layers and data blocks from the layer around the bull's eye.
         *
         * @param bullsEyeCorners the array of bull's eye corners
         * @throws NotFoundException in case of too many errors or invalid parameters
         */ extractParameters(bullsEyeCorners) {
            if (!this.isValidPoint(bullsEyeCorners[0]) || !this.isValidPoint(bullsEyeCorners[1]) || !this.isValidPoint(bullsEyeCorners[2]) || !this.isValidPoint(bullsEyeCorners[3])) throw new NotFoundException();
            let length = 2 * this.nbCenterLayers;
            // Get the bits around the bull's eye
            let sides = new Int32Array([
                this.sampleLine(bullsEyeCorners[0], bullsEyeCorners[1], length),
                this.sampleLine(bullsEyeCorners[1], bullsEyeCorners[2], length),
                this.sampleLine(bullsEyeCorners[2], bullsEyeCorners[3], length),
                this.sampleLine(bullsEyeCorners[3], bullsEyeCorners[0], length) // Top
            ]);
            // bullsEyeCorners[shift] is the corner of the bulls'eye that has three
            // orientation marks.
            // sides[shift] is the row/column that goes from the corner with three
            // orientation marks to the corner with two.
            this.shift = this.getRotation(sides, length);
            // Flatten the parameter bits into a single 28- or 40-bit long
            let parameterData = 0;
            for(let i = 0; i < 4; i++){
                let side = sides[(this.shift + i) % 4];
                if (this.compact) {
                    // Each side of the form ..XXXXXXX. where Xs are parameter data
                    parameterData <<= 7;
                    parameterData += side >> 1 & 0x7F;
                } else {
                    // Each side of the form ..XXXXX.XXXXX. where Xs are parameter data
                    parameterData <<= 10;
                    parameterData += (side >> 2 & 992) + (side >> 1 & 0x1F);
                }
            }
            // Corrects parameter data using RS.  Returns just the data portion
            // without the error correction.
            let correctedData = this.getCorrectedParameterData(parameterData, this.compact);
            if (this.compact) {
                // 8 bits:  2 bits layers and 6 bits data blocks
                this.nbLayers = (correctedData >> 6) + 1;
                this.nbDataBlocks = (correctedData & 0x3F) + 1;
            } else {
                // 16 bits:  5 bits layers and 11 bits data blocks
                this.nbLayers = (correctedData >> 11) + 1;
                this.nbDataBlocks = (correctedData & 0x7FF) + 1;
            }
        }
        getRotation(sides, length) {
            // In a normal pattern, we expect to See
            //   **    .*             D       A
            //   *      *
            //
            //   .      *
            //   ..    ..             C       B
            //
            // Grab the 3 bits from each of the sides the form the locator pattern and concatenate
            // into a 12-bit integer.  Start with the bit at A
            let cornerBits = 0;
            sides.forEach((side, idx, arr)=>{
                // XX......X where X's are orientation marks
                let t = (side >> length - 2 << 1) + (side & 1);
                cornerBits = (cornerBits << 3) + t;
            });
            // for (var side in sides) {
            //     // XX......X where X's are orientation marks
            //     var t = ((side >> (length - 2)) << 1) + (side & 1);
            //     cornerBits = (cornerBits << 3) + t;
            // }
            // Mov the bottom bit to the top, so that the three bits of the locator pattern at A are
            // together.  cornerBits is now:
            //  3 orientation bits at A || 3 orientation bits at B || ... || 3 orientation bits at D
            cornerBits = ((cornerBits & 1) << 11) + (cornerBits >> 1);
            // The result shift indicates which element of BullsEyeCorners[] goes into the top-left
            // corner. Since the four rotation values have a Hamming distance of 8, we
            // can easily tolerate two errors.
            for(let shift = 0; shift < 4; shift++){
                if (Integer.bitCount(cornerBits ^ this.EXPECTED_CORNER_BITS[shift]) <= 2) return shift;
            }
            throw new NotFoundException();
        }
        /**
         * Corrects the parameter bits using Reed-Solomon algorithm.
         *
         * @param parameterData parameter bits
         * @param compact true if this is a compact Aztec code
         * @throws NotFoundException if the array contains too many errors
         */ getCorrectedParameterData(parameterData, compact) {
            let numCodewords;
            let numDataCodewords;
            if (compact) {
                numCodewords = 7;
                numDataCodewords = 2;
            } else {
                numCodewords = 10;
                numDataCodewords = 4;
            }
            let numECCodewords = numCodewords - numDataCodewords;
            let parameterWords = new Int32Array(numCodewords);
            for(let i = numCodewords - 1; i >= 0; --i){
                parameterWords[i] = parameterData & 0xF;
                parameterData >>= 4;
            }
            try {
                let rsDecoder = new ReedSolomonDecoder(GenericGF.AZTEC_PARAM);
                rsDecoder.decode(parameterWords, numECCodewords);
            } catch (ignored) {
                throw new NotFoundException();
            }
            // Toss the error correction.  Just return the data as an integer
            let result = 0;
            for(let i = 0; i < numDataCodewords; i++)result = (result << 4) + parameterWords[i];
            return result;
        }
        /**
         * Finds the corners of a bull-eye centered on the passed point.
         * This returns the centers of the diagonal points just outside the bull's eye
         * Returns [topRight, bottomRight, bottomLeft, topLeft]
         *
         * @param pCenter Center point
         * @return The corners of the bull-eye
         * @throws NotFoundException If no valid bull-eye can be found
         */ getBullsEyeCorners(pCenter) {
            let pina = pCenter;
            let pinb = pCenter;
            let pinc = pCenter;
            let pind = pCenter;
            let color = true;
            for(this.nbCenterLayers = 1; this.nbCenterLayers < 9; this.nbCenterLayers++){
                let pouta = this.getFirstDifferent(pina, color, 1, -1);
                let poutb = this.getFirstDifferent(pinb, color, 1, 1);
                let poutc = this.getFirstDifferent(pinc, color, -1, 1);
                let poutd = this.getFirstDifferent(pind, color, -1, -1);
                // d      a
                //
                // c      b
                if (this.nbCenterLayers > 2) {
                    let q = this.distancePoint(poutd, pouta) * this.nbCenterLayers / (this.distancePoint(pind, pina) * (this.nbCenterLayers + 2));
                    if (q < 0.75 || q > 1.25 || !this.isWhiteOrBlackRectangle(pouta, poutb, poutc, poutd)) break;
                }
                pina = pouta;
                pinb = poutb;
                pinc = poutc;
                pind = poutd;
                color = !color;
            }
            if (this.nbCenterLayers !== 5 && this.nbCenterLayers !== 7) throw new NotFoundException();
            this.compact = this.nbCenterLayers === 5;
            // Expand the square by .5 pixel in each direction so that we're on the border
            // between the white square and the black square
            let pinax = new ResultPoint(pina.getX() + 0.5, pina.getY() - 0.5);
            let pinbx = new ResultPoint(pinb.getX() + 0.5, pinb.getY() + 0.5);
            let pincx = new ResultPoint(pinc.getX() - 0.5, pinc.getY() + 0.5);
            let pindx = new ResultPoint(pind.getX() - 0.5, pind.getY() - 0.5);
            // Expand the square so that its corners are the centers of the points
            // just outside the bull's eye.
            return this.expandSquare([
                pinax,
                pinbx,
                pincx,
                pindx
            ], 2 * this.nbCenterLayers - 3, 2 * this.nbCenterLayers);
        }
        /**
         * Finds a candidate center point of an Aztec code from an image
         *
         * @return the center point
         */ getMatrixCenter() {
            let pointA;
            let pointB;
            let pointC;
            let pointD;
            // Get a white rectangle that can be the border of the matrix in center bull's eye or
            try {
                let cornerPoints = new WhiteRectangleDetector(this.image).detect();
                pointA = cornerPoints[0];
                pointB = cornerPoints[1];
                pointC = cornerPoints[2];
                pointD = cornerPoints[3];
            } catch (e) {
                // This exception can be in case the initial rectangle is white
                // In that case, surely in the bull's eye, we try to expand the rectangle.
                let cx = this.image.getWidth() / 2;
                let cy = this.image.getHeight() / 2;
                pointA = this.getFirstDifferent(new Point(cx + 7, cy - 7), false, 1, -1).toResultPoint();
                pointB = this.getFirstDifferent(new Point(cx + 7, cy + 7), false, 1, 1).toResultPoint();
                pointC = this.getFirstDifferent(new Point(cx - 7, cy + 7), false, -1, 1).toResultPoint();
                pointD = this.getFirstDifferent(new Point(cx - 7, cy - 7), false, -1, -1).toResultPoint();
            }
            // Compute the center of the rectangle
            let cx = MathUtils.round((pointA.getX() + pointD.getX() + pointB.getX() + pointC.getX()) / 4.0);
            let cy = MathUtils.round((pointA.getY() + pointD.getY() + pointB.getY() + pointC.getY()) / 4.0);
            // Redetermine the white rectangle starting from previously computed center.
            // This will ensure that we end up with a white rectangle in center bull's eye
            // in order to compute a more accurate center.
            try {
                let cornerPoints = new WhiteRectangleDetector(this.image, 15, cx, cy).detect();
                pointA = cornerPoints[0];
                pointB = cornerPoints[1];
                pointC = cornerPoints[2];
                pointD = cornerPoints[3];
            } catch (e) {
                // This exception can be in case the initial rectangle is white
                // In that case we try to expand the rectangle.
                pointA = this.getFirstDifferent(new Point(cx + 7, cy - 7), false, 1, -1).toResultPoint();
                pointB = this.getFirstDifferent(new Point(cx + 7, cy + 7), false, 1, 1).toResultPoint();
                pointC = this.getFirstDifferent(new Point(cx - 7, cy + 7), false, -1, 1).toResultPoint();
                pointD = this.getFirstDifferent(new Point(cx - 7, cy - 7), false, -1, -1).toResultPoint();
            }
            // Recompute the center of the rectangle
            cx = MathUtils.round((pointA.getX() + pointD.getX() + pointB.getX() + pointC.getX()) / 4.0);
            cy = MathUtils.round((pointA.getY() + pointD.getY() + pointB.getY() + pointC.getY()) / 4.0);
            return new Point(cx, cy);
        }
        /**
         * Gets the Aztec code corners from the bull's eye corners and the parameters.
         *
         * @param bullsEyeCorners the array of bull's eye corners
         * @return the array of aztec code corners
         */ getMatrixCornerPoints(bullsEyeCorners) {
            return this.expandSquare(bullsEyeCorners, 2 * this.nbCenterLayers, this.getDimension());
        }
        /**
         * Creates a BitMatrix by sampling the provided image.
         * topLeft, topRight, bottomRight, and bottomLeft are the centers of the squares on the
         * diagonal just outside the bull's eye.
         */ sampleGrid(image, topLeft, topRight, bottomRight, bottomLeft) {
            let sampler = GridSamplerInstance.getInstance();
            let dimension = this.getDimension();
            let low = dimension / 2 - this.nbCenterLayers;
            let high = dimension / 2 + this.nbCenterLayers;
            return sampler.sampleGrid(image, dimension, dimension, low, low, high, low, high, high, low, high, topLeft.getX(), topLeft.getY(), topRight.getX(), topRight.getY(), bottomRight.getX(), bottomRight.getY(), bottomLeft.getX(), bottomLeft.getY());
        }
        /**
         * Samples a line.
         *
         * @param p1   start point (inclusive)
         * @param p2   end point (exclusive)
         * @param size number of bits
         * @return the array of bits as an int (first bit is high-order bit of result)
         */ sampleLine(p1, p2, size) {
            let result = 0;
            let d = this.distanceResultPoint(p1, p2);
            let moduleSize = d / size;
            let px = p1.getX();
            let py = p1.getY();
            let dx = moduleSize * (p2.getX() - p1.getX()) / d;
            let dy = moduleSize * (p2.getY() - p1.getY()) / d;
            for(let i = 0; i < size; i++)if (this.image.get(MathUtils.round(px + i * dx), MathUtils.round(py + i * dy))) result |= 1 << size - i - 1;
            return result;
        }
        /**
         * @return true if the border of the rectangle passed in parameter is compound of white points only
         *         or black points only
         */ isWhiteOrBlackRectangle(p1, p2, p3, p4) {
            let corr = 3;
            p1 = new Point(p1.getX() - corr, p1.getY() + corr);
            p2 = new Point(p2.getX() - corr, p2.getY() - corr);
            p3 = new Point(p3.getX() + corr, p3.getY() - corr);
            p4 = new Point(p4.getX() + corr, p4.getY() + corr);
            let cInit = this.getColor(p4, p1);
            if (cInit === 0) return false;
            let c = this.getColor(p1, p2);
            if (c !== cInit) return false;
            c = this.getColor(p2, p3);
            if (c !== cInit) return false;
            c = this.getColor(p3, p4);
            return c === cInit;
        }
        /**
         * Gets the color of a segment
         *
         * @return 1 if segment more than 90% black, -1 if segment is more than 90% white, 0 else
         */ getColor(p1, p2) {
            let d = this.distancePoint(p1, p2);
            let dx = (p2.getX() - p1.getX()) / d;
            let dy = (p2.getY() - p1.getY()) / d;
            let error = 0;
            let px = p1.getX();
            let py = p1.getY();
            let colorModel = this.image.get(p1.getX(), p1.getY());
            let iMax = Math.ceil(d);
            for(let i = 0; i < iMax; i++){
                px += dx;
                py += dy;
                if (this.image.get(MathUtils.round(px), MathUtils.round(py)) !== colorModel) error++;
            }
            let errRatio = error / d;
            if (errRatio > 0.1 && errRatio < 0.9) return 0;
            return errRatio <= 0.1 === colorModel ? 1 : -1;
        }
        /**
         * Gets the coordinate of the first point with a different color in the given direction
         */ getFirstDifferent(init, color, dx, dy) {
            let x = init.getX() + dx;
            let y = init.getY() + dy;
            while(this.isValid(x, y) && this.image.get(x, y) === color){
                x += dx;
                y += dy;
            }
            x -= dx;
            y -= dy;
            while(this.isValid(x, y) && this.image.get(x, y) === color)x += dx;
            x -= dx;
            while(this.isValid(x, y) && this.image.get(x, y) === color)y += dy;
            y -= dy;
            return new Point(x, y);
        }
        /**
         * Expand the square represented by the corner points by pushing out equally in all directions
         *
         * @param cornerPoints the corners of the square, which has the bull's eye at its center
         * @param oldSide the original length of the side of the square in the target bit matrix
         * @param newSide the new length of the size of the square in the target bit matrix
         * @return the corners of the expanded square
         */ expandSquare(cornerPoints, oldSide, newSide) {
            let ratio = newSide / (2.0 * oldSide);
            let dx = cornerPoints[0].getX() - cornerPoints[2].getX();
            let dy = cornerPoints[0].getY() - cornerPoints[2].getY();
            let centerx = (cornerPoints[0].getX() + cornerPoints[2].getX()) / 2.0;
            let centery = (cornerPoints[0].getY() + cornerPoints[2].getY()) / 2.0;
            let result0 = new ResultPoint(centerx + ratio * dx, centery + ratio * dy);
            let result2 = new ResultPoint(centerx - ratio * dx, centery - ratio * dy);
            dx = cornerPoints[1].getX() - cornerPoints[3].getX();
            dy = cornerPoints[1].getY() - cornerPoints[3].getY();
            centerx = (cornerPoints[1].getX() + cornerPoints[3].getX()) / 2.0;
            centery = (cornerPoints[1].getY() + cornerPoints[3].getY()) / 2.0;
            let result1 = new ResultPoint(centerx + ratio * dx, centery + ratio * dy);
            let result3 = new ResultPoint(centerx - ratio * dx, centery - ratio * dy);
            let results = [
                result0,
                result1,
                result2,
                result3
            ];
            return results;
        }
        isValid(x, y) {
            return x >= 0 && x < this.image.getWidth() && y > 0 && y < this.image.getHeight();
        }
        isValidPoint(point) {
            let x = MathUtils.round(point.getX());
            let y = MathUtils.round(point.getY());
            return this.isValid(x, y);
        }
        distancePoint(a, b) {
            return MathUtils.distance(a.getX(), a.getY(), b.getX(), b.getY());
        }
        distanceResultPoint(a, b) {
            return MathUtils.distance(a.getX(), a.getY(), b.getX(), b.getY());
        }
        getDimension() {
            if (this.compact) return 4 * this.nbLayers + 11;
            if (this.nbLayers <= 4) return 4 * this.nbLayers + 15;
            return 4 * this.nbLayers + 2 * (Integer.truncDivision(this.nbLayers - 4, 8) + 1) + 15;
        }
    }
    /*
     * Copyright 2010 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ // import java.util.List;
    // import java.util.Map;
    /**
     * This implementation can detect and decode Aztec codes in an image.
     *
     * @author David Olivier
     */ class AztecReader {
        /**
         * Locates and decodes a Data Matrix code in an image.
         *
         * @return a String representing the content encoded by the Data Matrix code
         * @throws NotFoundException if a Data Matrix code cannot be found
         * @throws FormatException if a Data Matrix code cannot be decoded
         */ decode(image, hints = null) {
            let exception = null;
            let detector = new Detector(image.getBlackMatrix());
            let points = null;
            let decoderResult = null;
            try {
                let detectorResult = detector.detectMirror(false);
                points = detectorResult.getPoints();
                this.reportFoundResultPoints(hints, points);
                decoderResult = new Decoder().decode(detectorResult);
            } catch (e) {
                exception = e;
            }
            if (decoderResult == null) try {
                let detectorResult = detector.detectMirror(true);
                points = detectorResult.getPoints();
                this.reportFoundResultPoints(hints, points);
                decoderResult = new Decoder().decode(detectorResult);
            } catch (e) {
                if (exception != null) throw exception;
                throw e;
            }
            let result = new Result(decoderResult.getText(), decoderResult.getRawBytes(), decoderResult.getNumBits(), points, BarcodeFormat$1.AZTEC, System.currentTimeMillis());
            let byteSegments = decoderResult.getByteSegments();
            if (byteSegments != null) result.putMetadata(ResultMetadataType$1.BYTE_SEGMENTS, byteSegments);
            let ecLevel = decoderResult.getECLevel();
            if (ecLevel != null) result.putMetadata(ResultMetadataType$1.ERROR_CORRECTION_LEVEL, ecLevel);
            return result;
        }
        reportFoundResultPoints(hints, points) {
            if (hints != null) {
                let rpcb = hints.get(DecodeHintType$1.NEED_RESULT_POINT_CALLBACK);
                if (rpcb != null) points.forEach((point, idx, arr)=>{
                    rpcb.foundPossibleResultPoint(point);
                });
            }
        }
        // @Override
        reset() {
        // do nothing
        }
    }
    /**
     * Aztec Code reader to use from browser.
     *
     * @class BrowserAztecCodeReader
     * @extends {BrowserCodeReader}
     */ class BrowserAztecCodeReader extends BrowserCodeReader {
        /**
         * Creates an instance of BrowserAztecCodeReader.
         * @param {number} [timeBetweenScansMillis=500] the time delay between subsequent decode tries
         *
         * @memberOf BrowserAztecCodeReader
         */ constructor(timeBetweenScansMillis = 500){
            super(new AztecReader(), timeBetweenScansMillis);
        }
    }
    /**
     * Encapsulates functionality and implementation that is common to all families
     * of one-dimensional barcodes.
     *
     * @author dswitkin@google.com (Daniel Switkin)
     * @author Sean Owen
     */ class OneDReader {
        /*
        @Override
        public Result decode(BinaryBitmap image) throws NotFoundException, FormatException {
          return decode(image, null);
        }
        */ // Note that we don't try rotation without the try harder flag, even if rotation was supported.
        // @Override
        decode(image, hints) {
            try {
                return this.doDecode(image, hints);
            } catch (nfe) {
                const tryHarder = hints && hints.get(DecodeHintType$1.TRY_HARDER) === true;
                if (tryHarder && image.isRotateSupported()) {
                    const rotatedImage = image.rotateCounterClockwise();
                    const result = this.doDecode(rotatedImage, hints);
                    // Record that we found it rotated 90 degrees CCW / 270 degrees CW
                    const metadata = result.getResultMetadata();
                    let orientation = 270;
                    if (metadata !== null && metadata.get(ResultMetadataType$1.ORIENTATION) === true) // But if we found it reversed in doDecode(), add in that result here:
                    orientation = orientation + metadata.get(ResultMetadataType$1.ORIENTATION) % 360;
                    result.putMetadata(ResultMetadataType$1.ORIENTATION, orientation);
                    // Update result points
                    const points = result.getResultPoints();
                    if (points !== null) {
                        const height = rotatedImage.getHeight();
                        for(let i = 0; i < points.length; i++)points[i] = new ResultPoint(height - points[i].getY() - 1, points[i].getX());
                    }
                    return result;
                } else throw new NotFoundException();
            }
        }
        // @Override
        reset() {
        // do nothing
        }
        /**
         * We're going to examine rows from the middle outward, searching alternately above and below the
         * middle, and farther out each time. rowStep is the number of rows between each successive
         * attempt above and below the middle. So we'd scan row middle, then middle - rowStep, then
         * middle + rowStep, then middle - (2 * rowStep), etc.
         * rowStep is bigger as the image is taller, but is always at least 1. We've somewhat arbitrarily
         * decided that moving up and down by about 1/16 of the image is pretty good; we try more of the
         * image if "trying harder".
         *
         * @param image The image to decode
         * @param hints Any hints that were requested
         * @return The contents of the decoded barcode
         * @throws NotFoundException Any spontaneous errors which occur
         */ doDecode(image, hints) {
            const width = image.getWidth();
            const height = image.getHeight();
            let row = new BitArray(width);
            const tryHarder = hints && hints.get(DecodeHintType$1.TRY_HARDER) === true;
            const rowStep = Math.max(1, height >> (tryHarder ? 8 : 5));
            let maxLines;
            if (tryHarder) maxLines = height; // Look at the whole image, not just the center
            else maxLines = 15; // 15 rows spaced 1/32 apart is roughly the middle half of the image
            const middle = Math.trunc(height / 2);
            for(let x = 0; x < maxLines; x++){
                // Scanning from the middle out. Determine which row we're looking at next:
                const rowStepsAboveOrBelow = Math.trunc((x + 1) / 2);
                const isAbove = (x & 0x01) === 0; // i.e. is x even?
                const rowNumber = middle + rowStep * (isAbove ? rowStepsAboveOrBelow : -rowStepsAboveOrBelow);
                if (rowNumber < 0 || rowNumber >= height) break;
                // Estimate black point for this row and load it:
                try {
                    row = image.getBlackRow(rowNumber, row);
                } catch (ignored) {
                    continue;
                }
                // While we have the image data in a BitArray, it's fairly cheap to reverse it in place to
                // handle decoding upside down barcodes.
                for(let attempt = 0; attempt < 2; attempt++){
                    if (attempt === 1) {
                        row.reverse(); // reverse the row and continue
                        // This means we will only ever draw result points *once* in the life of this method
                        // since we want to avoid drawing the wrong points after flipping the row, and,
                        // don't want to clutter with noise from every single row scan -- just the scans
                        // that start on the center line.
                        if (hints && hints.get(DecodeHintType$1.NEED_RESULT_POINT_CALLBACK) === true) {
                            const newHints = new Map();
                            hints.forEach((hint, key)=>newHints.set(key, hint));
                            newHints.delete(DecodeHintType$1.NEED_RESULT_POINT_CALLBACK);
                            hints = newHints;
                        }
                    }
                    try {
                        // Look for a barcode
                        const result = this.decodeRow(rowNumber, row, hints);
                        // We found our barcode
                        if (attempt === 1) {
                            // But it was upside down, so note that
                            result.putMetadata(ResultMetadataType$1.ORIENTATION, 180);
                            // And remember to flip the result points horizontally.
                            const points = result.getResultPoints();
                            if (points !== null) {
                                points[0] = new ResultPoint(width - points[0].getX() - 1, points[0].getY());
                                points[1] = new ResultPoint(width - points[1].getX() - 1, points[1].getY());
                            }
                        }
                        return result;
                    } catch (re) {
                    // continue -- just couldn't decode this row
                    }
                }
            }
            throw new NotFoundException();
        }
        /**
         * Records the size of successive runs of white and black pixels in a row, starting at a given point.
         * The values are recorded in the given array, and the number of runs recorded is equal to the size
         * of the array. If the row starts on a white pixel at the given start point, then the first count
         * recorded is the run of white pixels starting from that point; likewise it is the count of a run
         * of black pixels if the row begin on a black pixels at that point.
         *
         * @param row row to count from
         * @param start offset into row to start at
         * @param counters array into which to record counts
         * @throws NotFoundException if counters cannot be filled entirely from row before running out
         *  of pixels
         */ static recordPattern(row, start, counters) {
            const numCounters = counters.length;
            for(let index = 0; index < numCounters; index++)counters[index] = 0;
            const end = row.getSize();
            if (start >= end) throw new NotFoundException();
            let isWhite = !row.get(start);
            let counterPosition = 0;
            let i = start;
            while(i < end){
                if (row.get(i) !== isWhite) counters[counterPosition]++;
                else {
                    if (++counterPosition === numCounters) break;
                    else {
                        counters[counterPosition] = 1;
                        isWhite = !isWhite;
                    }
                }
                i++;
            }
            // If we read fully the last section of pixels and filled up our counters -- or filled
            // the last counter but ran off the side of the image, OK. Otherwise, a problem.
            if (!(counterPosition === numCounters || counterPosition === numCounters - 1 && i === end)) throw new NotFoundException();
        }
        static recordPatternInReverse(row, start, counters) {
            // This could be more efficient I guess
            let numTransitionsLeft = counters.length;
            let last = row.get(start);
            while(start > 0 && numTransitionsLeft >= 0)if (row.get(--start) !== last) {
                numTransitionsLeft--;
                last = !last;
            }
            if (numTransitionsLeft >= 0) throw new NotFoundException();
            OneDReader.recordPattern(row, start + 1, counters);
        }
        /**
         * Determines how closely a set of observed counts of runs of black/white values matches a given
         * target pattern. This is reported as the ratio of the total variance from the expected pattern
         * proportions across all pattern elements, to the length of the pattern.
         *
         * @param counters observed counters
         * @param pattern expected pattern
         * @param maxIndividualVariance The most any counter can differ before we give up
         * @return ratio of total variance between counters and pattern compared to total pattern size
         */ static patternMatchVariance(counters, pattern, maxIndividualVariance) {
            const numCounters = counters.length;
            let total = 0;
            let patternLength = 0;
            for(let i = 0; i < numCounters; i++){
                total += counters[i];
                patternLength += pattern[i];
            }
            if (total < patternLength) // If we don't even have one pixel per unit of bar width, assume this is too small
            // to reliably match, so fail:
            return Number.POSITIVE_INFINITY;
            const unitBarWidth = total / patternLength;
            maxIndividualVariance *= unitBarWidth;
            let totalVariance = 0.0;
            for(let x = 0; x < numCounters; x++){
                const counter = counters[x];
                const scaledPattern = pattern[x] * unitBarWidth;
                const variance = counter > scaledPattern ? counter - scaledPattern : scaledPattern - counter;
                if (variance > maxIndividualVariance) return Number.POSITIVE_INFINITY;
                totalVariance += variance;
            }
            return totalVariance / total;
        }
    }
    /**
     * <p>Decodes Code 128 barcodes.</p>
     *
     * @author Sean Owen
     */ class Code128Reader extends OneDReader {
        static findStartPattern(row) {
            const width = row.getSize();
            const rowOffset = row.getNextSet(0);
            let counterPosition = 0;
            let counters = Int32Array.from([
                0,
                0,
                0,
                0,
                0,
                0
            ]);
            let patternStart = rowOffset;
            let isWhite = false;
            const patternLength = 6;
            for(let i = rowOffset; i < width; i++)if (row.get(i) !== isWhite) counters[counterPosition]++;
            else {
                if (counterPosition === patternLength - 1) {
                    let bestVariance = Code128Reader.MAX_AVG_VARIANCE;
                    let bestMatch = -1;
                    for(let startCode = Code128Reader.CODE_START_A; startCode <= Code128Reader.CODE_START_C; startCode++){
                        const variance = OneDReader.patternMatchVariance(counters, Code128Reader.CODE_PATTERNS[startCode], Code128Reader.MAX_INDIVIDUAL_VARIANCE);
                        if (variance < bestVariance) {
                            bestVariance = variance;
                            bestMatch = startCode;
                        }
                    }
                    // Look for whitespace before start pattern, >= 50% of width of start pattern
                    if (bestMatch >= 0 && row.isRange(Math.max(0, patternStart - (i - patternStart) / 2), patternStart, false)) return Int32Array.from([
                        patternStart,
                        i,
                        bestMatch
                    ]);
                    patternStart += counters[0] + counters[1];
                    counters = counters.slice(2, counters.length - 1);
                    counters[counterPosition - 1] = 0;
                    counters[counterPosition] = 0;
                    counterPosition--;
                } else counterPosition++;
                counters[counterPosition] = 1;
                isWhite = !isWhite;
            }
            throw new NotFoundException();
        }
        static decodeCode(row, counters, rowOffset) {
            OneDReader.recordPattern(row, rowOffset, counters);
            let bestVariance = Code128Reader.MAX_AVG_VARIANCE; // worst variance we'll accept
            let bestMatch = -1;
            for(let d = 0; d < Code128Reader.CODE_PATTERNS.length; d++){
                const pattern = Code128Reader.CODE_PATTERNS[d];
                const variance = this.patternMatchVariance(counters, pattern, Code128Reader.MAX_INDIVIDUAL_VARIANCE);
                if (variance < bestVariance) {
                    bestVariance = variance;
                    bestMatch = d;
                }
            }
            // TODO We're overlooking the fact that the STOP pattern has 7 values, not 6.
            if (bestMatch >= 0) return bestMatch;
            else throw new NotFoundException();
        }
        decodeRow(rowNumber, row, hints) {
            const convertFNC1 = hints && hints.get(DecodeHintType$1.ASSUME_GS1) === true;
            const startPatternInfo = Code128Reader.findStartPattern(row);
            const startCode = startPatternInfo[2];
            let currentRawCodesIndex = 0;
            const rawCodes = new Uint8Array(20);
            rawCodes[currentRawCodesIndex++] = startCode;
            let codeSet;
            switch(startCode){
                case Code128Reader.CODE_START_A:
                    codeSet = Code128Reader.CODE_CODE_A;
                    break;
                case Code128Reader.CODE_START_B:
                    codeSet = Code128Reader.CODE_CODE_B;
                    break;
                case Code128Reader.CODE_START_C:
                    codeSet = Code128Reader.CODE_CODE_C;
                    break;
                default:
                    throw new FormatException();
            }
            let done = false;
            let isNextShifted = false;
            let result = '';
            let lastStart = startPatternInfo[0];
            let nextStart = startPatternInfo[1];
            const counters = Int32Array.from([
                0,
                0,
                0,
                0,
                0,
                0
            ]);
            let lastCode = 0;
            let code = 0;
            let checksumTotal = startCode;
            let multiplier = 0;
            let lastCharacterWasPrintable = true;
            let upperMode = false;
            let shiftUpperMode = false;
            while(!done){
                const unshift = isNextShifted;
                isNextShifted = false;
                // Save off last code
                lastCode = code;
                // Decode another code from image
                code = Code128Reader.decodeCode(row, counters, nextStart);
                rawCodes[currentRawCodesIndex++] = code;
                // Remember whether the last code was printable or not (excluding CODE_STOP)
                if (code !== Code128Reader.CODE_STOP) lastCharacterWasPrintable = true;
                // Add to checksum computation (if not CODE_STOP of course)
                if (code !== Code128Reader.CODE_STOP) {
                    multiplier++;
                    checksumTotal += multiplier * code;
                }
                // Advance to where the next code will to start
                lastStart = nextStart;
                nextStart += counters.reduce((previous, current)=>previous + current, 0);
                // Take care of illegal start codes
                switch(code){
                    case Code128Reader.CODE_START_A:
                    case Code128Reader.CODE_START_B:
                    case Code128Reader.CODE_START_C:
                        throw new FormatException();
                }
                switch(codeSet){
                    case Code128Reader.CODE_CODE_A:
                        if (code < 64) {
                            if (shiftUpperMode === upperMode) result += String.fromCharCode(' '.charCodeAt(0) + code);
                            else result += String.fromCharCode(' '.charCodeAt(0) + code + 128);
                            shiftUpperMode = false;
                        } else if (code < 96) {
                            if (shiftUpperMode === upperMode) result += String.fromCharCode(code - 64);
                            else result += String.fromCharCode(code + 64);
                            shiftUpperMode = false;
                        } else {
                            // Don't let CODE_STOP, which always appears, affect whether whether we think the last
                            // code was printable or not.
                            if (code !== Code128Reader.CODE_STOP) lastCharacterWasPrintable = false;
                            switch(code){
                                case Code128Reader.CODE_FNC_1:
                                    if (convertFNC1) {
                                        if (result.length === 0) // GS1 specification 5.4.3.7. and 5.4.6.4. If the first char after the start code
                                        // is FNC1 then this is GS1-128. We add the symbology identifier.
                                        result += ']C1';
                                        else // GS1 specification 5.4.7.5. Every subsequent FNC1 is returned as ASCII 29 (GS)
                                        result += String.fromCharCode(29);
                                    }
                                    break;
                                case Code128Reader.CODE_FNC_2:
                                case Code128Reader.CODE_FNC_3:
                                    break;
                                case Code128Reader.CODE_FNC_4_A:
                                    if (!upperMode && shiftUpperMode) {
                                        upperMode = true;
                                        shiftUpperMode = false;
                                    } else if (upperMode && shiftUpperMode) {
                                        upperMode = false;
                                        shiftUpperMode = false;
                                    } else shiftUpperMode = true;
                                    break;
                                case Code128Reader.CODE_SHIFT:
                                    isNextShifted = true;
                                    codeSet = Code128Reader.CODE_CODE_B;
                                    break;
                                case Code128Reader.CODE_CODE_B:
                                    codeSet = Code128Reader.CODE_CODE_B;
                                    break;
                                case Code128Reader.CODE_CODE_C:
                                    codeSet = Code128Reader.CODE_CODE_C;
                                    break;
                                case Code128Reader.CODE_STOP:
                                    done = true;
                                    break;
                            }
                        }
                        break;
                    case Code128Reader.CODE_CODE_B:
                        if (code < 96) {
                            if (shiftUpperMode === upperMode) result += String.fromCharCode(' '.charCodeAt(0) + code);
                            else result += String.fromCharCode(' '.charCodeAt(0) + code + 128);
                            shiftUpperMode = false;
                        } else {
                            if (code !== Code128Reader.CODE_STOP) lastCharacterWasPrintable = false;
                            switch(code){
                                case Code128Reader.CODE_FNC_1:
                                    if (convertFNC1) {
                                        if (result.length === 0) // GS1 specification 5.4.3.7. and 5.4.6.4. If the first char after the start code
                                        // is FNC1 then this is GS1-128. We add the symbology identifier.
                                        result += ']C1';
                                        else // GS1 specification 5.4.7.5. Every subsequent FNC1 is returned as ASCII 29 (GS)
                                        result += String.fromCharCode(29);
                                    }
                                    break;
                                case Code128Reader.CODE_FNC_2:
                                case Code128Reader.CODE_FNC_3:
                                    break;
                                case Code128Reader.CODE_FNC_4_B:
                                    if (!upperMode && shiftUpperMode) {
                                        upperMode = true;
                                        shiftUpperMode = false;
                                    } else if (upperMode && shiftUpperMode) {
                                        upperMode = false;
                                        shiftUpperMode = false;
                                    } else shiftUpperMode = true;
                                    break;
                                case Code128Reader.CODE_SHIFT:
                                    isNextShifted = true;
                                    codeSet = Code128Reader.CODE_CODE_A;
                                    break;
                                case Code128Reader.CODE_CODE_A:
                                    codeSet = Code128Reader.CODE_CODE_A;
                                    break;
                                case Code128Reader.CODE_CODE_C:
                                    codeSet = Code128Reader.CODE_CODE_C;
                                    break;
                                case Code128Reader.CODE_STOP:
                                    done = true;
                                    break;
                            }
                        }
                        break;
                    case Code128Reader.CODE_CODE_C:
                        if (code < 100) {
                            if (code < 10) result += '0';
                            result += code;
                        } else {
                            if (code !== Code128Reader.CODE_STOP) lastCharacterWasPrintable = false;
                            switch(code){
                                case Code128Reader.CODE_FNC_1:
                                    if (convertFNC1) {
                                        if (result.length === 0) // GS1 specification 5.4.3.7. and 5.4.6.4. If the first char after the start code
                                        // is FNC1 then this is GS1-128. We add the symbology identifier.
                                        result += ']C1';
                                        else // GS1 specification 5.4.7.5. Every subsequent FNC1 is returned as ASCII 29 (GS)
                                        result += String.fromCharCode(29);
                                    }
                                    break;
                                case Code128Reader.CODE_CODE_A:
                                    codeSet = Code128Reader.CODE_CODE_A;
                                    break;
                                case Code128Reader.CODE_CODE_B:
                                    codeSet = Code128Reader.CODE_CODE_B;
                                    break;
                                case Code128Reader.CODE_STOP:
                                    done = true;
                                    break;
                            }
                        }
                        break;
                }
                // Unshift back to another code set if we were shifted
                if (unshift) codeSet = codeSet === Code128Reader.CODE_CODE_A ? Code128Reader.CODE_CODE_B : Code128Reader.CODE_CODE_A;
            }
            const lastPatternSize = nextStart - lastStart;
            // Check for ample whitespace following pattern, but, to do this we first need to remember that
            // we fudged decoding CODE_STOP since it actually has 7 bars, not 6. There is a black bar left
            // to read off. Would be slightly better to properly read. Here we just skip it:
            nextStart = row.getNextUnset(nextStart);
            if (!row.isRange(nextStart, Math.min(row.getSize(), nextStart + (nextStart - lastStart) / 2), false)) throw new NotFoundException();
            // Pull out from sum the value of the penultimate check code
            checksumTotal -= multiplier * lastCode;
            // lastCode is the checksum then:
            if (checksumTotal % 103 !== lastCode) throw new ChecksumException();
            // Need to pull out the check digits from string
            const resultLength = result.length;
            if (resultLength === 0) // false positive
            throw new NotFoundException();
            // Only bother if the result had at least one character, and if the checksum digit happened to
            // be a printable character. If it was just interpreted as a control code, nothing to remove.
            if (resultLength > 0 && lastCharacterWasPrintable) {
                if (codeSet === Code128Reader.CODE_CODE_C) result = result.substring(0, resultLength - 2);
                else result = result.substring(0, resultLength - 1);
            }
            const left = (startPatternInfo[1] + startPatternInfo[0]) / 2.0;
            const right = lastStart + lastPatternSize / 2.0;
            const rawCodesSize = rawCodes.length;
            const rawBytes = new Uint8Array(rawCodesSize);
            for(let i = 0; i < rawCodesSize; i++)rawBytes[i] = rawCodes[i];
            const points = [
                new ResultPoint(left, rowNumber),
                new ResultPoint(right, rowNumber)
            ];
            return new Result(result, rawBytes, 0, points, BarcodeFormat$1.CODE_128, new Date().getTime());
        }
    }
    Code128Reader.CODE_PATTERNS = [
        Int32Array.from([
            2,
            1,
            2,
            2,
            2,
            2
        ]),
        Int32Array.from([
            2,
            2,
            2,
            1,
            2,
            2
        ]),
        Int32Array.from([
            2,
            2,
            2,
            2,
            2,
            1
        ]),
        Int32Array.from([
            1,
            2,
            1,
            2,
            2,
            3
        ]),
        Int32Array.from([
            1,
            2,
            1,
            3,
            2,
            2
        ]),
        Int32Array.from([
            1,
            3,
            1,
            2,
            2,
            2
        ]),
        Int32Array.from([
            1,
            2,
            2,
            2,
            1,
            3
        ]),
        Int32Array.from([
            1,
            2,
            2,
            3,
            1,
            2
        ]),
        Int32Array.from([
            1,
            3,
            2,
            2,
            1,
            2
        ]),
        Int32Array.from([
            2,
            2,
            1,
            2,
            1,
            3
        ]),
        Int32Array.from([
            2,
            2,
            1,
            3,
            1,
            2
        ]),
        Int32Array.from([
            2,
            3,
            1,
            2,
            1,
            2
        ]),
        Int32Array.from([
            1,
            1,
            2,
            2,
            3,
            2
        ]),
        Int32Array.from([
            1,
            2,
            2,
            1,
            3,
            2
        ]),
        Int32Array.from([
            1,
            2,
            2,
            2,
            3,
            1
        ]),
        Int32Array.from([
            1,
            1,
            3,
            2,
            2,
            2
        ]),
        Int32Array.from([
            1,
            2,
            3,
            1,
            2,
            2
        ]),
        Int32Array.from([
            1,
            2,
            3,
            2,
            2,
            1
        ]),
        Int32Array.from([
            2,
            2,
            3,
            2,
            1,
            1
        ]),
        Int32Array.from([
            2,
            2,
            1,
            1,
            3,
            2
        ]),
        Int32Array.from([
            2,
            2,
            1,
            2,
            3,
            1
        ]),
        Int32Array.from([
            2,
            1,
            3,
            2,
            1,
            2
        ]),
        Int32Array.from([
            2,
            2,
            3,
            1,
            1,
            2
        ]),
        Int32Array.from([
            3,
            1,
            2,
            1,
            3,
            1
        ]),
        Int32Array.from([
            3,
            1,
            1,
            2,
            2,
            2
        ]),
        Int32Array.from([
            3,
            2,
            1,
            1,
            2,
            2
        ]),
        Int32Array.from([
            3,
            2,
            1,
            2,
            2,
            1
        ]),
        Int32Array.from([
            3,
            1,
            2,
            2,
            1,
            2
        ]),
        Int32Array.from([
            3,
            2,
            2,
            1,
            1,
            2
        ]),
        Int32Array.from([
            3,
            2,
            2,
            2,
            1,
            1
        ]),
        Int32Array.from([
            2,
            1,
            2,
            1,
            2,
            3
        ]),
        Int32Array.from([
            2,
            1,
            2,
            3,
            2,
            1
        ]),
        Int32Array.from([
            2,
            3,
            2,
            1,
            2,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            3,
            2,
            3
        ]),
        Int32Array.from([
            1,
            3,
            1,
            1,
            2,
            3
        ]),
        Int32Array.from([
            1,
            3,
            1,
            3,
            2,
            1
        ]),
        Int32Array.from([
            1,
            1,
            2,
            3,
            1,
            3
        ]),
        Int32Array.from([
            1,
            3,
            2,
            1,
            1,
            3
        ]),
        Int32Array.from([
            1,
            3,
            2,
            3,
            1,
            1
        ]),
        Int32Array.from([
            2,
            1,
            1,
            3,
            1,
            3
        ]),
        Int32Array.from([
            2,
            3,
            1,
            1,
            1,
            3
        ]),
        Int32Array.from([
            2,
            3,
            1,
            3,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            2,
            1,
            3,
            3
        ]),
        Int32Array.from([
            1,
            1,
            2,
            3,
            3,
            1
        ]),
        Int32Array.from([
            1,
            3,
            2,
            1,
            3,
            1
        ]),
        Int32Array.from([
            1,
            1,
            3,
            1,
            2,
            3
        ]),
        Int32Array.from([
            1,
            1,
            3,
            3,
            2,
            1
        ]),
        Int32Array.from([
            1,
            3,
            3,
            1,
            2,
            1
        ]),
        Int32Array.from([
            3,
            1,
            3,
            1,
            2,
            1
        ]),
        Int32Array.from([
            2,
            1,
            1,
            3,
            3,
            1
        ]),
        Int32Array.from([
            2,
            3,
            1,
            1,
            3,
            1
        ]),
        Int32Array.from([
            2,
            1,
            3,
            1,
            1,
            3
        ]),
        Int32Array.from([
            2,
            1,
            3,
            3,
            1,
            1
        ]),
        Int32Array.from([
            2,
            1,
            3,
            1,
            3,
            1
        ]),
        Int32Array.from([
            3,
            1,
            1,
            1,
            2,
            3
        ]),
        Int32Array.from([
            3,
            1,
            1,
            3,
            2,
            1
        ]),
        Int32Array.from([
            3,
            3,
            1,
            1,
            2,
            1
        ]),
        Int32Array.from([
            3,
            1,
            2,
            1,
            1,
            3
        ]),
        Int32Array.from([
            3,
            1,
            2,
            3,
            1,
            1
        ]),
        Int32Array.from([
            3,
            3,
            2,
            1,
            1,
            1
        ]),
        Int32Array.from([
            3,
            1,
            4,
            1,
            1,
            1
        ]),
        Int32Array.from([
            2,
            2,
            1,
            4,
            1,
            1
        ]),
        Int32Array.from([
            4,
            3,
            1,
            1,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            2,
            2,
            4
        ]),
        Int32Array.from([
            1,
            1,
            1,
            4,
            2,
            2
        ]),
        Int32Array.from([
            1,
            2,
            1,
            1,
            2,
            4
        ]),
        Int32Array.from([
            1,
            2,
            1,
            4,
            2,
            1
        ]),
        Int32Array.from([
            1,
            4,
            1,
            1,
            2,
            2
        ]),
        Int32Array.from([
            1,
            4,
            1,
            2,
            2,
            1
        ]),
        Int32Array.from([
            1,
            1,
            2,
            2,
            1,
            4
        ]),
        Int32Array.from([
            1,
            1,
            2,
            4,
            1,
            2
        ]),
        Int32Array.from([
            1,
            2,
            2,
            1,
            1,
            4
        ]),
        Int32Array.from([
            1,
            2,
            2,
            4,
            1,
            1
        ]),
        Int32Array.from([
            1,
            4,
            2,
            1,
            1,
            2
        ]),
        Int32Array.from([
            1,
            4,
            2,
            2,
            1,
            1
        ]),
        Int32Array.from([
            2,
            4,
            1,
            2,
            1,
            1
        ]),
        Int32Array.from([
            2,
            2,
            1,
            1,
            1,
            4
        ]),
        Int32Array.from([
            4,
            1,
            3,
            1,
            1,
            1
        ]),
        Int32Array.from([
            2,
            4,
            1,
            1,
            1,
            2
        ]),
        Int32Array.from([
            1,
            3,
            4,
            1,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            2,
            4,
            2
        ]),
        Int32Array.from([
            1,
            2,
            1,
            1,
            4,
            2
        ]),
        Int32Array.from([
            1,
            2,
            1,
            2,
            4,
            1
        ]),
        Int32Array.from([
            1,
            1,
            4,
            2,
            1,
            2
        ]),
        Int32Array.from([
            1,
            2,
            4,
            1,
            1,
            2
        ]),
        Int32Array.from([
            1,
            2,
            4,
            2,
            1,
            1
        ]),
        Int32Array.from([
            4,
            1,
            1,
            2,
            1,
            2
        ]),
        Int32Array.from([
            4,
            2,
            1,
            1,
            1,
            2
        ]),
        Int32Array.from([
            4,
            2,
            1,
            2,
            1,
            1
        ]),
        Int32Array.from([
            2,
            1,
            2,
            1,
            4,
            1
        ]),
        Int32Array.from([
            2,
            1,
            4,
            1,
            2,
            1
        ]),
        Int32Array.from([
            4,
            1,
            2,
            1,
            2,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            1,
            4,
            3
        ]),
        Int32Array.from([
            1,
            1,
            1,
            3,
            4,
            1
        ]),
        Int32Array.from([
            1,
            3,
            1,
            1,
            4,
            1
        ]),
        Int32Array.from([
            1,
            1,
            4,
            1,
            1,
            3
        ]),
        Int32Array.from([
            1,
            1,
            4,
            3,
            1,
            1
        ]),
        Int32Array.from([
            4,
            1,
            1,
            1,
            1,
            3
        ]),
        Int32Array.from([
            4,
            1,
            1,
            3,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            3,
            1,
            4,
            1
        ]),
        Int32Array.from([
            1,
            1,
            4,
            1,
            3,
            1
        ]),
        Int32Array.from([
            3,
            1,
            1,
            1,
            4,
            1
        ]),
        Int32Array.from([
            4,
            1,
            1,
            1,
            3,
            1
        ]),
        Int32Array.from([
            2,
            1,
            1,
            4,
            1,
            2
        ]),
        Int32Array.from([
            2,
            1,
            1,
            2,
            1,
            4
        ]),
        Int32Array.from([
            2,
            1,
            1,
            2,
            3,
            2
        ]),
        Int32Array.from([
            2,
            3,
            3,
            1,
            1,
            1,
            2
        ])
    ];
    Code128Reader.MAX_AVG_VARIANCE = 0.25;
    Code128Reader.MAX_INDIVIDUAL_VARIANCE = 0.7;
    Code128Reader.CODE_SHIFT = 98;
    Code128Reader.CODE_CODE_C = 99;
    Code128Reader.CODE_CODE_B = 100;
    Code128Reader.CODE_CODE_A = 101;
    Code128Reader.CODE_FNC_1 = 102;
    Code128Reader.CODE_FNC_2 = 97;
    Code128Reader.CODE_FNC_3 = 96;
    Code128Reader.CODE_FNC_4_A = 101;
    Code128Reader.CODE_FNC_4_B = 100;
    Code128Reader.CODE_START_A = 103;
    Code128Reader.CODE_START_B = 104;
    Code128Reader.CODE_START_C = 105;
    Code128Reader.CODE_STOP = 106;
    /**
     * <p>Decodes Code 39 barcodes. Supports "Full ASCII Code 39" if USE_CODE_39_EXTENDED_MODE is set.</p>
     *
     * @author Sean Owen
     * @see Code93Reader
     */ class Code39Reader extends OneDReader {
        /**
         * Creates a reader that assumes all encoded data is data, and does not treat the final
         * character as a check digit. It will not decoded "extended Code 39" sequences.
         */ // public Code39Reader() {
        //   this(false);
        // }
        /**
         * Creates a reader that can be configured to check the last character as a check digit.
         * It will not decoded "extended Code 39" sequences.
         *
         * @param usingCheckDigit if true, treat the last data character as a check digit, not
         * data, and verify that the checksum passes.
         */ // public Code39Reader(boolean usingCheckDigit) {
        //   this(usingCheckDigit, false);
        // }
        /**
         * Creates a reader that can be configured to check the last character as a check digit,
         * or optionally attempt to decode "extended Code 39" sequences that are used to encode
         * the full ASCII character set.
         *
         * @param usingCheckDigit if true, treat the last data character as a check digit, not
         * data, and verify that the checksum passes.
         * @param extendedMode if true, will attempt to decode extended Code 39 sequences in the
         * text.
         */ constructor(usingCheckDigit = false, extendedMode = false){
            super();
            this.usingCheckDigit = usingCheckDigit;
            this.extendedMode = extendedMode;
            this.decodeRowResult = '';
            this.counters = new Int32Array(9);
        }
        decodeRow(rowNumber, row, hints) {
            let theCounters = this.counters;
            theCounters.fill(0);
            this.decodeRowResult = '';
            let start = Code39Reader.findAsteriskPattern(row, theCounters);
            // Read off white space
            let nextStart = row.getNextSet(start[1]);
            let end = row.getSize();
            let decodedChar;
            let lastStart;
            do {
                Code39Reader.recordPattern(row, nextStart, theCounters);
                let pattern = Code39Reader.toNarrowWidePattern(theCounters);
                if (pattern < 0) throw new NotFoundException();
                decodedChar = Code39Reader.patternToChar(pattern);
                this.decodeRowResult += decodedChar;
                lastStart = nextStart;
                for (let counter of theCounters)nextStart += counter;
                // Read off white space
                nextStart = row.getNextSet(nextStart);
            }while (decodedChar !== '*');
            this.decodeRowResult = this.decodeRowResult.substring(0, this.decodeRowResult.length - 1); // remove asterisk
            // Look for whitespace after pattern:
            let lastPatternSize = 0;
            for (let counter of theCounters)lastPatternSize += counter;
            let whiteSpaceAfterEnd = nextStart - lastStart - lastPatternSize;
            // If 50% of last pattern size, following last pattern, is not whitespace, fail
            // (but if it's whitespace to the very end of the image, that's OK)
            if (nextStart !== end && whiteSpaceAfterEnd * 2 < lastPatternSize) throw new NotFoundException();
            if (this.usingCheckDigit) {
                let max = this.decodeRowResult.length - 1;
                let total = 0;
                for(let i = 0; i < max; i++)total += Code39Reader.ALPHABET_STRING.indexOf(this.decodeRowResult.charAt(i));
                if (this.decodeRowResult.charAt(max) !== Code39Reader.ALPHABET_STRING.charAt(total % 43)) throw new ChecksumException();
                this.decodeRowResult = this.decodeRowResult.substring(0, max);
            }
            if (this.decodeRowResult.length === 0) // false positive
            throw new NotFoundException();
            let resultString;
            if (this.extendedMode) resultString = Code39Reader.decodeExtended(this.decodeRowResult);
            else resultString = this.decodeRowResult;
            let left = (start[1] + start[0]) / 2.0;
            let right = lastStart + lastPatternSize / 2.0;
            return new Result(resultString, null, 0, [
                new ResultPoint(left, rowNumber),
                new ResultPoint(right, rowNumber)
            ], BarcodeFormat$1.CODE_39, new Date().getTime());
        }
        static findAsteriskPattern(row, counters) {
            let width = row.getSize();
            let rowOffset = row.getNextSet(0);
            let counterPosition = 0;
            let patternStart = rowOffset;
            let isWhite = false;
            let patternLength = counters.length;
            for(let i = rowOffset; i < width; i++)if (row.get(i) !== isWhite) counters[counterPosition]++;
            else {
                if (counterPosition === patternLength - 1) {
                    // Look for whitespace before start pattern, >= 50% of width of start pattern
                    if (this.toNarrowWidePattern(counters) === Code39Reader.ASTERISK_ENCODING && row.isRange(Math.max(0, patternStart - Math.floor((i - patternStart) / 2)), patternStart, false)) return [
                        patternStart,
                        i
                    ];
                    patternStart += counters[0] + counters[1];
                    counters.copyWithin(0, 2, 2 + counterPosition - 1);
                    counters[counterPosition - 1] = 0;
                    counters[counterPosition] = 0;
                    counterPosition--;
                } else counterPosition++;
                counters[counterPosition] = 1;
                isWhite = !isWhite;
            }
            throw new NotFoundException();
        }
        // For efficiency, returns -1 on failure. Not throwing here saved as many as 700 exceptions
        // per image when using some of our blackbox images.
        static toNarrowWidePattern(counters) {
            let numCounters = counters.length;
            let maxNarrowCounter = 0;
            let wideCounters;
            do {
                let minCounter = 0x7fffffff;
                for (let counter of counters)if (counter < minCounter && counter > maxNarrowCounter) minCounter = counter;
                maxNarrowCounter = minCounter;
                wideCounters = 0;
                let totalWideCountersWidth = 0;
                let pattern = 0;
                for(let i = 0; i < numCounters; i++){
                    let counter = counters[i];
                    if (counter > maxNarrowCounter) {
                        pattern |= 1 << numCounters - 1 - i;
                        wideCounters++;
                        totalWideCountersWidth += counter;
                    }
                }
                if (wideCounters === 3) {
                    // Found 3 wide counters, but are they close enough in width?
                    // We can perform a cheap, conservative check to see if any individual
                    // counter is more than 1.5 times the average:
                    for(let i = 0; i < numCounters && wideCounters > 0; i++){
                        let counter = counters[i];
                        if (counter > maxNarrowCounter) {
                            wideCounters--;
                            // totalWideCountersWidth = 3 * average, so this checks if counter >= 3/2 * average
                            if (counter * 2 >= totalWideCountersWidth) return -1;
                        }
                    }
                    return pattern;
                }
            }while (wideCounters > 3);
            return -1;
        }
        static patternToChar(pattern) {
            for(let i = 0; i < Code39Reader.CHARACTER_ENCODINGS.length; i++){
                if (Code39Reader.CHARACTER_ENCODINGS[i] === pattern) return Code39Reader.ALPHABET_STRING.charAt(i);
            }
            if (pattern === Code39Reader.ASTERISK_ENCODING) return '*';
            throw new NotFoundException();
        }
        static decodeExtended(encoded) {
            let length = encoded.length;
            let decoded = '';
            for(let i = 0; i < length; i++){
                let c = encoded.charAt(i);
                if (c === '+' || c === '$' || c === '%' || c === '/') {
                    let next = encoded.charAt(i + 1);
                    let decodedChar = '\0';
                    switch(c){
                        case '+':
                            // +A to +Z map to a to z
                            if (next >= 'A' && next <= 'Z') decodedChar = String.fromCharCode(next.charCodeAt(0) + 32);
                            else throw new FormatException();
                            break;
                        case '$':
                            // $A to $Z map to control codes SH to SB
                            if (next >= 'A' && next <= 'Z') decodedChar = String.fromCharCode(next.charCodeAt(0) - 64);
                            else throw new FormatException();
                            break;
                        case '%':
                            // %A to %E map to control codes ESC to US
                            if (next >= 'A' && next <= 'E') decodedChar = String.fromCharCode(next.charCodeAt(0) - 38);
                            else if (next >= 'F' && next <= 'J') decodedChar = String.fromCharCode(next.charCodeAt(0) - 11);
                            else if (next >= 'K' && next <= 'O') decodedChar = String.fromCharCode(next.charCodeAt(0) + 16);
                            else if (next >= 'P' && next <= 'T') decodedChar = String.fromCharCode(next.charCodeAt(0) + 43);
                            else if (next === 'U') decodedChar = '\0';
                            else if (next === 'V') decodedChar = '@';
                            else if (next === 'W') decodedChar = '`';
                            else if (next === 'X' || next === 'Y' || next === 'Z') decodedChar = '\x7f';
                            else throw new FormatException();
                            break;
                        case '/':
                            // /A to /O map to ! to , and /Z maps to :
                            if (next >= 'A' && next <= 'O') decodedChar = String.fromCharCode(next.charCodeAt(0) - 32);
                            else if (next === 'Z') decodedChar = ':';
                            else throw new FormatException();
                            break;
                    }
                    decoded += decodedChar;
                    // bump up i again since we read two characters
                    i++;
                } else decoded += c;
            }
            return decoded;
        }
    }
    Code39Reader.ALPHABET_STRING = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ-. $/+%';
    /**
     * These represent the encodings of characters, as patterns of wide and narrow bars.
     * The 9 least-significant bits of each int correspond to the pattern of wide and narrow,
     * with 1s representing "wide" and 0s representing narrow.
     */ Code39Reader.CHARACTER_ENCODINGS = [
        0x034,
        0x121,
        0x061,
        0x160,
        0x031,
        0x130,
        0x070,
        0x025,
        0x124,
        0x064,
        0x109,
        0x049,
        0x148,
        0x019,
        0x118,
        0x058,
        0x00D,
        0x10C,
        0x04C,
        0x01C,
        0x103,
        0x043,
        0x142,
        0x013,
        0x112,
        0x052,
        0x007,
        0x106,
        0x046,
        0x016,
        0x181,
        0x0C1,
        0x1C0,
        0x091,
        0x190,
        0x0D0,
        0x085,
        0x184,
        0x0C4,
        0x0A8,
        0x0A2,
        0x08A,
        0x02A // /-%
    ];
    Code39Reader.ASTERISK_ENCODING = 0x094;
    /**
     * <p>Decodes ITF barcodes.</p>
     *
     * @author Tjieco
     */ class ITFReader extends OneDReader {
        constructor(){
            // private static W = 3; // Pixel width of a 3x wide line
            // private static w = 2; // Pixel width of a 2x wide line
            // private static N = 1; // Pixed width of a narrow line
            super(...arguments);
            // Stores the actual narrow line width of the image being decoded.
            this.narrowLineWidth = -1;
        }
        // See ITFWriter.PATTERNS
        /*
      
        /!**
         * Patterns of Wide / Narrow lines to indicate each digit
         *!/
        */ decodeRow(rowNumber, row, hints) {
            // Find out where the Middle section (payload) starts & ends
            let startRange = this.decodeStart(row);
            let endRange = this.decodeEnd(row);
            let result = new StringBuilder();
            ITFReader.decodeMiddle(row, startRange[1], endRange[0], result);
            let resultString = result.toString();
            let allowedLengths = null;
            if (hints != null) allowedLengths = hints.get(DecodeHintType$1.ALLOWED_LENGTHS);
            if (allowedLengths == null) allowedLengths = ITFReader.DEFAULT_ALLOWED_LENGTHS;
            // To avoid false positives with 2D barcodes (and other patterns), make
            // an assumption that the decoded string must be a 'standard' length if it's short
            let length = resultString.length;
            let lengthOK = false;
            let maxAllowedLength = 0;
            for (let value of allowedLengths){
                if (length === value) {
                    lengthOK = true;
                    break;
                }
                if (value > maxAllowedLength) maxAllowedLength = value;
            }
            if (!lengthOK && length > maxAllowedLength) lengthOK = true;
            if (!lengthOK) throw new FormatException();
            const points = [
                new ResultPoint(startRange[1], rowNumber),
                new ResultPoint(endRange[0], rowNumber)
            ];
            let resultReturn = new Result(resultString, null, 0, points, BarcodeFormat$1.ITF, new Date().getTime());
            return resultReturn;
        }
        /*
        /!**
         * @param row          row of black/white values to search
         * @param payloadStart offset of start pattern
         * @param resultString {@link StringBuilder} to append decoded chars to
         * @throws NotFoundException if decoding could not complete successfully
         *!/*/ static decodeMiddle(row, payloadStart, payloadEnd, resultString) {
            // Digits are interleaved in pairs - 5 black lines for one digit, and the
            // 5
            // interleaved white lines for the second digit.
            // Therefore, need to scan 10 lines and then
            // split these into two arrays
            let counterDigitPair = new Int32Array(10); // 10
            let counterBlack = new Int32Array(5); // 5
            let counterWhite = new Int32Array(5); // 5
            counterDigitPair.fill(0);
            counterBlack.fill(0);
            counterWhite.fill(0);
            while(payloadStart < payloadEnd){
                // Get 10 runs of black/white.
                OneDReader.recordPattern(row, payloadStart, counterDigitPair);
                // Split them into each array
                for(let k = 0; k < 5; k++){
                    let twoK = 2 * k;
                    counterBlack[k] = counterDigitPair[twoK];
                    counterWhite[k] = counterDigitPair[twoK + 1];
                }
                let bestMatch = ITFReader.decodeDigit(counterBlack);
                resultString.append(bestMatch.toString());
                bestMatch = this.decodeDigit(counterWhite);
                resultString.append(bestMatch.toString());
                counterDigitPair.forEach(function(counterDigit) {
                    payloadStart += counterDigit;
                });
            }
        }
        /*/!**
         * Identify where the start of the middle / payload section starts.
         *
         * @param row row of black/white values to search
         * @return Array, containing index of start of 'start block' and end of
         *         'start block'
         *!/*/ decodeStart(row) {
            let endStart = ITFReader.skipWhiteSpace(row);
            let startPattern = ITFReader.findGuardPattern(row, endStart, ITFReader.START_PATTERN);
            // Determine the width of a narrow line in pixels. We can do this by
            // getting the width of the start pattern and dividing by 4 because its
            // made up of 4 narrow lines.
            this.narrowLineWidth = (startPattern[1] - startPattern[0]) / 4;
            this.validateQuietZone(row, startPattern[0]);
            return startPattern;
        }
        /*/!**
         * The start & end patterns must be pre/post fixed by a quiet zone. This
         * zone must be at least 10 times the width of a narrow line.  Scan back until
         * we either get to the start of the barcode or match the necessary number of
         * quiet zone pixels.
         *
         * Note: Its assumed the row is reversed when using this method to find
         * quiet zone after the end pattern.
         *
         * ref: http://www.barcode-1.net/i25code.html
         *
         * @param row bit array representing the scanned barcode.
         * @param startPattern index into row of the start or end pattern.
         * @throws NotFoundException if the quiet zone cannot be found
         *!/*/ validateQuietZone(row, startPattern) {
            let quietCount = this.narrowLineWidth * 10; // expect to find this many pixels of quiet zone
            // if there are not so many pixel at all let's try as many as possible
            quietCount = quietCount < startPattern ? quietCount : startPattern;
            for(let i = startPattern - 1; quietCount > 0 && i >= 0; i--){
                if (row.get(i)) break;
                quietCount--;
            }
            if (quietCount !== 0) // Unable to find the necessary number of quiet zone pixels.
            throw new NotFoundException();
        }
        /*
        /!**
         * Skip all whitespace until we get to the first black line.
         *
         * @param row row of black/white values to search
         * @return index of the first black line.
         * @throws NotFoundException Throws exception if no black lines are found in the row
         *!/*/ static skipWhiteSpace(row) {
            const width = row.getSize();
            const endStart = row.getNextSet(0);
            if (endStart === width) throw new NotFoundException();
            return endStart;
        }
        /*/!**
         * Identify where the end of the middle / payload section ends.
         *
         * @param row row of black/white values to search
         * @return Array, containing index of start of 'end block' and end of 'end
         *         block'
         *!/*/ decodeEnd(row) {
            // For convenience, reverse the row and then
            // search from 'the start' for the end block
            row.reverse();
            try {
                let endStart = ITFReader.skipWhiteSpace(row);
                let endPattern;
                try {
                    endPattern = ITFReader.findGuardPattern(row, endStart, ITFReader.END_PATTERN_REVERSED[0]);
                } catch (error) {
                    if (error instanceof NotFoundException) endPattern = ITFReader.findGuardPattern(row, endStart, ITFReader.END_PATTERN_REVERSED[1]);
                }
                // The start & end patterns must be pre/post fixed by a quiet zone. This
                // zone must be at least 10 times the width of a narrow line.
                // ref: http://www.barcode-1.net/i25code.html
                this.validateQuietZone(row, endPattern[0]);
                // Now recalculate the indices of where the 'endblock' starts & stops to
                // accommodate
                // the reversed nature of the search
                let temp = endPattern[0];
                endPattern[0] = row.getSize() - endPattern[1];
                endPattern[1] = row.getSize() - temp;
                return endPattern;
            } finally{
                // Put the row back the right way.
                row.reverse();
            }
        }
        /*
        /!**
         * @param row       row of black/white values to search
         * @param rowOffset position to start search
         * @param pattern   pattern of counts of number of black and white pixels that are
         *                  being searched for as a pattern
         * @return start/end horizontal offset of guard pattern, as an array of two
         *         ints
         * @throws NotFoundException if pattern is not found
         *!/*/ static findGuardPattern(row, rowOffset, pattern) {
            let patternLength = pattern.length;
            let counters = new Int32Array(patternLength);
            let width = row.getSize();
            let isWhite = false;
            let counterPosition = 0;
            let patternStart = rowOffset;
            counters.fill(0);
            for(let x = rowOffset; x < width; x++)if (row.get(x) !== isWhite) counters[counterPosition]++;
            else {
                if (counterPosition === patternLength - 1) {
                    if (OneDReader.patternMatchVariance(counters, pattern, ITFReader.MAX_INDIVIDUAL_VARIANCE) < ITFReader.MAX_AVG_VARIANCE) return [
                        patternStart,
                        x
                    ];
                    patternStart += counters[0] + counters[1];
                    System.arraycopy(counters, 2, counters, 0, counterPosition - 1);
                    counters[counterPosition - 1] = 0;
                    counters[counterPosition] = 0;
                    counterPosition--;
                } else counterPosition++;
                counters[counterPosition] = 1;
                isWhite = !isWhite;
            }
            throw new NotFoundException();
        }
        /*/!**
         * Attempts to decode a sequence of ITF black/white lines into single
         * digit.
         *
         * @param counters the counts of runs of observed black/white/black/... values
         * @return The decoded digit
         * @throws NotFoundException if digit cannot be decoded
         *!/*/ static decodeDigit(counters) {
            let bestVariance = ITFReader.MAX_AVG_VARIANCE; // worst variance we'll accept
            let bestMatch = -1;
            let max = ITFReader.PATTERNS.length;
            for(let i = 0; i < max; i++){
                let pattern = ITFReader.PATTERNS[i];
                let variance = OneDReader.patternMatchVariance(counters, pattern, ITFReader.MAX_INDIVIDUAL_VARIANCE);
                if (variance < bestVariance) {
                    bestVariance = variance;
                    bestMatch = i;
                } else if (variance === bestVariance) // if we find a second 'best match' with the same variance, we can not reliably report to have a suitable match
                bestMatch = -1;
            }
            if (bestMatch >= 0) return bestMatch % 10;
            else throw new NotFoundException();
        }
    }
    ITFReader.PATTERNS = [
        Int32Array.from([
            1,
            1,
            2,
            2,
            1
        ]),
        Int32Array.from([
            2,
            1,
            1,
            1,
            2
        ]),
        Int32Array.from([
            1,
            2,
            1,
            1,
            2
        ]),
        Int32Array.from([
            2,
            2,
            1,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            2,
            1,
            2
        ]),
        Int32Array.from([
            2,
            1,
            2,
            1,
            1
        ]),
        Int32Array.from([
            1,
            2,
            2,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            2,
            2
        ]),
        Int32Array.from([
            2,
            1,
            1,
            2,
            1
        ]),
        Int32Array.from([
            1,
            2,
            1,
            2,
            1
        ]),
        Int32Array.from([
            1,
            1,
            3,
            3,
            1
        ]),
        Int32Array.from([
            3,
            1,
            1,
            1,
            3
        ]),
        Int32Array.from([
            1,
            3,
            1,
            1,
            3
        ]),
        Int32Array.from([
            3,
            3,
            1,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            3,
            1,
            3
        ]),
        Int32Array.from([
            3,
            1,
            3,
            1,
            1
        ]),
        Int32Array.from([
            1,
            3,
            3,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            3,
            3
        ]),
        Int32Array.from([
            3,
            1,
            1,
            3,
            1
        ]),
        Int32Array.from([
            1,
            3,
            1,
            3,
            1
        ]) // 9
    ];
    ITFReader.MAX_AVG_VARIANCE = 0.38;
    ITFReader.MAX_INDIVIDUAL_VARIANCE = 0.5;
    /* /!** Valid ITF lengths. Anything longer than the largest value is also allowed. *!/*/ ITFReader.DEFAULT_ALLOWED_LENGTHS = [
        6,
        8,
        10,
        12,
        14
    ];
    /*/!**
     * Start/end guard pattern.
     *
     * Note: The end pattern is reversed because the row is reversed before
     * searching for the END_PATTERN
     *!/*/ ITFReader.START_PATTERN = Int32Array.from([
        1,
        1,
        1,
        1
    ]);
    ITFReader.END_PATTERN_REVERSED = [
        Int32Array.from([
            1,
            1,
            2
        ]),
        Int32Array.from([
            1,
            1,
            3
        ]) // 3x
    ];
    /**
     * <p>Encapsulates functionality and implementation that is common to UPC and EAN families
     * of one-dimensional barcodes.</p>
     *
     * @author dswitkin@google.com (Daniel Switkin)
     * @author Sean Owen
     * @author alasdair@google.com (Alasdair Mackintosh)
     */ class AbstractUPCEANReader extends OneDReader {
        constructor(){
            super(...arguments);
            this.decodeRowStringBuffer = '';
        }
        static findStartGuardPattern(row) {
            let foundStart = false;
            let startRange;
            let nextStart = 0;
            let counters = Int32Array.from([
                0,
                0,
                0
            ]);
            while(!foundStart){
                counters = Int32Array.from([
                    0,
                    0,
                    0
                ]);
                startRange = AbstractUPCEANReader.findGuardPattern(row, nextStart, false, this.START_END_PATTERN, counters);
                let start = startRange[0];
                nextStart = startRange[1];
                let quietStart = start - (nextStart - start);
                if (quietStart >= 0) foundStart = row.isRange(quietStart, start, false);
            }
            return startRange;
        }
        static checkChecksum(s) {
            return AbstractUPCEANReader.checkStandardUPCEANChecksum(s);
        }
        static checkStandardUPCEANChecksum(s) {
            let length = s.length;
            if (length === 0) return false;
            let check = parseInt(s.charAt(length - 1), 10);
            return AbstractUPCEANReader.getStandardUPCEANChecksum(s.substring(0, length - 1)) === check;
        }
        static getStandardUPCEANChecksum(s) {
            let length = s.length;
            let sum = 0;
            for(let i = length - 1; i >= 0; i -= 2){
                let digit = s.charAt(i).charCodeAt(0) - '0'.charCodeAt(0);
                if (digit < 0 || digit > 9) throw new FormatException();
                sum += digit;
            }
            sum *= 3;
            for(let i = length - 2; i >= 0; i -= 2){
                let digit = s.charAt(i).charCodeAt(0) - '0'.charCodeAt(0);
                if (digit < 0 || digit > 9) throw new FormatException();
                sum += digit;
            }
            return (1000 - sum) % 10;
        }
        static decodeEnd(row, endStart) {
            return AbstractUPCEANReader.findGuardPattern(row, endStart, false, AbstractUPCEANReader.START_END_PATTERN, new Int32Array(AbstractUPCEANReader.START_END_PATTERN.length).fill(0));
        }
        /**
         * @throws NotFoundException
         */ static findGuardPatternWithoutCounters(row, rowOffset, whiteFirst, pattern) {
            return this.findGuardPattern(row, rowOffset, whiteFirst, pattern, new Int32Array(pattern.length));
        }
        /**
         * @param row row of black/white values to search
         * @param rowOffset position to start search
         * @param whiteFirst if true, indicates that the pattern specifies white/black/white/...
         * pixel counts, otherwise, it is interpreted as black/white/black/...
         * @param pattern pattern of counts of number of black and white pixels that are being
         * searched for as a pattern
         * @param counters array of counters, as long as pattern, to re-use
         * @return start/end horizontal offset of guard pattern, as an array of two ints
         * @throws NotFoundException if pattern is not found
         */ static findGuardPattern(row, rowOffset, whiteFirst, pattern, counters) {
            let width = row.getSize();
            rowOffset = whiteFirst ? row.getNextUnset(rowOffset) : row.getNextSet(rowOffset);
            let counterPosition = 0;
            let patternStart = rowOffset;
            let patternLength = pattern.length;
            let isWhite = whiteFirst;
            for(let x = rowOffset; x < width; x++)if (row.get(x) !== isWhite) counters[counterPosition]++;
            else {
                if (counterPosition === patternLength - 1) {
                    if (OneDReader.patternMatchVariance(counters, pattern, AbstractUPCEANReader.MAX_INDIVIDUAL_VARIANCE) < AbstractUPCEANReader.MAX_AVG_VARIANCE) return Int32Array.from([
                        patternStart,
                        x
                    ]);
                    patternStart += counters[0] + counters[1];
                    let slice = counters.slice(2, counters.length - 1);
                    for(let i = 0; i < counterPosition - 1; i++)counters[i] = slice[i];
                    counters[counterPosition - 1] = 0;
                    counters[counterPosition] = 0;
                    counterPosition--;
                } else counterPosition++;
                counters[counterPosition] = 1;
                isWhite = !isWhite;
            }
            throw new NotFoundException();
        }
        static decodeDigit(row, counters, rowOffset, patterns) {
            this.recordPattern(row, rowOffset, counters);
            let bestVariance = this.MAX_AVG_VARIANCE;
            let bestMatch = -1;
            let max = patterns.length;
            for(let i = 0; i < max; i++){
                let pattern = patterns[i];
                let variance = OneDReader.patternMatchVariance(counters, pattern, AbstractUPCEANReader.MAX_INDIVIDUAL_VARIANCE);
                if (variance < bestVariance) {
                    bestVariance = variance;
                    bestMatch = i;
                }
            }
            if (bestMatch >= 0) return bestMatch;
            else throw new NotFoundException();
        }
    }
    // These two values are critical for determining how permissive the decoding will be.
    // We've arrived at these values through a lot of trial and error. Setting them any higher
    // lets false positives creep in quickly.
    AbstractUPCEANReader.MAX_AVG_VARIANCE = 0.48;
    AbstractUPCEANReader.MAX_INDIVIDUAL_VARIANCE = 0.7;
    /**
     * Start/end guard pattern.
     */ AbstractUPCEANReader.START_END_PATTERN = Int32Array.from([
        1,
        1,
        1
    ]);
    /**
     * Pattern marking the middle of a UPC/EAN pattern, separating the two halves.
     */ AbstractUPCEANReader.MIDDLE_PATTERN = Int32Array.from([
        1,
        1,
        1,
        1,
        1
    ]);
    /**
     * end guard pattern.
     */ AbstractUPCEANReader.END_PATTERN = Int32Array.from([
        1,
        1,
        1,
        1,
        1,
        1
    ]);
    /**
     * "Odd", or "L" patterns used to encode UPC/EAN digits.
     */ AbstractUPCEANReader.L_PATTERNS = [
        Int32Array.from([
            3,
            2,
            1,
            1
        ]),
        Int32Array.from([
            2,
            2,
            2,
            1
        ]),
        Int32Array.from([
            2,
            1,
            2,
            2
        ]),
        Int32Array.from([
            1,
            4,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            3,
            2
        ]),
        Int32Array.from([
            1,
            2,
            3,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            4
        ]),
        Int32Array.from([
            1,
            3,
            1,
            2
        ]),
        Int32Array.from([
            1,
            2,
            1,
            3
        ]),
        Int32Array.from([
            3,
            1,
            1,
            2
        ])
    ];
    /**
     * @see UPCEANExtension2Support
     */ class UPCEANExtension5Support {
        constructor(){
            this.CHECK_DIGIT_ENCODINGS = [
                0x18,
                0x14,
                0x12,
                0x11,
                0x0C,
                0x06,
                0x03,
                0x0A,
                0x09,
                0x05
            ];
            this.decodeMiddleCounters = Int32Array.from([
                0,
                0,
                0,
                0
            ]);
            this.decodeRowStringBuffer = '';
        }
        decodeRow(rowNumber, row, extensionStartRange) {
            let result = this.decodeRowStringBuffer;
            let end = this.decodeMiddle(row, extensionStartRange, result);
            let resultString = result.toString();
            let extensionData = UPCEANExtension5Support.parseExtensionString(resultString);
            let resultPoints = [
                new ResultPoint((extensionStartRange[0] + extensionStartRange[1]) / 2.0, rowNumber),
                new ResultPoint(end, rowNumber)
            ];
            let extensionResult = new Result(resultString, null, 0, resultPoints, BarcodeFormat$1.UPC_EAN_EXTENSION, new Date().getTime());
            if (extensionData != null) extensionResult.putAllMetadata(extensionData);
            return extensionResult;
        }
        decodeMiddle(row, startRange, resultString) {
            let counters = this.decodeMiddleCounters;
            counters[0] = 0;
            counters[1] = 0;
            counters[2] = 0;
            counters[3] = 0;
            let end = row.getSize();
            let rowOffset = startRange[1];
            let lgPatternFound = 0;
            for(let x = 0; x < 5 && rowOffset < end; x++){
                let bestMatch = AbstractUPCEANReader.decodeDigit(row, counters, rowOffset, AbstractUPCEANReader.L_AND_G_PATTERNS);
                resultString += String.fromCharCode('0'.charCodeAt(0) + bestMatch % 10);
                for (let counter of counters)rowOffset += counter;
                if (bestMatch >= 10) lgPatternFound |= 1 << 4 - x;
                if (x !== 4) {
                    // Read off separator if not last
                    rowOffset = row.getNextSet(rowOffset);
                    rowOffset = row.getNextUnset(rowOffset);
                }
            }
            if (resultString.length !== 5) throw new NotFoundException();
            let checkDigit = this.determineCheckDigit(lgPatternFound);
            if (UPCEANExtension5Support.extensionChecksum(resultString.toString()) !== checkDigit) throw new NotFoundException();
            return rowOffset;
        }
        static extensionChecksum(s) {
            let length = s.length;
            let sum = 0;
            for(let i = length - 2; i >= 0; i -= 2)sum += s.charAt(i).charCodeAt(0) - '0'.charCodeAt(0);
            sum *= 3;
            for(let i = length - 1; i >= 0; i -= 2)sum += s.charAt(i).charCodeAt(0) - '0'.charCodeAt(0);
            sum *= 3;
            return sum % 10;
        }
        determineCheckDigit(lgPatternFound) {
            for(let d = 0; d < 10; d++){
                if (lgPatternFound === this.CHECK_DIGIT_ENCODINGS[d]) return d;
            }
            throw new NotFoundException();
        }
        static parseExtensionString(raw) {
            if (raw.length !== 5) return null;
            let value = UPCEANExtension5Support.parseExtension5String(raw);
            if (value == null) return null;
            return new Map([
                [
                    ResultMetadataType$1.SUGGESTED_PRICE,
                    value
                ]
            ]);
        }
        static parseExtension5String(raw) {
            let currency;
            switch(raw.charAt(0)){
                case '0':
                    currency = "\xa3";
                    break;
                case '5':
                    currency = '$';
                    break;
                case '9':
                    // Reference: http://www.jollytech.com
                    switch(raw){
                        case '90000':
                            // No suggested retail price
                            return null;
                        case '99991':
                            // Complementary
                            return '0.00';
                        case '99990':
                            return 'Used';
                    }
                    // Otherwise... unknown currency?
                    currency = '';
                    break;
                default:
                    currency = '';
                    break;
            }
            let rawAmount = parseInt(raw.substring(1));
            let unitsString = (rawAmount / 100).toString();
            let hundredths = rawAmount % 100;
            let hundredthsString = hundredths < 10 ? '0' + hundredths : hundredths.toString(); // fixme
            return currency + unitsString + '.' + hundredthsString;
        }
    }
    /**
     * @see UPCEANExtension5Support
     */ class UPCEANExtension2Support {
        constructor(){
            this.decodeMiddleCounters = Int32Array.from([
                0,
                0,
                0,
                0
            ]);
            this.decodeRowStringBuffer = '';
        }
        decodeRow(rowNumber, row, extensionStartRange) {
            let result = this.decodeRowStringBuffer;
            let end = this.decodeMiddle(row, extensionStartRange, result);
            let resultString = result.toString();
            let extensionData = UPCEANExtension2Support.parseExtensionString(resultString);
            let resultPoints = [
                new ResultPoint((extensionStartRange[0] + extensionStartRange[1]) / 2.0, rowNumber),
                new ResultPoint(end, rowNumber)
            ];
            let extensionResult = new Result(resultString, null, 0, resultPoints, BarcodeFormat$1.UPC_EAN_EXTENSION, new Date().getTime());
            if (extensionData != null) extensionResult.putAllMetadata(extensionData);
            return extensionResult;
        }
        decodeMiddle(row, startRange, resultString) {
            let counters = this.decodeMiddleCounters;
            counters[0] = 0;
            counters[1] = 0;
            counters[2] = 0;
            counters[3] = 0;
            let end = row.getSize();
            let rowOffset = startRange[1];
            let checkParity = 0;
            for(let x = 0; x < 2 && rowOffset < end; x++){
                let bestMatch = AbstractUPCEANReader.decodeDigit(row, counters, rowOffset, AbstractUPCEANReader.L_AND_G_PATTERNS);
                resultString += String.fromCharCode('0'.charCodeAt(0) + bestMatch % 10);
                for (let counter of counters)rowOffset += counter;
                if (bestMatch >= 10) checkParity |= 1 << 1 - x;
                if (x !== 1) {
                    // Read off separator if not last
                    rowOffset = row.getNextSet(rowOffset);
                    rowOffset = row.getNextUnset(rowOffset);
                }
            }
            if (resultString.length !== 2) throw new NotFoundException();
            if (parseInt(resultString.toString()) % 4 !== checkParity) throw new NotFoundException();
            return rowOffset;
        }
        static parseExtensionString(raw) {
            if (raw.length !== 2) return null;
            return new Map([
                [
                    ResultMetadataType$1.ISSUE_NUMBER,
                    parseInt(raw)
                ]
            ]);
        }
    }
    class UPCEANExtensionSupport {
        static decodeRow(rowNumber, row, rowOffset) {
            let extensionStartRange = AbstractUPCEANReader.findGuardPattern(row, rowOffset, false, this.EXTENSION_START_PATTERN, new Int32Array(this.EXTENSION_START_PATTERN.length).fill(0));
            try {
                // return null;
                let fiveSupport = new UPCEANExtension5Support();
                return fiveSupport.decodeRow(rowNumber, row, extensionStartRange);
            } catch (err) {
                // return null;
                let twoSupport = new UPCEANExtension2Support();
                return twoSupport.decodeRow(rowNumber, row, extensionStartRange);
            }
        }
    }
    UPCEANExtensionSupport.EXTENSION_START_PATTERN = Int32Array.from([
        1,
        1,
        2
    ]);
    /**
     * <p>Encapsulates functionality and implementation that is common to UPC and EAN families
     * of one-dimensional barcodes.</p>
     *
     * @author dswitkin@google.com (Daniel Switkin)
     * @author Sean Owen
     * @author alasdair@google.com (Alasdair Mackintosh)
     */ class UPCEANReader extends AbstractUPCEANReader {
        constructor(){
            super();
            this.decodeRowStringBuffer = '';
            UPCEANReader.L_AND_G_PATTERNS = UPCEANReader.L_PATTERNS.map((arr)=>Int32Array.from(arr));
            for(let i = 10; i < 20; i++){
                let widths = UPCEANReader.L_PATTERNS[i - 10];
                let reversedWidths = new Int32Array(widths.length);
                for(let j = 0; j < widths.length; j++)reversedWidths[j] = widths[widths.length - j - 1];
                UPCEANReader.L_AND_G_PATTERNS[i] = reversedWidths;
            }
        }
        decodeRow(rowNumber, row, hints) {
            let startGuardRange = UPCEANReader.findStartGuardPattern(row);
            let resultPointCallback = hints == null ? null : hints.get(DecodeHintType$1.NEED_RESULT_POINT_CALLBACK);
            if (resultPointCallback != null) {
                const resultPoint = new ResultPoint((startGuardRange[0] + startGuardRange[1]) / 2.0, rowNumber);
                resultPointCallback.foundPossibleResultPoint(resultPoint);
            }
            let budello = this.decodeMiddle(row, startGuardRange, this.decodeRowStringBuffer);
            let endStart = budello.rowOffset;
            let result = budello.resultString;
            if (resultPointCallback != null) {
                const resultPoint = new ResultPoint(endStart, rowNumber);
                resultPointCallback.foundPossibleResultPoint(resultPoint);
            }
            let endRange = this.decodeEnd(row, endStart);
            if (resultPointCallback != null) {
                const resultPoint = new ResultPoint((endRange[0] + endRange[1]) / 2.0, rowNumber);
                resultPointCallback.foundPossibleResultPoint(resultPoint);
            }
            // Make sure there is a quiet zone at least as big as the end pattern after the barcode. The
            // spec might want more whitespace, but in practice this is the maximum we can count on.
            let end = endRange[1];
            let quietEnd = end + (end - endRange[0]);
            if (quietEnd >= row.getSize() || !row.isRange(end, quietEnd, false)) throw new NotFoundException();
            let resultString = result.toString();
            // UPC/EAN should never be less than 8 chars anyway
            if (resultString.length < 8) throw new FormatException();
            if (!UPCEANReader.checkChecksum(resultString)) throw new ChecksumException();
            let left = (startGuardRange[1] + startGuardRange[0]) / 2.0;
            let right = (endRange[1] + endRange[0]) / 2.0;
            let format = this.getBarcodeFormat();
            let resultPoint = [
                new ResultPoint(left, rowNumber),
                new ResultPoint(right, rowNumber)
            ];
            let decodeResult = new Result(resultString, null, 0, resultPoint, format, new Date().getTime());
            let extensionLength = 0;
            try {
                let extensionResult = UPCEANExtensionSupport.decodeRow(rowNumber, row, endRange[1]);
                decodeResult.putMetadata(ResultMetadataType$1.UPC_EAN_EXTENSION, extensionResult.getText());
                decodeResult.putAllMetadata(extensionResult.getResultMetadata());
                decodeResult.addResultPoints(extensionResult.getResultPoints());
                extensionLength = extensionResult.getText().length;
            } catch (ignoreError) {}
            let allowedExtensions = hints == null ? null : hints.get(DecodeHintType$1.ALLOWED_EAN_EXTENSIONS);
            if (allowedExtensions != null) {
                let valid = false;
                for(let length in allowedExtensions)if (extensionLength.toString() === length) {
                    valid = true;
                    break;
                }
                if (!valid) throw new NotFoundException();
            }
            return decodeResult;
        }
        decodeEnd(row, endStart) {
            return UPCEANReader.findGuardPattern(row, endStart, false, UPCEANReader.START_END_PATTERN, new Int32Array(UPCEANReader.START_END_PATTERN.length).fill(0));
        }
        static checkChecksum(s) {
            return UPCEANReader.checkStandardUPCEANChecksum(s);
        }
        static checkStandardUPCEANChecksum(s) {
            let length = s.length;
            if (length === 0) return false;
            let check = parseInt(s.charAt(length - 1), 10);
            return UPCEANReader.getStandardUPCEANChecksum(s.substring(0, length - 1)) === check;
        }
        static getStandardUPCEANChecksum(s) {
            let length = s.length;
            let sum = 0;
            for(let i = length - 1; i >= 0; i -= 2){
                let digit = s.charAt(i).charCodeAt(0) - '0'.charCodeAt(0);
                if (digit < 0 || digit > 9) throw new FormatException();
                sum += digit;
            }
            sum *= 3;
            for(let i = length - 2; i >= 0; i -= 2){
                let digit = s.charAt(i).charCodeAt(0) - '0'.charCodeAt(0);
                if (digit < 0 || digit > 9) throw new FormatException();
                sum += digit;
            }
            return (1000 - sum) % 10;
        }
    }
    /**
     * <p>Implements decoding of the EAN-13 format.</p>
     *
     * @author dswitkin@google.com (Daniel Switkin)
     * @author Sean Owen
     * @author alasdair@google.com (Alasdair Mackintosh)
     */ class EAN13Reader extends UPCEANReader {
        constructor(){
            super();
            this.decodeMiddleCounters = Int32Array.from([
                0,
                0,
                0,
                0
            ]);
        }
        decodeMiddle(row, startRange, resultString) {
            let counters = this.decodeMiddleCounters;
            counters[0] = 0;
            counters[1] = 0;
            counters[2] = 0;
            counters[3] = 0;
            let end = row.getSize();
            let rowOffset = startRange[1];
            let lgPatternFound = 0;
            for(let x = 0; x < 6 && rowOffset < end; x++){
                let bestMatch = UPCEANReader.decodeDigit(row, counters, rowOffset, UPCEANReader.L_AND_G_PATTERNS);
                resultString += String.fromCharCode('0'.charCodeAt(0) + bestMatch % 10);
                for (let counter of counters)rowOffset += counter;
                if (bestMatch >= 10) lgPatternFound |= 1 << 5 - x;
            }
            resultString = EAN13Reader.determineFirstDigit(resultString, lgPatternFound);
            let middleRange = UPCEANReader.findGuardPattern(row, rowOffset, true, UPCEANReader.MIDDLE_PATTERN, new Int32Array(UPCEANReader.MIDDLE_PATTERN.length).fill(0));
            rowOffset = middleRange[1];
            for(let x = 0; x < 6 && rowOffset < end; x++){
                let bestMatch = UPCEANReader.decodeDigit(row, counters, rowOffset, UPCEANReader.L_PATTERNS);
                resultString += String.fromCharCode('0'.charCodeAt(0) + bestMatch);
                for (let counter of counters)rowOffset += counter;
            }
            return {
                rowOffset: rowOffset,
                resultString: resultString
            };
        }
        getBarcodeFormat() {
            return BarcodeFormat$1.EAN_13;
        }
        static determineFirstDigit(resultString, lgPatternFound) {
            for(let d = 0; d < 10; d++)if (lgPatternFound === this.FIRST_DIGIT_ENCODINGS[d]) {
                resultString = String.fromCharCode('0'.charCodeAt(0) + d) + resultString;
                return resultString;
            }
            throw new NotFoundException();
        }
    }
    EAN13Reader.FIRST_DIGIT_ENCODINGS = [
        0x00,
        0x0B,
        0x0D,
        0xE,
        0x13,
        0x19,
        0x1C,
        0x15,
        0x16,
        0x1A
    ];
    /**
     * <p>Implements decoding of the EAN-8 format.</p>
     *
     * @author Sean Owen
     */ class EAN8Reader extends UPCEANReader {
        constructor(){
            super();
            this.decodeMiddleCounters = Int32Array.from([
                0,
                0,
                0,
                0
            ]);
        }
        decodeMiddle(row, startRange, resultString) {
            const counters = this.decodeMiddleCounters;
            counters[0] = 0;
            counters[1] = 0;
            counters[2] = 0;
            counters[3] = 0;
            let end = row.getSize();
            let rowOffset = startRange[1];
            for(let x = 0; x < 4 && rowOffset < end; x++){
                let bestMatch = UPCEANReader.decodeDigit(row, counters, rowOffset, UPCEANReader.L_PATTERNS);
                resultString += String.fromCharCode('0'.charCodeAt(0) + bestMatch);
                for (let counter of counters)rowOffset += counter;
            }
            let middleRange = UPCEANReader.findGuardPattern(row, rowOffset, true, UPCEANReader.MIDDLE_PATTERN, new Int32Array(UPCEANReader.MIDDLE_PATTERN.length).fill(0));
            rowOffset = middleRange[1];
            for(let x = 0; x < 4 && rowOffset < end; x++){
                let bestMatch = UPCEANReader.decodeDigit(row, counters, rowOffset, UPCEANReader.L_PATTERNS);
                resultString += String.fromCharCode('0'.charCodeAt(0) + bestMatch);
                for (let counter of counters)rowOffset += counter;
            }
            return {
                rowOffset: rowOffset,
                resultString: resultString
            };
        }
        getBarcodeFormat() {
            return BarcodeFormat$1.EAN_8;
        }
    }
    /**
     * Encapsulates functionality and implementation that is common to all families
     * of one-dimensional barcodes.
     *
     * @author dswitkin@google.com (Daniel Switkin)
     * @author Sean Owen
     * @author sam2332 (Sam Rudloff)
     *
     * @source https://github.com/zxing/zxing/blob/3c96923276dd5785d58eb970b6ba3f80d36a9505/core/src/main/java/com/google/zxing/oned/UPCAReader.java
     *
     * @experimental
     */ class UPCAReader extends UPCEANReader {
        constructor(){
            super(...arguments);
            this.ean13Reader = new EAN13Reader();
        }
        // @Override
        getBarcodeFormat() {
            return BarcodeFormat$1.UPC_A;
        }
        // Note that we don't try rotation without the try harder flag, even if rotation was supported.
        // @Override
        decode(image, hints) {
            return this.maybeReturnResult(this.ean13Reader.decode(image));
        }
        // @Override
        decodeRow(rowNumber, row, hints) {
            return this.maybeReturnResult(this.ean13Reader.decodeRow(rowNumber, row, hints));
        }
        // @Override
        decodeMiddle(row, startRange, resultString) {
            return this.ean13Reader.decodeMiddle(row, startRange, resultString);
        }
        maybeReturnResult(result) {
            let text = result.getText();
            if (text.charAt(0) === '0') {
                let upcaResult = new Result(text.substring(1), null, null, result.getResultPoints(), BarcodeFormat$1.UPC_A);
                if (result.getResultMetadata() != null) upcaResult.putAllMetadata(result.getResultMetadata());
                return upcaResult;
            } else throw new NotFoundException();
        }
        reset() {
            this.ean13Reader.reset();
        }
    }
    /**
     * <p>Implements decoding of the UPC-E format.</p>
     * <p><a href="http://www.barcodeisland.com/upce.phtml">This</a> is a great reference for
     * UPC-E information.</p>
     *
     * @author Sean Owen
     *
     * @source https://github.com/zxing/zxing/blob/3c96923276dd5785d58eb970b6ba3f80d36a9505/core/src/main/java/com/google/zxing/oned/UPCEReader.java
     *
     * @experimental
     */ /* final */ class UPCEReader extends UPCEANReader {
        constructor(){
            super();
            this.decodeMiddleCounters = new Int32Array(4);
        }
        /**
         * @throws NotFoundException
         */ // @Override
        decodeMiddle(row, startRange, result) {
            const counters = this.decodeMiddleCounters.map((x)=>x);
            counters[0] = 0;
            counters[1] = 0;
            counters[2] = 0;
            counters[3] = 0;
            const end = row.getSize();
            let rowOffset = startRange[1];
            let lgPatternFound = 0;
            for(let x = 0; x < 6 && rowOffset < end; x++){
                const bestMatch = UPCEReader.decodeDigit(row, counters, rowOffset, UPCEReader.L_AND_G_PATTERNS);
                result += String.fromCharCode('0'.charCodeAt(0) + bestMatch % 10);
                for (let counter of counters)rowOffset += counter;
                if (bestMatch >= 10) lgPatternFound |= 1 << 5 - x;
            }
            let resultString = UPCEReader.determineNumSysAndCheckDigit(result, lgPatternFound);
            return {
                rowOffset: rowOffset,
                resultString: resultString
            };
        }
        /**
         * @throws NotFoundException
         */ // @Override
        decodeEnd(row, endStart) {
            return UPCEReader.findGuardPatternWithoutCounters(row, endStart, true, UPCEReader.MIDDLE_END_PATTERN);
        }
        /**
         * @throws FormatException
         */ // @Override
        checkChecksum(s) {
            return UPCEANReader.checkChecksum(UPCEReader.convertUPCEtoUPCA(s));
        }
        /**
         * @throws NotFoundException
         */ static determineNumSysAndCheckDigit(resultString, lgPatternFound) {
            for(let numSys = 0; numSys <= 1; numSys++){
                for(let d = 0; d < 10; d++)if (lgPatternFound === this.NUMSYS_AND_CHECK_DIGIT_PATTERNS[numSys][d]) {
                    let prefix = String.fromCharCode('0'.charCodeAt(0) + numSys);
                    let suffix = String.fromCharCode('0'.charCodeAt(0) + d);
                    return prefix + resultString + suffix;
                }
            }
            throw NotFoundException.getNotFoundInstance();
        }
        // @Override
        getBarcodeFormat() {
            return BarcodeFormat$1.UPC_E;
        }
        /**
         * Expands a UPC-E value back into its full, equivalent UPC-A code value.
         *
         * @param upce UPC-E code as string of digits
         * @return equivalent UPC-A code as string of digits
         */ static convertUPCEtoUPCA(upce) {
            // the following line is equivalent to upce.getChars(1, 7, upceChars, 0);
            const upceChars = upce.slice(1, 7).split('').map((x)=>x.charCodeAt(0));
            const result = new StringBuilder();
            result.append(upce.charAt(0));
            let lastChar = upceChars[5];
            switch(lastChar){
                case 0:
                case 1:
                case 2:
                    result.appendChars(upceChars, 0, 2);
                    result.append(lastChar);
                    result.append('0000');
                    result.appendChars(upceChars, 2, 3);
                    break;
                case 3:
                    result.appendChars(upceChars, 0, 3);
                    result.append('00000');
                    result.appendChars(upceChars, 3, 2);
                    break;
                case 4:
                    result.appendChars(upceChars, 0, 4);
                    result.append('00000');
                    result.append(upceChars[4]);
                    break;
                default:
                    result.appendChars(upceChars, 0, 5);
                    result.append('0000');
                    result.append(lastChar);
                    break;
            }
            // Only append check digit in conversion if supplied
            if (upce.length >= 8) result.append(upce.charAt(7));
            return result.toString();
        }
    }
    /**
     * The pattern that marks the middle, and end, of a UPC-E pattern.
     * There is no "second half" to a UPC-E barcode.
     */ UPCEReader.MIDDLE_END_PATTERN = Int32Array.from([
        1,
        1,
        1,
        1,
        1,
        1
    ]);
    // For an UPC-E barcode, the final digit is represented by the parities used
    // to encode the middle six digits, according to the table below.
    //
    //                Parity of next 6 digits
    //    Digit   0     1     2     3     4     5
    //       0    Even   Even  Even Odd  Odd   Odd
    //       1    Even   Even  Odd  Even Odd   Odd
    //       2    Even   Even  Odd  Odd  Even  Odd
    //       3    Even   Even  Odd  Odd  Odd   Even
    //       4    Even   Odd   Even Even Odd   Odd
    //       5    Even   Odd   Odd  Even Even  Odd
    //       6    Even   Odd   Odd  Odd  Even  Even
    //       7    Even   Odd   Even Odd  Even  Odd
    //       8    Even   Odd   Even Odd  Odd   Even
    //       9    Even   Odd   Odd  Even Odd   Even
    //
    // The encoding is represented by the following array, which is a bit pattern
    // using Odd = 0 and Even = 1. For example, 5 is represented by:
    //
    //              Odd Even Even Odd Odd Even
    // in binary:
    //                0    1    1   0   0    1   == 0x19
    //
    /**
     * See {@link #L_AND_G_PATTERNS}; these values similarly represent patterns of
     * even-odd parity encodings of digits that imply both the number system (0 or 1)
     * used, and the check digit.
     */ UPCEReader.NUMSYS_AND_CHECK_DIGIT_PATTERNS = [
        Int32Array.from([
            0x38,
            0x34,
            0x32,
            0x31,
            0x2C,
            0x26,
            0x23,
            0x2A,
            0x29,
            0x25
        ]),
        Int32Array.from([
            0x07,
            0x0B,
            0x0D,
            0x0E,
            0x13,
            0x19,
            0x1C,
            0x15,
            0x16,
            0x1A
        ])
    ];
    /**
     * <p>A reader that can read all available UPC/EAN formats. If a caller wants to try to
     * read all such formats, it is most efficient to use this implementation rather than invoke
     * individual readers.</p>
     *
     * @author Sean Owen
     */ class MultiFormatUPCEANReader extends OneDReader {
        constructor(hints){
            super();
            let possibleFormats = hints == null ? null : hints.get(DecodeHintType$1.POSSIBLE_FORMATS);
            let readers = [];
            if (!isNullOrUndefined(possibleFormats)) {
                if (possibleFormats.indexOf(BarcodeFormat$1.EAN_13) > -1) readers.push(new EAN13Reader());
                if (possibleFormats.indexOf(BarcodeFormat$1.UPC_A) > -1) readers.push(new UPCAReader());
                if (possibleFormats.indexOf(BarcodeFormat$1.EAN_8) > -1) readers.push(new EAN8Reader());
                if (possibleFormats.indexOf(BarcodeFormat$1.UPC_E) > -1) readers.push(new UPCEReader());
            } else {
                // No hints provided.
                readers.push(new EAN13Reader());
                readers.push(new UPCAReader());
                readers.push(new EAN8Reader());
                readers.push(new UPCEReader());
            }
            this.readers = readers;
        }
        decodeRow(rowNumber, row, hints) {
            for (let reader of this.readers)try {
                // const result: Result = reader.decodeRow(rowNumber, row, startGuardPattern, hints);
                const result = reader.decodeRow(rowNumber, row, hints);
                // Special case: a 12-digit code encoded in UPC-A is identical to a "0"
                // followed by those 12 digits encoded as EAN-13. Each will recognize such a code,
                // UPC-A as a 12-digit string and EAN-13 as a 13-digit string starting with "0".
                // Individually these are correct and their readers will both read such a code
                // and correctly call it EAN-13, or UPC-A, respectively.
                //
                // In this case, if we've been looking for both types, we'd like to call it
                // a UPC-A code. But for efficiency we only run the EAN-13 decoder to also read
                // UPC-A. So we special case it here, and convert an EAN-13 result to a UPC-A
                // result if appropriate.
                //
                // But, don't return UPC-A if UPC-A was not a requested format!
                const ean13MayBeUPCA = result.getBarcodeFormat() === BarcodeFormat$1.EAN_13 && result.getText().charAt(0) === '0';
                // @SuppressWarnings("unchecked")
                const possibleFormats = hints == null ? null : hints.get(DecodeHintType$1.POSSIBLE_FORMATS);
                const canReturnUPCA = possibleFormats == null || possibleFormats.includes(BarcodeFormat$1.UPC_A);
                if (ean13MayBeUPCA && canReturnUPCA) {
                    const rawBytes = result.getRawBytes();
                    // Transfer the metadata across
                    const resultUPCA = new Result(result.getText().substring(1), rawBytes, rawBytes ? rawBytes.length : null, result.getResultPoints(), BarcodeFormat$1.UPC_A);
                    resultUPCA.putAllMetadata(result.getResultMetadata());
                    return resultUPCA;
                }
                return result;
            } catch (err) {
            // continue;
            }
            throw new NotFoundException();
        }
        reset() {
            for (let reader of this.readers)reader.reset();
        }
    }
    // import Integer from '../../util/Integer';
    // import Float from '../../util/Float';
    class AbstractRSSReader extends OneDReader {
        constructor(){
            super();
            this.decodeFinderCounters = new Int32Array(4);
            this.dataCharacterCounters = new Int32Array(8);
            this.oddRoundingErrors = new Array(4);
            this.evenRoundingErrors = new Array(4);
            this.oddCounts = new Array(this.dataCharacterCounters.length / 2);
            this.evenCounts = new Array(this.dataCharacterCounters.length / 2);
        }
        getDecodeFinderCounters() {
            return this.decodeFinderCounters;
        }
        getDataCharacterCounters() {
            return this.dataCharacterCounters;
        }
        getOddRoundingErrors() {
            return this.oddRoundingErrors;
        }
        getEvenRoundingErrors() {
            return this.evenRoundingErrors;
        }
        getOddCounts() {
            return this.oddCounts;
        }
        getEvenCounts() {
            return this.evenCounts;
        }
        parseFinderValue(counters, finderPatterns) {
            for(let value = 0; value < finderPatterns.length; value++){
                if (OneDReader.patternMatchVariance(counters, finderPatterns[value], AbstractRSSReader.MAX_INDIVIDUAL_VARIANCE) < AbstractRSSReader.MAX_AVG_VARIANCE) return value;
            }
            throw new NotFoundException();
        }
        /**
         * @param array values to sum
         * @return sum of values
         * @deprecated call {@link MathUtils#sum(int[])}
         */ static count(array) {
            return MathUtils.sum(new Int32Array(array));
        }
        static increment(array, errors) {
            let index = 0;
            let biggestError = errors[0];
            for(let i = 1; i < array.length; i++)if (errors[i] > biggestError) {
                biggestError = errors[i];
                index = i;
            }
            array[index]++;
        }
        static decrement(array, errors) {
            let index = 0;
            let biggestError = errors[0];
            for(let i = 1; i < array.length; i++)if (errors[i] < biggestError) {
                biggestError = errors[i];
                index = i;
            }
            array[index]--;
        }
        static isFinderPattern(counters) {
            let firstTwoSum = counters[0] + counters[1];
            let sum = firstTwoSum + counters[2] + counters[3];
            let ratio = firstTwoSum / sum;
            if (ratio >= AbstractRSSReader.MIN_FINDER_PATTERN_RATIO && ratio <= AbstractRSSReader.MAX_FINDER_PATTERN_RATIO) {
                // passes ratio test in spec, but see if the counts are unreasonable
                let minCounter = Number.MAX_SAFE_INTEGER;
                let maxCounter = Number.MIN_SAFE_INTEGER;
                for (let counter of counters){
                    if (counter > maxCounter) maxCounter = counter;
                    if (counter < minCounter) minCounter = counter;
                }
                return maxCounter < 10 * minCounter;
            }
            return false;
        }
    }
    AbstractRSSReader.MAX_AVG_VARIANCE = 0.2;
    AbstractRSSReader.MAX_INDIVIDUAL_VARIANCE = 0.45;
    AbstractRSSReader.MIN_FINDER_PATTERN_RATIO = 9.5 / 12.0;
    AbstractRSSReader.MAX_FINDER_PATTERN_RATIO = 12.5 / 14.0;
    class DataCharacter {
        constructor(value, checksumPortion){
            this.value = value;
            this.checksumPortion = checksumPortion;
        }
        getValue() {
            return this.value;
        }
        getChecksumPortion() {
            return this.checksumPortion;
        }
        toString() {
            return this.value + '(' + this.checksumPortion + ')';
        }
        equals(o) {
            if (!(o instanceof DataCharacter)) return false;
            const that = o;
            return this.value === that.value && this.checksumPortion === that.checksumPortion;
        }
        hashCode() {
            return this.value ^ this.checksumPortion;
        }
    }
    class FinderPattern {
        constructor(value, startEnd, start, end, rowNumber){
            this.value = value;
            this.startEnd = startEnd;
            this.value = value;
            this.startEnd = startEnd;
            this.resultPoints = new Array();
            this.resultPoints.push(new ResultPoint(start, rowNumber));
            this.resultPoints.push(new ResultPoint(end, rowNumber));
        }
        getValue() {
            return this.value;
        }
        getStartEnd() {
            return this.startEnd;
        }
        getResultPoints() {
            return this.resultPoints;
        }
        equals(o) {
            if (!(o instanceof FinderPattern)) return false;
            const that = o;
            return this.value === that.value;
        }
        hashCode() {
            return this.value;
        }
    }
    /**
     * RSS util functions.
     */ class RSSUtils {
        constructor(){}
        static getRSSvalue(widths, maxWidth, noNarrow) {
            let n = 0;
            for (let width of widths)n += width;
            let val = 0;
            let narrowMask = 0;
            let elements = widths.length;
            for(let bar = 0; bar < elements - 1; bar++){
                let elmWidth;
                for(elmWidth = 1, narrowMask |= 1 << bar; elmWidth < widths[bar]; elmWidth++, narrowMask &= ~(1 << bar)){
                    let subVal = RSSUtils.combins(n - elmWidth - 1, elements - bar - 2);
                    if (noNarrow && narrowMask === 0 && n - elmWidth - (elements - bar - 1) >= elements - bar - 1) subVal -= RSSUtils.combins(n - elmWidth - (elements - bar), elements - bar - 2);
                    if (elements - bar - 1 > 1) {
                        let lessVal = 0;
                        for(let mxwElement = n - elmWidth - (elements - bar - 2); mxwElement > maxWidth; mxwElement--)lessVal += RSSUtils.combins(n - elmWidth - mxwElement - 1, elements - bar - 3);
                        subVal -= lessVal * (elements - 1 - bar);
                    } else if (n - elmWidth > maxWidth) subVal--;
                    val += subVal;
                }
                n -= elmWidth;
            }
            return val;
        }
        static combins(n, r) {
            let maxDenom;
            let minDenom;
            if (n - r > r) {
                minDenom = r;
                maxDenom = n - r;
            } else {
                minDenom = n - r;
                maxDenom = r;
            }
            let val = 1;
            let j = 1;
            for(let i = n; i > maxDenom; i--){
                val *= i;
                if (j <= minDenom) {
                    val /= j;
                    j++;
                }
            }
            while(j <= minDenom){
                val /= j;
                j++;
            }
            return val;
        }
    }
    class BitArrayBuilder {
        static buildBitArray(pairs) {
            let charNumber = pairs.length * 2 - 1;
            if (pairs[pairs.length - 1].getRightChar() == null) charNumber -= 1;
            let size = 12 * charNumber;
            let binary = new BitArray(size);
            let accPos = 0;
            let firstPair = pairs[0];
            let firstValue = firstPair.getRightChar().getValue();
            for(let i = 11; i >= 0; --i){
                if ((firstValue & 1 << i) != 0) binary.set(accPos);
                accPos++;
            }
            for(let i = 1; i < pairs.length; ++i){
                let currentPair = pairs[i];
                let leftValue = currentPair.getLeftChar().getValue();
                for(let j = 11; j >= 0; --j){
                    if ((leftValue & 1 << j) != 0) binary.set(accPos);
                    accPos++;
                }
                if (currentPair.getRightChar() != null) {
                    let rightValue = currentPair.getRightChar().getValue();
                    for(let j = 11; j >= 0; --j){
                        if ((rightValue & 1 << j) != 0) binary.set(accPos);
                        accPos++;
                    }
                }
            }
            return binary;
        }
    }
    class BlockParsedResult {
        constructor(finished, decodedInformation){
            if (decodedInformation) this.decodedInformation = null;
            else {
                this.finished = finished;
                this.decodedInformation = decodedInformation;
            }
        }
        getDecodedInformation() {
            return this.decodedInformation;
        }
        isFinished() {
            return this.finished;
        }
    }
    class DecodedObject {
        constructor(newPosition){
            this.newPosition = newPosition;
        }
        getNewPosition() {
            return this.newPosition;
        }
    }
    class DecodedChar extends DecodedObject {
        constructor(newPosition, value){
            super(newPosition);
            this.value = value;
        }
        getValue() {
            return this.value;
        }
        isFNC1() {
            return this.value === DecodedChar.FNC1;
        }
    }
    DecodedChar.FNC1 = '$';
    class DecodedInformation extends DecodedObject {
        constructor(newPosition, newString, remainingValue){
            super(newPosition);
            if (remainingValue) {
                this.remaining = true;
                this.remainingValue = this.remainingValue;
            } else {
                this.remaining = false;
                this.remainingValue = 0;
            }
            this.newString = newString;
        }
        getNewString() {
            return this.newString;
        }
        isRemaining() {
            return this.remaining;
        }
        getRemainingValue() {
            return this.remainingValue;
        }
    }
    class DecodedNumeric extends DecodedObject {
        constructor(newPosition, firstDigit, secondDigit){
            super(newPosition);
            if (firstDigit < 0 || firstDigit > 10 || secondDigit < 0 || secondDigit > 10) throw new FormatException();
            this.firstDigit = firstDigit;
            this.secondDigit = secondDigit;
        }
        getFirstDigit() {
            return this.firstDigit;
        }
        getSecondDigit() {
            return this.secondDigit;
        }
        getValue() {
            return this.firstDigit * 10 + this.secondDigit;
        }
        isFirstDigitFNC1() {
            return this.firstDigit === DecodedNumeric.FNC1;
        }
        isSecondDigitFNC1() {
            return this.secondDigit === DecodedNumeric.FNC1;
        }
        isAnyFNC1() {
            return this.firstDigit === DecodedNumeric.FNC1 || this.secondDigit === DecodedNumeric.FNC1;
        }
    }
    DecodedNumeric.FNC1 = 10;
    class FieldParser {
        constructor(){}
        static parseFieldsInGeneralPurpose(rawInformation) {
            if (!rawInformation) return null;
            // Processing 2-digit AIs
            if (rawInformation.length < 2) throw new NotFoundException();
            let firstTwoDigits = rawInformation.substring(0, 2);
            for (let dataLength of FieldParser.TWO_DIGIT_DATA_LENGTH)if (dataLength[0] === firstTwoDigits) {
                if (dataLength[1] === FieldParser.VARIABLE_LENGTH) return FieldParser.processVariableAI(2, dataLength[2], rawInformation);
                return FieldParser.processFixedAI(2, dataLength[1], rawInformation);
            }
            if (rawInformation.length < 3) throw new NotFoundException();
            let firstThreeDigits = rawInformation.substring(0, 3);
            for (let dataLength of FieldParser.THREE_DIGIT_DATA_LENGTH)if (dataLength[0] === firstThreeDigits) {
                if (dataLength[1] === FieldParser.VARIABLE_LENGTH) return FieldParser.processVariableAI(3, dataLength[2], rawInformation);
                return FieldParser.processFixedAI(3, dataLength[1], rawInformation);
            }
            for (let dataLength of FieldParser.THREE_DIGIT_PLUS_DIGIT_DATA_LENGTH)if (dataLength[0] === firstThreeDigits) {
                if (dataLength[1] === FieldParser.VARIABLE_LENGTH) return FieldParser.processVariableAI(4, dataLength[2], rawInformation);
                return FieldParser.processFixedAI(4, dataLength[1], rawInformation);
            }
            if (rawInformation.length < 4) throw new NotFoundException();
            let firstFourDigits = rawInformation.substring(0, 4);
            for (let dataLength of FieldParser.FOUR_DIGIT_DATA_LENGTH)if (dataLength[0] === firstFourDigits) {
                if (dataLength[1] === FieldParser.VARIABLE_LENGTH) return FieldParser.processVariableAI(4, dataLength[2], rawInformation);
                return FieldParser.processFixedAI(4, dataLength[1], rawInformation);
            }
            throw new NotFoundException();
        }
        static processFixedAI(aiSize, fieldSize, rawInformation) {
            if (rawInformation.length < aiSize) throw new NotFoundException();
            let ai = rawInformation.substring(0, aiSize);
            if (rawInformation.length < aiSize + fieldSize) throw new NotFoundException();
            let field = rawInformation.substring(aiSize, aiSize + fieldSize);
            let remaining = rawInformation.substring(aiSize + fieldSize);
            let result = '(' + ai + ')' + field;
            let parsedAI = FieldParser.parseFieldsInGeneralPurpose(remaining);
            return parsedAI == null ? result : result + parsedAI;
        }
        static processVariableAI(aiSize, variableFieldSize, rawInformation) {
            let ai = rawInformation.substring(0, aiSize);
            let maxSize;
            if (rawInformation.length < aiSize + variableFieldSize) maxSize = rawInformation.length;
            else maxSize = aiSize + variableFieldSize;
            let field = rawInformation.substring(aiSize, maxSize);
            let remaining = rawInformation.substring(maxSize);
            let result = '(' + ai + ')' + field;
            let parsedAI = FieldParser.parseFieldsInGeneralPurpose(remaining);
            return parsedAI == null ? result : result + parsedAI;
        }
    }
    FieldParser.VARIABLE_LENGTH = [];
    FieldParser.TWO_DIGIT_DATA_LENGTH = [
        [
            '00',
            18
        ],
        [
            '01',
            14
        ],
        [
            '02',
            14
        ],
        [
            '10',
            FieldParser.VARIABLE_LENGTH,
            20
        ],
        [
            '11',
            6
        ],
        [
            '12',
            6
        ],
        [
            '13',
            6
        ],
        [
            '15',
            6
        ],
        [
            '17',
            6
        ],
        [
            '20',
            2
        ],
        [
            '21',
            FieldParser.VARIABLE_LENGTH,
            20
        ],
        [
            '22',
            FieldParser.VARIABLE_LENGTH,
            29
        ],
        [
            '30',
            FieldParser.VARIABLE_LENGTH,
            8
        ],
        [
            '37',
            FieldParser.VARIABLE_LENGTH,
            8
        ],
        // internal company codes
        [
            '90',
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            '91',
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            '92',
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            '93',
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            '94',
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            '95',
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            '96',
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            '97',
            FieldParser.VARIABLE_LENGTH,
            3
        ],
        [
            '98',
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            '99',
            FieldParser.VARIABLE_LENGTH,
            30
        ]
    ];
    FieldParser.THREE_DIGIT_DATA_LENGTH = [
        // Same format as above
        [
            '240',
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            '241',
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            '242',
            FieldParser.VARIABLE_LENGTH,
            6
        ],
        [
            '250',
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            '251',
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            '253',
            FieldParser.VARIABLE_LENGTH,
            17
        ],
        [
            '254',
            FieldParser.VARIABLE_LENGTH,
            20
        ],
        [
            '400',
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            '401',
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            '402',
            17
        ],
        [
            '403',
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            '410',
            13
        ],
        [
            '411',
            13
        ],
        [
            '412',
            13
        ],
        [
            '413',
            13
        ],
        [
            '414',
            13
        ],
        [
            '420',
            FieldParser.VARIABLE_LENGTH,
            20
        ],
        [
            '421',
            FieldParser.VARIABLE_LENGTH,
            15
        ],
        [
            '422',
            3
        ],
        [
            '423',
            FieldParser.VARIABLE_LENGTH,
            15
        ],
        [
            '424',
            3
        ],
        [
            '425',
            3
        ],
        [
            '426',
            3
        ]
    ];
    FieldParser.THREE_DIGIT_PLUS_DIGIT_DATA_LENGTH = [
        // Same format as above
        [
            '310',
            6
        ],
        [
            '311',
            6
        ],
        [
            '312',
            6
        ],
        [
            '313',
            6
        ],
        [
            '314',
            6
        ],
        [
            '315',
            6
        ],
        [
            '316',
            6
        ],
        [
            '320',
            6
        ],
        [
            '321',
            6
        ],
        [
            '322',
            6
        ],
        [
            '323',
            6
        ],
        [
            '324',
            6
        ],
        [
            '325',
            6
        ],
        [
            '326',
            6
        ],
        [
            '327',
            6
        ],
        [
            '328',
            6
        ],
        [
            '329',
            6
        ],
        [
            '330',
            6
        ],
        [
            '331',
            6
        ],
        [
            '332',
            6
        ],
        [
            '333',
            6
        ],
        [
            '334',
            6
        ],
        [
            '335',
            6
        ],
        [
            '336',
            6
        ],
        [
            '340',
            6
        ],
        [
            '341',
            6
        ],
        [
            '342',
            6
        ],
        [
            '343',
            6
        ],
        [
            '344',
            6
        ],
        [
            '345',
            6
        ],
        [
            '346',
            6
        ],
        [
            '347',
            6
        ],
        [
            '348',
            6
        ],
        [
            '349',
            6
        ],
        [
            '350',
            6
        ],
        [
            '351',
            6
        ],
        [
            '352',
            6
        ],
        [
            '353',
            6
        ],
        [
            '354',
            6
        ],
        [
            '355',
            6
        ],
        [
            '356',
            6
        ],
        [
            '357',
            6
        ],
        [
            '360',
            6
        ],
        [
            '361',
            6
        ],
        [
            '362',
            6
        ],
        [
            '363',
            6
        ],
        [
            '364',
            6
        ],
        [
            '365',
            6
        ],
        [
            '366',
            6
        ],
        [
            '367',
            6
        ],
        [
            '368',
            6
        ],
        [
            '369',
            6
        ],
        [
            '390',
            FieldParser.VARIABLE_LENGTH,
            15
        ],
        [
            '391',
            FieldParser.VARIABLE_LENGTH,
            18
        ],
        [
            '392',
            FieldParser.VARIABLE_LENGTH,
            15
        ],
        [
            '393',
            FieldParser.VARIABLE_LENGTH,
            18
        ],
        [
            '703',
            FieldParser.VARIABLE_LENGTH,
            30
        ]
    ];
    FieldParser.FOUR_DIGIT_DATA_LENGTH = [
        // Same format as above
        [
            '7001',
            13
        ],
        [
            '7002',
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            '7003',
            10
        ],
        [
            '8001',
            14
        ],
        [
            '8002',
            FieldParser.VARIABLE_LENGTH,
            20
        ],
        [
            '8003',
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            '8004',
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            '8005',
            6
        ],
        [
            '8006',
            18
        ],
        [
            '8007',
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            '8008',
            FieldParser.VARIABLE_LENGTH,
            12
        ],
        [
            '8018',
            18
        ],
        [
            '8020',
            FieldParser.VARIABLE_LENGTH,
            25
        ],
        [
            '8100',
            6
        ],
        [
            '8101',
            10
        ],
        [
            '8102',
            2
        ],
        [
            '8110',
            FieldParser.VARIABLE_LENGTH,
            70
        ],
        [
            '8200',
            FieldParser.VARIABLE_LENGTH,
            70
        ]
    ];
    class GeneralAppIdDecoder {
        constructor(information){
            this.buffer = new StringBuilder();
            this.information = information;
        }
        decodeAllCodes(buff, initialPosition) {
            let currentPosition = initialPosition;
            let remaining = null;
            do {
                let info = this.decodeGeneralPurposeField(currentPosition, remaining);
                let parsedFields = FieldParser.parseFieldsInGeneralPurpose(info.getNewString());
                if (parsedFields != null) buff.append(parsedFields);
                if (info.isRemaining()) remaining = '' + info.getRemainingValue();
                else remaining = null;
                if (currentPosition === info.getNewPosition()) break;
                currentPosition = info.getNewPosition();
            }while (true);
            return buff.toString();
        }
        isStillNumeric(pos) {
            // It's numeric if it still has 7 positions
            // and one of the first 4 bits is "1".
            if (pos + 7 > this.information.getSize()) return pos + 4 <= this.information.getSize();
            for(let i = pos; i < pos + 3; ++i){
                if (this.information.get(i)) return true;
            }
            return this.information.get(pos + 3);
        }
        decodeNumeric(pos) {
            if (pos + 7 > this.information.getSize()) {
                let numeric = this.extractNumericValueFromBitArray(pos, 4);
                if (numeric === 0) return new DecodedNumeric(this.information.getSize(), DecodedNumeric.FNC1, DecodedNumeric.FNC1);
                return new DecodedNumeric(this.information.getSize(), numeric - 1, DecodedNumeric.FNC1);
            }
            let numeric = this.extractNumericValueFromBitArray(pos, 7);
            let digit1 = (numeric - 8) / 11;
            let digit2 = (numeric - 8) % 11;
            return new DecodedNumeric(pos + 7, digit1, digit2);
        }
        extractNumericValueFromBitArray(pos, bits) {
            return GeneralAppIdDecoder.extractNumericValueFromBitArray(this.information, pos, bits);
        }
        static extractNumericValueFromBitArray(information, pos, bits) {
            let value = 0;
            for(let i = 0; i < bits; ++i)if (information.get(pos + i)) value |= 1 << bits - i - 1;
            return value;
        }
        decodeGeneralPurposeField(pos, remaining) {
            // this.buffer.setLength(0);
            this.buffer.setLengthToZero();
            if (remaining != null) this.buffer.append(remaining);
            this.current.setPosition(pos);
            let lastDecoded = this.parseBlocks();
            if (lastDecoded != null && lastDecoded.isRemaining()) return new DecodedInformation(this.current.getPosition(), this.buffer.toString(), lastDecoded.getRemainingValue());
            return new DecodedInformation(this.current.getPosition(), this.buffer.toString());
        }
        parseBlocks() {
            let isFinished;
            let result;
            do {
                let initialPosition = this.current.getPosition();
                if (this.current.isAlpha()) {
                    result = this.parseAlphaBlock();
                    isFinished = result.isFinished();
                } else if (this.current.isIsoIec646()) {
                    result = this.parseIsoIec646Block();
                    isFinished = result.isFinished();
                } else {
                    result = this.parseNumericBlock();
                    isFinished = result.isFinished();
                }
                let positionChanged = initialPosition !== this.current.getPosition();
                if (!positionChanged && !isFinished) break;
            }while (!isFinished);
            return result.getDecodedInformation();
        }
        parseNumericBlock() {
            while(this.isStillNumeric(this.current.getPosition())){
                let numeric = this.decodeNumeric(this.current.getPosition());
                this.current.setPosition(numeric.getNewPosition());
                if (numeric.isFirstDigitFNC1()) {
                    let information;
                    if (numeric.isSecondDigitFNC1()) information = new DecodedInformation(this.current.getPosition(), this.buffer.toString());
                    else information = new DecodedInformation(this.current.getPosition(), this.buffer.toString(), numeric.getSecondDigit());
                    return new BlockParsedResult(true, information);
                }
                this.buffer.append(numeric.getFirstDigit());
                if (numeric.isSecondDigitFNC1()) {
                    let information = new DecodedInformation(this.current.getPosition(), this.buffer.toString());
                    return new BlockParsedResult(true, information);
                }
                this.buffer.append(numeric.getSecondDigit());
            }
            if (this.isNumericToAlphaNumericLatch(this.current.getPosition())) {
                this.current.setAlpha();
                this.current.incrementPosition(4);
            }
            return new BlockParsedResult(false);
        }
        parseIsoIec646Block() {
            while(this.isStillIsoIec646(this.current.getPosition())){
                let iso = this.decodeIsoIec646(this.current.getPosition());
                this.current.setPosition(iso.getNewPosition());
                if (iso.isFNC1()) {
                    let information = new DecodedInformation(this.current.getPosition(), this.buffer.toString());
                    return new BlockParsedResult(true, information);
                }
                this.buffer.append(iso.getValue());
            }
            if (this.isAlphaOr646ToNumericLatch(this.current.getPosition())) {
                this.current.incrementPosition(3);
                this.current.setNumeric();
            } else if (this.isAlphaTo646ToAlphaLatch(this.current.getPosition())) {
                if (this.current.getPosition() + 5 < this.information.getSize()) this.current.incrementPosition(5);
                else this.current.setPosition(this.information.getSize());
                this.current.setAlpha();
            }
            return new BlockParsedResult(false);
        }
        parseAlphaBlock() {
            while(this.isStillAlpha(this.current.getPosition())){
                let alpha = this.decodeAlphanumeric(this.current.getPosition());
                this.current.setPosition(alpha.getNewPosition());
                if (alpha.isFNC1()) {
                    let information = new DecodedInformation(this.current.getPosition(), this.buffer.toString());
                    return new BlockParsedResult(true, information); // end of the char block
                }
                this.buffer.append(alpha.getValue());
            }
            if (this.isAlphaOr646ToNumericLatch(this.current.getPosition())) {
                this.current.incrementPosition(3);
                this.current.setNumeric();
            } else if (this.isAlphaTo646ToAlphaLatch(this.current.getPosition())) {
                if (this.current.getPosition() + 5 < this.information.getSize()) this.current.incrementPosition(5);
                else this.current.setPosition(this.information.getSize());
                this.current.setIsoIec646();
            }
            return new BlockParsedResult(false);
        }
        isStillIsoIec646(pos) {
            if (pos + 5 > this.information.getSize()) return false;
            let fiveBitValue = this.extractNumericValueFromBitArray(pos, 5);
            if (fiveBitValue >= 5 && fiveBitValue < 16) return true;
            if (pos + 7 > this.information.getSize()) return false;
            let sevenBitValue = this.extractNumericValueFromBitArray(pos, 7);
            if (sevenBitValue >= 64 && sevenBitValue < 116) return true;
            if (pos + 8 > this.information.getSize()) return false;
            let eightBitValue = this.extractNumericValueFromBitArray(pos, 8);
            return eightBitValue >= 232 && eightBitValue < 253;
        }
        decodeIsoIec646(pos) {
            let fiveBitValue = this.extractNumericValueFromBitArray(pos, 5);
            if (fiveBitValue === 15) return new DecodedChar(pos + 5, DecodedChar.FNC1);
            if (fiveBitValue >= 5 && fiveBitValue < 15) return new DecodedChar(pos + 5, '0' + (fiveBitValue - 5));
            let sevenBitValue = this.extractNumericValueFromBitArray(pos, 7);
            if (sevenBitValue >= 64 && sevenBitValue < 90) return new DecodedChar(pos + 7, '' + (sevenBitValue + 1));
            if (sevenBitValue >= 90 && sevenBitValue < 116) return new DecodedChar(pos + 7, '' + (sevenBitValue + 7));
            let eightBitValue = this.extractNumericValueFromBitArray(pos, 8);
            let c;
            switch(eightBitValue){
                case 232:
                    c = '!';
                    break;
                case 233:
                    c = '"';
                    break;
                case 234:
                    c = '%';
                    break;
                case 235:
                    c = '&';
                    break;
                case 236:
                    c = '\'';
                    break;
                case 237:
                    c = '(';
                    break;
                case 238:
                    c = ')';
                    break;
                case 239:
                    c = '*';
                    break;
                case 240:
                    c = '+';
                    break;
                case 241:
                    c = ',';
                    break;
                case 242:
                    c = '-';
                    break;
                case 243:
                    c = '.';
                    break;
                case 244:
                    c = '/';
                    break;
                case 245:
                    c = ':';
                    break;
                case 246:
                    c = ';';
                    break;
                case 247:
                    c = '<';
                    break;
                case 248:
                    c = '=';
                    break;
                case 249:
                    c = '>';
                    break;
                case 250:
                    c = '?';
                    break;
                case 251:
                    c = '_';
                    break;
                case 252:
                    c = ' ';
                    break;
                default:
                    throw new FormatException();
            }
            return new DecodedChar(pos + 8, c);
        }
        isStillAlpha(pos) {
            if (pos + 5 > this.information.getSize()) return false;
            // We now check if it's a valid 5-bit value (0..9 and FNC1)
            let fiveBitValue = this.extractNumericValueFromBitArray(pos, 5);
            if (fiveBitValue >= 5 && fiveBitValue < 16) return true;
            if (pos + 6 > this.information.getSize()) return false;
            let sixBitValue = this.extractNumericValueFromBitArray(pos, 6);
            return sixBitValue >= 16 && sixBitValue < 63; // 63 not included
        }
        decodeAlphanumeric(pos) {
            let fiveBitValue = this.extractNumericValueFromBitArray(pos, 5);
            if (fiveBitValue === 15) return new DecodedChar(pos + 5, DecodedChar.FNC1);
            if (fiveBitValue >= 5 && fiveBitValue < 15) return new DecodedChar(pos + 5, '0' + (fiveBitValue - 5));
            let sixBitValue = this.extractNumericValueFromBitArray(pos, 6);
            if (sixBitValue >= 32 && sixBitValue < 58) return new DecodedChar(pos + 6, '' + (sixBitValue + 33));
            let c;
            switch(sixBitValue){
                case 58:
                    c = '*';
                    break;
                case 59:
                    c = ',';
                    break;
                case 60:
                    c = '-';
                    break;
                case 61:
                    c = '.';
                    break;
                case 62:
                    c = '/';
                    break;
                default:
                    throw new IllegalStateException('Decoding invalid alphanumeric value: ' + sixBitValue);
            }
            return new DecodedChar(pos + 6, c);
        }
        isAlphaTo646ToAlphaLatch(pos) {
            if (pos + 1 > this.information.getSize()) return false;
            for(let i = 0; i < 5 && i + pos < this.information.getSize(); ++i){
                if (i === 2) {
                    if (!this.information.get(pos + 2)) return false;
                } else if (this.information.get(pos + i)) return false;
            }
            return true;
        }
        isAlphaOr646ToNumericLatch(pos) {
            // Next is alphanumeric if there are 3 positions and they are all zeros
            if (pos + 3 > this.information.getSize()) return false;
            for(let i = pos; i < pos + 3; ++i){
                if (this.information.get(i)) return false;
            }
            return true;
        }
        isNumericToAlphaNumericLatch(pos) {
            // Next is alphanumeric if there are 4 positions and they are all zeros, or
            // if there is a subset of this just before the end of the symbol
            if (pos + 1 > this.information.getSize()) return false;
            for(let i = 0; i < 4 && i + pos < this.information.getSize(); ++i){
                if (this.information.get(pos + i)) return false;
            }
            return true;
        }
    }
    class AbstractExpandedDecoder {
        constructor(information){
            this.information = information;
            this.generalDecoder = new GeneralAppIdDecoder(information);
        }
        getInformation() {
            return this.information;
        }
        getGeneralDecoder() {
            return this.generalDecoder;
        }
    }
    class AI01decoder extends AbstractExpandedDecoder {
        constructor(information){
            super(information);
        }
        encodeCompressedGtin(buf, currentPos) {
            buf.append('(01)');
            let initialPosition = buf.length();
            buf.append('9');
            this.encodeCompressedGtinWithoutAI(buf, currentPos, initialPosition);
        }
        encodeCompressedGtinWithoutAI(buf, currentPos, initialBufferPosition) {
            for(let i = 0; i < 4; ++i){
                let currentBlock = this.getGeneralDecoder().extractNumericValueFromBitArray(currentPos + 10 * i, 10);
                if (currentBlock / 100 === 0) buf.append('0');
                if (currentBlock / 10 === 0) buf.append('0');
                buf.append(currentBlock);
            }
            AI01decoder.appendCheckDigit(buf, initialBufferPosition);
        }
        static appendCheckDigit(buf, currentPos) {
            let checkDigit = 0;
            for(let i = 0; i < 13; i++){
                // let digit = buf.charAt(i + currentPos) - '0';
                // To be checked
                let digit = buf.charAt(i + currentPos).charCodeAt(0) - '0'.charCodeAt(0);
                checkDigit += (i & 0x01) === 0 ? 3 * digit : digit;
            }
            checkDigit = 10 - checkDigit % 10;
            if (checkDigit === 10) checkDigit = 0;
            buf.append(checkDigit);
        }
    }
    AI01decoder.GTIN_SIZE = 40;
    class AI01AndOtherAIs extends AI01decoder {
        // the second one is the encodation method, and the other two are for the variable length
        constructor(information){
            super(information);
        }
        parseInformation() {
            let buff = new StringBuilder();
            buff.append('(01)');
            let initialGtinPosition = buff.length();
            let firstGtinDigit = this.getGeneralDecoder().extractNumericValueFromBitArray(AI01AndOtherAIs.HEADER_SIZE, 4);
            buff.append(firstGtinDigit);
            this.encodeCompressedGtinWithoutAI(buff, AI01AndOtherAIs.HEADER_SIZE + 4, initialGtinPosition);
            return this.getGeneralDecoder().decodeAllCodes(buff, AI01AndOtherAIs.HEADER_SIZE + 44);
        }
    }
    AI01AndOtherAIs.HEADER_SIZE = 4; // first bit encodes the linkage flag,
    class AnyAIDecoder extends AbstractExpandedDecoder {
        constructor(information){
            super(information);
        }
        parseInformation() {
            let buf = new StringBuilder();
            return this.getGeneralDecoder().decodeAllCodes(buf, AnyAIDecoder.HEADER_SIZE);
        }
    }
    AnyAIDecoder.HEADER_SIZE = 5;
    class AI01weightDecoder extends AI01decoder {
        constructor(information){
            super(information);
        }
        encodeCompressedWeight(buf, currentPos, weightSize) {
            let originalWeightNumeric = this.getGeneralDecoder().extractNumericValueFromBitArray(currentPos, weightSize);
            this.addWeightCode(buf, originalWeightNumeric);
            let weightNumeric = this.checkWeight(originalWeightNumeric);
            let currentDivisor = 100000;
            for(let i = 0; i < 5; ++i){
                if (weightNumeric / currentDivisor === 0) buf.append('0');
                currentDivisor /= 10;
            }
            buf.append(weightNumeric);
        }
    }
    class AI013x0xDecoder extends AI01weightDecoder {
        constructor(information){
            super(information);
        }
        parseInformation() {
            if (this.getInformation().getSize() != AI013x0xDecoder.HEADER_SIZE + AI01weightDecoder.GTIN_SIZE + AI013x0xDecoder.WEIGHT_SIZE) throw new NotFoundException();
            let buf = new StringBuilder();
            this.encodeCompressedGtin(buf, AI013x0xDecoder.HEADER_SIZE);
            this.encodeCompressedWeight(buf, AI013x0xDecoder.HEADER_SIZE + AI01weightDecoder.GTIN_SIZE, AI013x0xDecoder.WEIGHT_SIZE);
            return buf.toString();
        }
    }
    AI013x0xDecoder.HEADER_SIZE = 5;
    AI013x0xDecoder.WEIGHT_SIZE = 15;
    class AI013103decoder extends AI013x0xDecoder {
        constructor(information){
            super(information);
        }
        addWeightCode(buf, weight) {
            buf.append('(3103)');
        }
        checkWeight(weight) {
            return weight;
        }
    }
    class AI01320xDecoder extends AI013x0xDecoder {
        constructor(information){
            super(information);
        }
        addWeightCode(buf, weight) {
            if (weight < 10000) buf.append('(3202)');
            else buf.append('(3203)');
        }
        checkWeight(weight) {
            if (weight < 10000) return weight;
            return weight - 10000;
        }
    }
    class AI01392xDecoder extends AI01decoder {
        constructor(information){
            super(information);
        }
        parseInformation() {
            if (this.getInformation().getSize() < AI01392xDecoder.HEADER_SIZE + AI01decoder.GTIN_SIZE) throw new NotFoundException();
            let buf = new StringBuilder();
            this.encodeCompressedGtin(buf, AI01392xDecoder.HEADER_SIZE);
            let lastAIdigit = this.getGeneralDecoder().extractNumericValueFromBitArray(AI01392xDecoder.HEADER_SIZE + AI01decoder.GTIN_SIZE, AI01392xDecoder.LAST_DIGIT_SIZE);
            buf.append('(392');
            buf.append(lastAIdigit);
            buf.append(')');
            let decodedInformation = this.getGeneralDecoder().decodeGeneralPurposeField(AI01392xDecoder.HEADER_SIZE + AI01decoder.GTIN_SIZE + AI01392xDecoder.LAST_DIGIT_SIZE, null);
            buf.append(decodedInformation.getNewString());
            return buf.toString();
        }
    }
    AI01392xDecoder.HEADER_SIZE = 8;
    AI01392xDecoder.LAST_DIGIT_SIZE = 2;
    class AI01393xDecoder extends AI01decoder {
        constructor(information){
            super(information);
        }
        parseInformation() {
            if (this.getInformation().getSize() < AI01393xDecoder.HEADER_SIZE + AI01decoder.GTIN_SIZE) throw new NotFoundException();
            let buf = new StringBuilder();
            this.encodeCompressedGtin(buf, AI01393xDecoder.HEADER_SIZE);
            let lastAIdigit = this.getGeneralDecoder().extractNumericValueFromBitArray(AI01393xDecoder.HEADER_SIZE + AI01decoder.GTIN_SIZE, AI01393xDecoder.LAST_DIGIT_SIZE);
            buf.append('(393');
            buf.append(lastAIdigit);
            buf.append(')');
            let firstThreeDigits = this.getGeneralDecoder().extractNumericValueFromBitArray(AI01393xDecoder.HEADER_SIZE + AI01decoder.GTIN_SIZE + AI01393xDecoder.LAST_DIGIT_SIZE, AI01393xDecoder.FIRST_THREE_DIGITS_SIZE);
            if (firstThreeDigits / 100 == 0) buf.append('0');
            if (firstThreeDigits / 10 == 0) buf.append('0');
            buf.append(firstThreeDigits);
            let generalInformation = this.getGeneralDecoder().decodeGeneralPurposeField(AI01393xDecoder.HEADER_SIZE + AI01decoder.GTIN_SIZE + AI01393xDecoder.LAST_DIGIT_SIZE + AI01393xDecoder.FIRST_THREE_DIGITS_SIZE, null);
            buf.append(generalInformation.getNewString());
            return buf.toString();
        }
    }
    AI01393xDecoder.HEADER_SIZE = 8;
    AI01393xDecoder.LAST_DIGIT_SIZE = 2;
    AI01393xDecoder.FIRST_THREE_DIGITS_SIZE = 10;
    class AI013x0x1xDecoder extends AI01weightDecoder {
        constructor(information, firstAIdigits, dateCode){
            super(information);
            this.dateCode = dateCode;
            this.firstAIdigits = firstAIdigits;
        }
        parseInformation() {
            if (this.getInformation().getSize() != AI013x0x1xDecoder.HEADER_SIZE + AI013x0x1xDecoder.GTIN_SIZE + AI013x0x1xDecoder.WEIGHT_SIZE + AI013x0x1xDecoder.DATE_SIZE) throw new NotFoundException();
            let buf = new StringBuilder();
            this.encodeCompressedGtin(buf, AI013x0x1xDecoder.HEADER_SIZE);
            this.encodeCompressedWeight(buf, AI013x0x1xDecoder.HEADER_SIZE + AI013x0x1xDecoder.GTIN_SIZE, AI013x0x1xDecoder.WEIGHT_SIZE);
            this.encodeCompressedDate(buf, AI013x0x1xDecoder.HEADER_SIZE + AI013x0x1xDecoder.GTIN_SIZE + AI013x0x1xDecoder.WEIGHT_SIZE);
            return buf.toString();
        }
        encodeCompressedDate(buf, currentPos) {
            let numericDate = this.getGeneralDecoder().extractNumericValueFromBitArray(currentPos, AI013x0x1xDecoder.DATE_SIZE);
            if (numericDate == 38400) return;
            buf.append('(');
            buf.append(this.dateCode);
            buf.append(')');
            let day = numericDate % 32;
            numericDate /= 32;
            let month = numericDate % 12 + 1;
            numericDate /= 12;
            let year = numericDate;
            if (year / 10 == 0) buf.append('0');
            buf.append(year);
            if (month / 10 == 0) buf.append('0');
            buf.append(month);
            if (day / 10 == 0) buf.append('0');
            buf.append(day);
        }
        addWeightCode(buf, weight) {
            buf.append('(');
            buf.append(this.firstAIdigits);
            buf.append(weight / 100000);
            buf.append(')');
        }
        checkWeight(weight) {
            return weight % 100000;
        }
    }
    AI013x0x1xDecoder.HEADER_SIZE = 8;
    AI013x0x1xDecoder.WEIGHT_SIZE = 20;
    AI013x0x1xDecoder.DATE_SIZE = 16;
    function createDecoder(information) {
        try {
            if (information.get(1)) return new AI01AndOtherAIs(information);
            if (!information.get(2)) return new AnyAIDecoder(information);
            let fourBitEncodationMethod = GeneralAppIdDecoder.extractNumericValueFromBitArray(information, 1, 4);
            switch(fourBitEncodationMethod){
                case 4:
                    return new AI013103decoder(information);
                case 5:
                    return new AI01320xDecoder(information);
            }
            let fiveBitEncodationMethod = GeneralAppIdDecoder.extractNumericValueFromBitArray(information, 1, 5);
            switch(fiveBitEncodationMethod){
                case 12:
                    return new AI01392xDecoder(information);
                case 13:
                    return new AI01393xDecoder(information);
            }
            let sevenBitEncodationMethod = GeneralAppIdDecoder.extractNumericValueFromBitArray(information, 1, 7);
            switch(sevenBitEncodationMethod){
                case 56:
                    return new AI013x0x1xDecoder(information, '310', '11');
                case 57:
                    return new AI013x0x1xDecoder(information, '320', '11');
                case 58:
                    return new AI013x0x1xDecoder(information, '310', '13');
                case 59:
                    return new AI013x0x1xDecoder(information, '320', '13');
                case 60:
                    return new AI013x0x1xDecoder(information, '310', '15');
                case 61:
                    return new AI013x0x1xDecoder(information, '320', '15');
                case 62:
                    return new AI013x0x1xDecoder(information, '310', '17');
                case 63:
                    return new AI013x0x1xDecoder(information, '320', '17');
            }
        } catch (e) {
            console.log(e);
            throw new IllegalStateException('unknown decoder: ' + information);
        }
    }
    class ExpandedPair {
        constructor(leftChar, rightChar, finderPatter, mayBeLast){
            this.leftchar = leftChar;
            this.rightchar = rightChar;
            this.finderpattern = finderPatter;
            this.maybeLast = mayBeLast;
        }
        mayBeLast() {
            return this.maybeLast;
        }
        getLeftChar() {
            return this.leftchar;
        }
        getRightChar() {
            return this.rightchar;
        }
        getFinderPattern() {
            return this.finderpattern;
        }
        mustBeLast() {
            return this.rightchar == null;
        }
        toString() {
            return '[ ' + this.leftchar + ', ' + this.rightchar + ' : ' + (this.finderpattern == null ? 'null' : this.finderpattern.getValue()) + ' ]';
        }
        static equals(o1, o2) {
            if (!(o1 instanceof ExpandedPair)) return false;
            return ExpandedPair.equalsOrNull(o1.leftchar, o2.leftchar) && ExpandedPair.equalsOrNull(o1.rightchar, o2.rightchar) && ExpandedPair.equalsOrNull(o1.finderpattern, o2.finderpattern);
        }
        static equalsOrNull(o1, o2) {
            return o1 === null ? o2 === null : ExpandedPair.equals(o1, o2);
        }
        hashCode() {
            // return ExpandedPair.hashNotNull(leftChar) ^ hashNotNull(rightChar) ^ hashNotNull(finderPattern);
            let value = this.leftchar.getValue() ^ this.rightchar.getValue() ^ this.finderpattern.getValue();
            return value;
        }
    }
    class ExpandedRow {
        constructor(pairs, rowNumber, wasReversed){
            this.pairs = pairs;
            this.rowNumber = rowNumber;
            this.wasReversed = wasReversed;
        }
        getPairs() {
            return this.pairs;
        }
        getRowNumber() {
            return this.rowNumber;
        }
        isReversed() {
            return this.wasReversed;
        }
        // check implementation
        isEquivalent(otherPairs) {
            return this.checkEqualitity(this, otherPairs);
        }
        // @Override
        toString() {
            return '{ ' + this.pairs + ' }';
        }
        /**
         * Two rows are equal if they contain the same pairs in the same order.
         */ // @Override
        // check implementation
        equals(o1, o2) {
            if (!(o1 instanceof ExpandedRow)) return false;
            return this.checkEqualitity(o1, o2) && o1.wasReversed === o2.wasReversed;
        }
        checkEqualitity(pair1, pair2) {
            if (!pair1 || !pair2) return;
            let result;
            pair1.forEach((e1, i)=>{
                pair2.forEach((e2)=>{
                    if (e1.getLeftChar().getValue() === e2.getLeftChar().getValue() && e1.getRightChar().getValue() === e2.getRightChar().getValue() && e1.getFinderPatter().getValue() === e2.getFinderPatter().getValue()) result = true;
                });
            });
            return result;
        }
    }
    // import java.util.ArrayList;
    // import java.util.Iterator;
    // import java.util.List;
    // import java.util.Map;
    // import java.util.Collections;
    class RSSExpandedReader extends AbstractRSSReader {
        constructor(verbose){
            super(...arguments);
            this.pairs = new Array(RSSExpandedReader.MAX_PAIRS);
            this.rows = new Array();
            this.startEnd = [
                2
            ];
            this.verbose = verbose === true;
        }
        decodeRow(rowNumber, row, hints) {
            // Rows can start with even pattern in case in prev rows there where odd number of patters.
            // So lets try twice
            // this.pairs.clear();
            this.pairs.length = 0;
            this.startFromEven = false;
            try {
                return RSSExpandedReader.constructResult(this.decodeRow2pairs(rowNumber, row));
            } catch (e) {
                // OK
                if (this.verbose) console.log(e);
            }
            this.pairs.length = 0;
            this.startFromEven = true;
            return RSSExpandedReader.constructResult(this.decodeRow2pairs(rowNumber, row));
        }
        reset() {
            this.pairs.length = 0;
            this.rows.length = 0;
        }
        // Not private for testing
        decodeRow2pairs(rowNumber, row) {
            let done = false;
            while(!done)try {
                this.pairs.push(this.retrieveNextPair(row, this.pairs, rowNumber));
            } catch (error) {
                if (error instanceof NotFoundException) {
                    if (!this.pairs.length) throw new NotFoundException();
                    // exit this loop when retrieveNextPair() fails and throws
                    done = true;
                }
            }
            // TODO: verify sequence of finder patterns as in checkPairSequence()
            if (this.checkChecksum()) return this.pairs;
            let tryStackedDecode;
            if (this.rows.length) tryStackedDecode = true;
            else tryStackedDecode = false;
            // let tryStackedDecode = !this.rows.isEmpty();
            this.storeRow(rowNumber, false); // TODO: deal with reversed rows
            if (tryStackedDecode) {
                // When the image is 180-rotated, then rows are sorted in wrong direction.
                // Try twice with both the directions.
                let ps = this.checkRowsBoolean(false);
                if (ps != null) return ps;
                ps = this.checkRowsBoolean(true);
                if (ps != null) return ps;
            }
            throw new NotFoundException();
        }
        // Need to Verify
        checkRowsBoolean(reverse) {
            // Limit number of rows we are checking
            // We use recursive algorithm with pure complexity and don't want it to take forever
            // Stacked barcode can have up to 11 rows, so 25 seems reasonable enough
            if (this.rows.length > 25) {
                this.rows.length = 0; // We will never have a chance to get result, so clear it
                return null;
            }
            this.pairs.length = 0;
            if (reverse) this.rows = this.rows.reverse();
            let ps = null;
            try {
                ps = this.checkRows(new Array(), 0);
            } catch (e) {
                // OK
                if (this.verbose) console.log(e);
            }
            if (reverse) this.rows = this.rows.reverse();
            return ps;
        }
        // Try to construct a valid rows sequence
        // Recursion is used to implement backtracking
        checkRows(collectedRows, currentRow) {
            for(let i = currentRow; i < this.rows.length; i++){
                let row = this.rows[i];
                this.pairs.length = 0;
                for (let collectedRow of collectedRows)this.pairs.push(collectedRow.getPairs());
                this.pairs.push(row.getPairs());
                if (!RSSExpandedReader.isValidSequence(this.pairs)) continue;
                if (this.checkChecksum()) return this.pairs;
                let rs = new Array(collectedRows);
                rs.push(row);
                try {
                    // Recursion: try to add more rows
                    return this.checkRows(rs, i + 1);
                } catch (e) {
                    // We failed, try the next candidate
                    if (this.verbose) console.log(e);
                }
            }
            throw new NotFoundException();
        }
        // Whether the pairs form a valid find pattern sequence,
        // either complete or a prefix
        static isValidSequence(pairs) {
            for (let sequence of RSSExpandedReader.FINDER_PATTERN_SEQUENCES){
                if (pairs.length > sequence.length) continue;
                let stop = true;
                for(let j = 0; j < pairs.length; j++)if (pairs[j].getFinderPattern().getValue() != sequence[j]) {
                    stop = false;
                    break;
                }
                if (stop) return true;
            }
            return false;
        }
        storeRow(rowNumber, wasReversed) {
            // Discard if duplicate above or below; otherwise insert in order by row number.
            let insertPos = 0;
            let prevIsSame = false;
            let nextIsSame = false;
            while(insertPos < this.rows.length){
                let erow = this.rows[insertPos];
                if (erow.getRowNumber() > rowNumber) {
                    nextIsSame = erow.isEquivalent(this.pairs);
                    break;
                }
                prevIsSame = erow.isEquivalent(this.pairs);
                insertPos++;
            }
            if (nextIsSame || prevIsSame) return;
            // When the row was partially decoded (e.g. 2 pairs found instead of 3),
            // it will prevent us from detecting the barcode.
            // Try to merge partial rows
            // Check whether the row is part of an allready detected row
            if (RSSExpandedReader.isPartialRow(this.pairs, this.rows)) return;
            this.rows.push(insertPos, new ExpandedRow(this.pairs, rowNumber, wasReversed));
            this.removePartialRows(this.pairs, this.rows);
        }
        // Remove all the rows that contains only specified pairs
        removePartialRows(pairs, rows) {
            // for (Iterator<ExpandedRow> iterator = rows.iterator(); iterator.hasNext();) {
            //   ExpandedRow r = iterator.next();
            //   if (r.getPairs().size() == pairs.size()) {
            //     continue;
            //   }
            //   boolean allFound = true;
            //   for (ExpandedPair p : r.getPairs()) {
            //     boolean found = false;
            //     for (ExpandedPair pp : pairs) {
            //       if (p.equals(pp)) {
            //         found = true;
            //         break;
            //       }
            //     }
            //     if (!found) {
            //       allFound = false;
            //       break;
            //     }
            //   }
            //   if (allFound) {
            //     // 'pairs' contains all the pairs from the row 'r'
            //     iterator.remove();
            //   }
            // }
            for (let row of rows){
                if (row.getPairs().length === pairs.length) continue;
                for (let p of row.getPairs())for (let pp of pairs){
                    if (ExpandedPair.equals(p, pp)) break;
                }
            }
        }
        // Returns true when one of the rows already contains all the pairs
        static isPartialRow(pairs, rows) {
            for (let r of rows){
                let allFound = true;
                for (let p of pairs){
                    let found = false;
                    for (let pp of r.getPairs())if (p.equals(pp)) {
                        found = true;
                        break;
                    }
                    if (!found) {
                        allFound = false;
                        break;
                    }
                }
                if (allFound) // the row 'r' contain all the pairs from 'pairs'
                return true;
            }
            return false;
        }
        // Only used for unit testing
        getRows() {
            return this.rows;
        }
        // Not private for unit testing
        static constructResult(pairs) {
            let binary = BitArrayBuilder.buildBitArray(pairs);
            let decoder = createDecoder(binary);
            let resultingString = decoder.parseInformation();
            let firstPoints = pairs[0].getFinderPattern().getResultPoints();
            let lastPoints = pairs[pairs.length - 1].getFinderPattern().getResultPoints();
            let points = [
                firstPoints[0],
                firstPoints[1],
                lastPoints[0],
                lastPoints[1]
            ];
            return new Result(resultingString, null, null, points, BarcodeFormat$1.RSS_EXPANDED, null);
        }
        checkChecksum() {
            let firstPair = this.pairs.get(0);
            let checkCharacter = firstPair.getLeftChar();
            let firstCharacter = firstPair.getRightChar();
            if (firstCharacter == null) return false;
            let checksum = firstCharacter.getChecksumPortion();
            let s = 2;
            for(let i = 1; i < this.pairs.size(); ++i){
                let currentPair = this.pairs.get(i);
                checksum += currentPair.getLeftChar().getChecksumPortion();
                s++;
                let currentRightChar = currentPair.getRightChar();
                if (currentRightChar != null) {
                    checksum += currentRightChar.getChecksumPortion();
                    s++;
                }
            }
            checksum %= 211;
            let checkCharacterValue = 211 * (s - 4) + checksum;
            return checkCharacterValue == checkCharacter.getValue();
        }
        static getNextSecondBar(row, initialPos) {
            let currentPos;
            if (row.get(initialPos)) {
                currentPos = row.getNextUnset(initialPos);
                currentPos = row.getNextSet(currentPos);
            } else {
                currentPos = row.getNextSet(initialPos);
                currentPos = row.getNextUnset(currentPos);
            }
            return currentPos;
        }
        // not private for testing
        retrieveNextPair(row, previousPairs, rowNumber) {
            let isOddPattern = previousPairs.length % 2 == 0;
            if (this.startFromEven) isOddPattern = !isOddPattern;
            let pattern;
            let keepFinding = true;
            let forcedOffset = -1;
            do {
                this.findNextPair(row, previousPairs, forcedOffset);
                pattern = this.parseFoundFinderPattern(row, rowNumber, isOddPattern);
                if (pattern == null) forcedOffset = RSSExpandedReader.getNextSecondBar(row, this.startEnd[0]);
                else keepFinding = false;
            }while (keepFinding);
            // When stacked symbol is split over multiple rows, there's no way to guess if this pair can be last or not.
            // boolean mayBeLast = checkPairSequence(previousPairs, pattern);
            let leftChar = this.decodeDataCharacter(row, pattern, isOddPattern, true);
            if (!this.isEmptyPair(previousPairs) && previousPairs[previousPairs.length - 1].mustBeLast()) throw new NotFoundException();
            let rightChar;
            try {
                rightChar = this.decodeDataCharacter(row, pattern, isOddPattern, false);
            } catch (e) {
                rightChar = null;
                if (this.verbose) console.log(e);
            }
            return new ExpandedPair(leftChar, rightChar, pattern, true);
        }
        isEmptyPair(pairs) {
            if (pairs.length === 0) return true;
            return false;
        }
        findNextPair(row, previousPairs, forcedOffset) {
            let counters = this.getDecodeFinderCounters();
            counters[0] = 0;
            counters[1] = 0;
            counters[2] = 0;
            counters[3] = 0;
            let width = row.getSize();
            let rowOffset;
            if (forcedOffset >= 0) rowOffset = forcedOffset;
            else if (this.isEmptyPair(previousPairs)) rowOffset = 0;
            else {
                let lastPair = previousPairs[previousPairs.length - 1];
                rowOffset = lastPair.getFinderPattern().getStartEnd()[1];
            }
            let searchingEvenPair = previousPairs.length % 2 != 0;
            if (this.startFromEven) searchingEvenPair = !searchingEvenPair;
            let isWhite = false;
            while(rowOffset < width){
                isWhite = !row.get(rowOffset);
                if (!isWhite) break;
                rowOffset++;
            }
            let counterPosition = 0;
            let patternStart = rowOffset;
            for(let x = rowOffset; x < width; x++)if (row.get(x) != isWhite) counters[counterPosition]++;
            else {
                if (counterPosition == 3) {
                    if (searchingEvenPair) RSSExpandedReader.reverseCounters(counters);
                    if (RSSExpandedReader.isFinderPattern(counters)) {
                        this.startEnd[0] = patternStart;
                        this.startEnd[1] = x;
                        return;
                    }
                    if (searchingEvenPair) RSSExpandedReader.reverseCounters(counters);
                    patternStart += counters[0] + counters[1];
                    counters[0] = counters[2];
                    counters[1] = counters[3];
                    counters[2] = 0;
                    counters[3] = 0;
                    counterPosition--;
                } else counterPosition++;
                counters[counterPosition] = 1;
                isWhite = !isWhite;
            }
            throw new NotFoundException();
        }
        static reverseCounters(counters) {
            let length = counters.length;
            for(let i = 0; i < length / 2; ++i){
                let tmp = counters[i];
                counters[i] = counters[length - i - 1];
                counters[length - i - 1] = tmp;
            }
        }
        parseFoundFinderPattern(row, rowNumber, oddPattern) {
            // Actually we found elements 2-5.
            let firstCounter;
            let start;
            let end;
            if (oddPattern) {
                // If pattern number is odd, we need to locate element 1 *before* the current block.
                let firstElementStart = this.startEnd[0] - 1;
                // Locate element 1
                while(firstElementStart >= 0 && !row.get(firstElementStart))firstElementStart--;
                firstElementStart++;
                firstCounter = this.startEnd[0] - firstElementStart;
                start = firstElementStart;
                end = this.startEnd[1];
            } else {
                // If pattern number is even, the pattern is reversed, so we need to locate element 1 *after* the current block.
                start = this.startEnd[0];
                end = row.getNextUnset(this.startEnd[1] + 1);
                firstCounter = end - this.startEnd[1];
            }
            // Make 'counters' hold 1-4
            let counters = this.getDecodeFinderCounters();
            System.arraycopy(counters, 0, counters, 1, counters.length - 1);
            counters[0] = firstCounter;
            let value;
            try {
                value = this.parseFinderValue(counters, RSSExpandedReader.FINDER_PATTERNS);
            } catch (e) {
                return null;
            }
            // return new FinderPattern(value, new int[] { start, end }, start, end, rowNumber});
            return new FinderPattern(value, [
                start,
                end
            ], start, end, rowNumber);
        }
        decodeDataCharacter(row, pattern, isOddPattern, leftChar) {
            let counters = this.getDataCharacterCounters();
            for(let x = 0; x < counters.length; x++)counters[x] = 0;
            if (leftChar) RSSExpandedReader.recordPatternInReverse(row, pattern.getStartEnd()[0], counters);
            else {
                RSSExpandedReader.recordPattern(row, pattern.getStartEnd()[1], counters);
                // reverse it
                for(let i = 0, j = counters.length - 1; i < j; i++, j--){
                    let temp = counters[i];
                    counters[i] = counters[j];
                    counters[j] = temp;
                }
            } // counters[] has the pixels of the module
            let numModules = 17; // left and right data characters have all the same length
            let elementWidth = MathUtils.sum(new Int32Array(counters)) / numModules;
            // Sanity check: element width for pattern and the character should match
            let expectedElementWidth = (pattern.getStartEnd()[1] - pattern.getStartEnd()[0]) / 15.0;
            if (Math.abs(elementWidth - expectedElementWidth) / expectedElementWidth > 0.3) throw new NotFoundException();
            let oddCounts = this.getOddCounts();
            let evenCounts = this.getEvenCounts();
            let oddRoundingErrors = this.getOddRoundingErrors();
            let evenRoundingErrors = this.getEvenRoundingErrors();
            for(let i = 0; i < counters.length; i++){
                let value = 1.0 * counters[i] / elementWidth;
                let count = value + 0.5; // Round
                if (count < 1) {
                    if (value < 0.3) throw new NotFoundException();
                    count = 1;
                } else if (count > 8) {
                    if (value > 8.7) throw new NotFoundException();
                    count = 8;
                }
                let offset = i / 2;
                if ((i & 0x01) == 0) {
                    oddCounts[offset] = count;
                    oddRoundingErrors[offset] = value - count;
                } else {
                    evenCounts[offset] = count;
                    evenRoundingErrors[offset] = value - count;
                }
            }
            this.adjustOddEvenCounts(numModules);
            let weightRowNumber = 4 * pattern.getValue() + (isOddPattern ? 0 : 2) + (leftChar ? 0 : 1) - 1;
            let oddSum = 0;
            let oddChecksumPortion = 0;
            for(let i = oddCounts.length - 1; i >= 0; i--){
                if (RSSExpandedReader.isNotA1left(pattern, isOddPattern, leftChar)) {
                    let weight = RSSExpandedReader.WEIGHTS[weightRowNumber][2 * i];
                    oddChecksumPortion += oddCounts[i] * weight;
                }
                oddSum += oddCounts[i];
            }
            let evenChecksumPortion = 0;
            // int evenSum = 0;
            for(let i = evenCounts.length - 1; i >= 0; i--)if (RSSExpandedReader.isNotA1left(pattern, isOddPattern, leftChar)) {
                let weight = RSSExpandedReader.WEIGHTS[weightRowNumber][2 * i + 1];
                evenChecksumPortion += evenCounts[i] * weight;
            }
            let checksumPortion = oddChecksumPortion + evenChecksumPortion;
            if ((oddSum & 0x01) != 0 || oddSum > 13 || oddSum < 4) throw new NotFoundException();
            let group = (13 - oddSum) / 2;
            let oddWidest = RSSExpandedReader.SYMBOL_WIDEST[group];
            let evenWidest = 9 - oddWidest;
            let vOdd = RSSUtils.getRSSvalue(oddCounts, oddWidest, true);
            let vEven = RSSUtils.getRSSvalue(evenCounts, evenWidest, false);
            let tEven = RSSExpandedReader.EVEN_TOTAL_SUBSET[group];
            let gSum = RSSExpandedReader.GSUM[group];
            let value = vOdd * tEven + vEven + gSum;
            return new DataCharacter(value, checksumPortion);
        }
        static isNotA1left(pattern, isOddPattern, leftChar) {
            // A1: pattern.getValue is 0 (A), and it's an oddPattern, and it is a left char
            return !(pattern.getValue() == 0 && isOddPattern && leftChar);
        }
        adjustOddEvenCounts(numModules) {
            let oddSum = MathUtils.sum(new Int32Array(this.getOddCounts()));
            let evenSum = MathUtils.sum(new Int32Array(this.getEvenCounts()));
            let incrementOdd = false;
            let decrementOdd = false;
            if (oddSum > 13) decrementOdd = true;
            else if (oddSum < 4) incrementOdd = true;
            let incrementEven = false;
            let decrementEven = false;
            if (evenSum > 13) decrementEven = true;
            else if (evenSum < 4) incrementEven = true;
            let mismatch = oddSum + evenSum - numModules;
            let oddParityBad = (oddSum & 0x01) == 1;
            let evenParityBad = (evenSum & 0x01) == 0;
            if (mismatch == 1) {
                if (oddParityBad) {
                    if (evenParityBad) throw new NotFoundException();
                    decrementOdd = true;
                } else {
                    if (!evenParityBad) throw new NotFoundException();
                    decrementEven = true;
                }
            } else if (mismatch == -1) {
                if (oddParityBad) {
                    if (evenParityBad) throw new NotFoundException();
                    incrementOdd = true;
                } else {
                    if (!evenParityBad) throw new NotFoundException();
                    incrementEven = true;
                }
            } else if (mismatch == 0) {
                if (oddParityBad) {
                    if (!evenParityBad) throw new NotFoundException();
                    // Both bad
                    if (oddSum < evenSum) {
                        incrementOdd = true;
                        decrementEven = true;
                    } else {
                        decrementOdd = true;
                        incrementEven = true;
                    }
                } else {
                    if (evenParityBad) throw new NotFoundException();
                // Nothing to do!
                }
            } else throw new NotFoundException();
            if (incrementOdd) {
                if (decrementOdd) throw new NotFoundException();
                RSSExpandedReader.increment(this.getOddCounts(), this.getOddRoundingErrors());
            }
            if (decrementOdd) RSSExpandedReader.decrement(this.getOddCounts(), this.getOddRoundingErrors());
            if (incrementEven) {
                if (decrementEven) throw new NotFoundException();
                RSSExpandedReader.increment(this.getEvenCounts(), this.getOddRoundingErrors());
            }
            if (decrementEven) RSSExpandedReader.decrement(this.getEvenCounts(), this.getEvenRoundingErrors());
        }
    }
    RSSExpandedReader.SYMBOL_WIDEST = [
        7,
        5,
        4,
        3,
        1
    ];
    RSSExpandedReader.EVEN_TOTAL_SUBSET = [
        4,
        20,
        52,
        104,
        204
    ];
    RSSExpandedReader.GSUM = [
        0,
        348,
        1388,
        2948,
        3988
    ];
    RSSExpandedReader.FINDER_PATTERNS = [
        Int32Array.from([
            1,
            8,
            4,
            1
        ]),
        Int32Array.from([
            3,
            6,
            4,
            1
        ]),
        Int32Array.from([
            3,
            4,
            6,
            1
        ]),
        Int32Array.from([
            3,
            2,
            8,
            1
        ]),
        Int32Array.from([
            2,
            6,
            5,
            1
        ]),
        Int32Array.from([
            2,
            2,
            9,
            1
        ]) // F
    ];
    RSSExpandedReader.WEIGHTS = [
        [
            1,
            3,
            9,
            27,
            81,
            32,
            96,
            77
        ],
        [
            20,
            60,
            180,
            118,
            143,
            7,
            21,
            63
        ],
        [
            189,
            145,
            13,
            39,
            117,
            140,
            209,
            205
        ],
        [
            193,
            157,
            49,
            147,
            19,
            57,
            171,
            91
        ],
        [
            62,
            186,
            136,
            197,
            169,
            85,
            44,
            132
        ],
        [
            185,
            133,
            188,
            142,
            4,
            12,
            36,
            108
        ],
        [
            113,
            128,
            173,
            97,
            80,
            29,
            87,
            50
        ],
        [
            150,
            28,
            84,
            41,
            123,
            158,
            52,
            156
        ],
        [
            46,
            138,
            203,
            187,
            139,
            206,
            196,
            166
        ],
        [
            76,
            17,
            51,
            153,
            37,
            111,
            122,
            155
        ],
        [
            43,
            129,
            176,
            106,
            107,
            110,
            119,
            146
        ],
        [
            16,
            48,
            144,
            10,
            30,
            90,
            59,
            177
        ],
        [
            109,
            116,
            137,
            200,
            178,
            112,
            125,
            164
        ],
        [
            70,
            210,
            208,
            202,
            184,
            130,
            179,
            115
        ],
        [
            134,
            191,
            151,
            31,
            93,
            68,
            204,
            190
        ],
        [
            148,
            22,
            66,
            198,
            172,
            94,
            71,
            2
        ],
        [
            6,
            18,
            54,
            162,
            64,
            192,
            154,
            40
        ],
        [
            120,
            149,
            25,
            75,
            14,
            42,
            126,
            167
        ],
        [
            79,
            26,
            78,
            23,
            69,
            207,
            199,
            175
        ],
        [
            103,
            98,
            83,
            38,
            114,
            131,
            182,
            124
        ],
        [
            161,
            61,
            183,
            127,
            170,
            88,
            53,
            159
        ],
        [
            55,
            165,
            73,
            8,
            24,
            72,
            5,
            15
        ],
        [
            45,
            135,
            194,
            160,
            58,
            174,
            100,
            89
        ]
    ];
    RSSExpandedReader.FINDER_PAT_A = 0;
    RSSExpandedReader.FINDER_PAT_B = 1;
    RSSExpandedReader.FINDER_PAT_C = 2;
    RSSExpandedReader.FINDER_PAT_D = 3;
    RSSExpandedReader.FINDER_PAT_E = 4;
    RSSExpandedReader.FINDER_PAT_F = 5;
    RSSExpandedReader.FINDER_PATTERN_SEQUENCES = [
        [
            RSSExpandedReader.FINDER_PAT_A,
            RSSExpandedReader.FINDER_PAT_A
        ],
        [
            RSSExpandedReader.FINDER_PAT_A,
            RSSExpandedReader.FINDER_PAT_B,
            RSSExpandedReader.FINDER_PAT_B
        ],
        [
            RSSExpandedReader.FINDER_PAT_A,
            RSSExpandedReader.FINDER_PAT_C,
            RSSExpandedReader.FINDER_PAT_B,
            RSSExpandedReader.FINDER_PAT_D
        ],
        [
            RSSExpandedReader.FINDER_PAT_A,
            RSSExpandedReader.FINDER_PAT_E,
            RSSExpandedReader.FINDER_PAT_B,
            RSSExpandedReader.FINDER_PAT_D,
            RSSExpandedReader.FINDER_PAT_C
        ],
        [
            RSSExpandedReader.FINDER_PAT_A,
            RSSExpandedReader.FINDER_PAT_E,
            RSSExpandedReader.FINDER_PAT_B,
            RSSExpandedReader.FINDER_PAT_D,
            RSSExpandedReader.FINDER_PAT_D,
            RSSExpandedReader.FINDER_PAT_F
        ],
        [
            RSSExpandedReader.FINDER_PAT_A,
            RSSExpandedReader.FINDER_PAT_E,
            RSSExpandedReader.FINDER_PAT_B,
            RSSExpandedReader.FINDER_PAT_D,
            RSSExpandedReader.FINDER_PAT_E,
            RSSExpandedReader.FINDER_PAT_F,
            RSSExpandedReader.FINDER_PAT_F
        ],
        [
            RSSExpandedReader.FINDER_PAT_A,
            RSSExpandedReader.FINDER_PAT_A,
            RSSExpandedReader.FINDER_PAT_B,
            RSSExpandedReader.FINDER_PAT_B,
            RSSExpandedReader.FINDER_PAT_C,
            RSSExpandedReader.FINDER_PAT_C,
            RSSExpandedReader.FINDER_PAT_D,
            RSSExpandedReader.FINDER_PAT_D
        ],
        [
            RSSExpandedReader.FINDER_PAT_A,
            RSSExpandedReader.FINDER_PAT_A,
            RSSExpandedReader.FINDER_PAT_B,
            RSSExpandedReader.FINDER_PAT_B,
            RSSExpandedReader.FINDER_PAT_C,
            RSSExpandedReader.FINDER_PAT_C,
            RSSExpandedReader.FINDER_PAT_D,
            RSSExpandedReader.FINDER_PAT_E,
            RSSExpandedReader.FINDER_PAT_E
        ],
        [
            RSSExpandedReader.FINDER_PAT_A,
            RSSExpandedReader.FINDER_PAT_A,
            RSSExpandedReader.FINDER_PAT_B,
            RSSExpandedReader.FINDER_PAT_B,
            RSSExpandedReader.FINDER_PAT_C,
            RSSExpandedReader.FINDER_PAT_C,
            RSSExpandedReader.FINDER_PAT_D,
            RSSExpandedReader.FINDER_PAT_E,
            RSSExpandedReader.FINDER_PAT_F,
            RSSExpandedReader.FINDER_PAT_F
        ],
        [
            RSSExpandedReader.FINDER_PAT_A,
            RSSExpandedReader.FINDER_PAT_A,
            RSSExpandedReader.FINDER_PAT_B,
            RSSExpandedReader.FINDER_PAT_B,
            RSSExpandedReader.FINDER_PAT_C,
            RSSExpandedReader.FINDER_PAT_D,
            RSSExpandedReader.FINDER_PAT_D,
            RSSExpandedReader.FINDER_PAT_E,
            RSSExpandedReader.FINDER_PAT_E,
            RSSExpandedReader.FINDER_PAT_F,
            RSSExpandedReader.FINDER_PAT_F
        ]
    ];
    RSSExpandedReader.MAX_PAIRS = 11;
    class Pair extends DataCharacter {
        constructor(value, checksumPortion, finderPattern){
            super(value, checksumPortion);
            this.count = 0;
            this.finderPattern = finderPattern;
        }
        getFinderPattern() {
            return this.finderPattern;
        }
        getCount() {
            return this.count;
        }
        incrementCount() {
            this.count++;
        }
    }
    class RSS14Reader extends AbstractRSSReader {
        constructor(){
            super(...arguments);
            this.possibleLeftPairs = [];
            this.possibleRightPairs = [];
        }
        decodeRow(rowNumber, row, hints) {
            const leftPair = this.decodePair(row, false, rowNumber, hints);
            RSS14Reader.addOrTally(this.possibleLeftPairs, leftPair);
            row.reverse();
            let rightPair = this.decodePair(row, true, rowNumber, hints);
            RSS14Reader.addOrTally(this.possibleRightPairs, rightPair);
            row.reverse();
            for (let left of this.possibleLeftPairs){
                if (left.getCount() > 1) for (let right of this.possibleRightPairs){
                    if (right.getCount() > 1 && RSS14Reader.checkChecksum(left, right)) return RSS14Reader.constructResult(left, right);
                }
            }
            throw new NotFoundException();
        }
        static addOrTally(possiblePairs, pair) {
            if (pair == null) return;
            let found = false;
            for (let other of possiblePairs)if (other.getValue() === pair.getValue()) {
                other.incrementCount();
                found = true;
                break;
            }
            if (!found) possiblePairs.push(pair);
        }
        reset() {
            this.possibleLeftPairs.length = 0;
            this.possibleRightPairs.length = 0;
        }
        static constructResult(leftPair, rightPair) {
            let symbolValue = 4537077 * leftPair.getValue() + rightPair.getValue();
            let text = new String(symbolValue).toString();
            let buffer = new StringBuilder();
            for(let i = 13 - text.length; i > 0; i--)buffer.append('0');
            buffer.append(text);
            let checkDigit = 0;
            for(let i = 0; i < 13; i++){
                let digit = buffer.charAt(i).charCodeAt(0) - '0'.charCodeAt(0);
                checkDigit += (i & 0x01) === 0 ? 3 * digit : digit;
            }
            checkDigit = 10 - checkDigit % 10;
            if (checkDigit === 10) checkDigit = 0;
            buffer.append(checkDigit.toString());
            let leftPoints = leftPair.getFinderPattern().getResultPoints();
            let rightPoints = rightPair.getFinderPattern().getResultPoints();
            return new Result(buffer.toString(), null, 0, [
                leftPoints[0],
                leftPoints[1],
                rightPoints[0],
                rightPoints[1]
            ], BarcodeFormat$1.RSS_14, new Date().getTime());
        }
        static checkChecksum(leftPair, rightPair) {
            let checkValue = (leftPair.getChecksumPortion() + 16 * rightPair.getChecksumPortion()) % 79;
            let targetCheckValue = 9 * leftPair.getFinderPattern().getValue() + rightPair.getFinderPattern().getValue();
            if (targetCheckValue > 72) targetCheckValue--;
            if (targetCheckValue > 8) targetCheckValue--;
            return checkValue === targetCheckValue;
        }
        decodePair(row, right, rowNumber, hints) {
            try {
                let startEnd = this.findFinderPattern(row, right);
                let pattern = this.parseFoundFinderPattern(row, rowNumber, right, startEnd);
                let resultPointCallback = hints == null ? null : hints.get(DecodeHintType$1.NEED_RESULT_POINT_CALLBACK);
                if (resultPointCallback != null) {
                    let center = (startEnd[0] + startEnd[1]) / 2.0;
                    if (right) // row is actually reversed
                    center = row.getSize() - 1 - center;
                    resultPointCallback.foundPossibleResultPoint(new ResultPoint(center, rowNumber));
                }
                let outside = this.decodeDataCharacter(row, pattern, true);
                let inside = this.decodeDataCharacter(row, pattern, false);
                return new Pair(1597 * outside.getValue() + inside.getValue(), outside.getChecksumPortion() + 4 * inside.getChecksumPortion(), pattern);
            } catch (err) {
                return null;
            }
        }
        decodeDataCharacter(row, pattern, outsideChar) {
            let counters = this.getDataCharacterCounters();
            for(let x = 0; x < counters.length; x++)counters[x] = 0;
            if (outsideChar) OneDReader.recordPatternInReverse(row, pattern.getStartEnd()[0], counters);
            else {
                OneDReader.recordPattern(row, pattern.getStartEnd()[1] + 1, counters);
                // reverse it
                for(let i = 0, j = counters.length - 1; i < j; i++, j--){
                    let temp = counters[i];
                    counters[i] = counters[j];
                    counters[j] = temp;
                }
            }
            let numModules = outsideChar ? 16 : 15;
            let elementWidth = MathUtils.sum(new Int32Array(counters)) / numModules;
            let oddCounts = this.getOddCounts();
            let evenCounts = this.getEvenCounts();
            let oddRoundingErrors = this.getOddRoundingErrors();
            let evenRoundingErrors = this.getEvenRoundingErrors();
            for(let i = 0; i < counters.length; i++){
                let value = counters[i] / elementWidth;
                let count = Math.floor(value + 0.5);
                if (count < 1) count = 1;
                else if (count > 8) count = 8;
                let offset = Math.floor(i / 2);
                if ((i & 0x01) === 0) {
                    oddCounts[offset] = count;
                    oddRoundingErrors[offset] = value - count;
                } else {
                    evenCounts[offset] = count;
                    evenRoundingErrors[offset] = value - count;
                }
            }
            this.adjustOddEvenCounts(outsideChar, numModules);
            let oddSum = 0;
            let oddChecksumPortion = 0;
            for(let i = oddCounts.length - 1; i >= 0; i--){
                oddChecksumPortion *= 9;
                oddChecksumPortion += oddCounts[i];
                oddSum += oddCounts[i];
            }
            let evenChecksumPortion = 0;
            let evenSum = 0;
            for(let i = evenCounts.length - 1; i >= 0; i--){
                evenChecksumPortion *= 9;
                evenChecksumPortion += evenCounts[i];
                evenSum += evenCounts[i];
            }
            let checksumPortion = oddChecksumPortion + 3 * evenChecksumPortion;
            if (outsideChar) {
                if ((oddSum & 0x01) !== 0 || oddSum > 12 || oddSum < 4) throw new NotFoundException();
                let group = (12 - oddSum) / 2;
                let oddWidest = RSS14Reader.OUTSIDE_ODD_WIDEST[group];
                let evenWidest = 9 - oddWidest;
                let vOdd = RSSUtils.getRSSvalue(oddCounts, oddWidest, false);
                let vEven = RSSUtils.getRSSvalue(evenCounts, evenWidest, true);
                let tEven = RSS14Reader.OUTSIDE_EVEN_TOTAL_SUBSET[group];
                let gSum = RSS14Reader.OUTSIDE_GSUM[group];
                return new DataCharacter(vOdd * tEven + vEven + gSum, checksumPortion);
            } else {
                if ((evenSum & 0x01) !== 0 || evenSum > 10 || evenSum < 4) throw new NotFoundException();
                let group = (10 - evenSum) / 2;
                let oddWidest = RSS14Reader.INSIDE_ODD_WIDEST[group];
                let evenWidest = 9 - oddWidest;
                let vOdd = RSSUtils.getRSSvalue(oddCounts, oddWidest, true);
                let vEven = RSSUtils.getRSSvalue(evenCounts, evenWidest, false);
                let tOdd = RSS14Reader.INSIDE_ODD_TOTAL_SUBSET[group];
                let gSum = RSS14Reader.INSIDE_GSUM[group];
                return new DataCharacter(vEven * tOdd + vOdd + gSum, checksumPortion);
            }
        }
        findFinderPattern(row, rightFinderPattern) {
            let counters = this.getDecodeFinderCounters();
            counters[0] = 0;
            counters[1] = 0;
            counters[2] = 0;
            counters[3] = 0;
            let width = row.getSize();
            let isWhite = false;
            let rowOffset = 0;
            while(rowOffset < width){
                isWhite = !row.get(rowOffset);
                if (rightFinderPattern === isWhite) break;
                rowOffset++;
            }
            let counterPosition = 0;
            let patternStart = rowOffset;
            for(let x = rowOffset; x < width; x++)if (row.get(x) !== isWhite) counters[counterPosition]++;
            else {
                if (counterPosition === 3) {
                    if (AbstractRSSReader.isFinderPattern(counters)) return [
                        patternStart,
                        x
                    ];
                    patternStart += counters[0] + counters[1];
                    counters[0] = counters[2];
                    counters[1] = counters[3];
                    counters[2] = 0;
                    counters[3] = 0;
                    counterPosition--;
                } else counterPosition++;
                counters[counterPosition] = 1;
                isWhite = !isWhite;
            }
            throw new NotFoundException();
        }
        parseFoundFinderPattern(row, rowNumber, right, startEnd) {
            // Actually we found elements 2-5
            let firstIsBlack = row.get(startEnd[0]);
            let firstElementStart = startEnd[0] - 1;
            // Locate element 1
            while(firstElementStart >= 0 && firstIsBlack !== row.get(firstElementStart))firstElementStart--;
            firstElementStart++;
            const firstCounter = startEnd[0] - firstElementStart;
            // Make 'counters' hold 1-4
            const counters = this.getDecodeFinderCounters();
            const copy = new Int32Array(counters.length);
            System.arraycopy(counters, 0, copy, 1, counters.length - 1);
            copy[0] = firstCounter;
            const value = this.parseFinderValue(copy, RSS14Reader.FINDER_PATTERNS);
            let start = firstElementStart;
            let end = startEnd[1];
            if (right) {
                // row is actually reversed
                start = row.getSize() - 1 - start;
                end = row.getSize() - 1 - end;
            }
            return new FinderPattern(value, [
                firstElementStart,
                startEnd[1]
            ], start, end, rowNumber);
        }
        adjustOddEvenCounts(outsideChar, numModules) {
            let oddSum = MathUtils.sum(new Int32Array(this.getOddCounts()));
            let evenSum = MathUtils.sum(new Int32Array(this.getEvenCounts()));
            let incrementOdd = false;
            let decrementOdd = false;
            let incrementEven = false;
            let decrementEven = false;
            if (outsideChar) {
                if (oddSum > 12) decrementOdd = true;
                else if (oddSum < 4) incrementOdd = true;
                if (evenSum > 12) decrementEven = true;
                else if (evenSum < 4) incrementEven = true;
            } else {
                if (oddSum > 11) decrementOdd = true;
                else if (oddSum < 5) incrementOdd = true;
                if (evenSum > 10) decrementEven = true;
                else if (evenSum < 4) incrementEven = true;
            }
            let mismatch = oddSum + evenSum - numModules;
            let oddParityBad = (oddSum & 0x01) === (outsideChar ? 1 : 0);
            let evenParityBad = (evenSum & 0x01) === 1;
            if (mismatch === 1) {
                if (oddParityBad) {
                    if (evenParityBad) throw new NotFoundException();
                    decrementOdd = true;
                } else {
                    if (!evenParityBad) throw new NotFoundException();
                    decrementEven = true;
                }
            } else if (mismatch === -1) {
                if (oddParityBad) {
                    if (evenParityBad) throw new NotFoundException();
                    incrementOdd = true;
                } else {
                    if (!evenParityBad) throw new NotFoundException();
                    incrementEven = true;
                }
            } else if (mismatch === 0) {
                if (oddParityBad) {
                    if (!evenParityBad) throw new NotFoundException();
                    // Both bad
                    if (oddSum < evenSum) {
                        incrementOdd = true;
                        decrementEven = true;
                    } else {
                        decrementOdd = true;
                        incrementEven = true;
                    }
                } else {
                    if (evenParityBad) throw new NotFoundException();
                // Nothing to do!
                }
            } else throw new NotFoundException();
            if (incrementOdd) {
                if (decrementOdd) throw new NotFoundException();
                AbstractRSSReader.increment(this.getOddCounts(), this.getOddRoundingErrors());
            }
            if (decrementOdd) AbstractRSSReader.decrement(this.getOddCounts(), this.getOddRoundingErrors());
            if (incrementEven) {
                if (decrementEven) throw new NotFoundException();
                AbstractRSSReader.increment(this.getEvenCounts(), this.getOddRoundingErrors());
            }
            if (decrementEven) AbstractRSSReader.decrement(this.getEvenCounts(), this.getEvenRoundingErrors());
        }
    }
    RSS14Reader.OUTSIDE_EVEN_TOTAL_SUBSET = [
        1,
        10,
        34,
        70,
        126
    ];
    RSS14Reader.INSIDE_ODD_TOTAL_SUBSET = [
        4,
        20,
        48,
        81
    ];
    RSS14Reader.OUTSIDE_GSUM = [
        0,
        161,
        961,
        2015,
        2715
    ];
    RSS14Reader.INSIDE_GSUM = [
        0,
        336,
        1036,
        1516
    ];
    RSS14Reader.OUTSIDE_ODD_WIDEST = [
        8,
        6,
        4,
        3,
        1
    ];
    RSS14Reader.INSIDE_ODD_WIDEST = [
        2,
        4,
        6,
        8
    ];
    RSS14Reader.FINDER_PATTERNS = [
        Int32Array.from([
            3,
            8,
            2,
            1
        ]),
        Int32Array.from([
            3,
            5,
            5,
            1
        ]),
        Int32Array.from([
            3,
            3,
            7,
            1
        ]),
        Int32Array.from([
            3,
            1,
            9,
            1
        ]),
        Int32Array.from([
            2,
            7,
            4,
            1
        ]),
        Int32Array.from([
            2,
            5,
            6,
            1
        ]),
        Int32Array.from([
            2,
            3,
            8,
            1
        ]),
        Int32Array.from([
            1,
            5,
            7,
            1
        ]),
        Int32Array.from([
            1,
            3,
            9,
            1
        ])
    ];
    /**
     * @author Daniel Switkin <dswitkin@google.com>
     * @author Sean Owen
     */ class MultiFormatOneDReader extends OneDReader {
        constructor(hints, verbose){
            super();
            this.readers = [];
            this.verbose = verbose === true;
            const possibleFormats = !hints ? null : hints.get(DecodeHintType$1.POSSIBLE_FORMATS);
            const useCode39CheckDigit = hints && hints.get(DecodeHintType$1.ASSUME_CODE_39_CHECK_DIGIT) !== undefined;
            if (possibleFormats) {
                if (possibleFormats.includes(BarcodeFormat$1.EAN_13) || possibleFormats.includes(BarcodeFormat$1.UPC_A) || possibleFormats.includes(BarcodeFormat$1.EAN_8) || possibleFormats.includes(BarcodeFormat$1.UPC_E)) this.readers.push(new MultiFormatUPCEANReader(hints));
                if (possibleFormats.includes(BarcodeFormat$1.CODE_39)) this.readers.push(new Code39Reader(useCode39CheckDigit));
                // if (possibleFormats.includes(BarcodeFormat.CODE_93)) {
                //    this.readers.push(new Code93Reader());
                // }
                if (possibleFormats.includes(BarcodeFormat$1.CODE_128)) this.readers.push(new Code128Reader());
                if (possibleFormats.includes(BarcodeFormat$1.ITF)) this.readers.push(new ITFReader());
                // if (possibleFormats.includes(BarcodeFormat.CODABAR)) {
                //    this.readers.push(new CodaBarReader());
                // }
                if (possibleFormats.includes(BarcodeFormat$1.RSS_14)) this.readers.push(new RSS14Reader());
                if (possibleFormats.includes(BarcodeFormat$1.RSS_EXPANDED)) this.readers.push(new RSSExpandedReader(this.verbose));
            } else {
                // Case when no hints were provided -> add all.
                this.readers.push(new MultiFormatUPCEANReader(hints));
                this.readers.push(new Code39Reader());
                // this.readers.push(new CodaBarReader());
                // this.readers.push(new Code93Reader());
                this.readers.push(new MultiFormatUPCEANReader(hints));
                this.readers.push(new Code128Reader());
                this.readers.push(new ITFReader());
                this.readers.push(new RSS14Reader());
                this.readers.push(new RSSExpandedReader(this.verbose));
            }
        }
        // @Override
        decodeRow(rowNumber, row, hints) {
            for(let i = 0; i < this.readers.length; i++)try {
                return this.readers[i].decodeRow(rowNumber, row, hints);
            } catch (re) {
            // continue
            }
            throw new NotFoundException();
        }
        // @Override
        reset() {
            this.readers.forEach((reader)=>reader.reset());
        }
    }
    /**
     * @deprecated Moving to @zxing/browser
     *
     * Barcode reader reader to use from browser.
     */ class BrowserBarcodeReader extends BrowserCodeReader {
        /**
         * Creates an instance of BrowserBarcodeReader.
         * @param {number} [timeBetweenScansMillis=500] the time delay between subsequent decode tries
         * @param {Map<DecodeHintType, any>} hints
         */ constructor(timeBetweenScansMillis = 500, hints){
            super(new MultiFormatOneDReader(hints), timeBetweenScansMillis, hints);
        }
    }
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * <p>Encapsulates a set of error-correction blocks in one symbol version. Most versions will
     * use blocks of differing sizes within one version, so, this encapsulates the parameters for
     * each set of blocks. It also holds the number of error-correction codewords per block since it
     * will be the same across all blocks within one version.</p>
     */ class ECBlocks {
        constructor(ecCodewords, ecBlocks1, ecBlocks2){
            this.ecCodewords = ecCodewords;
            this.ecBlocks = [
                ecBlocks1
            ];
            ecBlocks2 && this.ecBlocks.push(ecBlocks2);
        }
        getECCodewords() {
            return this.ecCodewords;
        }
        getECBlocks() {
            return this.ecBlocks;
        }
    }
    /**
     * <p>Encapsulates the parameters for one error-correction block in one symbol version.
     * This includes the number of data codewords, and the number of times a block with these
     * parameters is used consecutively in the Data Matrix code version's format.</p>
     */ class ECB {
        constructor(count, dataCodewords){
            this.count = count;
            this.dataCodewords = dataCodewords;
        }
        getCount() {
            return this.count;
        }
        getDataCodewords() {
            return this.dataCodewords;
        }
    }
    /**
     * The Version object encapsulates attributes about a particular
     * size Data Matrix Code.
     *
     * @author bbrown@google.com (Brian Brown)
     */ class Version {
        constructor(versionNumber, symbolSizeRows, symbolSizeColumns, dataRegionSizeRows, dataRegionSizeColumns, ecBlocks){
            this.versionNumber = versionNumber;
            this.symbolSizeRows = symbolSizeRows;
            this.symbolSizeColumns = symbolSizeColumns;
            this.dataRegionSizeRows = dataRegionSizeRows;
            this.dataRegionSizeColumns = dataRegionSizeColumns;
            this.ecBlocks = ecBlocks;
            // Calculate the total number of codewords
            let total = 0;
            const ecCodewords = ecBlocks.getECCodewords();
            const ecbArray = ecBlocks.getECBlocks();
            for (let ecBlock of ecbArray)total += ecBlock.getCount() * (ecBlock.getDataCodewords() + ecCodewords);
            this.totalCodewords = total;
        }
        getVersionNumber() {
            return this.versionNumber;
        }
        getSymbolSizeRows() {
            return this.symbolSizeRows;
        }
        getSymbolSizeColumns() {
            return this.symbolSizeColumns;
        }
        getDataRegionSizeRows() {
            return this.dataRegionSizeRows;
        }
        getDataRegionSizeColumns() {
            return this.dataRegionSizeColumns;
        }
        getTotalCodewords() {
            return this.totalCodewords;
        }
        getECBlocks() {
            return this.ecBlocks;
        }
        /**
         * <p>Deduces version information from Data Matrix dimensions.</p>
         *
         * @param numRows Number of rows in modules
         * @param numColumns Number of columns in modules
         * @return Version for a Data Matrix Code of those dimensions
         * @throws FormatException if dimensions do correspond to a valid Data Matrix size
         */ static getVersionForDimensions(numRows, numColumns) {
            if ((numRows & 0x01) !== 0 || (numColumns & 0x01) !== 0) throw new FormatException();
            for (let version of Version.VERSIONS){
                if (version.symbolSizeRows === numRows && version.symbolSizeColumns === numColumns) return version;
            }
            throw new FormatException();
        }
        //  @Override
        toString() {
            return '' + this.versionNumber;
        }
        /**
         * See ISO 16022:2006 5.5.1 Table 7
         */ static buildVersions() {
            return [
                new Version(1, 10, 10, 8, 8, new ECBlocks(5, new ECB(1, 3))),
                new Version(2, 12, 12, 10, 10, new ECBlocks(7, new ECB(1, 5))),
                new Version(3, 14, 14, 12, 12, new ECBlocks(10, new ECB(1, 8))),
                new Version(4, 16, 16, 14, 14, new ECBlocks(12, new ECB(1, 12))),
                new Version(5, 18, 18, 16, 16, new ECBlocks(14, new ECB(1, 18))),
                new Version(6, 20, 20, 18, 18, new ECBlocks(18, new ECB(1, 22))),
                new Version(7, 22, 22, 20, 20, new ECBlocks(20, new ECB(1, 30))),
                new Version(8, 24, 24, 22, 22, new ECBlocks(24, new ECB(1, 36))),
                new Version(9, 26, 26, 24, 24, new ECBlocks(28, new ECB(1, 44))),
                new Version(10, 32, 32, 14, 14, new ECBlocks(36, new ECB(1, 62))),
                new Version(11, 36, 36, 16, 16, new ECBlocks(42, new ECB(1, 86))),
                new Version(12, 40, 40, 18, 18, new ECBlocks(48, new ECB(1, 114))),
                new Version(13, 44, 44, 20, 20, new ECBlocks(56, new ECB(1, 144))),
                new Version(14, 48, 48, 22, 22, new ECBlocks(68, new ECB(1, 174))),
                new Version(15, 52, 52, 24, 24, new ECBlocks(42, new ECB(2, 102))),
                new Version(16, 64, 64, 14, 14, new ECBlocks(56, new ECB(2, 140))),
                new Version(17, 72, 72, 16, 16, new ECBlocks(36, new ECB(4, 92))),
                new Version(18, 80, 80, 18, 18, new ECBlocks(48, new ECB(4, 114))),
                new Version(19, 88, 88, 20, 20, new ECBlocks(56, new ECB(4, 144))),
                new Version(20, 96, 96, 22, 22, new ECBlocks(68, new ECB(4, 174))),
                new Version(21, 104, 104, 24, 24, new ECBlocks(56, new ECB(6, 136))),
                new Version(22, 120, 120, 18, 18, new ECBlocks(68, new ECB(6, 175))),
                new Version(23, 132, 132, 20, 20, new ECBlocks(62, new ECB(8, 163))),
                new Version(24, 144, 144, 22, 22, new ECBlocks(62, new ECB(8, 156), new ECB(2, 155))),
                new Version(25, 8, 18, 6, 16, new ECBlocks(7, new ECB(1, 5))),
                new Version(26, 8, 32, 6, 14, new ECBlocks(11, new ECB(1, 10))),
                new Version(27, 12, 26, 10, 24, new ECBlocks(14, new ECB(1, 16))),
                new Version(28, 12, 36, 10, 16, new ECBlocks(18, new ECB(1, 22))),
                new Version(29, 16, 36, 14, 16, new ECBlocks(24, new ECB(1, 32))),
                new Version(30, 16, 48, 14, 22, new ECBlocks(28, new ECB(1, 49)))
            ];
        }
    }
    Version.VERSIONS = Version.buildVersions();
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * @author bbrown@google.com (Brian Brown)
     */ class BitMatrixParser {
        /**
         * @param bitMatrix {@link BitMatrix} to parse
         * @throws FormatException if dimension is < 8 or > 144 or not 0 mod 2
         */ constructor(bitMatrix){
            const dimension = bitMatrix.getHeight();
            if (dimension < 8 || dimension > 144 || (dimension & 0x01) !== 0) throw new FormatException();
            this.version = BitMatrixParser.readVersion(bitMatrix);
            this.mappingBitMatrix = this.extractDataRegion(bitMatrix);
            this.readMappingMatrix = new BitMatrix(this.mappingBitMatrix.getWidth(), this.mappingBitMatrix.getHeight());
        }
        getVersion() {
            return this.version;
        }
        /**
         * <p>Creates the version object based on the dimension of the original bit matrix from
         * the datamatrix code.</p>
         *
         * <p>See ISO 16022:2006 Table 7 - ECC 200 symbol attributes</p>
         *
         * @param bitMatrix Original {@link BitMatrix} including alignment patterns
         * @return {@link Version} encapsulating the Data Matrix Code's "version"
         * @throws FormatException if the dimensions of the mapping matrix are not valid
         * Data Matrix dimensions.
         */ static readVersion(bitMatrix) {
            const numRows = bitMatrix.getHeight();
            const numColumns = bitMatrix.getWidth();
            return Version.getVersionForDimensions(numRows, numColumns);
        }
        /**
         * <p>Reads the bits in the {@link BitMatrix} representing the mapping matrix (No alignment patterns)
         * in the correct order in order to reconstitute the codewords bytes contained within the
         * Data Matrix Code.</p>
         *
         * @return bytes encoded within the Data Matrix Code
         * @throws FormatException if the exact number of bytes expected is not read
         */ readCodewords() {
            const result = new Int8Array(this.version.getTotalCodewords());
            let resultOffset = 0;
            let row = 4;
            let column = 0;
            const numRows = this.mappingBitMatrix.getHeight();
            const numColumns = this.mappingBitMatrix.getWidth();
            let corner1Read = false;
            let corner2Read = false;
            let corner3Read = false;
            let corner4Read = false;
            // Read all of the codewords
            do {
                // Check the four corner cases
                if (row === numRows && column === 0 && !corner1Read) {
                    result[resultOffset++] = this.readCorner1(numRows, numColumns) & 0xff;
                    row -= 2;
                    column += 2;
                    corner1Read = true;
                } else if (row === numRows - 2 && column === 0 && (numColumns & 0x03) !== 0 && !corner2Read) {
                    result[resultOffset++] = this.readCorner2(numRows, numColumns) & 0xff;
                    row -= 2;
                    column += 2;
                    corner2Read = true;
                } else if (row === numRows + 4 && column === 2 && (numColumns & 0x07) === 0 && !corner3Read) {
                    result[resultOffset++] = this.readCorner3(numRows, numColumns) & 0xff;
                    row -= 2;
                    column += 2;
                    corner3Read = true;
                } else if (row === numRows - 2 && column === 0 && (numColumns & 0x07) === 4 && !corner4Read) {
                    result[resultOffset++] = this.readCorner4(numRows, numColumns) & 0xff;
                    row -= 2;
                    column += 2;
                    corner4Read = true;
                } else {
                    // Sweep upward diagonally to the right
                    do {
                        if (row < numRows && column >= 0 && !this.readMappingMatrix.get(column, row)) result[resultOffset++] = this.readUtah(row, column, numRows, numColumns) & 0xff;
                        row -= 2;
                        column += 2;
                    }while (row >= 0 && column < numColumns);
                    row += 1;
                    column += 3;
                    // Sweep downward diagonally to the left
                    do {
                        if (row >= 0 && column < numColumns && !this.readMappingMatrix.get(column, row)) result[resultOffset++] = this.readUtah(row, column, numRows, numColumns) & 0xff;
                        row += 2;
                        column -= 2;
                    }while (row < numRows && column >= 0);
                    row += 3;
                    column += 1;
                }
            }while (row < numRows || column < numColumns);
            if (resultOffset !== this.version.getTotalCodewords()) throw new FormatException();
            return result;
        }
        /**
         * <p>Reads a bit of the mapping matrix accounting for boundary wrapping.</p>
         *
         * @param row Row to read in the mapping matrix
         * @param column Column to read in the mapping matrix
         * @param numRows Number of rows in the mapping matrix
         * @param numColumns Number of columns in the mapping matrix
         * @return value of the given bit in the mapping matrix
         */ readModule(row, column, numRows, numColumns) {
            // Adjust the row and column indices based on boundary wrapping
            if (row < 0) {
                row += numRows;
                column += 4 - (numRows + 4 & 0x07);
            }
            if (column < 0) {
                column += numColumns;
                row += 4 - (numColumns + 4 & 0x07);
            }
            this.readMappingMatrix.set(column, row);
            return this.mappingBitMatrix.get(column, row);
        }
        /**
         * <p>Reads the 8 bits of the standard Utah-shaped pattern.</p>
         *
         * <p>See ISO 16022:2006, 5.8.1 Figure 6</p>
         *
         * @param row Current row in the mapping matrix, anchored at the 8th bit (LSB) of the pattern
         * @param column Current column in the mapping matrix, anchored at the 8th bit (LSB) of the pattern
         * @param numRows Number of rows in the mapping matrix
         * @param numColumns Number of columns in the mapping matrix
         * @return byte from the utah shape
         */ readUtah(row, column, numRows, numColumns) {
            let currentByte = 0;
            if (this.readModule(row - 2, column - 2, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(row - 2, column - 1, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(row - 1, column - 2, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(row - 1, column - 1, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(row - 1, column, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(row, column - 2, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(row, column - 1, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(row, column, numRows, numColumns)) currentByte |= 1;
            return currentByte;
        }
        /**
         * <p>Reads the 8 bits of the special corner condition 1.</p>
         *
         * <p>See ISO 16022:2006, Figure F.3</p>
         *
         * @param numRows Number of rows in the mapping matrix
         * @param numColumns Number of columns in the mapping matrix
         * @return byte from the Corner condition 1
         */ readCorner1(numRows, numColumns) {
            let currentByte = 0;
            if (this.readModule(numRows - 1, 0, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(numRows - 1, 1, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(numRows - 1, 2, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(0, numColumns - 2, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(0, numColumns - 1, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(1, numColumns - 1, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(2, numColumns - 1, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(3, numColumns - 1, numRows, numColumns)) currentByte |= 1;
            return currentByte;
        }
        /**
         * <p>Reads the 8 bits of the special corner condition 2.</p>
         *
         * <p>See ISO 16022:2006, Figure F.4</p>
         *
         * @param numRows Number of rows in the mapping matrix
         * @param numColumns Number of columns in the mapping matrix
         * @return byte from the Corner condition 2
         */ readCorner2(numRows, numColumns) {
            let currentByte = 0;
            if (this.readModule(numRows - 3, 0, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(numRows - 2, 0, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(numRows - 1, 0, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(0, numColumns - 4, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(0, numColumns - 3, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(0, numColumns - 2, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(0, numColumns - 1, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(1, numColumns - 1, numRows, numColumns)) currentByte |= 1;
            return currentByte;
        }
        /**
         * <p>Reads the 8 bits of the special corner condition 3.</p>
         *
         * <p>See ISO 16022:2006, Figure F.5</p>
         *
         * @param numRows Number of rows in the mapping matrix
         * @param numColumns Number of columns in the mapping matrix
         * @return byte from the Corner condition 3
         */ readCorner3(numRows, numColumns) {
            let currentByte = 0;
            if (this.readModule(numRows - 1, 0, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(numRows - 1, numColumns - 1, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(0, numColumns - 3, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(0, numColumns - 2, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(0, numColumns - 1, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(1, numColumns - 3, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(1, numColumns - 2, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(1, numColumns - 1, numRows, numColumns)) currentByte |= 1;
            return currentByte;
        }
        /**
         * <p>Reads the 8 bits of the special corner condition 4.</p>
         *
         * <p>See ISO 16022:2006, Figure F.6</p>
         *
         * @param numRows Number of rows in the mapping matrix
         * @param numColumns Number of columns in the mapping matrix
         * @return byte from the Corner condition 4
         */ readCorner4(numRows, numColumns) {
            let currentByte = 0;
            if (this.readModule(numRows - 3, 0, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(numRows - 2, 0, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(numRows - 1, 0, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(0, numColumns - 2, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(0, numColumns - 1, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(1, numColumns - 1, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(2, numColumns - 1, numRows, numColumns)) currentByte |= 1;
            currentByte <<= 1;
            if (this.readModule(3, numColumns - 1, numRows, numColumns)) currentByte |= 1;
            return currentByte;
        }
        /**
         * <p>Extracts the data region from a {@link BitMatrix} that contains
         * alignment patterns.</p>
         *
         * @param bitMatrix Original {@link BitMatrix} with alignment patterns
         * @return BitMatrix that has the alignment patterns removed
         */ extractDataRegion(bitMatrix) {
            const symbolSizeRows = this.version.getSymbolSizeRows();
            const symbolSizeColumns = this.version.getSymbolSizeColumns();
            if (bitMatrix.getHeight() !== symbolSizeRows) throw new IllegalArgumentException('Dimension of bitMatrix must match the version size');
            const dataRegionSizeRows = this.version.getDataRegionSizeRows();
            const dataRegionSizeColumns = this.version.getDataRegionSizeColumns();
            const numDataRegionsRow = symbolSizeRows / dataRegionSizeRows | 0;
            const numDataRegionsColumn = symbolSizeColumns / dataRegionSizeColumns | 0;
            const sizeDataRegionRow = numDataRegionsRow * dataRegionSizeRows;
            const sizeDataRegionColumn = numDataRegionsColumn * dataRegionSizeColumns;
            const bitMatrixWithoutAlignment = new BitMatrix(sizeDataRegionColumn, sizeDataRegionRow);
            for(let dataRegionRow = 0; dataRegionRow < numDataRegionsRow; ++dataRegionRow){
                const dataRegionRowOffset = dataRegionRow * dataRegionSizeRows;
                for(let dataRegionColumn = 0; dataRegionColumn < numDataRegionsColumn; ++dataRegionColumn){
                    const dataRegionColumnOffset = dataRegionColumn * dataRegionSizeColumns;
                    for(let i = 0; i < dataRegionSizeRows; ++i){
                        const readRowOffset = dataRegionRow * (dataRegionSizeRows + 2) + 1 + i;
                        const writeRowOffset = dataRegionRowOffset + i;
                        for(let j = 0; j < dataRegionSizeColumns; ++j){
                            const readColumnOffset = dataRegionColumn * (dataRegionSizeColumns + 2) + 1 + j;
                            if (bitMatrix.get(readColumnOffset, readRowOffset)) {
                                const writeColumnOffset = dataRegionColumnOffset + j;
                                bitMatrixWithoutAlignment.set(writeColumnOffset, writeRowOffset);
                            }
                        }
                    }
                }
            }
            return bitMatrixWithoutAlignment;
        }
    }
    /**
     * <p>Encapsulates a block of data within a Data Matrix Code. Data Matrix Codes may split their data into
     * multiple blocks, each of which is a unit of data and error-correction codewords. Each
     * is represented by an instance of this class.</p>
     *
     * @author bbrown@google.com (Brian Brown)
     */ class DataBlock {
        constructor(numDataCodewords, codewords){
            this.numDataCodewords = numDataCodewords;
            this.codewords = codewords;
        }
        /**
         * <p>When Data Matrix Codes use multiple data blocks, they actually interleave the bytes of each of them.
         * That is, the first byte of data block 1 to n is written, then the second bytes, and so on. This
         * method will separate the data into original blocks.</p>
         *
         * @param rawCodewords bytes as read directly from the Data Matrix Code
         * @param version version of the Data Matrix Code
         * @return DataBlocks containing original bytes, "de-interleaved" from representation in the
         *         Data Matrix Code
         */ static getDataBlocks(rawCodewords, version) {
            // Figure out the number and size of data blocks used by this version
            const ecBlocks = version.getECBlocks();
            // First count the total number of data blocks
            let totalBlocks = 0;
            const ecBlockArray = ecBlocks.getECBlocks();
            for (let ecBlock of ecBlockArray)totalBlocks += ecBlock.getCount();
            // Now establish DataBlocks of the appropriate size and number of data codewords
            const result = new Array(totalBlocks);
            let numResultBlocks = 0;
            for (let ecBlock of ecBlockArray)for(let i = 0; i < ecBlock.getCount(); i++){
                const numDataCodewords = ecBlock.getDataCodewords();
                const numBlockCodewords = ecBlocks.getECCodewords() + numDataCodewords;
                result[numResultBlocks++] = new DataBlock(numDataCodewords, new Uint8Array(numBlockCodewords));
            }
            // All blocks have the same amount of data, except that the last n
            // (where n may be 0) have 1 less byte. Figure out where these start.
            // TODO(bbrown): There is only one case where there is a difference for Data Matrix for size 144
            const longerBlocksTotalCodewords = result[0].codewords.length;
            // int shorterBlocksTotalCodewords = longerBlocksTotalCodewords - 1;
            const longerBlocksNumDataCodewords = longerBlocksTotalCodewords - ecBlocks.getECCodewords();
            const shorterBlocksNumDataCodewords = longerBlocksNumDataCodewords - 1;
            // The last elements of result may be 1 element shorter for 144 matrix
            // first fill out as many elements as all of them have minus 1
            let rawCodewordsOffset = 0;
            for(let i = 0; i < shorterBlocksNumDataCodewords; i++)for(let j = 0; j < numResultBlocks; j++)result[j].codewords[i] = rawCodewords[rawCodewordsOffset++];
            // Fill out the last data block in the longer ones
            const specialVersion = version.getVersionNumber() === 24;
            const numLongerBlocks = specialVersion ? 8 : numResultBlocks;
            for(let j = 0; j < numLongerBlocks; j++)result[j].codewords[longerBlocksNumDataCodewords - 1] = rawCodewords[rawCodewordsOffset++];
            // Now add in error correction blocks
            const max = result[0].codewords.length;
            for(let i = longerBlocksNumDataCodewords; i < max; i++)for(let j = 0; j < numResultBlocks; j++){
                const jOffset = specialVersion ? (j + 8) % numResultBlocks : j;
                const iOffset = specialVersion && jOffset > 7 ? i - 1 : i;
                result[jOffset].codewords[iOffset] = rawCodewords[rawCodewordsOffset++];
            }
            if (rawCodewordsOffset !== rawCodewords.length) throw new IllegalArgumentException();
            return result;
        }
        getNumDataCodewords() {
            return this.numDataCodewords;
        }
        getCodewords() {
            return this.codewords;
        }
    }
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * <p>This provides an easy abstraction to read bits at a time from a sequence of bytes, where the
     * number of bits read is not often a multiple of 8.</p>
     *
     * <p>This class is thread-safe but not reentrant -- unless the caller modifies the bytes array
     * it passed in, in which case all bets are off.</p>
     *
     * @author Sean Owen
     */ class BitSource {
        /**
         * @param bytes bytes from which this will read bits. Bits will be read from the first byte first.
         * Bits are read within a byte from most-significant to least-significant bit.
         */ constructor(bytes){
            this.bytes = bytes;
            this.byteOffset = 0;
            this.bitOffset = 0;
        }
        /**
         * @return index of next bit in current byte which would be read by the next call to {@link #readBits(int)}.
         */ getBitOffset() {
            return this.bitOffset;
        }
        /**
         * @return index of next byte in input byte array which would be read by the next call to {@link #readBits(int)}.
         */ getByteOffset() {
            return this.byteOffset;
        }
        /**
         * @param numBits number of bits to read
         * @return int representing the bits read. The bits will appear as the least-significant
         *         bits of the int
         * @throws IllegalArgumentException if numBits isn't in [1,32] or more than is available
         */ readBits(numBits /*int*/ ) {
            if (numBits < 1 || numBits > 32 || numBits > this.available()) throw new IllegalArgumentException('' + numBits);
            let result = 0;
            let bitOffset = this.bitOffset;
            let byteOffset = this.byteOffset;
            const bytes = this.bytes;
            // First, read remainder from current byte
            if (bitOffset > 0) {
                const bitsLeft = 8 - bitOffset;
                const toRead = numBits < bitsLeft ? numBits : bitsLeft;
                const bitsToNotRead = bitsLeft - toRead;
                const mask = 0xFF >> 8 - toRead << bitsToNotRead;
                result = (bytes[byteOffset] & mask) >> bitsToNotRead;
                numBits -= toRead;
                bitOffset += toRead;
                if (bitOffset === 8) {
                    bitOffset = 0;
                    byteOffset++;
                }
            }
            // Next read whole bytes
            if (numBits > 0) {
                while(numBits >= 8){
                    result = result << 8 | bytes[byteOffset] & 0xFF;
                    byteOffset++;
                    numBits -= 8;
                }
                // Finally read a partial byte
                if (numBits > 0) {
                    const bitsToNotRead = 8 - numBits;
                    const mask = 0xFF >> bitsToNotRead << bitsToNotRead;
                    result = result << numBits | (bytes[byteOffset] & mask) >> bitsToNotRead;
                    bitOffset += numBits;
                }
            }
            this.bitOffset = bitOffset;
            this.byteOffset = byteOffset;
            return result;
        }
        /**
         * @return number of bits that can be read successfully
         */ available() {
            return 8 * (this.bytes.length - this.byteOffset) - this.bitOffset;
        }
    }
    var Mode;
    (function(Mode) {
        Mode[Mode["PAD_ENCODE"] = 0] = "PAD_ENCODE";
        Mode[Mode["ASCII_ENCODE"] = 1] = "ASCII_ENCODE";
        Mode[Mode["C40_ENCODE"] = 2] = "C40_ENCODE";
        Mode[Mode["TEXT_ENCODE"] = 3] = "TEXT_ENCODE";
        Mode[Mode["ANSIX12_ENCODE"] = 4] = "ANSIX12_ENCODE";
        Mode[Mode["EDIFACT_ENCODE"] = 5] = "EDIFACT_ENCODE";
        Mode[Mode["BASE256_ENCODE"] = 6] = "BASE256_ENCODE";
    })(Mode || (Mode = {}));
    /**
     * <p>Data Matrix Codes can encode text as bits in one of several modes, and can use multiple modes
     * in one Data Matrix Code. This class decodes the bits back into text.</p>
     *
     * <p>See ISO 16022:2006, 5.2.1 - 5.2.9.2</p>
     *
     * @author bbrown@google.com (Brian Brown)
     * @author Sean Owen
     */ class DecodedBitStreamParser {
        static decode(bytes) {
            const bits = new BitSource(bytes);
            const result = new StringBuilder();
            const resultTrailer = new StringBuilder();
            const byteSegments = new Array();
            let mode = Mode.ASCII_ENCODE;
            do if (mode === Mode.ASCII_ENCODE) mode = this.decodeAsciiSegment(bits, result, resultTrailer);
            else {
                switch(mode){
                    case Mode.C40_ENCODE:
                        this.decodeC40Segment(bits, result);
                        break;
                    case Mode.TEXT_ENCODE:
                        this.decodeTextSegment(bits, result);
                        break;
                    case Mode.ANSIX12_ENCODE:
                        this.decodeAnsiX12Segment(bits, result);
                        break;
                    case Mode.EDIFACT_ENCODE:
                        this.decodeEdifactSegment(bits, result);
                        break;
                    case Mode.BASE256_ENCODE:
                        this.decodeBase256Segment(bits, result, byteSegments);
                        break;
                    default:
                        throw new FormatException();
                }
                mode = Mode.ASCII_ENCODE;
            }
            while (mode !== Mode.PAD_ENCODE && bits.available() > 0);
            if (resultTrailer.length() > 0) result.append(resultTrailer.toString());
            return new DecoderResult(bytes, result.toString(), byteSegments.length === 0 ? null : byteSegments, null);
        }
        /**
         * See ISO 16022:2006, 5.2.3 and Annex C, Table C.2
         */ static decodeAsciiSegment(bits, result, resultTrailer) {
            let upperShift = false;
            do {
                let oneByte = bits.readBits(8);
                if (oneByte === 0) throw new FormatException();
                else if (oneByte <= 128) {
                    if (upperShift) oneByte += 128;
                    result.append(String.fromCharCode(oneByte - 1));
                    return Mode.ASCII_ENCODE;
                } else if (oneByte === 129) return Mode.PAD_ENCODE;
                else if (oneByte <= 229) {
                    const value = oneByte - 130;
                    if (value < 10) result.append('0');
                    result.append('' + value);
                } else switch(oneByte){
                    case 230:
                        return Mode.C40_ENCODE;
                    case 231:
                        return Mode.BASE256_ENCODE;
                    case 232:
                        result.append(String.fromCharCode(29)); // translate as ASCII 29
                        break;
                    case 233:
                    case 234:
                        break;
                    case 235:
                        upperShift = true;
                        break;
                    case 236:
                        result.append('[)>\u001E05\u001D');
                        resultTrailer.insert(0, '\u001E\u0004');
                        break;
                    case 237:
                        result.append('[)>\u001E06\u001D');
                        resultTrailer.insert(0, '\u001E\u0004');
                        break;
                    case 238:
                        return Mode.ANSIX12_ENCODE;
                    case 239:
                        return Mode.TEXT_ENCODE;
                    case 240:
                        return Mode.EDIFACT_ENCODE;
                    case 241:
                        break;
                    default:
                        // Not to be used in ASCII encodation
                        // but work around encoders that end with 254, latch back to ASCII
                        if (oneByte !== 254 || bits.available() !== 0) throw new FormatException();
                        break;
                }
            }while (bits.available() > 0);
            return Mode.ASCII_ENCODE;
        }
        /**
         * See ISO 16022:2006, 5.2.5 and Annex C, Table C.1
         */ static decodeC40Segment(bits, result) {
            // Three C40 values are encoded in a 16-bit value as
            // (1600 * C1) + (40 * C2) + C3 + 1
            // TODO(bbrown): The Upper Shift with C40 doesn't work in the 4 value scenario all the time
            let upperShift = false;
            const cValues = [];
            let shift = 0;
            do {
                // If there is only one byte left then it will be encoded as ASCII
                if (bits.available() === 8) return;
                const firstByte = bits.readBits(8);
                if (firstByte === 254) return;
                this.parseTwoBytes(firstByte, bits.readBits(8), cValues);
                for(let i = 0; i < 3; i++){
                    const cValue = cValues[i];
                    switch(shift){
                        case 0:
                            if (cValue < 3) shift = cValue + 1;
                            else if (cValue < this.C40_BASIC_SET_CHARS.length) {
                                const c40char = this.C40_BASIC_SET_CHARS[cValue];
                                if (upperShift) {
                                    result.append(String.fromCharCode(c40char.charCodeAt(0) + 128));
                                    upperShift = false;
                                } else result.append(c40char);
                            } else throw new FormatException();
                            break;
                        case 1:
                            if (upperShift) {
                                result.append(String.fromCharCode(cValue + 128));
                                upperShift = false;
                            } else result.append(String.fromCharCode(cValue));
                            shift = 0;
                            break;
                        case 2:
                            if (cValue < this.C40_SHIFT2_SET_CHARS.length) {
                                const c40char = this.C40_SHIFT2_SET_CHARS[cValue];
                                if (upperShift) {
                                    result.append(String.fromCharCode(c40char.charCodeAt(0) + 128));
                                    upperShift = false;
                                } else result.append(c40char);
                            } else switch(cValue){
                                case 27:
                                    result.append(String.fromCharCode(29)); // translate as ASCII 29
                                    break;
                                case 30:
                                    upperShift = true;
                                    break;
                                default:
                                    throw new FormatException();
                            }
                            shift = 0;
                            break;
                        case 3:
                            if (upperShift) {
                                result.append(String.fromCharCode(cValue + 224));
                                upperShift = false;
                            } else result.append(String.fromCharCode(cValue + 96));
                            shift = 0;
                            break;
                        default:
                            throw new FormatException();
                    }
                }
            }while (bits.available() > 0);
        }
        /**
         * See ISO 16022:2006, 5.2.6 and Annex C, Table C.2
         */ static decodeTextSegment(bits, result) {
            // Three Text values are encoded in a 16-bit value as
            // (1600 * C1) + (40 * C2) + C3 + 1
            // TODO(bbrown): The Upper Shift with Text doesn't work in the 4 value scenario all the time
            let upperShift = false;
            let cValues = [];
            let shift = 0;
            do {
                // If there is only one byte left then it will be encoded as ASCII
                if (bits.available() === 8) return;
                const firstByte = bits.readBits(8);
                if (firstByte === 254) return;
                this.parseTwoBytes(firstByte, bits.readBits(8), cValues);
                for(let i = 0; i < 3; i++){
                    const cValue = cValues[i];
                    switch(shift){
                        case 0:
                            if (cValue < 3) shift = cValue + 1;
                            else if (cValue < this.TEXT_BASIC_SET_CHARS.length) {
                                const textChar = this.TEXT_BASIC_SET_CHARS[cValue];
                                if (upperShift) {
                                    result.append(String.fromCharCode(textChar.charCodeAt(0) + 128));
                                    upperShift = false;
                                } else result.append(textChar);
                            } else throw new FormatException();
                            break;
                        case 1:
                            if (upperShift) {
                                result.append(String.fromCharCode(cValue + 128));
                                upperShift = false;
                            } else result.append(String.fromCharCode(cValue));
                            shift = 0;
                            break;
                        case 2:
                            // Shift 2 for Text is the same encoding as C40
                            if (cValue < this.TEXT_SHIFT2_SET_CHARS.length) {
                                const textChar = this.TEXT_SHIFT2_SET_CHARS[cValue];
                                if (upperShift) {
                                    result.append(String.fromCharCode(textChar.charCodeAt(0) + 128));
                                    upperShift = false;
                                } else result.append(textChar);
                            } else switch(cValue){
                                case 27:
                                    result.append(String.fromCharCode(29)); // translate as ASCII 29
                                    break;
                                case 30:
                                    upperShift = true;
                                    break;
                                default:
                                    throw new FormatException();
                            }
                            shift = 0;
                            break;
                        case 3:
                            if (cValue < this.TEXT_SHIFT3_SET_CHARS.length) {
                                const textChar = this.TEXT_SHIFT3_SET_CHARS[cValue];
                                if (upperShift) {
                                    result.append(String.fromCharCode(textChar.charCodeAt(0) + 128));
                                    upperShift = false;
                                } else result.append(textChar);
                                shift = 0;
                            } else throw new FormatException();
                            break;
                        default:
                            throw new FormatException();
                    }
                }
            }while (bits.available() > 0);
        }
        /**
         * See ISO 16022:2006, 5.2.7
         */ static decodeAnsiX12Segment(bits, result) {
            // Three ANSI X12 values are encoded in a 16-bit value as
            // (1600 * C1) + (40 * C2) + C3 + 1
            const cValues = [];
            do {
                // If there is only one byte left then it will be encoded as ASCII
                if (bits.available() === 8) return;
                const firstByte = bits.readBits(8);
                if (firstByte === 254) return;
                this.parseTwoBytes(firstByte, bits.readBits(8), cValues);
                for(let i = 0; i < 3; i++){
                    const cValue = cValues[i];
                    switch(cValue){
                        case 0:
                            result.append('\r');
                            break;
                        case 1:
                            result.append('*');
                            break;
                        case 2:
                            result.append('>');
                            break;
                        case 3:
                            result.append(' ');
                            break;
                        default:
                            if (cValue < 14) result.append(String.fromCharCode(cValue + 44));
                            else if (cValue < 40) result.append(String.fromCharCode(cValue + 51));
                            else throw new FormatException();
                            break;
                    }
                }
            }while (bits.available() > 0);
        }
        static parseTwoBytes(firstByte, secondByte, result) {
            let fullBitValue = (firstByte << 8) + secondByte - 1;
            let temp = Math.floor(fullBitValue / 1600);
            result[0] = temp;
            fullBitValue -= temp * 1600;
            temp = Math.floor(fullBitValue / 40);
            result[1] = temp;
            result[2] = fullBitValue - temp * 40;
        }
        /**
         * See ISO 16022:2006, 5.2.8 and Annex C Table C.3
         */ static decodeEdifactSegment(bits, result) {
            do {
                // If there is only two or less bytes left then it will be encoded as ASCII
                if (bits.available() <= 16) return;
                for(let i = 0; i < 4; i++){
                    let edifactValue = bits.readBits(6);
                    // Check for the unlatch character
                    if (edifactValue === 0x1F) {
                        // Read rest of byte, which should be 0, and stop
                        const bitsLeft = 8 - bits.getBitOffset();
                        if (bitsLeft !== 8) bits.readBits(bitsLeft);
                        return;
                    }
                    if ((edifactValue & 0x20) === 0) edifactValue |= 0x40; // Add a leading 01 to the 6 bit binary value
                    result.append(String.fromCharCode(edifactValue));
                }
            }while (bits.available() > 0);
        }
        /**
         * See ISO 16022:2006, 5.2.9 and Annex B, B.2
         */ static decodeBase256Segment(bits, result, byteSegments) {
            // Figure out how long the Base 256 Segment is.
            let codewordPosition = 1 + bits.getByteOffset(); // position is 1-indexed
            const d1 = this.unrandomize255State(bits.readBits(8), codewordPosition++);
            let count;
            if (d1 === 0) count = bits.available() / 8 | 0;
            else if (d1 < 250) count = d1;
            else count = 250 * (d1 - 249) + this.unrandomize255State(bits.readBits(8), codewordPosition++);
            // We're seeing NegativeArraySizeException errors from users.
            if (count < 0) throw new FormatException();
            const bytes = new Uint8Array(count);
            for(let i = 0; i < count; i++){
                // Have seen this particular error in the wild, such as at
                // http://www.bcgen.com/demo/IDAutomationStreamingDataMatrix.aspx?MODE=3&D=Fred&PFMT=3&PT=F&X=0.3&O=0&LM=0.2
                if (bits.available() < 8) throw new FormatException();
                bytes[i] = this.unrandomize255State(bits.readBits(8), codewordPosition++);
            }
            byteSegments.push(bytes);
            try {
                result.append(StringEncoding.decode(bytes, StringUtils.ISO88591));
            } catch (uee) {
                throw new IllegalStateException('Platform does not support required encoding: ' + uee.message);
            }
        }
        /**
         * See ISO 16022:2006, Annex B, B.2
         */ static unrandomize255State(randomizedBase256Codeword, base256CodewordPosition) {
            const pseudoRandomNumber = 149 * base256CodewordPosition % 255 + 1;
            const tempVariable = randomizedBase256Codeword - pseudoRandomNumber;
            return tempVariable >= 0 ? tempVariable : tempVariable + 256;
        }
    }
    /**
     * See ISO 16022:2006, Annex C Table C.1
     * The C40 Basic Character Set (*'s used for placeholders for the shift values)
     */ DecodedBitStreamParser.C40_BASIC_SET_CHARS = [
        '*',
        '*',
        '*',
        ' ',
        '0',
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        'A',
        'B',
        'C',
        'D',
        'E',
        'F',
        'G',
        'H',
        'I',
        'J',
        'K',
        'L',
        'M',
        'N',
        'O',
        'P',
        'Q',
        'R',
        'S',
        'T',
        'U',
        'V',
        'W',
        'X',
        'Y',
        'Z'
    ];
    DecodedBitStreamParser.C40_SHIFT2_SET_CHARS = [
        '!',
        '"',
        '#',
        '$',
        '%',
        '&',
        '\'',
        '(',
        ')',
        '*',
        '+',
        ',',
        '-',
        '.',
        '/',
        ':',
        ';',
        '<',
        '=',
        '>',
        '?',
        '@',
        '[',
        '\\',
        ']',
        '^',
        '_'
    ];
    /**
     * See ISO 16022:2006, Annex C Table C.2
     * The Text Basic Character Set (*'s used for placeholders for the shift values)
     */ DecodedBitStreamParser.TEXT_BASIC_SET_CHARS = [
        '*',
        '*',
        '*',
        ' ',
        '0',
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        'a',
        'b',
        'c',
        'd',
        'e',
        'f',
        'g',
        'h',
        'i',
        'j',
        'k',
        'l',
        'm',
        'n',
        'o',
        'p',
        'q',
        'r',
        's',
        't',
        'u',
        'v',
        'w',
        'x',
        'y',
        'z'
    ];
    // Shift 2 for Text is the same encoding as C40
    DecodedBitStreamParser.TEXT_SHIFT2_SET_CHARS = DecodedBitStreamParser.C40_SHIFT2_SET_CHARS;
    DecodedBitStreamParser.TEXT_SHIFT3_SET_CHARS = [
        '`',
        'A',
        'B',
        'C',
        'D',
        'E',
        'F',
        'G',
        'H',
        'I',
        'J',
        'K',
        'L',
        'M',
        'N',
        'O',
        'P',
        'Q',
        'R',
        'S',
        'T',
        'U',
        'V',
        'W',
        'X',
        'Y',
        'Z',
        '{',
        '|',
        '}',
        '~',
        String.fromCharCode(127)
    ];
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * <p>The main class which implements Data Matrix Code decoding -- as opposed to locating and extracting
     * the Data Matrix Code from an image.</p>
     *
     * @author bbrown@google.com (Brian Brown)
     */ class Decoder$1 {
        constructor(){
            this.rsDecoder = new ReedSolomonDecoder(GenericGF.DATA_MATRIX_FIELD_256);
        }
        /**
         * <p>Decodes a Data Matrix Code represented as a {@link BitMatrix}. A 1 or "true" is taken
         * to mean a black module.</p>
         *
         * @param bits booleans representing white/black Data Matrix Code modules
         * @return text and bytes encoded within the Data Matrix Code
         * @throws FormatException if the Data Matrix Code cannot be decoded
         * @throws ChecksumException if error correction fails
         */ decode(bits) {
            // Construct a parser and read version, error-correction level
            const parser = new BitMatrixParser(bits);
            const version = parser.getVersion();
            // Read codewords
            const codewords = parser.readCodewords();
            // Separate into data blocks
            const dataBlocks = DataBlock.getDataBlocks(codewords, version);
            // Count total number of data bytes
            let totalBytes = 0;
            for (let db of dataBlocks)totalBytes += db.getNumDataCodewords();
            const resultBytes = new Uint8Array(totalBytes);
            const dataBlocksCount = dataBlocks.length;
            // Error-correct and copy data blocks together into a stream of bytes
            for(let j = 0; j < dataBlocksCount; j++){
                const dataBlock = dataBlocks[j];
                const codewordBytes = dataBlock.getCodewords();
                const numDataCodewords = dataBlock.getNumDataCodewords();
                this.correctErrors(codewordBytes, numDataCodewords);
                for(let i = 0; i < numDataCodewords; i++)// De-interlace data blocks.
                resultBytes[i * dataBlocksCount + j] = codewordBytes[i];
            }
            // Decode the contents of that stream of bytes
            return DecodedBitStreamParser.decode(resultBytes);
        }
        /**
         * <p>Given data and error-correction codewords received, possibly corrupted by errors, attempts to
         * correct the errors in-place using Reed-Solomon error correction.</p>
         *
         * @param codewordBytes data and error correction codewords
         * @param numDataCodewords number of codewords that are data bytes
         * @throws ChecksumException if error correction fails
         */ correctErrors(codewordBytes, numDataCodewords) {
            // const numCodewords = codewordBytes.length;
            // First read into an array of ints
            const codewordsInts = new Int32Array(codewordBytes);
            // for (let i = 0; i < numCodewords; i++) {
            //   codewordsInts[i] = codewordBytes[i] & 0xFF;
            // }
            try {
                this.rsDecoder.decode(codewordsInts, codewordBytes.length - numDataCodewords);
            } catch (ignored /* ReedSolomonException */ ) {
                throw new ChecksumException();
            }
            // Copy back into array of bytes -- only need to worry about the bytes that were data
            // We don't care about errors in the error-correction codewords
            for(let i = 0; i < numDataCodewords; i++)codewordBytes[i] = codewordsInts[i];
        }
    }
    /**
     * <p>Encapsulates logic that can detect a Data Matrix Code in an image, even if the Data Matrix Code
     * is rotated or skewed, or partially obscured.</p>
     *
     * @author Sean Owen
     */ class Detector$1 {
        constructor(image){
            this.image = image;
            this.rectangleDetector = new WhiteRectangleDetector(this.image);
        }
        /**
         * <p>Detects a Data Matrix Code in an image.</p>
         *
         * @return {@link DetectorResult} encapsulating results of detecting a Data Matrix Code
         * @throws NotFoundException if no Data Matrix Code can be found
         */ detect() {
            const cornerPoints = this.rectangleDetector.detect();
            let points = this.detectSolid1(cornerPoints);
            points = this.detectSolid2(points);
            points[3] = this.correctTopRight(points);
            if (!points[3]) throw new NotFoundException();
            points = this.shiftToModuleCenter(points);
            const topLeft = points[0];
            const bottomLeft = points[1];
            const bottomRight = points[2];
            const topRight = points[3];
            let dimensionTop = this.transitionsBetween(topLeft, topRight) + 1;
            let dimensionRight = this.transitionsBetween(bottomRight, topRight) + 1;
            if ((dimensionTop & 0x01) === 1) dimensionTop += 1;
            if ((dimensionRight & 0x01) === 1) dimensionRight += 1;
            if (4 * dimensionTop < 7 * dimensionRight && 4 * dimensionRight < 7 * dimensionTop) // The matrix is square
            dimensionTop = dimensionRight = Math.max(dimensionTop, dimensionRight);
            let bits = Detector$1.sampleGrid(this.image, topLeft, bottomLeft, bottomRight, topRight, dimensionTop, dimensionRight);
            return new DetectorResult(bits, [
                topLeft,
                bottomLeft,
                bottomRight,
                topRight
            ]);
        }
        static shiftPoint(point, to, div) {
            let x = (to.getX() - point.getX()) / (div + 1);
            let y = (to.getY() - point.getY()) / (div + 1);
            return new ResultPoint(point.getX() + x, point.getY() + y);
        }
        static moveAway(point, fromX, fromY) {
            let x = point.getX();
            let y = point.getY();
            if (x < fromX) x -= 1;
            else x += 1;
            if (y < fromY) y -= 1;
            else y += 1;
            return new ResultPoint(x, y);
        }
        /**
         * Detect a solid side which has minimum transition.
         */ detectSolid1(cornerPoints) {
            // 0  2
            // 1  3
            let pointA = cornerPoints[0];
            let pointB = cornerPoints[1];
            let pointC = cornerPoints[3];
            let pointD = cornerPoints[2];
            let trAB = this.transitionsBetween(pointA, pointB);
            let trBC = this.transitionsBetween(pointB, pointC);
            let trCD = this.transitionsBetween(pointC, pointD);
            let trDA = this.transitionsBetween(pointD, pointA);
            // 0..3
            // :  :
            // 1--2
            let min = trAB;
            let points = [
                pointD,
                pointA,
                pointB,
                pointC
            ];
            if (min > trBC) {
                min = trBC;
                points[0] = pointA;
                points[1] = pointB;
                points[2] = pointC;
                points[3] = pointD;
            }
            if (min > trCD) {
                min = trCD;
                points[0] = pointB;
                points[1] = pointC;
                points[2] = pointD;
                points[3] = pointA;
            }
            if (min > trDA) {
                points[0] = pointC;
                points[1] = pointD;
                points[2] = pointA;
                points[3] = pointB;
            }
            return points;
        }
        /**
         * Detect a second solid side next to first solid side.
         */ detectSolid2(points) {
            // A..D
            // :  :
            // B--C
            let pointA = points[0];
            let pointB = points[1];
            let pointC = points[2];
            let pointD = points[3];
            // Transition detection on the edge is not stable.
            // To safely detect, shift the points to the module center.
            let tr = this.transitionsBetween(pointA, pointD);
            let pointBs = Detector$1.shiftPoint(pointB, pointC, (tr + 1) * 4);
            let pointCs = Detector$1.shiftPoint(pointC, pointB, (tr + 1) * 4);
            let trBA = this.transitionsBetween(pointBs, pointA);
            let trCD = this.transitionsBetween(pointCs, pointD);
            // 0..3
            // |  :
            // 1--2
            if (trBA < trCD) {
                // solid sides: A-B-C
                points[0] = pointA;
                points[1] = pointB;
                points[2] = pointC;
                points[3] = pointD;
            } else {
                // solid sides: B-C-D
                points[0] = pointB;
                points[1] = pointC;
                points[2] = pointD;
                points[3] = pointA;
            }
            return points;
        }
        /**
         * Calculates the corner position of the white top right module.
         */ correctTopRight(points) {
            // A..D
            // |  :
            // B--C
            let pointA = points[0];
            let pointB = points[1];
            let pointC = points[2];
            let pointD = points[3];
            // shift points for safe transition detection.
            let trTop = this.transitionsBetween(pointA, pointD);
            let trRight = this.transitionsBetween(pointB, pointD);
            let pointAs = Detector$1.shiftPoint(pointA, pointB, (trRight + 1) * 4);
            let pointCs = Detector$1.shiftPoint(pointC, pointB, (trTop + 1) * 4);
            trTop = this.transitionsBetween(pointAs, pointD);
            trRight = this.transitionsBetween(pointCs, pointD);
            let candidate1 = new ResultPoint(pointD.getX() + (pointC.getX() - pointB.getX()) / (trTop + 1), pointD.getY() + (pointC.getY() - pointB.getY()) / (trTop + 1));
            let candidate2 = new ResultPoint(pointD.getX() + (pointA.getX() - pointB.getX()) / (trRight + 1), pointD.getY() + (pointA.getY() - pointB.getY()) / (trRight + 1));
            if (!this.isValid(candidate1)) {
                if (this.isValid(candidate2)) return candidate2;
                return null;
            }
            if (!this.isValid(candidate2)) return candidate1;
            let sumc1 = this.transitionsBetween(pointAs, candidate1) + this.transitionsBetween(pointCs, candidate1);
            let sumc2 = this.transitionsBetween(pointAs, candidate2) + this.transitionsBetween(pointCs, candidate2);
            if (sumc1 > sumc2) return candidate1;
            else return candidate2;
        }
        /**
         * Shift the edge points to the module center.
         */ shiftToModuleCenter(points) {
            // A..D
            // |  :
            // B--C
            let pointA = points[0];
            let pointB = points[1];
            let pointC = points[2];
            let pointD = points[3];
            // calculate pseudo dimensions
            let dimH = this.transitionsBetween(pointA, pointD) + 1;
            let dimV = this.transitionsBetween(pointC, pointD) + 1;
            // shift points for safe dimension detection
            let pointAs = Detector$1.shiftPoint(pointA, pointB, dimV * 4);
            let pointCs = Detector$1.shiftPoint(pointC, pointB, dimH * 4);
            //  calculate more precise dimensions
            dimH = this.transitionsBetween(pointAs, pointD) + 1;
            dimV = this.transitionsBetween(pointCs, pointD) + 1;
            if ((dimH & 0x01) === 1) dimH += 1;
            if ((dimV & 0x01) === 1) dimV += 1;
            // WhiteRectangleDetector returns points inside of the rectangle.
            // I want points on the edges.
            let centerX = (pointA.getX() + pointB.getX() + pointC.getX() + pointD.getX()) / 4;
            let centerY = (pointA.getY() + pointB.getY() + pointC.getY() + pointD.getY()) / 4;
            pointA = Detector$1.moveAway(pointA, centerX, centerY);
            pointB = Detector$1.moveAway(pointB, centerX, centerY);
            pointC = Detector$1.moveAway(pointC, centerX, centerY);
            pointD = Detector$1.moveAway(pointD, centerX, centerY);
            let pointBs;
            let pointDs;
            // shift points to the center of each modules
            pointAs = Detector$1.shiftPoint(pointA, pointB, dimV * 4);
            pointAs = Detector$1.shiftPoint(pointAs, pointD, dimH * 4);
            pointBs = Detector$1.shiftPoint(pointB, pointA, dimV * 4);
            pointBs = Detector$1.shiftPoint(pointBs, pointC, dimH * 4);
            pointCs = Detector$1.shiftPoint(pointC, pointD, dimV * 4);
            pointCs = Detector$1.shiftPoint(pointCs, pointB, dimH * 4);
            pointDs = Detector$1.shiftPoint(pointD, pointC, dimV * 4);
            pointDs = Detector$1.shiftPoint(pointDs, pointA, dimH * 4);
            return [
                pointAs,
                pointBs,
                pointCs,
                pointDs
            ];
        }
        isValid(p) {
            return p.getX() >= 0 && p.getX() < this.image.getWidth() && p.getY() > 0 && p.getY() < this.image.getHeight();
        }
        static sampleGrid(image, topLeft, bottomLeft, bottomRight, topRight, dimensionX, dimensionY) {
            const sampler = GridSamplerInstance.getInstance();
            return sampler.sampleGrid(image, dimensionX, dimensionY, 0.5, 0.5, dimensionX - 0.5, 0.5, dimensionX - 0.5, dimensionY - 0.5, 0.5, dimensionY - 0.5, topLeft.getX(), topLeft.getY(), topRight.getX(), topRight.getY(), bottomRight.getX(), bottomRight.getY(), bottomLeft.getX(), bottomLeft.getY());
        }
        /**
         * Counts the number of black/white transitions between two points, using something like Bresenham's algorithm.
         */ transitionsBetween(from, to) {
            // See QR Code Detector, sizeOfBlackWhiteBlackRun()
            let fromX = Math.trunc(from.getX());
            let fromY = Math.trunc(from.getY());
            let toX = Math.trunc(to.getX());
            let toY = Math.trunc(to.getY());
            let steep = Math.abs(toY - fromY) > Math.abs(toX - fromX);
            if (steep) {
                let temp = fromX;
                fromX = fromY;
                fromY = temp;
                temp = toX;
                toX = toY;
                toY = temp;
            }
            let dx = Math.abs(toX - fromX);
            let dy = Math.abs(toY - fromY);
            let error = -dx / 2;
            let ystep = fromY < toY ? 1 : -1;
            let xstep = fromX < toX ? 1 : -1;
            let transitions = 0;
            let inBlack = this.image.get(steep ? fromY : fromX, steep ? fromX : fromY);
            for(let x = fromX, y = fromY; x !== toX; x += xstep){
                let isBlack = this.image.get(steep ? y : x, steep ? x : y);
                if (isBlack !== inBlack) {
                    transitions++;
                    inBlack = isBlack;
                }
                error += dy;
                if (error > 0) {
                    if (y === toY) break;
                    y += ystep;
                    error -= dx;
                }
            }
            return transitions;
        }
    }
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * This implementation can detect and decode Data Matrix codes in an image.
     *
     * @author bbrown@google.com (Brian Brown)
     */ class DataMatrixReader {
        constructor(){
            this.decoder = new Decoder$1();
        }
        /**
         * Locates and decodes a Data Matrix code in an image.
         *
         * @return a String representing the content encoded by the Data Matrix code
         * @throws NotFoundException if a Data Matrix code cannot be found
         * @throws FormatException if a Data Matrix code cannot be decoded
         * @throws ChecksumException if error correction fails
         */ // @Override
        // public Result decode(BinaryBitmap image) throws NotFoundException, ChecksumException, FormatException {
        //   return decode(image, null);
        // }
        // @Override
        decode(image, hints = null) {
            let decoderResult;
            let points;
            if (hints != null && hints.has(DecodeHintType$1.PURE_BARCODE)) {
                const bits = DataMatrixReader.extractPureBits(image.getBlackMatrix());
                decoderResult = this.decoder.decode(bits);
                points = DataMatrixReader.NO_POINTS;
            } else {
                const detectorResult = new Detector$1(image.getBlackMatrix()).detect();
                decoderResult = this.decoder.decode(detectorResult.getBits());
                points = detectorResult.getPoints();
            }
            const rawBytes = decoderResult.getRawBytes();
            const result = new Result(decoderResult.getText(), rawBytes, 8 * rawBytes.length, points, BarcodeFormat$1.DATA_MATRIX, System.currentTimeMillis());
            const byteSegments = decoderResult.getByteSegments();
            if (byteSegments != null) result.putMetadata(ResultMetadataType$1.BYTE_SEGMENTS, byteSegments);
            const ecLevel = decoderResult.getECLevel();
            if (ecLevel != null) result.putMetadata(ResultMetadataType$1.ERROR_CORRECTION_LEVEL, ecLevel);
            return result;
        }
        // @Override
        reset() {
        // do nothing
        }
        /**
         * This method detects a code in a "pure" image -- that is, pure monochrome image
         * which contains only an unrotated, unskewed, image of a code, with some white border
         * around it. This is a specialized method that works exceptionally fast in this special
         * case.
         *
         * @see com.google.zxing.qrcode.QRCodeReader#extractPureBits(BitMatrix)
         */ static extractPureBits(image) {
            const leftTopBlack = image.getTopLeftOnBit();
            const rightBottomBlack = image.getBottomRightOnBit();
            if (leftTopBlack == null || rightBottomBlack == null) throw new NotFoundException();
            const moduleSize = this.moduleSize(leftTopBlack, image);
            let top = leftTopBlack[1];
            const bottom = rightBottomBlack[1];
            let left = leftTopBlack[0];
            const right = rightBottomBlack[0];
            const matrixWidth = (right - left + 1) / moduleSize;
            const matrixHeight = (bottom - top + 1) / moduleSize;
            if (matrixWidth <= 0 || matrixHeight <= 0) throw new NotFoundException();
            // Push in the "border" by half the module width so that we start
            // sampling in the middle of the module. Just in case the image is a
            // little off, this will help recover.
            const nudge = moduleSize / 2;
            top += nudge;
            left += nudge;
            // Now just read off the bits
            const bits = new BitMatrix(matrixWidth, matrixHeight);
            for(let y = 0; y < matrixHeight; y++){
                const iOffset = top + y * moduleSize;
                for(let x = 0; x < matrixWidth; x++)if (image.get(left + x * moduleSize, iOffset)) bits.set(x, y);
            }
            return bits;
        }
        static moduleSize(leftTopBlack, image) {
            const width = image.getWidth();
            let x = leftTopBlack[0];
            const y = leftTopBlack[1];
            while(x < width && image.get(x, y))x++;
            if (x === width) throw new NotFoundException();
            const moduleSize = x - leftTopBlack[0];
            if (moduleSize === 0) throw new NotFoundException();
            return moduleSize;
        }
    }
    DataMatrixReader.NO_POINTS = [];
    /**
     * @deprecated Moving to @zxing/browser
     *
     * QR Code reader to use from browser.
     */ class BrowserDatamatrixCodeReader extends BrowserCodeReader {
        /**
         * Creates an instance of BrowserQRCodeReader.
         * @param {number} [timeBetweenScansMillis=500] the time delay between subsequent decode tries
         */ constructor(timeBetweenScansMillis = 500){
            super(new DataMatrixReader(), timeBetweenScansMillis);
        }
    }
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ var ErrorCorrectionLevelValues;
    (function(ErrorCorrectionLevelValues) {
        ErrorCorrectionLevelValues[ErrorCorrectionLevelValues["L"] = 0] = "L";
        ErrorCorrectionLevelValues[ErrorCorrectionLevelValues["M"] = 1] = "M";
        ErrorCorrectionLevelValues[ErrorCorrectionLevelValues["Q"] = 2] = "Q";
        ErrorCorrectionLevelValues[ErrorCorrectionLevelValues["H"] = 3] = "H";
    })(ErrorCorrectionLevelValues || (ErrorCorrectionLevelValues = {}));
    /**
     * <p>See ISO 18004:2006, 6.5.1. This enum encapsulates the four error correction levels
     * defined by the QR code standard.</p>
     *
     * @author Sean Owen
     */ class ErrorCorrectionLevel {
        constructor(value, stringValue, bits /*int*/ ){
            this.value = value;
            this.stringValue = stringValue;
            this.bits = bits;
            ErrorCorrectionLevel.FOR_BITS.set(bits, this);
            ErrorCorrectionLevel.FOR_VALUE.set(value, this);
        }
        getValue() {
            return this.value;
        }
        getBits() {
            return this.bits;
        }
        static fromString(s) {
            switch(s){
                case 'L':
                    return ErrorCorrectionLevel.L;
                case 'M':
                    return ErrorCorrectionLevel.M;
                case 'Q':
                    return ErrorCorrectionLevel.Q;
                case 'H':
                    return ErrorCorrectionLevel.H;
                default:
                    throw new ArgumentException(s + 'not available');
            }
        }
        toString() {
            return this.stringValue;
        }
        equals(o) {
            if (!(o instanceof ErrorCorrectionLevel)) return false;
            const other = o;
            return this.value === other.value;
        }
        /**
         * @param bits int containing the two bits encoding a QR Code's error correction level
         * @return ErrorCorrectionLevel representing the encoded error correction level
         */ static forBits(bits /*int*/ ) {
            if (bits < 0 || bits >= ErrorCorrectionLevel.FOR_BITS.size) throw new IllegalArgumentException();
            return ErrorCorrectionLevel.FOR_BITS.get(bits);
        }
    }
    ErrorCorrectionLevel.FOR_BITS = new Map();
    ErrorCorrectionLevel.FOR_VALUE = new Map();
    /** L = ~7% correction */ ErrorCorrectionLevel.L = new ErrorCorrectionLevel(ErrorCorrectionLevelValues.L, 'L', 0x01);
    /** M = ~15% correction */ ErrorCorrectionLevel.M = new ErrorCorrectionLevel(ErrorCorrectionLevelValues.M, 'M', 0x00);
    /** Q = ~25% correction */ ErrorCorrectionLevel.Q = new ErrorCorrectionLevel(ErrorCorrectionLevelValues.Q, 'Q', 0x03);
    /** H = ~30% correction */ ErrorCorrectionLevel.H = new ErrorCorrectionLevel(ErrorCorrectionLevelValues.H, 'H', 0x02);
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * <p>Encapsulates a QR Code's format information, including the data mask used and
     * error correction level.</p>
     *
     * @author Sean Owen
     * @see DataMask
     * @see ErrorCorrectionLevel
     */ class FormatInformation {
        constructor(formatInfo /*int*/ ){
            // Bits 3,4
            this.errorCorrectionLevel = ErrorCorrectionLevel.forBits(formatInfo >> 3 & 0x03);
            // Bottom 3 bits
            this.dataMask = /*(byte) */ formatInfo & 0x07;
        }
        static numBitsDiffering(a /*int*/ , b /*int*/ ) {
            return Integer.bitCount(a ^ b);
        }
        /**
         * @param maskedFormatInfo1 format info indicator, with mask still applied
         * @param maskedFormatInfo2 second copy of same info; both are checked at the same time
         *  to establish best match
         * @return information about the format it specifies, or {@code null}
         *  if doesn't seem to match any known pattern
         */ static decodeFormatInformation(maskedFormatInfo1 /*int*/ , maskedFormatInfo2 /*int*/ ) {
            const formatInfo = FormatInformation.doDecodeFormatInformation(maskedFormatInfo1, maskedFormatInfo2);
            if (formatInfo !== null) return formatInfo;
            // Should return null, but, some QR codes apparently
            // do not mask this info. Try again by actually masking the pattern
            // first
            return FormatInformation.doDecodeFormatInformation(maskedFormatInfo1 ^ FormatInformation.FORMAT_INFO_MASK_QR, maskedFormatInfo2 ^ FormatInformation.FORMAT_INFO_MASK_QR);
        }
        static doDecodeFormatInformation(maskedFormatInfo1 /*int*/ , maskedFormatInfo2 /*int*/ ) {
            // Find the int in FORMAT_INFO_DECODE_LOOKUP with fewest bits differing
            let bestDifference = Number.MAX_SAFE_INTEGER;
            let bestFormatInfo = 0;
            for (const decodeInfo of FormatInformation.FORMAT_INFO_DECODE_LOOKUP){
                const targetInfo = decodeInfo[0];
                if (targetInfo === maskedFormatInfo1 || targetInfo === maskedFormatInfo2) // Found an exact match
                return new FormatInformation(decodeInfo[1]);
                let bitsDifference = FormatInformation.numBitsDiffering(maskedFormatInfo1, targetInfo);
                if (bitsDifference < bestDifference) {
                    bestFormatInfo = decodeInfo[1];
                    bestDifference = bitsDifference;
                }
                if (maskedFormatInfo1 !== maskedFormatInfo2) {
                    // also try the other option
                    bitsDifference = FormatInformation.numBitsDiffering(maskedFormatInfo2, targetInfo);
                    if (bitsDifference < bestDifference) {
                        bestFormatInfo = decodeInfo[1];
                        bestDifference = bitsDifference;
                    }
                }
            }
            // Hamming distance of the 32 masked codes is 7, by construction, so <= 3 bits
            // differing means we found a match
            if (bestDifference <= 3) return new FormatInformation(bestFormatInfo);
            return null;
        }
        getErrorCorrectionLevel() {
            return this.errorCorrectionLevel;
        }
        getDataMask() {
            return this.dataMask;
        }
        /*@Override*/ hashCode() {
            return this.errorCorrectionLevel.getBits() << 3 | this.dataMask;
        }
        /*@Override*/ equals(o) {
            if (!(o instanceof FormatInformation)) return false;
            const other = o;
            return this.errorCorrectionLevel === other.errorCorrectionLevel && this.dataMask === other.dataMask;
        }
    }
    FormatInformation.FORMAT_INFO_MASK_QR = 0x5412;
    /**
     * See ISO 18004:2006, Annex C, Table C.1
     */ FormatInformation.FORMAT_INFO_DECODE_LOOKUP = [
        Int32Array.from([
            0x5412,
            0x00
        ]),
        Int32Array.from([
            0x5125,
            0x01
        ]),
        Int32Array.from([
            0x5E7C,
            0x02
        ]),
        Int32Array.from([
            0x5B4B,
            0x03
        ]),
        Int32Array.from([
            0x45F9,
            0x04
        ]),
        Int32Array.from([
            0x40CE,
            0x05
        ]),
        Int32Array.from([
            0x4F97,
            0x06
        ]),
        Int32Array.from([
            0x4AA0,
            0x07
        ]),
        Int32Array.from([
            0x77C4,
            0x08
        ]),
        Int32Array.from([
            0x72F3,
            0x09
        ]),
        Int32Array.from([
            0x7DAA,
            0x0A
        ]),
        Int32Array.from([
            0x789D,
            0x0B
        ]),
        Int32Array.from([
            0x662F,
            0x0C
        ]),
        Int32Array.from([
            0x6318,
            0x0D
        ]),
        Int32Array.from([
            0x6C41,
            0x0E
        ]),
        Int32Array.from([
            0x6976,
            0x0F
        ]),
        Int32Array.from([
            0x1689,
            0x10
        ]),
        Int32Array.from([
            0x13BE,
            0x11
        ]),
        Int32Array.from([
            0x1CE7,
            0x12
        ]),
        Int32Array.from([
            0x19D0,
            0x13
        ]),
        Int32Array.from([
            0x0762,
            0x14
        ]),
        Int32Array.from([
            0x0255,
            0x15
        ]),
        Int32Array.from([
            0x0D0C,
            0x16
        ]),
        Int32Array.from([
            0x083B,
            0x17
        ]),
        Int32Array.from([
            0x355F,
            0x18
        ]),
        Int32Array.from([
            0x3068,
            0x19
        ]),
        Int32Array.from([
            0x3F31,
            0x1A
        ]),
        Int32Array.from([
            0x3A06,
            0x1B
        ]),
        Int32Array.from([
            0x24B4,
            0x1C
        ]),
        Int32Array.from([
            0x2183,
            0x1D
        ]),
        Int32Array.from([
            0x2EDA,
            0x1E
        ]),
        Int32Array.from([
            0x2BED,
            0x1F
        ])
    ];
    /**
     * <p>Encapsulates a set of error-correction blocks in one symbol version. Most versions will
     * use blocks of differing sizes within one version, so, this encapsulates the parameters for
     * each set of blocks. It also holds the number of error-correction codewords per block since it
     * will be the same across all blocks within one version.</p>
     */ class ECBlocks$1 {
        constructor(ecCodewordsPerBlock /*int*/ , ...ecBlocks){
            this.ecCodewordsPerBlock = ecCodewordsPerBlock;
            this.ecBlocks = ecBlocks;
        }
        getECCodewordsPerBlock() {
            return this.ecCodewordsPerBlock;
        }
        getNumBlocks() {
            let total = 0;
            const ecBlocks = this.ecBlocks;
            for (const ecBlock of ecBlocks)total += ecBlock.getCount();
            return total;
        }
        getTotalECCodewords() {
            return this.ecCodewordsPerBlock * this.getNumBlocks();
        }
        getECBlocks() {
            return this.ecBlocks;
        }
    }
    /**
     * <p>Encapsulates the parameters for one error-correction block in one symbol version.
     * This includes the number of data codewords, and the number of times a block with these
     * parameters is used consecutively in the QR code version's format.</p>
     */ class ECB$1 {
        constructor(count /*int*/ , dataCodewords /*int*/ ){
            this.count = count;
            this.dataCodewords = dataCodewords;
        }
        getCount() {
            return this.count;
        }
        getDataCodewords() {
            return this.dataCodewords;
        }
    }
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * See ISO 18004:2006 Annex D
     *
     * @author Sean Owen
     */ class Version$1 {
        constructor(versionNumber /*int*/ , alignmentPatternCenters, ...ecBlocks){
            this.versionNumber = versionNumber;
            this.alignmentPatternCenters = alignmentPatternCenters;
            this.ecBlocks = ecBlocks;
            let total = 0;
            const ecCodewords = ecBlocks[0].getECCodewordsPerBlock();
            const ecbArray = ecBlocks[0].getECBlocks();
            for (const ecBlock of ecbArray)total += ecBlock.getCount() * (ecBlock.getDataCodewords() + ecCodewords);
            this.totalCodewords = total;
        }
        getVersionNumber() {
            return this.versionNumber;
        }
        getAlignmentPatternCenters() {
            return this.alignmentPatternCenters;
        }
        getTotalCodewords() {
            return this.totalCodewords;
        }
        getDimensionForVersion() {
            return 17 + 4 * this.versionNumber;
        }
        getECBlocksForLevel(ecLevel) {
            return this.ecBlocks[ecLevel.getValue()];
        // TYPESCRIPTPORT: original was using ordinal, and using the order of levels as defined in ErrorCorrectionLevel enum (LMQH)
        // I will use the direct value from ErrorCorrectionLevelValues enum which in typescript goes to a number
        }
        /**
         * <p>Deduces version information purely from QR Code dimensions.</p>
         *
         * @param dimension dimension in modules
         * @return Version for a QR Code of that dimension
         * @throws FormatException if dimension is not 1 mod 4
         */ static getProvisionalVersionForDimension(dimension /*int*/ ) {
            if (dimension % 4 !== 1) throw new FormatException();
            try {
                return this.getVersionForNumber((dimension - 17) / 4);
            } catch (ignored /*: IllegalArgumentException*/ ) {
                throw new FormatException();
            }
        }
        static getVersionForNumber(versionNumber /*int*/ ) {
            if (versionNumber < 1 || versionNumber > 40) throw new IllegalArgumentException();
            return Version$1.VERSIONS[versionNumber - 1];
        }
        static decodeVersionInformation(versionBits /*int*/ ) {
            let bestDifference = Number.MAX_SAFE_INTEGER;
            let bestVersion = 0;
            for(let i = 0; i < Version$1.VERSION_DECODE_INFO.length; i++){
                const targetVersion = Version$1.VERSION_DECODE_INFO[i];
                // Do the version info bits match exactly? done.
                if (targetVersion === versionBits) return Version$1.getVersionForNumber(i + 7);
                // Otherwise see if this is the closest to a real version info bit string
                // we have seen so far
                const bitsDifference = FormatInformation.numBitsDiffering(versionBits, targetVersion);
                if (bitsDifference < bestDifference) {
                    bestVersion = i + 7;
                    bestDifference = bitsDifference;
                }
            }
            // We can tolerate up to 3 bits of error since no two version info codewords will
            // differ in less than 8 bits.
            if (bestDifference <= 3) return Version$1.getVersionForNumber(bestVersion);
            // If we didn't find a close enough match, fail
            return null;
        }
        /**
         * See ISO 18004:2006 Annex E
         */ buildFunctionPattern() {
            const dimension = this.getDimensionForVersion();
            const bitMatrix = new BitMatrix(dimension);
            // Top left finder pattern + separator + format
            bitMatrix.setRegion(0, 0, 9, 9);
            // Top right finder pattern + separator + format
            bitMatrix.setRegion(dimension - 8, 0, 8, 9);
            // Bottom left finder pattern + separator + format
            bitMatrix.setRegion(0, dimension - 8, 9, 8);
            // Alignment patterns
            const max = this.alignmentPatternCenters.length;
            for(let x = 0; x < max; x++){
                const i = this.alignmentPatternCenters[x] - 2;
                for(let y = 0; y < max; y++){
                    if (x === 0 && (y === 0 || y === max - 1) || x === max - 1 && y === 0) continue;
                    bitMatrix.setRegion(this.alignmentPatternCenters[y] - 2, i, 5, 5);
                }
            }
            // Vertical timing pattern
            bitMatrix.setRegion(6, 9, 1, dimension - 17);
            // Horizontal timing pattern
            bitMatrix.setRegion(9, 6, dimension - 17, 1);
            if (this.versionNumber > 6) {
                // Version info, top right
                bitMatrix.setRegion(dimension - 11, 0, 3, 6);
                // Version info, bottom left
                bitMatrix.setRegion(0, dimension - 11, 6, 3);
            }
            return bitMatrix;
        }
        /*@Override*/ toString() {
            return '' + this.versionNumber;
        }
    }
    /**
       * See ISO 18004:2006 Annex D.
       * Element i represents the raw version bits that specify version i + 7
       */ Version$1.VERSION_DECODE_INFO = Int32Array.from([
        0x07C94,
        0x085BC,
        0x09A99,
        0x0A4D3,
        0x0BBF6,
        0x0C762,
        0x0D847,
        0x0E60D,
        0x0F928,
        0x10B78,
        0x1145D,
        0x12A17,
        0x13532,
        0x149A6,
        0x15683,
        0x168C9,
        0x177EC,
        0x18EC4,
        0x191E1,
        0x1AFAB,
        0x1B08E,
        0x1CC1A,
        0x1D33F,
        0x1ED75,
        0x1F250,
        0x209D5,
        0x216F0,
        0x228BA,
        0x2379F,
        0x24B0B,
        0x2542E,
        0x26A64,
        0x27541,
        0x28C69
    ]);
    /**
       * See ISO 18004:2006 6.5.1 Table 9
       */ Version$1.VERSIONS = [
        new Version$1(1, new Int32Array(0), new ECBlocks$1(7, new ECB$1(1, 19)), new ECBlocks$1(10, new ECB$1(1, 16)), new ECBlocks$1(13, new ECB$1(1, 13)), new ECBlocks$1(17, new ECB$1(1, 9))),
        new Version$1(2, Int32Array.from([
            6,
            18
        ]), new ECBlocks$1(10, new ECB$1(1, 34)), new ECBlocks$1(16, new ECB$1(1, 28)), new ECBlocks$1(22, new ECB$1(1, 22)), new ECBlocks$1(28, new ECB$1(1, 16))),
        new Version$1(3, Int32Array.from([
            6,
            22
        ]), new ECBlocks$1(15, new ECB$1(1, 55)), new ECBlocks$1(26, new ECB$1(1, 44)), new ECBlocks$1(18, new ECB$1(2, 17)), new ECBlocks$1(22, new ECB$1(2, 13))),
        new Version$1(4, Int32Array.from([
            6,
            26
        ]), new ECBlocks$1(20, new ECB$1(1, 80)), new ECBlocks$1(18, new ECB$1(2, 32)), new ECBlocks$1(26, new ECB$1(2, 24)), new ECBlocks$1(16, new ECB$1(4, 9))),
        new Version$1(5, Int32Array.from([
            6,
            30
        ]), new ECBlocks$1(26, new ECB$1(1, 108)), new ECBlocks$1(24, new ECB$1(2, 43)), new ECBlocks$1(18, new ECB$1(2, 15), new ECB$1(2, 16)), new ECBlocks$1(22, new ECB$1(2, 11), new ECB$1(2, 12))),
        new Version$1(6, Int32Array.from([
            6,
            34
        ]), new ECBlocks$1(18, new ECB$1(2, 68)), new ECBlocks$1(16, new ECB$1(4, 27)), new ECBlocks$1(24, new ECB$1(4, 19)), new ECBlocks$1(28, new ECB$1(4, 15))),
        new Version$1(7, Int32Array.from([
            6,
            22,
            38
        ]), new ECBlocks$1(20, new ECB$1(2, 78)), new ECBlocks$1(18, new ECB$1(4, 31)), new ECBlocks$1(18, new ECB$1(2, 14), new ECB$1(4, 15)), new ECBlocks$1(26, new ECB$1(4, 13), new ECB$1(1, 14))),
        new Version$1(8, Int32Array.from([
            6,
            24,
            42
        ]), new ECBlocks$1(24, new ECB$1(2, 97)), new ECBlocks$1(22, new ECB$1(2, 38), new ECB$1(2, 39)), new ECBlocks$1(22, new ECB$1(4, 18), new ECB$1(2, 19)), new ECBlocks$1(26, new ECB$1(4, 14), new ECB$1(2, 15))),
        new Version$1(9, Int32Array.from([
            6,
            26,
            46
        ]), new ECBlocks$1(30, new ECB$1(2, 116)), new ECBlocks$1(22, new ECB$1(3, 36), new ECB$1(2, 37)), new ECBlocks$1(20, new ECB$1(4, 16), new ECB$1(4, 17)), new ECBlocks$1(24, new ECB$1(4, 12), new ECB$1(4, 13))),
        new Version$1(10, Int32Array.from([
            6,
            28,
            50
        ]), new ECBlocks$1(18, new ECB$1(2, 68), new ECB$1(2, 69)), new ECBlocks$1(26, new ECB$1(4, 43), new ECB$1(1, 44)), new ECBlocks$1(24, new ECB$1(6, 19), new ECB$1(2, 20)), new ECBlocks$1(28, new ECB$1(6, 15), new ECB$1(2, 16))),
        new Version$1(11, Int32Array.from([
            6,
            30,
            54
        ]), new ECBlocks$1(20, new ECB$1(4, 81)), new ECBlocks$1(30, new ECB$1(1, 50), new ECB$1(4, 51)), new ECBlocks$1(28, new ECB$1(4, 22), new ECB$1(4, 23)), new ECBlocks$1(24, new ECB$1(3, 12), new ECB$1(8, 13))),
        new Version$1(12, Int32Array.from([
            6,
            32,
            58
        ]), new ECBlocks$1(24, new ECB$1(2, 92), new ECB$1(2, 93)), new ECBlocks$1(22, new ECB$1(6, 36), new ECB$1(2, 37)), new ECBlocks$1(26, new ECB$1(4, 20), new ECB$1(6, 21)), new ECBlocks$1(28, new ECB$1(7, 14), new ECB$1(4, 15))),
        new Version$1(13, Int32Array.from([
            6,
            34,
            62
        ]), new ECBlocks$1(26, new ECB$1(4, 107)), new ECBlocks$1(22, new ECB$1(8, 37), new ECB$1(1, 38)), new ECBlocks$1(24, new ECB$1(8, 20), new ECB$1(4, 21)), new ECBlocks$1(22, new ECB$1(12, 11), new ECB$1(4, 12))),
        new Version$1(14, Int32Array.from([
            6,
            26,
            46,
            66
        ]), new ECBlocks$1(30, new ECB$1(3, 115), new ECB$1(1, 116)), new ECBlocks$1(24, new ECB$1(4, 40), new ECB$1(5, 41)), new ECBlocks$1(20, new ECB$1(11, 16), new ECB$1(5, 17)), new ECBlocks$1(24, new ECB$1(11, 12), new ECB$1(5, 13))),
        new Version$1(15, Int32Array.from([
            6,
            26,
            48,
            70
        ]), new ECBlocks$1(22, new ECB$1(5, 87), new ECB$1(1, 88)), new ECBlocks$1(24, new ECB$1(5, 41), new ECB$1(5, 42)), new ECBlocks$1(30, new ECB$1(5, 24), new ECB$1(7, 25)), new ECBlocks$1(24, new ECB$1(11, 12), new ECB$1(7, 13))),
        new Version$1(16, Int32Array.from([
            6,
            26,
            50,
            74
        ]), new ECBlocks$1(24, new ECB$1(5, 98), new ECB$1(1, 99)), new ECBlocks$1(28, new ECB$1(7, 45), new ECB$1(3, 46)), new ECBlocks$1(24, new ECB$1(15, 19), new ECB$1(2, 20)), new ECBlocks$1(30, new ECB$1(3, 15), new ECB$1(13, 16))),
        new Version$1(17, Int32Array.from([
            6,
            30,
            54,
            78
        ]), new ECBlocks$1(28, new ECB$1(1, 107), new ECB$1(5, 108)), new ECBlocks$1(28, new ECB$1(10, 46), new ECB$1(1, 47)), new ECBlocks$1(28, new ECB$1(1, 22), new ECB$1(15, 23)), new ECBlocks$1(28, new ECB$1(2, 14), new ECB$1(17, 15))),
        new Version$1(18, Int32Array.from([
            6,
            30,
            56,
            82
        ]), new ECBlocks$1(30, new ECB$1(5, 120), new ECB$1(1, 121)), new ECBlocks$1(26, new ECB$1(9, 43), new ECB$1(4, 44)), new ECBlocks$1(28, new ECB$1(17, 22), new ECB$1(1, 23)), new ECBlocks$1(28, new ECB$1(2, 14), new ECB$1(19, 15))),
        new Version$1(19, Int32Array.from([
            6,
            30,
            58,
            86
        ]), new ECBlocks$1(28, new ECB$1(3, 113), new ECB$1(4, 114)), new ECBlocks$1(26, new ECB$1(3, 44), new ECB$1(11, 45)), new ECBlocks$1(26, new ECB$1(17, 21), new ECB$1(4, 22)), new ECBlocks$1(26, new ECB$1(9, 13), new ECB$1(16, 14))),
        new Version$1(20, Int32Array.from([
            6,
            34,
            62,
            90
        ]), new ECBlocks$1(28, new ECB$1(3, 107), new ECB$1(5, 108)), new ECBlocks$1(26, new ECB$1(3, 41), new ECB$1(13, 42)), new ECBlocks$1(30, new ECB$1(15, 24), new ECB$1(5, 25)), new ECBlocks$1(28, new ECB$1(15, 15), new ECB$1(10, 16))),
        new Version$1(21, Int32Array.from([
            6,
            28,
            50,
            72,
            94
        ]), new ECBlocks$1(28, new ECB$1(4, 116), new ECB$1(4, 117)), new ECBlocks$1(26, new ECB$1(17, 42)), new ECBlocks$1(28, new ECB$1(17, 22), new ECB$1(6, 23)), new ECBlocks$1(30, new ECB$1(19, 16), new ECB$1(6, 17))),
        new Version$1(22, Int32Array.from([
            6,
            26,
            50,
            74,
            98
        ]), new ECBlocks$1(28, new ECB$1(2, 111), new ECB$1(7, 112)), new ECBlocks$1(28, new ECB$1(17, 46)), new ECBlocks$1(30, new ECB$1(7, 24), new ECB$1(16, 25)), new ECBlocks$1(24, new ECB$1(34, 13))),
        new Version$1(23, Int32Array.from([
            6,
            30,
            54,
            78,
            102
        ]), new ECBlocks$1(30, new ECB$1(4, 121), new ECB$1(5, 122)), new ECBlocks$1(28, new ECB$1(4, 47), new ECB$1(14, 48)), new ECBlocks$1(30, new ECB$1(11, 24), new ECB$1(14, 25)), new ECBlocks$1(30, new ECB$1(16, 15), new ECB$1(14, 16))),
        new Version$1(24, Int32Array.from([
            6,
            28,
            54,
            80,
            106
        ]), new ECBlocks$1(30, new ECB$1(6, 117), new ECB$1(4, 118)), new ECBlocks$1(28, new ECB$1(6, 45), new ECB$1(14, 46)), new ECBlocks$1(30, new ECB$1(11, 24), new ECB$1(16, 25)), new ECBlocks$1(30, new ECB$1(30, 16), new ECB$1(2, 17))),
        new Version$1(25, Int32Array.from([
            6,
            32,
            58,
            84,
            110
        ]), new ECBlocks$1(26, new ECB$1(8, 106), new ECB$1(4, 107)), new ECBlocks$1(28, new ECB$1(8, 47), new ECB$1(13, 48)), new ECBlocks$1(30, new ECB$1(7, 24), new ECB$1(22, 25)), new ECBlocks$1(30, new ECB$1(22, 15), new ECB$1(13, 16))),
        new Version$1(26, Int32Array.from([
            6,
            30,
            58,
            86,
            114
        ]), new ECBlocks$1(28, new ECB$1(10, 114), new ECB$1(2, 115)), new ECBlocks$1(28, new ECB$1(19, 46), new ECB$1(4, 47)), new ECBlocks$1(28, new ECB$1(28, 22), new ECB$1(6, 23)), new ECBlocks$1(30, new ECB$1(33, 16), new ECB$1(4, 17))),
        new Version$1(27, Int32Array.from([
            6,
            34,
            62,
            90,
            118
        ]), new ECBlocks$1(30, new ECB$1(8, 122), new ECB$1(4, 123)), new ECBlocks$1(28, new ECB$1(22, 45), new ECB$1(3, 46)), new ECBlocks$1(30, new ECB$1(8, 23), new ECB$1(26, 24)), new ECBlocks$1(30, new ECB$1(12, 15), new ECB$1(28, 16))),
        new Version$1(28, Int32Array.from([
            6,
            26,
            50,
            74,
            98,
            122
        ]), new ECBlocks$1(30, new ECB$1(3, 117), new ECB$1(10, 118)), new ECBlocks$1(28, new ECB$1(3, 45), new ECB$1(23, 46)), new ECBlocks$1(30, new ECB$1(4, 24), new ECB$1(31, 25)), new ECBlocks$1(30, new ECB$1(11, 15), new ECB$1(31, 16))),
        new Version$1(29, Int32Array.from([
            6,
            30,
            54,
            78,
            102,
            126
        ]), new ECBlocks$1(30, new ECB$1(7, 116), new ECB$1(7, 117)), new ECBlocks$1(28, new ECB$1(21, 45), new ECB$1(7, 46)), new ECBlocks$1(30, new ECB$1(1, 23), new ECB$1(37, 24)), new ECBlocks$1(30, new ECB$1(19, 15), new ECB$1(26, 16))),
        new Version$1(30, Int32Array.from([
            6,
            26,
            52,
            78,
            104,
            130
        ]), new ECBlocks$1(30, new ECB$1(5, 115), new ECB$1(10, 116)), new ECBlocks$1(28, new ECB$1(19, 47), new ECB$1(10, 48)), new ECBlocks$1(30, new ECB$1(15, 24), new ECB$1(25, 25)), new ECBlocks$1(30, new ECB$1(23, 15), new ECB$1(25, 16))),
        new Version$1(31, Int32Array.from([
            6,
            30,
            56,
            82,
            108,
            134
        ]), new ECBlocks$1(30, new ECB$1(13, 115), new ECB$1(3, 116)), new ECBlocks$1(28, new ECB$1(2, 46), new ECB$1(29, 47)), new ECBlocks$1(30, new ECB$1(42, 24), new ECB$1(1, 25)), new ECBlocks$1(30, new ECB$1(23, 15), new ECB$1(28, 16))),
        new Version$1(32, Int32Array.from([
            6,
            34,
            60,
            86,
            112,
            138
        ]), new ECBlocks$1(30, new ECB$1(17, 115)), new ECBlocks$1(28, new ECB$1(10, 46), new ECB$1(23, 47)), new ECBlocks$1(30, new ECB$1(10, 24), new ECB$1(35, 25)), new ECBlocks$1(30, new ECB$1(19, 15), new ECB$1(35, 16))),
        new Version$1(33, Int32Array.from([
            6,
            30,
            58,
            86,
            114,
            142
        ]), new ECBlocks$1(30, new ECB$1(17, 115), new ECB$1(1, 116)), new ECBlocks$1(28, new ECB$1(14, 46), new ECB$1(21, 47)), new ECBlocks$1(30, new ECB$1(29, 24), new ECB$1(19, 25)), new ECBlocks$1(30, new ECB$1(11, 15), new ECB$1(46, 16))),
        new Version$1(34, Int32Array.from([
            6,
            34,
            62,
            90,
            118,
            146
        ]), new ECBlocks$1(30, new ECB$1(13, 115), new ECB$1(6, 116)), new ECBlocks$1(28, new ECB$1(14, 46), new ECB$1(23, 47)), new ECBlocks$1(30, new ECB$1(44, 24), new ECB$1(7, 25)), new ECBlocks$1(30, new ECB$1(59, 16), new ECB$1(1, 17))),
        new Version$1(35, Int32Array.from([
            6,
            30,
            54,
            78,
            102,
            126,
            150
        ]), new ECBlocks$1(30, new ECB$1(12, 121), new ECB$1(7, 122)), new ECBlocks$1(28, new ECB$1(12, 47), new ECB$1(26, 48)), new ECBlocks$1(30, new ECB$1(39, 24), new ECB$1(14, 25)), new ECBlocks$1(30, new ECB$1(22, 15), new ECB$1(41, 16))),
        new Version$1(36, Int32Array.from([
            6,
            24,
            50,
            76,
            102,
            128,
            154
        ]), new ECBlocks$1(30, new ECB$1(6, 121), new ECB$1(14, 122)), new ECBlocks$1(28, new ECB$1(6, 47), new ECB$1(34, 48)), new ECBlocks$1(30, new ECB$1(46, 24), new ECB$1(10, 25)), new ECBlocks$1(30, new ECB$1(2, 15), new ECB$1(64, 16))),
        new Version$1(37, Int32Array.from([
            6,
            28,
            54,
            80,
            106,
            132,
            158
        ]), new ECBlocks$1(30, new ECB$1(17, 122), new ECB$1(4, 123)), new ECBlocks$1(28, new ECB$1(29, 46), new ECB$1(14, 47)), new ECBlocks$1(30, new ECB$1(49, 24), new ECB$1(10, 25)), new ECBlocks$1(30, new ECB$1(24, 15), new ECB$1(46, 16))),
        new Version$1(38, Int32Array.from([
            6,
            32,
            58,
            84,
            110,
            136,
            162
        ]), new ECBlocks$1(30, new ECB$1(4, 122), new ECB$1(18, 123)), new ECBlocks$1(28, new ECB$1(13, 46), new ECB$1(32, 47)), new ECBlocks$1(30, new ECB$1(48, 24), new ECB$1(14, 25)), new ECBlocks$1(30, new ECB$1(42, 15), new ECB$1(32, 16))),
        new Version$1(39, Int32Array.from([
            6,
            26,
            54,
            82,
            110,
            138,
            166
        ]), new ECBlocks$1(30, new ECB$1(20, 117), new ECB$1(4, 118)), new ECBlocks$1(28, new ECB$1(40, 47), new ECB$1(7, 48)), new ECBlocks$1(30, new ECB$1(43, 24), new ECB$1(22, 25)), new ECBlocks$1(30, new ECB$1(10, 15), new ECB$1(67, 16))),
        new Version$1(40, Int32Array.from([
            6,
            30,
            58,
            86,
            114,
            142,
            170
        ]), new ECBlocks$1(30, new ECB$1(19, 118), new ECB$1(6, 119)), new ECBlocks$1(28, new ECB$1(18, 47), new ECB$1(31, 48)), new ECBlocks$1(30, new ECB$1(34, 24), new ECB$1(34, 25)), new ECBlocks$1(30, new ECB$1(20, 15), new ECB$1(61, 16)))
    ];
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ var DataMaskValues;
    (function(DataMaskValues) {
        DataMaskValues[DataMaskValues["DATA_MASK_000"] = 0] = "DATA_MASK_000";
        DataMaskValues[DataMaskValues["DATA_MASK_001"] = 1] = "DATA_MASK_001";
        DataMaskValues[DataMaskValues["DATA_MASK_010"] = 2] = "DATA_MASK_010";
        DataMaskValues[DataMaskValues["DATA_MASK_011"] = 3] = "DATA_MASK_011";
        DataMaskValues[DataMaskValues["DATA_MASK_100"] = 4] = "DATA_MASK_100";
        DataMaskValues[DataMaskValues["DATA_MASK_101"] = 5] = "DATA_MASK_101";
        DataMaskValues[DataMaskValues["DATA_MASK_110"] = 6] = "DATA_MASK_110";
        DataMaskValues[DataMaskValues["DATA_MASK_111"] = 7] = "DATA_MASK_111";
    })(DataMaskValues || (DataMaskValues = {}));
    /**
     * <p>Encapsulates data masks for the data bits in a QR code, per ISO 18004:2006 6.8. Implementations
     * of this class can un-mask a raw BitMatrix. For simplicity, they will unmask the entire BitMatrix,
     * including areas used for finder patterns, timing patterns, etc. These areas should be unused
     * after the point they are unmasked anyway.</p>
     *
     * <p>Note that the diagram in section 6.8.1 is misleading since it indicates that i is column position
     * and j is row position. In fact, as the text says, i is row position and j is column position.</p>
     *
     * @author Sean Owen
     */ class DataMask {
        // See ISO 18004:2006 6.8.1
        constructor(value, isMasked){
            this.value = value;
            this.isMasked = isMasked;
        }
        // End of enum constants.
        /**
         * <p>Implementations of this method reverse the data masking process applied to a QR Code and
         * make its bits ready to read.</p>
         *
         * @param bits representation of QR Code bits
         * @param dimension dimension of QR Code, represented by bits, being unmasked
         */ unmaskBitMatrix(bits, dimension /*int*/ ) {
            for(let i = 0; i < dimension; i++){
                for(let j = 0; j < dimension; j++)if (this.isMasked(i, j)) bits.flip(j, i);
            }
        }
    }
    DataMask.values = new Map([
        /**
         * 000: mask bits for which (x + y) mod 2 == 0
         */ [
            DataMaskValues.DATA_MASK_000,
            new DataMask(DataMaskValues.DATA_MASK_000, (i /*int*/ , j /*int*/ )=>{
                return (i + j & 0x01) === 0;
            })
        ],
        /**
         * 001: mask bits for which x mod 2 == 0
         */ [
            DataMaskValues.DATA_MASK_001,
            new DataMask(DataMaskValues.DATA_MASK_001, (i /*int*/ , j /*int*/ )=>{
                return (i & 0x01) === 0;
            })
        ],
        /**
         * 010: mask bits for which y mod 3 == 0
         */ [
            DataMaskValues.DATA_MASK_010,
            new DataMask(DataMaskValues.DATA_MASK_010, (i /*int*/ , j /*int*/ )=>{
                return j % 3 === 0;
            })
        ],
        /**
         * 011: mask bits for which (x + y) mod 3 == 0
         */ [
            DataMaskValues.DATA_MASK_011,
            new DataMask(DataMaskValues.DATA_MASK_011, (i /*int*/ , j /*int*/ )=>{
                return (i + j) % 3 === 0;
            })
        ],
        /**
         * 100: mask bits for which (x/2 + y/3) mod 2 == 0
         */ [
            DataMaskValues.DATA_MASK_100,
            new DataMask(DataMaskValues.DATA_MASK_100, (i /*int*/ , j /*int*/ )=>{
                return (Math.floor(i / 2) + Math.floor(j / 3) & 0x01) === 0;
            })
        ],
        /**
         * 101: mask bits for which xy mod 2 + xy mod 3 == 0
         * equivalently, such that xy mod 6 == 0
         */ [
            DataMaskValues.DATA_MASK_101,
            new DataMask(DataMaskValues.DATA_MASK_101, (i /*int*/ , j /*int*/ )=>{
                return i * j % 6 === 0;
            })
        ],
        /**
         * 110: mask bits for which (xy mod 2 + xy mod 3) mod 2 == 0
         * equivalently, such that xy mod 6 < 3
         */ [
            DataMaskValues.DATA_MASK_110,
            new DataMask(DataMaskValues.DATA_MASK_110, (i /*int*/ , j /*int*/ )=>{
                return i * j % 6 < 3;
            })
        ],
        /**
         * 111: mask bits for which ((x+y)mod 2 + xy mod 3) mod 2 == 0
         * equivalently, such that (x + y + xy mod 3) mod 2 == 0
         */ [
            DataMaskValues.DATA_MASK_111,
            new DataMask(DataMaskValues.DATA_MASK_111, (i /*int*/ , j /*int*/ )=>{
                return (i + j + i * j % 3 & 0x01) === 0;
            })
        ]
    ]);
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * @author Sean Owen
     */ class BitMatrixParser$1 {
        /**
         * @param bitMatrix {@link BitMatrix} to parse
         * @throws FormatException if dimension is not >= 21 and 1 mod 4
         */ constructor(bitMatrix){
            const dimension = bitMatrix.getHeight();
            if (dimension < 21 || (dimension & 0x03) !== 1) throw new FormatException();
            this.bitMatrix = bitMatrix;
        }
        /**
         * <p>Reads format information from one of its two locations within the QR Code.</p>
         *
         * @return {@link FormatInformation} encapsulating the QR Code's format info
         * @throws FormatException if both format information locations cannot be parsed as
         * the valid encoding of format information
         */ readFormatInformation() {
            if (this.parsedFormatInfo !== null && this.parsedFormatInfo !== undefined) return this.parsedFormatInfo;
            // Read top-left format info bits
            let formatInfoBits1 = 0;
            for(let i = 0; i < 6; i++)formatInfoBits1 = this.copyBit(i, 8, formatInfoBits1);
            // .. and skip a bit in the timing pattern ...
            formatInfoBits1 = this.copyBit(7, 8, formatInfoBits1);
            formatInfoBits1 = this.copyBit(8, 8, formatInfoBits1);
            formatInfoBits1 = this.copyBit(8, 7, formatInfoBits1);
            // .. and skip a bit in the timing pattern ...
            for(let j = 5; j >= 0; j--)formatInfoBits1 = this.copyBit(8, j, formatInfoBits1);
            // Read the top-right/bottom-left pattern too
            const dimension = this.bitMatrix.getHeight();
            let formatInfoBits2 = 0;
            const jMin = dimension - 7;
            for(let j = dimension - 1; j >= jMin; j--)formatInfoBits2 = this.copyBit(8, j, formatInfoBits2);
            for(let i = dimension - 8; i < dimension; i++)formatInfoBits2 = this.copyBit(i, 8, formatInfoBits2);
            this.parsedFormatInfo = FormatInformation.decodeFormatInformation(formatInfoBits1, formatInfoBits2);
            if (this.parsedFormatInfo !== null) return this.parsedFormatInfo;
            throw new FormatException();
        }
        /**
         * <p>Reads version information from one of its two locations within the QR Code.</p>
         *
         * @return {@link Version} encapsulating the QR Code's version
         * @throws FormatException if both version information locations cannot be parsed as
         * the valid encoding of version information
         */ readVersion() {
            if (this.parsedVersion !== null && this.parsedVersion !== undefined) return this.parsedVersion;
            const dimension = this.bitMatrix.getHeight();
            const provisionalVersion = Math.floor((dimension - 17) / 4);
            if (provisionalVersion <= 6) return Version$1.getVersionForNumber(provisionalVersion);
            // Read top-right version info: 3 wide by 6 tall
            let versionBits = 0;
            const ijMin = dimension - 11;
            for(let j = 5; j >= 0; j--)for(let i = dimension - 9; i >= ijMin; i--)versionBits = this.copyBit(i, j, versionBits);
            let theParsedVersion = Version$1.decodeVersionInformation(versionBits);
            if (theParsedVersion !== null && theParsedVersion.getDimensionForVersion() === dimension) {
                this.parsedVersion = theParsedVersion;
                return theParsedVersion;
            }
            // Hmm, failed. Try bottom left: 6 wide by 3 tall
            versionBits = 0;
            for(let i = 5; i >= 0; i--)for(let j = dimension - 9; j >= ijMin; j--)versionBits = this.copyBit(i, j, versionBits);
            theParsedVersion = Version$1.decodeVersionInformation(versionBits);
            if (theParsedVersion !== null && theParsedVersion.getDimensionForVersion() === dimension) {
                this.parsedVersion = theParsedVersion;
                return theParsedVersion;
            }
            throw new FormatException();
        }
        copyBit(i /*int*/ , j /*int*/ , versionBits /*int*/ ) {
            const bit = this.isMirror ? this.bitMatrix.get(j, i) : this.bitMatrix.get(i, j);
            return bit ? versionBits << 1 | 0x1 : versionBits << 1;
        }
        /**
         * <p>Reads the bits in the {@link BitMatrix} representing the finder pattern in the
         * correct order in order to reconstruct the codewords bytes contained within the
         * QR Code.</p>
         *
         * @return bytes encoded within the QR Code
         * @throws FormatException if the exact number of bytes expected is not read
         */ readCodewords() {
            const formatInfo = this.readFormatInformation();
            const version = this.readVersion();
            // Get the data mask for the format used in this QR Code. This will exclude
            // some bits from reading as we wind through the bit matrix.
            const dataMask = DataMask.values.get(formatInfo.getDataMask());
            const dimension = this.bitMatrix.getHeight();
            dataMask.unmaskBitMatrix(this.bitMatrix, dimension);
            const functionPattern = version.buildFunctionPattern();
            let readingUp = true;
            const result = new Uint8Array(version.getTotalCodewords());
            let resultOffset = 0;
            let currentByte = 0;
            let bitsRead = 0;
            // Read columns in pairs, from right to left
            for(let j = dimension - 1; j > 0; j -= 2){
                if (j === 6) // Skip whole column with vertical alignment pattern
                // saves time and makes the other code proceed more cleanly
                j--;
                // Read alternatingly from bottom to top then top to bottom
                for(let count = 0; count < dimension; count++){
                    const i = readingUp ? dimension - 1 - count : count;
                    for(let col = 0; col < 2; col++)// Ignore bits covered by the function pattern
                    if (!functionPattern.get(j - col, i)) {
                        // Read a bit
                        bitsRead++;
                        currentByte <<= 1;
                        if (this.bitMatrix.get(j - col, i)) currentByte |= 1;
                        // If we've made a whole byte, save it off
                        if (bitsRead === 8) {
                            result[resultOffset++] = /*(byte) */ currentByte;
                            bitsRead = 0;
                            currentByte = 0;
                        }
                    }
                }
                readingUp = !readingUp; // readingUp ^= true; // readingUp = !readingUp; // switch directions
            }
            if (resultOffset !== version.getTotalCodewords()) throw new FormatException();
            return result;
        }
        /**
         * Revert the mask removal done while reading the code words. The bit matrix should revert to its original state.
         */ remask() {
            if (this.parsedFormatInfo === null) return; // We have no format information, and have no data mask
            const dataMask = DataMask.values[this.parsedFormatInfo.getDataMask()];
            const dimension = this.bitMatrix.getHeight();
            dataMask.unmaskBitMatrix(this.bitMatrix, dimension);
        }
        /**
         * Prepare the parser for a mirrored operation.
         * This flag has effect only on the {@link #readFormatInformation()} and the
         * {@link #readVersion()}. Before proceeding with {@link #readCodewords()} the
         * {@link #mirror()} method should be called.
         *
         * @param mirror Whether to read version and format information mirrored.
         */ setMirror(isMirror) {
            this.parsedVersion = null;
            this.parsedFormatInfo = null;
            this.isMirror = isMirror;
        }
        /** Mirror the bit matrix in order to attempt a second reading. */ mirror() {
            const bitMatrix = this.bitMatrix;
            for(let x = 0, width = bitMatrix.getWidth(); x < width; x++){
                for(let y = x + 1, height = bitMatrix.getHeight(); y < height; y++)if (bitMatrix.get(x, y) !== bitMatrix.get(y, x)) {
                    bitMatrix.flip(y, x);
                    bitMatrix.flip(x, y);
                }
            }
        }
    }
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * <p>Encapsulates a block of data within a QR Code. QR Codes may split their data into
     * multiple blocks, each of which is a unit of data and error-correction codewords. Each
     * is represented by an instance of this class.</p>
     *
     * @author Sean Owen
     */ class DataBlock$1 {
        constructor(numDataCodewords /*int*/ , codewords){
            this.numDataCodewords = numDataCodewords;
            this.codewords = codewords;
        }
        /**
         * <p>When QR Codes use multiple data blocks, they are actually interleaved.
         * That is, the first byte of data block 1 to n is written, then the second bytes, and so on. This
         * method will separate the data into original blocks.</p>
         *
         * @param rawCodewords bytes as read directly from the QR Code
         * @param version version of the QR Code
         * @param ecLevel error-correction level of the QR Code
         * @return DataBlocks containing original bytes, "de-interleaved" from representation in the
         *         QR Code
         */ static getDataBlocks(rawCodewords, version, ecLevel) {
            if (rawCodewords.length !== version.getTotalCodewords()) throw new IllegalArgumentException();
            // Figure out the number and size of data blocks used by this version and
            // error correction level
            const ecBlocks = version.getECBlocksForLevel(ecLevel);
            // First count the total number of data blocks
            let totalBlocks = 0;
            const ecBlockArray = ecBlocks.getECBlocks();
            for (const ecBlock of ecBlockArray)totalBlocks += ecBlock.getCount();
            // Now establish DataBlocks of the appropriate size and number of data codewords
            const result = new Array(totalBlocks);
            let numResultBlocks = 0;
            for (const ecBlock of ecBlockArray)for(let i = 0; i < ecBlock.getCount(); i++){
                const numDataCodewords = ecBlock.getDataCodewords();
                const numBlockCodewords = ecBlocks.getECCodewordsPerBlock() + numDataCodewords;
                result[numResultBlocks++] = new DataBlock$1(numDataCodewords, new Uint8Array(numBlockCodewords));
            }
            // All blocks have the same amount of data, except that the last n
            // (where n may be 0) have 1 more byte. Figure out where these start.
            const shorterBlocksTotalCodewords = result[0].codewords.length;
            let longerBlocksStartAt = result.length - 1;
            // TYPESCRIPTPORT: check length is correct here
            while(longerBlocksStartAt >= 0){
                const numCodewords = result[longerBlocksStartAt].codewords.length;
                if (numCodewords === shorterBlocksTotalCodewords) break;
                longerBlocksStartAt--;
            }
            longerBlocksStartAt++;
            const shorterBlocksNumDataCodewords = shorterBlocksTotalCodewords - ecBlocks.getECCodewordsPerBlock();
            // The last elements of result may be 1 element longer
            // first fill out as many elements as all of them have
            let rawCodewordsOffset = 0;
            for(let i = 0; i < shorterBlocksNumDataCodewords; i++)for(let j = 0; j < numResultBlocks; j++)result[j].codewords[i] = rawCodewords[rawCodewordsOffset++];
            // Fill out the last data block in the longer ones
            for(let j = longerBlocksStartAt; j < numResultBlocks; j++)result[j].codewords[shorterBlocksNumDataCodewords] = rawCodewords[rawCodewordsOffset++];
            // Now add in error correction blocks
            const max = result[0].codewords.length;
            for(let i = shorterBlocksNumDataCodewords; i < max; i++)for(let j = 0; j < numResultBlocks; j++){
                const iOffset = j < longerBlocksStartAt ? i : i + 1;
                result[j].codewords[iOffset] = rawCodewords[rawCodewordsOffset++];
            }
            return result;
        }
        getNumDataCodewords() {
            return this.numDataCodewords;
        }
        getCodewords() {
            return this.codewords;
        }
    }
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ var ModeValues;
    (function(ModeValues) {
        ModeValues[ModeValues["TERMINATOR"] = 0] = "TERMINATOR";
        ModeValues[ModeValues["NUMERIC"] = 1] = "NUMERIC";
        ModeValues[ModeValues["ALPHANUMERIC"] = 2] = "ALPHANUMERIC";
        ModeValues[ModeValues["STRUCTURED_APPEND"] = 3] = "STRUCTURED_APPEND";
        ModeValues[ModeValues["BYTE"] = 4] = "BYTE";
        ModeValues[ModeValues["ECI"] = 5] = "ECI";
        ModeValues[ModeValues["KANJI"] = 6] = "KANJI";
        ModeValues[ModeValues["FNC1_FIRST_POSITION"] = 7] = "FNC1_FIRST_POSITION";
        ModeValues[ModeValues["FNC1_SECOND_POSITION"] = 8] = "FNC1_SECOND_POSITION";
        /** See GBT 18284-2000; "Hanzi" is a transliteration of this mode name. */ ModeValues[ModeValues["HANZI"] = 9] = "HANZI";
    })(ModeValues || (ModeValues = {}));
    /**
     * <p>See ISO 18004:2006, 6.4.1, Tables 2 and 3. This enum encapsulates the various modes in which
     * data can be encoded to bits in the QR code standard.</p>
     *
     * @author Sean Owen
     */ class Mode$1 {
        constructor(value, stringValue, characterCountBitsForVersions, bits /*int*/ ){
            this.value = value;
            this.stringValue = stringValue;
            this.characterCountBitsForVersions = characterCountBitsForVersions;
            this.bits = bits;
            Mode$1.FOR_BITS.set(bits, this);
            Mode$1.FOR_VALUE.set(value, this);
        }
        /**
         * @param bits four bits encoding a QR Code data mode
         * @return Mode encoded by these bits
         * @throws IllegalArgumentException if bits do not correspond to a known mode
         */ static forBits(bits /*int*/ ) {
            const mode = Mode$1.FOR_BITS.get(bits);
            if (undefined === mode) throw new IllegalArgumentException();
            return mode;
        }
        /**
         * @param version version in question
         * @return number of bits used, in this QR Code symbol {@link Version}, to encode the
         *         count of characters that will follow encoded in this Mode
         */ getCharacterCountBits(version) {
            const versionNumber = version.getVersionNumber();
            let offset;
            if (versionNumber <= 9) offset = 0;
            else if (versionNumber <= 26) offset = 1;
            else offset = 2;
            return this.characterCountBitsForVersions[offset];
        }
        getValue() {
            return this.value;
        }
        getBits() {
            return this.bits;
        }
        equals(o) {
            if (!(o instanceof Mode$1)) return false;
            const other = o;
            return this.value === other.value;
        }
        toString() {
            return this.stringValue;
        }
    }
    Mode$1.FOR_BITS = new Map();
    Mode$1.FOR_VALUE = new Map();
    Mode$1.TERMINATOR = new Mode$1(ModeValues.TERMINATOR, 'TERMINATOR', Int32Array.from([
        0,
        0,
        0
    ]), 0x00); // Not really a mode...
    Mode$1.NUMERIC = new Mode$1(ModeValues.NUMERIC, 'NUMERIC', Int32Array.from([
        10,
        12,
        14
    ]), 0x01);
    Mode$1.ALPHANUMERIC = new Mode$1(ModeValues.ALPHANUMERIC, 'ALPHANUMERIC', Int32Array.from([
        9,
        11,
        13
    ]), 0x02);
    Mode$1.STRUCTURED_APPEND = new Mode$1(ModeValues.STRUCTURED_APPEND, 'STRUCTURED_APPEND', Int32Array.from([
        0,
        0,
        0
    ]), 0x03); // Not supported
    Mode$1.BYTE = new Mode$1(ModeValues.BYTE, 'BYTE', Int32Array.from([
        8,
        16,
        16
    ]), 0x04);
    Mode$1.ECI = new Mode$1(ModeValues.ECI, 'ECI', Int32Array.from([
        0,
        0,
        0
    ]), 0x07); // character counts don't apply
    Mode$1.KANJI = new Mode$1(ModeValues.KANJI, 'KANJI', Int32Array.from([
        8,
        10,
        12
    ]), 0x08);
    Mode$1.FNC1_FIRST_POSITION = new Mode$1(ModeValues.FNC1_FIRST_POSITION, 'FNC1_FIRST_POSITION', Int32Array.from([
        0,
        0,
        0
    ]), 0x05);
    Mode$1.FNC1_SECOND_POSITION = new Mode$1(ModeValues.FNC1_SECOND_POSITION, 'FNC1_SECOND_POSITION', Int32Array.from([
        0,
        0,
        0
    ]), 0x09);
    /** See GBT 18284-2000; "Hanzi" is a transliteration of this mode name. */ Mode$1.HANZI = new Mode$1(ModeValues.HANZI, 'HANZI', Int32Array.from([
        8,
        10,
        12
    ]), 0x0D);
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /*import java.io.UnsupportedEncodingException;*/ /*import java.util.ArrayList;*/ /*import java.util.Collection;*/ /*import java.util.List;*/ /*import java.util.Map;*/ /**
     * <p>QR Codes can encode text as bits in one of several modes, and can use multiple modes
     * in one QR Code. This class decodes the bits back into text.</p>
     *
     * <p>See ISO 18004:2006, 6.4.3 - 6.4.7</p>
     *
     * @author Sean Owen
     */ class DecodedBitStreamParser$1 {
        static decode(bytes, version, ecLevel, hints) {
            const bits = new BitSource(bytes);
            let result = new StringBuilder();
            const byteSegments = new Array(); // 1
            // TYPESCRIPTPORT: I do not use constructor with size 1 as in original Java means capacity and the array length is checked below
            let symbolSequence = -1;
            let parityData = -1;
            try {
                let currentCharacterSetECI = null;
                let fc1InEffect = false;
                let mode;
                do {
                    // While still another segment to read...
                    if (bits.available() < 4) // OK, assume we're done. Really, a TERMINATOR mode should have been recorded here
                    mode = Mode$1.TERMINATOR;
                    else {
                        const modeBits = bits.readBits(4);
                        mode = Mode$1.forBits(modeBits); // mode is encoded by 4 bits
                    }
                    switch(mode){
                        case Mode$1.TERMINATOR:
                            break;
                        case Mode$1.FNC1_FIRST_POSITION:
                        case Mode$1.FNC1_SECOND_POSITION:
                            // We do little with FNC1 except alter the parsed result a bit according to the spec
                            fc1InEffect = true;
                            break;
                        case Mode$1.STRUCTURED_APPEND:
                            if (bits.available() < 16) throw new FormatException();
                            // sequence number and parity is added later to the result metadata
                            // Read next 8 bits (symbol sequence #) and 8 bits (data: parity), then continue
                            symbolSequence = bits.readBits(8);
                            parityData = bits.readBits(8);
                            break;
                        case Mode$1.ECI:
                            // Count doesn't apply to ECI
                            const value = DecodedBitStreamParser$1.parseECIValue(bits);
                            currentCharacterSetECI = CharacterSetECI.getCharacterSetECIByValue(value);
                            if (currentCharacterSetECI === null) throw new FormatException();
                            break;
                        case Mode$1.HANZI:
                            // First handle Hanzi mode which does not start with character count
                            // Chinese mode contains a sub set indicator right after mode indicator
                            const subset = bits.readBits(4);
                            const countHanzi = bits.readBits(mode.getCharacterCountBits(version));
                            if (subset === DecodedBitStreamParser$1.GB2312_SUBSET) DecodedBitStreamParser$1.decodeHanziSegment(bits, result, countHanzi);
                            break;
                        default:
                            // "Normal" QR code modes:
                            // How many characters will follow, encoded in this mode?
                            const count = bits.readBits(mode.getCharacterCountBits(version));
                            switch(mode){
                                case Mode$1.NUMERIC:
                                    DecodedBitStreamParser$1.decodeNumericSegment(bits, result, count);
                                    break;
                                case Mode$1.ALPHANUMERIC:
                                    DecodedBitStreamParser$1.decodeAlphanumericSegment(bits, result, count, fc1InEffect);
                                    break;
                                case Mode$1.BYTE:
                                    DecodedBitStreamParser$1.decodeByteSegment(bits, result, count, currentCharacterSetECI, byteSegments, hints);
                                    break;
                                case Mode$1.KANJI:
                                    DecodedBitStreamParser$1.decodeKanjiSegment(bits, result, count);
                                    break;
                                default:
                                    throw new FormatException();
                            }
                            break;
                    }
                }while (mode !== Mode$1.TERMINATOR);
            } catch (iae /*: IllegalArgumentException*/ ) {
                // from readBits() calls
                throw new FormatException();
            }
            return new DecoderResult(bytes, result.toString(), byteSegments.length === 0 ? null : byteSegments, ecLevel === null ? null : ecLevel.toString(), symbolSequence, parityData);
        }
        /**
         * See specification GBT 18284-2000
         */ static decodeHanziSegment(bits, result, count /*int*/ ) {
            // Don't crash trying to read more bits than we have available.
            if (count * 13 > bits.available()) throw new FormatException();
            // Each character will require 2 bytes. Read the characters as 2-byte pairs
            // and decode as GB2312 afterwards
            const buffer = new Uint8Array(2 * count);
            let offset = 0;
            while(count > 0){
                // Each 13 bits encodes a 2-byte character
                const twoBytes = bits.readBits(13);
                let assembledTwoBytes = twoBytes / 0x060 << 8 & 0xFFFFFFFF | twoBytes % 0x060;
                if (assembledTwoBytes < 0x003BF) // In the 0xA1A1 to 0xAAFE range
                assembledTwoBytes += 0x0A1A1;
                else // In the 0xB0A1 to 0xFAFE range
                assembledTwoBytes += 0x0A6A1;
                buffer[offset] = /*(byte) */ assembledTwoBytes >> 8 & 0xFF;
                buffer[offset + 1] = /*(byte) */ assembledTwoBytes & 0xFF;
                offset += 2;
                count--;
            }
            try {
                result.append(StringEncoding.decode(buffer, StringUtils.GB2312));
            // TYPESCRIPTPORT: TODO: implement GB2312 decode. StringView from MDN could be a starting point
            } catch (ignored /*: UnsupportedEncodingException*/ ) {
                throw new FormatException(ignored);
            }
        }
        static decodeKanjiSegment(bits, result, count /*int*/ ) {
            // Don't crash trying to read more bits than we have available.
            if (count * 13 > bits.available()) throw new FormatException();
            // Each character will require 2 bytes. Read the characters as 2-byte pairs
            // and decode as Shift_JIS afterwards
            const buffer = new Uint8Array(2 * count);
            let offset = 0;
            while(count > 0){
                // Each 13 bits encodes a 2-byte character
                const twoBytes = bits.readBits(13);
                let assembledTwoBytes = twoBytes / 0x0C0 << 8 & 0xFFFFFFFF | twoBytes % 0x0C0;
                if (assembledTwoBytes < 0x01F00) // In the 0x8140 to 0x9FFC range
                assembledTwoBytes += 0x08140;
                else // In the 0xE040 to 0xEBBF range
                assembledTwoBytes += 0x0C140;
                buffer[offset] = /*(byte) */ assembledTwoBytes >> 8;
                buffer[offset + 1] = /*(byte) */ assembledTwoBytes;
                offset += 2;
                count--;
            }
            // Shift_JIS may not be supported in some environments:
            try {
                result.append(StringEncoding.decode(buffer, StringUtils.SHIFT_JIS));
            // TYPESCRIPTPORT: TODO: implement SHIFT_JIS decode. StringView from MDN could be a starting point
            } catch (ignored /*: UnsupportedEncodingException*/ ) {
                throw new FormatException(ignored);
            }
        }
        static decodeByteSegment(bits, result, count /*int*/ , currentCharacterSetECI, byteSegments, hints) {
            // Don't crash trying to read more bits than we have available.
            if (8 * count > bits.available()) throw new FormatException();
            const readBytes = new Uint8Array(count);
            for(let i = 0; i < count; i++)readBytes[i] = /*(byte) */ bits.readBits(8);
            let encoding;
            if (currentCharacterSetECI === null) // The spec isn't clear on this mode; see
            // section 6.4.5: t does not say which encoding to assuming
            // upon decoding. I have seen ISO-8859-1 used as well as
            // Shift_JIS -- without anything like an ECI designator to
            // give a hint.
            encoding = StringUtils.guessEncoding(readBytes, hints);
            else encoding = currentCharacterSetECI.getName();
            try {
                result.append(StringEncoding.decode(readBytes, encoding));
            } catch (ignored /*: UnsupportedEncodingException*/ ) {
                throw new FormatException(ignored);
            }
            byteSegments.push(readBytes);
        }
        static toAlphaNumericChar(value /*int*/ ) {
            if (value >= DecodedBitStreamParser$1.ALPHANUMERIC_CHARS.length) throw new FormatException();
            return DecodedBitStreamParser$1.ALPHANUMERIC_CHARS[value];
        }
        static decodeAlphanumericSegment(bits, result, count /*int*/ , fc1InEffect) {
            // Read two characters at a time
            const start = result.length();
            while(count > 1){
                if (bits.available() < 11) throw new FormatException();
                const nextTwoCharsBits = bits.readBits(11);
                result.append(DecodedBitStreamParser$1.toAlphaNumericChar(Math.floor(nextTwoCharsBits / 45)));
                result.append(DecodedBitStreamParser$1.toAlphaNumericChar(nextTwoCharsBits % 45));
                count -= 2;
            }
            if (count === 1) {
                // special case: one character left
                if (bits.available() < 6) throw new FormatException();
                result.append(DecodedBitStreamParser$1.toAlphaNumericChar(bits.readBits(6)));
            }
            // See section 6.4.8.1, 6.4.8.2
            if (fc1InEffect) {
                // We need to massage the result a bit if in an FNC1 mode:
                for(let i = start; i < result.length(); i++)if (result.charAt(i) === '%') {
                    if (i < result.length() - 1 && result.charAt(i + 1) === '%') // %% is rendered as %
                    result.deleteCharAt(i + 1);
                    else // In alpha mode, % should be converted to FNC1 separator 0x1D
                    result.setCharAt(i, String.fromCharCode(0x1D));
                }
            }
        }
        static decodeNumericSegment(bits, result, count /*int*/ ) {
            // Read three digits at a time
            while(count >= 3){
                // Each 10 bits encodes three digits
                if (bits.available() < 10) throw new FormatException();
                const threeDigitsBits = bits.readBits(10);
                if (threeDigitsBits >= 1000) throw new FormatException();
                result.append(DecodedBitStreamParser$1.toAlphaNumericChar(Math.floor(threeDigitsBits / 100)));
                result.append(DecodedBitStreamParser$1.toAlphaNumericChar(Math.floor(threeDigitsBits / 10) % 10));
                result.append(DecodedBitStreamParser$1.toAlphaNumericChar(threeDigitsBits % 10));
                count -= 3;
            }
            if (count === 2) {
                // Two digits left over to read, encoded in 7 bits
                if (bits.available() < 7) throw new FormatException();
                const twoDigitsBits = bits.readBits(7);
                if (twoDigitsBits >= 100) throw new FormatException();
                result.append(DecodedBitStreamParser$1.toAlphaNumericChar(Math.floor(twoDigitsBits / 10)));
                result.append(DecodedBitStreamParser$1.toAlphaNumericChar(twoDigitsBits % 10));
            } else if (count === 1) {
                // One digit left over to read
                if (bits.available() < 4) throw new FormatException();
                const digitBits = bits.readBits(4);
                if (digitBits >= 10) throw new FormatException();
                result.append(DecodedBitStreamParser$1.toAlphaNumericChar(digitBits));
            }
        }
        static parseECIValue(bits) {
            const firstByte = bits.readBits(8);
            if ((firstByte & 0x80) === 0) // just one byte
            return firstByte & 0x7F;
            if ((firstByte & 0xC0) === 0x80) {
                // two bytes
                const secondByte = bits.readBits(8);
                return (firstByte & 0x3F) << 8 & 0xFFFFFFFF | secondByte;
            }
            if ((firstByte & 0xE0) === 0xC0) {
                // three bytes
                const secondThirdBytes = bits.readBits(16);
                return (firstByte & 0x1F) << 16 & 0xFFFFFFFF | secondThirdBytes;
            }
            throw new FormatException();
        }
    }
    /**
     * See ISO 18004:2006, 6.4.4 Table 5
     */ DecodedBitStreamParser$1.ALPHANUMERIC_CHARS = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ $%*+-./:';
    DecodedBitStreamParser$1.GB2312_SUBSET = 1;
    // function Uint8ArrayToString(a: Uint8Array): string {
    //     const CHUNK_SZ = 0x8000;
    //     const c = new StringBuilder();
    //     for (let i = 0, length = a.length; i < length; i += CHUNK_SZ) {
    //         c.append(String.fromCharCode.apply(null, a.subarray(i, i + CHUNK_SZ)));
    //     }
    //     return c.toString();
    // }
    /*
     * Copyright 2013 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * Meta-data container for QR Code decoding. Instances of this class may be used to convey information back to the
     * decoding caller. Callers are expected to process this.
     *
     * @see com.google.zxing.common.DecoderResult#getOther()
     */ class QRCodeDecoderMetaData {
        constructor(mirrored){
            this.mirrored = mirrored;
        }
        /**
         * @return true if the QR Code was mirrored.
         */ isMirrored() {
            return this.mirrored;
        }
        /**
         * Apply the result points' order correction due to mirroring.
         *
         * @param points Array of points to apply mirror correction to.
         */ applyMirroredCorrection(points) {
            if (!this.mirrored || points === null || points.length < 3) return;
            const bottomLeft = points[0];
            points[0] = points[2];
            points[2] = bottomLeft;
        // No need to 'fix' top-left and alignment pattern.
        }
    }
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /*import java.util.Map;*/ /**
     * <p>The main class which implements QR Code decoding -- as opposed to locating and extracting
     * the QR Code from an image.</p>
     *
     * @author Sean Owen
     */ class Decoder$2 {
        constructor(){
            this.rsDecoder = new ReedSolomonDecoder(GenericGF.QR_CODE_FIELD_256);
        }
        // public decode(image: boolean[][]): DecoderResult /*throws ChecksumException, FormatException*/ {
        //   return decode(image, null)
        // }
        /**
         * <p>Convenience method that can decode a QR Code represented as a 2D array of booleans.
         * "true" is taken to mean a black module.</p>
         *
         * @param image booleans representing white/black QR Code modules
         * @param hints decoding hints that should be used to influence decoding
         * @return text and bytes encoded within the QR Code
         * @throws FormatException if the QR Code cannot be decoded
         * @throws ChecksumException if error correction fails
         */ decodeBooleanArray(image, hints) {
            return this.decodeBitMatrix(BitMatrix.parseFromBooleanArray(image), hints);
        }
        // public decodeBitMatrix(bits: BitMatrix): DecoderResult /*throws ChecksumException, FormatException*/ {
        //   return decode(bits, null)
        // }
        /**
         * <p>Decodes a QR Code represented as a {@link BitMatrix}. A 1 or "true" is taken to mean a black module.</p>
         *
         * @param bits booleans representing white/black QR Code modules
         * @param hints decoding hints that should be used to influence decoding
         * @return text and bytes encoded within the QR Code
         * @throws FormatException if the QR Code cannot be decoded
         * @throws ChecksumException if error correction fails
         */ decodeBitMatrix(bits, hints) {
            // Construct a parser and read version, error-correction level
            const parser = new BitMatrixParser$1(bits);
            let ex = null;
            try {
                return this.decodeBitMatrixParser(parser, hints);
            } catch (e /*: FormatException, ChecksumException*/ ) {
                ex = e;
            }
            try {
                // Revert the bit matrix
                parser.remask();
                // Will be attempting a mirrored reading of the version and format info.
                parser.setMirror(true);
                // Preemptively read the version.
                parser.readVersion();
                // Preemptively read the format information.
                parser.readFormatInformation();
                /*
                 * Since we're here, this means we have successfully detected some kind
                 * of version and format information when mirrored. This is a good sign,
                 * that the QR code may be mirrored, and we should try once more with a
                 * mirrored content.
                 */ // Prepare for a mirrored reading.
                parser.mirror();
                const result = this.decodeBitMatrixParser(parser, hints);
                // Success! Notify the caller that the code was mirrored.
                result.setOther(new QRCodeDecoderMetaData(true));
                return result;
            } catch (e /*FormatException | ChecksumException*/ ) {
                // Throw the exception from the original reading
                if (ex !== null) throw ex;
                throw e;
            }
        }
        decodeBitMatrixParser(parser, hints) {
            const version = parser.readVersion();
            const ecLevel = parser.readFormatInformation().getErrorCorrectionLevel();
            // Read codewords
            const codewords = parser.readCodewords();
            // Separate into data blocks
            const dataBlocks = DataBlock$1.getDataBlocks(codewords, version, ecLevel);
            // Count total number of data bytes
            let totalBytes = 0;
            for (const dataBlock of dataBlocks)totalBytes += dataBlock.getNumDataCodewords();
            const resultBytes = new Uint8Array(totalBytes);
            let resultOffset = 0;
            // Error-correct and copy data blocks together into a stream of bytes
            for (const dataBlock of dataBlocks){
                const codewordBytes = dataBlock.getCodewords();
                const numDataCodewords = dataBlock.getNumDataCodewords();
                this.correctErrors(codewordBytes, numDataCodewords);
                for(let i = 0; i < numDataCodewords; i++)resultBytes[resultOffset++] = codewordBytes[i];
            }
            // Decode the contents of that stream of bytes
            return DecodedBitStreamParser$1.decode(resultBytes, version, ecLevel, hints);
        }
        /**
         * <p>Given data and error-correction codewords received, possibly corrupted by errors, attempts to
         * correct the errors in-place using Reed-Solomon error correction.</p>
         *
         * @param codewordBytes data and error correction codewords
         * @param numDataCodewords number of codewords that are data bytes
         * @throws ChecksumException if error correction fails
         */ correctErrors(codewordBytes, numDataCodewords /*int*/ ) {
            // const numCodewords = codewordBytes.length;
            // First read into an array of ints
            const codewordsInts = new Int32Array(codewordBytes);
            // TYPESCRIPTPORT: not realy necessary to transform to ints? could redesign everything to work with unsigned bytes?
            // const codewordsInts = new Int32Array(numCodewords)
            // for (let i = 0; i < numCodewords; i++) {
            //   codewordsInts[i] = codewordBytes[i] & 0xFF
            // }
            try {
                this.rsDecoder.decode(codewordsInts, codewordBytes.length - numDataCodewords);
            } catch (ignored /*: ReedSolomonException*/ ) {
                throw new ChecksumException();
            }
            // Copy back into array of bytes -- only need to worry about the bytes that were data
            // We don't care about errors in the error-correction codewords
            for(let i = 0; i < numDataCodewords; i++)codewordBytes[i] = /*(byte) */ codewordsInts[i];
        }
    }
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * <p>Encapsulates an alignment pattern, which are the smaller square patterns found in
     * all but the simplest QR Codes.</p>
     *
     * @author Sean Owen
     */ class AlignmentPattern extends ResultPoint {
        constructor(posX /*float*/ , posY /*float*/ , estimatedModuleSize /*float*/ ){
            super(posX, posY);
            this.estimatedModuleSize = estimatedModuleSize;
        }
        /**
         * <p>Determines if this alignment pattern "about equals" an alignment pattern at the stated
         * position and size -- meaning, it is at nearly the same center with nearly the same size.</p>
         */ aboutEquals(moduleSize /*float*/ , i /*float*/ , j /*float*/ ) {
            if (Math.abs(i - this.getY()) <= moduleSize && Math.abs(j - this.getX()) <= moduleSize) {
                const moduleSizeDiff = Math.abs(moduleSize - this.estimatedModuleSize);
                return moduleSizeDiff <= 1.0 || moduleSizeDiff <= this.estimatedModuleSize;
            }
            return false;
        }
        /**
         * Combines this object's current estimate of a finder pattern position and module size
         * with a new estimate. It returns a new {@code FinderPattern} containing an average of the two.
         */ combineEstimate(i /*float*/ , j /*float*/ , newModuleSize /*float*/ ) {
            const combinedX = (this.getX() + j) / 2.0;
            const combinedY = (this.getY() + i) / 2.0;
            const combinedModuleSize = (this.estimatedModuleSize + newModuleSize) / 2.0;
            return new AlignmentPattern(combinedX, combinedY, combinedModuleSize);
        }
    }
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /*import java.util.ArrayList;*/ /*import java.util.List;*/ /**
     * <p>This class attempts to find alignment patterns in a QR Code. Alignment patterns look like finder
     * patterns but are smaller and appear at regular intervals throughout the image.</p>
     *
     * <p>At the moment this only looks for the bottom-right alignment pattern.</p>
     *
     * <p>This is mostly a simplified copy of {@link FinderPatternFinder}. It is copied,
     * pasted and stripped down here for maximum performance but does unfortunately duplicate
     * some code.</p>
     *
     * <p>This class is thread-safe but not reentrant. Each thread must allocate its own object.</p>
     *
     * @author Sean Owen
     */ class AlignmentPatternFinder {
        /**
         * <p>Creates a finder that will look in a portion of the whole image.</p>
         *
         * @param image image to search
         * @param startX left column from which to start searching
         * @param startY top row from which to start searching
         * @param width width of region to search
         * @param height height of region to search
         * @param moduleSize estimated module size so far
         */ constructor(image, startX /*int*/ , startY /*int*/ , width /*int*/ , height /*int*/ , moduleSize /*float*/ , resultPointCallback){
            this.image = image;
            this.startX = startX;
            this.startY = startY;
            this.width = width;
            this.height = height;
            this.moduleSize = moduleSize;
            this.resultPointCallback = resultPointCallback;
            this.possibleCenters = []; // new Array<any>(5))
            // TYPESCRIPTPORT: array initialization without size as the length is checked below
            this.crossCheckStateCount = new Int32Array(3);
        }
        /**
         * <p>This method attempts to find the bottom-right alignment pattern in the image. It is a bit messy since
         * it's pretty performance-critical and so is written to be fast foremost.</p>
         *
         * @return {@link AlignmentPattern} if found
         * @throws NotFoundException if not found
         */ find() {
            const startX = this.startX;
            const height = this.height;
            const width = this.width;
            const maxJ = startX + width;
            const middleI = this.startY + height / 2;
            // We are looking for black/white/black modules in 1:1:1 ratio
            // this tracks the number of black/white/black modules seen so far
            const stateCount = new Int32Array(3);
            const image = this.image;
            for(let iGen = 0; iGen < height; iGen++){
                // Search from middle outwards
                const i = middleI + ((iGen & 0x01) === 0 ? Math.floor((iGen + 1) / 2) : -Math.floor((iGen + 1) / 2));
                stateCount[0] = 0;
                stateCount[1] = 0;
                stateCount[2] = 0;
                let j = startX;
                // Burn off leading white pixels before anything else; if we start in the middle of
                // a white run, it doesn't make sense to count its length, since we don't know if the
                // white run continued to the left of the start point
                while(j < maxJ && !image.get(j, i))j++;
                let currentState = 0;
                while(j < maxJ){
                    if (image.get(j, i)) {
                        // Black pixel
                        if (currentState === 1) stateCount[1]++;
                        else if (currentState === 2) {
                            if (this.foundPatternCross(stateCount)) {
                                const confirmed = this.handlePossibleCenter(stateCount, i, j);
                                if (confirmed !== null) return confirmed;
                            }
                            stateCount[0] = stateCount[2];
                            stateCount[1] = 1;
                            stateCount[2] = 0;
                            currentState = 1;
                        } else stateCount[++currentState]++;
                    } else {
                        if (currentState === 1) currentState++;
                        stateCount[currentState]++;
                    }
                    j++;
                }
                if (this.foundPatternCross(stateCount)) {
                    const confirmed = this.handlePossibleCenter(stateCount, i, maxJ);
                    if (confirmed !== null) return confirmed;
                }
            }
            // Hmm, nothing we saw was observed and confirmed twice. If we had
            // any guess at all, return it.
            if (this.possibleCenters.length !== 0) return this.possibleCenters[0];
            throw new NotFoundException();
        }
        /**
         * Given a count of black/white/black pixels just seen and an end position,
         * figures the location of the center of this black/white/black run.
         */ static centerFromEnd(stateCount, end /*int*/ ) {
            return end - stateCount[2] - stateCount[1] / 2.0;
        }
        /**
         * @param stateCount count of black/white/black pixels just read
         * @return true iff the proportions of the counts is close enough to the 1/1/1 ratios
         *         used by alignment patterns to be considered a match
         */ foundPatternCross(stateCount) {
            const moduleSize = this.moduleSize;
            const maxVariance = moduleSize / 2.0;
            for(let i = 0; i < 3; i++){
                if (Math.abs(moduleSize - stateCount[i]) >= maxVariance) return false;
            }
            return true;
        }
        /**
         * <p>After a horizontal scan finds a potential alignment pattern, this method
         * "cross-checks" by scanning down vertically through the center of the possible
         * alignment pattern to see if the same proportion is detected.</p>
         *
         * @param startI row where an alignment pattern was detected
         * @param centerJ center of the section that appears to cross an alignment pattern
         * @param maxCount maximum reasonable number of modules that should be
         * observed in any reading state, based on the results of the horizontal scan
         * @return vertical center of alignment pattern, or {@link Float#NaN} if not found
         */ crossCheckVertical(startI /*int*/ , centerJ /*int*/ , maxCount /*int*/ , originalStateCountTotal /*int*/ ) {
            const image = this.image;
            const maxI = image.getHeight();
            const stateCount = this.crossCheckStateCount;
            stateCount[0] = 0;
            stateCount[1] = 0;
            stateCount[2] = 0;
            // Start counting up from center
            let i = startI;
            while(i >= 0 && image.get(centerJ, i) && stateCount[1] <= maxCount){
                stateCount[1]++;
                i--;
            }
            // If already too many modules in this state or ran off the edge:
            if (i < 0 || stateCount[1] > maxCount) return NaN;
            while(i >= 0 && !image.get(centerJ, i) && stateCount[0] <= maxCount){
                stateCount[0]++;
                i--;
            }
            if (stateCount[0] > maxCount) return NaN;
            // Now also count down from center
            i = startI + 1;
            while(i < maxI && image.get(centerJ, i) && stateCount[1] <= maxCount){
                stateCount[1]++;
                i++;
            }
            if (i === maxI || stateCount[1] > maxCount) return NaN;
            while(i < maxI && !image.get(centerJ, i) && stateCount[2] <= maxCount){
                stateCount[2]++;
                i++;
            }
            if (stateCount[2] > maxCount) return NaN;
            const stateCountTotal = stateCount[0] + stateCount[1] + stateCount[2];
            if (5 * Math.abs(stateCountTotal - originalStateCountTotal) >= 2 * originalStateCountTotal) return NaN;
            return this.foundPatternCross(stateCount) ? AlignmentPatternFinder.centerFromEnd(stateCount, i) : NaN;
        }
        /**
         * <p>This is called when a horizontal scan finds a possible alignment pattern. It will
         * cross check with a vertical scan, and if successful, will see if this pattern had been
         * found on a previous horizontal scan. If so, we consider it confirmed and conclude we have
         * found the alignment pattern.</p>
         *
         * @param stateCount reading state module counts from horizontal scan
         * @param i row where alignment pattern may be found
         * @param j end of possible alignment pattern in row
         * @return {@link AlignmentPattern} if we have found the same pattern twice, or null if not
         */ handlePossibleCenter(stateCount, i /*int*/ , j /*int*/ ) {
            const stateCountTotal = stateCount[0] + stateCount[1] + stateCount[2];
            const centerJ = AlignmentPatternFinder.centerFromEnd(stateCount, j);
            const centerI = this.crossCheckVertical(i, /*(int) */ centerJ, 2 * stateCount[1], stateCountTotal);
            if (!isNaN(centerI)) {
                const estimatedModuleSize = (stateCount[0] + stateCount[1] + stateCount[2]) / 3.0;
                for (const center of this.possibleCenters){
                    // Look for about the same center and module size:
                    if (center.aboutEquals(estimatedModuleSize, centerI, centerJ)) return center.combineEstimate(centerI, centerJ, estimatedModuleSize);
                }
                // Hadn't found this before; save it
                const point = new AlignmentPattern(centerJ, centerI, estimatedModuleSize);
                this.possibleCenters.push(point);
                if (this.resultPointCallback !== null && this.resultPointCallback !== undefined) this.resultPointCallback.foundPossibleResultPoint(point);
            }
            return null;
        }
    }
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * <p>Encapsulates a finder pattern, which are the three square patterns found in
     * the corners of QR Codes. It also encapsulates a count of similar finder patterns,
     * as a convenience to the finder's bookkeeping.</p>
     *
     * @author Sean Owen
     */ class FinderPattern$1 extends ResultPoint {
        // FinderPattern(posX: number/*float*/, posY: number/*float*/, estimatedModuleSize: number/*float*/) {
        //   this(posX, posY, estimatedModuleSize, 1)
        // }
        constructor(posX /*float*/ , posY /*float*/ , estimatedModuleSize /*float*/ , count /*int*/ ){
            super(posX, posY);
            this.estimatedModuleSize = estimatedModuleSize;
            this.count = count;
            if (undefined === count) this.count = 1;
        }
        getEstimatedModuleSize() {
            return this.estimatedModuleSize;
        }
        getCount() {
            return this.count;
        }
        /*
        void incrementCount() {
          this.count++
        }
         */ /**
         * <p>Determines if this finder pattern "about equals" a finder pattern at the stated
         * position and size -- meaning, it is at nearly the same center with nearly the same size.</p>
         */ aboutEquals(moduleSize /*float*/ , i /*float*/ , j /*float*/ ) {
            if (Math.abs(i - this.getY()) <= moduleSize && Math.abs(j - this.getX()) <= moduleSize) {
                const moduleSizeDiff = Math.abs(moduleSize - this.estimatedModuleSize);
                return moduleSizeDiff <= 1.0 || moduleSizeDiff <= this.estimatedModuleSize;
            }
            return false;
        }
        /**
         * Combines this object's current estimate of a finder pattern position and module size
         * with a new estimate. It returns a new {@code FinderPattern} containing a weighted average
         * based on count.
         */ combineEstimate(i /*float*/ , j /*float*/ , newModuleSize /*float*/ ) {
            const combinedCount = this.count + 1;
            const combinedX = (this.count * this.getX() + j) / combinedCount;
            const combinedY = (this.count * this.getY() + i) / combinedCount;
            const combinedModuleSize = (this.count * this.estimatedModuleSize + newModuleSize) / combinedCount;
            return new FinderPattern$1(combinedX, combinedY, combinedModuleSize, combinedCount);
        }
    }
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * <p>Encapsulates information about finder patterns in an image, including the location of
     * the three finder patterns, and their estimated module size.</p>
     *
     * @author Sean Owen
     */ class FinderPatternInfo {
        constructor(patternCenters){
            this.bottomLeft = patternCenters[0];
            this.topLeft = patternCenters[1];
            this.topRight = patternCenters[2];
        }
        getBottomLeft() {
            return this.bottomLeft;
        }
        getTopLeft() {
            return this.topLeft;
        }
        getTopRight() {
            return this.topRight;
        }
    }
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /*import java.io.Serializable;*/ /*import java.util.ArrayList;*/ /*import java.util.Collections;*/ /*import java.util.Comparator;*/ /*import java.util.List;*/ /*import java.util.Map;*/ /**
     * <p>This class attempts to find finder patterns in a QR Code. Finder patterns are the square
     * markers at three corners of a QR Code.</p>
     *
     * <p>This class is thread-safe but not reentrant. Each thread must allocate its own object.
     *
     * @author Sean Owen
     */ class FinderPatternFinder {
        /**
         * <p>Creates a finder that will search the image for three finder patterns.</p>
         *
         * @param image image to search
         */ // public constructor(image: BitMatrix) {
        //   this(image, null)
        // }
        constructor(image, resultPointCallback){
            this.image = image;
            this.resultPointCallback = resultPointCallback;
            this.possibleCenters = [];
            this.crossCheckStateCount = new Int32Array(5);
            this.resultPointCallback = resultPointCallback;
        }
        getImage() {
            return this.image;
        }
        getPossibleCenters() {
            return this.possibleCenters;
        }
        find(hints) {
            const tryHarder = hints !== null && hints !== undefined && undefined !== hints.get(DecodeHintType$1.TRY_HARDER);
            const pureBarcode = hints !== null && hints !== undefined && undefined !== hints.get(DecodeHintType$1.PURE_BARCODE);
            const image = this.image;
            const maxI = image.getHeight();
            const maxJ = image.getWidth();
            // We are looking for black/white/black/white/black modules in
            // 1:1:3:1:1 ratio; this tracks the number of such modules seen so far
            // Let's assume that the maximum version QR Code we support takes up 1/4 the height of the
            // image, and then account for the center being 3 modules in size. This gives the smallest
            // number of pixels the center could be, so skip this often. When trying harder, look for all
            // QR versions regardless of how dense they are.
            let iSkip = Math.floor(3 * maxI / (4 * FinderPatternFinder.MAX_MODULES));
            if (iSkip < FinderPatternFinder.MIN_SKIP || tryHarder) iSkip = FinderPatternFinder.MIN_SKIP;
            let done = false;
            const stateCount = new Int32Array(5);
            for(let i = iSkip - 1; i < maxI && !done; i += iSkip){
                // Get a row of black/white values
                stateCount[0] = 0;
                stateCount[1] = 0;
                stateCount[2] = 0;
                stateCount[3] = 0;
                stateCount[4] = 0;
                let currentState = 0;
                for(let j = 0; j < maxJ; j++){
                    if (image.get(j, i)) {
                        // Black pixel
                        if ((currentState & 1) === 1) currentState++;
                        stateCount[currentState]++;
                    } else if ((currentState & 1) === 0) {
                        if (currentState === 4) {
                            if (FinderPatternFinder.foundPatternCross(stateCount)) {
                                const confirmed = this.handlePossibleCenter(stateCount, i, j, pureBarcode);
                                if (confirmed === true) {
                                    // Start examining every other line. Checking each line turned out to be too
                                    // expensive and didn't improve performance.
                                    iSkip = 2;
                                    if (this.hasSkipped === true) done = this.haveMultiplyConfirmedCenters();
                                    else {
                                        const rowSkip = this.findRowSkip();
                                        if (rowSkip > stateCount[2]) {
                                            // Skip rows between row of lower confirmed center
                                            // and top of presumed third confirmed center
                                            // but back up a bit to get a full chance of detecting
                                            // it, entire width of center of finder pattern
                                            // Skip by rowSkip, but back off by stateCount[2] (size of last center
                                            // of pattern we saw) to be conservative, and also back off by iSkip which
                                            // is about to be re-added
                                            i += rowSkip - stateCount[2] - iSkip;
                                            j = maxJ - 1;
                                        }
                                    }
                                } else {
                                    stateCount[0] = stateCount[2];
                                    stateCount[1] = stateCount[3];
                                    stateCount[2] = stateCount[4];
                                    stateCount[3] = 1;
                                    stateCount[4] = 0;
                                    currentState = 3;
                                    continue;
                                }
                                // Clear state to start looking again
                                currentState = 0;
                                stateCount[0] = 0;
                                stateCount[1] = 0;
                                stateCount[2] = 0;
                                stateCount[3] = 0;
                                stateCount[4] = 0;
                            } else {
                                stateCount[0] = stateCount[2];
                                stateCount[1] = stateCount[3];
                                stateCount[2] = stateCount[4];
                                stateCount[3] = 1;
                                stateCount[4] = 0;
                                currentState = 3;
                            }
                        } else stateCount[++currentState]++;
                    } else stateCount[currentState]++;
                }
                if (FinderPatternFinder.foundPatternCross(stateCount)) {
                    const confirmed = this.handlePossibleCenter(stateCount, i, maxJ, pureBarcode);
                    if (confirmed === true) {
                        iSkip = stateCount[0];
                        if (this.hasSkipped) // Found a third one
                        done = this.haveMultiplyConfirmedCenters();
                    }
                }
            }
            const patternInfo = this.selectBestPatterns();
            ResultPoint.orderBestPatterns(patternInfo);
            return new FinderPatternInfo(patternInfo);
        }
        /**
         * Given a count of black/white/black/white/black pixels just seen and an end position,
         * figures the location of the center of this run.
         */ static centerFromEnd(stateCount, end /*int*/ ) {
            return end - stateCount[4] - stateCount[3] - stateCount[2] / 2.0;
        }
        /**
         * @param stateCount count of black/white/black/white/black pixels just read
         * @return true iff the proportions of the counts is close enough to the 1/1/3/1/1 ratios
         *         used by finder patterns to be considered a match
         */ static foundPatternCross(stateCount) {
            let totalModuleSize = 0;
            for(let i = 0; i < 5; i++){
                const count = stateCount[i];
                if (count === 0) return false;
                totalModuleSize += count;
            }
            if (totalModuleSize < 7) return false;
            const moduleSize = totalModuleSize / 7.0;
            const maxVariance = moduleSize / 2.0;
            // Allow less than 50% variance from 1-1-3-1-1 proportions
            return Math.abs(moduleSize - stateCount[0]) < maxVariance && Math.abs(moduleSize - stateCount[1]) < maxVariance && Math.abs(3.0 * moduleSize - stateCount[2]) < 3 * maxVariance && Math.abs(moduleSize - stateCount[3]) < maxVariance && Math.abs(moduleSize - stateCount[4]) < maxVariance;
        }
        getCrossCheckStateCount() {
            const crossCheckStateCount = this.crossCheckStateCount;
            crossCheckStateCount[0] = 0;
            crossCheckStateCount[1] = 0;
            crossCheckStateCount[2] = 0;
            crossCheckStateCount[3] = 0;
            crossCheckStateCount[4] = 0;
            return crossCheckStateCount;
        }
        /**
         * After a vertical and horizontal scan finds a potential finder pattern, this method
         * "cross-cross-cross-checks" by scanning down diagonally through the center of the possible
         * finder pattern to see if the same proportion is detected.
         *
         * @param startI row where a finder pattern was detected
         * @param centerJ center of the section that appears to cross a finder pattern
         * @param maxCount maximum reasonable number of modules that should be
         *  observed in any reading state, based on the results of the horizontal scan
         * @param originalStateCountTotal The original state count total.
         * @return true if proportions are withing expected limits
         */ crossCheckDiagonal(startI /*int*/ , centerJ /*int*/ , maxCount /*int*/ , originalStateCountTotal /*int*/ ) {
            const stateCount = this.getCrossCheckStateCount();
            // Start counting up, left from center finding black center mass
            let i = 0;
            const image = this.image;
            while(startI >= i && centerJ >= i && image.get(centerJ - i, startI - i)){
                stateCount[2]++;
                i++;
            }
            if (startI < i || centerJ < i) return false;
            // Continue up, left finding white space
            while(startI >= i && centerJ >= i && !image.get(centerJ - i, startI - i) && stateCount[1] <= maxCount){
                stateCount[1]++;
                i++;
            }
            // If already too many modules in this state or ran off the edge:
            if (startI < i || centerJ < i || stateCount[1] > maxCount) return false;
            // Continue up, left finding black border
            while(startI >= i && centerJ >= i && image.get(centerJ - i, startI - i) && stateCount[0] <= maxCount){
                stateCount[0]++;
                i++;
            }
            if (stateCount[0] > maxCount) return false;
            const maxI = image.getHeight();
            const maxJ = image.getWidth();
            // Now also count down, right from center
            i = 1;
            while(startI + i < maxI && centerJ + i < maxJ && image.get(centerJ + i, startI + i)){
                stateCount[2]++;
                i++;
            }
            // Ran off the edge?
            if (startI + i >= maxI || centerJ + i >= maxJ) return false;
            while(startI + i < maxI && centerJ + i < maxJ && !image.get(centerJ + i, startI + i) && stateCount[3] < maxCount){
                stateCount[3]++;
                i++;
            }
            if (startI + i >= maxI || centerJ + i >= maxJ || stateCount[3] >= maxCount) return false;
            while(startI + i < maxI && centerJ + i < maxJ && image.get(centerJ + i, startI + i) && stateCount[4] < maxCount){
                stateCount[4]++;
                i++;
            }
            if (stateCount[4] >= maxCount) return false;
            // If we found a finder-pattern-like section, but its size is more than 100% different than
            // the original, assume it's a false positive
            const stateCountTotal = stateCount[0] + stateCount[1] + stateCount[2] + stateCount[3] + stateCount[4];
            return Math.abs(stateCountTotal - originalStateCountTotal) < 2 * originalStateCountTotal && FinderPatternFinder.foundPatternCross(stateCount);
        }
        /**
         * <p>After a horizontal scan finds a potential finder pattern, this method
         * "cross-checks" by scanning down vertically through the center of the possible
         * finder pattern to see if the same proportion is detected.</p>
         *
         * @param startI row where a finder pattern was detected
         * @param centerJ center of the section that appears to cross a finder pattern
         * @param maxCount maximum reasonable number of modules that should be
         * observed in any reading state, based on the results of the horizontal scan
         * @return vertical center of finder pattern, or {@link Float#NaN} if not found
         */ crossCheckVertical(startI /*int*/ , centerJ /*int*/ , maxCount /*int*/ , originalStateCountTotal /*int*/ ) {
            const image = this.image;
            const maxI = image.getHeight();
            const stateCount = this.getCrossCheckStateCount();
            // Start counting up from center
            let i = startI;
            while(i >= 0 && image.get(centerJ, i)){
                stateCount[2]++;
                i--;
            }
            if (i < 0) return NaN;
            while(i >= 0 && !image.get(centerJ, i) && stateCount[1] <= maxCount){
                stateCount[1]++;
                i--;
            }
            // If already too many modules in this state or ran off the edge:
            if (i < 0 || stateCount[1] > maxCount) return NaN;
            while(i >= 0 && image.get(centerJ, i) && stateCount[0] <= maxCount){
                stateCount[0]++;
                i--;
            }
            if (stateCount[0] > maxCount) return NaN;
            // Now also count down from center
            i = startI + 1;
            while(i < maxI && image.get(centerJ, i)){
                stateCount[2]++;
                i++;
            }
            if (i === maxI) return NaN;
            while(i < maxI && !image.get(centerJ, i) && stateCount[3] < maxCount){
                stateCount[3]++;
                i++;
            }
            if (i === maxI || stateCount[3] >= maxCount) return NaN;
            while(i < maxI && image.get(centerJ, i) && stateCount[4] < maxCount){
                stateCount[4]++;
                i++;
            }
            if (stateCount[4] >= maxCount) return NaN;
            // If we found a finder-pattern-like section, but its size is more than 40% different than
            // the original, assume it's a false positive
            const stateCountTotal = stateCount[0] + stateCount[1] + stateCount[2] + stateCount[3] + stateCount[4];
            if (5 * Math.abs(stateCountTotal - originalStateCountTotal) >= 2 * originalStateCountTotal) return NaN;
            return FinderPatternFinder.foundPatternCross(stateCount) ? FinderPatternFinder.centerFromEnd(stateCount, i) : NaN;
        }
        /**
         * <p>Like {@link #crossCheckVertical(int, int, int, int)}, and in fact is basically identical,
         * except it reads horizontally instead of vertically. This is used to cross-cross
         * check a vertical cross check and locate the real center of the alignment pattern.</p>
         */ crossCheckHorizontal(startJ /*int*/ , centerI /*int*/ , maxCount /*int*/ , originalStateCountTotal /*int*/ ) {
            const image = this.image;
            const maxJ = image.getWidth();
            const stateCount = this.getCrossCheckStateCount();
            let j = startJ;
            while(j >= 0 && image.get(j, centerI)){
                stateCount[2]++;
                j--;
            }
            if (j < 0) return NaN;
            while(j >= 0 && !image.get(j, centerI) && stateCount[1] <= maxCount){
                stateCount[1]++;
                j--;
            }
            if (j < 0 || stateCount[1] > maxCount) return NaN;
            while(j >= 0 && image.get(j, centerI) && stateCount[0] <= maxCount){
                stateCount[0]++;
                j--;
            }
            if (stateCount[0] > maxCount) return NaN;
            j = startJ + 1;
            while(j < maxJ && image.get(j, centerI)){
                stateCount[2]++;
                j++;
            }
            if (j === maxJ) return NaN;
            while(j < maxJ && !image.get(j, centerI) && stateCount[3] < maxCount){
                stateCount[3]++;
                j++;
            }
            if (j === maxJ || stateCount[3] >= maxCount) return NaN;
            while(j < maxJ && image.get(j, centerI) && stateCount[4] < maxCount){
                stateCount[4]++;
                j++;
            }
            if (stateCount[4] >= maxCount) return NaN;
            // If we found a finder-pattern-like section, but its size is significantly different than
            // the original, assume it's a false positive
            const stateCountTotal = stateCount[0] + stateCount[1] + stateCount[2] + stateCount[3] + stateCount[4];
            if (5 * Math.abs(stateCountTotal - originalStateCountTotal) >= originalStateCountTotal) return NaN;
            return FinderPatternFinder.foundPatternCross(stateCount) ? FinderPatternFinder.centerFromEnd(stateCount, j) : NaN;
        }
        /**
         * <p>This is called when a horizontal scan finds a possible alignment pattern. It will
         * cross check with a vertical scan, and if successful, will, ah, cross-cross-check
         * with another horizontal scan. This is needed primarily to locate the real horizontal
         * center of the pattern in cases of extreme skew.
         * And then we cross-cross-cross check with another diagonal scan.</p>
         *
         * <p>If that succeeds the finder pattern location is added to a list that tracks
         * the number of times each location has been nearly-matched as a finder pattern.
         * Each additional find is more evidence that the location is in fact a finder
         * pattern center
         *
         * @param stateCount reading state module counts from horizontal scan
         * @param i row where finder pattern may be found
         * @param j end of possible finder pattern in row
         * @param pureBarcode true if in "pure barcode" mode
         * @return true if a finder pattern candidate was found this time
         */ handlePossibleCenter(stateCount, i /*int*/ , j /*int*/ , pureBarcode) {
            const stateCountTotal = stateCount[0] + stateCount[1] + stateCount[2] + stateCount[3] + stateCount[4];
            let centerJ = FinderPatternFinder.centerFromEnd(stateCount, j);
            let centerI = this.crossCheckVertical(i, /*(int) */ Math.floor(centerJ), stateCount[2], stateCountTotal);
            if (!isNaN(centerI)) {
                // Re-cross check
                centerJ = this.crossCheckHorizontal(/*(int) */ Math.floor(centerJ), /*(int) */ Math.floor(centerI), stateCount[2], stateCountTotal);
                if (!isNaN(centerJ) && (!pureBarcode || this.crossCheckDiagonal(/*(int) */ Math.floor(centerI), /*(int) */ Math.floor(centerJ), stateCount[2], stateCountTotal))) {
                    const estimatedModuleSize = stateCountTotal / 7.0;
                    let found = false;
                    const possibleCenters = this.possibleCenters;
                    for(let index = 0, length = possibleCenters.length; index < length; index++){
                        const center = possibleCenters[index];
                        // Look for about the same center and module size:
                        if (center.aboutEquals(estimatedModuleSize, centerI, centerJ)) {
                            possibleCenters[index] = center.combineEstimate(centerI, centerJ, estimatedModuleSize);
                            found = true;
                            break;
                        }
                    }
                    if (!found) {
                        const point = new FinderPattern$1(centerJ, centerI, estimatedModuleSize);
                        possibleCenters.push(point);
                        if (this.resultPointCallback !== null && this.resultPointCallback !== undefined) this.resultPointCallback.foundPossibleResultPoint(point);
                    }
                    return true;
                }
            }
            return false;
        }
        /**
         * @return number of rows we could safely skip during scanning, based on the first
         *         two finder patterns that have been located. In some cases their position will
         *         allow us to infer that the third pattern must lie below a certain point farther
         *         down in the image.
         */ findRowSkip() {
            const max = this.possibleCenters.length;
            if (max <= 1) return 0;
            let firstConfirmedCenter = null;
            for (const center of this.possibleCenters)if (center.getCount() >= FinderPatternFinder.CENTER_QUORUM) {
                if (firstConfirmedCenter == null) firstConfirmedCenter = center;
                else {
                    // We have two confirmed centers
                    // How far down can we skip before resuming looking for the next
                    // pattern? In the worst case, only the difference between the
                    // difference in the x / y coordinates of the two centers.
                    // This is the case where you find top left last.
                    this.hasSkipped = true;
                    return /*(int) */ Math.floor((Math.abs(firstConfirmedCenter.getX() - center.getX()) - Math.abs(firstConfirmedCenter.getY() - center.getY())) / 2);
                }
            }
            return 0;
        }
        /**
         * @return true iff we have found at least 3 finder patterns that have been detected
         *         at least {@link #CENTER_QUORUM} times each, and, the estimated module size of the
         *         candidates is "pretty similar"
         */ haveMultiplyConfirmedCenters() {
            let confirmedCount = 0;
            let totalModuleSize = 0.0;
            const max = this.possibleCenters.length;
            for (const pattern of this.possibleCenters)if (pattern.getCount() >= FinderPatternFinder.CENTER_QUORUM) {
                confirmedCount++;
                totalModuleSize += pattern.getEstimatedModuleSize();
            }
            if (confirmedCount < 3) return false;
            // OK, we have at least 3 confirmed centers, but, it's possible that one is a "false positive"
            // and that we need to keep looking. We detect this by asking if the estimated module sizes
            // vary too much. We arbitrarily say that when the total deviation from average exceeds
            // 5% of the total module size estimates, it's too much.
            const average = totalModuleSize / max;
            let totalDeviation = 0.0;
            for (const pattern of this.possibleCenters)totalDeviation += Math.abs(pattern.getEstimatedModuleSize() - average);
            return totalDeviation <= 0.05 * totalModuleSize;
        }
        /**
         * @return the 3 best {@link FinderPattern}s from our list of candidates. The "best" are
         *         those that have been detected at least {@link #CENTER_QUORUM} times, and whose module
         *         size differs from the average among those patterns the least
         * @throws NotFoundException if 3 such finder patterns do not exist
         */ selectBestPatterns() {
            const startSize = this.possibleCenters.length;
            if (startSize < 3) // Couldn't find enough finder patterns
            throw new NotFoundException();
            const possibleCenters = this.possibleCenters;
            let average;
            // Filter outlier possibilities whose module size is too different
            if (startSize > 3) {
                // But we can only afford to do so if we have at least 4 possibilities to choose from
                let totalModuleSize = 0.0;
                let square = 0.0;
                for (const center of this.possibleCenters){
                    const size = center.getEstimatedModuleSize();
                    totalModuleSize += size;
                    square += size * size;
                }
                average = totalModuleSize / startSize;
                let stdDev = Math.sqrt(square / startSize - average * average);
                possibleCenters.sort(/**
                 * <p>Orders by furthest from average</p>
                 */ // FurthestFromAverageComparator implements Comparator<FinderPattern>
                (center1, center2)=>{
                    const dA = Math.abs(center2.getEstimatedModuleSize() - average);
                    const dB = Math.abs(center1.getEstimatedModuleSize() - average);
                    return dA < dB ? -1 : dA > dB ? 1 : 0;
                });
                const limit = Math.max(0.2 * average, stdDev);
                for(let i = 0; i < possibleCenters.length && possibleCenters.length > 3; i++){
                    const pattern = possibleCenters[i];
                    if (Math.abs(pattern.getEstimatedModuleSize() - average) > limit) {
                        possibleCenters.splice(i, 1);
                        i--;
                    }
                }
            }
            if (possibleCenters.length > 3) {
                // Throw away all but those first size candidate points we found.
                let totalModuleSize = 0.0;
                for (const possibleCenter of possibleCenters)totalModuleSize += possibleCenter.getEstimatedModuleSize();
                average = totalModuleSize / possibleCenters.length;
                possibleCenters.sort(/**
                 * <p>Orders by {@link FinderPattern#getCount()}, descending.</p>
                 */ // CenterComparator implements Comparator<FinderPattern>
                (center1, center2)=>{
                    if (center2.getCount() === center1.getCount()) {
                        const dA = Math.abs(center2.getEstimatedModuleSize() - average);
                        const dB = Math.abs(center1.getEstimatedModuleSize() - average);
                        return dA < dB ? 1 : dA > dB ? -1 : 0;
                    } else return center2.getCount() - center1.getCount();
                });
                possibleCenters.splice(3); // this is not realy necessary as we only return first 3 anyway
            }
            return [
                possibleCenters[0],
                possibleCenters[1],
                possibleCenters[2]
            ];
        }
    }
    FinderPatternFinder.CENTER_QUORUM = 2;
    FinderPatternFinder.MIN_SKIP = 3; // 1 pixel/module times 3 modules/center
    FinderPatternFinder.MAX_MODULES = 57; // support up to version 10 for mobile clients
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /*import java.util.Map;*/ /**
     * <p>Encapsulates logic that can detect a QR Code in an image, even if the QR Code
     * is rotated or skewed, or partially obscured.</p>
     *
     * @author Sean Owen
     */ class Detector$2 {
        constructor(image){
            this.image = image;
        }
        getImage() {
            return this.image;
        }
        getResultPointCallback() {
            return this.resultPointCallback;
        }
        /**
         * <p>Detects a QR Code in an image.</p>
         *
         * @return {@link DetectorResult} encapsulating results of detecting a QR Code
         * @throws NotFoundException if QR Code cannot be found
         * @throws FormatException if a QR Code cannot be decoded
         */ // public detect(): DetectorResult /*throws NotFoundException, FormatException*/ {
        //   return detect(null)
        // }
        /**
         * <p>Detects a QR Code in an image.</p>
         *
         * @param hints optional hints to detector
         * @return {@link DetectorResult} encapsulating results of detecting a QR Code
         * @throws NotFoundException if QR Code cannot be found
         * @throws FormatException if a QR Code cannot be decoded
         */ detect(hints) {
            this.resultPointCallback = hints === null || hints === undefined ? null : /*(ResultPointCallback) */ hints.get(DecodeHintType$1.NEED_RESULT_POINT_CALLBACK);
            const finder = new FinderPatternFinder(this.image, this.resultPointCallback);
            const info = finder.find(hints);
            return this.processFinderPatternInfo(info);
        }
        processFinderPatternInfo(info) {
            const topLeft = info.getTopLeft();
            const topRight = info.getTopRight();
            const bottomLeft = info.getBottomLeft();
            const moduleSize = this.calculateModuleSize(topLeft, topRight, bottomLeft);
            if (moduleSize < 1.0) throw new NotFoundException('No pattern found in proccess finder.');
            const dimension = Detector$2.computeDimension(topLeft, topRight, bottomLeft, moduleSize);
            const provisionalVersion = Version$1.getProvisionalVersionForDimension(dimension);
            const modulesBetweenFPCenters = provisionalVersion.getDimensionForVersion() - 7;
            let alignmentPattern = null;
            // Anything above version 1 has an alignment pattern
            if (provisionalVersion.getAlignmentPatternCenters().length > 0) {
                // Guess where a "bottom right" finder pattern would have been
                const bottomRightX = topRight.getX() - topLeft.getX() + bottomLeft.getX();
                const bottomRightY = topRight.getY() - topLeft.getY() + bottomLeft.getY();
                // Estimate that alignment pattern is closer by 3 modules
                // from "bottom right" to known top left location
                const correctionToTopLeft = 1.0 - 3.0 / modulesBetweenFPCenters;
                const estAlignmentX = /*(int) */ Math.floor(topLeft.getX() + correctionToTopLeft * (bottomRightX - topLeft.getX()));
                const estAlignmentY = /*(int) */ Math.floor(topLeft.getY() + correctionToTopLeft * (bottomRightY - topLeft.getY()));
                // Kind of arbitrary -- expand search radius before giving up
                for(let i = 4; i <= 16; i <<= 1)try {
                    alignmentPattern = this.findAlignmentInRegion(moduleSize, estAlignmentX, estAlignmentY, i);
                    break;
                } catch (re /*NotFoundException*/ ) {
                    if (!(re instanceof NotFoundException)) throw re;
                // try next round
                }
            // If we didn't find alignment pattern... well try anyway without it
            }
            const transform = Detector$2.createTransform(topLeft, topRight, bottomLeft, alignmentPattern, dimension);
            const bits = Detector$2.sampleGrid(this.image, transform, dimension);
            let points;
            if (alignmentPattern === null) points = [
                bottomLeft,
                topLeft,
                topRight
            ];
            else points = [
                bottomLeft,
                topLeft,
                topRight,
                alignmentPattern
            ];
            return new DetectorResult(bits, points);
        }
        static createTransform(topLeft, topRight, bottomLeft, alignmentPattern, dimension /*int*/ ) {
            const dimMinusThree = dimension - 3.5;
            let bottomRightX; /*float*/ 
            let bottomRightY; /*float*/ 
            let sourceBottomRightX; /*float*/ 
            let sourceBottomRightY; /*float*/ 
            if (alignmentPattern !== null) {
                bottomRightX = alignmentPattern.getX();
                bottomRightY = alignmentPattern.getY();
                sourceBottomRightX = dimMinusThree - 3.0;
                sourceBottomRightY = sourceBottomRightX;
            } else {
                // Don't have an alignment pattern, just make up the bottom-right point
                bottomRightX = topRight.getX() - topLeft.getX() + bottomLeft.getX();
                bottomRightY = topRight.getY() - topLeft.getY() + bottomLeft.getY();
                sourceBottomRightX = dimMinusThree;
                sourceBottomRightY = dimMinusThree;
            }
            return PerspectiveTransform.quadrilateralToQuadrilateral(3.5, 3.5, dimMinusThree, 3.5, sourceBottomRightX, sourceBottomRightY, 3.5, dimMinusThree, topLeft.getX(), topLeft.getY(), topRight.getX(), topRight.getY(), bottomRightX, bottomRightY, bottomLeft.getX(), bottomLeft.getY());
        }
        static sampleGrid(image, transform, dimension /*int*/ ) {
            const sampler = GridSamplerInstance.getInstance();
            return sampler.sampleGridWithTransform(image, dimension, dimension, transform);
        }
        /**
         * <p>Computes the dimension (number of modules on a size) of the QR Code based on the position
         * of the finder patterns and estimated module size.</p>
         */ static computeDimension(topLeft, topRight, bottomLeft, moduleSize /*float*/ ) {
            const tltrCentersDimension = MathUtils.round(ResultPoint.distance(topLeft, topRight) / moduleSize);
            const tlblCentersDimension = MathUtils.round(ResultPoint.distance(topLeft, bottomLeft) / moduleSize);
            let dimension = Math.floor((tltrCentersDimension + tlblCentersDimension) / 2) + 7;
            switch(dimension & 0x03){
                case 0:
                    dimension++;
                    break;
                // 1? do nothing
                case 2:
                    dimension--;
                    break;
                case 3:
                    throw new NotFoundException('Dimensions could be not found.');
            }
            return dimension;
        }
        /**
         * <p>Computes an average estimated module size based on estimated derived from the positions
         * of the three finder patterns.</p>
         *
         * @param topLeft detected top-left finder pattern center
         * @param topRight detected top-right finder pattern center
         * @param bottomLeft detected bottom-left finder pattern center
         * @return estimated module size
         */ calculateModuleSize(topLeft, topRight, bottomLeft) {
            // Take the average
            return (this.calculateModuleSizeOneWay(topLeft, topRight) + this.calculateModuleSizeOneWay(topLeft, bottomLeft)) / 2.0;
        }
        /**
         * <p>Estimates module size based on two finder patterns -- it uses
         * {@link #sizeOfBlackWhiteBlackRunBothWays(int, int, int, int)} to figure the
         * width of each, measuring along the axis between their centers.</p>
         */ calculateModuleSizeOneWay(pattern, otherPattern) {
            const moduleSizeEst1 = this.sizeOfBlackWhiteBlackRunBothWays(/*(int) */ Math.floor(pattern.getX()), /*(int) */ Math.floor(pattern.getY()), /*(int) */ Math.floor(otherPattern.getX()), /*(int) */ Math.floor(otherPattern.getY()));
            const moduleSizeEst2 = this.sizeOfBlackWhiteBlackRunBothWays(/*(int) */ Math.floor(otherPattern.getX()), /*(int) */ Math.floor(otherPattern.getY()), /*(int) */ Math.floor(pattern.getX()), /*(int) */ Math.floor(pattern.getY()));
            if (isNaN(moduleSizeEst1)) return moduleSizeEst2 / 7.0;
            if (isNaN(moduleSizeEst2)) return moduleSizeEst1 / 7.0;
            // Average them, and divide by 7 since we've counted the width of 3 black modules,
            // and 1 white and 1 black module on either side. Ergo, divide sum by 14.
            return (moduleSizeEst1 + moduleSizeEst2) / 14.0;
        }
        /**
         * See {@link #sizeOfBlackWhiteBlackRun(int, int, int, int)}; computes the total width of
         * a finder pattern by looking for a black-white-black run from the center in the direction
         * of another point (another finder pattern center), and in the opposite direction too.
         */ sizeOfBlackWhiteBlackRunBothWays(fromX /*int*/ , fromY /*int*/ , toX /*int*/ , toY /*int*/ ) {
            let result = this.sizeOfBlackWhiteBlackRun(fromX, fromY, toX, toY);
            // Now count other way -- don't run off image though of course
            let scale = 1.0;
            let otherToX = fromX - (toX - fromX);
            if (otherToX < 0) {
                scale = fromX / /*(float) */ (fromX - otherToX);
                otherToX = 0;
            } else if (otherToX >= this.image.getWidth()) {
                scale = (this.image.getWidth() - 1 - fromX) / /*(float) */ (otherToX - fromX);
                otherToX = this.image.getWidth() - 1;
            }
            let otherToY = /*(int) */ Math.floor(fromY - (toY - fromY) * scale);
            scale = 1.0;
            if (otherToY < 0) {
                scale = fromY / /*(float) */ (fromY - otherToY);
                otherToY = 0;
            } else if (otherToY >= this.image.getHeight()) {
                scale = (this.image.getHeight() - 1 - fromY) / /*(float) */ (otherToY - fromY);
                otherToY = this.image.getHeight() - 1;
            }
            otherToX = /*(int) */ Math.floor(fromX + (otherToX - fromX) * scale);
            result += this.sizeOfBlackWhiteBlackRun(fromX, fromY, otherToX, otherToY);
            // Middle pixel is double-counted this way; subtract 1
            return result - 1.0;
        }
        /**
         * <p>This method traces a line from a point in the image, in the direction towards another point.
         * It begins in a black region, and keeps going until it finds white, then black, then white again.
         * It reports the distance from the start to this point.</p>
         *
         * <p>This is used when figuring out how wide a finder pattern is, when the finder pattern
         * may be skewed or rotated.</p>
         */ sizeOfBlackWhiteBlackRun(fromX /*int*/ , fromY /*int*/ , toX /*int*/ , toY /*int*/ ) {
            // Mild variant of Bresenham's algorithm
            // see http://en.wikipedia.org/wiki/Bresenham's_line_algorithm
            const steep = Math.abs(toY - fromY) > Math.abs(toX - fromX);
            if (steep) {
                let temp = fromX;
                fromX = fromY;
                fromY = temp;
                temp = toX;
                toX = toY;
                toY = temp;
            }
            const dx = Math.abs(toX - fromX);
            const dy = Math.abs(toY - fromY);
            let error = -dx / 2;
            const xstep = fromX < toX ? 1 : -1;
            const ystep = fromY < toY ? 1 : -1;
            // In black pixels, looking for white, first or second time.
            let state = 0;
            // Loop up until x == toX, but not beyond
            const xLimit = toX + xstep;
            for(let x = fromX, y = fromY; x !== xLimit; x += xstep){
                const realX = steep ? y : x;
                const realY = steep ? x : y;
                // Does current pixel mean we have moved white to black or vice versa?
                // Scanning black in state 0,2 and white in state 1, so if we find the wrong
                // color, advance to next state or end if we are in state 2 already
                if (state === 1 === this.image.get(realX, realY)) {
                    if (state === 2) return MathUtils.distance(x, y, fromX, fromY);
                    state++;
                }
                error += dy;
                if (error > 0) {
                    if (y === toY) break;
                    y += ystep;
                    error -= dx;
                }
            }
            // Found black-white-black; give the benefit of the doubt that the next pixel outside the image
            // is "white" so this last point at (toX+xStep,toY) is the right ending. This is really a
            // small approximation; (toX+xStep,toY+yStep) might be really correct. Ignore this.
            if (state === 2) return MathUtils.distance(toX + xstep, toY, fromX, fromY);
            // else we didn't find even black-white-black; no estimate is really possible
            return NaN;
        }
        /**
         * <p>Attempts to locate an alignment pattern in a limited region of the image, which is
         * guessed to contain it. This method uses {@link AlignmentPattern}.</p>
         *
         * @param overallEstModuleSize estimated module size so far
         * @param estAlignmentX x coordinate of center of area probably containing alignment pattern
         * @param estAlignmentY y coordinate of above
         * @param allowanceFactor number of pixels in all directions to search from the center
         * @return {@link AlignmentPattern} if found, or null otherwise
         * @throws NotFoundException if an unexpected error occurs during detection
         */ findAlignmentInRegion(overallEstModuleSize /*float*/ , estAlignmentX /*int*/ , estAlignmentY /*int*/ , allowanceFactor /*float*/ ) {
            // Look for an alignment pattern (3 modules in size) around where it
            // should be
            const allowance = /*(int) */ Math.floor(allowanceFactor * overallEstModuleSize);
            const alignmentAreaLeftX = Math.max(0, estAlignmentX - allowance);
            const alignmentAreaRightX = Math.min(this.image.getWidth() - 1, estAlignmentX + allowance);
            if (alignmentAreaRightX - alignmentAreaLeftX < overallEstModuleSize * 3) throw new NotFoundException('Alignment top exceeds estimated module size.');
            const alignmentAreaTopY = Math.max(0, estAlignmentY - allowance);
            const alignmentAreaBottomY = Math.min(this.image.getHeight() - 1, estAlignmentY + allowance);
            if (alignmentAreaBottomY - alignmentAreaTopY < overallEstModuleSize * 3) throw new NotFoundException('Alignment bottom exceeds estimated module size.');
            const alignmentFinder = new AlignmentPatternFinder(this.image, alignmentAreaLeftX, alignmentAreaTopY, alignmentAreaRightX - alignmentAreaLeftX, alignmentAreaBottomY - alignmentAreaTopY, overallEstModuleSize, this.resultPointCallback);
            return alignmentFinder.find();
        }
    }
    /*
     * Copyright 2007 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /*import java.util.List;*/ /*import java.util.Map;*/ /**
     * This implementation can detect and decode QR Codes in an image.
     *
     * @author Sean Owen
     */ class QRCodeReader {
        constructor(){
            this.decoder = new Decoder$2();
        }
        getDecoder() {
            return this.decoder;
        }
        /**
         * Locates and decodes a QR code in an image.
         *
         * @return a representing: string the content encoded by the QR code
         * @throws NotFoundException if a QR code cannot be found
         * @throws FormatException if a QR code cannot be decoded
         * @throws ChecksumException if error correction fails
         */ /*@Override*/ // public decode(image: BinaryBitmap): Result /*throws NotFoundException, ChecksumException, FormatException */ {
        //   return this.decode(image, null)
        // }
        /*@Override*/ decode(image, hints) {
            let decoderResult;
            let points;
            if (hints !== undefined && hints !== null && undefined !== hints.get(DecodeHintType$1.PURE_BARCODE)) {
                const bits = QRCodeReader.extractPureBits(image.getBlackMatrix());
                decoderResult = this.decoder.decodeBitMatrix(bits, hints);
                points = QRCodeReader.NO_POINTS;
            } else {
                const detectorResult = new Detector$2(image.getBlackMatrix()).detect(hints);
                decoderResult = this.decoder.decodeBitMatrix(detectorResult.getBits(), hints);
                points = detectorResult.getPoints();
            }
            // If the code was mirrored: swap the bottom-left and the top-right points.
            if (decoderResult.getOther() instanceof QRCodeDecoderMetaData) decoderResult.getOther().applyMirroredCorrection(points);
            const result = new Result(decoderResult.getText(), decoderResult.getRawBytes(), undefined, points, BarcodeFormat$1.QR_CODE, undefined);
            const byteSegments = decoderResult.getByteSegments();
            if (byteSegments !== null) result.putMetadata(ResultMetadataType$1.BYTE_SEGMENTS, byteSegments);
            const ecLevel = decoderResult.getECLevel();
            if (ecLevel !== null) result.putMetadata(ResultMetadataType$1.ERROR_CORRECTION_LEVEL, ecLevel);
            if (decoderResult.hasStructuredAppend()) {
                result.putMetadata(ResultMetadataType$1.STRUCTURED_APPEND_SEQUENCE, decoderResult.getStructuredAppendSequenceNumber());
                result.putMetadata(ResultMetadataType$1.STRUCTURED_APPEND_PARITY, decoderResult.getStructuredAppendParity());
            }
            return result;
        }
        /*@Override*/ reset() {
        // do nothing
        }
        /**
         * This method detects a code in a "pure" image -- that is, pure monochrome image
         * which contains only an unrotated, unskewed, image of a code, with some white border
         * around it. This is a specialized method that works exceptionally fast in this special
         * case.
         *
         * @see com.google.zxing.datamatrix.DataMatrixReader#extractPureBits(BitMatrix)
         */ static extractPureBits(image) {
            const leftTopBlack = image.getTopLeftOnBit();
            const rightBottomBlack = image.getBottomRightOnBit();
            if (leftTopBlack === null || rightBottomBlack === null) throw new NotFoundException();
            const moduleSize = this.moduleSize(leftTopBlack, image);
            let top = leftTopBlack[1];
            let bottom = rightBottomBlack[1];
            let left = leftTopBlack[0];
            let right = rightBottomBlack[0];
            // Sanity check!
            if (left >= right || top >= bottom) throw new NotFoundException();
            if (bottom - top !== right - left) {
                // Special case, where bottom-right module wasn't black so we found something else in the last row
                // Assume it's a square, so use height as the width
                right = left + (bottom - top);
                if (right >= image.getWidth()) // Abort if that would not make sense -- off image
                throw new NotFoundException();
            }
            const matrixWidth = Math.round((right - left + 1) / moduleSize);
            const matrixHeight = Math.round((bottom - top + 1) / moduleSize);
            if (matrixWidth <= 0 || matrixHeight <= 0) throw new NotFoundException();
            if (matrixHeight !== matrixWidth) // Only possibly decode square regions
            throw new NotFoundException();
            // Push in the "border" by half the module width so that we start
            // sampling in the middle of the module. Just in case the image is a
            // little off, this will help recover.
            const nudge = /*(int) */ Math.floor(moduleSize / 2.0);
            top += nudge;
            left += nudge;
            // But careful that this does not sample off the edge
            // "right" is the farthest-right valid pixel location -- right+1 is not necessarily
            // This is positive by how much the inner x loop below would be too large
            const nudgedTooFarRight = left + /*(int) */ Math.floor((matrixWidth - 1) * moduleSize) - right;
            if (nudgedTooFarRight > 0) {
                if (nudgedTooFarRight > nudge) // Neither way fits; abort
                throw new NotFoundException();
                left -= nudgedTooFarRight;
            }
            // See logic above
            const nudgedTooFarDown = top + /*(int) */ Math.floor((matrixHeight - 1) * moduleSize) - bottom;
            if (nudgedTooFarDown > 0) {
                if (nudgedTooFarDown > nudge) // Neither way fits; abort
                throw new NotFoundException();
                top -= nudgedTooFarDown;
            }
            // Now just read off the bits
            const bits = new BitMatrix(matrixWidth, matrixHeight);
            for(let y = 0; y < matrixHeight; y++){
                const iOffset = top + /*(int) */ Math.floor(y * moduleSize);
                for(let x = 0; x < matrixWidth; x++)if (image.get(left + /*(int) */ Math.floor(x * moduleSize), iOffset)) bits.set(x, y);
            }
            return bits;
        }
        static moduleSize(leftTopBlack, image) {
            const height = image.getHeight();
            const width = image.getWidth();
            let x = leftTopBlack[0];
            let y = leftTopBlack[1];
            let inBlack = true;
            let transitions = 0;
            while(x < width && y < height){
                if (inBlack !== image.get(x, y)) {
                    if (++transitions === 5) break;
                    inBlack = !inBlack;
                }
                x++;
                y++;
            }
            if (x === width || y === height) throw new NotFoundException();
            return (x - leftTopBlack[0]) / 7.0;
        }
    }
    QRCodeReader.NO_POINTS = new Array();
    /*
    * Copyright 2009 ZXing authors
    *
    * Licensed under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License.
    * You may obtain a copy of the License at
    *
    *      http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software
    * distributed under the License is distributed on an "AS IS" BASIS,
    * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    * See the License for the specific language governing permissions and
    * limitations under the License.
    */ /**
     * @author SITA Lab (kevin.osullivan@sita.aero)
     * @author Guenther Grau
     */ /*public final*/ class PDF417Common {
        PDF417Common() {}
        /**
         * @param moduleBitCount values to sum
         * @return sum of values
         * @deprecated call {@link MathUtils#sum(int[])}
         */ // @Deprecated
        static getBitCountSum(moduleBitCount) {
            return MathUtils.sum(moduleBitCount);
        }
        static toIntArray(list) {
            if (list == null || !list.length) return PDF417Common.EMPTY_INT_ARRAY;
            const result = new Int32Array(list.length);
            let i = 0;
            for (const integer of list)result[i++] = integer;
            return result;
        }
        /**
         * @param symbol encoded symbol to translate to a codeword
         * @return the codeword corresponding to the symbol.
         */ static getCodeword(symbol /*int*/ ) {
            const i = Arrays.binarySearch(PDF417Common.SYMBOL_TABLE, symbol & 0x3FFFF);
            if (i < 0) return -1;
            return (PDF417Common.CODEWORD_TABLE[i] - 1) % PDF417Common.NUMBER_OF_CODEWORDS;
        }
    }
    PDF417Common.NUMBER_OF_CODEWORDS = 929;
    // Maximum Codewords (Data + Error).
    PDF417Common.MAX_CODEWORDS_IN_BARCODE = PDF417Common.NUMBER_OF_CODEWORDS - 1;
    PDF417Common.MIN_ROWS_IN_BARCODE = 3;
    PDF417Common.MAX_ROWS_IN_BARCODE = 90;
    // One left row indication column + max 30 data columns + one right row indicator column
    // public static /*final*/ MAX_CODEWORDS_IN_ROW: /*int*/ number = 32;
    PDF417Common.MODULES_IN_CODEWORD = 17;
    PDF417Common.MODULES_IN_STOP_PATTERN = 18;
    PDF417Common.BARS_IN_MODULE = 8;
    PDF417Common.EMPTY_INT_ARRAY = new Int32Array([]);
    /**
     * The sorted table of all possible symbols. Extracted from the PDF417
     * specification. The index of a symbol in this table corresponds to the
     * index into the codeword table.
     */ PDF417Common.SYMBOL_TABLE = Int32Array.from([
        0x1025e,
        0x1027a,
        0x1029e,
        0x102bc,
        0x102f2,
        0x102f4,
        0x1032e,
        0x1034e,
        0x1035c,
        0x10396,
        0x103a6,
        0x103ac,
        0x10422,
        0x10428,
        0x10436,
        0x10442,
        0x10444,
        0x10448,
        0x10450,
        0x1045e,
        0x10466,
        0x1046c,
        0x1047a,
        0x10482,
        0x1049e,
        0x104a0,
        0x104bc,
        0x104c6,
        0x104d8,
        0x104ee,
        0x104f2,
        0x104f4,
        0x10504,
        0x10508,
        0x10510,
        0x1051e,
        0x10520,
        0x1053c,
        0x10540,
        0x10578,
        0x10586,
        0x1058c,
        0x10598,
        0x105b0,
        0x105be,
        0x105ce,
        0x105dc,
        0x105e2,
        0x105e4,
        0x105e8,
        0x105f6,
        0x1062e,
        0x1064e,
        0x1065c,
        0x1068e,
        0x1069c,
        0x106b8,
        0x106de,
        0x106fa,
        0x10716,
        0x10726,
        0x1072c,
        0x10746,
        0x1074c,
        0x10758,
        0x1076e,
        0x10792,
        0x10794,
        0x107a2,
        0x107a4,
        0x107a8,
        0x107b6,
        0x10822,
        0x10828,
        0x10842,
        0x10848,
        0x10850,
        0x1085e,
        0x10866,
        0x1086c,
        0x1087a,
        0x10882,
        0x10884,
        0x10890,
        0x1089e,
        0x108a0,
        0x108bc,
        0x108c6,
        0x108cc,
        0x108d8,
        0x108ee,
        0x108f2,
        0x108f4,
        0x10902,
        0x10908,
        0x1091e,
        0x10920,
        0x1093c,
        0x10940,
        0x10978,
        0x10986,
        0x10998,
        0x109b0,
        0x109be,
        0x109ce,
        0x109dc,
        0x109e2,
        0x109e4,
        0x109e8,
        0x109f6,
        0x10a08,
        0x10a10,
        0x10a1e,
        0x10a20,
        0x10a3c,
        0x10a40,
        0x10a78,
        0x10af0,
        0x10b06,
        0x10b0c,
        0x10b18,
        0x10b30,
        0x10b3e,
        0x10b60,
        0x10b7c,
        0x10b8e,
        0x10b9c,
        0x10bb8,
        0x10bc2,
        0x10bc4,
        0x10bc8,
        0x10bd0,
        0x10bde,
        0x10be6,
        0x10bec,
        0x10c2e,
        0x10c4e,
        0x10c5c,
        0x10c62,
        0x10c64,
        0x10c68,
        0x10c76,
        0x10c8e,
        0x10c9c,
        0x10cb8,
        0x10cc2,
        0x10cc4,
        0x10cc8,
        0x10cd0,
        0x10cde,
        0x10ce6,
        0x10cec,
        0x10cfa,
        0x10d0e,
        0x10d1c,
        0x10d38,
        0x10d70,
        0x10d7e,
        0x10d82,
        0x10d84,
        0x10d88,
        0x10d90,
        0x10d9e,
        0x10da0,
        0x10dbc,
        0x10dc6,
        0x10dcc,
        0x10dd8,
        0x10dee,
        0x10df2,
        0x10df4,
        0x10e16,
        0x10e26,
        0x10e2c,
        0x10e46,
        0x10e58,
        0x10e6e,
        0x10e86,
        0x10e8c,
        0x10e98,
        0x10eb0,
        0x10ebe,
        0x10ece,
        0x10edc,
        0x10f0a,
        0x10f12,
        0x10f14,
        0x10f22,
        0x10f28,
        0x10f36,
        0x10f42,
        0x10f44,
        0x10f48,
        0x10f50,
        0x10f5e,
        0x10f66,
        0x10f6c,
        0x10fb2,
        0x10fb4,
        0x11022,
        0x11028,
        0x11042,
        0x11048,
        0x11050,
        0x1105e,
        0x1107a,
        0x11082,
        0x11084,
        0x11090,
        0x1109e,
        0x110a0,
        0x110bc,
        0x110c6,
        0x110cc,
        0x110d8,
        0x110ee,
        0x110f2,
        0x110f4,
        0x11102,
        0x1111e,
        0x11120,
        0x1113c,
        0x11140,
        0x11178,
        0x11186,
        0x11198,
        0x111b0,
        0x111be,
        0x111ce,
        0x111dc,
        0x111e2,
        0x111e4,
        0x111e8,
        0x111f6,
        0x11208,
        0x1121e,
        0x11220,
        0x11278,
        0x112f0,
        0x1130c,
        0x11330,
        0x1133e,
        0x11360,
        0x1137c,
        0x1138e,
        0x1139c,
        0x113b8,
        0x113c2,
        0x113c8,
        0x113d0,
        0x113de,
        0x113e6,
        0x113ec,
        0x11408,
        0x11410,
        0x1141e,
        0x11420,
        0x1143c,
        0x11440,
        0x11478,
        0x114f0,
        0x115e0,
        0x1160c,
        0x11618,
        0x11630,
        0x1163e,
        0x11660,
        0x1167c,
        0x116c0,
        0x116f8,
        0x1171c,
        0x11738,
        0x11770,
        0x1177e,
        0x11782,
        0x11784,
        0x11788,
        0x11790,
        0x1179e,
        0x117a0,
        0x117bc,
        0x117c6,
        0x117cc,
        0x117d8,
        0x117ee,
        0x1182e,
        0x11834,
        0x1184e,
        0x1185c,
        0x11862,
        0x11864,
        0x11868,
        0x11876,
        0x1188e,
        0x1189c,
        0x118b8,
        0x118c2,
        0x118c8,
        0x118d0,
        0x118de,
        0x118e6,
        0x118ec,
        0x118fa,
        0x1190e,
        0x1191c,
        0x11938,
        0x11970,
        0x1197e,
        0x11982,
        0x11984,
        0x11990,
        0x1199e,
        0x119a0,
        0x119bc,
        0x119c6,
        0x119cc,
        0x119d8,
        0x119ee,
        0x119f2,
        0x119f4,
        0x11a0e,
        0x11a1c,
        0x11a38,
        0x11a70,
        0x11a7e,
        0x11ae0,
        0x11afc,
        0x11b08,
        0x11b10,
        0x11b1e,
        0x11b20,
        0x11b3c,
        0x11b40,
        0x11b78,
        0x11b8c,
        0x11b98,
        0x11bb0,
        0x11bbe,
        0x11bce,
        0x11bdc,
        0x11be2,
        0x11be4,
        0x11be8,
        0x11bf6,
        0x11c16,
        0x11c26,
        0x11c2c,
        0x11c46,
        0x11c4c,
        0x11c58,
        0x11c6e,
        0x11c86,
        0x11c98,
        0x11cb0,
        0x11cbe,
        0x11cce,
        0x11cdc,
        0x11ce2,
        0x11ce4,
        0x11ce8,
        0x11cf6,
        0x11d06,
        0x11d0c,
        0x11d18,
        0x11d30,
        0x11d3e,
        0x11d60,
        0x11d7c,
        0x11d8e,
        0x11d9c,
        0x11db8,
        0x11dc4,
        0x11dc8,
        0x11dd0,
        0x11dde,
        0x11de6,
        0x11dec,
        0x11dfa,
        0x11e0a,
        0x11e12,
        0x11e14,
        0x11e22,
        0x11e24,
        0x11e28,
        0x11e36,
        0x11e42,
        0x11e44,
        0x11e50,
        0x11e5e,
        0x11e66,
        0x11e6c,
        0x11e82,
        0x11e84,
        0x11e88,
        0x11e90,
        0x11e9e,
        0x11ea0,
        0x11ebc,
        0x11ec6,
        0x11ecc,
        0x11ed8,
        0x11eee,
        0x11f1a,
        0x11f2e,
        0x11f32,
        0x11f34,
        0x11f4e,
        0x11f5c,
        0x11f62,
        0x11f64,
        0x11f68,
        0x11f76,
        0x12048,
        0x1205e,
        0x12082,
        0x12084,
        0x12090,
        0x1209e,
        0x120a0,
        0x120bc,
        0x120d8,
        0x120f2,
        0x120f4,
        0x12108,
        0x1211e,
        0x12120,
        0x1213c,
        0x12140,
        0x12178,
        0x12186,
        0x12198,
        0x121b0,
        0x121be,
        0x121e2,
        0x121e4,
        0x121e8,
        0x121f6,
        0x12204,
        0x12210,
        0x1221e,
        0x12220,
        0x12278,
        0x122f0,
        0x12306,
        0x1230c,
        0x12330,
        0x1233e,
        0x12360,
        0x1237c,
        0x1238e,
        0x1239c,
        0x123b8,
        0x123c2,
        0x123c8,
        0x123d0,
        0x123e6,
        0x123ec,
        0x1241e,
        0x12420,
        0x1243c,
        0x124f0,
        0x125e0,
        0x12618,
        0x1263e,
        0x12660,
        0x1267c,
        0x126c0,
        0x126f8,
        0x12738,
        0x12770,
        0x1277e,
        0x12782,
        0x12784,
        0x12790,
        0x1279e,
        0x127a0,
        0x127bc,
        0x127c6,
        0x127cc,
        0x127d8,
        0x127ee,
        0x12820,
        0x1283c,
        0x12840,
        0x12878,
        0x128f0,
        0x129e0,
        0x12bc0,
        0x12c18,
        0x12c30,
        0x12c3e,
        0x12c60,
        0x12c7c,
        0x12cc0,
        0x12cf8,
        0x12df0,
        0x12e1c,
        0x12e38,
        0x12e70,
        0x12e7e,
        0x12ee0,
        0x12efc,
        0x12f04,
        0x12f08,
        0x12f10,
        0x12f20,
        0x12f3c,
        0x12f40,
        0x12f78,
        0x12f86,
        0x12f8c,
        0x12f98,
        0x12fb0,
        0x12fbe,
        0x12fce,
        0x12fdc,
        0x1302e,
        0x1304e,
        0x1305c,
        0x13062,
        0x13068,
        0x1308e,
        0x1309c,
        0x130b8,
        0x130c2,
        0x130c8,
        0x130d0,
        0x130de,
        0x130ec,
        0x130fa,
        0x1310e,
        0x13138,
        0x13170,
        0x1317e,
        0x13182,
        0x13184,
        0x13190,
        0x1319e,
        0x131a0,
        0x131bc,
        0x131c6,
        0x131cc,
        0x131d8,
        0x131f2,
        0x131f4,
        0x1320e,
        0x1321c,
        0x13270,
        0x1327e,
        0x132e0,
        0x132fc,
        0x13308,
        0x1331e,
        0x13320,
        0x1333c,
        0x13340,
        0x13378,
        0x13386,
        0x13398,
        0x133b0,
        0x133be,
        0x133ce,
        0x133dc,
        0x133e2,
        0x133e4,
        0x133e8,
        0x133f6,
        0x1340e,
        0x1341c,
        0x13438,
        0x13470,
        0x1347e,
        0x134e0,
        0x134fc,
        0x135c0,
        0x135f8,
        0x13608,
        0x13610,
        0x1361e,
        0x13620,
        0x1363c,
        0x13640,
        0x13678,
        0x136f0,
        0x1370c,
        0x13718,
        0x13730,
        0x1373e,
        0x13760,
        0x1377c,
        0x1379c,
        0x137b8,
        0x137c2,
        0x137c4,
        0x137c8,
        0x137d0,
        0x137de,
        0x137e6,
        0x137ec,
        0x13816,
        0x13826,
        0x1382c,
        0x13846,
        0x1384c,
        0x13858,
        0x1386e,
        0x13874,
        0x13886,
        0x13898,
        0x138b0,
        0x138be,
        0x138ce,
        0x138dc,
        0x138e2,
        0x138e4,
        0x138e8,
        0x13906,
        0x1390c,
        0x13930,
        0x1393e,
        0x13960,
        0x1397c,
        0x1398e,
        0x1399c,
        0x139b8,
        0x139c8,
        0x139d0,
        0x139de,
        0x139e6,
        0x139ec,
        0x139fa,
        0x13a06,
        0x13a0c,
        0x13a18,
        0x13a30,
        0x13a3e,
        0x13a60,
        0x13a7c,
        0x13ac0,
        0x13af8,
        0x13b0e,
        0x13b1c,
        0x13b38,
        0x13b70,
        0x13b7e,
        0x13b88,
        0x13b90,
        0x13b9e,
        0x13ba0,
        0x13bbc,
        0x13bcc,
        0x13bd8,
        0x13bee,
        0x13bf2,
        0x13bf4,
        0x13c12,
        0x13c14,
        0x13c22,
        0x13c24,
        0x13c28,
        0x13c36,
        0x13c42,
        0x13c48,
        0x13c50,
        0x13c5e,
        0x13c66,
        0x13c6c,
        0x13c82,
        0x13c84,
        0x13c90,
        0x13c9e,
        0x13ca0,
        0x13cbc,
        0x13cc6,
        0x13ccc,
        0x13cd8,
        0x13cee,
        0x13d02,
        0x13d04,
        0x13d08,
        0x13d10,
        0x13d1e,
        0x13d20,
        0x13d3c,
        0x13d40,
        0x13d78,
        0x13d86,
        0x13d8c,
        0x13d98,
        0x13db0,
        0x13dbe,
        0x13dce,
        0x13ddc,
        0x13de4,
        0x13de8,
        0x13df6,
        0x13e1a,
        0x13e2e,
        0x13e32,
        0x13e34,
        0x13e4e,
        0x13e5c,
        0x13e62,
        0x13e64,
        0x13e68,
        0x13e76,
        0x13e8e,
        0x13e9c,
        0x13eb8,
        0x13ec2,
        0x13ec4,
        0x13ec8,
        0x13ed0,
        0x13ede,
        0x13ee6,
        0x13eec,
        0x13f26,
        0x13f2c,
        0x13f3a,
        0x13f46,
        0x13f4c,
        0x13f58,
        0x13f6e,
        0x13f72,
        0x13f74,
        0x14082,
        0x1409e,
        0x140a0,
        0x140bc,
        0x14104,
        0x14108,
        0x14110,
        0x1411e,
        0x14120,
        0x1413c,
        0x14140,
        0x14178,
        0x1418c,
        0x14198,
        0x141b0,
        0x141be,
        0x141e2,
        0x141e4,
        0x141e8,
        0x14208,
        0x14210,
        0x1421e,
        0x14220,
        0x1423c,
        0x14240,
        0x14278,
        0x142f0,
        0x14306,
        0x1430c,
        0x14318,
        0x14330,
        0x1433e,
        0x14360,
        0x1437c,
        0x1438e,
        0x143c2,
        0x143c4,
        0x143c8,
        0x143d0,
        0x143e6,
        0x143ec,
        0x14408,
        0x14410,
        0x1441e,
        0x14420,
        0x1443c,
        0x14440,
        0x14478,
        0x144f0,
        0x145e0,
        0x1460c,
        0x14618,
        0x14630,
        0x1463e,
        0x14660,
        0x1467c,
        0x146c0,
        0x146f8,
        0x1471c,
        0x14738,
        0x14770,
        0x1477e,
        0x14782,
        0x14784,
        0x14788,
        0x14790,
        0x147a0,
        0x147bc,
        0x147c6,
        0x147cc,
        0x147d8,
        0x147ee,
        0x14810,
        0x14820,
        0x1483c,
        0x14840,
        0x14878,
        0x148f0,
        0x149e0,
        0x14bc0,
        0x14c30,
        0x14c3e,
        0x14c60,
        0x14c7c,
        0x14cc0,
        0x14cf8,
        0x14df0,
        0x14e38,
        0x14e70,
        0x14e7e,
        0x14ee0,
        0x14efc,
        0x14f04,
        0x14f08,
        0x14f10,
        0x14f1e,
        0x14f20,
        0x14f3c,
        0x14f40,
        0x14f78,
        0x14f86,
        0x14f8c,
        0x14f98,
        0x14fb0,
        0x14fce,
        0x14fdc,
        0x15020,
        0x15040,
        0x15078,
        0x150f0,
        0x151e0,
        0x153c0,
        0x15860,
        0x1587c,
        0x158c0,
        0x158f8,
        0x159f0,
        0x15be0,
        0x15c70,
        0x15c7e,
        0x15ce0,
        0x15cfc,
        0x15dc0,
        0x15df8,
        0x15e08,
        0x15e10,
        0x15e20,
        0x15e40,
        0x15e78,
        0x15ef0,
        0x15f0c,
        0x15f18,
        0x15f30,
        0x15f60,
        0x15f7c,
        0x15f8e,
        0x15f9c,
        0x15fb8,
        0x1604e,
        0x1605c,
        0x1608e,
        0x1609c,
        0x160b8,
        0x160c2,
        0x160c4,
        0x160c8,
        0x160de,
        0x1610e,
        0x1611c,
        0x16138,
        0x16170,
        0x1617e,
        0x16184,
        0x16188,
        0x16190,
        0x1619e,
        0x161a0,
        0x161bc,
        0x161c6,
        0x161cc,
        0x161d8,
        0x161f2,
        0x161f4,
        0x1620e,
        0x1621c,
        0x16238,
        0x16270,
        0x1627e,
        0x162e0,
        0x162fc,
        0x16304,
        0x16308,
        0x16310,
        0x1631e,
        0x16320,
        0x1633c,
        0x16340,
        0x16378,
        0x16386,
        0x1638c,
        0x16398,
        0x163b0,
        0x163be,
        0x163ce,
        0x163dc,
        0x163e2,
        0x163e4,
        0x163e8,
        0x163f6,
        0x1640e,
        0x1641c,
        0x16438,
        0x16470,
        0x1647e,
        0x164e0,
        0x164fc,
        0x165c0,
        0x165f8,
        0x16610,
        0x1661e,
        0x16620,
        0x1663c,
        0x16640,
        0x16678,
        0x166f0,
        0x16718,
        0x16730,
        0x1673e,
        0x16760,
        0x1677c,
        0x1678e,
        0x1679c,
        0x167b8,
        0x167c2,
        0x167c4,
        0x167c8,
        0x167d0,
        0x167de,
        0x167e6,
        0x167ec,
        0x1681c,
        0x16838,
        0x16870,
        0x168e0,
        0x168fc,
        0x169c0,
        0x169f8,
        0x16bf0,
        0x16c10,
        0x16c1e,
        0x16c20,
        0x16c3c,
        0x16c40,
        0x16c78,
        0x16cf0,
        0x16de0,
        0x16e18,
        0x16e30,
        0x16e3e,
        0x16e60,
        0x16e7c,
        0x16ec0,
        0x16ef8,
        0x16f1c,
        0x16f38,
        0x16f70,
        0x16f7e,
        0x16f84,
        0x16f88,
        0x16f90,
        0x16f9e,
        0x16fa0,
        0x16fbc,
        0x16fc6,
        0x16fcc,
        0x16fd8,
        0x17026,
        0x1702c,
        0x17046,
        0x1704c,
        0x17058,
        0x1706e,
        0x17086,
        0x1708c,
        0x17098,
        0x170b0,
        0x170be,
        0x170ce,
        0x170dc,
        0x170e8,
        0x17106,
        0x1710c,
        0x17118,
        0x17130,
        0x1713e,
        0x17160,
        0x1717c,
        0x1718e,
        0x1719c,
        0x171b8,
        0x171c2,
        0x171c4,
        0x171c8,
        0x171d0,
        0x171de,
        0x171e6,
        0x171ec,
        0x171fa,
        0x17206,
        0x1720c,
        0x17218,
        0x17230,
        0x1723e,
        0x17260,
        0x1727c,
        0x172c0,
        0x172f8,
        0x1730e,
        0x1731c,
        0x17338,
        0x17370,
        0x1737e,
        0x17388,
        0x17390,
        0x1739e,
        0x173a0,
        0x173bc,
        0x173cc,
        0x173d8,
        0x173ee,
        0x173f2,
        0x173f4,
        0x1740c,
        0x17418,
        0x17430,
        0x1743e,
        0x17460,
        0x1747c,
        0x174c0,
        0x174f8,
        0x175f0,
        0x1760e,
        0x1761c,
        0x17638,
        0x17670,
        0x1767e,
        0x176e0,
        0x176fc,
        0x17708,
        0x17710,
        0x1771e,
        0x17720,
        0x1773c,
        0x17740,
        0x17778,
        0x17798,
        0x177b0,
        0x177be,
        0x177dc,
        0x177e2,
        0x177e4,
        0x177e8,
        0x17822,
        0x17824,
        0x17828,
        0x17836,
        0x17842,
        0x17844,
        0x17848,
        0x17850,
        0x1785e,
        0x17866,
        0x1786c,
        0x17882,
        0x17884,
        0x17888,
        0x17890,
        0x1789e,
        0x178a0,
        0x178bc,
        0x178c6,
        0x178cc,
        0x178d8,
        0x178ee,
        0x178f2,
        0x178f4,
        0x17902,
        0x17904,
        0x17908,
        0x17910,
        0x1791e,
        0x17920,
        0x1793c,
        0x17940,
        0x17978,
        0x17986,
        0x1798c,
        0x17998,
        0x179b0,
        0x179be,
        0x179ce,
        0x179dc,
        0x179e2,
        0x179e4,
        0x179e8,
        0x179f6,
        0x17a04,
        0x17a08,
        0x17a10,
        0x17a1e,
        0x17a20,
        0x17a3c,
        0x17a40,
        0x17a78,
        0x17af0,
        0x17b06,
        0x17b0c,
        0x17b18,
        0x17b30,
        0x17b3e,
        0x17b60,
        0x17b7c,
        0x17b8e,
        0x17b9c,
        0x17bb8,
        0x17bc4,
        0x17bc8,
        0x17bd0,
        0x17bde,
        0x17be6,
        0x17bec,
        0x17c2e,
        0x17c32,
        0x17c34,
        0x17c4e,
        0x17c5c,
        0x17c62,
        0x17c64,
        0x17c68,
        0x17c76,
        0x17c8e,
        0x17c9c,
        0x17cb8,
        0x17cc2,
        0x17cc4,
        0x17cc8,
        0x17cd0,
        0x17cde,
        0x17ce6,
        0x17cec,
        0x17d0e,
        0x17d1c,
        0x17d38,
        0x17d70,
        0x17d82,
        0x17d84,
        0x17d88,
        0x17d90,
        0x17d9e,
        0x17da0,
        0x17dbc,
        0x17dc6,
        0x17dcc,
        0x17dd8,
        0x17dee,
        0x17e26,
        0x17e2c,
        0x17e3a,
        0x17e46,
        0x17e4c,
        0x17e58,
        0x17e6e,
        0x17e72,
        0x17e74,
        0x17e86,
        0x17e8c,
        0x17e98,
        0x17eb0,
        0x17ece,
        0x17edc,
        0x17ee2,
        0x17ee4,
        0x17ee8,
        0x17ef6,
        0x1813a,
        0x18172,
        0x18174,
        0x18216,
        0x18226,
        0x1823a,
        0x1824c,
        0x18258,
        0x1826e,
        0x18272,
        0x18274,
        0x18298,
        0x182be,
        0x182e2,
        0x182e4,
        0x182e8,
        0x182f6,
        0x1835e,
        0x1837a,
        0x183ae,
        0x183d6,
        0x18416,
        0x18426,
        0x1842c,
        0x1843a,
        0x18446,
        0x18458,
        0x1846e,
        0x18472,
        0x18474,
        0x18486,
        0x184b0,
        0x184be,
        0x184ce,
        0x184dc,
        0x184e2,
        0x184e4,
        0x184e8,
        0x184f6,
        0x18506,
        0x1850c,
        0x18518,
        0x18530,
        0x1853e,
        0x18560,
        0x1857c,
        0x1858e,
        0x1859c,
        0x185b8,
        0x185c2,
        0x185c4,
        0x185c8,
        0x185d0,
        0x185de,
        0x185e6,
        0x185ec,
        0x185fa,
        0x18612,
        0x18614,
        0x18622,
        0x18628,
        0x18636,
        0x18642,
        0x18650,
        0x1865e,
        0x1867a,
        0x18682,
        0x18684,
        0x18688,
        0x18690,
        0x1869e,
        0x186a0,
        0x186bc,
        0x186c6,
        0x186cc,
        0x186d8,
        0x186ee,
        0x186f2,
        0x186f4,
        0x1872e,
        0x1874e,
        0x1875c,
        0x18796,
        0x187a6,
        0x187ac,
        0x187d2,
        0x187d4,
        0x18826,
        0x1882c,
        0x1883a,
        0x18846,
        0x1884c,
        0x18858,
        0x1886e,
        0x18872,
        0x18874,
        0x18886,
        0x18898,
        0x188b0,
        0x188be,
        0x188ce,
        0x188dc,
        0x188e2,
        0x188e4,
        0x188e8,
        0x188f6,
        0x1890c,
        0x18930,
        0x1893e,
        0x18960,
        0x1897c,
        0x1898e,
        0x189b8,
        0x189c2,
        0x189c8,
        0x189d0,
        0x189de,
        0x189e6,
        0x189ec,
        0x189fa,
        0x18a18,
        0x18a30,
        0x18a3e,
        0x18a60,
        0x18a7c,
        0x18ac0,
        0x18af8,
        0x18b1c,
        0x18b38,
        0x18b70,
        0x18b7e,
        0x18b82,
        0x18b84,
        0x18b88,
        0x18b90,
        0x18b9e,
        0x18ba0,
        0x18bbc,
        0x18bc6,
        0x18bcc,
        0x18bd8,
        0x18bee,
        0x18bf2,
        0x18bf4,
        0x18c22,
        0x18c24,
        0x18c28,
        0x18c36,
        0x18c42,
        0x18c48,
        0x18c50,
        0x18c5e,
        0x18c66,
        0x18c7a,
        0x18c82,
        0x18c84,
        0x18c90,
        0x18c9e,
        0x18ca0,
        0x18cbc,
        0x18ccc,
        0x18cf2,
        0x18cf4,
        0x18d04,
        0x18d08,
        0x18d10,
        0x18d1e,
        0x18d20,
        0x18d3c,
        0x18d40,
        0x18d78,
        0x18d86,
        0x18d98,
        0x18dce,
        0x18de2,
        0x18de4,
        0x18de8,
        0x18e2e,
        0x18e32,
        0x18e34,
        0x18e4e,
        0x18e5c,
        0x18e62,
        0x18e64,
        0x18e68,
        0x18e8e,
        0x18e9c,
        0x18eb8,
        0x18ec2,
        0x18ec4,
        0x18ec8,
        0x18ed0,
        0x18efa,
        0x18f16,
        0x18f26,
        0x18f2c,
        0x18f46,
        0x18f4c,
        0x18f58,
        0x18f6e,
        0x18f8a,
        0x18f92,
        0x18f94,
        0x18fa2,
        0x18fa4,
        0x18fa8,
        0x18fb6,
        0x1902c,
        0x1903a,
        0x19046,
        0x1904c,
        0x19058,
        0x19072,
        0x19074,
        0x19086,
        0x19098,
        0x190b0,
        0x190be,
        0x190ce,
        0x190dc,
        0x190e2,
        0x190e8,
        0x190f6,
        0x19106,
        0x1910c,
        0x19130,
        0x1913e,
        0x19160,
        0x1917c,
        0x1918e,
        0x1919c,
        0x191b8,
        0x191c2,
        0x191c8,
        0x191d0,
        0x191de,
        0x191e6,
        0x191ec,
        0x191fa,
        0x19218,
        0x1923e,
        0x19260,
        0x1927c,
        0x192c0,
        0x192f8,
        0x19338,
        0x19370,
        0x1937e,
        0x19382,
        0x19384,
        0x19390,
        0x1939e,
        0x193a0,
        0x193bc,
        0x193c6,
        0x193cc,
        0x193d8,
        0x193ee,
        0x193f2,
        0x193f4,
        0x19430,
        0x1943e,
        0x19460,
        0x1947c,
        0x194c0,
        0x194f8,
        0x195f0,
        0x19638,
        0x19670,
        0x1967e,
        0x196e0,
        0x196fc,
        0x19702,
        0x19704,
        0x19708,
        0x19710,
        0x19720,
        0x1973c,
        0x19740,
        0x19778,
        0x19786,
        0x1978c,
        0x19798,
        0x197b0,
        0x197be,
        0x197ce,
        0x197dc,
        0x197e2,
        0x197e4,
        0x197e8,
        0x19822,
        0x19824,
        0x19842,
        0x19848,
        0x19850,
        0x1985e,
        0x19866,
        0x1987a,
        0x19882,
        0x19884,
        0x19890,
        0x1989e,
        0x198a0,
        0x198bc,
        0x198cc,
        0x198f2,
        0x198f4,
        0x19902,
        0x19908,
        0x1991e,
        0x19920,
        0x1993c,
        0x19940,
        0x19978,
        0x19986,
        0x19998,
        0x199ce,
        0x199e2,
        0x199e4,
        0x199e8,
        0x19a08,
        0x19a10,
        0x19a1e,
        0x19a20,
        0x19a3c,
        0x19a40,
        0x19a78,
        0x19af0,
        0x19b18,
        0x19b3e,
        0x19b60,
        0x19b9c,
        0x19bc2,
        0x19bc4,
        0x19bc8,
        0x19bd0,
        0x19be6,
        0x19c2e,
        0x19c34,
        0x19c4e,
        0x19c5c,
        0x19c62,
        0x19c64,
        0x19c68,
        0x19c8e,
        0x19c9c,
        0x19cb8,
        0x19cc2,
        0x19cc8,
        0x19cd0,
        0x19ce6,
        0x19cfa,
        0x19d0e,
        0x19d1c,
        0x19d38,
        0x19d70,
        0x19d7e,
        0x19d82,
        0x19d84,
        0x19d88,
        0x19d90,
        0x19da0,
        0x19dcc,
        0x19df2,
        0x19df4,
        0x19e16,
        0x19e26,
        0x19e2c,
        0x19e46,
        0x19e4c,
        0x19e58,
        0x19e74,
        0x19e86,
        0x19e8c,
        0x19e98,
        0x19eb0,
        0x19ebe,
        0x19ece,
        0x19ee2,
        0x19ee4,
        0x19ee8,
        0x19f0a,
        0x19f12,
        0x19f14,
        0x19f22,
        0x19f24,
        0x19f28,
        0x19f42,
        0x19f44,
        0x19f48,
        0x19f50,
        0x19f5e,
        0x19f6c,
        0x19f9a,
        0x19fae,
        0x19fb2,
        0x19fb4,
        0x1a046,
        0x1a04c,
        0x1a072,
        0x1a074,
        0x1a086,
        0x1a08c,
        0x1a098,
        0x1a0b0,
        0x1a0be,
        0x1a0e2,
        0x1a0e4,
        0x1a0e8,
        0x1a0f6,
        0x1a106,
        0x1a10c,
        0x1a118,
        0x1a130,
        0x1a13e,
        0x1a160,
        0x1a17c,
        0x1a18e,
        0x1a19c,
        0x1a1b8,
        0x1a1c2,
        0x1a1c4,
        0x1a1c8,
        0x1a1d0,
        0x1a1de,
        0x1a1e6,
        0x1a1ec,
        0x1a218,
        0x1a230,
        0x1a23e,
        0x1a260,
        0x1a27c,
        0x1a2c0,
        0x1a2f8,
        0x1a31c,
        0x1a338,
        0x1a370,
        0x1a37e,
        0x1a382,
        0x1a384,
        0x1a388,
        0x1a390,
        0x1a39e,
        0x1a3a0,
        0x1a3bc,
        0x1a3c6,
        0x1a3cc,
        0x1a3d8,
        0x1a3ee,
        0x1a3f2,
        0x1a3f4,
        0x1a418,
        0x1a430,
        0x1a43e,
        0x1a460,
        0x1a47c,
        0x1a4c0,
        0x1a4f8,
        0x1a5f0,
        0x1a61c,
        0x1a638,
        0x1a670,
        0x1a67e,
        0x1a6e0,
        0x1a6fc,
        0x1a702,
        0x1a704,
        0x1a708,
        0x1a710,
        0x1a71e,
        0x1a720,
        0x1a73c,
        0x1a740,
        0x1a778,
        0x1a786,
        0x1a78c,
        0x1a798,
        0x1a7b0,
        0x1a7be,
        0x1a7ce,
        0x1a7dc,
        0x1a7e2,
        0x1a7e4,
        0x1a7e8,
        0x1a830,
        0x1a860,
        0x1a87c,
        0x1a8c0,
        0x1a8f8,
        0x1a9f0,
        0x1abe0,
        0x1ac70,
        0x1ac7e,
        0x1ace0,
        0x1acfc,
        0x1adc0,
        0x1adf8,
        0x1ae04,
        0x1ae08,
        0x1ae10,
        0x1ae20,
        0x1ae3c,
        0x1ae40,
        0x1ae78,
        0x1aef0,
        0x1af06,
        0x1af0c,
        0x1af18,
        0x1af30,
        0x1af3e,
        0x1af60,
        0x1af7c,
        0x1af8e,
        0x1af9c,
        0x1afb8,
        0x1afc4,
        0x1afc8,
        0x1afd0,
        0x1afde,
        0x1b042,
        0x1b05e,
        0x1b07a,
        0x1b082,
        0x1b084,
        0x1b088,
        0x1b090,
        0x1b09e,
        0x1b0a0,
        0x1b0bc,
        0x1b0cc,
        0x1b0f2,
        0x1b0f4,
        0x1b102,
        0x1b104,
        0x1b108,
        0x1b110,
        0x1b11e,
        0x1b120,
        0x1b13c,
        0x1b140,
        0x1b178,
        0x1b186,
        0x1b198,
        0x1b1ce,
        0x1b1e2,
        0x1b1e4,
        0x1b1e8,
        0x1b204,
        0x1b208,
        0x1b210,
        0x1b21e,
        0x1b220,
        0x1b23c,
        0x1b240,
        0x1b278,
        0x1b2f0,
        0x1b30c,
        0x1b33e,
        0x1b360,
        0x1b39c,
        0x1b3c2,
        0x1b3c4,
        0x1b3c8,
        0x1b3d0,
        0x1b3e6,
        0x1b410,
        0x1b41e,
        0x1b420,
        0x1b43c,
        0x1b440,
        0x1b478,
        0x1b4f0,
        0x1b5e0,
        0x1b618,
        0x1b660,
        0x1b67c,
        0x1b6c0,
        0x1b738,
        0x1b782,
        0x1b784,
        0x1b788,
        0x1b790,
        0x1b79e,
        0x1b7a0,
        0x1b7cc,
        0x1b82e,
        0x1b84e,
        0x1b85c,
        0x1b88e,
        0x1b89c,
        0x1b8b8,
        0x1b8c2,
        0x1b8c4,
        0x1b8c8,
        0x1b8d0,
        0x1b8e6,
        0x1b8fa,
        0x1b90e,
        0x1b91c,
        0x1b938,
        0x1b970,
        0x1b97e,
        0x1b982,
        0x1b984,
        0x1b988,
        0x1b990,
        0x1b99e,
        0x1b9a0,
        0x1b9cc,
        0x1b9f2,
        0x1b9f4,
        0x1ba0e,
        0x1ba1c,
        0x1ba38,
        0x1ba70,
        0x1ba7e,
        0x1bae0,
        0x1bafc,
        0x1bb08,
        0x1bb10,
        0x1bb20,
        0x1bb3c,
        0x1bb40,
        0x1bb98,
        0x1bbce,
        0x1bbe2,
        0x1bbe4,
        0x1bbe8,
        0x1bc16,
        0x1bc26,
        0x1bc2c,
        0x1bc46,
        0x1bc4c,
        0x1bc58,
        0x1bc72,
        0x1bc74,
        0x1bc86,
        0x1bc8c,
        0x1bc98,
        0x1bcb0,
        0x1bcbe,
        0x1bcce,
        0x1bce2,
        0x1bce4,
        0x1bce8,
        0x1bd06,
        0x1bd0c,
        0x1bd18,
        0x1bd30,
        0x1bd3e,
        0x1bd60,
        0x1bd7c,
        0x1bd9c,
        0x1bdc2,
        0x1bdc4,
        0x1bdc8,
        0x1bdd0,
        0x1bde6,
        0x1bdfa,
        0x1be12,
        0x1be14,
        0x1be22,
        0x1be24,
        0x1be28,
        0x1be42,
        0x1be44,
        0x1be48,
        0x1be50,
        0x1be5e,
        0x1be66,
        0x1be82,
        0x1be84,
        0x1be88,
        0x1be90,
        0x1be9e,
        0x1bea0,
        0x1bebc,
        0x1becc,
        0x1bef4,
        0x1bf1a,
        0x1bf2e,
        0x1bf32,
        0x1bf34,
        0x1bf4e,
        0x1bf5c,
        0x1bf62,
        0x1bf64,
        0x1bf68,
        0x1c09a,
        0x1c0b2,
        0x1c0b4,
        0x1c11a,
        0x1c132,
        0x1c134,
        0x1c162,
        0x1c164,
        0x1c168,
        0x1c176,
        0x1c1ba,
        0x1c21a,
        0x1c232,
        0x1c234,
        0x1c24e,
        0x1c25c,
        0x1c262,
        0x1c264,
        0x1c268,
        0x1c276,
        0x1c28e,
        0x1c2c2,
        0x1c2c4,
        0x1c2c8,
        0x1c2d0,
        0x1c2de,
        0x1c2e6,
        0x1c2ec,
        0x1c2fa,
        0x1c316,
        0x1c326,
        0x1c33a,
        0x1c346,
        0x1c34c,
        0x1c372,
        0x1c374,
        0x1c41a,
        0x1c42e,
        0x1c432,
        0x1c434,
        0x1c44e,
        0x1c45c,
        0x1c462,
        0x1c464,
        0x1c468,
        0x1c476,
        0x1c48e,
        0x1c49c,
        0x1c4b8,
        0x1c4c2,
        0x1c4c8,
        0x1c4d0,
        0x1c4de,
        0x1c4e6,
        0x1c4ec,
        0x1c4fa,
        0x1c51c,
        0x1c538,
        0x1c570,
        0x1c57e,
        0x1c582,
        0x1c584,
        0x1c588,
        0x1c590,
        0x1c59e,
        0x1c5a0,
        0x1c5bc,
        0x1c5c6,
        0x1c5cc,
        0x1c5d8,
        0x1c5ee,
        0x1c5f2,
        0x1c5f4,
        0x1c616,
        0x1c626,
        0x1c62c,
        0x1c63a,
        0x1c646,
        0x1c64c,
        0x1c658,
        0x1c66e,
        0x1c672,
        0x1c674,
        0x1c686,
        0x1c68c,
        0x1c698,
        0x1c6b0,
        0x1c6be,
        0x1c6ce,
        0x1c6dc,
        0x1c6e2,
        0x1c6e4,
        0x1c6e8,
        0x1c712,
        0x1c714,
        0x1c722,
        0x1c728,
        0x1c736,
        0x1c742,
        0x1c744,
        0x1c748,
        0x1c750,
        0x1c75e,
        0x1c766,
        0x1c76c,
        0x1c77a,
        0x1c7ae,
        0x1c7d6,
        0x1c7ea,
        0x1c81a,
        0x1c82e,
        0x1c832,
        0x1c834,
        0x1c84e,
        0x1c85c,
        0x1c862,
        0x1c864,
        0x1c868,
        0x1c876,
        0x1c88e,
        0x1c89c,
        0x1c8b8,
        0x1c8c2,
        0x1c8c8,
        0x1c8d0,
        0x1c8de,
        0x1c8e6,
        0x1c8ec,
        0x1c8fa,
        0x1c90e,
        0x1c938,
        0x1c970,
        0x1c97e,
        0x1c982,
        0x1c984,
        0x1c990,
        0x1c99e,
        0x1c9a0,
        0x1c9bc,
        0x1c9c6,
        0x1c9cc,
        0x1c9d8,
        0x1c9ee,
        0x1c9f2,
        0x1c9f4,
        0x1ca38,
        0x1ca70,
        0x1ca7e,
        0x1cae0,
        0x1cafc,
        0x1cb02,
        0x1cb04,
        0x1cb08,
        0x1cb10,
        0x1cb20,
        0x1cb3c,
        0x1cb40,
        0x1cb78,
        0x1cb86,
        0x1cb8c,
        0x1cb98,
        0x1cbb0,
        0x1cbbe,
        0x1cbce,
        0x1cbdc,
        0x1cbe2,
        0x1cbe4,
        0x1cbe8,
        0x1cbf6,
        0x1cc16,
        0x1cc26,
        0x1cc2c,
        0x1cc3a,
        0x1cc46,
        0x1cc58,
        0x1cc72,
        0x1cc74,
        0x1cc86,
        0x1ccb0,
        0x1ccbe,
        0x1ccce,
        0x1cce2,
        0x1cce4,
        0x1cce8,
        0x1cd06,
        0x1cd0c,
        0x1cd18,
        0x1cd30,
        0x1cd3e,
        0x1cd60,
        0x1cd7c,
        0x1cd9c,
        0x1cdc2,
        0x1cdc4,
        0x1cdc8,
        0x1cdd0,
        0x1cdde,
        0x1cde6,
        0x1cdfa,
        0x1ce22,
        0x1ce28,
        0x1ce42,
        0x1ce50,
        0x1ce5e,
        0x1ce66,
        0x1ce7a,
        0x1ce82,
        0x1ce84,
        0x1ce88,
        0x1ce90,
        0x1ce9e,
        0x1cea0,
        0x1cebc,
        0x1cecc,
        0x1cef2,
        0x1cef4,
        0x1cf2e,
        0x1cf32,
        0x1cf34,
        0x1cf4e,
        0x1cf5c,
        0x1cf62,
        0x1cf64,
        0x1cf68,
        0x1cf96,
        0x1cfa6,
        0x1cfac,
        0x1cfca,
        0x1cfd2,
        0x1cfd4,
        0x1d02e,
        0x1d032,
        0x1d034,
        0x1d04e,
        0x1d05c,
        0x1d062,
        0x1d064,
        0x1d068,
        0x1d076,
        0x1d08e,
        0x1d09c,
        0x1d0b8,
        0x1d0c2,
        0x1d0c4,
        0x1d0c8,
        0x1d0d0,
        0x1d0de,
        0x1d0e6,
        0x1d0ec,
        0x1d0fa,
        0x1d11c,
        0x1d138,
        0x1d170,
        0x1d17e,
        0x1d182,
        0x1d184,
        0x1d188,
        0x1d190,
        0x1d19e,
        0x1d1a0,
        0x1d1bc,
        0x1d1c6,
        0x1d1cc,
        0x1d1d8,
        0x1d1ee,
        0x1d1f2,
        0x1d1f4,
        0x1d21c,
        0x1d238,
        0x1d270,
        0x1d27e,
        0x1d2e0,
        0x1d2fc,
        0x1d302,
        0x1d304,
        0x1d308,
        0x1d310,
        0x1d31e,
        0x1d320,
        0x1d33c,
        0x1d340,
        0x1d378,
        0x1d386,
        0x1d38c,
        0x1d398,
        0x1d3b0,
        0x1d3be,
        0x1d3ce,
        0x1d3dc,
        0x1d3e2,
        0x1d3e4,
        0x1d3e8,
        0x1d3f6,
        0x1d470,
        0x1d47e,
        0x1d4e0,
        0x1d4fc,
        0x1d5c0,
        0x1d5f8,
        0x1d604,
        0x1d608,
        0x1d610,
        0x1d620,
        0x1d640,
        0x1d678,
        0x1d6f0,
        0x1d706,
        0x1d70c,
        0x1d718,
        0x1d730,
        0x1d73e,
        0x1d760,
        0x1d77c,
        0x1d78e,
        0x1d79c,
        0x1d7b8,
        0x1d7c2,
        0x1d7c4,
        0x1d7c8,
        0x1d7d0,
        0x1d7de,
        0x1d7e6,
        0x1d7ec,
        0x1d826,
        0x1d82c,
        0x1d83a,
        0x1d846,
        0x1d84c,
        0x1d858,
        0x1d872,
        0x1d874,
        0x1d886,
        0x1d88c,
        0x1d898,
        0x1d8b0,
        0x1d8be,
        0x1d8ce,
        0x1d8e2,
        0x1d8e4,
        0x1d8e8,
        0x1d8f6,
        0x1d90c,
        0x1d918,
        0x1d930,
        0x1d93e,
        0x1d960,
        0x1d97c,
        0x1d99c,
        0x1d9c2,
        0x1d9c4,
        0x1d9c8,
        0x1d9d0,
        0x1d9e6,
        0x1d9fa,
        0x1da0c,
        0x1da18,
        0x1da30,
        0x1da3e,
        0x1da60,
        0x1da7c,
        0x1dac0,
        0x1daf8,
        0x1db38,
        0x1db82,
        0x1db84,
        0x1db88,
        0x1db90,
        0x1db9e,
        0x1dba0,
        0x1dbcc,
        0x1dbf2,
        0x1dbf4,
        0x1dc22,
        0x1dc42,
        0x1dc44,
        0x1dc48,
        0x1dc50,
        0x1dc5e,
        0x1dc66,
        0x1dc7a,
        0x1dc82,
        0x1dc84,
        0x1dc88,
        0x1dc90,
        0x1dc9e,
        0x1dca0,
        0x1dcbc,
        0x1dccc,
        0x1dcf2,
        0x1dcf4,
        0x1dd04,
        0x1dd08,
        0x1dd10,
        0x1dd1e,
        0x1dd20,
        0x1dd3c,
        0x1dd40,
        0x1dd78,
        0x1dd86,
        0x1dd98,
        0x1ddce,
        0x1dde2,
        0x1dde4,
        0x1dde8,
        0x1de2e,
        0x1de32,
        0x1de34,
        0x1de4e,
        0x1de5c,
        0x1de62,
        0x1de64,
        0x1de68,
        0x1de8e,
        0x1de9c,
        0x1deb8,
        0x1dec2,
        0x1dec4,
        0x1dec8,
        0x1ded0,
        0x1dee6,
        0x1defa,
        0x1df16,
        0x1df26,
        0x1df2c,
        0x1df46,
        0x1df4c,
        0x1df58,
        0x1df72,
        0x1df74,
        0x1df8a,
        0x1df92,
        0x1df94,
        0x1dfa2,
        0x1dfa4,
        0x1dfa8,
        0x1e08a,
        0x1e092,
        0x1e094,
        0x1e0a2,
        0x1e0a4,
        0x1e0a8,
        0x1e0b6,
        0x1e0da,
        0x1e10a,
        0x1e112,
        0x1e114,
        0x1e122,
        0x1e124,
        0x1e128,
        0x1e136,
        0x1e142,
        0x1e144,
        0x1e148,
        0x1e150,
        0x1e166,
        0x1e16c,
        0x1e17a,
        0x1e19a,
        0x1e1b2,
        0x1e1b4,
        0x1e20a,
        0x1e212,
        0x1e214,
        0x1e222,
        0x1e224,
        0x1e228,
        0x1e236,
        0x1e242,
        0x1e248,
        0x1e250,
        0x1e25e,
        0x1e266,
        0x1e26c,
        0x1e27a,
        0x1e282,
        0x1e284,
        0x1e288,
        0x1e290,
        0x1e2a0,
        0x1e2bc,
        0x1e2c6,
        0x1e2cc,
        0x1e2d8,
        0x1e2ee,
        0x1e2f2,
        0x1e2f4,
        0x1e31a,
        0x1e332,
        0x1e334,
        0x1e35c,
        0x1e362,
        0x1e364,
        0x1e368,
        0x1e3ba,
        0x1e40a,
        0x1e412,
        0x1e414,
        0x1e422,
        0x1e428,
        0x1e436,
        0x1e442,
        0x1e448,
        0x1e450,
        0x1e45e,
        0x1e466,
        0x1e46c,
        0x1e47a,
        0x1e482,
        0x1e484,
        0x1e490,
        0x1e49e,
        0x1e4a0,
        0x1e4bc,
        0x1e4c6,
        0x1e4cc,
        0x1e4d8,
        0x1e4ee,
        0x1e4f2,
        0x1e4f4,
        0x1e502,
        0x1e504,
        0x1e508,
        0x1e510,
        0x1e51e,
        0x1e520,
        0x1e53c,
        0x1e540,
        0x1e578,
        0x1e586,
        0x1e58c,
        0x1e598,
        0x1e5b0,
        0x1e5be,
        0x1e5ce,
        0x1e5dc,
        0x1e5e2,
        0x1e5e4,
        0x1e5e8,
        0x1e5f6,
        0x1e61a,
        0x1e62e,
        0x1e632,
        0x1e634,
        0x1e64e,
        0x1e65c,
        0x1e662,
        0x1e668,
        0x1e68e,
        0x1e69c,
        0x1e6b8,
        0x1e6c2,
        0x1e6c4,
        0x1e6c8,
        0x1e6d0,
        0x1e6e6,
        0x1e6fa,
        0x1e716,
        0x1e726,
        0x1e72c,
        0x1e73a,
        0x1e746,
        0x1e74c,
        0x1e758,
        0x1e772,
        0x1e774,
        0x1e792,
        0x1e794,
        0x1e7a2,
        0x1e7a4,
        0x1e7a8,
        0x1e7b6,
        0x1e812,
        0x1e814,
        0x1e822,
        0x1e824,
        0x1e828,
        0x1e836,
        0x1e842,
        0x1e844,
        0x1e848,
        0x1e850,
        0x1e85e,
        0x1e866,
        0x1e86c,
        0x1e87a,
        0x1e882,
        0x1e884,
        0x1e888,
        0x1e890,
        0x1e89e,
        0x1e8a0,
        0x1e8bc,
        0x1e8c6,
        0x1e8cc,
        0x1e8d8,
        0x1e8ee,
        0x1e8f2,
        0x1e8f4,
        0x1e902,
        0x1e904,
        0x1e908,
        0x1e910,
        0x1e920,
        0x1e93c,
        0x1e940,
        0x1e978,
        0x1e986,
        0x1e98c,
        0x1e998,
        0x1e9b0,
        0x1e9be,
        0x1e9ce,
        0x1e9dc,
        0x1e9e2,
        0x1e9e4,
        0x1e9e8,
        0x1e9f6,
        0x1ea04,
        0x1ea08,
        0x1ea10,
        0x1ea20,
        0x1ea40,
        0x1ea78,
        0x1eaf0,
        0x1eb06,
        0x1eb0c,
        0x1eb18,
        0x1eb30,
        0x1eb3e,
        0x1eb60,
        0x1eb7c,
        0x1eb8e,
        0x1eb9c,
        0x1ebb8,
        0x1ebc2,
        0x1ebc4,
        0x1ebc8,
        0x1ebd0,
        0x1ebde,
        0x1ebe6,
        0x1ebec,
        0x1ec1a,
        0x1ec2e,
        0x1ec32,
        0x1ec34,
        0x1ec4e,
        0x1ec5c,
        0x1ec62,
        0x1ec64,
        0x1ec68,
        0x1ec8e,
        0x1ec9c,
        0x1ecb8,
        0x1ecc2,
        0x1ecc4,
        0x1ecc8,
        0x1ecd0,
        0x1ece6,
        0x1ecfa,
        0x1ed0e,
        0x1ed1c,
        0x1ed38,
        0x1ed70,
        0x1ed7e,
        0x1ed82,
        0x1ed84,
        0x1ed88,
        0x1ed90,
        0x1ed9e,
        0x1eda0,
        0x1edcc,
        0x1edf2,
        0x1edf4,
        0x1ee16,
        0x1ee26,
        0x1ee2c,
        0x1ee3a,
        0x1ee46,
        0x1ee4c,
        0x1ee58,
        0x1ee6e,
        0x1ee72,
        0x1ee74,
        0x1ee86,
        0x1ee8c,
        0x1ee98,
        0x1eeb0,
        0x1eebe,
        0x1eece,
        0x1eedc,
        0x1eee2,
        0x1eee4,
        0x1eee8,
        0x1ef12,
        0x1ef22,
        0x1ef24,
        0x1ef28,
        0x1ef36,
        0x1ef42,
        0x1ef44,
        0x1ef48,
        0x1ef50,
        0x1ef5e,
        0x1ef66,
        0x1ef6c,
        0x1ef7a,
        0x1efae,
        0x1efb2,
        0x1efb4,
        0x1efd6,
        0x1f096,
        0x1f0a6,
        0x1f0ac,
        0x1f0ba,
        0x1f0ca,
        0x1f0d2,
        0x1f0d4,
        0x1f116,
        0x1f126,
        0x1f12c,
        0x1f13a,
        0x1f146,
        0x1f14c,
        0x1f158,
        0x1f16e,
        0x1f172,
        0x1f174,
        0x1f18a,
        0x1f192,
        0x1f194,
        0x1f1a2,
        0x1f1a4,
        0x1f1a8,
        0x1f1da,
        0x1f216,
        0x1f226,
        0x1f22c,
        0x1f23a,
        0x1f246,
        0x1f258,
        0x1f26e,
        0x1f272,
        0x1f274,
        0x1f286,
        0x1f28c,
        0x1f298,
        0x1f2b0,
        0x1f2be,
        0x1f2ce,
        0x1f2dc,
        0x1f2e2,
        0x1f2e4,
        0x1f2e8,
        0x1f2f6,
        0x1f30a,
        0x1f312,
        0x1f314,
        0x1f322,
        0x1f328,
        0x1f342,
        0x1f344,
        0x1f348,
        0x1f350,
        0x1f35e,
        0x1f366,
        0x1f37a,
        0x1f39a,
        0x1f3ae,
        0x1f3b2,
        0x1f3b4,
        0x1f416,
        0x1f426,
        0x1f42c,
        0x1f43a,
        0x1f446,
        0x1f44c,
        0x1f458,
        0x1f46e,
        0x1f472,
        0x1f474,
        0x1f486,
        0x1f48c,
        0x1f498,
        0x1f4b0,
        0x1f4be,
        0x1f4ce,
        0x1f4dc,
        0x1f4e2,
        0x1f4e4,
        0x1f4e8,
        0x1f4f6,
        0x1f506,
        0x1f50c,
        0x1f518,
        0x1f530,
        0x1f53e,
        0x1f560,
        0x1f57c,
        0x1f58e,
        0x1f59c,
        0x1f5b8,
        0x1f5c2,
        0x1f5c4,
        0x1f5c8,
        0x1f5d0,
        0x1f5de,
        0x1f5e6,
        0x1f5ec,
        0x1f5fa,
        0x1f60a,
        0x1f612,
        0x1f614,
        0x1f622,
        0x1f624,
        0x1f628,
        0x1f636,
        0x1f642,
        0x1f644,
        0x1f648,
        0x1f650,
        0x1f65e,
        0x1f666,
        0x1f67a,
        0x1f682,
        0x1f684,
        0x1f688,
        0x1f690,
        0x1f69e,
        0x1f6a0,
        0x1f6bc,
        0x1f6cc,
        0x1f6f2,
        0x1f6f4,
        0x1f71a,
        0x1f72e,
        0x1f732,
        0x1f734,
        0x1f74e,
        0x1f75c,
        0x1f762,
        0x1f764,
        0x1f768,
        0x1f776,
        0x1f796,
        0x1f7a6,
        0x1f7ac,
        0x1f7ba,
        0x1f7d2,
        0x1f7d4,
        0x1f89a,
        0x1f8ae,
        0x1f8b2,
        0x1f8b4,
        0x1f8d6,
        0x1f8ea,
        0x1f91a,
        0x1f92e,
        0x1f932,
        0x1f934,
        0x1f94e,
        0x1f95c,
        0x1f962,
        0x1f964,
        0x1f968,
        0x1f976,
        0x1f996,
        0x1f9a6,
        0x1f9ac,
        0x1f9ba,
        0x1f9ca,
        0x1f9d2,
        0x1f9d4,
        0x1fa1a,
        0x1fa2e,
        0x1fa32,
        0x1fa34,
        0x1fa4e,
        0x1fa5c,
        0x1fa62,
        0x1fa64,
        0x1fa68,
        0x1fa76,
        0x1fa8e,
        0x1fa9c,
        0x1fab8,
        0x1fac2,
        0x1fac4,
        0x1fac8,
        0x1fad0,
        0x1fade,
        0x1fae6,
        0x1faec,
        0x1fb16,
        0x1fb26,
        0x1fb2c,
        0x1fb3a,
        0x1fb46,
        0x1fb4c,
        0x1fb58,
        0x1fb6e,
        0x1fb72,
        0x1fb74,
        0x1fb8a,
        0x1fb92,
        0x1fb94,
        0x1fba2,
        0x1fba4,
        0x1fba8,
        0x1fbb6,
        0x1fbda
    ]);
    /**
     * This table contains to codewords for all symbols.
     */ PDF417Common.CODEWORD_TABLE = Int32Array.from([
        2627,
        1819,
        2622,
        2621,
        1813,
        1812,
        2729,
        2724,
        2723,
        2779,
        2774,
        2773,
        902,
        896,
        908,
        868,
        865,
        861,
        859,
        2511,
        873,
        871,
        1780,
        835,
        2493,
        825,
        2491,
        842,
        837,
        844,
        1764,
        1762,
        811,
        810,
        809,
        2483,
        807,
        2482,
        806,
        2480,
        815,
        814,
        813,
        812,
        2484,
        817,
        816,
        1745,
        1744,
        1742,
        1746,
        2655,
        2637,
        2635,
        2626,
        2625,
        2623,
        2628,
        1820,
        2752,
        2739,
        2737,
        2728,
        2727,
        2725,
        2730,
        2785,
        2783,
        2778,
        2777,
        2775,
        2780,
        787,
        781,
        747,
        739,
        736,
        2413,
        754,
        752,
        1719,
        692,
        689,
        681,
        2371,
        678,
        2369,
        700,
        697,
        694,
        703,
        1688,
        1686,
        642,
        638,
        2343,
        631,
        2341,
        627,
        2338,
        651,
        646,
        643,
        2345,
        654,
        652,
        1652,
        1650,
        1647,
        1654,
        601,
        599,
        2322,
        596,
        2321,
        594,
        2319,
        2317,
        611,
        610,
        608,
        606,
        2324,
        603,
        2323,
        615,
        614,
        612,
        1617,
        1616,
        1614,
        1612,
        616,
        1619,
        1618,
        2575,
        2538,
        2536,
        905,
        901,
        898,
        909,
        2509,
        2507,
        2504,
        870,
        867,
        864,
        860,
        2512,
        875,
        872,
        1781,
        2490,
        2489,
        2487,
        2485,
        1748,
        836,
        834,
        832,
        830,
        2494,
        827,
        2492,
        843,
        841,
        839,
        845,
        1765,
        1763,
        2701,
        2676,
        2674,
        2653,
        2648,
        2656,
        2634,
        2633,
        2631,
        2629,
        1821,
        2638,
        2636,
        2770,
        2763,
        2761,
        2750,
        2745,
        2753,
        2736,
        2735,
        2733,
        2731,
        1848,
        2740,
        2738,
        2786,
        2784,
        591,
        588,
        576,
        569,
        566,
        2296,
        1590,
        537,
        534,
        526,
        2276,
        522,
        2274,
        545,
        542,
        539,
        548,
        1572,
        1570,
        481,
        2245,
        466,
        2242,
        462,
        2239,
        492,
        485,
        482,
        2249,
        496,
        494,
        1534,
        1531,
        1528,
        1538,
        413,
        2196,
        406,
        2191,
        2188,
        425,
        419,
        2202,
        415,
        2199,
        432,
        430,
        427,
        1472,
        1467,
        1464,
        433,
        1476,
        1474,
        368,
        367,
        2160,
        365,
        2159,
        362,
        2157,
        2155,
        2152,
        378,
        377,
        375,
        2166,
        372,
        2165,
        369,
        2162,
        383,
        381,
        379,
        2168,
        1419,
        1418,
        1416,
        1414,
        385,
        1411,
        384,
        1423,
        1422,
        1420,
        1424,
        2461,
        802,
        2441,
        2439,
        790,
        786,
        783,
        794,
        2409,
        2406,
        2403,
        750,
        742,
        738,
        2414,
        756,
        753,
        1720,
        2367,
        2365,
        2362,
        2359,
        1663,
        693,
        691,
        684,
        2373,
        680,
        2370,
        702,
        699,
        696,
        704,
        1690,
        1687,
        2337,
        2336,
        2334,
        2332,
        1624,
        2329,
        1622,
        640,
        637,
        2344,
        634,
        2342,
        630,
        2340,
        650,
        648,
        645,
        2346,
        655,
        653,
        1653,
        1651,
        1649,
        1655,
        2612,
        2597,
        2595,
        2571,
        2568,
        2565,
        2576,
        2534,
        2529,
        2526,
        1787,
        2540,
        2537,
        907,
        904,
        900,
        910,
        2503,
        2502,
        2500,
        2498,
        1768,
        2495,
        1767,
        2510,
        2508,
        2506,
        869,
        866,
        863,
        2513,
        876,
        874,
        1782,
        2720,
        2713,
        2711,
        2697,
        2694,
        2691,
        2702,
        2672,
        2670,
        2664,
        1828,
        2678,
        2675,
        2647,
        2646,
        2644,
        2642,
        1823,
        2639,
        1822,
        2654,
        2652,
        2650,
        2657,
        2771,
        1855,
        2765,
        2762,
        1850,
        1849,
        2751,
        2749,
        2747,
        2754,
        353,
        2148,
        344,
        342,
        336,
        2142,
        332,
        2140,
        345,
        1375,
        1373,
        306,
        2130,
        299,
        2128,
        295,
        2125,
        319,
        314,
        311,
        2132,
        1354,
        1352,
        1349,
        1356,
        262,
        257,
        2101,
        253,
        2096,
        2093,
        274,
        273,
        267,
        2107,
        263,
        2104,
        280,
        278,
        275,
        1316,
        1311,
        1308,
        1320,
        1318,
        2052,
        202,
        2050,
        2044,
        2040,
        219,
        2063,
        212,
        2060,
        208,
        2055,
        224,
        221,
        2066,
        1260,
        1258,
        1252,
        231,
        1248,
        229,
        1266,
        1264,
        1261,
        1268,
        155,
        1998,
        153,
        1996,
        1994,
        1991,
        1988,
        165,
        164,
        2007,
        162,
        2006,
        159,
        2003,
        2000,
        172,
        171,
        169,
        2012,
        166,
        2010,
        1186,
        1184,
        1182,
        1179,
        175,
        1176,
        173,
        1192,
        1191,
        1189,
        1187,
        176,
        1194,
        1193,
        2313,
        2307,
        2305,
        592,
        589,
        2294,
        2292,
        2289,
        578,
        572,
        568,
        2297,
        580,
        1591,
        2272,
        2267,
        2264,
        1547,
        538,
        536,
        529,
        2278,
        525,
        2275,
        547,
        544,
        541,
        1574,
        1571,
        2237,
        2235,
        2229,
        1493,
        2225,
        1489,
        478,
        2247,
        470,
        2244,
        465,
        2241,
        493,
        488,
        484,
        2250,
        498,
        495,
        1536,
        1533,
        1530,
        1539,
        2187,
        2186,
        2184,
        2182,
        1432,
        2179,
        1430,
        2176,
        1427,
        414,
        412,
        2197,
        409,
        2195,
        405,
        2193,
        2190,
        426,
        424,
        421,
        2203,
        418,
        2201,
        431,
        429,
        1473,
        1471,
        1469,
        1466,
        434,
        1477,
        1475,
        2478,
        2472,
        2470,
        2459,
        2457,
        2454,
        2462,
        803,
        2437,
        2432,
        2429,
        1726,
        2443,
        2440,
        792,
        789,
        785,
        2401,
        2399,
        2393,
        1702,
        2389,
        1699,
        2411,
        2408,
        2405,
        745,
        741,
        2415,
        758,
        755,
        1721,
        2358,
        2357,
        2355,
        2353,
        1661,
        2350,
        1660,
        2347,
        1657,
        2368,
        2366,
        2364,
        2361,
        1666,
        690,
        687,
        2374,
        683,
        2372,
        701,
        698,
        705,
        1691,
        1689,
        2619,
        2617,
        2610,
        2608,
        2605,
        2613,
        2593,
        2588,
        2585,
        1803,
        2599,
        2596,
        2563,
        2561,
        2555,
        1797,
        2551,
        1795,
        2573,
        2570,
        2567,
        2577,
        2525,
        2524,
        2522,
        2520,
        1786,
        2517,
        1785,
        2514,
        1783,
        2535,
        2533,
        2531,
        2528,
        1788,
        2541,
        2539,
        906,
        903,
        911,
        2721,
        1844,
        2715,
        2712,
        1838,
        1836,
        2699,
        2696,
        2693,
        2703,
        1827,
        1826,
        1824,
        2673,
        2671,
        2669,
        2666,
        1829,
        2679,
        2677,
        1858,
        1857,
        2772,
        1854,
        1853,
        1851,
        1856,
        2766,
        2764,
        143,
        1987,
        139,
        1986,
        135,
        133,
        131,
        1984,
        128,
        1983,
        125,
        1981,
        138,
        137,
        136,
        1985,
        1133,
        1132,
        1130,
        112,
        110,
        1974,
        107,
        1973,
        104,
        1971,
        1969,
        122,
        121,
        119,
        117,
        1977,
        114,
        1976,
        124,
        1115,
        1114,
        1112,
        1110,
        1117,
        1116,
        84,
        83,
        1953,
        81,
        1952,
        78,
        1950,
        1948,
        1945,
        94,
        93,
        91,
        1959,
        88,
        1958,
        85,
        1955,
        99,
        97,
        95,
        1961,
        1086,
        1085,
        1083,
        1081,
        1078,
        100,
        1090,
        1089,
        1087,
        1091,
        49,
        47,
        1917,
        44,
        1915,
        1913,
        1910,
        1907,
        59,
        1926,
        56,
        1925,
        53,
        1922,
        1919,
        66,
        64,
        1931,
        61,
        1929,
        1042,
        1040,
        1038,
        71,
        1035,
        70,
        1032,
        68,
        1048,
        1047,
        1045,
        1043,
        1050,
        1049,
        12,
        10,
        1869,
        1867,
        1864,
        1861,
        21,
        1880,
        19,
        1877,
        1874,
        1871,
        28,
        1888,
        25,
        1886,
        22,
        1883,
        982,
        980,
        977,
        974,
        32,
        30,
        991,
        989,
        987,
        984,
        34,
        995,
        994,
        992,
        2151,
        2150,
        2147,
        2146,
        2144,
        356,
        355,
        354,
        2149,
        2139,
        2138,
        2136,
        2134,
        1359,
        343,
        341,
        338,
        2143,
        335,
        2141,
        348,
        347,
        346,
        1376,
        1374,
        2124,
        2123,
        2121,
        2119,
        1326,
        2116,
        1324,
        310,
        308,
        305,
        2131,
        302,
        2129,
        298,
        2127,
        320,
        318,
        316,
        313,
        2133,
        322,
        321,
        1355,
        1353,
        1351,
        1357,
        2092,
        2091,
        2089,
        2087,
        1276,
        2084,
        1274,
        2081,
        1271,
        259,
        2102,
        256,
        2100,
        252,
        2098,
        2095,
        272,
        269,
        2108,
        266,
        2106,
        281,
        279,
        277,
        1317,
        1315,
        1313,
        1310,
        282,
        1321,
        1319,
        2039,
        2037,
        2035,
        2032,
        1203,
        2029,
        1200,
        1197,
        207,
        2053,
        205,
        2051,
        201,
        2049,
        2046,
        2043,
        220,
        218,
        2064,
        215,
        2062,
        211,
        2059,
        228,
        226,
        223,
        2069,
        1259,
        1257,
        1254,
        232,
        1251,
        230,
        1267,
        1265,
        1263,
        2316,
        2315,
        2312,
        2311,
        2309,
        2314,
        2304,
        2303,
        2301,
        2299,
        1593,
        2308,
        2306,
        590,
        2288,
        2287,
        2285,
        2283,
        1578,
        2280,
        1577,
        2295,
        2293,
        2291,
        579,
        577,
        574,
        571,
        2298,
        582,
        581,
        1592,
        2263,
        2262,
        2260,
        2258,
        1545,
        2255,
        1544,
        2252,
        1541,
        2273,
        2271,
        2269,
        2266,
        1550,
        535,
        532,
        2279,
        528,
        2277,
        546,
        543,
        549,
        1575,
        1573,
        2224,
        2222,
        2220,
        1486,
        2217,
        1485,
        2214,
        1482,
        1479,
        2238,
        2236,
        2234,
        2231,
        1496,
        2228,
        1492,
        480,
        477,
        2248,
        473,
        2246,
        469,
        2243,
        490,
        487,
        2251,
        497,
        1537,
        1535,
        1532,
        2477,
        2476,
        2474,
        2479,
        2469,
        2468,
        2466,
        2464,
        1730,
        2473,
        2471,
        2453,
        2452,
        2450,
        2448,
        1729,
        2445,
        1728,
        2460,
        2458,
        2456,
        2463,
        805,
        804,
        2428,
        2427,
        2425,
        2423,
        1725,
        2420,
        1724,
        2417,
        1722,
        2438,
        2436,
        2434,
        2431,
        1727,
        2444,
        2442,
        793,
        791,
        788,
        795,
        2388,
        2386,
        2384,
        1697,
        2381,
        1696,
        2378,
        1694,
        1692,
        2402,
        2400,
        2398,
        2395,
        1703,
        2392,
        1701,
        2412,
        2410,
        2407,
        751,
        748,
        744,
        2416,
        759,
        757,
        1807,
        2620,
        2618,
        1806,
        1805,
        2611,
        2609,
        2607,
        2614,
        1802,
        1801,
        1799,
        2594,
        2592,
        2590,
        2587,
        1804,
        2600,
        2598,
        1794,
        1793,
        1791,
        1789,
        2564,
        2562,
        2560,
        2557,
        1798,
        2554,
        1796,
        2574,
        2572,
        2569,
        2578,
        1847,
        1846,
        2722,
        1843,
        1842,
        1840,
        1845,
        2716,
        2714,
        1835,
        1834,
        1832,
        1830,
        1839,
        1837,
        2700,
        2698,
        2695,
        2704,
        1817,
        1811,
        1810,
        897,
        862,
        1777,
        829,
        826,
        838,
        1760,
        1758,
        808,
        2481,
        1741,
        1740,
        1738,
        1743,
        2624,
        1818,
        2726,
        2776,
        782,
        740,
        737,
        1715,
        686,
        679,
        695,
        1682,
        1680,
        639,
        628,
        2339,
        647,
        644,
        1645,
        1643,
        1640,
        1648,
        602,
        600,
        597,
        595,
        2320,
        593,
        2318,
        609,
        607,
        604,
        1611,
        1610,
        1608,
        1606,
        613,
        1615,
        1613,
        2328,
        926,
        924,
        892,
        886,
        899,
        857,
        850,
        2505,
        1778,
        824,
        823,
        821,
        819,
        2488,
        818,
        2486,
        833,
        831,
        828,
        840,
        1761,
        1759,
        2649,
        2632,
        2630,
        2746,
        2734,
        2732,
        2782,
        2781,
        570,
        567,
        1587,
        531,
        527,
        523,
        540,
        1566,
        1564,
        476,
        467,
        463,
        2240,
        486,
        483,
        1524,
        1521,
        1518,
        1529,
        411,
        403,
        2192,
        399,
        2189,
        423,
        416,
        1462,
        1457,
        1454,
        428,
        1468,
        1465,
        2210,
        366,
        363,
        2158,
        360,
        2156,
        357,
        2153,
        376,
        373,
        370,
        2163,
        1410,
        1409,
        1407,
        1405,
        382,
        1402,
        380,
        1417,
        1415,
        1412,
        1421,
        2175,
        2174,
        777,
        774,
        771,
        784,
        732,
        725,
        722,
        2404,
        743,
        1716,
        676,
        674,
        668,
        2363,
        665,
        2360,
        685,
        1684,
        1681,
        626,
        624,
        622,
        2335,
        620,
        2333,
        617,
        2330,
        641,
        635,
        649,
        1646,
        1644,
        1642,
        2566,
        928,
        925,
        2530,
        2527,
        894,
        891,
        888,
        2501,
        2499,
        2496,
        858,
        856,
        854,
        851,
        1779,
        2692,
        2668,
        2665,
        2645,
        2643,
        2640,
        2651,
        2768,
        2759,
        2757,
        2744,
        2743,
        2741,
        2748,
        352,
        1382,
        340,
        337,
        333,
        1371,
        1369,
        307,
        300,
        296,
        2126,
        315,
        312,
        1347,
        1342,
        1350,
        261,
        258,
        250,
        2097,
        246,
        2094,
        271,
        268,
        264,
        1306,
        1301,
        1298,
        276,
        1312,
        1309,
        2115,
        203,
        2048,
        195,
        2045,
        191,
        2041,
        213,
        209,
        2056,
        1246,
        1244,
        1238,
        225,
        1234,
        222,
        1256,
        1253,
        1249,
        1262,
        2080,
        2079,
        154,
        1997,
        150,
        1995,
        147,
        1992,
        1989,
        163,
        160,
        2004,
        156,
        2001,
        1175,
        1174,
        1172,
        1170,
        1167,
        170,
        1164,
        167,
        1185,
        1183,
        1180,
        1177,
        174,
        1190,
        1188,
        2025,
        2024,
        2022,
        587,
        586,
        564,
        559,
        556,
        2290,
        573,
        1588,
        520,
        518,
        512,
        2268,
        508,
        2265,
        530,
        1568,
        1565,
        461,
        457,
        2233,
        450,
        2230,
        446,
        2226,
        479,
        471,
        489,
        1526,
        1523,
        1520,
        397,
        395,
        2185,
        392,
        2183,
        389,
        2180,
        2177,
        410,
        2194,
        402,
        422,
        1463,
        1461,
        1459,
        1456,
        1470,
        2455,
        799,
        2433,
        2430,
        779,
        776,
        773,
        2397,
        2394,
        2390,
        734,
        728,
        724,
        746,
        1717,
        2356,
        2354,
        2351,
        2348,
        1658,
        677,
        675,
        673,
        670,
        667,
        688,
        1685,
        1683,
        2606,
        2589,
        2586,
        2559,
        2556,
        2552,
        927,
        2523,
        2521,
        2518,
        2515,
        1784,
        2532,
        895,
        893,
        890,
        2718,
        2709,
        2707,
        2689,
        2687,
        2684,
        2663,
        2662,
        2660,
        2658,
        1825,
        2667,
        2769,
        1852,
        2760,
        2758,
        142,
        141,
        1139,
        1138,
        134,
        132,
        129,
        126,
        1982,
        1129,
        1128,
        1126,
        1131,
        113,
        111,
        108,
        105,
        1972,
        101,
        1970,
        120,
        118,
        115,
        1109,
        1108,
        1106,
        1104,
        123,
        1113,
        1111,
        82,
        79,
        1951,
        75,
        1949,
        72,
        1946,
        92,
        89,
        86,
        1956,
        1077,
        1076,
        1074,
        1072,
        98,
        1069,
        96,
        1084,
        1082,
        1079,
        1088,
        1968,
        1967,
        48,
        45,
        1916,
        42,
        1914,
        39,
        1911,
        1908,
        60,
        57,
        54,
        1923,
        50,
        1920,
        1031,
        1030,
        1028,
        1026,
        67,
        1023,
        65,
        1020,
        62,
        1041,
        1039,
        1036,
        1033,
        69,
        1046,
        1044,
        1944,
        1943,
        1941,
        11,
        9,
        1868,
        7,
        1865,
        1862,
        1859,
        20,
        1878,
        16,
        1875,
        13,
        1872,
        970,
        968,
        966,
        963,
        29,
        960,
        26,
        23,
        983,
        981,
        978,
        975,
        33,
        971,
        31,
        990,
        988,
        985,
        1906,
        1904,
        1902,
        993,
        351,
        2145,
        1383,
        331,
        330,
        328,
        326,
        2137,
        323,
        2135,
        339,
        1372,
        1370,
        294,
        293,
        291,
        289,
        2122,
        286,
        2120,
        283,
        2117,
        309,
        303,
        317,
        1348,
        1346,
        1344,
        245,
        244,
        242,
        2090,
        239,
        2088,
        236,
        2085,
        2082,
        260,
        2099,
        249,
        270,
        1307,
        1305,
        1303,
        1300,
        1314,
        189,
        2038,
        186,
        2036,
        183,
        2033,
        2030,
        2026,
        206,
        198,
        2047,
        194,
        216,
        1247,
        1245,
        1243,
        1240,
        227,
        1237,
        1255,
        2310,
        2302,
        2300,
        2286,
        2284,
        2281,
        565,
        563,
        561,
        558,
        575,
        1589,
        2261,
        2259,
        2256,
        2253,
        1542,
        521,
        519,
        517,
        514,
        2270,
        511,
        533,
        1569,
        1567,
        2223,
        2221,
        2218,
        2215,
        1483,
        2211,
        1480,
        459,
        456,
        453,
        2232,
        449,
        474,
        491,
        1527,
        1525,
        1522,
        2475,
        2467,
        2465,
        2451,
        2449,
        2446,
        801,
        800,
        2426,
        2424,
        2421,
        2418,
        1723,
        2435,
        780,
        778,
        775,
        2387,
        2385,
        2382,
        2379,
        1695,
        2375,
        1693,
        2396,
        735,
        733,
        730,
        727,
        749,
        1718,
        2616,
        2615,
        2604,
        2603,
        2601,
        2584,
        2583,
        2581,
        2579,
        1800,
        2591,
        2550,
        2549,
        2547,
        2545,
        1792,
        2542,
        1790,
        2558,
        929,
        2719,
        1841,
        2710,
        2708,
        1833,
        1831,
        2690,
        2688,
        2686,
        1815,
        1809,
        1808,
        1774,
        1756,
        1754,
        1737,
        1736,
        1734,
        1739,
        1816,
        1711,
        1676,
        1674,
        633,
        629,
        1638,
        1636,
        1633,
        1641,
        598,
        1605,
        1604,
        1602,
        1600,
        605,
        1609,
        1607,
        2327,
        887,
        853,
        1775,
        822,
        820,
        1757,
        1755,
        1584,
        524,
        1560,
        1558,
        468,
        464,
        1514,
        1511,
        1508,
        1519,
        408,
        404,
        400,
        1452,
        1447,
        1444,
        417,
        1458,
        1455,
        2208,
        364,
        361,
        358,
        2154,
        1401,
        1400,
        1398,
        1396,
        374,
        1393,
        371,
        1408,
        1406,
        1403,
        1413,
        2173,
        2172,
        772,
        726,
        723,
        1712,
        672,
        669,
        666,
        682,
        1678,
        1675,
        625,
        623,
        621,
        618,
        2331,
        636,
        632,
        1639,
        1637,
        1635,
        920,
        918,
        884,
        880,
        889,
        849,
        848,
        847,
        846,
        2497,
        855,
        852,
        1776,
        2641,
        2742,
        2787,
        1380,
        334,
        1367,
        1365,
        301,
        297,
        1340,
        1338,
        1335,
        1343,
        255,
        251,
        247,
        1296,
        1291,
        1288,
        265,
        1302,
        1299,
        2113,
        204,
        196,
        192,
        2042,
        1232,
        1230,
        1224,
        214,
        1220,
        210,
        1242,
        1239,
        1235,
        1250,
        2077,
        2075,
        151,
        148,
        1993,
        144,
        1990,
        1163,
        1162,
        1160,
        1158,
        1155,
        161,
        1152,
        157,
        1173,
        1171,
        1168,
        1165,
        168,
        1181,
        1178,
        2021,
        2020,
        2018,
        2023,
        585,
        560,
        557,
        1585,
        516,
        509,
        1562,
        1559,
        458,
        447,
        2227,
        472,
        1516,
        1513,
        1510,
        398,
        396,
        393,
        390,
        2181,
        386,
        2178,
        407,
        1453,
        1451,
        1449,
        1446,
        420,
        1460,
        2209,
        769,
        764,
        720,
        712,
        2391,
        729,
        1713,
        664,
        663,
        661,
        659,
        2352,
        656,
        2349,
        671,
        1679,
        1677,
        2553,
        922,
        919,
        2519,
        2516,
        885,
        883,
        881,
        2685,
        2661,
        2659,
        2767,
        2756,
        2755,
        140,
        1137,
        1136,
        130,
        127,
        1125,
        1124,
        1122,
        1127,
        109,
        106,
        102,
        1103,
        1102,
        1100,
        1098,
        116,
        1107,
        1105,
        1980,
        80,
        76,
        73,
        1947,
        1068,
        1067,
        1065,
        1063,
        90,
        1060,
        87,
        1075,
        1073,
        1070,
        1080,
        1966,
        1965,
        46,
        43,
        40,
        1912,
        36,
        1909,
        1019,
        1018,
        1016,
        1014,
        58,
        1011,
        55,
        1008,
        51,
        1029,
        1027,
        1024,
        1021,
        63,
        1037,
        1034,
        1940,
        1939,
        1937,
        1942,
        8,
        1866,
        4,
        1863,
        1,
        1860,
        956,
        954,
        952,
        949,
        946,
        17,
        14,
        969,
        967,
        964,
        961,
        27,
        957,
        24,
        979,
        976,
        972,
        1901,
        1900,
        1898,
        1896,
        986,
        1905,
        1903,
        350,
        349,
        1381,
        329,
        327,
        324,
        1368,
        1366,
        292,
        290,
        287,
        284,
        2118,
        304,
        1341,
        1339,
        1337,
        1345,
        243,
        240,
        237,
        2086,
        233,
        2083,
        254,
        1297,
        1295,
        1293,
        1290,
        1304,
        2114,
        190,
        187,
        184,
        2034,
        180,
        2031,
        177,
        2027,
        199,
        1233,
        1231,
        1229,
        1226,
        217,
        1223,
        1241,
        2078,
        2076,
        584,
        555,
        554,
        552,
        550,
        2282,
        562,
        1586,
        507,
        506,
        504,
        502,
        2257,
        499,
        2254,
        515,
        1563,
        1561,
        445,
        443,
        441,
        2219,
        438,
        2216,
        435,
        2212,
        460,
        454,
        475,
        1517,
        1515,
        1512,
        2447,
        798,
        797,
        2422,
        2419,
        770,
        768,
        766,
        2383,
        2380,
        2376,
        721,
        719,
        717,
        714,
        731,
        1714,
        2602,
        2582,
        2580,
        2548,
        2546,
        2543,
        923,
        921,
        2717,
        2706,
        2705,
        2683,
        2682,
        2680,
        1771,
        1752,
        1750,
        1733,
        1732,
        1731,
        1735,
        1814,
        1707,
        1670,
        1668,
        1631,
        1629,
        1626,
        1634,
        1599,
        1598,
        1596,
        1594,
        1603,
        1601,
        2326,
        1772,
        1753,
        1751,
        1581,
        1554,
        1552,
        1504,
        1501,
        1498,
        1509,
        1442,
        1437,
        1434,
        401,
        1448,
        1445,
        2206,
        1392,
        1391,
        1389,
        1387,
        1384,
        359,
        1399,
        1397,
        1394,
        1404,
        2171,
        2170,
        1708,
        1672,
        1669,
        619,
        1632,
        1630,
        1628,
        1773,
        1378,
        1363,
        1361,
        1333,
        1328,
        1336,
        1286,
        1281,
        1278,
        248,
        1292,
        1289,
        2111,
        1218,
        1216,
        1210,
        197,
        1206,
        193,
        1228,
        1225,
        1221,
        1236,
        2073,
        2071,
        1151,
        1150,
        1148,
        1146,
        152,
        1143,
        149,
        1140,
        145,
        1161,
        1159,
        1156,
        1153,
        158,
        1169,
        1166,
        2017,
        2016,
        2014,
        2019,
        1582,
        510,
        1556,
        1553,
        452,
        448,
        1506,
        1500,
        394,
        391,
        387,
        1443,
        1441,
        1439,
        1436,
        1450,
        2207,
        765,
        716,
        713,
        1709,
        662,
        660,
        657,
        1673,
        1671,
        916,
        914,
        879,
        878,
        877,
        882,
        1135,
        1134,
        1121,
        1120,
        1118,
        1123,
        1097,
        1096,
        1094,
        1092,
        103,
        1101,
        1099,
        1979,
        1059,
        1058,
        1056,
        1054,
        77,
        1051,
        74,
        1066,
        1064,
        1061,
        1071,
        1964,
        1963,
        1007,
        1006,
        1004,
        1002,
        999,
        41,
        996,
        37,
        1017,
        1015,
        1012,
        1009,
        52,
        1025,
        1022,
        1936,
        1935,
        1933,
        1938,
        942,
        940,
        938,
        935,
        932,
        5,
        2,
        955,
        953,
        950,
        947,
        18,
        943,
        15,
        965,
        962,
        958,
        1895,
        1894,
        1892,
        1890,
        973,
        1899,
        1897,
        1379,
        325,
        1364,
        1362,
        288,
        285,
        1334,
        1332,
        1330,
        241,
        238,
        234,
        1287,
        1285,
        1283,
        1280,
        1294,
        2112,
        188,
        185,
        181,
        178,
        2028,
        1219,
        1217,
        1215,
        1212,
        200,
        1209,
        1227,
        2074,
        2072,
        583,
        553,
        551,
        1583,
        505,
        503,
        500,
        513,
        1557,
        1555,
        444,
        442,
        439,
        436,
        2213,
        455,
        451,
        1507,
        1505,
        1502,
        796,
        763,
        762,
        760,
        767,
        711,
        710,
        708,
        706,
        2377,
        718,
        715,
        1710,
        2544,
        917,
        915,
        2681,
        1627,
        1597,
        1595,
        2325,
        1769,
        1749,
        1747,
        1499,
        1438,
        1435,
        2204,
        1390,
        1388,
        1385,
        1395,
        2169,
        2167,
        1704,
        1665,
        1662,
        1625,
        1623,
        1620,
        1770,
        1329,
        1282,
        1279,
        2109,
        1214,
        1207,
        1222,
        2068,
        2065,
        1149,
        1147,
        1144,
        1141,
        146,
        1157,
        1154,
        2013,
        2011,
        2008,
        2015,
        1579,
        1549,
        1546,
        1495,
        1487,
        1433,
        1431,
        1428,
        1425,
        388,
        1440,
        2205,
        1705,
        658,
        1667,
        1664,
        1119,
        1095,
        1093,
        1978,
        1057,
        1055,
        1052,
        1062,
        1962,
        1960,
        1005,
        1003,
        1000,
        997,
        38,
        1013,
        1010,
        1932,
        1930,
        1927,
        1934,
        941,
        939,
        936,
        933,
        6,
        930,
        3,
        951,
        948,
        944,
        1889,
        1887,
        1884,
        1881,
        959,
        1893,
        1891,
        35,
        1377,
        1360,
        1358,
        1327,
        1325,
        1322,
        1331,
        1277,
        1275,
        1272,
        1269,
        235,
        1284,
        2110,
        1205,
        1204,
        1201,
        1198,
        182,
        1195,
        179,
        1213,
        2070,
        2067,
        1580,
        501,
        1551,
        1548,
        440,
        437,
        1497,
        1494,
        1490,
        1503,
        761,
        709,
        707,
        1706,
        913,
        912,
        2198,
        1386,
        2164,
        2161,
        1621,
        1766,
        2103,
        1208,
        2058,
        2054,
        1145,
        1142,
        2005,
        2002,
        1999,
        2009,
        1488,
        1429,
        1426,
        2200,
        1698,
        1659,
        1656,
        1975,
        1053,
        1957,
        1954,
        1001,
        998,
        1924,
        1921,
        1918,
        1928,
        937,
        934,
        931,
        1879,
        1876,
        1873,
        1870,
        945,
        1885,
        1882,
        1323,
        1273,
        1270,
        2105,
        1202,
        1199,
        1196,
        1211,
        2061,
        2057,
        1576,
        1543,
        1540,
        1484,
        1481,
        1478,
        1491,
        1700
    ]);
    /*
    * Copyright 2007 ZXing authors
    *
    * Licensed under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License.
    * You may obtain a copy of the License at
    *
    *      http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software
    * distributed under the License is distributed on an "AS IS" BASIS,
    * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    * See the License for the specific language governing permissions and
    * limitations under the License.
    */ // import java.util.List;
    /**
     * @author Guenther Grau
     */ /*public final*/ class PDF417DetectorResult {
        constructor(bits, points){
            this.bits = bits;
            this.points = points;
        }
        getBits() {
            return this.bits;
        }
        getPoints() {
            return this.points;
        }
    }
    /*
    * Copyright 2009 ZXing authors
    *
    * Licensed under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License.
    * You may obtain a copy of the License at
    *
    *      http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software
    * distributed under the License is distributed on an "AS IS" BASIS,
    * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    * See the License for the specific language governing permissions and
    * limitations under the License.
    */ // import java.util.ArrayList;
    // import java.util.Arrays;
    // import java.util.List;
    // import java.util.Map;
    /**
     * <p>Encapsulates logic that can detect a PDF417 Code in an image, even if the
     * PDF417 Code is rotated or skewed, or partially obscured.</p>
     *
     * @author SITA Lab (kevin.osullivan@sita.aero)
     * @author dswitkin@google.com (Daniel Switkin)
     * @author Guenther Grau
     */ /*public*/ /*final*/ class Detector$3 {
        /**
         * <p>Detects a PDF417 Code in an image. Only checks 0 and 180 degree rotations.</p>
         *
         * @param image barcode image to decode
         * @param hints optional hints to detector
         * @param multiple if true, then the image is searched for multiple codes. If false, then at most one code will
         * be found and returned
         * @return {@link PDF417DetectorResult} encapsulating results of detecting a PDF417 code
         * @throws NotFoundException if no PDF417 Code can be found
         */ static detectMultiple(image, hints, multiple) {
            // TODO detection improvement, tryHarder could try several different luminance thresholds/blackpoints or even
            // different binarizers
            // boolean tryHarder = hints != null && hints.containsKey(DecodeHintType.TRY_HARDER);
            let bitMatrix = image.getBlackMatrix();
            let barcodeCoordinates = Detector$3.detect(multiple, bitMatrix);
            if (!barcodeCoordinates.length) {
                bitMatrix = bitMatrix.clone();
                bitMatrix.rotate180();
                barcodeCoordinates = Detector$3.detect(multiple, bitMatrix);
            }
            return new PDF417DetectorResult(bitMatrix, barcodeCoordinates);
        }
        /**
         * Detects PDF417 codes in an image. Only checks 0 degree rotation
         * @param multiple if true, then the image is searched for multiple codes. If false, then at most one code will
         * be found and returned
         * @param bitMatrix bit matrix to detect barcodes in
         * @return List of ResultPoint arrays containing the coordinates of found barcodes
         */ static detect(multiple, bitMatrix) {
            const barcodeCoordinates = new Array();
            let row = 0;
            let column = 0;
            let foundBarcodeInRow = false;
            while(row < bitMatrix.getHeight()){
                const vertices = Detector$3.findVertices(bitMatrix, row, column);
                if (vertices[0] == null && vertices[3] == null) {
                    if (!foundBarcodeInRow) break;
                    // we didn't find a barcode starting at the given column and row. Try again from the first column and slightly
                    // below the lowest barcode we found so far.
                    foundBarcodeInRow = false;
                    column = 0;
                    for (const barcodeCoordinate of barcodeCoordinates){
                        if (barcodeCoordinate[1] != null) row = Math.trunc(Math.max(row, barcodeCoordinate[1].getY()));
                        if (barcodeCoordinate[3] != null) row = Math.max(row, Math.trunc(barcodeCoordinate[3].getY()));
                    }
                    row += Detector$3.ROW_STEP;
                    continue;
                }
                foundBarcodeInRow = true;
                barcodeCoordinates.push(vertices);
                if (!multiple) break;
                // if we didn't find a right row indicator column, then continue the search for the next barcode after the
                // start pattern of the barcode just found.
                if (vertices[2] != null) {
                    column = Math.trunc(vertices[2].getX());
                    row = Math.trunc(vertices[2].getY());
                } else {
                    column = Math.trunc(vertices[4].getX());
                    row = Math.trunc(vertices[4].getY());
                }
            }
            return barcodeCoordinates;
        }
        /**
         * Locate the vertices and the codewords area of a black blob using the Start
         * and Stop patterns as locators.
         *
         * @param matrix the scanned barcode image.
         * @return an array containing the vertices:
         *           vertices[0] x, y top left barcode
         *           vertices[1] x, y bottom left barcode
         *           vertices[2] x, y top right barcode
         *           vertices[3] x, y bottom right barcode
         *           vertices[4] x, y top left codeword area
         *           vertices[5] x, y bottom left codeword area
         *           vertices[6] x, y top right codeword area
         *           vertices[7] x, y bottom right codeword area
         */ static findVertices(matrix, startRow, startColumn) {
            const height = matrix.getHeight();
            const width = matrix.getWidth();
            // const result = new ResultPoint[8];
            const result = new Array(8);
            Detector$3.copyToResult(result, Detector$3.findRowsWithPattern(matrix, height, width, startRow, startColumn, Detector$3.START_PATTERN), Detector$3.INDEXES_START_PATTERN);
            if (result[4] != null) {
                startColumn = Math.trunc(result[4].getX());
                startRow = Math.trunc(result[4].getY());
            }
            Detector$3.copyToResult(result, Detector$3.findRowsWithPattern(matrix, height, width, startRow, startColumn, Detector$3.STOP_PATTERN), Detector$3.INDEXES_STOP_PATTERN);
            return result;
        }
        static copyToResult(result, tmpResult, destinationIndexes) {
            for(let i = 0; i < destinationIndexes.length; i++)result[destinationIndexes[i]] = tmpResult[i];
        }
        static findRowsWithPattern(matrix, height, width, startRow, startColumn, pattern) {
            // const result = new ResultPoint[4];
            const result = new Array(4);
            let found = false;
            const counters = new Int32Array(pattern.length);
            for(; startRow < height; startRow += Detector$3.ROW_STEP){
                let loc = Detector$3.findGuardPattern(matrix, startColumn, startRow, width, false, pattern, counters);
                if (loc != null) {
                    while(startRow > 0){
                        const previousRowLoc = Detector$3.findGuardPattern(matrix, startColumn, --startRow, width, false, pattern, counters);
                        if (previousRowLoc != null) loc = previousRowLoc;
                        else {
                            startRow++;
                            break;
                        }
                    }
                    result[0] = new ResultPoint(loc[0], startRow);
                    result[1] = new ResultPoint(loc[1], startRow);
                    found = true;
                    break;
                }
            }
            let stopRow = startRow + 1;
            // Last row of the current symbol that contains pattern
            if (found) {
                let skippedRowCount = 0;
                let previousRowLoc = Int32Array.from([
                    Math.trunc(result[0].getX()),
                    Math.trunc(result[1].getX())
                ]);
                for(; stopRow < height; stopRow++){
                    const loc = Detector$3.findGuardPattern(matrix, previousRowLoc[0], stopRow, width, false, pattern, counters);
                    // a found pattern is only considered to belong to the same barcode if the start and end positions
                    // don't differ too much. Pattern drift should be not bigger than two for consecutive rows. With
                    // a higher number of skipped rows drift could be larger. To keep it simple for now, we allow a slightly
                    // larger drift and don't check for skipped rows.
                    if (loc != null && Math.abs(previousRowLoc[0] - loc[0]) < Detector$3.MAX_PATTERN_DRIFT && Math.abs(previousRowLoc[1] - loc[1]) < Detector$3.MAX_PATTERN_DRIFT) {
                        previousRowLoc = loc;
                        skippedRowCount = 0;
                    } else {
                        if (skippedRowCount > Detector$3.SKIPPED_ROW_COUNT_MAX) break;
                        else skippedRowCount++;
                    }
                }
                stopRow -= skippedRowCount + 1;
                result[2] = new ResultPoint(previousRowLoc[0], stopRow);
                result[3] = new ResultPoint(previousRowLoc[1], stopRow);
            }
            if (stopRow - startRow < Detector$3.BARCODE_MIN_HEIGHT) Arrays.fill(result, null);
            return result;
        }
        /**
         * @param matrix row of black/white values to search
         * @param column x position to start search
         * @param row y position to start search
         * @param width the number of pixels to search on this row
         * @param pattern pattern of counts of number of black and white pixels that are
         *                 being searched for as a pattern
         * @param counters array of counters, as long as pattern, to re-use
         * @return start/end horizontal offset of guard pattern, as an array of two ints.
         */ static findGuardPattern(matrix, column, row, width, whiteFirst, pattern, counters) {
            Arrays.fillWithin(counters, 0, counters.length, 0);
            let patternStart = column;
            let pixelDrift = 0;
            // if there are black pixels left of the current pixel shift to the left, but only for MAX_PIXEL_DRIFT pixels
            while(matrix.get(patternStart, row) && patternStart > 0 && pixelDrift++ < Detector$3.MAX_PIXEL_DRIFT)patternStart--;
            let x = patternStart;
            let counterPosition = 0;
            let patternLength = pattern.length;
            for(let isWhite = whiteFirst; x < width; x++){
                let pixel = matrix.get(x, row);
                if (pixel !== isWhite) counters[counterPosition]++;
                else {
                    if (counterPosition === patternLength - 1) {
                        if (Detector$3.patternMatchVariance(counters, pattern, Detector$3.MAX_INDIVIDUAL_VARIANCE) < Detector$3.MAX_AVG_VARIANCE) return new Int32Array([
                            patternStart,
                            x
                        ]);
                        patternStart += counters[0] + counters[1];
                        System.arraycopy(counters, 2, counters, 0, counterPosition - 1);
                        counters[counterPosition - 1] = 0;
                        counters[counterPosition] = 0;
                        counterPosition--;
                    } else counterPosition++;
                    counters[counterPosition] = 1;
                    isWhite = !isWhite;
                }
            }
            if (counterPosition === patternLength - 1 && Detector$3.patternMatchVariance(counters, pattern, Detector$3.MAX_INDIVIDUAL_VARIANCE) < Detector$3.MAX_AVG_VARIANCE) return new Int32Array([
                patternStart,
                x - 1
            ]);
            return null;
        }
        /**
         * Determines how closely a set of observed counts of runs of black/white
         * values matches a given target pattern. This is reported as the ratio of
         * the total variance from the expected pattern proportions across all
         * pattern elements, to the length of the pattern.
         *
         * @param counters observed counters
         * @param pattern expected pattern
         * @param maxIndividualVariance The most any counter can differ before we give up
         * @return ratio of total variance between counters and pattern compared to total pattern size
         */ static patternMatchVariance(counters, pattern, maxIndividualVariance) {
            let numCounters = counters.length;
            let total = 0;
            let patternLength = 0;
            for(let i = 0; i < numCounters; i++){
                total += counters[i];
                patternLength += pattern[i];
            }
            if (total < patternLength) // If we don't even have one pixel per unit of bar width, assume this
            // is too small to reliably match, so fail:
            return /*Float.POSITIVE_INFINITY*/ Infinity;
            // We're going to fake floating-point math in integers. We just need to use more bits.
            // Scale up patternLength so that intermediate values below like scaledCounter will have
            // more "significant digits".
            let unitBarWidth = total / patternLength;
            maxIndividualVariance *= unitBarWidth;
            let totalVariance = 0.0;
            for(let x = 0; x < numCounters; x++){
                let counter = counters[x];
                let scaledPattern = pattern[x] * unitBarWidth;
                let variance = counter > scaledPattern ? counter - scaledPattern : scaledPattern - counter;
                if (variance > maxIndividualVariance) return /*Float.POSITIVE_INFINITY*/ Infinity;
                totalVariance += variance;
            }
            return totalVariance / total;
        }
    }
    Detector$3.INDEXES_START_PATTERN = Int32Array.from([
        0,
        4,
        1,
        5
    ]);
    Detector$3.INDEXES_STOP_PATTERN = Int32Array.from([
        6,
        2,
        7,
        3
    ]);
    Detector$3.MAX_AVG_VARIANCE = 0.42;
    Detector$3.MAX_INDIVIDUAL_VARIANCE = 0.8;
    // B S B S B S B S Bar/Space pattern
    // 11111111 0 1 0 1 0 1 000
    Detector$3.START_PATTERN = Int32Array.from([
        8,
        1,
        1,
        1,
        1,
        1,
        1,
        3
    ]);
    // 1111111 0 1 000 1 0 1 00 1
    Detector$3.STOP_PATTERN = Int32Array.from([
        7,
        1,
        1,
        3,
        1,
        1,
        1,
        2,
        1
    ]);
    Detector$3.MAX_PIXEL_DRIFT = 3;
    Detector$3.MAX_PATTERN_DRIFT = 5;
    // if we set the value too low, then we don't detect the correct height of the bar if the start patterns are damaged.
    // if we set the value too high, then we might detect the start pattern from a neighbor barcode.
    Detector$3.SKIPPED_ROW_COUNT_MAX = 25;
    // A PDF471 barcode should have at least 3 rows, with each row being >= 3 times the module width. Therefore it should be at least
    // 9 pixels tall. To be conservative, we use about half the size to ensure we don't miss it.
    Detector$3.ROW_STEP = 5;
    Detector$3.BARCODE_MIN_HEIGHT = 10;
    /*
    * Copyright 2012 ZXing authors
    *
    * Licensed under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License.
    * You may obtain a copy of the License at
    *
    *      http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software
    * distributed under the License is distributed on an "AS IS" BASIS,
    * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    * See the License for the specific language governing permissions and
    * limitations under the License.
    */ /**
     * @author Sean Owen
     * @see com.google.zxing.common.reedsolomon.GenericGFPoly
     */ /*final*/ class ModulusPoly {
        constructor(field, coefficients){
            if (coefficients.length === 0) throw new IllegalArgumentException();
            this.field = field;
            let coefficientsLength = /*int*/ coefficients.length;
            if (coefficientsLength > 1 && coefficients[0] === 0) {
                // Leading term must be non-zero for anything except the constant polynomial "0"
                let firstNonZero = /*int*/ 1;
                while(firstNonZero < coefficientsLength && coefficients[firstNonZero] === 0)firstNonZero++;
                if (firstNonZero === coefficientsLength) this.coefficients = new Int32Array([
                    0
                ]);
                else {
                    this.coefficients = new Int32Array(coefficientsLength - firstNonZero);
                    System.arraycopy(coefficients, firstNonZero, this.coefficients, 0, this.coefficients.length);
                }
            } else this.coefficients = coefficients;
        }
        getCoefficients() {
            return this.coefficients;
        }
        /**
         * @return degree of this polynomial
         */ getDegree() {
            return this.coefficients.length - 1;
        }
        /**
         * @return true iff this polynomial is the monomial "0"
         */ isZero() {
            return this.coefficients[0] === 0;
        }
        /**
         * @return coefficient of x^degree term in this polynomial
         */ getCoefficient(degree) {
            return this.coefficients[this.coefficients.length - 1 - degree];
        }
        /**
         * @return evaluation of this polynomial at a given point
         */ evaluateAt(a) {
            if (a === 0) // Just return the x^0 coefficient
            return this.getCoefficient(0);
            if (a === 1) {
                // Just the sum of the coefficients
                let sum = /*int*/ 0;
                for (let coefficient /*int*/  of this.coefficients)sum = this.field.add(sum, coefficient);
                return sum;
            }
            let result = /*int*/ this.coefficients[0];
            let size = /*int*/ this.coefficients.length;
            for(let i /*int*/  = 1; i < size; i++)result = this.field.add(this.field.multiply(a, result), this.coefficients[i]);
            return result;
        }
        add(other) {
            if (!this.field.equals(other.field)) throw new IllegalArgumentException('ModulusPolys do not have same ModulusGF field');
            if (this.isZero()) return other;
            if (other.isZero()) return this;
            let smallerCoefficients = this.coefficients;
            let largerCoefficients = other.coefficients;
            if (smallerCoefficients.length > largerCoefficients.length) {
                let temp = smallerCoefficients;
                smallerCoefficients = largerCoefficients;
                largerCoefficients = temp;
            }
            let sumDiff = new Int32Array(largerCoefficients.length);
            let lengthDiff = /*int*/ largerCoefficients.length - smallerCoefficients.length;
            // Copy high-order terms only found in higher-degree polynomial's coefficients
            System.arraycopy(largerCoefficients, 0, sumDiff, 0, lengthDiff);
            for(let i /*int*/  = lengthDiff; i < largerCoefficients.length; i++)sumDiff[i] = this.field.add(smallerCoefficients[i - lengthDiff], largerCoefficients[i]);
            return new ModulusPoly(this.field, sumDiff);
        }
        subtract(other) {
            if (!this.field.equals(other.field)) throw new IllegalArgumentException('ModulusPolys do not have same ModulusGF field');
            if (other.isZero()) return this;
            return this.add(other.negative());
        }
        multiply(other) {
            if (other instanceof ModulusPoly) return this.multiplyOther(other);
            return this.multiplyScalar(other);
        }
        multiplyOther(other) {
            if (!this.field.equals(other.field)) throw new IllegalArgumentException('ModulusPolys do not have same ModulusGF field');
            if (this.isZero() || other.isZero()) // return this.field.getZero();
            return new ModulusPoly(this.field, new Int32Array([
                0
            ]));
            let aCoefficients = this.coefficients;
            let aLength = /*int*/ aCoefficients.length;
            let bCoefficients = other.coefficients;
            let bLength = /*int*/ bCoefficients.length;
            let product = new Int32Array(aLength + bLength - 1);
            for(let i /*int*/  = 0; i < aLength; i++){
                let aCoeff = /*int*/ aCoefficients[i];
                for(let j /*int*/  = 0; j < bLength; j++)product[i + j] = this.field.add(product[i + j], this.field.multiply(aCoeff, bCoefficients[j]));
            }
            return new ModulusPoly(this.field, product);
        }
        negative() {
            let size = /*int*/ this.coefficients.length;
            let negativeCoefficients = new Int32Array(size);
            for(let i /*int*/  = 0; i < size; i++)negativeCoefficients[i] = this.field.subtract(0, this.coefficients[i]);
            return new ModulusPoly(this.field, negativeCoefficients);
        }
        multiplyScalar(scalar) {
            if (scalar === 0) return new ModulusPoly(this.field, new Int32Array([
                0
            ]));
            if (scalar === 1) return this;
            let size = /*int*/ this.coefficients.length;
            let product = new Int32Array(size);
            for(let i /*int*/  = 0; i < size; i++)product[i] = this.field.multiply(this.coefficients[i], scalar);
            return new ModulusPoly(this.field, product);
        }
        multiplyByMonomial(degree, coefficient) {
            if (degree < 0) throw new IllegalArgumentException();
            if (coefficient === 0) return new ModulusPoly(this.field, new Int32Array([
                0
            ]));
            let size = /*int*/ this.coefficients.length;
            let product = new Int32Array(size + degree);
            for(let i /*int*/  = 0; i < size; i++)product[i] = this.field.multiply(this.coefficients[i], coefficient);
            return new ModulusPoly(this.field, product);
        }
        /*
        ModulusPoly[] divide(other: ModulusPoly) {
          if (!field.equals(other.field)) {
            throw new IllegalArgumentException("ModulusPolys do not have same ModulusGF field");
          }
          if (other.isZero()) {
            throw new IllegalArgumentException("Divide by 0");
          }
      
          let quotient: ModulusPoly = field.getZero();
          let remainder: ModulusPoly = this;
      
          let denominatorLeadingTerm: /*int/ number = other.getCoefficient(other.getDegree());
          let inverseDenominatorLeadingTerm: /*int/ number = field.inverse(denominatorLeadingTerm);
      
          while (remainder.getDegree() >= other.getDegree() && !remainder.isZero()) {
            let degreeDifference: /*int/ number = remainder.getDegree() - other.getDegree();
            let scale: /*int/ number = field.multiply(remainder.getCoefficient(remainder.getDegree()), inverseDenominatorLeadingTerm);
            let term: ModulusPoly = other.multiplyByMonomial(degreeDifference, scale);
            let iterationQuotient: ModulusPoly = field.buildMonomial(degreeDifference, scale);
            quotient = quotient.add(iterationQuotient);
            remainder = remainder.subtract(term);
          }
      
          return new ModulusPoly[] { quotient, remainder };
        }
        */ // @Override
        toString() {
            let result = new StringBuilder(); // dynamic string size in JS
            for(let degree /*int*/  = this.getDegree(); degree >= 0; degree--){
                let coefficient = /*int*/ this.getCoefficient(degree);
                if (coefficient !== 0) {
                    if (coefficient < 0) {
                        result.append(' - ');
                        coefficient = -coefficient;
                    } else if (result.length() > 0) result.append(' + ');
                    if (degree === 0 || coefficient !== 1) result.append(coefficient);
                    if (degree !== 0) {
                        if (degree === 1) result.append('x');
                        else {
                            result.append('x^');
                            result.append(degree);
                        }
                    }
                }
            }
            return result.toString();
        }
    }
    class ModulusBase {
        add(a, b) {
            return (a + b) % this.modulus;
        }
        subtract(a, b) {
            return (this.modulus + a - b) % this.modulus;
        }
        exp(a) {
            return this.expTable[a];
        }
        log(a) {
            if (a === 0) throw new IllegalArgumentException();
            return this.logTable[a];
        }
        inverse(a) {
            if (a === 0) throw new ArithmeticException();
            return this.expTable[this.modulus - this.logTable[a] - 1];
        }
        multiply(a, b) {
            if (a === 0 || b === 0) return 0;
            return this.expTable[(this.logTable[a] + this.logTable[b]) % (this.modulus - 1)];
        }
        getSize() {
            return this.modulus;
        }
        equals(o) {
            return o === this;
        }
    }
    /*
     * Copyright 2012 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * <p>A field based on powers of a generator integer, modulo some modulus.</p>
     *
     * @author Sean Owen
     * @see com.google.zxing.common.reedsolomon.GenericGF
     */ /*public final*/ class ModulusGF extends ModulusBase {
        // private /*final*/ modulus: /*int*/ number;
        constructor(modulus, generator){
            super();
            this.modulus = modulus;
            this.expTable = new Int32Array(modulus);
            this.logTable = new Int32Array(modulus);
            let x = /*int*/ 1;
            for(let i /*int*/  = 0; i < modulus; i++){
                this.expTable[i] = x;
                x = x * generator % modulus;
            }
            for(let i /*int*/  = 0; i < modulus - 1; i++)this.logTable[this.expTable[i]] = i;
            // logTable[0] == 0 but this should never be used
            this.zero = new ModulusPoly(this, new Int32Array([
                0
            ]));
            this.one = new ModulusPoly(this, new Int32Array([
                1
            ]));
        }
        getZero() {
            return this.zero;
        }
        getOne() {
            return this.one;
        }
        buildMonomial(degree, coefficient) {
            if (degree < 0) throw new IllegalArgumentException();
            if (coefficient === 0) return this.zero;
            let coefficients = new Int32Array(degree + 1);
            coefficients[0] = coefficient;
            return new ModulusPoly(this, coefficients);
        }
    }
    ModulusGF.PDF417_GF = new ModulusGF(PDF417Common.NUMBER_OF_CODEWORDS, 3);
    /*
    * Copyright 2012 ZXing authors
    *
    * Licensed under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License.
    * You may obtain a copy of the License at
    *
    *      http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software
    * distributed under the License is distributed on an "AS IS" BASIS,
    * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    * See the License for the specific language governing permissions and
    * limitations under the License.
    */ /**
     * <p>PDF417 error correction implementation.</p>
     *
     * <p>This <a href="http://en.wikipedia.org/wiki/Reed%E2%80%93Solomon_error_correction#Example">example</a>
     * is quite useful in understanding the algorithm.</p>
     *
     * @author Sean Owen
     * @see com.google.zxing.common.reedsolomon.ReedSolomonDecoder
     */ /*public final*/ class ErrorCorrection {
        constructor(){
            this.field = ModulusGF.PDF417_GF;
        }
        /**
         * @param received received codewords
         * @param numECCodewords number of those codewords used for EC
         * @param erasures location of erasures
         * @return number of errors
         * @throws ChecksumException if errors cannot be corrected, maybe because of too many errors
         */ decode(received, numECCodewords, erasures) {
            let poly = new ModulusPoly(this.field, received);
            let S = new Int32Array(numECCodewords);
            let error = false;
            for(let i /*int*/  = numECCodewords; i > 0; i--){
                let evaluation = poly.evaluateAt(this.field.exp(i));
                S[numECCodewords - i] = evaluation;
                if (evaluation !== 0) error = true;
            }
            if (!error) return 0;
            let knownErrors = this.field.getOne();
            if (erasures != null) for (const erasure of erasures){
                let b = this.field.exp(received.length - 1 - erasure);
                // Add (1 - bx) term:
                let term = new ModulusPoly(this.field, new Int32Array([
                    this.field.subtract(0, b),
                    1
                ]));
                knownErrors = knownErrors.multiply(term);
            }
            let syndrome = new ModulusPoly(this.field, S);
            // syndrome = syndrome.multiply(knownErrors);
            let sigmaOmega = this.runEuclideanAlgorithm(this.field.buildMonomial(numECCodewords, 1), syndrome, numECCodewords);
            let sigma = sigmaOmega[0];
            let omega = sigmaOmega[1];
            // sigma = sigma.multiply(knownErrors);
            let errorLocations = this.findErrorLocations(sigma);
            let errorMagnitudes = this.findErrorMagnitudes(omega, sigma, errorLocations);
            for(let i /*int*/  = 0; i < errorLocations.length; i++){
                let position = received.length - 1 - this.field.log(errorLocations[i]);
                if (position < 0) throw ChecksumException.getChecksumInstance();
                received[position] = this.field.subtract(received[position], errorMagnitudes[i]);
            }
            return errorLocations.length;
        }
        /**
         *
         * @param ModulusPoly
         * @param a
         * @param ModulusPoly
         * @param b
         * @param int
         * @param R
         * @throws ChecksumException
         */ runEuclideanAlgorithm(a, b, R) {
            // Assume a's degree is >= b's
            if (a.getDegree() < b.getDegree()) {
                let temp = a;
                a = b;
                b = temp;
            }
            let rLast = a;
            let r = b;
            let tLast = this.field.getZero();
            let t = this.field.getOne();
            // Run Euclidean algorithm until r's degree is less than R/2
            while(r.getDegree() >= Math.round(R / 2)){
                let rLastLast = rLast;
                let tLastLast = tLast;
                rLast = r;
                tLast = t;
                // Divide rLastLast by rLast, with quotient in q and remainder in r
                if (rLast.isZero()) // Oops, Euclidean algorithm already terminated?
                throw ChecksumException.getChecksumInstance();
                r = rLastLast;
                let q = this.field.getZero();
                let denominatorLeadingTerm = rLast.getCoefficient(rLast.getDegree());
                let dltInverse = this.field.inverse(denominatorLeadingTerm);
                while(r.getDegree() >= rLast.getDegree() && !r.isZero()){
                    let degreeDiff = r.getDegree() - rLast.getDegree();
                    let scale = this.field.multiply(r.getCoefficient(r.getDegree()), dltInverse);
                    q = q.add(this.field.buildMonomial(degreeDiff, scale));
                    r = r.subtract(rLast.multiplyByMonomial(degreeDiff, scale));
                }
                t = q.multiply(tLast).subtract(tLastLast).negative();
            }
            let sigmaTildeAtZero = t.getCoefficient(0);
            if (sigmaTildeAtZero === 0) throw ChecksumException.getChecksumInstance();
            let inverse = this.field.inverse(sigmaTildeAtZero);
            let sigma = t.multiply(inverse);
            let omega = r.multiply(inverse);
            return [
                sigma,
                omega
            ];
        }
        /**
         *
         * @param errorLocator
         * @throws ChecksumException
         */ findErrorLocations(errorLocator) {
            // This is a direct application of Chien's search
            let numErrors = errorLocator.getDegree();
            let result = new Int32Array(numErrors);
            let e = 0;
            for(let i /*int*/  = 1; i < this.field.getSize() && e < numErrors; i++)if (errorLocator.evaluateAt(i) === 0) {
                result[e] = this.field.inverse(i);
                e++;
            }
            if (e !== numErrors) throw ChecksumException.getChecksumInstance();
            return result;
        }
        findErrorMagnitudes(errorEvaluator, errorLocator, errorLocations) {
            let errorLocatorDegree = errorLocator.getDegree();
            let formalDerivativeCoefficients = new Int32Array(errorLocatorDegree);
            for(let i /*int*/  = 1; i <= errorLocatorDegree; i++)formalDerivativeCoefficients[errorLocatorDegree - i] = this.field.multiply(i, errorLocator.getCoefficient(i));
            let formalDerivative = new ModulusPoly(this.field, formalDerivativeCoefficients);
            // This is directly applying Forney's Formula
            let s = errorLocations.length;
            let result = new Int32Array(s);
            for(let i /*int*/  = 0; i < s; i++){
                let xiInverse = this.field.inverse(errorLocations[i]);
                let numerator = this.field.subtract(0, errorEvaluator.evaluateAt(xiInverse));
                let denominator = this.field.inverse(formalDerivative.evaluateAt(xiInverse));
                result[i] = this.field.multiply(numerator, denominator);
            }
            return result;
        }
    }
    /*
    * Copyright 2013 ZXing authors
    *
    * Licensed under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License.
    * You may obtain a copy of the License at
    *
    *      http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software
    * distributed under the License is distributed on an "AS IS" BASIS,
    * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    * See the License for the specific language governing permissions and
    * limitations under the License.
    */ /**
     * @author Guenther Grau
     */ /*final*/ class BoundingBox {
        constructor(image, topLeft, bottomLeft, topRight, bottomRight){
            if (image instanceof BoundingBox) this.constructor_2(image);
            else this.constructor_1(image, topLeft, bottomLeft, topRight, bottomRight);
        }
        /**
         *
         * @param image
         * @param topLeft
         * @param bottomLeft
         * @param topRight
         * @param bottomRight
         *
         * @throws NotFoundException
         */ constructor_1(image, topLeft, bottomLeft, topRight, bottomRight) {
            const leftUnspecified = topLeft == null || bottomLeft == null;
            const rightUnspecified = topRight == null || bottomRight == null;
            if (leftUnspecified && rightUnspecified) throw new NotFoundException();
            if (leftUnspecified) {
                topLeft = new ResultPoint(0, topRight.getY());
                bottomLeft = new ResultPoint(0, bottomRight.getY());
            } else if (rightUnspecified) {
                topRight = new ResultPoint(image.getWidth() - 1, topLeft.getY());
                bottomRight = new ResultPoint(image.getWidth() - 1, bottomLeft.getY());
            }
            this.image = image;
            this.topLeft = topLeft;
            this.bottomLeft = bottomLeft;
            this.topRight = topRight;
            this.bottomRight = bottomRight;
            this.minX = Math.trunc(Math.min(topLeft.getX(), bottomLeft.getX()));
            this.maxX = Math.trunc(Math.max(topRight.getX(), bottomRight.getX()));
            this.minY = Math.trunc(Math.min(topLeft.getY(), topRight.getY()));
            this.maxY = Math.trunc(Math.max(bottomLeft.getY(), bottomRight.getY()));
        }
        constructor_2(boundingBox) {
            this.image = boundingBox.image;
            this.topLeft = boundingBox.getTopLeft();
            this.bottomLeft = boundingBox.getBottomLeft();
            this.topRight = boundingBox.getTopRight();
            this.bottomRight = boundingBox.getBottomRight();
            this.minX = boundingBox.getMinX();
            this.maxX = boundingBox.getMaxX();
            this.minY = boundingBox.getMinY();
            this.maxY = boundingBox.getMaxY();
        }
        /**
         * @throws NotFoundException
         */ static merge(leftBox, rightBox) {
            if (leftBox == null) return rightBox;
            if (rightBox == null) return leftBox;
            return new BoundingBox(leftBox.image, leftBox.topLeft, leftBox.bottomLeft, rightBox.topRight, rightBox.bottomRight);
        }
        /**
         * @throws NotFoundException
         */ addMissingRows(missingStartRows, missingEndRows, isLeft) {
            let newTopLeft = this.topLeft;
            let newBottomLeft = this.bottomLeft;
            let newTopRight = this.topRight;
            let newBottomRight = this.bottomRight;
            if (missingStartRows > 0) {
                let top = isLeft ? this.topLeft : this.topRight;
                let newMinY = Math.trunc(top.getY() - missingStartRows);
                if (newMinY < 0) newMinY = 0;
                let newTop = new ResultPoint(top.getX(), newMinY);
                if (isLeft) newTopLeft = newTop;
                else newTopRight = newTop;
            }
            if (missingEndRows > 0) {
                let bottom = isLeft ? this.bottomLeft : this.bottomRight;
                let newMaxY = Math.trunc(bottom.getY() + missingEndRows);
                if (newMaxY >= this.image.getHeight()) newMaxY = this.image.getHeight() - 1;
                let newBottom = new ResultPoint(bottom.getX(), newMaxY);
                if (isLeft) newBottomLeft = newBottom;
                else newBottomRight = newBottom;
            }
            return new BoundingBox(this.image, newTopLeft, newBottomLeft, newTopRight, newBottomRight);
        }
        getMinX() {
            return this.minX;
        }
        getMaxX() {
            return this.maxX;
        }
        getMinY() {
            return this.minY;
        }
        getMaxY() {
            return this.maxY;
        }
        getTopLeft() {
            return this.topLeft;
        }
        getTopRight() {
            return this.topRight;
        }
        getBottomLeft() {
            return this.bottomLeft;
        }
        getBottomRight() {
            return this.bottomRight;
        }
    }
    /*
     * Copyright 2013 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ // package com.google.zxing.pdf417.decoder;
    /**
     * @author Guenther Grau
     */ /*final*/ class BarcodeMetadata {
        constructor(columnCount, rowCountUpperPart, rowCountLowerPart, errorCorrectionLevel){
            this.columnCount = columnCount;
            this.errorCorrectionLevel = errorCorrectionLevel;
            this.rowCountUpperPart = rowCountUpperPart;
            this.rowCountLowerPart = rowCountLowerPart;
            this.rowCount = rowCountUpperPart + rowCountLowerPart;
        }
        getColumnCount() {
            return this.columnCount;
        }
        getErrorCorrectionLevel() {
            return this.errorCorrectionLevel;
        }
        getRowCount() {
            return this.rowCount;
        }
        getRowCountUpperPart() {
            return this.rowCountUpperPart;
        }
        getRowCountLowerPart() {
            return this.rowCountLowerPart;
        }
    }
    /**
     * Java Formatter class polyfill that works in the JS way.
     */ class Formatter {
        constructor(){
            this.buffer = '';
        }
        /**
         *
         * @see https://stackoverflow.com/a/13439711/4367683
         *
         * @param str
         * @param arr
         */ static form(str, arr) {
            let i = -1;
            function callback(exp, p0, p1, p2, p3, p4) {
                if (exp === '%%') return '%';
                if (arr[++i] === undefined) return undefined;
                exp = p2 ? parseInt(p2.substr(1)) : undefined;
                let base = p3 ? parseInt(p3.substr(1)) : undefined;
                let val;
                switch(p4){
                    case 's':
                        val = arr[i];
                        break;
                    case 'c':
                        val = arr[i][0];
                        break;
                    case 'f':
                        val = parseFloat(arr[i]).toFixed(exp);
                        break;
                    case 'p':
                        val = parseFloat(arr[i]).toPrecision(exp);
                        break;
                    case 'e':
                        val = parseFloat(arr[i]).toExponential(exp);
                        break;
                    case 'x':
                        val = parseInt(arr[i]).toString(base ? base : 16);
                        break;
                    case 'd':
                        val = parseFloat(parseInt(arr[i], base ? base : 10).toPrecision(exp)).toFixed(0);
                        break;
                }
                val = typeof val === 'object' ? JSON.stringify(val) : (+val).toString(base);
                let size = parseInt(p1); /* padding size */ 
                let ch = p1 && p1[0] + '' === '0' ? '0' : ' '; /* isnull? */ 
                while(val.length < size)val = p0 !== undefined ? val + ch : ch + val; /* isminus? */ 
                return val;
            }
            let regex = /%(-)?(0?[0-9]+)?([.][0-9]+)?([#][0-9]+)?([scfpexd%])/g;
            return str.replace(regex, callback);
        }
        /**
         *
         * @param append The new string to append.
         * @param args Argumets values to be formated.
         */ format(append, ...args) {
            this.buffer += Formatter.form(append, args);
        }
        /**
         * Returns the Formatter string value.
         */ toString() {
            return this.buffer;
        }
    }
    /*
     * Copyright 2013 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * @author Guenther Grau
     */ class DetectionResultColumn {
        constructor(boundingBox){
            this.boundingBox = new BoundingBox(boundingBox);
            // this.codewords = new Codeword[boundingBox.getMaxY() - boundingBox.getMinY() + 1];
            this.codewords = new Array(boundingBox.getMaxY() - boundingBox.getMinY() + 1);
        }
        /*final*/ getCodewordNearby(imageRow) {
            let codeword = this.getCodeword(imageRow);
            if (codeword != null) return codeword;
            for(let i = 1; i < DetectionResultColumn.MAX_NEARBY_DISTANCE; i++){
                let nearImageRow = this.imageRowToCodewordIndex(imageRow) - i;
                if (nearImageRow >= 0) {
                    codeword = this.codewords[nearImageRow];
                    if (codeword != null) return codeword;
                }
                nearImageRow = this.imageRowToCodewordIndex(imageRow) + i;
                if (nearImageRow < this.codewords.length) {
                    codeword = this.codewords[nearImageRow];
                    if (codeword != null) return codeword;
                }
            }
            return null;
        }
        /*final int*/ imageRowToCodewordIndex(imageRow) {
            return imageRow - this.boundingBox.getMinY();
        }
        /*final void*/ setCodeword(imageRow, codeword) {
            this.codewords[this.imageRowToCodewordIndex(imageRow)] = codeword;
        }
        /*final*/ getCodeword(imageRow) {
            return this.codewords[this.imageRowToCodewordIndex(imageRow)];
        }
        /*final*/ getBoundingBox() {
            return this.boundingBox;
        }
        /*final*/ getCodewords() {
            return this.codewords;
        }
        // @Override
        toString() {
            const formatter = new Formatter();
            let row = 0;
            for (const codeword of this.codewords){
                if (codeword == null) {
                    formatter.format('%3d:    |   %n', row++);
                    continue;
                }
                formatter.format('%3d: %3d|%3d%n', row++, codeword.getRowNumber(), codeword.getValue());
            }
            return formatter.toString();
        }
    }
    DetectionResultColumn.MAX_NEARBY_DISTANCE = 5;
    /*
     * Copyright 2013 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ // import java.util.ArrayList;
    // import java.util.Collection;
    // import java.util.HashMap;
    // import java.util.Map;
    // import java.util.Map.Entry;
    /**
     * @author Guenther Grau
     */ /*final*/ class BarcodeValue {
        constructor(){
            this.values = new Map();
        }
        /**
         * Add an occurrence of a value
         */ setValue(value) {
            value = Math.trunc(value);
            let confidence = this.values.get(value);
            if (confidence == null) confidence = 0;
            confidence++;
            this.values.set(value, confidence);
        }
        /**
         * Determines the maximum occurrence of a set value and returns all values which were set with this occurrence.
         * @return an array of int, containing the values with the highest occurrence, or null, if no value was set
         */ getValue() {
            let maxConfidence = -1;
            let result = new Array();
            for (const [key, value] of this.values.entries()){
                const entry = {
                    getKey: ()=>key,
                    getValue: ()=>value
                };
                if (entry.getValue() > maxConfidence) {
                    maxConfidence = entry.getValue();
                    result = [];
                    result.push(entry.getKey());
                } else if (entry.getValue() === maxConfidence) result.push(entry.getKey());
            }
            return PDF417Common.toIntArray(result);
        }
        getConfidence(value) {
            return this.values.get(value);
        }
    }
    /*
     * Copyright 2013 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * @author Guenther Grau
     */ /*final*/ class DetectionResultRowIndicatorColumn extends DetectionResultColumn {
        constructor(boundingBox, isLeft){
            super(boundingBox);
            this._isLeft = isLeft;
        }
        setRowNumbers() {
            for (let codeword /*Codeword*/  of this.getCodewords())if (codeword != null) codeword.setRowNumberAsRowIndicatorColumn();
        }
        // TODO implement properly
        // TODO maybe we should add missing codewords to store the correct row number to make
        // finding row numbers for other columns easier
        // use row height count to make detection of invalid row numbers more reliable
        adjustCompleteIndicatorColumnRowNumbers(barcodeMetadata) {
            let codewords = this.getCodewords();
            this.setRowNumbers();
            this.removeIncorrectCodewords(codewords, barcodeMetadata);
            let boundingBox = this.getBoundingBox();
            let top = this._isLeft ? boundingBox.getTopLeft() : boundingBox.getTopRight();
            let bottom = this._isLeft ? boundingBox.getBottomLeft() : boundingBox.getBottomRight();
            let firstRow = this.imageRowToCodewordIndex(Math.trunc(top.getY()));
            let lastRow = this.imageRowToCodewordIndex(Math.trunc(bottom.getY()));
            // We need to be careful using the average row height. Barcode could be skewed so that we have smaller and
            // taller rows
            // float averageRowHeight = (lastRow - firstRow) / /*(float)*/ barcodeMetadata.getRowCount();
            let barcodeRow = -1;
            let maxRowHeight = 1;
            let currentRowHeight = 0;
            for(let codewordsRow /*int*/  = firstRow; codewordsRow < lastRow; codewordsRow++){
                if (codewords[codewordsRow] == null) continue;
                let codeword = codewords[codewordsRow];
                //      float expectedRowNumber = (codewordsRow - firstRow) / averageRowHeight;
                //      if (Math.abs(codeword.getRowNumber() - expectedRowNumber) > 2) {
                //        SimpleLog.log(LEVEL.WARNING,
                //            "Removing codeword, rowNumberSkew too high, codeword[" + codewordsRow + "]: Expected Row: " +
                //                expectedRowNumber + ", RealRow: " + codeword.getRowNumber() + ", value: " + codeword.getValue());
                //        codewords[codewordsRow] = null;
                //      }
                let rowDifference = codeword.getRowNumber() - barcodeRow;
                // TODO improve handling with case where first row indicator doesn't start with 0
                if (rowDifference === 0) currentRowHeight++;
                else if (rowDifference === 1) {
                    maxRowHeight = Math.max(maxRowHeight, currentRowHeight);
                    currentRowHeight = 1;
                    barcodeRow = codeword.getRowNumber();
                } else if (rowDifference < 0 || codeword.getRowNumber() >= barcodeMetadata.getRowCount() || rowDifference > codewordsRow) codewords[codewordsRow] = null;
                else {
                    let checkedRows;
                    if (maxRowHeight > 2) checkedRows = (maxRowHeight - 2) * rowDifference;
                    else checkedRows = rowDifference;
                    let closePreviousCodewordFound = checkedRows >= codewordsRow;
                    for(let i /*int*/  = 1; i <= checkedRows && !closePreviousCodewordFound; i++)// there must be (height * rowDifference) number of codewords missing. For now we assume height = 1.
                    // This should hopefully get rid of most problems already.
                    closePreviousCodewordFound = codewords[codewordsRow - i] != null;
                    if (closePreviousCodewordFound) codewords[codewordsRow] = null;
                    else {
                        barcodeRow = codeword.getRowNumber();
                        currentRowHeight = 1;
                    }
                }
            }
        // return (int) (averageRowHeight + 0.5);
        }
        getRowHeights() {
            let barcodeMetadata = this.getBarcodeMetadata();
            if (barcodeMetadata == null) return null;
            this.adjustIncompleteIndicatorColumnRowNumbers(barcodeMetadata);
            let result = new Int32Array(barcodeMetadata.getRowCount());
            for (let codeword /*Codeword*/  of this.getCodewords())if (codeword != null) {
                let rowNumber = codeword.getRowNumber();
                if (rowNumber >= result.length) continue;
                result[rowNumber]++;
            } // else throw exception?
            return result;
        }
        // TODO maybe we should add missing codewords to store the correct row number to make
        // finding row numbers for other columns easier
        // use row height count to make detection of invalid row numbers more reliable
        adjustIncompleteIndicatorColumnRowNumbers(barcodeMetadata) {
            let boundingBox = this.getBoundingBox();
            let top = this._isLeft ? boundingBox.getTopLeft() : boundingBox.getTopRight();
            let bottom = this._isLeft ? boundingBox.getBottomLeft() : boundingBox.getBottomRight();
            let firstRow = this.imageRowToCodewordIndex(Math.trunc(top.getY()));
            let lastRow = this.imageRowToCodewordIndex(Math.trunc(bottom.getY()));
            // float averageRowHeight = (lastRow - firstRow) / /*(float)*/ barcodeMetadata.getRowCount();
            let codewords = this.getCodewords();
            let barcodeRow = -1;
            for(let codewordsRow /*int*/  = firstRow; codewordsRow < lastRow; codewordsRow++){
                if (codewords[codewordsRow] == null) continue;
                let codeword = codewords[codewordsRow];
                codeword.setRowNumberAsRowIndicatorColumn();
                let rowDifference = codeword.getRowNumber() - barcodeRow;
                // TODO improve handling with case where first row indicator doesn't start with 0
                if (rowDifference === 0) ;
                else if (rowDifference === 1) barcodeRow = codeword.getRowNumber();
                else if (codeword.getRowNumber() >= barcodeMetadata.getRowCount()) codewords[codewordsRow] = null;
                else barcodeRow = codeword.getRowNumber();
            }
        // return (int) (averageRowHeight + 0.5);
        }
        getBarcodeMetadata() {
            let codewords = this.getCodewords();
            let barcodeColumnCount = new BarcodeValue();
            let barcodeRowCountUpperPart = new BarcodeValue();
            let barcodeRowCountLowerPart = new BarcodeValue();
            let barcodeECLevel = new BarcodeValue();
            for (let codeword /*Codeword*/  of codewords){
                if (codeword == null) continue;
                codeword.setRowNumberAsRowIndicatorColumn();
                let rowIndicatorValue = codeword.getValue() % 30;
                let codewordRowNumber = codeword.getRowNumber();
                if (!this._isLeft) codewordRowNumber += 2;
                switch(codewordRowNumber % 3){
                    case 0:
                        barcodeRowCountUpperPart.setValue(rowIndicatorValue * 3 + 1);
                        break;
                    case 1:
                        barcodeECLevel.setValue(rowIndicatorValue / 3);
                        barcodeRowCountLowerPart.setValue(rowIndicatorValue % 3);
                        break;
                    case 2:
                        barcodeColumnCount.setValue(rowIndicatorValue + 1);
                        break;
                }
            }
            // Maybe we should check if we have ambiguous values?
            if (barcodeColumnCount.getValue().length === 0 || barcodeRowCountUpperPart.getValue().length === 0 || barcodeRowCountLowerPart.getValue().length === 0 || barcodeECLevel.getValue().length === 0 || barcodeColumnCount.getValue()[0] < 1 || barcodeRowCountUpperPart.getValue()[0] + barcodeRowCountLowerPart.getValue()[0] < PDF417Common.MIN_ROWS_IN_BARCODE || barcodeRowCountUpperPart.getValue()[0] + barcodeRowCountLowerPart.getValue()[0] > PDF417Common.MAX_ROWS_IN_BARCODE) return null;
            let barcodeMetadata = new BarcodeMetadata(barcodeColumnCount.getValue()[0], barcodeRowCountUpperPart.getValue()[0], barcodeRowCountLowerPart.getValue()[0], barcodeECLevel.getValue()[0]);
            this.removeIncorrectCodewords(codewords, barcodeMetadata);
            return barcodeMetadata;
        }
        removeIncorrectCodewords(codewords, barcodeMetadata) {
            // Remove codewords which do not match the metadata
            // TODO Maybe we should keep the incorrect codewords for the start and end positions?
            for(let codewordRow /*int*/  = 0; codewordRow < codewords.length; codewordRow++){
                let codeword = codewords[codewordRow];
                if (codewords[codewordRow] == null) continue;
                let rowIndicatorValue = codeword.getValue() % 30;
                let codewordRowNumber = codeword.getRowNumber();
                if (codewordRowNumber > barcodeMetadata.getRowCount()) {
                    codewords[codewordRow] = null;
                    continue;
                }
                if (!this._isLeft) codewordRowNumber += 2;
                switch(codewordRowNumber % 3){
                    case 0:
                        if (rowIndicatorValue * 3 + 1 !== barcodeMetadata.getRowCountUpperPart()) codewords[codewordRow] = null;
                        break;
                    case 1:
                        if (Math.trunc(rowIndicatorValue / 3) !== barcodeMetadata.getErrorCorrectionLevel() || rowIndicatorValue % 3 !== barcodeMetadata.getRowCountLowerPart()) codewords[codewordRow] = null;
                        break;
                    case 2:
                        if (rowIndicatorValue + 1 !== barcodeMetadata.getColumnCount()) codewords[codewordRow] = null;
                        break;
                }
            }
        }
        isLeft() {
            return this._isLeft;
        }
        // @Override
        toString() {
            return 'IsLeft: ' + this._isLeft + '\n' + super.toString();
        }
    }
    /*
     * Copyright 2013 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * @author Guenther Grau
     */ /*final*/ class DetectionResult {
        constructor(barcodeMetadata, boundingBox){
            /*final*/ this.ADJUST_ROW_NUMBER_SKIP = 2;
            this.barcodeMetadata = barcodeMetadata;
            this.barcodeColumnCount = barcodeMetadata.getColumnCount();
            this.boundingBox = boundingBox;
            // this.detectionResultColumns = new DetectionResultColumn[this.barcodeColumnCount + 2];
            this.detectionResultColumns = new Array(this.barcodeColumnCount + 2);
        }
        getDetectionResultColumns() {
            this.adjustIndicatorColumnRowNumbers(this.detectionResultColumns[0]);
            this.adjustIndicatorColumnRowNumbers(this.detectionResultColumns[this.barcodeColumnCount + 1]);
            let unadjustedCodewordCount = PDF417Common.MAX_CODEWORDS_IN_BARCODE;
            let previousUnadjustedCount;
            do {
                previousUnadjustedCount = unadjustedCodewordCount;
                unadjustedCodewordCount = this.adjustRowNumbersAndGetCount();
            }while (unadjustedCodewordCount > 0 && unadjustedCodewordCount < previousUnadjustedCount);
            return this.detectionResultColumns;
        }
        adjustIndicatorColumnRowNumbers(detectionResultColumn) {
            if (detectionResultColumn != null) detectionResultColumn.adjustCompleteIndicatorColumnRowNumbers(this.barcodeMetadata);
        }
        // TODO ensure that no detected codewords with unknown row number are left
        // we should be able to estimate the row height and use it as a hint for the row number
        // we should also fill the rows top to bottom and bottom to top
        /**
         * @return number of codewords which don't have a valid row number. Note that the count is not accurate as codewords
         * will be counted several times. It just serves as an indicator to see when we can stop adjusting row numbers
         */ adjustRowNumbersAndGetCount() {
            let unadjustedCount = this.adjustRowNumbersByRow();
            if (unadjustedCount === 0) return 0;
            for(let barcodeColumn /*int*/  = 1; barcodeColumn < this.barcodeColumnCount + 1; barcodeColumn++){
                let codewords = this.detectionResultColumns[barcodeColumn].getCodewords();
                for(let codewordsRow /*int*/  = 0; codewordsRow < codewords.length; codewordsRow++){
                    if (codewords[codewordsRow] == null) continue;
                    if (!codewords[codewordsRow].hasValidRowNumber()) this.adjustRowNumbers(barcodeColumn, codewordsRow, codewords);
                }
            }
            return unadjustedCount;
        }
        adjustRowNumbersByRow() {
            this.adjustRowNumbersFromBothRI();
            // TODO we should only do full row adjustments if row numbers of left and right row indicator column match.
            // Maybe it's even better to calculated the height (rows: d) and divide it by the number of barcode
            // rows. This, together with the LRI and RRI row numbers should allow us to get a good estimate where a row
            // number starts and ends.
            let unadjustedCount = this.adjustRowNumbersFromLRI();
            return unadjustedCount + this.adjustRowNumbersFromRRI();
        }
        adjustRowNumbersFromBothRI() {
            if (this.detectionResultColumns[0] == null || this.detectionResultColumns[this.barcodeColumnCount + 1] == null) return;
            let LRIcodewords = this.detectionResultColumns[0].getCodewords();
            let RRIcodewords = this.detectionResultColumns[this.barcodeColumnCount + 1].getCodewords();
            for(let codewordsRow /*int*/  = 0; codewordsRow < LRIcodewords.length; codewordsRow++){
                if (LRIcodewords[codewordsRow] != null && RRIcodewords[codewordsRow] != null && LRIcodewords[codewordsRow].getRowNumber() === RRIcodewords[codewordsRow].getRowNumber()) for(let barcodeColumn /*int*/  = 1; barcodeColumn <= this.barcodeColumnCount; barcodeColumn++){
                    let codeword = this.detectionResultColumns[barcodeColumn].getCodewords()[codewordsRow];
                    if (codeword == null) continue;
                    codeword.setRowNumber(LRIcodewords[codewordsRow].getRowNumber());
                    if (!codeword.hasValidRowNumber()) this.detectionResultColumns[barcodeColumn].getCodewords()[codewordsRow] = null;
                }
            }
        }
        adjustRowNumbersFromRRI() {
            if (this.detectionResultColumns[this.barcodeColumnCount + 1] == null) return 0;
            let unadjustedCount = 0;
            let codewords = this.detectionResultColumns[this.barcodeColumnCount + 1].getCodewords();
            for(let codewordsRow /*int*/  = 0; codewordsRow < codewords.length; codewordsRow++){
                if (codewords[codewordsRow] == null) continue;
                let rowIndicatorRowNumber = codewords[codewordsRow].getRowNumber();
                let invalidRowCounts = 0;
                for(let barcodeColumn /*int*/  = this.barcodeColumnCount + 1; barcodeColumn > 0 && invalidRowCounts < this.ADJUST_ROW_NUMBER_SKIP; barcodeColumn--){
                    let codeword = this.detectionResultColumns[barcodeColumn].getCodewords()[codewordsRow];
                    if (codeword != null) {
                        invalidRowCounts = DetectionResult.adjustRowNumberIfValid(rowIndicatorRowNumber, invalidRowCounts, codeword);
                        if (!codeword.hasValidRowNumber()) unadjustedCount++;
                    }
                }
            }
            return unadjustedCount;
        }
        adjustRowNumbersFromLRI() {
            if (this.detectionResultColumns[0] == null) return 0;
            let unadjustedCount = 0;
            let codewords = this.detectionResultColumns[0].getCodewords();
            for(let codewordsRow /*int*/  = 0; codewordsRow < codewords.length; codewordsRow++){
                if (codewords[codewordsRow] == null) continue;
                let rowIndicatorRowNumber = codewords[codewordsRow].getRowNumber();
                let invalidRowCounts = 0;
                for(let barcodeColumn /*int*/  = 1; barcodeColumn < this.barcodeColumnCount + 1 && invalidRowCounts < this.ADJUST_ROW_NUMBER_SKIP; barcodeColumn++){
                    let codeword = this.detectionResultColumns[barcodeColumn].getCodewords()[codewordsRow];
                    if (codeword != null) {
                        invalidRowCounts = DetectionResult.adjustRowNumberIfValid(rowIndicatorRowNumber, invalidRowCounts, codeword);
                        if (!codeword.hasValidRowNumber()) unadjustedCount++;
                    }
                }
            }
            return unadjustedCount;
        }
        static adjustRowNumberIfValid(rowIndicatorRowNumber, invalidRowCounts, codeword) {
            if (codeword == null) return invalidRowCounts;
            if (!codeword.hasValidRowNumber()) {
                if (codeword.isValidRowNumber(rowIndicatorRowNumber)) {
                    codeword.setRowNumber(rowIndicatorRowNumber);
                    invalidRowCounts = 0;
                } else ++invalidRowCounts;
            }
            return invalidRowCounts;
        }
        adjustRowNumbers(barcodeColumn, codewordsRow, codewords) {
            if (!this.detectionResultColumns[barcodeColumn - 1]) return;
            let codeword = codewords[codewordsRow];
            let previousColumnCodewords = this.detectionResultColumns[barcodeColumn - 1].getCodewords();
            let nextColumnCodewords = previousColumnCodewords;
            if (this.detectionResultColumns[barcodeColumn + 1] != null) nextColumnCodewords = this.detectionResultColumns[barcodeColumn + 1].getCodewords();
            // let otherCodewords: Codeword[] = new Codeword[14];
            let otherCodewords = new Array(14);
            otherCodewords[2] = previousColumnCodewords[codewordsRow];
            otherCodewords[3] = nextColumnCodewords[codewordsRow];
            if (codewordsRow > 0) {
                otherCodewords[0] = codewords[codewordsRow - 1];
                otherCodewords[4] = previousColumnCodewords[codewordsRow - 1];
                otherCodewords[5] = nextColumnCodewords[codewordsRow - 1];
            }
            if (codewordsRow > 1) {
                otherCodewords[8] = codewords[codewordsRow - 2];
                otherCodewords[10] = previousColumnCodewords[codewordsRow - 2];
                otherCodewords[11] = nextColumnCodewords[codewordsRow - 2];
            }
            if (codewordsRow < codewords.length - 1) {
                otherCodewords[1] = codewords[codewordsRow + 1];
                otherCodewords[6] = previousColumnCodewords[codewordsRow + 1];
                otherCodewords[7] = nextColumnCodewords[codewordsRow + 1];
            }
            if (codewordsRow < codewords.length - 2) {
                otherCodewords[9] = codewords[codewordsRow + 2];
                otherCodewords[12] = previousColumnCodewords[codewordsRow + 2];
                otherCodewords[13] = nextColumnCodewords[codewordsRow + 2];
            }
            for (let otherCodeword of otherCodewords){
                if (DetectionResult.adjustRowNumber(codeword, otherCodeword)) return;
            }
        }
        /**
         * @return true, if row number was adjusted, false otherwise
         */ static adjustRowNumber(codeword, otherCodeword) {
            if (otherCodeword == null) return false;
            if (otherCodeword.hasValidRowNumber() && otherCodeword.getBucket() === codeword.getBucket()) {
                codeword.setRowNumber(otherCodeword.getRowNumber());
                return true;
            }
            return false;
        }
        getBarcodeColumnCount() {
            return this.barcodeColumnCount;
        }
        getBarcodeRowCount() {
            return this.barcodeMetadata.getRowCount();
        }
        getBarcodeECLevel() {
            return this.barcodeMetadata.getErrorCorrectionLevel();
        }
        setBoundingBox(boundingBox) {
            this.boundingBox = boundingBox;
        }
        getBoundingBox() {
            return this.boundingBox;
        }
        setDetectionResultColumn(barcodeColumn, detectionResultColumn) {
            this.detectionResultColumns[barcodeColumn] = detectionResultColumn;
        }
        getDetectionResultColumn(barcodeColumn) {
            return this.detectionResultColumns[barcodeColumn];
        }
        // @Override
        toString() {
            let rowIndicatorColumn = this.detectionResultColumns[0];
            if (rowIndicatorColumn == null) rowIndicatorColumn = this.detectionResultColumns[this.barcodeColumnCount + 1];
            // try (
            let formatter = new Formatter();
            // ) {
            for(let codewordsRow /*int*/  = 0; codewordsRow < rowIndicatorColumn.getCodewords().length; codewordsRow++){
                formatter.format('CW %3d:', codewordsRow);
                for(let barcodeColumn /*int*/  = 0; barcodeColumn < this.barcodeColumnCount + 2; barcodeColumn++){
                    if (this.detectionResultColumns[barcodeColumn] == null) {
                        formatter.format('    |   ');
                        continue;
                    }
                    let codeword = this.detectionResultColumns[barcodeColumn].getCodewords()[codewordsRow];
                    if (codeword == null) {
                        formatter.format('    |   ');
                        continue;
                    }
                    formatter.format(' %3d|%3d', codeword.getRowNumber(), codeword.getValue());
                }
                formatter.format('%n');
            }
            return formatter.toString();
        // }
        }
    }
    /*
     * Copyright 2013 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ // package com.google.zxing.pdf417.decoder;
    /**
     * @author Guenther Grau
     */ /*final*/ class Codeword {
        constructor(startX, endX, bucket, value){
            this.rowNumber = Codeword.BARCODE_ROW_UNKNOWN;
            this.startX = Math.trunc(startX);
            this.endX = Math.trunc(endX);
            this.bucket = Math.trunc(bucket);
            this.value = Math.trunc(value);
        }
        hasValidRowNumber() {
            return this.isValidRowNumber(this.rowNumber);
        }
        isValidRowNumber(rowNumber) {
            return rowNumber !== Codeword.BARCODE_ROW_UNKNOWN && this.bucket === rowNumber % 3 * 3;
        }
        setRowNumberAsRowIndicatorColumn() {
            this.rowNumber = Math.trunc(Math.trunc(this.value / 30) * 3 + Math.trunc(this.bucket / 3));
        }
        getWidth() {
            return this.endX - this.startX;
        }
        getStartX() {
            return this.startX;
        }
        getEndX() {
            return this.endX;
        }
        getBucket() {
            return this.bucket;
        }
        getValue() {
            return this.value;
        }
        getRowNumber() {
            return this.rowNumber;
        }
        setRowNumber(rowNumber) {
            this.rowNumber = rowNumber;
        }
        //   @Override
        toString() {
            return this.rowNumber + '|' + this.value;
        }
    }
    Codeword.BARCODE_ROW_UNKNOWN = -1;
    /*
    * Copyright 2013 ZXing authors
    *
    * Licensed under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License.
    * You may obtain a copy of the License at
    *
    *      http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software
    * distributed under the License is distributed on an "AS IS" BASIS,
    * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    * See the License for the specific language governing permissions and
    * limitations under the License.
    */ /**
     * @author Guenther Grau
     * @author creatale GmbH (christoph.schulz@creatale.de)
     */ /*final*/ class PDF417CodewordDecoder {
        /* @note
         * this action have to be performed before first use of class
         * - static constructor
         * working with 32bit float (based from Java logic)
        */ static initialize() {
            // Pre-computes the symbol ratio table.
            for(/*int*/ let i = 0; i < PDF417Common.SYMBOL_TABLE.length; i++){
                let currentSymbol = PDF417Common.SYMBOL_TABLE[i];
                let currentBit = currentSymbol & 0x1;
                for(/*int*/ let j = 0; j < PDF417Common.BARS_IN_MODULE; j++){
                    let size = 0.0;
                    while((currentSymbol & 0x1) === currentBit){
                        size += 1.0;
                        currentSymbol >>= 1;
                    }
                    currentBit = currentSymbol & 0x1;
                    if (!PDF417CodewordDecoder.RATIOS_TABLE[i]) PDF417CodewordDecoder.RATIOS_TABLE[i] = new Array(PDF417Common.BARS_IN_MODULE);
                    PDF417CodewordDecoder.RATIOS_TABLE[i][PDF417Common.BARS_IN_MODULE - j - 1] = Math.fround(size / PDF417Common.MODULES_IN_CODEWORD);
                }
            }
            this.bSymbolTableReady = true;
        }
        static getDecodedValue(moduleBitCount) {
            let decodedValue = PDF417CodewordDecoder.getDecodedCodewordValue(PDF417CodewordDecoder.sampleBitCounts(moduleBitCount));
            if (decodedValue !== -1) return decodedValue;
            return PDF417CodewordDecoder.getClosestDecodedValue(moduleBitCount);
        }
        static sampleBitCounts(moduleBitCount) {
            let bitCountSum = MathUtils.sum(moduleBitCount);
            let result = new Int32Array(PDF417Common.BARS_IN_MODULE);
            let bitCountIndex = 0;
            let sumPreviousBits = 0;
            for(/*int*/ let i = 0; i < PDF417Common.MODULES_IN_CODEWORD; i++){
                let sampleIndex = bitCountSum / (2 * PDF417Common.MODULES_IN_CODEWORD) + i * bitCountSum / PDF417Common.MODULES_IN_CODEWORD;
                if (sumPreviousBits + moduleBitCount[bitCountIndex] <= sampleIndex) {
                    sumPreviousBits += moduleBitCount[bitCountIndex];
                    bitCountIndex++;
                }
                result[bitCountIndex]++;
            }
            return result;
        }
        static getDecodedCodewordValue(moduleBitCount) {
            let decodedValue = PDF417CodewordDecoder.getBitValue(moduleBitCount);
            return PDF417Common.getCodeword(decodedValue) === -1 ? -1 : decodedValue;
        }
        static getBitValue(moduleBitCount) {
            let result = /*long*/ 0;
            for(let /*int*/ i = 0; i < moduleBitCount.length; i++)for(/*int*/ let bit = 0; bit < moduleBitCount[i]; bit++)result = result << 1 | (i % 2 === 0 ? 1 : 0);
            return Math.trunc(result);
        }
        // working with 32bit float (as in Java)
        static getClosestDecodedValue(moduleBitCount) {
            let bitCountSum = MathUtils.sum(moduleBitCount);
            let bitCountRatios = new Array(PDF417Common.BARS_IN_MODULE);
            if (bitCountSum > 1) for(let /*int*/ i = 0; i < bitCountRatios.length; i++)bitCountRatios[i] = Math.fround(moduleBitCount[i] / bitCountSum);
            let bestMatchError = Float.MAX_VALUE;
            let bestMatch = -1;
            if (!this.bSymbolTableReady) PDF417CodewordDecoder.initialize();
            for(/*int*/ let j = 0; j < PDF417CodewordDecoder.RATIOS_TABLE.length; j++){
                let error = 0.0;
                let ratioTableRow = PDF417CodewordDecoder.RATIOS_TABLE[j];
                for(/*int*/ let k = 0; k < PDF417Common.BARS_IN_MODULE; k++){
                    let diff = Math.fround(ratioTableRow[k] - bitCountRatios[k]);
                    error += Math.fround(diff * diff);
                    if (error >= bestMatchError) break;
                }
                if (error < bestMatchError) {
                    bestMatchError = error;
                    bestMatch = PDF417Common.SYMBOL_TABLE[j];
                }
            }
            return bestMatch;
        }
    }
    // flag that the table is ready for use
    PDF417CodewordDecoder.bSymbolTableReady = false;
    PDF417CodewordDecoder.RATIOS_TABLE = new Array(PDF417Common.SYMBOL_TABLE.length).map((x)=>x = new Array(PDF417Common.BARS_IN_MODULE));
    /*
     * Copyright 2013 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ // package com.google.zxing.pdf417;
    /**
     * @author Guenther Grau
     */ /*public final*/ class PDF417ResultMetadata {
        constructor(){
            this.segmentCount = -1;
            this.fileSize = -1;
            this.timestamp = -1;
            this.checksum = -1;
        }
        /**
         * The Segment ID represents the segment of the whole file distributed over different symbols.
         *
         * @return File segment index
         */ getSegmentIndex() {
            return this.segmentIndex;
        }
        setSegmentIndex(segmentIndex) {
            this.segmentIndex = segmentIndex;
        }
        /**
         * Is the same for each related PDF417 symbol
         *
         * @return File ID
         */ getFileId() {
            return this.fileId;
        }
        setFileId(fileId) {
            this.fileId = fileId;
        }
        /**
         * @return always null
         * @deprecated use dedicated already parsed fields
         */ //   @Deprecated
        getOptionalData() {
            return this.optionalData;
        }
        /**
         * @param optionalData old optional data format as int array
         * @deprecated parse and use new fields
         */ //   @Deprecated
        setOptionalData(optionalData) {
            this.optionalData = optionalData;
        }
        /**
         * @return true if it is the last segment
         */ isLastSegment() {
            return this.lastSegment;
        }
        setLastSegment(lastSegment) {
            this.lastSegment = lastSegment;
        }
        /**
         * @return count of segments, -1 if not set
         */ getSegmentCount() {
            return this.segmentCount;
        }
        setSegmentCount(segmentCount /*int*/ ) {
            this.segmentCount = segmentCount;
        }
        getSender() {
            return this.sender || null;
        }
        setSender(sender) {
            this.sender = sender;
        }
        getAddressee() {
            return this.addressee || null;
        }
        setAddressee(addressee) {
            this.addressee = addressee;
        }
        /**
         * Filename of the encoded file
         *
         * @return filename
         */ getFileName() {
            return this.fileName;
        }
        setFileName(fileName) {
            this.fileName = fileName;
        }
        /**
         * filesize in bytes of the encoded file
         *
         * @return filesize in bytes, -1 if not set
         */ getFileSize() {
            return this.fileSize;
        }
        setFileSize(fileSize /*long*/ ) {
            this.fileSize = fileSize;
        }
        /**
         * 16-bit CRC checksum using CCITT-16
         *
         * @return crc checksum, -1 if not set
         */ getChecksum() {
            return this.checksum;
        }
        setChecksum(checksum /*int*/ ) {
            this.checksum = checksum;
        }
        /**
         * unix epock timestamp, elapsed seconds since 1970-01-01
         *
         * @return elapsed seconds, -1 if not set
         */ getTimestamp() {
            return this.timestamp;
        }
        setTimestamp(timestamp /*long*/ ) {
            this.timestamp = timestamp;
        }
    }
    /**
     * Ponyfill for Java's Long class.
     */ class Long {
        /**
         * Parses a string to a number, since JS has no really Int64.
         *
         * @param num Numeric string.
         * @param radix Destination radix.
         */ static parseLong(num, radix) {
            return parseInt(num, radix);
        }
    }
    /**
     * Custom Error class of type Exception.
     */ class NullPointerException extends Exception {
    }
    NullPointerException.kind = 'NullPointerException';
    /*
     * Copyright (c) 1994, 2004, Oracle and/or its affiliates. All rights reserved.
     * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
     *
     * This code is free software; you can redistribute it and/or modify it
     * under the terms of the GNU General Public License version 2 only, as
     * published by the Free Software Foundation.  Oracle designates this
     * particular file as subject to the "Classpath" exception as provided
     * by Oracle in the LICENSE file that accompanied this code.
     *
     * This code is distributed in the hope that it will be useful, but WITHOUT
     * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or
     * FITNESS FOR A PARTICULAR PURPOSE.  See the GNU General Public License
     * version 2 for more details (a copy is included in the LICENSE file that
     * accompanied this code).
     *
     * You should have received a copy of the GNU General Public License version
     * 2 along with this work; if not, write to the Free Software Foundation,
     * Inc., 51 Franklin St, Fifth Floor, Boston, MA 02110-1301 USA.
     *
     * Please contact Oracle, 500 Oracle Parkway, Redwood Shores, CA 94065 USA
     * or visit www.oracle.com if you need additional information or have any
     * questions.
     */ // package java.io;
    /**
     * This abstract class is the superclass of all classes representing
     * an output stream of bytes. An output stream accepts output bytes
     * and sends them to some sink.
     * <p>
     * Applications that need to define a subclass of
     * <code>OutputStream</code> must always provide at least a method
     * that writes one byte of output.
     *
     * @author  Arthur van Hoff
     * @see     java.io.BufferedOutputStream
     * @see     java.io.ByteArrayOutputStream
     * @see     java.io.DataOutputStream
     * @see     java.io.FilterOutputStream
     * @see     java.io.InputStream
     * @see     java.io.OutputStream#write(int)
     * @since   JDK1.0
     */ /*public*/ class OutputStream {
        /**
         * Writes <code>b.length</code> bytes from the specified byte array
         * to this output stream. The general contract for <code>write(b)</code>
         * is that it should have exactly the same effect as the call
         * <code>write(b, 0, b.length)</code>.
         *
         * @param      b   the data.
         * @exception  IOException  if an I/O error occurs.
         * @see        java.io.OutputStream#write(byte[], int, int)
         */ writeBytes(b) {
            this.writeBytesOffset(b, 0, b.length);
        }
        /**
         * Writes <code>len</code> bytes from the specified byte array
         * starting at offset <code>off</code> to this output stream.
         * The general contract for <code>write(b, off, len)</code> is that
         * some of the bytes in the array <code>b</code> are written to the
         * output stream in order; element <code>b[off]</code> is the first
         * byte written and <code>b[off+len-1]</code> is the last byte written
         * by this operation.
         * <p>
         * The <code>write</code> method of <code>OutputStream</code> calls
         * the write method of one argument on each of the bytes to be
         * written out. Subclasses are encouraged to override this method and
         * provide a more efficient implementation.
         * <p>
         * If <code>b</code> is <code>null</code>, a
         * <code>NullPointerException</code> is thrown.
         * <p>
         * If <code>off</code> is negative, or <code>len</code> is negative, or
         * <code>off+len</code> is greater than the length of the array
         * <code>b</code>, then an <tt>IndexOutOfBoundsException</tt> is thrown.
         *
         * @param      b     the data.
         * @param      off   the start offset in the data.
         * @param      len   the number of bytes to write.
         * @exception  IOException  if an I/O error occurs. In particular,
         *             an <code>IOException</code> is thrown if the output
         *             stream is closed.
         */ writeBytesOffset(b, off, len) {
            if (b == null) throw new NullPointerException();
            else if (off < 0 || off > b.length || len < 0 || off + len > b.length || off + len < 0) throw new IndexOutOfBoundsException();
            else if (len === 0) return;
            for(let i = 0; i < len; i++)this.write(b[off + i]);
        }
        /**
         * Flushes this output stream and forces any buffered output bytes
         * to be written out. The general contract of <code>flush</code> is
         * that calling it is an indication that, if any bytes previously
         * written have been buffered by the implementation of the output
         * stream, such bytes should immediately be written to their
         * intended destination.
         * <p>
         * If the intended destination of this stream is an abstraction provided by
         * the underlying operating system, for example a file, then flushing the
         * stream guarantees only that bytes previously written to the stream are
         * passed to the operating system for writing; it does not guarantee that
         * they are actually written to a physical device such as a disk drive.
         * <p>
         * The <code>flush</code> method of <code>OutputStream</code> does nothing.
         *
         * @exception  IOException  if an I/O error occurs.
         */ flush() {}
        /**
         * Closes this output stream and releases any system resources
         * associated with this stream. The general contract of <code>close</code>
         * is that it closes the output stream. A closed stream cannot perform
         * output operations and cannot be reopened.
         * <p>
         * The <code>close</code> method of <code>OutputStream</code> does nothing.
         *
         * @exception  IOException  if an I/O error occurs.
         */ close() {}
    }
    /**
     * Custom Error class of type Exception.
     */ class OutOfMemoryError extends Exception {
    }
    /*
     * Copyright (c) 1994, 2010, Oracle and/or its affiliates. All rights reserved.
     * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
     *
     * This code is free software; you can redistribute it and/or modify it
     * under the terms of the GNU General Public License version 2 only, as
     * published by the Free Software Foundation.  Oracle designates this
     * particular file as subject to the "Classpath" exception as provided
     * by Oracle in the LICENSE file that accompanied this code.
     *
     * This code is distributed in the hope that it will be useful, but WITHOUT
     * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or
     * FITNESS FOR A PARTICULAR PURPOSE.  See the GNU General Public License
     * version 2 for more details (a copy is included in the LICENSE file that
     * accompanied this code).
     *
     * You should have received a copy of the GNU General Public License version
     * 2 along with this work; if not, write to the Free Software Foundation,
     * Inc., 51 Franklin St, Fifth Floor, Boston, MA 02110-1301 USA.
     *
     * Please contact Oracle, 500 Oracle Parkway, Redwood Shores, CA 94065 USA
     * or visit www.oracle.com if you need additional information or have any
     * questions.
     */ /**
     * This class implements an output stream in which the data is
     * written into a byte array. The buffer automatically grows as data
     * is written to it.
     * The data can be retrieved using <code>toByteArray()</code> and
     * <code>toString()</code>.
     * <p>
     * Closing a <tt>ByteArrayOutputStream</tt> has no effect. The methods in
     * this class can be called after the stream has been closed without
     * generating an <tt>IOException</tt>.
     *
     * @author  Arthur van Hoff
     * @since   JDK1.0
     */ /*public*/ class ByteArrayOutputStream extends OutputStream {
        /**
         * Creates a new byte array output stream. The buffer capacity is
         * initially 32 bytes, though its size increases if necessary.
         */ // public constructor() {
        //     this(32);
        // }
        /**
         * Creates a new byte array output stream, with a buffer capacity of
         * the specified size, in bytes.
         *
         * @param   size   the initial size.
         * @exception  IllegalArgumentException if size is negative.
         */ constructor(size = 32){
            super();
            /**
             * The number of valid bytes in the buffer.
             */ this.count = 0;
            if (size < 0) throw new IllegalArgumentException('Negative initial size: ' + size);
            this.buf = new Uint8Array(size);
        }
        /**
         * Increases the capacity if necessary to ensure that it can hold
         * at least the number of elements specified by the minimum
         * capacity argument.
         *
         * @param minCapacity the desired minimum capacity
         * @throws OutOfMemoryError if {@code minCapacity < 0}.  This is
         * interpreted as a request for the unsatisfiably large capacity
         * {@code (long) Integer.MAX_VALUE + (minCapacity - Integer.MAX_VALUE)}.
         */ ensureCapacity(minCapacity) {
            // overflow-conscious code
            if (minCapacity - this.buf.length > 0) this.grow(minCapacity);
        }
        /**
         * Increases the capacity to ensure that it can hold at least the
         * number of elements specified by the minimum capacity argument.
         *
         * @param minCapacity the desired minimum capacity
         */ grow(minCapacity) {
            // overflow-conscious code
            let oldCapacity = this.buf.length;
            let newCapacity = oldCapacity << 1;
            if (newCapacity - minCapacity < 0) newCapacity = minCapacity;
            if (newCapacity < 0) {
                if (minCapacity < 0) throw new OutOfMemoryError();
                newCapacity = Integer.MAX_VALUE;
            }
            this.buf = Arrays.copyOfUint8Array(this.buf, newCapacity);
        }
        /**
         * Writes the specified byte to this byte array output stream.
         *
         * @param   b   the byte to be written.
         */ write(b) {
            this.ensureCapacity(this.count + 1);
            this.buf[this.count] = /*(byte)*/ b;
            this.count += 1;
        }
        /**
         * Writes <code>len</code> bytes from the specified byte array
         * starting at offset <code>off</code> to this byte array output stream.
         *
         * @param   b     the data.
         * @param   off   the start offset in the data.
         * @param   len   the number of bytes to write.
         */ writeBytesOffset(b, off, len) {
            if (off < 0 || off > b.length || len < 0 || off + len - b.length > 0) throw new IndexOutOfBoundsException();
            this.ensureCapacity(this.count + len);
            System.arraycopy(b, off, this.buf, this.count, len);
            this.count += len;
        }
        /**
         * Writes the complete contents of this byte array output stream to
         * the specified output stream argument, as if by calling the output
         * stream's write method using <code>out.write(buf, 0, count)</code>.
         *
         * @param      out   the output stream to which to write the data.
         * @exception  IOException  if an I/O error occurs.
         */ writeTo(out) {
            out.writeBytesOffset(this.buf, 0, this.count);
        }
        /**
         * Resets the <code>count</code> field of this byte array output
         * stream to zero, so that all currently accumulated output in the
         * output stream is discarded. The output stream can be used again,
         * reusing the already allocated buffer space.
         *
         * @see     java.io.ByteArrayInputStream#count
         */ reset() {
            this.count = 0;
        }
        /**
         * Creates a newly allocated byte array. Its size is the current
         * size of this output stream and the valid contents of the buffer
         * have been copied into it.
         *
         * @return  the current contents of this output stream, as a byte array.
         * @see     java.io.ByteArrayOutputStream#size()
         */ toByteArray() {
            return Arrays.copyOfUint8Array(this.buf, this.count);
        }
        /**
         * Returns the current size of the buffer.
         *
         * @return  the value of the <code>count</code> field, which is the number
         *          of valid bytes in this output stream.
         * @see     java.io.ByteArrayOutputStream#count
         */ size() {
            return this.count;
        }
        toString(param) {
            if (!param) return this.toString_void();
            if (typeof param === 'string') return this.toString_string(param);
            return this.toString_number(param);
        }
        /**
         * Converts the buffer's contents into a string decoding bytes using the
         * platform's default character set. The length of the new <tt>String</tt>
         * is a function of the character set, and hence may not be equal to the
         * size of the buffer.
         *
         * <p> This method always replaces malformed-input and unmappable-character
         * sequences with the default replacement string for the platform's
         * default character set. The {@linkplain java.nio.charset.CharsetDecoder}
         * class should be used when more control over the decoding process is
         * required.
         *
         * @return String decoded from the buffer's contents.
         * @since  JDK1.1
         */ toString_void() {
            return new String(this.buf /*, 0, this.count*/ ).toString();
        }
        /**
         * Converts the buffer's contents into a string by decoding the bytes using
         * the specified {@link java.nio.charset.Charset charsetName}. The length of
         * the new <tt>String</tt> is a function of the charset, and hence may not be
         * equal to the length of the byte array.
         *
         * <p> This method always replaces malformed-input and unmappable-character
         * sequences with this charset's default replacement string. The {@link
         * java.nio.charset.CharsetDecoder} class should be used when more control
         * over the decoding process is required.
         *
         * @param  charsetName  the name of a supported
         *              {@linkplain java.nio.charset.Charset </code>charset<code>}
         * @return String decoded from the buffer's contents.
         * @exception  UnsupportedEncodingException
         *             If the named charset is not supported
         * @since   JDK1.1
         */ toString_string(charsetName) {
            return new String(this.buf /*, 0, this.count, charsetName*/ ).toString();
        }
        /**
         * Creates a newly allocated string. Its size is the current size of
         * the output stream and the valid contents of the buffer have been
         * copied into it. Each character <i>c</i> in the resulting string is
         * constructed from the corresponding element <i>b</i> in the byte
         * array such that:
         * <blockquote><pre>
         *     c == (char)(((hibyte &amp; 0xff) &lt;&lt; 8) | (b &amp; 0xff))
         * </pre></blockquote>
         *
         * @deprecated This method does not properly convert bytes into characters.
         * As of JDK&nbsp;1.1, the preferred way to do this is via the
         * <code>toString(String enc)</code> method, which takes an encoding-name
         * argument, or the <code>toString()</code> method, which uses the
         * platform's default character encoding.
         *
         * @param      hibyte    the high byte of each resulting Unicode character.
         * @return     the current contents of the output stream, as a string.
         * @see        java.io.ByteArrayOutputStream#size()
         * @see        java.io.ByteArrayOutputStream#toString(String)
         * @see        java.io.ByteArrayOutputStream#toString()
         */ // @Deprecated
        toString_number(hibyte) {
            return new String(this.buf /*, hibyte, 0, this.count*/ ).toString();
        }
        /**
         * Closing a <tt>ByteArrayOutputStream</tt> has no effect. The methods in
         * this class can be called after the stream has been closed without
         * generating an <tt>IOException</tt>.
         * <p>
         *
         * @throws IOException
         */ close() {}
    }
    /*
     * Copyright 2009 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /*private*/ var Mode$2;
    (function(Mode) {
        Mode[Mode["ALPHA"] = 0] = "ALPHA";
        Mode[Mode["LOWER"] = 1] = "LOWER";
        Mode[Mode["MIXED"] = 2] = "MIXED";
        Mode[Mode["PUNCT"] = 3] = "PUNCT";
        Mode[Mode["ALPHA_SHIFT"] = 4] = "ALPHA_SHIFT";
        Mode[Mode["PUNCT_SHIFT"] = 5] = "PUNCT_SHIFT";
    })(Mode$2 || (Mode$2 = {}));
    /**
     * Indirectly access the global BigInt constructor, it
     * allows browsers that doesn't support BigInt to run
     * the library without breaking due to "undefined BigInt"
     * errors.
     */ function getBigIntConstructor() {
        if (typeof window !== 'undefined') return window['BigInt'] || null;
        if (typeof $parcel$global !== 'undefined') return $parcel$global['BigInt'] || null;
        if (typeof self !== 'undefined') return self['BigInt'] || null;
        throw new Error('Can\'t search globals for BigInt!');
    }
    /**
     * Used to store the BigInt constructor.
     */ let BigInteger;
    /**
     * This function creates a bigint value. It allows browsers
     * that doesn't support BigInt to run the rest of the library
     * by not directly accessing the BigInt constructor.
     */ function createBigInt(num) {
        if (typeof BigInteger === 'undefined') BigInteger = getBigIntConstructor();
        if (BigInteger === null) throw new Error('BigInt is not supported!');
        return BigInteger(num);
    }
    function getEXP900() {
        // in Java - array with length = 16
        let EXP900 = [];
        EXP900[0] = createBigInt(1);
        let nineHundred = createBigInt(900);
        EXP900[1] = nineHundred;
        // in Java - array with length = 16
        for(let i /*int*/  = 2; i < 16; i++)EXP900[i] = EXP900[i - 1] * nineHundred;
        return EXP900;
    }
    /**
     * <p>This class contains the methods for decoding the PDF417 codewords.</p>
     *
     * @author SITA Lab (kevin.osullivan@sita.aero)
     * @author Guenther Grau
     */ /*final*/ class DecodedBitStreamParser$2 {
        //   private DecodedBitStreamParser() {
        // }
        /**
         *
         * @param codewords
         * @param ecLevel
         *
         * @throws FormatException
         */ static decode(codewords, ecLevel) {
            // pass encoding to result (will be used for decode symbols in byte mode)
            let result = new StringBuilder('');
            // let encoding: Charset = StandardCharsets.ISO_8859_1;
            let encoding = CharacterSetECI.ISO8859_1;
            /**
             * @note the next command is specific from this TypeScript library
             * because TS can't properly cast some values to char and
             * convert it to string later correctly due to encoding
             * differences from Java version. As reported here:
             * https://github.com/zxing-js/library/pull/264/files#r382831593
             */ result.enableDecoding(encoding);
            // Get compaction mode
            let codeIndex = 1;
            let code = codewords[codeIndex++];
            let resultMetadata = new PDF417ResultMetadata();
            while(codeIndex < codewords[0]){
                switch(code){
                    case DecodedBitStreamParser$2.TEXT_COMPACTION_MODE_LATCH:
                        codeIndex = DecodedBitStreamParser$2.textCompaction(codewords, codeIndex, result);
                        break;
                    case DecodedBitStreamParser$2.BYTE_COMPACTION_MODE_LATCH:
                    case DecodedBitStreamParser$2.BYTE_COMPACTION_MODE_LATCH_6:
                        codeIndex = DecodedBitStreamParser$2.byteCompaction(code, codewords, encoding, codeIndex, result);
                        break;
                    case DecodedBitStreamParser$2.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                        result.append(/*(char)*/ codewords[codeIndex++]);
                        break;
                    case DecodedBitStreamParser$2.NUMERIC_COMPACTION_MODE_LATCH:
                        codeIndex = DecodedBitStreamParser$2.numericCompaction(codewords, codeIndex, result);
                        break;
                    case DecodedBitStreamParser$2.ECI_CHARSET:
                        let charsetECI = CharacterSetECI.getCharacterSetECIByValue(codewords[codeIndex++]);
                        break;
                    case DecodedBitStreamParser$2.ECI_GENERAL_PURPOSE:
                        // Can't do anything with generic ECI; skip its 2 characters
                        codeIndex += 2;
                        break;
                    case DecodedBitStreamParser$2.ECI_USER_DEFINED:
                        // Can't do anything with user ECI; skip its 1 character
                        codeIndex++;
                        break;
                    case DecodedBitStreamParser$2.BEGIN_MACRO_PDF417_CONTROL_BLOCK:
                        codeIndex = DecodedBitStreamParser$2.decodeMacroBlock(codewords, codeIndex, resultMetadata);
                        break;
                    case DecodedBitStreamParser$2.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
                    case DecodedBitStreamParser$2.MACRO_PDF417_TERMINATOR:
                        // Should not see these outside a macro block
                        throw new FormatException();
                    default:
                        // Default to text compaction. During testing numerous barcodes
                        // appeared to be missing the starting mode. In these cases defaulting
                        // to text compaction seems to work.
                        codeIndex--;
                        codeIndex = DecodedBitStreamParser$2.textCompaction(codewords, codeIndex, result);
                        break;
                }
                if (codeIndex < codewords.length) code = codewords[codeIndex++];
                else throw FormatException.getFormatInstance();
            }
            if (result.length() === 0) throw FormatException.getFormatInstance();
            let decoderResult = new DecoderResult(null, result.toString(), null, ecLevel);
            decoderResult.setOther(resultMetadata);
            return decoderResult;
        }
        /**
         *
         * @param int
         * @param param1
         * @param codewords
         * @param int
         * @param codeIndex
         * @param PDF417ResultMetadata
         * @param resultMetadata
         *
         * @throws FormatException
         */ // @SuppressWarnings("deprecation")
        static decodeMacroBlock(codewords, codeIndex, resultMetadata) {
            if (codeIndex + DecodedBitStreamParser$2.NUMBER_OF_SEQUENCE_CODEWORDS > codewords[0]) // we must have at least two bytes left for the segment index
            throw FormatException.getFormatInstance();
            let segmentIndexArray = new Int32Array(DecodedBitStreamParser$2.NUMBER_OF_SEQUENCE_CODEWORDS);
            for(let i /*int*/  = 0; i < DecodedBitStreamParser$2.NUMBER_OF_SEQUENCE_CODEWORDS; i++, codeIndex++)segmentIndexArray[i] = codewords[codeIndex];
            resultMetadata.setSegmentIndex(Integer.parseInt(DecodedBitStreamParser$2.decodeBase900toBase10(segmentIndexArray, DecodedBitStreamParser$2.NUMBER_OF_SEQUENCE_CODEWORDS)));
            let fileId = new StringBuilder();
            codeIndex = DecodedBitStreamParser$2.textCompaction(codewords, codeIndex, fileId);
            resultMetadata.setFileId(fileId.toString());
            let optionalFieldsStart = -1;
            if (codewords[codeIndex] === DecodedBitStreamParser$2.BEGIN_MACRO_PDF417_OPTIONAL_FIELD) optionalFieldsStart = codeIndex + 1;
            while(codeIndex < codewords[0])switch(codewords[codeIndex]){
                case DecodedBitStreamParser$2.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
                    codeIndex++;
                    switch(codewords[codeIndex]){
                        case DecodedBitStreamParser$2.MACRO_PDF417_OPTIONAL_FIELD_FILE_NAME:
                            let fileName = new StringBuilder();
                            codeIndex = DecodedBitStreamParser$2.textCompaction(codewords, codeIndex + 1, fileName);
                            resultMetadata.setFileName(fileName.toString());
                            break;
                        case DecodedBitStreamParser$2.MACRO_PDF417_OPTIONAL_FIELD_SENDER:
                            let sender = new StringBuilder();
                            codeIndex = DecodedBitStreamParser$2.textCompaction(codewords, codeIndex + 1, sender);
                            resultMetadata.setSender(sender.toString());
                            break;
                        case DecodedBitStreamParser$2.MACRO_PDF417_OPTIONAL_FIELD_ADDRESSEE:
                            let addressee = new StringBuilder();
                            codeIndex = DecodedBitStreamParser$2.textCompaction(codewords, codeIndex + 1, addressee);
                            resultMetadata.setAddressee(addressee.toString());
                            break;
                        case DecodedBitStreamParser$2.MACRO_PDF417_OPTIONAL_FIELD_SEGMENT_COUNT:
                            let segmentCount = new StringBuilder();
                            codeIndex = DecodedBitStreamParser$2.numericCompaction(codewords, codeIndex + 1, segmentCount);
                            resultMetadata.setSegmentCount(Integer.parseInt(segmentCount.toString()));
                            break;
                        case DecodedBitStreamParser$2.MACRO_PDF417_OPTIONAL_FIELD_TIME_STAMP:
                            let timestamp = new StringBuilder();
                            codeIndex = DecodedBitStreamParser$2.numericCompaction(codewords, codeIndex + 1, timestamp);
                            resultMetadata.setTimestamp(Long.parseLong(timestamp.toString()));
                            break;
                        case DecodedBitStreamParser$2.MACRO_PDF417_OPTIONAL_FIELD_CHECKSUM:
                            let checksum = new StringBuilder();
                            codeIndex = DecodedBitStreamParser$2.numericCompaction(codewords, codeIndex + 1, checksum);
                            resultMetadata.setChecksum(Integer.parseInt(checksum.toString()));
                            break;
                        case DecodedBitStreamParser$2.MACRO_PDF417_OPTIONAL_FIELD_FILE_SIZE:
                            let fileSize = new StringBuilder();
                            codeIndex = DecodedBitStreamParser$2.numericCompaction(codewords, codeIndex + 1, fileSize);
                            resultMetadata.setFileSize(Long.parseLong(fileSize.toString()));
                            break;
                        default:
                            throw FormatException.getFormatInstance();
                    }
                    break;
                case DecodedBitStreamParser$2.MACRO_PDF417_TERMINATOR:
                    codeIndex++;
                    resultMetadata.setLastSegment(true);
                    break;
                default:
                    throw FormatException.getFormatInstance();
            }
            // copy optional fields to additional options
            if (optionalFieldsStart !== -1) {
                let optionalFieldsLength = codeIndex - optionalFieldsStart;
                if (resultMetadata.isLastSegment()) // do not include terminator
                optionalFieldsLength--;
                resultMetadata.setOptionalData(Arrays.copyOfRange(codewords, optionalFieldsStart, optionalFieldsStart + optionalFieldsLength));
            }
            return codeIndex;
        }
        /**
         * Text Compaction mode (see 5.4.1.5) permits all printable ASCII characters to be
         * encoded, i.e. values 32 - 126 inclusive in accordance with ISO/IEC 646 (IRV), as
         * well as selected control characters.
         *
         * @param codewords The array of codewords (data + error)
         * @param codeIndex The current index into the codeword array.
         * @param result    The decoded data is appended to the result.
         * @return The next index into the codeword array.
         */ static textCompaction(codewords, codeIndex, result) {
            // 2 character per codeword
            let textCompactionData = new Int32Array((codewords[0] - codeIndex) * 2);
            // Used to hold the byte compaction value if there is a mode shift
            let byteCompactionData = new Int32Array((codewords[0] - codeIndex) * 2);
            let index = 0;
            let end = false;
            while(codeIndex < codewords[0] && !end){
                let code = codewords[codeIndex++];
                if (code < DecodedBitStreamParser$2.TEXT_COMPACTION_MODE_LATCH) {
                    textCompactionData[index] = code / 30;
                    textCompactionData[index + 1] = code % 30;
                    index += 2;
                } else switch(code){
                    case DecodedBitStreamParser$2.TEXT_COMPACTION_MODE_LATCH:
                        // reinitialize text compaction mode to alpha sub mode
                        textCompactionData[index++] = DecodedBitStreamParser$2.TEXT_COMPACTION_MODE_LATCH;
                        break;
                    case DecodedBitStreamParser$2.BYTE_COMPACTION_MODE_LATCH:
                    case DecodedBitStreamParser$2.BYTE_COMPACTION_MODE_LATCH_6:
                    case DecodedBitStreamParser$2.NUMERIC_COMPACTION_MODE_LATCH:
                    case DecodedBitStreamParser$2.BEGIN_MACRO_PDF417_CONTROL_BLOCK:
                    case DecodedBitStreamParser$2.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
                    case DecodedBitStreamParser$2.MACRO_PDF417_TERMINATOR:
                        codeIndex--;
                        end = true;
                        break;
                    case DecodedBitStreamParser$2.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                        // The Mode Shift codeword 913 shall cause a temporary
                        // switch from Text Compaction mode to Byte Compaction mode.
                        // This switch shall be in effect for only the next codeword,
                        // after which the mode shall revert to the prevailing sub-mode
                        // of the Text Compaction mode. Codeword 913 is only available
                        // in Text Compaction mode; its use is described in 5.4.2.4.
                        textCompactionData[index] = DecodedBitStreamParser$2.MODE_SHIFT_TO_BYTE_COMPACTION_MODE;
                        code = codewords[codeIndex++];
                        byteCompactionData[index] = code;
                        index++;
                        break;
                }
            }
            DecodedBitStreamParser$2.decodeTextCompaction(textCompactionData, byteCompactionData, index, result);
            return codeIndex;
        }
        /**
         * The Text Compaction mode includes all the printable ASCII characters
         * (i.e. values from 32 to 126) and three ASCII control characters: HT or tab
         * (9: e), LF or line feed (10: e), and CR or carriage
         * return (13: e). The Text Compaction mode also includes various latch
         * and shift characters which are used exclusively within the mode. The Text
         * Compaction mode encodes up to 2 characters per codeword. The compaction rules
         * for converting data into PDF417 codewords are defined in 5.4.2.2. The sub-mode
         * switches are defined in 5.4.2.3.
         *
         * @param textCompactionData The text compaction data.
         * @param byteCompactionData The byte compaction data if there
         *                           was a mode shift.
         * @param length             The size of the text compaction and byte compaction data.
         * @param result             The decoded data is appended to the result.
         */ static decodeTextCompaction(textCompactionData, byteCompactionData, length, result) {
            // Beginning from an initial state of the Alpha sub-mode
            // The default compaction mode for PDF417 in effect at the start of each symbol shall always be Text
            // Compaction mode Alpha sub-mode (alphabetic: uppercase). A latch codeword from another mode to the Text
            // Compaction mode shall always switch to the Text Compaction Alpha sub-mode.
            let subMode = Mode$2.ALPHA;
            let priorToShiftMode = Mode$2.ALPHA;
            let i = 0;
            while(i < length){
                let subModeCh = textCompactionData[i];
                let ch = /*char*/ '';
                switch(subMode){
                    case Mode$2.ALPHA:
                        // Alpha (alphabetic: uppercase)
                        if (subModeCh < 26) // Upper case Alpha Character
                        // Note: 65 = 'A' ASCII -> there is byte code of symbol
                        ch = /*(char)('A' + subModeCh) */ String.fromCharCode(65 + subModeCh);
                        else switch(subModeCh){
                            case 26:
                                ch = ' ';
                                break;
                            case DecodedBitStreamParser$2.LL:
                                subMode = Mode$2.LOWER;
                                break;
                            case DecodedBitStreamParser$2.ML:
                                subMode = Mode$2.MIXED;
                                break;
                            case DecodedBitStreamParser$2.PS:
                                // Shift to punctuation
                                priorToShiftMode = subMode;
                                subMode = Mode$2.PUNCT_SHIFT;
                                break;
                            case DecodedBitStreamParser$2.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                                result.append(/*(char)*/ byteCompactionData[i]);
                                break;
                            case DecodedBitStreamParser$2.TEXT_COMPACTION_MODE_LATCH:
                                subMode = Mode$2.ALPHA;
                                break;
                        }
                        break;
                    case Mode$2.LOWER:
                        // Lower (alphabetic: lowercase)
                        if (subModeCh < 26) ch = /*(char)('a' + subModeCh)*/ String.fromCharCode(97 + subModeCh);
                        else switch(subModeCh){
                            case 26:
                                ch = ' ';
                                break;
                            case DecodedBitStreamParser$2.AS:
                                // Shift to alpha
                                priorToShiftMode = subMode;
                                subMode = Mode$2.ALPHA_SHIFT;
                                break;
                            case DecodedBitStreamParser$2.ML:
                                subMode = Mode$2.MIXED;
                                break;
                            case DecodedBitStreamParser$2.PS:
                                // Shift to punctuation
                                priorToShiftMode = subMode;
                                subMode = Mode$2.PUNCT_SHIFT;
                                break;
                            case DecodedBitStreamParser$2.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                                // TODO Does this need to use the current character encoding? See other occurrences below
                                result.append(/*(char)*/ byteCompactionData[i]);
                                break;
                            case DecodedBitStreamParser$2.TEXT_COMPACTION_MODE_LATCH:
                                subMode = Mode$2.ALPHA;
                                break;
                        }
                        break;
                    case Mode$2.MIXED:
                        // Mixed (punctuation: e)
                        if (subModeCh < DecodedBitStreamParser$2.PL) ch = DecodedBitStreamParser$2.MIXED_CHARS[subModeCh];
                        else switch(subModeCh){
                            case DecodedBitStreamParser$2.PL:
                                subMode = Mode$2.PUNCT;
                                break;
                            case 26:
                                ch = ' ';
                                break;
                            case DecodedBitStreamParser$2.LL:
                                subMode = Mode$2.LOWER;
                                break;
                            case DecodedBitStreamParser$2.AL:
                                subMode = Mode$2.ALPHA;
                                break;
                            case DecodedBitStreamParser$2.PS:
                                // Shift to punctuation
                                priorToShiftMode = subMode;
                                subMode = Mode$2.PUNCT_SHIFT;
                                break;
                            case DecodedBitStreamParser$2.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                                result.append(/*(char)*/ byteCompactionData[i]);
                                break;
                            case DecodedBitStreamParser$2.TEXT_COMPACTION_MODE_LATCH:
                                subMode = Mode$2.ALPHA;
                                break;
                        }
                        break;
                    case Mode$2.PUNCT:
                        // Punctuation
                        if (subModeCh < DecodedBitStreamParser$2.PAL) ch = DecodedBitStreamParser$2.PUNCT_CHARS[subModeCh];
                        else switch(subModeCh){
                            case DecodedBitStreamParser$2.PAL:
                                subMode = Mode$2.ALPHA;
                                break;
                            case DecodedBitStreamParser$2.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                                result.append(/*(char)*/ byteCompactionData[i]);
                                break;
                            case DecodedBitStreamParser$2.TEXT_COMPACTION_MODE_LATCH:
                                subMode = Mode$2.ALPHA;
                                break;
                        }
                        break;
                    case Mode$2.ALPHA_SHIFT:
                        // Restore sub-mode
                        subMode = priorToShiftMode;
                        if (subModeCh < 26) ch = /*(char)('A' + subModeCh)*/ String.fromCharCode(65 + subModeCh);
                        else switch(subModeCh){
                            case 26:
                                ch = ' ';
                                break;
                            case DecodedBitStreamParser$2.TEXT_COMPACTION_MODE_LATCH:
                                subMode = Mode$2.ALPHA;
                                break;
                        }
                        break;
                    case Mode$2.PUNCT_SHIFT:
                        // Restore sub-mode
                        subMode = priorToShiftMode;
                        if (subModeCh < DecodedBitStreamParser$2.PAL) ch = DecodedBitStreamParser$2.PUNCT_CHARS[subModeCh];
                        else switch(subModeCh){
                            case DecodedBitStreamParser$2.PAL:
                                subMode = Mode$2.ALPHA;
                                break;
                            case DecodedBitStreamParser$2.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                                // PS before Shift-to-Byte is used as a padding character,
                                // see 5.4.2.4 of the specification
                                result.append(/*(char)*/ byteCompactionData[i]);
                                break;
                            case DecodedBitStreamParser$2.TEXT_COMPACTION_MODE_LATCH:
                                subMode = Mode$2.ALPHA;
                                break;
                        }
                        break;
                }
                // if (ch !== 0) {
                if (ch !== '') // Append decoded character to result
                result.append(ch);
                i++;
            }
        }
        /**
         * Byte Compaction mode (see 5.4.3) permits all 256 possible 8-bit byte values to be encoded.
         * This includes all ASCII characters value 0 to 127 inclusive and provides for international
         * character set support.
         *
         * @param mode      The byte compaction mode i.e. 901 or 924
         * @param codewords The array of codewords (data + error)
         * @param encoding  Currently active character encoding
         * @param codeIndex The current index into the codeword array.
         * @param result    The decoded data is appended to the result.
         * @return The next index into the codeword array.
         */ static byteCompaction(mode, codewords, encoding, codeIndex, result) {
            let decodedBytes = new ByteArrayOutputStream();
            let count = 0;
            let value = /*long*/ 0;
            let end = false;
            switch(mode){
                case DecodedBitStreamParser$2.BYTE_COMPACTION_MODE_LATCH:
                    // Total number of Byte Compaction characters to be encoded
                    // is not a multiple of 6
                    let byteCompactedCodewords = new Int32Array(6);
                    let nextCode = codewords[codeIndex++];
                    while(codeIndex < codewords[0] && !end){
                        byteCompactedCodewords[count++] = nextCode;
                        // Base 900
                        value = 900 * value + nextCode;
                        nextCode = codewords[codeIndex++];
                        // perhaps it should be ok to check only nextCode >= TEXT_COMPACTION_MODE_LATCH
                        switch(nextCode){
                            case DecodedBitStreamParser$2.TEXT_COMPACTION_MODE_LATCH:
                            case DecodedBitStreamParser$2.BYTE_COMPACTION_MODE_LATCH:
                            case DecodedBitStreamParser$2.NUMERIC_COMPACTION_MODE_LATCH:
                            case DecodedBitStreamParser$2.BYTE_COMPACTION_MODE_LATCH_6:
                            case DecodedBitStreamParser$2.BEGIN_MACRO_PDF417_CONTROL_BLOCK:
                            case DecodedBitStreamParser$2.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
                            case DecodedBitStreamParser$2.MACRO_PDF417_TERMINATOR:
                                codeIndex--;
                                end = true;
                                break;
                            default:
                                if (count % 5 === 0 && count > 0) {
                                    // Decode every 5 codewords
                                    // Convert to Base 256
                                    for(let j /*int*/  = 0; j < 6; ++j)/* @note
                                         * JavaScript stores numbers as 64 bits floating point numbers, but all bitwise operations are performed on 32 bits binary numbers.
                                         * So the next bitwise operation could not be done with simple numbers
                                         */ decodedBytes.write(/*(byte)*/ Number(createBigInt(value) >> createBigInt(8 * (5 - j))));
                                    value = 0;
                                    count = 0;
                                }
                                break;
                        }
                    }
                    // if the end of all codewords is reached the last codeword needs to be added
                    if (codeIndex === codewords[0] && nextCode < DecodedBitStreamParser$2.TEXT_COMPACTION_MODE_LATCH) byteCompactedCodewords[count++] = nextCode;
                    // If Byte Compaction mode is invoked with codeword 901,
                    // the last group of codewords is interpreted directly
                    // as one byte per codeword, without compaction.
                    for(let i /*int*/  = 0; i < count; i++)decodedBytes.write(/*(byte)*/ byteCompactedCodewords[i]);
                    break;
                case DecodedBitStreamParser$2.BYTE_COMPACTION_MODE_LATCH_6:
                    // Total number of Byte Compaction characters to be encoded
                    // is an integer multiple of 6
                    while(codeIndex < codewords[0] && !end){
                        let code = codewords[codeIndex++];
                        if (code < DecodedBitStreamParser$2.TEXT_COMPACTION_MODE_LATCH) {
                            count++;
                            // Base 900
                            value = 900 * value + code;
                        } else switch(code){
                            case DecodedBitStreamParser$2.TEXT_COMPACTION_MODE_LATCH:
                            case DecodedBitStreamParser$2.BYTE_COMPACTION_MODE_LATCH:
                            case DecodedBitStreamParser$2.NUMERIC_COMPACTION_MODE_LATCH:
                            case DecodedBitStreamParser$2.BYTE_COMPACTION_MODE_LATCH_6:
                            case DecodedBitStreamParser$2.BEGIN_MACRO_PDF417_CONTROL_BLOCK:
                            case DecodedBitStreamParser$2.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
                            case DecodedBitStreamParser$2.MACRO_PDF417_TERMINATOR:
                                codeIndex--;
                                end = true;
                                break;
                        }
                        if (count % 5 === 0 && count > 0) {
                            // Decode every 5 codewords
                            // Convert to Base 256
                            /* @note
                             * JavaScript stores numbers as 64 bits floating point numbers, but all bitwise operations are performed on 32 bits binary numbers.
                             * So the next bitwise operation could not be done with simple numbers
                            */ for(let j /*int*/  = 0; j < 6; ++j)decodedBytes.write(/*(byte)*/ Number(createBigInt(value) >> createBigInt(8 * (5 - j))));
                            value = 0;
                            count = 0;
                        }
                    }
                    break;
            }
            result.append(StringEncoding.decode(decodedBytes.toByteArray(), encoding));
            return codeIndex;
        }
        /**
         * Numeric Compaction mode (see 5.4.4) permits efficient encoding of numeric data strings.
         *
         * @param codewords The array of codewords (data + error)
         * @param codeIndex The current index into the codeword array.
         * @param result    The decoded data is appended to the result.
         * @return The next index into the codeword array.
         *
         * @throws FormatException
         */ static numericCompaction(codewords, codeIndex /*int*/ , result) {
            let count = 0;
            let end = false;
            let numericCodewords = new Int32Array(DecodedBitStreamParser$2.MAX_NUMERIC_CODEWORDS);
            while(codeIndex < codewords[0] && !end){
                let code = codewords[codeIndex++];
                if (codeIndex === codewords[0]) end = true;
                if (code < DecodedBitStreamParser$2.TEXT_COMPACTION_MODE_LATCH) {
                    numericCodewords[count] = code;
                    count++;
                } else switch(code){
                    case DecodedBitStreamParser$2.TEXT_COMPACTION_MODE_LATCH:
                    case DecodedBitStreamParser$2.BYTE_COMPACTION_MODE_LATCH:
                    case DecodedBitStreamParser$2.BYTE_COMPACTION_MODE_LATCH_6:
                    case DecodedBitStreamParser$2.BEGIN_MACRO_PDF417_CONTROL_BLOCK:
                    case DecodedBitStreamParser$2.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
                    case DecodedBitStreamParser$2.MACRO_PDF417_TERMINATOR:
                        codeIndex--;
                        end = true;
                        break;
                }
                if ((count % DecodedBitStreamParser$2.MAX_NUMERIC_CODEWORDS === 0 || code === DecodedBitStreamParser$2.NUMERIC_COMPACTION_MODE_LATCH || end) && count > 0) {
                    // Re-invoking Numeric Compaction mode (by using codeword 902
                    // while in Numeric Compaction mode) serves  to terminate the
                    // current Numeric Compaction mode grouping as described in 5.4.4.2,
                    // and then to start a new one grouping.
                    result.append(DecodedBitStreamParser$2.decodeBase900toBase10(numericCodewords, count));
                    count = 0;
                }
            }
            return codeIndex;
        }
        /**
         * Convert a list of Numeric Compacted codewords from Base 900 to Base 10.
         *
         * @param codewords The array of codewords
         * @param count     The number of codewords
         * @return The decoded string representing the Numeric data.
         *
         * EXAMPLE
         * Encode the fifteen digit numeric string 000213298174000
         * Prefix the numeric string with a 1 and set the initial value of
         * t = 1 000 213 298 174 000
         * Calculate codeword 0
         * d0 = 1 000 213 298 174 000 mod 900 = 200
         *
         * t = 1 000 213 298 174 000 div 900 = 1 111 348 109 082
         * Calculate codeword 1
         * d1 = 1 111 348 109 082 mod 900 = 282
         *
         * t = 1 111 348 109 082 div 900 = 1 234 831 232
         * Calculate codeword 2
         * d2 = 1 234 831 232 mod 900 = 632
         *
         * t = 1 234 831 232 div 900 = 1 372 034
         * Calculate codeword 3
         * d3 = 1 372 034 mod 900 = 434
         *
         * t = 1 372 034 div 900 = 1 524
         * Calculate codeword 4
         * d4 = 1 524 mod 900 = 624
         *
         * t = 1 524 div 900 = 1
         * Calculate codeword 5
         * d5 = 1 mod 900 = 1
         * t = 1 div 900 = 0
         * Codeword sequence is: 1, 624, 434, 632, 282, 200
         *
         * Decode the above codewords involves
         *   1 x 900 power of 5 + 624 x 900 power of 4 + 434 x 900 power of 3 +
         * 632 x 900 power of 2 + 282 x 900 power of 1 + 200 x 900 power of 0 = 1000213298174000
         *
         * Remove leading 1 =>  Result is 000213298174000
         *
         * @throws FormatException
         */ static decodeBase900toBase10(codewords, count) {
            let result = createBigInt(0);
            for(let i /*int*/  = 0; i < count; i++)result += DecodedBitStreamParser$2.EXP900[count - i - 1] * createBigInt(codewords[i]);
            let resultString = result.toString();
            if (resultString.charAt(0) !== '1') throw new FormatException();
            return resultString.substring(1);
        }
    }
    DecodedBitStreamParser$2.TEXT_COMPACTION_MODE_LATCH = 900;
    DecodedBitStreamParser$2.BYTE_COMPACTION_MODE_LATCH = 901;
    DecodedBitStreamParser$2.NUMERIC_COMPACTION_MODE_LATCH = 902;
    DecodedBitStreamParser$2.BYTE_COMPACTION_MODE_LATCH_6 = 924;
    DecodedBitStreamParser$2.ECI_USER_DEFINED = 925;
    DecodedBitStreamParser$2.ECI_GENERAL_PURPOSE = 926;
    DecodedBitStreamParser$2.ECI_CHARSET = 927;
    DecodedBitStreamParser$2.BEGIN_MACRO_PDF417_CONTROL_BLOCK = 928;
    DecodedBitStreamParser$2.BEGIN_MACRO_PDF417_OPTIONAL_FIELD = 923;
    DecodedBitStreamParser$2.MACRO_PDF417_TERMINATOR = 922;
    DecodedBitStreamParser$2.MODE_SHIFT_TO_BYTE_COMPACTION_MODE = 913;
    DecodedBitStreamParser$2.MAX_NUMERIC_CODEWORDS = 15;
    DecodedBitStreamParser$2.MACRO_PDF417_OPTIONAL_FIELD_FILE_NAME = 0;
    DecodedBitStreamParser$2.MACRO_PDF417_OPTIONAL_FIELD_SEGMENT_COUNT = 1;
    DecodedBitStreamParser$2.MACRO_PDF417_OPTIONAL_FIELD_TIME_STAMP = 2;
    DecodedBitStreamParser$2.MACRO_PDF417_OPTIONAL_FIELD_SENDER = 3;
    DecodedBitStreamParser$2.MACRO_PDF417_OPTIONAL_FIELD_ADDRESSEE = 4;
    DecodedBitStreamParser$2.MACRO_PDF417_OPTIONAL_FIELD_FILE_SIZE = 5;
    DecodedBitStreamParser$2.MACRO_PDF417_OPTIONAL_FIELD_CHECKSUM = 6;
    DecodedBitStreamParser$2.PL = 25;
    DecodedBitStreamParser$2.LL = 27;
    DecodedBitStreamParser$2.AS = 27;
    DecodedBitStreamParser$2.ML = 28;
    DecodedBitStreamParser$2.AL = 28;
    DecodedBitStreamParser$2.PS = 29;
    DecodedBitStreamParser$2.PAL = 29;
    DecodedBitStreamParser$2.PUNCT_CHARS = ';<>@[\\]_`~!\r\t,:\n-.$/"|*()?{}\'';
    DecodedBitStreamParser$2.MIXED_CHARS = '0123456789&\r\t,:#-.$/+%*=^';
    /**
     * Table containing values for the exponent of 900.
     * This is used in the numeric compaction decode algorithm.
     */ DecodedBitStreamParser$2.EXP900 = getBigIntConstructor() ? getEXP900() : [];
    DecodedBitStreamParser$2.NUMBER_OF_SEQUENCE_CODEWORDS = 2;
    /*
    * Copyright 2013 ZXing authors
    *
    * Licensed under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License.
    * You may obtain a copy of the License at
    *
    *      http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software
    * distributed under the License is distributed on an "AS IS" BASIS,
    * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    * See the License for the specific language governing permissions and
    * limitations under the License.
    */ // import java.util.ArrayList;
    // import java.util.Collection;
    // import java.util.Formatter;
    // import java.util.List;
    /**
     * @author Guenther Grau
     */ /*public final*/ class PDF417ScanningDecoder {
        constructor(){}
        /**
         * @TODO don't pass in minCodewordWidth and maxCodewordWidth, pass in barcode columns for start and stop pattern
         *
         * columns. That way width can be deducted from the pattern column.
         * This approach also allows to detect more details about the barcode, e.g. if a bar type (white or black) is wider
         * than it should be. This can happen if the scanner used a bad blackpoint.
         *
         * @param BitMatrix
         * @param image
         * @param ResultPoint
         * @param imageTopLeft
         * @param ResultPoint
         * @param imageBottomLeft
         * @param ResultPoint
         * @param imageTopRight
         * @param ResultPoint
         * @param imageBottomRight
         * @param int
         * @param minCodewordWidth
         * @param int
         * @param maxCodewordWidth
         *
         * @throws NotFoundException
         * @throws FormatException
         * @throws ChecksumException
         */ static decode(image, imageTopLeft, imageBottomLeft, imageTopRight, imageBottomRight, minCodewordWidth, maxCodewordWidth) {
            let boundingBox = new BoundingBox(image, imageTopLeft, imageBottomLeft, imageTopRight, imageBottomRight);
            let leftRowIndicatorColumn = null;
            let rightRowIndicatorColumn = null;
            let detectionResult;
            for(let firstPass /*boolean*/  = true;; firstPass = false){
                if (imageTopLeft != null) leftRowIndicatorColumn = PDF417ScanningDecoder.getRowIndicatorColumn(image, boundingBox, imageTopLeft, true, minCodewordWidth, maxCodewordWidth);
                if (imageTopRight != null) rightRowIndicatorColumn = PDF417ScanningDecoder.getRowIndicatorColumn(image, boundingBox, imageTopRight, false, minCodewordWidth, maxCodewordWidth);
                detectionResult = PDF417ScanningDecoder.merge(leftRowIndicatorColumn, rightRowIndicatorColumn);
                if (detectionResult == null) throw NotFoundException.getNotFoundInstance();
                let resultBox = detectionResult.getBoundingBox();
                if (firstPass && resultBox != null && (resultBox.getMinY() < boundingBox.getMinY() || resultBox.getMaxY() > boundingBox.getMaxY())) boundingBox = resultBox;
                else break;
            }
            detectionResult.setBoundingBox(boundingBox);
            let maxBarcodeColumn = detectionResult.getBarcodeColumnCount() + 1;
            detectionResult.setDetectionResultColumn(0, leftRowIndicatorColumn);
            detectionResult.setDetectionResultColumn(maxBarcodeColumn, rightRowIndicatorColumn);
            let leftToRight = leftRowIndicatorColumn != null;
            for(let barcodeColumnCount /*int*/  = 1; barcodeColumnCount <= maxBarcodeColumn; barcodeColumnCount++){
                let barcodeColumn = leftToRight ? barcodeColumnCount : maxBarcodeColumn - barcodeColumnCount;
                if (detectionResult.getDetectionResultColumn(barcodeColumn) !== /* null */ undefined) continue;
                let detectionResultColumn;
                if (barcodeColumn === 0 || barcodeColumn === maxBarcodeColumn) detectionResultColumn = new DetectionResultRowIndicatorColumn(boundingBox, barcodeColumn === 0);
                else detectionResultColumn = new DetectionResultColumn(boundingBox);
                detectionResult.setDetectionResultColumn(barcodeColumn, detectionResultColumn);
                let startColumn = -1;
                let previousStartColumn = startColumn;
                // TODO start at a row for which we know the start position, then detect upwards and downwards from there.
                for(let imageRow /*int*/  = boundingBox.getMinY(); imageRow <= boundingBox.getMaxY(); imageRow++){
                    startColumn = PDF417ScanningDecoder.getStartColumn(detectionResult, barcodeColumn, imageRow, leftToRight);
                    if (startColumn < 0 || startColumn > boundingBox.getMaxX()) {
                        if (previousStartColumn === -1) continue;
                        startColumn = previousStartColumn;
                    }
                    let codeword = PDF417ScanningDecoder.detectCodeword(image, boundingBox.getMinX(), boundingBox.getMaxX(), leftToRight, startColumn, imageRow, minCodewordWidth, maxCodewordWidth);
                    if (codeword != null) {
                        detectionResultColumn.setCodeword(imageRow, codeword);
                        previousStartColumn = startColumn;
                        minCodewordWidth = Math.min(minCodewordWidth, codeword.getWidth());
                        maxCodewordWidth = Math.max(maxCodewordWidth, codeword.getWidth());
                    }
                }
            }
            return PDF417ScanningDecoder.createDecoderResult(detectionResult);
        }
        /**
         *
         * @param leftRowIndicatorColumn
         * @param rightRowIndicatorColumn
         *
         * @throws NotFoundException
         */ static merge(leftRowIndicatorColumn, rightRowIndicatorColumn) {
            if (leftRowIndicatorColumn == null && rightRowIndicatorColumn == null) return null;
            let barcodeMetadata = PDF417ScanningDecoder.getBarcodeMetadata(leftRowIndicatorColumn, rightRowIndicatorColumn);
            if (barcodeMetadata == null) return null;
            let boundingBox = BoundingBox.merge(PDF417ScanningDecoder.adjustBoundingBox(leftRowIndicatorColumn), PDF417ScanningDecoder.adjustBoundingBox(rightRowIndicatorColumn));
            return new DetectionResult(barcodeMetadata, boundingBox);
        }
        /**
         *
         * @param rowIndicatorColumn
         *
         * @throws NotFoundException
         */ static adjustBoundingBox(rowIndicatorColumn) {
            if (rowIndicatorColumn == null) return null;
            let rowHeights = rowIndicatorColumn.getRowHeights();
            if (rowHeights == null) return null;
            let maxRowHeight = PDF417ScanningDecoder.getMax(rowHeights);
            let missingStartRows = 0;
            for (let rowHeight /*int*/  of rowHeights){
                missingStartRows += maxRowHeight - rowHeight;
                if (rowHeight > 0) break;
            }
            let codewords = rowIndicatorColumn.getCodewords();
            for(let row /*int*/  = 0; missingStartRows > 0 && codewords[row] == null; row++)missingStartRows--;
            let missingEndRows = 0;
            for(let row /*int*/  = rowHeights.length - 1; row >= 0; row--){
                missingEndRows += maxRowHeight - rowHeights[row];
                if (rowHeights[row] > 0) break;
            }
            for(let row /*int*/  = codewords.length - 1; missingEndRows > 0 && codewords[row] == null; row--)missingEndRows--;
            return rowIndicatorColumn.getBoundingBox().addMissingRows(missingStartRows, missingEndRows, rowIndicatorColumn.isLeft());
        }
        static getMax(values) {
            let maxValue = -1;
            for (let value /*int*/  of values)maxValue = Math.max(maxValue, value);
            return maxValue;
        }
        static getBarcodeMetadata(leftRowIndicatorColumn, rightRowIndicatorColumn) {
            let leftBarcodeMetadata;
            if (leftRowIndicatorColumn == null || (leftBarcodeMetadata = leftRowIndicatorColumn.getBarcodeMetadata()) == null) return rightRowIndicatorColumn == null ? null : rightRowIndicatorColumn.getBarcodeMetadata();
            let rightBarcodeMetadata;
            if (rightRowIndicatorColumn == null || (rightBarcodeMetadata = rightRowIndicatorColumn.getBarcodeMetadata()) == null) return leftBarcodeMetadata;
            if (leftBarcodeMetadata.getColumnCount() !== rightBarcodeMetadata.getColumnCount() && leftBarcodeMetadata.getErrorCorrectionLevel() !== rightBarcodeMetadata.getErrorCorrectionLevel() && leftBarcodeMetadata.getRowCount() !== rightBarcodeMetadata.getRowCount()) return null;
            return leftBarcodeMetadata;
        }
        static getRowIndicatorColumn(image, boundingBox, startPoint, leftToRight, minCodewordWidth, maxCodewordWidth) {
            let rowIndicatorColumn = new DetectionResultRowIndicatorColumn(boundingBox, leftToRight);
            for(let i /*int*/  = 0; i < 2; i++){
                let increment = i === 0 ? 1 : -1;
                let startColumn = Math.trunc(Math.trunc(startPoint.getX()));
                for(let imageRow /*int*/  = Math.trunc(Math.trunc(startPoint.getY())); imageRow <= boundingBox.getMaxY() && imageRow >= boundingBox.getMinY(); imageRow += increment){
                    let codeword = PDF417ScanningDecoder.detectCodeword(image, 0, image.getWidth(), leftToRight, startColumn, imageRow, minCodewordWidth, maxCodewordWidth);
                    if (codeword != null) {
                        rowIndicatorColumn.setCodeword(imageRow, codeword);
                        if (leftToRight) startColumn = codeword.getStartX();
                        else startColumn = codeword.getEndX();
                    }
                }
            }
            return rowIndicatorColumn;
        }
        /**
         *
         * @param detectionResult
         * @param BarcodeValue
         * @param param2
         * @param param3
         * @param barcodeMatrix
         *
         * @throws NotFoundException
         */ static adjustCodewordCount(detectionResult, barcodeMatrix) {
            let barcodeMatrix01 = barcodeMatrix[0][1];
            let numberOfCodewords = barcodeMatrix01.getValue();
            let calculatedNumberOfCodewords = detectionResult.getBarcodeColumnCount() * detectionResult.getBarcodeRowCount() - PDF417ScanningDecoder.getNumberOfECCodeWords(detectionResult.getBarcodeECLevel());
            if (numberOfCodewords.length === 0) {
                if (calculatedNumberOfCodewords < 1 || calculatedNumberOfCodewords > PDF417Common.MAX_CODEWORDS_IN_BARCODE) throw NotFoundException.getNotFoundInstance();
                barcodeMatrix01.setValue(calculatedNumberOfCodewords);
            } else if (numberOfCodewords[0] !== calculatedNumberOfCodewords) // The calculated one is more reliable as it is derived from the row indicator columns
            barcodeMatrix01.setValue(calculatedNumberOfCodewords);
        }
        /**
         *
         * @param detectionResult
         *
         * @throws FormatException
         * @throws ChecksumException
         * @throws NotFoundException
         */ static createDecoderResult(detectionResult) {
            let barcodeMatrix = PDF417ScanningDecoder.createBarcodeMatrix(detectionResult);
            PDF417ScanningDecoder.adjustCodewordCount(detectionResult, barcodeMatrix);
            let erasures /*Collection<Integer>*/  = new Array();
            let codewords = new Int32Array(detectionResult.getBarcodeRowCount() * detectionResult.getBarcodeColumnCount());
            let ambiguousIndexValuesList = /*List<int[]>*/ [];
            let ambiguousIndexesList = /*Collection<Integer>*/ new Array();
            for(let row /*int*/  = 0; row < detectionResult.getBarcodeRowCount(); row++)for(let column /*int*/  = 0; column < detectionResult.getBarcodeColumnCount(); column++){
                let values = barcodeMatrix[row][column + 1].getValue();
                let codewordIndex = row * detectionResult.getBarcodeColumnCount() + column;
                if (values.length === 0) erasures.push(codewordIndex);
                else if (values.length === 1) codewords[codewordIndex] = values[0];
                else {
                    ambiguousIndexesList.push(codewordIndex);
                    ambiguousIndexValuesList.push(values);
                }
            }
            let ambiguousIndexValues = new Array(ambiguousIndexValuesList.length);
            for(let i /*int*/  = 0; i < ambiguousIndexValues.length; i++)ambiguousIndexValues[i] = ambiguousIndexValuesList[i];
            return PDF417ScanningDecoder.createDecoderResultFromAmbiguousValues(detectionResult.getBarcodeECLevel(), codewords, PDF417Common.toIntArray(erasures), PDF417Common.toIntArray(ambiguousIndexesList), ambiguousIndexValues);
        }
        /**
         * This method deals with the fact, that the decoding process doesn't always yield a single most likely value. The
         * current error correction implementation doesn't deal with erasures very well, so it's better to provide a value
         * for these ambiguous codewords instead of treating it as an erasure. The problem is that we don't know which of
         * the ambiguous values to choose. We try decode using the first value, and if that fails, we use another of the
         * ambiguous values and try to decode again. This usually only happens on very hard to read and decode barcodes,
         * so decoding the normal barcodes is not affected by this.
         *
         * @param erasureArray contains the indexes of erasures
         * @param ambiguousIndexes array with the indexes that have more than one most likely value
         * @param ambiguousIndexValues two dimensional array that contains the ambiguous values. The first dimension must
         * be the same length as the ambiguousIndexes array
         *
         * @throws FormatException
         * @throws ChecksumException
         */ static createDecoderResultFromAmbiguousValues(ecLevel, codewords, erasureArray, ambiguousIndexes, ambiguousIndexValues) {
            let ambiguousIndexCount = new Int32Array(ambiguousIndexes.length);
            let tries = 100;
            while(tries-- > 0){
                for(let i /*int*/  = 0; i < ambiguousIndexCount.length; i++)codewords[ambiguousIndexes[i]] = ambiguousIndexValues[i][ambiguousIndexCount[i]];
                try {
                    return PDF417ScanningDecoder.decodeCodewords(codewords, ecLevel, erasureArray);
                } catch (err) {
                    let ignored = err instanceof ChecksumException;
                    if (!ignored) throw err;
                }
                if (ambiguousIndexCount.length === 0) throw ChecksumException.getChecksumInstance();
                for(let i /*int*/  = 0; i < ambiguousIndexCount.length; i++)if (ambiguousIndexCount[i] < ambiguousIndexValues[i].length - 1) {
                    ambiguousIndexCount[i]++;
                    break;
                } else {
                    ambiguousIndexCount[i] = 0;
                    if (i === ambiguousIndexCount.length - 1) throw ChecksumException.getChecksumInstance();
                }
            }
            throw ChecksumException.getChecksumInstance();
        }
        static createBarcodeMatrix(detectionResult) {
            // let barcodeMatrix: BarcodeValue[][] =
            // new BarcodeValue[detectionResult.getBarcodeRowCount()][detectionResult.getBarcodeColumnCount() + 2];
            let barcodeMatrix = Array.from({
                length: detectionResult.getBarcodeRowCount()
            }, ()=>new Array(detectionResult.getBarcodeColumnCount() + 2));
            for(let row /*int*/  = 0; row < barcodeMatrix.length; row++)for(let column /*int*/  = 0; column < barcodeMatrix[row].length; column++)barcodeMatrix[row][column] = new BarcodeValue();
            let column = 0;
            for (let detectionResultColumn /*DetectionResultColumn*/  of detectionResult.getDetectionResultColumns()){
                if (detectionResultColumn != null) {
                    for (let codeword /*Codeword*/  of detectionResultColumn.getCodewords())if (codeword != null) {
                        let rowNumber = codeword.getRowNumber();
                        if (rowNumber >= 0) {
                            if (rowNumber >= barcodeMatrix.length) continue;
                            barcodeMatrix[rowNumber][column].setValue(codeword.getValue());
                        }
                    }
                }
                column++;
            }
            return barcodeMatrix;
        }
        static isValidBarcodeColumn(detectionResult, barcodeColumn) {
            return barcodeColumn >= 0 && barcodeColumn <= detectionResult.getBarcodeColumnCount() + 1;
        }
        static getStartColumn(detectionResult, barcodeColumn, imageRow, leftToRight) {
            let offset = leftToRight ? 1 : -1;
            let codeword = null;
            if (PDF417ScanningDecoder.isValidBarcodeColumn(detectionResult, barcodeColumn - offset)) codeword = detectionResult.getDetectionResultColumn(barcodeColumn - offset).getCodeword(imageRow);
            if (codeword != null) return leftToRight ? codeword.getEndX() : codeword.getStartX();
            codeword = detectionResult.getDetectionResultColumn(barcodeColumn).getCodewordNearby(imageRow);
            if (codeword != null) return leftToRight ? codeword.getStartX() : codeword.getEndX();
            if (PDF417ScanningDecoder.isValidBarcodeColumn(detectionResult, barcodeColumn - offset)) codeword = detectionResult.getDetectionResultColumn(barcodeColumn - offset).getCodewordNearby(imageRow);
            if (codeword != null) return leftToRight ? codeword.getEndX() : codeword.getStartX();
            let skippedColumns = 0;
            while(PDF417ScanningDecoder.isValidBarcodeColumn(detectionResult, barcodeColumn - offset)){
                barcodeColumn -= offset;
                for (let previousRowCodeword /*Codeword*/  of detectionResult.getDetectionResultColumn(barcodeColumn).getCodewords()){
                    if (previousRowCodeword != null) return (leftToRight ? previousRowCodeword.getEndX() : previousRowCodeword.getStartX()) + offset * skippedColumns * (previousRowCodeword.getEndX() - previousRowCodeword.getStartX());
                }
                skippedColumns++;
            }
            return leftToRight ? detectionResult.getBoundingBox().getMinX() : detectionResult.getBoundingBox().getMaxX();
        }
        static detectCodeword(image, minColumn, maxColumn, leftToRight, startColumn, imageRow, minCodewordWidth, maxCodewordWidth) {
            startColumn = PDF417ScanningDecoder.adjustCodewordStartColumn(image, minColumn, maxColumn, leftToRight, startColumn, imageRow);
            // we usually know fairly exact now how long a codeword is. We should provide minimum and maximum expected length
            // and try to adjust the read pixels, e.g. remove single pixel errors or try to cut off exceeding pixels.
            // min and maxCodewordWidth should not be used as they are calculated for the whole barcode an can be inaccurate
            // for the current position
            let moduleBitCount = PDF417ScanningDecoder.getModuleBitCount(image, minColumn, maxColumn, leftToRight, startColumn, imageRow);
            if (moduleBitCount == null) return null;
            let endColumn;
            let codewordBitCount = MathUtils.sum(moduleBitCount);
            if (leftToRight) endColumn = startColumn + codewordBitCount;
            else {
                for(let i /*int*/  = 0; i < moduleBitCount.length / 2; i++){
                    let tmpCount = moduleBitCount[i];
                    moduleBitCount[i] = moduleBitCount[moduleBitCount.length - 1 - i];
                    moduleBitCount[moduleBitCount.length - 1 - i] = tmpCount;
                }
                endColumn = startColumn;
                startColumn = endColumn - codewordBitCount;
            }
            // TODO implement check for width and correction of black and white bars
            // use start (and maybe stop pattern) to determine if black bars are wider than white bars. If so, adjust.
            // should probably done only for codewords with a lot more than 17 bits.
            // The following fixes 10-1.png, which has wide black bars and small white bars
            //    for (let i /*int*/ = 0; i < moduleBitCount.length; i++) {
            //      if (i % 2 === 0) {
            //        moduleBitCount[i]--;
            //      } else {
            //        moduleBitCount[i]++;
            //      }
            //    }
            // We could also use the width of surrounding codewords for more accurate results, but this seems
            // sufficient for now
            if (!PDF417ScanningDecoder.checkCodewordSkew(codewordBitCount, minCodewordWidth, maxCodewordWidth)) // We could try to use the startX and endX position of the codeword in the same column in the previous row,
            // create the bit count from it and normalize it to 8. This would help with single pixel errors.
            return null;
            let decodedValue = PDF417CodewordDecoder.getDecodedValue(moduleBitCount);
            let codeword = PDF417Common.getCodeword(decodedValue);
            if (codeword === -1) return null;
            return new Codeword(startColumn, endColumn, PDF417ScanningDecoder.getCodewordBucketNumber(decodedValue), codeword);
        }
        static getModuleBitCount(image, minColumn, maxColumn, leftToRight, startColumn, imageRow) {
            let imageColumn = startColumn;
            let moduleBitCount = new Int32Array(8);
            let moduleNumber = 0;
            let increment = leftToRight ? 1 : -1;
            let previousPixelValue = leftToRight;
            while((leftToRight ? imageColumn < maxColumn : imageColumn >= minColumn) && moduleNumber < moduleBitCount.length)if (image.get(imageColumn, imageRow) === previousPixelValue) {
                moduleBitCount[moduleNumber]++;
                imageColumn += increment;
            } else {
                moduleNumber++;
                previousPixelValue = !previousPixelValue;
            }
            if (moduleNumber === moduleBitCount.length || imageColumn === (leftToRight ? maxColumn : minColumn) && moduleNumber === moduleBitCount.length - 1) return moduleBitCount;
            return null;
        }
        static getNumberOfECCodeWords(barcodeECLevel) {
            return 2 << barcodeECLevel;
        }
        static adjustCodewordStartColumn(image, minColumn, maxColumn, leftToRight, codewordStartColumn, imageRow) {
            let correctedStartColumn = codewordStartColumn;
            let increment = leftToRight ? -1 : 1;
            // there should be no black pixels before the start column. If there are, then we need to start earlier.
            for(let i /*int*/  = 0; i < 2; i++){
                while((leftToRight ? correctedStartColumn >= minColumn : correctedStartColumn < maxColumn) && leftToRight === image.get(correctedStartColumn, imageRow)){
                    if (Math.abs(codewordStartColumn - correctedStartColumn) > PDF417ScanningDecoder.CODEWORD_SKEW_SIZE) return codewordStartColumn;
                    correctedStartColumn += increment;
                }
                increment = -increment;
                leftToRight = !leftToRight;
            }
            return correctedStartColumn;
        }
        static checkCodewordSkew(codewordSize, minCodewordWidth, maxCodewordWidth) {
            return minCodewordWidth - PDF417ScanningDecoder.CODEWORD_SKEW_SIZE <= codewordSize && codewordSize <= maxCodewordWidth + PDF417ScanningDecoder.CODEWORD_SKEW_SIZE;
        }
        /**
         * @throws FormatException,
         * @throws ChecksumException
         */ static decodeCodewords(codewords, ecLevel, erasures) {
            if (codewords.length === 0) throw FormatException.getFormatInstance();
            let numECCodewords = 1 << ecLevel + 1;
            let correctedErrorsCount = PDF417ScanningDecoder.correctErrors(codewords, erasures, numECCodewords);
            PDF417ScanningDecoder.verifyCodewordCount(codewords, numECCodewords);
            // Decode the codewords
            let decoderResult = DecodedBitStreamParser$2.decode(codewords, '' + ecLevel);
            decoderResult.setErrorsCorrected(correctedErrorsCount);
            decoderResult.setErasures(erasures.length);
            return decoderResult;
        }
        /**
         * <p>Given data and error-correction codewords received, possibly corrupted by errors, attempts to
         * correct the errors in-place.</p>
         *
         * @param codewords   data and error correction codewords
         * @param erasures positions of any known erasures
         * @param numECCodewords number of error correction codewords that are available in codewords
         * @throws ChecksumException if error correction fails
         */ static correctErrors(codewords, erasures, numECCodewords) {
            if (erasures != null && erasures.length > numECCodewords / 2 + PDF417ScanningDecoder.MAX_ERRORS || numECCodewords < 0 || numECCodewords > PDF417ScanningDecoder.MAX_EC_CODEWORDS) // Too many errors or EC Codewords is corrupted
            throw ChecksumException.getChecksumInstance();
            return PDF417ScanningDecoder.errorCorrection.decode(codewords, numECCodewords, erasures);
        }
        /**
         * Verify that all is OK with the codeword array.
         * @throws FormatException
         */ static verifyCodewordCount(codewords, numECCodewords) {
            if (codewords.length < 4) // Codeword array size should be at least 4 allowing for
            // Count CW, At least one Data CW, Error Correction CW, Error Correction CW
            throw FormatException.getFormatInstance();
            // The first codeword, the Symbol Length Descriptor, shall always encode the total number of data
            // codewords in the symbol, including the Symbol Length Descriptor itself, data codewords and pad
            // codewords, but excluding the number of error correction codewords.
            let numberOfCodewords = codewords[0];
            if (numberOfCodewords > codewords.length) throw FormatException.getFormatInstance();
            if (numberOfCodewords === 0) {
                // Reset to the length of the array - 8 (Allow for at least level 3 Error Correction (8 Error Codewords)
                if (numECCodewords < codewords.length) codewords[0] = codewords.length - numECCodewords;
                else throw FormatException.getFormatInstance();
            }
        }
        static getBitCountForCodeword(codeword) {
            let result = new Int32Array(8);
            let previousValue = 0;
            let i = result.length - 1;
            while(true){
                if ((codeword & 0x1) !== previousValue) {
                    previousValue = codeword & 0x1;
                    i--;
                    if (i < 0) break;
                }
                result[i]++;
                codeword >>= 1;
            }
            return result;
        }
        static getCodewordBucketNumber(codeword) {
            if (codeword instanceof Int32Array) return this.getCodewordBucketNumber_Int32Array(codeword);
            return this.getCodewordBucketNumber_number(codeword);
        }
        static getCodewordBucketNumber_number(codeword) {
            return PDF417ScanningDecoder.getCodewordBucketNumber(PDF417ScanningDecoder.getBitCountForCodeword(codeword));
        }
        static getCodewordBucketNumber_Int32Array(moduleBitCount) {
            return (moduleBitCount[0] - moduleBitCount[2] + moduleBitCount[4] - moduleBitCount[6] + 9) % 9;
        }
        static toString(barcodeMatrix) {
            let formatter = new Formatter();
            // try (let formatter = new Formatter()) {
            for(let row /*int*/  = 0; row < barcodeMatrix.length; row++){
                formatter.format('Row %2d: ', row);
                for(let column /*int*/  = 0; column < barcodeMatrix[row].length; column++){
                    let barcodeValue = barcodeMatrix[row][column];
                    if (barcodeValue.getValue().length === 0) formatter.format('        ', null);
                    else formatter.format('%4d(%2d)', barcodeValue.getValue()[0], barcodeValue.getConfidence(barcodeValue.getValue()[0]));
                }
                formatter.format('%n');
            }
            return formatter.toString();
        // }
        }
    }
    /*final*/ PDF417ScanningDecoder.CODEWORD_SKEW_SIZE = 2;
    /*final*/ PDF417ScanningDecoder.MAX_ERRORS = 3;
    /*final*/ PDF417ScanningDecoder.MAX_EC_CODEWORDS = 512;
    /*final*/ PDF417ScanningDecoder.errorCorrection = new ErrorCorrection();
    /*
     * Copyright 2009 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ // import java.util.ArrayList;
    // import java.util.List;
    // import java.util.Map;
    /**
     * This implementation can detect and decode PDF417 codes in an image.
     *
     * @author Guenther Grau
     */ /*public final*/ class PDF417Reader {
        // private static /*final Result[]*/ EMPTY_RESULT_ARRAY: Result[] = new Result([0]);
        /**
         * Locates and decodes a PDF417 code in an image.
         *
         * @return a String representing the content encoded by the PDF417 code
         * @throws NotFoundException if a PDF417 code cannot be found,
         * @throws FormatException if a PDF417 cannot be decoded
         * @throws ChecksumException
         */ // @Override
        decode(image, hints = null) {
            let result = PDF417Reader.decode(image, hints, false);
            if (result == null || result.length === 0 || result[0] == null) throw NotFoundException.getNotFoundInstance();
            return result[0];
        }
        /**
         *
         * @param BinaryBitmap
         * @param image
         * @throws NotFoundException
         */ //   @Override
        decodeMultiple(image, hints = null) {
            try {
                return PDF417Reader.decode(image, hints, true);
            } catch (ignored) {
                if (ignored instanceof FormatException || ignored instanceof ChecksumException) throw NotFoundException.getNotFoundInstance();
                throw ignored;
            }
        }
        /**
         *
         * @param image
         * @param hints
         * @param multiple
         *
         * @throws NotFoundException
         * @throws FormatExceptionß
         * @throws ChecksumException
         */ static decode(image, hints, multiple) {
            const results = new Array();
            const detectorResult = Detector$3.detectMultiple(image, hints, multiple);
            for (const points of detectorResult.getPoints()){
                const decoderResult = PDF417ScanningDecoder.decode(detectorResult.getBits(), points[4], points[5], points[6], points[7], PDF417Reader.getMinCodewordWidth(points), PDF417Reader.getMaxCodewordWidth(points));
                const result = new Result(decoderResult.getText(), decoderResult.getRawBytes(), undefined, points, BarcodeFormat$1.PDF_417);
                result.putMetadata(ResultMetadataType$1.ERROR_CORRECTION_LEVEL, decoderResult.getECLevel());
                const pdf417ResultMetadata = decoderResult.getOther();
                if (pdf417ResultMetadata != null) result.putMetadata(ResultMetadataType$1.PDF417_EXTRA_METADATA, pdf417ResultMetadata);
                results.push(result);
            }
            return results.map((x)=>x);
        }
        static getMaxWidth(p1, p2) {
            if (p1 == null || p2 == null) return 0;
            return Math.trunc(Math.abs(p1.getX() - p2.getX()));
        }
        static getMinWidth(p1, p2) {
            if (p1 == null || p2 == null) return Integer.MAX_VALUE;
            return Math.trunc(Math.abs(p1.getX() - p2.getX()));
        }
        static getMaxCodewordWidth(p) {
            return Math.floor(Math.max(Math.max(PDF417Reader.getMaxWidth(p[0], p[4]), PDF417Reader.getMaxWidth(p[6], p[2]) * PDF417Common.MODULES_IN_CODEWORD / PDF417Common.MODULES_IN_STOP_PATTERN), Math.max(PDF417Reader.getMaxWidth(p[1], p[5]), PDF417Reader.getMaxWidth(p[7], p[3]) * PDF417Common.MODULES_IN_CODEWORD / PDF417Common.MODULES_IN_STOP_PATTERN)));
        }
        static getMinCodewordWidth(p) {
            return Math.floor(Math.min(Math.min(PDF417Reader.getMinWidth(p[0], p[4]), PDF417Reader.getMinWidth(p[6], p[2]) * PDF417Common.MODULES_IN_CODEWORD / PDF417Common.MODULES_IN_STOP_PATTERN), Math.min(PDF417Reader.getMinWidth(p[1], p[5]), PDF417Reader.getMinWidth(p[7], p[3]) * PDF417Common.MODULES_IN_CODEWORD / PDF417Common.MODULES_IN_STOP_PATTERN)));
        }
        // @Override
        reset() {
        // nothing needs to be reset
        }
    }
    /**
     * Custom Error class of type Exception.
     */ class ReaderException extends Exception {
    }
    ReaderException.kind = 'ReaderException';
    /*
     * Copyright 2009 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /*namespace com.google.zxing {*/ /**
     * MultiFormatReader is a convenience class and the main entry point into the library for most uses.
     * By default it attempts to decode all barcode formats that the library supports. Optionally, you
     * can provide a hints object to request different behavior, for example only decoding QR codes.
     *
     * @author Sean Owen
     * @author dswitkin@google.com (Daniel Switkin)
     */ class MultiFormatReader {
        /**
         * Creates an instance of this class
         * 
         * @param {Boolean} verbose if 'true' logs will be dumped to console, otherwise hidden.
         * @param hints The hints to use, clearing the previous state.
         */ constructor(verbose, hints){
            this.verbose = verbose === true;
            if (hints) this.setHints(hints);
        }
        /**
         * This version of decode honors the intent of Reader.decode(BinaryBitmap) in that it
         * passes null as a hint to the decoders. However, that makes it inefficient to call repeatedly.
         * Use setHints() followed by decodeWithState() for continuous scan applications.
         *
         * @param image The pixel data to decode
         * @return The contents of the image
         *
         * @throws NotFoundException Any errors which occurred
         */ /*@Override*/ // public decode(image: BinaryBitmap): Result {
        //   setHints(null)
        //   return decodeInternal(image)
        // }
        /**
         * Decode an image using the hints provided. Does not honor existing state.
         *
         * @param image The pixel data to decode
         * @param hints The hints to use, clearing the previous state.
         * @return The contents of the image
         *
         * @throws NotFoundException Any errors which occurred
         */ /*@Override*/ decode(image, hints) {
            if (hints) this.setHints(hints);
            return this.decodeInternal(image);
        }
        /**
         * Decode an image using the state set up by calling setHints() previously. Continuous scan
         * clients will get a <b>large</b> speed increase by using this instead of decode().
         *
         * @param image The pixel data to decode
         * @return The contents of the image
         *
         * @throws NotFoundException Any errors which occurred
         */ decodeWithState(image) {
            // Make sure to set up the default state so we don't crash
            if (this.readers === null || this.readers === undefined) this.setHints(null);
            return this.decodeInternal(image);
        }
        /**
         * This method adds state to the MultiFormatReader. By setting the hints once, subsequent calls
         * to decodeWithState(image) can reuse the same set of readers without reallocating memory. This
         * is important for performance in continuous scan clients.
         *
         * @param hints The set of hints to use for subsequent calls to decode(image)
         */ setHints(hints) {
            this.hints = hints;
            const tryHarder = !isNullOrUndefined(hints) && hints.get(DecodeHintType$1.TRY_HARDER) === true;
            const formats = isNullOrUndefined(hints) ? null : hints.get(DecodeHintType$1.POSSIBLE_FORMATS);
            const readers = new Array();
            if (!isNullOrUndefined(formats)) {
                const addOneDReader = formats.some((f)=>{
                    return f === BarcodeFormat$1.UPC_A || f === BarcodeFormat$1.UPC_E || f === BarcodeFormat$1.EAN_13 || f === BarcodeFormat$1.EAN_8 || f === BarcodeFormat$1.CODABAR || f === BarcodeFormat$1.CODE_39 || f === BarcodeFormat$1.CODE_93 || f === BarcodeFormat$1.CODE_128 || f === BarcodeFormat$1.ITF || f === BarcodeFormat$1.RSS_14 || f === BarcodeFormat$1.RSS_EXPANDED;
                });
                // Put 1D readers upfront in "normal" mode
                if (addOneDReader && !tryHarder) readers.push(new MultiFormatOneDReader(hints, this.verbose));
                if (formats.includes(BarcodeFormat$1.QR_CODE)) readers.push(new QRCodeReader());
                if (formats.includes(BarcodeFormat$1.DATA_MATRIX)) readers.push(new DataMatrixReader());
                if (formats.includes(BarcodeFormat$1.AZTEC)) readers.push(new AztecReader());
                if (formats.includes(BarcodeFormat$1.PDF_417)) readers.push(new PDF417Reader());
                // if (formats.includes(BarcodeFormat.MAXICODE)) {
                //    readers.push(new MaxiCodeReader())
                // }
                // At end in "try harder" mode
                if (addOneDReader && tryHarder) readers.push(new MultiFormatOneDReader(hints, this.verbose));
            }
            if (readers.length === 0) {
                if (!tryHarder) readers.push(new MultiFormatOneDReader(hints, this.verbose));
                readers.push(new QRCodeReader());
                readers.push(new DataMatrixReader());
                readers.push(new AztecReader());
                readers.push(new PDF417Reader());
                // readers.push(new MaxiCodeReader())
                if (tryHarder) readers.push(new MultiFormatOneDReader(hints, this.verbose));
            }
            this.readers = readers; // .toArray(new Reader[readers.size()])
        }
        /*@Override*/ reset() {
            if (this.readers !== null) for (const reader of this.readers)reader.reset();
        }
        /**
         * @throws NotFoundException
         */ decodeInternal(image) {
            if (this.readers === null) throw new ReaderException('No readers where selected, nothing can be read.');
            for (const reader of this.readers)// Trying to decode with ${reader} reader.
            try {
                return reader.decode(image, this.hints);
            } catch (ex) {
                if (ex instanceof ReaderException) continue;
            // Bad Exception.
            }
            throw new NotFoundException('No MultiFormat Readers were able to detect the code.');
        }
    }
    class BrowserMultiFormatReader extends BrowserCodeReader {
        constructor(hints = null, timeBetweenScansMillis = 500){
            const reader = new MultiFormatReader();
            reader.setHints(hints);
            super(reader, timeBetweenScansMillis);
        }
        /**
         * Overwrite decodeBitmap to call decodeWithState, which will pay
         * attention to the hints set in the constructor function
         */ decodeBitmap(binaryBitmap) {
            return this.reader.decodeWithState(binaryBitmap);
        }
    }
    /**
     * @deprecated Moving to @zxing/browser
     *
     * QR Code reader to use from browser.
     */ class BrowserPDF417Reader extends BrowserCodeReader {
        /**
         * Creates an instance of BrowserPDF417Reader.
         * @param {number} [timeBetweenScansMillis=500] the time delay between subsequent decode tries
         */ constructor(timeBetweenScansMillis = 500){
            super(new PDF417Reader(), timeBetweenScansMillis);
        }
    }
    /**
     * @deprecated Moving to @zxing/browser
     *
     * QR Code reader to use from browser.
     */ class BrowserQRCodeReader extends BrowserCodeReader {
        /**
         * Creates an instance of BrowserQRCodeReader.
         * @param {number} [timeBetweenScansMillis=500] the time delay between subsequent decode tries
         */ constructor(timeBetweenScansMillis = 500){
            super(new QRCodeReader(), timeBetweenScansMillis);
        }
    }
    /*
     * Copyright 2009 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /*namespace com.google.zxing {*/ /**
     * These are a set of hints that you may pass to Writers to specify their behavior.
     *
     * @author dswitkin@google.com (Daniel Switkin)
     */ var EncodeHintType;
    (function(EncodeHintType) {
        /**
         * Specifies what degree of error correction to use, for example in QR Codes.
         * Type depends on the encoder. For example for QR codes it's type
         * {@link com.google.zxing.qrcode.decoder.ErrorCorrectionLevel ErrorCorrectionLevel}.
         * For Aztec it is of type {@link Integer}, representing the minimal percentage of error correction words.
         * For PDF417 it is of type {@link Integer}, valid values being 0 to 8.
         * In all cases, it can also be a {@link String} representation of the desired value as well.
         * Note: an Aztec symbol should have a minimum of 25% EC words.
         */ EncodeHintType[EncodeHintType["ERROR_CORRECTION"] = 0] = "ERROR_CORRECTION";
        /**
         * Specifies what character encoding to use where applicable (type {@link String})
         */ EncodeHintType[EncodeHintType["CHARACTER_SET"] = 1] = "CHARACTER_SET";
        /**
         * Specifies the matrix shape for Data Matrix (type {@link com.google.zxing.datamatrix.encoder.SymbolShapeHint})
         */ EncodeHintType[EncodeHintType["DATA_MATRIX_SHAPE"] = 2] = "DATA_MATRIX_SHAPE";
        /**
         * Specifies a minimum barcode size (type {@link Dimension}). Only applicable to Data Matrix now.
         *
         * @deprecated use width/height params in
         * {@link com.google.zxing.datamatrix.DataMatrixWriter#encode(String, BarcodeFormat, int, int)}
         */ /*@Deprecated*/ EncodeHintType[EncodeHintType["MIN_SIZE"] = 3] = "MIN_SIZE";
        /**
         * Specifies a maximum barcode size (type {@link Dimension}). Only applicable to Data Matrix now.
         *
         * @deprecated without replacement
         */ /*@Deprecated*/ EncodeHintType[EncodeHintType["MAX_SIZE"] = 4] = "MAX_SIZE";
        /**
         * Specifies margin, in pixels, to use when generating the barcode. The meaning can vary
         * by format; for example it controls margin before and after the barcode horizontally for
         * most 1D formats. (Type {@link Integer}, or {@link String} representation of the integer value).
         */ EncodeHintType[EncodeHintType["MARGIN"] = 5] = "MARGIN";
        /**
         * Specifies whether to use compact mode for PDF417 (type {@link Boolean}, or "true" or "false"
         * {@link String} value).
         */ EncodeHintType[EncodeHintType["PDF417_COMPACT"] = 6] = "PDF417_COMPACT";
        /**
         * Specifies what compaction mode to use for PDF417 (type
         * {@link com.google.zxing.pdf417.encoder.Compaction Compaction} or {@link String} value of one of its
         * enum values).
         */ EncodeHintType[EncodeHintType["PDF417_COMPACTION"] = 7] = "PDF417_COMPACTION";
        /**
         * Specifies the minimum and maximum number of rows and columns for PDF417 (type
         * {@link com.google.zxing.pdf417.encoder.Dimensions Dimensions}).
         */ EncodeHintType[EncodeHintType["PDF417_DIMENSIONS"] = 8] = "PDF417_DIMENSIONS";
        /**
         * Specifies the required number of layers for an Aztec code.
         * A negative number (-1, -2, -3, -4) specifies a compact Aztec code.
         * 0 indicates to use the minimum number of layers (the default).
         * A positive number (1, 2, .. 32) specifies a normal (non-compact) Aztec code.
         * (Type {@link Integer}, or {@link String} representation of the integer value).
         */ EncodeHintType[EncodeHintType["AZTEC_LAYERS"] = 9] = "AZTEC_LAYERS";
        /**
         * Specifies the exact version of QR code to be encoded.
         * (Type {@link Integer}, or {@link String} representation of the integer value).
         */ EncodeHintType[EncodeHintType["QR_VERSION"] = 10] = "QR_VERSION";
    })(EncodeHintType || (EncodeHintType = {}));
    var EncodeHintType$1 = EncodeHintType;
    /**
     * <p>Implements Reed-Solomon encoding, as the name implies.</p>
     *
     * @author Sean Owen
     * @author William Rucklidge
     */ class ReedSolomonEncoder {
        /**
         * A reed solomon error-correcting encoding constructor is created by
         * passing as Galois Field with of size equal to the number of code
         * words (symbols) in the alphabet (the number of values in each
         * element of arrays that are encoded/decoded).
         * @param field A galois field with a number of elements equal to the size
         * of the alphabet of symbols to encode.
         */ constructor(field){
            this.field = field;
            this.cachedGenerators = [];
            this.cachedGenerators.push(new GenericGFPoly(field, Int32Array.from([
                1
            ])));
        }
        buildGenerator(degree /*int*/ ) {
            const cachedGenerators = this.cachedGenerators;
            if (degree >= cachedGenerators.length) {
                let lastGenerator = cachedGenerators[cachedGenerators.length - 1];
                const field = this.field;
                for(let d = cachedGenerators.length; d <= degree; d++){
                    const nextGenerator = lastGenerator.multiply(new GenericGFPoly(field, Int32Array.from([
                        1,
                        field.exp(d - 1 + field.getGeneratorBase())
                    ])));
                    cachedGenerators.push(nextGenerator);
                    lastGenerator = nextGenerator;
                }
            }
            return cachedGenerators[degree];
        }
        /**
         * <p>Encode a sequence of code words (symbols) using Reed-Solomon to allow decoders
         * to detect and correct errors that may have been introduced when the resulting
         * data is stored or transmitted.</p>
         *
         * @param toEncode array used for both and output. Caller initializes the array with
         * the code words (symbols) to be encoded followed by empty elements allocated to make
         * space for error-correction code words in the encoded output. The array contains
         * the encdoded output when encode returns. Code words are encoded as numbers from
         * 0 to n-1, where n is the number of possible code words (symbols), as determined
         * by the size of the Galois Field passed in the constructor of this object.
         * @param ecBytes the number of elements reserved in the array (first parameter)
         * to store error-correction code words. Thus, the number of code words (symbols)
         * to encode in the first parameter is thus toEncode.length - ecBytes.
         * Note, the use of "bytes" in the name of this parameter is misleading, as there may
         * be more or fewer than 256 symbols being encoded, as determined by the number of
         * elements in the Galois Field passed as a constructor to this object.
         * @throws IllegalArgumentException thrown in response to validation errros.
         */ encode(toEncode, ecBytes /*int*/ ) {
            if (ecBytes === 0) throw new IllegalArgumentException('No error correction bytes');
            const dataBytes = toEncode.length - ecBytes;
            if (dataBytes <= 0) throw new IllegalArgumentException('No data bytes provided');
            const generator = this.buildGenerator(ecBytes);
            const infoCoefficients = new Int32Array(dataBytes);
            System.arraycopy(toEncode, 0, infoCoefficients, 0, dataBytes);
            let info = new GenericGFPoly(this.field, infoCoefficients);
            info = info.multiplyByMonomial(ecBytes, 1);
            const remainder = info.divide(generator)[1];
            const coefficients = remainder.getCoefficients();
            const numZeroCoefficients = ecBytes - coefficients.length;
            for(let i = 0; i < numZeroCoefficients; i++)toEncode[dataBytes + i] = 0;
            System.arraycopy(coefficients, 0, toEncode, dataBytes + numZeroCoefficients, coefficients.length);
        }
    }
    /**
     * @author Satoru Takabayashi
     * @author Daniel Switkin
     * @author Sean Owen
     */ class MaskUtil {
        constructor(){
        // do nothing
        }
        /**
         * Apply mask penalty rule 1 and return the penalty. Find repetitive cells with the same color and
         * give penalty to them. Example: 00000 or 11111.
         */ static applyMaskPenaltyRule1(matrix) {
            return MaskUtil.applyMaskPenaltyRule1Internal(matrix, true) + MaskUtil.applyMaskPenaltyRule1Internal(matrix, false);
        }
        /**
         * Apply mask penalty rule 2 and return the penalty. Find 2x2 blocks with the same color and give
         * penalty to them. This is actually equivalent to the spec's rule, which is to find MxN blocks and give a
         * penalty proportional to (M-1)x(N-1), because this is the number of 2x2 blocks inside such a block.
         */ static applyMaskPenaltyRule2(matrix) {
            let penalty = 0;
            const array = matrix.getArray();
            const width = matrix.getWidth();
            const height = matrix.getHeight();
            for(let y = 0; y < height - 1; y++){
                const arrayY = array[y];
                for(let x = 0; x < width - 1; x++){
                    const value = arrayY[x];
                    if (value === arrayY[x + 1] && value === array[y + 1][x] && value === array[y + 1][x + 1]) penalty++;
                }
            }
            return MaskUtil.N2 * penalty;
        }
        /**
         * Apply mask penalty rule 3 and return the penalty. Find consecutive runs of 1:1:3:1:1:4
         * starting with black, or 4:1:1:3:1:1 starting with white, and give penalty to them.  If we
         * find patterns like 000010111010000, we give penalty once.
         */ static applyMaskPenaltyRule3(matrix) {
            let numPenalties = 0;
            const array = matrix.getArray();
            const width = matrix.getWidth();
            const height = matrix.getHeight();
            for(let y = 0; y < height; y++)for(let x = 0; x < width; x++){
                const arrayY = array[y]; // We can at least optimize this access
                if (x + 6 < width && arrayY[x] === 1 && arrayY[x + 1] === 0 && arrayY[x + 2] === 1 && arrayY[x + 3] === 1 && arrayY[x + 4] === 1 && arrayY[x + 5] === 0 && arrayY[x + 6] === 1 && (MaskUtil.isWhiteHorizontal(arrayY, x - 4, x) || MaskUtil.isWhiteHorizontal(arrayY, x + 7, x + 11))) numPenalties++;
                if (y + 6 < height && array[y][x] === 1 && array[y + 1][x] === 0 && array[y + 2][x] === 1 && array[y + 3][x] === 1 && array[y + 4][x] === 1 && array[y + 5][x] === 0 && array[y + 6][x] === 1 && (MaskUtil.isWhiteVertical(array, x, y - 4, y) || MaskUtil.isWhiteVertical(array, x, y + 7, y + 11))) numPenalties++;
            }
            return numPenalties * MaskUtil.N3;
        }
        static isWhiteHorizontal(rowArray, from /*int*/ , to /*int*/ ) {
            from = Math.max(from, 0);
            to = Math.min(to, rowArray.length);
            for(let i = from; i < to; i++){
                if (rowArray[i] === 1) return false;
            }
            return true;
        }
        static isWhiteVertical(array, col /*int*/ , from /*int*/ , to /*int*/ ) {
            from = Math.max(from, 0);
            to = Math.min(to, array.length);
            for(let i = from; i < to; i++){
                if (array[i][col] === 1) return false;
            }
            return true;
        }
        /**
         * Apply mask penalty rule 4 and return the penalty. Calculate the ratio of dark cells and give
         * penalty if the ratio is far from 50%. It gives 10 penalty for 5% distance.
         */ static applyMaskPenaltyRule4(matrix) {
            let numDarkCells = 0;
            const array = matrix.getArray();
            const width = matrix.getWidth();
            const height = matrix.getHeight();
            for(let y = 0; y < height; y++){
                const arrayY = array[y];
                for(let x = 0; x < width; x++)if (arrayY[x] === 1) numDarkCells++;
            }
            const numTotalCells = matrix.getHeight() * matrix.getWidth();
            const fivePercentVariances = Math.floor(Math.abs(numDarkCells * 2 - numTotalCells) * 10 / numTotalCells);
            return fivePercentVariances * MaskUtil.N4;
        }
        /**
         * Return the mask bit for "getMaskPattern" at "x" and "y". See 8.8 of JISX0510:2004 for mask
         * pattern conditions.
         */ static getDataMaskBit(maskPattern /*int*/ , x /*int*/ , y /*int*/ ) {
            let intermediate; /*int*/ 
            let temp; /*int*/ 
            switch(maskPattern){
                case 0:
                    intermediate = y + x & 0x1;
                    break;
                case 1:
                    intermediate = y & 0x1;
                    break;
                case 2:
                    intermediate = x % 3;
                    break;
                case 3:
                    intermediate = (y + x) % 3;
                    break;
                case 4:
                    intermediate = Math.floor(y / 2) + Math.floor(x / 3) & 0x1;
                    break;
                case 5:
                    temp = y * x;
                    intermediate = (temp & 0x1) + temp % 3;
                    break;
                case 6:
                    temp = y * x;
                    intermediate = (temp & 0x1) + temp % 3 & 0x1;
                    break;
                case 7:
                    temp = y * x;
                    intermediate = temp % 3 + (y + x & 0x1) & 0x1;
                    break;
                default:
                    throw new IllegalArgumentException('Invalid mask pattern: ' + maskPattern);
            }
            return intermediate === 0;
        }
        /**
         * Helper function for applyMaskPenaltyRule1. We need this for doing this calculation in both
         * vertical and horizontal orders respectively.
         */ static applyMaskPenaltyRule1Internal(matrix, isHorizontal) {
            let penalty = 0;
            const iLimit = isHorizontal ? matrix.getHeight() : matrix.getWidth();
            const jLimit = isHorizontal ? matrix.getWidth() : matrix.getHeight();
            const array = matrix.getArray();
            for(let i = 0; i < iLimit; i++){
                let numSameBitCells = 0;
                let prevBit = -1;
                for(let j = 0; j < jLimit; j++){
                    const bit = isHorizontal ? array[i][j] : array[j][i];
                    if (bit === prevBit) numSameBitCells++;
                    else {
                        if (numSameBitCells >= 5) penalty += MaskUtil.N1 + (numSameBitCells - 5);
                        numSameBitCells = 1; // Include the cell itself.
                        prevBit = bit;
                    }
                }
                if (numSameBitCells >= 5) penalty += MaskUtil.N1 + (numSameBitCells - 5);
            }
            return penalty;
        }
    }
    // Penalty weights from section 6.8.2.1
    MaskUtil.N1 = 3;
    MaskUtil.N2 = 3;
    MaskUtil.N3 = 40;
    MaskUtil.N4 = 10;
    /**
     * JAVAPORT: The original code was a 2D array of ints, but since it only ever gets assigned
     * -1, 0, and 1, I'm going to use less memory and go with bytes.
     *
     * @author dswitkin@google.com (Daniel Switkin)
     */ class ByteMatrix {
        constructor(width /*int*/ , height /*int*/ ){
            this.width = width;
            this.height = height;
            const bytes = new Array(height); // [height][width]
            for(let i = 0; i !== height; i++)bytes[i] = new Uint8Array(width);
            this.bytes = bytes;
        }
        getHeight() {
            return this.height;
        }
        getWidth() {
            return this.width;
        }
        get(x /*int*/ , y /*int*/ ) {
            return this.bytes[y][x];
        }
        /**
         * @return an internal representation as bytes, in row-major order. array[y][x] represents point (x,y)
         */ getArray() {
            return this.bytes;
        }
        // TYPESCRIPTPORT: preffer to let two methods instead of override to avoid type comparison inside
        setNumber(x /*int*/ , y /*int*/ , value /*byte|int*/ ) {
            this.bytes[y][x] = value;
        }
        // public set(x: number /*int*/, y: number /*int*/, value: number /*int*/): void {
        //   bytes[y][x] = (byte) value
        // }
        setBoolean(x /*int*/ , y /*int*/ , value) {
            this.bytes[y][x] = /*(byte) */ value ? 1 : 0;
        }
        clear(value /*byte*/ ) {
            for (const aByte of this.bytes)Arrays.fill(aByte, value);
        }
        equals(o) {
            if (!(o instanceof ByteMatrix)) return false;
            const other = o;
            if (this.width !== other.width) return false;
            if (this.height !== other.height) return false;
            for(let y = 0, height = this.height; y < height; ++y){
                const bytesY = this.bytes[y];
                const otherBytesY = other.bytes[y];
                for(let x = 0, width = this.width; x < width; ++x){
                    if (bytesY[x] !== otherBytesY[x]) return false;
                }
            }
            return true;
        }
        /*@Override*/ toString() {
            const result = new StringBuilder(); // (2 * width * height + 2)
            for(let y = 0, height = this.height; y < height; ++y){
                const bytesY = this.bytes[y];
                for(let x = 0, width = this.width; x < width; ++x)switch(bytesY[x]){
                    case 0:
                        result.append(' 0');
                        break;
                    case 1:
                        result.append(' 1');
                        break;
                    default:
                        result.append('  ');
                        break;
                }
                result.append('\n');
            }
            return result.toString();
        }
    }
    /**
     * @author satorux@google.com (Satoru Takabayashi) - creator
     * @author dswitkin@google.com (Daniel Switkin) - ported from C++
     */ class QRCode {
        constructor(){
            this.maskPattern = -1;
        }
        getMode() {
            return this.mode;
        }
        getECLevel() {
            return this.ecLevel;
        }
        getVersion() {
            return this.version;
        }
        getMaskPattern() {
            return this.maskPattern;
        }
        getMatrix() {
            return this.matrix;
        }
        /*@Override*/ toString() {
            const result = new StringBuilder(); // (200)
            result.append('<<\n');
            result.append(' mode: ');
            result.append(this.mode ? this.mode.toString() : 'null');
            result.append('\n ecLevel: ');
            result.append(this.ecLevel ? this.ecLevel.toString() : 'null');
            result.append('\n version: ');
            result.append(this.version ? this.version.toString() : 'null');
            result.append('\n maskPattern: ');
            result.append(this.maskPattern.toString());
            if (this.matrix) {
                result.append('\n matrix:\n');
                result.append(this.matrix.toString());
            } else result.append('\n matrix: null\n');
            result.append('>>\n');
            return result.toString();
        }
        setMode(value) {
            this.mode = value;
        }
        setECLevel(value) {
            this.ecLevel = value;
        }
        setVersion(version) {
            this.version = version;
        }
        setMaskPattern(value /*int*/ ) {
            this.maskPattern = value;
        }
        setMatrix(value) {
            this.matrix = value;
        }
        // Check if "mask_pattern" is valid.
        static isValidMaskPattern(maskPattern /*int*/ ) {
            return maskPattern >= 0 && maskPattern < QRCode.NUM_MASK_PATTERNS;
        }
    }
    QRCode.NUM_MASK_PATTERNS = 8;
    /**
     * Custom Error class of type Exception.
     */ class WriterException extends Exception {
    }
    WriterException.kind = 'WriterException';
    /**
     * @author satorux@google.com (Satoru Takabayashi) - creator
     * @author dswitkin@google.com (Daniel Switkin) - ported from C++
     */ class MatrixUtil {
        constructor(){
        // do nothing
        }
        // Set all cells to -1 (TYPESCRIPTPORT: 255).  -1 (TYPESCRIPTPORT: 255) means that the cell is empty (not set yet).
        //
        // JAVAPORT: We shouldn't need to do this at all. The code should be rewritten to begin encoding
        // with the ByteMatrix initialized all to zero.
        static clearMatrix(matrix) {
            // TYPESCRIPTPORT: we use UintArray se changed here from -1 to 255
            matrix.clear(/*(byte) */ /*-1*/ 255);
        }
        // Build 2D matrix of QR Code from "dataBits" with "ecLevel", "version" and "getMaskPattern". On
        // success, store the result in "matrix" and return true.
        static buildMatrix(dataBits, ecLevel, version, maskPattern /*int*/ , matrix) {
            MatrixUtil.clearMatrix(matrix);
            MatrixUtil.embedBasicPatterns(version, matrix);
            // Type information appear with any version.
            MatrixUtil.embedTypeInfo(ecLevel, maskPattern, matrix);
            // Version info appear if version >= 7.
            MatrixUtil.maybeEmbedVersionInfo(version, matrix);
            // Data should be embedded at end.
            MatrixUtil.embedDataBits(dataBits, maskPattern, matrix);
        }
        // Embed basic patterns. On success, modify the matrix and return true.
        // The basic patterns are:
        // - Position detection patterns
        // - Timing patterns
        // - Dark dot at the left bottom corner
        // - Position adjustment patterns, if need be
        static embedBasicPatterns(version, matrix) {
            // Let's get started with embedding big squares at corners.
            MatrixUtil.embedPositionDetectionPatternsAndSeparators(matrix);
            // Then, embed the dark dot at the left bottom corner.
            MatrixUtil.embedDarkDotAtLeftBottomCorner(matrix);
            // Position adjustment patterns appear if version >= 2.
            MatrixUtil.maybeEmbedPositionAdjustmentPatterns(version, matrix);
            // Timing patterns should be embedded after position adj. patterns.
            MatrixUtil.embedTimingPatterns(matrix);
        }
        // Embed type information. On success, modify the matrix.
        static embedTypeInfo(ecLevel, maskPattern /*int*/ , matrix) {
            const typeInfoBits = new BitArray();
            MatrixUtil.makeTypeInfoBits(ecLevel, maskPattern, typeInfoBits);
            for(let i = 0, size = typeInfoBits.getSize(); i < size; ++i){
                // Place bits in LSB to MSB order.  LSB (least significant bit) is the last value in
                // "typeInfoBits".
                const bit = typeInfoBits.get(typeInfoBits.getSize() - 1 - i);
                // Type info bits at the left top corner. See 8.9 of JISX0510:2004 (p.46).
                const coordinates = MatrixUtil.TYPE_INFO_COORDINATES[i];
                const x1 = coordinates[0];
                const y1 = coordinates[1];
                matrix.setBoolean(x1, y1, bit);
                if (i < 8) {
                    // Right top corner.
                    const x2 = matrix.getWidth() - i - 1;
                    const y2 = 8;
                    matrix.setBoolean(x2, y2, bit);
                } else {
                    // Left bottom corner.
                    const x2 = 8;
                    const y2 = matrix.getHeight() - 7 + (i - 8);
                    matrix.setBoolean(x2, y2, bit);
                }
            }
        }
        // Embed version information if need be. On success, modify the matrix and return true.
        // See 8.10 of JISX0510:2004 (p.47) for how to embed version information.
        static maybeEmbedVersionInfo(version, matrix) {
            if (version.getVersionNumber() < 7) return; // Don't need version info.
            const versionInfoBits = new BitArray();
            MatrixUtil.makeVersionInfoBits(version, versionInfoBits);
            let bitIndex = 17; // It will decrease from 17 to 0.
            for(let i = 0; i < 6; ++i)for(let j = 0; j < 3; ++j){
                // Place bits in LSB (least significant bit) to MSB order.
                const bit = versionInfoBits.get(bitIndex);
                bitIndex--;
                // Left bottom corner.
                matrix.setBoolean(i, matrix.getHeight() - 11 + j, bit);
                // Right bottom corner.
                matrix.setBoolean(matrix.getHeight() - 11 + j, i, bit);
            }
        }
        // Embed "dataBits" using "getMaskPattern". On success, modify the matrix and return true.
        // For debugging purposes, it skips masking process if "getMaskPattern" is -1(TYPESCRIPTPORT: 255).
        // See 8.7 of JISX0510:2004 (p.38) for how to embed data bits.
        static embedDataBits(dataBits, maskPattern /*int*/ , matrix) {
            let bitIndex = 0;
            let direction = -1;
            // Start from the right bottom cell.
            let x = matrix.getWidth() - 1;
            let y = matrix.getHeight() - 1;
            while(x > 0){
                // Skip the vertical timing pattern.
                if (x === 6) x -= 1;
                while(y >= 0 && y < matrix.getHeight()){
                    for(let i = 0; i < 2; ++i){
                        const xx = x - i;
                        // Skip the cell if it's not empty.
                        if (!MatrixUtil.isEmpty(matrix.get(xx, y))) continue;
                        let bit;
                        if (bitIndex < dataBits.getSize()) {
                            bit = dataBits.get(bitIndex);
                            ++bitIndex;
                        } else // Padding bit. If there is no bit left, we'll fill the left cells with 0, as described
                        // in 8.4.9 of JISX0510:2004 (p. 24).
                        bit = false;
                        // Skip masking if mask_pattern is -1 (TYPESCRIPTPORT: 255).
                        if (maskPattern !== 255 && MaskUtil.getDataMaskBit(maskPattern, xx, y)) bit = !bit;
                        matrix.setBoolean(xx, y, bit);
                    }
                    y += direction;
                }
                direction = -direction; // Reverse the direction.
                y += direction;
                x -= 2; // Move to the left.
            }
            // All bits should be consumed.
            if (bitIndex !== dataBits.getSize()) throw new WriterException('Not all bits consumed: ' + bitIndex + '/' + dataBits.getSize());
        }
        // Return the position of the most significant bit set (one: to) in the "value". The most
        // significant bit is position 32. If there is no bit set, return 0. Examples:
        // - findMSBSet(0) => 0
        // - findMSBSet(1) => 1
        // - findMSBSet(255) => 8
        static findMSBSet(value /*int*/ ) {
            return 32 - Integer.numberOfLeadingZeros(value);
        }
        // Calculate BCH (Bose-Chaudhuri-Hocquenghem) code for "value" using polynomial "poly". The BCH
        // code is used for encoding type information and version information.
        // Example: Calculation of version information of 7.
        // f(x) is created from 7.
        //   - 7 = 000111 in 6 bits
        //   - f(x) = x^2 + x^1 + x^0
        // g(x) is given by the standard (p. 67)
        //   - g(x) = x^12 + x^11 + x^10 + x^9 + x^8 + x^5 + x^2 + 1
        // Multiply f(x) by x^(18 - 6)
        //   - f'(x) = f(x) * x^(18 - 6)
        //   - f'(x) = x^14 + x^13 + x^12
        // Calculate the remainder of f'(x) / g(x)
        //         x^2
        //         __________________________________________________
        //   g(x) )x^14 + x^13 + x^12
        //         x^14 + x^13 + x^12 + x^11 + x^10 + x^7 + x^4 + x^2
        //         --------------------------------------------------
        //                              x^11 + x^10 + x^7 + x^4 + x^2
        //
        // The remainder is x^11 + x^10 + x^7 + x^4 + x^2
        // Encode it in binary: 110010010100
        // The return value is 0xc94 (1100 1001 0100)
        //
        // Since all coefficients in the polynomials are 1 or 0, we can do the calculation by bit
        // operations. We don't care if coefficients are positive or negative.
        static calculateBCHCode(value /*int*/ , poly /*int*/ ) {
            if (poly === 0) throw new IllegalArgumentException('0 polynomial');
            // If poly is "1 1111 0010 0101" (version info poly), msbSetInPoly is 13. We'll subtract 1
            // from 13 to make it 12.
            const msbSetInPoly = MatrixUtil.findMSBSet(poly);
            value <<= msbSetInPoly - 1;
            // Do the division business using exclusive-or operations.
            while(MatrixUtil.findMSBSet(value) >= msbSetInPoly)value ^= poly << MatrixUtil.findMSBSet(value) - msbSetInPoly;
            // Now the "value" is the remainder (i.e. the BCH code)
            return value;
        }
        // Make bit vector of type information. On success, store the result in "bits" and return true.
        // Encode error correction level and mask pattern. See 8.9 of
        // JISX0510:2004 (p.45) for details.
        static makeTypeInfoBits(ecLevel, maskPattern /*int*/ , bits) {
            if (!QRCode.isValidMaskPattern(maskPattern)) throw new WriterException('Invalid mask pattern');
            const typeInfo = ecLevel.getBits() << 3 | maskPattern;
            bits.appendBits(typeInfo, 5);
            const bchCode = MatrixUtil.calculateBCHCode(typeInfo, MatrixUtil.TYPE_INFO_POLY);
            bits.appendBits(bchCode, 10);
            const maskBits = new BitArray();
            maskBits.appendBits(MatrixUtil.TYPE_INFO_MASK_PATTERN, 15);
            bits.xor(maskBits);
            if (bits.getSize() !== 15) throw new WriterException('should not happen but we got: ' + bits.getSize());
        }
        // Make bit vector of version information. On success, store the result in "bits" and return true.
        // See 8.10 of JISX0510:2004 (p.45) for details.
        static makeVersionInfoBits(version, bits) {
            bits.appendBits(version.getVersionNumber(), 6);
            const bchCode = MatrixUtil.calculateBCHCode(version.getVersionNumber(), MatrixUtil.VERSION_INFO_POLY);
            bits.appendBits(bchCode, 12);
            if (bits.getSize() !== 18) throw new WriterException('should not happen but we got: ' + bits.getSize());
        }
        // Check if "value" is empty.
        static isEmpty(value /*int*/ ) {
            return value === 255; // -1
        }
        static embedTimingPatterns(matrix) {
            // -8 is for skipping position detection patterns (7: size), and two horizontal/vertical
            // separation patterns (1: size). Thus, 8 = 7 + 1.
            for(let i = 8; i < matrix.getWidth() - 8; ++i){
                const bit = (i + 1) % 2;
                // Horizontal line.
                if (MatrixUtil.isEmpty(matrix.get(i, 6))) matrix.setNumber(i, 6, bit);
                // Vertical line.
                if (MatrixUtil.isEmpty(matrix.get(6, i))) matrix.setNumber(6, i, bit);
            }
        }
        // Embed the lonely dark dot at left bottom corner. JISX0510:2004 (p.46)
        static embedDarkDotAtLeftBottomCorner(matrix) {
            if (matrix.get(8, matrix.getHeight() - 8) === 0) throw new WriterException();
            matrix.setNumber(8, matrix.getHeight() - 8, 1);
        }
        static embedHorizontalSeparationPattern(xStart /*int*/ , yStart /*int*/ , matrix) {
            for(let x = 0; x < 8; ++x){
                if (!MatrixUtil.isEmpty(matrix.get(xStart + x, yStart))) throw new WriterException();
                matrix.setNumber(xStart + x, yStart, 0);
            }
        }
        static embedVerticalSeparationPattern(xStart /*int*/ , yStart /*int*/ , matrix) {
            for(let y = 0; y < 7; ++y){
                if (!MatrixUtil.isEmpty(matrix.get(xStart, yStart + y))) throw new WriterException();
                matrix.setNumber(xStart, yStart + y, 0);
            }
        }
        static embedPositionAdjustmentPattern(xStart /*int*/ , yStart /*int*/ , matrix) {
            for(let y = 0; y < 5; ++y){
                const patternY = MatrixUtil.POSITION_ADJUSTMENT_PATTERN[y];
                for(let x = 0; x < 5; ++x)matrix.setNumber(xStart + x, yStart + y, patternY[x]);
            }
        }
        static embedPositionDetectionPattern(xStart /*int*/ , yStart /*int*/ , matrix) {
            for(let y = 0; y < 7; ++y){
                const patternY = MatrixUtil.POSITION_DETECTION_PATTERN[y];
                for(let x = 0; x < 7; ++x)matrix.setNumber(xStart + x, yStart + y, patternY[x]);
            }
        }
        // Embed position detection patterns and surrounding vertical/horizontal separators.
        static embedPositionDetectionPatternsAndSeparators(matrix) {
            // Embed three big squares at corners.
            const pdpWidth = MatrixUtil.POSITION_DETECTION_PATTERN[0].length;
            // Left top corner.
            MatrixUtil.embedPositionDetectionPattern(0, 0, matrix);
            // Right top corner.
            MatrixUtil.embedPositionDetectionPattern(matrix.getWidth() - pdpWidth, 0, matrix);
            // Left bottom corner.
            MatrixUtil.embedPositionDetectionPattern(0, matrix.getWidth() - pdpWidth, matrix);
            // Embed horizontal separation patterns around the squares.
            const hspWidth = 8;
            // Left top corner.
            MatrixUtil.embedHorizontalSeparationPattern(0, hspWidth - 1, matrix);
            // Right top corner.
            MatrixUtil.embedHorizontalSeparationPattern(matrix.getWidth() - hspWidth, hspWidth - 1, matrix);
            // Left bottom corner.
            MatrixUtil.embedHorizontalSeparationPattern(0, matrix.getWidth() - hspWidth, matrix);
            // Embed vertical separation patterns around the squares.
            const vspSize = 7;
            // Left top corner.
            MatrixUtil.embedVerticalSeparationPattern(vspSize, 0, matrix);
            // Right top corner.
            MatrixUtil.embedVerticalSeparationPattern(matrix.getHeight() - vspSize - 1, 0, matrix);
            // Left bottom corner.
            MatrixUtil.embedVerticalSeparationPattern(vspSize, matrix.getHeight() - vspSize, matrix);
        }
        // Embed position adjustment patterns if need be.
        static maybeEmbedPositionAdjustmentPatterns(version, matrix) {
            if (version.getVersionNumber() < 2) return;
            const index = version.getVersionNumber() - 1;
            const coordinates = MatrixUtil.POSITION_ADJUSTMENT_PATTERN_COORDINATE_TABLE[index];
            for(let i = 0, length = coordinates.length; i !== length; i++){
                const y = coordinates[i];
                if (y >= 0) for(let j = 0; j !== length; j++){
                    const x = coordinates[j];
                    if (x >= 0 && MatrixUtil.isEmpty(matrix.get(x, y))) // If the cell is unset, we embed the position adjustment pattern here.
                    // -2 is necessary since the x/y coordinates point to the center of the pattern, not the
                    // left top corner.
                    MatrixUtil.embedPositionAdjustmentPattern(x - 2, y - 2, matrix);
                }
            }
        }
    }
    MatrixUtil.POSITION_DETECTION_PATTERN = Array.from([
        Int32Array.from([
            1,
            1,
            1,
            1,
            1,
            1,
            1
        ]),
        Int32Array.from([
            1,
            0,
            0,
            0,
            0,
            0,
            1
        ]),
        Int32Array.from([
            1,
            0,
            1,
            1,
            1,
            0,
            1
        ]),
        Int32Array.from([
            1,
            0,
            1,
            1,
            1,
            0,
            1
        ]),
        Int32Array.from([
            1,
            0,
            1,
            1,
            1,
            0,
            1
        ]),
        Int32Array.from([
            1,
            0,
            0,
            0,
            0,
            0,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            1,
            1,
            1,
            1
        ])
    ]);
    MatrixUtil.POSITION_ADJUSTMENT_PATTERN = Array.from([
        Int32Array.from([
            1,
            1,
            1,
            1,
            1
        ]),
        Int32Array.from([
            1,
            0,
            0,
            0,
            1
        ]),
        Int32Array.from([
            1,
            0,
            1,
            0,
            1
        ]),
        Int32Array.from([
            1,
            0,
            0,
            0,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            1,
            1
        ])
    ]);
    // From Appendix E. Table 1, JIS0510X:2004 (71: p). The table was double-checked by komatsu.
    MatrixUtil.POSITION_ADJUSTMENT_PATTERN_COORDINATE_TABLE = Array.from([
        Int32Array.from([
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            18,
            -1,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            22,
            -1,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            26,
            -1,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            -1,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            34,
            -1,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            22,
            38,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            24,
            42,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            26,
            46,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            28,
            50,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            54,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            32,
            58,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            34,
            62,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            26,
            46,
            66,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            26,
            48,
            70,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            26,
            50,
            74,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            54,
            78,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            56,
            82,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            58,
            86,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            34,
            62,
            90,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            28,
            50,
            72,
            94,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            26,
            50,
            74,
            98,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            54,
            78,
            102,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            28,
            54,
            80,
            106,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            32,
            58,
            84,
            110,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            58,
            86,
            114,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            34,
            62,
            90,
            118,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            26,
            50,
            74,
            98,
            122,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            54,
            78,
            102,
            126,
            -1
        ]),
        Int32Array.from([
            6,
            26,
            52,
            78,
            104,
            130,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            56,
            82,
            108,
            134,
            -1
        ]),
        Int32Array.from([
            6,
            34,
            60,
            86,
            112,
            138,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            58,
            86,
            114,
            142,
            -1
        ]),
        Int32Array.from([
            6,
            34,
            62,
            90,
            118,
            146,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            54,
            78,
            102,
            126,
            150
        ]),
        Int32Array.from([
            6,
            24,
            50,
            76,
            102,
            128,
            154
        ]),
        Int32Array.from([
            6,
            28,
            54,
            80,
            106,
            132,
            158
        ]),
        Int32Array.from([
            6,
            32,
            58,
            84,
            110,
            136,
            162
        ]),
        Int32Array.from([
            6,
            26,
            54,
            82,
            110,
            138,
            166
        ]),
        Int32Array.from([
            6,
            30,
            58,
            86,
            114,
            142,
            170
        ])
    ]);
    // Type info cells at the left top corner.
    MatrixUtil.TYPE_INFO_COORDINATES = Array.from([
        Int32Array.from([
            8,
            0
        ]),
        Int32Array.from([
            8,
            1
        ]),
        Int32Array.from([
            8,
            2
        ]),
        Int32Array.from([
            8,
            3
        ]),
        Int32Array.from([
            8,
            4
        ]),
        Int32Array.from([
            8,
            5
        ]),
        Int32Array.from([
            8,
            7
        ]),
        Int32Array.from([
            8,
            8
        ]),
        Int32Array.from([
            7,
            8
        ]),
        Int32Array.from([
            5,
            8
        ]),
        Int32Array.from([
            4,
            8
        ]),
        Int32Array.from([
            3,
            8
        ]),
        Int32Array.from([
            2,
            8
        ]),
        Int32Array.from([
            1,
            8
        ]),
        Int32Array.from([
            0,
            8
        ])
    ]);
    // From Appendix D in JISX0510:2004 (p. 67)
    MatrixUtil.VERSION_INFO_POLY = 0x1f25; // 1 1111 0010 0101
    // From Appendix C in JISX0510:2004 (p.65).
    MatrixUtil.TYPE_INFO_POLY = 0x537;
    MatrixUtil.TYPE_INFO_MASK_PATTERN = 0x5412;
    /*namespace com.google.zxing.qrcode.encoder {*/ class BlockPair {
        constructor(dataBytes, errorCorrectionBytes){
            this.dataBytes = dataBytes;
            this.errorCorrectionBytes = errorCorrectionBytes;
        }
        getDataBytes() {
            return this.dataBytes;
        }
        getErrorCorrectionBytes() {
            return this.errorCorrectionBytes;
        }
    }
    /*import java.io.UnsupportedEncodingException;*/ /*import java.util.ArrayList;*/ /*import java.util.Collection;*/ /*import java.util.Map;*/ /**
     * @author satorux@google.com (Satoru Takabayashi) - creator
     * @author dswitkin@google.com (Daniel Switkin) - ported from C++
     */ class Encoder {
        // TYPESCRIPTPORT: changed to UTF8, the default for js
        constructor(){}
        // The mask penalty calculation is complicated.  See Table 21 of JISX0510:2004 (p.45) for details.
        // Basically it applies four rules and summate all penalties.
        static calculateMaskPenalty(matrix) {
            return MaskUtil.applyMaskPenaltyRule1(matrix) + MaskUtil.applyMaskPenaltyRule2(matrix) + MaskUtil.applyMaskPenaltyRule3(matrix) + MaskUtil.applyMaskPenaltyRule4(matrix);
        }
        /**
         * @param content text to encode
         * @param ecLevel error correction level to use
         * @return {@link QRCode} representing the encoded QR code
         * @throws WriterException if encoding can't succeed, because of for example invalid content
         *   or configuration
         */ // public static encode(content: string, ecLevel: ErrorCorrectionLevel): QRCode /*throws WriterException*/ {
        //   return encode(content, ecLevel, null)
        // }
        static encode(content, ecLevel, hints = null) {
            // Determine what character encoding has been specified by the caller, if any
            let encoding = Encoder.DEFAULT_BYTE_MODE_ENCODING;
            const hasEncodingHint = hints !== null && undefined !== hints.get(EncodeHintType$1.CHARACTER_SET);
            if (hasEncodingHint) encoding = hints.get(EncodeHintType$1.CHARACTER_SET).toString();
            // Pick an encoding mode appropriate for the content. Note that this will not attempt to use
            // multiple modes / segments even if that were more efficient. Twould be nice.
            const mode = this.chooseMode(content, encoding);
            // This will store the header information, like mode and
            // length, as well as "header" segments like an ECI segment.
            const headerBits = new BitArray();
            // Append ECI segment if applicable
            if (mode === Mode$1.BYTE && (hasEncodingHint || Encoder.DEFAULT_BYTE_MODE_ENCODING !== encoding)) {
                const eci = CharacterSetECI.getCharacterSetECIByName(encoding);
                if (eci !== undefined) this.appendECI(eci, headerBits);
            }
            // (With ECI in place,) Write the mode marker
            this.appendModeInfo(mode, headerBits);
            // Collect data within the main segment, separately, to count its size if needed. Don't add it to
            // main payload yet.
            const dataBits = new BitArray();
            this.appendBytes(content, mode, dataBits, encoding);
            let version;
            if (hints !== null && undefined !== hints.get(EncodeHintType$1.QR_VERSION)) {
                const versionNumber = Number.parseInt(hints.get(EncodeHintType$1.QR_VERSION).toString(), 10);
                version = Version$1.getVersionForNumber(versionNumber);
                const bitsNeeded = this.calculateBitsNeeded(mode, headerBits, dataBits, version);
                if (!this.willFit(bitsNeeded, version, ecLevel)) throw new WriterException('Data too big for requested version');
            } else version = this.recommendVersion(ecLevel, mode, headerBits, dataBits);
            const headerAndDataBits = new BitArray();
            headerAndDataBits.appendBitArray(headerBits);
            // Find "length" of main segment and write it
            const numLetters = mode === Mode$1.BYTE ? dataBits.getSizeInBytes() : content.length;
            this.appendLengthInfo(numLetters, version, mode, headerAndDataBits);
            // Put data together into the overall payload
            headerAndDataBits.appendBitArray(dataBits);
            const ecBlocks = version.getECBlocksForLevel(ecLevel);
            const numDataBytes = version.getTotalCodewords() - ecBlocks.getTotalECCodewords();
            // Terminate the bits properly.
            this.terminateBits(numDataBytes, headerAndDataBits);
            // Interleave data bits with error correction code.
            const finalBits = this.interleaveWithECBytes(headerAndDataBits, version.getTotalCodewords(), numDataBytes, ecBlocks.getNumBlocks());
            const qrCode = new QRCode();
            qrCode.setECLevel(ecLevel);
            qrCode.setMode(mode);
            qrCode.setVersion(version);
            //  Choose the mask pattern and set to "qrCode".
            const dimension = version.getDimensionForVersion();
            const matrix = new ByteMatrix(dimension, dimension);
            const maskPattern = this.chooseMaskPattern(finalBits, ecLevel, version, matrix);
            qrCode.setMaskPattern(maskPattern);
            // Build the matrix and set it to "qrCode".
            MatrixUtil.buildMatrix(finalBits, ecLevel, version, maskPattern, matrix);
            qrCode.setMatrix(matrix);
            return qrCode;
        }
        /**
         * Decides the smallest version of QR code that will contain all of the provided data.
         *
         * @throws WriterException if the data cannot fit in any version
         */ static recommendVersion(ecLevel, mode, headerBits, dataBits) {
            // Hard part: need to know version to know how many bits length takes. But need to know how many
            // bits it takes to know version. First we take a guess at version by assuming version will be
            // the minimum, 1:
            const provisionalBitsNeeded = this.calculateBitsNeeded(mode, headerBits, dataBits, Version$1.getVersionForNumber(1));
            const provisionalVersion = this.chooseVersion(provisionalBitsNeeded, ecLevel);
            // Use that guess to calculate the right version. I am still not sure this works in 100% of cases.
            const bitsNeeded = this.calculateBitsNeeded(mode, headerBits, dataBits, provisionalVersion);
            return this.chooseVersion(bitsNeeded, ecLevel);
        }
        static calculateBitsNeeded(mode, headerBits, dataBits, version) {
            return headerBits.getSize() + mode.getCharacterCountBits(version) + dataBits.getSize();
        }
        /**
         * @return the code point of the table used in alphanumeric mode or
         *  -1 if there is no corresponding code in the table.
         */ static getAlphanumericCode(code /*int*/ ) {
            if (code < Encoder.ALPHANUMERIC_TABLE.length) return Encoder.ALPHANUMERIC_TABLE[code];
            return -1;
        }
        // public static chooseMode(content: string): Mode {
        //   return chooseMode(content, null);
        // }
        /**
         * Choose the best mode by examining the content. Note that 'encoding' is used as a hint;
         * if it is Shift_JIS, and the input is only double-byte Kanji, then we return {@link Mode#KANJI}.
         */ static chooseMode(content, encoding = null) {
            if (CharacterSetECI.SJIS.getName() === encoding && this.isOnlyDoubleByteKanji(content)) // Choose Kanji mode if all input are double-byte characters
            return Mode$1.KANJI;
            let hasNumeric = false;
            let hasAlphanumeric = false;
            for(let i = 0, length = content.length; i < length; ++i){
                const c = content.charAt(i);
                if (Encoder.isDigit(c)) hasNumeric = true;
                else if (this.getAlphanumericCode(c.charCodeAt(0)) !== -1) hasAlphanumeric = true;
                else return Mode$1.BYTE;
            }
            if (hasAlphanumeric) return Mode$1.ALPHANUMERIC;
            if (hasNumeric) return Mode$1.NUMERIC;
            return Mode$1.BYTE;
        }
        static isOnlyDoubleByteKanji(content) {
            let bytes;
            try {
                bytes = StringEncoding.encode(content, CharacterSetECI.SJIS); // content.getBytes("Shift_JIS"))
            } catch (ignored /*: UnsupportedEncodingException*/ ) {
                return false;
            }
            const length = bytes.length;
            if (length % 2 !== 0) return false;
            for(let i = 0; i < length; i += 2){
                const byte1 = bytes[i] & 0xFF;
                if ((byte1 < 0x81 || byte1 > 0x9F) && (byte1 < 0xE0 || byte1 > 0xEB)) return false;
            }
            return true;
        }
        static chooseMaskPattern(bits, ecLevel, version, matrix) {
            let minPenalty = Number.MAX_SAFE_INTEGER; // Lower penalty is better.
            let bestMaskPattern = -1;
            // We try all mask patterns to choose the best one.
            for(let maskPattern = 0; maskPattern < QRCode.NUM_MASK_PATTERNS; maskPattern++){
                MatrixUtil.buildMatrix(bits, ecLevel, version, maskPattern, matrix);
                let penalty = this.calculateMaskPenalty(matrix);
                if (penalty < minPenalty) {
                    minPenalty = penalty;
                    bestMaskPattern = maskPattern;
                }
            }
            return bestMaskPattern;
        }
        static chooseVersion(numInputBits /*int*/ , ecLevel) {
            for(let versionNum = 1; versionNum <= 40; versionNum++){
                const version = Version$1.getVersionForNumber(versionNum);
                if (Encoder.willFit(numInputBits, version, ecLevel)) return version;
            }
            throw new WriterException('Data too big');
        }
        /**
         * @return true if the number of input bits will fit in a code with the specified version and
         * error correction level.
         */ static willFit(numInputBits /*int*/ , version, ecLevel) {
            // In the following comments, we use numbers of Version 7-H.
            // numBytes = 196
            const numBytes = version.getTotalCodewords();
            // getNumECBytes = 130
            const ecBlocks = version.getECBlocksForLevel(ecLevel);
            const numEcBytes = ecBlocks.getTotalECCodewords();
            // getNumDataBytes = 196 - 130 = 66
            const numDataBytes = numBytes - numEcBytes;
            const totalInputBytes = (numInputBits + 7) / 8;
            return numDataBytes >= totalInputBytes;
        }
        /**
         * Terminate bits as described in 8.4.8 and 8.4.9 of JISX0510:2004 (p.24).
         */ static terminateBits(numDataBytes /*int*/ , bits) {
            const capacity = numDataBytes * 8;
            if (bits.getSize() > capacity) throw new WriterException('data bits cannot fit in the QR Code' + bits.getSize() + ' > ' + capacity);
            for(let i = 0; i < 4 && bits.getSize() < capacity; ++i)bits.appendBit(false);
            // Append termination bits. See 8.4.8 of JISX0510:2004 (p.24) for details.
            // If the last byte isn't 8-bit aligned, we'll add padding bits.
            const numBitsInLastByte = bits.getSize() & 0x07;
            if (numBitsInLastByte > 0) for(let i = numBitsInLastByte; i < 8; i++)bits.appendBit(false);
            // If we have more space, we'll fill the space with padding patterns defined in 8.4.9 (p.24).
            const numPaddingBytes = numDataBytes - bits.getSizeInBytes();
            for(let i = 0; i < numPaddingBytes; ++i)bits.appendBits((i & 0x01) === 0 ? 0xEC : 0x11, 8);
            if (bits.getSize() !== capacity) throw new WriterException('Bits size does not equal capacity');
        }
        /**
         * Get number of data bytes and number of error correction bytes for block id "blockID". Store
         * the result in "numDataBytesInBlock", and "numECBytesInBlock". See table 12 in 8.5.1 of
         * JISX0510:2004 (p.30)
         */ static getNumDataBytesAndNumECBytesForBlockID(numTotalBytes /*int*/ , numDataBytes /*int*/ , numRSBlocks /*int*/ , blockID /*int*/ , numDataBytesInBlock, numECBytesInBlock) {
            if (blockID >= numRSBlocks) throw new WriterException('Block ID too large');
            // numRsBlocksInGroup2 = 196 % 5 = 1
            const numRsBlocksInGroup2 = numTotalBytes % numRSBlocks;
            // numRsBlocksInGroup1 = 5 - 1 = 4
            const numRsBlocksInGroup1 = numRSBlocks - numRsBlocksInGroup2;
            // numTotalBytesInGroup1 = 196 / 5 = 39
            const numTotalBytesInGroup1 = Math.floor(numTotalBytes / numRSBlocks);
            // numTotalBytesInGroup2 = 39 + 1 = 40
            const numTotalBytesInGroup2 = numTotalBytesInGroup1 + 1;
            // numDataBytesInGroup1 = 66 / 5 = 13
            const numDataBytesInGroup1 = Math.floor(numDataBytes / numRSBlocks);
            // numDataBytesInGroup2 = 13 + 1 = 14
            const numDataBytesInGroup2 = numDataBytesInGroup1 + 1;
            // numEcBytesInGroup1 = 39 - 13 = 26
            const numEcBytesInGroup1 = numTotalBytesInGroup1 - numDataBytesInGroup1;
            // numEcBytesInGroup2 = 40 - 14 = 26
            const numEcBytesInGroup2 = numTotalBytesInGroup2 - numDataBytesInGroup2;
            // Sanity checks.
            // 26 = 26
            if (numEcBytesInGroup1 !== numEcBytesInGroup2) throw new WriterException('EC bytes mismatch');
            // 5 = 4 + 1.
            if (numRSBlocks !== numRsBlocksInGroup1 + numRsBlocksInGroup2) throw new WriterException('RS blocks mismatch');
            // 196 = (13 + 26) * 4 + (14 + 26) * 1
            if (numTotalBytes !== (numDataBytesInGroup1 + numEcBytesInGroup1) * numRsBlocksInGroup1 + (numDataBytesInGroup2 + numEcBytesInGroup2) * numRsBlocksInGroup2) throw new WriterException('Total bytes mismatch');
            if (blockID < numRsBlocksInGroup1) {
                numDataBytesInBlock[0] = numDataBytesInGroup1;
                numECBytesInBlock[0] = numEcBytesInGroup1;
            } else {
                numDataBytesInBlock[0] = numDataBytesInGroup2;
                numECBytesInBlock[0] = numEcBytesInGroup2;
            }
        }
        /**
         * Interleave "bits" with corresponding error correction bytes. On success, store the result in
         * "result". The interleave rule is complicated. See 8.6 of JISX0510:2004 (p.37) for details.
         */ static interleaveWithECBytes(bits, numTotalBytes /*int*/ , numDataBytes /*int*/ , numRSBlocks /*int*/ ) {
            // "bits" must have "getNumDataBytes" bytes of data.
            if (bits.getSizeInBytes() !== numDataBytes) throw new WriterException('Number of bits and data bytes does not match');
            // Step 1.  Divide data bytes into blocks and generate error correction bytes for them. We'll
            // store the divided data bytes blocks and error correction bytes blocks into "blocks".
            let dataBytesOffset = 0;
            let maxNumDataBytes = 0;
            let maxNumEcBytes = 0;
            // Since, we know the number of reedsolmon blocks, we can initialize the vector with the number.
            const blocks = new Array(); // new Array<BlockPair>(numRSBlocks)
            for(let i = 0; i < numRSBlocks; ++i){
                const numDataBytesInBlock = new Int32Array(1);
                const numEcBytesInBlock = new Int32Array(1);
                Encoder.getNumDataBytesAndNumECBytesForBlockID(numTotalBytes, numDataBytes, numRSBlocks, i, numDataBytesInBlock, numEcBytesInBlock);
                const size = numDataBytesInBlock[0];
                const dataBytes = new Uint8Array(size);
                bits.toBytes(8 * dataBytesOffset, dataBytes, 0, size);
                const ecBytes = Encoder.generateECBytes(dataBytes, numEcBytesInBlock[0]);
                blocks.push(new BlockPair(dataBytes, ecBytes));
                maxNumDataBytes = Math.max(maxNumDataBytes, size);
                maxNumEcBytes = Math.max(maxNumEcBytes, ecBytes.length);
                dataBytesOffset += numDataBytesInBlock[0];
            }
            if (numDataBytes !== dataBytesOffset) throw new WriterException('Data bytes does not match offset');
            const result = new BitArray();
            // First, place data blocks.
            for(let i = 0; i < maxNumDataBytes; ++i)for (const block of blocks){
                const dataBytes = block.getDataBytes();
                if (i < dataBytes.length) result.appendBits(dataBytes[i], 8);
            }
            // Then, place error correction blocks.
            for(let i = 0; i < maxNumEcBytes; ++i)for (const block of blocks){
                const ecBytes = block.getErrorCorrectionBytes();
                if (i < ecBytes.length) result.appendBits(ecBytes[i], 8);
            }
            if (numTotalBytes !== result.getSizeInBytes()) throw new WriterException('Interleaving error: ' + numTotalBytes + ' and ' + result.getSizeInBytes() + ' differ.');
            return result;
        }
        static generateECBytes(dataBytes, numEcBytesInBlock /*int*/ ) {
            const numDataBytes = dataBytes.length;
            const toEncode = new Int32Array(numDataBytes + numEcBytesInBlock); // int[numDataBytes + numEcBytesInBlock]
            for(let i = 0; i < numDataBytes; i++)toEncode[i] = dataBytes[i] & 0xFF;
            new ReedSolomonEncoder(GenericGF.QR_CODE_FIELD_256).encode(toEncode, numEcBytesInBlock);
            const ecBytes = new Uint8Array(numEcBytesInBlock);
            for(let i = 0; i < numEcBytesInBlock; i++)ecBytes[i] = /*(byte) */ toEncode[numDataBytes + i];
            return ecBytes;
        }
        /**
         * Append mode info. On success, store the result in "bits".
         */ static appendModeInfo(mode, bits) {
            bits.appendBits(mode.getBits(), 4);
        }
        /**
         * Append length info. On success, store the result in "bits".
         */ static appendLengthInfo(numLetters /*int*/ , version, mode, bits) {
            const numBits = mode.getCharacterCountBits(version);
            if (numLetters >= 1 << numBits) throw new WriterException(numLetters + ' is bigger than ' + ((1 << numBits) - 1));
            bits.appendBits(numLetters, numBits);
        }
        /**
         * Append "bytes" in "mode" mode (encoding) into "bits". On success, store the result in "bits".
         */ static appendBytes(content, mode, bits, encoding) {
            switch(mode){
                case Mode$1.NUMERIC:
                    Encoder.appendNumericBytes(content, bits);
                    break;
                case Mode$1.ALPHANUMERIC:
                    Encoder.appendAlphanumericBytes(content, bits);
                    break;
                case Mode$1.BYTE:
                    Encoder.append8BitBytes(content, bits, encoding);
                    break;
                case Mode$1.KANJI:
                    Encoder.appendKanjiBytes(content, bits);
                    break;
                default:
                    throw new WriterException('Invalid mode: ' + mode);
            }
        }
        static getDigit(singleCharacter) {
            return singleCharacter.charCodeAt(0) - 48;
        }
        static isDigit(singleCharacter) {
            const cn = Encoder.getDigit(singleCharacter);
            return cn >= 0 && cn <= 9;
        }
        static appendNumericBytes(content, bits) {
            const length = content.length;
            let i = 0;
            while(i < length){
                const num1 = Encoder.getDigit(content.charAt(i));
                if (i + 2 < length) {
                    // Encode three numeric letters in ten bits.
                    const num2 = Encoder.getDigit(content.charAt(i + 1));
                    const num3 = Encoder.getDigit(content.charAt(i + 2));
                    bits.appendBits(num1 * 100 + num2 * 10 + num3, 10);
                    i += 3;
                } else if (i + 1 < length) {
                    // Encode two numeric letters in seven bits.
                    const num2 = Encoder.getDigit(content.charAt(i + 1));
                    bits.appendBits(num1 * 10 + num2, 7);
                    i += 2;
                } else {
                    // Encode one numeric letter in four bits.
                    bits.appendBits(num1, 4);
                    i++;
                }
            }
        }
        static appendAlphanumericBytes(content, bits) {
            const length = content.length;
            let i = 0;
            while(i < length){
                const code1 = Encoder.getAlphanumericCode(content.charCodeAt(i));
                if (code1 === -1) throw new WriterException();
                if (i + 1 < length) {
                    const code2 = Encoder.getAlphanumericCode(content.charCodeAt(i + 1));
                    if (code2 === -1) throw new WriterException();
                    // Encode two alphanumeric letters in 11 bits.
                    bits.appendBits(code1 * 45 + code2, 11);
                    i += 2;
                } else {
                    // Encode one alphanumeric letter in six bits.
                    bits.appendBits(code1, 6);
                    i++;
                }
            }
        }
        static append8BitBytes(content, bits, encoding) {
            let bytes;
            try {
                bytes = StringEncoding.encode(content, encoding);
            } catch (uee /*: UnsupportedEncodingException*/ ) {
                throw new WriterException(uee);
            }
            for(let i = 0, length = bytes.length; i !== length; i++){
                const b = bytes[i];
                bits.appendBits(b, 8);
            }
        }
        /**
         * @throws WriterException
         */ static appendKanjiBytes(content, bits) {
            let bytes;
            try {
                bytes = StringEncoding.encode(content, CharacterSetECI.SJIS);
            } catch (uee /*: UnsupportedEncodingException*/ ) {
                throw new WriterException(uee);
            }
            const length = bytes.length;
            for(let i = 0; i < length; i += 2){
                const byte1 = bytes[i] & 0xFF;
                const byte2 = bytes[i + 1] & 0xFF;
                const code = byte1 << 8 & 0xFFFFFFFF | byte2;
                let subtracted = -1;
                if (code >= 0x8140 && code <= 0x9ffc) subtracted = code - 0x8140;
                else if (code >= 0xe040 && code <= 0xebbf) subtracted = code - 0xc140;
                if (subtracted === -1) throw new WriterException('Invalid byte sequence');
                const encoded = (subtracted >> 8) * 0xc0 + (subtracted & 0xff);
                bits.appendBits(encoded, 13);
            }
        }
        static appendECI(eci, bits) {
            bits.appendBits(Mode$1.ECI.getBits(), 4);
            // This is correct for values up to 127, which is all we need now.
            bits.appendBits(eci.getValue(), 8);
        }
    }
    // The original table is defined in the table 5 of JISX0510:2004 (p.19).
    Encoder.ALPHANUMERIC_TABLE = Int32Array.from([
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        36,
        -1,
        -1,
        -1,
        37,
        38,
        -1,
        -1,
        -1,
        -1,
        39,
        40,
        -1,
        41,
        42,
        43,
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        44,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23,
        24,
        25,
        26,
        27,
        28,
        29,
        30,
        31,
        32,
        33,
        34,
        35,
        -1,
        -1,
        -1,
        -1,
        -1
    ]);
    Encoder.DEFAULT_BYTE_MODE_ENCODING = CharacterSetECI.UTF8.getName(); // "ISO-8859-1"
    /**
     * @deprecated Moving to @zxing/browser
     */ class BrowserQRCodeSvgWriter {
        /**
         * Writes and renders a QRCode SVG element.
         *
         * @param contents
         * @param width
         * @param height
         * @param hints
         */ write(contents, width, height, hints = null) {
            if (contents.length === 0) throw new IllegalArgumentException('Found empty contents');
            // if (format != BarcodeFormat.QR_CODE) {
            //   throw new IllegalArgumentException("Can only encode QR_CODE, but got " + format)
            // }
            if (width < 0 || height < 0) throw new IllegalArgumentException('Requested dimensions are too small: ' + width + 'x' + height);
            let errorCorrectionLevel = ErrorCorrectionLevel.L;
            let quietZone = BrowserQRCodeSvgWriter.QUIET_ZONE_SIZE;
            if (hints !== null) {
                if (undefined !== hints.get(EncodeHintType$1.ERROR_CORRECTION)) errorCorrectionLevel = ErrorCorrectionLevel.fromString(hints.get(EncodeHintType$1.ERROR_CORRECTION).toString());
                if (undefined !== hints.get(EncodeHintType$1.MARGIN)) quietZone = Number.parseInt(hints.get(EncodeHintType$1.MARGIN).toString(), 10);
            }
            const code = Encoder.encode(contents, errorCorrectionLevel, hints);
            return this.renderResult(code, width, height, quietZone);
        }
        /**
         * Renders the result and then appends it to the DOM.
         */ writeToDom(containerElement, contents, width, height, hints = null) {
            if (typeof containerElement === 'string') containerElement = document.querySelector(containerElement);
            const svgElement = this.write(contents, width, height, hints);
            if (containerElement) containerElement.appendChild(svgElement);
        }
        /**
         * Note that the input matrix uses 0 == white, 1 == black.
         * The output matrix uses 0 == black, 255 == white (i.e. an 8 bit greyscale bitmap).
         */ renderResult(code, width /*int*/ , height /*int*/ , quietZone /*int*/ ) {
            const input = code.getMatrix();
            if (input === null) throw new IllegalStateException();
            const inputWidth = input.getWidth();
            const inputHeight = input.getHeight();
            const qrWidth = inputWidth + quietZone * 2;
            const qrHeight = inputHeight + quietZone * 2;
            const outputWidth = Math.max(width, qrWidth);
            const outputHeight = Math.max(height, qrHeight);
            const multiple = Math.min(Math.floor(outputWidth / qrWidth), Math.floor(outputHeight / qrHeight));
            // Padding includes both the quiet zone and the extra white pixels to accommodate the requested
            // dimensions. For example, if input is 25x25 the QR will be 33x33 including the quiet zone.
            // If the requested size is 200x160, the multiple will be 4, for a QR of 132x132. These will
            // handle all the padding from 100x100 (the actual QR) up to 200x160.
            const leftPadding = Math.floor((outputWidth - inputWidth * multiple) / 2);
            const topPadding = Math.floor((outputHeight - inputHeight * multiple) / 2);
            const svgElement = this.createSVGElement(outputWidth, outputHeight);
            for(let inputY = 0, outputY = topPadding; inputY < inputHeight; inputY++, outputY += multiple){
                // Write the contents of this row of the barcode
                for(let inputX = 0, outputX = leftPadding; inputX < inputWidth; inputX++, outputX += multiple)if (input.get(inputX, inputY) === 1) {
                    const svgRectElement = this.createSvgRectElement(outputX, outputY, multiple, multiple);
                    svgElement.appendChild(svgRectElement);
                }
            }
            return svgElement;
        }
        /**
         * Creates a SVG element.
         *
         * @param w SVG's width attribute
         * @param h SVG's height attribute
         */ createSVGElement(w, h) {
            const svgElement = document.createElementNS(BrowserQRCodeSvgWriter.SVG_NS, 'svg');
            svgElement.setAttributeNS(null, 'height', w.toString());
            svgElement.setAttributeNS(null, 'width', h.toString());
            return svgElement;
        }
        /**
         * Creates a SVG rect element.
         *
         * @param x Element's x coordinate
         * @param y Element's y coordinate
         * @param w Element's width attribute
         * @param h Element's height attribute
         */ createSvgRectElement(x, y, w, h) {
            const rect = document.createElementNS(BrowserQRCodeSvgWriter.SVG_NS, 'rect');
            rect.setAttributeNS(null, 'x', x.toString());
            rect.setAttributeNS(null, 'y', y.toString());
            rect.setAttributeNS(null, 'height', w.toString());
            rect.setAttributeNS(null, 'width', h.toString());
            rect.setAttributeNS(null, 'fill', '#000000');
            return rect;
        }
    }
    BrowserQRCodeSvgWriter.QUIET_ZONE_SIZE = 4;
    /**
     * SVG markup NameSpace
     */ BrowserQRCodeSvgWriter.SVG_NS = 'http://www.w3.org/2000/svg';
    /*import java.util.Map;*/ /**
     * This object renders a QR Code as a BitMatrix 2D array of greyscale values.
     *
     * @author dswitkin@google.com (Daniel Switkin)
     */ class QRCodeWriter {
        /*@Override*/ // public encode(contents: string, format: BarcodeFormat, width: number /*int*/, height: number /*int*/): BitMatrix
        //     /*throws WriterException */ {
        //   return encode(contents, format, width, height, null)
        // }
        /*@Override*/ encode(contents, format, width /*int*/ , height /*int*/ , hints) {
            if (contents.length === 0) throw new IllegalArgumentException('Found empty contents');
            if (format !== BarcodeFormat$1.QR_CODE) throw new IllegalArgumentException('Can only encode QR_CODE, but got ' + format);
            if (width < 0 || height < 0) throw new IllegalArgumentException(`Requested dimensions are too small: ${width}x${height}`);
            let errorCorrectionLevel = ErrorCorrectionLevel.L;
            let quietZone = QRCodeWriter.QUIET_ZONE_SIZE;
            if (hints !== null) {
                if (undefined !== hints.get(EncodeHintType$1.ERROR_CORRECTION)) errorCorrectionLevel = ErrorCorrectionLevel.fromString(hints.get(EncodeHintType$1.ERROR_CORRECTION).toString());
                if (undefined !== hints.get(EncodeHintType$1.MARGIN)) quietZone = Number.parseInt(hints.get(EncodeHintType$1.MARGIN).toString(), 10);
            }
            const code = Encoder.encode(contents, errorCorrectionLevel, hints);
            return QRCodeWriter.renderResult(code, width, height, quietZone);
        }
        // Note that the input matrix uses 0 == white, 1 == black, while the output matrix uses
        // 0 == black, 255 == white (i.e. an 8 bit greyscale bitmap).
        static renderResult(code, width /*int*/ , height /*int*/ , quietZone /*int*/ ) {
            const input = code.getMatrix();
            if (input === null) throw new IllegalStateException();
            const inputWidth = input.getWidth();
            const inputHeight = input.getHeight();
            const qrWidth = inputWidth + quietZone * 2;
            const qrHeight = inputHeight + quietZone * 2;
            const outputWidth = Math.max(width, qrWidth);
            const outputHeight = Math.max(height, qrHeight);
            const multiple = Math.min(Math.floor(outputWidth / qrWidth), Math.floor(outputHeight / qrHeight));
            // Padding includes both the quiet zone and the extra white pixels to accommodate the requested
            // dimensions. For example, if input is 25x25 the QR will be 33x33 including the quiet zone.
            // If the requested size is 200x160, the multiple will be 4, for a QR of 132x132. These will
            // handle all the padding from 100x100 (the actual QR) up to 200x160.
            const leftPadding = Math.floor((outputWidth - inputWidth * multiple) / 2);
            const topPadding = Math.floor((outputHeight - inputHeight * multiple) / 2);
            const output = new BitMatrix(outputWidth, outputHeight);
            for(let inputY = 0, outputY = topPadding; inputY < inputHeight; inputY++, outputY += multiple){
                // Write the contents of this row of the barcode
                for(let inputX = 0, outputX = leftPadding; inputX < inputWidth; inputX++, outputX += multiple)if (input.get(inputX, inputY) === 1) output.setRegion(outputX, outputY, multiple, multiple);
            }
            return output;
        }
    }
    QRCodeWriter.QUIET_ZONE_SIZE = 4;
    /*import java.util.Map;*/ /**
     * This is a factory class which finds the appropriate Writer subclass for the BarcodeFormat
     * requested and encodes the barcode with the supplied contents.
     *
     * @author dswitkin@google.com (Daniel Switkin)
     */ class MultiFormatWriter {
        /*@Override*/ // public encode(contents: string,
        //                         format: BarcodeFormat,
        //                         width: number /*int*/,
        //                         height: number /*int*/): BitMatrix /*throws WriterException */ {
        //   return encode(contents, format, width, height, null)
        // }
        /*@Override*/ encode(contents, format, width /*int*/ , height /*int*/ , hints) {
            let writer;
            switch(format){
                // case BarcodeFormat.EAN_8:
                //   writer = new EAN8Writer()
                //   break
                // case BarcodeFormat.UPC_E:
                //   writer = new UPCEWriter()
                //   break
                // case BarcodeFormat.EAN_13:
                //   writer = new EAN13Writer()
                //   break
                // case BarcodeFormat.UPC_A:
                //   writer = new UPCAWriter()
                //   break
                case BarcodeFormat$1.QR_CODE:
                    writer = new QRCodeWriter();
                    break;
                // case BarcodeFormat.CODE_39:
                //   writer = new Code39Writer()
                //   break
                // case BarcodeFormat.CODE_93:
                //   writer = new Code93Writer()
                //   break
                // case BarcodeFormat.CODE_128:
                //   writer = new Code128Writer()
                //   break
                // case BarcodeFormat.ITF:
                //   writer = new ITFWriter()
                //   break
                // case BarcodeFormat.PDF_417:
                //   writer = new PDF417Writer()
                //   break
                // case BarcodeFormat.CODABAR:
                //   writer = new CodaBarWriter()
                //   break
                // case BarcodeFormat.DATA_MATRIX:
                //   writer = new DataMatrixWriter()
                //   break
                // case BarcodeFormat.AZTEC:
                //   writer = new AztecWriter()
                //   break
                default:
                    throw new IllegalArgumentException('No encoder available for format ' + format);
            }
            return writer.encode(contents, format, width, height, hints);
        }
    }
    /*
     * Copyright 2009 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * This object extends LuminanceSource around an array of YUV data returned from the camera driver,
     * with the option to crop to a rectangle within the full data. This can be used to exclude
     * superfluous pixels around the perimeter and speed up decoding.
     *
     * It works for any pixel format where the Y channel is planar and appears first, including
     * YCbCr_420_SP and YCbCr_422_SP.
     *
     * @author dswitkin@google.com (Daniel Switkin)
     */ class PlanarYUVLuminanceSource extends LuminanceSource {
        constructor(yuvData, dataWidth /*int*/ , dataHeight /*int*/ , left /*int*/ , top /*int*/ , width /*int*/ , height /*int*/ , reverseHorizontal){
            super(width, height);
            this.yuvData = yuvData;
            this.dataWidth = dataWidth;
            this.dataHeight = dataHeight;
            this.left = left;
            this.top = top;
            if (left + width > dataWidth || top + height > dataHeight) throw new IllegalArgumentException('Crop rectangle does not fit within image data.');
            if (reverseHorizontal) this.reverseHorizontal(width, height);
        }
        /*@Override*/ getRow(y /*int*/ , row) {
            if (y < 0 || y >= this.getHeight()) throw new IllegalArgumentException('Requested row is outside the image: ' + y);
            const width = this.getWidth();
            if (row === null || row === undefined || row.length < width) row = new Uint8ClampedArray(width);
            const offset = (y + this.top) * this.dataWidth + this.left;
            System.arraycopy(this.yuvData, offset, row, 0, width);
            return row;
        }
        /*@Override*/ getMatrix() {
            const width = this.getWidth();
            const height = this.getHeight();
            // If the caller asks for the entire underlying image, save the copy and give them the
            // original data. The docs specifically warn that result.length must be ignored.
            if (width === this.dataWidth && height === this.dataHeight) return this.yuvData;
            const area = width * height;
            const matrix = new Uint8ClampedArray(area);
            let inputOffset = this.top * this.dataWidth + this.left;
            // If the width matches the full width of the underlying data, perform a single copy.
            if (width === this.dataWidth) {
                System.arraycopy(this.yuvData, inputOffset, matrix, 0, area);
                return matrix;
            }
            // Otherwise copy one cropped row at a time.
            for(let y = 0; y < height; y++){
                const outputOffset = y * width;
                System.arraycopy(this.yuvData, inputOffset, matrix, outputOffset, width);
                inputOffset += this.dataWidth;
            }
            return matrix;
        }
        /*@Override*/ isCropSupported() {
            return true;
        }
        /*@Override*/ crop(left /*int*/ , top /*int*/ , width /*int*/ , height /*int*/ ) {
            return new PlanarYUVLuminanceSource(this.yuvData, this.dataWidth, this.dataHeight, this.left + left, this.top + top, width, height, false);
        }
        renderThumbnail() {
            const width = this.getWidth() / PlanarYUVLuminanceSource.THUMBNAIL_SCALE_FACTOR;
            const height = this.getHeight() / PlanarYUVLuminanceSource.THUMBNAIL_SCALE_FACTOR;
            const pixels = new Int32Array(width * height);
            const yuv = this.yuvData;
            let inputOffset = this.top * this.dataWidth + this.left;
            for(let y = 0; y < height; y++){
                const outputOffset = y * width;
                for(let x = 0; x < width; x++){
                    const grey = yuv[inputOffset + x * PlanarYUVLuminanceSource.THUMBNAIL_SCALE_FACTOR] & 0xff;
                    pixels[outputOffset + x] = 0xFF000000 | grey * 0x00010101;
                }
                inputOffset += this.dataWidth * PlanarYUVLuminanceSource.THUMBNAIL_SCALE_FACTOR;
            }
            return pixels;
        }
        /**
         * @return width of image from {@link #renderThumbnail()}
         */ getThumbnailWidth() {
            return this.getWidth() / PlanarYUVLuminanceSource.THUMBNAIL_SCALE_FACTOR;
        }
        /**
         * @return height of image from {@link #renderThumbnail()}
         */ getThumbnailHeight() {
            return this.getHeight() / PlanarYUVLuminanceSource.THUMBNAIL_SCALE_FACTOR;
        }
        reverseHorizontal(width /*int*/ , height /*int*/ ) {
            const yuvData = this.yuvData;
            for(let y = 0, rowStart = this.top * this.dataWidth + this.left; y < height; y++, rowStart += this.dataWidth){
                const middle = rowStart + width / 2;
                for(let x1 = rowStart, x2 = rowStart + width - 1; x1 < middle; x1++, x2--){
                    const temp = yuvData[x1];
                    yuvData[x1] = yuvData[x2];
                    yuvData[x2] = temp;
                }
            }
        }
        invert() {
            return new InvertedLuminanceSource(this);
        }
    }
    PlanarYUVLuminanceSource.THUMBNAIL_SCALE_FACTOR = 2;
    /*
     * Copyright 2009 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * This class is used to help decode images from files which arrive as RGB data from
     * an ARGB pixel array. It does not support rotation.
     *
     * @author dswitkin@google.com (Daniel Switkin)
     * @author Betaminos
     */ class RGBLuminanceSource extends LuminanceSource {
        constructor(luminances, width /*int*/ , height /*int*/ , dataWidth /*int*/ , dataHeight /*int*/ , left /*int*/ , top /*int*/ ){
            super(width, height);
            this.dataWidth = dataWidth;
            this.dataHeight = dataHeight;
            this.left = left;
            this.top = top;
            if (luminances.BYTES_PER_ELEMENT === 4) {
                const size = width * height;
                const luminancesUint8Array = new Uint8ClampedArray(size);
                for(let offset = 0; offset < size; offset++){
                    const pixel = luminances[offset];
                    const r = pixel >> 16 & 0xff; // red
                    const g2 = pixel >> 7 & 0x1fe; // 2 * green
                    const b = pixel & 0xff; // blue
                    // Calculate green-favouring average cheaply
                    luminancesUint8Array[offset] = (r + g2 + b) / 4 & 0xFF;
                }
                this.luminances = luminancesUint8Array;
            } else this.luminances = luminances;
            if (undefined === dataWidth) this.dataWidth = width;
            if (undefined === dataHeight) this.dataHeight = height;
            if (undefined === left) this.left = 0;
            if (undefined === top) this.top = 0;
            if (this.left + width > this.dataWidth || this.top + height > this.dataHeight) throw new IllegalArgumentException('Crop rectangle does not fit within image data.');
        }
        /*@Override*/ getRow(y /*int*/ , row) {
            if (y < 0 || y >= this.getHeight()) throw new IllegalArgumentException('Requested row is outside the image: ' + y);
            const width = this.getWidth();
            if (row === null || row === undefined || row.length < width) row = new Uint8ClampedArray(width);
            const offset = (y + this.top) * this.dataWidth + this.left;
            System.arraycopy(this.luminances, offset, row, 0, width);
            return row;
        }
        /*@Override*/ getMatrix() {
            const width = this.getWidth();
            const height = this.getHeight();
            // If the caller asks for the entire underlying image, save the copy and give them the
            // original data. The docs specifically warn that result.length must be ignored.
            if (width === this.dataWidth && height === this.dataHeight) return this.luminances;
            const area = width * height;
            const matrix = new Uint8ClampedArray(area);
            let inputOffset = this.top * this.dataWidth + this.left;
            // If the width matches the full width of the underlying data, perform a single copy.
            if (width === this.dataWidth) {
                System.arraycopy(this.luminances, inputOffset, matrix, 0, area);
                return matrix;
            }
            // Otherwise copy one cropped row at a time.
            for(let y = 0; y < height; y++){
                const outputOffset = y * width;
                System.arraycopy(this.luminances, inputOffset, matrix, outputOffset, width);
                inputOffset += this.dataWidth;
            }
            return matrix;
        }
        /*@Override*/ isCropSupported() {
            return true;
        }
        /*@Override*/ crop(left /*int*/ , top /*int*/ , width /*int*/ , height /*int*/ ) {
            return new RGBLuminanceSource(this.luminances, width, height, this.dataWidth, this.dataHeight, this.left + left, this.top + top);
        }
        invert() {
            return new InvertedLuminanceSource(this);
        }
    }
    /**
     * Just to make a shortcut between Java code and TS code.
     */ class Charset extends CharacterSetECI {
        static forName(name) {
            return this.getCharacterSetECIByName(name);
        }
    }
    /**
     * Just to make a shortcut between Java code and TS code.
     */ class StandardCharsets {
    }
    StandardCharsets.ISO_8859_1 = CharacterSetECI.ISO8859_1;
    /*
    * Copyright 2013 ZXing authors
    *
    * Licensed under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License.
    * You may obtain a copy of the License at
    *
    *      http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software
    * distributed under the License is distributed on an "AS IS" BASIS,
    * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    * See the License for the specific language governing permissions and
    * limitations under the License.
    */ /**
     * Aztec 2D code representation
     *
     * @author Rustam Abdullaev
     */ /*public final*/ class AztecCode {
        /**
         * @return {@code true} if compact instead of full mode
         */ isCompact() {
            return this.compact;
        }
        setCompact(compact) {
            this.compact = compact;
        }
        /**
         * @return size in pixels (width and height)
         */ getSize() {
            return this.size;
        }
        setSize(size) {
            this.size = size;
        }
        /**
         * @return number of levels
         */ getLayers() {
            return this.layers;
        }
        setLayers(layers) {
            this.layers = layers;
        }
        /**
         * @return number of data codewords
         */ getCodeWords() {
            return this.codeWords;
        }
        setCodeWords(codeWords) {
            this.codeWords = codeWords;
        }
        /**
         * @return the symbol image
         */ getMatrix() {
            return this.matrix;
        }
        setMatrix(matrix) {
            this.matrix = matrix;
        }
    }
    class Collections {
        /**
         * The singletonList(T) method is used to return an immutable list containing only the specified object.
         */ static singletonList(item) {
            return [
                item
            ];
        }
        /**
         * The min(Collection<? extends T>, Comparator<? super T>) method is used to return the minimum element of the given collection, according to the order induced by the specified comparator.
         */ static min(collection, comparator) {
            return collection.sort(comparator)[0];
        }
    }
    /*
    * Copyright 2013 ZXing authors
    *
    * Licensed under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License.
    * You may obtain a copy of the License at
    *
    *      http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software
    * distributed under the License is distributed on an "AS IS" BASIS,
    * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    * See the License for the specific language governing permissions and
    * limitations under the License.
    */ class Token {
        constructor(previous){
            this.previous = previous;
        }
        getPrevious() {
            return this.previous;
        }
    }
    /*
    * Copyright 2013 ZXing authors
    *
    * Licensed under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License.
    * You may obtain a copy of the License at
    *
    *      http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software
    * distributed under the License is distributed on an "AS IS" BASIS,
    * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    * See the License for the specific language governing permissions and
    * limitations under the License.
    */ /*final*/ class SimpleToken extends Token {
        constructor(previous, value, bitCount){
            super(previous);
            this.value = value;
            this.bitCount = bitCount;
        }
        /**
         * @Override
         */ appendTo(bitArray, text) {
            bitArray.appendBits(this.value, this.bitCount);
        }
        add(value, bitCount) {
            return new SimpleToken(this, value, bitCount);
        }
        addBinaryShift(start, byteCount) {
            // no-op can't binary shift a simple token
            console.warn('addBinaryShift on SimpleToken, this simply returns a copy of this token');
            return new SimpleToken(this, start, byteCount);
        }
        /**
         * @Override
         */ toString() {
            let value = this.value & (1 << this.bitCount) - 1;
            value |= 1 << this.bitCount;
            return '<' + Integer.toBinaryString(value | 1 << this.bitCount).substring(1) + '>';
        }
    }
    /*
    * Copyright 2013 ZXing authors
    *
    * Licensed under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License.
    * You may obtain a copy of the License at
    *
    *      http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software
    * distributed under the License is distributed on an "AS IS" BASIS,
    * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    * See the License for the specific language governing permissions and
    * limitations under the License.
    */ /*final*/ class BinaryShiftToken extends SimpleToken {
        constructor(previous, binaryShiftStart, binaryShiftByteCount){
            super(previous, 0, 0);
            this.binaryShiftStart = binaryShiftStart;
            this.binaryShiftByteCount = binaryShiftByteCount;
        }
        /**
         * @Override
         */ appendTo(bitArray, text) {
            for(let i = 0; i < this.binaryShiftByteCount; i++){
                if (i === 0 || i === 31 && this.binaryShiftByteCount <= 62) {
                    // We need a header before the first character, and before
                    // character 31 when the total byte code is <= 62
                    bitArray.appendBits(31, 5); // BINARY_SHIFT
                    if (this.binaryShiftByteCount > 62) bitArray.appendBits(this.binaryShiftByteCount - 31, 16);
                    else if (i === 0) // 1 <= binaryShiftByteCode <= 62
                    bitArray.appendBits(Math.min(this.binaryShiftByteCount, 31), 5);
                    else // 32 <= binaryShiftCount <= 62 and i == 31
                    bitArray.appendBits(this.binaryShiftByteCount - 31, 5);
                }
                bitArray.appendBits(text[this.binaryShiftStart + i], 8);
            }
        }
        addBinaryShift(start, byteCount) {
            // int bitCount = (byteCount * 8) + (byteCount <= 31 ? 10 : byteCount <= 62 ? 20 : 21);
            return new BinaryShiftToken(this, start, byteCount);
        }
        /**
         * @Override
         */ toString() {
            return '<' + this.binaryShiftStart + '::' + (this.binaryShiftStart + this.binaryShiftByteCount - 1) + '>';
        }
    }
    function addBinaryShift(token, start, byteCount) {
        // int bitCount = (byteCount * 8) + (byteCount <= 31 ? 10 : byteCount <= 62 ? 20 : 21);
        return new BinaryShiftToken(token, start, byteCount);
    }
    function add(token, value, bitCount) {
        return new SimpleToken(token, value, bitCount);
    }
    const /*final*/ MODE_NAMES = [
        'UPPER',
        'LOWER',
        'DIGIT',
        'MIXED',
        'PUNCT'
    ];
    const /*final*/ MODE_UPPER = 0; // 5 bits
    const /*final*/ MODE_LOWER = 1; // 5 bits
    const /*final*/ MODE_DIGIT = 2; // 4 bits
    const /*final*/ MODE_MIXED = 3; // 5 bits
    const /*final*/ MODE_PUNCT = 4; // 5 bits
    const EMPTY_TOKEN = new SimpleToken(null, 0, 0);
    // The Latch Table shows, for each pair of Modes, the optimal method for
    // getting from one mode to another.  In the worst possible case, this can
    // be up to 14 bits.  In the best possible case, we are already there!
    // The high half-word of each entry gives the number of bits.
    // The low half-word of each entry are the actual bits necessary to change
    const LATCH_TABLE = [
        Int32Array.from([
            0,
            327708,
            327710,
            327709,
            656318 // UPPER -> MIXED -> PUNCT
        ]),
        Int32Array.from([
            590318,
            0,
            327710,
            327709,
            656318 // LOWER -> MIXED -> PUNCT
        ]),
        Int32Array.from([
            262158,
            590300,
            0,
            590301,
            932798
        ]),
        Int32Array.from([
            327709,
            327708,
            656318,
            0,
            327710 // MIXED -> PUNCT
        ]),
        Int32Array.from([
            327711,
            656380,
            656382,
            656381,
            0
        ])
    ];
    function static_SHIFT_TABLE(SHIFT_TABLE) {
        for (let table /*Int32Array*/  of SHIFT_TABLE)Arrays.fill(table, -1);
        SHIFT_TABLE[MODE_UPPER][MODE_PUNCT] = 0;
        SHIFT_TABLE[MODE_LOWER][MODE_PUNCT] = 0;
        SHIFT_TABLE[MODE_LOWER][MODE_UPPER] = 28;
        SHIFT_TABLE[MODE_MIXED][MODE_PUNCT] = 0;
        SHIFT_TABLE[MODE_DIGIT][MODE_PUNCT] = 0;
        SHIFT_TABLE[MODE_DIGIT][MODE_UPPER] = 15;
        return SHIFT_TABLE;
    }
    const /*final*/ SHIFT_TABLE = static_SHIFT_TABLE(Arrays.createInt32Array(6, 6)); // mode shift codes, per table
    /*
     * Copyright 2013 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * State represents all information about a sequence necessary to generate the current output.
     * Note that a state is immutable.
     */ /*final*/ class State {
        constructor(token, mode, binaryBytes, bitCount){
            this.token = token;
            this.mode = mode;
            this.binaryShiftByteCount = binaryBytes;
            this.bitCount = bitCount;
        // Make sure we match the token
        // int binaryShiftBitCount = (binaryShiftByteCount * 8) +
        //    (binaryShiftByteCount === 0 ? 0 :
        //     binaryShiftByteCount <= 31 ? 10 :
        //     binaryShiftByteCount <= 62 ? 20 : 21);
        // assert this.bitCount === token.getTotalBitCount() + binaryShiftBitCount;
        }
        getMode() {
            return this.mode;
        }
        getToken() {
            return this.token;
        }
        getBinaryShiftByteCount() {
            return this.binaryShiftByteCount;
        }
        getBitCount() {
            return this.bitCount;
        }
        // Create a new state representing this state with a latch to a (not
        // necessary different) mode, and then a code.
        latchAndAppend(mode, value) {
            // assert binaryShiftByteCount === 0;
            let bitCount = this.bitCount;
            let token = this.token;
            if (mode !== this.mode) {
                let latch = LATCH_TABLE[this.mode][mode];
                token = add(token, latch & 0xffff, latch >> 16);
                bitCount += latch >> 16;
            }
            let latchModeBitCount = mode === MODE_DIGIT ? 4 : 5;
            token = add(token, value, latchModeBitCount);
            return new State(token, mode, 0, bitCount + latchModeBitCount);
        }
        // Create a new state representing this state, with a temporary shift
        // to a different mode to output a single value.
        shiftAndAppend(mode, value) {
            // assert binaryShiftByteCount === 0 && this.mode !== mode;
            let token = this.token;
            let thisModeBitCount = this.mode === MODE_DIGIT ? 4 : 5;
            // Shifts exist only to UPPER and PUNCT, both with tokens size 5.
            token = add(token, SHIFT_TABLE[this.mode][mode], thisModeBitCount);
            token = add(token, value, 5);
            return new State(token, this.mode, 0, this.bitCount + thisModeBitCount + 5);
        }
        // Create a new state representing this state, but an additional character
        // output in Binary Shift mode.
        addBinaryShiftChar(index) {
            let token = this.token;
            let mode = this.mode;
            let bitCount = this.bitCount;
            if (this.mode === MODE_PUNCT || this.mode === MODE_DIGIT) {
                // assert binaryShiftByteCount === 0;
                let latch = LATCH_TABLE[mode][MODE_UPPER];
                token = add(token, latch & 0xffff, latch >> 16);
                bitCount += latch >> 16;
                mode = MODE_UPPER;
            }
            let deltaBitCount = this.binaryShiftByteCount === 0 || this.binaryShiftByteCount === 31 ? 18 : this.binaryShiftByteCount === 62 ? 9 : 8;
            let result = new State(token, mode, this.binaryShiftByteCount + 1, bitCount + deltaBitCount);
            if (result.binaryShiftByteCount === 2078) // The string is as long as it's allowed to be.  We should end it.
            result = result.endBinaryShift(index + 1);
            return result;
        }
        // Create the state identical to this one, but we are no longer in
        // Binary Shift mode.
        endBinaryShift(index) {
            if (this.binaryShiftByteCount === 0) return this;
            let token = this.token;
            token = addBinaryShift(token, index - this.binaryShiftByteCount, this.binaryShiftByteCount);
            // assert token.getTotalBitCount() === this.bitCount;
            return new State(token, this.mode, 0, this.bitCount);
        }
        // Returns true if "this" state is better (equal: or) to be in than "that"
        // state under all possible circumstances.
        isBetterThanOrEqualTo(other) {
            let newModeBitCount = this.bitCount + (LATCH_TABLE[this.mode][other.mode] >> 16);
            if (this.binaryShiftByteCount < other.binaryShiftByteCount) // add additional B/S encoding cost of other, if any
            newModeBitCount += State.calculateBinaryShiftCost(other) - State.calculateBinaryShiftCost(this);
            else if (this.binaryShiftByteCount > other.binaryShiftByteCount && other.binaryShiftByteCount > 0) // maximum possible additional cost (it: h)
            newModeBitCount += 10;
            return newModeBitCount <= other.bitCount;
        }
        toBitArray(text) {
            // Reverse the tokens, so that they are in the order that they should
            // be output
            let symbols = [];
            for(let token = this.endBinaryShift(text.length).token; token !== null; token = token.getPrevious())symbols.unshift(token);
            let bitArray = new BitArray();
            // Add each token to the result.
            for (const symbol of symbols)symbol.appendTo(bitArray, text);
            // assert bitArray.getSize() === this.bitCount;
            return bitArray;
        }
        /**
         * @Override
         */ toString() {
            return StringUtils.format('%s bits=%d bytes=%d', MODE_NAMES[this.mode], this.bitCount, this.binaryShiftByteCount);
        }
        static calculateBinaryShiftCost(state) {
            if (state.binaryShiftByteCount > 62) return 21; // B/S with extended length
            if (state.binaryShiftByteCount > 31) return 20; // two B/S
            if (state.binaryShiftByteCount > 0) return 10; // one B/S
            return 0;
        }
    }
    State.INITIAL_STATE = new State(EMPTY_TOKEN, MODE_UPPER, 0, 0);
    function static_CHAR_MAP(CHAR_MAP) {
        const spaceCharCode = StringUtils.getCharCode(' ');
        const pointCharCode = StringUtils.getCharCode('.');
        const commaCharCode = StringUtils.getCharCode(',');
        CHAR_MAP[MODE_UPPER][spaceCharCode] = 1;
        const zUpperCharCode = StringUtils.getCharCode('Z');
        const aUpperCharCode = StringUtils.getCharCode('A');
        for(let c = aUpperCharCode; c <= zUpperCharCode; c++)CHAR_MAP[MODE_UPPER][c] = c - aUpperCharCode + 2;
        CHAR_MAP[MODE_LOWER][spaceCharCode] = 1;
        const zLowerCharCode = StringUtils.getCharCode('z');
        const aLowerCharCode = StringUtils.getCharCode('a');
        for(let c = aLowerCharCode; c <= zLowerCharCode; c++)CHAR_MAP[MODE_LOWER][c] = c - aLowerCharCode + 2;
        CHAR_MAP[MODE_DIGIT][spaceCharCode] = 1;
        const nineCharCode = StringUtils.getCharCode('9');
        const zeroCharCode = StringUtils.getCharCode('0');
        for(let c = zeroCharCode; c <= nineCharCode; c++)CHAR_MAP[MODE_DIGIT][c] = c - zeroCharCode + 2;
        CHAR_MAP[MODE_DIGIT][commaCharCode] = 12;
        CHAR_MAP[MODE_DIGIT][pointCharCode] = 13;
        const mixedTable = [
            '\x00',
            ' ',
            '\x01',
            '\x02',
            '\x03',
            '\x04',
            '\x05',
            '\x06',
            '\x07',
            '\b',
            '\t',
            '\n',
            '\x0b',
            '\f',
            '\r',
            '\x1b',
            '\x1c',
            '\x1d',
            '\x1e',
            '\x1f',
            '@',
            '\\',
            '^',
            '_',
            '`',
            '|',
            '~',
            '\x7f'
        ];
        for(let i = 0; i < mixedTable.length; i++)CHAR_MAP[MODE_MIXED][StringUtils.getCharCode(mixedTable[i])] = i;
        const punctTable = [
            '\x00',
            '\r',
            '\x00',
            '\x00',
            '\x00',
            '\x00',
            '!',
            '\'',
            '#',
            '$',
            '%',
            '&',
            '\'',
            '(',
            ')',
            '*',
            '+',
            ',',
            '-',
            '.',
            '/',
            ':',
            ';',
            '<',
            '=',
            '>',
            '?',
            '[',
            ']',
            '{',
            '}'
        ];
        for(let i = 0; i < punctTable.length; i++)if (StringUtils.getCharCode(punctTable[i]) > 0) CHAR_MAP[MODE_PUNCT][StringUtils.getCharCode(punctTable[i])] = i;
        return CHAR_MAP;
    }
    const CHAR_MAP = static_CHAR_MAP(Arrays.createInt32Array(5, 256));
    /*
     * Copyright 2013 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ /**
     * This produces nearly optimal encodings of text into the first-level of
     * encoding used by Aztec code.
     *
     * It uses a dynamic algorithm.  For each prefix of the string, it determines
     * a set of encodings that could lead to this prefix.  We repeatedly add a
     * character and generate a new set of optimal encodings until we have read
     * through the entire input.
     *
     * @author Frank Yellin
     * @author Rustam Abdullaev
     */ /*public final*/ class HighLevelEncoder {
        constructor(text){
            this.text = text;
        }
        /**
         * @return text represented by this encoder encoded as a {@link BitArray}
         */ encode() {
            const spaceCharCode = StringUtils.getCharCode(' ');
            const lineBreakCharCode = StringUtils.getCharCode('\n');
            let states = Collections.singletonList(State.INITIAL_STATE);
            for(let index = 0; index < this.text.length; index++){
                let pairCode;
                let nextChar = index + 1 < this.text.length ? this.text[index + 1] : 0;
                switch(this.text[index]){
                    case StringUtils.getCharCode('\r'):
                        pairCode = nextChar === lineBreakCharCode ? 2 : 0;
                        break;
                    case StringUtils.getCharCode('.'):
                        pairCode = nextChar === spaceCharCode ? 3 : 0;
                        break;
                    case StringUtils.getCharCode(','):
                        pairCode = nextChar === spaceCharCode ? 4 : 0;
                        break;
                    case StringUtils.getCharCode(':'):
                        pairCode = nextChar === spaceCharCode ? 5 : 0;
                        break;
                    default:
                        pairCode = 0;
                }
                if (pairCode > 0) {
                    // We have one of the four special PUNCT pairs.  Treat them specially.
                    // Get a new set of states for the two new characters.
                    states = HighLevelEncoder.updateStateListForPair(states, index, pairCode);
                    index++;
                } else // Get a new set of states for the new character.
                states = this.updateStateListForChar(states, index);
            }
            // We are left with a set of states.  Find the shortest one.
            const minState = Collections.min(states, (a, b)=>{
                return a.getBitCount() - b.getBitCount();
            });
            // Convert it to a bit array, and return.
            return minState.toBitArray(this.text);
        }
        // We update a set of states for a new character by updating each state
        // for the new character, merging the results, and then removing the
        // non-optimal states.
        updateStateListForChar(states, index) {
            const result = [];
            for (let state /*State*/  of states)this.updateStateForChar(state, index, result);
            return HighLevelEncoder.simplifyStates(result);
        }
        // Return a set of states that represent the possible ways of updating this
        // state for the next character.  The resulting set of states are added to
        // the "result" list.
        updateStateForChar(state, index, result) {
            let ch = this.text[index] & 0xff;
            let charInCurrentTable = CHAR_MAP[state.getMode()][ch] > 0;
            let stateNoBinary = null;
            for(let mode /*int*/  = 0; mode <= MODE_PUNCT; mode++){
                let charInMode = CHAR_MAP[mode][ch];
                if (charInMode > 0) {
                    if (stateNoBinary == null) // Only create stateNoBinary the first time it's required.
                    stateNoBinary = state.endBinaryShift(index);
                    // Try generating the character by latching to its mode
                    if (!charInCurrentTable || mode === state.getMode() || mode === MODE_DIGIT) {
                        // If the character is in the current table, we don't want to latch to
                        // any other mode except possibly digit (which uses only 4 bits).  Any
                        // other latch would be equally successful *after* this character, and
                        // so wouldn't save any bits.
                        const latchState = stateNoBinary.latchAndAppend(mode, charInMode);
                        result.push(latchState);
                    }
                    // Try generating the character by switching to its mode.
                    if (!charInCurrentTable && SHIFT_TABLE[state.getMode()][mode] >= 0) {
                        // It never makes sense to temporarily shift to another mode if the
                        // character exists in the current mode.  That can never save bits.
                        const shiftState = stateNoBinary.shiftAndAppend(mode, charInMode);
                        result.push(shiftState);
                    }
                }
            }
            if (state.getBinaryShiftByteCount() > 0 || CHAR_MAP[state.getMode()][ch] === 0) {
                // It's never worthwhile to go into binary shift mode if you're not already
                // in binary shift mode, and the character exists in your current mode.
                // That can never save bits over just outputting the char in the current mode.
                let binaryState = state.addBinaryShiftChar(index);
                result.push(binaryState);
            }
        }
        static updateStateListForPair(states, index, pairCode) {
            const result = [];
            for (let state /*State*/  of states)this.updateStateForPair(state, index, pairCode, result);
            return this.simplifyStates(result);
        }
        static updateStateForPair(state, index, pairCode, result) {
            let stateNoBinary = state.endBinaryShift(index);
            // Possibility 1.  Latch to C.MODE_PUNCT, and then append this code
            result.push(stateNoBinary.latchAndAppend(MODE_PUNCT, pairCode));
            if (state.getMode() !== MODE_PUNCT) // Possibility 2.  Shift to C.MODE_PUNCT, and then append this code.
            // Every state except C.MODE_PUNCT (handled above) can shift
            result.push(stateNoBinary.shiftAndAppend(MODE_PUNCT, pairCode));
            if (pairCode === 3 || pairCode === 4) {
                // both characters are in DIGITS.  Sometimes better to just add two digits
                let digitState = stateNoBinary.latchAndAppend(MODE_DIGIT, 16 - pairCode) // period or comma in DIGIT
                .latchAndAppend(MODE_DIGIT, 1); // space in DIGIT
                result.push(digitState);
            }
            if (state.getBinaryShiftByteCount() > 0) {
                // It only makes sense to do the characters as binary if we're already
                // in binary mode.
                let binaryState = state.addBinaryShiftChar(index).addBinaryShiftChar(index + 1);
                result.push(binaryState);
            }
        }
        static simplifyStates(states) {
            let result = [];
            for (const newState of states){
                let add = true;
                for (const oldState of result){
                    if (oldState.isBetterThanOrEqualTo(newState)) {
                        add = false;
                        break;
                    }
                    if (newState.isBetterThanOrEqualTo(oldState)) // iterator.remove();
                    result = result.filter((x)=>x !== oldState); // remove old state
                }
                if (add) result.push(newState);
            }
            return result;
        }
    }
    /*
     * Copyright 2013 ZXing authors
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *      http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ // package com.google.zxing.aztec.encoder;
    // import com.google.zxing.common.BitArray;
    // import com.google.zxing.common.BitMatrix;
    // import com.google.zxing.common.reedsolomon.GenericGF;
    // import com.google.zxing.common.reedsolomon.ReedSolomonEncoder;
    /**
     * Generates Aztec 2D barcodes.
     *
     * @author Rustam Abdullaev
     */ /*public final*/ class Encoder$1 {
        constructor(){}
        /**
         * Encodes the given binary content as an Aztec symbol
         *
         * @param data input data string
         * @return Aztec symbol matrix with metadata
         */ static encodeBytes(data) {
            return Encoder$1.encode(data, Encoder$1.DEFAULT_EC_PERCENT, Encoder$1.DEFAULT_AZTEC_LAYERS);
        }
        /**
         * Encodes the given binary content as an Aztec symbol
         *
         * @param data input data string
         * @param minECCPercent minimal percentage of error check words (According to ISO/IEC 24778:2008,
         *                      a minimum of 23% + 3 words is recommended)
         * @param userSpecifiedLayers if non-zero, a user-specified value for the number of layers
         * @return Aztec symbol matrix with metadata
         */ static encode(data, minECCPercent, userSpecifiedLayers) {
            // High-level encode
            let bits = new HighLevelEncoder(data).encode();
            // stuff bits and choose symbol size
            let eccBits = Integer.truncDivision(bits.getSize() * minECCPercent, 100) + 11;
            let totalSizeBits = bits.getSize() + eccBits;
            let compact;
            let layers;
            let totalBitsInLayer;
            let wordSize;
            let stuffedBits;
            if (userSpecifiedLayers !== Encoder$1.DEFAULT_AZTEC_LAYERS) {
                compact = userSpecifiedLayers < 0;
                layers = Math.abs(userSpecifiedLayers);
                if (layers > (compact ? Encoder$1.MAX_NB_BITS_COMPACT : Encoder$1.MAX_NB_BITS)) throw new IllegalArgumentException(StringUtils.format('Illegal value %s for layers', userSpecifiedLayers));
                totalBitsInLayer = Encoder$1.totalBitsInLayer(layers, compact);
                wordSize = Encoder$1.WORD_SIZE[layers];
                let usableBitsInLayers = totalBitsInLayer - totalBitsInLayer % wordSize;
                stuffedBits = Encoder$1.stuffBits(bits, wordSize);
                if (stuffedBits.getSize() + eccBits > usableBitsInLayers) throw new IllegalArgumentException('Data to large for user specified layer');
                if (compact && stuffedBits.getSize() > wordSize * 64) // Compact format only allows 64 data words, though C4 can hold more words than that
                throw new IllegalArgumentException('Data to large for user specified layer');
            } else {
                wordSize = 0;
                stuffedBits = null;
                // We look at the possible table sizes in the order Compact1, Compact2, Compact3,
                // Compact4, Normal4,...  Normal(i) for i < 4 isn't typically used since Compact(i+1)
                // is the same size, but has more data.
                for(let i /*int*/  = 0;; i++){
                    if (i > Encoder$1.MAX_NB_BITS) throw new IllegalArgumentException('Data too large for an Aztec code');
                    compact = i <= 3;
                    layers = compact ? i + 1 : i;
                    totalBitsInLayer = Encoder$1.totalBitsInLayer(layers, compact);
                    if (totalSizeBits > totalBitsInLayer) continue;
                    // [Re]stuff the bits if this is the first opportunity, or if the
                    // wordSize has changed
                    if (stuffedBits == null || wordSize !== Encoder$1.WORD_SIZE[layers]) {
                        wordSize = Encoder$1.WORD_SIZE[layers];
                        stuffedBits = Encoder$1.stuffBits(bits, wordSize);
                    }
                    let usableBitsInLayers = totalBitsInLayer - totalBitsInLayer % wordSize;
                    if (compact && stuffedBits.getSize() > wordSize * 64) continue;
                    if (stuffedBits.getSize() + eccBits <= usableBitsInLayers) break;
                }
            }
            let messageBits = Encoder$1.generateCheckWords(stuffedBits, totalBitsInLayer, wordSize);
            // generate mode message
            let messageSizeInWords = stuffedBits.getSize() / wordSize;
            let modeMessage = Encoder$1.generateModeMessage(compact, layers, messageSizeInWords);
            // allocate symbol
            let baseMatrixSize = (compact ? 11 : 14) + layers * 4; // not including alignment lines
            let alignmentMap = new Int32Array(baseMatrixSize);
            let matrixSize;
            if (compact) {
                // no alignment marks in compact mode, alignmentMap is a no-op
                matrixSize = baseMatrixSize;
                for(let i /*int*/  = 0; i < alignmentMap.length; i++)alignmentMap[i] = i;
            } else {
                matrixSize = baseMatrixSize + 1 + 2 * Integer.truncDivision(Integer.truncDivision(baseMatrixSize, 2) - 1, 15);
                let origCenter = Integer.truncDivision(baseMatrixSize, 2);
                let center = Integer.truncDivision(matrixSize, 2);
                for(let i /*int*/  = 0; i < origCenter; i++){
                    let newOffset = i + Integer.truncDivision(i, 15);
                    alignmentMap[origCenter - i - 1] = center - newOffset - 1;
                    alignmentMap[origCenter + i] = center + newOffset + 1;
                }
            }
            let matrix = new BitMatrix(matrixSize);
            // draw data bits
            for(let i /*int*/  = 0, rowOffset = 0; i < layers; i++){
                let rowSize = (layers - i) * 4 + (compact ? 9 : 12);
                for(let j /*int*/  = 0; j < rowSize; j++){
                    let columnOffset = j * 2;
                    for(let k /*int*/  = 0; k < 2; k++){
                        if (messageBits.get(rowOffset + columnOffset + k)) matrix.set(alignmentMap[i * 2 + k], alignmentMap[i * 2 + j]);
                        if (messageBits.get(rowOffset + rowSize * 2 + columnOffset + k)) matrix.set(alignmentMap[i * 2 + j], alignmentMap[baseMatrixSize - 1 - i * 2 - k]);
                        if (messageBits.get(rowOffset + rowSize * 4 + columnOffset + k)) matrix.set(alignmentMap[baseMatrixSize - 1 - i * 2 - k], alignmentMap[baseMatrixSize - 1 - i * 2 - j]);
                        if (messageBits.get(rowOffset + rowSize * 6 + columnOffset + k)) matrix.set(alignmentMap[baseMatrixSize - 1 - i * 2 - j], alignmentMap[i * 2 + k]);
                    }
                }
                rowOffset += rowSize * 8;
            }
            // draw mode message
            Encoder$1.drawModeMessage(matrix, compact, matrixSize, modeMessage);
            // draw alignment marks
            if (compact) Encoder$1.drawBullsEye(matrix, Integer.truncDivision(matrixSize, 2), 5);
            else {
                Encoder$1.drawBullsEye(matrix, Integer.truncDivision(matrixSize, 2), 7);
                for(let i /*int*/  = 0, j = 0; i < Integer.truncDivision(baseMatrixSize, 2) - 1; i += 15, j += 16)for(let k /*int*/  = Integer.truncDivision(matrixSize, 2) & 1; k < matrixSize; k += 2){
                    matrix.set(Integer.truncDivision(matrixSize, 2) - j, k);
                    matrix.set(Integer.truncDivision(matrixSize, 2) + j, k);
                    matrix.set(k, Integer.truncDivision(matrixSize, 2) - j);
                    matrix.set(k, Integer.truncDivision(matrixSize, 2) + j);
                }
            }
            let aztec = new AztecCode();
            aztec.setCompact(compact);
            aztec.setSize(matrixSize);
            aztec.setLayers(layers);
            aztec.setCodeWords(messageSizeInWords);
            aztec.setMatrix(matrix);
            return aztec;
        }
        static drawBullsEye(matrix, center, size) {
            for(let i /*int*/  = 0; i < size; i += 2)for(let j /*int*/  = center - i; j <= center + i; j++){
                matrix.set(j, center - i);
                matrix.set(j, center + i);
                matrix.set(center - i, j);
                matrix.set(center + i, j);
            }
            matrix.set(center - size, center - size);
            matrix.set(center - size + 1, center - size);
            matrix.set(center - size, center - size + 1);
            matrix.set(center + size, center - size);
            matrix.set(center + size, center - size + 1);
            matrix.set(center + size, center + size - 1);
        }
        static generateModeMessage(compact, layers, messageSizeInWords) {
            let modeMessage = new BitArray();
            if (compact) {
                modeMessage.appendBits(layers - 1, 2);
                modeMessage.appendBits(messageSizeInWords - 1, 6);
                modeMessage = Encoder$1.generateCheckWords(modeMessage, 28, 4);
            } else {
                modeMessage.appendBits(layers - 1, 5);
                modeMessage.appendBits(messageSizeInWords - 1, 11);
                modeMessage = Encoder$1.generateCheckWords(modeMessage, 40, 4);
            }
            return modeMessage;
        }
        static drawModeMessage(matrix, compact, matrixSize, modeMessage) {
            let center = Integer.truncDivision(matrixSize, 2);
            if (compact) for(let i /*int*/  = 0; i < 7; i++){
                let offset = center - 3 + i;
                if (modeMessage.get(i)) matrix.set(offset, center - 5);
                if (modeMessage.get(i + 7)) matrix.set(center + 5, offset);
                if (modeMessage.get(20 - i)) matrix.set(offset, center + 5);
                if (modeMessage.get(27 - i)) matrix.set(center - 5, offset);
            }
            else for(let i /*int*/  = 0; i < 10; i++){
                let offset = center - 5 + i + Integer.truncDivision(i, 5);
                if (modeMessage.get(i)) matrix.set(offset, center - 7);
                if (modeMessage.get(i + 10)) matrix.set(center + 7, offset);
                if (modeMessage.get(29 - i)) matrix.set(offset, center + 7);
                if (modeMessage.get(39 - i)) matrix.set(center - 7, offset);
            }
        }
        static generateCheckWords(bitArray, totalBits, wordSize) {
            // bitArray is guaranteed to be a multiple of the wordSize, so no padding needed
            let messageSizeInWords = bitArray.getSize() / wordSize;
            let rs = new ReedSolomonEncoder(Encoder$1.getGF(wordSize));
            let totalWords = Integer.truncDivision(totalBits, wordSize);
            let messageWords = Encoder$1.bitsToWords(bitArray, wordSize, totalWords);
            rs.encode(messageWords, totalWords - messageSizeInWords);
            let startPad = totalBits % wordSize;
            let messageBits = new BitArray();
            messageBits.appendBits(0, startPad);
            for (const messageWord /*: int*/  of Array.from(messageWords))messageBits.appendBits(messageWord, wordSize);
            return messageBits;
        }
        static bitsToWords(stuffedBits, wordSize, totalWords) {
            let message = new Int32Array(totalWords);
            let i;
            let n;
            for(i = 0, n = stuffedBits.getSize() / wordSize; i < n; i++){
                let value = 0;
                for(let j /*int*/  = 0; j < wordSize; j++)value |= stuffedBits.get(i * wordSize + j) ? 1 << wordSize - j - 1 : 0;
                message[i] = value;
            }
            return message;
        }
        static getGF(wordSize) {
            switch(wordSize){
                case 4:
                    return GenericGF.AZTEC_PARAM;
                case 6:
                    return GenericGF.AZTEC_DATA_6;
                case 8:
                    return GenericGF.AZTEC_DATA_8;
                case 10:
                    return GenericGF.AZTEC_DATA_10;
                case 12:
                    return GenericGF.AZTEC_DATA_12;
                default:
                    throw new IllegalArgumentException('Unsupported word size ' + wordSize);
            }
        }
        static stuffBits(bits, wordSize) {
            let out = new BitArray();
            let n = bits.getSize();
            let mask = (1 << wordSize) - 2;
            for(let i /*int*/  = 0; i < n; i += wordSize){
                let word = 0;
                for(let j /*int*/  = 0; j < wordSize; j++)if (i + j >= n || bits.get(i + j)) word |= 1 << wordSize - 1 - j;
                if ((word & mask) === mask) {
                    out.appendBits(word & mask, wordSize);
                    i--;
                } else if ((word & mask) === 0) {
                    out.appendBits(word | 1, wordSize);
                    i--;
                } else out.appendBits(word, wordSize);
            }
            return out;
        }
        static totalBitsInLayer(layers, compact) {
            return ((compact ? 88 : 112) + 16 * layers) * layers;
        }
    }
    Encoder$1.DEFAULT_EC_PERCENT = 33; // default minimal percentage of error check words
    Encoder$1.DEFAULT_AZTEC_LAYERS = 0;
    Encoder$1.MAX_NB_BITS = 32;
    Encoder$1.MAX_NB_BITS_COMPACT = 4;
    Encoder$1.WORD_SIZE = Int32Array.from([
        4,
        6,
        6,
        8,
        8,
        8,
        8,
        8,
        8,
        10,
        10,
        10,
        10,
        10,
        10,
        10,
        10,
        10,
        10,
        10,
        10,
        10,
        10,
        12,
        12,
        12,
        12,
        12,
        12,
        12,
        12,
        12,
        12
    ]);
    /*
    * Copyright 2013 ZXing authors
    *
    * Licensed under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License.
    * You may obtain a copy of the License at
    *
    *      http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software
    * distributed under the License is distributed on an "AS IS" BASIS,
    * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    * See the License for the specific language governing permissions and
    * limitations under the License.
    */ /**
     * Renders an Aztec code as a {@link BitMatrix}.
     */ /*public final*/ class AztecWriter {
        // @Override
        encode(contents, format, width, height) {
            return this.encodeWithHints(contents, format, width, height, null);
        }
        // @Override
        encodeWithHints(contents, format, width, height, hints) {
            let charset = StandardCharsets.ISO_8859_1;
            let eccPercent = Encoder$1.DEFAULT_EC_PERCENT;
            let layers = Encoder$1.DEFAULT_AZTEC_LAYERS;
            if (hints != null) {
                if (hints.has(EncodeHintType$1.CHARACTER_SET)) charset = Charset.forName(hints.get(EncodeHintType$1.CHARACTER_SET).toString());
                if (hints.has(EncodeHintType$1.ERROR_CORRECTION)) eccPercent = Integer.parseInt(hints.get(EncodeHintType$1.ERROR_CORRECTION).toString());
                if (hints.has(EncodeHintType$1.AZTEC_LAYERS)) layers = Integer.parseInt(hints.get(EncodeHintType$1.AZTEC_LAYERS).toString());
            }
            return AztecWriter.encodeLayers(contents, format, width, height, charset, eccPercent, layers);
        }
        static encodeLayers(contents, format, width, height, charset, eccPercent, layers) {
            if (format !== BarcodeFormat$1.AZTEC) throw new IllegalArgumentException('Can only encode AZTEC, but got ' + format);
            let aztec = Encoder$1.encode(StringUtils.getBytes(contents, charset), eccPercent, layers);
            return AztecWriter.renderResult(aztec, width, height);
        }
        static renderResult(code, width, height) {
            let input = code.getMatrix();
            if (input == null) throw new IllegalStateException();
            let inputWidth = input.getWidth();
            let inputHeight = input.getHeight();
            let outputWidth = Math.max(width, inputWidth);
            let outputHeight = Math.max(height, inputHeight);
            let multiple = Math.min(outputWidth / inputWidth, outputHeight / inputHeight);
            let leftPadding = (outputWidth - inputWidth * multiple) / 2;
            let topPadding = (outputHeight - inputHeight * multiple) / 2;
            let output = new BitMatrix(outputWidth, outputHeight);
            for(let inputY /*int*/  = 0, outputY = topPadding; inputY < inputHeight; inputY++, outputY += multiple){
                // Write the contents of this row of the barcode
                for(let inputX /*int*/  = 0, outputX = leftPadding; inputX < inputWidth; inputX++, outputX += multiple)if (input.get(inputX, inputY)) output.setRegion(outputX, outputY, multiple, multiple);
            }
            return output;
        }
    }
    exports1.AbstractExpandedDecoder = AbstractExpandedDecoder;
    exports1.ArgumentException = ArgumentException;
    exports1.ArithmeticException = ArithmeticException;
    exports1.AztecCode = AztecCode;
    exports1.AztecCodeReader = AztecReader;
    exports1.AztecCodeWriter = AztecWriter;
    exports1.AztecDecoder = Decoder;
    exports1.AztecDetector = Detector;
    exports1.AztecDetectorResult = AztecDetectorResult;
    exports1.AztecEncoder = Encoder$1;
    exports1.AztecHighLevelEncoder = HighLevelEncoder;
    exports1.AztecPoint = Point;
    exports1.BarcodeFormat = BarcodeFormat$1;
    exports1.Binarizer = Binarizer;
    exports1.BinaryBitmap = BinaryBitmap;
    exports1.BitArray = BitArray;
    exports1.BitMatrix = BitMatrix;
    exports1.BitSource = BitSource;
    exports1.BrowserAztecCodeReader = BrowserAztecCodeReader;
    exports1.BrowserBarcodeReader = BrowserBarcodeReader;
    exports1.BrowserCodeReader = BrowserCodeReader;
    exports1.BrowserDatamatrixCodeReader = BrowserDatamatrixCodeReader;
    exports1.BrowserMultiFormatReader = BrowserMultiFormatReader;
    exports1.BrowserPDF417Reader = BrowserPDF417Reader;
    exports1.BrowserQRCodeReader = BrowserQRCodeReader;
    exports1.BrowserQRCodeSvgWriter = BrowserQRCodeSvgWriter;
    exports1.CharacterSetECI = CharacterSetECI;
    exports1.ChecksumException = ChecksumException;
    exports1.Code128Reader = Code128Reader;
    exports1.Code39Reader = Code39Reader;
    exports1.DataMatrixDecodedBitStreamParser = DecodedBitStreamParser;
    exports1.DataMatrixReader = DataMatrixReader;
    exports1.DecodeHintType = DecodeHintType$1;
    exports1.DecoderResult = DecoderResult;
    exports1.DefaultGridSampler = DefaultGridSampler;
    exports1.DetectorResult = DetectorResult;
    exports1.EAN13Reader = EAN13Reader;
    exports1.EncodeHintType = EncodeHintType$1;
    exports1.Exception = Exception;
    exports1.FormatException = FormatException;
    exports1.GenericGF = GenericGF;
    exports1.GenericGFPoly = GenericGFPoly;
    exports1.GlobalHistogramBinarizer = GlobalHistogramBinarizer;
    exports1.GridSampler = GridSampler;
    exports1.GridSamplerInstance = GridSamplerInstance;
    exports1.HTMLCanvasElementLuminanceSource = HTMLCanvasElementLuminanceSource;
    exports1.HybridBinarizer = HybridBinarizer;
    exports1.ITFReader = ITFReader;
    exports1.IllegalArgumentException = IllegalArgumentException;
    exports1.IllegalStateException = IllegalStateException;
    exports1.InvertedLuminanceSource = InvertedLuminanceSource;
    exports1.LuminanceSource = LuminanceSource;
    exports1.MathUtils = MathUtils;
    exports1.MultiFormatOneDReader = MultiFormatOneDReader;
    exports1.MultiFormatReader = MultiFormatReader;
    exports1.MultiFormatWriter = MultiFormatWriter;
    exports1.NotFoundException = NotFoundException;
    exports1.OneDReader = OneDReader;
    exports1.PDF417DecodedBitStreamParser = DecodedBitStreamParser$2;
    exports1.PDF417DecoderErrorCorrection = ErrorCorrection;
    exports1.PDF417Reader = PDF417Reader;
    exports1.PDF417ResultMetadata = PDF417ResultMetadata;
    exports1.PerspectiveTransform = PerspectiveTransform;
    exports1.PlanarYUVLuminanceSource = PlanarYUVLuminanceSource;
    exports1.QRCodeByteMatrix = ByteMatrix;
    exports1.QRCodeDataMask = DataMask;
    exports1.QRCodeDecodedBitStreamParser = DecodedBitStreamParser$1;
    exports1.QRCodeDecoderErrorCorrectionLevel = ErrorCorrectionLevel;
    exports1.QRCodeDecoderFormatInformation = FormatInformation;
    exports1.QRCodeEncoder = Encoder;
    exports1.QRCodeEncoderQRCode = QRCode;
    exports1.QRCodeMaskUtil = MaskUtil;
    exports1.QRCodeMatrixUtil = MatrixUtil;
    exports1.QRCodeMode = Mode$1;
    exports1.QRCodeReader = QRCodeReader;
    exports1.QRCodeVersion = Version$1;
    exports1.QRCodeWriter = QRCodeWriter;
    exports1.RGBLuminanceSource = RGBLuminanceSource;
    exports1.RSS14Reader = RSS14Reader;
    exports1.RSSExpandedReader = RSSExpandedReader;
    exports1.ReaderException = ReaderException;
    exports1.ReedSolomonDecoder = ReedSolomonDecoder;
    exports1.ReedSolomonEncoder = ReedSolomonEncoder;
    exports1.ReedSolomonException = ReedSolomonException;
    exports1.Result = Result;
    exports1.ResultMetadataType = ResultMetadataType$1;
    exports1.ResultPoint = ResultPoint;
    exports1.StringUtils = StringUtils;
    exports1.UnsupportedOperationException = UnsupportedOperationException;
    exports1.VideoInputDevice = VideoInputDevice;
    exports1.WhiteRectangleDetector = WhiteRectangleDetector;
    exports1.WriterException = WriterException;
    exports1.ZXingArrays = Arrays;
    exports1.ZXingCharset = Charset;
    exports1.ZXingInteger = Integer;
    exports1.ZXingStandardCharsets = StandardCharsets;
    exports1.ZXingStringBuilder = StringBuilder;
    exports1.ZXingStringEncoding = StringEncoding;
    exports1.ZXingSystem = System;
    exports1.createAbstractExpandedDecoder = createDecoder;
    Object.defineProperty(exports1, '__esModule', {
        value: true
    });
});

});


parcelRegister("9G8XY", function(module, exports) {

$parcel$export(module.exports, "BarcodeDetectorDelegate", () => $70befdcd4f932438$export$199d29c1710b56b6);

var $a3hi8 = parcelRequire("a3hi8");
var $70befdcd4f932438$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $70befdcd4f932438$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $70befdcd4f932438$export$199d29c1710b56b6 = function() {
    function BarcodeDetectorDelegate(requestedFormats, verbose, logger) {
        this.formatMap = new Map([
            [
                (0, $a3hi8.Html5QrcodeSupportedFormats).QR_CODE,
                "qr_code"
            ],
            [
                (0, $a3hi8.Html5QrcodeSupportedFormats).AZTEC,
                "aztec"
            ],
            [
                (0, $a3hi8.Html5QrcodeSupportedFormats).CODABAR,
                "codabar"
            ],
            [
                (0, $a3hi8.Html5QrcodeSupportedFormats).CODE_39,
                "code_39"
            ],
            [
                (0, $a3hi8.Html5QrcodeSupportedFormats).CODE_93,
                "code_93"
            ],
            [
                (0, $a3hi8.Html5QrcodeSupportedFormats).CODE_128,
                "code_128"
            ],
            [
                (0, $a3hi8.Html5QrcodeSupportedFormats).DATA_MATRIX,
                "data_matrix"
            ],
            [
                (0, $a3hi8.Html5QrcodeSupportedFormats).ITF,
                "itf"
            ],
            [
                (0, $a3hi8.Html5QrcodeSupportedFormats).EAN_13,
                "ean_13"
            ],
            [
                (0, $a3hi8.Html5QrcodeSupportedFormats).EAN_8,
                "ean_8"
            ],
            [
                (0, $a3hi8.Html5QrcodeSupportedFormats).PDF_417,
                "pdf417"
            ],
            [
                (0, $a3hi8.Html5QrcodeSupportedFormats).UPC_A,
                "upc_a"
            ],
            [
                (0, $a3hi8.Html5QrcodeSupportedFormats).UPC_E,
                "upc_e"
            ]
        ]);
        this.reverseFormatMap = this.createReverseFormatMap();
        if (!BarcodeDetectorDelegate.isSupported()) throw "Use html5qrcode.min.js without edit, Use BarcodeDetectorDelegate only if it isSupported();";
        this.verbose = verbose;
        this.logger = logger;
        var formats = this.createBarcodeDetectorFormats(requestedFormats);
        this.detector = new BarcodeDetector(formats);
        if (!this.detector) throw "BarcodeDetector detector not supported";
    }
    BarcodeDetectorDelegate.isSupported = function() {
        if (!("BarcodeDetector" in window)) return false;
        var dummyDetector = new BarcodeDetector({
            formats: [
                "qr_code"
            ]
        });
        return typeof dummyDetector !== "undefined";
    };
    BarcodeDetectorDelegate.prototype.decodeAsync = function(canvas) {
        return $70befdcd4f932438$var$__awaiter(this, void 0, void 0, function() {
            var barcodes, largestBarcode;
            return $70befdcd4f932438$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4,
                            this.detector.detect(canvas)
                        ];
                    case 1:
                        barcodes = _a.sent();
                        if (!barcodes || barcodes.length === 0) throw "No barcode or QR code detected.";
                        largestBarcode = this.selectLargestBarcode(barcodes);
                        return [
                            2,
                            {
                                text: largestBarcode.rawValue,
                                format: (0, $a3hi8.QrcodeResultFormat).create(this.toHtml5QrcodeSupportedFormats(largestBarcode.format)),
                                debugData: this.createDebugData()
                            }
                        ];
                }
            });
        });
    };
    BarcodeDetectorDelegate.prototype.selectLargestBarcode = function(barcodes) {
        var largestBarcode = null;
        var maxArea = 0;
        for(var _i = 0, barcodes_1 = barcodes; _i < barcodes_1.length; _i++){
            var barcode = barcodes_1[_i];
            var area = barcode.boundingBox.width * barcode.boundingBox.height;
            if (area > maxArea) {
                maxArea = area;
                largestBarcode = barcode;
            }
        }
        if (!largestBarcode) throw "No largest barcode found";
        return largestBarcode;
    };
    BarcodeDetectorDelegate.prototype.createBarcodeDetectorFormats = function(requestedFormats) {
        var formats = [];
        for(var _i = 0, requestedFormats_1 = requestedFormats; _i < requestedFormats_1.length; _i++){
            var requestedFormat = requestedFormats_1[_i];
            if (this.formatMap.has(requestedFormat)) formats.push(this.formatMap.get(requestedFormat));
            else this.logger.warn("".concat(requestedFormat, " is not supported by") + "BarcodeDetectorDelegate");
        }
        return {
            formats: formats
        };
    };
    BarcodeDetectorDelegate.prototype.toHtml5QrcodeSupportedFormats = function(barcodeDetectorFormat) {
        if (!this.reverseFormatMap.has(barcodeDetectorFormat)) throw "reverseFormatMap doesn't have ".concat(barcodeDetectorFormat);
        return this.reverseFormatMap.get(barcodeDetectorFormat);
    };
    BarcodeDetectorDelegate.prototype.createReverseFormatMap = function() {
        var result = new Map();
        this.formatMap.forEach(function(value, key, _) {
            result.set(value, key);
        });
        return result;
    };
    BarcodeDetectorDelegate.prototype.createDebugData = function() {
        return {
            decoderName: "BarcodeDetector"
        };
    };
    return BarcodeDetectorDelegate;
}();

});


parcelRegister("6tR4m", function(module, exports) {

$parcel$export(module.exports, "CameraFactory", () => $4b7e9dfcf56ffd8b$export$2fe5dfd38a5788bd);

var $7V7hN = parcelRequire("7V7hN");
var $4b7e9dfcf56ffd8b$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $4b7e9dfcf56ffd8b$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $4b7e9dfcf56ffd8b$export$2fe5dfd38a5788bd = function() {
    function CameraFactory() {}
    CameraFactory.failIfNotSupported = function() {
        return $4b7e9dfcf56ffd8b$var$__awaiter(this, void 0, void 0, function() {
            return $4b7e9dfcf56ffd8b$var$__generator(this, function(_a) {
                if (!navigator.mediaDevices) throw "navigator.mediaDevices not supported";
                return [
                    2,
                    new CameraFactory()
                ];
            });
        });
    };
    CameraFactory.prototype.create = function(videoConstraints) {
        return $4b7e9dfcf56ffd8b$var$__awaiter(this, void 0, void 0, function() {
            return $4b7e9dfcf56ffd8b$var$__generator(this, function(_a) {
                return [
                    2,
                    (0, $7V7hN.CameraImpl).create(videoConstraints)
                ];
            });
        });
    };
    return CameraFactory;
}();

});
parcelRegister("7V7hN", function(module, exports) {

$parcel$export(module.exports, "CameraImpl", () => $5c438225b2e6422b$export$628cc91c21cd86e4);
var $5c438225b2e6422b$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $5c438225b2e6422b$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $5c438225b2e6422b$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $5c438225b2e6422b$var$AbstractCameraCapability = function() {
    function AbstractCameraCapability(name, track) {
        this.name = name;
        this.track = track;
    }
    AbstractCameraCapability.prototype.isSupported = function() {
        if (!this.track.getCapabilities) return false;
        return this.name in this.track.getCapabilities();
    };
    AbstractCameraCapability.prototype.apply = function(value) {
        var constraint = {};
        constraint[this.name] = value;
        var constraints = {
            advanced: [
                constraint
            ]
        };
        return this.track.applyConstraints(constraints);
    };
    AbstractCameraCapability.prototype.value = function() {
        var settings = this.track.getSettings();
        if (this.name in settings) {
            var settingValue = settings[this.name];
            return settingValue;
        }
        return null;
    };
    return AbstractCameraCapability;
}();
var $5c438225b2e6422b$var$AbstractRangeCameraCapability = function(_super) {
    $5c438225b2e6422b$var$__extends(AbstractRangeCameraCapability, _super);
    function AbstractRangeCameraCapability(name, track) {
        return _super.call(this, name, track) || this;
    }
    AbstractRangeCameraCapability.prototype.min = function() {
        return this.getCapabilities().min;
    };
    AbstractRangeCameraCapability.prototype.max = function() {
        return this.getCapabilities().max;
    };
    AbstractRangeCameraCapability.prototype.step = function() {
        return this.getCapabilities().step;
    };
    AbstractRangeCameraCapability.prototype.apply = function(value) {
        var constraint = {};
        constraint[this.name] = value;
        var constraints = {
            advanced: [
                constraint
            ]
        };
        return this.track.applyConstraints(constraints);
    };
    AbstractRangeCameraCapability.prototype.getCapabilities = function() {
        this.failIfNotSupported();
        var capabilities = this.track.getCapabilities();
        var capability = capabilities[this.name];
        return {
            min: capability.min,
            max: capability.max,
            step: capability.step
        };
    };
    AbstractRangeCameraCapability.prototype.failIfNotSupported = function() {
        if (!this.isSupported()) throw new Error("".concat(this.name, " capability not supported"));
    };
    return AbstractRangeCameraCapability;
}($5c438225b2e6422b$var$AbstractCameraCapability);
var $5c438225b2e6422b$var$ZoomFeatureImpl = function(_super) {
    $5c438225b2e6422b$var$__extends(ZoomFeatureImpl, _super);
    function ZoomFeatureImpl(track) {
        return _super.call(this, "zoom", track) || this;
    }
    return ZoomFeatureImpl;
}($5c438225b2e6422b$var$AbstractRangeCameraCapability);
var $5c438225b2e6422b$var$TorchFeatureImpl = function(_super) {
    $5c438225b2e6422b$var$__extends(TorchFeatureImpl, _super);
    function TorchFeatureImpl(track) {
        return _super.call(this, "torch", track) || this;
    }
    return TorchFeatureImpl;
}($5c438225b2e6422b$var$AbstractCameraCapability);
var $5c438225b2e6422b$var$CameraCapabilitiesImpl = function() {
    function CameraCapabilitiesImpl(track) {
        this.track = track;
    }
    CameraCapabilitiesImpl.prototype.zoomFeature = function() {
        return new $5c438225b2e6422b$var$ZoomFeatureImpl(this.track);
    };
    CameraCapabilitiesImpl.prototype.torchFeature = function() {
        return new $5c438225b2e6422b$var$TorchFeatureImpl(this.track);
    };
    return CameraCapabilitiesImpl;
}();
var $5c438225b2e6422b$var$RenderedCameraImpl = function() {
    function RenderedCameraImpl(parentElement, mediaStream, callbacks) {
        this.isClosed = false;
        this.parentElement = parentElement;
        this.mediaStream = mediaStream;
        this.callbacks = callbacks;
        this.surface = this.createVideoElement(this.parentElement.clientWidth);
        parentElement.append(this.surface);
    }
    RenderedCameraImpl.prototype.createVideoElement = function(width) {
        var videoElement = document.createElement("video");
        videoElement.style.width = "".concat(width, "px");
        videoElement.style.display = "block";
        videoElement.muted = true;
        videoElement.setAttribute("muted", "true");
        videoElement.playsInline = true;
        return videoElement;
    };
    RenderedCameraImpl.prototype.setupSurface = function() {
        var _this = this;
        this.surface.onabort = function() {
            throw "RenderedCameraImpl video surface onabort() called";
        };
        this.surface.onerror = function() {
            throw "RenderedCameraImpl video surface onerror() called";
        };
        var onVideoStart = function() {
            var videoWidth = _this.surface.clientWidth;
            var videoHeight = _this.surface.clientHeight;
            _this.callbacks.onRenderSurfaceReady(videoWidth, videoHeight);
            _this.surface.removeEventListener("playing", onVideoStart);
        };
        this.surface.addEventListener("playing", onVideoStart);
        this.surface.srcObject = this.mediaStream;
        this.surface.play();
    };
    RenderedCameraImpl.create = function(parentElement, mediaStream, options, callbacks) {
        return $5c438225b2e6422b$var$__awaiter(this, void 0, void 0, function() {
            var renderedCamera, aspectRatioConstraint;
            return $5c438225b2e6422b$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        renderedCamera = new RenderedCameraImpl(parentElement, mediaStream, callbacks);
                        if (!options.aspectRatio) return [
                            3,
                            2
                        ];
                        aspectRatioConstraint = {
                            aspectRatio: options.aspectRatio
                        };
                        return [
                            4,
                            renderedCamera.getFirstTrackOrFail().applyConstraints(aspectRatioConstraint)
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        renderedCamera.setupSurface();
                        return [
                            2,
                            renderedCamera
                        ];
                }
            });
        });
    };
    RenderedCameraImpl.prototype.failIfClosed = function() {
        if (this.isClosed) throw "The RenderedCamera has already been closed.";
    };
    RenderedCameraImpl.prototype.getFirstTrackOrFail = function() {
        this.failIfClosed();
        if (this.mediaStream.getVideoTracks().length === 0) throw "No video tracks found";
        return this.mediaStream.getVideoTracks()[0];
    };
    RenderedCameraImpl.prototype.pause = function() {
        this.failIfClosed();
        this.surface.pause();
    };
    RenderedCameraImpl.prototype.resume = function(onResumeCallback) {
        this.failIfClosed();
        var $this = this;
        var onVideoResume = function() {
            setTimeout(onResumeCallback, 200);
            $this.surface.removeEventListener("playing", onVideoResume);
        };
        this.surface.addEventListener("playing", onVideoResume);
        this.surface.play();
    };
    RenderedCameraImpl.prototype.isPaused = function() {
        this.failIfClosed();
        return this.surface.paused;
    };
    RenderedCameraImpl.prototype.getSurface = function() {
        this.failIfClosed();
        return this.surface;
    };
    RenderedCameraImpl.prototype.getRunningTrackCapabilities = function() {
        return this.getFirstTrackOrFail().getCapabilities();
    };
    RenderedCameraImpl.prototype.getRunningTrackSettings = function() {
        return this.getFirstTrackOrFail().getSettings();
    };
    RenderedCameraImpl.prototype.applyVideoConstraints = function(constraints) {
        return $5c438225b2e6422b$var$__awaiter(this, void 0, void 0, function() {
            return $5c438225b2e6422b$var$__generator(this, function(_a) {
                if ("aspectRatio" in constraints) throw "Changing 'aspectRatio' in run-time is not yet supported.";
                return [
                    2,
                    this.getFirstTrackOrFail().applyConstraints(constraints)
                ];
            });
        });
    };
    RenderedCameraImpl.prototype.close = function() {
        if (this.isClosed) return Promise.resolve();
        var $this = this;
        return new Promise(function(resolve, _) {
            var tracks = $this.mediaStream.getVideoTracks();
            var tracksToClose = tracks.length;
            var tracksClosed = 0;
            $this.mediaStream.getVideoTracks().forEach(function(videoTrack) {
                $this.mediaStream.removeTrack(videoTrack);
                videoTrack.stop();
                ++tracksClosed;
                if (tracksClosed >= tracksToClose) {
                    $this.isClosed = true;
                    $this.parentElement.removeChild($this.surface);
                    resolve();
                }
            });
        });
    };
    RenderedCameraImpl.prototype.getCapabilities = function() {
        return new $5c438225b2e6422b$var$CameraCapabilitiesImpl(this.getFirstTrackOrFail());
    };
    return RenderedCameraImpl;
}();
var $5c438225b2e6422b$export$628cc91c21cd86e4 = function() {
    function CameraImpl(mediaStream) {
        this.mediaStream = mediaStream;
    }
    CameraImpl.prototype.render = function(parentElement, options, callbacks) {
        return $5c438225b2e6422b$var$__awaiter(this, void 0, void 0, function() {
            return $5c438225b2e6422b$var$__generator(this, function(_a) {
                return [
                    2,
                    $5c438225b2e6422b$var$RenderedCameraImpl.create(parentElement, this.mediaStream, options, callbacks)
                ];
            });
        });
    };
    CameraImpl.create = function(videoConstraints) {
        return $5c438225b2e6422b$var$__awaiter(this, void 0, void 0, function() {
            var constraints, mediaStream;
            return $5c438225b2e6422b$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!navigator.mediaDevices) throw "navigator.mediaDevices not supported";
                        constraints = {
                            audio: false,
                            video: videoConstraints
                        };
                        return [
                            4,
                            navigator.mediaDevices.getUserMedia(constraints)
                        ];
                    case 1:
                        mediaStream = _a.sent();
                        return [
                            2,
                            new CameraImpl(mediaStream)
                        ];
                }
            });
        });
    };
    return CameraImpl;
}();

});


parcelRegister("ffdwa", function(module, exports) {

$parcel$export(module.exports, "CameraRetriever", () => $b192be1c90c73b86$export$3cb69280b8b5ed56);

var $45mrT = parcelRequire("45mrT");
var $b192be1c90c73b86$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $b192be1c90c73b86$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $b192be1c90c73b86$export$3cb69280b8b5ed56 = function() {
    function CameraRetriever() {}
    CameraRetriever.retrieve = function() {
        if (navigator.mediaDevices) return CameraRetriever.getCamerasFromMediaDevices();
        var mst = MediaStreamTrack;
        if (MediaStreamTrack && mst.getSources) return CameraRetriever.getCamerasFromMediaStreamTrack();
        return CameraRetriever.rejectWithError();
    };
    CameraRetriever.rejectWithError = function() {
        var errorMessage = (0, $45mrT.Html5QrcodeStrings).unableToQuerySupportedDevices();
        if (!CameraRetriever.isHttpsOrLocalhost()) errorMessage = (0, $45mrT.Html5QrcodeStrings).insecureContextCameraQueryError();
        return Promise.reject(errorMessage);
    };
    CameraRetriever.isHttpsOrLocalhost = function() {
        if (location.protocol === "https:") return true;
        var host = location.host.split(":")[0];
        return host === "127.0.0.1" || host === "localhost";
    };
    CameraRetriever.getCamerasFromMediaDevices = function() {
        return $b192be1c90c73b86$var$__awaiter(this, void 0, void 0, function() {
            var closeActiveStreams, mediaStream, devices, results, _i, devices_1, device;
            return $b192be1c90c73b86$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        closeActiveStreams = function(stream) {
                            var tracks = stream.getVideoTracks();
                            for(var _i = 0, tracks_1 = tracks; _i < tracks_1.length; _i++){
                                var track = tracks_1[_i];
                                track.enabled = false;
                                track.stop();
                                stream.removeTrack(track);
                            }
                        };
                        return [
                            4,
                            navigator.mediaDevices.getUserMedia({
                                audio: false,
                                video: true
                            })
                        ];
                    case 1:
                        mediaStream = _a.sent();
                        return [
                            4,
                            navigator.mediaDevices.enumerateDevices()
                        ];
                    case 2:
                        devices = _a.sent();
                        results = [];
                        for(_i = 0, devices_1 = devices; _i < devices_1.length; _i++){
                            device = devices_1[_i];
                            if (device.kind === "videoinput") results.push({
                                id: device.deviceId,
                                label: device.label
                            });
                        }
                        closeActiveStreams(mediaStream);
                        return [
                            2,
                            results
                        ];
                }
            });
        });
    };
    CameraRetriever.getCamerasFromMediaStreamTrack = function() {
        return new Promise(function(resolve, _) {
            var callback = function(sourceInfos) {
                var results = [];
                for(var _i = 0, sourceInfos_1 = sourceInfos; _i < sourceInfos_1.length; _i++){
                    var sourceInfo = sourceInfos_1[_i];
                    if (sourceInfo.kind === "video") results.push({
                        id: sourceInfo.id,
                        label: sourceInfo.label
                    });
                }
                resolve(results);
            };
            var mst = MediaStreamTrack;
            mst.getSources(callback);
        });
    };
    return CameraRetriever;
}();

});

parcelRegister("lkAMB", function(module, exports) {

$parcel$export(module.exports, "Html5QrcodeScannerState", () => $f877ff90df2d8946$export$c90f317190d585a3);
$parcel$export(module.exports, "StateManagerFactory", () => $f877ff90df2d8946$export$9379d7cc304330e9);
var $f877ff90df2d8946$export$c90f317190d585a3;
(function(Html5QrcodeScannerState) {
    Html5QrcodeScannerState[Html5QrcodeScannerState["UNKNOWN"] = 0] = "UNKNOWN";
    Html5QrcodeScannerState[Html5QrcodeScannerState["NOT_STARTED"] = 1] = "NOT_STARTED";
    Html5QrcodeScannerState[Html5QrcodeScannerState["SCANNING"] = 2] = "SCANNING";
    Html5QrcodeScannerState[Html5QrcodeScannerState["PAUSED"] = 3] = "PAUSED";
})($f877ff90df2d8946$export$c90f317190d585a3 || ($f877ff90df2d8946$export$c90f317190d585a3 = {}));
var $f877ff90df2d8946$var$StateManagerImpl = function() {
    function StateManagerImpl() {
        this.state = $f877ff90df2d8946$export$c90f317190d585a3.NOT_STARTED;
        this.onGoingTransactionNewState = $f877ff90df2d8946$export$c90f317190d585a3.UNKNOWN;
    }
    StateManagerImpl.prototype.directTransition = function(newState) {
        this.failIfTransitionOngoing();
        this.validateTransition(newState);
        this.state = newState;
    };
    StateManagerImpl.prototype.startTransition = function(newState) {
        this.failIfTransitionOngoing();
        this.validateTransition(newState);
        this.onGoingTransactionNewState = newState;
        return this;
    };
    StateManagerImpl.prototype.execute = function() {
        if (this.onGoingTransactionNewState === $f877ff90df2d8946$export$c90f317190d585a3.UNKNOWN) throw "Transaction is already cancelled, cannot execute().";
        var tempNewState = this.onGoingTransactionNewState;
        this.onGoingTransactionNewState = $f877ff90df2d8946$export$c90f317190d585a3.UNKNOWN;
        this.directTransition(tempNewState);
    };
    StateManagerImpl.prototype.cancel = function() {
        if (this.onGoingTransactionNewState === $f877ff90df2d8946$export$c90f317190d585a3.UNKNOWN) throw "Transaction is already cancelled, cannot cancel().";
        this.onGoingTransactionNewState = $f877ff90df2d8946$export$c90f317190d585a3.UNKNOWN;
    };
    StateManagerImpl.prototype.getState = function() {
        return this.state;
    };
    StateManagerImpl.prototype.failIfTransitionOngoing = function() {
        if (this.onGoingTransactionNewState !== $f877ff90df2d8946$export$c90f317190d585a3.UNKNOWN) throw "Cannot transition to a new state, already under transition";
    };
    StateManagerImpl.prototype.validateTransition = function(newState) {
        switch(this.state){
            case $f877ff90df2d8946$export$c90f317190d585a3.UNKNOWN:
                throw "Transition from unknown is not allowed";
            case $f877ff90df2d8946$export$c90f317190d585a3.NOT_STARTED:
                this.failIfNewStateIs(newState, [
                    $f877ff90df2d8946$export$c90f317190d585a3.PAUSED
                ]);
                break;
            case $f877ff90df2d8946$export$c90f317190d585a3.SCANNING:
                break;
            case $f877ff90df2d8946$export$c90f317190d585a3.PAUSED:
                break;
        }
    };
    StateManagerImpl.prototype.failIfNewStateIs = function(newState, disallowedStatesToTransition) {
        for(var _i = 0, disallowedStatesToTransition_1 = disallowedStatesToTransition; _i < disallowedStatesToTransition_1.length; _i++){
            var disallowedState = disallowedStatesToTransition_1[_i];
            if (newState === disallowedState) throw "Cannot transition from ".concat(this.state, " to ").concat(newState);
        }
    };
    return StateManagerImpl;
}();
var $f877ff90df2d8946$export$999aa14d48ead8a4 = function() {
    function StateManagerProxy(stateManager) {
        this.stateManager = stateManager;
    }
    StateManagerProxy.prototype.startTransition = function(newState) {
        return this.stateManager.startTransition(newState);
    };
    StateManagerProxy.prototype.directTransition = function(newState) {
        this.stateManager.directTransition(newState);
    };
    StateManagerProxy.prototype.getState = function() {
        return this.stateManager.getState();
    };
    StateManagerProxy.prototype.canScanFile = function() {
        return this.stateManager.getState() === $f877ff90df2d8946$export$c90f317190d585a3.NOT_STARTED;
    };
    StateManagerProxy.prototype.isScanning = function() {
        return this.stateManager.getState() !== $f877ff90df2d8946$export$c90f317190d585a3.NOT_STARTED;
    };
    StateManagerProxy.prototype.isStrictlyScanning = function() {
        return this.stateManager.getState() === $f877ff90df2d8946$export$c90f317190d585a3.SCANNING;
    };
    StateManagerProxy.prototype.isPaused = function() {
        return this.stateManager.getState() === $f877ff90df2d8946$export$c90f317190d585a3.PAUSED;
    };
    return StateManagerProxy;
}();
var $f877ff90df2d8946$export$9379d7cc304330e9 = function() {
    function StateManagerFactory() {}
    StateManagerFactory.create = function() {
        return new $f877ff90df2d8946$export$999aa14d48ead8a4(new $f877ff90df2d8946$var$StateManagerImpl());
    };
    return StateManagerFactory;
}();

});


parcelRegister("bfh1Q", function(module, exports) {

var $a3hi8 = parcelRequire("a3hi8");

var $jY10E = parcelRequire("jY10E");

var $45mrT = parcelRequire("45mrT");

var $3UFjS = parcelRequire("3UFjS");

var $cmkKR = parcelRequire("cmkKR");

var $bAclF = parcelRequire("bAclF");

var $jaJWv = parcelRequire("jaJWv");

var $6R5ZT = parcelRequire("6R5ZT");

var $h4YAq = parcelRequire("h4YAq");

var $d2L5r = parcelRequire("d2L5r");

var $ccGEO = parcelRequire("ccGEO");

var $jY6p9 = parcelRequire("jY6p9");

var $5b9Ca = parcelRequire("5b9Ca");
var $82fe4e001c9c6a08$var$Html5QrcodeScannerStatus;
(function(Html5QrcodeScannerStatus) {
    Html5QrcodeScannerStatus[Html5QrcodeScannerStatus["STATUS_DEFAULT"] = 0] = "STATUS_DEFAULT";
    Html5QrcodeScannerStatus[Html5QrcodeScannerStatus["STATUS_SUCCESS"] = 1] = "STATUS_SUCCESS";
    Html5QrcodeScannerStatus[Html5QrcodeScannerStatus["STATUS_WARNING"] = 2] = "STATUS_WARNING";
    Html5QrcodeScannerStatus[Html5QrcodeScannerStatus["STATUS_REQUESTING_PERMISSION"] = 3] = "STATUS_REQUESTING_PERMISSION";
})($82fe4e001c9c6a08$var$Html5QrcodeScannerStatus || ($82fe4e001c9c6a08$var$Html5QrcodeScannerStatus = {}));
function $82fe4e001c9c6a08$var$toHtml5QrcodeCameraScanConfig(config) {
    return {
        fps: config.fps,
        qrbox: config.qrbox,
        aspectRatio: config.aspectRatio,
        disableFlip: config.disableFlip,
        videoConstraints: config.videoConstraints
    };
}
function $82fe4e001c9c6a08$var$toHtml5QrcodeFullConfig(config, verbose) {
    return {
        formatsToSupport: config.formatsToSupport,
        useBarCodeDetectorIfSupported: config.useBarCodeDetectorIfSupported,
        experimentalFeatures: config.experimentalFeatures,
        verbose: verbose
    };
}
var $82fe4e001c9c6a08$export$bc9b6fcc47abf610 = function() {
    function Html5QrcodeScanner(elementId, config, verbose) {
        this.lastMatchFound = null;
        this.cameraScanImage = null;
        this.fileScanImage = null;
        this.fileSelectionUi = null;
        this.elementId = elementId;
        this.config = this.createConfig(config);
        this.verbose = verbose === true;
        if (!document.getElementById(elementId)) throw "HTML Element with id=".concat(elementId, " not found");
        this.scanTypeSelector = new (0, $6R5ZT.ScanTypeSelector)(this.config.supportedScanTypes);
        this.currentScanType = this.scanTypeSelector.getDefaultScanType();
        this.sectionSwapAllowed = true;
        this.logger = new (0, $a3hi8.BaseLoggger)(this.verbose);
        this.persistedDataManager = new (0, $cmkKR.PersistedDataManager)();
        if (config.rememberLastUsedCamera !== true) this.persistedDataManager.reset();
    }
    Html5QrcodeScanner.prototype.render = function(qrCodeSuccessCallback, qrCodeErrorCallback) {
        var _this = this;
        this.lastMatchFound = null;
        this.qrCodeSuccessCallback = function(decodedText, result) {
            if (qrCodeSuccessCallback) qrCodeSuccessCallback(decodedText, result);
            else {
                if (_this.lastMatchFound === decodedText) return;
                _this.lastMatchFound = decodedText;
                _this.setHeaderMessage((0, $45mrT.Html5QrcodeScannerStrings).lastMatch(decodedText), $82fe4e001c9c6a08$var$Html5QrcodeScannerStatus.STATUS_SUCCESS);
            }
        };
        this.qrCodeErrorCallback = function(errorMessage, error) {
            if (qrCodeErrorCallback) qrCodeErrorCallback(errorMessage, error);
        };
        var container = document.getElementById(this.elementId);
        if (!container) throw "HTML Element with id=".concat(this.elementId, " not found");
        container.innerHTML = "";
        this.createBasicLayout(container);
        this.html5Qrcode = new (0, $jY10E.Html5Qrcode)(this.getScanRegionId(), $82fe4e001c9c6a08$var$toHtml5QrcodeFullConfig(this.config, this.verbose));
    };
    Html5QrcodeScanner.prototype.pause = function(shouldPauseVideo) {
        if ((0, $a3hi8.isNullOrUndefined)(shouldPauseVideo) || shouldPauseVideo !== true) shouldPauseVideo = false;
        this.getHtml5QrcodeOrFail().pause(shouldPauseVideo);
    };
    Html5QrcodeScanner.prototype.resume = function() {
        this.getHtml5QrcodeOrFail().resume();
    };
    Html5QrcodeScanner.prototype.getState = function() {
        return this.getHtml5QrcodeOrFail().getState();
    };
    Html5QrcodeScanner.prototype.clear = function() {
        var _this = this;
        var emptyHtmlContainer = function() {
            var mainContainer = document.getElementById(_this.elementId);
            if (mainContainer) {
                mainContainer.innerHTML = "";
                _this.resetBasicLayout(mainContainer);
            }
        };
        if (this.html5Qrcode) return new Promise(function(resolve, reject) {
            if (!_this.html5Qrcode) {
                resolve();
                return;
            }
            if (_this.html5Qrcode.isScanning) _this.html5Qrcode.stop().then(function(_) {
                if (!_this.html5Qrcode) {
                    resolve();
                    return;
                }
                _this.html5Qrcode.clear();
                emptyHtmlContainer();
                resolve();
            }).catch(function(error) {
                if (_this.verbose) _this.logger.logError("Unable to stop qrcode scanner", error);
                reject(error);
            });
            else {
                _this.html5Qrcode.clear();
                emptyHtmlContainer();
                resolve();
            }
        });
        return Promise.resolve();
    };
    Html5QrcodeScanner.prototype.getRunningTrackCapabilities = function() {
        return this.getHtml5QrcodeOrFail().getRunningTrackCapabilities();
    };
    Html5QrcodeScanner.prototype.getRunningTrackSettings = function() {
        return this.getHtml5QrcodeOrFail().getRunningTrackSettings();
    };
    Html5QrcodeScanner.prototype.applyVideoConstraints = function(videoConstaints) {
        return this.getHtml5QrcodeOrFail().applyVideoConstraints(videoConstaints);
    };
    Html5QrcodeScanner.prototype.getHtml5QrcodeOrFail = function() {
        if (!this.html5Qrcode) throw "Code scanner not initialized.";
        return this.html5Qrcode;
    };
    Html5QrcodeScanner.prototype.createConfig = function(config) {
        if (config) {
            if (!config.fps) config.fps = (0, $a3hi8.Html5QrcodeConstants).SCAN_DEFAULT_FPS;
            if (config.rememberLastUsedCamera !== !(0, $a3hi8.Html5QrcodeConstants).DEFAULT_REMEMBER_LAST_CAMERA_USED) config.rememberLastUsedCamera = (0, $a3hi8.Html5QrcodeConstants).DEFAULT_REMEMBER_LAST_CAMERA_USED;
            if (!config.supportedScanTypes) config.supportedScanTypes = (0, $a3hi8.Html5QrcodeConstants).DEFAULT_SUPPORTED_SCAN_TYPE;
            return config;
        }
        return {
            fps: (0, $a3hi8.Html5QrcodeConstants).SCAN_DEFAULT_FPS,
            rememberLastUsedCamera: (0, $a3hi8.Html5QrcodeConstants).DEFAULT_REMEMBER_LAST_CAMERA_USED,
            supportedScanTypes: (0, $a3hi8.Html5QrcodeConstants).DEFAULT_SUPPORTED_SCAN_TYPE
        };
    };
    Html5QrcodeScanner.prototype.createBasicLayout = function(parent) {
        parent.style.position = "relative";
        parent.style.padding = "0px";
        parent.style.border = "1px solid silver";
        this.createHeader(parent);
        var qrCodeScanRegion = document.createElement("div");
        var scanRegionId = this.getScanRegionId();
        qrCodeScanRegion.id = scanRegionId;
        qrCodeScanRegion.style.width = "100%";
        qrCodeScanRegion.style.minHeight = "100px";
        qrCodeScanRegion.style.textAlign = "center";
        parent.appendChild(qrCodeScanRegion);
        if ((0, $6R5ZT.ScanTypeSelector).isCameraScanType(this.currentScanType)) this.insertCameraScanImageToScanRegion();
        else this.insertFileScanImageToScanRegion();
        var qrCodeDashboard = document.createElement("div");
        var dashboardId = this.getDashboardId();
        qrCodeDashboard.id = dashboardId;
        qrCodeDashboard.style.width = "100%";
        parent.appendChild(qrCodeDashboard);
        this.setupInitialDashboard(qrCodeDashboard);
    };
    Html5QrcodeScanner.prototype.resetBasicLayout = function(mainContainer) {
        mainContainer.style.border = "none";
    };
    Html5QrcodeScanner.prototype.setupInitialDashboard = function(dashboard) {
        this.createSection(dashboard);
        this.createSectionControlPanel();
        if (this.scanTypeSelector.hasMoreThanOneScanType()) this.createSectionSwap();
    };
    Html5QrcodeScanner.prototype.createHeader = function(dashboard) {
        var header = document.createElement("div");
        header.style.textAlign = "left";
        header.style.margin = "0px";
        dashboard.appendChild(header);
        var libraryInfo = new (0, $bAclF.LibraryInfoContainer)();
        libraryInfo.renderInto(header);
        var headerMessageContainer = document.createElement("div");
        headerMessageContainer.id = this.getHeaderMessageContainerId();
        headerMessageContainer.style.display = "none";
        headerMessageContainer.style.textAlign = "center";
        headerMessageContainer.style.fontSize = "14px";
        headerMessageContainer.style.padding = "2px 10px";
        headerMessageContainer.style.margin = "4px";
        headerMessageContainer.style.borderTop = "1px solid #f6f6f6";
        header.appendChild(headerMessageContainer);
    };
    Html5QrcodeScanner.prototype.createSection = function(dashboard) {
        var section = document.createElement("div");
        section.id = this.getDashboardSectionId();
        section.style.width = "100%";
        section.style.padding = "10px 0px 10px 0px";
        section.style.textAlign = "left";
        dashboard.appendChild(section);
    };
    Html5QrcodeScanner.prototype.createCameraListUi = function(scpCameraScanRegion, requestPermissionContainer, requestPermissionButton) {
        var $this = this;
        $this.showHideScanTypeSwapLink(false);
        $this.setHeaderMessage((0, $45mrT.Html5QrcodeScannerStrings).cameraPermissionRequesting());
        var createPermissionButtonIfNotExists = function() {
            if (!requestPermissionButton) $this.createPermissionButton(scpCameraScanRegion, requestPermissionContainer);
        };
        (0, $jY10E.Html5Qrcode).getCameras().then(function(cameras) {
            $this.persistedDataManager.setHasPermission(true);
            $this.showHideScanTypeSwapLink(true);
            $this.resetHeaderMessage();
            if (cameras && cameras.length > 0) {
                scpCameraScanRegion.removeChild(requestPermissionContainer);
                $this.renderCameraSelection(cameras);
            } else {
                $this.setHeaderMessage((0, $45mrT.Html5QrcodeScannerStrings).noCameraFound(), $82fe4e001c9c6a08$var$Html5QrcodeScannerStatus.STATUS_WARNING);
                createPermissionButtonIfNotExists();
            }
        }).catch(function(error) {
            $this.persistedDataManager.setHasPermission(false);
            if (requestPermissionButton) requestPermissionButton.disabled = false;
            else createPermissionButtonIfNotExists();
            $this.setHeaderMessage(error, $82fe4e001c9c6a08$var$Html5QrcodeScannerStatus.STATUS_WARNING);
            $this.showHideScanTypeSwapLink(true);
        });
    };
    Html5QrcodeScanner.prototype.createPermissionButton = function(scpCameraScanRegion, requestPermissionContainer) {
        var $this = this;
        var requestPermissionButton = (0, $ccGEO.BaseUiElementFactory).createElement("button", this.getCameraPermissionButtonId());
        requestPermissionButton.innerText = (0, $45mrT.Html5QrcodeScannerStrings).cameraPermissionTitle();
        requestPermissionButton.addEventListener("click", function() {
            requestPermissionButton.disabled = true;
            $this.createCameraListUi(scpCameraScanRegion, requestPermissionContainer, requestPermissionButton);
        });
        requestPermissionContainer.appendChild(requestPermissionButton);
    };
    Html5QrcodeScanner.prototype.createPermissionsUi = function(scpCameraScanRegion, requestPermissionContainer) {
        var $this = this;
        if ((0, $6R5ZT.ScanTypeSelector).isCameraScanType(this.currentScanType) && this.persistedDataManager.hasCameraPermissions()) {
            (0, $jaJWv.CameraPermissions).hasPermissions().then(function(hasPermissions) {
                if (hasPermissions) $this.createCameraListUi(scpCameraScanRegion, requestPermissionContainer);
                else {
                    $this.persistedDataManager.setHasPermission(false);
                    $this.createPermissionButton(scpCameraScanRegion, requestPermissionContainer);
                }
            }).catch(function(_) {
                $this.persistedDataManager.setHasPermission(false);
                $this.createPermissionButton(scpCameraScanRegion, requestPermissionContainer);
            });
            return;
        }
        this.createPermissionButton(scpCameraScanRegion, requestPermissionContainer);
    };
    Html5QrcodeScanner.prototype.createSectionControlPanel = function() {
        var section = document.getElementById(this.getDashboardSectionId());
        var sectionControlPanel = document.createElement("div");
        section.appendChild(sectionControlPanel);
        var scpCameraScanRegion = document.createElement("div");
        scpCameraScanRegion.id = this.getDashboardSectionCameraScanRegionId();
        scpCameraScanRegion.style.display = (0, $6R5ZT.ScanTypeSelector).isCameraScanType(this.currentScanType) ? "block" : "none";
        sectionControlPanel.appendChild(scpCameraScanRegion);
        var requestPermissionContainer = document.createElement("div");
        requestPermissionContainer.style.textAlign = "center";
        scpCameraScanRegion.appendChild(requestPermissionContainer);
        if (this.scanTypeSelector.isCameraScanRequired()) this.createPermissionsUi(scpCameraScanRegion, requestPermissionContainer);
        this.renderFileScanUi(sectionControlPanel);
    };
    Html5QrcodeScanner.prototype.renderFileScanUi = function(parent) {
        var showOnRender = (0, $6R5ZT.ScanTypeSelector).isFileScanType(this.currentScanType);
        var $this = this;
        var onFileSelected = function(file) {
            if (!$this.html5Qrcode) throw "html5Qrcode not defined";
            if (!(0, $6R5ZT.ScanTypeSelector).isFileScanType($this.currentScanType)) return;
            $this.setHeaderMessage((0, $45mrT.Html5QrcodeScannerStrings).loadingImage());
            $this.html5Qrcode.scanFileV2(file, true).then(function(html5qrcodeResult) {
                $this.resetHeaderMessage();
                $this.qrCodeSuccessCallback(html5qrcodeResult.decodedText, html5qrcodeResult);
            }).catch(function(error) {
                $this.setHeaderMessage(error, $82fe4e001c9c6a08$var$Html5QrcodeScannerStatus.STATUS_WARNING);
                $this.qrCodeErrorCallback(error, (0, $a3hi8.Html5QrcodeErrorFactory).createFrom(error));
            });
        };
        this.fileSelectionUi = (0, $d2L5r.FileSelectionUi).create(parent, showOnRender, onFileSelected);
    };
    Html5QrcodeScanner.prototype.renderCameraSelection = function(cameras) {
        var _this = this;
        var $this = this;
        var scpCameraScanRegion = document.getElementById(this.getDashboardSectionCameraScanRegionId());
        scpCameraScanRegion.style.textAlign = "center";
        var cameraZoomUi = (0, $5b9Ca.CameraZoomUi).create(scpCameraScanRegion, false);
        var renderCameraZoomUiIfSupported = function(cameraCapabilities) {
            var zoomCapability = cameraCapabilities.zoomFeature();
            if (!zoomCapability.isSupported()) return;
            cameraZoomUi.setOnCameraZoomValueChangeCallback(function(zoomValue) {
                zoomCapability.apply(zoomValue);
            });
            var defaultZoom = 1;
            if (_this.config.defaultZoomValueIfSupported) defaultZoom = _this.config.defaultZoomValueIfSupported;
            defaultZoom = (0, $a3hi8.clip)(defaultZoom, zoomCapability.min(), zoomCapability.max());
            cameraZoomUi.setValues(zoomCapability.min(), zoomCapability.max(), defaultZoom, zoomCapability.step());
            cameraZoomUi.show();
        };
        var cameraSelectUi = (0, $jY6p9.CameraSelectionUi).create(scpCameraScanRegion, cameras);
        var cameraActionContainer = document.createElement("span");
        var cameraActionStartButton = (0, $ccGEO.BaseUiElementFactory).createElement("button", (0, $ccGEO.PublicUiElementIdAndClasses).CAMERA_START_BUTTON_ID);
        cameraActionStartButton.innerText = (0, $45mrT.Html5QrcodeScannerStrings).scanButtonStartScanningText();
        cameraActionContainer.appendChild(cameraActionStartButton);
        var cameraActionStopButton = (0, $ccGEO.BaseUiElementFactory).createElement("button", (0, $ccGEO.PublicUiElementIdAndClasses).CAMERA_STOP_BUTTON_ID);
        cameraActionStopButton.innerText = (0, $45mrT.Html5QrcodeScannerStrings).scanButtonStopScanningText();
        cameraActionStopButton.style.display = "none";
        cameraActionStopButton.disabled = true;
        cameraActionContainer.appendChild(cameraActionStopButton);
        var torchButton;
        var createAndShowTorchButtonIfSupported = function(cameraCapabilities) {
            if (!cameraCapabilities.torchFeature().isSupported()) {
                if (torchButton) torchButton.hide();
                return;
            }
            if (!torchButton) torchButton = (0, $h4YAq.TorchButton).create(cameraActionContainer, cameraCapabilities.torchFeature(), {
                display: "none",
                marginLeft: "5px"
            }, function(errorMessage) {
                $this.setHeaderMessage(errorMessage, $82fe4e001c9c6a08$var$Html5QrcodeScannerStatus.STATUS_WARNING);
            });
            else torchButton.updateTorchCapability(cameraCapabilities.torchFeature());
            torchButton.show();
        };
        scpCameraScanRegion.appendChild(cameraActionContainer);
        var resetCameraActionStartButton = function(shouldShow) {
            if (!shouldShow) cameraActionStartButton.style.display = "none";
            cameraActionStartButton.innerText = (0, $45mrT.Html5QrcodeScannerStrings).scanButtonStartScanningText();
            cameraActionStartButton.style.opacity = "1";
            cameraActionStartButton.disabled = false;
            if (shouldShow) cameraActionStartButton.style.display = "inline-block";
        };
        cameraActionStartButton.addEventListener("click", function(_) {
            cameraActionStartButton.innerText = (0, $45mrT.Html5QrcodeScannerStrings).scanButtonScanningStarting();
            cameraSelectUi.disable();
            cameraActionStartButton.disabled = true;
            cameraActionStartButton.style.opacity = "0.5";
            if (_this.scanTypeSelector.hasMoreThanOneScanType()) $this.showHideScanTypeSwapLink(false);
            $this.resetHeaderMessage();
            var cameraId = cameraSelectUi.getValue();
            $this.persistedDataManager.setLastUsedCameraId(cameraId);
            $this.html5Qrcode.start(cameraId, $82fe4e001c9c6a08$var$toHtml5QrcodeCameraScanConfig($this.config), $this.qrCodeSuccessCallback, $this.qrCodeErrorCallback).then(function(_) {
                cameraActionStopButton.disabled = false;
                cameraActionStopButton.style.display = "inline-block";
                resetCameraActionStartButton(false);
                var cameraCapabilities = $this.html5Qrcode.getRunningTrackCameraCapabilities();
                if (_this.config.showTorchButtonIfSupported === true) createAndShowTorchButtonIfSupported(cameraCapabilities);
                if (_this.config.showZoomSliderIfSupported === true) renderCameraZoomUiIfSupported(cameraCapabilities);
            }).catch(function(error) {
                $this.showHideScanTypeSwapLink(true);
                cameraSelectUi.enable();
                resetCameraActionStartButton(true);
                $this.setHeaderMessage(error, $82fe4e001c9c6a08$var$Html5QrcodeScannerStatus.STATUS_WARNING);
            });
        });
        if (cameraSelectUi.hasSingleItem()) cameraActionStartButton.click();
        cameraActionStopButton.addEventListener("click", function(_) {
            if (!$this.html5Qrcode) throw "html5Qrcode not defined";
            cameraActionStopButton.disabled = true;
            $this.html5Qrcode.stop().then(function(_) {
                if (_this.scanTypeSelector.hasMoreThanOneScanType()) $this.showHideScanTypeSwapLink(true);
                cameraSelectUi.enable();
                cameraActionStartButton.disabled = false;
                cameraActionStopButton.style.display = "none";
                cameraActionStartButton.style.display = "inline-block";
                if (torchButton) {
                    torchButton.reset();
                    torchButton.hide();
                }
                cameraZoomUi.removeOnCameraZoomValueChangeCallback();
                cameraZoomUi.hide();
                $this.insertCameraScanImageToScanRegion();
            }).catch(function(error) {
                cameraActionStopButton.disabled = false;
                $this.setHeaderMessage(error, $82fe4e001c9c6a08$var$Html5QrcodeScannerStatus.STATUS_WARNING);
            });
        });
        if ($this.persistedDataManager.getLastUsedCameraId()) {
            var cameraId = $this.persistedDataManager.getLastUsedCameraId();
            if (cameraSelectUi.hasValue(cameraId)) {
                cameraSelectUi.setValue(cameraId);
                cameraActionStartButton.click();
            } else $this.persistedDataManager.resetLastUsedCameraId();
        }
    };
    Html5QrcodeScanner.prototype.createSectionSwap = function() {
        var $this = this;
        var TEXT_IF_CAMERA_SCAN_SELECTED = (0, $45mrT.Html5QrcodeScannerStrings).textIfCameraScanSelected();
        var TEXT_IF_FILE_SCAN_SELECTED = (0, $45mrT.Html5QrcodeScannerStrings).textIfFileScanSelected();
        var section = document.getElementById(this.getDashboardSectionId());
        var switchContainer = document.createElement("div");
        switchContainer.style.textAlign = "center";
        var switchScanTypeLink = (0, $ccGEO.BaseUiElementFactory).createElement("span", this.getDashboardSectionSwapLinkId());
        switchScanTypeLink.style.textDecoration = "underline";
        switchScanTypeLink.style.cursor = "pointer";
        switchScanTypeLink.innerText = (0, $6R5ZT.ScanTypeSelector).isCameraScanType(this.currentScanType) ? TEXT_IF_CAMERA_SCAN_SELECTED : TEXT_IF_FILE_SCAN_SELECTED;
        switchScanTypeLink.addEventListener("click", function() {
            if (!$this.sectionSwapAllowed) {
                if ($this.verbose) $this.logger.logError("Section swap called when not allowed");
                return;
            }
            $this.resetHeaderMessage();
            $this.fileSelectionUi.resetValue();
            $this.sectionSwapAllowed = false;
            if ((0, $6R5ZT.ScanTypeSelector).isCameraScanType($this.currentScanType)) {
                $this.clearScanRegion();
                $this.getCameraScanRegion().style.display = "none";
                $this.fileSelectionUi.show();
                switchScanTypeLink.innerText = TEXT_IF_FILE_SCAN_SELECTED;
                $this.currentScanType = (0, $a3hi8.Html5QrcodeScanType).SCAN_TYPE_FILE;
                $this.insertFileScanImageToScanRegion();
            } else {
                $this.clearScanRegion();
                $this.getCameraScanRegion().style.display = "block";
                $this.fileSelectionUi.hide();
                switchScanTypeLink.innerText = TEXT_IF_CAMERA_SCAN_SELECTED;
                $this.currentScanType = (0, $a3hi8.Html5QrcodeScanType).SCAN_TYPE_CAMERA;
                $this.insertCameraScanImageToScanRegion();
                $this.startCameraScanIfPermissionExistsOnSwap();
            }
            $this.sectionSwapAllowed = true;
        });
        switchContainer.appendChild(switchScanTypeLink);
        section.appendChild(switchContainer);
    };
    Html5QrcodeScanner.prototype.startCameraScanIfPermissionExistsOnSwap = function() {
        var _this = this;
        var $this = this;
        if (this.persistedDataManager.hasCameraPermissions()) {
            (0, $jaJWv.CameraPermissions).hasPermissions().then(function(hasPermissions) {
                if (hasPermissions) {
                    var permissionButton = document.getElementById($this.getCameraPermissionButtonId());
                    if (!permissionButton) {
                        _this.logger.logError("Permission button not found, fail;");
                        throw "Permission button not found";
                    }
                    permissionButton.click();
                } else $this.persistedDataManager.setHasPermission(false);
            }).catch(function(_) {
                $this.persistedDataManager.setHasPermission(false);
            });
            return;
        }
    };
    Html5QrcodeScanner.prototype.resetHeaderMessage = function() {
        var messageDiv = document.getElementById(this.getHeaderMessageContainerId());
        messageDiv.style.display = "none";
    };
    Html5QrcodeScanner.prototype.setHeaderMessage = function(messageText, scannerStatus) {
        if (!scannerStatus) scannerStatus = $82fe4e001c9c6a08$var$Html5QrcodeScannerStatus.STATUS_DEFAULT;
        var messageDiv = this.getHeaderMessageDiv();
        messageDiv.innerText = messageText;
        messageDiv.style.display = "block";
        switch(scannerStatus){
            case $82fe4e001c9c6a08$var$Html5QrcodeScannerStatus.STATUS_SUCCESS:
                messageDiv.style.background = "rgba(106, 175, 80, 0.26)";
                messageDiv.style.color = "#477735";
                break;
            case $82fe4e001c9c6a08$var$Html5QrcodeScannerStatus.STATUS_WARNING:
                messageDiv.style.background = "rgba(203, 36, 49, 0.14)";
                messageDiv.style.color = "#cb2431";
                break;
            case $82fe4e001c9c6a08$var$Html5QrcodeScannerStatus.STATUS_DEFAULT:
            default:
                messageDiv.style.background = "rgba(0, 0, 0, 0)";
                messageDiv.style.color = "rgb(17, 17, 17)";
                break;
        }
    };
    Html5QrcodeScanner.prototype.showHideScanTypeSwapLink = function(shouldDisplay) {
        if (this.scanTypeSelector.hasMoreThanOneScanType()) {
            if (shouldDisplay !== true) shouldDisplay = false;
            this.sectionSwapAllowed = shouldDisplay;
            this.getDashboardSectionSwapLink().style.display = shouldDisplay ? "inline-block" : "none";
        }
    };
    Html5QrcodeScanner.prototype.insertCameraScanImageToScanRegion = function() {
        var $this = this;
        var qrCodeScanRegion = document.getElementById(this.getScanRegionId());
        if (this.cameraScanImage) {
            qrCodeScanRegion.innerHTML = "<br>";
            qrCodeScanRegion.appendChild(this.cameraScanImage);
            return;
        }
        this.cameraScanImage = new Image;
        this.cameraScanImage.onload = function(_) {
            qrCodeScanRegion.innerHTML = "<br>";
            qrCodeScanRegion.appendChild($this.cameraScanImage);
        };
        this.cameraScanImage.width = 64;
        this.cameraScanImage.style.opacity = "0.8";
        this.cameraScanImage.src = (0, $3UFjS.ASSET_CAMERA_SCAN);
        this.cameraScanImage.alt = (0, $45mrT.Html5QrcodeScannerStrings).cameraScanAltText();
    };
    Html5QrcodeScanner.prototype.insertFileScanImageToScanRegion = function() {
        var $this = this;
        var qrCodeScanRegion = document.getElementById(this.getScanRegionId());
        if (this.fileScanImage) {
            qrCodeScanRegion.innerHTML = "<br>";
            qrCodeScanRegion.appendChild(this.fileScanImage);
            return;
        }
        this.fileScanImage = new Image;
        this.fileScanImage.onload = function(_) {
            qrCodeScanRegion.innerHTML = "<br>";
            qrCodeScanRegion.appendChild($this.fileScanImage);
        };
        this.fileScanImage.width = 64;
        this.fileScanImage.style.opacity = "0.8";
        this.fileScanImage.src = (0, $3UFjS.ASSET_FILE_SCAN);
        this.fileScanImage.alt = (0, $45mrT.Html5QrcodeScannerStrings).fileScanAltText();
    };
    Html5QrcodeScanner.prototype.clearScanRegion = function() {
        var qrCodeScanRegion = document.getElementById(this.getScanRegionId());
        qrCodeScanRegion.innerHTML = "";
    };
    Html5QrcodeScanner.prototype.getDashboardSectionId = function() {
        return "".concat(this.elementId, "__dashboard_section");
    };
    Html5QrcodeScanner.prototype.getDashboardSectionCameraScanRegionId = function() {
        return "".concat(this.elementId, "__dashboard_section_csr");
    };
    Html5QrcodeScanner.prototype.getDashboardSectionSwapLinkId = function() {
        return (0, $ccGEO.PublicUiElementIdAndClasses).SCAN_TYPE_CHANGE_ANCHOR_ID;
    };
    Html5QrcodeScanner.prototype.getScanRegionId = function() {
        return "".concat(this.elementId, "__scan_region");
    };
    Html5QrcodeScanner.prototype.getDashboardId = function() {
        return "".concat(this.elementId, "__dashboard");
    };
    Html5QrcodeScanner.prototype.getHeaderMessageContainerId = function() {
        return "".concat(this.elementId, "__header_message");
    };
    Html5QrcodeScanner.prototype.getCameraPermissionButtonId = function() {
        return (0, $ccGEO.PublicUiElementIdAndClasses).CAMERA_PERMISSION_BUTTON_ID;
    };
    Html5QrcodeScanner.prototype.getCameraScanRegion = function() {
        return document.getElementById(this.getDashboardSectionCameraScanRegionId());
    };
    Html5QrcodeScanner.prototype.getDashboardSectionSwapLink = function() {
        return document.getElementById(this.getDashboardSectionSwapLinkId());
    };
    Html5QrcodeScanner.prototype.getHeaderMessageDiv = function() {
        return document.getElementById(this.getHeaderMessageContainerId());
    };
    return Html5QrcodeScanner;
}();

});
parcelRegister("3UFjS", function(module, exports) {

$parcel$export(module.exports, "ASSET_CAMERA_SCAN", () => $2d96a7499b03b291$export$be7b9b11efa99dbc);
$parcel$export(module.exports, "ASSET_FILE_SCAN", () => $2d96a7499b03b291$export$c97cd35b47589f30);
$parcel$export(module.exports, "ASSET_INFO_ICON_16PX", () => $2d96a7499b03b291$export$c5538664401ceea);
$parcel$export(module.exports, "ASSET_CLOSE_ICON_16PX", () => $2d96a7499b03b291$export$a9695a750cdd2270);
var $2d96a7499b03b291$var$SVG_XML_PREFIX = "data:image/svg+xml;base64,";
var $2d96a7499b03b291$export$be7b9b11efa99dbc = $2d96a7499b03b291$var$SVG_XML_PREFIX + "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";
var $2d96a7499b03b291$export$c97cd35b47589f30 = $2d96a7499b03b291$var$SVG_XML_PREFIX + "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1OS4wMTggNTkuMDE4IiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA1OS4wMTggNTkuMDE4IiB4bWw6c3BhY2U9InByZXNlcnZlIj48cGF0aCBkPSJtNTguNzQxIDU0LjgwOS01Ljk2OS02LjI0NGExMC43NCAxMC43NCAwIDAgMCAyLjgyLTcuMjVjMC01Ljk1My00Ljg0My0xMC43OTYtMTAuNzk2LTEwLjc5NlMzNCAzNS4zNjEgMzQgNDEuMzE0IDM4Ljg0MyA1Mi4xMSA0NC43OTYgNTIuMTFjMi40NDEgMCA0LjY4OC0uODI0IDYuNDk5LTIuMTk2bDYuMDAxIDYuMjc3YS45OTguOTk4IDAgMCAwIDEuNDE0LjAzMiAxIDEgMCAwIDAgLjAzMS0xLjQxNHpNMzYgNDEuMzE0YzAtNC44NSAzLjk0Ni04Ljc5NiA4Ljc5Ni04Ljc5NnM4Ljc5NiAzLjk0NiA4Ljc5NiA4Ljc5Ni0zLjk0NiA4Ljc5Ni04Ljc5NiA4Ljc5NlMzNiA0Ni4xNjQgMzYgNDEuMzE0ek0xMC40MzEgMTYuMDg4YzAgMy4wNyAyLjQ5OCA1LjU2OCA1LjU2OSA1LjU2OHM1LjU2OS0yLjQ5OCA1LjU2OS01LjU2OGMwLTMuMDcxLTIuNDk4LTUuNTY5LTUuNTY5LTUuNTY5cy01LjU2OSAyLjQ5OC01LjU2OSA1LjU2OXptOS4xMzggMGMwIDEuOTY4LTEuNjAyIDMuNTY4LTMuNTY5IDMuNTY4cy0zLjU2OS0xLjYwMS0zLjU2OS0zLjU2OCAxLjYwMi0zLjU2OSAzLjU2OS0zLjU2OSAzLjU2OSAxLjYwMSAzLjU2OSAzLjU2OXoiLz48cGF0aCBkPSJtMzAuODgyIDI4Ljk4NyA5LjE4LTEwLjA1NCAxMS4yNjIgMTAuMzIzYTEgMSAwIDAgMCAxLjM1MS0xLjQ3NWwtMTItMTFhMSAxIDAgMCAwLTEuNDE0LjA2M2wtOS43OTQgMTAuNzI3LTQuNzQzLTQuNzQzYTEuMDAzIDEuMDAzIDAgMCAwLTEuMzY4LS4wNDRMNi4zMzkgMzcuNzY4YTEgMSAwIDEgMCAxLjMyMiAxLjUwMWwxNi4zMTMtMTQuMzYyIDcuMzE5IDcuMzE4YS45OTkuOTk5IDAgMSAwIDEuNDE0LTEuNDE0bC0xLjgyNS0xLjgyNHoiLz48cGF0aCBkPSJNMzAgNDYuNTE4SDJ2LTQyaDU0djI4YTEgMSAwIDEgMCAyIDB2LTI5YTEgMSAwIDAgMC0xLTFIMWExIDEgMCAwIDAtMSAxdjQ0YTEgMSAwIDAgMCAxIDFoMjlhMSAxIDAgMSAwIDAtMnoiLz48L3N2Zz4=";
var $2d96a7499b03b291$export$c5538664401ceea = $2d96a7499b03b291$var$SVG_XML_PREFIX + "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0NjAgNDYwIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA0NjAgNDYwIiB4bWw6c3BhY2U9InByZXNlcnZlIj48cGF0aCBkPSJNMjMwIDBDMTAyLjk3NSAwIDAgMTAyLjk3NSAwIDIzMHMxMDIuOTc1IDIzMCAyMzAgMjMwIDIzMC0xMDIuOTc0IDIzMC0yMzBTMzU3LjAyNSAwIDIzMCAwem0zOC4zMzMgMzc3LjM2YzAgOC42NzYtNy4wMzQgMTUuNzEtMTUuNzEgMTUuNzFoLTQzLjEwMWMtOC42NzYgMC0xNS43MS03LjAzNC0xNS43MS0xNS43MVYyMDIuNDc3YzAtOC42NzYgNy4wMzMtMTUuNzEgMTUuNzEtMTUuNzFoNDMuMTAxYzguNjc2IDAgMTUuNzEgNy4wMzMgMTUuNzEgMTUuNzFWMzc3LjM2ek0yMzAgMTU3Yy0yMS41MzkgMC0zOS0xNy40NjEtMzktMzlzMTcuNDYxLTM5IDM5LTM5IDM5IDE3LjQ2MSAzOSAzOS0xNy40NjEgMzktMzkgMzl6Ii8+PC9zdmc+";
var $2d96a7499b03b291$export$a9695a750cdd2270 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAAQgAAAEIBarqQRAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAE1SURBVDiNfdI7S0NBEAXgLya1otFgpbYSbISAgpXYi6CmiH9KCAiChaVga6OiWPgfRDQ+0itaGVNosXtluWwcuMzePfM4M3sq8lbHBubwg1dc4m1E/J/N4ghDPOIsfk/4xiEao5KX0McFljN4C9d4QTPXuY99jP3DsIoDPGM6BY5i5yI5R7O4q+ImFkJY2DCh3cAH2klyB+9J1xUMMAG7eCh1a+Mr+k48b5diXrFVwwLuS+BJ9MfR7+G0FHOHhTHhnXNWS87VDF4pcnfQK4Ep7XScNLmPTZgURNKKYENYWDpzW1BhscS1WHS8CDgURFJQrWcoF3c13KKbgg1BYQfy8xZWEzTTw1QZbAoKu8FqJnktdu5hcVSHmchiILzzuaDQvjBzV2m8yohCE1jHfPx/xhU+y4G/D75ELlRJsSYAAAAASUVORK5CYII=";

});

parcelRegister("cmkKR", function(module, exports) {

$parcel$export(module.exports, "PersistedDataManager", () => $8ff7a39a5b475581$export$f4f7158604555024);
var $8ff7a39a5b475581$var$PersistedDataFactory = function() {
    function PersistedDataFactory() {}
    PersistedDataFactory.createDefault = function() {
        return {
            hasPermission: false,
            lastUsedCameraId: null
        };
    };
    return PersistedDataFactory;
}();
var $8ff7a39a5b475581$export$f4f7158604555024 = function() {
    function PersistedDataManager() {
        this.data = $8ff7a39a5b475581$var$PersistedDataFactory.createDefault();
        var data = localStorage.getItem(PersistedDataManager.LOCAL_STORAGE_KEY);
        if (!data) this.reset();
        else this.data = JSON.parse(data);
    }
    PersistedDataManager.prototype.hasCameraPermissions = function() {
        return this.data.hasPermission;
    };
    PersistedDataManager.prototype.getLastUsedCameraId = function() {
        return this.data.lastUsedCameraId;
    };
    PersistedDataManager.prototype.setHasPermission = function(hasPermission) {
        this.data.hasPermission = hasPermission;
        this.flush();
    };
    PersistedDataManager.prototype.setLastUsedCameraId = function(lastUsedCameraId) {
        this.data.lastUsedCameraId = lastUsedCameraId;
        this.flush();
    };
    PersistedDataManager.prototype.resetLastUsedCameraId = function() {
        this.data.lastUsedCameraId = null;
        this.flush();
    };
    PersistedDataManager.prototype.reset = function() {
        this.data = $8ff7a39a5b475581$var$PersistedDataFactory.createDefault();
        this.flush();
    };
    PersistedDataManager.prototype.flush = function() {
        localStorage.setItem(PersistedDataManager.LOCAL_STORAGE_KEY, JSON.stringify(this.data));
    };
    PersistedDataManager.LOCAL_STORAGE_KEY = "HTML5_QRCODE_DATA";
    return PersistedDataManager;
}();

});

parcelRegister("bAclF", function(module, exports) {

$parcel$export(module.exports, "LibraryInfoContainer", () => $86eca2a20a5cd14e$export$a2d0fe6d33028e31);

var $3UFjS = parcelRequire("3UFjS");

var $45mrT = parcelRequire("45mrT");
var $86eca2a20a5cd14e$var$LibraryInfoDiv = function() {
    function LibraryInfoDiv() {
        this.infoDiv = document.createElement("div");
    }
    LibraryInfoDiv.prototype.renderInto = function(parent) {
        this.infoDiv.style.position = "absolute";
        this.infoDiv.style.top = "10px";
        this.infoDiv.style.right = "10px";
        this.infoDiv.style.zIndex = "2";
        this.infoDiv.style.display = "none";
        this.infoDiv.style.padding = "5pt";
        this.infoDiv.style.border = "1px solid #171717";
        this.infoDiv.style.fontSize = "10pt";
        this.infoDiv.style.background = "rgb(0 0 0 / 69%)";
        this.infoDiv.style.borderRadius = "5px";
        this.infoDiv.style.textAlign = "center";
        this.infoDiv.style.fontWeight = "400";
        this.infoDiv.style.color = "white";
        this.infoDiv.innerText = (0, $45mrT.LibraryInfoStrings).poweredBy();
        var projectLink = document.createElement("a");
        projectLink.innerText = "ScanApp";
        projectLink.href = "https://scanapp.org";
        projectLink.target = "new";
        projectLink.style.color = "white";
        this.infoDiv.appendChild(projectLink);
        var breakElemFirst = document.createElement("br");
        var breakElemSecond = document.createElement("br");
        this.infoDiv.appendChild(breakElemFirst);
        this.infoDiv.appendChild(breakElemSecond);
        var reportIssueLink = document.createElement("a");
        reportIssueLink.innerText = (0, $45mrT.LibraryInfoStrings).reportIssues();
        reportIssueLink.href = "https://github.com/mebjas/html5-qrcode/issues";
        reportIssueLink.target = "new";
        reportIssueLink.style.color = "white";
        this.infoDiv.appendChild(reportIssueLink);
        parent.appendChild(this.infoDiv);
    };
    LibraryInfoDiv.prototype.show = function() {
        this.infoDiv.style.display = "block";
    };
    LibraryInfoDiv.prototype.hide = function() {
        this.infoDiv.style.display = "none";
    };
    return LibraryInfoDiv;
}();
var $86eca2a20a5cd14e$var$LibraryInfoIcon = function() {
    function LibraryInfoIcon(onTapIn, onTapOut) {
        this.isShowingInfoIcon = true;
        this.onTapIn = onTapIn;
        this.onTapOut = onTapOut;
        this.infoIcon = document.createElement("img");
    }
    LibraryInfoIcon.prototype.renderInto = function(parent) {
        var _this = this;
        this.infoIcon.alt = "Info icon";
        this.infoIcon.src = (0, $3UFjS.ASSET_INFO_ICON_16PX);
        this.infoIcon.style.position = "absolute";
        this.infoIcon.style.top = "4px";
        this.infoIcon.style.right = "4px";
        this.infoIcon.style.opacity = "0.6";
        this.infoIcon.style.cursor = "pointer";
        this.infoIcon.style.zIndex = "2";
        this.infoIcon.style.width = "16px";
        this.infoIcon.style.height = "16px";
        this.infoIcon.onmouseover = function(_) {
            return _this.onHoverIn();
        };
        this.infoIcon.onmouseout = function(_) {
            return _this.onHoverOut();
        };
        this.infoIcon.onclick = function(_) {
            return _this.onClick();
        };
        parent.appendChild(this.infoIcon);
    };
    LibraryInfoIcon.prototype.onHoverIn = function() {
        if (this.isShowingInfoIcon) this.infoIcon.style.opacity = "1";
    };
    LibraryInfoIcon.prototype.onHoverOut = function() {
        if (this.isShowingInfoIcon) this.infoIcon.style.opacity = "0.6";
    };
    LibraryInfoIcon.prototype.onClick = function() {
        if (this.isShowingInfoIcon) {
            this.isShowingInfoIcon = false;
            this.onTapIn();
            this.infoIcon.src = (0, $3UFjS.ASSET_CLOSE_ICON_16PX);
            this.infoIcon.style.opacity = "1";
        } else {
            this.isShowingInfoIcon = true;
            this.onTapOut();
            this.infoIcon.src = (0, $3UFjS.ASSET_INFO_ICON_16PX);
            this.infoIcon.style.opacity = "0.6";
        }
    };
    return LibraryInfoIcon;
}();
var $86eca2a20a5cd14e$export$a2d0fe6d33028e31 = function() {
    function LibraryInfoContainer() {
        var _this = this;
        this.infoDiv = new $86eca2a20a5cd14e$var$LibraryInfoDiv();
        this.infoIcon = new $86eca2a20a5cd14e$var$LibraryInfoIcon(function() {
            _this.infoDiv.show();
        }, function() {
            _this.infoDiv.hide();
        });
    }
    LibraryInfoContainer.prototype.renderInto = function(parent) {
        this.infoDiv.renderInto(parent);
        this.infoIcon.renderInto(parent);
    };
    return LibraryInfoContainer;
}();

});

parcelRegister("jaJWv", function(module, exports) {

$parcel$export(module.exports, "CameraPermissions", () => $df5296c27cb134c5$export$693eae80963d557e);
var $df5296c27cb134c5$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $df5296c27cb134c5$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $df5296c27cb134c5$export$693eae80963d557e = function() {
    function CameraPermissions() {}
    CameraPermissions.hasPermissions = function() {
        return $df5296c27cb134c5$var$__awaiter(this, void 0, void 0, function() {
            var devices, _i, devices_1, device;
            return $df5296c27cb134c5$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4,
                            navigator.mediaDevices.enumerateDevices()
                        ];
                    case 1:
                        devices = _a.sent();
                        for(_i = 0, devices_1 = devices; _i < devices_1.length; _i++){
                            device = devices_1[_i];
                            if (device.kind === "videoinput" && device.label) return [
                                2,
                                true
                            ];
                        }
                        return [
                            2,
                            false
                        ];
                }
            });
        });
    };
    return CameraPermissions;
}();

});

parcelRegister("6R5ZT", function(module, exports) {

$parcel$export(module.exports, "ScanTypeSelector", () => $4fdc584216328e1c$export$528d36479c095a59);

var $a3hi8 = parcelRequire("a3hi8");
var $4fdc584216328e1c$export$528d36479c095a59 = function() {
    function ScanTypeSelector(supportedScanTypes) {
        this.supportedScanTypes = this.validateAndReturnScanTypes(supportedScanTypes);
    }
    ScanTypeSelector.prototype.getDefaultScanType = function() {
        return this.supportedScanTypes[0];
    };
    ScanTypeSelector.prototype.hasMoreThanOneScanType = function() {
        return this.supportedScanTypes.length > 1;
    };
    ScanTypeSelector.prototype.isCameraScanRequired = function() {
        for(var _i = 0, _a = this.supportedScanTypes; _i < _a.length; _i++){
            var scanType = _a[_i];
            if (ScanTypeSelector.isCameraScanType(scanType)) return true;
        }
        return false;
    };
    ScanTypeSelector.isCameraScanType = function(scanType) {
        return scanType === (0, $a3hi8.Html5QrcodeScanType).SCAN_TYPE_CAMERA;
    };
    ScanTypeSelector.isFileScanType = function(scanType) {
        return scanType === (0, $a3hi8.Html5QrcodeScanType).SCAN_TYPE_FILE;
    };
    ScanTypeSelector.prototype.validateAndReturnScanTypes = function(supportedScanTypes) {
        if (!supportedScanTypes || supportedScanTypes.length === 0) return (0, $a3hi8.Html5QrcodeConstants).DEFAULT_SUPPORTED_SCAN_TYPE;
        var maxExpectedValues = (0, $a3hi8.Html5QrcodeConstants).DEFAULT_SUPPORTED_SCAN_TYPE.length;
        if (supportedScanTypes.length > maxExpectedValues) throw "Max ".concat(maxExpectedValues, " values expected for ") + "supportedScanTypes";
        for(var _i = 0, supportedScanTypes_1 = supportedScanTypes; _i < supportedScanTypes_1.length; _i++){
            var scanType = supportedScanTypes_1[_i];
            if (!(0, $a3hi8.Html5QrcodeConstants).DEFAULT_SUPPORTED_SCAN_TYPE.includes(scanType)) throw "Unsupported scan type ".concat(scanType);
        }
        return supportedScanTypes;
    };
    return ScanTypeSelector;
}();

});

parcelRegister("h4YAq", function(module, exports) {

$parcel$export(module.exports, "TorchButton", () => $c6f1cea0bd3aadd9$export$11856eebe9d443c6);

var $45mrT = parcelRequire("45mrT");

var $ccGEO = parcelRequire("ccGEO");
var $c6f1cea0bd3aadd9$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $c6f1cea0bd3aadd9$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $c6f1cea0bd3aadd9$var$TorchController = function() {
    function TorchController(torchCapability, buttonController, onTorchActionFailureCallback) {
        this.isTorchOn = false;
        this.torchCapability = torchCapability;
        this.buttonController = buttonController;
        this.onTorchActionFailureCallback = onTorchActionFailureCallback;
    }
    TorchController.prototype.isTorchEnabled = function() {
        return this.isTorchOn;
    };
    TorchController.prototype.flipState = function() {
        return $c6f1cea0bd3aadd9$var$__awaiter(this, void 0, void 0, function() {
            var isTorchOnExpected, error_1;
            return $c6f1cea0bd3aadd9$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.buttonController.disable();
                        isTorchOnExpected = !this.isTorchOn;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            this.torchCapability.apply(isTorchOnExpected)
                        ];
                    case 2:
                        _a.sent();
                        this.updateUiBasedOnLatestSettings(this.torchCapability.value(), isTorchOnExpected);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error_1 = _a.sent();
                        this.propagateFailure(isTorchOnExpected, error_1);
                        this.buttonController.enable();
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
    };
    TorchController.prototype.updateUiBasedOnLatestSettings = function(isTorchOn, isTorchOnExpected) {
        if (isTorchOn === isTorchOnExpected) {
            this.buttonController.setText(isTorchOnExpected ? (0, $45mrT.Html5QrcodeScannerStrings).torchOffButton() : (0, $45mrT.Html5QrcodeScannerStrings).torchOnButton());
            this.isTorchOn = isTorchOnExpected;
        } else this.propagateFailure(isTorchOnExpected);
        this.buttonController.enable();
    };
    TorchController.prototype.propagateFailure = function(isTorchOnExpected, error) {
        var errorMessage = isTorchOnExpected ? (0, $45mrT.Html5QrcodeScannerStrings).torchOnFailedMessage() : (0, $45mrT.Html5QrcodeScannerStrings).torchOffFailedMessage();
        if (error) errorMessage += "; Error = " + error;
        this.onTorchActionFailureCallback(errorMessage);
    };
    TorchController.prototype.reset = function() {
        this.isTorchOn = false;
    };
    return TorchController;
}();
var $c6f1cea0bd3aadd9$export$11856eebe9d443c6 = function() {
    function TorchButton(torchCapability, onTorchActionFailureCallback) {
        this.onTorchActionFailureCallback = onTorchActionFailureCallback;
        this.torchButton = (0, $ccGEO.BaseUiElementFactory).createElement("button", (0, $ccGEO.PublicUiElementIdAndClasses).TORCH_BUTTON_ID);
        this.torchController = new $c6f1cea0bd3aadd9$var$TorchController(torchCapability, this, onTorchActionFailureCallback);
    }
    TorchButton.prototype.render = function(parentElement, torchButtonOptions) {
        var _this = this;
        this.torchButton.innerText = (0, $45mrT.Html5QrcodeScannerStrings).torchOnButton();
        this.torchButton.style.display = torchButtonOptions.display;
        this.torchButton.style.marginLeft = torchButtonOptions.marginLeft;
        var $this = this;
        this.torchButton.addEventListener("click", function(_) {
            return $c6f1cea0bd3aadd9$var$__awaiter(_this, void 0, void 0, function() {
                return $c6f1cea0bd3aadd9$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4,
                                $this.torchController.flipState()
                            ];
                        case 1:
                            _a.sent();
                            if ($this.torchController.isTorchEnabled()) {
                                $this.torchButton.classList.remove((0, $ccGEO.PublicUiElementIdAndClasses).TORCH_BUTTON_CLASS_TORCH_OFF);
                                $this.torchButton.classList.add((0, $ccGEO.PublicUiElementIdAndClasses).TORCH_BUTTON_CLASS_TORCH_ON);
                            } else {
                                $this.torchButton.classList.remove((0, $ccGEO.PublicUiElementIdAndClasses).TORCH_BUTTON_CLASS_TORCH_ON);
                                $this.torchButton.classList.add((0, $ccGEO.PublicUiElementIdAndClasses).TORCH_BUTTON_CLASS_TORCH_OFF);
                            }
                            return [
                                2
                            ];
                    }
                });
            });
        });
        parentElement.appendChild(this.torchButton);
    };
    TorchButton.prototype.updateTorchCapability = function(torchCapability) {
        this.torchController = new $c6f1cea0bd3aadd9$var$TorchController(torchCapability, this, this.onTorchActionFailureCallback);
    };
    TorchButton.prototype.getTorchButton = function() {
        return this.torchButton;
    };
    TorchButton.prototype.hide = function() {
        this.torchButton.style.display = "none";
    };
    TorchButton.prototype.show = function() {
        this.torchButton.style.display = "inline-block";
    };
    TorchButton.prototype.disable = function() {
        this.torchButton.disabled = true;
    };
    TorchButton.prototype.enable = function() {
        this.torchButton.disabled = false;
    };
    TorchButton.prototype.setText = function(text) {
        this.torchButton.innerText = text;
    };
    TorchButton.prototype.reset = function() {
        this.torchButton.innerText = (0, $45mrT.Html5QrcodeScannerStrings).torchOnButton();
        this.torchController.reset();
    };
    TorchButton.create = function(parentElement, torchCapability, torchButtonOptions, onTorchActionFailureCallback) {
        var button = new TorchButton(torchCapability, onTorchActionFailureCallback);
        button.render(parentElement, torchButtonOptions);
        return button;
    };
    return TorchButton;
}();

});
parcelRegister("ccGEO", function(module, exports) {

$parcel$export(module.exports, "PublicUiElementIdAndClasses", () => $8e27b1d9e0ec19fc$export$5263f2f87e9ad375);
$parcel$export(module.exports, "BaseUiElementFactory", () => $8e27b1d9e0ec19fc$export$6a3443a184593c5);
var $8e27b1d9e0ec19fc$export$5263f2f87e9ad375 = function() {
    function PublicUiElementIdAndClasses() {}
    PublicUiElementIdAndClasses.ALL_ELEMENT_CLASS = "html5-qrcode-element";
    PublicUiElementIdAndClasses.CAMERA_PERMISSION_BUTTON_ID = "html5-qrcode-button-camera-permission";
    PublicUiElementIdAndClasses.CAMERA_START_BUTTON_ID = "html5-qrcode-button-camera-start";
    PublicUiElementIdAndClasses.CAMERA_STOP_BUTTON_ID = "html5-qrcode-button-camera-stop";
    PublicUiElementIdAndClasses.TORCH_BUTTON_ID = "html5-qrcode-button-torch";
    PublicUiElementIdAndClasses.CAMERA_SELECTION_SELECT_ID = "html5-qrcode-select-camera";
    PublicUiElementIdAndClasses.FILE_SELECTION_BUTTON_ID = "html5-qrcode-button-file-selection";
    PublicUiElementIdAndClasses.ZOOM_SLIDER_ID = "html5-qrcode-input-range-zoom";
    PublicUiElementIdAndClasses.SCAN_TYPE_CHANGE_ANCHOR_ID = "html5-qrcode-anchor-scan-type-change";
    PublicUiElementIdAndClasses.TORCH_BUTTON_CLASS_TORCH_ON = "html5-qrcode-button-torch-on";
    PublicUiElementIdAndClasses.TORCH_BUTTON_CLASS_TORCH_OFF = "html5-qrcode-button-torch-off";
    return PublicUiElementIdAndClasses;
}();
var $8e27b1d9e0ec19fc$export$6a3443a184593c5 = function() {
    function BaseUiElementFactory() {}
    BaseUiElementFactory.createElement = function(elementType, elementId) {
        var element = document.createElement(elementType);
        element.id = elementId;
        element.classList.add($8e27b1d9e0ec19fc$export$5263f2f87e9ad375.ALL_ELEMENT_CLASS);
        if (elementType === "button") element.setAttribute("type", "button");
        return element;
    };
    return BaseUiElementFactory;
}();

});


parcelRegister("d2L5r", function(module, exports) {

$parcel$export(module.exports, "FileSelectionUi", () => $97effcb968b8dd3b$export$bb6f0d5a8973d33);

var $45mrT = parcelRequire("45mrT");

var $ccGEO = parcelRequire("ccGEO");
var $97effcb968b8dd3b$export$bb6f0d5a8973d33 = function() {
    function FileSelectionUi(parentElement, showOnRender, onFileSelected) {
        this.fileBasedScanRegion = this.createFileBasedScanRegion();
        this.fileBasedScanRegion.style.display = showOnRender ? "block" : "none";
        parentElement.appendChild(this.fileBasedScanRegion);
        var fileScanLabel = document.createElement("label");
        fileScanLabel.setAttribute("for", this.getFileScanInputId());
        fileScanLabel.style.display = "inline-block";
        this.fileBasedScanRegion.appendChild(fileScanLabel);
        this.fileSelectionButton = (0, $ccGEO.BaseUiElementFactory).createElement("button", (0, $ccGEO.PublicUiElementIdAndClasses).FILE_SELECTION_BUTTON_ID);
        this.setInitialValueToButton();
        this.fileSelectionButton.addEventListener("click", function(_) {
            fileScanLabel.click();
        });
        fileScanLabel.append(this.fileSelectionButton);
        this.fileScanInput = (0, $ccGEO.BaseUiElementFactory).createElement("input", this.getFileScanInputId());
        this.fileScanInput.type = "file";
        this.fileScanInput.accept = "image/*";
        this.fileScanInput.style.display = "none";
        fileScanLabel.appendChild(this.fileScanInput);
        var $this = this;
        this.fileScanInput.addEventListener("change", function(e) {
            if (e == null || e.target == null) return;
            var target = e.target;
            if (target.files && target.files.length === 0) return;
            var fileList = target.files;
            var file = fileList[0];
            var fileName = file.name;
            $this.setImageNameToButton(fileName);
            onFileSelected(file);
        });
        var dragAndDropMessage = this.createDragAndDropMessage();
        this.fileBasedScanRegion.appendChild(dragAndDropMessage);
        this.fileBasedScanRegion.addEventListener("dragenter", function(event) {
            $this.fileBasedScanRegion.style.border = $this.fileBasedScanRegionActiveBorder();
            event.stopPropagation();
            event.preventDefault();
        });
        this.fileBasedScanRegion.addEventListener("dragleave", function(event) {
            $this.fileBasedScanRegion.style.border = $this.fileBasedScanRegionDefaultBorder();
            event.stopPropagation();
            event.preventDefault();
        });
        this.fileBasedScanRegion.addEventListener("dragover", function(event) {
            $this.fileBasedScanRegion.style.border = $this.fileBasedScanRegionActiveBorder();
            event.stopPropagation();
            event.preventDefault();
        });
        this.fileBasedScanRegion.addEventListener("drop", function(event) {
            event.stopPropagation();
            event.preventDefault();
            $this.fileBasedScanRegion.style.border = $this.fileBasedScanRegionDefaultBorder();
            var dataTransfer = event.dataTransfer;
            if (dataTransfer) {
                var files = dataTransfer.files;
                if (!files || files.length === 0) return;
                var isAnyFileImage = false;
                for(var i = 0; i < files.length; ++i){
                    var file = files.item(i);
                    if (!file) continue;
                    var imageType = /image.*/;
                    if (!file.type.match(imageType)) continue;
                    isAnyFileImage = true;
                    var fileName = file.name;
                    $this.setImageNameToButton(fileName);
                    onFileSelected(file);
                    dragAndDropMessage.innerText = (0, $45mrT.Html5QrcodeScannerStrings).dragAndDropMessage();
                    break;
                }
                if (!isAnyFileImage) dragAndDropMessage.innerText = (0, $45mrT.Html5QrcodeScannerStrings).dragAndDropMessageOnlyImages();
            }
        });
    }
    FileSelectionUi.prototype.hide = function() {
        this.fileBasedScanRegion.style.display = "none";
        this.fileScanInput.disabled = true;
    };
    FileSelectionUi.prototype.show = function() {
        this.fileBasedScanRegion.style.display = "block";
        this.fileScanInput.disabled = false;
    };
    FileSelectionUi.prototype.isShowing = function() {
        return this.fileBasedScanRegion.style.display === "block";
    };
    FileSelectionUi.prototype.resetValue = function() {
        this.fileScanInput.value = "";
        this.setInitialValueToButton();
    };
    FileSelectionUi.prototype.createFileBasedScanRegion = function() {
        var fileBasedScanRegion = document.createElement("div");
        fileBasedScanRegion.style.textAlign = "center";
        fileBasedScanRegion.style.margin = "auto";
        fileBasedScanRegion.style.width = "80%";
        fileBasedScanRegion.style.maxWidth = "600px";
        fileBasedScanRegion.style.border = this.fileBasedScanRegionDefaultBorder();
        fileBasedScanRegion.style.padding = "10px";
        fileBasedScanRegion.style.marginBottom = "10px";
        return fileBasedScanRegion;
    };
    FileSelectionUi.prototype.fileBasedScanRegionDefaultBorder = function() {
        return "6px dashed #ebebeb";
    };
    FileSelectionUi.prototype.fileBasedScanRegionActiveBorder = function() {
        return "6px dashed rgb(153 151 151)";
    };
    FileSelectionUi.prototype.createDragAndDropMessage = function() {
        var dragAndDropMessage = document.createElement("div");
        dragAndDropMessage.innerText = (0, $45mrT.Html5QrcodeScannerStrings).dragAndDropMessage();
        dragAndDropMessage.style.fontWeight = "400";
        return dragAndDropMessage;
    };
    FileSelectionUi.prototype.setImageNameToButton = function(imageFileName) {
        var MAX_CHARS = 20;
        if (imageFileName.length > MAX_CHARS) {
            var start8Chars = imageFileName.substring(0, 8);
            var length_1 = imageFileName.length;
            var last8Chars = imageFileName.substring(length_1 - 8, length_1);
            imageFileName = "".concat(start8Chars, "....").concat(last8Chars);
        }
        var newText = (0, $45mrT.Html5QrcodeScannerStrings).fileSelectionChooseAnother() + " - " + imageFileName;
        this.fileSelectionButton.innerText = newText;
    };
    FileSelectionUi.prototype.setInitialValueToButton = function() {
        var initialText = (0, $45mrT.Html5QrcodeScannerStrings).fileSelectionChooseImage() + " - " + (0, $45mrT.Html5QrcodeScannerStrings).fileSelectionNoImageSelected();
        this.fileSelectionButton.innerText = initialText;
    };
    FileSelectionUi.prototype.getFileScanInputId = function() {
        return "html5-qrcode-private-filescan-input";
    };
    FileSelectionUi.create = function(parentElement, showOnRender, onFileSelected) {
        var button = new FileSelectionUi(parentElement, showOnRender, onFileSelected);
        return button;
    };
    return FileSelectionUi;
}();

});

parcelRegister("jY6p9", function(module, exports) {

$parcel$export(module.exports, "CameraSelectionUi", () => $e89896bf092653c6$export$86c8efd5b3ebd03e);

var $ccGEO = parcelRequire("ccGEO");

var $45mrT = parcelRequire("45mrT");
var $e89896bf092653c6$export$86c8efd5b3ebd03e = function() {
    function CameraSelectionUi(cameras) {
        this.selectElement = (0, $ccGEO.BaseUiElementFactory).createElement("select", (0, $ccGEO.PublicUiElementIdAndClasses).CAMERA_SELECTION_SELECT_ID);
        this.cameras = cameras;
        this.options = [];
    }
    CameraSelectionUi.prototype.render = function(parentElement) {
        var cameraSelectionContainer = document.createElement("span");
        cameraSelectionContainer.style.marginRight = "10px";
        var numCameras = this.cameras.length;
        if (numCameras === 0) throw new Error("No cameras found");
        if (numCameras === 1) cameraSelectionContainer.style.display = "none";
        else {
            var selectCameraString = (0, $45mrT.Html5QrcodeScannerStrings).selectCamera();
            cameraSelectionContainer.innerText = "".concat(selectCameraString, " (").concat(this.cameras.length, ")  ");
        }
        var anonymousCameraId = 1;
        for(var _i = 0, _a = this.cameras; _i < _a.length; _i++){
            var camera = _a[_i];
            var value = camera.id;
            var name_1 = camera.label == null ? value : camera.label;
            if (!name_1 || name_1 === "") name_1 = [
                (0, $45mrT.Html5QrcodeScannerStrings).anonymousCameraPrefix(),
                anonymousCameraId++
            ].join(" ");
            var option = document.createElement("option");
            option.value = value;
            option.innerText = name_1;
            this.options.push(option);
            this.selectElement.appendChild(option);
        }
        cameraSelectionContainer.appendChild(this.selectElement);
        parentElement.appendChild(cameraSelectionContainer);
    };
    CameraSelectionUi.prototype.disable = function() {
        this.selectElement.disabled = true;
    };
    CameraSelectionUi.prototype.isDisabled = function() {
        return this.selectElement.disabled === true;
    };
    CameraSelectionUi.prototype.enable = function() {
        this.selectElement.disabled = false;
    };
    CameraSelectionUi.prototype.getValue = function() {
        return this.selectElement.value;
    };
    CameraSelectionUi.prototype.hasValue = function(value) {
        for(var _i = 0, _a = this.options; _i < _a.length; _i++){
            var option = _a[_i];
            if (option.value === value) return true;
        }
        return false;
    };
    CameraSelectionUi.prototype.setValue = function(value) {
        if (!this.hasValue(value)) throw new Error("".concat(value, " is not present in the camera list."));
        this.selectElement.value = value;
    };
    CameraSelectionUi.prototype.hasSingleItem = function() {
        return this.cameras.length === 1;
    };
    CameraSelectionUi.prototype.numCameras = function() {
        return this.cameras.length;
    };
    CameraSelectionUi.create = function(parentElement, cameras) {
        var cameraSelectUi = new CameraSelectionUi(cameras);
        cameraSelectUi.render(parentElement);
        return cameraSelectUi;
    };
    return CameraSelectionUi;
}();

});

parcelRegister("5b9Ca", function(module, exports) {

$parcel$export(module.exports, "CameraZoomUi", () => $3c55701d61474f4c$export$2e993d10f166e456);

var $ccGEO = parcelRequire("ccGEO");

var $45mrT = parcelRequire("45mrT");
var $3c55701d61474f4c$export$2e993d10f166e456 = function() {
    function CameraZoomUi() {
        this.onChangeCallback = null;
        this.zoomElementContainer = document.createElement("div");
        this.rangeInput = (0, $ccGEO.BaseUiElementFactory).createElement("input", (0, $ccGEO.PublicUiElementIdAndClasses).ZOOM_SLIDER_ID);
        this.rangeInput.type = "range";
        this.rangeText = document.createElement("span");
        this.rangeInput.min = "1";
        this.rangeInput.max = "5";
        this.rangeInput.value = "1";
        this.rangeInput.step = "0.1";
    }
    CameraZoomUi.prototype.render = function(parentElement, renderOnCreate) {
        this.zoomElementContainer.style.display = renderOnCreate ? "block" : "none";
        this.zoomElementContainer.style.padding = "5px 10px";
        this.zoomElementContainer.style.textAlign = "center";
        parentElement.appendChild(this.zoomElementContainer);
        this.rangeInput.style.display = "inline-block";
        this.rangeInput.style.width = "50%";
        this.rangeInput.style.height = "5px";
        this.rangeInput.style.background = "#d3d3d3";
        this.rangeInput.style.outline = "none";
        this.rangeInput.style.opacity = "0.7";
        var zoomString = (0, $45mrT.Html5QrcodeScannerStrings).zoom();
        this.rangeText.innerText = "".concat(this.rangeInput.value, "x ").concat(zoomString);
        this.rangeText.style.marginRight = "10px";
        var $this = this;
        this.rangeInput.addEventListener("input", function() {
            return $this.onValueChange();
        });
        this.rangeInput.addEventListener("change", function() {
            return $this.onValueChange();
        });
        this.zoomElementContainer.appendChild(this.rangeInput);
        this.zoomElementContainer.appendChild(this.rangeText);
    };
    CameraZoomUi.prototype.onValueChange = function() {
        var zoomString = (0, $45mrT.Html5QrcodeScannerStrings).zoom();
        this.rangeText.innerText = "".concat(this.rangeInput.value, "x ").concat(zoomString);
        if (this.onChangeCallback) this.onChangeCallback(parseFloat(this.rangeInput.value));
    };
    CameraZoomUi.prototype.setValues = function(minValue, maxValue, defaultValue, step) {
        this.rangeInput.min = minValue.toString();
        this.rangeInput.max = maxValue.toString();
        this.rangeInput.step = step.toString();
        this.rangeInput.value = defaultValue.toString();
        this.onValueChange();
    };
    CameraZoomUi.prototype.show = function() {
        this.zoomElementContainer.style.display = "block";
    };
    CameraZoomUi.prototype.hide = function() {
        this.zoomElementContainer.style.display = "none";
    };
    CameraZoomUi.prototype.setOnCameraZoomValueChangeCallback = function(onChangeCallback) {
        this.onChangeCallback = onChangeCallback;
    };
    CameraZoomUi.prototype.removeOnCameraZoomValueChangeCallback = function() {
        this.onChangeCallback = null;
    };
    CameraZoomUi.create = function(parentElement, renderOnCreate) {
        var cameraZoomUi = new CameraZoomUi();
        cameraZoomUi.render(parentElement, renderOnCreate);
        return cameraZoomUi;
    };
    return CameraZoomUi;
}();

});




parcelRegister("gIoAf", function(module, exports) {
module.exports = import("cSwnE").then(()=>parcelRequire('ahvFp'));

});

parcelRegister("7IZbQ", function(module, exports) {
module.exports = import("3gZp0").then(()=>parcelRequire('9i68Q'));

});

parcelRegister("cyPaV", function(module, exports) {

$parcel$export(module.exports, "Directory", () => $92505b5d1ea04cf3$export$1dbf9926a0d54d98);
$parcel$export(module.exports, "Encoding", () => $92505b5d1ea04cf3$export$72958ca7c468c63b);
var $92505b5d1ea04cf3$export$1dbf9926a0d54d98;
(function(Directory) {
    /**
     * The Documents directory.
     * On iOS it's the app's documents directory.
     * Use this directory to store user-generated content.
     * On Android it's the Public Documents folder, so it's accessible from other apps.
     * It's not accessible on Android 10 unless the app enables legacy External Storage
     * by adding `android:requestLegacyExternalStorage="true"` in the `application` tag
     * in the `AndroidManifest.xml`.
     * On Android 11 or newer the app can only access the files/folders the app created.
     *
     * @since 1.0.0
     */ Directory["Documents"] = "DOCUMENTS";
    /**
     * The Data directory.
     * On iOS it will use the Documents directory.
     * On Android it's the directory holding application files.
     * Files will be deleted when the application is uninstalled.
     *
     * @since 1.0.0
     */ Directory["Data"] = "DATA";
    /**
     * The Library directory.
     * On iOS it will use the Library directory.
     * On Android it's the directory holding application files.
     * Files will be deleted when the application is uninstalled.
     *
     * @since 1.1.0
     */ Directory["Library"] = "LIBRARY";
    /**
     * The Cache directory.
     * Can be deleted in cases of low memory, so use this directory to write app-specific files.
     * that your app can re-create easily.
     *
     * @since 1.0.0
     */ Directory["Cache"] = "CACHE";
    /**
     * The external directory.
     * On iOS it will use the Documents directory.
     * On Android it's the directory on the primary shared/external
     * storage device where the application can place persistent files it owns.
     * These files are internal to the applications, and not typically visible
     * to the user as media.
     * Files will be deleted when the application is uninstalled.
     *
     * @since 1.0.0
     */ Directory["External"] = "EXTERNAL";
    /**
     * The external storage directory.
     * On iOS it will use the Documents directory.
     * On Android it's the primary shared/external storage directory.
     * It's not accessible on Android 10 unless the app enables legacy External Storage
     * by adding `android:requestLegacyExternalStorage="true"` in the `application` tag
     * in the `AndroidManifest.xml`.
     * It's not accessible on Android 11 or newer.
     *
     * @since 1.0.0
     */ Directory["ExternalStorage"] = "EXTERNAL_STORAGE";
    /**
     * The external cache directory.
     * On iOS it will use the Documents directory.
     * On Android it's the primary shared/external cache.
     *
     * @since 7.1.0
     */ Directory["ExternalCache"] = "EXTERNAL_CACHE";
    /**
     * The Library directory without cloud backup. Used in iOS.
     * On Android it's the directory holding application files.
     *
     * @since 7.1.0
     */ Directory["LibraryNoCloud"] = "LIBRARY_NO_CLOUD";
    /**
     * A temporary directory for iOS.
     * On Android it's the directory holding the application cache.
     *
     * @since 7.1.0
     */ Directory["Temporary"] = "TEMPORARY";
})($92505b5d1ea04cf3$export$1dbf9926a0d54d98 || ($92505b5d1ea04cf3$export$1dbf9926a0d54d98 = {}));
var $92505b5d1ea04cf3$export$72958ca7c468c63b;
(function(Encoding) {
    /**
     * Eight-bit UCS Transformation Format
     *
     * @since 1.0.0
     */ Encoding["UTF8"] = "utf8";
    /**
     * Seven-bit ASCII, a.k.a. ISO646-US, a.k.a. the Basic Latin block of the
     * Unicode character set
     * This encoding is only supported on Android.
     *
     * @since 1.0.0
     */ Encoding["ASCII"] = "ascii";
    /**
     * Sixteen-bit UCS Transformation Format, byte order identified by an
     * optional byte-order mark
     * This encoding is only supported on Android.
     *
     * @since 1.0.0
     */ Encoding["UTF16"] = "utf16";
})($92505b5d1ea04cf3$export$72958ca7c468c63b || ($92505b5d1ea04cf3$export$72958ca7c468c63b = {}));
const $92505b5d1ea04cf3$export$861052fb7011ee8d = $92505b5d1ea04cf3$export$1dbf9926a0d54d98;
const $92505b5d1ea04cf3$export$e3c47a378cd87a52 = $92505b5d1ea04cf3$export$72958ca7c468c63b;

});

parcelRegister("jj2K8", function(module, exports) {
module.exports = import("ixm1c").then(()=>parcelRequire('4J8NU'));

});

parcelRegister("6jpYe", function(module, exports) {
module.exports = import("grCGO").then(()=>parcelRequire('3LwSL'));

});


var $gJCIb = parcelRequire("gJCIb");
/// <reference types="@capacitor/cli" />



const $e5872e05a705af44$export$8717f78bb40a9548 = (0, $gJCIb.registerPlugin)('SplashScreen', {
    web: ()=>(parcelRequire("jcSJO")).then((m)=>new m.SplashScreenWeb())
});









// This file consistently uses `let` keyword instead of `const` for reducing the bundle size.
// Global variables - aliasing some builtin symbols to reduce the bundle size.
let $259ccf8ca7c2ca99$var$protoOf = Object.getPrototypeOf;
let $259ccf8ca7c2ca99$var$changedStates, $259ccf8ca7c2ca99$var$derivedStates, $259ccf8ca7c2ca99$var$curDeps, $259ccf8ca7c2ca99$var$curNewDerives, $259ccf8ca7c2ca99$var$alwaysConnectedDom = {
    isConnected: 1
};
let $259ccf8ca7c2ca99$var$gcCycleInMs = 1000, $259ccf8ca7c2ca99$var$statesToGc, $259ccf8ca7c2ca99$var$propSetterCache = {};
let $259ccf8ca7c2ca99$var$objProto = $259ccf8ca7c2ca99$var$protoOf($259ccf8ca7c2ca99$var$alwaysConnectedDom), $259ccf8ca7c2ca99$var$funcProto = $259ccf8ca7c2ca99$var$protoOf($259ccf8ca7c2ca99$var$protoOf), $259ccf8ca7c2ca99$var$_undefined;
let $259ccf8ca7c2ca99$var$addAndScheduleOnFirst = (set, s, f, waitMs)=>(set ?? (setTimeout(f, waitMs), new Set)).add(s);
let $259ccf8ca7c2ca99$var$runAndCaptureDeps = (f, deps, arg)=>{
    let prevDeps = $259ccf8ca7c2ca99$var$curDeps;
    $259ccf8ca7c2ca99$var$curDeps = deps;
    try {
        return f(arg);
    } catch (e) {
        console.error(e);
        return arg;
    } finally{
        $259ccf8ca7c2ca99$var$curDeps = prevDeps;
    }
};
let $259ccf8ca7c2ca99$var$keepConnected = (l)=>l.filter((b)=>b._dom?.isConnected);
let $259ccf8ca7c2ca99$var$addStatesToGc = (d)=>$259ccf8ca7c2ca99$var$statesToGc = $259ccf8ca7c2ca99$var$addAndScheduleOnFirst($259ccf8ca7c2ca99$var$statesToGc, d, ()=>{
        for (let s of $259ccf8ca7c2ca99$var$statesToGc)s._bindings = $259ccf8ca7c2ca99$var$keepConnected(s._bindings), s._listeners = $259ccf8ca7c2ca99$var$keepConnected(s._listeners);
        $259ccf8ca7c2ca99$var$statesToGc = $259ccf8ca7c2ca99$var$_undefined;
    }, $259ccf8ca7c2ca99$var$gcCycleInMs);
let $259ccf8ca7c2ca99$var$stateProto = {
    get val () {
        $259ccf8ca7c2ca99$var$curDeps?._getters?.add(this);
        return this.rawVal;
    },
    get oldVal () {
        $259ccf8ca7c2ca99$var$curDeps?._getters?.add(this);
        return this._oldVal;
    },
    set val (v){
        $259ccf8ca7c2ca99$var$curDeps?._setters?.add(this);
        if (v !== this.rawVal) {
            this.rawVal = v;
            this._bindings.length + this._listeners.length ? ($259ccf8ca7c2ca99$var$derivedStates?.add(this), $259ccf8ca7c2ca99$var$changedStates = $259ccf8ca7c2ca99$var$addAndScheduleOnFirst($259ccf8ca7c2ca99$var$changedStates, this, $259ccf8ca7c2ca99$var$updateDoms)) : this._oldVal = v;
        }
    }
};
let $259ccf8ca7c2ca99$var$state = (initVal)=>({
        __proto__: $259ccf8ca7c2ca99$var$stateProto,
        rawVal: initVal,
        _oldVal: initVal,
        _bindings: [],
        _listeners: []
    });
let $259ccf8ca7c2ca99$var$bind = (f, dom)=>{
    let deps = {
        _getters: new Set,
        _setters: new Set
    }, binding = {
        f: f
    }, prevNewDerives = $259ccf8ca7c2ca99$var$curNewDerives;
    $259ccf8ca7c2ca99$var$curNewDerives = [];
    let newDom = $259ccf8ca7c2ca99$var$runAndCaptureDeps(f, deps, dom);
    newDom = (newDom ?? document).nodeType ? newDom : new Text(newDom);
    for (let d of deps._getters)deps._setters.has(d) || ($259ccf8ca7c2ca99$var$addStatesToGc(d), d._bindings.push(binding));
    for (let l of $259ccf8ca7c2ca99$var$curNewDerives)l._dom = newDom;
    $259ccf8ca7c2ca99$var$curNewDerives = prevNewDerives;
    return binding._dom = newDom;
};
let $259ccf8ca7c2ca99$var$derive = (f, s = $259ccf8ca7c2ca99$var$state(), dom)=>{
    let deps = {
        _getters: new Set,
        _setters: new Set
    }, listener = {
        f: f,
        s: s
    };
    listener._dom = dom ?? $259ccf8ca7c2ca99$var$curNewDerives?.push(listener) ?? $259ccf8ca7c2ca99$var$alwaysConnectedDom;
    s.val = $259ccf8ca7c2ca99$var$runAndCaptureDeps(f, deps, s.rawVal);
    for (let d of deps._getters)deps._setters.has(d) || ($259ccf8ca7c2ca99$var$addStatesToGc(d), d._listeners.push(listener));
    return s;
};
let $259ccf8ca7c2ca99$var$add = (dom, ...children)=>{
    for (let c of children.flat(Infinity)){
        let protoOfC = $259ccf8ca7c2ca99$var$protoOf(c ?? 0);
        let child = protoOfC === $259ccf8ca7c2ca99$var$stateProto ? $259ccf8ca7c2ca99$var$bind(()=>c.val) : protoOfC === $259ccf8ca7c2ca99$var$funcProto ? $259ccf8ca7c2ca99$var$bind(c) : c;
        child != $259ccf8ca7c2ca99$var$_undefined && dom.append(child);
    }
    return dom;
};
let $259ccf8ca7c2ca99$var$tag = (ns, name, ...args)=>{
    let [{ is: is, ...props }, ...children] = $259ccf8ca7c2ca99$var$protoOf(args[0] ?? 0) === $259ccf8ca7c2ca99$var$objProto ? args : [
        {},
        ...args
    ];
    let dom = ns ? document.createElementNS(ns, name, {
        is: is
    }) : document.createElement(name, {
        is: is
    });
    for (let [k, v1] of Object.entries(props)){
        let getPropDescriptor = (proto)=>proto ? Object.getOwnPropertyDescriptor(proto, k) ?? getPropDescriptor($259ccf8ca7c2ca99$var$protoOf(proto)) : $259ccf8ca7c2ca99$var$_undefined;
        let cacheKey = name + "," + k;
        let propSetter = $259ccf8ca7c2ca99$var$propSetterCache[cacheKey] ??= getPropDescriptor($259ccf8ca7c2ca99$var$protoOf(dom))?.set ?? 0;
        let setter = k.startsWith("on") ? (v1, oldV)=>{
            let event = k.slice(2);
            dom.removeEventListener(event, oldV);
            dom.addEventListener(event, v1);
        } : propSetter ? propSetter.bind(dom) : dom.setAttribute.bind(dom, k);
        let protoOfV = $259ccf8ca7c2ca99$var$protoOf(v1 ?? 0);
        k.startsWith("on") || protoOfV === $259ccf8ca7c2ca99$var$funcProto && (v1 = $259ccf8ca7c2ca99$var$derive(v1), protoOfV = $259ccf8ca7c2ca99$var$stateProto);
        protoOfV === $259ccf8ca7c2ca99$var$stateProto ? $259ccf8ca7c2ca99$var$bind(()=>(setter(v1.val, v1._oldVal), dom)) : setter(v1);
    }
    return $259ccf8ca7c2ca99$var$add(dom, children);
};
let $259ccf8ca7c2ca99$var$handler = (ns)=>({
        get: (_, name)=>$259ccf8ca7c2ca99$var$tag.bind($259ccf8ca7c2ca99$var$_undefined, ns, name)
    });
let $259ccf8ca7c2ca99$var$update = (dom, newDom)=>newDom ? newDom !== dom && dom.replaceWith(newDom) : dom.remove();
let $259ccf8ca7c2ca99$var$updateDoms = ()=>{
    let iter = 0, derivedStatesArray = [
        ...$259ccf8ca7c2ca99$var$changedStates
    ].filter((s)=>s.rawVal !== s._oldVal);
    do {
        $259ccf8ca7c2ca99$var$derivedStates = new Set;
        for (let l of new Set(derivedStatesArray.flatMap((s)=>s._listeners = $259ccf8ca7c2ca99$var$keepConnected(s._listeners))))$259ccf8ca7c2ca99$var$derive(l.f, l.s, l._dom), l._dom = $259ccf8ca7c2ca99$var$_undefined;
    }while (++iter < 100 && (derivedStatesArray = [
        ...$259ccf8ca7c2ca99$var$derivedStates
    ]).length);
    let changedStatesArray = [
        ...$259ccf8ca7c2ca99$var$changedStates
    ].filter((s)=>s.rawVal !== s._oldVal);
    $259ccf8ca7c2ca99$var$changedStates = $259ccf8ca7c2ca99$var$_undefined;
    for (let b of new Set(changedStatesArray.flatMap((s)=>s._bindings = $259ccf8ca7c2ca99$var$keepConnected(s._bindings))))$259ccf8ca7c2ca99$var$update(b._dom, $259ccf8ca7c2ca99$var$bind(b.f, b._dom)), b._dom = $259ccf8ca7c2ca99$var$_undefined;
    for (let s of changedStatesArray)s._oldVal = s.rawVal;
};
var $259ccf8ca7c2ca99$export$2e2bcd8739ae039 = {
    tags: new Proxy((ns)=>new Proxy($259ccf8ca7c2ca99$var$tag, $259ccf8ca7c2ca99$var$handler(ns)), $259ccf8ca7c2ca99$var$handler()),
    hydrate: (dom, f)=>$259ccf8ca7c2ca99$var$update(dom, $259ccf8ca7c2ca99$var$bind(f, dom)),
    add: $259ccf8ca7c2ca99$var$add,
    state: $259ccf8ca7c2ca99$var$state,
    derive: $259ccf8ca7c2ca99$var$derive
};



const { a: $01d3af8f1b8eef63$export$407448d2b89b1813, article: $01d3af8f1b8eef63$export$bba2aacf8566461b, br: $01d3af8f1b8eef63$export$479ac0420f53ed26, button: $01d3af8f1b8eef63$export$2ba01fb71ed41cb6, canvas: $01d3af8f1b8eef63$export$67ea982130081db, div: $01d3af8f1b8eef63$export$159d9494db57879b, h1: $01d3af8f1b8eef63$export$448e4850cad7c7b0, h2: $01d3af8f1b8eef63$export$a943aa9a0fca3f0b, hr: $01d3af8f1b8eef63$export$b4adb3f464574dcf, input: $01d3af8f1b8eef63$export$b7e3ae3d7c15e42e, label: $01d3af8f1b8eef63$export$1237798dc640739a, li: $01d3af8f1b8eef63$export$19caeaf7d9d84644, nav: $01d3af8f1b8eef63$export$80e4b313e5e6b30d, option: $01d3af8f1b8eef63$export$a75d1723e6bda2ec, p: $01d3af8f1b8eef63$export$ffb5f4729a158638, pre: $01d3af8f1b8eef63$export$2af2ac64526e2aa9, section: $01d3af8f1b8eef63$export$fe2e36411d703b3d, select: $01d3af8f1b8eef63$export$2e6c959c16ff56b8, span: $01d3af8f1b8eef63$export$afc1bfabebaf28a2, table: $01d3af8f1b8eef63$export$9852986a3ec5f6a0, tbody: $01d3af8f1b8eef63$export$7cdd536eaa8f163c, td: $01d3af8f1b8eef63$export$2beef8af2014e5c6, th: $01d3af8f1b8eef63$export$d657bc098992a431, tr: $01d3af8f1b8eef63$export$72451b88a72ad9c2, ul: $01d3af8f1b8eef63$export$b5023c870cb34848 } = (0, $259ccf8ca7c2ca99$export$2e2bcd8739ae039).tags;


const $2055f4ca6115a910$var$narrowColumnClassList = "column is-12-mobile is-7-tablet is-6-desktop is-5-widescreen is-3-fullhd";
const $2055f4ca6115a910$var$wideColumnClassList = "column is-12-mobile is-11-tablet is-11-desktop is-11-widescreen is-8-fullhd";
function $2055f4ca6115a910$export$f48b751f41069b9b(cfg, ...children) {
    return (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
        class: "columns is-centered is-mobile"
    }, (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
        class: cfg.size === "narrow" ? $2055f4ca6115a910$var$narrowColumnClassList : $2055f4ca6115a910$var$wideColumnClassList
    }, ...children));
}



function $e47741cb5fbbb614$export$4b0227fa4b29008b(cfg, ...children) {
    return (0, $2055f4ca6115a910$export$f48b751f41069b9b)(cfg, (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
        class: "box"
    }, ...children));
}



class $bfef550b573ada6a$export$b25f57c16f88d7e0 {
    #deviceField(deviceIdType, deviceType) {
        return (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "field has-addons"
        }, (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "control is-expanded"
        }, (0, $01d3af8f1b8eef63$export$b7e3ae3d7c15e42e)({
            class: "input",
            oninput: (e)=>{
                if (!(e.target instanceof HTMLInputElement)) return;
                this.#id = e.target.value;
            },
            placeholder: deviceIdType
        })), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "control"
        }, (0, $01d3af8f1b8eef63$export$2ba01fb71ed41cb6)({
            class: "button is-primary",
            onclick: ()=>{
                this.#ctx.router.jump(`/admin/${deviceType.toLowerCase().replaceAll(" ", "-")}/${this.#id}`);
            }
        }, deviceType)));
    }
    /**
	 * @param {import("navigo").Match} _
	 */ async refresh(_) {}
    #ctx;
    #id = "";
    ChildDom;
    constructor(ctx){
        this.#ctx = ctx;
        this.ChildDom = (0, $e47741cb5fbbb614$export$4b0227fa4b29008b)({
            size: "narrow"
        }, (0, $01d3af8f1b8eef63$export$448e4850cad7c7b0)({
            class: "title is-4"
        }, "Admin"), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "buttons"
        }, (0, $01d3af8f1b8eef63$export$2ba01fb71ed41cb6)({
            class: "button is-fullwidth is-primary",
            onclick: ()=>this.#ctx.router.jump("/admin/user")
        }, "User"), (0, $01d3af8f1b8eef63$export$2ba01fb71ed41cb6)({
            class: "button is-fullwidth is-primary",
            onclick: ()=>this.#ctx.router.jump("/admin/notices")
        }, "Notices")), this.#deviceField("IMSI", "FarmCam SIM"), this.#deviceField("IMEI", "FenceAlarm"), this.#deviceField("IMEI", "FenceAlarm2"), this.#deviceField("IMEI", "SmartPlug"), this.#deviceField("IMEI", "SmartPlug2"));
    }
}



var $15e3aefa8e338b9b$exports = {};

$parcel$export($15e3aefa8e338b9b$exports, "registerLocale", () => $15e3aefa8e338b9b$export$bab6a7822cc1e2cd, (v) => $15e3aefa8e338b9b$export$bab6a7822cc1e2cd = v);
$parcel$export($15e3aefa8e338b9b$exports, "alpha3ToAlpha2", () => $15e3aefa8e338b9b$export$2a91d0f6f59b9f68, (v) => $15e3aefa8e338b9b$export$2a91d0f6f59b9f68 = v);
$parcel$export($15e3aefa8e338b9b$exports, "alpha2ToAlpha3", () => $15e3aefa8e338b9b$export$65a456803fd0f049, (v) => $15e3aefa8e338b9b$export$65a456803fd0f049 = v);
$parcel$export($15e3aefa8e338b9b$exports, "alpha3ToNumeric", () => $15e3aefa8e338b9b$export$442b6884bee533cd, (v) => $15e3aefa8e338b9b$export$442b6884bee533cd = v);
$parcel$export($15e3aefa8e338b9b$exports, "alpha2ToNumeric", () => $15e3aefa8e338b9b$export$e8f1fd30e9fba660, (v) => $15e3aefa8e338b9b$export$e8f1fd30e9fba660 = v);
$parcel$export($15e3aefa8e338b9b$exports, "numericToAlpha3", () => $15e3aefa8e338b9b$export$c50ba58d0968541f, (v) => $15e3aefa8e338b9b$export$c50ba58d0968541f = v);
$parcel$export($15e3aefa8e338b9b$exports, "numericToAlpha2", () => $15e3aefa8e338b9b$export$e21a59c72a3c77a7, (v) => $15e3aefa8e338b9b$export$e21a59c72a3c77a7 = v);
$parcel$export($15e3aefa8e338b9b$exports, "toAlpha3", () => $15e3aefa8e338b9b$export$3d1d5c3d00561285, (v) => $15e3aefa8e338b9b$export$3d1d5c3d00561285 = v);
$parcel$export($15e3aefa8e338b9b$exports, "toAlpha2", () => $15e3aefa8e338b9b$export$53e0b99b5d556acf, (v) => $15e3aefa8e338b9b$export$53e0b99b5d556acf = v);
$parcel$export($15e3aefa8e338b9b$exports, "getName", () => $15e3aefa8e338b9b$export$7d9f7e9c1c02b41e, (v) => $15e3aefa8e338b9b$export$7d9f7e9c1c02b41e = v);
$parcel$export($15e3aefa8e338b9b$exports, "getNames", () => $15e3aefa8e338b9b$export$dc8de070e3f64a1a, (v) => $15e3aefa8e338b9b$export$dc8de070e3f64a1a = v);
$parcel$export($15e3aefa8e338b9b$exports, "getAlpha2Code", () => $15e3aefa8e338b9b$export$9abd449eff192ddc, (v) => $15e3aefa8e338b9b$export$9abd449eff192ddc = v);
$parcel$export($15e3aefa8e338b9b$exports, "getSimpleAlpha2Code", () => $15e3aefa8e338b9b$export$2db6702cc2165503, (v) => $15e3aefa8e338b9b$export$2db6702cc2165503 = v);
$parcel$export($15e3aefa8e338b9b$exports, "getAlpha2Codes", () => $15e3aefa8e338b9b$export$f340c49a8d00de7f, (v) => $15e3aefa8e338b9b$export$f340c49a8d00de7f = v);
$parcel$export($15e3aefa8e338b9b$exports, "getAlpha3Code", () => $15e3aefa8e338b9b$export$51175d5ff4bc4261, (v) => $15e3aefa8e338b9b$export$51175d5ff4bc4261 = v);
$parcel$export($15e3aefa8e338b9b$exports, "getSimpleAlpha3Code", () => $15e3aefa8e338b9b$export$13496d6083a3d6ac, (v) => $15e3aefa8e338b9b$export$13496d6083a3d6ac = v);
$parcel$export($15e3aefa8e338b9b$exports, "getAlpha3Codes", () => $15e3aefa8e338b9b$export$5b1d6865bbe9ebc, (v) => $15e3aefa8e338b9b$export$5b1d6865bbe9ebc = v);
$parcel$export($15e3aefa8e338b9b$exports, "getNumericCodes", () => $15e3aefa8e338b9b$export$5169b68793e9dfd1, (v) => $15e3aefa8e338b9b$export$5169b68793e9dfd1 = v);
$parcel$export($15e3aefa8e338b9b$exports, "langs", () => $15e3aefa8e338b9b$export$359be4c8544d6fb1, (v) => $15e3aefa8e338b9b$export$359be4c8544d6fb1 = v);
$parcel$export($15e3aefa8e338b9b$exports, "getSupportedLanguages", () => $15e3aefa8e338b9b$export$3308a67cbbb588bc, (v) => $15e3aefa8e338b9b$export$3308a67cbbb588bc = v);
$parcel$export($15e3aefa8e338b9b$exports, "isValid", () => $15e3aefa8e338b9b$export$1ea939691cdc45b8, (v) => $15e3aefa8e338b9b$export$1ea939691cdc45b8 = v);
/**
 * Register countries in browsers' environment:
 * @param {object} localeData
 * @example countries.registerLocale(require("i18n-iso-countries/langs/en.json"));
 * @return void
 */ var $15e3aefa8e338b9b$export$bab6a7822cc1e2cd;
var $15e3aefa8e338b9b$export$2a91d0f6f59b9f68;
var $15e3aefa8e338b9b$export$65a456803fd0f049;
var $15e3aefa8e338b9b$export$442b6884bee533cd;
var $15e3aefa8e338b9b$export$e8f1fd30e9fba660;
var $15e3aefa8e338b9b$export$c50ba58d0968541f;
var $15e3aefa8e338b9b$export$e21a59c72a3c77a7;
var $15e3aefa8e338b9b$export$3d1d5c3d00561285;
var $15e3aefa8e338b9b$export$53e0b99b5d556acf;
/**
 * @param {string | number | Alpha2Code | Alpha3Code} code
 * @param {String} lang          language for country name
 * @param {GetNameOptions} options
 * @return {String | String[] | undefined}  name
 */ var $15e3aefa8e338b9b$export$7d9f7e9c1c02b41e;
/**
 * @param {String} lang             language for country names
 * @param {GetNameOptions} options   getNames Options
 * @return {LocalizedCountryNames}  country code
 *                                  mapped to county name
 */ var $15e3aefa8e338b9b$export$dc8de070e3f64a1a;
/*
 * @param name name
 * @param lang language for country name
 * @return ISO 3166-1 alpha-2 or undefined
 */ var $15e3aefa8e338b9b$export$9abd449eff192ddc;
/*
 * @param name name
 * @param lang language for country name
 * @return ISO 3166-1 alpha-2 or undefined
 */ var $15e3aefa8e338b9b$export$2db6702cc2165503;
/*
 * @return Object of alpha-2 codes mapped to alpha-3 codes
 */ var $15e3aefa8e338b9b$export$f340c49a8d00de7f;
/*
 * @param name name
 * @param lang language for country name
 * @return ISO 3166-1 alpha-3 or undefined
 */ var $15e3aefa8e338b9b$export$51175d5ff4bc4261;
/*
 * @param name name
 * @param lang language for country name
 * @return ISO 3166-1 alpha-3 or undefined
 */ var $15e3aefa8e338b9b$export$13496d6083a3d6ac;
/*
 * @return Object of alpha-3 codes mapped to alpha-2 codes
 */ var $15e3aefa8e338b9b$export$5b1d6865bbe9ebc;
/*
 * @return Object of numeric codes mapped to alpha-2 codes
 */ var $15e3aefa8e338b9b$export$5169b68793e9dfd1;
/*
 * @return Array of registered languages
 */ var $15e3aefa8e338b9b$export$359be4c8544d6fb1;
/*
 * @return Array of supported languages
 */ var $15e3aefa8e338b9b$export$3308a67cbbb588bc;
/*
 * @param code ISO 3166-1 alpha-2, alpha-3 or numeric code
 * @return Boolean
 */ var $15e3aefa8e338b9b$export$1ea939691cdc45b8;
"use strict";
var $da66b25377f1dccf$exports = {};
$da66b25377f1dccf$exports = JSON.parse("[[\"AF\",\"AFG\",\"004\",\"ISO 3166-2:AF\"],[\"AL\",\"ALB\",\"008\",\"ISO 3166-2:AL\"],[\"DZ\",\"DZA\",\"012\",\"ISO 3166-2:DZ\"],[\"AS\",\"ASM\",\"016\",\"ISO 3166-2:AS\"],[\"AD\",\"AND\",\"020\",\"ISO 3166-2:AD\"],[\"AO\",\"AGO\",\"024\",\"ISO 3166-2:AO\"],[\"AI\",\"AIA\",\"660\",\"ISO 3166-2:AI\"],[\"AQ\",\"ATA\",\"010\",\"ISO 3166-2:AQ\"],[\"AG\",\"ATG\",\"028\",\"ISO 3166-2:AG\"],[\"AR\",\"ARG\",\"032\",\"ISO 3166-2:AR\"],[\"AM\",\"ARM\",\"051\",\"ISO 3166-2:AM\"],[\"AW\",\"ABW\",\"533\",\"ISO 3166-2:AW\"],[\"AU\",\"AUS\",\"036\",\"ISO 3166-2:AU\"],[\"AT\",\"AUT\",\"040\",\"ISO 3166-2:AT\"],[\"AZ\",\"AZE\",\"031\",\"ISO 3166-2:AZ\"],[\"BS\",\"BHS\",\"044\",\"ISO 3166-2:BS\"],[\"BH\",\"BHR\",\"048\",\"ISO 3166-2:BH\"],[\"BD\",\"BGD\",\"050\",\"ISO 3166-2:BD\"],[\"BB\",\"BRB\",\"052\",\"ISO 3166-2:BB\"],[\"BY\",\"BLR\",\"112\",\"ISO 3166-2:BY\"],[\"BE\",\"BEL\",\"056\",\"ISO 3166-2:BE\"],[\"BZ\",\"BLZ\",\"084\",\"ISO 3166-2:BZ\"],[\"BJ\",\"BEN\",\"204\",\"ISO 3166-2:BJ\"],[\"BM\",\"BMU\",\"060\",\"ISO 3166-2:BM\"],[\"BT\",\"BTN\",\"064\",\"ISO 3166-2:BT\"],[\"BO\",\"BOL\",\"068\",\"ISO 3166-2:BO\"],[\"BA\",\"BIH\",\"070\",\"ISO 3166-2:BA\"],[\"BW\",\"BWA\",\"072\",\"ISO 3166-2:BW\"],[\"BV\",\"BVT\",\"074\",\"ISO 3166-2:BV\"],[\"BR\",\"BRA\",\"076\",\"ISO 3166-2:BR\"],[\"IO\",\"IOT\",\"086\",\"ISO 3166-2:IO\"],[\"BN\",\"BRN\",\"096\",\"ISO 3166-2:BN\"],[\"BG\",\"BGR\",\"100\",\"ISO 3166-2:BG\"],[\"BF\",\"BFA\",\"854\",\"ISO 3166-2:BF\"],[\"BI\",\"BDI\",\"108\",\"ISO 3166-2:BI\"],[\"KH\",\"KHM\",\"116\",\"ISO 3166-2:KH\"],[\"CM\",\"CMR\",\"120\",\"ISO 3166-2:CM\"],[\"CA\",\"CAN\",\"124\",\"ISO 3166-2:CA\"],[\"CV\",\"CPV\",\"132\",\"ISO 3166-2:CV\"],[\"KY\",\"CYM\",\"136\",\"ISO 3166-2:KY\"],[\"CF\",\"CAF\",\"140\",\"ISO 3166-2:CF\"],[\"TD\",\"TCD\",\"148\",\"ISO 3166-2:TD\"],[\"CL\",\"CHL\",\"152\",\"ISO 3166-2:CL\"],[\"CN\",\"CHN\",\"156\",\"ISO 3166-2:CN\"],[\"CX\",\"CXR\",\"162\",\"ISO 3166-2:CX\"],[\"CC\",\"CCK\",\"166\",\"ISO 3166-2:CC\"],[\"CO\",\"COL\",\"170\",\"ISO 3166-2:CO\"],[\"KM\",\"COM\",\"174\",\"ISO 3166-2:KM\"],[\"CG\",\"COG\",\"178\",\"ISO 3166-2:CG\"],[\"CD\",\"COD\",\"180\",\"ISO 3166-2:CD\"],[\"CK\",\"COK\",\"184\",\"ISO 3166-2:CK\"],[\"CR\",\"CRI\",\"188\",\"ISO 3166-2:CR\"],[\"CI\",\"CIV\",\"384\",\"ISO 3166-2:CI\"],[\"HR\",\"HRV\",\"191\",\"ISO 3166-2:HR\"],[\"CU\",\"CUB\",\"192\",\"ISO 3166-2:CU\"],[\"CY\",\"CYP\",\"196\",\"ISO 3166-2:CY\"],[\"CZ\",\"CZE\",\"203\",\"ISO 3166-2:CZ\"],[\"DK\",\"DNK\",\"208\",\"ISO 3166-2:DK\"],[\"DJ\",\"DJI\",\"262\",\"ISO 3166-2:DJ\"],[\"DM\",\"DMA\",\"212\",\"ISO 3166-2:DM\"],[\"DO\",\"DOM\",\"214\",\"ISO 3166-2:DO\"],[\"EC\",\"ECU\",\"218\",\"ISO 3166-2:EC\"],[\"EG\",\"EGY\",\"818\",\"ISO 3166-2:EG\"],[\"SV\",\"SLV\",\"222\",\"ISO 3166-2:SV\"],[\"GQ\",\"GNQ\",\"226\",\"ISO 3166-2:GQ\"],[\"ER\",\"ERI\",\"232\",\"ISO 3166-2:ER\"],[\"EE\",\"EST\",\"233\",\"ISO 3166-2:EE\"],[\"ET\",\"ETH\",\"231\",\"ISO 3166-2:ET\"],[\"FK\",\"FLK\",\"238\",\"ISO 3166-2:FK\"],[\"FO\",\"FRO\",\"234\",\"ISO 3166-2:FO\"],[\"FJ\",\"FJI\",\"242\",\"ISO 3166-2:FJ\"],[\"FI\",\"FIN\",\"246\",\"ISO 3166-2:FI\"],[\"FR\",\"FRA\",\"250\",\"ISO 3166-2:FR\"],[\"GF\",\"GUF\",\"254\",\"ISO 3166-2:GF\"],[\"PF\",\"PYF\",\"258\",\"ISO 3166-2:PF\"],[\"TF\",\"ATF\",\"260\",\"ISO 3166-2:TF\"],[\"GA\",\"GAB\",\"266\",\"ISO 3166-2:GA\"],[\"GM\",\"GMB\",\"270\",\"ISO 3166-2:GM\"],[\"GE\",\"GEO\",\"268\",\"ISO 3166-2:GE\"],[\"DE\",\"DEU\",\"276\",\"ISO 3166-2:DE\"],[\"GH\",\"GHA\",\"288\",\"ISO 3166-2:GH\"],[\"GI\",\"GIB\",\"292\",\"ISO 3166-2:GI\"],[\"GR\",\"GRC\",\"300\",\"ISO 3166-2:GR\"],[\"GL\",\"GRL\",\"304\",\"ISO 3166-2:GL\"],[\"GD\",\"GRD\",\"308\",\"ISO 3166-2:GD\"],[\"GP\",\"GLP\",\"312\",\"ISO 3166-2:GP\"],[\"GU\",\"GUM\",\"316\",\"ISO 3166-2:GU\"],[\"GT\",\"GTM\",\"320\",\"ISO 3166-2:GT\"],[\"GN\",\"GIN\",\"324\",\"ISO 3166-2:GN\"],[\"GW\",\"GNB\",\"624\",\"ISO 3166-2:GW\"],[\"GY\",\"GUY\",\"328\",\"ISO 3166-2:GY\"],[\"HT\",\"HTI\",\"332\",\"ISO 3166-2:HT\"],[\"HM\",\"HMD\",\"334\",\"ISO 3166-2:HM\"],[\"VA\",\"VAT\",\"336\",\"ISO 3166-2:VA\"],[\"HN\",\"HND\",\"340\",\"ISO 3166-2:HN\"],[\"HK\",\"HKG\",\"344\",\"ISO 3166-2:HK\"],[\"HU\",\"HUN\",\"348\",\"ISO 3166-2:HU\"],[\"IS\",\"ISL\",\"352\",\"ISO 3166-2:IS\"],[\"IN\",\"IND\",\"356\",\"ISO 3166-2:IN\"],[\"ID\",\"IDN\",\"360\",\"ISO 3166-2:ID\"],[\"IR\",\"IRN\",\"364\",\"ISO 3166-2:IR\"],[\"IQ\",\"IRQ\",\"368\",\"ISO 3166-2:IQ\"],[\"IE\",\"IRL\",\"372\",\"ISO 3166-2:IE\"],[\"IL\",\"ISR\",\"376\",\"ISO 3166-2:IL\"],[\"IT\",\"ITA\",\"380\",\"ISO 3166-2:IT\"],[\"JM\",\"JAM\",\"388\",\"ISO 3166-2:JM\"],[\"JP\",\"JPN\",\"392\",\"ISO 3166-2:JP\"],[\"JO\",\"JOR\",\"400\",\"ISO 3166-2:JO\"],[\"KZ\",\"KAZ\",\"398\",\"ISO 3166-2:KZ\"],[\"KE\",\"KEN\",\"404\",\"ISO 3166-2:KE\"],[\"KI\",\"KIR\",\"296\",\"ISO 3166-2:KI\"],[\"KP\",\"PRK\",\"408\",\"ISO 3166-2:KP\"],[\"KR\",\"KOR\",\"410\",\"ISO 3166-2:KR\"],[\"KW\",\"KWT\",\"414\",\"ISO 3166-2:KW\"],[\"KG\",\"KGZ\",\"417\",\"ISO 3166-2:KG\"],[\"LA\",\"LAO\",\"418\",\"ISO 3166-2:LA\"],[\"LV\",\"LVA\",\"428\",\"ISO 3166-2:LV\"],[\"LB\",\"LBN\",\"422\",\"ISO 3166-2:LB\"],[\"LS\",\"LSO\",\"426\",\"ISO 3166-2:LS\"],[\"LR\",\"LBR\",\"430\",\"ISO 3166-2:LR\"],[\"LY\",\"LBY\",\"434\",\"ISO 3166-2:LY\"],[\"LI\",\"LIE\",\"438\",\"ISO 3166-2:LI\"],[\"LT\",\"LTU\",\"440\",\"ISO 3166-2:LT\"],[\"LU\",\"LUX\",\"442\",\"ISO 3166-2:LU\"],[\"MO\",\"MAC\",\"446\",\"ISO 3166-2:MO\"],[\"MG\",\"MDG\",\"450\",\"ISO 3166-2:MG\"],[\"MW\",\"MWI\",\"454\",\"ISO 3166-2:MW\"],[\"MY\",\"MYS\",\"458\",\"ISO 3166-2:MY\"],[\"MV\",\"MDV\",\"462\",\"ISO 3166-2:MV\"],[\"ML\",\"MLI\",\"466\",\"ISO 3166-2:ML\"],[\"MT\",\"MLT\",\"470\",\"ISO 3166-2:MT\"],[\"MH\",\"MHL\",\"584\",\"ISO 3166-2:MH\"],[\"MQ\",\"MTQ\",\"474\",\"ISO 3166-2:MQ\"],[\"MR\",\"MRT\",\"478\",\"ISO 3166-2:MR\"],[\"MU\",\"MUS\",\"480\",\"ISO 3166-2:MU\"],[\"YT\",\"MYT\",\"175\",\"ISO 3166-2:YT\"],[\"MX\",\"MEX\",\"484\",\"ISO 3166-2:MX\"],[\"FM\",\"FSM\",\"583\",\"ISO 3166-2:FM\"],[\"MD\",\"MDA\",\"498\",\"ISO 3166-2:MD\"],[\"MC\",\"MCO\",\"492\",\"ISO 3166-2:MC\"],[\"MN\",\"MNG\",\"496\",\"ISO 3166-2:MN\"],[\"MS\",\"MSR\",\"500\",\"ISO 3166-2:MS\"],[\"MA\",\"MAR\",\"504\",\"ISO 3166-2:MA\"],[\"MZ\",\"MOZ\",\"508\",\"ISO 3166-2:MZ\"],[\"MM\",\"MMR\",\"104\",\"ISO 3166-2:MM\"],[\"NA\",\"NAM\",\"516\",\"ISO 3166-2:NA\"],[\"NR\",\"NRU\",\"520\",\"ISO 3166-2:NR\"],[\"NP\",\"NPL\",\"524\",\"ISO 3166-2:NP\"],[\"NL\",\"NLD\",\"528\",\"ISO 3166-2:NL\"],[\"NC\",\"NCL\",\"540\",\"ISO 3166-2:NC\"],[\"NZ\",\"NZL\",\"554\",\"ISO 3166-2:NZ\"],[\"NI\",\"NIC\",\"558\",\"ISO 3166-2:NI\"],[\"NE\",\"NER\",\"562\",\"ISO 3166-2:NE\"],[\"NG\",\"NGA\",\"566\",\"ISO 3166-2:NG\"],[\"NU\",\"NIU\",\"570\",\"ISO 3166-2:NU\"],[\"NF\",\"NFK\",\"574\",\"ISO 3166-2:NF\"],[\"MP\",\"MNP\",\"580\",\"ISO 3166-2:MP\"],[\"MK\",\"MKD\",\"807\",\"ISO 3166-2:MK\"],[\"NO\",\"NOR\",\"578\",\"ISO 3166-2:NO\"],[\"OM\",\"OMN\",\"512\",\"ISO 3166-2:OM\"],[\"PK\",\"PAK\",\"586\",\"ISO 3166-2:PK\"],[\"PW\",\"PLW\",\"585\",\"ISO 3166-2:PW\"],[\"PS\",\"PSE\",\"275\",\"ISO 3166-2:PS\"],[\"PA\",\"PAN\",\"591\",\"ISO 3166-2:PA\"],[\"PG\",\"PNG\",\"598\",\"ISO 3166-2:PG\"],[\"PY\",\"PRY\",\"600\",\"ISO 3166-2:PY\"],[\"PE\",\"PER\",\"604\",\"ISO 3166-2:PE\"],[\"PH\",\"PHL\",\"608\",\"ISO 3166-2:PH\"],[\"PN\",\"PCN\",\"612\",\"ISO 3166-2:PN\"],[\"PL\",\"POL\",\"616\",\"ISO 3166-2:PL\"],[\"PT\",\"PRT\",\"620\",\"ISO 3166-2:PT\"],[\"PR\",\"PRI\",\"630\",\"ISO 3166-2:PR\"],[\"QA\",\"QAT\",\"634\",\"ISO 3166-2:QA\"],[\"RE\",\"REU\",\"638\",\"ISO 3166-2:RE\"],[\"RO\",\"ROU\",\"642\",\"ISO 3166-2:RO\"],[\"RU\",\"RUS\",\"643\",\"ISO 3166-2:RU\"],[\"RW\",\"RWA\",\"646\",\"ISO 3166-2:RW\"],[\"SH\",\"SHN\",\"654\",\"ISO 3166-2:SH\"],[\"KN\",\"KNA\",\"659\",\"ISO 3166-2:KN\"],[\"LC\",\"LCA\",\"662\",\"ISO 3166-2:LC\"],[\"PM\",\"SPM\",\"666\",\"ISO 3166-2:PM\"],[\"VC\",\"VCT\",\"670\",\"ISO 3166-2:VC\"],[\"WS\",\"WSM\",\"882\",\"ISO 3166-2:WS\"],[\"SM\",\"SMR\",\"674\",\"ISO 3166-2:SM\"],[\"ST\",\"STP\",\"678\",\"ISO 3166-2:ST\"],[\"SA\",\"SAU\",\"682\",\"ISO 3166-2:SA\"],[\"SN\",\"SEN\",\"686\",\"ISO 3166-2:SN\"],[\"SC\",\"SYC\",\"690\",\"ISO 3166-2:SC\"],[\"SL\",\"SLE\",\"694\",\"ISO 3166-2:SL\"],[\"SG\",\"SGP\",\"702\",\"ISO 3166-2:SG\"],[\"SK\",\"SVK\",\"703\",\"ISO 3166-2:SK\"],[\"SI\",\"SVN\",\"705\",\"ISO 3166-2:SI\"],[\"SB\",\"SLB\",\"090\",\"ISO 3166-2:SB\"],[\"SO\",\"SOM\",\"706\",\"ISO 3166-2:SO\"],[\"ZA\",\"ZAF\",\"710\",\"ISO 3166-2:ZA\"],[\"GS\",\"SGS\",\"239\",\"ISO 3166-2:GS\"],[\"ES\",\"ESP\",\"724\",\"ISO 3166-2:ES\"],[\"LK\",\"LKA\",\"144\",\"ISO 3166-2:LK\"],[\"SD\",\"SDN\",\"729\",\"ISO 3166-2:SD\"],[\"SR\",\"SUR\",\"740\",\"ISO 3166-2:SR\"],[\"SJ\",\"SJM\",\"744\",\"ISO 3166-2:SJ\"],[\"SZ\",\"SWZ\",\"748\",\"ISO 3166-2:SZ\"],[\"SE\",\"SWE\",\"752\",\"ISO 3166-2:SE\"],[\"CH\",\"CHE\",\"756\",\"ISO 3166-2:CH\"],[\"SY\",\"SYR\",\"760\",\"ISO 3166-2:SY\"],[\"TW\",\"TWN\",\"158\",\"ISO 3166-2:TW\"],[\"TJ\",\"TJK\",\"762\",\"ISO 3166-2:TJ\"],[\"TZ\",\"TZA\",\"834\",\"ISO 3166-2:TZ\"],[\"TH\",\"THA\",\"764\",\"ISO 3166-2:TH\"],[\"TL\",\"TLS\",\"626\",\"ISO 3166-2:TL\"],[\"TG\",\"TGO\",\"768\",\"ISO 3166-2:TG\"],[\"TK\",\"TKL\",\"772\",\"ISO 3166-2:TK\"],[\"TO\",\"TON\",\"776\",\"ISO 3166-2:TO\"],[\"TT\",\"TTO\",\"780\",\"ISO 3166-2:TT\"],[\"TN\",\"TUN\",\"788\",\"ISO 3166-2:TN\"],[\"TR\",\"TUR\",\"792\",\"ISO 3166-2:TR\"],[\"TM\",\"TKM\",\"795\",\"ISO 3166-2:TM\"],[\"TC\",\"TCA\",\"796\",\"ISO 3166-2:TC\"],[\"TV\",\"TUV\",\"798\",\"ISO 3166-2:TV\"],[\"UG\",\"UGA\",\"800\",\"ISO 3166-2:UG\"],[\"UA\",\"UKR\",\"804\",\"ISO 3166-2:UA\"],[\"AE\",\"ARE\",\"784\",\"ISO 3166-2:AE\"],[\"GB\",\"GBR\",\"826\",\"ISO 3166-2:GB\"],[\"US\",\"USA\",\"840\",\"ISO 3166-2:US\"],[\"UM\",\"UMI\",\"581\",\"ISO 3166-2:UM\"],[\"UY\",\"URY\",\"858\",\"ISO 3166-2:UY\"],[\"UZ\",\"UZB\",\"860\",\"ISO 3166-2:UZ\"],[\"VU\",\"VUT\",\"548\",\"ISO 3166-2:VU\"],[\"VE\",\"VEN\",\"862\",\"ISO 3166-2:VE\"],[\"VN\",\"VNM\",\"704\",\"ISO 3166-2:VN\"],[\"VG\",\"VGB\",\"092\",\"ISO 3166-2:VG\"],[\"VI\",\"VIR\",\"850\",\"ISO 3166-2:VI\"],[\"WF\",\"WLF\",\"876\",\"ISO 3166-2:WF\"],[\"EH\",\"ESH\",\"732\",\"ISO 3166-2:EH\"],[\"YE\",\"YEM\",\"887\",\"ISO 3166-2:YE\"],[\"ZM\",\"ZMB\",\"894\",\"ISO 3166-2:ZM\"],[\"ZW\",\"ZWE\",\"716\",\"ISO 3166-2:ZW\"],[\"AX\",\"ALA\",\"248\",\"ISO 3166-2:AX\"],[\"BQ\",\"BES\",\"535\",\"ISO 3166-2:BQ\"],[\"CW\",\"CUW\",\"531\",\"ISO 3166-2:CW\"],[\"GG\",\"GGY\",\"831\",\"ISO 3166-2:GG\"],[\"IM\",\"IMN\",\"833\",\"ISO 3166-2:IM\"],[\"JE\",\"JEY\",\"832\",\"ISO 3166-2:JE\"],[\"ME\",\"MNE\",\"499\",\"ISO 3166-2:ME\"],[\"BL\",\"BLM\",\"652\",\"ISO 3166-2:BL\"],[\"MF\",\"MAF\",\"663\",\"ISO 3166-2:MF\"],[\"RS\",\"SRB\",\"688\",\"ISO 3166-2:RS\"],[\"SX\",\"SXM\",\"534\",\"ISO 3166-2:SX\"],[\"SS\",\"SSD\",\"728\",\"ISO 3166-2:SS\"],[\"XK\",\"XKK\",\"983\",\"ISO 3166-2:XK\"]]");


var $ac8329aaa7c2f2a8$exports = {};
$ac8329aaa7c2f2a8$exports = JSON.parse("[\"br\",\"cy\",\"dv\",\"sw\",\"eu\",\"af\",\"am\",\"ha\",\"ku\",\"ml\",\"mt\",\"no\",\"ps\",\"sd\",\"so\",\"sq\",\"ta\",\"tg\",\"tt\",\"ug\",\"ur\",\"vi\",\"ar\",\"az\",\"be\",\"bg\",\"bn\",\"bs\",\"ca\",\"cs\",\"da\",\"de\",\"el\",\"en\",\"es\",\"et\",\"fa\",\"fi\",\"fr\",\"ga\",\"gl\",\"he\",\"hi\",\"hr\",\"hu\",\"hy\",\"id\",\"is\",\"it\",\"ja\",\"ka\",\"kk\",\"km\",\"ko\",\"ky\",\"lt\",\"lv\",\"mk\",\"mn\",\"mr\",\"ms\",\"nb\",\"nl\",\"nn\",\"pl\",\"pt\",\"ro\",\"ru\",\"sk\",\"sl\",\"sr\",\"sv\",\"th\",\"tk\",\"tr\",\"uk\",\"uz\",\"zh\"]");


var $6e4725ac584d2777$export$cd7f480d6b8286c3;
var $6e4725ac584d2777$export$452fcf31d2a11c49;
var $6e4725ac584d2777$export$a078a2660a2c4d03;
$6e4725ac584d2777$export$cd7f480d6b8286c3 = $6e4725ac584d2777$var$removeDiacritics;
var $6e4725ac584d2777$var$replacementList = [
    {
        base: ' ',
        chars: "\u00A0"
    },
    {
        base: '0',
        chars: "\u07C0"
    },
    {
        base: 'A',
        chars: "\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: 'AA',
        chars: "\uA732"
    },
    {
        base: 'AE',
        chars: "\u00C6\u01FC\u01E2"
    },
    {
        base: 'AO',
        chars: "\uA734"
    },
    {
        base: 'AU',
        chars: "\uA736"
    },
    {
        base: 'AV',
        chars: "\uA738\uA73A"
    },
    {
        base: 'AY',
        chars: "\uA73C"
    },
    {
        base: 'B',
        chars: "\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0181"
    },
    {
        base: 'C',
        chars: "\u24b8\uff23\uA73E\u1E08\u0106\u0043\u0108\u010A\u010C\u00C7\u0187\u023B"
    },
    {
        base: 'D',
        chars: "\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018A\u0189\u1D05\uA779"
    },
    {
        base: 'Dh',
        chars: "\u00D0"
    },
    {
        base: 'DZ',
        chars: "\u01F1\u01C4"
    },
    {
        base: 'Dz',
        chars: "\u01F2\u01C5"
    },
    {
        base: 'E',
        chars: "\u025B\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E\u1D07"
    },
    {
        base: 'F',
        chars: "\uA77C\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: 'G',
        chars: "\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E\u0262"
    },
    {
        base: 'H',
        chars: "\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: 'I',
        chars: "\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: 'J',
        chars: "\u24BF\uFF2A\u0134\u0248\u0237"
    },
    {
        base: 'K',
        chars: "\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: 'L',
        chars: "\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: 'LJ',
        chars: "\u01C7"
    },
    {
        base: 'Lj',
        chars: "\u01C8"
    },
    {
        base: 'M',
        chars: "\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C\u03FB"
    },
    {
        base: 'N',
        chars: "\uA7A4\u0220\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u019D\uA790\u1D0E"
    },
    {
        base: 'NJ',
        chars: "\u01CA"
    },
    {
        base: 'Nj',
        chars: "\u01CB"
    },
    {
        base: 'O',
        chars: "\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: 'OE',
        chars: "\u0152"
    },
    {
        base: 'OI',
        chars: "\u01A2"
    },
    {
        base: 'OO',
        chars: "\uA74E"
    },
    {
        base: 'OU',
        chars: "\u0222"
    },
    {
        base: 'P',
        chars: "\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: 'Q',
        chars: "\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: 'R',
        chars: "\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: 'S',
        chars: "\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: 'T',
        chars: "\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: 'Th',
        chars: "\u00DE"
    },
    {
        base: 'TZ',
        chars: "\uA728"
    },
    {
        base: 'U',
        chars: "\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: 'V',
        chars: "\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: 'VY',
        chars: "\uA760"
    },
    {
        base: 'W',
        chars: "\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: 'X',
        chars: "\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: 'Y',
        chars: "\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: 'Z',
        chars: "\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: 'a',
        chars: "\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250\u0251"
    },
    {
        base: 'aa',
        chars: "\uA733"
    },
    {
        base: 'ae',
        chars: "\u00E6\u01FD\u01E3"
    },
    {
        base: 'ao',
        chars: "\uA735"
    },
    {
        base: 'au',
        chars: "\uA737"
    },
    {
        base: 'av',
        chars: "\uA739\uA73B"
    },
    {
        base: 'ay',
        chars: "\uA73D"
    },
    {
        base: 'b',
        chars: "\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253\u0182"
    },
    {
        base: 'c',
        chars: "\uFF43\u24D2\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: 'd',
        chars: "\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\u018B\u13E7\u0501\uA7AA"
    },
    {
        base: 'dh',
        chars: "\u00F0"
    },
    {
        base: 'dz',
        chars: "\u01F3\u01C6"
    },
    {
        base: 'e',
        chars: "\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u01DD"
    },
    {
        base: 'f',
        chars: "\u24D5\uFF46\u1E1F\u0192"
    },
    {
        base: 'ff',
        chars: "\uFB00"
    },
    {
        base: 'fi',
        chars: "\uFB01"
    },
    {
        base: 'fl',
        chars: "\uFB02"
    },
    {
        base: 'ffi',
        chars: "\uFB03"
    },
    {
        base: 'ffl',
        chars: "\uFB04"
    },
    {
        base: 'g',
        chars: "\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\uA77F\u1D79"
    },
    {
        base: 'h',
        chars: "\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: 'hv',
        chars: "\u0195"
    },
    {
        base: 'i',
        chars: "\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: 'j',
        chars: "\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: 'k',
        chars: "\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: 'l',
        chars: "\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747\u026D"
    },
    {
        base: 'lj',
        chars: "\u01C9"
    },
    {
        base: 'm',
        chars: "\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: 'n',
        chars: "\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5\u043B\u0509"
    },
    {
        base: 'nj',
        chars: "\u01CC"
    },
    {
        base: 'o',
        chars: "\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\uA74B\uA74D\u0275\u0254\u1D11"
    },
    {
        base: 'oe',
        chars: "\u0153"
    },
    {
        base: 'oi',
        chars: "\u01A3"
    },
    {
        base: 'oo',
        chars: "\uA74F"
    },
    {
        base: 'ou',
        chars: "\u0223"
    },
    {
        base: 'p',
        chars: "\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755\u03C1"
    },
    {
        base: 'q',
        chars: "\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: 'r',
        chars: "\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: 's',
        chars: "\u24E2\uFF53\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B\u0282"
    },
    {
        base: 'ss',
        chars: "\xDF"
    },
    {
        base: 't',
        chars: "\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: 'th',
        chars: "\u00FE"
    },
    {
        base: 'tz',
        chars: "\uA729"
    },
    {
        base: 'u',
        chars: "\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: 'v',
        chars: "\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: 'vy',
        chars: "\uA761"
    },
    {
        base: 'w',
        chars: "\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: 'x',
        chars: "\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: 'y',
        chars: "\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: 'z',
        chars: "\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var $6e4725ac584d2777$var$diacriticsMap = {};
for(var $6e4725ac584d2777$var$i = 0; $6e4725ac584d2777$var$i < $6e4725ac584d2777$var$replacementList.length; $6e4725ac584d2777$var$i += 1){
    var $6e4725ac584d2777$var$chars = $6e4725ac584d2777$var$replacementList[$6e4725ac584d2777$var$i].chars;
    for(var $6e4725ac584d2777$var$j = 0; $6e4725ac584d2777$var$j < $6e4725ac584d2777$var$chars.length; $6e4725ac584d2777$var$j += 1)$6e4725ac584d2777$var$diacriticsMap[$6e4725ac584d2777$var$chars[$6e4725ac584d2777$var$j]] = $6e4725ac584d2777$var$replacementList[$6e4725ac584d2777$var$i].base;
}
function $6e4725ac584d2777$var$removeDiacritics(str) {
    return str.replace(/[^\u0000-\u007e]/g, function(c) {
        return $6e4725ac584d2777$var$diacriticsMap[c] || c;
    });
}
$6e4725ac584d2777$export$452fcf31d2a11c49 = $6e4725ac584d2777$var$replacementList;
$6e4725ac584d2777$export$a078a2660a2c4d03 = $6e4725ac584d2777$var$diacriticsMap;


var $15e3aefa8e338b9b$require$removeDiacritics = $6e4725ac584d2777$export$cd7f480d6b8286c3;
const $15e3aefa8e338b9b$var$registeredLocales = {};
/*
 * All codes map to ISO 3166-1 alpha-2
 */ const $15e3aefa8e338b9b$var$alpha2 = {}, $15e3aefa8e338b9b$var$alpha3 = {}, $15e3aefa8e338b9b$var$numeric = {}, $15e3aefa8e338b9b$var$invertedNumeric = {};
$da66b25377f1dccf$exports.forEach(function(codeInformation) {
    const s = codeInformation;
    $15e3aefa8e338b9b$var$alpha2[s[0]] = s[1];
    $15e3aefa8e338b9b$var$alpha3[s[1]] = s[0];
    $15e3aefa8e338b9b$var$numeric[s[2]] = s[0];
    $15e3aefa8e338b9b$var$invertedNumeric[s[0]] = s[2];
});
/**
 * @private
 * @param {number} code
 */ function $15e3aefa8e338b9b$var$formatNumericCode(code) {
    return String("000" + (code ? code : "")).slice(-3);
}
/**
 * @private
 * Avoid using obj.hasOwnProperty directly as `hasOwnProperty` could be a
 * property in itself ({ hasOwnProperty: 1 }) and cause weird bugs
 * https://eslint.org/docs/rules/no-prototype-builtins
 */ function $15e3aefa8e338b9b$var$hasOwnProperty(object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
}
/**
 * @private
 * Pass localeList through a filter and return a newLocaleList obj
 * with the same structure of the old localeList.
 *
 * @param {LocalizedCountryNames} localeList  Local List in raw
 * @param {Function} filter    callback to set filter rule
 * @return {String | String[]} new filtered Local List
 */ function $15e3aefa8e338b9b$var$localeFilter(localeList, filter) {
    return Object.keys(localeList).reduce(function(newLocaleList, alpha2) {
        const nameList = localeList[alpha2];
        newLocaleList[alpha2] = filter(nameList, alpha2);
        return newLocaleList;
    }, {});
}
/**
 * @private
 * Preserve for getName & getNames
 *
 * @param {GetNameOptions.select} type all | official | alias
 * @param countryNameList  string array of country's
 *                         official name and alias
 * @return {String | String[]} of a country name
 */ function $15e3aefa8e338b9b$var$filterNameBy(type, countryNameList) {
    switch(type){
        case "official":
            return Array.isArray(countryNameList) ? countryNameList[0] : countryNameList;
        case "all":
            return typeof countryNameList === "string" ? [
                countryNameList
            ] : countryNameList;
        case "alias":
            return Array.isArray(countryNameList) ? countryNameList[1] || countryNameList[0] : countryNameList;
        default:
            throw new TypeError("LocaleNameType must be one of these: all, official, alias!");
    }
}
$15e3aefa8e338b9b$export$bab6a7822cc1e2cd = function(localeData) {
    if (!localeData.locale) throw new TypeError("Missing localeData.locale");
    if (!localeData.countries) throw new TypeError("Missing localeData.countries");
    $15e3aefa8e338b9b$var$registeredLocales[localeData.locale] = localeData.countries;
};
/*
 * @param code Alpha-3 code
 * @return Alpha-2 code or undefined
 */ function $15e3aefa8e338b9b$var$alpha3ToAlpha2(code) {
    return $15e3aefa8e338b9b$var$alpha3[code];
}
$15e3aefa8e338b9b$export$2a91d0f6f59b9f68 = $15e3aefa8e338b9b$var$alpha3ToAlpha2;
/*
 * @param code Alpha-2 code
 * @return Alpha-3 code or undefined
 */ function $15e3aefa8e338b9b$var$alpha2ToAlpha3(code) {
    return $15e3aefa8e338b9b$var$alpha2[code];
}
$15e3aefa8e338b9b$export$65a456803fd0f049 = $15e3aefa8e338b9b$var$alpha2ToAlpha3;
/*
 * @param code Alpha-3 code
 * @return Numeric code or undefined
 */ function $15e3aefa8e338b9b$var$alpha3ToNumeric(code) {
    return $15e3aefa8e338b9b$var$invertedNumeric[$15e3aefa8e338b9b$var$alpha3ToAlpha2(code)];
}
$15e3aefa8e338b9b$export$442b6884bee533cd = $15e3aefa8e338b9b$var$alpha3ToNumeric;
/*
 * @param code Alpha-2 code
 * @return Numeric code or undefined
 */ function $15e3aefa8e338b9b$var$alpha2ToNumeric(code) {
    return $15e3aefa8e338b9b$var$invertedNumeric[code];
}
$15e3aefa8e338b9b$export$e8f1fd30e9fba660 = $15e3aefa8e338b9b$var$alpha2ToNumeric;
/*
 * @param code Numeric code
 * @return Alpha-3 code or undefined
 */ function $15e3aefa8e338b9b$var$numericToAlpha3(code) {
    const padded = $15e3aefa8e338b9b$var$formatNumericCode(code);
    return $15e3aefa8e338b9b$var$alpha2ToAlpha3($15e3aefa8e338b9b$var$numeric[padded]);
}
$15e3aefa8e338b9b$export$c50ba58d0968541f = $15e3aefa8e338b9b$var$numericToAlpha3;
/*
 * @param code Numeric code
 * @return Alpha-2 code or undefined
 */ function $15e3aefa8e338b9b$var$numericToAlpha2(code) {
    const padded = $15e3aefa8e338b9b$var$formatNumericCode(code);
    return $15e3aefa8e338b9b$var$numeric[padded];
}
$15e3aefa8e338b9b$export$e21a59c72a3c77a7 = $15e3aefa8e338b9b$var$numericToAlpha2;
/*
 * @param code ISO 3166-1 alpha-2, alpha-3 or numeric code
 * @return ISO 3166-1 alpha-3
 */ function $15e3aefa8e338b9b$var$toAlpha3(code) {
    if (typeof code === "string") {
        if (/^[0-9]*$/.test(code)) return $15e3aefa8e338b9b$var$numericToAlpha3(code);
        if (code.length === 2) return $15e3aefa8e338b9b$var$alpha2ToAlpha3(code.toUpperCase());
        if (code.length === 3) return code.toUpperCase();
    }
    if (typeof code === "number") return $15e3aefa8e338b9b$var$numericToAlpha3(code);
    return undefined;
}
$15e3aefa8e338b9b$export$3d1d5c3d00561285 = $15e3aefa8e338b9b$var$toAlpha3;
/*
 * @param code ISO 3166-1 alpha-2, alpha-3 or numeric code
 * @return ISO 3166-1 alpha-2
 */ function $15e3aefa8e338b9b$var$toAlpha2(code) {
    if (typeof code === "string") {
        if (/^[0-9]*$/.test(code)) return $15e3aefa8e338b9b$var$numericToAlpha2(code);
        if (code.length === 2) return code.toUpperCase();
        if (code.length === 3) return $15e3aefa8e338b9b$var$alpha3ToAlpha2(code.toUpperCase());
    }
    if (typeof code === "number") return $15e3aefa8e338b9b$var$numericToAlpha2(code);
    return undefined;
}
$15e3aefa8e338b9b$export$53e0b99b5d556acf = $15e3aefa8e338b9b$var$toAlpha2;
$15e3aefa8e338b9b$export$7d9f7e9c1c02b41e = function(code, lang, options = {}) {
    if (!("select" in options)) options.select = "official";
    try {
        const codeMaps = $15e3aefa8e338b9b$var$registeredLocales[lang.toLowerCase()];
        const nameList = codeMaps[$15e3aefa8e338b9b$var$toAlpha2(code)];
        return $15e3aefa8e338b9b$var$filterNameBy(options.select, nameList);
    } catch (err) {
        return undefined;
    }
};
$15e3aefa8e338b9b$export$dc8de070e3f64a1a = function(lang, options = {}) {
    if (!("select" in options)) options.select = "official";
    const localeList = $15e3aefa8e338b9b$var$registeredLocales[lang.toLowerCase()];
    if (localeList === undefined) return {};
    return $15e3aefa8e338b9b$var$localeFilter(localeList, function(nameList) {
        return $15e3aefa8e338b9b$var$filterNameBy(options.select, nameList);
    });
};
$15e3aefa8e338b9b$export$9abd449eff192ddc = function(name, lang) {
    const normalizeString = (string)=>string.toLowerCase();
    const areSimilar = (a, b)=>normalizeString(a) === normalizeString(b);
    try {
        const codenames = $15e3aefa8e338b9b$var$registeredLocales[lang.toLowerCase()];
        for(const p in codenames){
            if (!$15e3aefa8e338b9b$var$hasOwnProperty(codenames, p)) continue;
            if (typeof codenames[p] === "string") {
                if (areSimilar(codenames[p], name)) return p;
            }
            if (Array.isArray(codenames[p])) for (const mappedName of codenames[p]){
                if (areSimilar(mappedName, name)) return p;
            }
        }
        return undefined;
    } catch (err) {
        return undefined;
    }
};
$15e3aefa8e338b9b$export$2db6702cc2165503 = function(name, lang) {
    const normalizeString = (string)=>$15e3aefa8e338b9b$require$removeDiacritics(string.toLowerCase());
    const areSimilar = (a, b)=>normalizeString(a) === normalizeString(b);
    try {
        const codenames = $15e3aefa8e338b9b$var$registeredLocales[lang.toLowerCase()];
        for(const p in codenames){
            if (!$15e3aefa8e338b9b$var$hasOwnProperty(codenames, p)) continue;
            if (typeof codenames[p] === "string") {
                if (areSimilar(codenames[p], name)) return p;
            }
            if (Array.isArray(codenames[p])) for (const mappedName of codenames[p]){
                if (areSimilar(mappedName, name)) return p;
            }
        }
        return undefined;
    } catch (err) {
        return undefined;
    }
};
$15e3aefa8e338b9b$export$f340c49a8d00de7f = function() {
    return $15e3aefa8e338b9b$var$alpha2;
};
$15e3aefa8e338b9b$export$51175d5ff4bc4261 = function(name, lang) {
    const alpha2 = $15e3aefa8e338b9b$export$9abd449eff192ddc(name, lang);
    if (alpha2) return $15e3aefa8e338b9b$export$3d1d5c3d00561285(alpha2);
    else return undefined;
};
$15e3aefa8e338b9b$export$13496d6083a3d6ac = function(name, lang) {
    const alpha2 = $15e3aefa8e338b9b$export$2db6702cc2165503(name, lang);
    if (alpha2) return $15e3aefa8e338b9b$export$3d1d5c3d00561285(alpha2);
    else return undefined;
};
$15e3aefa8e338b9b$export$5b1d6865bbe9ebc = function() {
    return $15e3aefa8e338b9b$var$alpha3;
};
$15e3aefa8e338b9b$export$5169b68793e9dfd1 = function() {
    return $15e3aefa8e338b9b$var$numeric;
};
$15e3aefa8e338b9b$export$359be4c8544d6fb1 = function() {
    return Object.keys($15e3aefa8e338b9b$var$registeredLocales);
};
$15e3aefa8e338b9b$export$3308a67cbbb588bc = function() {
    return $ac8329aaa7c2f2a8$exports;
};
$15e3aefa8e338b9b$export$1ea939691cdc45b8 = function(code) {
    if (!code) return false;
    const coerced = code.toString().toUpperCase();
    return $15e3aefa8e338b9b$var$hasOwnProperty($15e3aefa8e338b9b$var$alpha3, coerced) || $15e3aefa8e338b9b$var$hasOwnProperty($15e3aefa8e338b9b$var$alpha2, coerced) || $15e3aefa8e338b9b$var$hasOwnProperty($15e3aefa8e338b9b$var$numeric, coerced);
};





$15e3aefa8e338b9b$export$bab6a7822cc1e2cd((parcelRequire("7GJAx")));

$15e3aefa8e338b9b$export$bab6a7822cc1e2cd((parcelRequire("hcrRu")));

$15e3aefa8e338b9b$export$bab6a7822cc1e2cd((parcelRequire("8XBG6")));

$15e3aefa8e338b9b$export$bab6a7822cc1e2cd((parcelRequire("9Vuew")));
function $093d22e30b803c56$var$dateString(date) {
    if (typeof date === "number" || typeof date === "string") date = new Date(date);
    return date.toLocaleDateString($093d22e30b803c56$export$8d41c815dd2ad610);
}
function $093d22e30b803c56$var$dateTimeString(date) {
    if (typeof date === "number" || typeof date === "string") date = new Date(date);
    return `${$093d22e30b803c56$var$dateString(date)} ${date.toLocaleTimeString($093d22e30b803c56$export$8d41c815dd2ad610)}`;
}
function $093d22e30b803c56$var$kitchenTimeString(date) {
    if (typeof date === "string") date = new Date(date);
    const hour = date.getHours().toString().padStart(2, "0");
    const minute = date.getMinutes().toString().padStart(2, "0");
    return `${hour}:${minute}`;
}
function $093d22e30b803c56$export$d6acfab709ab64b(date) {
    if (date === "") return "";
    if (typeof date === "string") date = new Date(date);
    const now = new Date();
    const elapsed = date.getTime() - now.getTime();
    const absElapsed = Math.abs(elapsed);
    const second = 1000;
    const minute = second * 60;
    const hour = minute * 60;
    const day = hour * 24;
    const month = day * 30;
    const year = month * 12;
    const rtf = new Intl.RelativeTimeFormat($093d22e30b803c56$export$8d41c815dd2ad610, {
        numeric: "auto"
    });
    if (absElapsed < minute) return rtf.format(Math.round(elapsed / second), "second");
    if (absElapsed < hour) return rtf.format(Math.round(elapsed / minute), "minute");
    if (absElapsed < day) return rtf.format(Math.round(elapsed / hour), "hour");
    if (absElapsed < month) return rtf.format(Math.round(elapsed / day), "day");
    if (absElapsed < year) return rtf.format(Math.round(elapsed / month), "month");
    return rtf.format(Math.round(elapsed / year), "year");
}
// DEPRECATED
function $093d22e30b803c56$var$string(s) {
    switch($093d22e30b803c56$export$8d41c815dd2ad610){
        case "de-DE":
            return s.deDE;
        case "fr-FR":
            return s.frFR;
        case "sv-SE":
            return s.svSE;
        default:
            return s.enGB;
    }
}
function $093d22e30b803c56$export$625550452a3fa3ec(key, replacements = {}) {
    const keyParts = key.split(".");
    let currentNode = $093d22e30b803c56$var$localeRootNode;
    while(!("en-GB" in currentNode)){
        const nextKeyPart = keyParts.shift();
        if (!nextKeyPart) throw `missing locale entry: ${key}`;
        currentNode = currentNode[nextKeyPart];
        if (!currentNode) throw `missing locale entry: ${key}`;
    }
    return ()=>{
        if (!currentNode["en-GB"]) throw "";
        let s = currentNode[$093d22e30b803c56$var$activeLocale2.val];
        Object.entries(replacements).forEach(([placeholder, value])=>{
            s = s.replaceAll(`{${placeholder}}`, value);
        });
        return s;
    };
}
async function $093d22e30b803c56$export$722fbec263ad908a() {
    const supportedLocales = [
        "de-DE",
        "en-GB",
        "fr-FR",
        "sv-SE"
    ];
    const user = await (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).getSignedInUser();
    $093d22e30b803c56$export$8d41c815dd2ad610 = supportedLocales.includes(user.Locale) ? user.Locale : "en-GB";
    $093d22e30b803c56$var$activeLocale2.val = $093d22e30b803c56$export$8d41c815dd2ad610;
    $093d22e30b803c56$export$162ce11d62a1ca51.strings = $093d22e30b803c56$var$strings[$093d22e30b803c56$export$8d41c815dd2ad610];
    document.documentElement.lang = $093d22e30b803c56$export$8d41c815dd2ad610.substring(0, 2);
}
function $093d22e30b803c56$export$21e30707d27594c3() {
    switch($093d22e30b803c56$export$8d41c815dd2ad610){
        case "de-DE":
            return [
                "Sonntag",
                "Montag",
                "Dienstag",
                "Mittwoch",
                "Donnerstag",
                "Freitag",
                "Samstag"
            ];
        case "fr-FR":
            return [
                "dimanche",
                "lundi",
                "mardi",
                "mercredi",
                "jeudi",
                "vendredi",
                "samedi"
            ];
        case "sv-SE":
            return [
                "s\xf6ndag",
                "m\xe5ndag",
                "tisdag",
                "onsdag",
                "torsdag",
                "fredag",
                "l\xf6rdag"
            ];
        default:
            return [
                "Sunday",
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday"
            ];
    }
}
let $093d22e30b803c56$export$8d41c815dd2ad610 = "en-GB";
const $093d22e30b803c56$var$activeLocale2 = (0, $259ccf8ca7c2ca99$export$2e2bcd8739ae039).state("en-GB");
const $093d22e30b803c56$var$localeRootNode = {
    configureSp2Page: {
        fotaButton: {
            latestVersion: {
                "de-DE": "Neueste Version",
                "en-GB": "Latest version",
                "fr-FR": "Derni\xe8re version",
                "sv-SE": "Senaste versionen"
            },
            update: {
                "de-DE": "Aktualisieren",
                "en-GB": "Update",
                "fr-FR": "Mettre \xe0 jour",
                "sv-SE": "Uppdatera"
            }
        },
        fotaLabel: {
            "de-DE": "Firmware",
            "en-GB": "Firmware",
            "fr-FR": "Firmware",
            "sv-SE": "Firmware"
        }
    },
    deviceCard: {
        connection: {
            "de-DE": "- Verbindung",
            "en-GB": "- Connection",
            "fr-FR": "- Connexion",
            "sv-SE": "- Anslutning"
        },
        connectionMajorDisruptions: {
            "de-DE": "Starke St\xf6rungen",
            "en-GB": "Major disruptions",
            "fr-FR": "Perturbations majeures",
            "sv-SE": "Stora st\xf6rningar"
        },
        connectionMinorDisruptions: {
            "de-DE": "Geringe St\xf6rungen",
            "en-GB": "Minor disruptions",
            "fr-FR": "Perturbations mineures",
            "sv-SE": "Mindre st\xf6rningar"
        },
        connectionReliable: {
            "de-DE": "Zuverl\xe4ssig",
            "en-GB": "Reliable",
            "fr-FR": "Fiable",
            "sv-SE": "Stabil"
        },
        lastActive: {
            "de-DE": "- Zuletzt aktiv",
            "en-GB": "- Last active",
            "fr-FR": "- Derni\xe8re activit\xe9",
            "sv-SE": "- Senast aktiv"
        }
    },
    deviceSettingsPage: {
        backButton: {
            "de-DE": "Zur\xfcck",
            "en-GB": "Back",
            "fr-FR": "Retour",
            "sv-SE": "Tillbaka"
        },
        confirmUnregistrationModal: {
            cancelButton: {
                "de-DE": "Abbrechen",
                "en-GB": "Cancel",
                "fr-FR": "Annuler",
                "sv-SE": "Avbryt"
            },
            confirmButton: {
                "de-DE": "Abmeldung",
                "en-GB": "Confirm",
                "fr-FR": "Confirmer",
                "sv-SE": "Bekr\xe4fta"
            },
            header: {
                "de-DE": "Abmeldung best\xe4tigen",
                "en-GB": "Confirm unregistration",
                "fr-FR": "Confirmer la d\xe9sinscription",
                "sv-SE": "Bekr\xe4fta avregistrering"
            }
        },
        nameLabel: {
            "de-DE": "Name",
            "en-GB": "Name",
            "fr-FR": "Nom",
            "sv-SE": "Namn"
        },
        ownerLabel: {
            "de-DE": "Eigent\xfcmer",
            "en-GB": "Owner",
            "fr-FR": "Propri\xe9taire",
            "sv-SE": "\xc4gare"
        },
        saveButton: {
            "de-DE": "Speichern",
            "en-GB": "Save",
            "fr-FR": "Enregistrer",
            "sv-SE": "Spara"
        },
        sharingField: {
            inviteButton: {
                "de-DE": "Einladen",
                "en-GB": "Invite",
                "fr-FR": "Inviter",
                "sv-SE": "Bjud in"
            },
            label: {
                "de-DE": "Teilen",
                "en-GB": "Sharing",
                "fr-FR": "Partage",
                "sv-SE": "Delning"
            }
        },
        subscriptionLabel: {
            "de-DE": "Abonnement",
            "en-GB": "Subscription",
            "fr-FR": "Abonnement",
            "sv-SE": "Abonnemang"
        },
        tagsField: {
            addButton: {
                "de-DE": "Hinzuf\xfcgen",
                "en-GB": "Add",
                "fr-FR": "Ajouter",
                "sv-SE": "L\xe4gg till"
            },
            label: {
                "de-DE": "Tags",
                "en-GB": "Tags",
                "fr-FR": "Mots-cl\xe9s",
                "sv-SE": "Taggar"
            }
        },
        unregisterButton: {
            "de-DE": "Registrierung aufheben",
            "en-GB": "Unregister",
            "fr-FR": "D\xe9senregistrer",
            "sv-SE": "Avregistrera"
        }
    },
    deviceUnregistrationDisclaimer: {
        "de-DE": "Durch Klicken auf \u201EBest\xe4tigen\u201C erkl\xe4ren Sie sich damit einverstanden, dieses Ger\xe4t von Ihrem Konto abzumelden, und dass jegliche verbleibende Abonnementlaufzeit oder andere kostenpflichtige Funktionen, die mit diesem Ger\xe4t verkn\xfcpft sind, mit sofortiger Wirkung und ohne Entsch\xe4digung verloren gehen.",
        "en-GB": "By clicking confirm you acknowledge that you wish to unregister this device from your account and that any remaining subscription time or other paid for features associated with this device will be lost without compensation with immediate effect.",
        "fr-FR": "En cliquant sur confirmer, vous reconnaissez que vous souhaitez d\xe9senregistrer cet appareil de votre compte et que toute p\xe9riode d'abonnement restante ou autre fonctionnalit\xe9 payante associ\xe9e \xe0 cet appareil sera perdue sans compensation avec effet imm\xe9diat.",
        "sv-SE": "Genom att klicka p\xe5 bekr\xe4fta godk\xe4nner du att du vill avregistrera denna enhet fr\xe5n ditt konto och att eventuell \xe5terst\xe5ende prenumerationstid eller andra betalda funktioner kopplade till denna enhet g\xe5r f\xf6rlorade med omedelbar verkan utan ers\xe4ttning."
    },
    loadingScreen: {
        abortButton: {
            "de-DE": "Abbrechen",
            "en-GB": "Abort",
            "fr-FR": "Annuler",
            "sv-SE": "Avbryt"
        }
    },
    price: {
        monthly: {
            "de-DE": "{price} {currency} pro Monat ohne MwSt",
            "en-GB": "{price} {currency} per month ex VAT",
            "fr-FR": "{price} {currency} par mois hors tva",
            "sv-SE": "{price} {currency} per m\xe5nad ex moms"
        },
        yearly: {
            "de-DE": "{price} {currency} pro Jahr ohne MwSt",
            "en-GB": "{price} {currency} per year ex VAT",
            "fr-FR": "{price} {currency} par an hors tva",
            "sv-SE": "{price} {currency} per \xe5r ex moms"
        }
    },
    sp2Card: {
        off: {
            "de-DE": "Aus",
            "en-GB": "Off",
            "fr-FR": "\xc9teint",
            "sv-SE": "Av"
        },
        on: {
            "de-DE": "Ein",
            "en-GB": "On",
            "fr-FR": "Allum\xe9",
            "sv-SE": "P\xe5"
        },
        power: {
            "de-DE": "- Leistung",
            "en-GB": "- Power",
            "fr-FR": "- Puissance",
            "sv-SE": "- Str\xf6m"
        }
    },
    sp2LogsPage: {
        backButton: {
            "de-DE": "Zur\xfcck",
            "en-GB": "Back",
            "fr-FR": "Retour",
            "sv-SE": "Tillbaka"
        },
        consumptionHeader: {
            "de-DE": "Verbrauch",
            "en-GB": "Consumption",
            "fr-FR": "Consommation",
            "sv-SE": "F\xf6rbrukning"
        },
        loadHeader: {
            "de-DE": "Stromlast",
            "en-GB": "Power load",
            "fr-FR": "Charge \xe9lectrique",
            "sv-SE": "Belastning"
        }
    },
    sp2SettingsPage: {
        consumptionField: {
            label: {
                "de-DE": "Verbrauch",
                "en-GB": "Consumption",
                "fr-FR": "Consommation",
                "sv-SE": "F\xf6rbrukning"
            },
            resetButton: {
                "de-DE": "Zur\xfccksetzen",
                "en-GB": "Reset",
                "fr-FR": "R\xe9initialiser",
                "sv-SE": "\xc5terst\xe4ll"
            }
        },
        createTimerRuleModal: {
            actionLabel: {
                "de-DE": "Aktion",
                "en-GB": "Action",
                "fr-FR": "Action",
                "sv-SE": "\xc5tg\xe4rd"
            },
            actionOptions: {
                turnOff: {
                    "de-DE": "Ausschalten",
                    "en-GB": "Turn off",
                    "fr-FR": "\xc9teindre",
                    "sv-SE": "St\xe4ng av"
                },
                turnOn: {
                    "de-DE": "Einschalten",
                    "en-GB": "Turn on",
                    "fr-FR": "Allumer",
                    "sv-SE": "S\xe4tt p\xe5"
                }
            },
            cancelButton: {
                "de-DE": "Abbrechen",
                "en-GB": "Cancel",
                "fr-FR": "Annuler",
                "sv-SE": "Avbryt"
            },
            createButton: {
                "de-DE": "Erstellen",
                "en-GB": "Create",
                "fr-FR": "Cr\xe9er",
                "sv-SE": "Skapa"
            },
            daysLabel: {
                "de-DE": "Tage",
                "en-GB": "Days",
                "fr-FR": "Jours",
                "sv-SE": "Dagar"
            },
            header: {
                "de-DE": "Timer-Regel erstellen",
                "en-GB": "Create timer rule",
                "fr-FR": "Cr\xe9er une r\xe8gle de minuterie",
                "sv-SE": "Skapa timerregel"
            },
            timeLabel: {
                "de-DE": "Zeit",
                "en-GB": "Time",
                "fr-FR": "Temps",
                "sv-SE": "Tid"
            }
        },
        deviceBeepLabel: {
            "de-DE": "Ger\xe4te-Piepton",
            "en-GB": "Device beep",
            "fr-FR": "Bip de l'appareil",
            "sv-SE": "Enhetspipljud"
        },
        powerFailureLabel: {
            "de-DE": "Stromausfall-Benachrichtigungen",
            "en-GB": "Power failure notifications",
            "fr-FR": "Notifications de coupure de courant",
            "sv-SE": "Str\xf6mavbrottsaviseringar"
        },
        powerLoadLabel: {
            "de-DE": "Stromlast-Benachrichtigungen",
            "en-GB": "Power load notifications",
            "fr-FR": "Notifications de charge \xe9lectrique",
            "sv-SE": "Belastningsnotiser"
        },
        timerField: {
            createRuleButton: {
                "de-DE": "Regel erstellen",
                "en-GB": "Create rule",
                "fr-FR": "Cr\xe9er une r\xe8gle",
                "sv-SE": "Skapa regel"
            },
            label: {
                "de-DE": "Timer",
                "en-GB": "Timer",
                "fr-FR": "Minuteur",
                "sv-SE": "Timer"
            },
            ruleTableActions: {
                turnOff: {
                    "de-DE": "Ausschalten",
                    "en-GB": "Turn off",
                    "fr-FR": "\xc9teindre",
                    "sv-SE": "St\xe4ng av"
                },
                turnOn: {
                    "de-DE": "Einschalten",
                    "en-GB": "Turn on",
                    "fr-FR": "Allumer",
                    "sv-SE": "S\xe4tt p\xe5"
                }
            }
        }
    }
};
// DEPRECATED
const $093d22e30b803c56$var$strings = {
    "de-DE": {
        add: "Hinzuf\xfcgen",
        back: "Zur\xfcck",
        billing: "Abrechnung",
        cancel: "Abbrechen",
        confirm: "Best\xe4tigen",
        country: "Land",
        createAccount: "Konto erstellen",
        dateOfPurchase: "Kaufdatum",
        done: "Fertig",
        edit: "Bearbeiten",
        email: "E-Mail",
        friday: "Freitag",
        language: "Sprache",
        monday: "Montag",
        name: "Name",
        none: "Keine",
        off: "Aus",
        on: "Ein",
        owner: "Besitzer",
        password: "Passwort",
        phone: "Telefon",
        product: "Produkt",
        proofOfPurchase: "Kaufbeleg",
        register: "Registrieren",
        resetPassword: "Passwort zur\xfccksetzen",
        retailer: "H\xe4ndler",
        saturday: "Samstag",
        save: "Speichern",
        serialNumber: "Seriennummer",
        signIn: "Anmelden",
        subscription: "Abonnement",
        sunday: "Sonntag",
        tags: "Tags",
        thursday: "Donnerstag",
        trial: "Probeabonnement",
        tuesday: "Dienstag",
        turnOff: "Schalte aus",
        turnOn: "Schalte ein",
        unregister: "Abmelden",
        verificationCode: "Verifizierungscode",
        verifyAccount: "Konto verifizieren",
        voltage: "Voltage",
        wednesday: "Mittwoch",
        warranties: "Garantien"
    },
    "en-GB": {
        add: "Add",
        back: "Back",
        billing: "Billing",
        cancel: "Cancel",
        confirm: "Confirm",
        country: "Country",
        createAccount: "Create account",
        dateOfPurchase: "Date of purchase",
        done: "Done",
        edit: "Edit",
        email: "Email",
        friday: "Friday",
        language: "Language",
        monday: "Monday",
        name: "Name",
        none: "None",
        off: "Off",
        on: "On",
        owner: "Owner",
        password: "Password",
        phone: "Phone",
        product: "Product",
        proofOfPurchase: "Proof of purchase",
        register: "Register",
        resetPassword: "Reset password",
        retailer: "Retailer",
        saturday: "Saturday",
        save: "Save",
        serialNumber: "Serial number",
        signIn: "Sign in",
        subscription: "Subscription",
        sunday: "Sunday",
        tags: "Tags",
        thursday: "Thursday",
        trial: "Trial",
        tuesday: "Tuesday",
        turnOff: "Turn off",
        turnOn: "Turn on",
        unregister: "Unregister",
        verificationCode: "Verification code",
        verifyAccount: "Verify account",
        voltage: "Voltage",
        warranties: "Warranties",
        wednesday: "Wednesday"
    },
    "fr-FR": {
        add: "Ajouter",
        back: "Retour",
        billing: "Facturation",
        cancel: "Annuler",
        confirm: "Confirmer",
        country: "Pays",
        createAccount: "Cr\xe9er un compte",
        dateOfPurchase: "Date d'achat",
        done: "Termin\xe9",
        edit: "\xc9diter",
        email: "E-mail",
        friday: "Vendredi",
        language: "Langue",
        monday: "Lundi",
        name: "Nom",
        none: "Aucun",
        off: "\xc9teint",
        on: "Allum\xe9",
        owner: "Propri\xe9taire",
        password: "Mot de passe",
        phone: "T\xe9l\xe9phone",
        product: "Produit",
        proofOfPurchase: "Preuve d'achat",
        register: "S'inscrire",
        retailer: "D\xe9taillant",
        resetPassword: "R\xe9initialiser le mot de passe",
        saturday: "Samedi",
        save: "Enregistrer",
        serialNumber: "Num\xe9ro de s\xe9rie",
        signIn: "Se connecter",
        subscription: "Abonnement",
        sunday: "Dimanche",
        tags: "\xc9tiquettes",
        thursday: "Jeudi",
        trial: "Essai",
        tuesday: "Mardi",
        turnOff: "\xc9teins",
        turnOn: "Allume",
        unregister: "Se d\xe9sinscrire",
        verificationCode: "Code de v\xe9rification",
        verifyAccount: "V\xe9rifier le compte",
        voltage: "Tension",
        warranties: "Garanties",
        wednesday: "Mercredi"
    },
    "sv-SE": {
        add: "L\xe4gg till",
        back: "Tillbaka",
        billing: "Betalning",
        cancel: "Avbryt",
        confirm: "Bekr\xe4fta",
        country: "Land",
        createAccount: "Skapa konto",
        dateOfPurchase: "Ink\xf6psdatum",
        done: "Klar",
        edit: "Redigera",
        email: "E-post",
        friday: "Fredag",
        language: "Spr\xe5k",
        monday: "M\xe5ndag",
        name: "Namn",
        none: "Ingen",
        off: "Av",
        on: "P\xe5",
        owner: "\xc4gare",
        password: "L\xf6senord",
        phone: "Telefon",
        product: "Produkt",
        proofOfPurchase: "Ink\xf6psbevis",
        register: "Registrera",
        resetPassword: "\xc5terst\xe4ll l\xf6senord",
        retailer: "\xc5terf\xf6rs\xe4ljare",
        saturday: "L\xf6rdag",
        save: "Spara",
        serialNumber: "Serienummer",
        signIn: "Logga in",
        subscription: "Prenumeration",
        sunday: "S\xf6ndag",
        tags: "Taggar",
        thursday: "Torsdag",
        trial: "Provperiod",
        tuesday: "Tisdag",
        turnOff: "St\xe4ng av",
        turnOn: "S\xe4tt p\xe5",
        unregister: "Avregistrera",
        verificationCode: "Verifikationskod",
        verifyAccount: "Verifiera konto",
        voltage: "Sp\xe4nning",
        warranties: "Garantier",
        wednesday: "Onsdag"
    }
};
const $093d22e30b803c56$export$162ce11d62a1ca51 = {
    countries: $15e3aefa8e338b9b$exports,
    dateString: $093d22e30b803c56$var$dateString,
    dateTimeString: $093d22e30b803c56$var$dateTimeString,
    kitchenTimeString: $093d22e30b803c56$var$kitchenTimeString,
    id: $093d22e30b803c56$export$8d41c815dd2ad610,
    string: $093d22e30b803c56$var$string,
    strings: $093d22e30b803c56$var$strings[$093d22e30b803c56$export$8d41c815dd2ad610],
    update: $093d22e30b803c56$export$722fbec263ad908a,
    weekdays: $093d22e30b803c56$export$21e30707d27594c3
};



/**
 * @typedef {Object} AnchorConfig
 * @property {string} [href]
 * @property {(event: MouseEvent) => void} [onClick]
 * @property {"_blank"} [target]
 * 
 * @param {AnchorConfig} cfg 
 * @param {...(HTMLElement|string)} children
 */ function $00995e7d83a33b33$var$anchor(cfg, ...children) {
    const anchor1 = document.createElement("a");
    anchor1.append(...children);
    if (cfg.href) anchor1.href = cfg.href;
    if (cfg.onClick) anchor1.onclick = cfg.onClick;
    if (cfg.target) anchor1.target = cfg.target;
    return anchor1;
}
/**
 * @param {HTMLAnchorElement|string} child 
 * @returns {HTMLLIElement}
 */ function $00995e7d83a33b33$var$listItem(child) {
    const li = document.createElement("li");
    li.append(child);
    return li;
}
/**
 * @param {string} text 
 */ function $00995e7d83a33b33$var$paragraph(text) {
    const p = document.createElement("p");
    p.append(text);
    return p;
}
/**
 * @param  {...(HTMLAnchorElement|string)} children
 */ function $00995e7d83a33b33$var$unorderedList(...children) {
    const ul = document.createElement("ul");
    ul.replaceChildren(...children.map((c)=>$00995e7d83a33b33$var$listItem(c)));
    /**
     * @param {string} text 
     */ function append(text) {
        ul.appendChild($00995e7d83a33b33$var$listItem(text));
    }
    return {
        append: append,
        element: ul
    };
}
const $00995e7d83a33b33$export$13f9d3c4397c4713 = {
    anchor: $00995e7d83a33b33$var$anchor,
    paragraph: $00995e7d83a33b33$var$paragraph,
    unorderedList: $00995e7d83a33b33$var$unorderedList
};


/**
 * @typedef {Object} IconConfig
 * @property {"add"|"add_circle"|"barcode"|"close"|"content_copy"|"done"|"edit"|"error"|"flash_off"|"flash_on"|"help"|"hide"|"info"|"monitoring"|"notifications"|"notifications_off"|"qr_code_2"|"remove"|"settings"|"show"|"star"|"upload"|"visibility"|"visibility_off"} id
 * @property {"left"|"right"} [alignment]
 * @property {boolean} [flashing]
 * @property {boolean} [hidden]
 * @property {(event: MouseEvent) => void} [onClick]
 * @property {1|2|3|4|5|6|7} [size]
 *
 * @param {IconConfig} cfg
 */ function $1abc8d719eea79cd$var$icon(cfg) {
    const icon = document.createElement("span");
    icon.className = "material-symbols-sharp";
    icon.textContent = cfg.id;
    if (cfg.flashing) icon.classList.add("flashing");
    if (cfg.onClick) {
        icon.onclick = cfg.onClick;
        icon.style.cursor = "pointer";
    } else icon.style.cursor = "default";
    if (cfg.size) icon.classList.add(`is-size-${cfg.size}`);
    const container = document.createElement("span");
    container.className = "icon";
    container.append(icon);
    if (cfg.alignment) container.classList.add(`is-${cfg.alignment}`);
    if (cfg.hidden) container.classList.add("is-hidden");
    switch(cfg.size){
        case 7:
        case 6:
            container.classList.add("is-small"); // 1x1 rem
        case 5:
        case 4:
            break; // 1.5x1.5 rem
        case 3:
            container.classList.add("is-medium"); // 2x2 rem
        case 2:
        case 1:
            container.classList.add("is-large"); // 3x3 rem
    }
    return container;
}
const $1abc8d719eea79cd$export$e1dd10d13c5a06 = {
    icon: $1abc8d719eea79cd$var$icon
};


/**
 * @param {...Node} children
 */ function $6d068560d6a0dc33$var$box(...children) {
    const box1 = document.createElement("div");
    box1.className = "box";
    box1.append(...children);
    return box1;
}
/**
 * @param  {...HTMLAnchorElement} children
 */ function $6d068560d6a0dc33$var$breadcrumb(...children) {
    children[children.length - 1].classList.add("is-active");
    const breadcrumbs = document.createElement("nav");
    breadcrumbs.className = "breadcrumb";
    breadcrumbs.append((0, $00995e7d83a33b33$export$13f9d3c4397c4713).unorderedList(...children).element);
    return breadcrumbs;
}
/**
 * @typedef {Object} ButtonConfig
 * @property {boolean} [disabled]
 * @property {("is-danger"|"is-fullwidth"|"is-light"|"is-primary"|"is-small")[]} [styles]
 * @property {(event: MouseEvent) => void} [onClick]
 *
 * @param {ButtonConfig} cfg
 * @param {...(Node|string)} children
 */ function $6d068560d6a0dc33$var$button(cfg, ...children) {
    const button1 = document.createElement("button");
    button1.className = "button";
    button1.append(...children);
    if (cfg.disabled) button1.disabled = cfg.disabled;
    if (cfg.styles) cfg.styles.forEach((style)=>{
        button1.classList.add(style);
    });
    if (cfg.onClick) button1.onclick = cfg.onClick;
    return button1;
}
/**
 * @param  {...HTMLButtonElement} buttons
 */ function $6d068560d6a0dc33$var$buttons(...buttons1) {
    const div = document.createElement("div");
    div.className = "buttons";
    div.append(...buttons1);
    return div;
}
/**
 * @param {...HTMLElement} children
 */ function $6d068560d6a0dc33$var$card(...children) {
    const card1 = document.createElement("div");
    card1.className = "card";
    card1.append(...children);
    return card1;
}
/**
 * @param  {...HTMLElement} children
 */ function $6d068560d6a0dc33$var$cardContent(...children) {
    const content = document.createElement("div");
    content.className = "card-content";
    content.append(...children);
    return content;
}
/**
 * @typedef {Object} CardFooterConfig
 * @property {DeviceType} [color]
 *
 * @param {CardFooterConfig} cfg
 * @param  {...HTMLAnchorElement} children
 */ function $6d068560d6a0dc33$var$cardFooter(cfg, ...children) {
    const footer = document.createElement("footer");
    footer.className = "card-footer";
    footer.append(...children);
    children.forEach((a)=>{
        a.classList.add("card-footer-item");
    });
    if (cfg.color) footer.classList.add(cfg.color);
    return footer;
}
/**
 * @typedef {Object} CardHeaderConfig
 * @property {DeviceType} [color]
 * @property {(event: MouseEvent) => void} [onClick]
 *
 * @param {CardHeaderConfig} cfg
 * @param  {...HTMLElement} children
 * @returns
 */ function $6d068560d6a0dc33$var$cardHeader(cfg, ...children) {
    const header = document.createElement("header");
    header.className = "card-header p-2";
    header.append(...children);
    if (cfg.color) header.classList.add(cfg.color);
    if (cfg.onClick) {
        header.classList.add("is-clickable");
        header.onclick = cfg.onClick;
    }
    return header;
}
/**
 * @param {HTMLSpanElement} icon
 */ function $6d068560d6a0dc33$var$cardHeaderIcon(icon) {
    const button = document.createElement("button");
    button.className = "card-header-icon";
    button.append(icon);
    return button;
}
/**
 * @param {string} text
 */ function $6d068560d6a0dc33$var$cardHeaderTitle(text) {
    const p = document.createElement("p");
    p.className = "card-header-title";
    p.append(text);
    return p;
}
/**
 * @typedef {Object} CheckboxConfig
 * @property {string} [text]
 * @property {boolean} [checked]
 * @property {boolean} [disabled]
 *
 * @param {CheckboxConfig} cfg
 */ function $6d068560d6a0dc33$var$checkbox(cfg) {
    const checkbox = document.createElement("input");
    checkbox.type = "checkbox";
    if (cfg.checked) checkbox.checked = cfg.checked;
    if (cfg.disabled) checkbox.classList.add("is-disabled");
    const label = document.createElement("label");
    label.className = "checkbox";
    label.append(checkbox);
    if (cfg.text) label.append(` ${cfg.text}`);
    return {
        element: label,
        isChecked: ()=>checkbox.checked,
        /** @type {(checked: boolean) => void} */ setChecked: (checked)=>{
            checkbox.checked = checked;
        }
    };
}
/**
 *
 * @param {...HTMLLabelElement} children
 */ function $6d068560d6a0dc33$var$checkboxes(...children) {
    const div = document.createElement("div");
    div.className = "checkboxes";
    div.append(...children);
    return div;
}
/**
 * @typedef {Object} ColumnConfig
 * @property {ColumnSize[]} [classList]
 *
 * @param {ColumnConfig} cfg
 * @param {...Node} children
 */ function $6d068560d6a0dc33$var$column(cfg, ...children) {
    const column1 = document.createElement("div");
    column1.className = "column";
    column1.append(...children);
    if (cfg.classList) cfg.classList.forEach((c)=>{
        column1.classList.add(c);
    });
    return column1;
}
/**
 * @typedef {Object} ColumnsConfig
 * @property {boolean} [isCentered]
 * @property {boolean} [isMobile]
 * @property {boolean} [isMultiline]
 *
 * @param {ColumnsConfig} cfg
 * @param {...HTMLDivElement} children
 */ function $6d068560d6a0dc33$var$columns(cfg, ...children) {
    const columns1 = document.createElement("div");
    columns1.className = "columns";
    columns1.append(...children);
    if (cfg.isCentered) columns1.classList.add("is-centered");
    if (cfg.isMobile) columns1.classList.add("is-mobile");
    if (cfg.isMultiline) columns1.classList.add("is-multiline");
    return columns1;
}
/**
 *
 * @param  {...HTMLElement} children
 * @returns
 */ function $6d068560d6a0dc33$var$container(...children) {
    const container1 = document.createElement("div");
    container1.className = "container is-fluid";
    container1.append(...children);
    return container1;
}
/**
 * @typedef {Object} ControlConfig
 * @property {boolean} [hidden]
 * @property {("has-icons-left"|"has-icons-right"|"is-expanded")[]} [styles]
 *
 * @param {ControlConfig} cfg
 * @param {...Node} children
 */ function $6d068560d6a0dc33$var$control(cfg, ...children) {
    const control1 = document.createElement("div");
    control1.className = "control";
    control1.append(...children);
    if (cfg.hidden) control1.classList.add("is-hidden");
    if (cfg.styles) cfg.styles.forEach((style)=>{
        control1.classList.add(style);
    });
    return control1;
}
/**
 * @typedef {Object} DateInputConfig
 * @property {(event: Event) => void} [onChange]
 *
 * @param {DateInputConfig} cfg
 */ function $6d068560d6a0dc33$var$dateInput(cfg) {
    const input = document.createElement("input");
    input.type = "date";
    input.className = "input";
    input.value = new Date().toISOString().split("T").shift() || "";
    if (cfg.onChange) input.onchange = cfg.onChange;
    return {
        element: input,
        getDate: ()=>new Date(`${input.value}T00:00`)
    };
}
/**
 * @param {(event: MouseEvent) => void} onClick
 * @param {""|"is-small"|"is-medium"|"is-large"} [size=""]
 */ function $6d068560d6a0dc33$var$deleteButton(onClick, size = "") {
    const button = document.createElement("button");
    button.className = "delete";
    button.onclick = onClick;
    if (size) button.classList.add(size);
    return button;
}
/**
 * @typedef {Object} FieldConfig
 * @property {("has-addons"|"has-addons-right"|"is-grouped"|"is-grouped-multiline"|"is-hidden")[]} [styles]
 *
 * @param {FieldConfig} cfg
 * @param {...Node} children
 */ function $6d068560d6a0dc33$var$field(cfg, ...children) {
    const field1 = document.createElement("div");
    field1.className = "field";
    if (cfg.styles) cfg.styles.forEach((style)=>{
        field1.classList.add(style);
    });
    field1.append(...children);
    return field1;
}
function $6d068560d6a0dc33$var$fileInput() {
    const fileName = document.createElement("span");
    fileName.className = "file-name";
    const fileCta = document.createElement("span");
    fileCta.className = "file-cta";
    fileCta.append((0, $1abc8d719eea79cd$export$e1dd10d13c5a06).icon({
        id: "upload"
    }));
    const fileInput = document.createElement("input");
    fileInput.className = "file-input";
    fileInput.type = "file";
    fileInput.oninput = ()=>{
        if (!fileInput.files) return;
        if (fileInput.files.length < 1) return;
        fileName.textContent = fileInput.files[0].name;
    };
    const fileLabel = document.createElement("label");
    fileLabel.className = "file-label";
    fileLabel.append(fileInput, fileCta, fileName);
    const fileInputContainer = document.createElement("div");
    fileInputContainer.className = "file has-name is-fullwidth";
    fileInputContainer.append(fileLabel);
    const getBase64 = async ()=>new Promise((resolve, reject)=>{
            if (!fileInput.files) return;
            if (fileInput.files.length < 1) return;
            const reader = new FileReader();
            reader.onloadend = ()=>{
                if (reader.readyState !== FileReader.DONE) reject();
                else if (typeof reader.result !== "string") reject();
                else resolve(reader.result.split(",")[1]);
            };
            reader.onerror = reject;
            reader.readAsDataURL(fileInput.files[0]);
        });
    return {
        element: fileInputContainer,
        getBase64: getBase64
    };
}
/**
 * @param  {...Node} children
 */ function $6d068560d6a0dc33$var$hero(...children) {
    const hero1 = document.createElement("section");
    hero1.className = "hero is-fullheight-with-navbar";
    hero1.append(...children);
    return hero1;
}
/**
 * @param {string} [text=""]
 */ function $6d068560d6a0dc33$var$help(text = "") {
    const p = document.createElement("p");
    p.className = "help";
    p.append(text);
    return p;
}
/**
 * @typedef {Object} InputConfig
 * @property {"email"|"password"|"tel"|"text"} type
 * @property {boolean} [isReadonly]
 * @property {(event: Event) => void} [onInput]
 * @property {string} [placeholder]
 * @property {("is-static")[]} [styles]
 * @property {string} [value]
 *
 * @param {InputConfig} cfg
 */ function $6d068560d6a0dc33$var$input(cfg) {
    const input = document.createElement("input");
    input.className = "input";
    input.type = cfg.type;
    if (cfg.isReadonly) input.setAttribute("readonly", "");
    if (cfg.onInput) input.addEventListener("input", cfg.onInput);
    if (cfg.placeholder) input.placeholder = cfg.placeholder;
    if (cfg.styles) cfg.styles.forEach((style)=>{
        input.classList.add(style);
    });
    if (cfg.value) input.value = cfg.value;
    /**
	 * @param {string} v
	 */ const setValue = (v)=>{
        input.value = v;
    };
    return {
        element: input,
        getValue: ()=>input.value,
        setValue: setValue
    };
}
/**
 * @param {string} text
 */ function $6d068560d6a0dc33$var$label(text) {
    const label = document.createElement("label");
    label.className = "label";
    label.textContent = text;
    return label;
}
/**
 * @param {...HTMLDivElement} children
 */ function $6d068560d6a0dc33$var$level(...children) {
    const level1 = document.createElement("div");
    level1.className = "level is-mobile";
    level1.append(...children);
    return level1;
}
/**
 * @param  {...HTMLElement} children
 */ function $6d068560d6a0dc33$var$levelItem(...children) {
    const div = document.createElement("div");
    div.append(...children);
    const item = document.createElement("div");
    item.className = "level-item";
    item.append(div);
    return item;
}
/**
 * @param  {...HTMLElement} children
 */ function $6d068560d6a0dc33$var$levelLeft(...children) {
    const left = document.createElement("div");
    left.className = "level-left";
    left.append(...children);
    return left;
}
/**
 * @param  {...HTMLElement} children
 */ function $6d068560d6a0dc33$var$levelRight(...children) {
    const right = document.createElement("div");
    right.className = "level-right";
    right.append(...children);
    return right;
}
/**
 * @typedef {Object} MediaConfig
 * @property {HTMLElement} [image]
 * @property {HTMLElement[]} [content]
 * @property {HTMLElement[]} [right]
 *
 * @param {MediaConfig} cfg
 */ function $6d068560d6a0dc33$var$media(cfg) {
    const media = document.createElement("div");
    media.className = "media";
    if (cfg.image) {
        const left = document.createElement("figure");
        left.className = "media-left";
        left.append(cfg.image);
        media.append(left);
    }
    if (cfg.content) {
        const content = document.createElement("div");
        content.className = "media-content";
        content.append(...cfg.content);
        media.append(content);
    }
    if (cfg.right) {
        const right = document.createElement("div");
        right.className = "media-right";
        right.append(...cfg.right);
        media.append(right);
    }
    return media;
}
function $6d068560d6a0dc33$var$modalCard() {
    const closeModal = ()=>modal.classList.remove("is-active");
    const card = document.createElement("div");
    card.className = "modal-card";
    const background = document.createElement("div");
    background.className = "modal-background";
    background.onclick = closeModal;
    const modal = document.createElement("div");
    modal.className = "modal";
    modal.append(background, card);
    /**
	 * @typedef {Object} ModalCardConfig
	 * @property {string} header
	 * @property {HTMLElement[]} body
	 * @property {HTMLButtonElement[]} footer
	 *
	 * @param {ModalCardConfig} cfg
	 */ const open = (cfg)=>{
        const title = document.createElement("p");
        title.className = "modal-card-title";
        title.append(cfg.header);
        const header = document.createElement("header");
        header.className = "modal-card-head";
        header.append(title, $6d068560d6a0dc33$var$deleteButton(closeModal));
        const body = document.createElement("section");
        body.className = "modal-card-body";
        body.append(...cfg.body);
        const footer = document.createElement("footer");
        footer.className = "modal-card-foot";
        footer.append($6d068560d6a0dc33$var$buttons(...cfg.footer));
        card.replaceChildren(header, body, footer);
        modal.classList.add("is-active");
    };
    return {
        element: modal,
        open: open,
        close: closeModal
    };
}
/**
 * @typedef {Object} NavbarConfig
 * @property {string} theme
 * @property {(HTMLAnchorElement|HTMLDivElement)[]} brand
 * @property {(HTMLAnchorElement|HTMLDivElement)[]} start
 * @property {(HTMLAnchorElement|HTMLDivElement)[]} end
 */ /**
 * @param {NavbarConfig} cfg
 */ function $6d068560d6a0dc33$var$navbar(cfg) {
    const navbarStart = document.createElement("div");
    navbarStart.className = "navbar-start";
    navbarStart.append(...cfg.start);
    const navbarEnd = document.createElement("div");
    navbarEnd.className = "navbar-end";
    navbarEnd.append(...cfg.end);
    // -----------------------------------------------
    const navbarMenu = document.createElement("div");
    navbarMenu.className = "navbar-menu";
    navbarMenu.append(navbarStart, navbarEnd);
    // -----------------------------------------------
    const navbarBurger = document.createElement("a");
    navbarBurger.className = "navbar-burger";
    navbarBurger.append($6d068560d6a0dc33$var$navbarItem({}, (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
        enGB: "Menu",
        deDE: "Men\xfc",
        frFR: "Menu",
        svSE: "Meny"
    })));
    navbarBurger.onclick = ()=>{
        navbarBurger.classList.toggle("is-active");
        navbarMenu.classList.toggle("is-active");
    };
    const navbarBrand = document.createElement("div");
    navbarBrand.className = "navbar-brand";
    navbarBrand.append(...cfg.brand, navbarBurger);
    // -----------------------------------------------
    const navbar = document.createElement("nav");
    navbar.className = `navbar is-fixed-top ${cfg.theme}`;
    navbar.append(navbarBrand, navbarMenu);
    return navbar;
}
/**
 * @param {string} text
 * @param  {...HTMLAnchorElement} items
 */ function $6d068560d6a0dc33$var$navbarDropdown(text, ...items) {
    const link = document.createElement("a");
    link.className = "navbar-link";
    link.textContent = text;
    const dropdown = document.createElement("div");
    dropdown.className = "navbar-dropdown";
    dropdown.append(...items);
    const item = document.createElement("div");
    item.className = "navbar-item has-dropdown is-hoverable";
    item.append(link, dropdown);
    return item;
}
/**
 * @typedef {Object} NavbarAnchorItemConfig
 * @property {boolean} [active]
 * @property {boolean} [hidden]
 * @property {string} [href]
 * @property {(event: MouseEvent) => void} [onClick]
 * @property {"_blank"} [target]
 *
 * @param {NavbarAnchorItemConfig} cfg
 * @param  {...(HTMLElement|string)} children
 */ function $6d068560d6a0dc33$var$navbarItem(cfg, ...children) {
    const item = document.createElement("a");
    item.className = "navbar-item";
    item.append(...children);
    if (cfg.active) item.classList.add("is-active");
    if (cfg.hidden) item.classList.add("is-hidden");
    if (cfg.href) item.href = cfg.href;
    if (cfg.onClick) item.onclick = cfg.onClick;
    if (cfg.target) item.target = cfg.target;
    return item;
}
/**
 * @param {string} text
 * @param {string} value
 * @param {boolean} [selected=false]
 */ function $6d068560d6a0dc33$var$option(text, value, selected = false) {
    const option1 = document.createElement("option");
    option1.textContent = text;
    option1.value = value;
    option1.selected = selected;
    return option1;
}
/**
 * @typedef {Object} SectionConfig
 * @property {boolean} [hidden]
 *
 * @param {SectionConfig} cfg
 * @param  {...HTMLElement} children
 */ function $6d068560d6a0dc33$var$section(cfg, ...children) {
    const section1 = document.createElement("section");
    section1.className = "section";
    section1.append(...children);
    if (cfg.hidden) section1.classList.add("is-hidden");
    return section1;
}
/**
 * @typedef {Object} SelectConfig
 * @property {HTMLOptionElement[]} options
 * @property {boolean} [disabled]
 * @property {("is-fullwidth")[]} [styles]
 * @property {() => void} [onInput]
 *
 * @param {SelectConfig} cfg
 */ function $6d068560d6a0dc33$var$select(cfg) {
    const select = document.createElement("select");
    select.append(...cfg.options);
    if (cfg.disabled) select.disabled = cfg.disabled;
    if (cfg.onInput) select.oninput = cfg.onInput;
    const container = document.createElement("div");
    container.className = "select";
    container.append(select);
    if (cfg.styles) cfg.styles.forEach((style)=>{
        container.classList.add(style);
    });
    /**
	 * @param {string} v
	 */ function setValue(v) {
        select.value = v;
    }
    return {
        element: container,
        getValue: ()=>select.value,
        setValue: setValue
    };
}
/**
 * @param {string} text
 * @param {"is-1"|"is-2"|"is-3"|"is-4"|"is-5"|"is-6"} [size="is-3"]
 */ function $6d068560d6a0dc33$var$subtitle(text, size = "is-5") {
    const subtitle1 = document.createElement("p");
    subtitle1.className = `subtitle ${size}`;
    subtitle1.textContent = text;
    return subtitle1;
}
/**
 * @typedef {Object} TableConfig
 * @property {("is-fullwidth"|"is-striped")[]} [classList]
 * @property {HTMLTableRowElement} [header]
 * @property {HTMLTableRowElement[]} [body]
 * @property {HTMLTableRowElement} [footer]
 *
 * @param {TableConfig} cfg
 */ function $6d068560d6a0dc33$var$table(cfg) {
    const table = document.createElement("table");
    table.className = "table";
    if (cfg.classList) cfg.classList.forEach((c)=>{
        table.classList.add(c);
    });
    if (cfg.header) {
        const header = document.createElement("thead");
        header.append(cfg.header);
        table.append(header);
    }
    if (cfg.body) {
        const body = document.createElement("tbody");
        body.append(...cfg.body);
        table.append(body);
    }
    if (cfg.footer) {
        const footer = document.createElement("tfoot");
        footer.append(cfg.footer);
        table.append(footer);
    }
    return table;
}
/**
 * @param {Node|string} content
 */ function $6d068560d6a0dc33$var$tableDataCell(content) {
    const cell = document.createElement("td");
    cell.append(content);
    return cell;
}
/**
 * @param {Node|string} content
 */ function $6d068560d6a0dc33$var$tableHeaderCell(content) {
    const cell = document.createElement("th");
    cell.append(content);
    return cell;
}
/**
 * @typedef {Object} TableRowConfig
 * @property {(event: MouseEvent) => void} [onClick]
 *
 * @param {TableRowConfig} cfg
 * @param  {...HTMLTableCellElement} cells
 */ function $6d068560d6a0dc33$var$tableRow(cfg, ...cells) {
    const row = document.createElement("tr");
    row.append(...cells);
    if (cfg.onClick) {
        row.classList.add("is-clickable");
        row.onclick = cfg.onClick;
    }
    return row;
}
/**
 * @typedef {Object} TagConfig
 * @property {HTMLSpanElement|string} content
 * @property {""|"is-primary"} [color]
 * @property {(event: MouseEvent) => void} [onClick]
 *
 * @param {TagConfig} cfg
 */ function $6d068560d6a0dc33$var$tag(cfg) {
    const tag = document.createElement("span");
    tag.classList.add("tag");
    tag.append(cfg.content);
    if (cfg.color) tag.classList.add(cfg.color);
    if (cfg.onClick) tag.onclick = cfg.onClick;
    return tag;
}
/**
 * @param {TagConfig} left
 * @param {TagConfig} right
 */ function $6d068560d6a0dc33$var$tagWithAddon(left, right) {
    const tags = document.createElement("div");
    tags.className = "tags has-addons";
    tags.append($6d068560d6a0dc33$var$tag(left), $6d068560d6a0dc33$var$tag(right));
    return tags;
}
function $6d068560d6a0dc33$var$timeInput() {
    const input = document.createElement("input");
    input.type = "time";
    input.className = "input";
    const getUtc = ()=>{
        const [localHours, localMinutes] = input.value.split(":");
        const localDate = new Date();
        localDate.setHours(+localHours, +localMinutes);
        return localDate.toISOString().substring(11, 16);
    };
    return {
        element: input,
        getUtc: getUtc,
        getLocal: ()=>input.value
    };
}
/**
 * @param {string} text
 * @param {"is-1"|"is-2"|"is-3"|"is-4"|"is-5"|"is-6"} [size="is-3"]
 */ function $6d068560d6a0dc33$var$title(text, size = "is-3") {
    const title1 = document.createElement("p");
    title1.className = `title ${size}`;
    title1.textContent = text;
    return title1;
}
const $6d068560d6a0dc33$export$9bf88dd34cb662bf = {
    box: $6d068560d6a0dc33$var$box,
    breadcrumb: $6d068560d6a0dc33$var$breadcrumb,
    button: $6d068560d6a0dc33$var$button,
    buttons: $6d068560d6a0dc33$var$buttons,
    card: $6d068560d6a0dc33$var$card,
    cardContent: $6d068560d6a0dc33$var$cardContent,
    cardFooter: $6d068560d6a0dc33$var$cardFooter,
    cardHeader: $6d068560d6a0dc33$var$cardHeader,
    cardHeaderIcon: $6d068560d6a0dc33$var$cardHeaderIcon,
    cardHeaderTitle: $6d068560d6a0dc33$var$cardHeaderTitle,
    checkbox: $6d068560d6a0dc33$var$checkbox,
    checkboxes: $6d068560d6a0dc33$var$checkboxes,
    column: $6d068560d6a0dc33$var$column,
    columns: $6d068560d6a0dc33$var$columns,
    container: $6d068560d6a0dc33$var$container,
    control: $6d068560d6a0dc33$var$control,
    dateInput: $6d068560d6a0dc33$var$dateInput,
    field: $6d068560d6a0dc33$var$field,
    fileInput: $6d068560d6a0dc33$var$fileInput,
    input: $6d068560d6a0dc33$var$input,
    hero: $6d068560d6a0dc33$var$hero,
    help: $6d068560d6a0dc33$var$help,
    label: $6d068560d6a0dc33$var$label,
    level: $6d068560d6a0dc33$var$level,
    levelItem: $6d068560d6a0dc33$var$levelItem,
    levelLeft: $6d068560d6a0dc33$var$levelLeft,
    levelRight: $6d068560d6a0dc33$var$levelRight,
    media: $6d068560d6a0dc33$var$media,
    modalCard: $6d068560d6a0dc33$var$modalCard,
    navbar: $6d068560d6a0dc33$var$navbar,
    navbarDropdown: $6d068560d6a0dc33$var$navbarDropdown,
    navbarItem: $6d068560d6a0dc33$var$navbarItem,
    option: $6d068560d6a0dc33$var$option,
    section: $6d068560d6a0dc33$var$section,
    select: $6d068560d6a0dc33$var$select,
    subtitle: $6d068560d6a0dc33$var$subtitle,
    table: $6d068560d6a0dc33$var$table,
    tableDataCell: $6d068560d6a0dc33$var$tableDataCell,
    tableHeaderCell: $6d068560d6a0dc33$var$tableHeaderCell,
    tableRow: $6d068560d6a0dc33$var$tableRow,
    tag: $6d068560d6a0dc33$var$tag,
    tagWithAddon: $6d068560d6a0dc33$var$tagWithAddon,
    timeInput: $6d068560d6a0dc33$var$timeInput,
    title: $6d068560d6a0dc33$var$title
};


var $2a8504bcdc58eacb$exports = {};
/*!
 * bulma-toast 2.4.4 
 * (c) 2018-present @rfoel <rafaelfr@outlook.com> 
 * Released under the MIT License.
 */ (function(a, b) {
    b($2a8504bcdc58eacb$exports);
})($2a8504bcdc58eacb$exports, function(a) {
    'use strict';
    function b(a, b) {
        var c = Object.keys(a);
        if (Object.getOwnPropertySymbols) {
            var d = Object.getOwnPropertySymbols(a);
            b && (d = d.filter(function(b) {
                return Object.getOwnPropertyDescriptor(a, b).enumerable;
            })), c.push.apply(c, d);
        }
        return c;
    }
    function c(a) {
        for(var c, d = 1; d < arguments.length; d++)c = null == arguments[d] ? {} : arguments[d], d % 2 ? b(Object(c), !0).forEach(function(b) {
            g(a, b, c[b]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(c)) : b(Object(c)).forEach(function(b) {
            Object.defineProperty(a, b, Object.getOwnPropertyDescriptor(c, b));
        });
        return a;
    }
    function d(a, b) {
        if (!(a instanceof b)) throw new TypeError("Cannot call a class as a function");
    }
    function e(a, b) {
        for(var c, d = 0; d < b.length; d++)c = b[d], c.enumerable = c.enumerable || !1, c.configurable = !0, "value" in c && (c.writable = !0), Object.defineProperty(a, c.key, c);
    }
    function f(a, b, c) {
        return b && e(a.prototype, b), c && e(a, c), a;
    }
    function g(a, b, c) {
        return b in a ? Object.defineProperty(a, b, {
            value: c,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : a[b] = c, a;
    }
    function h() {
        var a;
        return null !== (a = o) && void 0 !== a ? a : document;
    }
    function i(a, b, c, d, e, f) {
        if (n.position) return n.position;
        var g = h().createElement("div");
        return g.setAttribute("style", "width:100%;z-index:99999;position:fixed;pointer-events:none;display:flex;flex-direction:column;padding:15px;" + p(b, c, d, e, f)), a.appendChild(g), n.position = g, g;
    }
    function j(a) {
        for(var b in n)n[b].remove();
        n = {}, o = a;
    }
    function k(a) {
        if (!a.message) throw new Error("message is required");
        var b = c(c({}, m), a), d = new q(b), e = i(b.appendTo || h().body, b.position || m.position, b.offsetTop || m.offsetTop, b.offsetBottom || m.offsetBottom, b.offsetLeft || m.offsetLeft, b.offsetRight || m.offsetRight);
        if (b.single) for(var f = e.lastElementChild; f;)e.removeChild(f), f = e.lastElementChild;
        e.appendChild(d.element);
    }
    var l = {
        duration: 2e3,
        position: "top-right",
        closeOnClick: !0,
        opacity: 1,
        single: !1,
        offsetTop: 0,
        offsetBottom: 0,
        offsetLeft: 0,
        offsetRight: 0,
        extraClasses: ""
    }, m = c({}, l), n = {}, o = null, p = function(a, b, c, d, e) {
        return "top-left" === a ? "left:".concat(d, ";top:").concat(b, ";text-align:left;align-items:flex-start;") : "top-right" === a ? "right:".concat(e, ";top:").concat(b, ";text-align:right;align-items:flex-end;") : "top-center" === a ? "top:".concat(b, ";left:0;right:0;text-align:center;align-items:center;") : "bottom-left" === a ? "left:".concat(d, ";bottom:").concat(c, ";text-align:left;align-items:flex-start;") : "bottom-right" === a ? "right:".concat(e, ";bottom:").concat(c, ";text-align:right;align-items:flex-end;") : "bottom-center" === a ? "bottom:".concat(c, ";left:0;right:0;text-align:center;align-items:center;") : "center" === a ? "top:0;left:0;right:0;bottom:0;flex-flow:column;justify-content:center;align-items:center;" : void 0;
    }, q = /*#__PURE__*/ function() {
        function a(b) {
            var c = this;
            d(this, a), this.element = h().createElement("div"), this.opacity = b.opacity, this.type = b.type, this.animate = b.animate, this.dismissible = b.dismissible, this.closeOnClick = b.closeOnClick, this.message = b.message, this.duration = b.duration, this.pauseOnHover = b.pauseOnHover, this.offsetTop = b.offsetTop, this.offsetBottom = b.offsetBottom, this.offsetLeft = b.offsetLeft, this.offsetRight = b.offsetRight, this.extraClasses = b.extraClasses;
            var e = "width:auto;pointer-events:auto;display:inline-flex;white-space:pre-wrap;opacity:".concat(this.opacity, ";"), f = [
                "notification",
                this.extraClasses
            ];
            if (this.type && f.push(this.type), this.animate && this.animate["in"]) {
                var g = "animate__".concat(this.animate["in"]), i = this.animate.speed ? "animate__".concat(this.animate.speed) : "animate__faster";
                f.push("animate__animated ".concat(g, " ").concat(i)), this.onAnimationEnd(function() {
                    return c.element.classList.remove(g);
                });
            }
            if (this.element.className = f.join(" "), this.dismissible) {
                var j = h().createElement("button");
                j.className = "delete", j.addEventListener("click", function() {
                    c.destroy();
                }), this.element.insertAdjacentElement("afterbegin", j);
            } else e += "padding: 1.25rem 1.5rem";
            this.closeOnClick && this.element.addEventListener("click", function() {
                c.destroy();
            }), this.element.setAttribute("style", e), "string" == typeof this.message ? this.element.insertAdjacentHTML("beforeend", this.message) : this.element.appendChild(this.message);
            var k = new r(function() {
                c.destroy();
            }, this.duration);
            this.pauseOnHover && (this.element.addEventListener("mouseover", function() {
                k.pause();
            }), this.element.addEventListener("mouseout", function() {
                k.resume();
            }));
        }
        return f(a, [
            {
                key: "destroy",
                value: function() {
                    var a = this;
                    this.animate && this.animate.out ? (this.element.classList.add("animate__".concat(this.animate.out)), this.onAnimationEnd(function() {
                        a.removeParent(a.element.parentNode), a.element.remove();
                    })) : (this.removeParent(this.element.parentNode), this.element.remove());
                }
            },
            {
                key: "removeParent",
                value: function(a) {
                    a && 1 >= a.children.length && (a.remove(), delete n.position);
                }
            },
            {
                key: "onAnimationEnd",
                value: function() {
                    var a = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : function() {}, b = {
                        animation: "animationend",
                        OAnimation: "oAnimationEnd",
                        MozAnimation: "mozAnimationEnd",
                        WebkitAnimation: "webkitAnimationEnd"
                    };
                    for(var c in b)if (void 0 !== this.element.style[c]) {
                        this.element.addEventListener(b[c], function() {
                            return a();
                        });
                        break;
                    }
                }
            }
        ]), a;
    }(), r = /*#__PURE__*/ function() {
        function a(b, c) {
            d(this, a), this.timer, this.start, this.remaining = c, this.callback = b, this.resume();
        }
        return f(a, [
            {
                key: "pause",
                value: function() {
                    "undefined" == typeof document || (window.clearTimeout(this.timer), this.remaining -= new Date - this.start);
                }
            },
            {
                key: "resume",
                value: function() {
                    "undefined" == typeof document || (this.start = new Date, window.clearTimeout(this.timer), this.timer = window.setTimeout(this.callback, this.remaining));
                }
            }
        ]), a;
    }();
    a.resetDefaults = function() {
        m = c({}, l);
    }, a.setDefaults = function(a) {
        m = c(c({}, l), a);
    }, a.setDoc = j, a.toast = k, Object.defineProperty(a, "__esModule", {
        value: !0
    });
});





/**
 * @param {"large"|"small"} size
 * @param {...Node} children
 */ function $62f894d94fb7061c$export$4b0227fa4b29008b(size, ...children) {
    /** @type {ColumnSize[]} */ const classList = size === "large" ? [
        "is-12-mobile",
        "is-11-tablet",
        "is-11-desktop",
        "is-11-widescreen",
        "is-8-fullhd"
    ] : [
        "is-12-mobile",
        "is-7-tablet",
        "is-6-desktop",
        "is-5-widescreen",
        "is-3-fullhd"
    ];
    return (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).columns({
        isCentered: true,
        isMobile: true
    }, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).column({
        classList: classList
    }, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).box(...children)));
}
function $62f894d94fb7061c$export$a9bf4c2a13f1ac95() {
    const comparator = new Intl.Collator((0, $093d22e30b803c56$export$162ce11d62a1ca51).id);
    const countryMap = (0, $093d22e30b803c56$export$162ce11d62a1ca51).countries.getNames((0, $093d22e30b803c56$export$162ce11d62a1ca51).id.substring(0, 2));
    const options = Object.entries(countryMap).sort(([_code1, name1], [_code2, name2])=>comparator.compare(name1, name2)).map(([code, name])=>{
        const selected = (0, $093d22e30b803c56$export$162ce11d62a1ca51).id.substring(3, 5) === code;
        return (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).option(name, code, selected);
    });
    return (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).select({
        options: options
    });
}
/**
 * @param {Error | string} err
 */ function $62f894d94fb7061c$export$6badb0ecde4e0bd0(err) {
    let msg = "";
    if (err instanceof Error) msg = err.message;
    else msg = err;
    (0, $2a8504bcdc58eacb$exports.toast)({
        message: msg,
        type: "is-danger",
        position: "center",
        duration: 3000
    });
}
/**
 * @param {string} [key=""]
 * @param {string} [value=""]
 */ function $62f894d94fb7061c$export$c7b5d08fe382bb2a(key = "", value = "") {
    const k = document.createElement("span");
    k.className = "mr-2";
    k.textContent = key;
    const v = document.createElement("span");
    v.className = "ml-2";
    v.textContent = value;
    const paragraph = document.createElement("p");
    paragraph.className = "spaced";
    paragraph.append(k, v);
    return paragraph;
}
function $62f894d94fb7061c$export$48d6f7351f788047() {
    let isHidden = true;
    const hiddenInput = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).input({
        type: "password"
    });
    const hiddenButton = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).button({}, (0, $1abc8d719eea79cd$export$e1dd10d13c5a06).icon({
        id: "visibility_off",
        onClick: ()=>{
            visibleInput.setValue(hiddenInput.getValue());
            hiddenInput.element.replaceWith(visibleInput.element);
            hiddenButton.replaceWith(visibleButton);
            isHidden = false;
        }
    }));
    const visibleInput = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).input({
        type: "text"
    });
    const visibleButton = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).button({}, (0, $1abc8d719eea79cd$export$e1dd10d13c5a06).icon({
        id: "visibility",
        onClick: ()=>{
            hiddenInput.setValue(visibleInput.getValue());
            visibleInput.element.replaceWith(hiddenInput.element);
            visibleButton.replaceWith(hiddenButton);
            isHidden = true;
        }
    }));
    const field = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).field({
        styles: [
            "has-addons"
        ]
    }, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({
        styles: [
            "is-expanded"
        ]
    }, hiddenInput.element), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({}, hiddenButton));
    return {
        element: field,
        getValue: ()=>isHidden ? hiddenInput.getValue() : visibleInput.getValue()
    };
}
/**
 * @param {string} [text=""]
 */ function $62f894d94fb7061c$export$b006dc062b05ab9c(text = "") {
    const pre = document.createElement("pre");
    pre.className = "is-tiny-mobile";
    pre.textContent = text;
    return pre;
}
function $62f894d94fb7061c$export$73e19c0339806233() {
    (0, $2a8504bcdc58eacb$exports.toast)({
        message: (0, $1abc8d719eea79cd$export$e1dd10d13c5a06).icon({
            id: "done"
        }),
        type: "is-success",
        duration: 500,
        position: "center"
    });
}


/**
 * @param {Response} res
 * @returns {Promise<Response>}
 */ async function $1fb5d845307c571c$export$f00cf23da648bc9b(res) {
    switch(res.status){
        case 408:
            (0, $62f894d94fb7061c$export$6badb0ecde4e0bd0)("408: Connection to server timed out");
            break;
        case 500:
            (0, $62f894d94fb7061c$export$6badb0ecde4e0bd0)("500: Internal Server Error");
            break;
        default:
            (0, $62f894d94fb7061c$export$6badb0ecde4e0bd0)(`${res.status} ${res.statusText}: ${await res.text()}`);
    }
    return res;
}
function $1fb5d845307c571c$export$17fa54b11a8d3e34() {
    (0, $b4e14b6b8da86996$export$8390d50e515c191d)((0, $62f894d94fb7061c$export$4b0227fa4b29008b)("small", (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).label((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
        enGB: "Connection to the server failed. Please verify your internet connection and try again. If you are still experiencing issues, you can contact our support at https://support.luda.farm.",
        deDE: "Die Verbindung zum Server ist fehlgeschlagen. Bitte \xfcberpr\xfcfen Sie Ihre Internetverbindung und versuchen Sie es erneut. Wenn Sie immer noch Probleme haben, k\xf6nnen Sie unseren Support unter https://support.luda.farm kontaktieren.",
        frFR: "La connexion au serveur a \xe9chou\xe9. Veuillez v\xe9rifier votre connexion internet et r\xe9essayer. Si vous rencontrez toujours des probl\xe8mes, vous pouvez contacter notre service d'assistance \xe0 l'adresse https://support.luda.farm.",
        svSE: "Anslutningen till servern misslyckades. V\xe4nligen verifiera din internetanslutning och f\xf6rs\xf6k igen. Om du fortfarande upplever problem kan du kontakta v\xe5r support p\xe5 https://support.luda.farm."
    })), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).button({
        onClick: ()=>window.location.href = "/",
        styles: [
            'is-primary'
        ]
    }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
        enGB: "Try again",
        deDE: "Erneut versuchen",
        frFR: "R\xe9essayez",
        svSE: "F\xf6rs\xf6k igen"
    }))));
}



/**
 * @param {Record<string,string>} assets
 */ var $e9ece281420eedff$exports = {};
$e9ece281420eedff$exports = import.meta.resolve("bu9eP");


var $46864fbb51854c72$exports = {};
$46864fbb51854c72$exports = import.meta.resolve("5PmSB");


var $cc83aa21f8bcb0b6$exports = {};
$cc83aa21f8bcb0b6$exports = import.meta.resolve("8mfXf");


var $b70cd19fdb65fb8e$exports = {};
$b70cd19fdb65fb8e$exports = import.meta.resolve("kFnoZ");


var $088c4d486e6e7910$exports = {};
$088c4d486e6e7910$exports = import.meta.resolve("ghm9O");


var $b09f1421e2e1bd29$exports = {};
$b09f1421e2e1bd29$exports = import.meta.resolve("h4vKE");


var $6750b400f28f2fc5$exports = {};
$6750b400f28f2fc5$exports = import.meta.resolve("7lpX6");


var $c31557a0739de113$exports = {};
$c31557a0739de113$exports = import.meta.resolve("jjO3S");


function $85dc7822bd378df4$var$loadAssets(assets) {
    assets["farmcam-sim.png"] = new URL($e9ece281420eedff$exports).href;
    assets["favicon-16x16.png"] = new URL($46864fbb51854c72$exports).href;
    assets["favicon-32x32.png"] = new URL($cc83aa21f8bcb0b6$exports).href;
    assets["fencealarm.png"] = new URL($b70cd19fdb65fb8e$exports).href;
    assets["fencealarm2.png"] = new URL($088c4d486e6e7910$exports).href;
    assets["logo.png"] = new URL($b09f1421e2e1bd29$exports).href;
    assets["smartplug.png"] = new URL($6750b400f28f2fc5$exports).href;
    assets["smartplug2.png"] = new URL($c31557a0739de113$exports).href;
}

function $85dc7822bd378df4$export$d95d5d0b23652551(assets, config) {
    $85dc7822bd378df4$var$loadAssets(assets);
    $85dc7822bd378df4$var$populateConfig(config);
    (parcelRequire("b9oFS"));
}
/**
 * @param {import("./common").Config} config
 */ function $85dc7822bd378df4$var$populateConfig(config) {
    config.apiBaseUrl = "https://api.luda.farm";
    config.apiHost = "api.luda.farm";
    config.appId = "my.luda.farm";
    config.baseUrl = "https://my.luda.farm";
    config.brand = "luda";
    config.navbarTheme = "is-dark";
    config.sp2gwHost = "smartplug2.luda.farm";
    config.stripeBaseUrl = "https://dashboard.stripe.com";
    config.supportedDevices = [
        "farmcam-sim",
        "fencealarm2",
        "fencealarm",
        "smartplug2",
        "smartplug"
    ];
}



function $6cf00709c1be414e$export$cbfe8c107717f907(assets, config) {
    (0, $85dc7822bd378df4$export$d95d5d0b23652551)(assets, config);
    $6cf00709c1be414e$var$overwriteConfig(config);
    (parcelRequire("b9oFS"));
}
/**
 * @param {import("./common").Config} config
 */ function $6cf00709c1be414e$var$overwriteConfig(config) {
    config.apiBaseUrl = "https://test.api.luda.farm";
    config.apiHost = "test.api.luda.farm";
    config.appId = "test.my.luda.farm";
    config.baseUrl = "https://test.my.luda.farm";
    config.brand = "luda";
    config.sp2gwHost = "test.sp2gw.luda.farm";
    config.sp2gwSelfSignedHost = "test.smartplug2.luda.farm";
    config.stripeBaseUrl = "https://dashboard.stripe.com/test";
    config.supportedDevices = [
        "farmcam-sim",
        "fencealarm2",
        "fencealarm",
        "smartplug2",
        "smartplug"
    ];
}



/**
 * @param {Record<string,string>} assets
 */ var $7d47a67496cde4bb$exports = {};
$7d47a67496cde4bb$exports = import.meta.resolve("kCqQP");


var $9a3ae8261c6e585c$exports = {};
$9a3ae8261c6e585c$exports = import.meta.resolve("8SVmm");


var $ce288af01fa576e4$exports = {};
$ce288af01fa576e4$exports = import.meta.resolve("liv19");


var $c1be019d0a8214ec$exports = {};
$c1be019d0a8214ec$exports = import.meta.resolve("TjDHx");


var $73a83104c691d860$exports = {};
$73a83104c691d860$exports = import.meta.resolve("d1ouZ");


var $03dfed1ca8cfaf87$exports = {};
$03dfed1ca8cfaf87$exports = import.meta.resolve("VOKyY");


var $e9b5bfdb82edbc50$exports = {};
$e9b5bfdb82edbc50$exports = import.meta.resolve("hBwI3");


function $237b15639a796bac$var$loadAssets(assets) {
    assets["favicon-16x16.png"] = new URL($7d47a67496cde4bb$exports).href;
    assets["favicon-32x32.png"] = new URL($9a3ae8261c6e585c$exports).href;
    assets["fencealarm.png"] = new URL($ce288af01fa576e4$exports).href;
    assets["fencealarm2.png"] = new URL($c1be019d0a8214ec$exports).href;
    assets["logo.png"] = new URL($73a83104c691d860$exports).href;
    assets["smartplug.png"] = new URL($03dfed1ca8cfaf87$exports).href;
    assets["smartplug2.png"] = new URL($e9b5bfdb82edbc50$exports).href;
}

function $237b15639a796bac$export$22b6b784e4445a20(assets, config) {
    $237b15639a796bac$var$loadAssets(assets);
    $237b15639a796bac$var$populateConfig(config);
    (parcelRequire("eXXR9"));
}
/**
 * @param {import("./common").Config} config
 */ function $237b15639a796bac$var$populateConfig(config) {
    config.apiBaseUrl = "https://api.luda.farm";
    config.apiHost = "api.luda.farm";
    config.appId = "patura.luda.farm";
    config.baseUrl = "https://patura.luda.farm";
    config.brand = "patura";
    config.navbarTheme = "is-light";
    config.sp2gwHost = "smartplug2.luda.farm";
    config.stripeBaseUrl = "https://dashboard.stripe.com";
    config.supportedDevices = [
        "fencealarm2",
        "fencealarm",
        "smartplug2",
        "smartplug"
    ];
}


function $46d03d54faf4cdf4$export$b38182bb7e976415() {
    $46d03d54faf4cdf4$var$loadCommonAssets();
    $46d03d54faf4cdf4$var$loadAppEnv();
    $46d03d54faf4cdf4$var$appendTitle();
    $46d03d54faf4cdf4$var$appendFavicon();
}
function $46d03d54faf4cdf4$var$loadAppEnv() {
    (0, $237b15639a796bac$export$22b6b784e4445a20)($46d03d54faf4cdf4$export$555f04397502546, $46d03d54faf4cdf4$export$e506a1d27d1eaa20);
}
function $46d03d54faf4cdf4$var$appendTitle() {
    const title = document.createElement("title");
    title.textContent = $46d03d54faf4cdf4$export$e506a1d27d1eaa20.appId;
    document.head.append(title);
}
function $46d03d54faf4cdf4$var$appendFavicon() {
    const favicon = document.createElement("link");
    favicon.rel = "icon";
    favicon.type = "image/png";
    favicon.href = $46d03d54faf4cdf4$export$555f04397502546["favicon-32x32.png"];
    document.head.append(favicon);
}
var $483cd9ccb6167fda$exports = {};
$483cd9ccb6167fda$exports = import.meta.resolve("5OO8a");


var $89799ce4beb33978$exports = {};
$89799ce4beb33978$exports = import.meta.resolve("38STL");


var $1dba05f5b239e3e7$exports = {};
$1dba05f5b239e3e7$exports = import.meta.resolve("e3Fu5");


var $20e591827ac894fa$exports = {};
$20e591827ac894fa$exports = import.meta.resolve("bNNhD");


var $2e39a67056ad552d$exports = {};
$2e39a67056ad552d$exports = import.meta.resolve("1CP2C");


function $46d03d54faf4cdf4$var$loadCommonAssets() {
    $46d03d54faf4cdf4$export$555f04397502546["farmcam-sim.svg"] = new URL($483cd9ccb6167fda$exports).href;
    $46d03d54faf4cdf4$export$555f04397502546["fencealarm.svg"] = new URL($89799ce4beb33978$exports).href;
    $46d03d54faf4cdf4$export$555f04397502546["fencealarm2.svg"] = new URL($1dba05f5b239e3e7$exports).href;
    $46d03d54faf4cdf4$export$555f04397502546["smartplug.svg"] = new URL($20e591827ac894fa$exports).href;
    $46d03d54faf4cdf4$export$555f04397502546["smartplug2.svg"] = new URL($2e39a67056ad552d$exports).href;
}
const $46d03d54faf4cdf4$export$555f04397502546 = {};
const $46d03d54faf4cdf4$export$e506a1d27d1eaa20 = {
    apiBaseUrl: "",
    apiHost: "",
    appId: "",
    baseUrl: "",
    brand: "",
    navbarTheme: "",
    sp2gwHost: "",
    sp2gwSelfSignedHost: "",
    stripeBaseUrl: "",
    supportedDevices: []
};




/**
 * Wraps fetch with an authorization header and generates a url based on the path and api url
 * @param {string} path
 * @param {RequestInit} req
 * @param {number} [timeout] milliseconds
 * @returns {Promise<Response>}
 */ async function $5ca15832b8c5d5ea$var$apiFetch(path, req, timeout) {
    if (!timeout) return fetch((0, $46d03d54faf4cdf4$export$e506a1d27d1eaa20).apiBaseUrl + path, req);
    // else with timeout
    const ctrl = new AbortController();
    req.signal = ctrl.signal;
    const abortJob = ()=>{
        ctrl.abort();
        (0, $1fb5d845307c571c$export$17fa54b11a8d3e34)();
    };
    const timer = setTimeout(abortJob, timeout);
    return fetch((0, $46d03d54faf4cdf4$export$e506a1d27d1eaa20).apiBaseUrl + path, req).finally(()=>clearTimeout(timer));
}
/**
 * @typedef {Object} RequestOptions
 * @property {BodyInit} [body]
 * @property {number} [timeout] milliseconds
 */ /**
 * @param {string} method
 * @param {RequestOptions} [reqOpts]
 */ async function $5ca15832b8c5d5ea$var$newRequest(method, reqOpts) {
    /** @type {RequestInit} */ const req = {
        headers: {
            Authorization: `Bearer ${await (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).getTokenString()}`
        },
        method: method
    };
    if (reqOpts) {
        if (reqOpts.body) req.body = reqOpts.body;
    }
    return req;
}
/**
 * Api DELETE request
 * @param {string} path
 * @param {RequestOptions} [reqOpts]
 * @returns {Promise<Response>}
 */ async function $5ca15832b8c5d5ea$export$1d2f21e549771e67(path, reqOpts) {
    const req = await $5ca15832b8c5d5ea$var$newRequest("DELETE", reqOpts);
    if (reqOpts?.timeout) return $5ca15832b8c5d5ea$var$apiFetch(path, req, reqOpts.timeout);
    else return $5ca15832b8c5d5ea$var$apiFetch(path, req);
}
/**
 * Api GET request
 * @param {string} path
 * @param {RequestOptions} [reqOpts]
 * @returns {Promise<Response>}
 */ async function $5ca15832b8c5d5ea$export$3988ae62b71be9a3(path, reqOpts) {
    const req = await $5ca15832b8c5d5ea$var$newRequest("GET", reqOpts);
    if (reqOpts?.timeout) return $5ca15832b8c5d5ea$var$apiFetch(path, req, reqOpts.timeout);
    else return $5ca15832b8c5d5ea$var$apiFetch(path, req);
}
/**
 *  Api POST request
 * @param {string} path
 * @param {RequestOptions} [reqOpts]
 * @returns {Promise<Response>}
 */ async function $5ca15832b8c5d5ea$export$299ba2dee77727e9(path, reqOpts) {
    const req = await $5ca15832b8c5d5ea$var$newRequest("POST", reqOpts);
    if (reqOpts?.timeout) return $5ca15832b8c5d5ea$var$apiFetch(path, req, reqOpts.timeout);
    else return $5ca15832b8c5d5ea$var$apiFetch(path, req);
}
/**
 * Api PUT request
 * @param {string} path
 * @param {RequestOptions} [reqOpts]
 * @returns {Promise<Response>}
 */ async function $5ca15832b8c5d5ea$export$327f7b26ebf455db(path, reqOpts) {
    const req = await $5ca15832b8c5d5ea$var$newRequest("PUT", reqOpts);
    if (reqOpts?.timeout) return $5ca15832b8c5d5ea$var$apiFetch(path, req, reqOpts.timeout);
    else return $5ca15832b8c5d5ea$var$apiFetch(path, req);
}


/**
 * @returns {Promise<Devices>}
 */ async function $242ad89fa77f4e5f$export$dcbad4de9b70b527() {
    const user = await (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).getActiveUser();
    const res = await (0, $5ca15832b8c5d5ea$export$3988ae62b71be9a3)(`/users/${user.Id}/devices`);
    if (!res.ok) throw await (0, $1fb5d845307c571c$export$f00cf23da648bc9b)(res);
    return res.json();
}


/**
 * @template T
 * @param {T[]} arr 
 * @param {T} ele 
 */ function $32a329fb73bfcadd$export$2b602f2290961f2e(arr, ele) {
    const res = $32a329fb73bfcadd$var$sortedSetSearch(arr, ele);
    if (res.included) return arr;
    else return arr.toSpliced(res.index, 0, ele);
}
function $32a329fb73bfcadd$export$410a12b43f8fbe6f(arr, ele) {
    const res = $32a329fb73bfcadd$var$sortedSetSearch(arr, ele);
    if (res.included) return arr.toSpliced(res.index, 1);
    else return arr;
}
function $32a329fb73bfcadd$export$5d254a84db9b349c(arr, ele) {
    return $32a329fb73bfcadd$var$sortedSetSearch(arr, ele).included;
}
/**
 * @template T
 * @param {T[]} arr 
 * @param {T} ele 
 */ function $32a329fb73bfcadd$var$sortedSetSearch(arr, ele) {
    let low = 0;
    let high = arr.length - 1;
    while(low <= high){
        const mid = Math.floor((low + high) / 2);
        if (arr[mid] === ele) return {
            index: mid,
            included: true
        };
        else if (arr[mid] < ele) low = mid + 1;
        else high = mid - 1;
    }
    return {
        index: low,
        included: false
    };
}
function $32a329fb73bfcadd$export$455194c4a67afc83(arr) {
    return [
        ...new Set(arr)
    ].toSorted();
}



var $gJCIb = parcelRequire("gJCIb");



const $d8c8c6c54969fb10$export$6b7b6cff4ccb438b = (0, $gJCIb.registerPlugin)('Preferences', {
    web: ()=>(parcelRequire("34ADT")).then((m)=>new m.PreferencesWeb())
});



var $gJCIb = parcelRequire("gJCIb");



const $fc70cc85372c45fc$export$86fbec116b87613f = (0, $gJCIb.registerPlugin)('App', {
    web: ()=>(parcelRequire("dwEVR")).then((m)=>new m.AppWeb())
});



var $gJCIb = parcelRequire("gJCIb");

var $bNWYI = parcelRequire("bNWYI");
/**
 * Predefined CSS rules for styling barcode scanner components.
 * Each object in the array defines a CSS rule, with a selector and the CSS properties to apply.
 */ const $90c2022afb37dcf8$export$556bfb832ff6a3c3 = [
    {
        selector: '.scanner-container-display',
        css: 'display: block;'
    },
    {
        selector: '.scanner-dialog',
        css: 'display: none; position: fixed; z-index: 999; left: 0; top: 0; width: 100%; height: 100%; overflow: auto; background-color: rgba(0,0,0,0.4);'
    },
    {
        selector: '.scanner-dialog-inner',
        css: 'background-color: #fefefe; margin: 2% auto; padding: 20px; border: 1px solid #888; width: 96%;'
    },
    {
        selector: '.close-button',
        css: 'color: #aaa; float: right; font-size: 28px; font-weight: bold; cursor: pointer;'
    },
    {
        selector: '.close-button:hover',
        css: 'color: #222;'
    },
    {
        selector: '.scanner-container-full-width',
        css: 'width: 100%;'
    }
];
function $90c2022afb37dcf8$export$8f8bd2fc8a3be624(cssRules) {
    const styleId = 'custom-style-os-cap-barcode'; // Unique identifier for the style element.
    let styleElement = document.getElementById(styleId);
    if (!styleElement) {
        // Create and append a new style element if it does not exist.
        styleElement = document.createElement('style');
        styleElement.type = 'text/css';
        styleElement.id = styleId;
        document.head.appendChild(styleElement);
    }
    if (styleElement.sheet) {
        // Clear existing CSS rules.
        while(styleElement.sheet.cssRules.length)styleElement.sheet.deleteRule(0);
        // Insert new CSS rules.
        for (const { selector: selector, css: css } of cssRules)styleElement.sheet.insertRule(`${selector} { ${css} }`);
    } else {
        // Fallback for older browsers using textContent.
        styleElement.textContent = '';
        for (const { selector: selector, css: css } of cssRules)styleElement.textContent += `${selector} { ${css} }`;
    }
}



/**
 * Registers the `OSBarcode` plugin with Capacitor.
 * For web platforms, it applies necessary CSS for the barcode scanner and dynamically imports the web implementation.
 * This allows for lazy loading of the web code only when needed, optimizing overall bundle size.
 */ const $6244e290c71dde24$var$CapacitorBarcodeScannerImpl = (0, $gJCIb.registerPlugin)('CapacitorBarcodeScanner', {
    web: ()=>{
        (0, $90c2022afb37dcf8$export$8f8bd2fc8a3be624)((0, $90c2022afb37dcf8$export$556bfb832ff6a3c3)); // Apply the CSS styles necessary for the web implementation of the barcode scanner.
        return (parcelRequire("gIoAf")).then((m)=>new m.CapacitorBarcodeScannerWeb()); // Dynamically import the web implementation and instantiate it.
    }
});
class $6244e290c71dde24$export$d57e9a136c2acc03 {
    static async scanBarcode(options) {
        options.scanInstructions = options.scanInstructions || ' '; // Ensure scanInstructions is at least a space.
        options.scanButton = options.scanButton || false; // Set scanButton to false if not provided.
        options.scanText = options.scanText || ' '; // Ensure scanText is at least a space.
        options.cameraDirection = options.cameraDirection || (0, $bNWYI.CapacitorBarcodeScannerCameraDirection).BACK; // Set cameraDirection to 'BACK' if not provided.
        options.scanOrientation = options.scanOrientation || (0, $bNWYI.CapacitorBarcodeScannerScanOrientation).ADAPTIVE; // Set scanOrientation to 'ADAPTIVE' if not provided.
        return $6244e290c71dde24$var$CapacitorBarcodeScannerImpl.scanBarcode(options);
    }
}
 // Re-export all exports from the definitions file.


var $bNWYI = parcelRequire("bNWYI");

var $gJCIb = parcelRequire("gJCIb");

var $gJCIb = parcelRequire("gJCIb");
function $adc7742c85f64ed2$var$s(t) {
    t.CapacitorUtils.Synapse = new Proxy({}, {
        get (e, n) {
            return new Proxy({}, {
                get (w, o) {
                    return (c, p, r)=>{
                        const i = t.Capacitor.Plugins[n];
                        if (i === void 0) {
                            r(new Error(`Capacitor plugin ${n} not found`));
                            return;
                        }
                        if (typeof i[o] != "function") {
                            r(new Error(`Method ${o} not found in Capacitor plugin ${n}`));
                            return;
                        }
                        (async ()=>{
                            try {
                                const a = await i[o](c);
                                p(a);
                            } catch (a) {
                                r(a);
                            }
                        })();
                    };
                }
            });
        }
    });
}
function $adc7742c85f64ed2$var$u(t) {
    t.CapacitorUtils.Synapse = new Proxy({}, {
        get (e, n) {
            return t.cordova.plugins[n];
        }
    });
}
function $adc7742c85f64ed2$export$8fe1108d741bcfe3(t = !1) {
    typeof window > "u" || (window.CapacitorUtils = window.CapacitorUtils || {}, window.Capacitor !== void 0 && !t ? $adc7742c85f64ed2$var$s(window) : window.cordova !== void 0 && $adc7742c85f64ed2$var$u(window));
}


parcelRequire("cyPaV");

const $8279e179eaa0eace$export$d0c48aaede1ff6e5 = (0, $gJCIb.registerPlugin)('Filesystem', {
    web: ()=>(parcelRequire("7IZbQ")).then((m)=>new m.FilesystemWeb())
});
(0, $adc7742c85f64ed2$export$8fe1108d741bcfe3)();


var $cyPaV = parcelRequire("cyPaV");

var $gJCIb = parcelRequire("gJCIb");
/// <reference types="@capacitor/cli" />


const $73af3aa28454c31d$export$8f83d3f28eb09744 = (0, $gJCIb.registerPlugin)('PushNotifications', {});



var $gJCIb = parcelRequire("gJCIb");



const $0793367efc17a8e8$export$c9915453de10000b = (0, $gJCIb.registerPlugin)('Share', {
    web: ()=>(parcelRequire("jj2K8")).then((m)=>new m.ShareWeb())
});






/**
 * @param {string} Token
 */ async function $1a098edb0104b631$export$c4e9ed27683c7df0(Token) {
    const user = await (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).getSignedInUser();
    const res = await (0, $5ca15832b8c5d5ea$export$299ba2dee77727e9)(`/users/${user.Id}/device-tokens`, {
        body: JSON.stringify({
            Token: Token
        })
    });
    if (!res.ok) throw await (0, $1fb5d845307c571c$export$f00cf23da648bc9b)(res);
    return true;
}




/**
 * @template T
 * @param {T[]} arr
 * @param {T} val
 */ function $820877bea407f5fe$export$69b94c46bed08c28(arr, val) {
    let low = 0;
    let high = arr.length;
    while(low < high){
        const i = Math.floor((low + high) / 2);
        if (arr[i] < val) low = i + 1;
        else high = i;
    }
    arr.splice(low, 0, val);
}
/**
 * @template T
 * @param {T[]} arr
 * @param {T} val
 */ function $820877bea407f5fe$export$225ffb4bcef29a56(arr, val) {
    let low = 0;
    let high = arr.length;
    while(low < high){
        const i = Math.floor((low + high) / 2);
        if (arr[i] < val) low = i + 1;
        else if (arr[i] > val) high = i;
        else return arr.splice(i, 1);
    }
}
/**
 * @param {Blob} blob
 * @param {string} filename
 * @returns {Promise<File>}
 */ function $820877bea407f5fe$export$8baab45858d3f0e4(blob, filename) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onloadend = ()=>{
            if (reader.readyState !== FileReader.DONE) {
                reject();
                return;
            }
            if (!(reader.result instanceof ArrayBuffer)) {
                reject();
                return;
            }
            const fileType = $820877bea407f5fe$var$getFileType(reader.result);
            const file = new File([
                blob
            ], filename + fileType);
            resolve(file);
        };
        reader.onerror = reject;
        reader.readAsArrayBuffer(blob);
    });
}
/**
 * @param {number} ms
 */ function $820877bea407f5fe$export$1391212d75b2ee65(ms) {
    return new Promise((resolve)=>setTimeout(resolve, ms));
}
/**
 * @param {File} file 
 */ function $820877bea407f5fe$export$24422be91ad4011f(file) {
    // setup
    const url = URL.createObjectURL(file);
    const a = document.createElement("a");
    a.href = url;
    a.download = file.name;
    // download
    document.body.appendChild(a);
    a.click();
    // cleanup
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
}
/**
 * @param {number} amount
 */ function $820877bea407f5fe$export$93320de5093983a2(amount) {
    const units = [
        "B",
        "KB",
        "MB",
        "GB"
    ];
    let i = 0;
    for(; amount > 999; amount /= 1e3)i++;
    return `${parseFloat(amount.toFixed(2))} ${units[i]}`;
// return `${amount.toPrecision(3)} ${units[i]}`
}
/**
 * @param {ArrayBuffer} buffer 
 */ function $820877bea407f5fe$var$getFileType(buffer) {
    const bytes = new Uint8Array(buffer);
    if (bytes[0] === 0xFF && bytes[1] === 0xD8 && bytes[2] === 0xFF) return '.jpg';
    if (bytes[0] === 0x89 && bytes[1] === 0x50 && bytes[2] === 0x4E && bytes[3] === 0x47) return '.png';
    if (bytes[0] === 0x25 && bytes[1] === 0x50 && bytes[2] === 0x44 && bytes[3] === 0x46) return '.pdf';
    return "";
}
/**
 * @param {number} i 
 * @returns {string}
 */ function $820877bea407f5fe$export$b42dcb51e2659f75(i) {
    switch(i % 7){
        case 0:
            return (0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.sunday;
        case 1:
            return (0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.monday;
        case 2:
            return (0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.tuesday;
        case 3:
            return (0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.wednesday;
        case 4:
            return (0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.thursday;
        case 5:
            return (0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.friday;
        case 6:
            return (0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.saturday;
        default:
            throw `invalid index: ${i}`;
    }
}
/**
 * @param {Object | undefined} params
 */ function $820877bea407f5fe$export$89a7e74069fbb7af(params) {
    if (!params || typeof params !== "object") return "";
    return Object.entries(params).filter(([key, value])=>value).reduce((acc, [key, value])=>`${acc}${acc.length > 0 ? '&' : '?'}${key}=${value}`, "");
}


const $1d17319f79c68be8$export$f0e9209d1b946997 = (0, $gJCIb.Capacitor).getPlatform() === "android";
const $1d17319f79c68be8$export$d00bb5c9f079dd4e = (0, $gJCIb.Capacitor).getPlatform() === "ios";
const $1d17319f79c68be8$export$d70a5ce4bc79c42d = (0, $gJCIb.Capacitor).getPlatform() !== "web";
/**
 * @typedef {'appFinishedLoading' | 'registeredNotificationsToken'} MobileFlag
 */ const $1d17319f79c68be8$var$createMobileFlags = ()=>{
    /** @type {Record<MobileFlag, boolean>} */ const flags = {
        appFinishedLoading: false,
        registeredNotificationsToken: false
    };
    /**
	 * @param {MobileFlag} flag
	 */ const getValue = (flag)=>flags[flag];
    /**
	 * @param {MobileFlag} flag
	 * @param {boolean} value
	 */ const setValue = (flag, value)=>{
        flags[flag] = value;
    };
    return {
        getValue: getValue,
        setValue: setValue
    };
};
const $1d17319f79c68be8$export$273fb6590fc80197 = $1d17319f79c68be8$var$createMobileFlags();
/**
 * Loads the barcode-scanner and displays an overlay for handling scanner feedback.
 * @param {string} instructions
 * @returns {Promise<string | null>}
 */ async function $1d17319f79c68be8$export$7564757b89ba44f1(instructions) {
    try {
        const result = await (0, $6244e290c71dde24$export$d57e9a136c2acc03).scanBarcode({
            hint: (0, $bNWYI.CapacitorBarcodeScannerTypeHint).ALL,
            scanInstructions: instructions ?? "Scan",
            android: {
                scanningLibrary: (0, $bNWYI.CapacitorBarcodeScannerAndroidScanningLibrary).MLKIT
            }
        });
        return result?.ScanResult ?? null;
    } catch (error) {
        return null;
    }
}
/**
 * Saves a file to the public storage directory.
 * @param {string} filename
 * @param {any} data
 * @returns {Promise<boolean | string>}
 */ async function $1d17319f79c68be8$export$e620933a198f7bc(filename, data) {
    try {
        const currentPermission = await (0, $8279e179eaa0eace$export$d0c48aaede1ff6e5).checkPermissions();
        if (currentPermission.publicStorage !== "granted") {
            const requestedPermission = await (0, $8279e179eaa0eace$export$d0c48aaede1ff6e5).requestPermissions();
            if (requestedPermission.publicStorage !== "granted") return "Permission denied";
        }
        await (0, $8279e179eaa0eace$export$d0c48aaede1ff6e5).writeFile({
            path: filename,
            data: data,
            directory: (0, $cyPaV.Directory).Documents,
            encoding: (0, $cyPaV.Encoding).UTF8
        });
        return true;
    } catch (error) {
        console.error(error);
        return error.message;
    }
}
/**
 * @param {string} filename
 * @param {string} data
 * @param {Encoding} [encoding]
 * @returns {Promise<string>}
 */ async function $1d17319f79c68be8$var$createTempFile(filename, data, encoding) {
    const fileName = filename;
    const result = await (0, $8279e179eaa0eace$export$d0c48aaede1ff6e5).writeFile({
        path: fileName,
        data: data,
        directory: (0, $cyPaV.Directory).Cache,
        ...encoding && {
            encoding: encoding
        }
    });
    return result.uri;
}
/**
 * @param {string} filename
 * @param {string} data
 * @returns {Promise<'save_csv_cancelled'|'save_csv_error'|'save_csv_success'|'save_csv_unavailable'>}
 */ async function $1d17319f79c68be8$export$fdd44ecf112d8ba0(filename, data) {
    try {
        const canShare = await (0, $0793367efc17a8e8$export$c9915453de10000b).canShare();
        if (!canShare) throw new Error("Sharing not available");
        const fileUri = await $1d17319f79c68be8$var$createTempFile(filename, data, (0, $cyPaV.Encoding).UTF8);
        await (0, $0793367efc17a8e8$export$c9915453de10000b).share({
            title: "CSV File",
            url: fileUri,
            dialogTitle: "Save or share your CSV file"
        });
        return "save_csv_success";
    } catch (error) {
        console.error(error);
        switch(error.message){
            case "Sharing not available":
                return "save_csv_error";
            case "Share canceled":
                return "save_csv_success";
            default:
                return "save_csv_error";
        }
    }
}
/**
 * @param {string} filename
 * @param {Blob} blob
 */ async function $1d17319f79c68be8$export$9016c9576545678(filename, blob) {
    const canShare = await (0, $0793367efc17a8e8$export$c9915453de10000b).canShare();
    if (!canShare) throw new Error("Sharing not available");
    return new Promise((resolve, reject)=>{
        try {
            const reader = new FileReader();
            reader.onloadend = ()=>{
                if (typeof reader.result === "string") $1d17319f79c68be8$var$createTempFile(filename, reader.result).then((fileUri)=>{
                    (0, $0793367efc17a8e8$export$c9915453de10000b).share({
                        title: "Proof of purchase",
                        files: [
                            fileUri
                        ],
                        dialogTitle: "Save file"
                    }).then(()=>{
                        resolve(true);
                    }).catch(reject);
                });
                else reject("Failed to read file");
            };
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        } catch (error) {
            reject(error);
        }
    });
}
/**
 * @typedef {'farmcamsim' | 'fencealarm' | 'fencealarm2' | 'smartplug'} ListenerType
 */ /**
 * @typedef {Record<string, function>} CallbackMap
 */ /**
 * @typedef {Record<ListenerType, CallbackMap>} NotificationListener
 */ /**
 * @type {import('@capacitor/push-notifications').PushNotificationSchema | undefined}
 */ let $1d17319f79c68be8$var$initialNotification;
function $1d17319f79c68be8$export$974358a537b1f4c() {
    const value = $1d17319f79c68be8$var$initialNotification;
    $1d17319f79c68be8$var$initialNotification = undefined;
    return value;
}
/**
 * @type {{
 *  farmcamsim: Record<string,() => void>
 *  fencealarm: Record<string,() => void>
 *  fencealarm2: Record<string,() => void>
 *  smartplug: Record<string,() => void>
 *  smartplug2: Record<string,() => void>
 * }}
 */ const $1d17319f79c68be8$var$notificationListeners = {
    farmcamsim: {},
    fencealarm: {},
    fencealarm2: {},
    smartplug: {},
    smartplug2: {}
};
/**
 * @param {"farmcamsim"|"fencealarm"|"fencealarm2"|"smartplug"|"smartplug2"} deviceType
 * @param {string} deviceId
 * @param {() => void} callback // Note: Consider forwarding the notification data to the callback
 */ const $1d17319f79c68be8$export$1fb3ec0f927e5ebb = (deviceType, deviceId, callback)=>{
    if (!$1d17319f79c68be8$export$d70a5ce4bc79c42d) return;
    $1d17319f79c68be8$var$notificationListeners[deviceType][deviceId] = callback;
};
/**
 * @param {"farmcamsim"|"fencealarm"|"fencealarm2"|"smartplug"|"smartplug2"} deviceType
 * @param {string} deviceId
 */ const $1d17319f79c68be8$export$de3286d9f4bb572b = (deviceType, deviceId)=>{
    if (!$1d17319f79c68be8$export$d70a5ce4bc79c42d) return;
    delete $1d17319f79c68be8$var$notificationListeners[deviceType][deviceId];
};
async function $1d17319f79c68be8$export$bc8117be864076f2() {
    let permStatus = await (0, $73af3aa28454c31d$export$8f83d3f28eb09744).checkPermissions();
    if (permStatus.receive === "prompt") permStatus = await (0, $73af3aa28454c31d$export$8f83d3f28eb09744).requestPermissions();
    if (permStatus.receive !== "granted") // Handle error
    throw new Error("User denied permissions!");
    await (0, $73af3aa28454c31d$export$8f83d3f28eb09744).register();
}
async function $1d17319f79c68be8$export$e66a2914cd52b9ef() {
    await (0, $73af3aa28454c31d$export$8f83d3f28eb09744).addListener("registration", async (token)=>{
        try {
            if (!token?.value || !(await (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).getSignedInUser()).Id) return;
            await (0, $1a098edb0104b631$export$c4e9ed27683c7df0)(token.value);
            $1d17319f79c68be8$export$273fb6590fc80197.setValue("registeredNotificationsToken", true);
        } catch (error) {
            console.error("Failed to register token", error);
        }
    });
    await (0, $73af3aa28454c31d$export$8f83d3f28eb09744).addListener("registrationError", (err)=>{
        console.error("Registration error: ", err.error);
    });
    await (0, $73af3aa28454c31d$export$8f83d3f28eb09744).addListener("pushNotificationReceived", async (notification)=>{
        if (!(await (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).getSignedInUser())?.Id) return;
        try {
            if (!notification.data?.Imei) {
                if (notification.data?.Device === "fencealarm") $1d17319f79c68be8$var$notificationListeners["fencealarm"][notification.data.Imei]?.();
                else if (notification.data?.Device === "fencealarm2") $1d17319f79c68be8$var$notificationListeners["fencealarm2"][notification.data.Imei]?.();
                else if (notification.data?.Device === "smartplug") $1d17319f79c68be8$var$notificationListeners["smartplug"][notification.data.Imei]?.();
            } else if (notification.data?.Imsi) {
                if (notification.data?.Device === "farmcamsim") $1d17319f79c68be8$var$notificationListeners["farmcamsim"][notification.data.Imsi]?.();
            }
        } catch (error) {
        // Handle callback error
        }
    });
    await (0, $73af3aa28454c31d$export$8f83d3f28eb09744).addListener("pushNotificationActionPerformed", async (action)=>{
        if (!$1d17319f79c68be8$export$273fb6590fc80197.getValue("appFinishedLoading")) {
            $1d17319f79c68be8$var$initialNotification = action.notification;
            return;
        }
        if (!(await (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).getSignedInUser())?.Id) return;
        const imei = action.notification.data?.Imei;
        if (imei) (0, $b4e14b6b8da86996$export$5375cda95f0b0eb4).jump("/devices" + (0, $820877bea407f5fe$export$89a7e74069fbb7af)({
            id: imei
        }));
    });
}
let $1d17319f79c68be8$var$lastActiveAt = Date.now();
let $1d17319f79c68be8$var$lastInactiveAt = Date.now();
/** @typedef {Record<string, (n: number) => void>} StateListener */ /** @type {StateListener} */ let $1d17319f79c68be8$var$focusListeners = {};
/** @type {StateListener} */ let $1d17319f79c68be8$var$blurListeners = {};
async function $1d17319f79c68be8$export$a6277d66d891fee0() {
    (0, $fc70cc85372c45fc$export$86fbec116b87613f).addListener("appStateChange", (state)=>{
        if (state.isActive) {
            $1d17319f79c68be8$var$lastActiveAt = Date.now();
            const secondsInactive = (Date.now() - $1d17319f79c68be8$var$lastInactiveAt) / 1000;
            Object.keys($1d17319f79c68be8$var$focusListeners).forEach((key)=>{
                try {
                    $1d17319f79c68be8$var$focusListeners[key]?.(secondsInactive);
                } catch (error) {
                    console.error("Error in focus listener", error);
                }
            });
        } else {
            $1d17319f79c68be8$var$lastInactiveAt = Date.now();
            const secondsActive = (Date.now() - $1d17319f79c68be8$var$lastActiveAt) / 1000;
            Object.keys($1d17319f79c68be8$var$blurListeners).forEach((key)=>{
                try {
                    $1d17319f79c68be8$var$blurListeners[key]?.(secondsActive);
                } catch (error) {
                    console.error("Error in blur listener", error);
                }
            });
        }
    });
}
/**
 * @param {string} key
 * @param {(n: number) => void} callback
 */ function $1d17319f79c68be8$export$f1c910826b30c777(key, callback) {
    $1d17319f79c68be8$var$focusListeners[key] = callback;
}
/**
 * @param {string} key
 */ function $1d17319f79c68be8$export$441507473916da2(key) {
    delete $1d17319f79c68be8$var$focusListeners[key];
}
/**
 * @param {string} key
 * @param {(n: number) => void} callback
 */ function $1d17319f79c68be8$export$ed76dd34f19449(key, callback) {
    $1d17319f79c68be8$var$blurListeners[key] = callback;
}
/**
 * @param {string} key
 */ function $1d17319f79c68be8$export$6ca1fdbef0f27d1a(key) {
    delete $1d17319f79c68be8$var$focusListeners[key];
}
/**
 * @param {string} key
 */ function $1d17319f79c68be8$export$ce7ae6ec133f8554(key) {
    delete $1d17319f79c68be8$var$focusListeners[key];
    delete $1d17319f79c68be8$var$blurListeners[key];
}
function $1d17319f79c68be8$export$962c6cb2beed8b66() {
    $1d17319f79c68be8$var$focusListeners = {};
    $1d17319f79c68be8$var$blurListeners = {};
}


/**
 * 
 * @param {string} key 
 * @returns {Promise<string | null>}
 */ async function $744d2dad838f829a$export$f92dfeb71e9bb569(key) {
    if (0, $1d17319f79c68be8$export$d70a5ce4bc79c42d) return (await (0, $d8c8c6c54969fb10$export$6b7b6cff4ccb438b).get({
        key: key
    })).value;
    return localStorage.getItem(key);
}
/**
 * 
 * @param {string} key 
 * @returns {Promise<void>}
 */ async function $744d2dad838f829a$export$fe2d9b4e03920b4c(key) {
    if (0, $1d17319f79c68be8$export$d70a5ce4bc79c42d) return await (0, $d8c8c6c54969fb10$export$6b7b6cff4ccb438b).remove({
        key: key
    });
    return localStorage.removeItem(key);
}
/**
 * @param {string} key 
 * @param {string} value 
 * @returns {Promise<void>}
 */ async function $744d2dad838f829a$export$8a8216c44337cd5(key, value) {
    if (0, $1d17319f79c68be8$export$d70a5ce4bc79c42d) return await (0, $d8c8c6c54969fb10$export$6b7b6cff4ccb438b).set({
        key: key,
        value: value
    });
    return localStorage.setItem(key, value);
}


/** @type {NodeJS.Timeout|undefined} */ let $bfc59006cf644cf7$var$loadDevicesTimeout;
/** @type {Record<string, FarmcamSim>} */ const $bfc59006cf644cf7$var$farmcamSims = {};
/** @type {Record<string, Fencealarm>} */ const $bfc59006cf644cf7$var$fencealarms = {};
/** @type {Record<string, Fencealarm2>} */ const $bfc59006cf644cf7$var$fencealarm2s = {};
/** @type {Record<string, Smartplug>} */ const $bfc59006cf644cf7$var$smartplugs = {};
/** @type {Record<string, Smartplug2>} */ const $bfc59006cf644cf7$var$smartplug2s = {};
/**
 * @returns {Promise<User>}
 */ async function $bfc59006cf644cf7$var$getActiveUser() {
    const impersonate = sessionStorage.getItem("impersonate");
    if (impersonate) return JSON.parse(impersonate);
    return $bfc59006cf644cf7$var$getSignedInUser();
}
/**
 * @returns {string[]}
 */ function $bfc59006cf644cf7$var$getDeviceTags() {
    /** @type {Set<string>} */ const tagSet = new Set();
    Object.entries($bfc59006cf644cf7$var$farmcamSims).flatMap(([_imsi, fcs])=>fcs.Metadata.Tags).forEach((tag)=>{
        if (tag) tagSet.add(tag);
    });
    Object.entries($bfc59006cf644cf7$var$fencealarms).flatMap(([_imei, fa])=>fa.Metadata.Tags).forEach((tag)=>{
        if (tag) tagSet.add(tag);
    });
    Object.entries($bfc59006cf644cf7$var$fencealarm2s).flatMap(([_imei, fa2])=>fa2.Metadata.Tags).forEach((tag)=>{
        if (tag) tagSet.add(tag);
    });
    Object.entries($bfc59006cf644cf7$var$smartplugs).flatMap(([_imei, sp])=>sp.Metadata.Tags).forEach((tag)=>{
        if (tag) tagSet.add(tag);
    });
    Object.entries($bfc59006cf644cf7$var$smartplug2s).flatMap(([_imei, sp2])=>sp2.Metadata.Tags).forEach((tag)=>{
        if (tag) tagSet.add(tag);
    });
    return Array.from(tagSet).sort((a, b)=>a.localeCompare(b));
}
/**
 * @returns {Promise<User>}
 */ async function $bfc59006cf644cf7$var$getSignedInUser() {
    const user = await $744d2dad838f829a$export$f92dfeb71e9bb569("user");
    if (user) return JSON.parse(user);
    return {
        Id: "",
        CustomerId: "",
        AccountType: "",
        Email: "",
        Phone: "",
        Locale: "en-GB",
        Country: "",
        EmailNotifications: {
            Billing: false,
            Device: false,
            Marketing: false
        },
        PushNotifications: {
            Enabled: false,
            Tokens: []
        },
        SmsNotifications: {
            Enabled: false,
            Balance: 0
        }
    };
}
/**
 * @returns {Promise<Token>}
 */ async function $bfc59006cf644cf7$var$getToken() {
    const token = await $744d2dad838f829a$export$f92dfeb71e9bb569("token");
    if (token) return JSON.parse(token);
    else return {
        String: "",
        ExpiresAt: "1970-01-01T00:00:00Z"
    };
}
/**
 * @returns {Promise<string>}
 */ async function $bfc59006cf644cf7$var$getTokenString() {
    const token = await $bfc59006cf644cf7$var$getToken();
    return token.String;
}
function $bfc59006cf644cf7$var$isImpersonating() {
    const impersonate = sessionStorage.getItem("impersonate");
    if (impersonate) return true;
    return false;
}
async function $bfc59006cf644cf7$var$isSignedIn() {
    const margin = 1e4;
    const expiresAt = new Date((await $bfc59006cf644cf7$var$getToken()).ExpiresAt);
    const now = Date.now();
    return now < expiresAt.getTime() - margin;
}
async function $bfc59006cf644cf7$var$loadDevices() {
    const devices = await (0, $242ad89fa77f4e5f$export$dcbad4de9b70b527)();
    Object.keys($bfc59006cf644cf7$var$farmcamSims).forEach((imsi)=>{
        delete $bfc59006cf644cf7$var$farmcamSims[imsi];
    });
    for (const fcs of devices.FarmcamSims){
        fcs.Metadata.Tags = (0, $32a329fb73bfcadd$export$2b602f2290961f2e)(fcs.Metadata.Tags, "FarmCam SIM");
        fcs.Metadata.Tags = (0, $32a329fb73bfcadd$export$2b602f2290961f2e)(fcs.Metadata.Tags, fcs.Metadata.OwnerEmail);
        $bfc59006cf644cf7$var$farmcamSims[fcs.Imsi] = fcs;
    }
    Object.keys($bfc59006cf644cf7$var$fencealarms).forEach((imei)=>{
        delete $bfc59006cf644cf7$var$fencealarms[imei];
    });
    for (const fa of devices.Fencealarms){
        fa.Metadata.Tags = (0, $32a329fb73bfcadd$export$2b602f2290961f2e)(fa.Metadata.Tags, "FenceAlarm");
        fa.Metadata.Tags = (0, $32a329fb73bfcadd$export$2b602f2290961f2e)(fa.Metadata.Tags, fa.Metadata.OwnerEmail);
        $bfc59006cf644cf7$var$fencealarms[fa.Imei] = fa;
    }
    Object.keys($bfc59006cf644cf7$var$fencealarm2s).forEach((imei)=>{
        delete $bfc59006cf644cf7$var$fencealarm2s[imei];
    });
    for (const fa2 of devices.Fencealarm2s){
        fa2.Metadata.Tags = (0, $32a329fb73bfcadd$export$2b602f2290961f2e)(fa2.Metadata.Tags, "FenceAlarm2");
        fa2.Metadata.Tags = (0, $32a329fb73bfcadd$export$2b602f2290961f2e)(fa2.Metadata.Tags, fa2.Metadata.OwnerEmail);
        $bfc59006cf644cf7$var$fencealarm2s[fa2.Imei] = fa2;
    }
    Object.keys($bfc59006cf644cf7$var$smartplugs).forEach((imei)=>{
        delete $bfc59006cf644cf7$var$smartplugs[imei];
    });
    for (const sp of devices.Smartplugs){
        sp.Metadata.Tags = (0, $32a329fb73bfcadd$export$2b602f2290961f2e)(sp.Metadata.Tags, "SmartPlug");
        sp.Metadata.Tags = (0, $32a329fb73bfcadd$export$2b602f2290961f2e)(sp.Metadata.Tags, sp.Metadata.OwnerEmail);
        $bfc59006cf644cf7$var$smartplugs[sp.Imei] = sp;
    }
    Object.keys($bfc59006cf644cf7$var$smartplug2s).forEach((imei)=>{
        delete $bfc59006cf644cf7$var$smartplug2s[imei];
    });
    for (const sp2 of devices.Smartplug2s){
        sp2.Metadata.Tags = (0, $32a329fb73bfcadd$export$2b602f2290961f2e)(sp2.Metadata.Tags, "SmartPlug2");
        sp2.Metadata.Tags = (0, $32a329fb73bfcadd$export$2b602f2290961f2e)(sp2.Metadata.Tags, sp2.Metadata.OwnerEmail);
        $bfc59006cf644cf7$var$smartplug2s[sp2.Imei] = sp2;
    }
}
/**
 * @param {Token} token
 */ async function $bfc59006cf644cf7$var$setToken(token) {
    await $744d2dad838f829a$export$8a8216c44337cd5("token", JSON.stringify(token));
}
/**
 * @param {User} user
 */ async function $bfc59006cf644cf7$var$setUser(user) {
    await $744d2dad838f829a$export$8a8216c44337cd5("user", JSON.stringify(user));
}
async function $bfc59006cf644cf7$var$signOut() {
    await $744d2dad838f829a$export$fe2d9b4e03920b4c("token");
    await $744d2dad838f829a$export$fe2d9b4e03920b4c("user");
}
/**
 * @param {User} user
 */ async function $bfc59006cf644cf7$var$startImpersonating(user) {
    sessionStorage.setItem("impersonate", JSON.stringify(user));
    await $bfc59006cf644cf7$var$loadDevices();
}
/**
 * @param {() => void} onLoad
 */ function $bfc59006cf644cf7$var$startLoadDevicesInterval(onLoad) {
    if ($bfc59006cf644cf7$var$loadDevicesTimeout) return;
    const job = ()=>$bfc59006cf644cf7$var$loadDevices().then(onLoad);
    $bfc59006cf644cf7$var$loadDevicesTimeout = setInterval(job, 5000);
}
async function $bfc59006cf644cf7$var$stopImpersonate() {
    sessionStorage.removeItem("impersonate");
    await $bfc59006cf644cf7$var$loadDevices();
}
function $bfc59006cf644cf7$var$stopLoadDevicesInterval() {
    clearInterval($bfc59006cf644cf7$var$loadDevicesTimeout);
    $bfc59006cf644cf7$var$loadDevicesTimeout = undefined;
}
const $bfc59006cf644cf7$export$ca000e230c0caa3e = {
    farmcamSims: $bfc59006cf644cf7$var$farmcamSims,
    fencealarms: $bfc59006cf644cf7$var$fencealarms,
    fencealarm2s: $bfc59006cf644cf7$var$fencealarm2s,
    getActiveUser: $bfc59006cf644cf7$var$getActiveUser,
    getDeviceTags: $bfc59006cf644cf7$var$getDeviceTags,
    getSignedInUser: $bfc59006cf644cf7$var$getSignedInUser,
    getToken: $bfc59006cf644cf7$var$getToken,
    getTokenString: $bfc59006cf644cf7$var$getTokenString,
    isImpersonating: $bfc59006cf644cf7$var$isImpersonating,
    isSignedIn: $bfc59006cf644cf7$var$isSignedIn,
    loadDevices: $bfc59006cf644cf7$var$loadDevices,
    setToken: $bfc59006cf644cf7$var$setToken,
    setUser: $bfc59006cf644cf7$var$setUser,
    signOut: $bfc59006cf644cf7$var$signOut,
    smartplugs: $bfc59006cf644cf7$var$smartplugs,
    smartplug2s: $bfc59006cf644cf7$var$smartplug2s,
    startImpersonating: $bfc59006cf644cf7$var$startImpersonating,
    startLoadDevicesInterval: $bfc59006cf644cf7$var$startLoadDevicesInterval,
    stopImpersonate: $bfc59006cf644cf7$var$stopImpersonate,
    stopLoadDevicesInterval: $bfc59006cf644cf7$var$stopLoadDevicesInterval
};


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
'use strict';
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
'use strict';
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup['-'.charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup['_'.charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case 'ascii':
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case 'base64':
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $eeb0961446aae8e3$export$6100ba28696e12de(buf);
    else return $eeb0961446aae8e3$export$6100ba28696e12de(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$51861dfc7ca9d588$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $eeb0961446aae8e3$export$d622b2ad8d90c771($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}


var $b6a0b7007b404cc4$require$Buffer = $51861dfc7ca9d588$export$a143d493d941bafc;
class $b6a0b7007b404cc4$export$bf71da7aebe9ddc1 {
    delete(path) {
        return new $b6a0b7007b404cc4$var$ApiRequest({
            host: this.#host,
            method: "DELETE",
            onTimeout: ()=>this.#onTimeout(),
            path: path
        });
    }
    get(path) {
        return new $b6a0b7007b404cc4$var$ApiRequest({
            host: this.#host,
            method: "GET",
            onTimeout: ()=>this.#onTimeout(),
            path: path
        });
    }
    post(path) {
        return new $b6a0b7007b404cc4$var$ApiRequest({
            host: this.#host,
            method: "POST",
            onTimeout: ()=>this.#onTimeout(),
            path: path
        });
    }
    put(path) {
        return new $b6a0b7007b404cc4$var$ApiRequest({
            host: this.#host,
            method: "PUT",
            onTimeout: ()=>this.#onTimeout(),
            path: path
        });
    }
    #host;
    #onTimeout;
    constructor(host, onTimeout){
        this.#host = host;
        this.#onTimeout = onTimeout;
    }
}
class $b6a0b7007b404cc4$var$ApiRequest {
    async do() {
        await Promise.all(this.#promises);
        let url = `https://${this.#host}${this.#path}`;
        if (this.#query) url += this.#query;
        return await fetch(url, {
            body: this.#body,
            headers: this.#headers,
            method: this.#method,
            signal: AbortSignal.timeout(this.#timeout)
        }).catch((err)=>{
            if (err instanceof DOMException && err.name === "TimeoutError") this.#onTimeout();
            throw err;
        });
    }
    setBasicAuth(username, password) {
        const base64String = $b6a0b7007b404cc4$require$Buffer.from(`${username}:${password}`).toString("base64");
        this.#headers.set("Authorization", `Basic ${base64String}`);
    }
    setBody(data) {
        this.#body = data;
    }
    setJsonBody(data) {
        this.#body = JSON.stringify(data);
        this.#headers.set("Content-Type", "application/json");
    }
    setSignedInUserAuth() {
        const promise = (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).getTokenString().then((tokenString)=>{
            this.#headers.set("Authorization", `Bearer ${tokenString}`);
        });
        this.#promises.push(promise);
    }
    setTimeout(ms) {
        this.#timeout = ms;
    }
    #body;
    #headers = new Headers();
    #host;
    #method;
    #onTimeout;
    #path;
    #promises = [];
    #query = "";
    #timeout = 30e3;
    constructor(args){
        this.#host = args.host;
        this.#method = args.method;
        this.#method = args.method;
        this.#onTimeout = args.onTimeout;
        this.#path = args.path;
    }
}






/**
 * @typedef {Object} Prices
 * @property {Price} FarmcamSimExtraData
 * @property {Price} FarmcamSimSmall
 * @property {Price} FarmcamSimMedium
 * @property {Price} FarmcamSimLarge
 * @property {Price} FencealarmMonth
 * @property {Price} FencealarmYear
 * @property {Price} Fencealarm2Month
 * @property {Price} Fencealarm2Year
 * @property {Price} SmartplugMonth
 * @property {Price} SmartplugYear
 * @property {Price} Smartplug2Month
 * @property {Price} Smartplug2Year
 * @property {Price} Sms
 * 
 * @typedef {Object} Price
 * @property {string} Id
 * @property {string} Name
 * @property {number} Eur
 * @property {number} Sek
 * @property {() => Promise<string>} toString
 */ /**
 * DEPRECATED in favour of billing/prices.js
 * @returns {Promise<Prices>}
 */ async function $26a5802c7b7183d2$export$41303c5fee299aff() {
    if (!$26a5802c7b7183d2$var$getPricesCache) {
        const res = await (0, $5ca15832b8c5d5ea$export$3988ae62b71be9a3)("/prices", {
            timeout: 20000
        });
        if (!res.ok) throw (0, $1fb5d845307c571c$export$f00cf23da648bc9b)(res);
        $26a5802c7b7183d2$var$getPricesCache = await res.json();
    }
    if (!$26a5802c7b7183d2$var$getPricesCache) throw "failed to get price data";
    /** @type {Prices} */ Object.entries($26a5802c7b7183d2$var$getPricesCache).forEach(([key, price])=>{
        price.toString = async ()=>{
            const currency = (await (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).getActiveUser()).Country === "SE" ? "Sek" : "Eur";
            const perMonthString = (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
                enGB: "per month ex VAT",
                deDE: "pro Monat ohne MwSt.",
                frFR: "par mois hors TVA",
                svSE: "per m\xe5nad ex moms"
            });
            const perYearString = (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
                enGB: "per year ex VAT",
                deDE: "pro Jahr ohne MwSt.",
                frFR: "par an hors TVA",
                svSE: "per \xe5r ex moms"
            });
            switch(key){
                case "FarmcamSimSmall":
                case "FarmcamSimMedium":
                case "FarmcamSimLarge":
                case "FencealarmMonth":
                case "Fencealarm2Month":
                case "SmartplugMonth":
                case "Smartplug2Month":
                    return `${price[currency]} ${currency.toUpperCase()} ${perMonthString}`;
                case "FencealarmYear":
                case "Fencealarm2Year":
                case "SmartplugYear":
                case "Smartplug2Year":
                    return `${price[currency]} ${currency.toUpperCase()} ${perYearString}`;
                case "FarmcamSimExtraData":
                case "Sms":
                    return `${price[currency]} ${currency.toUpperCase()}`;
                default:
                    return `0 ${currency.toUpperCase()}`;
            }
        };
    });
    return $26a5802c7b7183d2$var$getPricesCache;
}
/** @type {Prices|undefined} */ let $26a5802c7b7183d2$var$getPricesCache;





async function $1cfcaaa9e36e40b3$export$c542b5e295206b2a() {
    if (!await (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).isSignedIn()) return;
    const res = await (0, $5ca15832b8c5d5ea$export$3988ae62b71be9a3)("/token");
    if (res.ok) {
        await (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).setToken(await res.json());
        return;
    }
    switch(res.status){
        case 401:
            (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).signOut();
            return;
        default:
            throw await (0, $1fb5d845307c571c$export$f00cf23da648bc9b)(res);
    }
}









/**
 * @param {string} imsi
 */ async function $85e6b33e9fd1129e$export$4d294e620db04cb8(imsi) {
    const res = await (0, $5ca15832b8c5d5ea$export$1d2f21e549771e67)(`/farmcam-sims/${imsi}`);
    if (!res.ok) throw await (0, $1fb5d845307c571c$export$f00cf23da648bc9b)(res);
}
/**
 * @param {string} imsi
 * @returns {Promise<FarmcamSim>}
 */ async function $85e6b33e9fd1129e$export$120a35c1e84d6bc4(imsi) {
    const res = await (0, $5ca15832b8c5d5ea$export$1d2f21e549771e67)(`/farmcam-sims/${imsi}/subscription`);
    if (!res.ok) throw await (0, $1fb5d845307c571c$export$f00cf23da648bc9b)(res);
    return res.json();
}
/**
 * @param {string} imsi
 * @returns {Promise<FarmcamSim>}
 */ async function $85e6b33e9fd1129e$export$9ec98c9f02cbcd4d(imsi) {
    const res = await (0, $5ca15832b8c5d5ea$export$3988ae62b71be9a3)(`/farmcam-sims/${imsi}`);
    if (!res.ok) throw await (0, $1fb5d845307c571c$export$f00cf23da648bc9b)(res);
    return res.json();
}
/**
 * @typedef {Object} RemainingDataDataPoint
 * @property {string} Imsi
 * @property {number} RemainingData
 * @property {string} Timestamp
 */ /**
 * @param {string} imsi
 * @param {DataPointQueryParams} [args]
 * @returns {Promise<RemainingDataDataPoint[]|Blob>}
 */ async function $85e6b33e9fd1129e$export$4ae75616531cb2b8(imsi, args) {
    const params = (0, $820877bea407f5fe$export$89a7e74069fbb7af)(args);
    const res = await (0, $5ca15832b8c5d5ea$export$3988ae62b71be9a3)(`/farmcam-sims/${imsi}/remaining-data${params}`);
    if (!res.ok) throw await (0, $1fb5d845307c571c$export$f00cf23da648bc9b)(res);
    if (!args || args.format === "json") return res.json();
    return res.blob();
}
/**
 * @param {string} imsi
 * @returns {Promise<FarmcamSim>}
 */ async function $85e6b33e9fd1129e$export$f10f79f76bbb768f(imsi) {
    const res = await (0, $5ca15832b8c5d5ea$export$299ba2dee77727e9)(`/farmcam-sims/${imsi}/data`);
    if (!res.ok) throw await (0, $1fb5d845307c571c$export$f00cf23da648bc9b)(res);
    return res.json();
}
/**
 * @param {string} imsi
 * @param {PutFarmcamSimParams} args
 * @returns {Promise<FarmcamSim>}
 */ async function $85e6b33e9fd1129e$export$69cc339365cb68a4(imsi, args) {
    const res = await (0, $5ca15832b8c5d5ea$export$327f7b26ebf455db)(`/farmcam-sims/${imsi}`, {
        body: JSON.stringify(args)
    });
    if (!res.ok) throw await (0, $1fb5d845307c571c$export$f00cf23da648bc9b)(res);
    return res.json();
}
/**
 * @param {string} imsi 
 * @param {string} email 
 * @returns {Promise<FarmcamSim>}
 */ async function $85e6b33e9fd1129e$export$e1403bb2fa4d8315(imsi, email) {
    const res = await (0, $5ca15832b8c5d5ea$export$327f7b26ebf455db)(`/farmcam-sims/${imsi}/owner`, {
        body: JSON.stringify({
            Email: email
        })
    });
    if (!res.ok) throw await (0, $1fb5d845307c571c$export$f00cf23da648bc9b)(res);
    return res.json();
}
/**
 * @param {string} imsi
 * @param {number} bytes
 * @param {number} days
 * @returns {Promise<FarmcamSim>}
 */ async function $85e6b33e9fd1129e$export$11f488bcc280aeb6(imsi, bytes, days) {
    const res = await (0, $5ca15832b8c5d5ea$export$327f7b26ebf455db)(`/farmcam-sims/${imsi}/trial`, {
        body: JSON.stringify({
            Bytes: bytes,
            Days: days
        })
    });
    if (!res.ok) throw await (0, $1fb5d845307c571c$export$f00cf23da648bc9b)(res);
    return res.json();
}









function $6ca74af0140fbc39$export$234fe0565be67471(cfg) {
    let iconClassList = "icon";
    switch(cfg.size){
        case 1:
        case 2:
            iconClassList += " is-large";
            break;
        case 3:
        case 4:
            break;
        case 5:
            iconClassList += " is-medium";
            break;
        case 6:
        case 7:
            iconClassList += " is-small";
    }
    if (cfg.hidden) iconClassList += " is-hidden";
    let symbolClassList = `material-symbols-sharp is-size-${cfg.size}`;
    if (cfg.onclick) symbolClassList += " is-clickable";
    if (cfg.flashing) symbolClassList += " flashing";
    const onclick = cfg.onclick ? cfg.onclick : null;
    return (0, $01d3af8f1b8eef63$export$afc1bfabebaf28a2)({
        class: iconClassList
    }, (0, $01d3af8f1b8eef63$export$afc1bfabebaf28a2)({
        class: symbolClassList,
        onclick: onclick
    }, cfg.id));
}


/**
 * @typedef {object} DeviceCardConfig
 * @property {string} deviceName
 * @property {DeviceType} deviceType
 * @property {string} productName
 * @property {string[]} warnings
 * @property {HTMLParagraphElement[]} lines
 * @property {HTMLAnchorElement[]} buttons
 
 * @param {DeviceCardConfig} cfg 
 */ function $b803aaa0dd2fc957$export$3d7ac60f9474f7a3(cfg) {
    cfg.buttons.forEach((a)=>a.classList.add("card-footer-item"));
    return (0, $259ccf8ca7c2ca99$export$2e2bcd8739ae039).tags.div({
        class: "card"
    }, (0, $259ccf8ca7c2ca99$export$2e2bcd8739ae039).tags.div({
        class: `card-header p-2 ${cfg.deviceType}`
    }, (0, $259ccf8ca7c2ca99$export$2e2bcd8739ae039).tags.div({
        class: "media"
    }, (0, $259ccf8ca7c2ca99$export$2e2bcd8739ae039).tags.figure({
        class: "media-left"
    }, (0, $259ccf8ca7c2ca99$export$2e2bcd8739ae039).tags.figure({
        class: "image is-48x48"
    }, (0, $259ccf8ca7c2ca99$export$2e2bcd8739ae039).tags.img({
        src: (0, $46d03d54faf4cdf4$export$555f04397502546)[`${cfg.deviceType}.svg`]
    }))), (0, $259ccf8ca7c2ca99$export$2e2bcd8739ae039).tags.div({
        class: "media-content"
    }, (0, $259ccf8ca7c2ca99$export$2e2bcd8739ae039).tags.h1({
        class: "title is-4"
    }, cfg.deviceName), (0, $259ccf8ca7c2ca99$export$2e2bcd8739ae039).tags.h2({
        class: "subtitle is-6"
    }, cfg.productName)), (0, $259ccf8ca7c2ca99$export$2e2bcd8739ae039).tags.div({
        class: "media-right"
    }, (0, $6ca74af0140fbc39$export$234fe0565be67471)({
        flashing: true,
        hidden: cfg.warnings.length < 1,
        id: "error",
        onclick: ()=>$b803aaa0dd2fc957$var$openWarningsModal(cfg.deviceName, cfg.warnings),
        size: 1
    })))), (0, $259ccf8ca7c2ca99$export$2e2bcd8739ae039).tags.div({
        class: "card-content"
    }, ...cfg.lines), (0, $259ccf8ca7c2ca99$export$2e2bcd8739ae039).tags.div({
        class: `card-footer ${cfg.deviceType}`
    }, ...cfg.buttons));
}
/**
 * @param {Subscription} sub
 * @returns {[string,string]} localised label, formatted date
 */ function $b803aaa0dd2fc957$export$1f1e817cb63ab44a(sub) {
    const now = new Date();
    const expiresAt = new Date(sub.ExpiresAt);
    const expiresAtFormatted = (0, $093d22e30b803c56$export$162ce11d62a1ca51).dateString(expiresAt);
    if (sub.PriceIds.Next) return [
        (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
            deDE: "- Verl\xe4ngert sich",
            enGB: "- Renews",
            frFR: "- Renouvellement le",
            svSE: "- F\xf6rnyas"
        }),
        expiresAtFormatted
    ];
    if (expiresAt < now) return [
        (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
            deDE: "- Beendet am",
            enGB: "- Ended",
            frFR: "- Termin\xe9 le",
            svSE: "- Avslutades"
        }),
        expiresAtFormatted
    ];
    return [
        (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
            deDE: "- Endet am",
            enGB: "- Ends",
            frFR: "- Jusqu'au",
            svSE: "- Upph\xf6r"
        }),
        expiresAtFormatted
    ];
}
/**
 *
 * @param {string} deviceName
 * @param {string[]} warnings
 */ function $b803aaa0dd2fc957$var$openWarningsModal(deviceName, warnings) {
    (0, $b4e14b6b8da86996$export$96e4b36520c26a2c).open({
        header: deviceName,
        body: [
            (0, $00995e7d83a33b33$export$13f9d3c4397c4713).unorderedList(...warnings).element
        ],
        footer: []
    });
}










/**
 * @param {FarmcamSim} fcs 
 * @returns {string}
 */ function $1ee19110e9860fe1$var$checkRemainingData(fcs) {
    if (Date.now() > new Date(fcs.Subscription.ExpiresAt).getTime()) return "";
    if (fcs.RemainingData < 1) return (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
        enGB: "Out of data",
        deDE: "Keine Daten mehr vorhanden",
        frFR: "Donn\xe9es manquantes",
        svSE: "Slut p\xe5 data"
    });
    if (fcs.RemainingData < 20e6) return (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
        enGB: "Low data",
        deDE: "Niedrige Daten",
        frFR: "Peu de donn\xe9es",
        svSE: "L\xe5g data"
    });
    return "";
}
/**
 * @param {FarmcamSim} fcs 
 * @returns {string[]}
 */ function $1ee19110e9860fe1$export$10a1372e1e5219c5(fcs) {
    return [
        $1ee19110e9860fe1$var$checkRemainingData(fcs)
    ].filter((text)=>text !== "");
}


/**
 * @param {FarmcamSim} fcs
 */ async function $09e8f7aaccc0857e$export$f4c20afbd1fb63c3(fcs) {
    (0, $1d17319f79c68be8$export$1fb3ec0f927e5ebb)("farmcamsim", fcs.Imsi, ()=>{
        (0, $85e6b33e9fd1129e$export$9ec98c9f02cbcd4d)(fcs.Imsi).then((fcs)=>{
            (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).farmcamSims[fcs.Imsi] = fcs;
        // refresh(fcs)
        });
    });
    return (0, $b803aaa0dd2fc957$export$3d7ac60f9474f7a3)({
        deviceName: fcs.Metadata.Name,
        deviceType: "farmcam-sim",
        productName: "FarmCam SIM",
        warnings: (0, $1ee19110e9860fe1$export$10a1372e1e5219c5)(fcs),
        lines: [
            (0, $62f894d94fb7061c$export$c7b5d08fe382bb2a)((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
                enGB: "Remaining data",
                deDE: "Verbleibende Daten",
                frFR: "Donn\xe9es restantes",
                svSE: "\xc5terst\xe5ende data"
            }), (0, $820877bea407f5fe$export$93320de5093983a2)(fcs.RemainingData)),
            (0, $62f894d94fb7061c$export$c7b5d08fe382bb2a)((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
                enGB: "Subscription",
                deDE: "Abonnement",
                frFR: "Abonnement",
                svSE: "Prenumeration"
            })),
            (0, $62f894d94fb7061c$export$c7b5d08fe382bb2a)((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
                enGB: "- Plan",
                deDE: "- Plan",
                frFR: "- Plan",
                svSE: "- Plan"
            }), await $09e8f7aaccc0857e$var$formatSubscriptionPlan(fcs)),
            (0, $62f894d94fb7061c$export$c7b5d08fe382bb2a)(...(0, $b803aaa0dd2fc957$export$1f1e817cb63ab44a)(fcs.Subscription))
        ],
        buttons: [
            (0, $00995e7d83a33b33$export$13f9d3c4397c4713).anchor({}, (0, $1abc8d719eea79cd$export$e1dd10d13c5a06).icon({
                id: "monitoring",
                onClick: ()=>(0, $b4e14b6b8da86996$export$5375cda95f0b0eb4).jump(`/farmcam-sim/${fcs.Imsi}/logs`)
            })),
            (0, $00995e7d83a33b33$export$13f9d3c4397c4713).anchor({}, (0, $1abc8d719eea79cd$export$e1dd10d13c5a06).icon({
                id: "settings",
                onClick: ()=>(0, $b4e14b6b8da86996$export$5375cda95f0b0eb4).jump(`/farmcam-sim/${fcs.Imsi}`)
            }))
        ]
    });
}
/**
 * @param {FarmcamSim} fcs
 */ async function $09e8f7aaccc0857e$var$formatSubscriptionPlan(fcs) {
    if (fcs.Subscription.Trialing) return (0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.trial;
    const { FarmcamSimLarge: FarmcamSimLarge, FarmcamSimMedium: FarmcamSimMedium, FarmcamSimSmall: FarmcamSimSmall } = await (0, $26a5802c7b7183d2$export$41303c5fee299aff)();
    /** @type {(price: import('../billing/prices').Price) => string} */ const formatPrice = (price)=>{
        const matches = price.Name.match(/([0-9]+ [KMGT]?B)/gm);
        if (!matches) throw `invalid subscription name for price: ${price.Id}`;
        return matches[0];
    };
    switch(fcs.Subscription.PriceIds.Current){
        case FarmcamSimLarge.Id:
            return formatPrice(FarmcamSimLarge);
        case FarmcamSimMedium.Id:
            return formatPrice(FarmcamSimMedium);
        case FarmcamSimSmall.Id:
            return formatPrice(FarmcamSimSmall);
    }
    // This is to handle the transition period from priceId to priceIds.current/next
    const expiryTime = new Date(fcs.Subscription.ExpiresAt);
    if (Date.now() < expiryTime.getTime()) return "";
    return (0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.none;
}






/**
 * @param {string} imei
 */ async function $9711acd2da3d5569$export$d3d611f163395585(imei) {
    const res = await (0, $5ca15832b8c5d5ea$export$1d2f21e549771e67)(`/fencealarms/${imei}`);
    if (!res.ok) throw await (0, $1fb5d845307c571c$export$f00cf23da648bc9b)(res);
}
/**
 * @param {string} imei 
 * @returns {Promise<Fencealarm>}
 */ async function $9711acd2da3d5569$export$f65d65e9fd92caad(imei) {
    const res = await (0, $5ca15832b8c5d5ea$export$1d2f21e549771e67)(`/fencealarms/${imei}/subscription`);
    if (!res.ok) throw await (0, $1fb5d845307c571c$export$f00cf23da648bc9b)(res);
    return res.json();
}
/**
 * @param {string} imei
 * @returns {Promise<Fencealarm>}
 */ async function $9711acd2da3d5569$export$eb45d485f0b29de2(imei) {
    const res = await (0, $5ca15832b8c5d5ea$export$3988ae62b71be9a3)(`/fencealarms/${imei}`);
    if (res.status === 408) throw new Error('TIMEOUT');
    if (!res.ok) throw await (0, $1fb5d845307c571c$export$f00cf23da648bc9b)(res);
    return await res.json();
}
/**
 * @param {string} imei
 * @param {PutFencealarmParams} args
 * @returns {Promise<Fencealarm>}
 */ async function $9711acd2da3d5569$export$3424602516fb6a32(imei, args) {
    const res = await (0, $5ca15832b8c5d5ea$export$327f7b26ebf455db)(`/fencealarms/${imei}`, {
        body: JSON.stringify(args)
    });
    if (!res.ok) throw await (0, $1fb5d845307c571c$export$f00cf23da648bc9b)(res);
    return res.json();
}
/**
 * @param {string} imei 
 * @param {string} email 
 * @returns {Promise<Fencealarm>}
 */ async function $9711acd2da3d5569$export$360d3c05fe2527a9(imei, email) {
    const res = await (0, $5ca15832b8c5d5ea$export$327f7b26ebf455db)(`/fencealarms/${imei}/owner`, {
        body: JSON.stringify({
            Email: email
        })
    });
    if (!res.ok) throw await (0, $1fb5d845307c571c$export$f00cf23da648bc9b)(res);
    return res.json();
}
/**
 * @param {string} imei
 * @param {number} days 
 * @returns {Promise<Fencealarm>}
 */ async function $9711acd2da3d5569$export$b7007e151dbf0c70(imei, days) {
    const res = await (0, $5ca15832b8c5d5ea$export$327f7b26ebf455db)(`/fencealarms/${imei}/trial`, {
        body: JSON.stringify({
            Days: days
        })
    });
    if (!res.ok) throw await (0, $1fb5d845307c571c$export$f00cf23da648bc9b)(res);
    return res.json();
}
/**
 * @typedef {Object} VoltageDataPoint
 * @property {string} Imei
 * @property {number} Voltage
 * @property {string} Timestamp
 * 
 * @param {string} imei
 * @param {DataPointQueryParams} [args]
 * @returns {Promise<Blob|VoltageDataPoint[]>}
 */ async function $9711acd2da3d5569$export$c51e99cff56b63ce(imei, args) {
    const queryString = (0, $820877bea407f5fe$export$89a7e74069fbb7af)(args);
    const res = await (0, $5ca15832b8c5d5ea$export$3988ae62b71be9a3)(`/fencealarms/${imei}/voltage${queryString}`);
    if (!res.ok) throw await (0, $1fb5d845307c571c$export$f00cf23da648bc9b)(res);
    if (!args || args.format !== "json") return res.blob();
    return res.json();
}











/**
 * @param {Fencealarm} fa 
 * @returns {string}
 */ function $e2e52d051b880292$var$checkLowBatteryAlarm(fa) {
    if (fa.LowBatteryAlarm.Triggered) return (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
        enGB: "Low battery",
        deDE: "Schwache Batterie",
        frFR: "Pile faible",
        svSE: "L\xe5gt batteri"
    });
    return "";
}
/**
 * @param {Fencealarm} fa 
 * @returns {string}
 */ function $e2e52d051b880292$var$checkOfflineAlarm(fa) {
    if (fa.OfflineAlarm.Triggered) return (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
        enGB: "Device offline",
        deDE: "Ger\xe4t offline",
        frFR: "Appareil hors ligne",
        svSE: "Enhet offline"
    });
    return "";
}
/**
 * @param {Fencealarm} fa 
 * @returns {string}
 */ function $e2e52d051b880292$var$checkVoltageAlarm(fa) {
    if (fa.VoltageAlarm.Enabled && fa.VoltageAlarm.Triggered) return (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
        enGB: "Low fence voltage",
        deDE: "Niedrige Zaunspannung",
        frFR: "Faible tension de cl\xf4ture",
        svSE: "L\xe5g sp\xe4nning i st\xe4ngslet"
    });
    return "";
}
/**
 * @param {Fencealarm} fa 
 * @returns {string[]}
 */ function $e2e52d051b880292$export$33dfb56f599df445(fa) {
    return [
        $e2e52d051b880292$var$checkLowBatteryAlarm(fa),
        $e2e52d051b880292$var$checkOfflineAlarm(fa),
        $e2e52d051b880292$var$checkVoltageAlarm(fa)
    ].filter((text)=>text !== "");
}


/**
 * @param {Fencealarm} fa
 */ async function $256c2302b29b72fa$export$1879beac42e49fe2(fa) {
    (0, $1d17319f79c68be8$export$1fb3ec0f927e5ebb)("fencealarm", fa.Imei, ()=>{
        (0, $9711acd2da3d5569$export$eb45d485f0b29de2)(fa.Imei).then((fa)=>{
            (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).fencealarms[fa.Imei] = fa;
        // refresh(fa)
        });
    });
    return (0, $b803aaa0dd2fc957$export$3d7ac60f9474f7a3)({
        deviceName: fa.Metadata.Name,
        deviceType: "fencealarm",
        productName: "FenceAlarm",
        warnings: (0, $e2e52d051b880292$export$33dfb56f599df445)(fa),
        lines: [
            (0, $62f894d94fb7061c$export$c7b5d08fe382bb2a)((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
                enGB: "Device status",
                deDE: "Ger\xe4testatus",
                frFR: "\xc9tat de l'appareil",
                svSE: "Enhetsstatus"
            })),
            (0, $62f894d94fb7061c$export$c7b5d08fe382bb2a)((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
                enGB: "- Voltage",
                deDE: "- Spannung",
                frFR: "- Tension",
                svSE: "- Sp\xe4nning"
            }), `${fa.LastReport.Data.Voltage} V`),
            (0, $62f894d94fb7061c$export$c7b5d08fe382bb2a)((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
                enGB: "- Alarm level",
                deDE: "- Alarmstufe",
                frFR: "- Niveau d'alarme",
                svSE: "- Larmniv\xe5"
            }), `${fa.Config.AlarmLevel} V`),
            (0, $62f894d94fb7061c$export$c7b5d08fe382bb2a)((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
                enGB: "- Battery level",
                deDE: "- Batteriestand",
                frFR: "- Niveau de batterie",
                svSE: "- Batteriniv\xe5"
            }), `${fa.LastReport.Data.Battery}%`),
            (0, $62f894d94fb7061c$export$c7b5d08fe382bb2a)((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
                deDE: "- Signalst\xe4rke",
                enGB: "- Signal strength",
                frFR: "- Force de signal",
                svSE: "- Signalstyrka"
            }), `${fa.LastReport.Data.Rssi}%`),
            (0, $62f894d94fb7061c$export$c7b5d08fe382bb2a)((0, $093d22e30b803c56$export$625550452a3fa3ec)("deviceCard.lastActive")(), (0, $093d22e30b803c56$export$d6acfab709ab64b)(fa.LastReport.Timestamp)),
            (0, $62f894d94fb7061c$export$c7b5d08fe382bb2a)((0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.subscription),
            (0, $62f894d94fb7061c$export$c7b5d08fe382bb2a)((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
                enGB: "- Plan",
                deDE: "- Plan",
                frFR: "- Plan",
                svSE: "- Plan"
            }), await $256c2302b29b72fa$var$formatSubscriptionPlan(fa)),
            (0, $62f894d94fb7061c$export$c7b5d08fe382bb2a)(...(0, $b803aaa0dd2fc957$export$1f1e817cb63ab44a)(fa.Subscription))
        ],
        buttons: [
            (0, $00995e7d83a33b33$export$13f9d3c4397c4713).anchor({}, (0, $1abc8d719eea79cd$export$e1dd10d13c5a06).icon({
                id: "monitoring",
                onClick: ()=>(0, $b4e14b6b8da86996$export$5375cda95f0b0eb4).jump(`/fencealarm/${fa.Imei}/logs`)
            })),
            (0, $00995e7d83a33b33$export$13f9d3c4397c4713).anchor({}, (0, $1abc8d719eea79cd$export$e1dd10d13c5a06).icon({
                id: "settings",
                onClick: ()=>(0, $b4e14b6b8da86996$export$5375cda95f0b0eb4).jump(`/fencealarm/${fa.Imei}`)
            }))
        ]
    });
}
/**
 * @param {Fencealarm} fa
 */ async function $256c2302b29b72fa$var$formatSubscriptionPlan(fa) {
    if (fa.Subscription.Trialing) return (0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.trial;
    const { FencealarmMonth: FencealarmMonth, FencealarmYear: FencealarmYear } = await (0, $26a5802c7b7183d2$export$41303c5fee299aff)();
    switch(fa.Subscription.PriceIds.Current){
        case FencealarmMonth.Id:
            return (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
                deDE: "Monatlich",
                enGB: "Monthly",
                frFR: "Mensuel",
                svSE: "M\xe5nadsvis"
            });
        case FencealarmYear.Id:
            return (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
                deDE: "J\xe4hrlich",
                enGB: "Yearly",
                frFR: "Annuel",
                svSE: "\xc5rsvis"
            });
    }
    const expiryTime = new Date(fa.Subscription.ExpiresAt);
    if (Date.now() < expiryTime.getTime()) return "";
    return (0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.none;
}






/**
 * @param {string} imei
 */ async function $e02c85f02889dc78$export$8fe567c8d2ab8e83(imei) {
    const res = await (0, $5ca15832b8c5d5ea$export$1d2f21e549771e67)(`/fencealarm2s/${imei}`);
    if (!res.ok) throw await (0, $1fb5d845307c571c$export$f00cf23da648bc9b)(res);
}
/**
 * @param {string} imei
 * @returns {Promise<Fencealarm2>}
 */ async function $e02c85f02889dc78$export$c94d5c2644851db2(imei) {
    const res = await (0, $5ca15832b8c5d5ea$export$3988ae62b71be9a3)(`/fencealarm2s/${imei}`);
    if (!res.ok) throw await (0, $1fb5d845307c571c$export$f00cf23da648bc9b)(res);
    return res.json();
}
/**
 * @typedef {Object} VoltageDataPoint
 * @property {string} Imei
 * @property {number} Voltage
 * @property {string} Timestamp
 */ /**
 * @param {string} imei
 * @param {DataPointQueryParams} [args]
 * @returns {Promise<VoltageDataPoint[]|Blob>}
 */ async function $e02c85f02889dc78$export$ccbacfa6860d6eff(imei, args) {
    const params = (0, $820877bea407f5fe$export$89a7e74069fbb7af)(args);
    const res = await (0, $5ca15832b8c5d5ea$export$3988ae62b71be9a3)(`/fencealarm2s/${imei}/voltage${params}`);
    if (!res.ok) throw await (0, $1fb5d845307c571c$export$f00cf23da648bc9b)(res);
    if (!args || args.format !== "json") return res.blob();
    return res.json();
}
/**
 * @param {string} imei
 * @param {FlashFencealarm2Params} args
 */ async function $e02c85f02889dc78$export$d003b69284bad423(imei, args) {
    const res = await (0, $5ca15832b8c5d5ea$export$327f7b26ebf455db)(`/fencealarm2s/${imei}/fota`, {
        body: JSON.stringify(args)
    });
    if (!res.ok) throw await (0, $1fb5d845307c571c$export$f00cf23da648bc9b)(res);
}
/**
 * @param {string} imei
 * @param {string} email
 * @returns {Promise<Fencealarm2>}
 */ async function $e02c85f02889dc78$export$26f4c5c095f49565(imei, email) {
    const res = await (0, $5ca15832b8c5d5ea$export$327f7b26ebf455db)(`/fencealarm2s/${imei}/owner`, {
        body: JSON.stringify({
            Email: email
        })
    });
    if (!res.ok) throw await (0, $1fb5d845307c571c$export$f00cf23da648bc9b)(res);
    return res.json();
}











/**
 * @param {Fencealarm2} fa2 
 * @returns {string}
 */ function $5f489a65a30ae45b$var$checkVoltageLevel(fa2) {
    if (fa2.VoltageAlarm.Enabled && fa2.VoltageAlarm.Triggered) return (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
        enGB: "Low fence voltage",
        deDE: "Niedrige Zaunspannung",
        frFR: "Faible tension de cl\xf4ture",
        svSE: "L\xe5g sp\xe4nning i st\xe4ngslet"
    });
    return "";
}
/**
 * @param {Fencealarm2} fa2 
 * @returns {string[]}
 */ function $5f489a65a30ae45b$export$5d193aff9425031c(fa2) {
    return [
        $5f489a65a30ae45b$var$checkVoltageLevel(fa2)
    ].filter((text)=>text !== "");
}


/**
 * @param {Fencealarm2} fa2
 */ async function $414706a39b83e889$export$fcb5591deda717cd(fa2) {
    (0, $1d17319f79c68be8$export$1fb3ec0f927e5ebb)("fencealarm2", fa2.Imei, ()=>{
        (0, $e02c85f02889dc78$export$c94d5c2644851db2)(fa2.Imei).then((fa2)=>{
            (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).fencealarm2s[fa2.Imei] = fa2;
        // refresh(fa2)
        });
    });
    return (0, $b803aaa0dd2fc957$export$3d7ac60f9474f7a3)({
        deviceName: fa2.Metadata.Name,
        deviceType: "fencealarm2",
        productName: "FenceAlarm2",
        warnings: (0, $5f489a65a30ae45b$export$5d193aff9425031c)(fa2),
        lines: [
            (0, $62f894d94fb7061c$export$c7b5d08fe382bb2a)((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
                enGB: "Device status",
                deDE: "Ger\xe4testatus",
                frFR: "\xc9tat de l'appareil",
                svSE: "Enhetsstatus"
            })),
            (0, $62f894d94fb7061c$export$c7b5d08fe382bb2a)((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
                enGB: "- Voltage",
                deDE: "- Spannung",
                frFR: "- Tension",
                svSE: "- Sp\xe4nning"
            }), `${fa2.Voltage} V`),
            (0, $62f894d94fb7061c$export$c7b5d08fe382bb2a)((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
                enGB: "- Alarm level",
                deDE: "- Alarmstufe",
                frFR: "- Niveau d'alarme",
                svSE: "- Larmniv\xe5"
            }), `${fa2.PendingResponse_v0_3?.Config?.AlarmLevel && fa2.PendingResponse_v0_3.Config.AlarmLevel !== fa2.Config_v0_3.AlarmLevel ? "*" : ""} ${fa2.Config_v0_3.AlarmLevel} V`),
            (0, $62f894d94fb7061c$export$c7b5d08fe382bb2a)((0, $093d22e30b803c56$export$625550452a3fa3ec)("deviceCard.lastActive")(), (0, $093d22e30b803c56$export$d6acfab709ab64b)(fa2.LastUplinkAt)),
            (0, $62f894d94fb7061c$export$c7b5d08fe382bb2a)((0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.subscription),
            (0, $62f894d94fb7061c$export$c7b5d08fe382bb2a)((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
                enGB: "- Plan",
                deDE: "- Plan",
                frFR: "- Plan",
                svSE: "- Plan"
            }), await $414706a39b83e889$var$formatSubscriptionPlan(fa2)),
            (0, $62f894d94fb7061c$export$c7b5d08fe382bb2a)(...(0, $b803aaa0dd2fc957$export$1f1e817cb63ab44a)(fa2.Subscription))
        ],
        buttons: [
            (0, $00995e7d83a33b33$export$13f9d3c4397c4713).anchor({}, (0, $1abc8d719eea79cd$export$e1dd10d13c5a06).icon({
                id: "monitoring",
                onClick: ()=>(0, $b4e14b6b8da86996$export$5375cda95f0b0eb4).jump(`/fencealarm2/${fa2.Imei}/logs`)
            })),
            (0, $00995e7d83a33b33$export$13f9d3c4397c4713).anchor({}, (0, $1abc8d719eea79cd$export$e1dd10d13c5a06).icon({
                id: "settings",
                onClick: ()=>(0, $b4e14b6b8da86996$export$5375cda95f0b0eb4).jump(`/fencealarm2/${fa2.Imei}`)
            }))
        ]
    });
}
/**
 * @param {Fencealarm2} fa2
 */ async function $414706a39b83e889$var$formatSubscriptionPlan(fa2) {
    if (fa2.Subscription.Trialing) return (0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.trial;
    const { Fencealarm2Month: Fencealarm2Month, Fencealarm2Year: Fencealarm2Year } = await (0, $26a5802c7b7183d2$export$41303c5fee299aff)();
    switch(fa2.Subscription.PriceIds.Current){
        case Fencealarm2Month.Id:
            return (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
                deDE: "Monatlich",
                enGB: "Monthly",
                frFR: "Mensuel",
                svSE: "M\xe5nadsvis"
            });
        case Fencealarm2Year.Id:
            return (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
                deDE: "J\xe4hrlich",
                enGB: "Yearly",
                frFR: "Annuel",
                svSE: "\xc5rsvis"
            });
    }
    const expiryTime = new Date(fa2.Subscription.ExpiresAt);
    if (Date.now() < expiryTime.getTime()) return "";
    return (0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.none;
}









/**
 * @param {string} imei 
 * @returns {Promise<Smartplug>}
 */ async function $56e57e5ddb2fa934$export$8831afbcb0670a33(imei) {
    const res = await (0, $5ca15832b8c5d5ea$export$1d2f21e549771e67)(`/smartplugs/${imei}/subscription`);
    if (!res.ok) throw await (0, $1fb5d845307c571c$export$f00cf23da648bc9b)(res);
    return res.json();
}
/**
 * @param {string} imei
 * @returns {Promise<Smartplug>}
 */ async function $56e57e5ddb2fa934$export$42d19af3276e7596(imei) {
    const res = await (0, $5ca15832b8c5d5ea$export$3988ae62b71be9a3)(`/smartplugs/${imei}`);
    if (res.status === 408) throw new Error('TIMEOUT');
    if (!res.ok) throw await (0, $1fb5d845307c571c$export$f00cf23da648bc9b)(res);
    const plug = await res.json();
    return plug;
}
/**
 * @typedef {Object} ConsumptionDataPoint
 * @property {number} Consumption
 * @property {string} Imei
 * @property {string} Timestamp
 */ /**
 * @param {string} imei
 * @param {DataPointQueryParams} [args]
 * @returns {Promise<ConsumptionDataPoint[]|Blob>}
 */ async function $56e57e5ddb2fa934$export$3cd0c4873726c28(imei, args) {
    const params = (0, $820877bea407f5fe$export$89a7e74069fbb7af)(args);
    const res = await (0, $5ca15832b8c5d5ea$export$3988ae62b71be9a3)(`/smartplugs/${imei}/consumption${params}`);
    if (!res.ok) throw await (0, $1fb5d845307c571c$export$f00cf23da648bc9b)(res);
    if (!args || args.format !== "json") return res.blob();
    return res.json();
}
/**
 * @typedef {Object} LoadDataPoint
 * @property {string} Imei
 * @property {number} Load
 * @property {string} Timestamp
 */ /**
 * @param {string} imei
 * @param {DataPointQueryParams} [args]
 * @returns {Promise<LoadDataPoint[]|Blob>}
 */ async function $56e57e5ddb2fa934$export$2ef7c30a294cc491(imei, args) {
    const params = (0, $820877bea407f5fe$export$89a7e74069fbb7af)(args);
    const res = await (0, $5ca15832b8c5d5ea$export$3988ae62b71be9a3)(`/smartplugs/${imei}/load${params}`);
    if (!res.ok) throw await (0, $1fb5d845307c571c$export$f00cf23da648bc9b)(res);
    if (!args || args.format !== "json") return res.blob();
    return res.json();
}
/**
 * @typedef {Object} TemperatureDataPoint
 * @property {string} Imei
 * @property {number} Temperature
 * @property {string} Timestamp
 */ /**
 * @param {string} imei
 * @param {DataPointQueryParams} [args]
 * @returns {Promise<TemperatureDataPoint[]|Blob>}
 */ async function $56e57e5ddb2fa934$export$ec780333b296bb7(imei, args) {
    const params = (0, $820877bea407f5fe$export$89a7e74069fbb7af)(args);
    const res = await (0, $5ca15832b8c5d5ea$export$3988ae62b71be9a3)(`/smartplugs/${imei}/temperature${params}`);
    if (!res.ok) throw await (0, $1fb5d845307c571c$export$f00cf23da648bc9b)(res);
    if (!args || args.format !== "json") return res.blob();
    return res.json();
}
/**
 * @param {string} imei
 * @param {PutSmartplugParams} args
 * @returns {Promise<Smartplug>}
 */ async function $56e57e5ddb2fa934$export$2e14eb8cf6f2e1c1(imei, args) {
    const res = await (0, $5ca15832b8c5d5ea$export$327f7b26ebf455db)(`/smartplugs/${imei}`, {
        body: JSON.stringify(args)
    });
    if (!res.ok) throw await (0, $1fb5d845307c571c$export$f00cf23da648bc9b)(res);
    const plug = await res.json();
    return plug;
}
/**
 * @param {string} imei 
 * @param {string} email 
 * @returns {Promise<Smartplug>}
 */ async function $56e57e5ddb2fa934$export$3ccdbc17c5fde6d(imei, email) {
    const res = await (0, $5ca15832b8c5d5ea$export$327f7b26ebf455db)(`/smartplugs/${imei}/owner`, {
        body: JSON.stringify({
            Email: email
        })
    });
    if (!res.ok) throw await (0, $1fb5d845307c571c$export$f00cf23da648bc9b)(res);
    return res.json();
}
/**
 * @param {string} imei
 * @param {boolean} enabled
 * @returns {Promise<Smartplug>}
 */ async function $56e57e5ddb2fa934$export$53346f74ec6fbae6(imei, enabled) {
    const res = await (0, $5ca15832b8c5d5ea$export$327f7b26ebf455db)(`/smartplugs/${imei}/power-enabled`, {
        body: JSON.stringify({
            Enabled: enabled
        }),
        timeout: 60000
    });
    if (!res.ok) throw await (0, $1fb5d845307c571c$export$f00cf23da648bc9b)(res);
    return res.json();
}
/**
 * @param {string} imei
 * @param {number} days 
 * @returns {Promise<Smartplug>}
 */ async function $56e57e5ddb2fa934$export$7896dfa83239de84(imei, days) {
    const res = await (0, $5ca15832b8c5d5ea$export$327f7b26ebf455db)(`/smartplugs/${imei}/trial`, {
        body: JSON.stringify({
            Days: days
        })
    });
    if (!res.ok) throw await (0, $1fb5d845307c571c$export$f00cf23da648bc9b)(res);
    return res.json();
}
/**
 * @param {string} imei
 * @returns {Promise<Smartplug>}
 */ async function $56e57e5ddb2fa934$export$ced0acecfaf2dace(imei) {
    const res = await (0, $5ca15832b8c5d5ea$export$327f7b26ebf455db)(`/smartplugs/${imei}/consumption/reset`);
    if (!res.ok) throw await (0, $1fb5d845307c571c$export$f00cf23da648bc9b)(res);
    return res.json();
}
/**
 * @param {string} imei
 */ async function $56e57e5ddb2fa934$export$54f51a31d8fbc449(imei) {
    const res = await (0, $5ca15832b8c5d5ea$export$1d2f21e549771e67)(`/smartplugs/${imei}`);
    if (!res.ok) throw await (0, $1fb5d845307c571c$export$f00cf23da648bc9b)(res);
}










/**
 * @param {Smartplug} sp 
 * @returns {string}
 */ function $6945f85a0776aca5$var$checkLoadAlarm(sp) {
    if (sp.LoadAlarm.Enabled && sp.LoadAlarm.Triggered) return (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
        enGB: "Load alarm triggered",
        deDE: "Last au\xdferhalb des erwarteten Intervalls",
        frFR: "Charge en dehors de l'intervalle pr\xe9vu",
        svSE: "Belastning utanf\xf6r f\xf6rv\xe4ntat intervall"
    });
    return "";
}
/**
 * @param {Smartplug} sp 
 * @returns {string}
 */ function $6945f85a0776aca5$var$checkOfflineAlarm(sp) {
    if (sp.OfflineAlarm && sp.OfflineAlarm.Enabled && sp.OfflineAlarm.Triggered) return (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
        enGB: "Device offline",
        deDE: "Ger\xe4t offline",
        frFR: "Appareil hors ligne",
        svSE: "Enhet offline"
    });
    return "";
}
/**
 * @param {Smartplug} sp 
 * @returns {string}
 */ function $6945f85a0776aca5$var$checkPowerFailureAlarm(sp) {
    if (sp.PowerFailureAlarm.Enabled && sp.PowerFailureAlarm.Triggered) return (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
        enGB: "Power failure",
        deDE: "Stromausfall",
        frFR: "Panne de courant",
        svSE: "Str\xf6mavbrott"
    });
    return "";
}
/**
 * @param {Smartplug} sp 
 * @returns {string}
 */ function $6945f85a0776aca5$var$checkTemperatureAlarm(sp) {
    if (sp.TemperatureRangeAlarm.Enabled && sp.TemperatureRangeAlarm.Triggered) return (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
        enGB: "Temperature outside expected interval",
        deDE: "Temperatur au\xdferhalb des erwarteten Intervalls",
        frFR: "Temp\xe9rature en dehors de l'intervalle pr\xe9vu",
        svSE: "Temperatur utanf\xf6r f\xf6rv\xe4ntat intervall"
    });
    return "";
}
/**
 * @param {Smartplug} sp 
 * @returns {string[]}
 */ function $6945f85a0776aca5$export$955cfcb5c0a871cc(sp) {
    return [
        $6945f85a0776aca5$var$checkLoadAlarm(sp),
        $6945f85a0776aca5$var$checkOfflineAlarm(sp),
        $6945f85a0776aca5$var$checkPowerFailureAlarm(sp),
        $6945f85a0776aca5$var$checkTemperatureAlarm(sp)
    ].filter((text)=>text !== "");
}


/**
 * @param {Smartplug} sp
 */ async function $6148a4e15577046b$var$formatSubscriptionPlan(sp) {
    if (sp.Subscription.Trialing) return (0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.trial;
    const { SmartplugMonth: SmartplugMonth, SmartplugYear: SmartplugYear } = await (0, $26a5802c7b7183d2$export$41303c5fee299aff)();
    switch(sp.Subscription.PriceIds.Current){
        case SmartplugMonth.Id:
            return (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
                deDE: "Monatlich",
                enGB: "Monthly",
                frFR: "Mensuel",
                svSE: "M\xe5nadsvis"
            });
        case SmartplugYear.Id:
            return (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
                deDE: "J\xe4hrlich",
                enGB: "Yearly",
                frFR: "Annuel",
                svSE: "\xc5rsvis"
            });
    }
    const expiryTime = new Date(sp.Subscription.ExpiresAt);
    if (Date.now() < expiryTime.getTime()) return "";
    return (0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.none;
}
/**
 * @param {Smartplug} sp
 */ async function $6148a4e15577046b$export$66ea754a992d2d5f(sp) {
    (0, $1d17319f79c68be8$export$1fb3ec0f927e5ebb)("smartplug", sp.Imei, ()=>{
        (0, $56e57e5ddb2fa934$export$42d19af3276e7596)(sp.Imei).then((sp)=>{
            (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).smartplugs[sp.Imei] = sp;
        });
    });
    const togglePower = ()=>{
        (0, $b4e14b6b8da86996$export$850e0ce216eef646)();
        (0, $56e57e5ddb2fa934$export$53346f74ec6fbae6)(sp.Imei, !(0, $bfc59006cf644cf7$export$ca000e230c0caa3e).smartplugs[sp.Imei].PowerEnabled).then((sp)=>{
            if (sp.PowerEnabled) powerOffIcon.replaceWith(powerOnIcon);
            else powerOnIcon.replaceWith(powerOffIcon);
            (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).smartplugs[sp.Imei] = sp;
            (0, $62f894d94fb7061c$export$73e19c0339806233)();
        }).catch((0, $62f894d94fb7061c$export$6badb0ecde4e0bd0)).finally((0, $b4e14b6b8da86996$export$d91ec774a0e3eb9e));
    };
    const powerOnIcon = (0, $1abc8d719eea79cd$export$e1dd10d13c5a06).icon({
        id: "flash_on",
        onClick: togglePower
    });
    const powerOffIcon = (0, $1abc8d719eea79cd$export$e1dd10d13c5a06).icon({
        id: "flash_off",
        onClick: togglePower
    });
    return (0, $b803aaa0dd2fc957$export$3d7ac60f9474f7a3)({
        deviceName: sp.Metadata.Name,
        deviceType: "smartplug",
        productName: "SmartPlug",
        warnings: (0, $6945f85a0776aca5$export$955cfcb5c0a871cc)(sp),
        lines: [
            (0, $62f894d94fb7061c$export$c7b5d08fe382bb2a)((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
                enGB: "Device status",
                deDE: "Ger\xe4testatus",
                frFR: "\xc9tat de l'appareil",
                svSE: "Enhetsstatus"
            })),
            (0, $62f894d94fb7061c$export$c7b5d08fe382bb2a)((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
                deDE: "- Strom",
                enGB: "- Power",
                frFR: "- Alimentation",
                svSE: "- Str\xf6m"
            }), sp.PowerEnabled ? (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
                deDE: "Ein",
                enGB: "On",
                frFR: "Activ\xe9",
                svSE: "P\xe5"
            }) : (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
                deDE: "Aus",
                enGB: "Off",
                frFR: "D\xe9sactiv\xe9",
                svSE: "Av"
            })),
            (0, $62f894d94fb7061c$export$c7b5d08fe382bb2a)((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
                deDE: "- Belastung",
                enGB: "- Load",
                frFR: "- Charge",
                svSE: "- Last"
            }), `${sp.Load} W`),
            (0, $62f894d94fb7061c$export$c7b5d08fe382bb2a)((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
                deDE: "- Verbrauch",
                enGB: "- Consumption",
                frFR: "- Consommation",
                svSE: "- F\xf6rbrukning"
            }), `${sp.Consumption} Wh`),
            (0, $62f894d94fb7061c$export$c7b5d08fe382bb2a)((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
                deDE: "- Temperatur",
                enGB: "- Temperature",
                frFR: "- Temp\xe9rature",
                svSE: "- Temperatur"
            }), sp.Temperature >= -20 ? `${sp.Temperature} \xb0C` : "-"),
            (0, $62f894d94fb7061c$export$c7b5d08fe382bb2a)((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
                deDE: "- Signalst\xe4rke",
                enGB: "- Signal strength",
                frFR: "- Force de signal",
                svSE: "- Signalstyrka"
            }), `${sp.SignalStrength}%`),
            (0, $62f894d94fb7061c$export$c7b5d08fe382bb2a)((0, $093d22e30b803c56$export$625550452a3fa3ec)("deviceCard.lastActive")(), (0, $093d22e30b803c56$export$d6acfab709ab64b)(sp.LastUplinkAt)),
            (0, $62f894d94fb7061c$export$c7b5d08fe382bb2a)((0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.subscription),
            (0, $62f894d94fb7061c$export$c7b5d08fe382bb2a)((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
                enGB: "- Plan",
                deDE: "- Plan",
                frFR: "- Plan",
                svSE: "- Plan"
            }), await $6148a4e15577046b$var$formatSubscriptionPlan(sp)),
            (0, $62f894d94fb7061c$export$c7b5d08fe382bb2a)(...(0, $b803aaa0dd2fc957$export$1f1e817cb63ab44a)(sp.Subscription))
        ],
        buttons: [
            (0, $00995e7d83a33b33$export$13f9d3c4397c4713).anchor({}, sp.PowerEnabled ? powerOnIcon : powerOffIcon),
            (0, $00995e7d83a33b33$export$13f9d3c4397c4713).anchor({}, (0, $1abc8d719eea79cd$export$e1dd10d13c5a06).icon({
                id: "monitoring",
                onClick: ()=>(0, $b4e14b6b8da86996$export$5375cda95f0b0eb4).jump(`/smartplug/${sp.Imei}/logs`)
            })),
            (0, $00995e7d83a33b33$export$13f9d3c4397c4713).anchor({}, (0, $1abc8d719eea79cd$export$e1dd10d13c5a06).icon({
                id: "settings",
                onClick: ()=>(0, $b4e14b6b8da86996$export$5375cda95f0b0eb4).jump(`/smartplug/${sp.Imei}`)
            }))
        ]
    });
}






async function $a2c9d757b6a615a4$export$cad27d2f07fc02d4(imei) {
    const res = await (0, $5ca15832b8c5d5ea$export$1d2f21e549771e67)(`/smartplug2s/${imei}/consumption`);
    if (!res.ok) throw await (0, $1fb5d845307c571c$export$f00cf23da648bc9b)(res);
    const sp2 = await res.json();
    return sp2;
}
async function $a2c9d757b6a615a4$export$9939c525af0c5106(imei) {
    const res = await (0, $5ca15832b8c5d5ea$export$3988ae62b71be9a3)(`/smartplug2s/${imei}`);
    if (!res.ok) throw await (0, $1fb5d845307c571c$export$f00cf23da648bc9b)(res);
    const sp2 = await res.json();
    return sp2;
}
async function $a2c9d757b6a615a4$export$5a951ad2fc2aa5f7(sp2) {
    const res = await (0, $5ca15832b8c5d5ea$export$327f7b26ebf455db)(`/smartplug2s/${sp2.Imei}`, {
        body: JSON.stringify(sp2)
    });
    if (!res.ok) throw await (0, $1fb5d845307c571c$export$f00cf23da648bc9b)(res);
    sp2 = await res.json();
    return sp2;
}










function $702917b410fadc6b$var$checkConnection(sp2) {
    if (sp2.ConnectionLost) return (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
        enGB: "Device offline",
        deDE: "Ger\xe4t offline",
        frFR: "Appareil hors ligne",
        svSE: "Enhet offline"
    });
    return "";
}
function $702917b410fadc6b$var$checkConsumption(sp2) {
    if (sp2.ConsumptionNotification.Enabled && sp2.ConsumptionNotification.Triggered) return (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
        enGB: "Consumption exceeded threshold",
        deDE: "Last au\xdferhalb des erwarteten Intervalls",
        frFR: "Charge en dehors de l'intervalle pr\xe9vu",
        svSE: "Belastning utanf\xf6r f\xf6rv\xe4ntat intervall"
    });
    return "";
}
function $702917b410fadc6b$var$checkLoad(sp2) {
    if (!sp2.TargetConfig.LoadAlarm.Enabled) return "";
    if (sp2.Load < sp2.TargetConfig.LoadAlarm.Lower) return (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
        enGB: "Load under the expected load",
        deDE: "Last unter dem erwarteten Wert",
        frFR: "Charge inf\xe9rieure \xe0 la charge pr\xe9vue",
        svSE: "Belastning under f\xf6rv\xe4ntad belastning"
    });
    if (sp2.Load > sp2.TargetConfig.LoadAlarm.Upper) return (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
        enGB: "Load over the expected load",
        deDE: "Last \xfcber dem erwarteten Wert",
        frFR: "Charge sup\xe9rieure \xe0 la charge pr\xe9vue",
        svSE: "Belastning \xf6ver f\xf6rv\xe4ntad belastning"
    });
    return "";
}
function $702917b410fadc6b$var$checkPower(sp2) {
    if (sp2.PowerFailureNotification.Enabled && sp2.PowerFailureNotification.Triggered) return (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
        enGB: "Power failure",
        deDE: "Stromausfall",
        frFR: "Panne de courant",
        svSE: "Str\xf6mavbrott"
    });
    return "";
}
function $702917b410fadc6b$export$c48a5066724ad749(sp2) {
    return [
        $702917b410fadc6b$var$checkConnection(sp2),
        $702917b410fadc6b$var$checkConsumption(sp2),
        $702917b410fadc6b$var$checkPower(sp2),
        $702917b410fadc6b$var$checkLoad(sp2)
    ].filter((text)=>text !== "");
}


/**
 * @param {import("./sp2").Smartplug2} sp2
 */ async function $adcbcd8fc56f21d2$var$formatSubscriptionPlan(sp2) {
    if (sp2.Subscription.Trialing) return (0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.trial;
    const { Smartplug2Month: Smartplug2Month, Smartplug2Year: Smartplug2Year } = await (0, $26a5802c7b7183d2$export$41303c5fee299aff)();
    switch(sp2.Subscription.PriceIds.Current){
        case Smartplug2Month.Id:
            return (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
                enGB: "Monthly",
                deDE: "Monatlich",
                frFR: "Mensuel",
                svSE: "M\xe5nadsvis"
            });
        case Smartplug2Year.Id:
            return (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
                enGB: "Yearly",
                deDE: "J\xe4hrlich",
                frFR: "Annuel",
                svSE: "\xc5rsvis"
            });
    }
    const expiryTime = new Date(sp2.Subscription.ExpiresAt);
    if (Date.now() < expiryTime.getTime()) return "";
    return (0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.none;
}
/**
 * @param {import("./sp2").Smartplug2} sp2
 */ async function $adcbcd8fc56f21d2$export$6219d39a1c2993ee(sp2) {
    (0, $1d17319f79c68be8$export$1fb3ec0f927e5ebb)("smartplug2", sp2.Imei, ()=>{
        (0, $a2c9d757b6a615a4$export$9939c525af0c5106)(sp2.Imei).then((sp2)=>{
            (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).smartplug2s[sp2.Imei] = sp2;
        });
    });
    const powerOnIcon = (0, $1abc8d719eea79cd$export$e1dd10d13c5a06).icon({
        id: "flash_on",
        onClick: onClickTogglePower
    });
    const powerOffIcon = (0, $1abc8d719eea79cd$export$e1dd10d13c5a06).icon({
        id: "flash_off",
        onClick: onClickTogglePower
    });
    const card = (0, $b803aaa0dd2fc957$export$3d7ac60f9474f7a3)({
        deviceName: sp2.Metadata.Name,
        deviceType: "smartplug2",
        productName: "SmartPlug2",
        warnings: (0, $702917b410fadc6b$export$c48a5066724ad749)(sp2),
        lines: [
            (0, $62f894d94fb7061c$export$c7b5d08fe382bb2a)((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
                enGB: "Device status",
                deDE: "Ger\xe4testatus",
                frFR: "\xc9tat de l'appareil",
                svSE: "Enhetsstatus"
            })),
            (0, $62f894d94fb7061c$export$c7b5d08fe382bb2a)((0, $093d22e30b803c56$export$625550452a3fa3ec)("sp2Card.power")(), sp2.DeviceConfig.OutputPower && sp2.TargetConfig.OutputPower ? (0, $093d22e30b803c56$export$625550452a3fa3ec)("sp2Card.on")() : !sp2.DeviceConfig.OutputPower && !sp2.TargetConfig.OutputPower ? (0, $093d22e30b803c56$export$625550452a3fa3ec)("sp2Card.off")() : "?"),
            (0, $62f894d94fb7061c$export$c7b5d08fe382bb2a)((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
                deDE: "- Belastung",
                enGB: "- Load",
                frFR: "- Charge",
                svSE: "- Last"
            }), `${sp2.Load} W`),
            (0, $62f894d94fb7061c$export$c7b5d08fe382bb2a)((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
                deDE: "- Verbrauch",
                enGB: "- Consumption",
                frFR: "- Consommation",
                svSE: "- F\xf6rbrukning"
            }), `${sp2.Consumption} Wh`),
            (0, $62f894d94fb7061c$export$c7b5d08fe382bb2a)((0, $093d22e30b803c56$export$625550452a3fa3ec)("deviceCard.connection")(), sp2.SignalStrength < 70 ? (0, $093d22e30b803c56$export$625550452a3fa3ec)("deviceCard.connectionMajorDisruptions")() : sp2.SignalStrength < 80 ? (0, $093d22e30b803c56$export$625550452a3fa3ec)("deviceCard.connectionMinorDisruptions")() : (0, $093d22e30b803c56$export$625550452a3fa3ec)("deviceCard.connectionReliable")()),
            (0, $62f894d94fb7061c$export$c7b5d08fe382bb2a)((0, $093d22e30b803c56$export$625550452a3fa3ec)("deviceCard.lastActive")(), (0, $093d22e30b803c56$export$d6acfab709ab64b)(sp2.LastUploadAt)),
            (0, $62f894d94fb7061c$export$c7b5d08fe382bb2a)((0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.subscription),
            (0, $62f894d94fb7061c$export$c7b5d08fe382bb2a)((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
                enGB: "- Plan",
                deDE: "- Plan",
                frFR: "- Plan",
                svSE: "- Plan"
            }), await $adcbcd8fc56f21d2$var$formatSubscriptionPlan(sp2)),
            (0, $62f894d94fb7061c$export$c7b5d08fe382bb2a)(...(0, $b803aaa0dd2fc957$export$1f1e817cb63ab44a)(sp2.Subscription))
        ],
        buttons: [
            (0, $00995e7d83a33b33$export$13f9d3c4397c4713).anchor({}, sp2.TargetConfig.OutputPower ? powerOnIcon : powerOffIcon),
            (0, $00995e7d83a33b33$export$13f9d3c4397c4713).anchor({}, (0, $1abc8d719eea79cd$export$e1dd10d13c5a06).icon({
                id: "monitoring",
                onClick: ()=>(0, $b4e14b6b8da86996$export$5375cda95f0b0eb4).jump(`/smartplug2/${sp2.Imei}/logs`)
            })),
            (0, $00995e7d83a33b33$export$13f9d3c4397c4713).anchor({}, (0, $1abc8d719eea79cd$export$e1dd10d13c5a06).icon({
                id: "settings",
                onClick: ()=>(0, $b4e14b6b8da86996$export$5375cda95f0b0eb4).jump(`/smartplug2/${sp2.Imei}`)
            }))
        ]
    });
    function onClickTogglePower() {
        (0, $b4e14b6b8da86996$export$850e0ce216eef646)();
        sp2.TargetConfig.OutputPower = !sp2.TargetConfig.OutputPower;
        (0, $a2c9d757b6a615a4$export$5a951ad2fc2aa5f7)(sp2).then((sp2)=>{
            if (sp2.TargetConfig.OutputPower) powerOffIcon.replaceWith(powerOnIcon);
            else powerOnIcon.replaceWith(powerOffIcon);
            (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).smartplug2s[sp2.Imei] = sp2;
            (0, $62f894d94fb7061c$export$73e19c0339806233)();
        }).catch((0, $62f894d94fb7061c$export$6badb0ecde4e0bd0)).finally((0, $b4e14b6b8da86996$export$d91ec774a0e3eb9e));
    }
    return card;
}






async function $148bc2e0664352dc$var$getDeviceColumns(devices, selectedTags, toCard, registerColumn) {
    return Promise.all(Object.entries(devices).filter(([_id, device])=>{
        if (selectedTags.length < 1) return true;
        if (!device.Metadata.Tags) return false;
        return device.Metadata.Tags.some((tag)=>selectedTags.includes(tag));
    }).sort(([_id1, device1], [_id2, device2])=>device1.Metadata.Name.localeCompare(device2.Metadata.Name)).map(async ([id, device])=>{
        const card = await toCard(device);
        const col = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).column({
            classList: [
                "is-full-mobile",
                "is-narrow-tablet",
                "is-narrow-desktop",
                "is-narrow-widescreen",
                "is-narrow-fullhd"
            ]
        }, card);
        registerColumn(id, col);
        return col;
    }));
}
async function $148bc2e0664352dc$export$d5ac705d10f5fe4f(match) {
    if (0, $1d17319f79c68be8$export$d70a5ce4bc79c42d) {
        (0, $1d17319f79c68be8$export$273fb6590fc80197).setValue("appFinishedLoading", true);
        if (!(0, $1d17319f79c68be8$export$273fb6590fc80197).getValue("registeredNotificationsToken")) setTimeout((0, $1d17319f79c68be8$export$bc8117be864076f2), 1000);
    }
    const selectedTags = [];
    const tagControls = (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).getDeviceTags().map((tag)=>{
        const selectedTag = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).tagWithAddon({
            content: tag,
            color: "is-primary"
        }, {
            content: (0, $1abc8d719eea79cd$export$e1dd10d13c5a06).icon({
                id: "remove"
            }),
            onClick: ()=>{
                (0, $820877bea407f5fe$export$225ffb4bcef29a56)(selectedTags, tag);
                refresh();
                selectedTag.replaceWith(deselectedTag);
            }
        });
        const deselectedTag = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).tagWithAddon({
            content: tag
        }, {
            content: (0, $1abc8d719eea79cd$export$e1dd10d13c5a06).icon({
                id: "add"
            }),
            onClick: ()=>{
                (0, $820877bea407f5fe$export$69b94c46bed08c28)(selectedTags, tag);
                refresh();
                deselectedTag.replaceWith(selectedTag);
            }
        });
        return (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({}, deselectedTag);
    });
    const deviceColumns = {};
    const scrollToDevice = (id)=>deviceColumns[id].scrollIntoView(false);
    const farmcamSimColumns = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).columns({
        isMobile: true,
        isMultiline: true
    });
    const fencealarmColumns = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).columns({
        isMobile: true,
        isMultiline: true
    });
    const fencealarm2Columns = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).columns({
        isMobile: true,
        isMultiline: true
    });
    const smartplugColumns = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).columns({
        isMobile: true,
        isMultiline: true
    });
    const smartplug2Columns = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).columns({
        isMobile: true,
        isMultiline: true
    });
    const refresh = async ()=>{
        farmcamSimColumns.replaceChildren(...await $148bc2e0664352dc$var$getDeviceColumns((0, $bfc59006cf644cf7$export$ca000e230c0caa3e).farmcamSims, selectedTags, (0, $09e8f7aaccc0857e$export$f4c20afbd1fb63c3), (id, col)=>deviceColumns[id] = col));
        fencealarmColumns.replaceChildren(...await $148bc2e0664352dc$var$getDeviceColumns((0, $bfc59006cf644cf7$export$ca000e230c0caa3e).fencealarms, selectedTags, (0, $256c2302b29b72fa$export$1879beac42e49fe2), (id, col)=>deviceColumns[id] = col));
        fencealarm2Columns.replaceChildren(...await $148bc2e0664352dc$var$getDeviceColumns((0, $bfc59006cf644cf7$export$ca000e230c0caa3e).fencealarm2s, selectedTags, (0, $414706a39b83e889$export$fcb5591deda717cd), (id, col)=>deviceColumns[id] = col));
        smartplugColumns.replaceChildren(...await $148bc2e0664352dc$var$getDeviceColumns((0, $bfc59006cf644cf7$export$ca000e230c0caa3e).smartplugs, selectedTags, (0, $6148a4e15577046b$export$66ea754a992d2d5f), (id, col)=>deviceColumns[id] = col));
        smartplug2Columns.replaceChildren(...await $148bc2e0664352dc$var$getDeviceColumns((0, $bfc59006cf644cf7$export$ca000e230c0caa3e).smartplug2s, selectedTags, (0, $adcbcd8fc56f21d2$export$6219d39a1c2993ee), (id, col)=>deviceColumns[id] = col));
    };
    (0, $1d17319f79c68be8$export$ed76dd34f19449)("devices", ()=>{
        (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).stopLoadDevicesInterval();
    });
    (0, $1d17319f79c68be8$export$f1c910826b30c777)("devices", ()=>{
        (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).startLoadDevicesInterval(refresh);
    });
    await refresh();
    (0, $b4e14b6b8da86996$export$8390d50e515c191d)((0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).container((0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).level((0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).levelLeft((0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).levelItem((0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).title((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
        enGB: "Devices",
        deDE: "Ger\xe4te",
        frFR: "Appareils",
        svSE: "Enheter"
    })))), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).levelRight((0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).levelItem((0, $1abc8d719eea79cd$export$e1dd10d13c5a06).icon({
        id: "add_circle",
        onClick: ()=>(0, $b4e14b6b8da86996$export$5375cda95f0b0eb4).jump("/devices/register"),
        size: 2
    })))), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).field({
        styles: [
            "is-grouped",
            "is-grouped-multiline"
        ]
    }, ...tagControls), farmcamSimColumns, fencealarmColumns, fencealarm2Columns, smartplugColumns, smartplug2Columns));
    if (match?.params?.id) scrollToDevice(match.params.id);
    (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).startLoadDevicesInterval(refresh);
}
function $148bc2e0664352dc$export$131337a3dd506b19(done, _match) {
    (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).stopLoadDevicesInterval();
    (0, $1d17319f79c68be8$export$6ca1fdbef0f27d1a)("devices");
    (0, $1d17319f79c68be8$export$441507473916da2)("devices");
    done();
}







const { button: $3718c958b5f34043$var$button, div: $3718c958b5f34043$var$div, figure: $3718c958b5f34043$var$figure, h1: $3718c958b5f34043$var$h1, h2: $3718c958b5f34043$var$h2, img: $3718c958b5f34043$var$img } = (0, $259ccf8ca7c2ca99$export$2e2bcd8739ae039).tags;
/**
 * @param {DeviceType} deviceType}
 */ function $3718c958b5f34043$var$registerDeviceCard(deviceType) {
    return $3718c958b5f34043$var$div({
        class: `card ${deviceType}`
    }, $3718c958b5f34043$var$div({
        class: "card-header is-clickable p-2",
        onclick: ()=>(0, $b4e14b6b8da86996$export$5375cda95f0b0eb4).jump(`/devices/register/${deviceType}`)
    }, $3718c958b5f34043$var$div({
        class: "level is-mobile"
    }, $3718c958b5f34043$var$div({
        class: "level-item"
    }, $3718c958b5f34043$var$figure({
        class: "image is-64x64"
    }, $3718c958b5f34043$var$img({
        src: (0, $46d03d54faf4cdf4$export$555f04397502546)[`${deviceType}.png`]
    }))), $3718c958b5f34043$var$div({
        class: "level-item"
    }, $3718c958b5f34043$var$div($3718c958b5f34043$var$h1({
        class: "title is-4"
    }, $3718c958b5f34043$var$productName[deviceType]), $3718c958b5f34043$var$h2({
        class: "subtitle is-6"
    }, $3718c958b5f34043$var$productDetails[deviceType]))))));
}
function $3718c958b5f34043$export$5f16fb988359c87d() {
    const root = (0, $e47741cb5fbbb614$export$4b0227fa4b29008b)({
        size: "narrow"
    }, $3718c958b5f34043$var$h1({
        class: "title is-5"
    }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
        enGB: "Select the product you wish to add",
        deDE: "W\xe4hlen Sie das Produkt, das Sie hinzuf\xfcgen m\xf6chten",
        frFR: "S\xe9lectionnez le produit que vous souhaitez ajouter",
        svSE: "V\xe4lj den produkt du vill l\xe4gga till"
    })), ...(0, $46d03d54faf4cdf4$export$e506a1d27d1eaa20).supportedDevices.map((id)=>$3718c958b5f34043$var$registerDeviceCard(id)), $3718c958b5f34043$var$button({
        class: "button is-primary",
        onclick: ()=>(0, $b4e14b6b8da86996$export$5375cda95f0b0eb4).jump("/devices")
    }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.back));
    (0, $b4e14b6b8da86996$export$8390d50e515c191d)(root);
}
/**
 * @type {Object<DeviceType,string>}
 */ const $3718c958b5f34043$var$productDetails = {
    "farmcam-sim": "Flex 4G, Mobility, Mobility S"
};
/**
 * @type {Record<DeviceType,string>}
 */ const $3718c958b5f34043$var$productName = {
    "farmcam-sim": "FarmCam SIM",
    fencealarm: "FenceAlarm",
    fencealarm2: "FenceAlarm2",
    smartplug: "SmartPlug",
    smartplug2: "SmartPlug2"
};




// This file consistently uses `let` keyword instead of `const` for reducing the bundle size.
// Global variables - aliasing some builtin symbols to reduce the bundle size.
let { fromEntries: $75d47fd8903c7af6$var$fromEntries, entries: $75d47fd8903c7af6$var$entries, keys: $75d47fd8903c7af6$var$keys, hasOwn: $75d47fd8903c7af6$var$hasOwn, getPrototypeOf: $75d47fd8903c7af6$var$getPrototypeOf, create: $75d47fd8903c7af6$var$create, assign: $75d47fd8903c7af6$var$assign } = Object;
let { get: $75d47fd8903c7af6$var$refGet, set: $75d47fd8903c7af6$var$refSet, deleteProperty: $75d47fd8903c7af6$var$refDelete, ownKeys: $75d47fd8903c7af6$var$refOwnKeys } = Reflect;
let { state: $75d47fd8903c7af6$var$state, derive: $75d47fd8903c7af6$var$derive, add: $75d47fd8903c7af6$var$add } = (0, $259ccf8ca7c2ca99$export$2e2bcd8739ae039);
let $75d47fd8903c7af6$var$statesToGc, $75d47fd8903c7af6$var$gcCycleInMs = 1000, $75d47fd8903c7af6$var$_undefined, $75d47fd8903c7af6$var$replacing;
let $75d47fd8903c7af6$var$statesSym = Symbol(), $75d47fd8903c7af6$var$isCalcFunc = Symbol(), $75d47fd8903c7af6$var$bindingsSym = Symbol(), $75d47fd8903c7af6$var$keysGenSym = Symbol(), $75d47fd8903c7af6$var$keyToChildSym = Symbol(), $75d47fd8903c7af6$var$noreactiveSym = Symbol();
let $75d47fd8903c7af6$export$42bfa9b2d4dad91a = (f)=>(f[$75d47fd8903c7af6$var$isCalcFunc] = 1, f);
let $75d47fd8903c7af6$var$isObject = (x)=>x instanceof Object && !(x instanceof Function) && !x[$75d47fd8903c7af6$var$noreactiveSym];
let $75d47fd8903c7af6$var$toState = (v)=>{
    if (v?.[$75d47fd8903c7af6$var$isCalcFunc]) {
        let s = $75d47fd8903c7af6$var$state();
        $75d47fd8903c7af6$var$derive(()=>{
            let newV = v();
            $75d47fd8903c7af6$var$isObject(s.rawVal) && $75d47fd8903c7af6$var$isObject(newV) ? $75d47fd8903c7af6$export$77ad94ebf1c2b9ed(s.rawVal, newV) : s.val = $75d47fd8903c7af6$export$90a44edba14e47be(newV);
        });
        return s;
    } else return $75d47fd8903c7af6$var$state($75d47fd8903c7af6$export$90a44edba14e47be(v));
};
let $75d47fd8903c7af6$var$buildStates = (srcObj)=>{
    let states = Array.isArray(srcObj) ? [] : {
        __proto__: $75d47fd8903c7af6$var$getPrototypeOf(srcObj)
    };
    for (let [k, v] of $75d47fd8903c7af6$var$entries(srcObj))states[k] = $75d47fd8903c7af6$var$toState(v);
    states[$75d47fd8903c7af6$var$bindingsSym] = [];
    states[$75d47fd8903c7af6$var$keysGenSym] = $75d47fd8903c7af6$var$state(1);
    return states;
};
let $75d47fd8903c7af6$var$reactiveHandler = {
    get: (states, name, proxy)=>name === $75d47fd8903c7af6$var$statesSym ? states : $75d47fd8903c7af6$var$hasOwn(states, name) ? Array.isArray(states) && name === "length" ? (states[$75d47fd8903c7af6$var$keysGenSym].val, states.length) : states[name].val : $75d47fd8903c7af6$var$refGet(states, name, proxy),
    set: (states, name, v, proxy)=>$75d47fd8903c7af6$var$hasOwn(states, name) ? Array.isArray(states) && name === "length" ? (v !== states.length && ++states[$75d47fd8903c7af6$var$keysGenSym].val, states.length = v, 1) : (states[name].val = $75d47fd8903c7af6$export$90a44edba14e47be(v), 1) : name in states ? $75d47fd8903c7af6$var$refSet(states, name, v, proxy) : $75d47fd8903c7af6$var$refSet(states, name, $75d47fd8903c7af6$var$toState(v)) && (++states[$75d47fd8903c7af6$var$keysGenSym].val, $75d47fd8903c7af6$var$filterBindings(states).forEach($75d47fd8903c7af6$var$addToContainer.bind($75d47fd8903c7af6$var$_undefined, proxy, name, states[name], $75d47fd8903c7af6$var$replacing)), 1),
    deleteProperty: (states, name)=>($75d47fd8903c7af6$var$refDelete(states, name) && $75d47fd8903c7af6$var$onDelete(states, name), ++states[$75d47fd8903c7af6$var$keysGenSym].val),
    ownKeys: (states)=>(states[$75d47fd8903c7af6$var$keysGenSym].val, $75d47fd8903c7af6$var$refOwnKeys(states))
};
let $75d47fd8903c7af6$export$90a44edba14e47be = (srcObj)=>!$75d47fd8903c7af6$var$isObject(srcObj) || srcObj[$75d47fd8903c7af6$var$statesSym] ? srcObj : new Proxy($75d47fd8903c7af6$var$buildStates(srcObj), $75d47fd8903c7af6$var$reactiveHandler);
let $75d47fd8903c7af6$export$d178a67dba336d3e = (x)=>(x[$75d47fd8903c7af6$var$noreactiveSym] = 1, x);
let $75d47fd8903c7af6$export$25bc5d365d8b32a4 = (obj)=>obj[$75d47fd8903c7af6$var$statesSym];
let $75d47fd8903c7af6$var$stateProto = $75d47fd8903c7af6$var$getPrototypeOf($75d47fd8903c7af6$var$state());
let $75d47fd8903c7af6$var$rawStates = (states)=>new Proxy(states, {
        get: (states, name, proxy)=>$75d47fd8903c7af6$var$getPrototypeOf(states[name] ?? 0) === $75d47fd8903c7af6$var$stateProto ? {
                val: $75d47fd8903c7af6$export$1776c186c69df29e(states[name].rawVal)
            } : $75d47fd8903c7af6$var$refGet(states, name, proxy)
    });
let $75d47fd8903c7af6$export$1776c186c69df29e = (obj)=>obj?.[$75d47fd8903c7af6$var$statesSym] ? new Proxy($75d47fd8903c7af6$var$rawStates(obj[$75d47fd8903c7af6$var$statesSym]), $75d47fd8903c7af6$var$reactiveHandler) : obj;
let $75d47fd8903c7af6$var$filterBindings = (states)=>states[$75d47fd8903c7af6$var$bindingsSym] = states[$75d47fd8903c7af6$var$bindingsSym].filter((b)=>b._containerDom.isConnected);
let $75d47fd8903c7af6$var$addToContainer = (items, k, v, skipReorder, { _containerDom: _containerDom, f: f })=>{
    let isArray = Array.isArray(items), typedK = isArray ? Number(k) : k;
    $75d47fd8903c7af6$var$add(_containerDom, ()=>_containerDom[$75d47fd8903c7af6$var$keyToChildSym][k] = f(v, ()=>delete items[k], typedK));
    isArray && !skipReorder && typedK !== items.length - 1 && _containerDom.insertBefore(_containerDom.lastChild, _containerDom[$75d47fd8903c7af6$var$keyToChildSym][$75d47fd8903c7af6$var$keys(items).find((key)=>Number(key) > typedK)]);
};
let $75d47fd8903c7af6$var$onDelete = (states, k)=>{
    for (let b of $75d47fd8903c7af6$var$filterBindings(states)){
        let keyToChild = b._containerDom[$75d47fd8903c7af6$var$keyToChildSym];
        keyToChild[k]?.remove();
        delete keyToChild[k];
    }
};
let $75d47fd8903c7af6$var$addStatesToGc = (states)=>($75d47fd8903c7af6$var$statesToGc ?? ($75d47fd8903c7af6$var$statesToGc = (setTimeout(()=>($75d47fd8903c7af6$var$statesToGc.forEach($75d47fd8903c7af6$var$filterBindings), $75d47fd8903c7af6$var$statesToGc = $75d47fd8903c7af6$var$_undefined), $75d47fd8903c7af6$var$gcCycleInMs), new Set))).add(states);
let $75d47fd8903c7af6$export$8837f4fc672e936d = (container, items, itemFunc)=>{
    let binding = {
        _containerDom: container instanceof Function ? container() : container,
        f: itemFunc
    };
    let states = items[$75d47fd8903c7af6$var$statesSym];
    binding._containerDom[$75d47fd8903c7af6$var$keyToChildSym] = {};
    states[$75d47fd8903c7af6$var$bindingsSym].push(binding);
    $75d47fd8903c7af6$var$addStatesToGc(states);
    for (let [k, v] of $75d47fd8903c7af6$var$entries(states))$75d47fd8903c7af6$var$addToContainer(items, k, v, 1, binding);
    return binding._containerDom;
};
let $75d47fd8903c7af6$var$replaceInternal = (obj, replacement)=>{
    for (let [k, v] of $75d47fd8903c7af6$var$entries(replacement)){
        let existingV = obj[k];
        $75d47fd8903c7af6$var$isObject(existingV) && $75d47fd8903c7af6$var$isObject(v) ? $75d47fd8903c7af6$var$replaceInternal(existingV, v) : obj[k] = v;
    }
    for(let k in obj)$75d47fd8903c7af6$var$hasOwn(replacement, k) || delete obj[k];
    let newKeys = $75d47fd8903c7af6$var$keys(replacement), isArray = Array.isArray(obj);
    if (isArray || $75d47fd8903c7af6$var$keys(obj).some((k, i)=>k !== newKeys[i])) {
        let states = obj[$75d47fd8903c7af6$var$statesSym];
        if (isArray) obj.length = replacement.length;
        else {
            ++states[$75d47fd8903c7af6$var$keysGenSym].val;
            let statesCopy = {
                ...states
            };
            for (let k of newKeys)delete states[k];
            for (let k of newKeys)states[k] = statesCopy[k];
        }
        for (let { _containerDom: _containerDom } of $75d47fd8903c7af6$var$filterBindings(states)){
            let { firstChild: dom, [$75d47fd8903c7af6$var$keyToChildSym]: keyToChild } = _containerDom;
            for (let k of newKeys)dom === keyToChild[k] ? dom = dom.nextSibling : _containerDom.insertBefore(keyToChild[k], dom);
        }
    }
    return obj;
};
let $75d47fd8903c7af6$export$77ad94ebf1c2b9ed = (obj, replacement)=>{
    $75d47fd8903c7af6$var$replacing = 1;
    try {
        return $75d47fd8903c7af6$var$replaceInternal(obj, replacement instanceof Function ? Array.isArray(obj) ? replacement(obj.filter((_)=>1)) : $75d47fd8903c7af6$var$fromEntries(replacement($75d47fd8903c7af6$var$entries(obj))) : replacement);
    } finally{
        $75d47fd8903c7af6$var$replacing = $75d47fd8903c7af6$var$_undefined;
    }
};
let $75d47fd8903c7af6$export$8e16b83750b44988 = (obj)=>Array.isArray(obj) ? obj.filter((_)=>1).map($75d47fd8903c7af6$export$8e16b83750b44988) : $75d47fd8903c7af6$var$isObject(obj) ? $75d47fd8903c7af6$var$assign($75d47fd8903c7af6$var$create($75d47fd8903c7af6$var$getPrototypeOf(obj)), $75d47fd8903c7af6$var$fromEntries($75d47fd8903c7af6$var$entries(obj).map(([k, v])=>[
            k,
            $75d47fd8903c7af6$export$8e16b83750b44988(v)
        ]))) : obj;





/**
 * @type {FarmcamSim}
 */ const $2590fa8d345b0ed5$export$8ee78a09007a744b = {
    Imsi: "",
    Active: false,
    RemainingData: 0,
    MonthlyData: 0,
    DataUsage: [],
    TrialUsed: false,
    LowDataWarning: false,
    Metadata: {
        OwnerEmail: "",
        Name: "",
        Tags: [],
        Access: [],
        Notify: []
    },
    Subscription: {
        ExpiresAt: "",
        PriceIds: {
            Current: "",
            Next: ""
        },
        Trialing: false
    }
};


class $64507ffd9a2bdb57$export$3e1e7910c6da7b17 {
    async #addTrial() {
        const req = this.#ctx.api.put(`/farmcam-sims/${this.#reactive.fcs.Imsi}/trial`);
        req.setJsonBody({
            Bytes: +this.#reactive.trialData * 1e6,
            Days: +this.#reactive.trialDays
        });
        req.setSignedInUserAuth();
        const res = await this.#ctx.loadingScreen.waitFor(req.do());
        if (res.ok) this.#reactive.fcs = await res.json();
    }
    async #cancelSubscription() {
        const req = this.#ctx.api.delete(`/farmcam-sims/${this.#reactive.fcs.Imsi}/subscription`);
        req.setSignedInUserAuth();
        const res = await this.#ctx.loadingScreen.waitFor(req.do());
        if (res.ok) this.#reactive.fcs = await res.json();
    }
    async #impersonate() {
        const req = this.#ctx.api.get(`/admin/impersonate?key=farmcamsim&value=${this.#reactive.fcs.Imsi}`);
        req.setSignedInUserAuth();
        const res = await this.#ctx.loadingScreen.waitFor(req.do());
        if (res.ok) {
            (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).startImpersonating(await res.json());
            this.#ctx.router.jump("/devices");
        }
    }
    async refresh(match) {
        if (!match.data?.imsi) throw "missing path param: imsi";
        const imsi = match.data?.imsi;
        const req = this.#ctx.api.get(`/farmcam-sims/${imsi}`);
        req.setSignedInUserAuth();
        const res = await req.do();
        if (res.ok) this.#reactive.fcs = await res.json();
    }
    #ctx;
    #reactive = (0, $75d47fd8903c7af6$export$90a44edba14e47be)({
        fcs: (0, $2590fa8d345b0ed5$export$8ee78a09007a744b),
        trialData: "",
        trialDays: ""
    });
    ChildDom;
    constructor(ctx){
        this.#ctx = ctx;
        this.ChildDom = (0, $e47741cb5fbbb614$export$4b0227fa4b29008b)({
            size: "narrow"
        }, (0, $01d3af8f1b8eef63$export$80e4b313e5e6b30d)({
            class: "breadcrumb"
        }, (0, $01d3af8f1b8eef63$export$b5023c870cb34848)((0, $01d3af8f1b8eef63$export$19caeaf7d9d84644)((0, $01d3af8f1b8eef63$export$407448d2b89b1813)({
            onclick: ()=>this.#ctx.router.jump("/admin")
        }, "Admin")), (0, $01d3af8f1b8eef63$export$19caeaf7d9d84644)((0, $01d3af8f1b8eef63$export$407448d2b89b1813)("FarmCam SIM")))), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "buttons"
        }, (0, $01d3af8f1b8eef63$export$2ba01fb71ed41cb6)({
            class: "button is-primary",
            onclick: ()=>this.#impersonate()
        }, "Impersonate owner"), (0, $01d3af8f1b8eef63$export$2ba01fb71ed41cb6)({
            class: "button is-primary",
            onclick: ()=>this.#cancelSubscription()
        }, "Cancel subscription")), (0, $01d3af8f1b8eef63$export$b4adb3f464574dcf)(), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "field"
        }, (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "control"
        }, (0, $01d3af8f1b8eef63$export$b7e3ae3d7c15e42e)({
            class: "input",
            oninput: (e)=>{
                if (!(e.target instanceof HTMLInputElement)) return;
                this.#reactive.trialData = e.target.value.replace(/\D/g, "");
                e.target.value = this.#reactive.trialData;
            },
            placeholder: "MB",
            value: ()=>this.#reactive.trialData
        }))), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "field"
        }, (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "control"
        }, (0, $01d3af8f1b8eef63$export$b7e3ae3d7c15e42e)({
            class: "input",
            oninput: (e)=>{
                if (!(e.target instanceof HTMLInputElement)) return;
                this.#reactive.trialDays = e.target.value.replace(/\D/g, "");
                e.target.value = this.#reactive.trialDays;
            },
            placeholder: "Days"
        }, ()=>this.#reactive.trialDays))), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "field"
        }, (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "control"
        }, (0, $01d3af8f1b8eef63$export$2ba01fb71ed41cb6)({
            class: "button is-primary",
            onclick: ()=>this.#addTrial()
        }, "Add trial"))), (0, $01d3af8f1b8eef63$export$b4adb3f464574dcf)(), (0, $01d3af8f1b8eef63$export$2af2ac64526e2aa9)({
            class: "is-tiny-mobile"
        }, ()=>JSON.stringify(this.#reactive.fcs, null, 2)));
    }
}




/*!
 * Chart.js v4.4.9
 * https://www.chartjs.org
 * (c) 2025 Chart.js Contributors
 * Released under the MIT License
 */ /*!
 * Chart.js v4.4.9
 * https://www.chartjs.org
 * (c) 2025 Chart.js Contributors
 * Released under the MIT License
 */ /*!
 * @kurkle/color v0.3.4
 * https://github.com/kurkle/color#readme
 * (c) 2024 Jukka Kurkela
 * Released under the MIT License
 */ function $87e6acd7396d97dc$export$2077e0241d6afd3c(v) {
    return v + 0.5 | 0;
}
const $87e6acd7396d97dc$export$837ba5c449269406 = (v, l, h)=>Math.max(Math.min(v, h), l);
function $87e6acd7396d97dc$export$bcc6e673dfa14d36(v) {
    return $87e6acd7396d97dc$export$837ba5c449269406($87e6acd7396d97dc$export$2077e0241d6afd3c(v * 2.55), 0, 255);
}
function $87e6acd7396d97dc$export$869b26d4e1bbdb63(v) {
    return $87e6acd7396d97dc$export$837ba5c449269406($87e6acd7396d97dc$export$2077e0241d6afd3c(v / 2.55), 0, 100);
}
function $87e6acd7396d97dc$export$ed9bd8dcaeba14f6(v) {
    return $87e6acd7396d97dc$export$837ba5c449269406($87e6acd7396d97dc$export$2077e0241d6afd3c(v * 255), 0, 255);
}
function $87e6acd7396d97dc$export$dbf961a8d278dbef(v) {
    return $87e6acd7396d97dc$export$837ba5c449269406($87e6acd7396d97dc$export$2077e0241d6afd3c(v / 2.55) / 100, 0, 1);
}
function $87e6acd7396d97dc$export$aa35ef1f24408ab9(v) {
    return $87e6acd7396d97dc$export$837ba5c449269406($87e6acd7396d97dc$export$2077e0241d6afd3c(v * 100), 0, 100);
}
const $87e6acd7396d97dc$var$map$1 = {
    0: 0,
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6,
    7: 7,
    8: 8,
    9: 9,
    A: 10,
    B: 11,
    C: 12,
    D: 13,
    E: 14,
    F: 15,
    a: 10,
    b: 11,
    c: 12,
    d: 13,
    e: 14,
    f: 15
};
const $87e6acd7396d97dc$var$hex = [
    ...'0123456789ABCDEF'
];
const $87e6acd7396d97dc$var$h1 = (b)=>$87e6acd7396d97dc$var$hex[b & 0xF];
const $87e6acd7396d97dc$var$h2 = (b)=>$87e6acd7396d97dc$var$hex[(b & 0xF0) >> 4] + $87e6acd7396d97dc$var$hex[b & 0xF];
const $87e6acd7396d97dc$var$eq = (b)=>(b & 0xF0) >> 4 === (b & 0xF);
const $87e6acd7396d97dc$var$isShort = (v)=>$87e6acd7396d97dc$var$eq(v.r) && $87e6acd7396d97dc$var$eq(v.g) && $87e6acd7396d97dc$var$eq(v.b) && $87e6acd7396d97dc$var$eq(v.a);
function $87e6acd7396d97dc$export$625a38b961e8b5e9(str) {
    var len = str.length;
    var ret;
    if (str[0] === '#') {
        if (len === 4 || len === 5) ret = {
            r: 255 & $87e6acd7396d97dc$var$map$1[str[1]] * 17,
            g: 255 & $87e6acd7396d97dc$var$map$1[str[2]] * 17,
            b: 255 & $87e6acd7396d97dc$var$map$1[str[3]] * 17,
            a: len === 5 ? $87e6acd7396d97dc$var$map$1[str[4]] * 17 : 255
        };
        else if (len === 7 || len === 9) ret = {
            r: $87e6acd7396d97dc$var$map$1[str[1]] << 4 | $87e6acd7396d97dc$var$map$1[str[2]],
            g: $87e6acd7396d97dc$var$map$1[str[3]] << 4 | $87e6acd7396d97dc$var$map$1[str[4]],
            b: $87e6acd7396d97dc$var$map$1[str[5]] << 4 | $87e6acd7396d97dc$var$map$1[str[6]],
            a: len === 9 ? $87e6acd7396d97dc$var$map$1[str[7]] << 4 | $87e6acd7396d97dc$var$map$1[str[8]] : 255
        };
    }
    return ret;
}
const $87e6acd7396d97dc$var$alpha = (a, f)=>a < 255 ? f(a) : '';
function $87e6acd7396d97dc$export$1b06654353ef9f67(v) {
    var f = $87e6acd7396d97dc$var$isShort(v) ? $87e6acd7396d97dc$var$h1 : $87e6acd7396d97dc$var$h2;
    return v ? '#' + f(v.r) + f(v.g) + f(v.b) + $87e6acd7396d97dc$var$alpha(v.a, f) : undefined;
}
const $87e6acd7396d97dc$var$HUE_RE = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
function $87e6acd7396d97dc$var$hsl2rgbn(h, s, l) {
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    return [
        f(0),
        f(8),
        f(4)
    ];
}
function $87e6acd7396d97dc$var$hsv2rgbn(h, s, v) {
    const f = (n, k = (n + h / 60) % 6)=>v - v * s * Math.max(Math.min(k, 4 - k, 1), 0);
    return [
        f(5),
        f(3),
        f(1)
    ];
}
function $87e6acd7396d97dc$var$hwb2rgbn(h, w, b) {
    const rgb = $87e6acd7396d97dc$var$hsl2rgbn(h, 1, 0.5);
    let i;
    if (w + b > 1) {
        i = 1 / (w + b);
        w *= i;
        b *= i;
    }
    for(i = 0; i < 3; i++){
        rgb[i] *= 1 - w - b;
        rgb[i] += w;
    }
    return rgb;
}
function $87e6acd7396d97dc$var$hueValue(r, g, b, d, max) {
    if (r === max) return (g - b) / d + (g < b ? 6 : 0);
    if (g === max) return (b - r) / d + 2;
    return (r - g) / d + 4;
}
function $87e6acd7396d97dc$export$b5ba70b240f8f7f(v) {
    const range = 255;
    const r = v.r / range;
    const g = v.g / range;
    const b = v.b / range;
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    const l = (max + min) / 2;
    let h, s, d;
    if (max !== min) {
        d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        h = $87e6acd7396d97dc$var$hueValue(r, g, b, d, max);
        h = h * 60 + 0.5;
    }
    return [
        h | 0,
        s || 0,
        l
    ];
}
function $87e6acd7396d97dc$var$calln(f, a, b, c) {
    return (Array.isArray(a) ? f(a[0], a[1], a[2]) : f(a, b, c)).map($87e6acd7396d97dc$export$ed9bd8dcaeba14f6);
}
function $87e6acd7396d97dc$export$4c15bd42559b811d(h, s, l) {
    return $87e6acd7396d97dc$var$calln($87e6acd7396d97dc$var$hsl2rgbn, h, s, l);
}
function $87e6acd7396d97dc$export$e2710022c70fc9ee(h, w, b) {
    return $87e6acd7396d97dc$var$calln($87e6acd7396d97dc$var$hwb2rgbn, h, w, b);
}
function $87e6acd7396d97dc$export$b785a357c84e4a04(h, s, v) {
    return $87e6acd7396d97dc$var$calln($87e6acd7396d97dc$var$hsv2rgbn, h, s, v);
}
function $87e6acd7396d97dc$var$hue(h) {
    return (h % 360 + 360) % 360;
}
function $87e6acd7396d97dc$export$5e91288c399be4f9(str) {
    const m = $87e6acd7396d97dc$var$HUE_RE.exec(str);
    let a = 255;
    let v;
    if (!m) return;
    if (m[5] !== v) a = m[6] ? $87e6acd7396d97dc$export$bcc6e673dfa14d36(+m[5]) : $87e6acd7396d97dc$export$ed9bd8dcaeba14f6(+m[5]);
    const h = $87e6acd7396d97dc$var$hue(+m[2]);
    const p1 = +m[3] / 100;
    const p2 = +m[4] / 100;
    if (m[1] === 'hwb') v = $87e6acd7396d97dc$export$e2710022c70fc9ee(h, p1, p2);
    else if (m[1] === 'hsv') v = $87e6acd7396d97dc$export$b785a357c84e4a04(h, p1, p2);
    else v = $87e6acd7396d97dc$export$4c15bd42559b811d(h, p1, p2);
    return {
        r: v[0],
        g: v[1],
        b: v[2],
        a: a
    };
}
function $87e6acd7396d97dc$export$bb628a54ab399bc9(v, deg) {
    var h = $87e6acd7396d97dc$export$b5ba70b240f8f7f(v);
    h[0] = $87e6acd7396d97dc$var$hue(h[0] + deg);
    h = $87e6acd7396d97dc$export$4c15bd42559b811d(h);
    v.r = h[0];
    v.g = h[1];
    v.b = h[2];
}
function $87e6acd7396d97dc$export$a197af1c58e6260c(v) {
    if (!v) return;
    const a = $87e6acd7396d97dc$export$b5ba70b240f8f7f(v);
    const h = a[0];
    const s = $87e6acd7396d97dc$export$aa35ef1f24408ab9(a[1]);
    const l = $87e6acd7396d97dc$export$aa35ef1f24408ab9(a[2]);
    return v.a < 255 ? `hsla(${h}, ${s}%, ${l}%, ${$87e6acd7396d97dc$export$dbf961a8d278dbef(v.a)})` : `hsl(${h}, ${s}%, ${l}%)`;
}
const $87e6acd7396d97dc$var$map = {
    x: 'dark',
    Z: 'light',
    Y: 're',
    X: 'blu',
    W: 'gr',
    V: 'medium',
    U: 'slate',
    A: 'ee',
    T: 'ol',
    S: 'or',
    B: 'ra',
    C: 'lateg',
    D: 'ights',
    R: 'in',
    Q: 'turquois',
    E: 'hi',
    P: 'ro',
    O: 'al',
    N: 'le',
    M: 'de',
    L: 'yello',
    F: 'en',
    K: 'ch',
    G: 'arks',
    H: 'ea',
    I: 'ightg',
    J: 'wh'
};
const $87e6acd7396d97dc$var$names$1 = {
    OiceXe: 'f0f8ff',
    antiquewEte: 'faebd7',
    aqua: 'ffff',
    aquamarRe: '7fffd4',
    azuY: 'f0ffff',
    beige: 'f5f5dc',
    bisque: 'ffe4c4',
    black: '0',
    blanKedOmond: 'ffebcd',
    Xe: 'ff',
    XeviTet: '8a2be2',
    bPwn: 'a52a2a',
    burlywood: 'deb887',
    caMtXe: '5f9ea0',
    KartYuse: '7fff00',
    KocTate: 'd2691e',
    cSO: 'ff7f50',
    cSnflowerXe: '6495ed',
    cSnsilk: 'fff8dc',
    crimson: 'dc143c',
    cyan: 'ffff',
    xXe: '8b',
    xcyan: '8b8b',
    xgTMnPd: 'b8860b',
    xWay: 'a9a9a9',
    xgYF: '6400',
    xgYy: 'a9a9a9',
    xkhaki: 'bdb76b',
    xmagFta: '8b008b',
    xTivegYF: '556b2f',
    xSange: 'ff8c00',
    xScEd: '9932cc',
    xYd: '8b0000',
    xsOmon: 'e9967a',
    xsHgYF: '8fbc8f',
    xUXe: '483d8b',
    xUWay: '2f4f4f',
    xUgYy: '2f4f4f',
    xQe: 'ced1',
    xviTet: '9400d3',
    dAppRk: 'ff1493',
    dApskyXe: 'bfff',
    dimWay: '696969',
    dimgYy: '696969',
    dodgerXe: '1e90ff',
    fiYbrick: 'b22222',
    flSOwEte: 'fffaf0',
    foYstWAn: '228b22',
    fuKsia: 'ff00ff',
    gaRsbSo: 'dcdcdc',
    ghostwEte: 'f8f8ff',
    gTd: 'ffd700',
    gTMnPd: 'daa520',
    Way: '808080',
    gYF: '8000',
    gYFLw: 'adff2f',
    gYy: '808080',
    honeyMw: 'f0fff0',
    hotpRk: 'ff69b4',
    RdianYd: 'cd5c5c',
    Rdigo: '4b0082',
    ivSy: 'fffff0',
    khaki: 'f0e68c',
    lavFMr: 'e6e6fa',
    lavFMrXsh: 'fff0f5',
    lawngYF: '7cfc00',
    NmoncEffon: 'fffacd',
    ZXe: 'add8e6',
    ZcSO: 'f08080',
    Zcyan: 'e0ffff',
    ZgTMnPdLw: 'fafad2',
    ZWay: 'd3d3d3',
    ZgYF: '90ee90',
    ZgYy: 'd3d3d3',
    ZpRk: 'ffb6c1',
    ZsOmon: 'ffa07a',
    ZsHgYF: '20b2aa',
    ZskyXe: '87cefa',
    ZUWay: '778899',
    ZUgYy: '778899',
    ZstAlXe: 'b0c4de',
    ZLw: 'ffffe0',
    lime: 'ff00',
    limegYF: '32cd32',
    lRF: 'faf0e6',
    magFta: 'ff00ff',
    maPon: '800000',
    VaquamarRe: '66cdaa',
    VXe: 'cd',
    VScEd: 'ba55d3',
    VpurpN: '9370db',
    VsHgYF: '3cb371',
    VUXe: '7b68ee',
    VsprRggYF: 'fa9a',
    VQe: '48d1cc',
    VviTetYd: 'c71585',
    midnightXe: '191970',
    mRtcYam: 'f5fffa',
    mistyPse: 'ffe4e1',
    moccasR: 'ffe4b5',
    navajowEte: 'ffdead',
    navy: '80',
    Tdlace: 'fdf5e6',
    Tive: '808000',
    TivedBb: '6b8e23',
    Sange: 'ffa500',
    SangeYd: 'ff4500',
    ScEd: 'da70d6',
    pOegTMnPd: 'eee8aa',
    pOegYF: '98fb98',
    pOeQe: 'afeeee',
    pOeviTetYd: 'db7093',
    papayawEp: 'ffefd5',
    pHKpuff: 'ffdab9',
    peru: 'cd853f',
    pRk: 'ffc0cb',
    plum: 'dda0dd',
    powMrXe: 'b0e0e6',
    purpN: '800080',
    YbeccapurpN: '663399',
    Yd: 'ff0000',
    Psybrown: 'bc8f8f',
    PyOXe: '4169e1',
    saddNbPwn: '8b4513',
    sOmon: 'fa8072',
    sandybPwn: 'f4a460',
    sHgYF: '2e8b57',
    sHshell: 'fff5ee',
    siFna: 'a0522d',
    silver: 'c0c0c0',
    skyXe: '87ceeb',
    UXe: '6a5acd',
    UWay: '708090',
    UgYy: '708090',
    snow: 'fffafa',
    sprRggYF: 'ff7f',
    stAlXe: '4682b4',
    tan: 'd2b48c',
    teO: '8080',
    tEstN: 'd8bfd8',
    tomato: 'ff6347',
    Qe: '40e0d0',
    viTet: 'ee82ee',
    JHt: 'f5deb3',
    wEte: 'ffffff',
    wEtesmoke: 'f5f5f5',
    Lw: 'ffff00',
    LwgYF: '9acd32'
};
function $87e6acd7396d97dc$var$unpack() {
    const unpacked = {};
    const keys = Object.keys($87e6acd7396d97dc$var$names$1);
    const tkeys = Object.keys($87e6acd7396d97dc$var$map);
    let i, j, k, ok, nk;
    for(i = 0; i < keys.length; i++){
        ok = nk = keys[i];
        for(j = 0; j < tkeys.length; j++){
            k = tkeys[j];
            nk = nk.replace(k, $87e6acd7396d97dc$var$map[k]);
        }
        k = parseInt($87e6acd7396d97dc$var$names$1[ok], 16);
        unpacked[nk] = [
            k >> 16 & 0xFF,
            k >> 8 & 0xFF,
            k & 0xFF
        ];
    }
    return unpacked;
}
let $87e6acd7396d97dc$var$names;
function $87e6acd7396d97dc$export$b2f06b640faad956(str) {
    if (!$87e6acd7396d97dc$var$names) {
        $87e6acd7396d97dc$var$names = $87e6acd7396d97dc$var$unpack();
        $87e6acd7396d97dc$var$names.transparent = [
            0,
            0,
            0,
            0
        ];
    }
    const a = $87e6acd7396d97dc$var$names[str.toLowerCase()];
    return a && {
        r: a[0],
        g: a[1],
        b: a[2],
        a: a.length === 4 ? a[3] : 255
    };
}
const $87e6acd7396d97dc$var$RGB_RE = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
function $87e6acd7396d97dc$export$91aedb20f296e541(str) {
    const m = $87e6acd7396d97dc$var$RGB_RE.exec(str);
    let a = 255;
    let r, g, b;
    if (!m) return;
    if (m[7] !== r) {
        const v = +m[7];
        a = m[8] ? $87e6acd7396d97dc$export$bcc6e673dfa14d36(v) : $87e6acd7396d97dc$export$837ba5c449269406(v * 255, 0, 255);
    }
    r = +m[1];
    g = +m[3];
    b = +m[5];
    r = 255 & (m[2] ? $87e6acd7396d97dc$export$bcc6e673dfa14d36(r) : $87e6acd7396d97dc$export$837ba5c449269406(r, 0, 255));
    g = 255 & (m[4] ? $87e6acd7396d97dc$export$bcc6e673dfa14d36(g) : $87e6acd7396d97dc$export$837ba5c449269406(g, 0, 255));
    b = 255 & (m[6] ? $87e6acd7396d97dc$export$bcc6e673dfa14d36(b) : $87e6acd7396d97dc$export$837ba5c449269406(b, 0, 255));
    return {
        r: r,
        g: g,
        b: b,
        a: a
    };
}
function $87e6acd7396d97dc$export$9595423f22cf925a(v) {
    return v && (v.a < 255 ? `rgba(${v.r}, ${v.g}, ${v.b}, ${$87e6acd7396d97dc$export$dbf961a8d278dbef(v.a)})` : `rgb(${v.r}, ${v.g}, ${v.b})`);
}
const $87e6acd7396d97dc$var$to = (v)=>v <= 0.0031308 ? v * 12.92 : Math.pow(v, 1.0 / 2.4) * 1.055 - 0.055;
const $87e6acd7396d97dc$var$from = (v)=>v <= 0.04045 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
function $87e6acd7396d97dc$var$interpolate(rgb1, rgb2, t) {
    const r = $87e6acd7396d97dc$var$from($87e6acd7396d97dc$export$dbf961a8d278dbef(rgb1.r));
    const g = $87e6acd7396d97dc$var$from($87e6acd7396d97dc$export$dbf961a8d278dbef(rgb1.g));
    const b = $87e6acd7396d97dc$var$from($87e6acd7396d97dc$export$dbf961a8d278dbef(rgb1.b));
    return {
        r: $87e6acd7396d97dc$export$ed9bd8dcaeba14f6($87e6acd7396d97dc$var$to(r + t * ($87e6acd7396d97dc$var$from($87e6acd7396d97dc$export$dbf961a8d278dbef(rgb2.r)) - r))),
        g: $87e6acd7396d97dc$export$ed9bd8dcaeba14f6($87e6acd7396d97dc$var$to(g + t * ($87e6acd7396d97dc$var$from($87e6acd7396d97dc$export$dbf961a8d278dbef(rgb2.g)) - g))),
        b: $87e6acd7396d97dc$export$ed9bd8dcaeba14f6($87e6acd7396d97dc$var$to(b + t * ($87e6acd7396d97dc$var$from($87e6acd7396d97dc$export$dbf961a8d278dbef(rgb2.b)) - b))),
        a: rgb1.a + t * (rgb2.a - rgb1.a)
    };
}
function $87e6acd7396d97dc$var$modHSL(v, i, ratio) {
    if (v) {
        let tmp = $87e6acd7396d97dc$export$b5ba70b240f8f7f(v);
        tmp[i] = Math.max(0, Math.min(tmp[i] + tmp[i] * ratio, i === 0 ? 360 : 1));
        tmp = $87e6acd7396d97dc$export$4c15bd42559b811d(tmp);
        v.r = tmp[0];
        v.g = tmp[1];
        v.b = tmp[2];
    }
}
function $87e6acd7396d97dc$var$clone(v, proto) {
    return v ? Object.assign(proto || {}, v) : v;
}
function $87e6acd7396d97dc$var$fromObject(input) {
    var v = {
        r: 0,
        g: 0,
        b: 0,
        a: 255
    };
    if (Array.isArray(input)) {
        if (input.length >= 3) {
            v = {
                r: input[0],
                g: input[1],
                b: input[2],
                a: 255
            };
            if (input.length > 3) v.a = $87e6acd7396d97dc$export$ed9bd8dcaeba14f6(input[3]);
        }
    } else {
        v = $87e6acd7396d97dc$var$clone(input, {
            r: 0,
            g: 0,
            b: 0,
            a: 1
        });
        v.a = $87e6acd7396d97dc$export$ed9bd8dcaeba14f6(v.a);
    }
    return v;
}
function $87e6acd7396d97dc$var$functionParse(str) {
    if (str.charAt(0) === 'r') return $87e6acd7396d97dc$export$91aedb20f296e541(str);
    return $87e6acd7396d97dc$export$5e91288c399be4f9(str);
}
class $87e6acd7396d97dc$export$892596cec99bc70e {
    constructor(input){
        if (input instanceof $87e6acd7396d97dc$export$892596cec99bc70e) return input;
        const type = typeof input;
        let v;
        if (type === 'object') v = $87e6acd7396d97dc$var$fromObject(input);
        else if (type === 'string') v = $87e6acd7396d97dc$export$625a38b961e8b5e9(input) || $87e6acd7396d97dc$export$b2f06b640faad956(input) || $87e6acd7396d97dc$var$functionParse(input);
        this._rgb = v;
        this._valid = !!v;
    }
    get valid() {
        return this._valid;
    }
    get rgb() {
        var v = $87e6acd7396d97dc$var$clone(this._rgb);
        if (v) v.a = $87e6acd7396d97dc$export$dbf961a8d278dbef(v.a);
        return v;
    }
    set rgb(obj) {
        this._rgb = $87e6acd7396d97dc$var$fromObject(obj);
    }
    rgbString() {
        return this._valid ? $87e6acd7396d97dc$export$9595423f22cf925a(this._rgb) : undefined;
    }
    hexString() {
        return this._valid ? $87e6acd7396d97dc$export$1b06654353ef9f67(this._rgb) : undefined;
    }
    hslString() {
        return this._valid ? $87e6acd7396d97dc$export$a197af1c58e6260c(this._rgb) : undefined;
    }
    mix(color, weight) {
        if (color) {
            const c1 = this.rgb;
            const c2 = color.rgb;
            let w2;
            const p = weight === w2 ? 0.5 : weight;
            const w = 2 * p - 1;
            const a = c1.a - c2.a;
            const w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
            w2 = 1 - w1;
            c1.r = 0xFF & w1 * c1.r + w2 * c2.r + 0.5;
            c1.g = 0xFF & w1 * c1.g + w2 * c2.g + 0.5;
            c1.b = 0xFF & w1 * c1.b + w2 * c2.b + 0.5;
            c1.a = p * c1.a + (1 - p) * c2.a;
            this.rgb = c1;
        }
        return this;
    }
    interpolate(color, t) {
        if (color) this._rgb = $87e6acd7396d97dc$var$interpolate(this._rgb, color._rgb, t);
        return this;
    }
    clone() {
        return new $87e6acd7396d97dc$export$892596cec99bc70e(this.rgb);
    }
    alpha(a) {
        this._rgb.a = $87e6acd7396d97dc$export$ed9bd8dcaeba14f6(a);
        return this;
    }
    clearer(ratio) {
        const rgb = this._rgb;
        rgb.a *= 1 - ratio;
        return this;
    }
    greyscale() {
        const rgb = this._rgb;
        const val = $87e6acd7396d97dc$export$2077e0241d6afd3c(rgb.r * 0.3 + rgb.g * 0.59 + rgb.b * 0.11);
        rgb.r = rgb.g = rgb.b = val;
        return this;
    }
    opaquer(ratio) {
        const rgb = this._rgb;
        rgb.a *= 1 + ratio;
        return this;
    }
    negate() {
        const v = this._rgb;
        v.r = 255 - v.r;
        v.g = 255 - v.g;
        v.b = 255 - v.b;
        return this;
    }
    lighten(ratio) {
        $87e6acd7396d97dc$var$modHSL(this._rgb, 2, ratio);
        return this;
    }
    darken(ratio) {
        $87e6acd7396d97dc$var$modHSL(this._rgb, 2, -ratio);
        return this;
    }
    saturate(ratio) {
        $87e6acd7396d97dc$var$modHSL(this._rgb, 1, ratio);
        return this;
    }
    desaturate(ratio) {
        $87e6acd7396d97dc$var$modHSL(this._rgb, 1, -ratio);
        return this;
    }
    rotate(deg) {
        $87e6acd7396d97dc$export$bb628a54ab399bc9(this._rgb, deg);
        return this;
    }
}
function $87e6acd7396d97dc$export$2e2bcd8739ae039(input) {
    return new $87e6acd7396d97dc$export$892596cec99bc70e(input);
}


/**
 * @namespace Chart.helpers
 */ /**
 * An empty function that can be used, for example, for optional callback.
 */ function $84f61e7391a78632$export$53a70dd1ebbae346() {
/* noop */ }
/**
 * Returns a unique id, sequentially generated from a global variable.
 */ const $84f61e7391a78632$export$2219238a014317b0 = (()=>{
    let id = 0;
    return ()=>id++;
})();
/**
 * Returns true if `value` is neither null nor undefined, else returns false.
 * @param value - The value to test.
 * @since 2.7.0
 */ function $84f61e7391a78632$export$342063e11d6c3cad(value) {
    return value === null || value === undefined;
}
/**
 * Returns true if `value` is an array (including typed arrays), else returns false.
 * @param value - The value to test.
 * @function
 */ function $84f61e7391a78632$export$8b22cf2602fb60ce(value) {
    if (Array.isArray && Array.isArray(value)) return true;
    const type = Object.prototype.toString.call(value);
    if (type.slice(0, 7) === '[object' && type.slice(-6) === 'Array]') return true;
    return false;
}
/**
 * Returns true if `value` is an object (excluding null), else returns false.
 * @param value - The value to test.
 * @since 2.7.0
 */ function $84f61e7391a78632$export$23f2a1d2818174ef(value) {
    return value !== null && Object.prototype.toString.call(value) === '[object Object]';
}
/**
 * Returns true if `value` is a finite number, else returns false
 * @param value  - The value to test.
 */ function $84f61e7391a78632$export$39b482c5e57630a8(value) {
    return (typeof value === 'number' || value instanceof Number) && isFinite(+value);
}
/**
 * Returns `value` if finite, else returns `defaultValue`.
 * @param value - The value to return if defined.
 * @param defaultValue - The value to return if `value` is not finite.
 */ function $84f61e7391a78632$export$c4ce752e73470fba(value, defaultValue) {
    return $84f61e7391a78632$export$39b482c5e57630a8(value) ? value : defaultValue;
}
/**
 * Returns `value` if defined, else returns `defaultValue`.
 * @param value - The value to return if defined.
 * @param defaultValue - The value to return if `value` is undefined.
 */ function $84f61e7391a78632$export$90a7f3efeed30595(value, defaultValue) {
    return typeof value === 'undefined' ? defaultValue : value;
}
const $84f61e7391a78632$export$953cecd6e717a553 = (value, dimension)=>typeof value === 'string' && value.endsWith('%') ? parseFloat(value) / 100 : +value / dimension;
const $84f61e7391a78632$export$7ccc53e8f1e7dfc5 = (value, dimension)=>typeof value === 'string' && value.endsWith('%') ? parseFloat(value) / 100 * dimension : +value;
/**
 * Calls `fn` with the given `args` in the scope defined by `thisArg` and returns the
 * value returned by `fn`. If `fn` is not a function, this method returns undefined.
 * @param fn - The function to call.
 * @param args - The arguments with which `fn` should be called.
 * @param [thisArg] - The value of `this` provided for the call to `fn`.
 */ function $84f61e7391a78632$export$3722cfe417b6ed86(fn, args, thisArg) {
    if (fn && typeof fn.call === 'function') return fn.apply(thisArg, args);
}
function $84f61e7391a78632$export$d66501df72047452(loopable, fn, thisArg, reverse) {
    let i, len, keys;
    if ($84f61e7391a78632$export$8b22cf2602fb60ce(loopable)) {
        len = loopable.length;
        if (reverse) for(i = len - 1; i >= 0; i--)fn.call(thisArg, loopable[i], i);
        else for(i = 0; i < len; i++)fn.call(thisArg, loopable[i], i);
    } else if ($84f61e7391a78632$export$23f2a1d2818174ef(loopable)) {
        keys = Object.keys(loopable);
        len = keys.length;
        for(i = 0; i < len; i++)fn.call(thisArg, loopable[keys[i]], keys[i]);
    }
}
/**
 * Returns true if the `a0` and `a1` arrays have the same content, else returns false.
 * @param a0 - The array to compare
 * @param a1 - The array to compare
 * @private
 */ function $84f61e7391a78632$export$f38c853ae54ed474(a0, a1) {
    let i, ilen, v0, v1;
    if (!a0 || !a1 || a0.length !== a1.length) return false;
    for(i = 0, ilen = a0.length; i < ilen; ++i){
        v0 = a0[i];
        v1 = a1[i];
        if (v0.datasetIndex !== v1.datasetIndex || v0.index !== v1.index) return false;
    }
    return true;
}
/**
 * Returns a deep copy of `source` without keeping references on objects and arrays.
 * @param source - The value to clone.
 */ function $84f61e7391a78632$export$667d3bf0c5f83305(source) {
    if ($84f61e7391a78632$export$8b22cf2602fb60ce(source)) return source.map($84f61e7391a78632$export$667d3bf0c5f83305);
    if ($84f61e7391a78632$export$23f2a1d2818174ef(source)) {
        const target = Object.create(null);
        const keys = Object.keys(source);
        const klen = keys.length;
        let k = 0;
        for(; k < klen; ++k)target[keys[k]] = $84f61e7391a78632$export$667d3bf0c5f83305(source[keys[k]]);
        return target;
    }
    return source;
}
function $84f61e7391a78632$var$isValidKey(key) {
    return [
        '__proto__',
        'prototype',
        'constructor'
    ].indexOf(key) === -1;
}
/**
 * The default merger when Chart.helpers.merge is called without merger option.
 * Note(SB): also used by mergeConfig and mergeScaleConfig as fallback.
 * @private
 */ function $84f61e7391a78632$export$317a3d46287192d8(key, target, source, options) {
    if (!$84f61e7391a78632$var$isValidKey(key)) return;
    const tval = target[key];
    const sval = source[key];
    if ($84f61e7391a78632$export$23f2a1d2818174ef(tval) && $84f61e7391a78632$export$23f2a1d2818174ef(sval)) // eslint-disable-next-line @typescript-eslint/no-use-before-define
    $84f61e7391a78632$export$efca4cbe5dd06740(tval, sval, options);
    else target[key] = $84f61e7391a78632$export$667d3bf0c5f83305(sval);
}
function $84f61e7391a78632$export$efca4cbe5dd06740(target, source, options) {
    const sources = $84f61e7391a78632$export$8b22cf2602fb60ce(source) ? source : [
        source
    ];
    const ilen = sources.length;
    if (!$84f61e7391a78632$export$23f2a1d2818174ef(target)) return target;
    options = options || {};
    const merger = options.merger || $84f61e7391a78632$export$317a3d46287192d8;
    let current;
    for(let i = 0; i < ilen; ++i){
        current = sources[i];
        if (!$84f61e7391a78632$export$23f2a1d2818174ef(current)) continue;
        const keys = Object.keys(current);
        for(let k = 0, klen = keys.length; k < klen; ++k)merger(keys[k], target, current, options);
    }
    return target;
}
function $84f61e7391a78632$export$555508cbc6add439(target, source) {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    return $84f61e7391a78632$export$efca4cbe5dd06740(target, source, {
        merger: $84f61e7391a78632$export$1ee57be6f6687d2c
    });
}
/**
 * Merges source[key] in target[key] only if target[key] is undefined.
 * @private
 */ function $84f61e7391a78632$export$1ee57be6f6687d2c(key, target, source) {
    if (!$84f61e7391a78632$var$isValidKey(key)) return;
    const tval = target[key];
    const sval = source[key];
    if ($84f61e7391a78632$export$23f2a1d2818174ef(tval) && $84f61e7391a78632$export$23f2a1d2818174ef(sval)) $84f61e7391a78632$export$555508cbc6add439(tval, sval);
    else if (!Object.prototype.hasOwnProperty.call(target, key)) target[key] = $84f61e7391a78632$export$667d3bf0c5f83305(sval);
}
/**
 * @private
 */ function $84f61e7391a78632$export$9d0e2d13d04f7070(scope, value, previous, current) {
    if (value !== undefined) console.warn(scope + ': "' + previous + '" is deprecated. Please use "' + current + '" instead');
}
// resolveObjectKey resolver cache
const $84f61e7391a78632$var$keyResolvers = {
    // Chart.helpers.core resolveObjectKey should resolve empty key to root object
    '': (v)=>v,
    // default resolvers
    x: (o)=>o.x,
    y: (o)=>o.y
};
/**
 * @private
 */ function $84f61e7391a78632$export$1a8f5705751d8277(key) {
    const parts = key.split('.');
    const keys = [];
    let tmp = '';
    for (const part of parts){
        tmp += part;
        if (tmp.endsWith('\\')) tmp = tmp.slice(0, -1) + '.';
        else {
            keys.push(tmp);
            tmp = '';
        }
    }
    return keys;
}
function $84f61e7391a78632$var$_getKeyResolver(key) {
    const keys = $84f61e7391a78632$export$1a8f5705751d8277(key);
    return (obj)=>{
        for (const k of keys){
            if (k === '') break;
            obj = obj && obj[k];
        }
        return obj;
    };
}
function $84f61e7391a78632$export$2d1720544b23b823(obj, key) {
    const resolver = $84f61e7391a78632$var$keyResolvers[key] || ($84f61e7391a78632$var$keyResolvers[key] = $84f61e7391a78632$var$_getKeyResolver(key));
    return resolver(obj);
}
/**
 * @private
 */ function $84f61e7391a78632$export$a8550f7dbe79f93a(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
const $84f61e7391a78632$export$dda1d9f60106f0e9 = (value)=>typeof value !== 'undefined';
const $84f61e7391a78632$export$a93c5207d687da10 = (value)=>typeof value === 'function';
// Adapted from https://stackoverflow.com/questions/31128855/comparing-ecma6-sets-for-equality#31129384
const $84f61e7391a78632$export$ee7c8ad385a60b7b = (a, b)=>{
    if (a.size !== b.size) return false;
    for (const item of a){
        if (!b.has(item)) return false;
    }
    return true;
};
/**
 * @param e - The event
 * @private
 */ function $84f61e7391a78632$export$3b513254972cfc9c(e) {
    return e.type === 'mouseup' || e.type === 'click' || e.type === 'contextmenu';
}
/**
 * @alias Chart.helpers.math
 * @namespace
 */ const $84f61e7391a78632$export$56c0d5a1e737357d = Math.PI;
const $84f61e7391a78632$export$971d5caa766a69d7 = 2 * $84f61e7391a78632$export$56c0d5a1e737357d;
const $84f61e7391a78632$export$2ec5befb9e6c97d4 = $84f61e7391a78632$export$971d5caa766a69d7 + $84f61e7391a78632$export$56c0d5a1e737357d;
const $84f61e7391a78632$export$53c86fa97d611818 = Number.POSITIVE_INFINITY;
const $84f61e7391a78632$export$39c1cc7c062529d4 = $84f61e7391a78632$export$56c0d5a1e737357d / 180;
const $84f61e7391a78632$export$7f8ddf7c7c20b3cd = $84f61e7391a78632$export$56c0d5a1e737357d / 2;
const $84f61e7391a78632$export$7a0bdf7d4a91ea88 = $84f61e7391a78632$export$56c0d5a1e737357d / 4;
const $84f61e7391a78632$export$c18d01048907ea92 = $84f61e7391a78632$export$56c0d5a1e737357d * 2 / 3;
const $84f61e7391a78632$export$faec65b429be379 = Math.log10;
const $84f61e7391a78632$export$2408f22a0fab9ae5 = Math.sign;
function $84f61e7391a78632$export$23ebac1979863676(x, y, epsilon) {
    return Math.abs(x - y) < epsilon;
}
/**
 * Implementation of the nice number algorithm used in determining where axis labels will go
 */ function $84f61e7391a78632$export$b9a6b53f9be3734(range) {
    const roundedRange = Math.round(range);
    range = $84f61e7391a78632$export$23ebac1979863676(range, roundedRange, range / 1000) ? roundedRange : range;
    const niceRange = Math.pow(10, Math.floor($84f61e7391a78632$export$faec65b429be379(range)));
    const fraction = range / niceRange;
    const niceFraction = fraction <= 1 ? 1 : fraction <= 2 ? 2 : fraction <= 5 ? 5 : 10;
    return niceFraction * niceRange;
}
/**
 * Returns an array of factors sorted from 1 to sqrt(value)
 * @private
 */ function $84f61e7391a78632$export$a07804094c3ecf2d(value) {
    const result = [];
    const sqrt = Math.sqrt(value);
    let i;
    for(i = 1; i < sqrt; i++)if (value % i === 0) {
        result.push(i);
        result.push(value / i);
    }
    if (sqrt === (sqrt | 0)) result.push(sqrt);
    result.sort((a, b)=>a - b).pop();
    return result;
}
/**
 * Verifies that attempting to coerce n to string or number won't throw a TypeError.
 */ function $84f61e7391a78632$var$isNonPrimitive(n) {
    return typeof n === 'symbol' || typeof n === 'object' && n !== null && !(Symbol.toPrimitive in n || 'toString' in n || 'valueOf' in n);
}
function $84f61e7391a78632$export$d141bba7fdc215a3(n) {
    return !$84f61e7391a78632$var$isNonPrimitive(n) && !isNaN(parseFloat(n)) && isFinite(n);
}
function $84f61e7391a78632$export$a05254e7c3aeba6e(x, epsilon) {
    const rounded = Math.round(x);
    return rounded - epsilon <= x && rounded + epsilon >= x;
}
/**
 * @private
 */ function $84f61e7391a78632$export$a33b77bbdbb8366c(array, target, property) {
    let i, ilen, value;
    for(i = 0, ilen = array.length; i < ilen; i++){
        value = array[i][property];
        if (!isNaN(value)) {
            target.min = Math.min(target.min, value);
            target.max = Math.max(target.max, value);
        }
    }
}
function $84f61e7391a78632$export$625550452a3fa3ec(degrees) {
    return degrees * ($84f61e7391a78632$export$56c0d5a1e737357d / 180);
}
function $84f61e7391a78632$export$3a6d5c9ae78a2c08(radians) {
    return radians * (180 / $84f61e7391a78632$export$56c0d5a1e737357d);
}
/**
 * Returns the number of decimal places
 * i.e. the number of digits after the decimal point, of the value of this Number.
 * @param x - A number.
 * @returns The number of decimal places.
 * @private
 */ function $84f61e7391a78632$export$91477dc880baac21(x) {
    if (!$84f61e7391a78632$export$39b482c5e57630a8(x)) return;
    let e = 1;
    let p = 0;
    while(Math.round(x * e) / e !== x){
        e *= 10;
        p++;
    }
    return p;
}
// Gets the angle from vertical upright to the point about a centre.
function $84f61e7391a78632$export$96f57966bedc81b4(centrePoint, anglePoint) {
    const distanceFromXCenter = anglePoint.x - centrePoint.x;
    const distanceFromYCenter = anglePoint.y - centrePoint.y;
    const radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
    let angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);
    if (angle < -0.5 * $84f61e7391a78632$export$56c0d5a1e737357d) angle += $84f61e7391a78632$export$971d5caa766a69d7; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
    return {
        angle: angle,
        distance: radialDistanceFromCenter
    };
}
function $84f61e7391a78632$export$cf2f7c5792f80b46(pt1, pt2) {
    return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
}
/**
 * Shortest distance between angles, in either direction.
 * @private
 */ function $84f61e7391a78632$export$f074adc9fbd50943(a, b) {
    return (a - b + $84f61e7391a78632$export$2ec5befb9e6c97d4) % $84f61e7391a78632$export$971d5caa766a69d7 - $84f61e7391a78632$export$56c0d5a1e737357d;
}
/**
 * Normalize angle to be between 0 and 2*PI
 * @private
 */ function $84f61e7391a78632$export$3d12bd131bb975d1(a) {
    return (a % $84f61e7391a78632$export$971d5caa766a69d7 + $84f61e7391a78632$export$971d5caa766a69d7) % $84f61e7391a78632$export$971d5caa766a69d7;
}
/**
 * @private
 */ function $84f61e7391a78632$export$ffb5f4729a158638(angle, start, end, sameAngleIsFullCircle) {
    const a = $84f61e7391a78632$export$3d12bd131bb975d1(angle);
    const s = $84f61e7391a78632$export$3d12bd131bb975d1(start);
    const e = $84f61e7391a78632$export$3d12bd131bb975d1(end);
    const angleToStart = $84f61e7391a78632$export$3d12bd131bb975d1(s - a);
    const angleToEnd = $84f61e7391a78632$export$3d12bd131bb975d1(e - a);
    const startToAngle = $84f61e7391a78632$export$3d12bd131bb975d1(a - s);
    const endToAngle = $84f61e7391a78632$export$3d12bd131bb975d1(a - e);
    return a === s || a === e || sameAngleIsFullCircle && s === e || angleToStart > angleToEnd && startToAngle < endToAngle;
}
/**
 * Limit `value` between `min` and `max`
 * @param value
 * @param min
 * @param max
 * @private
 */ function $84f61e7391a78632$export$25ce5a424b770e84(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
/**
 * @param {number} value
 * @private
 */ function $84f61e7391a78632$export$71cec2538cb2c617(value) {
    return $84f61e7391a78632$export$25ce5a424b770e84(value, -32768, 32767);
}
/**
 * @param value
 * @param start
 * @param end
 * @param [epsilon]
 * @private
 */ function $84f61e7391a78632$export$21579262ef46735b(value, start, end, epsilon = 1e-6) {
    return value >= Math.min(start, end) - epsilon && value <= Math.max(start, end) + epsilon;
}
function $84f61e7391a78632$export$f96d196f7728bb5(table, value, cmp) {
    cmp = cmp || ((index)=>table[index] < value);
    let hi = table.length - 1;
    let lo = 0;
    let mid;
    while(hi - lo > 1){
        mid = lo + hi >> 1;
        if (cmp(mid)) lo = mid;
        else hi = mid;
    }
    return {
        lo: lo,
        hi: hi
    };
}
/**
 * Binary search
 * @param table - the table search. must be sorted!
 * @param key - property name for the value in each entry
 * @param value - value to find
 * @param last - lookup last index
 * @private
 */ const $84f61e7391a78632$export$ef35774e6d314e91 = (table, key, value, last)=>$84f61e7391a78632$export$f96d196f7728bb5(table, value, last ? (index)=>{
        const ti = table[index][key];
        return ti < value || ti === value && table[index + 1][key] === value;
    } : (index)=>table[index][key] < value);
/**
 * Reverse binary search
 * @param table - the table search. must be sorted!
 * @param key - property name for the value in each entry
 * @param value - value to find
 * @private
 */ const $84f61e7391a78632$export$ebd11618f299a286 = (table, key, value)=>$84f61e7391a78632$export$f96d196f7728bb5(table, value, (index)=>table[index][key] >= value);
/**
 * Return subset of `values` between `min` and `max` inclusive.
 * Values are assumed to be in sorted order.
 * @param values - sorted array of values
 * @param min - min value
 * @param max - max value
 */ function $84f61e7391a78632$export$2ed0fc6709e59212(values, min, max) {
    let start = 0;
    let end = values.length;
    while(start < end && values[start] < min)start++;
    while(end > start && values[end - 1] > max)end--;
    return start > 0 || end < values.length ? values.slice(start, end) : values;
}
const $84f61e7391a78632$var$arrayEvents = [
    'push',
    'pop',
    'shift',
    'splice',
    'unshift'
];
function $84f61e7391a78632$export$882b5998b3b9117c(array, listener) {
    if (array._chartjs) {
        array._chartjs.listeners.push(listener);
        return;
    }
    Object.defineProperty(array, '_chartjs', {
        configurable: true,
        enumerable: false,
        value: {
            listeners: [
                listener
            ]
        }
    });
    $84f61e7391a78632$var$arrayEvents.forEach((key)=>{
        const method = '_onData' + $84f61e7391a78632$export$a8550f7dbe79f93a(key);
        const base = array[key];
        Object.defineProperty(array, key, {
            configurable: true,
            enumerable: false,
            value (...args) {
                const res = base.apply(this, args);
                array._chartjs.listeners.forEach((object)=>{
                    if (typeof object[method] === 'function') object[method](...args);
                });
                return res;
            }
        });
    });
}
function $84f61e7391a78632$export$3b14a55fb2447963(array, listener) {
    const stub = array._chartjs;
    if (!stub) return;
    const listeners = stub.listeners;
    const index = listeners.indexOf(listener);
    if (index !== -1) listeners.splice(index, 1);
    if (listeners.length > 0) return;
    $84f61e7391a78632$var$arrayEvents.forEach((key)=>{
        delete array[key];
    });
    delete array._chartjs;
}
/**
 * @param items
 */ function $84f61e7391a78632$export$71511d61b312f219(items) {
    const set = new Set(items);
    if (set.size === items.length) return items;
    return Array.from(set);
}
function $84f61e7391a78632$export$8c78c7c36408ea29(pixelSize, fontStyle, fontFamily) {
    return fontStyle + ' ' + pixelSize + 'px ' + fontFamily;
}
/**
* Request animation polyfill
*/ const $84f61e7391a78632$export$43caf9889c228507 = function() {
    if (typeof window === 'undefined') return function(callback) {
        return callback();
    };
    return window.requestAnimationFrame;
}();
/**
 * Throttles calling `fn` once per animation frame
 * Latest arguments are used on the actual call
 */ function $84f61e7391a78632$export$61196ced6d74a310(fn, thisArg) {
    let argsToUse = [];
    let ticking = false;
    return function(...args) {
        // Save the args for use later
        argsToUse = args;
        if (!ticking) {
            ticking = true;
            $84f61e7391a78632$export$43caf9889c228507.call(window, ()=>{
                ticking = false;
                fn.apply(thisArg, argsToUse);
            });
        }
    };
}
/**
 * Debounces calling `fn` for `delay` ms
 */ function $84f61e7391a78632$export$4c3d22f3d993c33f(fn, delay) {
    let timeout;
    return function(...args) {
        if (delay) {
            clearTimeout(timeout);
            timeout = setTimeout(fn, delay, args);
        } else fn.apply(this, args);
        return delay;
    };
}
/**
 * Converts 'start' to 'left', 'end' to 'right' and others to 'center'
 * @private
 */ const $84f61e7391a78632$export$3c2fa207a37baaea = (align)=>align === 'start' ? 'left' : align === 'end' ? 'right' : 'center';
/**
 * Returns `start`, `end` or `(start + end) / 2` depending on `align`. Defaults to `center`
 * @private
 */ const $84f61e7391a78632$export$ce26c07117d59d6a = (align, start, end)=>align === 'start' ? start : align === 'end' ? end : (start + end) / 2;
/**
 * Returns `left`, `right` or `(left + right) / 2` depending on `align`. Defaults to `left`
 * @private
 */ const $84f61e7391a78632$export$890c4ad488842ce7 = (align, left, right, rtl)=>{
    const check = rtl ? 'left' : 'right';
    return align === check ? right : align === 'center' ? (left + right) / 2 : left;
};
/**
 * Return start and count of visible points.
 * @private
 */ function $84f61e7391a78632$export$9e5f44173e64f162(meta, points, animationsDisabled) {
    const pointCount = points.length;
    let start = 0;
    let count = pointCount;
    if (meta._sorted) {
        const { iScale: iScale, vScale: vScale, _parsed: _parsed } = meta;
        const spanGaps = meta.dataset ? meta.dataset.options ? meta.dataset.options.spanGaps : null : null;
        const axis = iScale.axis;
        const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = iScale.getUserBounds();
        if (minDefined) {
            start = Math.min($84f61e7391a78632$export$ef35774e6d314e91(_parsed, axis, min).lo, animationsDisabled ? pointCount : $84f61e7391a78632$export$ef35774e6d314e91(points, axis, iScale.getPixelForValue(min)).lo);
            if (spanGaps) {
                const distanceToDefinedLo = _parsed.slice(0, start + 1).reverse().findIndex((point)=>!$84f61e7391a78632$export$342063e11d6c3cad(point[vScale.axis]));
                start -= Math.max(0, distanceToDefinedLo);
            }
            start = $84f61e7391a78632$export$25ce5a424b770e84(start, 0, pointCount - 1);
        }
        if (maxDefined) {
            let end = Math.max($84f61e7391a78632$export$ef35774e6d314e91(_parsed, iScale.axis, max, true).hi + 1, animationsDisabled ? 0 : $84f61e7391a78632$export$ef35774e6d314e91(points, axis, iScale.getPixelForValue(max), true).hi + 1);
            if (spanGaps) {
                const distanceToDefinedHi = _parsed.slice(end - 1).findIndex((point)=>!$84f61e7391a78632$export$342063e11d6c3cad(point[vScale.axis]));
                end += Math.max(0, distanceToDefinedHi);
            }
            count = $84f61e7391a78632$export$25ce5a424b770e84(end, start, pointCount) - start;
        } else count = pointCount - start;
    }
    return {
        start: start,
        count: count
    };
}
/**
 * Checks if the scale ranges have changed.
 * @param {object} meta - dataset meta.
 * @returns {boolean}
 * @private
 */ function $84f61e7391a78632$export$efccba1c4a2ef57b(meta) {
    const { xScale: xScale, yScale: yScale, _scaleRanges: _scaleRanges } = meta;
    const newRanges = {
        xmin: xScale.min,
        xmax: xScale.max,
        ymin: yScale.min,
        ymax: yScale.max
    };
    if (!_scaleRanges) {
        meta._scaleRanges = newRanges;
        return true;
    }
    const changed = _scaleRanges.xmin !== xScale.min || _scaleRanges.xmax !== xScale.max || _scaleRanges.ymin !== yScale.min || _scaleRanges.ymax !== yScale.max;
    Object.assign(_scaleRanges, newRanges);
    return changed;
}
const $84f61e7391a78632$var$atEdge = (t)=>t === 0 || t === 1;
const $84f61e7391a78632$var$elasticIn = (t, s, p)=>-(Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * $84f61e7391a78632$export$971d5caa766a69d7 / p));
const $84f61e7391a78632$var$elasticOut = (t, s, p)=>Math.pow(2, -10 * t) * Math.sin((t - s) * $84f61e7391a78632$export$971d5caa766a69d7 / p) + 1;
/**
 * Easing functions adapted from Robert Penner's easing equations.
 * @namespace Chart.helpers.easing.effects
 * @see http://www.robertpenner.com/easing/
 */ const $84f61e7391a78632$export$f1e1789686576879 = {
    linear: (t)=>t,
    easeInQuad: (t)=>t * t,
    easeOutQuad: (t)=>-t * (t - 2),
    easeInOutQuad: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t : -0.5 * (--t * (t - 2) - 1),
    easeInCubic: (t)=>t * t * t,
    easeOutCubic: (t)=>(t -= 1) * t * t + 1,
    easeInOutCubic: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t : 0.5 * ((t -= 2) * t * t + 2),
    easeInQuart: (t)=>t * t * t * t,
    easeOutQuart: (t)=>-((t -= 1) * t * t * t - 1),
    easeInOutQuart: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t * t : -0.5 * ((t -= 2) * t * t * t - 2),
    easeInQuint: (t)=>t * t * t * t * t,
    easeOutQuint: (t)=>(t -= 1) * t * t * t * t + 1,
    easeInOutQuint: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t * t * t : 0.5 * ((t -= 2) * t * t * t * t + 2),
    easeInSine: (t)=>-Math.cos(t * $84f61e7391a78632$export$7f8ddf7c7c20b3cd) + 1,
    easeOutSine: (t)=>Math.sin(t * $84f61e7391a78632$export$7f8ddf7c7c20b3cd),
    easeInOutSine: (t)=>-0.5 * (Math.cos($84f61e7391a78632$export$56c0d5a1e737357d * t) - 1),
    easeInExpo: (t)=>t === 0 ? 0 : Math.pow(2, 10 * (t - 1)),
    easeOutExpo: (t)=>t === 1 ? 1 : -Math.pow(2, -10 * t) + 1,
    easeInOutExpo: (t)=>$84f61e7391a78632$var$atEdge(t) ? t : t < 0.5 ? 0.5 * Math.pow(2, 10 * (t * 2 - 1)) : 0.5 * (-Math.pow(2, -10 * (t * 2 - 1)) + 2),
    easeInCirc: (t)=>t >= 1 ? t : -(Math.sqrt(1 - t * t) - 1),
    easeOutCirc: (t)=>Math.sqrt(1 - (t -= 1) * t),
    easeInOutCirc: (t)=>(t /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - t * t) - 1) : 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1),
    easeInElastic: (t)=>$84f61e7391a78632$var$atEdge(t) ? t : $84f61e7391a78632$var$elasticIn(t, 0.075, 0.3),
    easeOutElastic: (t)=>$84f61e7391a78632$var$atEdge(t) ? t : $84f61e7391a78632$var$elasticOut(t, 0.075, 0.3),
    easeInOutElastic (t) {
        const s = 0.1125;
        const p = 0.45;
        return $84f61e7391a78632$var$atEdge(t) ? t : t < 0.5 ? 0.5 * $84f61e7391a78632$var$elasticIn(t * 2, s, p) : 0.5 + 0.5 * $84f61e7391a78632$var$elasticOut(t * 2 - 1, s, p);
    },
    easeInBack (t) {
        const s = 1.70158;
        return t * t * ((s + 1) * t - s);
    },
    easeOutBack (t) {
        const s = 1.70158;
        return (t -= 1) * t * ((s + 1) * t + s) + 1;
    },
    easeInOutBack (t) {
        let s = 1.70158;
        if ((t /= 0.5) < 1) return 0.5 * (t * t * (((s *= 1.525) + 1) * t - s));
        return 0.5 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2);
    },
    easeInBounce: (t)=>1 - $84f61e7391a78632$export$f1e1789686576879.easeOutBounce(1 - t),
    easeOutBounce (t) {
        const m = 7.5625;
        const d = 2.75;
        if (t < 1 / d) return m * t * t;
        if (t < 2 / d) return m * (t -= 1.5 / d) * t + 0.75;
        if (t < 2.5 / d) return m * (t -= 2.25 / d) * t + 0.9375;
        return m * (t -= 2.625 / d) * t + 0.984375;
    },
    easeInOutBounce: (t)=>t < 0.5 ? $84f61e7391a78632$export$f1e1789686576879.easeInBounce(t * 2) * 0.5 : $84f61e7391a78632$export$f1e1789686576879.easeOutBounce(t * 2 - 1) * 0.5 + 0.5
};
function $84f61e7391a78632$export$738ab4df8bf92ae9(value) {
    if (value && typeof value === 'object') {
        const type = value.toString();
        return type === '[object CanvasPattern]' || type === '[object CanvasGradient]';
    }
    return false;
}
function $84f61e7391a78632$export$db3b6bfb95261072(value) {
    return $84f61e7391a78632$export$738ab4df8bf92ae9(value) ? value : new (0, $87e6acd7396d97dc$export$892596cec99bc70e)(value);
}
function $84f61e7391a78632$export$d377dcb2b61d6c4e(value) {
    return $84f61e7391a78632$export$738ab4df8bf92ae9(value) ? value : new (0, $87e6acd7396d97dc$export$892596cec99bc70e)(value).saturate(0.5).darken(0.1).hexString();
}
const $84f61e7391a78632$var$numbers = [
    'x',
    'y',
    'borderWidth',
    'radius',
    'tension'
];
const $84f61e7391a78632$var$colors = [
    'color',
    'borderColor',
    'backgroundColor'
];
function $84f61e7391a78632$var$applyAnimationsDefaults(defaults) {
    defaults.set('animation', {
        delay: undefined,
        duration: 1000,
        easing: 'easeOutQuart',
        fn: undefined,
        from: undefined,
        loop: undefined,
        to: undefined,
        type: undefined
    });
    defaults.describe('animation', {
        _fallback: false,
        _indexable: false,
        _scriptable: (name)=>name !== 'onProgress' && name !== 'onComplete' && name !== 'fn'
    });
    defaults.set('animations', {
        colors: {
            type: 'color',
            properties: $84f61e7391a78632$var$colors
        },
        numbers: {
            type: 'number',
            properties: $84f61e7391a78632$var$numbers
        }
    });
    defaults.describe('animations', {
        _fallback: 'animation'
    });
    defaults.set('transitions', {
        active: {
            animation: {
                duration: 400
            }
        },
        resize: {
            animation: {
                duration: 0
            }
        },
        show: {
            animations: {
                colors: {
                    from: 'transparent'
                },
                visible: {
                    type: 'boolean',
                    duration: 0
                }
            }
        },
        hide: {
            animations: {
                colors: {
                    to: 'transparent'
                },
                visible: {
                    type: 'boolean',
                    easing: 'linear',
                    fn: (v)=>v | 0
                }
            }
        }
    });
}
function $84f61e7391a78632$var$applyLayoutsDefaults(defaults) {
    defaults.set('layout', {
        autoPadding: true,
        padding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        }
    });
}
const $84f61e7391a78632$var$intlCache = new Map();
function $84f61e7391a78632$var$getNumberFormat(locale, options) {
    options = options || {};
    const cacheKey = locale + JSON.stringify(options);
    let formatter = $84f61e7391a78632$var$intlCache.get(cacheKey);
    if (!formatter) {
        formatter = new Intl.NumberFormat(locale, options);
        $84f61e7391a78632$var$intlCache.set(cacheKey, formatter);
    }
    return formatter;
}
function $84f61e7391a78632$export$ae1af26003f05816(num, locale, options) {
    return $84f61e7391a78632$var$getNumberFormat(locale, options).format(num);
}
const $84f61e7391a78632$var$formatters = {
    values (value) {
        return $84f61e7391a78632$export$8b22cf2602fb60ce(value) ? value : '' + value;
    },
    numeric (tickValue, index, ticks) {
        if (tickValue === 0) return '0';
        const locale = this.chart.options.locale;
        let notation;
        let delta = tickValue;
        if (ticks.length > 1) {
            const maxTick = Math.max(Math.abs(ticks[0].value), Math.abs(ticks[ticks.length - 1].value));
            if (maxTick < 1e-4 || maxTick > 1e+15) notation = 'scientific';
            delta = $84f61e7391a78632$var$calculateDelta(tickValue, ticks);
        }
        const logDelta = $84f61e7391a78632$export$faec65b429be379(Math.abs(delta));
        const numDecimal = isNaN(logDelta) ? 1 : Math.max(Math.min(-1 * Math.floor(logDelta), 20), 0);
        const options = {
            notation: notation,
            minimumFractionDigits: numDecimal,
            maximumFractionDigits: numDecimal
        };
        Object.assign(options, this.options.ticks.format);
        return $84f61e7391a78632$export$ae1af26003f05816(tickValue, locale, options);
    },
    logarithmic (tickValue, index, ticks) {
        if (tickValue === 0) return '0';
        const remain = ticks[index].significand || tickValue / Math.pow(10, Math.floor($84f61e7391a78632$export$faec65b429be379(tickValue)));
        if ([
            1,
            2,
            3,
            5,
            10,
            15
        ].includes(remain) || index > 0.8 * ticks.length) return $84f61e7391a78632$var$formatters.numeric.call(this, tickValue, index, ticks);
        return '';
    }
};
function $84f61e7391a78632$var$calculateDelta(tickValue, ticks) {
    let delta = ticks.length > 3 ? ticks[2].value - ticks[1].value : ticks[1].value - ticks[0].value;
    if (Math.abs(delta) >= 1 && tickValue !== Math.floor(tickValue)) delta = tickValue - Math.floor(tickValue);
    return delta;
}
var $84f61e7391a78632$export$9f4f30ee63539e24 = {
    formatters: $84f61e7391a78632$var$formatters
};
function $84f61e7391a78632$var$applyScaleDefaults(defaults) {
    defaults.set('scale', {
        display: true,
        offset: false,
        reverse: false,
        beginAtZero: false,
        bounds: 'ticks',
        clip: true,
        grace: 0,
        grid: {
            display: true,
            lineWidth: 1,
            drawOnChartArea: true,
            drawTicks: true,
            tickLength: 8,
            tickWidth: (_ctx, options)=>options.lineWidth,
            tickColor: (_ctx, options)=>options.color,
            offset: false
        },
        border: {
            display: true,
            dash: [],
            dashOffset: 0.0,
            width: 1
        },
        title: {
            display: false,
            text: '',
            padding: {
                top: 4,
                bottom: 4
            }
        },
        ticks: {
            minRotation: 0,
            maxRotation: 50,
            mirror: false,
            textStrokeWidth: 0,
            textStrokeColor: '',
            padding: 3,
            display: true,
            autoSkip: true,
            autoSkipPadding: 3,
            labelOffset: 0,
            callback: $84f61e7391a78632$export$9f4f30ee63539e24.formatters.values,
            minor: {},
            major: {},
            align: 'center',
            crossAlign: 'near',
            showLabelBackdrop: false,
            backdropColor: 'rgba(255, 255, 255, 0.75)',
            backdropPadding: 2
        }
    });
    defaults.route('scale.ticks', 'color', '', 'color');
    defaults.route('scale.grid', 'color', '', 'borderColor');
    defaults.route('scale.border', 'color', '', 'borderColor');
    defaults.route('scale.title', 'color', '', 'color');
    defaults.describe('scale', {
        _fallback: false,
        _scriptable: (name)=>!name.startsWith('before') && !name.startsWith('after') && name !== 'callback' && name !== 'parser',
        _indexable: (name)=>name !== 'borderDash' && name !== 'tickBorderDash' && name !== 'dash'
    });
    defaults.describe('scales', {
        _fallback: 'scale'
    });
    defaults.describe('scale.ticks', {
        _scriptable: (name)=>name !== 'backdropPadding' && name !== 'callback',
        _indexable: (name)=>name !== 'backdropPadding'
    });
}
const $84f61e7391a78632$export$6559d589eb85fbb6 = Object.create(null);
const $84f61e7391a78632$export$2e2af4578d910ddf = Object.create(null);
function $84f61e7391a78632$var$getScope$1(node, key) {
    if (!key) return node;
    const keys = key.split('.');
    for(let i = 0, n = keys.length; i < n; ++i){
        const k = keys[i];
        node = node[k] || (node[k] = Object.create(null));
    }
    return node;
}
function $84f61e7391a78632$var$set(root, scope, values) {
    if (typeof scope === 'string') return $84f61e7391a78632$export$efca4cbe5dd06740($84f61e7391a78632$var$getScope$1(root, scope), values);
    return $84f61e7391a78632$export$efca4cbe5dd06740($84f61e7391a78632$var$getScope$1(root, ''), scope);
}
class $84f61e7391a78632$var$Defaults {
    constructor(_descriptors, _appliers){
        this.animation = undefined;
        this.backgroundColor = 'rgba(0,0,0,0.1)';
        this.borderColor = 'rgba(0,0,0,0.1)';
        this.color = '#666';
        this.datasets = {};
        this.devicePixelRatio = (context)=>context.chart.platform.getDevicePixelRatio();
        this.elements = {};
        this.events = [
            'mousemove',
            'mouseout',
            'click',
            'touchstart',
            'touchmove'
        ];
        this.font = {
            family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
            size: 12,
            style: 'normal',
            lineHeight: 1.2,
            weight: null
        };
        this.hover = {};
        this.hoverBackgroundColor = (ctx, options)=>$84f61e7391a78632$export$d377dcb2b61d6c4e(options.backgroundColor);
        this.hoverBorderColor = (ctx, options)=>$84f61e7391a78632$export$d377dcb2b61d6c4e(options.borderColor);
        this.hoverColor = (ctx, options)=>$84f61e7391a78632$export$d377dcb2b61d6c4e(options.color);
        this.indexAxis = 'x';
        this.interaction = {
            mode: 'nearest',
            intersect: true,
            includeInvisible: false
        };
        this.maintainAspectRatio = true;
        this.onHover = null;
        this.onClick = null;
        this.parsing = true;
        this.plugins = {};
        this.responsive = true;
        this.scale = undefined;
        this.scales = {};
        this.showLine = true;
        this.drawActiveElementsOnTop = true;
        this.describe(_descriptors);
        this.apply(_appliers);
    }
    set(scope, values) {
        return $84f61e7391a78632$var$set(this, scope, values);
    }
    get(scope) {
        return $84f61e7391a78632$var$getScope$1(this, scope);
    }
    describe(scope, values) {
        return $84f61e7391a78632$var$set($84f61e7391a78632$export$2e2af4578d910ddf, scope, values);
    }
    override(scope, values) {
        return $84f61e7391a78632$var$set($84f61e7391a78632$export$6559d589eb85fbb6, scope, values);
    }
    route(scope, name, targetScope, targetName) {
        const scopeObject = $84f61e7391a78632$var$getScope$1(this, scope);
        const targetScopeObject = $84f61e7391a78632$var$getScope$1(this, targetScope);
        const privateName = '_' + name;
        Object.defineProperties(scopeObject, {
            [privateName]: {
                value: scopeObject[name],
                writable: true
            },
            [name]: {
                enumerable: true,
                get () {
                    const local = this[privateName];
                    const target = targetScopeObject[targetName];
                    if ($84f61e7391a78632$export$23f2a1d2818174ef(local)) return Object.assign({}, target, local);
                    return $84f61e7391a78632$export$90a7f3efeed30595(local, target);
                },
                set (value) {
                    this[privateName] = value;
                }
            }
        });
    }
    apply(appliers) {
        appliers.forEach((apply)=>apply(this));
    }
}
var $84f61e7391a78632$export$4368d992c4eafac0 = /* #__PURE__ */ new $84f61e7391a78632$var$Defaults({
    _scriptable: (name)=>!name.startsWith('on'),
    _indexable: (name)=>name !== 'events',
    hover: {
        _fallback: 'interaction'
    },
    interaction: {
        _scriptable: false,
        _indexable: false
    }
}, [
    $84f61e7391a78632$var$applyAnimationsDefaults,
    $84f61e7391a78632$var$applyLayoutsDefaults,
    $84f61e7391a78632$var$applyScaleDefaults
]);
/**
 * Converts the given font object into a CSS font string.
 * @param font - A font object.
 * @return The CSS font string. See https://developer.mozilla.org/en-US/docs/Web/CSS/font
 * @private
 */ function $84f61e7391a78632$export$e171bab687b50e0(font) {
    if (!font || $84f61e7391a78632$export$342063e11d6c3cad(font.size) || $84f61e7391a78632$export$342063e11d6c3cad(font.family)) return null;
    return (font.style ? font.style + ' ' : '') + (font.weight ? font.weight + ' ' : '') + font.size + 'px ' + font.family;
}
/**
 * @private
 */ function $84f61e7391a78632$export$e7c866399fa523f5(ctx, data, gc, longest, string) {
    let textWidth = data[string];
    if (!textWidth) {
        textWidth = data[string] = ctx.measureText(string).width;
        gc.push(string);
    }
    if (textWidth > longest) longest = textWidth;
    return longest;
}
/**
 * @private
 */ // eslint-disable-next-line complexity
function $84f61e7391a78632$export$c03999cb2f36933f(ctx, font, arrayOfThings, cache) {
    cache = cache || {};
    let data = cache.data = cache.data || {};
    let gc = cache.garbageCollect = cache.garbageCollect || [];
    if (cache.font !== font) {
        data = cache.data = {};
        gc = cache.garbageCollect = [];
        cache.font = font;
    }
    ctx.save();
    ctx.font = font;
    let longest = 0;
    const ilen = arrayOfThings.length;
    let i, j, jlen, thing, nestedThing;
    for(i = 0; i < ilen; i++){
        thing = arrayOfThings[i];
        // Undefined strings and arrays should not be measured
        if (thing !== undefined && thing !== null && !$84f61e7391a78632$export$8b22cf2602fb60ce(thing)) longest = $84f61e7391a78632$export$e7c866399fa523f5(ctx, data, gc, longest, thing);
        else if ($84f61e7391a78632$export$8b22cf2602fb60ce(thing)) // if it is an array lets measure each element
        // to do maybe simplify this function a bit so we can do this more recursively?
        for(j = 0, jlen = thing.length; j < jlen; j++){
            nestedThing = thing[j];
            // Undefined strings and arrays should not be measured
            if (nestedThing !== undefined && nestedThing !== null && !$84f61e7391a78632$export$8b22cf2602fb60ce(nestedThing)) longest = $84f61e7391a78632$export$e7c866399fa523f5(ctx, data, gc, longest, nestedThing);
        }
    }
    ctx.restore();
    const gcLen = gc.length / 2;
    if (gcLen > arrayOfThings.length) {
        for(i = 0; i < gcLen; i++)delete data[gc[i]];
        gc.splice(0, gcLen);
    }
    return longest;
}
/**
 * Returns the aligned pixel value to avoid anti-aliasing blur
 * @param chart - The chart instance.
 * @param pixel - A pixel value.
 * @param width - The width of the element.
 * @returns The aligned pixel value.
 * @private
 */ function $84f61e7391a78632$export$78acf4525d8a74c4(chart, pixel, width) {
    const devicePixelRatio = chart.currentDevicePixelRatio;
    const halfWidth = width !== 0 ? Math.max(width / 2, 0.5) : 0;
    return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
}
/**
 * Clears the entire canvas.
 */ function $84f61e7391a78632$export$c9170ad7d4cd7e57(canvas, ctx) {
    if (!ctx && !canvas) return;
    ctx = ctx || canvas.getContext('2d');
    ctx.save();
    // canvas.width and canvas.height do not consider the canvas transform,
    // while clearRect does
    ctx.resetTransform();
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.restore();
}
function $84f61e7391a78632$export$1fbe638ecf81657e(ctx, options, x, y) {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    $84f61e7391a78632$export$158acd800e1ef08b(ctx, options, x, y, null);
}
// eslint-disable-next-line complexity
function $84f61e7391a78632$export$158acd800e1ef08b(ctx, options, x, y, w) {
    let type, xOffset, yOffset, size, cornerRadius, width, xOffsetW, yOffsetW;
    const style = options.pointStyle;
    const rotation = options.rotation;
    const radius = options.radius;
    let rad = (rotation || 0) * $84f61e7391a78632$export$39c1cc7c062529d4;
    if (style && typeof style === 'object') {
        type = style.toString();
        if (type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]') {
            ctx.save();
            ctx.translate(x, y);
            ctx.rotate(rad);
            ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
            ctx.restore();
            return;
        }
    }
    if (isNaN(radius) || radius <= 0) return;
    ctx.beginPath();
    switch(style){
        // Default includes circle
        default:
            if (w) ctx.ellipse(x, y, w / 2, radius, 0, 0, $84f61e7391a78632$export$971d5caa766a69d7);
            else ctx.arc(x, y, radius, 0, $84f61e7391a78632$export$971d5caa766a69d7);
            ctx.closePath();
            break;
        case 'triangle':
            width = w ? w / 2 : radius;
            ctx.moveTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            rad += $84f61e7391a78632$export$c18d01048907ea92;
            ctx.lineTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            rad += $84f61e7391a78632$export$c18d01048907ea92;
            ctx.lineTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            ctx.closePath();
            break;
        case 'rectRounded':
            // NOTE: the rounded rect implementation changed to use `arc` instead of
            // `quadraticCurveTo` since it generates better results when rect is
            // almost a circle. 0.516 (instead of 0.5) produces results with visually
            // closer proportion to the previous impl and it is inscribed in the
            // circle with `radius`. For more details, see the following PRs:
            // https://github.com/chartjs/Chart.js/issues/5597
            // https://github.com/chartjs/Chart.js/issues/5858
            cornerRadius = radius * 0.516;
            size = radius - cornerRadius;
            xOffset = Math.cos(rad + $84f61e7391a78632$export$7a0bdf7d4a91ea88) * size;
            xOffsetW = Math.cos(rad + $84f61e7391a78632$export$7a0bdf7d4a91ea88) * (w ? w / 2 - cornerRadius : size);
            yOffset = Math.sin(rad + $84f61e7391a78632$export$7a0bdf7d4a91ea88) * size;
            yOffsetW = Math.sin(rad + $84f61e7391a78632$export$7a0bdf7d4a91ea88) * (w ? w / 2 - cornerRadius : size);
            ctx.arc(x - xOffsetW, y - yOffset, cornerRadius, rad - $84f61e7391a78632$export$56c0d5a1e737357d, rad - $84f61e7391a78632$export$7f8ddf7c7c20b3cd);
            ctx.arc(x + yOffsetW, y - xOffset, cornerRadius, rad - $84f61e7391a78632$export$7f8ddf7c7c20b3cd, rad);
            ctx.arc(x + xOffsetW, y + yOffset, cornerRadius, rad, rad + $84f61e7391a78632$export$7f8ddf7c7c20b3cd);
            ctx.arc(x - yOffsetW, y + xOffset, cornerRadius, rad + $84f61e7391a78632$export$7f8ddf7c7c20b3cd, rad + $84f61e7391a78632$export$56c0d5a1e737357d);
            ctx.closePath();
            break;
        case 'rect':
            if (!rotation) {
                size = Math.SQRT1_2 * radius;
                width = w ? w / 2 : size;
                ctx.rect(x - width, y - size, 2 * width, 2 * size);
                break;
            }
            rad += $84f61e7391a78632$export$7a0bdf7d4a91ea88;
        /* falls through */ case 'rectRot':
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            ctx.closePath();
            break;
        case 'crossRot':
            rad += $84f61e7391a78632$export$7a0bdf7d4a91ea88;
        /* falls through */ case 'cross':
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            break;
        case 'star':
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            rad += $84f61e7391a78632$export$7a0bdf7d4a91ea88;
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            break;
        case 'line':
            xOffset = w ? w / 2 : Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            break;
        case 'dash':
            ctx.moveTo(x, y);
            ctx.lineTo(x + Math.cos(rad) * (w ? w / 2 : radius), y + Math.sin(rad) * radius);
            break;
        case false:
            ctx.closePath();
            break;
    }
    ctx.fill();
    if (options.borderWidth > 0) ctx.stroke();
}
/**
 * Returns true if the point is inside the rectangle
 * @param point - The point to test
 * @param area - The rectangle
 * @param margin - allowed margin
 * @private
 */ function $84f61e7391a78632$export$e7094788287c5e9b(point, area, margin) {
    margin = margin || 0.5; // margin - default is to match rounded decimals
    return !area || point && point.x > area.left - margin && point.x < area.right + margin && point.y > area.top - margin && point.y < area.bottom + margin;
}
function $84f61e7391a78632$export$8743009a87fcb00f(ctx, area) {
    ctx.save();
    ctx.beginPath();
    ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
    ctx.clip();
}
function $84f61e7391a78632$export$3d8c2f653ac9d0b9(ctx) {
    ctx.restore();
}
/**
 * @private
 */ function $84f61e7391a78632$export$6554612db691658e(ctx, previous, target, flip, mode) {
    if (!previous) return ctx.lineTo(target.x, target.y);
    if (mode === 'middle') {
        const midpoint = (previous.x + target.x) / 2.0;
        ctx.lineTo(midpoint, previous.y);
        ctx.lineTo(midpoint, target.y);
    } else if (mode === 'after' !== !!flip) ctx.lineTo(previous.x, target.y);
    else ctx.lineTo(target.x, previous.y);
    ctx.lineTo(target.x, target.y);
}
/**
 * @private
 */ function $84f61e7391a78632$export$493d36ec626b6698(ctx, previous, target, flip) {
    if (!previous) return ctx.lineTo(target.x, target.y);
    ctx.bezierCurveTo(flip ? previous.cp1x : previous.cp2x, flip ? previous.cp1y : previous.cp2y, flip ? target.cp2x : target.cp1x, flip ? target.cp2y : target.cp1y, target.x, target.y);
}
function $84f61e7391a78632$var$setRenderOpts(ctx, opts) {
    if (opts.translation) ctx.translate(opts.translation[0], opts.translation[1]);
    if (!$84f61e7391a78632$export$342063e11d6c3cad(opts.rotation)) ctx.rotate(opts.rotation);
    if (opts.color) ctx.fillStyle = opts.color;
    if (opts.textAlign) ctx.textAlign = opts.textAlign;
    if (opts.textBaseline) ctx.textBaseline = opts.textBaseline;
}
function $84f61e7391a78632$var$decorateText(ctx, x, y, line, opts) {
    if (opts.strikethrough || opts.underline) {
        /**
     * Now that IE11 support has been dropped, we can use more
     * of the TextMetrics object. The actual bounding boxes
     * are unflagged in Chrome, Firefox, Edge, and Safari so they
     * can be safely used.
     * See https://developer.mozilla.org/en-US/docs/Web/API/TextMetrics#Browser_compatibility
     */ const metrics = ctx.measureText(line);
        const left = x - metrics.actualBoundingBoxLeft;
        const right = x + metrics.actualBoundingBoxRight;
        const top = y - metrics.actualBoundingBoxAscent;
        const bottom = y + metrics.actualBoundingBoxDescent;
        const yDecoration = opts.strikethrough ? (top + bottom) / 2 : bottom;
        ctx.strokeStyle = ctx.fillStyle;
        ctx.beginPath();
        ctx.lineWidth = opts.decorationWidth || 2;
        ctx.moveTo(left, yDecoration);
        ctx.lineTo(right, yDecoration);
        ctx.stroke();
    }
}
function $84f61e7391a78632$var$drawBackdrop(ctx, opts) {
    const oldColor = ctx.fillStyle;
    ctx.fillStyle = opts.color;
    ctx.fillRect(opts.left, opts.top, opts.width, opts.height);
    ctx.fillStyle = oldColor;
}
/**
 * Render text onto the canvas
 */ function $84f61e7391a78632$export$dc98b0b04f4c7758(ctx, text, x, y, font, opts = {}) {
    const lines = $84f61e7391a78632$export$8b22cf2602fb60ce(text) ? text : [
        text
    ];
    const stroke = opts.strokeWidth > 0 && opts.strokeColor !== '';
    let i, line;
    ctx.save();
    ctx.font = font.string;
    $84f61e7391a78632$var$setRenderOpts(ctx, opts);
    for(i = 0; i < lines.length; ++i){
        line = lines[i];
        if (opts.backdrop) $84f61e7391a78632$var$drawBackdrop(ctx, opts.backdrop);
        if (stroke) {
            if (opts.strokeColor) ctx.strokeStyle = opts.strokeColor;
            if (!$84f61e7391a78632$export$342063e11d6c3cad(opts.strokeWidth)) ctx.lineWidth = opts.strokeWidth;
            ctx.strokeText(line, x, y, opts.maxWidth);
        }
        ctx.fillText(line, x, y, opts.maxWidth);
        $84f61e7391a78632$var$decorateText(ctx, x, y, line, opts);
        y += Number(font.lineHeight);
    }
    ctx.restore();
}
/**
 * Add a path of a rectangle with rounded corners to the current sub-path
 * @param ctx - Context
 * @param rect - Bounding rect
 */ function $84f61e7391a78632$export$d66dc83d8cfc8dd(ctx, rect) {
    const { x: x, y: y, w: w, h: h, radius: radius } = rect;
    // top left arc
    ctx.arc(x + radius.topLeft, y + radius.topLeft, radius.topLeft, 1.5 * $84f61e7391a78632$export$56c0d5a1e737357d, $84f61e7391a78632$export$56c0d5a1e737357d, true);
    // line from top left to bottom left
    ctx.lineTo(x, y + h - radius.bottomLeft);
    // bottom left arc
    ctx.arc(x + radius.bottomLeft, y + h - radius.bottomLeft, radius.bottomLeft, $84f61e7391a78632$export$56c0d5a1e737357d, $84f61e7391a78632$export$7f8ddf7c7c20b3cd, true);
    // line from bottom left to bottom right
    ctx.lineTo(x + w - radius.bottomRight, y + h);
    // bottom right arc
    ctx.arc(x + w - radius.bottomRight, y + h - radius.bottomRight, radius.bottomRight, $84f61e7391a78632$export$7f8ddf7c7c20b3cd, 0, true);
    // line from bottom right to top right
    ctx.lineTo(x + w, y + radius.topRight);
    // top right arc
    ctx.arc(x + w - radius.topRight, y + radius.topRight, radius.topRight, 0, -$84f61e7391a78632$export$7f8ddf7c7c20b3cd, true);
    // line from top right to top left
    ctx.lineTo(x + radius.topLeft, y);
}
const $84f61e7391a78632$var$LINE_HEIGHT = /^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/;
const $84f61e7391a78632$var$FONT_STYLE = /^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/;
/**
 * @alias Chart.helpers.options
 * @namespace
 */ /**
 * Converts the given line height `value` in pixels for a specific font `size`.
 * @param value - The lineHeight to parse (eg. 1.6, '14px', '75%', '1.6em').
 * @param size - The font size (in pixels) used to resolve relative `value`.
 * @returns The effective line height in pixels (size * 1.2 if value is invalid).
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/line-height
 * @since 2.7.0
 */ function $84f61e7391a78632$export$d29e374196577086(value, size) {
    const matches = ('' + value).match($84f61e7391a78632$var$LINE_HEIGHT);
    if (!matches || matches[1] === 'normal') return size * 1.2;
    value = +matches[2];
    switch(matches[3]){
        case 'px':
            return value;
        case '%':
            value /= 100;
            break;
    }
    return size * value;
}
const $84f61e7391a78632$var$numberOrZero = (v)=>+v || 0;
function $84f61e7391a78632$export$ab83b03e4111b1d0(value, props) {
    const ret = {};
    const objProps = $84f61e7391a78632$export$23f2a1d2818174ef(props);
    const keys = objProps ? Object.keys(props) : props;
    const read = $84f61e7391a78632$export$23f2a1d2818174ef(value) ? objProps ? (prop)=>$84f61e7391a78632$export$90a7f3efeed30595(value[prop], value[props[prop]]) : (prop)=>value[prop] : ()=>value;
    for (const prop of keys)ret[prop] = $84f61e7391a78632$var$numberOrZero(read(prop));
    return ret;
}
/**
 * Converts the given value into a TRBL object.
 * @param value - If a number, set the value to all TRBL component,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 *  x / y are shorthands for same value for left/right and top/bottom.
 * @returns The padding values (top, right, bottom, left)
 * @since 3.0.0
 */ function $84f61e7391a78632$export$92108d983e8ee699(value) {
    return $84f61e7391a78632$export$ab83b03e4111b1d0(value, {
        top: 'y',
        right: 'x',
        bottom: 'y',
        left: 'x'
    });
}
/**
 * Converts the given value into a TRBL corners object (similar with css border-radius).
 * @param value - If a number, set the value to all TRBL corner components,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 * @returns The TRBL corner values (topLeft, topRight, bottomLeft, bottomRight)
 * @since 3.0.0
 */ function $84f61e7391a78632$export$9fa96a7d116ea3ce(value) {
    return $84f61e7391a78632$export$ab83b03e4111b1d0(value, [
        'topLeft',
        'topRight',
        'bottomLeft',
        'bottomRight'
    ]);
}
/**
 * Converts the given value into a padding object with pre-computed width/height.
 * @param value - If a number, set the value to all TRBL component,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 *  x / y are shorthands for same value for left/right and top/bottom.
 * @returns The padding values (top, right, bottom, left, width, height)
 * @since 2.7.0
 */ function $84f61e7391a78632$export$a9c23c6ac3fc3eca(value) {
    const obj = $84f61e7391a78632$export$92108d983e8ee699(value);
    obj.width = obj.left + obj.right;
    obj.height = obj.top + obj.bottom;
    return obj;
}
/**
 * Parses font options and returns the font object.
 * @param options - A object that contains font options to be parsed.
 * @param fallback - A object that contains fallback font options.
 * @return The font object.
 * @private
 */ function $84f61e7391a78632$export$34aec0b863436764(options, fallback) {
    options = options || {};
    fallback = fallback || $84f61e7391a78632$export$4368d992c4eafac0.font;
    let size = $84f61e7391a78632$export$90a7f3efeed30595(options.size, fallback.size);
    if (typeof size === 'string') size = parseInt(size, 10);
    let style = $84f61e7391a78632$export$90a7f3efeed30595(options.style, fallback.style);
    if (style && !('' + style).match($84f61e7391a78632$var$FONT_STYLE)) {
        console.warn('Invalid font style specified: "' + style + '"');
        style = undefined;
    }
    const font = {
        family: $84f61e7391a78632$export$90a7f3efeed30595(options.family, fallback.family),
        lineHeight: $84f61e7391a78632$export$d29e374196577086($84f61e7391a78632$export$90a7f3efeed30595(options.lineHeight, fallback.lineHeight), size),
        size: size,
        style: style,
        weight: $84f61e7391a78632$export$90a7f3efeed30595(options.weight, fallback.weight),
        string: ''
    };
    font.string = $84f61e7391a78632$export$e171bab687b50e0(font);
    return font;
}
/**
 * Evaluates the given `inputs` sequentially and returns the first defined value.
 * @param inputs - An array of values, falling back to the last value.
 * @param context - If defined and the current value is a function, the value
 * is called with `context` as first argument and the result becomes the new input.
 * @param index - If defined and the current value is an array, the value
 * at `index` become the new input.
 * @param info - object to return information about resolution in
 * @param info.cacheable - Will be set to `false` if option is not cacheable.
 * @since 2.7.0
 */ function $84f61e7391a78632$export$407448d2b89b1813(inputs, context, index, info) {
    let cacheable = true;
    let i, ilen, value;
    for(i = 0, ilen = inputs.length; i < ilen; ++i){
        value = inputs[i];
        if (value === undefined) continue;
        if (context !== undefined && typeof value === 'function') {
            value = value(context);
            cacheable = false;
        }
        if (index !== undefined && $84f61e7391a78632$export$8b22cf2602fb60ce(value)) {
            value = value[index % value.length];
            cacheable = false;
        }
        if (value !== undefined) {
            if (info && !cacheable) info.cacheable = false;
            return value;
        }
    }
}
/**
 * @param minmax
 * @param grace
 * @param beginAtZero
 * @private
 */ function $84f61e7391a78632$export$db202ddc8be9136(minmax, grace, beginAtZero) {
    const { min: min, max: max } = minmax;
    const change = $84f61e7391a78632$export$7ccc53e8f1e7dfc5(grace, (max - min) / 2);
    const keepZero = (value, add)=>beginAtZero && value === 0 ? 0 : value + add;
    return {
        min: keepZero(min, -Math.abs(change)),
        max: keepZero(max, change)
    };
}
function $84f61e7391a78632$export$35e795649ee09318(parentContext, context) {
    return Object.assign(Object.create(parentContext), context);
}
/**
 * Creates a Proxy for resolving raw values for options.
 * @param scopes - The option scopes to look for values, in resolution order
 * @param prefixes - The prefixes for values, in resolution order.
 * @param rootScopes - The root option scopes
 * @param fallback - Parent scopes fallback
 * @param getTarget - callback for getting the target for changed values
 * @returns Proxy
 * @private
 */ function $84f61e7391a78632$export$a9c996f45e5784d0(scopes, prefixes = [
    ''
], rootScopes, fallback, getTarget = ()=>scopes[0]) {
    const finalRootScopes = rootScopes || scopes;
    if (typeof fallback === 'undefined') fallback = $84f61e7391a78632$var$_resolve('_fallback', scopes);
    const cache = {
        [Symbol.toStringTag]: 'Object',
        _cacheable: true,
        _scopes: scopes,
        _rootScopes: finalRootScopes,
        _fallback: fallback,
        _getTarget: getTarget,
        override: (scope)=>$84f61e7391a78632$export$a9c996f45e5784d0([
                scope,
                ...scopes
            ], prefixes, finalRootScopes, fallback)
    };
    return new Proxy(cache, {
        /**
     * A trap for the delete operator.
     */ deleteProperty (target, prop) {
            delete target[prop]; // remove from cache
            delete target._keys; // remove cached keys
            delete scopes[0][prop]; // remove from top level scope
            return true;
        },
        /**
     * A trap for getting property values.
     */ get (target, prop) {
            return $84f61e7391a78632$var$_cached(target, prop, ()=>$84f61e7391a78632$var$_resolveWithPrefixes(prop, prefixes, scopes, target));
        },
        /**
     * A trap for Object.getOwnPropertyDescriptor.
     * Also used by Object.hasOwnProperty.
     */ getOwnPropertyDescriptor (target, prop) {
            return Reflect.getOwnPropertyDescriptor(target._scopes[0], prop);
        },
        /**
     * A trap for Object.getPrototypeOf.
     */ getPrototypeOf () {
            return Reflect.getPrototypeOf(scopes[0]);
        },
        /**
     * A trap for the in operator.
     */ has (target, prop) {
            return $84f61e7391a78632$var$getKeysFromAllScopes(target).includes(prop);
        },
        /**
     * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
     */ ownKeys (target) {
            return $84f61e7391a78632$var$getKeysFromAllScopes(target);
        },
        /**
     * A trap for setting property values.
     */ set (target, prop, value) {
            const storage = target._storage || (target._storage = getTarget());
            target[prop] = storage[prop] = value; // set to top level scope + cache
            delete target._keys; // remove cached keys
            return true;
        }
    });
}
/**
 * Returns an Proxy for resolving option values with context.
 * @param proxy - The Proxy returned by `_createResolver`
 * @param context - Context object for scriptable/indexable options
 * @param subProxy - The proxy provided for scriptable options
 * @param descriptorDefaults - Defaults for descriptors
 * @private
 */ function $84f61e7391a78632$export$c3950d9923825c02(proxy, context, subProxy, descriptorDefaults) {
    const cache = {
        _cacheable: false,
        _proxy: proxy,
        _context: context,
        _subProxy: subProxy,
        _stack: new Set(),
        _descriptors: $84f61e7391a78632$export$7910e0436ed8d1de(proxy, descriptorDefaults),
        setContext: (ctx)=>$84f61e7391a78632$export$c3950d9923825c02(proxy, ctx, subProxy, descriptorDefaults),
        override: (scope)=>$84f61e7391a78632$export$c3950d9923825c02(proxy.override(scope), context, subProxy, descriptorDefaults)
    };
    return new Proxy(cache, {
        /**
     * A trap for the delete operator.
     */ deleteProperty (target, prop) {
            delete target[prop]; // remove from cache
            delete proxy[prop]; // remove from proxy
            return true;
        },
        /**
     * A trap for getting property values.
     */ get (target, prop, receiver) {
            return $84f61e7391a78632$var$_cached(target, prop, ()=>$84f61e7391a78632$var$_resolveWithContext(target, prop, receiver));
        },
        /**
     * A trap for Object.getOwnPropertyDescriptor.
     * Also used by Object.hasOwnProperty.
     */ getOwnPropertyDescriptor (target, prop) {
            return target._descriptors.allKeys ? Reflect.has(proxy, prop) ? {
                enumerable: true,
                configurable: true
            } : undefined : Reflect.getOwnPropertyDescriptor(proxy, prop);
        },
        /**
     * A trap for Object.getPrototypeOf.
     */ getPrototypeOf () {
            return Reflect.getPrototypeOf(proxy);
        },
        /**
     * A trap for the in operator.
     */ has (target, prop) {
            return Reflect.has(proxy, prop);
        },
        /**
     * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
     */ ownKeys () {
            return Reflect.ownKeys(proxy);
        },
        /**
     * A trap for setting property values.
     */ set (target, prop, value) {
            proxy[prop] = value; // set to proxy
            delete target[prop]; // remove from cache
            return true;
        }
    });
}
/**
 * @private
 */ function $84f61e7391a78632$export$7910e0436ed8d1de(proxy, defaults = {
    scriptable: true,
    indexable: true
}) {
    const { _scriptable: _scriptable = defaults.scriptable, _indexable: _indexable = defaults.indexable, _allKeys: _allKeys = defaults.allKeys } = proxy;
    return {
        allKeys: _allKeys,
        scriptable: _scriptable,
        indexable: _indexable,
        isScriptable: $84f61e7391a78632$export$a93c5207d687da10(_scriptable) ? _scriptable : ()=>_scriptable,
        isIndexable: $84f61e7391a78632$export$a93c5207d687da10(_indexable) ? _indexable : ()=>_indexable
    };
}
const $84f61e7391a78632$var$readKey = (prefix, name)=>prefix ? prefix + $84f61e7391a78632$export$a8550f7dbe79f93a(name) : name;
const $84f61e7391a78632$var$needsSubResolver = (prop, value)=>$84f61e7391a78632$export$23f2a1d2818174ef(value) && prop !== 'adapters' && (Object.getPrototypeOf(value) === null || value.constructor === Object);
function $84f61e7391a78632$var$_cached(target, prop, resolve) {
    if (Object.prototype.hasOwnProperty.call(target, prop) || prop === 'constructor') return target[prop];
    const value = resolve();
    // cache the resolved value
    target[prop] = value;
    return value;
}
function $84f61e7391a78632$var$_resolveWithContext(target, prop, receiver) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _descriptors: descriptors } = target;
    let value = _proxy[prop]; // resolve from proxy
    // resolve with context
    if ($84f61e7391a78632$export$a93c5207d687da10(value) && descriptors.isScriptable(prop)) value = $84f61e7391a78632$var$_resolveScriptable(prop, value, target, receiver);
    if ($84f61e7391a78632$export$8b22cf2602fb60ce(value) && value.length) value = $84f61e7391a78632$var$_resolveArray(prop, value, target, descriptors.isIndexable);
    if ($84f61e7391a78632$var$needsSubResolver(prop, value)) // if the resolved value is an object, create a sub resolver for it
    value = $84f61e7391a78632$export$c3950d9923825c02(value, _context, _subProxy && _subProxy[prop], descriptors);
    return value;
}
function $84f61e7391a78632$var$_resolveScriptable(prop, getValue, target, receiver) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _stack: _stack } = target;
    if (_stack.has(prop)) throw new Error('Recursion detected: ' + Array.from(_stack).join('->') + '->' + prop);
    _stack.add(prop);
    let value = getValue(_context, _subProxy || receiver);
    _stack.delete(prop);
    if ($84f61e7391a78632$var$needsSubResolver(prop, value)) // When scriptable option returns an object, create a resolver on that.
    value = $84f61e7391a78632$var$createSubResolver(_proxy._scopes, _proxy, prop, value);
    return value;
}
function $84f61e7391a78632$var$_resolveArray(prop, value, target, isIndexable) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _descriptors: descriptors } = target;
    if (typeof _context.index !== 'undefined' && isIndexable(prop)) return value[_context.index % value.length];
    else if ($84f61e7391a78632$export$23f2a1d2818174ef(value[0])) {
        // Array of objects, return array or resolvers
        const arr = value;
        const scopes = _proxy._scopes.filter((s)=>s !== arr);
        value = [];
        for (const item of arr){
            const resolver = $84f61e7391a78632$var$createSubResolver(scopes, _proxy, prop, item);
            value.push($84f61e7391a78632$export$c3950d9923825c02(resolver, _context, _subProxy && _subProxy[prop], descriptors));
        }
    }
    return value;
}
function $84f61e7391a78632$var$resolveFallback(fallback, prop, value) {
    return $84f61e7391a78632$export$a93c5207d687da10(fallback) ? fallback(prop, value) : fallback;
}
const $84f61e7391a78632$var$getScope = (key, parent)=>key === true ? parent : typeof key === 'string' ? $84f61e7391a78632$export$2d1720544b23b823(parent, key) : undefined;
function $84f61e7391a78632$var$addScopes(set, parentScopes, key, parentFallback, value) {
    for (const parent of parentScopes){
        const scope = $84f61e7391a78632$var$getScope(key, parent);
        if (scope) {
            set.add(scope);
            const fallback = $84f61e7391a78632$var$resolveFallback(scope._fallback, key, value);
            if (typeof fallback !== 'undefined' && fallback !== key && fallback !== parentFallback) // When we reach the descriptor that defines a new _fallback, return that.
            // The fallback will resume to that new scope.
            return fallback;
        } else if (scope === false && typeof parentFallback !== 'undefined' && key !== parentFallback) // Fallback to `false` results to `false`, when falling back to different key.
        // For example `interaction` from `hover` or `plugins.tooltip` and `animation` from `animations`
        return null;
    }
    return false;
}
function $84f61e7391a78632$var$createSubResolver(parentScopes, resolver, prop, value) {
    const rootScopes = resolver._rootScopes;
    const fallback = $84f61e7391a78632$var$resolveFallback(resolver._fallback, prop, value);
    const allScopes = [
        ...parentScopes,
        ...rootScopes
    ];
    const set = new Set();
    set.add(value);
    let key = $84f61e7391a78632$var$addScopesFromKey(set, allScopes, prop, fallback || prop, value);
    if (key === null) return false;
    if (typeof fallback !== 'undefined' && fallback !== prop) {
        key = $84f61e7391a78632$var$addScopesFromKey(set, allScopes, fallback, key, value);
        if (key === null) return false;
    }
    return $84f61e7391a78632$export$a9c996f45e5784d0(Array.from(set), [
        ''
    ], rootScopes, fallback, ()=>$84f61e7391a78632$var$subGetTarget(resolver, prop, value));
}
function $84f61e7391a78632$var$addScopesFromKey(set, allScopes, key, fallback, item) {
    while(key)key = $84f61e7391a78632$var$addScopes(set, allScopes, key, fallback, item);
    return key;
}
function $84f61e7391a78632$var$subGetTarget(resolver, prop, value) {
    const parent = resolver._getTarget();
    if (!(prop in parent)) parent[prop] = {};
    const target = parent[prop];
    if ($84f61e7391a78632$export$8b22cf2602fb60ce(target) && $84f61e7391a78632$export$23f2a1d2818174ef(value)) // For array of objects, the object is used to store updated values
    return value;
    return target || {};
}
function $84f61e7391a78632$var$_resolveWithPrefixes(prop, prefixes, scopes, proxy) {
    let value;
    for (const prefix of prefixes){
        value = $84f61e7391a78632$var$_resolve($84f61e7391a78632$var$readKey(prefix, prop), scopes);
        if (typeof value !== 'undefined') return $84f61e7391a78632$var$needsSubResolver(prop, value) ? $84f61e7391a78632$var$createSubResolver(scopes, proxy, prop, value) : value;
    }
}
function $84f61e7391a78632$var$_resolve(key, scopes) {
    for (const scope of scopes){
        if (!scope) continue;
        const value = scope[key];
        if (typeof value !== 'undefined') return value;
    }
}
function $84f61e7391a78632$var$getKeysFromAllScopes(target) {
    let keys = target._keys;
    if (!keys) keys = target._keys = $84f61e7391a78632$var$resolveKeysFromAllScopes(target._scopes);
    return keys;
}
function $84f61e7391a78632$var$resolveKeysFromAllScopes(scopes) {
    const set = new Set();
    for (const scope of scopes)for (const key of Object.keys(scope).filter((k)=>!k.startsWith('_')))set.add(key);
    return Array.from(set);
}
function $84f61e7391a78632$export$4a5767248b18ef41(meta, data, start, count) {
    const { iScale: iScale } = meta;
    const { key: key = 'r' } = this._parsing;
    const parsed = new Array(count);
    let i, ilen, index, item;
    for(i = 0, ilen = count; i < ilen; ++i){
        index = i + start;
        item = data[index];
        parsed[i] = {
            r: iScale.parse($84f61e7391a78632$export$2d1720544b23b823(item, key), index)
        };
    }
    return parsed;
}
const $84f61e7391a78632$var$EPSILON = Number.EPSILON || 1e-14;
const $84f61e7391a78632$var$getPoint = (points, i)=>i < points.length && !points[i].skip && points[i];
const $84f61e7391a78632$var$getValueAxis = (indexAxis)=>indexAxis === 'x' ? 'y' : 'x';
function $84f61e7391a78632$export$527e9aa3390079e9(firstPoint, middlePoint, afterPoint, t) {
    // Props to Rob Spencer at scaled innovation for his post on splining between points
    // http://scaledinnovation.com/analytics/splines/aboutSplines.html
    // This function must also respect "skipped" points
    const previous = firstPoint.skip ? middlePoint : firstPoint;
    const current = middlePoint;
    const next = afterPoint.skip ? middlePoint : afterPoint;
    const d01 = $84f61e7391a78632$export$cf2f7c5792f80b46(current, previous);
    const d12 = $84f61e7391a78632$export$cf2f7c5792f80b46(next, current);
    let s01 = d01 / (d01 + d12);
    let s12 = d12 / (d01 + d12);
    // If all points are the same, s01 & s02 will be inf
    s01 = isNaN(s01) ? 0 : s01;
    s12 = isNaN(s12) ? 0 : s12;
    const fa = t * s01; // scaling factor for triangle Ta
    const fb = t * s12;
    return {
        previous: {
            x: current.x - fa * (next.x - previous.x),
            y: current.y - fa * (next.y - previous.y)
        },
        next: {
            x: current.x + fb * (next.x - previous.x),
            y: current.y + fb * (next.y - previous.y)
        }
    };
}
/**
 * Adjust tangents to ensure monotonic properties
 */ function $84f61e7391a78632$var$monotoneAdjust(points, deltaK, mK) {
    const pointsLen = points.length;
    let alphaK, betaK, tauK, squaredMagnitude, pointCurrent;
    let pointAfter = $84f61e7391a78632$var$getPoint(points, 0);
    for(let i = 0; i < pointsLen - 1; ++i){
        pointCurrent = pointAfter;
        pointAfter = $84f61e7391a78632$var$getPoint(points, i + 1);
        if (!pointCurrent || !pointAfter) continue;
        if ($84f61e7391a78632$export$23ebac1979863676(deltaK[i], 0, $84f61e7391a78632$var$EPSILON)) {
            mK[i] = mK[i + 1] = 0;
            continue;
        }
        alphaK = mK[i] / deltaK[i];
        betaK = mK[i + 1] / deltaK[i];
        squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
        if (squaredMagnitude <= 9) continue;
        tauK = 3 / Math.sqrt(squaredMagnitude);
        mK[i] = alphaK * tauK * deltaK[i];
        mK[i + 1] = betaK * tauK * deltaK[i];
    }
}
function $84f61e7391a78632$var$monotoneCompute(points, mK, indexAxis = 'x') {
    const valueAxis = $84f61e7391a78632$var$getValueAxis(indexAxis);
    const pointsLen = points.length;
    let delta, pointBefore, pointCurrent;
    let pointAfter = $84f61e7391a78632$var$getPoint(points, 0);
    for(let i = 0; i < pointsLen; ++i){
        pointBefore = pointCurrent;
        pointCurrent = pointAfter;
        pointAfter = $84f61e7391a78632$var$getPoint(points, i + 1);
        if (!pointCurrent) continue;
        const iPixel = pointCurrent[indexAxis];
        const vPixel = pointCurrent[valueAxis];
        if (pointBefore) {
            delta = (iPixel - pointBefore[indexAxis]) / 3;
            pointCurrent[`cp1${indexAxis}`] = iPixel - delta;
            pointCurrent[`cp1${valueAxis}`] = vPixel - delta * mK[i];
        }
        if (pointAfter) {
            delta = (pointAfter[indexAxis] - iPixel) / 3;
            pointCurrent[`cp2${indexAxis}`] = iPixel + delta;
            pointCurrent[`cp2${valueAxis}`] = vPixel + delta * mK[i];
        }
    }
}
/**
 * This function calculates Bézier control points in a similar way than |splineCurve|,
 * but preserves monotonicity of the provided data and ensures no local extremums are added
 * between the dataset discrete points due to the interpolation.
 * See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation
 */ function $84f61e7391a78632$export$a17c37559e1db147(points, indexAxis = 'x') {
    const valueAxis = $84f61e7391a78632$var$getValueAxis(indexAxis);
    const pointsLen = points.length;
    const deltaK = Array(pointsLen).fill(0);
    const mK = Array(pointsLen);
    // Calculate slopes (deltaK) and initialize tangents (mK)
    let i, pointBefore, pointCurrent;
    let pointAfter = $84f61e7391a78632$var$getPoint(points, 0);
    for(i = 0; i < pointsLen; ++i){
        pointBefore = pointCurrent;
        pointCurrent = pointAfter;
        pointAfter = $84f61e7391a78632$var$getPoint(points, i + 1);
        if (!pointCurrent) continue;
        if (pointAfter) {
            const slopeDelta = pointAfter[indexAxis] - pointCurrent[indexAxis];
            // In the case of two points that appear at the same x pixel, slopeDeltaX is 0
            deltaK[i] = slopeDelta !== 0 ? (pointAfter[valueAxis] - pointCurrent[valueAxis]) / slopeDelta : 0;
        }
        mK[i] = !pointBefore ? deltaK[i] : !pointAfter ? deltaK[i - 1] : $84f61e7391a78632$export$2408f22a0fab9ae5(deltaK[i - 1]) !== $84f61e7391a78632$export$2408f22a0fab9ae5(deltaK[i]) ? 0 : (deltaK[i - 1] + deltaK[i]) / 2;
    }
    $84f61e7391a78632$var$monotoneAdjust(points, deltaK, mK);
    $84f61e7391a78632$var$monotoneCompute(points, mK, indexAxis);
}
function $84f61e7391a78632$var$capControlPoint(pt, min, max) {
    return Math.max(Math.min(pt, max), min);
}
function $84f61e7391a78632$var$capBezierPoints(points, area) {
    let i, ilen, point, inArea, inAreaPrev;
    let inAreaNext = $84f61e7391a78632$export$e7094788287c5e9b(points[0], area);
    for(i = 0, ilen = points.length; i < ilen; ++i){
        inAreaPrev = inArea;
        inArea = inAreaNext;
        inAreaNext = i < ilen - 1 && $84f61e7391a78632$export$e7094788287c5e9b(points[i + 1], area);
        if (!inArea) continue;
        point = points[i];
        if (inAreaPrev) {
            point.cp1x = $84f61e7391a78632$var$capControlPoint(point.cp1x, area.left, area.right);
            point.cp1y = $84f61e7391a78632$var$capControlPoint(point.cp1y, area.top, area.bottom);
        }
        if (inAreaNext) {
            point.cp2x = $84f61e7391a78632$var$capControlPoint(point.cp2x, area.left, area.right);
            point.cp2y = $84f61e7391a78632$var$capControlPoint(point.cp2y, area.top, area.bottom);
        }
    }
}
/**
 * @private
 */ function $84f61e7391a78632$export$1a82df3d29112e01(points, options, area, loop, indexAxis) {
    let i, ilen, point, controlPoints;
    // Only consider points that are drawn in case the spanGaps option is used
    if (options.spanGaps) points = points.filter((pt)=>!pt.skip);
    if (options.cubicInterpolationMode === 'monotone') $84f61e7391a78632$export$a17c37559e1db147(points, indexAxis);
    else {
        let prev = loop ? points[points.length - 1] : points[0];
        for(i = 0, ilen = points.length; i < ilen; ++i){
            point = points[i];
            controlPoints = $84f61e7391a78632$export$527e9aa3390079e9(prev, point, points[Math.min(i + 1, ilen - (loop ? 0 : 1)) % ilen], options.tension);
            point.cp1x = controlPoints.previous.x;
            point.cp1y = controlPoints.previous.y;
            point.cp2x = controlPoints.next.x;
            point.cp2y = controlPoints.next.y;
            prev = point;
        }
    }
    if (options.capBezierPoints) $84f61e7391a78632$var$capBezierPoints(points, area);
}
/**
 * @private
 */ function $84f61e7391a78632$export$3a1a48c8f6ef640e() {
    return typeof window !== 'undefined' && typeof document !== 'undefined';
}
/**
 * @private
 */ function $84f61e7391a78632$export$9bb611d729802a56(domNode) {
    let parent = domNode.parentNode;
    if (parent && parent.toString() === '[object ShadowRoot]') parent = parent.host;
    return parent;
}
/**
 * convert max-width/max-height values that may be percentages into a number
 * @private
 */ function $84f61e7391a78632$var$parseMaxStyle(styleValue, node, parentProperty) {
    let valueInPixels;
    if (typeof styleValue === 'string') {
        valueInPixels = parseInt(styleValue, 10);
        if (styleValue.indexOf('%') !== -1) // percentage * size in dimension
        valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
    } else valueInPixels = styleValue;
    return valueInPixels;
}
const $84f61e7391a78632$var$getComputedStyle = (element)=>element.ownerDocument.defaultView.getComputedStyle(element, null);
function $84f61e7391a78632$export$fef3dfd9bad05307(el, property) {
    return $84f61e7391a78632$var$getComputedStyle(el).getPropertyValue(property);
}
const $84f61e7391a78632$var$positions = [
    'top',
    'right',
    'bottom',
    'left'
];
function $84f61e7391a78632$var$getPositionedStyle(styles, style, suffix) {
    const result = {};
    suffix = suffix ? '-' + suffix : '';
    for(let i = 0; i < 4; i++){
        const pos = $84f61e7391a78632$var$positions[i];
        result[pos] = parseFloat(styles[style + '-' + pos + suffix]) || 0;
    }
    result.width = result.left + result.right;
    result.height = result.top + result.bottom;
    return result;
}
const $84f61e7391a78632$var$useOffsetPos = (x, y, target)=>(x > 0 || y > 0) && (!target || !target.shadowRoot);
/**
 * @param e
 * @param canvas
 * @returns Canvas position
 */ function $84f61e7391a78632$var$getCanvasPosition(e, canvas) {
    const touches = e.touches;
    const source = touches && touches.length ? touches[0] : e;
    const { offsetX: offsetX, offsetY: offsetY } = source;
    let box = false;
    let x, y;
    if ($84f61e7391a78632$var$useOffsetPos(offsetX, offsetY, e.target)) {
        x = offsetX;
        y = offsetY;
    } else {
        const rect = canvas.getBoundingClientRect();
        x = source.clientX - rect.left;
        y = source.clientY - rect.top;
        box = true;
    }
    return {
        x: x,
        y: y,
        box: box
    };
}
/**
 * Gets an event's x, y coordinates, relative to the chart area
 * @param event
 * @param chart
 * @returns x and y coordinates of the event
 */ function $84f61e7391a78632$export$df995fae86a55f06(event, chart) {
    if ('native' in event) return event;
    const { canvas: canvas, currentDevicePixelRatio: currentDevicePixelRatio } = chart;
    const style = $84f61e7391a78632$var$getComputedStyle(canvas);
    const borderBox = style.boxSizing === 'border-box';
    const paddings = $84f61e7391a78632$var$getPositionedStyle(style, 'padding');
    const borders = $84f61e7391a78632$var$getPositionedStyle(style, 'border', 'width');
    const { x: x, y: y, box: box } = $84f61e7391a78632$var$getCanvasPosition(event, canvas);
    const xOffset = paddings.left + (box && borders.left);
    const yOffset = paddings.top + (box && borders.top);
    let { width: width, height: height } = chart;
    if (borderBox) {
        width -= paddings.width + borders.width;
        height -= paddings.height + borders.height;
    }
    return {
        x: Math.round((x - xOffset) / width * canvas.width / currentDevicePixelRatio),
        y: Math.round((y - yOffset) / height * canvas.height / currentDevicePixelRatio)
    };
}
function $84f61e7391a78632$var$getContainerSize(canvas, width, height) {
    let maxWidth, maxHeight;
    if (width === undefined || height === undefined) {
        const container = canvas && $84f61e7391a78632$export$9bb611d729802a56(canvas);
        if (!container) {
            width = canvas.clientWidth;
            height = canvas.clientHeight;
        } else {
            const rect = container.getBoundingClientRect(); // this is the border box of the container
            const containerStyle = $84f61e7391a78632$var$getComputedStyle(container);
            const containerBorder = $84f61e7391a78632$var$getPositionedStyle(containerStyle, 'border', 'width');
            const containerPadding = $84f61e7391a78632$var$getPositionedStyle(containerStyle, 'padding');
            width = rect.width - containerPadding.width - containerBorder.width;
            height = rect.height - containerPadding.height - containerBorder.height;
            maxWidth = $84f61e7391a78632$var$parseMaxStyle(containerStyle.maxWidth, container, 'clientWidth');
            maxHeight = $84f61e7391a78632$var$parseMaxStyle(containerStyle.maxHeight, container, 'clientHeight');
        }
    }
    return {
        width: width,
        height: height,
        maxWidth: maxWidth || $84f61e7391a78632$export$53c86fa97d611818,
        maxHeight: maxHeight || $84f61e7391a78632$export$53c86fa97d611818
    };
}
const $84f61e7391a78632$var$round1 = (v)=>Math.round(v * 10) / 10;
// eslint-disable-next-line complexity
function $84f61e7391a78632$export$2329c99376c9d0a4(canvas, bbWidth, bbHeight, aspectRatio) {
    const style = $84f61e7391a78632$var$getComputedStyle(canvas);
    const margins = $84f61e7391a78632$var$getPositionedStyle(style, 'margin');
    const maxWidth = $84f61e7391a78632$var$parseMaxStyle(style.maxWidth, canvas, 'clientWidth') || $84f61e7391a78632$export$53c86fa97d611818;
    const maxHeight = $84f61e7391a78632$var$parseMaxStyle(style.maxHeight, canvas, 'clientHeight') || $84f61e7391a78632$export$53c86fa97d611818;
    const containerSize = $84f61e7391a78632$var$getContainerSize(canvas, bbWidth, bbHeight);
    let { width: width, height: height } = containerSize;
    if (style.boxSizing === 'content-box') {
        const borders = $84f61e7391a78632$var$getPositionedStyle(style, 'border', 'width');
        const paddings = $84f61e7391a78632$var$getPositionedStyle(style, 'padding');
        width -= paddings.width + borders.width;
        height -= paddings.height + borders.height;
    }
    width = Math.max(0, width - margins.width);
    height = Math.max(0, aspectRatio ? width / aspectRatio : height - margins.height);
    width = $84f61e7391a78632$var$round1(Math.min(width, maxWidth, containerSize.maxWidth));
    height = $84f61e7391a78632$var$round1(Math.min(height, maxHeight, containerSize.maxHeight));
    if (width && !height) // https://github.com/chartjs/Chart.js/issues/4659
    // If the canvas has width, but no height, default to aspectRatio of 2 (canvas default)
    height = $84f61e7391a78632$var$round1(width / 2);
    const maintainHeight = bbWidth !== undefined || bbHeight !== undefined;
    if (maintainHeight && aspectRatio && containerSize.height && height > containerSize.height) {
        height = containerSize.height;
        width = $84f61e7391a78632$var$round1(Math.floor(height * aspectRatio));
    }
    return {
        width: width,
        height: height
    };
}
/**
 * @param chart
 * @param forceRatio
 * @param forceStyle
 * @returns True if the canvas context size or transformation has changed.
 */ function $84f61e7391a78632$export$f787f51d84a910ad(chart, forceRatio, forceStyle) {
    const pixelRatio = forceRatio || 1;
    const deviceHeight = Math.floor(chart.height * pixelRatio);
    const deviceWidth = Math.floor(chart.width * pixelRatio);
    chart.height = Math.floor(chart.height);
    chart.width = Math.floor(chart.width);
    const canvas = chart.canvas;
    // If no style has been set on the canvas, the render size is used as display size,
    // making the chart visually bigger, so let's enforce it to the "correct" values.
    // See https://github.com/chartjs/Chart.js/issues/3575
    if (canvas.style && (forceStyle || !canvas.style.height && !canvas.style.width)) {
        canvas.style.height = `${chart.height}px`;
        canvas.style.width = `${chart.width}px`;
    }
    if (chart.currentDevicePixelRatio !== pixelRatio || canvas.height !== deviceHeight || canvas.width !== deviceWidth) {
        chart.currentDevicePixelRatio = pixelRatio;
        canvas.height = deviceHeight;
        canvas.width = deviceWidth;
        chart.ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        return true;
    }
    return false;
}
/**
 * Detects support for options object argument in addEventListener.
 * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
 * @private
 */ const $84f61e7391a78632$export$3466f893ebf79586 = function() {
    let passiveSupported = false;
    try {
        const options = {
            get passive () {
                passiveSupported = true;
                return false;
            }
        };
        if ($84f61e7391a78632$export$3a1a48c8f6ef640e()) {
            window.addEventListener('test', null, options);
            window.removeEventListener('test', null, options);
        }
    } catch (e) {
    // continue regardless of error
    }
    return passiveSupported;
}();
/**
 * The "used" size is the final value of a dimension property after all calculations have
 * been performed. This method uses the computed style of `element` but returns undefined
 * if the computed style is not expressed in pixels. That can happen in some cases where
 * `element` has a size relative to its parent and this last one is not yet displayed,
 * for example because of `display: none` on a parent node.
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
 * @returns Size in pixels or undefined if unknown.
 */ function $84f61e7391a78632$export$b4171a6734a65d42(element, property) {
    const value = $84f61e7391a78632$export$fef3dfd9bad05307(element, property);
    const matches = value && value.match(/^(\d+)(\.\d+)?px$/);
    return matches ? +matches[1] : undefined;
}
/**
 * @private
 */ function $84f61e7391a78632$export$d24c54395ce0c509(p1, p2, t, mode) {
    return {
        x: p1.x + t * (p2.x - p1.x),
        y: p1.y + t * (p2.y - p1.y)
    };
}
/**
 * @private
 */ function $84f61e7391a78632$export$2f6ca3d3b1f80bf5(p1, p2, t, mode) {
    return {
        x: p1.x + t * (p2.x - p1.x),
        y: mode === 'middle' ? t < 0.5 ? p1.y : p2.y : mode === 'after' ? t < 1 ? p1.y : p2.y : t > 0 ? p2.y : p1.y
    };
}
/**
 * @private
 */ function $84f61e7391a78632$export$8a5498727ef6be21(p1, p2, t, mode) {
    const cp1 = {
        x: p1.cp2x,
        y: p1.cp2y
    };
    const cp2 = {
        x: p2.cp1x,
        y: p2.cp1y
    };
    const a = $84f61e7391a78632$export$d24c54395ce0c509(p1, cp1, t);
    const b = $84f61e7391a78632$export$d24c54395ce0c509(cp1, cp2, t);
    const c = $84f61e7391a78632$export$d24c54395ce0c509(cp2, p2, t);
    const d = $84f61e7391a78632$export$d24c54395ce0c509(a, b, t);
    const e = $84f61e7391a78632$export$d24c54395ce0c509(b, c, t);
    return $84f61e7391a78632$export$d24c54395ce0c509(d, e, t);
}
const $84f61e7391a78632$var$getRightToLeftAdapter = function(rectX, width) {
    return {
        x (x) {
            return rectX + rectX + width - x;
        },
        setWidth (w) {
            width = w;
        },
        textAlign (align) {
            if (align === 'center') return align;
            return align === 'right' ? 'left' : 'right';
        },
        xPlus (x, value) {
            return x - value;
        },
        leftForLtr (x, itemWidth) {
            return x - itemWidth;
        }
    };
};
const $84f61e7391a78632$var$getLeftToRightAdapter = function() {
    return {
        x (x) {
            return x;
        },
        setWidth (w) {},
        textAlign (align) {
            return align;
        },
        xPlus (x, value) {
            return x + value;
        },
        leftForLtr (x, _itemWidth) {
            return x;
        }
    };
};
function $84f61e7391a78632$export$91c6e00c14e7e6fd(rtl, rectX, width) {
    return rtl ? $84f61e7391a78632$var$getRightToLeftAdapter(rectX, width) : $84f61e7391a78632$var$getLeftToRightAdapter();
}
function $84f61e7391a78632$export$9d398bebfec1c039(ctx, direction) {
    let style, original;
    if (direction === 'ltr' || direction === 'rtl') {
        style = ctx.canvas.style;
        original = [
            style.getPropertyValue('direction'),
            style.getPropertyPriority('direction')
        ];
        style.setProperty('direction', direction, 'important');
        ctx.prevTextDirection = original;
    }
}
function $84f61e7391a78632$export$24baa2b76016ce0e(ctx, original) {
    if (original !== undefined) {
        delete ctx.prevTextDirection;
        ctx.canvas.style.setProperty('direction', original[0], original[1]);
    }
}
function $84f61e7391a78632$var$propertyFn(property) {
    if (property === 'angle') return {
        between: $84f61e7391a78632$export$ffb5f4729a158638,
        compare: $84f61e7391a78632$export$f074adc9fbd50943,
        normalize: $84f61e7391a78632$export$3d12bd131bb975d1
    };
    return {
        between: $84f61e7391a78632$export$21579262ef46735b,
        compare: (a, b)=>a - b,
        normalize: (x)=>x
    };
}
function $84f61e7391a78632$var$normalizeSegment({ start: start, end: end, count: count, loop: loop, style: style }) {
    return {
        start: start % count,
        end: end % count,
        loop: loop && (end - start + 1) % count === 0,
        style: style
    };
}
function $84f61e7391a78632$var$getSegment(segment, points, bounds) {
    const { property: property, start: startBound, end: endBound } = bounds;
    const { between: between, normalize: normalize } = $84f61e7391a78632$var$propertyFn(property);
    const count = points.length;
    let { start: start, end: end, loop: loop } = segment;
    let i, ilen;
    if (loop) {
        start += count;
        end += count;
        for(i = 0, ilen = count; i < ilen; ++i){
            if (!between(normalize(points[start % count][property]), startBound, endBound)) break;
            start--;
            end--;
        }
        start %= count;
        end %= count;
    }
    if (end < start) end += count;
    return {
        start: start,
        end: end,
        loop: loop,
        style: segment.style
    };
}
function $84f61e7391a78632$export$28f7fcd39efa255(segment, points, bounds) {
    if (!bounds) return [
        segment
    ];
    const { property: property, start: startBound, end: endBound } = bounds;
    const count = points.length;
    const { compare: compare, between: between, normalize: normalize } = $84f61e7391a78632$var$propertyFn(property);
    const { start: start, end: end, loop: loop, style: style } = $84f61e7391a78632$var$getSegment(segment, points, bounds);
    const result = [];
    let inside = false;
    let subStart = null;
    let value, point, prevValue;
    const startIsBefore = ()=>between(startBound, prevValue, value) && compare(startBound, prevValue) !== 0;
    const endIsBefore = ()=>compare(endBound, value) === 0 || between(endBound, prevValue, value);
    const shouldStart = ()=>inside || startIsBefore();
    const shouldStop = ()=>!inside || endIsBefore();
    for(let i = start, prev = start; i <= end; ++i){
        point = points[i % count];
        if (point.skip) continue;
        value = normalize(point[property]);
        if (value === prevValue) continue;
        inside = between(value, startBound, endBound);
        if (subStart === null && shouldStart()) subStart = compare(value, startBound) === 0 ? i : prev;
        if (subStart !== null && shouldStop()) {
            result.push($84f61e7391a78632$var$normalizeSegment({
                start: subStart,
                end: i,
                loop: loop,
                count: count,
                style: style
            }));
            subStart = null;
        }
        prev = i;
        prevValue = value;
    }
    if (subStart !== null) result.push($84f61e7391a78632$var$normalizeSegment({
        start: subStart,
        end: end,
        loop: loop,
        count: count,
        style: style
    }));
    return result;
}
function $84f61e7391a78632$export$7a38258bbe170828(line, bounds) {
    const result = [];
    const segments = line.segments;
    for(let i = 0; i < segments.length; i++){
        const sub = $84f61e7391a78632$export$28f7fcd39efa255(segments[i], line.points, bounds);
        if (sub.length) result.push(...sub);
    }
    return result;
}
function $84f61e7391a78632$var$findStartAndEnd(points, count, loop, spanGaps) {
    let start = 0;
    let end = count - 1;
    if (loop && !spanGaps) while(start < count && !points[start].skip)start++;
    while(start < count && points[start].skip)start++;
    start %= count;
    if (loop) end += start;
    while(end > start && points[end % count].skip)end--;
    end %= count;
    return {
        start: start,
        end: end
    };
}
function $84f61e7391a78632$var$solidSegments(points, start, max, loop) {
    const count = points.length;
    const result = [];
    let last = start;
    let prev = points[start];
    let end;
    for(end = start + 1; end <= max; ++end){
        const cur = points[end % count];
        if (cur.skip || cur.stop) {
            if (!prev.skip) {
                loop = false;
                result.push({
                    start: start % count,
                    end: (end - 1) % count,
                    loop: loop
                });
                start = last = cur.stop ? end : null;
            }
        } else {
            last = end;
            if (prev.skip) start = end;
        }
        prev = cur;
    }
    if (last !== null) result.push({
        start: start % count,
        end: last % count,
        loop: loop
    });
    return result;
}
function $84f61e7391a78632$export$306ddfe3a8403e2(line, segmentOptions) {
    const points = line.points;
    const spanGaps = line.options.spanGaps;
    const count = points.length;
    if (!count) return [];
    const loop = !!line._loop;
    const { start: start, end: end } = $84f61e7391a78632$var$findStartAndEnd(points, count, loop, spanGaps);
    if (spanGaps === true) return $84f61e7391a78632$var$splitByStyles(line, [
        {
            start: start,
            end: end,
            loop: loop
        }
    ], points, segmentOptions);
    const max = end < start ? end + count : end;
    const completeLoop = !!line._fullLoop && start === 0 && end === count - 1;
    return $84f61e7391a78632$var$splitByStyles(line, $84f61e7391a78632$var$solidSegments(points, start, max, completeLoop), points, segmentOptions);
}
function $84f61e7391a78632$var$splitByStyles(line, segments, points, segmentOptions) {
    if (!segmentOptions || !segmentOptions.setContext || !points) return segments;
    return $84f61e7391a78632$var$doSplitByStyles(line, segments, points, segmentOptions);
}
function $84f61e7391a78632$var$doSplitByStyles(line, segments, points, segmentOptions) {
    const chartContext = line._chart.getContext();
    const baseStyle = $84f61e7391a78632$var$readStyle(line.options);
    const { _datasetIndex: datasetIndex, options: { spanGaps: spanGaps } } = line;
    const count = points.length;
    const result = [];
    let prevStyle = baseStyle;
    let start = segments[0].start;
    let i = start;
    function addStyle(s, e, l, st) {
        const dir = spanGaps ? -1 : 1;
        if (s === e) return;
        s += count;
        while(points[s % count].skip)s -= dir;
        while(points[e % count].skip)e += dir;
        if (s % count !== e % count) {
            result.push({
                start: s % count,
                end: e % count,
                loop: l,
                style: st
            });
            prevStyle = st;
            start = e % count;
        }
    }
    for (const segment of segments){
        start = spanGaps ? start : segment.start;
        let prev = points[start % count];
        let style;
        for(i = start + 1; i <= segment.end; i++){
            const pt = points[i % count];
            style = $84f61e7391a78632$var$readStyle(segmentOptions.setContext($84f61e7391a78632$export$35e795649ee09318(chartContext, {
                type: 'segment',
                p0: prev,
                p1: pt,
                p0DataIndex: (i - 1) % count,
                p1DataIndex: i % count,
                datasetIndex: datasetIndex
            })));
            if ($84f61e7391a78632$var$styleChanged(style, prevStyle)) addStyle(start, i - 1, segment.loop, prevStyle);
            prev = pt;
            prevStyle = style;
        }
        if (start < i - 1) addStyle(start, i - 1, segment.loop, prevStyle);
    }
    return result;
}
function $84f61e7391a78632$var$readStyle(options) {
    return {
        backgroundColor: options.backgroundColor,
        borderCapStyle: options.borderCapStyle,
        borderDash: options.borderDash,
        borderDashOffset: options.borderDashOffset,
        borderJoinStyle: options.borderJoinStyle,
        borderWidth: options.borderWidth,
        borderColor: options.borderColor
    };
}
function $84f61e7391a78632$var$styleChanged(style, prevStyle) {
    if (!prevStyle) return false;
    const cache = [];
    const replacer = function(key, value) {
        if (!$84f61e7391a78632$export$738ab4df8bf92ae9(value)) return value;
        if (!cache.includes(value)) cache.push(value);
        return cache.indexOf(value);
    };
    return JSON.stringify(style, replacer) !== JSON.stringify(prevStyle, replacer);
}
function $84f61e7391a78632$var$getSizeForArea(scale, chartArea, field) {
    return scale.options.clip ? scale[field] : chartArea[field];
}
function $84f61e7391a78632$var$getDatasetArea(meta, chartArea) {
    const { xScale: xScale, yScale: yScale } = meta;
    if (xScale && yScale) return {
        left: $84f61e7391a78632$var$getSizeForArea(xScale, chartArea, 'left'),
        right: $84f61e7391a78632$var$getSizeForArea(xScale, chartArea, 'right'),
        top: $84f61e7391a78632$var$getSizeForArea(yScale, chartArea, 'top'),
        bottom: $84f61e7391a78632$var$getSizeForArea(yScale, chartArea, 'bottom')
    };
    return chartArea;
}
function $84f61e7391a78632$export$995eb9fca571757(chart, meta) {
    const clip = meta._clip;
    if (clip.disabled) return false;
    const area = $84f61e7391a78632$var$getDatasetArea(meta, chart.chartArea);
    return {
        left: clip.left === false ? 0 : area.left - (clip.left === true ? 0 : clip.left),
        right: clip.right === false ? chart.width : area.right + (clip.right === true ? 0 : clip.right),
        top: clip.top === false ? 0 : area.top - (clip.top === true ? 0 : clip.top),
        bottom: clip.bottom === false ? chart.height : area.bottom + (clip.bottom === true ? 0 : clip.bottom)
    };
}



class $216d2bdc6f281bf6$var$Animator {
    constructor(){
        this._request = null;
        this._charts = new Map();
        this._running = false;
        this._lastDate = undefined;
    }
    _notify(chart, anims, date, type) {
        const callbacks = anims.listeners[type];
        const numSteps = anims.duration;
        callbacks.forEach((fn)=>fn({
                chart: chart,
                initial: anims.initial,
                numSteps: numSteps,
                currentStep: Math.min(date - anims.start, numSteps)
            }));
    }
    _refresh() {
        if (this._request) return;
        this._running = true;
        this._request = (0, $84f61e7391a78632$export$43caf9889c228507).call(window, ()=>{
            this._update();
            this._request = null;
            if (this._running) this._refresh();
        });
    }
    _update(date = Date.now()) {
        let remaining = 0;
        this._charts.forEach((anims, chart)=>{
            if (!anims.running || !anims.items.length) return;
            const items = anims.items;
            let i = items.length - 1;
            let draw = false;
            let item;
            for(; i >= 0; --i){
                item = items[i];
                if (item._active) {
                    if (item._total > anims.duration) anims.duration = item._total;
                    item.tick(date);
                    draw = true;
                } else {
                    items[i] = items[items.length - 1];
                    items.pop();
                }
            }
            if (draw) {
                chart.draw();
                this._notify(chart, anims, date, 'progress');
            }
            if (!items.length) {
                anims.running = false;
                this._notify(chart, anims, date, 'complete');
                anims.initial = false;
            }
            remaining += items.length;
        });
        this._lastDate = date;
        if (remaining === 0) this._running = false;
    }
    _getAnims(chart) {
        const charts = this._charts;
        let anims = charts.get(chart);
        if (!anims) {
            anims = {
                running: false,
                initial: true,
                items: [],
                listeners: {
                    complete: [],
                    progress: []
                }
            };
            charts.set(chart, anims);
        }
        return anims;
    }
    listen(chart, event, cb) {
        this._getAnims(chart).listeners[event].push(cb);
    }
    add(chart, items) {
        if (!items || !items.length) return;
        this._getAnims(chart).items.push(...items);
    }
    has(chart) {
        return this._getAnims(chart).items.length > 0;
    }
    start(chart) {
        const anims = this._charts.get(chart);
        if (!anims) return;
        anims.running = true;
        anims.start = Date.now();
        anims.duration = anims.items.reduce((acc, cur)=>Math.max(acc, cur._duration), 0);
        this._refresh();
    }
    running(chart) {
        if (!this._running) return false;
        const anims = this._charts.get(chart);
        if (!anims || !anims.running || !anims.items.length) return false;
        return true;
    }
    stop(chart) {
        const anims = this._charts.get(chart);
        if (!anims || !anims.items.length) return;
        const items = anims.items;
        let i = items.length - 1;
        for(; i >= 0; --i)items[i].cancel();
        anims.items = [];
        this._notify(chart, anims, Date.now(), 'complete');
    }
    remove(chart) {
        return this._charts.delete(chart);
    }
}
var $216d2bdc6f281bf6$export$a424a0aa8f687495 = /* #__PURE__ */ new $216d2bdc6f281bf6$var$Animator();
const $216d2bdc6f281bf6$var$transparent = 'transparent';
const $216d2bdc6f281bf6$var$interpolators = {
    boolean (from, to, factor) {
        return factor > 0.5 ? to : from;
    },
    color (from, to, factor) {
        const c0 = (0, $84f61e7391a78632$export$db3b6bfb95261072)(from || $216d2bdc6f281bf6$var$transparent);
        const c1 = c0.valid && (0, $84f61e7391a78632$export$db3b6bfb95261072)(to || $216d2bdc6f281bf6$var$transparent);
        return c1 && c1.valid ? c1.mix(c0, factor).hexString() : to;
    },
    number (from, to, factor) {
        return from + (to - from) * factor;
    }
};
class $216d2bdc6f281bf6$export$c35d437ae5945fcd {
    constructor(cfg, target, prop, to){
        const currentValue = target[prop];
        to = (0, $84f61e7391a78632$export$407448d2b89b1813)([
            cfg.to,
            to,
            currentValue,
            cfg.from
        ]);
        const from = (0, $84f61e7391a78632$export$407448d2b89b1813)([
            cfg.from,
            currentValue,
            to
        ]);
        this._active = true;
        this._fn = cfg.fn || $216d2bdc6f281bf6$var$interpolators[cfg.type || typeof from];
        this._easing = (0, $84f61e7391a78632$export$f1e1789686576879)[cfg.easing] || (0, $84f61e7391a78632$export$f1e1789686576879).linear;
        this._start = Math.floor(Date.now() + (cfg.delay || 0));
        this._duration = this._total = Math.floor(cfg.duration);
        this._loop = !!cfg.loop;
        this._target = target;
        this._prop = prop;
        this._from = from;
        this._to = to;
        this._promises = undefined;
    }
    active() {
        return this._active;
    }
    update(cfg, to, date) {
        if (this._active) {
            this._notify(false);
            const currentValue = this._target[this._prop];
            const elapsed = date - this._start;
            const remain = this._duration - elapsed;
            this._start = date;
            this._duration = Math.floor(Math.max(remain, cfg.duration));
            this._total += elapsed;
            this._loop = !!cfg.loop;
            this._to = (0, $84f61e7391a78632$export$407448d2b89b1813)([
                cfg.to,
                to,
                currentValue,
                cfg.from
            ]);
            this._from = (0, $84f61e7391a78632$export$407448d2b89b1813)([
                cfg.from,
                currentValue,
                to
            ]);
        }
    }
    cancel() {
        if (this._active) {
            this.tick(Date.now());
            this._active = false;
            this._notify(false);
        }
    }
    tick(date) {
        const elapsed = date - this._start;
        const duration = this._duration;
        const prop = this._prop;
        const from = this._from;
        const loop = this._loop;
        const to = this._to;
        let factor;
        this._active = from !== to && (loop || elapsed < duration);
        if (!this._active) {
            this._target[prop] = to;
            this._notify(true);
            return;
        }
        if (elapsed < 0) {
            this._target[prop] = from;
            return;
        }
        factor = elapsed / duration % 2;
        factor = loop && factor > 1 ? 2 - factor : factor;
        factor = this._easing(Math.min(1, Math.max(0, factor)));
        this._target[prop] = this._fn(from, to, factor);
    }
    wait() {
        const promises = this._promises || (this._promises = []);
        return new Promise((res, rej)=>{
            promises.push({
                res: res,
                rej: rej
            });
        });
    }
    _notify(resolved) {
        const method = resolved ? 'res' : 'rej';
        const promises = this._promises || [];
        for(let i = 0; i < promises.length; i++)promises[i][method]();
    }
}
class $216d2bdc6f281bf6$export$8ab227dac26677d {
    constructor(chart, config){
        this._chart = chart;
        this._properties = new Map();
        this.configure(config);
    }
    configure(config) {
        if (!(0, $84f61e7391a78632$export$23f2a1d2818174ef)(config)) return;
        const animationOptions = Object.keys((0, $84f61e7391a78632$export$4368d992c4eafac0).animation);
        const animatedProps = this._properties;
        Object.getOwnPropertyNames(config).forEach((key)=>{
            const cfg = config[key];
            if (!(0, $84f61e7391a78632$export$23f2a1d2818174ef)(cfg)) return;
            const resolved = {};
            for (const option of animationOptions)resolved[option] = cfg[option];
            ((0, $84f61e7391a78632$export$8b22cf2602fb60ce)(cfg.properties) && cfg.properties || [
                key
            ]).forEach((prop)=>{
                if (prop === key || !animatedProps.has(prop)) animatedProps.set(prop, resolved);
            });
        });
    }
    _animateOptions(target, values) {
        const newOptions = values.options;
        const options = $216d2bdc6f281bf6$var$resolveTargetOptions(target, newOptions);
        if (!options) return [];
        const animations = this._createAnimations(options, newOptions);
        if (newOptions.$shared) $216d2bdc6f281bf6$var$awaitAll(target.options.$animations, newOptions).then(()=>{
            target.options = newOptions;
        }, ()=>{});
        return animations;
    }
    _createAnimations(target, values) {
        const animatedProps = this._properties;
        const animations = [];
        const running = target.$animations || (target.$animations = {});
        const props = Object.keys(values);
        const date = Date.now();
        let i;
        for(i = props.length - 1; i >= 0; --i){
            const prop = props[i];
            if (prop.charAt(0) === '$') continue;
            if (prop === 'options') {
                animations.push(...this._animateOptions(target, values));
                continue;
            }
            const value = values[prop];
            let animation = running[prop];
            const cfg = animatedProps.get(prop);
            if (animation) {
                if (cfg && animation.active()) {
                    animation.update(cfg, value, date);
                    continue;
                } else animation.cancel();
            }
            if (!cfg || !cfg.duration) {
                target[prop] = value;
                continue;
            }
            running[prop] = animation = new $216d2bdc6f281bf6$export$c35d437ae5945fcd(cfg, target, prop, value);
            animations.push(animation);
        }
        return animations;
    }
    update(target, values) {
        if (this._properties.size === 0) {
            Object.assign(target, values);
            return;
        }
        const animations = this._createAnimations(target, values);
        if (animations.length) {
            $216d2bdc6f281bf6$export$a424a0aa8f687495.add(this._chart, animations);
            return true;
        }
    }
}
function $216d2bdc6f281bf6$var$awaitAll(animations, properties) {
    const running = [];
    const keys = Object.keys(properties);
    for(let i = 0; i < keys.length; i++){
        const anim = animations[keys[i]];
        if (anim && anim.active()) running.push(anim.wait());
    }
    return Promise.all(running);
}
function $216d2bdc6f281bf6$var$resolveTargetOptions(target, newOptions) {
    if (!newOptions) return;
    let options = target.options;
    if (!options) {
        target.options = newOptions;
        return;
    }
    if (options.$shared) target.options = options = Object.assign({}, options, {
        $shared: false,
        $animations: {}
    });
    return options;
}
function $216d2bdc6f281bf6$var$scaleClip(scale, allowedOverflow) {
    const opts = scale && scale.options || {};
    const reverse = opts.reverse;
    const min = opts.min === undefined ? allowedOverflow : 0;
    const max = opts.max === undefined ? allowedOverflow : 0;
    return {
        start: reverse ? max : min,
        end: reverse ? min : max
    };
}
function $216d2bdc6f281bf6$var$defaultClip(xScale, yScale, allowedOverflow) {
    if (allowedOverflow === false) return false;
    const x = $216d2bdc6f281bf6$var$scaleClip(xScale, allowedOverflow);
    const y = $216d2bdc6f281bf6$var$scaleClip(yScale, allowedOverflow);
    return {
        top: y.end,
        right: x.end,
        bottom: y.start,
        left: x.start
    };
}
function $216d2bdc6f281bf6$var$toClip(value) {
    let t, r, b, l;
    if ((0, $84f61e7391a78632$export$23f2a1d2818174ef)(value)) {
        t = value.top;
        r = value.right;
        b = value.bottom;
        l = value.left;
    } else t = r = b = l = value;
    return {
        top: t,
        right: r,
        bottom: b,
        left: l,
        disabled: value === false
    };
}
function $216d2bdc6f281bf6$var$getSortedDatasetIndices(chart, filterVisible) {
    const keys = [];
    const metasets = chart._getSortedDatasetMetas(filterVisible);
    let i, ilen;
    for(i = 0, ilen = metasets.length; i < ilen; ++i)keys.push(metasets[i].index);
    return keys;
}
function $216d2bdc6f281bf6$var$applyStack(stack, value, dsIndex, options = {}) {
    const keys = stack.keys;
    const singleMode = options.mode === 'single';
    let i, ilen, datasetIndex, otherValue;
    if (value === null) return;
    let found = false;
    for(i = 0, ilen = keys.length; i < ilen; ++i){
        datasetIndex = +keys[i];
        if (datasetIndex === dsIndex) {
            found = true;
            if (options.all) continue;
            break;
        }
        otherValue = stack.values[datasetIndex];
        if ((0, $84f61e7391a78632$export$39b482c5e57630a8)(otherValue) && (singleMode || value === 0 || (0, $84f61e7391a78632$export$2408f22a0fab9ae5)(value) === (0, $84f61e7391a78632$export$2408f22a0fab9ae5)(otherValue))) value += otherValue;
    }
    if (!found && !options.all) return 0;
    return value;
}
function $216d2bdc6f281bf6$var$convertObjectDataToArray(data, meta) {
    const { iScale: iScale, vScale: vScale } = meta;
    const iAxisKey = iScale.axis === 'x' ? 'x' : 'y';
    const vAxisKey = vScale.axis === 'x' ? 'x' : 'y';
    const keys = Object.keys(data);
    const adata = new Array(keys.length);
    let i, ilen, key;
    for(i = 0, ilen = keys.length; i < ilen; ++i){
        key = keys[i];
        adata[i] = {
            [iAxisKey]: key,
            [vAxisKey]: data[key]
        };
    }
    return adata;
}
function $216d2bdc6f281bf6$var$isStacked(scale, meta) {
    const stacked = scale && scale.options.stacked;
    return stacked || stacked === undefined && meta.stack !== undefined;
}
function $216d2bdc6f281bf6$var$getStackKey(indexScale, valueScale, meta) {
    return `${indexScale.id}.${valueScale.id}.${meta.stack || meta.type}`;
}
function $216d2bdc6f281bf6$var$getUserBounds(scale) {
    const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = scale.getUserBounds();
    return {
        min: minDefined ? min : Number.NEGATIVE_INFINITY,
        max: maxDefined ? max : Number.POSITIVE_INFINITY
    };
}
function $216d2bdc6f281bf6$var$getOrCreateStack(stacks, stackKey, indexValue) {
    const subStack = stacks[stackKey] || (stacks[stackKey] = {});
    return subStack[indexValue] || (subStack[indexValue] = {});
}
function $216d2bdc6f281bf6$var$getLastIndexInStack(stack, vScale, positive, type) {
    for (const meta of vScale.getMatchingVisibleMetas(type).reverse()){
        const value = stack[meta.index];
        if (positive && value > 0 || !positive && value < 0) return meta.index;
    }
    return null;
}
function $216d2bdc6f281bf6$var$updateStacks(controller, parsed) {
    const { chart: chart, _cachedMeta: meta } = controller;
    const stacks = chart._stacks || (chart._stacks = {});
    const { iScale: iScale, vScale: vScale, index: datasetIndex } = meta;
    const iAxis = iScale.axis;
    const vAxis = vScale.axis;
    const key = $216d2bdc6f281bf6$var$getStackKey(iScale, vScale, meta);
    const ilen = parsed.length;
    let stack;
    for(let i = 0; i < ilen; ++i){
        const item = parsed[i];
        const { [iAxis]: index, [vAxis]: value } = item;
        const itemStacks = item._stacks || (item._stacks = {});
        stack = itemStacks[vAxis] = $216d2bdc6f281bf6$var$getOrCreateStack(stacks, key, index);
        stack[datasetIndex] = value;
        stack._top = $216d2bdc6f281bf6$var$getLastIndexInStack(stack, vScale, true, meta.type);
        stack._bottom = $216d2bdc6f281bf6$var$getLastIndexInStack(stack, vScale, false, meta.type);
        const visualValues = stack._visualValues || (stack._visualValues = {});
        visualValues[datasetIndex] = value;
    }
}
function $216d2bdc6f281bf6$var$getFirstScaleId(chart, axis) {
    const scales = chart.scales;
    return Object.keys(scales).filter((key)=>scales[key].axis === axis).shift();
}
function $216d2bdc6f281bf6$var$createDatasetContext(parent, index) {
    return (0, $84f61e7391a78632$export$35e795649ee09318)(parent, {
        active: false,
        dataset: undefined,
        datasetIndex: index,
        index: index,
        mode: 'default',
        type: 'dataset'
    });
}
function $216d2bdc6f281bf6$var$createDataContext(parent, index, element) {
    return (0, $84f61e7391a78632$export$35e795649ee09318)(parent, {
        active: false,
        dataIndex: index,
        parsed: undefined,
        raw: undefined,
        element: element,
        index: index,
        mode: 'default',
        type: 'data'
    });
}
function $216d2bdc6f281bf6$var$clearStacks(meta, items) {
    const datasetIndex = meta.controller.index;
    const axis = meta.vScale && meta.vScale.axis;
    if (!axis) return;
    items = items || meta._parsed;
    for (const parsed of items){
        const stacks = parsed._stacks;
        if (!stacks || stacks[axis] === undefined || stacks[axis][datasetIndex] === undefined) return;
        delete stacks[axis][datasetIndex];
        if (stacks[axis]._visualValues !== undefined && stacks[axis]._visualValues[datasetIndex] !== undefined) delete stacks[axis]._visualValues[datasetIndex];
    }
}
const $216d2bdc6f281bf6$var$isDirectUpdateMode = (mode)=>mode === 'reset' || mode === 'none';
const $216d2bdc6f281bf6$var$cloneIfNotShared = (cached, shared)=>shared ? cached : Object.assign({}, cached);
const $216d2bdc6f281bf6$var$createStack = (canStack, meta, chart)=>canStack && !meta.hidden && meta._stacked && {
        keys: $216d2bdc6f281bf6$var$getSortedDatasetIndices(chart, true),
        values: null
    };
class $216d2bdc6f281bf6$export$75572ec5c55b4048 {
    static defaults = {};
    static datasetElementType = null;
    static dataElementType = null;
    constructor(chart, datasetIndex){
        this.chart = chart;
        this._ctx = chart.ctx;
        this.index = datasetIndex;
        this._cachedDataOpts = {};
        this._cachedMeta = this.getMeta();
        this._type = this._cachedMeta.type;
        this.options = undefined;
        this._parsing = false;
        this._data = undefined;
        this._objectData = undefined;
        this._sharedOptions = undefined;
        this._drawStart = undefined;
        this._drawCount = undefined;
        this.enableOptionSharing = false;
        this.supportsDecimation = false;
        this.$context = undefined;
        this._syncList = [];
        this.datasetElementType = new.target.datasetElementType;
        this.dataElementType = new.target.dataElementType;
        this.initialize();
    }
    initialize() {
        const meta = this._cachedMeta;
        this.configure();
        this.linkScales();
        meta._stacked = $216d2bdc6f281bf6$var$isStacked(meta.vScale, meta);
        this.addElements();
        if (this.options.fill && !this.chart.isPluginEnabled('filler')) console.warn("Tried to use the 'fill' option without the 'Filler' plugin enabled. Please import and register the 'Filler' plugin and make sure it is not disabled in the options");
    }
    updateIndex(datasetIndex) {
        if (this.index !== datasetIndex) $216d2bdc6f281bf6$var$clearStacks(this._cachedMeta);
        this.index = datasetIndex;
    }
    linkScales() {
        const chart = this.chart;
        const meta = this._cachedMeta;
        const dataset = this.getDataset();
        const chooseId = (axis, x, y, r)=>axis === 'x' ? x : axis === 'r' ? r : y;
        const xid = meta.xAxisID = (0, $84f61e7391a78632$export$90a7f3efeed30595)(dataset.xAxisID, $216d2bdc6f281bf6$var$getFirstScaleId(chart, 'x'));
        const yid = meta.yAxisID = (0, $84f61e7391a78632$export$90a7f3efeed30595)(dataset.yAxisID, $216d2bdc6f281bf6$var$getFirstScaleId(chart, 'y'));
        const rid = meta.rAxisID = (0, $84f61e7391a78632$export$90a7f3efeed30595)(dataset.rAxisID, $216d2bdc6f281bf6$var$getFirstScaleId(chart, 'r'));
        const indexAxis = meta.indexAxis;
        const iid = meta.iAxisID = chooseId(indexAxis, xid, yid, rid);
        const vid = meta.vAxisID = chooseId(indexAxis, yid, xid, rid);
        meta.xScale = this.getScaleForId(xid);
        meta.yScale = this.getScaleForId(yid);
        meta.rScale = this.getScaleForId(rid);
        meta.iScale = this.getScaleForId(iid);
        meta.vScale = this.getScaleForId(vid);
    }
    getDataset() {
        return this.chart.data.datasets[this.index];
    }
    getMeta() {
        return this.chart.getDatasetMeta(this.index);
    }
    getScaleForId(scaleID) {
        return this.chart.scales[scaleID];
    }
    _getOtherScale(scale) {
        const meta = this._cachedMeta;
        return scale === meta.iScale ? meta.vScale : meta.iScale;
    }
    reset() {
        this._update('reset');
    }
    _destroy() {
        const meta = this._cachedMeta;
        if (this._data) (0, $84f61e7391a78632$export$3b14a55fb2447963)(this._data, this);
        if (meta._stacked) $216d2bdc6f281bf6$var$clearStacks(meta);
    }
    _dataCheck() {
        const dataset = this.getDataset();
        const data = dataset.data || (dataset.data = []);
        const _data = this._data;
        if ((0, $84f61e7391a78632$export$23f2a1d2818174ef)(data)) {
            const meta = this._cachedMeta;
            this._data = $216d2bdc6f281bf6$var$convertObjectDataToArray(data, meta);
        } else if (_data !== data) {
            if (_data) {
                (0, $84f61e7391a78632$export$3b14a55fb2447963)(_data, this);
                const meta = this._cachedMeta;
                $216d2bdc6f281bf6$var$clearStacks(meta);
                meta._parsed = [];
            }
            if (data && Object.isExtensible(data)) (0, $84f61e7391a78632$export$882b5998b3b9117c)(data, this);
            this._syncList = [];
            this._data = data;
        }
    }
    addElements() {
        const meta = this._cachedMeta;
        this._dataCheck();
        if (this.datasetElementType) meta.dataset = new this.datasetElementType();
    }
    buildOrUpdateElements(resetNewElements) {
        const meta = this._cachedMeta;
        const dataset = this.getDataset();
        let stackChanged = false;
        this._dataCheck();
        const oldStacked = meta._stacked;
        meta._stacked = $216d2bdc6f281bf6$var$isStacked(meta.vScale, meta);
        if (meta.stack !== dataset.stack) {
            stackChanged = true;
            $216d2bdc6f281bf6$var$clearStacks(meta);
            meta.stack = dataset.stack;
        }
        this._resyncElements(resetNewElements);
        if (stackChanged || oldStacked !== meta._stacked) {
            $216d2bdc6f281bf6$var$updateStacks(this, meta._parsed);
            meta._stacked = $216d2bdc6f281bf6$var$isStacked(meta.vScale, meta);
        }
    }
    configure() {
        const config = this.chart.config;
        const scopeKeys = config.datasetScopeKeys(this._type);
        const scopes = config.getOptionScopes(this.getDataset(), scopeKeys, true);
        this.options = config.createResolver(scopes, this.getContext());
        this._parsing = this.options.parsing;
        this._cachedDataOpts = {};
    }
    parse(start, count) {
        const { _cachedMeta: meta, _data: data } = this;
        const { iScale: iScale, _stacked: _stacked } = meta;
        const iAxis = iScale.axis;
        let sorted = start === 0 && count === data.length ? true : meta._sorted;
        let prev = start > 0 && meta._parsed[start - 1];
        let i, cur, parsed;
        if (this._parsing === false) {
            meta._parsed = data;
            meta._sorted = true;
            parsed = data;
        } else {
            if ((0, $84f61e7391a78632$export$8b22cf2602fb60ce)(data[start])) parsed = this.parseArrayData(meta, data, start, count);
            else if ((0, $84f61e7391a78632$export$23f2a1d2818174ef)(data[start])) parsed = this.parseObjectData(meta, data, start, count);
            else parsed = this.parsePrimitiveData(meta, data, start, count);
            const isNotInOrderComparedToPrev = ()=>cur[iAxis] === null || prev && cur[iAxis] < prev[iAxis];
            for(i = 0; i < count; ++i){
                meta._parsed[i + start] = cur = parsed[i];
                if (sorted) {
                    if (isNotInOrderComparedToPrev()) sorted = false;
                    prev = cur;
                }
            }
            meta._sorted = sorted;
        }
        if (_stacked) $216d2bdc6f281bf6$var$updateStacks(this, parsed);
    }
    parsePrimitiveData(meta, data, start, count) {
        const { iScale: iScale, vScale: vScale } = meta;
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const labels = iScale.getLabels();
        const singleScale = iScale === vScale;
        const parsed = new Array(count);
        let i, ilen, index;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            parsed[i] = {
                [iAxis]: singleScale || iScale.parse(labels[index], index),
                [vAxis]: vScale.parse(data[index], index)
            };
        }
        return parsed;
    }
    parseArrayData(meta, data, start, count) {
        const { xScale: xScale, yScale: yScale } = meta;
        const parsed = new Array(count);
        let i, ilen, index, item;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            item = data[index];
            parsed[i] = {
                x: xScale.parse(item[0], index),
                y: yScale.parse(item[1], index)
            };
        }
        return parsed;
    }
    parseObjectData(meta, data, start, count) {
        const { xScale: xScale, yScale: yScale } = meta;
        const { xAxisKey: xAxisKey = 'x', yAxisKey: yAxisKey = 'y' } = this._parsing;
        const parsed = new Array(count);
        let i, ilen, index, item;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            item = data[index];
            parsed[i] = {
                x: xScale.parse((0, $84f61e7391a78632$export$2d1720544b23b823)(item, xAxisKey), index),
                y: yScale.parse((0, $84f61e7391a78632$export$2d1720544b23b823)(item, yAxisKey), index)
            };
        }
        return parsed;
    }
    getParsed(index) {
        return this._cachedMeta._parsed[index];
    }
    getDataElement(index) {
        return this._cachedMeta.data[index];
    }
    applyStack(scale, parsed, mode) {
        const chart = this.chart;
        const meta = this._cachedMeta;
        const value = parsed[scale.axis];
        const stack = {
            keys: $216d2bdc6f281bf6$var$getSortedDatasetIndices(chart, true),
            values: parsed._stacks[scale.axis]._visualValues
        };
        return $216d2bdc6f281bf6$var$applyStack(stack, value, meta.index, {
            mode: mode
        });
    }
    updateRangeFromParsed(range, scale, parsed, stack) {
        const parsedValue = parsed[scale.axis];
        let value = parsedValue === null ? NaN : parsedValue;
        const values = stack && parsed._stacks[scale.axis];
        if (stack && values) {
            stack.values = values;
            value = $216d2bdc6f281bf6$var$applyStack(stack, parsedValue, this._cachedMeta.index);
        }
        range.min = Math.min(range.min, value);
        range.max = Math.max(range.max, value);
    }
    getMinMax(scale, canStack) {
        const meta = this._cachedMeta;
        const _parsed = meta._parsed;
        const sorted = meta._sorted && scale === meta.iScale;
        const ilen = _parsed.length;
        const otherScale = this._getOtherScale(scale);
        const stack = $216d2bdc6f281bf6$var$createStack(canStack, meta, this.chart);
        const range = {
            min: Number.POSITIVE_INFINITY,
            max: Number.NEGATIVE_INFINITY
        };
        const { min: otherMin, max: otherMax } = $216d2bdc6f281bf6$var$getUserBounds(otherScale);
        let i, parsed;
        function _skip() {
            parsed = _parsed[i];
            const otherValue = parsed[otherScale.axis];
            return !(0, $84f61e7391a78632$export$39b482c5e57630a8)(parsed[scale.axis]) || otherMin > otherValue || otherMax < otherValue;
        }
        for(i = 0; i < ilen; ++i){
            if (_skip()) continue;
            this.updateRangeFromParsed(range, scale, parsed, stack);
            if (sorted) break;
        }
        if (sorted) for(i = ilen - 1; i >= 0; --i){
            if (_skip()) continue;
            this.updateRangeFromParsed(range, scale, parsed, stack);
            break;
        }
        return range;
    }
    getAllParsedValues(scale) {
        const parsed = this._cachedMeta._parsed;
        const values = [];
        let i, ilen, value;
        for(i = 0, ilen = parsed.length; i < ilen; ++i){
            value = parsed[i][scale.axis];
            if ((0, $84f61e7391a78632$export$39b482c5e57630a8)(value)) values.push(value);
        }
        return values;
    }
    getMaxOverflow() {
        return false;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const iScale = meta.iScale;
        const vScale = meta.vScale;
        const parsed = this.getParsed(index);
        return {
            label: iScale ? '' + iScale.getLabelForValue(parsed[iScale.axis]) : '',
            value: vScale ? '' + vScale.getLabelForValue(parsed[vScale.axis]) : ''
        };
    }
    _update(mode) {
        const meta = this._cachedMeta;
        this.update(mode || 'default');
        meta._clip = $216d2bdc6f281bf6$var$toClip((0, $84f61e7391a78632$export$90a7f3efeed30595)(this.options.clip, $216d2bdc6f281bf6$var$defaultClip(meta.xScale, meta.yScale, this.getMaxOverflow())));
    }
    update(mode) {}
    draw() {
        const ctx = this._ctx;
        const chart = this.chart;
        const meta = this._cachedMeta;
        const elements = meta.data || [];
        const area = chart.chartArea;
        const active = [];
        const start = this._drawStart || 0;
        const count = this._drawCount || elements.length - start;
        const drawActiveElementsOnTop = this.options.drawActiveElementsOnTop;
        let i;
        if (meta.dataset) meta.dataset.draw(ctx, area, start, count);
        for(i = start; i < start + count; ++i){
            const element = elements[i];
            if (element.hidden) continue;
            if (element.active && drawActiveElementsOnTop) active.push(element);
            else element.draw(ctx, area);
        }
        for(i = 0; i < active.length; ++i)active[i].draw(ctx, area);
    }
    getStyle(index, active) {
        const mode = active ? 'active' : 'default';
        return index === undefined && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(mode) : this.resolveDataElementOptions(index || 0, mode);
    }
    getContext(index, active, mode) {
        const dataset = this.getDataset();
        let context;
        if (index >= 0 && index < this._cachedMeta.data.length) {
            const element = this._cachedMeta.data[index];
            context = element.$context || (element.$context = $216d2bdc6f281bf6$var$createDataContext(this.getContext(), index, element));
            context.parsed = this.getParsed(index);
            context.raw = dataset.data[index];
            context.index = context.dataIndex = index;
        } else {
            context = this.$context || (this.$context = $216d2bdc6f281bf6$var$createDatasetContext(this.chart.getContext(), this.index));
            context.dataset = dataset;
            context.index = context.datasetIndex = this.index;
        }
        context.active = !!active;
        context.mode = mode;
        return context;
    }
    resolveDatasetElementOptions(mode) {
        return this._resolveElementOptions(this.datasetElementType.id, mode);
    }
    resolveDataElementOptions(index, mode) {
        return this._resolveElementOptions(this.dataElementType.id, mode, index);
    }
    _resolveElementOptions(elementType, mode = 'default', index) {
        const active = mode === 'active';
        const cache = this._cachedDataOpts;
        const cacheKey = elementType + '-' + mode;
        const cached = cache[cacheKey];
        const sharing = this.enableOptionSharing && (0, $84f61e7391a78632$export$dda1d9f60106f0e9)(index);
        if (cached) return $216d2bdc6f281bf6$var$cloneIfNotShared(cached, sharing);
        const config = this.chart.config;
        const scopeKeys = config.datasetElementScopeKeys(this._type, elementType);
        const prefixes = active ? [
            `${elementType}Hover`,
            'hover',
            elementType,
            ''
        ] : [
            elementType,
            ''
        ];
        const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
        const names = Object.keys((0, $84f61e7391a78632$export$4368d992c4eafac0).elements[elementType]);
        const context = ()=>this.getContext(index, active, mode);
        const values = config.resolveNamedOptions(scopes, names, context, prefixes);
        if (values.$shared) {
            values.$shared = sharing;
            cache[cacheKey] = Object.freeze($216d2bdc6f281bf6$var$cloneIfNotShared(values, sharing));
        }
        return values;
    }
    _resolveAnimations(index, transition, active) {
        const chart = this.chart;
        const cache = this._cachedDataOpts;
        const cacheKey = `animation-${transition}`;
        const cached = cache[cacheKey];
        if (cached) return cached;
        let options;
        if (chart.options.animation !== false) {
            const config = this.chart.config;
            const scopeKeys = config.datasetAnimationScopeKeys(this._type, transition);
            const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
            options = config.createResolver(scopes, this.getContext(index, active, transition));
        }
        const animations = new $216d2bdc6f281bf6$export$8ab227dac26677d(chart, options && options.animations);
        if (options && options._cacheable) cache[cacheKey] = Object.freeze(animations);
        return animations;
    }
    getSharedOptions(options) {
        if (!options.$shared) return;
        return this._sharedOptions || (this._sharedOptions = Object.assign({}, options));
    }
    includeOptions(mode, sharedOptions) {
        return !sharedOptions || $216d2bdc6f281bf6$var$isDirectUpdateMode(mode) || this.chart._animationsDisabled;
    }
    _getSharedOptions(start, mode) {
        const firstOpts = this.resolveDataElementOptions(start, mode);
        const previouslySharedOptions = this._sharedOptions;
        const sharedOptions = this.getSharedOptions(firstOpts);
        const includeOptions = this.includeOptions(mode, sharedOptions) || sharedOptions !== previouslySharedOptions;
        this.updateSharedOptions(sharedOptions, mode, firstOpts);
        return {
            sharedOptions: sharedOptions,
            includeOptions: includeOptions
        };
    }
    updateElement(element, index, properties, mode) {
        if ($216d2bdc6f281bf6$var$isDirectUpdateMode(mode)) Object.assign(element, properties);
        else this._resolveAnimations(index, mode).update(element, properties);
    }
    updateSharedOptions(sharedOptions, mode, newOptions) {
        if (sharedOptions && !$216d2bdc6f281bf6$var$isDirectUpdateMode(mode)) this._resolveAnimations(undefined, mode).update(sharedOptions, newOptions);
    }
    _setStyle(element, index, mode, active) {
        element.active = active;
        const options = this.getStyle(index, active);
        this._resolveAnimations(index, mode, active).update(element, {
            options: !active && this.getSharedOptions(options) || options
        });
    }
    removeHoverStyle(element, datasetIndex, index) {
        this._setStyle(element, index, 'active', false);
    }
    setHoverStyle(element, datasetIndex, index) {
        this._setStyle(element, index, 'active', true);
    }
    _removeDatasetHoverStyle() {
        const element = this._cachedMeta.dataset;
        if (element) this._setStyle(element, undefined, 'active', false);
    }
    _setDatasetHoverStyle() {
        const element = this._cachedMeta.dataset;
        if (element) this._setStyle(element, undefined, 'active', true);
    }
    _resyncElements(resetNewElements) {
        const data = this._data;
        const elements = this._cachedMeta.data;
        for (const [method, arg1, arg2] of this._syncList)this[method](arg1, arg2);
        this._syncList = [];
        const numMeta = elements.length;
        const numData = data.length;
        const count = Math.min(numData, numMeta);
        if (count) this.parse(0, count);
        if (numData > numMeta) this._insertElements(numMeta, numData - numMeta, resetNewElements);
        else if (numData < numMeta) this._removeElements(numData, numMeta - numData);
    }
    _insertElements(start, count, resetNewElements = true) {
        const meta = this._cachedMeta;
        const data = meta.data;
        const end = start + count;
        let i;
        const move = (arr)=>{
            arr.length += count;
            for(i = arr.length - 1; i >= end; i--)arr[i] = arr[i - count];
        };
        move(data);
        for(i = start; i < end; ++i)data[i] = new this.dataElementType();
        if (this._parsing) move(meta._parsed);
        this.parse(start, count);
        if (resetNewElements) this.updateElements(data, start, count, 'reset');
    }
    updateElements(element, start, count, mode) {}
    _removeElements(start, count) {
        const meta = this._cachedMeta;
        if (this._parsing) {
            const removed = meta._parsed.splice(start, count);
            if (meta._stacked) $216d2bdc6f281bf6$var$clearStacks(meta, removed);
        }
        meta.data.splice(start, count);
    }
    _sync(args) {
        if (this._parsing) this._syncList.push(args);
        else {
            const [method, arg1, arg2] = args;
            this[method](arg1, arg2);
        }
        this.chart._dataChanges.push([
            this.index,
            ...args
        ]);
    }
    _onDataPush() {
        const count = arguments.length;
        this._sync([
            '_insertElements',
            this.getDataset().data.length - count,
            count
        ]);
    }
    _onDataPop() {
        this._sync([
            '_removeElements',
            this._cachedMeta.data.length - 1,
            1
        ]);
    }
    _onDataShift() {
        this._sync([
            '_removeElements',
            0,
            1
        ]);
    }
    _onDataSplice(start, count) {
        if (count) this._sync([
            '_removeElements',
            start,
            count
        ]);
        const newCount = arguments.length - 2;
        if (newCount) this._sync([
            '_insertElements',
            start,
            newCount
        ]);
    }
    _onDataUnshift() {
        this._sync([
            '_insertElements',
            0,
            arguments.length
        ]);
    }
}
function $216d2bdc6f281bf6$var$getAllScaleValues(scale, type) {
    if (!scale._cache.$bar) {
        const visibleMetas = scale.getMatchingVisibleMetas(type);
        let values = [];
        for(let i = 0, ilen = visibleMetas.length; i < ilen; i++)values = values.concat(visibleMetas[i].controller.getAllParsedValues(scale));
        scale._cache.$bar = (0, $84f61e7391a78632$export$71511d61b312f219)(values.sort((a, b)=>a - b));
    }
    return scale._cache.$bar;
}
function $216d2bdc6f281bf6$var$computeMinSampleSize(meta) {
    const scale = meta.iScale;
    const values = $216d2bdc6f281bf6$var$getAllScaleValues(scale, meta.type);
    let min = scale._length;
    let i, ilen, curr, prev;
    const updateMinAndPrev = ()=>{
        if (curr === 32767 || curr === -32768) return;
        if ((0, $84f61e7391a78632$export$dda1d9f60106f0e9)(prev)) min = Math.min(min, Math.abs(curr - prev) || min);
        prev = curr;
    };
    for(i = 0, ilen = values.length; i < ilen; ++i){
        curr = scale.getPixelForValue(values[i]);
        updateMinAndPrev();
    }
    prev = undefined;
    for(i = 0, ilen = scale.ticks.length; i < ilen; ++i){
        curr = scale.getPixelForTick(i);
        updateMinAndPrev();
    }
    return min;
}
function $216d2bdc6f281bf6$var$computeFitCategoryTraits(index, ruler, options, stackCount) {
    const thickness = options.barThickness;
    let size, ratio;
    if ((0, $84f61e7391a78632$export$342063e11d6c3cad)(thickness)) {
        size = ruler.min * options.categoryPercentage;
        ratio = options.barPercentage;
    } else {
        size = thickness * stackCount;
        ratio = 1;
    }
    return {
        chunk: size / stackCount,
        ratio: ratio,
        start: ruler.pixels[index] - size / 2
    };
}
function $216d2bdc6f281bf6$var$computeFlexCategoryTraits(index, ruler, options, stackCount) {
    const pixels = ruler.pixels;
    const curr = pixels[index];
    let prev = index > 0 ? pixels[index - 1] : null;
    let next = index < pixels.length - 1 ? pixels[index + 1] : null;
    const percent = options.categoryPercentage;
    if (prev === null) prev = curr - (next === null ? ruler.end - ruler.start : next - curr);
    if (next === null) next = curr + curr - prev;
    const start = curr - (curr - Math.min(prev, next)) / 2 * percent;
    const size = Math.abs(next - prev) / 2 * percent;
    return {
        chunk: size / stackCount,
        ratio: options.barPercentage,
        start: start
    };
}
function $216d2bdc6f281bf6$var$parseFloatBar(entry, item, vScale, i) {
    const startValue = vScale.parse(entry[0], i);
    const endValue = vScale.parse(entry[1], i);
    const min = Math.min(startValue, endValue);
    const max = Math.max(startValue, endValue);
    let barStart = min;
    let barEnd = max;
    if (Math.abs(min) > Math.abs(max)) {
        barStart = max;
        barEnd = min;
    }
    item[vScale.axis] = barEnd;
    item._custom = {
        barStart: barStart,
        barEnd: barEnd,
        start: startValue,
        end: endValue,
        min: min,
        max: max
    };
}
function $216d2bdc6f281bf6$var$parseValue(entry, item, vScale, i) {
    if ((0, $84f61e7391a78632$export$8b22cf2602fb60ce)(entry)) $216d2bdc6f281bf6$var$parseFloatBar(entry, item, vScale, i);
    else item[vScale.axis] = vScale.parse(entry, i);
    return item;
}
function $216d2bdc6f281bf6$var$parseArrayOrPrimitive(meta, data, start, count) {
    const iScale = meta.iScale;
    const vScale = meta.vScale;
    const labels = iScale.getLabels();
    const singleScale = iScale === vScale;
    const parsed = [];
    let i, ilen, item, entry;
    for(i = start, ilen = start + count; i < ilen; ++i){
        entry = data[i];
        item = {};
        item[iScale.axis] = singleScale || iScale.parse(labels[i], i);
        parsed.push($216d2bdc6f281bf6$var$parseValue(entry, item, vScale, i));
    }
    return parsed;
}
function $216d2bdc6f281bf6$var$isFloatBar(custom) {
    return custom && custom.barStart !== undefined && custom.barEnd !== undefined;
}
function $216d2bdc6f281bf6$var$barSign(size, vScale, actualBase) {
    if (size !== 0) return (0, $84f61e7391a78632$export$2408f22a0fab9ae5)(size);
    return (vScale.isHorizontal() ? 1 : -1) * (vScale.min >= actualBase ? 1 : -1);
}
function $216d2bdc6f281bf6$var$borderProps(properties) {
    let reverse, start, end, top, bottom;
    if (properties.horizontal) {
        reverse = properties.base > properties.x;
        start = 'left';
        end = 'right';
    } else {
        reverse = properties.base < properties.y;
        start = 'bottom';
        end = 'top';
    }
    if (reverse) {
        top = 'end';
        bottom = 'start';
    } else {
        top = 'start';
        bottom = 'end';
    }
    return {
        start: start,
        end: end,
        reverse: reverse,
        top: top,
        bottom: bottom
    };
}
function $216d2bdc6f281bf6$var$setBorderSkipped(properties, options, stack, index) {
    let edge = options.borderSkipped;
    const res = {};
    if (!edge) {
        properties.borderSkipped = res;
        return;
    }
    if (edge === true) {
        properties.borderSkipped = {
            top: true,
            right: true,
            bottom: true,
            left: true
        };
        return;
    }
    const { start: start, end: end, reverse: reverse, top: top, bottom: bottom } = $216d2bdc6f281bf6$var$borderProps(properties);
    if (edge === 'middle' && stack) {
        properties.enableBorderRadius = true;
        if ((stack._top || 0) === index) edge = top;
        else if ((stack._bottom || 0) === index) edge = bottom;
        else {
            res[$216d2bdc6f281bf6$var$parseEdge(bottom, start, end, reverse)] = true;
            edge = top;
        }
    }
    res[$216d2bdc6f281bf6$var$parseEdge(edge, start, end, reverse)] = true;
    properties.borderSkipped = res;
}
function $216d2bdc6f281bf6$var$parseEdge(edge, a, b, reverse) {
    if (reverse) {
        edge = $216d2bdc6f281bf6$var$swap(edge, a, b);
        edge = $216d2bdc6f281bf6$var$startEnd(edge, b, a);
    } else edge = $216d2bdc6f281bf6$var$startEnd(edge, a, b);
    return edge;
}
function $216d2bdc6f281bf6$var$swap(orig, v1, v2) {
    return orig === v1 ? v2 : orig === v2 ? v1 : orig;
}
function $216d2bdc6f281bf6$var$startEnd(v, start, end) {
    return v === 'start' ? start : v === 'end' ? end : v;
}
function $216d2bdc6f281bf6$var$setInflateAmount(properties, { inflateAmount: inflateAmount }, ratio) {
    properties.inflateAmount = inflateAmount === 'auto' ? ratio === 1 ? 0.33 : 0 : inflateAmount;
}
class $216d2bdc6f281bf6$export$e97d5dc64e999004 extends $216d2bdc6f281bf6$export$75572ec5c55b4048 {
    static id = 'bar';
    static defaults = {
        datasetElementType: false,
        dataElementType: 'bar',
        categoryPercentage: 0.8,
        barPercentage: 0.9,
        grouped: true,
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'base',
                    'width',
                    'height'
                ]
            }
        }
    };
    static overrides = {
        scales: {
            _index_: {
                type: 'category',
                offset: true,
                grid: {
                    offset: true
                }
            },
            _value_: {
                type: 'linear',
                beginAtZero: true
            }
        }
    };
    parsePrimitiveData(meta, data, start, count) {
        return $216d2bdc6f281bf6$var$parseArrayOrPrimitive(meta, data, start, count);
    }
    parseArrayData(meta, data, start, count) {
        return $216d2bdc6f281bf6$var$parseArrayOrPrimitive(meta, data, start, count);
    }
    parseObjectData(meta, data, start, count) {
        const { iScale: iScale, vScale: vScale } = meta;
        const { xAxisKey: xAxisKey = 'x', yAxisKey: yAxisKey = 'y' } = this._parsing;
        const iAxisKey = iScale.axis === 'x' ? xAxisKey : yAxisKey;
        const vAxisKey = vScale.axis === 'x' ? xAxisKey : yAxisKey;
        const parsed = [];
        let i, ilen, item, obj;
        for(i = start, ilen = start + count; i < ilen; ++i){
            obj = data[i];
            item = {};
            item[iScale.axis] = iScale.parse((0, $84f61e7391a78632$export$2d1720544b23b823)(obj, iAxisKey), i);
            parsed.push($216d2bdc6f281bf6$var$parseValue((0, $84f61e7391a78632$export$2d1720544b23b823)(obj, vAxisKey), item, vScale, i));
        }
        return parsed;
    }
    updateRangeFromParsed(range, scale, parsed, stack) {
        super.updateRangeFromParsed(range, scale, parsed, stack);
        const custom = parsed._custom;
        if (custom && scale === this._cachedMeta.vScale) {
            range.min = Math.min(range.min, custom.min);
            range.max = Math.max(range.max, custom.max);
        }
    }
    getMaxOverflow() {
        return 0;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const { iScale: iScale, vScale: vScale } = meta;
        const parsed = this.getParsed(index);
        const custom = parsed._custom;
        const value = $216d2bdc6f281bf6$var$isFloatBar(custom) ? '[' + custom.start + ', ' + custom.end + ']' : '' + vScale.getLabelForValue(parsed[vScale.axis]);
        return {
            label: '' + iScale.getLabelForValue(parsed[iScale.axis]),
            value: value
        };
    }
    initialize() {
        this.enableOptionSharing = true;
        super.initialize();
        const meta = this._cachedMeta;
        meta.stack = this.getDataset().stack;
    }
    update(mode) {
        const meta = this._cachedMeta;
        this.updateElements(meta.data, 0, meta.data.length, mode);
    }
    updateElements(bars, start, count, mode) {
        const reset = mode === 'reset';
        const { index: index, _cachedMeta: { vScale: vScale } } = this;
        const base = vScale.getBasePixel();
        const horizontal = vScale.isHorizontal();
        const ruler = this._getRuler();
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        for(let i = start; i < start + count; i++){
            const parsed = this.getParsed(i);
            const vpixels = reset || (0, $84f61e7391a78632$export$342063e11d6c3cad)(parsed[vScale.axis]) ? {
                base: base,
                head: base
            } : this._calculateBarValuePixels(i);
            const ipixels = this._calculateBarIndexPixels(i, ruler);
            const stack = (parsed._stacks || {})[vScale.axis];
            const properties = {
                horizontal: horizontal,
                base: vpixels.base,
                enableBorderRadius: !stack || $216d2bdc6f281bf6$var$isFloatBar(parsed._custom) || index === stack._top || index === stack._bottom,
                x: horizontal ? vpixels.head : ipixels.center,
                y: horizontal ? ipixels.center : vpixels.head,
                height: horizontal ? ipixels.size : Math.abs(vpixels.size),
                width: horizontal ? Math.abs(vpixels.size) : ipixels.size
            };
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, bars[i].active ? 'active' : mode);
            const options = properties.options || bars[i].options;
            $216d2bdc6f281bf6$var$setBorderSkipped(properties, options, stack, index);
            $216d2bdc6f281bf6$var$setInflateAmount(properties, options, ruler.ratio);
            this.updateElement(bars[i], i, properties, mode);
        }
    }
    _getStacks(last, dataIndex) {
        const { iScale: iScale } = this._cachedMeta;
        const metasets = iScale.getMatchingVisibleMetas(this._type).filter((meta)=>meta.controller.options.grouped);
        const stacked = iScale.options.stacked;
        const stacks = [];
        const currentParsed = this._cachedMeta.controller.getParsed(dataIndex);
        const iScaleValue = currentParsed && currentParsed[iScale.axis];
        const skipNull = (meta)=>{
            const parsed = meta._parsed.find((item)=>item[iScale.axis] === iScaleValue);
            const val = parsed && parsed[meta.vScale.axis];
            if ((0, $84f61e7391a78632$export$342063e11d6c3cad)(val) || isNaN(val)) return true;
        };
        for (const meta of metasets){
            if (dataIndex !== undefined && skipNull(meta)) continue;
            if (stacked === false || stacks.indexOf(meta.stack) === -1 || stacked === undefined && meta.stack === undefined) stacks.push(meta.stack);
            if (meta.index === last) break;
        }
        if (!stacks.length) stacks.push(undefined);
        return stacks;
    }
    _getStackCount(index) {
        return this._getStacks(undefined, index).length;
    }
    _getStackIndex(datasetIndex, name, dataIndex) {
        const stacks = this._getStacks(datasetIndex, dataIndex);
        const index = name !== undefined ? stacks.indexOf(name) : -1;
        return index === -1 ? stacks.length - 1 : index;
    }
    _getRuler() {
        const opts = this.options;
        const meta = this._cachedMeta;
        const iScale = meta.iScale;
        const pixels = [];
        let i, ilen;
        for(i = 0, ilen = meta.data.length; i < ilen; ++i)pixels.push(iScale.getPixelForValue(this.getParsed(i)[iScale.axis], i));
        const barThickness = opts.barThickness;
        const min = barThickness || $216d2bdc6f281bf6$var$computeMinSampleSize(meta);
        return {
            min: min,
            pixels: pixels,
            start: iScale._startPixel,
            end: iScale._endPixel,
            stackCount: this._getStackCount(),
            scale: iScale,
            grouped: opts.grouped,
            ratio: barThickness ? 1 : opts.categoryPercentage * opts.barPercentage
        };
    }
    _calculateBarValuePixels(index) {
        const { _cachedMeta: { vScale: vScale, _stacked: _stacked, index: datasetIndex }, options: { base: baseValue, minBarLength: minBarLength } } = this;
        const actualBase = baseValue || 0;
        const parsed = this.getParsed(index);
        const custom = parsed._custom;
        const floating = $216d2bdc6f281bf6$var$isFloatBar(custom);
        let value = parsed[vScale.axis];
        let start = 0;
        let length = _stacked ? this.applyStack(vScale, parsed, _stacked) : value;
        let head, size;
        if (length !== value) {
            start = length - value;
            length = value;
        }
        if (floating) {
            value = custom.barStart;
            length = custom.barEnd - custom.barStart;
            if (value !== 0 && (0, $84f61e7391a78632$export$2408f22a0fab9ae5)(value) !== (0, $84f61e7391a78632$export$2408f22a0fab9ae5)(custom.barEnd)) start = 0;
            start += value;
        }
        const startValue = !(0, $84f61e7391a78632$export$342063e11d6c3cad)(baseValue) && !floating ? baseValue : start;
        let base = vScale.getPixelForValue(startValue);
        if (this.chart.getDataVisibility(index)) head = vScale.getPixelForValue(start + length);
        else head = base;
        size = head - base;
        if (Math.abs(size) < minBarLength) {
            size = $216d2bdc6f281bf6$var$barSign(size, vScale, actualBase) * minBarLength;
            if (value === actualBase) base -= size / 2;
            const startPixel = vScale.getPixelForDecimal(0);
            const endPixel = vScale.getPixelForDecimal(1);
            const min = Math.min(startPixel, endPixel);
            const max = Math.max(startPixel, endPixel);
            base = Math.max(Math.min(base, max), min);
            head = base + size;
            if (_stacked && !floating) parsed._stacks[vScale.axis]._visualValues[datasetIndex] = vScale.getValueForPixel(head) - vScale.getValueForPixel(base);
        }
        if (base === vScale.getPixelForValue(actualBase)) {
            const halfGrid = (0, $84f61e7391a78632$export$2408f22a0fab9ae5)(size) * vScale.getLineWidthForValue(actualBase) / 2;
            base += halfGrid;
            size -= halfGrid;
        }
        return {
            size: size,
            base: base,
            head: head,
            center: head + size / 2
        };
    }
    _calculateBarIndexPixels(index, ruler) {
        const scale = ruler.scale;
        const options = this.options;
        const skipNull = options.skipNull;
        const maxBarThickness = (0, $84f61e7391a78632$export$90a7f3efeed30595)(options.maxBarThickness, Infinity);
        let center, size;
        if (ruler.grouped) {
            const stackCount = skipNull ? this._getStackCount(index) : ruler.stackCount;
            const range = options.barThickness === 'flex' ? $216d2bdc6f281bf6$var$computeFlexCategoryTraits(index, ruler, options, stackCount) : $216d2bdc6f281bf6$var$computeFitCategoryTraits(index, ruler, options, stackCount);
            const stackIndex = this._getStackIndex(this.index, this._cachedMeta.stack, skipNull ? index : undefined);
            center = range.start + range.chunk * stackIndex + range.chunk / 2;
            size = Math.min(maxBarThickness, range.chunk * range.ratio);
        } else {
            center = scale.getPixelForValue(this.getParsed(index)[scale.axis], index);
            size = Math.min(maxBarThickness, ruler.min * ruler.ratio);
        }
        return {
            base: center - size / 2,
            head: center + size / 2,
            center: center,
            size: size
        };
    }
    draw() {
        const meta = this._cachedMeta;
        const vScale = meta.vScale;
        const rects = meta.data;
        const ilen = rects.length;
        let i = 0;
        for(; i < ilen; ++i)if (this.getParsed(i)[vScale.axis] !== null && !rects[i].hidden) rects[i].draw(this._ctx);
    }
}
class $216d2bdc6f281bf6$export$19b5c4773f17abe extends $216d2bdc6f281bf6$export$75572ec5c55b4048 {
    static id = 'bubble';
    static defaults = {
        datasetElementType: false,
        dataElementType: 'point',
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'borderWidth',
                    'radius'
                ]
            }
        }
    };
    static overrides = {
        scales: {
            x: {
                type: 'linear'
            },
            y: {
                type: 'linear'
            }
        }
    };
    initialize() {
        this.enableOptionSharing = true;
        super.initialize();
    }
    parsePrimitiveData(meta, data, start, count) {
        const parsed = super.parsePrimitiveData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++)parsed[i]._custom = this.resolveDataElementOptions(i + start).radius;
        return parsed;
    }
    parseArrayData(meta, data, start, count) {
        const parsed = super.parseArrayData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++){
            const item = data[start + i];
            parsed[i]._custom = (0, $84f61e7391a78632$export$90a7f3efeed30595)(item[2], this.resolveDataElementOptions(i + start).radius);
        }
        return parsed;
    }
    parseObjectData(meta, data, start, count) {
        const parsed = super.parseObjectData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++){
            const item = data[start + i];
            parsed[i]._custom = (0, $84f61e7391a78632$export$90a7f3efeed30595)(item && item.r && +item.r, this.resolveDataElementOptions(i + start).radius);
        }
        return parsed;
    }
    getMaxOverflow() {
        const data = this._cachedMeta.data;
        let max = 0;
        for(let i = data.length - 1; i >= 0; --i)max = Math.max(max, data[i].size(this.resolveDataElementOptions(i)) / 2);
        return max > 0 && max;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const labels = this.chart.data.labels || [];
        const { xScale: xScale, yScale: yScale } = meta;
        const parsed = this.getParsed(index);
        const x = xScale.getLabelForValue(parsed.x);
        const y = yScale.getLabelForValue(parsed.y);
        const r = parsed._custom;
        return {
            label: labels[index] || '',
            value: '(' + x + ', ' + y + (r ? ', ' + r : '') + ')'
        };
    }
    update(mode) {
        const points = this._cachedMeta.data;
        this.updateElements(points, 0, points.length, mode);
    }
    updateElements(points, start, count, mode) {
        const reset = mode === 'reset';
        const { iScale: iScale, vScale: vScale } = this._cachedMeta;
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        for(let i = start; i < start + count; i++){
            const point = points[i];
            const parsed = !reset && this.getParsed(i);
            const properties = {};
            const iPixel = properties[iAxis] = reset ? iScale.getPixelForDecimal(0.5) : iScale.getPixelForValue(parsed[iAxis]);
            const vPixel = properties[vAxis] = reset ? vScale.getBasePixel() : vScale.getPixelForValue(parsed[vAxis]);
            properties.skip = isNaN(iPixel) || isNaN(vPixel);
            if (includeOptions) {
                properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? 'active' : mode);
                if (reset) properties.options.radius = 0;
            }
            this.updateElement(point, i, properties, mode);
        }
    }
    resolveDataElementOptions(index, mode) {
        const parsed = this.getParsed(index);
        let values = super.resolveDataElementOptions(index, mode);
        if (values.$shared) values = Object.assign({}, values, {
            $shared: false
        });
        const radius = values.radius;
        if (mode !== 'active') values.radius = 0;
        values.radius += (0, $84f61e7391a78632$export$90a7f3efeed30595)(parsed && parsed._custom, radius);
        return values;
    }
}
function $216d2bdc6f281bf6$var$getRatioAndOffset(rotation, circumference, cutout) {
    let ratioX = 1;
    let ratioY = 1;
    let offsetX = 0;
    let offsetY = 0;
    if (circumference < (0, $84f61e7391a78632$export$971d5caa766a69d7)) {
        const startAngle = rotation;
        const endAngle = startAngle + circumference;
        const startX = Math.cos(startAngle);
        const startY = Math.sin(startAngle);
        const endX = Math.cos(endAngle);
        const endY = Math.sin(endAngle);
        const calcMax = (angle, a, b)=>(0, $84f61e7391a78632$export$ffb5f4729a158638)(angle, startAngle, endAngle, true) ? 1 : Math.max(a, a * cutout, b, b * cutout);
        const calcMin = (angle, a, b)=>(0, $84f61e7391a78632$export$ffb5f4729a158638)(angle, startAngle, endAngle, true) ? -1 : Math.min(a, a * cutout, b, b * cutout);
        const maxX = calcMax(0, startX, endX);
        const maxY = calcMax((0, $84f61e7391a78632$export$7f8ddf7c7c20b3cd), startY, endY);
        const minX = calcMin((0, $84f61e7391a78632$export$56c0d5a1e737357d), startX, endX);
        const minY = calcMin((0, $84f61e7391a78632$export$56c0d5a1e737357d) + (0, $84f61e7391a78632$export$7f8ddf7c7c20b3cd), startY, endY);
        ratioX = (maxX - minX) / 2;
        ratioY = (maxY - minY) / 2;
        offsetX = -(maxX + minX) / 2;
        offsetY = -(maxY + minY) / 2;
    }
    return {
        ratioX: ratioX,
        ratioY: ratioY,
        offsetX: offsetX,
        offsetY: offsetY
    };
}
class $216d2bdc6f281bf6$export$e04603e7d8b77172 extends $216d2bdc6f281bf6$export$75572ec5c55b4048 {
    static id = 'doughnut';
    static defaults = {
        datasetElementType: false,
        dataElementType: 'arc',
        animation: {
            animateRotate: true,
            animateScale: false
        },
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'circumference',
                    'endAngle',
                    'innerRadius',
                    'outerRadius',
                    'startAngle',
                    'x',
                    'y',
                    'offset',
                    'borderWidth',
                    'spacing'
                ]
            }
        },
        cutout: '50%',
        rotation: 0,
        circumference: 360,
        radius: '100%',
        spacing: 0,
        indexAxis: 'r'
    };
    static descriptors = {
        _scriptable: (name)=>name !== 'spacing',
        _indexable: (name)=>name !== 'spacing' && !name.startsWith('borderDash') && !name.startsWith('hoverBorderDash')
    };
    static overrides = {
        aspectRatio: 1,
        plugins: {
            legend: {
                labels: {
                    generateLabels (chart) {
                        const data = chart.data;
                        if (data.labels.length && data.datasets.length) {
                            const { labels: { pointStyle: pointStyle, color: color } } = chart.legend.options;
                            return data.labels.map((label, i)=>{
                                const meta = chart.getDatasetMeta(0);
                                const style = meta.controller.getStyle(i);
                                return {
                                    text: label,
                                    fillStyle: style.backgroundColor,
                                    strokeStyle: style.borderColor,
                                    fontColor: color,
                                    lineWidth: style.borderWidth,
                                    pointStyle: pointStyle,
                                    hidden: !chart.getDataVisibility(i),
                                    index: i
                                };
                            });
                        }
                        return [];
                    }
                },
                onClick (e, legendItem, legend) {
                    legend.chart.toggleDataVisibility(legendItem.index);
                    legend.chart.update();
                }
            }
        }
    };
    constructor(chart, datasetIndex){
        super(chart, datasetIndex);
        this.enableOptionSharing = true;
        this.innerRadius = undefined;
        this.outerRadius = undefined;
        this.offsetX = undefined;
        this.offsetY = undefined;
    }
    linkScales() {}
    parse(start, count) {
        const data = this.getDataset().data;
        const meta = this._cachedMeta;
        if (this._parsing === false) meta._parsed = data;
        else {
            let getter = (i)=>+data[i];
            if ((0, $84f61e7391a78632$export$23f2a1d2818174ef)(data[start])) {
                const { key: key = 'value' } = this._parsing;
                getter = (i)=>+(0, $84f61e7391a78632$export$2d1720544b23b823)(data[i], key);
            }
            let i, ilen;
            for(i = start, ilen = start + count; i < ilen; ++i)meta._parsed[i] = getter(i);
        }
    }
    _getRotation() {
        return (0, $84f61e7391a78632$export$625550452a3fa3ec)(this.options.rotation - 90);
    }
    _getCircumference() {
        return (0, $84f61e7391a78632$export$625550452a3fa3ec)(this.options.circumference);
    }
    _getRotationExtents() {
        let min = (0, $84f61e7391a78632$export$971d5caa766a69d7);
        let max = -(0, $84f61e7391a78632$export$971d5caa766a69d7);
        for(let i = 0; i < this.chart.data.datasets.length; ++i)if (this.chart.isDatasetVisible(i) && this.chart.getDatasetMeta(i).type === this._type) {
            const controller = this.chart.getDatasetMeta(i).controller;
            const rotation = controller._getRotation();
            const circumference = controller._getCircumference();
            min = Math.min(min, rotation);
            max = Math.max(max, rotation + circumference);
        }
        return {
            rotation: min,
            circumference: max - min
        };
    }
    update(mode) {
        const chart = this.chart;
        const { chartArea: chartArea } = chart;
        const meta = this._cachedMeta;
        const arcs = meta.data;
        const spacing = this.getMaxBorderWidth() + this.getMaxOffset(arcs) + this.options.spacing;
        const maxSize = Math.max((Math.min(chartArea.width, chartArea.height) - spacing) / 2, 0);
        const cutout = Math.min((0, $84f61e7391a78632$export$953cecd6e717a553)(this.options.cutout, maxSize), 1);
        const chartWeight = this._getRingWeight(this.index);
        const { circumference: circumference, rotation: rotation } = this._getRotationExtents();
        const { ratioX: ratioX, ratioY: ratioY, offsetX: offsetX, offsetY: offsetY } = $216d2bdc6f281bf6$var$getRatioAndOffset(rotation, circumference, cutout);
        const maxWidth = (chartArea.width - spacing) / ratioX;
        const maxHeight = (chartArea.height - spacing) / ratioY;
        const maxRadius = Math.max(Math.min(maxWidth, maxHeight) / 2, 0);
        const outerRadius = (0, $84f61e7391a78632$export$7ccc53e8f1e7dfc5)(this.options.radius, maxRadius);
        const innerRadius = Math.max(outerRadius * cutout, 0);
        const radiusLength = (outerRadius - innerRadius) / this._getVisibleDatasetWeightTotal();
        this.offsetX = offsetX * outerRadius;
        this.offsetY = offsetY * outerRadius;
        meta.total = this.calculateTotal();
        this.outerRadius = outerRadius - radiusLength * this._getRingWeightOffset(this.index);
        this.innerRadius = Math.max(this.outerRadius - radiusLength * chartWeight, 0);
        this.updateElements(arcs, 0, arcs.length, mode);
    }
    _circumference(i, reset) {
        const opts = this.options;
        const meta = this._cachedMeta;
        const circumference = this._getCircumference();
        if (reset && opts.animation.animateRotate || !this.chart.getDataVisibility(i) || meta._parsed[i] === null || meta.data[i].hidden) return 0;
        return this.calculateCircumference(meta._parsed[i] * circumference / (0, $84f61e7391a78632$export$971d5caa766a69d7));
    }
    updateElements(arcs, start, count, mode) {
        const reset = mode === 'reset';
        const chart = this.chart;
        const chartArea = chart.chartArea;
        const opts = chart.options;
        const animationOpts = opts.animation;
        const centerX = (chartArea.left + chartArea.right) / 2;
        const centerY = (chartArea.top + chartArea.bottom) / 2;
        const animateScale = reset && animationOpts.animateScale;
        const innerRadius = animateScale ? 0 : this.innerRadius;
        const outerRadius = animateScale ? 0 : this.outerRadius;
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        let startAngle = this._getRotation();
        let i;
        for(i = 0; i < start; ++i)startAngle += this._circumference(i, reset);
        for(i = start; i < start + count; ++i){
            const circumference = this._circumference(i, reset);
            const arc = arcs[i];
            const properties = {
                x: centerX + this.offsetX,
                y: centerY + this.offsetY,
                startAngle: startAngle,
                endAngle: startAngle + circumference,
                circumference: circumference,
                outerRadius: outerRadius,
                innerRadius: innerRadius
            };
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, arc.active ? 'active' : mode);
            startAngle += circumference;
            this.updateElement(arc, i, properties, mode);
        }
    }
    calculateTotal() {
        const meta = this._cachedMeta;
        const metaData = meta.data;
        let total = 0;
        let i;
        for(i = 0; i < metaData.length; i++){
            const value = meta._parsed[i];
            if (value !== null && !isNaN(value) && this.chart.getDataVisibility(i) && !metaData[i].hidden) total += Math.abs(value);
        }
        return total;
    }
    calculateCircumference(value) {
        const total = this._cachedMeta.total;
        if (total > 0 && !isNaN(value)) return (0, $84f61e7391a78632$export$971d5caa766a69d7) * (Math.abs(value) / total);
        return 0;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const chart = this.chart;
        const labels = chart.data.labels || [];
        const value = (0, $84f61e7391a78632$export$ae1af26003f05816)(meta._parsed[index], chart.options.locale);
        return {
            label: labels[index] || '',
            value: value
        };
    }
    getMaxBorderWidth(arcs) {
        let max = 0;
        const chart = this.chart;
        let i, ilen, meta, controller, options;
        if (!arcs) {
            for(i = 0, ilen = chart.data.datasets.length; i < ilen; ++i)if (chart.isDatasetVisible(i)) {
                meta = chart.getDatasetMeta(i);
                arcs = meta.data;
                controller = meta.controller;
                break;
            }
        }
        if (!arcs) return 0;
        for(i = 0, ilen = arcs.length; i < ilen; ++i){
            options = controller.resolveDataElementOptions(i);
            if (options.borderAlign !== 'inner') max = Math.max(max, options.borderWidth || 0, options.hoverBorderWidth || 0);
        }
        return max;
    }
    getMaxOffset(arcs) {
        let max = 0;
        for(let i = 0, ilen = arcs.length; i < ilen; ++i){
            const options = this.resolveDataElementOptions(i);
            max = Math.max(max, options.offset || 0, options.hoverOffset || 0);
        }
        return max;
    }
    _getRingWeightOffset(datasetIndex) {
        let ringWeightOffset = 0;
        for(let i = 0; i < datasetIndex; ++i)if (this.chart.isDatasetVisible(i)) ringWeightOffset += this._getRingWeight(i);
        return ringWeightOffset;
    }
    _getRingWeight(datasetIndex) {
        return Math.max((0, $84f61e7391a78632$export$90a7f3efeed30595)(this.chart.data.datasets[datasetIndex].weight, 1), 0);
    }
    _getVisibleDatasetWeightTotal() {
        return this._getRingWeightOffset(this.chart.data.datasets.length) || 1;
    }
}
class $216d2bdc6f281bf6$export$3c9b5d28c11cbfd0 extends $216d2bdc6f281bf6$export$75572ec5c55b4048 {
    static id = 'line';
    static defaults = {
        datasetElementType: 'line',
        dataElementType: 'point',
        showLine: true,
        spanGaps: false
    };
    static overrides = {
        scales: {
            _index_: {
                type: 'category'
            },
            _value_: {
                type: 'linear'
            }
        }
    };
    initialize() {
        this.enableOptionSharing = true;
        this.supportsDecimation = true;
        super.initialize();
    }
    update(mode) {
        const meta = this._cachedMeta;
        const { dataset: line, data: points = [], _dataset: _dataset } = meta;
        const animationsDisabled = this.chart._animationsDisabled;
        let { start: start, count: count } = (0, $84f61e7391a78632$export$9e5f44173e64f162)(meta, points, animationsDisabled);
        this._drawStart = start;
        this._drawCount = count;
        if ((0, $84f61e7391a78632$export$efccba1c4a2ef57b)(meta)) {
            start = 0;
            count = points.length;
        }
        line._chart = this.chart;
        line._datasetIndex = this.index;
        line._decimated = !!_dataset._decimated;
        line.points = points;
        const options = this.resolveDatasetElementOptions(mode);
        if (!this.options.showLine) options.borderWidth = 0;
        options.segment = this.options.segment;
        this.updateElement(line, undefined, {
            animated: !animationsDisabled,
            options: options
        }, mode);
        this.updateElements(points, start, count, mode);
    }
    updateElements(points, start, count, mode) {
        const reset = mode === 'reset';
        const { iScale: iScale, vScale: vScale, _stacked: _stacked, _dataset: _dataset } = this._cachedMeta;
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const { spanGaps: spanGaps, segment: segment } = this.options;
        const maxGapLength = (0, $84f61e7391a78632$export$d141bba7fdc215a3)(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
        const directUpdate = this.chart._animationsDisabled || reset || mode === 'none';
        const end = start + count;
        const pointsCount = points.length;
        let prevParsed = start > 0 && this.getParsed(start - 1);
        for(let i = 0; i < pointsCount; ++i){
            const point = points[i];
            const properties = directUpdate ? point : {};
            if (i < start || i >= end) {
                properties.skip = true;
                continue;
            }
            const parsed = this.getParsed(i);
            const nullData = (0, $84f61e7391a78632$export$342063e11d6c3cad)(parsed[vAxis]);
            const iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
            const vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
            properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
            properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
            if (segment) {
                properties.parsed = parsed;
                properties.raw = _dataset.data[i];
            }
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? 'active' : mode);
            if (!directUpdate) this.updateElement(point, i, properties, mode);
            prevParsed = parsed;
        }
    }
    getMaxOverflow() {
        const meta = this._cachedMeta;
        const dataset = meta.dataset;
        const border = dataset.options && dataset.options.borderWidth || 0;
        const data = meta.data || [];
        if (!data.length) return border;
        const firstPoint = data[0].size(this.resolveDataElementOptions(0));
        const lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
        return Math.max(border, firstPoint, lastPoint) / 2;
    }
    draw() {
        const meta = this._cachedMeta;
        meta.dataset.updateControlPoints(this.chart.chartArea, meta.iScale.axis);
        super.draw();
    }
}
class $216d2bdc6f281bf6$export$2a270b3a0d973c85 extends $216d2bdc6f281bf6$export$75572ec5c55b4048 {
    static id = 'polarArea';
    static defaults = {
        dataElementType: 'arc',
        animation: {
            animateRotate: true,
            animateScale: true
        },
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'startAngle',
                    'endAngle',
                    'innerRadius',
                    'outerRadius'
                ]
            }
        },
        indexAxis: 'r',
        startAngle: 0
    };
    static overrides = {
        aspectRatio: 1,
        plugins: {
            legend: {
                labels: {
                    generateLabels (chart) {
                        const data = chart.data;
                        if (data.labels.length && data.datasets.length) {
                            const { labels: { pointStyle: pointStyle, color: color } } = chart.legend.options;
                            return data.labels.map((label, i)=>{
                                const meta = chart.getDatasetMeta(0);
                                const style = meta.controller.getStyle(i);
                                return {
                                    text: label,
                                    fillStyle: style.backgroundColor,
                                    strokeStyle: style.borderColor,
                                    fontColor: color,
                                    lineWidth: style.borderWidth,
                                    pointStyle: pointStyle,
                                    hidden: !chart.getDataVisibility(i),
                                    index: i
                                };
                            });
                        }
                        return [];
                    }
                },
                onClick (e, legendItem, legend) {
                    legend.chart.toggleDataVisibility(legendItem.index);
                    legend.chart.update();
                }
            }
        },
        scales: {
            r: {
                type: 'radialLinear',
                angleLines: {
                    display: false
                },
                beginAtZero: true,
                grid: {
                    circular: true
                },
                pointLabels: {
                    display: false
                },
                startAngle: 0
            }
        }
    };
    constructor(chart, datasetIndex){
        super(chart, datasetIndex);
        this.innerRadius = undefined;
        this.outerRadius = undefined;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const chart = this.chart;
        const labels = chart.data.labels || [];
        const value = (0, $84f61e7391a78632$export$ae1af26003f05816)(meta._parsed[index].r, chart.options.locale);
        return {
            label: labels[index] || '',
            value: value
        };
    }
    parseObjectData(meta, data, start, count) {
        return (0, $84f61e7391a78632$export$4a5767248b18ef41).bind(this)(meta, data, start, count);
    }
    update(mode) {
        const arcs = this._cachedMeta.data;
        this._updateRadius();
        this.updateElements(arcs, 0, arcs.length, mode);
    }
    getMinMax() {
        const meta = this._cachedMeta;
        const range = {
            min: Number.POSITIVE_INFINITY,
            max: Number.NEGATIVE_INFINITY
        };
        meta.data.forEach((element, index)=>{
            const parsed = this.getParsed(index).r;
            if (!isNaN(parsed) && this.chart.getDataVisibility(index)) {
                if (parsed < range.min) range.min = parsed;
                if (parsed > range.max) range.max = parsed;
            }
        });
        return range;
    }
    _updateRadius() {
        const chart = this.chart;
        const chartArea = chart.chartArea;
        const opts = chart.options;
        const minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
        const outerRadius = Math.max(minSize / 2, 0);
        const innerRadius = Math.max(opts.cutoutPercentage ? outerRadius / 100 * opts.cutoutPercentage : 1, 0);
        const radiusLength = (outerRadius - innerRadius) / chart.getVisibleDatasetCount();
        this.outerRadius = outerRadius - radiusLength * this.index;
        this.innerRadius = this.outerRadius - radiusLength;
    }
    updateElements(arcs, start, count, mode) {
        const reset = mode === 'reset';
        const chart = this.chart;
        const opts = chart.options;
        const animationOpts = opts.animation;
        const scale = this._cachedMeta.rScale;
        const centerX = scale.xCenter;
        const centerY = scale.yCenter;
        const datasetStartAngle = scale.getIndexAngle(0) - 0.5 * (0, $84f61e7391a78632$export$56c0d5a1e737357d);
        let angle = datasetStartAngle;
        let i;
        const defaultAngle = 360 / this.countVisibleElements();
        for(i = 0; i < start; ++i)angle += this._computeAngle(i, mode, defaultAngle);
        for(i = start; i < start + count; i++){
            const arc = arcs[i];
            let startAngle = angle;
            let endAngle = angle + this._computeAngle(i, mode, defaultAngle);
            let outerRadius = chart.getDataVisibility(i) ? scale.getDistanceFromCenterForValue(this.getParsed(i).r) : 0;
            angle = endAngle;
            if (reset) {
                if (animationOpts.animateScale) outerRadius = 0;
                if (animationOpts.animateRotate) startAngle = endAngle = datasetStartAngle;
            }
            const properties = {
                x: centerX,
                y: centerY,
                innerRadius: 0,
                outerRadius: outerRadius,
                startAngle: startAngle,
                endAngle: endAngle,
                options: this.resolveDataElementOptions(i, arc.active ? 'active' : mode)
            };
            this.updateElement(arc, i, properties, mode);
        }
    }
    countVisibleElements() {
        const meta = this._cachedMeta;
        let count = 0;
        meta.data.forEach((element, index)=>{
            if (!isNaN(this.getParsed(index).r) && this.chart.getDataVisibility(index)) count++;
        });
        return count;
    }
    _computeAngle(index, mode, defaultAngle) {
        return this.chart.getDataVisibility(index) ? (0, $84f61e7391a78632$export$625550452a3fa3ec)(this.resolveDataElementOptions(index, mode).angle || defaultAngle) : 0;
    }
}
class $216d2bdc6f281bf6$export$b21a3f1286706191 extends $216d2bdc6f281bf6$export$e04603e7d8b77172 {
    static id = 'pie';
    static defaults = {
        cutout: 0,
        rotation: 0,
        circumference: 360,
        radius: '100%'
    };
}
class $216d2bdc6f281bf6$export$48dbc6ac651bf8be extends $216d2bdc6f281bf6$export$75572ec5c55b4048 {
    static id = 'radar';
    static defaults = {
        datasetElementType: 'line',
        dataElementType: 'point',
        indexAxis: 'r',
        showLine: true,
        elements: {
            line: {
                fill: 'start'
            }
        }
    };
    static overrides = {
        aspectRatio: 1,
        scales: {
            r: {
                type: 'radialLinear'
            }
        }
    };
    getLabelAndValue(index) {
        const vScale = this._cachedMeta.vScale;
        const parsed = this.getParsed(index);
        return {
            label: vScale.getLabels()[index],
            value: '' + vScale.getLabelForValue(parsed[vScale.axis])
        };
    }
    parseObjectData(meta, data, start, count) {
        return (0, $84f61e7391a78632$export$4a5767248b18ef41).bind(this)(meta, data, start, count);
    }
    update(mode) {
        const meta = this._cachedMeta;
        const line = meta.dataset;
        const points = meta.data || [];
        const labels = meta.iScale.getLabels();
        line.points = points;
        if (mode !== 'resize') {
            const options = this.resolveDatasetElementOptions(mode);
            if (!this.options.showLine) options.borderWidth = 0;
            const properties = {
                _loop: true,
                _fullLoop: labels.length === points.length,
                options: options
            };
            this.updateElement(line, undefined, properties, mode);
        }
        this.updateElements(points, 0, points.length, mode);
    }
    updateElements(points, start, count, mode) {
        const scale = this._cachedMeta.rScale;
        const reset = mode === 'reset';
        for(let i = start; i < start + count; i++){
            const point = points[i];
            const options = this.resolveDataElementOptions(i, point.active ? 'active' : mode);
            const pointPosition = scale.getPointPositionForValue(i, this.getParsed(i).r);
            const x = reset ? scale.xCenter : pointPosition.x;
            const y = reset ? scale.yCenter : pointPosition.y;
            const properties = {
                x: x,
                y: y,
                angle: pointPosition.angle,
                skip: isNaN(x) || isNaN(y),
                options: options
            };
            this.updateElement(point, i, properties, mode);
        }
    }
}
class $216d2bdc6f281bf6$export$b2f2bae6713db87 extends $216d2bdc6f281bf6$export$75572ec5c55b4048 {
    static id = 'scatter';
    static defaults = {
        datasetElementType: false,
        dataElementType: 'point',
        showLine: false,
        fill: false
    };
    static overrides = {
        interaction: {
            mode: 'point'
        },
        scales: {
            x: {
                type: 'linear'
            },
            y: {
                type: 'linear'
            }
        }
    };
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const labels = this.chart.data.labels || [];
        const { xScale: xScale, yScale: yScale } = meta;
        const parsed = this.getParsed(index);
        const x = xScale.getLabelForValue(parsed.x);
        const y = yScale.getLabelForValue(parsed.y);
        return {
            label: labels[index] || '',
            value: '(' + x + ', ' + y + ')'
        };
    }
    update(mode) {
        const meta = this._cachedMeta;
        const { data: points = [] } = meta;
        const animationsDisabled = this.chart._animationsDisabled;
        let { start: start, count: count } = (0, $84f61e7391a78632$export$9e5f44173e64f162)(meta, points, animationsDisabled);
        this._drawStart = start;
        this._drawCount = count;
        if ((0, $84f61e7391a78632$export$efccba1c4a2ef57b)(meta)) {
            start = 0;
            count = points.length;
        }
        if (this.options.showLine) {
            if (!this.datasetElementType) this.addElements();
            const { dataset: line, _dataset: _dataset } = meta;
            line._chart = this.chart;
            line._datasetIndex = this.index;
            line._decimated = !!_dataset._decimated;
            line.points = points;
            const options = this.resolveDatasetElementOptions(mode);
            options.segment = this.options.segment;
            this.updateElement(line, undefined, {
                animated: !animationsDisabled,
                options: options
            }, mode);
        } else if (this.datasetElementType) {
            delete meta.dataset;
            this.datasetElementType = false;
        }
        this.updateElements(points, start, count, mode);
    }
    addElements() {
        const { showLine: showLine } = this.options;
        if (!this.datasetElementType && showLine) this.datasetElementType = this.chart.registry.getElement('line');
        super.addElements();
    }
    updateElements(points, start, count, mode) {
        const reset = mode === 'reset';
        const { iScale: iScale, vScale: vScale, _stacked: _stacked, _dataset: _dataset } = this._cachedMeta;
        const firstOpts = this.resolveDataElementOptions(start, mode);
        const sharedOptions = this.getSharedOptions(firstOpts);
        const includeOptions = this.includeOptions(mode, sharedOptions);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const { spanGaps: spanGaps, segment: segment } = this.options;
        const maxGapLength = (0, $84f61e7391a78632$export$d141bba7fdc215a3)(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
        const directUpdate = this.chart._animationsDisabled || reset || mode === 'none';
        let prevParsed = start > 0 && this.getParsed(start - 1);
        for(let i = start; i < start + count; ++i){
            const point = points[i];
            const parsed = this.getParsed(i);
            const properties = directUpdate ? point : {};
            const nullData = (0, $84f61e7391a78632$export$342063e11d6c3cad)(parsed[vAxis]);
            const iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
            const vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
            properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
            properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
            if (segment) {
                properties.parsed = parsed;
                properties.raw = _dataset.data[i];
            }
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? 'active' : mode);
            if (!directUpdate) this.updateElement(point, i, properties, mode);
            prevParsed = parsed;
        }
        this.updateSharedOptions(sharedOptions, mode, firstOpts);
    }
    getMaxOverflow() {
        const meta = this._cachedMeta;
        const data = meta.data || [];
        if (!this.options.showLine) {
            let max = 0;
            for(let i = data.length - 1; i >= 0; --i)max = Math.max(max, data[i].size(this.resolveDataElementOptions(i)) / 2);
            return max > 0 && max;
        }
        const dataset = meta.dataset;
        const border = dataset.options && dataset.options.borderWidth || 0;
        if (!data.length) return border;
        const firstPoint = data[0].size(this.resolveDataElementOptions(0));
        const lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
        return Math.max(border, firstPoint, lastPoint) / 2;
    }
}
var $216d2bdc6f281bf6$export$a6506504f799c5d5 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    BarController: $216d2bdc6f281bf6$export$e97d5dc64e999004,
    BubbleController: $216d2bdc6f281bf6$export$19b5c4773f17abe,
    DoughnutController: $216d2bdc6f281bf6$export$e04603e7d8b77172,
    LineController: $216d2bdc6f281bf6$export$3c9b5d28c11cbfd0,
    PieController: $216d2bdc6f281bf6$export$b21a3f1286706191,
    PolarAreaController: $216d2bdc6f281bf6$export$2a270b3a0d973c85,
    RadarController: $216d2bdc6f281bf6$export$48dbc6ac651bf8be,
    ScatterController: $216d2bdc6f281bf6$export$b2f2bae6713db87
});
/**
 * @namespace Chart._adapters
 * @since 2.8.0
 * @private
 */ function $216d2bdc6f281bf6$var$abstract() {
    throw new Error('This method is not implemented: Check that a complete date adapter is provided.');
}
/**
 * Date adapter (current used by the time scale)
 * @namespace Chart._adapters._date
 * @memberof Chart._adapters
 * @private
 */ class $216d2bdc6f281bf6$var$DateAdapterBase {
    /**
   * Override default date adapter methods.
   * Accepts type parameter to define options type.
   * @example
   * Chart._adapters._date.override<{myAdapterOption: string}>({
   *   init() {
   *     console.log(this.options.myAdapterOption);
   *   }
   * })
   */ static override(members) {
        Object.assign($216d2bdc6f281bf6$var$DateAdapterBase.prototype, members);
    }
    options;
    constructor(options){
        this.options = options || {};
    }
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    init() {}
    formats() {
        return $216d2bdc6f281bf6$var$abstract();
    }
    parse() {
        return $216d2bdc6f281bf6$var$abstract();
    }
    format() {
        return $216d2bdc6f281bf6$var$abstract();
    }
    add() {
        return $216d2bdc6f281bf6$var$abstract();
    }
    diff() {
        return $216d2bdc6f281bf6$var$abstract();
    }
    startOf() {
        return $216d2bdc6f281bf6$var$abstract();
    }
    endOf() {
        return $216d2bdc6f281bf6$var$abstract();
    }
}
var $216d2bdc6f281bf6$export$f32766ea09ec8bc4 = {
    _date: $216d2bdc6f281bf6$var$DateAdapterBase
};
function $216d2bdc6f281bf6$var$binarySearch(metaset, axis, value, intersect) {
    const { controller: controller, data: data, _sorted: _sorted } = metaset;
    const iScale = controller._cachedMeta.iScale;
    const spanGaps = metaset.dataset ? metaset.dataset.options ? metaset.dataset.options.spanGaps : null : null;
    if (iScale && axis === iScale.axis && axis !== 'r' && _sorted && data.length) {
        const lookupMethod = iScale._reversePixels ? (0, $84f61e7391a78632$export$ebd11618f299a286) : (0, $84f61e7391a78632$export$ef35774e6d314e91);
        if (!intersect) {
            const result = lookupMethod(data, axis, value);
            if (spanGaps) {
                const { vScale: vScale } = controller._cachedMeta;
                const { _parsed: _parsed } = metaset;
                const distanceToDefinedLo = _parsed.slice(0, result.lo + 1).reverse().findIndex((point)=>!(0, $84f61e7391a78632$export$342063e11d6c3cad)(point[vScale.axis]));
                result.lo -= Math.max(0, distanceToDefinedLo);
                const distanceToDefinedHi = _parsed.slice(result.hi).findIndex((point)=>!(0, $84f61e7391a78632$export$342063e11d6c3cad)(point[vScale.axis]));
                result.hi += Math.max(0, distanceToDefinedHi);
            }
            return result;
        } else if (controller._sharedOptions) {
            const el = data[0];
            const range = typeof el.getRange === 'function' && el.getRange(axis);
            if (range) {
                const start = lookupMethod(data, axis, value - range);
                const end = lookupMethod(data, axis, value + range);
                return {
                    lo: start.lo,
                    hi: end.hi
                };
            }
        }
    }
    return {
        lo: 0,
        hi: data.length - 1
    };
}
function $216d2bdc6f281bf6$var$evaluateInteractionItems(chart, axis, position, handler, intersect) {
    const metasets = chart.getSortedVisibleDatasetMetas();
    const value = position[axis];
    for(let i = 0, ilen = metasets.length; i < ilen; ++i){
        const { index: index, data: data } = metasets[i];
        const { lo: lo, hi: hi } = $216d2bdc6f281bf6$var$binarySearch(metasets[i], axis, value, intersect);
        for(let j = lo; j <= hi; ++j){
            const element = data[j];
            if (!element.skip) handler(element, index, j);
        }
    }
}
function $216d2bdc6f281bf6$var$getDistanceMetricForAxis(axis) {
    const useX = axis.indexOf('x') !== -1;
    const useY = axis.indexOf('y') !== -1;
    return function(pt1, pt2) {
        const deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
        const deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
        return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
    };
}
function $216d2bdc6f281bf6$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) {
    const items = [];
    if (!includeInvisible && !chart.isPointInArea(position)) return items;
    const evaluationFunc = function(element, datasetIndex, index) {
        if (!includeInvisible && !(0, $84f61e7391a78632$export$e7094788287c5e9b)(element, chart.chartArea, 0)) return;
        if (element.inRange(position.x, position.y, useFinalPosition)) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    };
    $216d2bdc6f281bf6$var$evaluateInteractionItems(chart, axis, position, evaluationFunc, true);
    return items;
}
function $216d2bdc6f281bf6$var$getNearestRadialItems(chart, position, axis, useFinalPosition) {
    let items = [];
    function evaluationFunc(element, datasetIndex, index) {
        const { startAngle: startAngle, endAngle: endAngle } = element.getProps([
            'startAngle',
            'endAngle'
        ], useFinalPosition);
        const { angle: angle } = (0, $84f61e7391a78632$export$96f57966bedc81b4)(element, {
            x: position.x,
            y: position.y
        });
        if ((0, $84f61e7391a78632$export$ffb5f4729a158638)(angle, startAngle, endAngle)) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    }
    $216d2bdc6f281bf6$var$evaluateInteractionItems(chart, axis, position, evaluationFunc);
    return items;
}
function $216d2bdc6f281bf6$var$getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
    let items = [];
    const distanceMetric = $216d2bdc6f281bf6$var$getDistanceMetricForAxis(axis);
    let minDistance = Number.POSITIVE_INFINITY;
    function evaluationFunc(element, datasetIndex, index) {
        const inRange = element.inRange(position.x, position.y, useFinalPosition);
        if (intersect && !inRange) return;
        const center = element.getCenterPoint(useFinalPosition);
        const pointInArea = !!includeInvisible || chart.isPointInArea(center);
        if (!pointInArea && !inRange) return;
        const distance = distanceMetric(position, center);
        if (distance < minDistance) {
            items = [
                {
                    element: element,
                    datasetIndex: datasetIndex,
                    index: index
                }
            ];
            minDistance = distance;
        } else if (distance === minDistance) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    }
    $216d2bdc6f281bf6$var$evaluateInteractionItems(chart, axis, position, evaluationFunc);
    return items;
}
function $216d2bdc6f281bf6$var$getNearestItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
    if (!includeInvisible && !chart.isPointInArea(position)) return [];
    return axis === 'r' && !intersect ? $216d2bdc6f281bf6$var$getNearestRadialItems(chart, position, axis, useFinalPosition) : $216d2bdc6f281bf6$var$getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible);
}
function $216d2bdc6f281bf6$var$getAxisItems(chart, position, axis, intersect, useFinalPosition) {
    const items = [];
    const rangeMethod = axis === 'x' ? 'inXRange' : 'inYRange';
    let intersectsItem = false;
    $216d2bdc6f281bf6$var$evaluateInteractionItems(chart, axis, position, (element, datasetIndex, index)=>{
        if (element[rangeMethod] && element[rangeMethod](position[axis], useFinalPosition)) {
            items.push({
                element: element,
                datasetIndex: datasetIndex,
                index: index
            });
            intersectsItem = intersectsItem || element.inRange(position.x, position.y, useFinalPosition);
        }
    });
    if (intersect && !intersectsItem) return [];
    return items;
}
var $216d2bdc6f281bf6$export$a13296960cae0384 = {
    evaluateInteractionItems: $216d2bdc6f281bf6$var$evaluateInteractionItems,
    modes: {
        index (chart, e, options, useFinalPosition) {
            const position = (0, $84f61e7391a78632$export$df995fae86a55f06)(e, chart);
            const axis = options.axis || 'x';
            const includeInvisible = options.includeInvisible || false;
            const items = options.intersect ? $216d2bdc6f281bf6$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : $216d2bdc6f281bf6$var$getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
            const elements = [];
            if (!items.length) return [];
            chart.getSortedVisibleDatasetMetas().forEach((meta)=>{
                const index = items[0].index;
                const element = meta.data[index];
                if (element && !element.skip) elements.push({
                    element: element,
                    datasetIndex: meta.index,
                    index: index
                });
            });
            return elements;
        },
        dataset (chart, e, options, useFinalPosition) {
            const position = (0, $84f61e7391a78632$export$df995fae86a55f06)(e, chart);
            const axis = options.axis || 'xy';
            const includeInvisible = options.includeInvisible || false;
            let items = options.intersect ? $216d2bdc6f281bf6$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : $216d2bdc6f281bf6$var$getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
            if (items.length > 0) {
                const datasetIndex = items[0].datasetIndex;
                const data = chart.getDatasetMeta(datasetIndex).data;
                items = [];
                for(let i = 0; i < data.length; ++i)items.push({
                    element: data[i],
                    datasetIndex: datasetIndex,
                    index: i
                });
            }
            return items;
        },
        point (chart, e, options, useFinalPosition) {
            const position = (0, $84f61e7391a78632$export$df995fae86a55f06)(e, chart);
            const axis = options.axis || 'xy';
            const includeInvisible = options.includeInvisible || false;
            return $216d2bdc6f281bf6$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible);
        },
        nearest (chart, e, options, useFinalPosition) {
            const position = (0, $84f61e7391a78632$export$df995fae86a55f06)(e, chart);
            const axis = options.axis || 'xy';
            const includeInvisible = options.includeInvisible || false;
            return $216d2bdc6f281bf6$var$getNearestItems(chart, position, axis, options.intersect, useFinalPosition, includeInvisible);
        },
        x (chart, e, options, useFinalPosition) {
            const position = (0, $84f61e7391a78632$export$df995fae86a55f06)(e, chart);
            return $216d2bdc6f281bf6$var$getAxisItems(chart, position, 'x', options.intersect, useFinalPosition);
        },
        y (chart, e, options, useFinalPosition) {
            const position = (0, $84f61e7391a78632$export$df995fae86a55f06)(e, chart);
            return $216d2bdc6f281bf6$var$getAxisItems(chart, position, 'y', options.intersect, useFinalPosition);
        }
    }
};
const $216d2bdc6f281bf6$var$STATIC_POSITIONS = [
    'left',
    'top',
    'right',
    'bottom'
];
function $216d2bdc6f281bf6$var$filterByPosition(array, position) {
    return array.filter((v)=>v.pos === position);
}
function $216d2bdc6f281bf6$var$filterDynamicPositionByAxis(array, axis) {
    return array.filter((v)=>$216d2bdc6f281bf6$var$STATIC_POSITIONS.indexOf(v.pos) === -1 && v.box.axis === axis);
}
function $216d2bdc6f281bf6$var$sortByWeight(array, reverse) {
    return array.sort((a, b)=>{
        const v0 = reverse ? b : a;
        const v1 = reverse ? a : b;
        return v0.weight === v1.weight ? v0.index - v1.index : v0.weight - v1.weight;
    });
}
function $216d2bdc6f281bf6$var$wrapBoxes(boxes) {
    const layoutBoxes = [];
    let i, ilen, box, pos, stack, stackWeight;
    for(i = 0, ilen = (boxes || []).length; i < ilen; ++i){
        box = boxes[i];
        ({ position: pos, options: { stack: stack, stackWeight: stackWeight = 1 } } = box);
        layoutBoxes.push({
            index: i,
            box: box,
            pos: pos,
            horizontal: box.isHorizontal(),
            weight: box.weight,
            stack: stack && pos + stack,
            stackWeight: stackWeight
        });
    }
    return layoutBoxes;
}
function $216d2bdc6f281bf6$var$buildStacks(layouts) {
    const stacks = {};
    for (const wrap of layouts){
        const { stack: stack, pos: pos, stackWeight: stackWeight } = wrap;
        if (!stack || !$216d2bdc6f281bf6$var$STATIC_POSITIONS.includes(pos)) continue;
        const _stack = stacks[stack] || (stacks[stack] = {
            count: 0,
            placed: 0,
            weight: 0,
            size: 0
        });
        _stack.count++;
        _stack.weight += stackWeight;
    }
    return stacks;
}
function $216d2bdc6f281bf6$var$setLayoutDims(layouts, params) {
    const stacks = $216d2bdc6f281bf6$var$buildStacks(layouts);
    const { vBoxMaxWidth: vBoxMaxWidth, hBoxMaxHeight: hBoxMaxHeight } = params;
    let i, ilen, layout;
    for(i = 0, ilen = layouts.length; i < ilen; ++i){
        layout = layouts[i];
        const { fullSize: fullSize } = layout.box;
        const stack = stacks[layout.stack];
        const factor = stack && layout.stackWeight / stack.weight;
        if (layout.horizontal) {
            layout.width = factor ? factor * vBoxMaxWidth : fullSize && params.availableWidth;
            layout.height = hBoxMaxHeight;
        } else {
            layout.width = vBoxMaxWidth;
            layout.height = factor ? factor * hBoxMaxHeight : fullSize && params.availableHeight;
        }
    }
    return stacks;
}
function $216d2bdc6f281bf6$var$buildLayoutBoxes(boxes) {
    const layoutBoxes = $216d2bdc6f281bf6$var$wrapBoxes(boxes);
    const fullSize = $216d2bdc6f281bf6$var$sortByWeight(layoutBoxes.filter((wrap)=>wrap.box.fullSize), true);
    const left = $216d2bdc6f281bf6$var$sortByWeight($216d2bdc6f281bf6$var$filterByPosition(layoutBoxes, 'left'), true);
    const right = $216d2bdc6f281bf6$var$sortByWeight($216d2bdc6f281bf6$var$filterByPosition(layoutBoxes, 'right'));
    const top = $216d2bdc6f281bf6$var$sortByWeight($216d2bdc6f281bf6$var$filterByPosition(layoutBoxes, 'top'), true);
    const bottom = $216d2bdc6f281bf6$var$sortByWeight($216d2bdc6f281bf6$var$filterByPosition(layoutBoxes, 'bottom'));
    const centerHorizontal = $216d2bdc6f281bf6$var$filterDynamicPositionByAxis(layoutBoxes, 'x');
    const centerVertical = $216d2bdc6f281bf6$var$filterDynamicPositionByAxis(layoutBoxes, 'y');
    return {
        fullSize: fullSize,
        leftAndTop: left.concat(top),
        rightAndBottom: right.concat(centerVertical).concat(bottom).concat(centerHorizontal),
        chartArea: $216d2bdc6f281bf6$var$filterByPosition(layoutBoxes, 'chartArea'),
        vertical: left.concat(right).concat(centerVertical),
        horizontal: top.concat(bottom).concat(centerHorizontal)
    };
}
function $216d2bdc6f281bf6$var$getCombinedMax(maxPadding, chartArea, a, b) {
    return Math.max(maxPadding[a], chartArea[a]) + Math.max(maxPadding[b], chartArea[b]);
}
function $216d2bdc6f281bf6$var$updateMaxPadding(maxPadding, boxPadding) {
    maxPadding.top = Math.max(maxPadding.top, boxPadding.top);
    maxPadding.left = Math.max(maxPadding.left, boxPadding.left);
    maxPadding.bottom = Math.max(maxPadding.bottom, boxPadding.bottom);
    maxPadding.right = Math.max(maxPadding.right, boxPadding.right);
}
function $216d2bdc6f281bf6$var$updateDims(chartArea, params, layout, stacks) {
    const { pos: pos, box: box } = layout;
    const maxPadding = chartArea.maxPadding;
    if (!(0, $84f61e7391a78632$export$23f2a1d2818174ef)(pos)) {
        if (layout.size) chartArea[pos] -= layout.size;
        const stack = stacks[layout.stack] || {
            size: 0,
            count: 1
        };
        stack.size = Math.max(stack.size, layout.horizontal ? box.height : box.width);
        layout.size = stack.size / stack.count;
        chartArea[pos] += layout.size;
    }
    if (box.getPadding) $216d2bdc6f281bf6$var$updateMaxPadding(maxPadding, box.getPadding());
    const newWidth = Math.max(0, params.outerWidth - $216d2bdc6f281bf6$var$getCombinedMax(maxPadding, chartArea, 'left', 'right'));
    const newHeight = Math.max(0, params.outerHeight - $216d2bdc6f281bf6$var$getCombinedMax(maxPadding, chartArea, 'top', 'bottom'));
    const widthChanged = newWidth !== chartArea.w;
    const heightChanged = newHeight !== chartArea.h;
    chartArea.w = newWidth;
    chartArea.h = newHeight;
    return layout.horizontal ? {
        same: widthChanged,
        other: heightChanged
    } : {
        same: heightChanged,
        other: widthChanged
    };
}
function $216d2bdc6f281bf6$var$handleMaxPadding(chartArea) {
    const maxPadding = chartArea.maxPadding;
    function updatePos(pos) {
        const change = Math.max(maxPadding[pos] - chartArea[pos], 0);
        chartArea[pos] += change;
        return change;
    }
    chartArea.y += updatePos('top');
    chartArea.x += updatePos('left');
    updatePos('right');
    updatePos('bottom');
}
function $216d2bdc6f281bf6$var$getMargins(horizontal, chartArea) {
    const maxPadding = chartArea.maxPadding;
    function marginForPositions(positions) {
        const margin = {
            left: 0,
            top: 0,
            right: 0,
            bottom: 0
        };
        positions.forEach((pos)=>{
            margin[pos] = Math.max(chartArea[pos], maxPadding[pos]);
        });
        return margin;
    }
    return horizontal ? marginForPositions([
        'left',
        'right'
    ]) : marginForPositions([
        'top',
        'bottom'
    ]);
}
function $216d2bdc6f281bf6$var$fitBoxes(boxes, chartArea, params, stacks) {
    const refitBoxes = [];
    let i, ilen, layout, box, refit, changed;
    for(i = 0, ilen = boxes.length, refit = 0; i < ilen; ++i){
        layout = boxes[i];
        box = layout.box;
        box.update(layout.width || chartArea.w, layout.height || chartArea.h, $216d2bdc6f281bf6$var$getMargins(layout.horizontal, chartArea));
        const { same: same, other: other } = $216d2bdc6f281bf6$var$updateDims(chartArea, params, layout, stacks);
        refit |= same && refitBoxes.length;
        changed = changed || other;
        if (!box.fullSize) refitBoxes.push(layout);
    }
    return refit && $216d2bdc6f281bf6$var$fitBoxes(refitBoxes, chartArea, params, stacks) || changed;
}
function $216d2bdc6f281bf6$var$setBoxDims(box, left, top, width, height) {
    box.top = top;
    box.left = left;
    box.right = left + width;
    box.bottom = top + height;
    box.width = width;
    box.height = height;
}
function $216d2bdc6f281bf6$var$placeBoxes(boxes, chartArea, params, stacks) {
    const userPadding = params.padding;
    let { x: x, y: y } = chartArea;
    for (const layout of boxes){
        const box = layout.box;
        const stack = stacks[layout.stack] || {
            count: 1,
            placed: 0,
            weight: 1
        };
        const weight = layout.stackWeight / stack.weight || 1;
        if (layout.horizontal) {
            const width = chartArea.w * weight;
            const height = stack.size || box.height;
            if ((0, $84f61e7391a78632$export$dda1d9f60106f0e9)(stack.start)) y = stack.start;
            if (box.fullSize) $216d2bdc6f281bf6$var$setBoxDims(box, userPadding.left, y, params.outerWidth - userPadding.right - userPadding.left, height);
            else $216d2bdc6f281bf6$var$setBoxDims(box, chartArea.left + stack.placed, y, width, height);
            stack.start = y;
            stack.placed += width;
            y = box.bottom;
        } else {
            const height = chartArea.h * weight;
            const width = stack.size || box.width;
            if ((0, $84f61e7391a78632$export$dda1d9f60106f0e9)(stack.start)) x = stack.start;
            if (box.fullSize) $216d2bdc6f281bf6$var$setBoxDims(box, x, userPadding.top, width, params.outerHeight - userPadding.bottom - userPadding.top);
            else $216d2bdc6f281bf6$var$setBoxDims(box, x, chartArea.top + stack.placed, width, height);
            stack.start = x;
            stack.placed += height;
            x = box.right;
        }
    }
    chartArea.x = x;
    chartArea.y = y;
}
var $216d2bdc6f281bf6$export$1ecca0613f5e56d2 = {
    addBox (chart, item) {
        if (!chart.boxes) chart.boxes = [];
        item.fullSize = item.fullSize || false;
        item.position = item.position || 'top';
        item.weight = item.weight || 0;
        item._layers = item._layers || function() {
            return [
                {
                    z: 0,
                    draw (chartArea) {
                        item.draw(chartArea);
                    }
                }
            ];
        };
        chart.boxes.push(item);
    },
    removeBox (chart, layoutItem) {
        const index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
        if (index !== -1) chart.boxes.splice(index, 1);
    },
    configure (chart, item, options) {
        item.fullSize = options.fullSize;
        item.position = options.position;
        item.weight = options.weight;
    },
    update (chart, width, height, minPadding) {
        if (!chart) return;
        const padding = (0, $84f61e7391a78632$export$a9c23c6ac3fc3eca)(chart.options.layout.padding);
        const availableWidth = Math.max(width - padding.width, 0);
        const availableHeight = Math.max(height - padding.height, 0);
        const boxes = $216d2bdc6f281bf6$var$buildLayoutBoxes(chart.boxes);
        const verticalBoxes = boxes.vertical;
        const horizontalBoxes = boxes.horizontal;
        (0, $84f61e7391a78632$export$d66501df72047452)(chart.boxes, (box)=>{
            if (typeof box.beforeLayout === 'function') box.beforeLayout();
        });
        const visibleVerticalBoxCount = verticalBoxes.reduce((total, wrap)=>wrap.box.options && wrap.box.options.display === false ? total : total + 1, 0) || 1;
        const params = Object.freeze({
            outerWidth: width,
            outerHeight: height,
            padding: padding,
            availableWidth: availableWidth,
            availableHeight: availableHeight,
            vBoxMaxWidth: availableWidth / 2 / visibleVerticalBoxCount,
            hBoxMaxHeight: availableHeight / 2
        });
        const maxPadding = Object.assign({}, padding);
        $216d2bdc6f281bf6$var$updateMaxPadding(maxPadding, (0, $84f61e7391a78632$export$a9c23c6ac3fc3eca)(minPadding));
        const chartArea = Object.assign({
            maxPadding: maxPadding,
            w: availableWidth,
            h: availableHeight,
            x: padding.left,
            y: padding.top
        }, padding);
        const stacks = $216d2bdc6f281bf6$var$setLayoutDims(verticalBoxes.concat(horizontalBoxes), params);
        $216d2bdc6f281bf6$var$fitBoxes(boxes.fullSize, chartArea, params, stacks);
        $216d2bdc6f281bf6$var$fitBoxes(verticalBoxes, chartArea, params, stacks);
        if ($216d2bdc6f281bf6$var$fitBoxes(horizontalBoxes, chartArea, params, stacks)) $216d2bdc6f281bf6$var$fitBoxes(verticalBoxes, chartArea, params, stacks);
        $216d2bdc6f281bf6$var$handleMaxPadding(chartArea);
        $216d2bdc6f281bf6$var$placeBoxes(boxes.leftAndTop, chartArea, params, stacks);
        chartArea.x += chartArea.w;
        chartArea.y += chartArea.h;
        $216d2bdc6f281bf6$var$placeBoxes(boxes.rightAndBottom, chartArea, params, stacks);
        chart.chartArea = {
            left: chartArea.left,
            top: chartArea.top,
            right: chartArea.left + chartArea.w,
            bottom: chartArea.top + chartArea.h,
            height: chartArea.h,
            width: chartArea.w
        };
        (0, $84f61e7391a78632$export$d66501df72047452)(boxes.chartArea, (layout)=>{
            const box = layout.box;
            Object.assign(box, chart.chartArea);
            box.update(chartArea.w, chartArea.h, {
                left: 0,
                top: 0,
                right: 0,
                bottom: 0
            });
        });
    }
};
class $216d2bdc6f281bf6$export$7b1aeb87f31f7da8 {
    acquireContext(canvas, aspectRatio) {}
    releaseContext(context) {
        return false;
    }
    addEventListener(chart, type, listener) {}
    removeEventListener(chart, type, listener) {}
    getDevicePixelRatio() {
        return 1;
    }
    getMaximumSize(element, width, height, aspectRatio) {
        width = Math.max(0, width || element.width);
        height = height || element.height;
        return {
            width: width,
            height: Math.max(0, aspectRatio ? Math.floor(width / aspectRatio) : height)
        };
    }
    isAttached(canvas) {
        return true;
    }
    updateConfig(config) {}
}
class $216d2bdc6f281bf6$export$a40a96b24b46cf35 extends $216d2bdc6f281bf6$export$7b1aeb87f31f7da8 {
    acquireContext(item) {
        return item && item.getContext && item.getContext('2d') || null;
    }
    updateConfig(config) {
        config.options.animation = false;
    }
}
const $216d2bdc6f281bf6$var$EXPANDO_KEY = '$chartjs';
const $216d2bdc6f281bf6$var$EVENT_TYPES = {
    touchstart: 'mousedown',
    touchmove: 'mousemove',
    touchend: 'mouseup',
    pointerenter: 'mouseenter',
    pointerdown: 'mousedown',
    pointermove: 'mousemove',
    pointerup: 'mouseup',
    pointerleave: 'mouseout',
    pointerout: 'mouseout'
};
const $216d2bdc6f281bf6$var$isNullOrEmpty = (value)=>value === null || value === '';
function $216d2bdc6f281bf6$var$initCanvas(canvas, aspectRatio) {
    const style = canvas.style;
    const renderHeight = canvas.getAttribute('height');
    const renderWidth = canvas.getAttribute('width');
    canvas[$216d2bdc6f281bf6$var$EXPANDO_KEY] = {
        initial: {
            height: renderHeight,
            width: renderWidth,
            style: {
                display: style.display,
                height: style.height,
                width: style.width
            }
        }
    };
    style.display = style.display || 'block';
    style.boxSizing = style.boxSizing || 'border-box';
    if ($216d2bdc6f281bf6$var$isNullOrEmpty(renderWidth)) {
        const displayWidth = (0, $84f61e7391a78632$export$b4171a6734a65d42)(canvas, 'width');
        if (displayWidth !== undefined) canvas.width = displayWidth;
    }
    if ($216d2bdc6f281bf6$var$isNullOrEmpty(renderHeight)) {
        if (canvas.style.height === '') canvas.height = canvas.width / (aspectRatio || 2);
        else {
            const displayHeight = (0, $84f61e7391a78632$export$b4171a6734a65d42)(canvas, 'height');
            if (displayHeight !== undefined) canvas.height = displayHeight;
        }
    }
    return canvas;
}
const $216d2bdc6f281bf6$var$eventListenerOptions = (0, $84f61e7391a78632$export$3466f893ebf79586) ? {
    passive: true
} : false;
function $216d2bdc6f281bf6$var$addListener(node, type, listener) {
    if (node) node.addEventListener(type, listener, $216d2bdc6f281bf6$var$eventListenerOptions);
}
function $216d2bdc6f281bf6$var$removeListener(chart, type, listener) {
    if (chart && chart.canvas) chart.canvas.removeEventListener(type, listener, $216d2bdc6f281bf6$var$eventListenerOptions);
}
function $216d2bdc6f281bf6$var$fromNativeEvent(event, chart) {
    const type = $216d2bdc6f281bf6$var$EVENT_TYPES[event.type] || event.type;
    const { x: x, y: y } = (0, $84f61e7391a78632$export$df995fae86a55f06)(event, chart);
    return {
        type: type,
        chart: chart,
        native: event,
        x: x !== undefined ? x : null,
        y: y !== undefined ? y : null
    };
}
function $216d2bdc6f281bf6$var$nodeListContains(nodeList, canvas) {
    for (const node of nodeList){
        if (node === canvas || node.contains(canvas)) return true;
    }
}
function $216d2bdc6f281bf6$var$createAttachObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const observer = new MutationObserver((entries)=>{
        let trigger = false;
        for (const entry of entries){
            trigger = trigger || $216d2bdc6f281bf6$var$nodeListContains(entry.addedNodes, canvas);
            trigger = trigger && !$216d2bdc6f281bf6$var$nodeListContains(entry.removedNodes, canvas);
        }
        if (trigger) listener();
    });
    observer.observe(document, {
        childList: true,
        subtree: true
    });
    return observer;
}
function $216d2bdc6f281bf6$var$createDetachObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const observer = new MutationObserver((entries)=>{
        let trigger = false;
        for (const entry of entries){
            trigger = trigger || $216d2bdc6f281bf6$var$nodeListContains(entry.removedNodes, canvas);
            trigger = trigger && !$216d2bdc6f281bf6$var$nodeListContains(entry.addedNodes, canvas);
        }
        if (trigger) listener();
    });
    observer.observe(document, {
        childList: true,
        subtree: true
    });
    return observer;
}
const $216d2bdc6f281bf6$var$drpListeningCharts = new Map();
let $216d2bdc6f281bf6$var$oldDevicePixelRatio = 0;
function $216d2bdc6f281bf6$var$onWindowResize() {
    const dpr = window.devicePixelRatio;
    if (dpr === $216d2bdc6f281bf6$var$oldDevicePixelRatio) return;
    $216d2bdc6f281bf6$var$oldDevicePixelRatio = dpr;
    $216d2bdc6f281bf6$var$drpListeningCharts.forEach((resize, chart)=>{
        if (chart.currentDevicePixelRatio !== dpr) resize();
    });
}
function $216d2bdc6f281bf6$var$listenDevicePixelRatioChanges(chart, resize) {
    if (!$216d2bdc6f281bf6$var$drpListeningCharts.size) window.addEventListener('resize', $216d2bdc6f281bf6$var$onWindowResize);
    $216d2bdc6f281bf6$var$drpListeningCharts.set(chart, resize);
}
function $216d2bdc6f281bf6$var$unlistenDevicePixelRatioChanges(chart) {
    $216d2bdc6f281bf6$var$drpListeningCharts.delete(chart);
    if (!$216d2bdc6f281bf6$var$drpListeningCharts.size) window.removeEventListener('resize', $216d2bdc6f281bf6$var$onWindowResize);
}
function $216d2bdc6f281bf6$var$createResizeObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const container = canvas && (0, $84f61e7391a78632$export$9bb611d729802a56)(canvas);
    if (!container) return;
    const resize = (0, $84f61e7391a78632$export$61196ced6d74a310)((width, height)=>{
        const w = container.clientWidth;
        listener(width, height);
        if (w < container.clientWidth) listener();
    }, window);
    const observer = new ResizeObserver((entries)=>{
        const entry = entries[0];
        const width = entry.contentRect.width;
        const height = entry.contentRect.height;
        if (width === 0 && height === 0) return;
        resize(width, height);
    });
    observer.observe(container);
    $216d2bdc6f281bf6$var$listenDevicePixelRatioChanges(chart, resize);
    return observer;
}
function $216d2bdc6f281bf6$var$releaseObserver(chart, type, observer) {
    if (observer) observer.disconnect();
    if (type === 'resize') $216d2bdc6f281bf6$var$unlistenDevicePixelRatioChanges(chart);
}
function $216d2bdc6f281bf6$var$createProxyAndListen(chart, type, listener) {
    const canvas = chart.canvas;
    const proxy = (0, $84f61e7391a78632$export$61196ced6d74a310)((event)=>{
        if (chart.ctx !== null) listener($216d2bdc6f281bf6$var$fromNativeEvent(event, chart));
    }, chart);
    $216d2bdc6f281bf6$var$addListener(canvas, type, proxy);
    return proxy;
}
class $216d2bdc6f281bf6$export$f02da7f882cf6b2e extends $216d2bdc6f281bf6$export$7b1aeb87f31f7da8 {
    acquireContext(canvas, aspectRatio) {
        const context = canvas && canvas.getContext && canvas.getContext('2d');
        if (context && context.canvas === canvas) {
            $216d2bdc6f281bf6$var$initCanvas(canvas, aspectRatio);
            return context;
        }
        return null;
    }
    releaseContext(context) {
        const canvas = context.canvas;
        if (!canvas[$216d2bdc6f281bf6$var$EXPANDO_KEY]) return false;
        const initial = canvas[$216d2bdc6f281bf6$var$EXPANDO_KEY].initial;
        [
            'height',
            'width'
        ].forEach((prop)=>{
            const value = initial[prop];
            if ((0, $84f61e7391a78632$export$342063e11d6c3cad)(value)) canvas.removeAttribute(prop);
            else canvas.setAttribute(prop, value);
        });
        const style = initial.style || {};
        Object.keys(style).forEach((key)=>{
            canvas.style[key] = style[key];
        });
        canvas.width = canvas.width;
        delete canvas[$216d2bdc6f281bf6$var$EXPANDO_KEY];
        return true;
    }
    addEventListener(chart, type, listener) {
        this.removeEventListener(chart, type);
        const proxies = chart.$proxies || (chart.$proxies = {});
        const handlers = {
            attach: $216d2bdc6f281bf6$var$createAttachObserver,
            detach: $216d2bdc6f281bf6$var$createDetachObserver,
            resize: $216d2bdc6f281bf6$var$createResizeObserver
        };
        const handler = handlers[type] || $216d2bdc6f281bf6$var$createProxyAndListen;
        proxies[type] = handler(chart, type, listener);
    }
    removeEventListener(chart, type) {
        const proxies = chart.$proxies || (chart.$proxies = {});
        const proxy = proxies[type];
        if (!proxy) return;
        const handlers = {
            attach: $216d2bdc6f281bf6$var$releaseObserver,
            detach: $216d2bdc6f281bf6$var$releaseObserver,
            resize: $216d2bdc6f281bf6$var$releaseObserver
        };
        const handler = handlers[type] || $216d2bdc6f281bf6$var$removeListener;
        handler(chart, type, proxy);
        proxies[type] = undefined;
    }
    getDevicePixelRatio() {
        return window.devicePixelRatio;
    }
    getMaximumSize(canvas, width, height, aspectRatio) {
        return (0, $84f61e7391a78632$export$2329c99376c9d0a4)(canvas, width, height, aspectRatio);
    }
    isAttached(canvas) {
        const container = canvas && (0, $84f61e7391a78632$export$9bb611d729802a56)(canvas);
        return !!(container && container.isConnected);
    }
}
function $216d2bdc6f281bf6$export$72cd9e67b1b784f9(canvas) {
    if (!(0, $84f61e7391a78632$export$3a1a48c8f6ef640e)() || typeof OffscreenCanvas !== 'undefined' && canvas instanceof OffscreenCanvas) return $216d2bdc6f281bf6$export$a40a96b24b46cf35;
    return $216d2bdc6f281bf6$export$f02da7f882cf6b2e;
}
class $216d2bdc6f281bf6$export$db77ccec0bb4ccac {
    static defaults = {};
    static defaultRoutes = undefined;
    x;
    y;
    active = false;
    options;
    $animations;
    tooltipPosition(useFinalPosition) {
        const { x: x, y: y } = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        return {
            x: x,
            y: y
        };
    }
    hasValue() {
        return (0, $84f61e7391a78632$export$d141bba7fdc215a3)(this.x) && (0, $84f61e7391a78632$export$d141bba7fdc215a3)(this.y);
    }
    getProps(props, final) {
        const anims = this.$animations;
        if (!final || !anims) // let's not create an object, if not needed
        return this;
        const ret = {};
        props.forEach((prop)=>{
            ret[prop] = anims[prop] && anims[prop].active() ? anims[prop]._to : this[prop];
        });
        return ret;
    }
}
function $216d2bdc6f281bf6$var$autoSkip(scale, ticks) {
    const tickOpts = scale.options.ticks;
    const determinedMaxTicks = $216d2bdc6f281bf6$var$determineMaxTicks(scale);
    const ticksLimit = Math.min(tickOpts.maxTicksLimit || determinedMaxTicks, determinedMaxTicks);
    const majorIndices = tickOpts.major.enabled ? $216d2bdc6f281bf6$var$getMajorIndices(ticks) : [];
    const numMajorIndices = majorIndices.length;
    const first = majorIndices[0];
    const last = majorIndices[numMajorIndices - 1];
    const newTicks = [];
    if (numMajorIndices > ticksLimit) {
        $216d2bdc6f281bf6$var$skipMajors(ticks, newTicks, majorIndices, numMajorIndices / ticksLimit);
        return newTicks;
    }
    const spacing = $216d2bdc6f281bf6$var$calculateSpacing(majorIndices, ticks, ticksLimit);
    if (numMajorIndices > 0) {
        let i, ilen;
        const avgMajorSpacing = numMajorIndices > 1 ? Math.round((last - first) / (numMajorIndices - 1)) : null;
        $216d2bdc6f281bf6$var$skip(ticks, newTicks, spacing, (0, $84f61e7391a78632$export$342063e11d6c3cad)(avgMajorSpacing) ? 0 : first - avgMajorSpacing, first);
        for(i = 0, ilen = numMajorIndices - 1; i < ilen; i++)$216d2bdc6f281bf6$var$skip(ticks, newTicks, spacing, majorIndices[i], majorIndices[i + 1]);
        $216d2bdc6f281bf6$var$skip(ticks, newTicks, spacing, last, (0, $84f61e7391a78632$export$342063e11d6c3cad)(avgMajorSpacing) ? ticks.length : last + avgMajorSpacing);
        return newTicks;
    }
    $216d2bdc6f281bf6$var$skip(ticks, newTicks, spacing);
    return newTicks;
}
function $216d2bdc6f281bf6$var$determineMaxTicks(scale) {
    const offset = scale.options.offset;
    const tickLength = scale._tickSize();
    const maxScale = scale._length / tickLength + (offset ? 0 : 1);
    const maxChart = scale._maxLength / tickLength;
    return Math.floor(Math.min(maxScale, maxChart));
}
function $216d2bdc6f281bf6$var$calculateSpacing(majorIndices, ticks, ticksLimit) {
    const evenMajorSpacing = $216d2bdc6f281bf6$var$getEvenSpacing(majorIndices);
    const spacing = ticks.length / ticksLimit;
    if (!evenMajorSpacing) return Math.max(spacing, 1);
    const factors = (0, $84f61e7391a78632$export$a07804094c3ecf2d)(evenMajorSpacing);
    for(let i = 0, ilen = factors.length - 1; i < ilen; i++){
        const factor = factors[i];
        if (factor > spacing) return factor;
    }
    return Math.max(spacing, 1);
}
function $216d2bdc6f281bf6$var$getMajorIndices(ticks) {
    const result = [];
    let i, ilen;
    for(i = 0, ilen = ticks.length; i < ilen; i++)if (ticks[i].major) result.push(i);
    return result;
}
function $216d2bdc6f281bf6$var$skipMajors(ticks, newTicks, majorIndices, spacing) {
    let count = 0;
    let next = majorIndices[0];
    let i;
    spacing = Math.ceil(spacing);
    for(i = 0; i < ticks.length; i++)if (i === next) {
        newTicks.push(ticks[i]);
        count++;
        next = majorIndices[count * spacing];
    }
}
function $216d2bdc6f281bf6$var$skip(ticks, newTicks, spacing, majorStart, majorEnd) {
    const start = (0, $84f61e7391a78632$export$90a7f3efeed30595)(majorStart, 0);
    const end = Math.min((0, $84f61e7391a78632$export$90a7f3efeed30595)(majorEnd, ticks.length), ticks.length);
    let count = 0;
    let length, i, next;
    spacing = Math.ceil(spacing);
    if (majorEnd) {
        length = majorEnd - majorStart;
        spacing = length / Math.floor(length / spacing);
    }
    next = start;
    while(next < 0){
        count++;
        next = Math.round(start + count * spacing);
    }
    for(i = Math.max(start, 0); i < end; i++)if (i === next) {
        newTicks.push(ticks[i]);
        count++;
        next = Math.round(start + count * spacing);
    }
}
function $216d2bdc6f281bf6$var$getEvenSpacing(arr) {
    const len = arr.length;
    let i, diff;
    if (len < 2) return false;
    for(diff = arr[0], i = 1; i < len; ++i){
        if (arr[i] - arr[i - 1] !== diff) return false;
    }
    return diff;
}
const $216d2bdc6f281bf6$var$reverseAlign = (align)=>align === 'left' ? 'right' : align === 'right' ? 'left' : align;
const $216d2bdc6f281bf6$var$offsetFromEdge = (scale, edge, offset)=>edge === 'top' || edge === 'left' ? scale[edge] + offset : scale[edge] - offset;
const $216d2bdc6f281bf6$var$getTicksLimit = (ticksLength, maxTicksLimit)=>Math.min(maxTicksLimit || ticksLength, ticksLength);
function $216d2bdc6f281bf6$var$sample(arr, numItems) {
    const result = [];
    const increment = arr.length / numItems;
    const len = arr.length;
    let i = 0;
    for(; i < len; i += increment)result.push(arr[Math.floor(i)]);
    return result;
}
function $216d2bdc6f281bf6$var$getPixelForGridLine(scale, index, offsetGridLines) {
    const length = scale.ticks.length;
    const validIndex = Math.min(index, length - 1);
    const start = scale._startPixel;
    const end = scale._endPixel;
    const epsilon = 1e-6;
    let lineValue = scale.getPixelForTick(validIndex);
    let offset;
    if (offsetGridLines) {
        if (length === 1) offset = Math.max(lineValue - start, end - lineValue);
        else if (index === 0) offset = (scale.getPixelForTick(1) - lineValue) / 2;
        else offset = (lineValue - scale.getPixelForTick(validIndex - 1)) / 2;
        lineValue += validIndex < index ? offset : -offset;
        if (lineValue < start - epsilon || lineValue > end + epsilon) return;
    }
    return lineValue;
}
function $216d2bdc6f281bf6$var$garbageCollect(caches, length) {
    (0, $84f61e7391a78632$export$d66501df72047452)(caches, (cache)=>{
        const gc = cache.gc;
        const gcLen = gc.length / 2;
        let i;
        if (gcLen > length) {
            for(i = 0; i < gcLen; ++i)delete cache.data[gc[i]];
            gc.splice(0, gcLen);
        }
    });
}
function $216d2bdc6f281bf6$var$getTickMarkLength(options) {
    return options.drawTicks ? options.tickLength : 0;
}
function $216d2bdc6f281bf6$var$getTitleHeight(options, fallback) {
    if (!options.display) return 0;
    const font = (0, $84f61e7391a78632$export$34aec0b863436764)(options.font, fallback);
    const padding = (0, $84f61e7391a78632$export$a9c23c6ac3fc3eca)(options.padding);
    const lines = (0, $84f61e7391a78632$export$8b22cf2602fb60ce)(options.text) ? options.text.length : 1;
    return lines * font.lineHeight + padding.height;
}
function $216d2bdc6f281bf6$var$createScaleContext(parent, scale) {
    return (0, $84f61e7391a78632$export$35e795649ee09318)(parent, {
        scale: scale,
        type: 'scale'
    });
}
function $216d2bdc6f281bf6$var$createTickContext(parent, index, tick) {
    return (0, $84f61e7391a78632$export$35e795649ee09318)(parent, {
        tick: tick,
        index: index,
        type: 'tick'
    });
}
function $216d2bdc6f281bf6$var$titleAlign(align, position, reverse) {
    let ret = (0, $84f61e7391a78632$export$3c2fa207a37baaea)(align);
    if (reverse && position !== 'right' || !reverse && position === 'right') ret = $216d2bdc6f281bf6$var$reverseAlign(ret);
    return ret;
}
function $216d2bdc6f281bf6$var$titleArgs(scale, offset, position, align) {
    const { top: top, left: left, bottom: bottom, right: right, chart: chart } = scale;
    const { chartArea: chartArea, scales: scales } = chart;
    let rotation = 0;
    let maxWidth, titleX, titleY;
    const height = bottom - top;
    const width = right - left;
    if (scale.isHorizontal()) {
        titleX = (0, $84f61e7391a78632$export$ce26c07117d59d6a)(align, left, right);
        if ((0, $84f61e7391a78632$export$23f2a1d2818174ef)(position)) {
            const positionAxisID = Object.keys(position)[0];
            const value = position[positionAxisID];
            titleY = scales[positionAxisID].getPixelForValue(value) + height - offset;
        } else if (position === 'center') titleY = (chartArea.bottom + chartArea.top) / 2 + height - offset;
        else titleY = $216d2bdc6f281bf6$var$offsetFromEdge(scale, position, offset);
        maxWidth = right - left;
    } else {
        if ((0, $84f61e7391a78632$export$23f2a1d2818174ef)(position)) {
            const positionAxisID = Object.keys(position)[0];
            const value = position[positionAxisID];
            titleX = scales[positionAxisID].getPixelForValue(value) - width + offset;
        } else if (position === 'center') titleX = (chartArea.left + chartArea.right) / 2 - width + offset;
        else titleX = $216d2bdc6f281bf6$var$offsetFromEdge(scale, position, offset);
        titleY = (0, $84f61e7391a78632$export$ce26c07117d59d6a)(align, bottom, top);
        rotation = position === 'left' ? -(0, $84f61e7391a78632$export$7f8ddf7c7c20b3cd) : (0, $84f61e7391a78632$export$7f8ddf7c7c20b3cd);
    }
    return {
        titleX: titleX,
        titleY: titleY,
        maxWidth: maxWidth,
        rotation: rotation
    };
}
class $216d2bdc6f281bf6$export$d60cfc58d3c358b6 extends $216d2bdc6f281bf6$export$db77ccec0bb4ccac {
    constructor(cfg){
        super();
        this.id = cfg.id;
        this.type = cfg.type;
        this.options = undefined;
        this.ctx = cfg.ctx;
        this.chart = cfg.chart;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.width = undefined;
        this.height = undefined;
        this._margins = {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        };
        this.maxWidth = undefined;
        this.maxHeight = undefined;
        this.paddingTop = undefined;
        this.paddingBottom = undefined;
        this.paddingLeft = undefined;
        this.paddingRight = undefined;
        this.axis = undefined;
        this.labelRotation = undefined;
        this.min = undefined;
        this.max = undefined;
        this._range = undefined;
        this.ticks = [];
        this._gridLineItems = null;
        this._labelItems = null;
        this._labelSizes = null;
        this._length = 0;
        this._maxLength = 0;
        this._longestTextCache = {};
        this._startPixel = undefined;
        this._endPixel = undefined;
        this._reversePixels = false;
        this._userMax = undefined;
        this._userMin = undefined;
        this._suggestedMax = undefined;
        this._suggestedMin = undefined;
        this._ticksLength = 0;
        this._borderValue = 0;
        this._cache = {};
        this._dataLimitsCached = false;
        this.$context = undefined;
    }
    init(options) {
        this.options = options.setContext(this.getContext());
        this.axis = options.axis;
        this._userMin = this.parse(options.min);
        this._userMax = this.parse(options.max);
        this._suggestedMin = this.parse(options.suggestedMin);
        this._suggestedMax = this.parse(options.suggestedMax);
    }
    parse(raw, index) {
        return raw;
    }
    getUserBounds() {
        let { _userMin: _userMin, _userMax: _userMax, _suggestedMin: _suggestedMin, _suggestedMax: _suggestedMax } = this;
        _userMin = (0, $84f61e7391a78632$export$c4ce752e73470fba)(_userMin, Number.POSITIVE_INFINITY);
        _userMax = (0, $84f61e7391a78632$export$c4ce752e73470fba)(_userMax, Number.NEGATIVE_INFINITY);
        _suggestedMin = (0, $84f61e7391a78632$export$c4ce752e73470fba)(_suggestedMin, Number.POSITIVE_INFINITY);
        _suggestedMax = (0, $84f61e7391a78632$export$c4ce752e73470fba)(_suggestedMax, Number.NEGATIVE_INFINITY);
        return {
            min: (0, $84f61e7391a78632$export$c4ce752e73470fba)(_userMin, _suggestedMin),
            max: (0, $84f61e7391a78632$export$c4ce752e73470fba)(_userMax, _suggestedMax),
            minDefined: (0, $84f61e7391a78632$export$39b482c5e57630a8)(_userMin),
            maxDefined: (0, $84f61e7391a78632$export$39b482c5e57630a8)(_userMax)
        };
    }
    getMinMax(canStack) {
        let { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let range;
        if (minDefined && maxDefined) return {
            min: min,
            max: max
        };
        const metas = this.getMatchingVisibleMetas();
        for(let i = 0, ilen = metas.length; i < ilen; ++i){
            range = metas[i].controller.getMinMax(this, canStack);
            if (!minDefined) min = Math.min(min, range.min);
            if (!maxDefined) max = Math.max(max, range.max);
        }
        min = maxDefined && min > max ? max : min;
        max = minDefined && min > max ? min : max;
        return {
            min: (0, $84f61e7391a78632$export$c4ce752e73470fba)(min, (0, $84f61e7391a78632$export$c4ce752e73470fba)(max, min)),
            max: (0, $84f61e7391a78632$export$c4ce752e73470fba)(max, (0, $84f61e7391a78632$export$c4ce752e73470fba)(min, max))
        };
    }
    getPadding() {
        return {
            left: this.paddingLeft || 0,
            top: this.paddingTop || 0,
            right: this.paddingRight || 0,
            bottom: this.paddingBottom || 0
        };
    }
    getTicks() {
        return this.ticks;
    }
    getLabels() {
        const data = this.chart.data;
        return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels || [];
    }
    getLabelItems(chartArea = this.chart.chartArea) {
        const items = this._labelItems || (this._labelItems = this._computeLabelItems(chartArea));
        return items;
    }
    beforeLayout() {
        this._cache = {};
        this._dataLimitsCached = false;
    }
    beforeUpdate() {
        (0, $84f61e7391a78632$export$3722cfe417b6ed86)(this.options.beforeUpdate, [
            this
        ]);
    }
    update(maxWidth, maxHeight, margins) {
        const { beginAtZero: beginAtZero, grace: grace, ticks: tickOpts } = this.options;
        const sampleSize = tickOpts.sampleSize;
        this.beforeUpdate();
        this.maxWidth = maxWidth;
        this.maxHeight = maxHeight;
        this._margins = margins = Object.assign({
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        }, margins);
        this.ticks = null;
        this._labelSizes = null;
        this._gridLineItems = null;
        this._labelItems = null;
        this.beforeSetDimensions();
        this.setDimensions();
        this.afterSetDimensions();
        this._maxLength = this.isHorizontal() ? this.width + margins.left + margins.right : this.height + margins.top + margins.bottom;
        if (!this._dataLimitsCached) {
            this.beforeDataLimits();
            this.determineDataLimits();
            this.afterDataLimits();
            this._range = (0, $84f61e7391a78632$export$db202ddc8be9136)(this, grace, beginAtZero);
            this._dataLimitsCached = true;
        }
        this.beforeBuildTicks();
        this.ticks = this.buildTicks() || [];
        this.afterBuildTicks();
        const samplingEnabled = sampleSize < this.ticks.length;
        this._convertTicksToLabels(samplingEnabled ? $216d2bdc6f281bf6$var$sample(this.ticks, sampleSize) : this.ticks);
        this.configure();
        this.beforeCalculateLabelRotation();
        this.calculateLabelRotation();
        this.afterCalculateLabelRotation();
        if (tickOpts.display && (tickOpts.autoSkip || tickOpts.source === 'auto')) {
            this.ticks = $216d2bdc6f281bf6$var$autoSkip(this, this.ticks);
            this._labelSizes = null;
            this.afterAutoSkip();
        }
        if (samplingEnabled) this._convertTicksToLabels(this.ticks);
        this.beforeFit();
        this.fit();
        this.afterFit();
        this.afterUpdate();
    }
    configure() {
        let reversePixels = this.options.reverse;
        let startPixel, endPixel;
        if (this.isHorizontal()) {
            startPixel = this.left;
            endPixel = this.right;
        } else {
            startPixel = this.top;
            endPixel = this.bottom;
            reversePixels = !reversePixels;
        }
        this._startPixel = startPixel;
        this._endPixel = endPixel;
        this._reversePixels = reversePixels;
        this._length = endPixel - startPixel;
        this._alignToPixels = this.options.alignToPixels;
    }
    afterUpdate() {
        (0, $84f61e7391a78632$export$3722cfe417b6ed86)(this.options.afterUpdate, [
            this
        ]);
    }
    beforeSetDimensions() {
        (0, $84f61e7391a78632$export$3722cfe417b6ed86)(this.options.beforeSetDimensions, [
            this
        ]);
    }
    setDimensions() {
        if (this.isHorizontal()) {
            this.width = this.maxWidth;
            this.left = 0;
            this.right = this.width;
        } else {
            this.height = this.maxHeight;
            this.top = 0;
            this.bottom = this.height;
        }
        this.paddingLeft = 0;
        this.paddingTop = 0;
        this.paddingRight = 0;
        this.paddingBottom = 0;
    }
    afterSetDimensions() {
        (0, $84f61e7391a78632$export$3722cfe417b6ed86)(this.options.afterSetDimensions, [
            this
        ]);
    }
    _callHooks(name) {
        this.chart.notifyPlugins(name, this.getContext());
        (0, $84f61e7391a78632$export$3722cfe417b6ed86)(this.options[name], [
            this
        ]);
    }
    beforeDataLimits() {
        this._callHooks('beforeDataLimits');
    }
    determineDataLimits() {}
    afterDataLimits() {
        this._callHooks('afterDataLimits');
    }
    beforeBuildTicks() {
        this._callHooks('beforeBuildTicks');
    }
    buildTicks() {
        return [];
    }
    afterBuildTicks() {
        this._callHooks('afterBuildTicks');
    }
    beforeTickToLabelConversion() {
        (0, $84f61e7391a78632$export$3722cfe417b6ed86)(this.options.beforeTickToLabelConversion, [
            this
        ]);
    }
    generateTickLabels(ticks) {
        const tickOpts = this.options.ticks;
        let i, ilen, tick;
        for(i = 0, ilen = ticks.length; i < ilen; i++){
            tick = ticks[i];
            tick.label = (0, $84f61e7391a78632$export$3722cfe417b6ed86)(tickOpts.callback, [
                tick.value,
                i,
                ticks
            ], this);
        }
    }
    afterTickToLabelConversion() {
        (0, $84f61e7391a78632$export$3722cfe417b6ed86)(this.options.afterTickToLabelConversion, [
            this
        ]);
    }
    beforeCalculateLabelRotation() {
        (0, $84f61e7391a78632$export$3722cfe417b6ed86)(this.options.beforeCalculateLabelRotation, [
            this
        ]);
    }
    calculateLabelRotation() {
        const options = this.options;
        const tickOpts = options.ticks;
        const numTicks = $216d2bdc6f281bf6$var$getTicksLimit(this.ticks.length, options.ticks.maxTicksLimit);
        const minRotation = tickOpts.minRotation || 0;
        const maxRotation = tickOpts.maxRotation;
        let labelRotation = minRotation;
        let tickWidth, maxHeight, maxLabelDiagonal;
        if (!this._isVisible() || !tickOpts.display || minRotation >= maxRotation || numTicks <= 1 || !this.isHorizontal()) {
            this.labelRotation = minRotation;
            return;
        }
        const labelSizes = this._getLabelSizes();
        const maxLabelWidth = labelSizes.widest.width;
        const maxLabelHeight = labelSizes.highest.height;
        const maxWidth = (0, $84f61e7391a78632$export$25ce5a424b770e84)(this.chart.width - maxLabelWidth, 0, this.maxWidth);
        tickWidth = options.offset ? this.maxWidth / numTicks : maxWidth / (numTicks - 1);
        if (maxLabelWidth + 6 > tickWidth) {
            tickWidth = maxWidth / (numTicks - (options.offset ? 0.5 : 1));
            maxHeight = this.maxHeight - $216d2bdc6f281bf6$var$getTickMarkLength(options.grid) - tickOpts.padding - $216d2bdc6f281bf6$var$getTitleHeight(options.title, this.chart.options.font);
            maxLabelDiagonal = Math.sqrt(maxLabelWidth * maxLabelWidth + maxLabelHeight * maxLabelHeight);
            labelRotation = (0, $84f61e7391a78632$export$3a6d5c9ae78a2c08)(Math.min(Math.asin((0, $84f61e7391a78632$export$25ce5a424b770e84)((labelSizes.highest.height + 6) / tickWidth, -1, 1)), Math.asin((0, $84f61e7391a78632$export$25ce5a424b770e84)(maxHeight / maxLabelDiagonal, -1, 1)) - Math.asin((0, $84f61e7391a78632$export$25ce5a424b770e84)(maxLabelHeight / maxLabelDiagonal, -1, 1))));
            labelRotation = Math.max(minRotation, Math.min(maxRotation, labelRotation));
        }
        this.labelRotation = labelRotation;
    }
    afterCalculateLabelRotation() {
        (0, $84f61e7391a78632$export$3722cfe417b6ed86)(this.options.afterCalculateLabelRotation, [
            this
        ]);
    }
    afterAutoSkip() {}
    beforeFit() {
        (0, $84f61e7391a78632$export$3722cfe417b6ed86)(this.options.beforeFit, [
            this
        ]);
    }
    fit() {
        const minSize = {
            width: 0,
            height: 0
        };
        const { chart: chart, options: { ticks: tickOpts, title: titleOpts, grid: gridOpts } } = this;
        const display = this._isVisible();
        const isHorizontal = this.isHorizontal();
        if (display) {
            const titleHeight = $216d2bdc6f281bf6$var$getTitleHeight(titleOpts, chart.options.font);
            if (isHorizontal) {
                minSize.width = this.maxWidth;
                minSize.height = $216d2bdc6f281bf6$var$getTickMarkLength(gridOpts) + titleHeight;
            } else {
                minSize.height = this.maxHeight;
                minSize.width = $216d2bdc6f281bf6$var$getTickMarkLength(gridOpts) + titleHeight;
            }
            if (tickOpts.display && this.ticks.length) {
                const { first: first, last: last, widest: widest, highest: highest } = this._getLabelSizes();
                const tickPadding = tickOpts.padding * 2;
                const angleRadians = (0, $84f61e7391a78632$export$625550452a3fa3ec)(this.labelRotation);
                const cos = Math.cos(angleRadians);
                const sin = Math.sin(angleRadians);
                if (isHorizontal) {
                    const labelHeight = tickOpts.mirror ? 0 : sin * widest.width + cos * highest.height;
                    minSize.height = Math.min(this.maxHeight, minSize.height + labelHeight + tickPadding);
                } else {
                    const labelWidth = tickOpts.mirror ? 0 : cos * widest.width + sin * highest.height;
                    minSize.width = Math.min(this.maxWidth, minSize.width + labelWidth + tickPadding);
                }
                this._calculatePadding(first, last, sin, cos);
            }
        }
        this._handleMargins();
        if (isHorizontal) {
            this.width = this._length = chart.width - this._margins.left - this._margins.right;
            this.height = minSize.height;
        } else {
            this.width = minSize.width;
            this.height = this._length = chart.height - this._margins.top - this._margins.bottom;
        }
    }
    _calculatePadding(first, last, sin, cos) {
        const { ticks: { align: align, padding: padding }, position: position } = this.options;
        const isRotated = this.labelRotation !== 0;
        const labelsBelowTicks = position !== 'top' && this.axis === 'x';
        if (this.isHorizontal()) {
            const offsetLeft = this.getPixelForTick(0) - this.left;
            const offsetRight = this.right - this.getPixelForTick(this.ticks.length - 1);
            let paddingLeft = 0;
            let paddingRight = 0;
            if (isRotated) {
                if (labelsBelowTicks) {
                    paddingLeft = cos * first.width;
                    paddingRight = sin * last.height;
                } else {
                    paddingLeft = sin * first.height;
                    paddingRight = cos * last.width;
                }
            } else if (align === 'start') paddingRight = last.width;
            else if (align === 'end') paddingLeft = first.width;
            else if (align !== 'inner') {
                paddingLeft = first.width / 2;
                paddingRight = last.width / 2;
            }
            this.paddingLeft = Math.max((paddingLeft - offsetLeft + padding) * this.width / (this.width - offsetLeft), 0);
            this.paddingRight = Math.max((paddingRight - offsetRight + padding) * this.width / (this.width - offsetRight), 0);
        } else {
            let paddingTop = last.height / 2;
            let paddingBottom = first.height / 2;
            if (align === 'start') {
                paddingTop = 0;
                paddingBottom = first.height;
            } else if (align === 'end') {
                paddingTop = last.height;
                paddingBottom = 0;
            }
            this.paddingTop = paddingTop + padding;
            this.paddingBottom = paddingBottom + padding;
        }
    }
    _handleMargins() {
        if (this._margins) {
            this._margins.left = Math.max(this.paddingLeft, this._margins.left);
            this._margins.top = Math.max(this.paddingTop, this._margins.top);
            this._margins.right = Math.max(this.paddingRight, this._margins.right);
            this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom);
        }
    }
    afterFit() {
        (0, $84f61e7391a78632$export$3722cfe417b6ed86)(this.options.afterFit, [
            this
        ]);
    }
    isHorizontal() {
        const { axis: axis, position: position } = this.options;
        return position === 'top' || position === 'bottom' || axis === 'x';
    }
    isFullSize() {
        return this.options.fullSize;
    }
    _convertTicksToLabels(ticks) {
        this.beforeTickToLabelConversion();
        this.generateTickLabels(ticks);
        let i, ilen;
        for(i = 0, ilen = ticks.length; i < ilen; i++)if ((0, $84f61e7391a78632$export$342063e11d6c3cad)(ticks[i].label)) {
            ticks.splice(i, 1);
            ilen--;
            i--;
        }
        this.afterTickToLabelConversion();
    }
    _getLabelSizes() {
        let labelSizes = this._labelSizes;
        if (!labelSizes) {
            const sampleSize = this.options.ticks.sampleSize;
            let ticks = this.ticks;
            if (sampleSize < ticks.length) ticks = $216d2bdc6f281bf6$var$sample(ticks, sampleSize);
            this._labelSizes = labelSizes = this._computeLabelSizes(ticks, ticks.length, this.options.ticks.maxTicksLimit);
        }
        return labelSizes;
    }
    _computeLabelSizes(ticks, length, maxTicksLimit) {
        const { ctx: ctx, _longestTextCache: caches } = this;
        const widths = [];
        const heights = [];
        const increment = Math.floor(length / $216d2bdc6f281bf6$var$getTicksLimit(length, maxTicksLimit));
        let widestLabelSize = 0;
        let highestLabelSize = 0;
        let i, j, jlen, label, tickFont, fontString, cache, lineHeight, width, height, nestedLabel;
        for(i = 0; i < length; i += increment){
            label = ticks[i].label;
            tickFont = this._resolveTickFontOptions(i);
            ctx.font = fontString = tickFont.string;
            cache = caches[fontString] = caches[fontString] || {
                data: {},
                gc: []
            };
            lineHeight = tickFont.lineHeight;
            width = height = 0;
            if (!(0, $84f61e7391a78632$export$342063e11d6c3cad)(label) && !(0, $84f61e7391a78632$export$8b22cf2602fb60ce)(label)) {
                width = (0, $84f61e7391a78632$export$e7c866399fa523f5)(ctx, cache.data, cache.gc, width, label);
                height = lineHeight;
            } else if ((0, $84f61e7391a78632$export$8b22cf2602fb60ce)(label)) for(j = 0, jlen = label.length; j < jlen; ++j){
                nestedLabel = label[j];
                if (!(0, $84f61e7391a78632$export$342063e11d6c3cad)(nestedLabel) && !(0, $84f61e7391a78632$export$8b22cf2602fb60ce)(nestedLabel)) {
                    width = (0, $84f61e7391a78632$export$e7c866399fa523f5)(ctx, cache.data, cache.gc, width, nestedLabel);
                    height += lineHeight;
                }
            }
            widths.push(width);
            heights.push(height);
            widestLabelSize = Math.max(width, widestLabelSize);
            highestLabelSize = Math.max(height, highestLabelSize);
        }
        $216d2bdc6f281bf6$var$garbageCollect(caches, length);
        const widest = widths.indexOf(widestLabelSize);
        const highest = heights.indexOf(highestLabelSize);
        const valueAt = (idx)=>({
                width: widths[idx] || 0,
                height: heights[idx] || 0
            });
        return {
            first: valueAt(0),
            last: valueAt(length - 1),
            widest: valueAt(widest),
            highest: valueAt(highest),
            widths: widths,
            heights: heights
        };
    }
    getLabelForValue(value) {
        return value;
    }
    getPixelForValue(value, index) {
        return NaN;
    }
    getValueForPixel(pixel) {}
    getPixelForTick(index) {
        const ticks = this.ticks;
        if (index < 0 || index > ticks.length - 1) return null;
        return this.getPixelForValue(ticks[index].value);
    }
    getPixelForDecimal(decimal) {
        if (this._reversePixels) decimal = 1 - decimal;
        const pixel = this._startPixel + decimal * this._length;
        return (0, $84f61e7391a78632$export$71cec2538cb2c617)(this._alignToPixels ? (0, $84f61e7391a78632$export$78acf4525d8a74c4)(this.chart, pixel, 0) : pixel);
    }
    getDecimalForPixel(pixel) {
        const decimal = (pixel - this._startPixel) / this._length;
        return this._reversePixels ? 1 - decimal : decimal;
    }
    getBasePixel() {
        return this.getPixelForValue(this.getBaseValue());
    }
    getBaseValue() {
        const { min: min, max: max } = this;
        return min < 0 && max < 0 ? max : min > 0 && max > 0 ? min : 0;
    }
    getContext(index) {
        const ticks = this.ticks || [];
        if (index >= 0 && index < ticks.length) {
            const tick = ticks[index];
            return tick.$context || (tick.$context = $216d2bdc6f281bf6$var$createTickContext(this.getContext(), index, tick));
        }
        return this.$context || (this.$context = $216d2bdc6f281bf6$var$createScaleContext(this.chart.getContext(), this));
    }
    _tickSize() {
        const optionTicks = this.options.ticks;
        const rot = (0, $84f61e7391a78632$export$625550452a3fa3ec)(this.labelRotation);
        const cos = Math.abs(Math.cos(rot));
        const sin = Math.abs(Math.sin(rot));
        const labelSizes = this._getLabelSizes();
        const padding = optionTicks.autoSkipPadding || 0;
        const w = labelSizes ? labelSizes.widest.width + padding : 0;
        const h = labelSizes ? labelSizes.highest.height + padding : 0;
        return this.isHorizontal() ? h * cos > w * sin ? w / cos : h / sin : h * sin < w * cos ? h / cos : w / sin;
    }
    _isVisible() {
        const display = this.options.display;
        if (display !== 'auto') return !!display;
        return this.getMatchingVisibleMetas().length > 0;
    }
    _computeGridLineItems(chartArea) {
        const axis = this.axis;
        const chart = this.chart;
        const options = this.options;
        const { grid: grid, position: position, border: border } = options;
        const offset = grid.offset;
        const isHorizontal = this.isHorizontal();
        const ticks = this.ticks;
        const ticksLength = ticks.length + (offset ? 1 : 0);
        const tl = $216d2bdc6f281bf6$var$getTickMarkLength(grid);
        const items = [];
        const borderOpts = border.setContext(this.getContext());
        const axisWidth = borderOpts.display ? borderOpts.width : 0;
        const axisHalfWidth = axisWidth / 2;
        const alignBorderValue = function(pixel) {
            return (0, $84f61e7391a78632$export$78acf4525d8a74c4)(chart, pixel, axisWidth);
        };
        let borderValue, i, lineValue, alignedLineValue;
        let tx1, ty1, tx2, ty2, x1, y1, x2, y2;
        if (position === 'top') {
            borderValue = alignBorderValue(this.bottom);
            ty1 = this.bottom - tl;
            ty2 = borderValue - axisHalfWidth;
            y1 = alignBorderValue(chartArea.top) + axisHalfWidth;
            y2 = chartArea.bottom;
        } else if (position === 'bottom') {
            borderValue = alignBorderValue(this.top);
            y1 = chartArea.top;
            y2 = alignBorderValue(chartArea.bottom) - axisHalfWidth;
            ty1 = borderValue + axisHalfWidth;
            ty2 = this.top + tl;
        } else if (position === 'left') {
            borderValue = alignBorderValue(this.right);
            tx1 = this.right - tl;
            tx2 = borderValue - axisHalfWidth;
            x1 = alignBorderValue(chartArea.left) + axisHalfWidth;
            x2 = chartArea.right;
        } else if (position === 'right') {
            borderValue = alignBorderValue(this.left);
            x1 = chartArea.left;
            x2 = alignBorderValue(chartArea.right) - axisHalfWidth;
            tx1 = borderValue + axisHalfWidth;
            tx2 = this.left + tl;
        } else if (axis === 'x') {
            if (position === 'center') borderValue = alignBorderValue((chartArea.top + chartArea.bottom) / 2 + 0.5);
            else if ((0, $84f61e7391a78632$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
            }
            y1 = chartArea.top;
            y2 = chartArea.bottom;
            ty1 = borderValue + axisHalfWidth;
            ty2 = ty1 + tl;
        } else if (axis === 'y') {
            if (position === 'center') borderValue = alignBorderValue((chartArea.left + chartArea.right) / 2);
            else if ((0, $84f61e7391a78632$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
            }
            tx1 = borderValue - axisHalfWidth;
            tx2 = tx1 - tl;
            x1 = chartArea.left;
            x2 = chartArea.right;
        }
        const limit = (0, $84f61e7391a78632$export$90a7f3efeed30595)(options.ticks.maxTicksLimit, ticksLength);
        const step = Math.max(1, Math.ceil(ticksLength / limit));
        for(i = 0; i < ticksLength; i += step){
            const context = this.getContext(i);
            const optsAtIndex = grid.setContext(context);
            const optsAtIndexBorder = border.setContext(context);
            const lineWidth = optsAtIndex.lineWidth;
            const lineColor = optsAtIndex.color;
            const borderDash = optsAtIndexBorder.dash || [];
            const borderDashOffset = optsAtIndexBorder.dashOffset;
            const tickWidth = optsAtIndex.tickWidth;
            const tickColor = optsAtIndex.tickColor;
            const tickBorderDash = optsAtIndex.tickBorderDash || [];
            const tickBorderDashOffset = optsAtIndex.tickBorderDashOffset;
            lineValue = $216d2bdc6f281bf6$var$getPixelForGridLine(this, i, offset);
            if (lineValue === undefined) continue;
            alignedLineValue = (0, $84f61e7391a78632$export$78acf4525d8a74c4)(chart, lineValue, lineWidth);
            if (isHorizontal) tx1 = tx2 = x1 = x2 = alignedLineValue;
            else ty1 = ty2 = y1 = y2 = alignedLineValue;
            items.push({
                tx1: tx1,
                ty1: ty1,
                tx2: tx2,
                ty2: ty2,
                x1: x1,
                y1: y1,
                x2: x2,
                y2: y2,
                width: lineWidth,
                color: lineColor,
                borderDash: borderDash,
                borderDashOffset: borderDashOffset,
                tickWidth: tickWidth,
                tickColor: tickColor,
                tickBorderDash: tickBorderDash,
                tickBorderDashOffset: tickBorderDashOffset
            });
        }
        this._ticksLength = ticksLength;
        this._borderValue = borderValue;
        return items;
    }
    _computeLabelItems(chartArea) {
        const axis = this.axis;
        const options = this.options;
        const { position: position, ticks: optionTicks } = options;
        const isHorizontal = this.isHorizontal();
        const ticks = this.ticks;
        const { align: align, crossAlign: crossAlign, padding: padding, mirror: mirror } = optionTicks;
        const tl = $216d2bdc6f281bf6$var$getTickMarkLength(options.grid);
        const tickAndPadding = tl + padding;
        const hTickAndPadding = mirror ? -padding : tickAndPadding;
        const rotation = -(0, $84f61e7391a78632$export$625550452a3fa3ec)(this.labelRotation);
        const items = [];
        let i, ilen, tick, label, x, y, textAlign, pixel, font, lineHeight, lineCount, textOffset;
        let textBaseline = 'middle';
        if (position === 'top') {
            y = this.bottom - hTickAndPadding;
            textAlign = this._getXAxisLabelAlignment();
        } else if (position === 'bottom') {
            y = this.top + hTickAndPadding;
            textAlign = this._getXAxisLabelAlignment();
        } else if (position === 'left') {
            const ret = this._getYAxisLabelAlignment(tl);
            textAlign = ret.textAlign;
            x = ret.x;
        } else if (position === 'right') {
            const ret = this._getYAxisLabelAlignment(tl);
            textAlign = ret.textAlign;
            x = ret.x;
        } else if (axis === 'x') {
            if (position === 'center') y = (chartArea.top + chartArea.bottom) / 2 + tickAndPadding;
            else if ((0, $84f61e7391a78632$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                y = this.chart.scales[positionAxisID].getPixelForValue(value) + tickAndPadding;
            }
            textAlign = this._getXAxisLabelAlignment();
        } else if (axis === 'y') {
            if (position === 'center') x = (chartArea.left + chartArea.right) / 2 - tickAndPadding;
            else if ((0, $84f61e7391a78632$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                x = this.chart.scales[positionAxisID].getPixelForValue(value);
            }
            textAlign = this._getYAxisLabelAlignment(tl).textAlign;
        }
        if (axis === 'y') {
            if (align === 'start') textBaseline = 'top';
            else if (align === 'end') textBaseline = 'bottom';
        }
        const labelSizes = this._getLabelSizes();
        for(i = 0, ilen = ticks.length; i < ilen; ++i){
            tick = ticks[i];
            label = tick.label;
            const optsAtIndex = optionTicks.setContext(this.getContext(i));
            pixel = this.getPixelForTick(i) + optionTicks.labelOffset;
            font = this._resolveTickFontOptions(i);
            lineHeight = font.lineHeight;
            lineCount = (0, $84f61e7391a78632$export$8b22cf2602fb60ce)(label) ? label.length : 1;
            const halfCount = lineCount / 2;
            const color = optsAtIndex.color;
            const strokeColor = optsAtIndex.textStrokeColor;
            const strokeWidth = optsAtIndex.textStrokeWidth;
            let tickTextAlign = textAlign;
            if (isHorizontal) {
                x = pixel;
                if (textAlign === 'inner') {
                    if (i === ilen - 1) tickTextAlign = !this.options.reverse ? 'right' : 'left';
                    else if (i === 0) tickTextAlign = !this.options.reverse ? 'left' : 'right';
                    else tickTextAlign = 'center';
                }
                if (position === 'top') {
                    if (crossAlign === 'near' || rotation !== 0) textOffset = -lineCount * lineHeight + lineHeight / 2;
                    else if (crossAlign === 'center') textOffset = -labelSizes.highest.height / 2 - halfCount * lineHeight + lineHeight;
                    else textOffset = -labelSizes.highest.height + lineHeight / 2;
                } else {
                    if (crossAlign === 'near' || rotation !== 0) textOffset = lineHeight / 2;
                    else if (crossAlign === 'center') textOffset = labelSizes.highest.height / 2 - halfCount * lineHeight;
                    else textOffset = labelSizes.highest.height - lineCount * lineHeight;
                }
                if (mirror) textOffset *= -1;
                if (rotation !== 0 && !optsAtIndex.showLabelBackdrop) x += lineHeight / 2 * Math.sin(rotation);
            } else {
                y = pixel;
                textOffset = (1 - lineCount) * lineHeight / 2;
            }
            let backdrop;
            if (optsAtIndex.showLabelBackdrop) {
                const labelPadding = (0, $84f61e7391a78632$export$a9c23c6ac3fc3eca)(optsAtIndex.backdropPadding);
                const height = labelSizes.heights[i];
                const width = labelSizes.widths[i];
                let top = textOffset - labelPadding.top;
                let left = 0 - labelPadding.left;
                switch(textBaseline){
                    case 'middle':
                        top -= height / 2;
                        break;
                    case 'bottom':
                        top -= height;
                        break;
                }
                switch(textAlign){
                    case 'center':
                        left -= width / 2;
                        break;
                    case 'right':
                        left -= width;
                        break;
                    case 'inner':
                        if (i === ilen - 1) left -= width;
                        else if (i > 0) left -= width / 2;
                        break;
                }
                backdrop = {
                    left: left,
                    top: top,
                    width: width + labelPadding.width,
                    height: height + labelPadding.height,
                    color: optsAtIndex.backdropColor
                };
            }
            items.push({
                label: label,
                font: font,
                textOffset: textOffset,
                options: {
                    rotation: rotation,
                    color: color,
                    strokeColor: strokeColor,
                    strokeWidth: strokeWidth,
                    textAlign: tickTextAlign,
                    textBaseline: textBaseline,
                    translation: [
                        x,
                        y
                    ],
                    backdrop: backdrop
                }
            });
        }
        return items;
    }
    _getXAxisLabelAlignment() {
        const { position: position, ticks: ticks } = this.options;
        const rotation = -(0, $84f61e7391a78632$export$625550452a3fa3ec)(this.labelRotation);
        if (rotation) return position === 'top' ? 'left' : 'right';
        let align = 'center';
        if (ticks.align === 'start') align = 'left';
        else if (ticks.align === 'end') align = 'right';
        else if (ticks.align === 'inner') align = 'inner';
        return align;
    }
    _getYAxisLabelAlignment(tl) {
        const { position: position, ticks: { crossAlign: crossAlign, mirror: mirror, padding: padding } } = this.options;
        const labelSizes = this._getLabelSizes();
        const tickAndPadding = tl + padding;
        const widest = labelSizes.widest.width;
        let textAlign;
        let x;
        if (position === 'left') {
            if (mirror) {
                x = this.right + padding;
                if (crossAlign === 'near') textAlign = 'left';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x += widest / 2;
                } else {
                    textAlign = 'right';
                    x += widest;
                }
            } else {
                x = this.right - tickAndPadding;
                if (crossAlign === 'near') textAlign = 'right';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x -= widest / 2;
                } else {
                    textAlign = 'left';
                    x = this.left;
                }
            }
        } else if (position === 'right') {
            if (mirror) {
                x = this.left + padding;
                if (crossAlign === 'near') textAlign = 'right';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x -= widest / 2;
                } else {
                    textAlign = 'left';
                    x -= widest;
                }
            } else {
                x = this.left + tickAndPadding;
                if (crossAlign === 'near') textAlign = 'left';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x += widest / 2;
                } else {
                    textAlign = 'right';
                    x = this.right;
                }
            }
        } else textAlign = 'right';
        return {
            textAlign: textAlign,
            x: x
        };
    }
    _computeLabelArea() {
        if (this.options.ticks.mirror) return;
        const chart = this.chart;
        const position = this.options.position;
        if (position === 'left' || position === 'right') return {
            top: 0,
            left: this.left,
            bottom: chart.height,
            right: this.right
        };
        if (position === 'top' || position === 'bottom') return {
            top: this.top,
            left: 0,
            bottom: this.bottom,
            right: chart.width
        };
    }
    drawBackground() {
        const { ctx: ctx, options: { backgroundColor: backgroundColor }, left: left, top: top, width: width, height: height } = this;
        if (backgroundColor) {
            ctx.save();
            ctx.fillStyle = backgroundColor;
            ctx.fillRect(left, top, width, height);
            ctx.restore();
        }
    }
    getLineWidthForValue(value) {
        const grid = this.options.grid;
        if (!this._isVisible() || !grid.display) return 0;
        const ticks = this.ticks;
        const index = ticks.findIndex((t)=>t.value === value);
        if (index >= 0) {
            const opts = grid.setContext(this.getContext(index));
            return opts.lineWidth;
        }
        return 0;
    }
    drawGrid(chartArea) {
        const grid = this.options.grid;
        const ctx = this.ctx;
        const items = this._gridLineItems || (this._gridLineItems = this._computeGridLineItems(chartArea));
        let i, ilen;
        const drawLine = (p1, p2, style)=>{
            if (!style.width || !style.color) return;
            ctx.save();
            ctx.lineWidth = style.width;
            ctx.strokeStyle = style.color;
            ctx.setLineDash(style.borderDash || []);
            ctx.lineDashOffset = style.borderDashOffset;
            ctx.beginPath();
            ctx.moveTo(p1.x, p1.y);
            ctx.lineTo(p2.x, p2.y);
            ctx.stroke();
            ctx.restore();
        };
        if (grid.display) for(i = 0, ilen = items.length; i < ilen; ++i){
            const item = items[i];
            if (grid.drawOnChartArea) drawLine({
                x: item.x1,
                y: item.y1
            }, {
                x: item.x2,
                y: item.y2
            }, item);
            if (grid.drawTicks) drawLine({
                x: item.tx1,
                y: item.ty1
            }, {
                x: item.tx2,
                y: item.ty2
            }, {
                color: item.tickColor,
                width: item.tickWidth,
                borderDash: item.tickBorderDash,
                borderDashOffset: item.tickBorderDashOffset
            });
        }
    }
    drawBorder() {
        const { chart: chart, ctx: ctx, options: { border: border, grid: grid } } = this;
        const borderOpts = border.setContext(this.getContext());
        const axisWidth = border.display ? borderOpts.width : 0;
        if (!axisWidth) return;
        const lastLineWidth = grid.setContext(this.getContext(0)).lineWidth;
        const borderValue = this._borderValue;
        let x1, x2, y1, y2;
        if (this.isHorizontal()) {
            x1 = (0, $84f61e7391a78632$export$78acf4525d8a74c4)(chart, this.left, axisWidth) - axisWidth / 2;
            x2 = (0, $84f61e7391a78632$export$78acf4525d8a74c4)(chart, this.right, lastLineWidth) + lastLineWidth / 2;
            y1 = y2 = borderValue;
        } else {
            y1 = (0, $84f61e7391a78632$export$78acf4525d8a74c4)(chart, this.top, axisWidth) - axisWidth / 2;
            y2 = (0, $84f61e7391a78632$export$78acf4525d8a74c4)(chart, this.bottom, lastLineWidth) + lastLineWidth / 2;
            x1 = x2 = borderValue;
        }
        ctx.save();
        ctx.lineWidth = borderOpts.width;
        ctx.strokeStyle = borderOpts.color;
        ctx.beginPath();
        ctx.moveTo(x1, y1);
        ctx.lineTo(x2, y2);
        ctx.stroke();
        ctx.restore();
    }
    drawLabels(chartArea) {
        const optionTicks = this.options.ticks;
        if (!optionTicks.display) return;
        const ctx = this.ctx;
        const area = this._computeLabelArea();
        if (area) (0, $84f61e7391a78632$export$8743009a87fcb00f)(ctx, area);
        const items = this.getLabelItems(chartArea);
        for (const item of items){
            const renderTextOptions = item.options;
            const tickFont = item.font;
            const label = item.label;
            const y = item.textOffset;
            (0, $84f61e7391a78632$export$dc98b0b04f4c7758)(ctx, label, 0, y, tickFont, renderTextOptions);
        }
        if (area) (0, $84f61e7391a78632$export$3d8c2f653ac9d0b9)(ctx);
    }
    drawTitle() {
        const { ctx: ctx, options: { position: position, title: title, reverse: reverse } } = this;
        if (!title.display) return;
        const font = (0, $84f61e7391a78632$export$34aec0b863436764)(title.font);
        const padding = (0, $84f61e7391a78632$export$a9c23c6ac3fc3eca)(title.padding);
        const align = title.align;
        let offset = font.lineHeight / 2;
        if (position === 'bottom' || position === 'center' || (0, $84f61e7391a78632$export$23f2a1d2818174ef)(position)) {
            offset += padding.bottom;
            if ((0, $84f61e7391a78632$export$8b22cf2602fb60ce)(title.text)) offset += font.lineHeight * (title.text.length - 1);
        } else offset += padding.top;
        const { titleX: titleX, titleY: titleY, maxWidth: maxWidth, rotation: rotation } = $216d2bdc6f281bf6$var$titleArgs(this, offset, position, align);
        (0, $84f61e7391a78632$export$dc98b0b04f4c7758)(ctx, title.text, 0, 0, font, {
            color: title.color,
            maxWidth: maxWidth,
            rotation: rotation,
            textAlign: $216d2bdc6f281bf6$var$titleAlign(align, position, reverse),
            textBaseline: 'middle',
            translation: [
                titleX,
                titleY
            ]
        });
    }
    draw(chartArea) {
        if (!this._isVisible()) return;
        this.drawBackground();
        this.drawGrid(chartArea);
        this.drawBorder();
        this.drawTitle();
        this.drawLabels(chartArea);
    }
    _layers() {
        const opts = this.options;
        const tz = opts.ticks && opts.ticks.z || 0;
        const gz = (0, $84f61e7391a78632$export$90a7f3efeed30595)(opts.grid && opts.grid.z, -1);
        const bz = (0, $84f61e7391a78632$export$90a7f3efeed30595)(opts.border && opts.border.z, 0);
        if (!this._isVisible() || this.draw !== $216d2bdc6f281bf6$export$d60cfc58d3c358b6.prototype.draw) return [
            {
                z: tz,
                draw: (chartArea)=>{
                    this.draw(chartArea);
                }
            }
        ];
        return [
            {
                z: gz,
                draw: (chartArea)=>{
                    this.drawBackground();
                    this.drawGrid(chartArea);
                    this.drawTitle();
                }
            },
            {
                z: bz,
                draw: ()=>{
                    this.drawBorder();
                }
            },
            {
                z: tz,
                draw: (chartArea)=>{
                    this.drawLabels(chartArea);
                }
            }
        ];
    }
    getMatchingVisibleMetas(type) {
        const metas = this.chart.getSortedVisibleDatasetMetas();
        const axisID = this.axis + 'AxisID';
        const result = [];
        let i, ilen;
        for(i = 0, ilen = metas.length; i < ilen; ++i){
            const meta = metas[i];
            if (meta[axisID] === this.id && (!type || meta.type === type)) result.push(meta);
        }
        return result;
    }
    _resolveTickFontOptions(index) {
        const opts = this.options.ticks.setContext(this.getContext(index));
        return (0, $84f61e7391a78632$export$34aec0b863436764)(opts.font);
    }
    _maxDigits() {
        const fontSize = this._resolveTickFontOptions(0).lineHeight;
        return (this.isHorizontal() ? this.width : this.height) / fontSize;
    }
}
class $216d2bdc6f281bf6$var$TypedRegistry {
    constructor(type, scope, override){
        this.type = type;
        this.scope = scope;
        this.override = override;
        this.items = Object.create(null);
    }
    isForType(type) {
        return Object.prototype.isPrototypeOf.call(this.type.prototype, type.prototype);
    }
    register(item) {
        const proto = Object.getPrototypeOf(item);
        let parentScope;
        if ($216d2bdc6f281bf6$var$isIChartComponent(proto)) parentScope = this.register(proto);
        const items = this.items;
        const id = item.id;
        const scope = this.scope + '.' + id;
        if (!id) throw new Error('class does not have id: ' + item);
        if (id in items) return scope;
        items[id] = item;
        $216d2bdc6f281bf6$var$registerDefaults(item, scope, parentScope);
        if (this.override) (0, $84f61e7391a78632$export$4368d992c4eafac0).override(item.id, item.overrides);
        return scope;
    }
    get(id) {
        return this.items[id];
    }
    unregister(item) {
        const items = this.items;
        const id = item.id;
        const scope = this.scope;
        if (id in items) delete items[id];
        if (scope && id in (0, $84f61e7391a78632$export$4368d992c4eafac0)[scope]) {
            delete (0, $84f61e7391a78632$export$4368d992c4eafac0)[scope][id];
            if (this.override) delete (0, $84f61e7391a78632$export$6559d589eb85fbb6)[id];
        }
    }
}
function $216d2bdc6f281bf6$var$registerDefaults(item, scope, parentScope) {
    const itemDefaults = (0, $84f61e7391a78632$export$efca4cbe5dd06740)(Object.create(null), [
        parentScope ? (0, $84f61e7391a78632$export$4368d992c4eafac0).get(parentScope) : {},
        (0, $84f61e7391a78632$export$4368d992c4eafac0).get(scope),
        item.defaults
    ]);
    (0, $84f61e7391a78632$export$4368d992c4eafac0).set(scope, itemDefaults);
    if (item.defaultRoutes) $216d2bdc6f281bf6$var$routeDefaults(scope, item.defaultRoutes);
    if (item.descriptors) (0, $84f61e7391a78632$export$4368d992c4eafac0).describe(scope, item.descriptors);
}
function $216d2bdc6f281bf6$var$routeDefaults(scope, routes) {
    Object.keys(routes).forEach((property)=>{
        const propertyParts = property.split('.');
        const sourceName = propertyParts.pop();
        const sourceScope = [
            scope
        ].concat(propertyParts).join('.');
        const parts = routes[property].split('.');
        const targetName = parts.pop();
        const targetScope = parts.join('.');
        (0, $84f61e7391a78632$export$4368d992c4eafac0).route(sourceScope, sourceName, targetScope, targetName);
    });
}
function $216d2bdc6f281bf6$var$isIChartComponent(proto) {
    return 'id' in proto && 'defaults' in proto;
}
class $216d2bdc6f281bf6$var$Registry {
    constructor(){
        this.controllers = new $216d2bdc6f281bf6$var$TypedRegistry($216d2bdc6f281bf6$export$75572ec5c55b4048, 'datasets', true);
        this.elements = new $216d2bdc6f281bf6$var$TypedRegistry($216d2bdc6f281bf6$export$db77ccec0bb4ccac, 'elements');
        this.plugins = new $216d2bdc6f281bf6$var$TypedRegistry(Object, 'plugins');
        this.scales = new $216d2bdc6f281bf6$var$TypedRegistry($216d2bdc6f281bf6$export$d60cfc58d3c358b6, 'scales');
        this._typedRegistries = [
            this.controllers,
            this.scales,
            this.elements
        ];
    }
    add(...args) {
        this._each('register', args);
    }
    remove(...args) {
        this._each('unregister', args);
    }
    addControllers(...args) {
        this._each('register', args, this.controllers);
    }
    addElements(...args) {
        this._each('register', args, this.elements);
    }
    addPlugins(...args) {
        this._each('register', args, this.plugins);
    }
    addScales(...args) {
        this._each('register', args, this.scales);
    }
    getController(id) {
        return this._get(id, this.controllers, 'controller');
    }
    getElement(id) {
        return this._get(id, this.elements, 'element');
    }
    getPlugin(id) {
        return this._get(id, this.plugins, 'plugin');
    }
    getScale(id) {
        return this._get(id, this.scales, 'scale');
    }
    removeControllers(...args) {
        this._each('unregister', args, this.controllers);
    }
    removeElements(...args) {
        this._each('unregister', args, this.elements);
    }
    removePlugins(...args) {
        this._each('unregister', args, this.plugins);
    }
    removeScales(...args) {
        this._each('unregister', args, this.scales);
    }
    _each(method, args, typedRegistry) {
        [
            ...args
        ].forEach((arg)=>{
            const reg = typedRegistry || this._getRegistryForType(arg);
            if (typedRegistry || reg.isForType(arg) || reg === this.plugins && arg.id) this._exec(method, reg, arg);
            else (0, $84f61e7391a78632$export$d66501df72047452)(arg, (item)=>{
                const itemReg = typedRegistry || this._getRegistryForType(item);
                this._exec(method, itemReg, item);
            });
        });
    }
    _exec(method, registry, component) {
        const camelMethod = (0, $84f61e7391a78632$export$a8550f7dbe79f93a)(method);
        (0, $84f61e7391a78632$export$3722cfe417b6ed86)(component['before' + camelMethod], [], component);
        registry[method](component);
        (0, $84f61e7391a78632$export$3722cfe417b6ed86)(component['after' + camelMethod], [], component);
    }
    _getRegistryForType(type) {
        for(let i = 0; i < this._typedRegistries.length; i++){
            const reg = this._typedRegistries[i];
            if (reg.isForType(type)) return reg;
        }
        return this.plugins;
    }
    _get(id, typedRegistry, type) {
        const item = typedRegistry.get(id);
        if (item === undefined) throw new Error('"' + id + '" is not a registered ' + type + '.');
        return item;
    }
}
var $216d2bdc6f281bf6$export$4bb7493d241fd8a5 = /* #__PURE__ */ new $216d2bdc6f281bf6$var$Registry();
class $216d2bdc6f281bf6$var$PluginService {
    constructor(){
        this._init = [];
    }
    notify(chart, hook, args, filter) {
        if (hook === 'beforeInit') {
            this._init = this._createDescriptors(chart, true);
            this._notify(this._init, chart, 'install');
        }
        const descriptors = filter ? this._descriptors(chart).filter(filter) : this._descriptors(chart);
        const result = this._notify(descriptors, chart, hook, args);
        if (hook === 'afterDestroy') {
            this._notify(descriptors, chart, 'stop');
            this._notify(this._init, chart, 'uninstall');
        }
        return result;
    }
    _notify(descriptors, chart, hook, args) {
        args = args || {};
        for (const descriptor of descriptors){
            const plugin = descriptor.plugin;
            const method = plugin[hook];
            const params = [
                chart,
                args,
                descriptor.options
            ];
            if ((0, $84f61e7391a78632$export$3722cfe417b6ed86)(method, params, plugin) === false && args.cancelable) return false;
        }
        return true;
    }
    invalidate() {
        if (!(0, $84f61e7391a78632$export$342063e11d6c3cad)(this._cache)) {
            this._oldCache = this._cache;
            this._cache = undefined;
        }
    }
    _descriptors(chart) {
        if (this._cache) return this._cache;
        const descriptors = this._cache = this._createDescriptors(chart);
        this._notifyStateChanges(chart);
        return descriptors;
    }
    _createDescriptors(chart, all) {
        const config = chart && chart.config;
        const options = (0, $84f61e7391a78632$export$90a7f3efeed30595)(config.options && config.options.plugins, {});
        const plugins = $216d2bdc6f281bf6$var$allPlugins(config);
        return options === false && !all ? [] : $216d2bdc6f281bf6$var$createDescriptors(chart, plugins, options, all);
    }
    _notifyStateChanges(chart) {
        const previousDescriptors = this._oldCache || [];
        const descriptors = this._cache;
        const diff = (a, b)=>a.filter((x)=>!b.some((y)=>x.plugin.id === y.plugin.id));
        this._notify(diff(previousDescriptors, descriptors), chart, 'stop');
        this._notify(diff(descriptors, previousDescriptors), chart, 'start');
    }
}
function $216d2bdc6f281bf6$var$allPlugins(config) {
    const localIds = {};
    const plugins = [];
    const keys = Object.keys($216d2bdc6f281bf6$export$4bb7493d241fd8a5.plugins.items);
    for(let i = 0; i < keys.length; i++)plugins.push($216d2bdc6f281bf6$export$4bb7493d241fd8a5.getPlugin(keys[i]));
    const local = config.plugins || [];
    for(let i = 0; i < local.length; i++){
        const plugin = local[i];
        if (plugins.indexOf(plugin) === -1) {
            plugins.push(plugin);
            localIds[plugin.id] = true;
        }
    }
    return {
        plugins: plugins,
        localIds: localIds
    };
}
function $216d2bdc6f281bf6$var$getOpts(options, all) {
    if (!all && options === false) return null;
    if (options === true) return {};
    return options;
}
function $216d2bdc6f281bf6$var$createDescriptors(chart, { plugins: plugins, localIds: localIds }, options, all) {
    const result = [];
    const context = chart.getContext();
    for (const plugin of plugins){
        const id = plugin.id;
        const opts = $216d2bdc6f281bf6$var$getOpts(options[id], all);
        if (opts === null) continue;
        result.push({
            plugin: plugin,
            options: $216d2bdc6f281bf6$var$pluginOpts(chart.config, {
                plugin: plugin,
                local: localIds[id]
            }, opts, context)
        });
    }
    return result;
}
function $216d2bdc6f281bf6$var$pluginOpts(config, { plugin: plugin, local: local }, opts, context) {
    const keys = config.pluginScopeKeys(plugin);
    const scopes = config.getOptionScopes(opts, keys);
    if (local && plugin.defaults) scopes.push(plugin.defaults);
    return config.createResolver(scopes, context, [
        ''
    ], {
        scriptable: false,
        indexable: false,
        allKeys: true
    });
}
function $216d2bdc6f281bf6$var$getIndexAxis(type, options) {
    const datasetDefaults = (0, $84f61e7391a78632$export$4368d992c4eafac0).datasets[type] || {};
    const datasetOptions = (options.datasets || {})[type] || {};
    return datasetOptions.indexAxis || options.indexAxis || datasetDefaults.indexAxis || 'x';
}
function $216d2bdc6f281bf6$var$getAxisFromDefaultScaleID(id, indexAxis) {
    let axis = id;
    if (id === '_index_') axis = indexAxis;
    else if (id === '_value_') axis = indexAxis === 'x' ? 'y' : 'x';
    return axis;
}
function $216d2bdc6f281bf6$var$getDefaultScaleIDFromAxis(axis, indexAxis) {
    return axis === indexAxis ? '_index_' : '_value_';
}
function $216d2bdc6f281bf6$var$idMatchesAxis(id) {
    if (id === 'x' || id === 'y' || id === 'r') return id;
}
function $216d2bdc6f281bf6$var$axisFromPosition(position) {
    if (position === 'top' || position === 'bottom') return 'x';
    if (position === 'left' || position === 'right') return 'y';
}
function $216d2bdc6f281bf6$var$determineAxis(id, ...scaleOptions) {
    if ($216d2bdc6f281bf6$var$idMatchesAxis(id)) return id;
    for (const opts of scaleOptions){
        const axis = opts.axis || $216d2bdc6f281bf6$var$axisFromPosition(opts.position) || id.length > 1 && $216d2bdc6f281bf6$var$idMatchesAxis(id[0].toLowerCase());
        if (axis) return axis;
    }
    throw new Error(`Cannot determine type of '${id}' axis. Please provide 'axis' or 'position' option.`);
}
function $216d2bdc6f281bf6$var$getAxisFromDataset(id, axis, dataset) {
    if (dataset[axis + 'AxisID'] === id) return {
        axis: axis
    };
}
function $216d2bdc6f281bf6$var$retrieveAxisFromDatasets(id, config) {
    if (config.data && config.data.datasets) {
        const boundDs = config.data.datasets.filter((d)=>d.xAxisID === id || d.yAxisID === id);
        if (boundDs.length) return $216d2bdc6f281bf6$var$getAxisFromDataset(id, 'x', boundDs[0]) || $216d2bdc6f281bf6$var$getAxisFromDataset(id, 'y', boundDs[0]);
    }
    return {};
}
function $216d2bdc6f281bf6$var$mergeScaleConfig(config, options) {
    const chartDefaults = (0, $84f61e7391a78632$export$6559d589eb85fbb6)[config.type] || {
        scales: {}
    };
    const configScales = options.scales || {};
    const chartIndexAxis = $216d2bdc6f281bf6$var$getIndexAxis(config.type, options);
    const scales = Object.create(null);
    Object.keys(configScales).forEach((id)=>{
        const scaleConf = configScales[id];
        if (!(0, $84f61e7391a78632$export$23f2a1d2818174ef)(scaleConf)) return console.error(`Invalid scale configuration for scale: ${id}`);
        if (scaleConf._proxy) return console.warn(`Ignoring resolver passed as options for scale: ${id}`);
        const axis = $216d2bdc6f281bf6$var$determineAxis(id, scaleConf, $216d2bdc6f281bf6$var$retrieveAxisFromDatasets(id, config), (0, $84f61e7391a78632$export$4368d992c4eafac0).scales[scaleConf.type]);
        const defaultId = $216d2bdc6f281bf6$var$getDefaultScaleIDFromAxis(axis, chartIndexAxis);
        const defaultScaleOptions = chartDefaults.scales || {};
        scales[id] = (0, $84f61e7391a78632$export$555508cbc6add439)(Object.create(null), [
            {
                axis: axis
            },
            scaleConf,
            defaultScaleOptions[axis],
            defaultScaleOptions[defaultId]
        ]);
    });
    config.data.datasets.forEach((dataset)=>{
        const type = dataset.type || config.type;
        const indexAxis = dataset.indexAxis || $216d2bdc6f281bf6$var$getIndexAxis(type, options);
        const datasetDefaults = (0, $84f61e7391a78632$export$6559d589eb85fbb6)[type] || {};
        const defaultScaleOptions = datasetDefaults.scales || {};
        Object.keys(defaultScaleOptions).forEach((defaultID)=>{
            const axis = $216d2bdc6f281bf6$var$getAxisFromDefaultScaleID(defaultID, indexAxis);
            const id = dataset[axis + 'AxisID'] || axis;
            scales[id] = scales[id] || Object.create(null);
            (0, $84f61e7391a78632$export$555508cbc6add439)(scales[id], [
                {
                    axis: axis
                },
                configScales[id],
                defaultScaleOptions[defaultID]
            ]);
        });
    });
    Object.keys(scales).forEach((key)=>{
        const scale = scales[key];
        (0, $84f61e7391a78632$export$555508cbc6add439)(scale, [
            (0, $84f61e7391a78632$export$4368d992c4eafac0).scales[scale.type],
            (0, $84f61e7391a78632$export$4368d992c4eafac0).scale
        ]);
    });
    return scales;
}
function $216d2bdc6f281bf6$var$initOptions(config) {
    const options = config.options || (config.options = {});
    options.plugins = (0, $84f61e7391a78632$export$90a7f3efeed30595)(options.plugins, {});
    options.scales = $216d2bdc6f281bf6$var$mergeScaleConfig(config, options);
}
function $216d2bdc6f281bf6$var$initData(data) {
    data = data || {};
    data.datasets = data.datasets || [];
    data.labels = data.labels || [];
    return data;
}
function $216d2bdc6f281bf6$var$initConfig(config) {
    config = config || {};
    config.data = $216d2bdc6f281bf6$var$initData(config.data);
    $216d2bdc6f281bf6$var$initOptions(config);
    return config;
}
const $216d2bdc6f281bf6$var$keyCache = new Map();
const $216d2bdc6f281bf6$var$keysCached = new Set();
function $216d2bdc6f281bf6$var$cachedKeys(cacheKey, generate) {
    let keys = $216d2bdc6f281bf6$var$keyCache.get(cacheKey);
    if (!keys) {
        keys = generate();
        $216d2bdc6f281bf6$var$keyCache.set(cacheKey, keys);
        $216d2bdc6f281bf6$var$keysCached.add(keys);
    }
    return keys;
}
const $216d2bdc6f281bf6$var$addIfFound = (set, obj, key)=>{
    const opts = (0, $84f61e7391a78632$export$2d1720544b23b823)(obj, key);
    if (opts !== undefined) set.add(opts);
};
class $216d2bdc6f281bf6$var$Config {
    constructor(config){
        this._config = $216d2bdc6f281bf6$var$initConfig(config);
        this._scopeCache = new Map();
        this._resolverCache = new Map();
    }
    get platform() {
        return this._config.platform;
    }
    get type() {
        return this._config.type;
    }
    set type(type) {
        this._config.type = type;
    }
    get data() {
        return this._config.data;
    }
    set data(data) {
        this._config.data = $216d2bdc6f281bf6$var$initData(data);
    }
    get options() {
        return this._config.options;
    }
    set options(options) {
        this._config.options = options;
    }
    get plugins() {
        return this._config.plugins;
    }
    update() {
        const config = this._config;
        this.clearCache();
        $216d2bdc6f281bf6$var$initOptions(config);
    }
    clearCache() {
        this._scopeCache.clear();
        this._resolverCache.clear();
    }
    datasetScopeKeys(datasetType) {
        return $216d2bdc6f281bf6$var$cachedKeys(datasetType, ()=>[
                [
                    `datasets.${datasetType}`,
                    ''
                ]
            ]);
    }
    datasetAnimationScopeKeys(datasetType, transition) {
        return $216d2bdc6f281bf6$var$cachedKeys(`${datasetType}.transition.${transition}`, ()=>[
                [
                    `datasets.${datasetType}.transitions.${transition}`,
                    `transitions.${transition}`
                ],
                [
                    `datasets.${datasetType}`,
                    ''
                ]
            ]);
    }
    datasetElementScopeKeys(datasetType, elementType) {
        return $216d2bdc6f281bf6$var$cachedKeys(`${datasetType}-${elementType}`, ()=>[
                [
                    `datasets.${datasetType}.elements.${elementType}`,
                    `datasets.${datasetType}`,
                    `elements.${elementType}`,
                    ''
                ]
            ]);
    }
    pluginScopeKeys(plugin) {
        const id = plugin.id;
        const type = this.type;
        return $216d2bdc6f281bf6$var$cachedKeys(`${type}-plugin-${id}`, ()=>[
                [
                    `plugins.${id}`,
                    ...plugin.additionalOptionScopes || []
                ]
            ]);
    }
    _cachedScopes(mainScope, resetCache) {
        const _scopeCache = this._scopeCache;
        let cache = _scopeCache.get(mainScope);
        if (!cache || resetCache) {
            cache = new Map();
            _scopeCache.set(mainScope, cache);
        }
        return cache;
    }
    getOptionScopes(mainScope, keyLists, resetCache) {
        const { options: options, type: type } = this;
        const cache = this._cachedScopes(mainScope, resetCache);
        const cached = cache.get(keyLists);
        if (cached) return cached;
        const scopes = new Set();
        keyLists.forEach((keys)=>{
            if (mainScope) {
                scopes.add(mainScope);
                keys.forEach((key)=>$216d2bdc6f281bf6$var$addIfFound(scopes, mainScope, key));
            }
            keys.forEach((key)=>$216d2bdc6f281bf6$var$addIfFound(scopes, options, key));
            keys.forEach((key)=>$216d2bdc6f281bf6$var$addIfFound(scopes, (0, $84f61e7391a78632$export$6559d589eb85fbb6)[type] || {}, key));
            keys.forEach((key)=>$216d2bdc6f281bf6$var$addIfFound(scopes, (0, $84f61e7391a78632$export$4368d992c4eafac0), key));
            keys.forEach((key)=>$216d2bdc6f281bf6$var$addIfFound(scopes, (0, $84f61e7391a78632$export$2e2af4578d910ddf), key));
        });
        const array = Array.from(scopes);
        if (array.length === 0) array.push(Object.create(null));
        if ($216d2bdc6f281bf6$var$keysCached.has(keyLists)) cache.set(keyLists, array);
        return array;
    }
    chartOptionScopes() {
        const { options: options, type: type } = this;
        return [
            options,
            (0, $84f61e7391a78632$export$6559d589eb85fbb6)[type] || {},
            (0, $84f61e7391a78632$export$4368d992c4eafac0).datasets[type] || {},
            {
                type: type
            },
            (0, $84f61e7391a78632$export$4368d992c4eafac0),
            (0, $84f61e7391a78632$export$2e2af4578d910ddf)
        ];
    }
    resolveNamedOptions(scopes, names, context, prefixes = [
        ''
    ]) {
        const result = {
            $shared: true
        };
        const { resolver: resolver, subPrefixes: subPrefixes } = $216d2bdc6f281bf6$var$getResolver(this._resolverCache, scopes, prefixes);
        let options = resolver;
        if ($216d2bdc6f281bf6$var$needContext(resolver, names)) {
            result.$shared = false;
            context = (0, $84f61e7391a78632$export$a93c5207d687da10)(context) ? context() : context;
            const subResolver = this.createResolver(scopes, context, subPrefixes);
            options = (0, $84f61e7391a78632$export$c3950d9923825c02)(resolver, context, subResolver);
        }
        for (const prop of names)result[prop] = options[prop];
        return result;
    }
    createResolver(scopes, context, prefixes = [
        ''
    ], descriptorDefaults) {
        const { resolver: resolver } = $216d2bdc6f281bf6$var$getResolver(this._resolverCache, scopes, prefixes);
        return (0, $84f61e7391a78632$export$23f2a1d2818174ef)(context) ? (0, $84f61e7391a78632$export$c3950d9923825c02)(resolver, context, undefined, descriptorDefaults) : resolver;
    }
}
function $216d2bdc6f281bf6$var$getResolver(resolverCache, scopes, prefixes) {
    let cache = resolverCache.get(scopes);
    if (!cache) {
        cache = new Map();
        resolverCache.set(scopes, cache);
    }
    const cacheKey = prefixes.join();
    let cached = cache.get(cacheKey);
    if (!cached) {
        const resolver = (0, $84f61e7391a78632$export$a9c996f45e5784d0)(scopes, prefixes);
        cached = {
            resolver: resolver,
            subPrefixes: prefixes.filter((p)=>!p.toLowerCase().includes('hover'))
        };
        cache.set(cacheKey, cached);
    }
    return cached;
}
const $216d2bdc6f281bf6$var$hasFunction = (value)=>(0, $84f61e7391a78632$export$23f2a1d2818174ef)(value) && Object.getOwnPropertyNames(value).some((key)=>(0, $84f61e7391a78632$export$a93c5207d687da10)(value[key]));
function $216d2bdc6f281bf6$var$needContext(proxy, names) {
    const { isScriptable: isScriptable, isIndexable: isIndexable } = (0, $84f61e7391a78632$export$7910e0436ed8d1de)(proxy);
    for (const prop of names){
        const scriptable = isScriptable(prop);
        const indexable = isIndexable(prop);
        const value = (indexable || scriptable) && proxy[prop];
        if (scriptable && ((0, $84f61e7391a78632$export$a93c5207d687da10)(value) || $216d2bdc6f281bf6$var$hasFunction(value)) || indexable && (0, $84f61e7391a78632$export$8b22cf2602fb60ce)(value)) return true;
    }
    return false;
}
var $216d2bdc6f281bf6$var$version = "4.4.9";
const $216d2bdc6f281bf6$var$KNOWN_POSITIONS = [
    'top',
    'bottom',
    'left',
    'right',
    'chartArea'
];
function $216d2bdc6f281bf6$var$positionIsHorizontal(position, axis) {
    return position === 'top' || position === 'bottom' || $216d2bdc6f281bf6$var$KNOWN_POSITIONS.indexOf(position) === -1 && axis === 'x';
}
function $216d2bdc6f281bf6$var$compare2Level(l1, l2) {
    return function(a, b) {
        return a[l1] === b[l1] ? a[l2] - b[l2] : a[l1] - b[l1];
    };
}
function $216d2bdc6f281bf6$var$onAnimationsComplete(context) {
    const chart = context.chart;
    const animationOptions = chart.options.animation;
    chart.notifyPlugins('afterRender');
    (0, $84f61e7391a78632$export$3722cfe417b6ed86)(animationOptions && animationOptions.onComplete, [
        context
    ], chart);
}
function $216d2bdc6f281bf6$var$onAnimationProgress(context) {
    const chart = context.chart;
    const animationOptions = chart.options.animation;
    (0, $84f61e7391a78632$export$3722cfe417b6ed86)(animationOptions && animationOptions.onProgress, [
        context
    ], chart);
}
function $216d2bdc6f281bf6$var$getCanvas(item) {
    if ((0, $84f61e7391a78632$export$3a1a48c8f6ef640e)() && typeof item === 'string') item = document.getElementById(item);
    else if (item && item.length) item = item[0];
    if (item && item.canvas) item = item.canvas;
    return item;
}
const $216d2bdc6f281bf6$var$instances = {};
const $216d2bdc6f281bf6$var$getChart = (key)=>{
    const canvas = $216d2bdc6f281bf6$var$getCanvas(key);
    return Object.values($216d2bdc6f281bf6$var$instances).filter((c)=>c.canvas === canvas).pop();
};
function $216d2bdc6f281bf6$var$moveNumericKeys(obj, start, move) {
    const keys = Object.keys(obj);
    for (const key of keys){
        const intKey = +key;
        if (intKey >= start) {
            const value = obj[key];
            delete obj[key];
            if (move > 0 || intKey > start) obj[intKey + move] = value;
        }
    }
}
function $216d2bdc6f281bf6$var$determineLastEvent(e, lastEvent, inChartArea, isClick) {
    if (!inChartArea || e.type === 'mouseout') return null;
    if (isClick) return lastEvent;
    return e;
}
class $216d2bdc6f281bf6$export$acaa6426d77a227e {
    static defaults = (0, $84f61e7391a78632$export$4368d992c4eafac0);
    static instances = $216d2bdc6f281bf6$var$instances;
    static overrides = (0, $84f61e7391a78632$export$6559d589eb85fbb6);
    static registry = $216d2bdc6f281bf6$export$4bb7493d241fd8a5;
    static version = $216d2bdc6f281bf6$var$version;
    static getChart = $216d2bdc6f281bf6$var$getChart;
    static register(...items) {
        $216d2bdc6f281bf6$export$4bb7493d241fd8a5.add(...items);
        $216d2bdc6f281bf6$var$invalidatePlugins();
    }
    static unregister(...items) {
        $216d2bdc6f281bf6$export$4bb7493d241fd8a5.remove(...items);
        $216d2bdc6f281bf6$var$invalidatePlugins();
    }
    constructor(item, userConfig){
        const config = this.config = new $216d2bdc6f281bf6$var$Config(userConfig);
        const initialCanvas = $216d2bdc6f281bf6$var$getCanvas(item);
        const existingChart = $216d2bdc6f281bf6$var$getChart(initialCanvas);
        if (existingChart) throw new Error('Canvas is already in use. Chart with ID \'' + existingChart.id + '\'' + ' must be destroyed before the canvas with ID \'' + existingChart.canvas.id + '\' can be reused.');
        const options = config.createResolver(config.chartOptionScopes(), this.getContext());
        this.platform = new (config.platform || $216d2bdc6f281bf6$export$72cd9e67b1b784f9(initialCanvas))();
        this.platform.updateConfig(config);
        const context = this.platform.acquireContext(initialCanvas, options.aspectRatio);
        const canvas = context && context.canvas;
        const height = canvas && canvas.height;
        const width = canvas && canvas.width;
        this.id = (0, $84f61e7391a78632$export$2219238a014317b0)();
        this.ctx = context;
        this.canvas = canvas;
        this.width = width;
        this.height = height;
        this._options = options;
        this._aspectRatio = this.aspectRatio;
        this._layers = [];
        this._metasets = [];
        this._stacks = undefined;
        this.boxes = [];
        this.currentDevicePixelRatio = undefined;
        this.chartArea = undefined;
        this._active = [];
        this._lastEvent = undefined;
        this._listeners = {};
        this._responsiveListeners = undefined;
        this._sortedMetasets = [];
        this.scales = {};
        this._plugins = new $216d2bdc6f281bf6$var$PluginService();
        this.$proxies = {};
        this._hiddenIndices = {};
        this.attached = false;
        this._animationsDisabled = undefined;
        this.$context = undefined;
        this._doResize = (0, $84f61e7391a78632$export$4c3d22f3d993c33f)((mode)=>this.update(mode), options.resizeDelay || 0);
        this._dataChanges = [];
        $216d2bdc6f281bf6$var$instances[this.id] = this;
        if (!context || !canvas) {
            console.error("Failed to create chart: can't acquire context from the given item");
            return;
        }
        $216d2bdc6f281bf6$export$a424a0aa8f687495.listen(this, 'complete', $216d2bdc6f281bf6$var$onAnimationsComplete);
        $216d2bdc6f281bf6$export$a424a0aa8f687495.listen(this, 'progress', $216d2bdc6f281bf6$var$onAnimationProgress);
        this._initialize();
        if (this.attached) this.update();
    }
    get aspectRatio() {
        const { options: { aspectRatio: aspectRatio, maintainAspectRatio: maintainAspectRatio }, width: width, height: height, _aspectRatio: _aspectRatio } = this;
        if (!(0, $84f61e7391a78632$export$342063e11d6c3cad)(aspectRatio)) return aspectRatio;
        if (maintainAspectRatio && _aspectRatio) return _aspectRatio;
        return height ? width / height : null;
    }
    get data() {
        return this.config.data;
    }
    set data(data) {
        this.config.data = data;
    }
    get options() {
        return this._options;
    }
    set options(options) {
        this.config.options = options;
    }
    get registry() {
        return $216d2bdc6f281bf6$export$4bb7493d241fd8a5;
    }
    _initialize() {
        this.notifyPlugins('beforeInit');
        if (this.options.responsive) this.resize();
        else (0, $84f61e7391a78632$export$f787f51d84a910ad)(this, this.options.devicePixelRatio);
        this.bindEvents();
        this.notifyPlugins('afterInit');
        return this;
    }
    clear() {
        (0, $84f61e7391a78632$export$c9170ad7d4cd7e57)(this.canvas, this.ctx);
        return this;
    }
    stop() {
        $216d2bdc6f281bf6$export$a424a0aa8f687495.stop(this);
        return this;
    }
    resize(width, height) {
        if (!$216d2bdc6f281bf6$export$a424a0aa8f687495.running(this)) this._resize(width, height);
        else this._resizeBeforeDraw = {
            width: width,
            height: height
        };
    }
    _resize(width, height) {
        const options = this.options;
        const canvas = this.canvas;
        const aspectRatio = options.maintainAspectRatio && this.aspectRatio;
        const newSize = this.platform.getMaximumSize(canvas, width, height, aspectRatio);
        const newRatio = options.devicePixelRatio || this.platform.getDevicePixelRatio();
        const mode = this.width ? 'resize' : 'attach';
        this.width = newSize.width;
        this.height = newSize.height;
        this._aspectRatio = this.aspectRatio;
        if (!(0, $84f61e7391a78632$export$f787f51d84a910ad)(this, newRatio, true)) return;
        this.notifyPlugins('resize', {
            size: newSize
        });
        (0, $84f61e7391a78632$export$3722cfe417b6ed86)(options.onResize, [
            this,
            newSize
        ], this);
        if (this.attached) {
            if (this._doResize(mode)) this.render();
        }
    }
    ensureScalesHaveIDs() {
        const options = this.options;
        const scalesOptions = options.scales || {};
        (0, $84f61e7391a78632$export$d66501df72047452)(scalesOptions, (axisOptions, axisID)=>{
            axisOptions.id = axisID;
        });
    }
    buildOrUpdateScales() {
        const options = this.options;
        const scaleOpts = options.scales;
        const scales = this.scales;
        const updated = Object.keys(scales).reduce((obj, id)=>{
            obj[id] = false;
            return obj;
        }, {});
        let items = [];
        if (scaleOpts) items = items.concat(Object.keys(scaleOpts).map((id)=>{
            const scaleOptions = scaleOpts[id];
            const axis = $216d2bdc6f281bf6$var$determineAxis(id, scaleOptions);
            const isRadial = axis === 'r';
            const isHorizontal = axis === 'x';
            return {
                options: scaleOptions,
                dposition: isRadial ? 'chartArea' : isHorizontal ? 'bottom' : 'left',
                dtype: isRadial ? 'radialLinear' : isHorizontal ? 'category' : 'linear'
            };
        }));
        (0, $84f61e7391a78632$export$d66501df72047452)(items, (item)=>{
            const scaleOptions = item.options;
            const id = scaleOptions.id;
            const axis = $216d2bdc6f281bf6$var$determineAxis(id, scaleOptions);
            const scaleType = (0, $84f61e7391a78632$export$90a7f3efeed30595)(scaleOptions.type, item.dtype);
            if (scaleOptions.position === undefined || $216d2bdc6f281bf6$var$positionIsHorizontal(scaleOptions.position, axis) !== $216d2bdc6f281bf6$var$positionIsHorizontal(item.dposition)) scaleOptions.position = item.dposition;
            updated[id] = true;
            let scale = null;
            if (id in scales && scales[id].type === scaleType) scale = scales[id];
            else {
                const scaleClass = $216d2bdc6f281bf6$export$4bb7493d241fd8a5.getScale(scaleType);
                scale = new scaleClass({
                    id: id,
                    type: scaleType,
                    ctx: this.ctx,
                    chart: this
                });
                scales[scale.id] = scale;
            }
            scale.init(scaleOptions, options);
        });
        (0, $84f61e7391a78632$export$d66501df72047452)(updated, (hasUpdated, id)=>{
            if (!hasUpdated) delete scales[id];
        });
        (0, $84f61e7391a78632$export$d66501df72047452)(scales, (scale)=>{
            $216d2bdc6f281bf6$export$1ecca0613f5e56d2.configure(this, scale, scale.options);
            $216d2bdc6f281bf6$export$1ecca0613f5e56d2.addBox(this, scale);
        });
    }
    _updateMetasets() {
        const metasets = this._metasets;
        const numData = this.data.datasets.length;
        const numMeta = metasets.length;
        metasets.sort((a, b)=>a.index - b.index);
        if (numMeta > numData) {
            for(let i = numData; i < numMeta; ++i)this._destroyDatasetMeta(i);
            metasets.splice(numData, numMeta - numData);
        }
        this._sortedMetasets = metasets.slice(0).sort($216d2bdc6f281bf6$var$compare2Level('order', 'index'));
    }
    _removeUnreferencedMetasets() {
        const { _metasets: metasets, data: { datasets: datasets } } = this;
        if (metasets.length > datasets.length) delete this._stacks;
        metasets.forEach((meta, index)=>{
            if (datasets.filter((x)=>x === meta._dataset).length === 0) this._destroyDatasetMeta(index);
        });
    }
    buildOrUpdateControllers() {
        const newControllers = [];
        const datasets = this.data.datasets;
        let i, ilen;
        this._removeUnreferencedMetasets();
        for(i = 0, ilen = datasets.length; i < ilen; i++){
            const dataset = datasets[i];
            let meta = this.getDatasetMeta(i);
            const type = dataset.type || this.config.type;
            if (meta.type && meta.type !== type) {
                this._destroyDatasetMeta(i);
                meta = this.getDatasetMeta(i);
            }
            meta.type = type;
            meta.indexAxis = dataset.indexAxis || $216d2bdc6f281bf6$var$getIndexAxis(type, this.options);
            meta.order = dataset.order || 0;
            meta.index = i;
            meta.label = '' + dataset.label;
            meta.visible = this.isDatasetVisible(i);
            if (meta.controller) {
                meta.controller.updateIndex(i);
                meta.controller.linkScales();
            } else {
                const ControllerClass = $216d2bdc6f281bf6$export$4bb7493d241fd8a5.getController(type);
                const { datasetElementType: datasetElementType, dataElementType: dataElementType } = (0, $84f61e7391a78632$export$4368d992c4eafac0).datasets[type];
                Object.assign(ControllerClass, {
                    dataElementType: $216d2bdc6f281bf6$export$4bb7493d241fd8a5.getElement(dataElementType),
                    datasetElementType: datasetElementType && $216d2bdc6f281bf6$export$4bb7493d241fd8a5.getElement(datasetElementType)
                });
                meta.controller = new ControllerClass(this, i);
                newControllers.push(meta.controller);
            }
        }
        this._updateMetasets();
        return newControllers;
    }
    _resetElements() {
        (0, $84f61e7391a78632$export$d66501df72047452)(this.data.datasets, (dataset, datasetIndex)=>{
            this.getDatasetMeta(datasetIndex).controller.reset();
        }, this);
    }
    reset() {
        this._resetElements();
        this.notifyPlugins('reset');
    }
    update(mode) {
        const config = this.config;
        config.update();
        const options = this._options = config.createResolver(config.chartOptionScopes(), this.getContext());
        const animsDisabled = this._animationsDisabled = !options.animation;
        this._updateScales();
        this._checkEventBindings();
        this._updateHiddenIndices();
        this._plugins.invalidate();
        if (this.notifyPlugins('beforeUpdate', {
            mode: mode,
            cancelable: true
        }) === false) return;
        const newControllers = this.buildOrUpdateControllers();
        this.notifyPlugins('beforeElementsUpdate');
        let minPadding = 0;
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; i++){
            const { controller: controller } = this.getDatasetMeta(i);
            const reset = !animsDisabled && newControllers.indexOf(controller) === -1;
            controller.buildOrUpdateElements(reset);
            minPadding = Math.max(+controller.getMaxOverflow(), minPadding);
        }
        minPadding = this._minPadding = options.layout.autoPadding ? minPadding : 0;
        this._updateLayout(minPadding);
        if (!animsDisabled) (0, $84f61e7391a78632$export$d66501df72047452)(newControllers, (controller)=>{
            controller.reset();
        });
        this._updateDatasets(mode);
        this.notifyPlugins('afterUpdate', {
            mode: mode
        });
        this._layers.sort($216d2bdc6f281bf6$var$compare2Level('z', '_idx'));
        const { _active: _active, _lastEvent: _lastEvent } = this;
        if (_lastEvent) this._eventHandler(_lastEvent, true);
        else if (_active.length) this._updateHoverStyles(_active, _active, true);
        this.render();
    }
    _updateScales() {
        (0, $84f61e7391a78632$export$d66501df72047452)(this.scales, (scale)=>{
            $216d2bdc6f281bf6$export$1ecca0613f5e56d2.removeBox(this, scale);
        });
        this.ensureScalesHaveIDs();
        this.buildOrUpdateScales();
    }
    _checkEventBindings() {
        const options = this.options;
        const existingEvents = new Set(Object.keys(this._listeners));
        const newEvents = new Set(options.events);
        if (!(0, $84f61e7391a78632$export$ee7c8ad385a60b7b)(existingEvents, newEvents) || !!this._responsiveListeners !== options.responsive) {
            this.unbindEvents();
            this.bindEvents();
        }
    }
    _updateHiddenIndices() {
        const { _hiddenIndices: _hiddenIndices } = this;
        const changes = this._getUniformDataChanges() || [];
        for (const { method: method, start: start, count: count } of changes){
            const move = method === '_removeElements' ? -count : count;
            $216d2bdc6f281bf6$var$moveNumericKeys(_hiddenIndices, start, move);
        }
    }
    _getUniformDataChanges() {
        const _dataChanges = this._dataChanges;
        if (!_dataChanges || !_dataChanges.length) return;
        this._dataChanges = [];
        const datasetCount = this.data.datasets.length;
        const makeSet = (idx)=>new Set(_dataChanges.filter((c)=>c[0] === idx).map((c, i)=>i + ',' + c.splice(1).join(',')));
        const changeSet = makeSet(0);
        for(let i = 1; i < datasetCount; i++){
            if (!(0, $84f61e7391a78632$export$ee7c8ad385a60b7b)(changeSet, makeSet(i))) return;
        }
        return Array.from(changeSet).map((c)=>c.split(',')).map((a)=>({
                method: a[1],
                start: +a[2],
                count: +a[3]
            }));
    }
    _updateLayout(minPadding) {
        if (this.notifyPlugins('beforeLayout', {
            cancelable: true
        }) === false) return;
        $216d2bdc6f281bf6$export$1ecca0613f5e56d2.update(this, this.width, this.height, minPadding);
        const area = this.chartArea;
        const noArea = area.width <= 0 || area.height <= 0;
        this._layers = [];
        (0, $84f61e7391a78632$export$d66501df72047452)(this.boxes, (box)=>{
            if (noArea && box.position === 'chartArea') return;
            if (box.configure) box.configure();
            this._layers.push(...box._layers());
        }, this);
        this._layers.forEach((item, index)=>{
            item._idx = index;
        });
        this.notifyPlugins('afterLayout');
    }
    _updateDatasets(mode) {
        if (this.notifyPlugins('beforeDatasetsUpdate', {
            mode: mode,
            cancelable: true
        }) === false) return;
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this.getDatasetMeta(i).controller.configure();
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this._updateDataset(i, (0, $84f61e7391a78632$export$a93c5207d687da10)(mode) ? mode({
            datasetIndex: i
        }) : mode);
        this.notifyPlugins('afterDatasetsUpdate', {
            mode: mode
        });
    }
    _updateDataset(index, mode) {
        const meta = this.getDatasetMeta(index);
        const args = {
            meta: meta,
            index: index,
            mode: mode,
            cancelable: true
        };
        if (this.notifyPlugins('beforeDatasetUpdate', args) === false) return;
        meta.controller._update(mode);
        args.cancelable = false;
        this.notifyPlugins('afterDatasetUpdate', args);
    }
    render() {
        if (this.notifyPlugins('beforeRender', {
            cancelable: true
        }) === false) return;
        if ($216d2bdc6f281bf6$export$a424a0aa8f687495.has(this)) {
            if (this.attached && !$216d2bdc6f281bf6$export$a424a0aa8f687495.running(this)) $216d2bdc6f281bf6$export$a424a0aa8f687495.start(this);
        } else {
            this.draw();
            $216d2bdc6f281bf6$var$onAnimationsComplete({
                chart: this
            });
        }
    }
    draw() {
        let i;
        if (this._resizeBeforeDraw) {
            const { width: width, height: height } = this._resizeBeforeDraw;
            this._resizeBeforeDraw = null;
            this._resize(width, height);
        }
        this.clear();
        if (this.width <= 0 || this.height <= 0) return;
        if (this.notifyPlugins('beforeDraw', {
            cancelable: true
        }) === false) return;
        const layers = this._layers;
        for(i = 0; i < layers.length && layers[i].z <= 0; ++i)layers[i].draw(this.chartArea);
        this._drawDatasets();
        for(; i < layers.length; ++i)layers[i].draw(this.chartArea);
        this.notifyPlugins('afterDraw');
    }
    _getSortedDatasetMetas(filterVisible) {
        const metasets = this._sortedMetasets;
        const result = [];
        let i, ilen;
        for(i = 0, ilen = metasets.length; i < ilen; ++i){
            const meta = metasets[i];
            if (!filterVisible || meta.visible) result.push(meta);
        }
        return result;
    }
    getSortedVisibleDatasetMetas() {
        return this._getSortedDatasetMetas(true);
    }
    _drawDatasets() {
        if (this.notifyPlugins('beforeDatasetsDraw', {
            cancelable: true
        }) === false) return;
        const metasets = this.getSortedVisibleDatasetMetas();
        for(let i = metasets.length - 1; i >= 0; --i)this._drawDataset(metasets[i]);
        this.notifyPlugins('afterDatasetsDraw');
    }
    _drawDataset(meta) {
        const ctx = this.ctx;
        const args = {
            meta: meta,
            index: meta.index,
            cancelable: true
        };
        const clip = (0, $84f61e7391a78632$export$995eb9fca571757)(this, meta);
        if (this.notifyPlugins('beforeDatasetDraw', args) === false) return;
        if (clip) (0, $84f61e7391a78632$export$8743009a87fcb00f)(ctx, clip);
        meta.controller.draw();
        if (clip) (0, $84f61e7391a78632$export$3d8c2f653ac9d0b9)(ctx);
        args.cancelable = false;
        this.notifyPlugins('afterDatasetDraw', args);
    }
    isPointInArea(point) {
        return (0, $84f61e7391a78632$export$e7094788287c5e9b)(point, this.chartArea, this._minPadding);
    }
    getElementsAtEventForMode(e, mode, options, useFinalPosition) {
        const method = $216d2bdc6f281bf6$export$a13296960cae0384.modes[mode];
        if (typeof method === 'function') return method(this, e, options, useFinalPosition);
        return [];
    }
    getDatasetMeta(datasetIndex) {
        const dataset = this.data.datasets[datasetIndex];
        const metasets = this._metasets;
        let meta = metasets.filter((x)=>x && x._dataset === dataset).pop();
        if (!meta) {
            meta = {
                type: null,
                data: [],
                dataset: null,
                controller: null,
                hidden: null,
                xAxisID: null,
                yAxisID: null,
                order: dataset && dataset.order || 0,
                index: datasetIndex,
                _dataset: dataset,
                _parsed: [],
                _sorted: false
            };
            metasets.push(meta);
        }
        return meta;
    }
    getContext() {
        return this.$context || (this.$context = (0, $84f61e7391a78632$export$35e795649ee09318)(null, {
            chart: this,
            type: 'chart'
        }));
    }
    getVisibleDatasetCount() {
        return this.getSortedVisibleDatasetMetas().length;
    }
    isDatasetVisible(datasetIndex) {
        const dataset = this.data.datasets[datasetIndex];
        if (!dataset) return false;
        const meta = this.getDatasetMeta(datasetIndex);
        return typeof meta.hidden === 'boolean' ? !meta.hidden : !dataset.hidden;
    }
    setDatasetVisibility(datasetIndex, visible) {
        const meta = this.getDatasetMeta(datasetIndex);
        meta.hidden = !visible;
    }
    toggleDataVisibility(index) {
        this._hiddenIndices[index] = !this._hiddenIndices[index];
    }
    getDataVisibility(index) {
        return !this._hiddenIndices[index];
    }
    _updateVisibility(datasetIndex, dataIndex, visible) {
        const mode = visible ? 'show' : 'hide';
        const meta = this.getDatasetMeta(datasetIndex);
        const anims = meta.controller._resolveAnimations(undefined, mode);
        if ((0, $84f61e7391a78632$export$dda1d9f60106f0e9)(dataIndex)) {
            meta.data[dataIndex].hidden = !visible;
            this.update();
        } else {
            this.setDatasetVisibility(datasetIndex, visible);
            anims.update(meta, {
                visible: visible
            });
            this.update((ctx)=>ctx.datasetIndex === datasetIndex ? mode : undefined);
        }
    }
    hide(datasetIndex, dataIndex) {
        this._updateVisibility(datasetIndex, dataIndex, false);
    }
    show(datasetIndex, dataIndex) {
        this._updateVisibility(datasetIndex, dataIndex, true);
    }
    _destroyDatasetMeta(datasetIndex) {
        const meta = this._metasets[datasetIndex];
        if (meta && meta.controller) meta.controller._destroy();
        delete this._metasets[datasetIndex];
    }
    _stop() {
        let i, ilen;
        this.stop();
        $216d2bdc6f281bf6$export$a424a0aa8f687495.remove(this);
        for(i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this._destroyDatasetMeta(i);
    }
    destroy() {
        this.notifyPlugins('beforeDestroy');
        const { canvas: canvas, ctx: ctx } = this;
        this._stop();
        this.config.clearCache();
        if (canvas) {
            this.unbindEvents();
            (0, $84f61e7391a78632$export$c9170ad7d4cd7e57)(canvas, ctx);
            this.platform.releaseContext(ctx);
            this.canvas = null;
            this.ctx = null;
        }
        delete $216d2bdc6f281bf6$var$instances[this.id];
        this.notifyPlugins('afterDestroy');
    }
    toBase64Image(...args) {
        return this.canvas.toDataURL(...args);
    }
    bindEvents() {
        this.bindUserEvents();
        if (this.options.responsive) this.bindResponsiveEvents();
        else this.attached = true;
    }
    bindUserEvents() {
        const listeners = this._listeners;
        const platform = this.platform;
        const _add = (type, listener)=>{
            platform.addEventListener(this, type, listener);
            listeners[type] = listener;
        };
        const listener = (e, x, y)=>{
            e.offsetX = x;
            e.offsetY = y;
            this._eventHandler(e);
        };
        (0, $84f61e7391a78632$export$d66501df72047452)(this.options.events, (type)=>_add(type, listener));
    }
    bindResponsiveEvents() {
        if (!this._responsiveListeners) this._responsiveListeners = {};
        const listeners = this._responsiveListeners;
        const platform = this.platform;
        const _add = (type, listener)=>{
            platform.addEventListener(this, type, listener);
            listeners[type] = listener;
        };
        const _remove = (type, listener)=>{
            if (listeners[type]) {
                platform.removeEventListener(this, type, listener);
                delete listeners[type];
            }
        };
        const listener = (width, height)=>{
            if (this.canvas) this.resize(width, height);
        };
        let detached;
        const attached = ()=>{
            _remove('attach', attached);
            this.attached = true;
            this.resize();
            _add('resize', listener);
            _add('detach', detached);
        };
        detached = ()=>{
            this.attached = false;
            _remove('resize', listener);
            this._stop();
            this._resize(0, 0);
            _add('attach', attached);
        };
        if (platform.isAttached(this.canvas)) attached();
        else detached();
    }
    unbindEvents() {
        (0, $84f61e7391a78632$export$d66501df72047452)(this._listeners, (listener, type)=>{
            this.platform.removeEventListener(this, type, listener);
        });
        this._listeners = {};
        (0, $84f61e7391a78632$export$d66501df72047452)(this._responsiveListeners, (listener, type)=>{
            this.platform.removeEventListener(this, type, listener);
        });
        this._responsiveListeners = undefined;
    }
    updateHoverStyle(items, mode, enabled) {
        const prefix = enabled ? 'set' : 'remove';
        let meta, item, i, ilen;
        if (mode === 'dataset') {
            meta = this.getDatasetMeta(items[0].datasetIndex);
            meta.controller['_' + prefix + 'DatasetHoverStyle']();
        }
        for(i = 0, ilen = items.length; i < ilen; ++i){
            item = items[i];
            const controller = item && this.getDatasetMeta(item.datasetIndex).controller;
            if (controller) controller[prefix + 'HoverStyle'](item.element, item.datasetIndex, item.index);
        }
    }
    getActiveElements() {
        return this._active || [];
    }
    setActiveElements(activeElements) {
        const lastActive = this._active || [];
        const active = activeElements.map(({ datasetIndex: datasetIndex, index: index })=>{
            const meta = this.getDatasetMeta(datasetIndex);
            if (!meta) throw new Error('No dataset found at index ' + datasetIndex);
            return {
                datasetIndex: datasetIndex,
                element: meta.data[index],
                index: index
            };
        });
        const changed = !(0, $84f61e7391a78632$export$f38c853ae54ed474)(active, lastActive);
        if (changed) {
            this._active = active;
            this._lastEvent = null;
            this._updateHoverStyles(active, lastActive);
        }
    }
    notifyPlugins(hook, args, filter) {
        return this._plugins.notify(this, hook, args, filter);
    }
    isPluginEnabled(pluginId) {
        return this._plugins._cache.filter((p)=>p.plugin.id === pluginId).length === 1;
    }
    _updateHoverStyles(active, lastActive, replay) {
        const hoverOptions = this.options.hover;
        const diff = (a, b)=>a.filter((x)=>!b.some((y)=>x.datasetIndex === y.datasetIndex && x.index === y.index));
        const deactivated = diff(lastActive, active);
        const activated = replay ? active : diff(active, lastActive);
        if (deactivated.length) this.updateHoverStyle(deactivated, hoverOptions.mode, false);
        if (activated.length && hoverOptions.mode) this.updateHoverStyle(activated, hoverOptions.mode, true);
    }
    _eventHandler(e, replay) {
        const args = {
            event: e,
            replay: replay,
            cancelable: true,
            inChartArea: this.isPointInArea(e)
        };
        const eventFilter = (plugin)=>(plugin.options.events || this.options.events).includes(e.native.type);
        if (this.notifyPlugins('beforeEvent', args, eventFilter) === false) return;
        const changed = this._handleEvent(e, replay, args.inChartArea);
        args.cancelable = false;
        this.notifyPlugins('afterEvent', args, eventFilter);
        if (changed || args.changed) this.render();
        return this;
    }
    _handleEvent(e, replay, inChartArea) {
        const { _active: lastActive = [], options: options } = this;
        const useFinalPosition = replay;
        const active = this._getActiveElements(e, lastActive, inChartArea, useFinalPosition);
        const isClick = (0, $84f61e7391a78632$export$3b513254972cfc9c)(e);
        const lastEvent = $216d2bdc6f281bf6$var$determineLastEvent(e, this._lastEvent, inChartArea, isClick);
        if (inChartArea) {
            this._lastEvent = null;
            (0, $84f61e7391a78632$export$3722cfe417b6ed86)(options.onHover, [
                e,
                active,
                this
            ], this);
            if (isClick) (0, $84f61e7391a78632$export$3722cfe417b6ed86)(options.onClick, [
                e,
                active,
                this
            ], this);
        }
        const changed = !(0, $84f61e7391a78632$export$f38c853ae54ed474)(active, lastActive);
        if (changed || replay) {
            this._active = active;
            this._updateHoverStyles(active, lastActive, replay);
        }
        this._lastEvent = lastEvent;
        return changed;
    }
    _getActiveElements(e, lastActive, inChartArea, useFinalPosition) {
        if (e.type === 'mouseout') return [];
        if (!inChartArea) return lastActive;
        const hoverOptions = this.options.hover;
        return this.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions, useFinalPosition);
    }
}
function $216d2bdc6f281bf6$var$invalidatePlugins() {
    return (0, $84f61e7391a78632$export$d66501df72047452)($216d2bdc6f281bf6$export$acaa6426d77a227e.instances, (chart)=>chart._plugins.invalidate());
}
function $216d2bdc6f281bf6$var$clipArc(ctx, element, endAngle) {
    const { startAngle: startAngle, pixelMargin: pixelMargin, x: x, y: y, outerRadius: outerRadius, innerRadius: innerRadius } = element;
    let angleMargin = pixelMargin / outerRadius;
    // Draw an inner border by clipping the arc and drawing a double-width border
    // Enlarge the clipping arc by 0.33 pixels to eliminate glitches between borders
    ctx.beginPath();
    ctx.arc(x, y, outerRadius, startAngle - angleMargin, endAngle + angleMargin);
    if (innerRadius > pixelMargin) {
        angleMargin = pixelMargin / innerRadius;
        ctx.arc(x, y, innerRadius, endAngle + angleMargin, startAngle - angleMargin, true);
    } else ctx.arc(x, y, pixelMargin, endAngle + (0, $84f61e7391a78632$export$7f8ddf7c7c20b3cd), startAngle - (0, $84f61e7391a78632$export$7f8ddf7c7c20b3cd));
    ctx.closePath();
    ctx.clip();
}
function $216d2bdc6f281bf6$var$toRadiusCorners(value) {
    return (0, $84f61e7391a78632$export$ab83b03e4111b1d0)(value, [
        'outerStart',
        'outerEnd',
        'innerStart',
        'innerEnd'
    ]);
}
/**
 * Parse border radius from the provided options
 */ function $216d2bdc6f281bf6$var$parseBorderRadius$1(arc, innerRadius, outerRadius, angleDelta) {
    const o = $216d2bdc6f281bf6$var$toRadiusCorners(arc.options.borderRadius);
    const halfThickness = (outerRadius - innerRadius) / 2;
    const innerLimit = Math.min(halfThickness, angleDelta * innerRadius / 2);
    // Outer limits are complicated. We want to compute the available angular distance at
    // a radius of outerRadius - borderRadius because for small angular distances, this term limits.
    // We compute at r = outerRadius - borderRadius because this circle defines the center of the border corners.
    //
    // If the borderRadius is large, that value can become negative.
    // This causes the outer borders to lose their radius entirely, which is rather unexpected. To solve that, if borderRadius > outerRadius
    // we know that the thickness term will dominate and compute the limits at that point
    const computeOuterLimit = (val)=>{
        const outerArcLimit = (outerRadius - Math.min(halfThickness, val)) * angleDelta / 2;
        return (0, $84f61e7391a78632$export$25ce5a424b770e84)(val, 0, Math.min(halfThickness, outerArcLimit));
    };
    return {
        outerStart: computeOuterLimit(o.outerStart),
        outerEnd: computeOuterLimit(o.outerEnd),
        innerStart: (0, $84f61e7391a78632$export$25ce5a424b770e84)(o.innerStart, 0, innerLimit),
        innerEnd: (0, $84f61e7391a78632$export$25ce5a424b770e84)(o.innerEnd, 0, innerLimit)
    };
}
/**
 * Convert (r, 𝜃) to (x, y)
 */ function $216d2bdc6f281bf6$var$rThetaToXY(r, theta, x, y) {
    return {
        x: x + r * Math.cos(theta),
        y: y + r * Math.sin(theta)
    };
}
/**
 * Path the arc, respecting border radius by separating into left and right halves.
 *
 *   Start      End
 *
 *    1--->a--->2    Outer
 *   /           \
 *   8           3
 *   |           |
 *   |           |
 *   7           4
 *   \           /
 *    6<---b<---5    Inner
 */ function $216d2bdc6f281bf6$var$pathArc(ctx, element, offset, spacing, end, circular) {
    const { x: x, y: y, startAngle: start, pixelMargin: pixelMargin, innerRadius: innerR } = element;
    const outerRadius = Math.max(element.outerRadius + spacing + offset - pixelMargin, 0);
    const innerRadius = innerR > 0 ? innerR + spacing + offset + pixelMargin : 0;
    let spacingOffset = 0;
    const alpha = end - start;
    if (spacing) {
        // When spacing is present, it is the same for all items
        // So we adjust the start and end angle of the arc such that
        // the distance is the same as it would be without the spacing
        const noSpacingInnerRadius = innerR > 0 ? innerR - spacing : 0;
        const noSpacingOuterRadius = outerRadius > 0 ? outerRadius - spacing : 0;
        const avNogSpacingRadius = (noSpacingInnerRadius + noSpacingOuterRadius) / 2;
        const adjustedAngle = avNogSpacingRadius !== 0 ? alpha * avNogSpacingRadius / (avNogSpacingRadius + spacing) : alpha;
        spacingOffset = (alpha - adjustedAngle) / 2;
    }
    const beta = Math.max(0.001, alpha * outerRadius - offset / (0, $84f61e7391a78632$export$56c0d5a1e737357d)) / outerRadius;
    const angleOffset = (alpha - beta) / 2;
    const startAngle = start + angleOffset + spacingOffset;
    const endAngle = end - angleOffset - spacingOffset;
    const { outerStart: outerStart, outerEnd: outerEnd, innerStart: innerStart, innerEnd: innerEnd } = $216d2bdc6f281bf6$var$parseBorderRadius$1(element, innerRadius, outerRadius, endAngle - startAngle);
    const outerStartAdjustedRadius = outerRadius - outerStart;
    const outerEndAdjustedRadius = outerRadius - outerEnd;
    const outerStartAdjustedAngle = startAngle + outerStart / outerStartAdjustedRadius;
    const outerEndAdjustedAngle = endAngle - outerEnd / outerEndAdjustedRadius;
    const innerStartAdjustedRadius = innerRadius + innerStart;
    const innerEndAdjustedRadius = innerRadius + innerEnd;
    const innerStartAdjustedAngle = startAngle + innerStart / innerStartAdjustedRadius;
    const innerEndAdjustedAngle = endAngle - innerEnd / innerEndAdjustedRadius;
    ctx.beginPath();
    if (circular) {
        // The first arc segments from point 1 to point a to point 2
        const outerMidAdjustedAngle = (outerStartAdjustedAngle + outerEndAdjustedAngle) / 2;
        ctx.arc(x, y, outerRadius, outerStartAdjustedAngle, outerMidAdjustedAngle);
        ctx.arc(x, y, outerRadius, outerMidAdjustedAngle, outerEndAdjustedAngle);
        // The corner segment from point 2 to point 3
        if (outerEnd > 0) {
            const pCenter = $216d2bdc6f281bf6$var$rThetaToXY(outerEndAdjustedRadius, outerEndAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, outerEnd, outerEndAdjustedAngle, endAngle + (0, $84f61e7391a78632$export$7f8ddf7c7c20b3cd));
        }
        // The line from point 3 to point 4
        const p4 = $216d2bdc6f281bf6$var$rThetaToXY(innerEndAdjustedRadius, endAngle, x, y);
        ctx.lineTo(p4.x, p4.y);
        // The corner segment from point 4 to point 5
        if (innerEnd > 0) {
            const pCenter = $216d2bdc6f281bf6$var$rThetaToXY(innerEndAdjustedRadius, innerEndAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, innerEnd, endAngle + (0, $84f61e7391a78632$export$7f8ddf7c7c20b3cd), innerEndAdjustedAngle + Math.PI);
        }
        // The inner arc from point 5 to point b to point 6
        const innerMidAdjustedAngle = (endAngle - innerEnd / innerRadius + (startAngle + innerStart / innerRadius)) / 2;
        ctx.arc(x, y, innerRadius, endAngle - innerEnd / innerRadius, innerMidAdjustedAngle, true);
        ctx.arc(x, y, innerRadius, innerMidAdjustedAngle, startAngle + innerStart / innerRadius, true);
        // The corner segment from point 6 to point 7
        if (innerStart > 0) {
            const pCenter = $216d2bdc6f281bf6$var$rThetaToXY(innerStartAdjustedRadius, innerStartAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, innerStart, innerStartAdjustedAngle + Math.PI, startAngle - (0, $84f61e7391a78632$export$7f8ddf7c7c20b3cd));
        }
        // The line from point 7 to point 8
        const p8 = $216d2bdc6f281bf6$var$rThetaToXY(outerStartAdjustedRadius, startAngle, x, y);
        ctx.lineTo(p8.x, p8.y);
        // The corner segment from point 8 to point 1
        if (outerStart > 0) {
            const pCenter = $216d2bdc6f281bf6$var$rThetaToXY(outerStartAdjustedRadius, outerStartAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, outerStart, startAngle - (0, $84f61e7391a78632$export$7f8ddf7c7c20b3cd), outerStartAdjustedAngle);
        }
    } else {
        ctx.moveTo(x, y);
        const outerStartX = Math.cos(outerStartAdjustedAngle) * outerRadius + x;
        const outerStartY = Math.sin(outerStartAdjustedAngle) * outerRadius + y;
        ctx.lineTo(outerStartX, outerStartY);
        const outerEndX = Math.cos(outerEndAdjustedAngle) * outerRadius + x;
        const outerEndY = Math.sin(outerEndAdjustedAngle) * outerRadius + y;
        ctx.lineTo(outerEndX, outerEndY);
    }
    ctx.closePath();
}
function $216d2bdc6f281bf6$var$drawArc(ctx, element, offset, spacing, circular) {
    const { fullCircles: fullCircles, startAngle: startAngle, circumference: circumference } = element;
    let endAngle = element.endAngle;
    if (fullCircles) {
        $216d2bdc6f281bf6$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
        for(let i = 0; i < fullCircles; ++i)ctx.fill();
        if (!isNaN(circumference)) endAngle = startAngle + (circumference % (0, $84f61e7391a78632$export$971d5caa766a69d7) || (0, $84f61e7391a78632$export$971d5caa766a69d7));
    }
    $216d2bdc6f281bf6$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
    ctx.fill();
    return endAngle;
}
function $216d2bdc6f281bf6$var$drawBorder(ctx, element, offset, spacing, circular) {
    const { fullCircles: fullCircles, startAngle: startAngle, circumference: circumference, options: options } = element;
    const { borderWidth: borderWidth, borderJoinStyle: borderJoinStyle, borderDash: borderDash, borderDashOffset: borderDashOffset } = options;
    const inner = options.borderAlign === 'inner';
    if (!borderWidth) return;
    ctx.setLineDash(borderDash || []);
    ctx.lineDashOffset = borderDashOffset;
    if (inner) {
        ctx.lineWidth = borderWidth * 2;
        ctx.lineJoin = borderJoinStyle || 'round';
    } else {
        ctx.lineWidth = borderWidth;
        ctx.lineJoin = borderJoinStyle || 'bevel';
    }
    let endAngle = element.endAngle;
    if (fullCircles) {
        $216d2bdc6f281bf6$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
        for(let i = 0; i < fullCircles; ++i)ctx.stroke();
        if (!isNaN(circumference)) endAngle = startAngle + (circumference % (0, $84f61e7391a78632$export$971d5caa766a69d7) || (0, $84f61e7391a78632$export$971d5caa766a69d7));
    }
    if (inner) $216d2bdc6f281bf6$var$clipArc(ctx, element, endAngle);
    if (!fullCircles) {
        $216d2bdc6f281bf6$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
        ctx.stroke();
    }
}
class $216d2bdc6f281bf6$export$d48203c759d6a1fc extends $216d2bdc6f281bf6$export$db77ccec0bb4ccac {
    static id = 'arc';
    static defaults = {
        borderAlign: 'center',
        borderColor: '#fff',
        borderDash: [],
        borderDashOffset: 0,
        borderJoinStyle: undefined,
        borderRadius: 0,
        borderWidth: 2,
        offset: 0,
        spacing: 0,
        angle: undefined,
        circular: true
    };
    static defaultRoutes = {
        backgroundColor: 'backgroundColor'
    };
    static descriptors = {
        _scriptable: true,
        _indexable: (name)=>name !== 'borderDash'
    };
    circumference;
    endAngle;
    fullCircles;
    innerRadius;
    outerRadius;
    pixelMargin;
    startAngle;
    constructor(cfg){
        super();
        this.options = undefined;
        this.circumference = undefined;
        this.startAngle = undefined;
        this.endAngle = undefined;
        this.innerRadius = undefined;
        this.outerRadius = undefined;
        this.pixelMargin = 0;
        this.fullCircles = 0;
        if (cfg) Object.assign(this, cfg);
    }
    inRange(chartX, chartY, useFinalPosition) {
        const point = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        const { angle: angle, distance: distance } = (0, $84f61e7391a78632$export$96f57966bedc81b4)(point, {
            x: chartX,
            y: chartY
        });
        const { startAngle: startAngle, endAngle: endAngle, innerRadius: innerRadius, outerRadius: outerRadius, circumference: circumference } = this.getProps([
            'startAngle',
            'endAngle',
            'innerRadius',
            'outerRadius',
            'circumference'
        ], useFinalPosition);
        const rAdjust = (this.options.spacing + this.options.borderWidth) / 2;
        const _circumference = (0, $84f61e7391a78632$export$90a7f3efeed30595)(circumference, endAngle - startAngle);
        const nonZeroBetween = (0, $84f61e7391a78632$export$ffb5f4729a158638)(angle, startAngle, endAngle) && startAngle !== endAngle;
        const betweenAngles = _circumference >= (0, $84f61e7391a78632$export$971d5caa766a69d7) || nonZeroBetween;
        const withinRadius = (0, $84f61e7391a78632$export$21579262ef46735b)(distance, innerRadius + rAdjust, outerRadius + rAdjust);
        return betweenAngles && withinRadius;
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y, startAngle: startAngle, endAngle: endAngle, innerRadius: innerRadius, outerRadius: outerRadius } = this.getProps([
            'x',
            'y',
            'startAngle',
            'endAngle',
            'innerRadius',
            'outerRadius'
        ], useFinalPosition);
        const { offset: offset, spacing: spacing } = this.options;
        const halfAngle = (startAngle + endAngle) / 2;
        const halfRadius = (innerRadius + outerRadius + spacing + offset) / 2;
        return {
            x: x + Math.cos(halfAngle) * halfRadius,
            y: y + Math.sin(halfAngle) * halfRadius
        };
    }
    tooltipPosition(useFinalPosition) {
        return this.getCenterPoint(useFinalPosition);
    }
    draw(ctx) {
        const { options: options, circumference: circumference } = this;
        const offset = (options.offset || 0) / 4;
        const spacing = (options.spacing || 0) / 2;
        const circular = options.circular;
        this.pixelMargin = options.borderAlign === 'inner' ? 0.33 : 0;
        this.fullCircles = circumference > (0, $84f61e7391a78632$export$971d5caa766a69d7) ? Math.floor(circumference / (0, $84f61e7391a78632$export$971d5caa766a69d7)) : 0;
        if (circumference === 0 || this.innerRadius < 0 || this.outerRadius < 0) return;
        ctx.save();
        const halfAngle = (this.startAngle + this.endAngle) / 2;
        ctx.translate(Math.cos(halfAngle) * offset, Math.sin(halfAngle) * offset);
        const fix = 1 - Math.sin(Math.min((0, $84f61e7391a78632$export$56c0d5a1e737357d), circumference || 0));
        const radiusOffset = offset * fix;
        ctx.fillStyle = options.backgroundColor;
        ctx.strokeStyle = options.borderColor;
        $216d2bdc6f281bf6$var$drawArc(ctx, this, radiusOffset, spacing, circular);
        $216d2bdc6f281bf6$var$drawBorder(ctx, this, radiusOffset, spacing, circular);
        ctx.restore();
    }
}
function $216d2bdc6f281bf6$var$setStyle(ctx, options, style = options) {
    ctx.lineCap = (0, $84f61e7391a78632$export$90a7f3efeed30595)(style.borderCapStyle, options.borderCapStyle);
    ctx.setLineDash((0, $84f61e7391a78632$export$90a7f3efeed30595)(style.borderDash, options.borderDash));
    ctx.lineDashOffset = (0, $84f61e7391a78632$export$90a7f3efeed30595)(style.borderDashOffset, options.borderDashOffset);
    ctx.lineJoin = (0, $84f61e7391a78632$export$90a7f3efeed30595)(style.borderJoinStyle, options.borderJoinStyle);
    ctx.lineWidth = (0, $84f61e7391a78632$export$90a7f3efeed30595)(style.borderWidth, options.borderWidth);
    ctx.strokeStyle = (0, $84f61e7391a78632$export$90a7f3efeed30595)(style.borderColor, options.borderColor);
}
function $216d2bdc6f281bf6$var$lineTo(ctx, previous, target) {
    ctx.lineTo(target.x, target.y);
}
function $216d2bdc6f281bf6$var$getLineMethod(options) {
    if (options.stepped) return 0, $84f61e7391a78632$export$6554612db691658e;
    if (options.tension || options.cubicInterpolationMode === 'monotone') return 0, $84f61e7391a78632$export$493d36ec626b6698;
    return $216d2bdc6f281bf6$var$lineTo;
}
function $216d2bdc6f281bf6$var$pathVars(points, segment, params = {}) {
    const count = points.length;
    const { start: paramsStart = 0, end: paramsEnd = count - 1 } = params;
    const { start: segmentStart, end: segmentEnd } = segment;
    const start = Math.max(paramsStart, segmentStart);
    const end = Math.min(paramsEnd, segmentEnd);
    const outside = paramsStart < segmentStart && paramsEnd < segmentStart || paramsStart > segmentEnd && paramsEnd > segmentEnd;
    return {
        count: count,
        start: start,
        loop: segment.loop,
        ilen: end < start && !outside ? count + end - start : end - start
    };
}
function $216d2bdc6f281bf6$var$pathSegment(ctx, line, segment, params) {
    const { points: points, options: options } = line;
    const { count: count, start: start, loop: loop, ilen: ilen } = $216d2bdc6f281bf6$var$pathVars(points, segment, params);
    const lineMethod = $216d2bdc6f281bf6$var$getLineMethod(options);
    let { move: move = true, reverse: reverse } = params || {};
    let i, point, prev;
    for(i = 0; i <= ilen; ++i){
        point = points[(start + (reverse ? ilen - i : i)) % count];
        if (point.skip) continue;
        else if (move) {
            ctx.moveTo(point.x, point.y);
            move = false;
        } else lineMethod(ctx, prev, point, reverse, options.stepped);
        prev = point;
    }
    if (loop) {
        point = points[(start + (reverse ? ilen : 0)) % count];
        lineMethod(ctx, prev, point, reverse, options.stepped);
    }
    return !!loop;
}
function $216d2bdc6f281bf6$var$fastPathSegment(ctx, line, segment, params) {
    const points = line.points;
    const { count: count, start: start, ilen: ilen } = $216d2bdc6f281bf6$var$pathVars(points, segment, params);
    const { move: move = true, reverse: reverse } = params || {};
    let avgX = 0;
    let countX = 0;
    let i, point, prevX, minY, maxY, lastY;
    const pointIndex = (index)=>(start + (reverse ? ilen - index : index)) % count;
    const drawX = ()=>{
        if (minY !== maxY) {
            ctx.lineTo(avgX, maxY);
            ctx.lineTo(avgX, minY);
            ctx.lineTo(avgX, lastY);
        }
    };
    if (move) {
        point = points[pointIndex(0)];
        ctx.moveTo(point.x, point.y);
    }
    for(i = 0; i <= ilen; ++i){
        point = points[pointIndex(i)];
        if (point.skip) continue;
        const x = point.x;
        const y = point.y;
        const truncX = x | 0;
        if (truncX === prevX) {
            if (y < minY) minY = y;
            else if (y > maxY) maxY = y;
            avgX = (countX * avgX + x) / ++countX;
        } else {
            drawX();
            ctx.lineTo(x, y);
            prevX = truncX;
            countX = 0;
            minY = maxY = y;
        }
        lastY = y;
    }
    drawX();
}
function $216d2bdc6f281bf6$var$_getSegmentMethod(line) {
    const opts = line.options;
    const borderDash = opts.borderDash && opts.borderDash.length;
    const useFastPath = !line._decimated && !line._loop && !opts.tension && opts.cubicInterpolationMode !== 'monotone' && !opts.stepped && !borderDash;
    return useFastPath ? $216d2bdc6f281bf6$var$fastPathSegment : $216d2bdc6f281bf6$var$pathSegment;
}
function $216d2bdc6f281bf6$var$_getInterpolationMethod(options) {
    if (options.stepped) return 0, $84f61e7391a78632$export$2f6ca3d3b1f80bf5;
    if (options.tension || options.cubicInterpolationMode === 'monotone') return 0, $84f61e7391a78632$export$8a5498727ef6be21;
    return 0, $84f61e7391a78632$export$d24c54395ce0c509;
}
function $216d2bdc6f281bf6$var$strokePathWithCache(ctx, line, start, count) {
    let path = line._path;
    if (!path) {
        path = line._path = new Path2D();
        if (line.path(path, start, count)) path.closePath();
    }
    $216d2bdc6f281bf6$var$setStyle(ctx, line.options);
    ctx.stroke(path);
}
function $216d2bdc6f281bf6$var$strokePathDirect(ctx, line, start, count) {
    const { segments: segments, options: options } = line;
    const segmentMethod = $216d2bdc6f281bf6$var$_getSegmentMethod(line);
    for (const segment of segments){
        $216d2bdc6f281bf6$var$setStyle(ctx, options, segment.style);
        ctx.beginPath();
        if (segmentMethod(ctx, line, segment, {
            start: start,
            end: start + count - 1
        })) ctx.closePath();
        ctx.stroke();
    }
}
const $216d2bdc6f281bf6$var$usePath2D = typeof Path2D === 'function';
function $216d2bdc6f281bf6$var$draw(ctx, line, start, count) {
    if ($216d2bdc6f281bf6$var$usePath2D && !line.options.segment) $216d2bdc6f281bf6$var$strokePathWithCache(ctx, line, start, count);
    else $216d2bdc6f281bf6$var$strokePathDirect(ctx, line, start, count);
}
class $216d2bdc6f281bf6$export$55e463fa7bcd3469 extends $216d2bdc6f281bf6$export$db77ccec0bb4ccac {
    static id = 'line';
    static defaults = {
        borderCapStyle: 'butt',
        borderDash: [],
        borderDashOffset: 0,
        borderJoinStyle: 'miter',
        borderWidth: 3,
        capBezierPoints: true,
        cubicInterpolationMode: 'default',
        fill: false,
        spanGaps: false,
        stepped: false,
        tension: 0
    };
    static defaultRoutes = {
        backgroundColor: 'backgroundColor',
        borderColor: 'borderColor'
    };
    static descriptors = {
        _scriptable: true,
        _indexable: (name)=>name !== 'borderDash' && name !== 'fill'
    };
    constructor(cfg){
        super();
        this.animated = true;
        this.options = undefined;
        this._chart = undefined;
        this._loop = undefined;
        this._fullLoop = undefined;
        this._path = undefined;
        this._points = undefined;
        this._segments = undefined;
        this._decimated = false;
        this._pointsUpdated = false;
        this._datasetIndex = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    updateControlPoints(chartArea, indexAxis) {
        const options = this.options;
        if ((options.tension || options.cubicInterpolationMode === 'monotone') && !options.stepped && !this._pointsUpdated) {
            const loop = options.spanGaps ? this._loop : this._fullLoop;
            (0, $84f61e7391a78632$export$1a82df3d29112e01)(this._points, options, chartArea, loop, indexAxis);
            this._pointsUpdated = true;
        }
    }
    set points(points) {
        this._points = points;
        delete this._segments;
        delete this._path;
        this._pointsUpdated = false;
    }
    get points() {
        return this._points;
    }
    get segments() {
        return this._segments || (this._segments = (0, $84f61e7391a78632$export$306ddfe3a8403e2)(this, this.options.segment));
    }
    first() {
        const segments = this.segments;
        const points = this.points;
        return segments.length && points[segments[0].start];
    }
    last() {
        const segments = this.segments;
        const points = this.points;
        const count = segments.length;
        return count && points[segments[count - 1].end];
    }
    interpolate(point, property) {
        const options = this.options;
        const value = point[property];
        const points = this.points;
        const segments = (0, $84f61e7391a78632$export$7a38258bbe170828)(this, {
            property: property,
            start: value,
            end: value
        });
        if (!segments.length) return;
        const result = [];
        const _interpolate = $216d2bdc6f281bf6$var$_getInterpolationMethod(options);
        let i, ilen;
        for(i = 0, ilen = segments.length; i < ilen; ++i){
            const { start: start, end: end } = segments[i];
            const p1 = points[start];
            const p2 = points[end];
            if (p1 === p2) {
                result.push(p1);
                continue;
            }
            const t = Math.abs((value - p1[property]) / (p2[property] - p1[property]));
            const interpolated = _interpolate(p1, p2, t, options.stepped);
            interpolated[property] = point[property];
            result.push(interpolated);
        }
        return result.length === 1 ? result[0] : result;
    }
    pathSegment(ctx, segment, params) {
        const segmentMethod = $216d2bdc6f281bf6$var$_getSegmentMethod(this);
        return segmentMethod(ctx, this, segment, params);
    }
    path(ctx, start, count) {
        const segments = this.segments;
        const segmentMethod = $216d2bdc6f281bf6$var$_getSegmentMethod(this);
        let loop = this._loop;
        start = start || 0;
        count = count || this.points.length - start;
        for (const segment of segments)loop &= segmentMethod(ctx, this, segment, {
            start: start,
            end: start + count - 1
        });
        return !!loop;
    }
    draw(ctx, chartArea, start, count) {
        const options = this.options || {};
        const points = this.points || [];
        if (points.length && options.borderWidth) {
            ctx.save();
            $216d2bdc6f281bf6$var$draw(ctx, this, start, count);
            ctx.restore();
        }
        if (this.animated) {
            this._pointsUpdated = false;
            this._path = undefined;
        }
    }
}
function $216d2bdc6f281bf6$var$inRange$1(el, pos, axis, useFinalPosition) {
    const options = el.options;
    const { [axis]: value } = el.getProps([
        axis
    ], useFinalPosition);
    return Math.abs(pos - value) < options.radius + options.hitRadius;
}
class $216d2bdc6f281bf6$export$bd159b522b230b7a extends $216d2bdc6f281bf6$export$db77ccec0bb4ccac {
    static id = 'point';
    parsed;
    skip;
    stop;
    /**
   * @type {any}
   */ static defaults = {
        borderWidth: 1,
        hitRadius: 1,
        hoverBorderWidth: 1,
        hoverRadius: 4,
        pointStyle: 'circle',
        radius: 3,
        rotation: 0
    };
    /**
   * @type {any}
   */ static defaultRoutes = {
        backgroundColor: 'backgroundColor',
        borderColor: 'borderColor'
    };
    constructor(cfg){
        super();
        this.options = undefined;
        this.parsed = undefined;
        this.skip = undefined;
        this.stop = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    inRange(mouseX, mouseY, useFinalPosition) {
        const options = this.options;
        const { x: x, y: y } = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        return Math.pow(mouseX - x, 2) + Math.pow(mouseY - y, 2) < Math.pow(options.hitRadius + options.radius, 2);
    }
    inXRange(mouseX, useFinalPosition) {
        return $216d2bdc6f281bf6$var$inRange$1(this, mouseX, 'x', useFinalPosition);
    }
    inYRange(mouseY, useFinalPosition) {
        return $216d2bdc6f281bf6$var$inRange$1(this, mouseY, 'y', useFinalPosition);
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y } = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        return {
            x: x,
            y: y
        };
    }
    size(options) {
        options = options || this.options || {};
        let radius = options.radius || 0;
        radius = Math.max(radius, radius && options.hoverRadius || 0);
        const borderWidth = radius && options.borderWidth || 0;
        return (radius + borderWidth) * 2;
    }
    draw(ctx, area) {
        const options = this.options;
        if (this.skip || options.radius < 0.1 || !(0, $84f61e7391a78632$export$e7094788287c5e9b)(this, area, this.size(options) / 2)) return;
        ctx.strokeStyle = options.borderColor;
        ctx.lineWidth = options.borderWidth;
        ctx.fillStyle = options.backgroundColor;
        (0, $84f61e7391a78632$export$1fbe638ecf81657e)(ctx, options, this.x, this.y);
    }
    getRange() {
        const options = this.options || {};
        // @ts-expect-error Fallbacks should never be hit in practice
        return options.radius + options.hitRadius;
    }
}
function $216d2bdc6f281bf6$var$getBarBounds(bar, useFinalPosition) {
    const { x: x, y: y, base: base, width: width, height: height } = bar.getProps([
        'x',
        'y',
        'base',
        'width',
        'height'
    ], useFinalPosition);
    let left, right, top, bottom, half;
    if (bar.horizontal) {
        half = height / 2;
        left = Math.min(x, base);
        right = Math.max(x, base);
        top = y - half;
        bottom = y + half;
    } else {
        half = width / 2;
        left = x - half;
        right = x + half;
        top = Math.min(y, base);
        bottom = Math.max(y, base);
    }
    return {
        left: left,
        top: top,
        right: right,
        bottom: bottom
    };
}
function $216d2bdc6f281bf6$var$skipOrLimit(skip, value, min, max) {
    return skip ? 0 : (0, $84f61e7391a78632$export$25ce5a424b770e84)(value, min, max);
}
function $216d2bdc6f281bf6$var$parseBorderWidth(bar, maxW, maxH) {
    const value = bar.options.borderWidth;
    const skip = bar.borderSkipped;
    const o = (0, $84f61e7391a78632$export$92108d983e8ee699)(value);
    return {
        t: $216d2bdc6f281bf6$var$skipOrLimit(skip.top, o.top, 0, maxH),
        r: $216d2bdc6f281bf6$var$skipOrLimit(skip.right, o.right, 0, maxW),
        b: $216d2bdc6f281bf6$var$skipOrLimit(skip.bottom, o.bottom, 0, maxH),
        l: $216d2bdc6f281bf6$var$skipOrLimit(skip.left, o.left, 0, maxW)
    };
}
function $216d2bdc6f281bf6$var$parseBorderRadius(bar, maxW, maxH) {
    const { enableBorderRadius: enableBorderRadius } = bar.getProps([
        'enableBorderRadius'
    ]);
    const value = bar.options.borderRadius;
    const o = (0, $84f61e7391a78632$export$9fa96a7d116ea3ce)(value);
    const maxR = Math.min(maxW, maxH);
    const skip = bar.borderSkipped;
    const enableBorder = enableBorderRadius || (0, $84f61e7391a78632$export$23f2a1d2818174ef)(value);
    return {
        topLeft: $216d2bdc6f281bf6$var$skipOrLimit(!enableBorder || skip.top || skip.left, o.topLeft, 0, maxR),
        topRight: $216d2bdc6f281bf6$var$skipOrLimit(!enableBorder || skip.top || skip.right, o.topRight, 0, maxR),
        bottomLeft: $216d2bdc6f281bf6$var$skipOrLimit(!enableBorder || skip.bottom || skip.left, o.bottomLeft, 0, maxR),
        bottomRight: $216d2bdc6f281bf6$var$skipOrLimit(!enableBorder || skip.bottom || skip.right, o.bottomRight, 0, maxR)
    };
}
function $216d2bdc6f281bf6$var$boundingRects(bar) {
    const bounds = $216d2bdc6f281bf6$var$getBarBounds(bar);
    const width = bounds.right - bounds.left;
    const height = bounds.bottom - bounds.top;
    const border = $216d2bdc6f281bf6$var$parseBorderWidth(bar, width / 2, height / 2);
    const radius = $216d2bdc6f281bf6$var$parseBorderRadius(bar, width / 2, height / 2);
    return {
        outer: {
            x: bounds.left,
            y: bounds.top,
            w: width,
            h: height,
            radius: radius
        },
        inner: {
            x: bounds.left + border.l,
            y: bounds.top + border.t,
            w: width - border.l - border.r,
            h: height - border.t - border.b,
            radius: {
                topLeft: Math.max(0, radius.topLeft - Math.max(border.t, border.l)),
                topRight: Math.max(0, radius.topRight - Math.max(border.t, border.r)),
                bottomLeft: Math.max(0, radius.bottomLeft - Math.max(border.b, border.l)),
                bottomRight: Math.max(0, radius.bottomRight - Math.max(border.b, border.r))
            }
        }
    };
}
function $216d2bdc6f281bf6$var$inRange(bar, x, y, useFinalPosition) {
    const skipX = x === null;
    const skipY = y === null;
    const skipBoth = skipX && skipY;
    const bounds = bar && !skipBoth && $216d2bdc6f281bf6$var$getBarBounds(bar, useFinalPosition);
    return bounds && (skipX || (0, $84f61e7391a78632$export$21579262ef46735b)(x, bounds.left, bounds.right)) && (skipY || (0, $84f61e7391a78632$export$21579262ef46735b)(y, bounds.top, bounds.bottom));
}
function $216d2bdc6f281bf6$var$hasRadius(radius) {
    return radius.topLeft || radius.topRight || radius.bottomLeft || radius.bottomRight;
}
function $216d2bdc6f281bf6$var$addNormalRectPath(ctx, rect) {
    ctx.rect(rect.x, rect.y, rect.w, rect.h);
}
function $216d2bdc6f281bf6$var$inflateRect(rect, amount, refRect = {}) {
    const x = rect.x !== refRect.x ? -amount : 0;
    const y = rect.y !== refRect.y ? -amount : 0;
    const w = (rect.x + rect.w !== refRect.x + refRect.w ? amount : 0) - x;
    const h = (rect.y + rect.h !== refRect.y + refRect.h ? amount : 0) - y;
    return {
        x: rect.x + x,
        y: rect.y + y,
        w: rect.w + w,
        h: rect.h + h,
        radius: rect.radius
    };
}
class $216d2bdc6f281bf6$export$a16ed71bf4b07672 extends $216d2bdc6f281bf6$export$db77ccec0bb4ccac {
    static id = 'bar';
    static defaults = {
        borderSkipped: 'start',
        borderWidth: 0,
        borderRadius: 0,
        inflateAmount: 'auto',
        pointStyle: undefined
    };
    static defaultRoutes = {
        backgroundColor: 'backgroundColor',
        borderColor: 'borderColor'
    };
    constructor(cfg){
        super();
        this.options = undefined;
        this.horizontal = undefined;
        this.base = undefined;
        this.width = undefined;
        this.height = undefined;
        this.inflateAmount = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    draw(ctx) {
        const { inflateAmount: inflateAmount, options: { borderColor: borderColor, backgroundColor: backgroundColor } } = this;
        const { inner: inner, outer: outer } = $216d2bdc6f281bf6$var$boundingRects(this);
        const addRectPath = $216d2bdc6f281bf6$var$hasRadius(outer.radius) ? (0, $84f61e7391a78632$export$d66dc83d8cfc8dd) : $216d2bdc6f281bf6$var$addNormalRectPath;
        ctx.save();
        if (outer.w !== inner.w || outer.h !== inner.h) {
            ctx.beginPath();
            addRectPath(ctx, $216d2bdc6f281bf6$var$inflateRect(outer, inflateAmount, inner));
            ctx.clip();
            addRectPath(ctx, $216d2bdc6f281bf6$var$inflateRect(inner, -inflateAmount, outer));
            ctx.fillStyle = borderColor;
            ctx.fill('evenodd');
        }
        ctx.beginPath();
        addRectPath(ctx, $216d2bdc6f281bf6$var$inflateRect(inner, inflateAmount));
        ctx.fillStyle = backgroundColor;
        ctx.fill();
        ctx.restore();
    }
    inRange(mouseX, mouseY, useFinalPosition) {
        return $216d2bdc6f281bf6$var$inRange(this, mouseX, mouseY, useFinalPosition);
    }
    inXRange(mouseX, useFinalPosition) {
        return $216d2bdc6f281bf6$var$inRange(this, mouseX, null, useFinalPosition);
    }
    inYRange(mouseY, useFinalPosition) {
        return $216d2bdc6f281bf6$var$inRange(this, null, mouseY, useFinalPosition);
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y, base: base, horizontal: horizontal } = this.getProps([
            'x',
            'y',
            'base',
            'horizontal'
        ], useFinalPosition);
        return {
            x: horizontal ? (x + base) / 2 : x,
            y: horizontal ? y : (y + base) / 2
        };
    }
    getRange(axis) {
        return axis === 'x' ? this.width / 2 : this.height / 2;
    }
}
var $216d2bdc6f281bf6$export$7a5d735b2ab6389d = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ArcElement: $216d2bdc6f281bf6$export$d48203c759d6a1fc,
    BarElement: $216d2bdc6f281bf6$export$a16ed71bf4b07672,
    LineElement: $216d2bdc6f281bf6$export$55e463fa7bcd3469,
    PointElement: $216d2bdc6f281bf6$export$bd159b522b230b7a
});
const $216d2bdc6f281bf6$var$BORDER_COLORS = [
    'rgb(54, 162, 235)',
    'rgb(255, 99, 132)',
    'rgb(255, 159, 64)',
    'rgb(255, 205, 86)',
    'rgb(75, 192, 192)',
    'rgb(153, 102, 255)',
    'rgb(201, 203, 207)' // grey
];
// Border colors with 50% transparency
const $216d2bdc6f281bf6$var$BACKGROUND_COLORS = /* #__PURE__ */ $216d2bdc6f281bf6$var$BORDER_COLORS.map((color)=>color.replace('rgb(', 'rgba(').replace(')', ', 0.5)'));
function $216d2bdc6f281bf6$var$getBorderColor(i) {
    return $216d2bdc6f281bf6$var$BORDER_COLORS[i % $216d2bdc6f281bf6$var$BORDER_COLORS.length];
}
function $216d2bdc6f281bf6$var$getBackgroundColor(i) {
    return $216d2bdc6f281bf6$var$BACKGROUND_COLORS[i % $216d2bdc6f281bf6$var$BACKGROUND_COLORS.length];
}
function $216d2bdc6f281bf6$var$colorizeDefaultDataset(dataset, i) {
    dataset.borderColor = $216d2bdc6f281bf6$var$getBorderColor(i);
    dataset.backgroundColor = $216d2bdc6f281bf6$var$getBackgroundColor(i);
    return ++i;
}
function $216d2bdc6f281bf6$var$colorizeDoughnutDataset(dataset, i) {
    dataset.backgroundColor = dataset.data.map(()=>$216d2bdc6f281bf6$var$getBorderColor(i++));
    return i;
}
function $216d2bdc6f281bf6$var$colorizePolarAreaDataset(dataset, i) {
    dataset.backgroundColor = dataset.data.map(()=>$216d2bdc6f281bf6$var$getBackgroundColor(i++));
    return i;
}
function $216d2bdc6f281bf6$var$getColorizer(chart) {
    let i = 0;
    return (dataset, datasetIndex)=>{
        const controller = chart.getDatasetMeta(datasetIndex).controller;
        if (controller instanceof $216d2bdc6f281bf6$export$e04603e7d8b77172) i = $216d2bdc6f281bf6$var$colorizeDoughnutDataset(dataset, i);
        else if (controller instanceof $216d2bdc6f281bf6$export$2a270b3a0d973c85) i = $216d2bdc6f281bf6$var$colorizePolarAreaDataset(dataset, i);
        else if (controller) i = $216d2bdc6f281bf6$var$colorizeDefaultDataset(dataset, i);
    };
}
function $216d2bdc6f281bf6$var$containsColorsDefinitions(descriptors) {
    let k;
    for(k in descriptors){
        if (descriptors[k].borderColor || descriptors[k].backgroundColor) return true;
    }
    return false;
}
function $216d2bdc6f281bf6$var$containsColorsDefinition(descriptor) {
    return descriptor && (descriptor.borderColor || descriptor.backgroundColor);
}
function $216d2bdc6f281bf6$var$containsDefaultColorsDefenitions() {
    return (0, $84f61e7391a78632$export$4368d992c4eafac0).borderColor !== 'rgba(0,0,0,0.1)' || (0, $84f61e7391a78632$export$4368d992c4eafac0).backgroundColor !== 'rgba(0,0,0,0.1)';
}
var $216d2bdc6f281bf6$export$c537fa0d021d010b = {
    id: 'colors',
    defaults: {
        enabled: true,
        forceOverride: false
    },
    beforeLayout (chart, _args, options) {
        if (!options.enabled) return;
        const { data: { datasets: datasets }, options: chartOptions } = chart.config;
        const { elements: elements } = chartOptions;
        const containsColorDefenition = $216d2bdc6f281bf6$var$containsColorsDefinitions(datasets) || $216d2bdc6f281bf6$var$containsColorsDefinition(chartOptions) || elements && $216d2bdc6f281bf6$var$containsColorsDefinitions(elements) || $216d2bdc6f281bf6$var$containsDefaultColorsDefenitions();
        if (!options.forceOverride && containsColorDefenition) return;
        const colorizer = $216d2bdc6f281bf6$var$getColorizer(chart);
        datasets.forEach(colorizer);
    }
};
function $216d2bdc6f281bf6$var$lttbDecimation(data, start, count, availableWidth, options) {
    const samples = options.samples || availableWidth;
    if (samples >= count) return data.slice(start, start + count);
    const decimated = [];
    const bucketWidth = (count - 2) / (samples - 2);
    let sampledIndex = 0;
    const endIndex = start + count - 1;
    let a = start;
    let i, maxAreaPoint, maxArea, area, nextA;
    decimated[sampledIndex++] = data[a];
    for(i = 0; i < samples - 2; i++){
        let avgX = 0;
        let avgY = 0;
        let j;
        const avgRangeStart = Math.floor((i + 1) * bucketWidth) + 1 + start;
        const avgRangeEnd = Math.min(Math.floor((i + 2) * bucketWidth) + 1, count) + start;
        const avgRangeLength = avgRangeEnd - avgRangeStart;
        for(j = avgRangeStart; j < avgRangeEnd; j++){
            avgX += data[j].x;
            avgY += data[j].y;
        }
        avgX /= avgRangeLength;
        avgY /= avgRangeLength;
        const rangeOffs = Math.floor(i * bucketWidth) + 1 + start;
        const rangeTo = Math.min(Math.floor((i + 1) * bucketWidth) + 1, count) + start;
        const { x: pointAx, y: pointAy } = data[a];
        maxArea = area = -1;
        for(j = rangeOffs; j < rangeTo; j++){
            area = 0.5 * Math.abs((pointAx - avgX) * (data[j].y - pointAy) - (pointAx - data[j].x) * (avgY - pointAy));
            if (area > maxArea) {
                maxArea = area;
                maxAreaPoint = data[j];
                nextA = j;
            }
        }
        decimated[sampledIndex++] = maxAreaPoint;
        a = nextA;
    }
    decimated[sampledIndex++] = data[endIndex];
    return decimated;
}
function $216d2bdc6f281bf6$var$minMaxDecimation(data, start, count, availableWidth) {
    let avgX = 0;
    let countX = 0;
    let i, point, x, y, prevX, minIndex, maxIndex, startIndex, minY, maxY;
    const decimated = [];
    const endIndex = start + count - 1;
    const xMin = data[start].x;
    const xMax = data[endIndex].x;
    const dx = xMax - xMin;
    for(i = start; i < start + count; ++i){
        point = data[i];
        x = (point.x - xMin) / dx * availableWidth;
        y = point.y;
        const truncX = x | 0;
        if (truncX === prevX) {
            if (y < minY) {
                minY = y;
                minIndex = i;
            } else if (y > maxY) {
                maxY = y;
                maxIndex = i;
            }
            avgX = (countX * avgX + point.x) / ++countX;
        } else {
            const lastIndex = i - 1;
            if (!(0, $84f61e7391a78632$export$342063e11d6c3cad)(minIndex) && !(0, $84f61e7391a78632$export$342063e11d6c3cad)(maxIndex)) {
                const intermediateIndex1 = Math.min(minIndex, maxIndex);
                const intermediateIndex2 = Math.max(minIndex, maxIndex);
                if (intermediateIndex1 !== startIndex && intermediateIndex1 !== lastIndex) decimated.push({
                    ...data[intermediateIndex1],
                    x: avgX
                });
                if (intermediateIndex2 !== startIndex && intermediateIndex2 !== lastIndex) decimated.push({
                    ...data[intermediateIndex2],
                    x: avgX
                });
            }
            if (i > 0 && lastIndex !== startIndex) decimated.push(data[lastIndex]);
            decimated.push(point);
            prevX = truncX;
            countX = 0;
            minY = maxY = y;
            minIndex = maxIndex = startIndex = i;
        }
    }
    return decimated;
}
function $216d2bdc6f281bf6$var$cleanDecimatedDataset(dataset) {
    if (dataset._decimated) {
        const data = dataset._data;
        delete dataset._decimated;
        delete dataset._data;
        Object.defineProperty(dataset, 'data', {
            configurable: true,
            enumerable: true,
            writable: true,
            value: data
        });
    }
}
function $216d2bdc6f281bf6$var$cleanDecimatedData(chart) {
    chart.data.datasets.forEach((dataset)=>{
        $216d2bdc6f281bf6$var$cleanDecimatedDataset(dataset);
    });
}
function $216d2bdc6f281bf6$var$getStartAndCountOfVisiblePointsSimplified(meta, points) {
    const pointCount = points.length;
    let start = 0;
    let count;
    const { iScale: iScale } = meta;
    const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = iScale.getUserBounds();
    if (minDefined) start = (0, $84f61e7391a78632$export$25ce5a424b770e84)((0, $84f61e7391a78632$export$ef35774e6d314e91)(points, iScale.axis, min).lo, 0, pointCount - 1);
    if (maxDefined) count = (0, $84f61e7391a78632$export$25ce5a424b770e84)((0, $84f61e7391a78632$export$ef35774e6d314e91)(points, iScale.axis, max).hi + 1, start, pointCount) - start;
    else count = pointCount - start;
    return {
        start: start,
        count: count
    };
}
var $216d2bdc6f281bf6$export$be17f937e9aa7533 = {
    id: 'decimation',
    defaults: {
        algorithm: 'min-max',
        enabled: false
    },
    beforeElementsUpdate: (chart, args, options)=>{
        if (!options.enabled) {
            $216d2bdc6f281bf6$var$cleanDecimatedData(chart);
            return;
        }
        const availableWidth = chart.width;
        chart.data.datasets.forEach((dataset, datasetIndex)=>{
            const { _data: _data, indexAxis: indexAxis } = dataset;
            const meta = chart.getDatasetMeta(datasetIndex);
            const data = _data || dataset.data;
            if ((0, $84f61e7391a78632$export$407448d2b89b1813)([
                indexAxis,
                chart.options.indexAxis
            ]) === 'y') return;
            if (!meta.controller.supportsDecimation) return;
            const xAxis = chart.scales[meta.xAxisID];
            if (xAxis.type !== 'linear' && xAxis.type !== 'time') return;
            if (chart.options.parsing) return;
            let { start: start, count: count } = $216d2bdc6f281bf6$var$getStartAndCountOfVisiblePointsSimplified(meta, data);
            const threshold = options.threshold || 4 * availableWidth;
            if (count <= threshold) {
                $216d2bdc6f281bf6$var$cleanDecimatedDataset(dataset);
                return;
            }
            if ((0, $84f61e7391a78632$export$342063e11d6c3cad)(_data)) {
                dataset._data = data;
                delete dataset.data;
                Object.defineProperty(dataset, 'data', {
                    configurable: true,
                    enumerable: true,
                    get: function() {
                        return this._decimated;
                    },
                    set: function(d) {
                        this._data = d;
                    }
                });
            }
            let decimated;
            switch(options.algorithm){
                case 'lttb':
                    decimated = $216d2bdc6f281bf6$var$lttbDecimation(data, start, count, availableWidth, options);
                    break;
                case 'min-max':
                    decimated = $216d2bdc6f281bf6$var$minMaxDecimation(data, start, count, availableWidth);
                    break;
                default:
                    throw new Error(`Unsupported decimation algorithm '${options.algorithm}'`);
            }
            dataset._decimated = decimated;
        });
    },
    destroy (chart) {
        $216d2bdc6f281bf6$var$cleanDecimatedData(chart);
    }
};
function $216d2bdc6f281bf6$var$_segments(line, target, property) {
    const segments = line.segments;
    const points = line.points;
    const tpoints = target.points;
    const parts = [];
    for (const segment of segments){
        let { start: start, end: end } = segment;
        end = $216d2bdc6f281bf6$var$_findSegmentEnd(start, end, points);
        const bounds = $216d2bdc6f281bf6$var$_getBounds(property, points[start], points[end], segment.loop);
        if (!target.segments) {
            parts.push({
                source: segment,
                target: bounds,
                start: points[start],
                end: points[end]
            });
            continue;
        }
        const targetSegments = (0, $84f61e7391a78632$export$7a38258bbe170828)(target, bounds);
        for (const tgt of targetSegments){
            const subBounds = $216d2bdc6f281bf6$var$_getBounds(property, tpoints[tgt.start], tpoints[tgt.end], tgt.loop);
            const fillSources = (0, $84f61e7391a78632$export$28f7fcd39efa255)(segment, points, subBounds);
            for (const fillSource of fillSources)parts.push({
                source: fillSource,
                target: tgt,
                start: {
                    [property]: $216d2bdc6f281bf6$var$_getEdge(bounds, subBounds, 'start', Math.max)
                },
                end: {
                    [property]: $216d2bdc6f281bf6$var$_getEdge(bounds, subBounds, 'end', Math.min)
                }
            });
        }
    }
    return parts;
}
function $216d2bdc6f281bf6$var$_getBounds(property, first, last, loop) {
    if (loop) return;
    let start = first[property];
    let end = last[property];
    if (property === 'angle') {
        start = (0, $84f61e7391a78632$export$3d12bd131bb975d1)(start);
        end = (0, $84f61e7391a78632$export$3d12bd131bb975d1)(end);
    }
    return {
        property: property,
        start: start,
        end: end
    };
}
function $216d2bdc6f281bf6$var$_pointsFromSegments(boundary, line) {
    const { x: x = null, y: y = null } = boundary || {};
    const linePoints = line.points;
    const points = [];
    line.segments.forEach(({ start: start, end: end })=>{
        end = $216d2bdc6f281bf6$var$_findSegmentEnd(start, end, linePoints);
        const first = linePoints[start];
        const last = linePoints[end];
        if (y !== null) {
            points.push({
                x: first.x,
                y: y
            });
            points.push({
                x: last.x,
                y: y
            });
        } else if (x !== null) {
            points.push({
                x: x,
                y: first.y
            });
            points.push({
                x: x,
                y: last.y
            });
        }
    });
    return points;
}
function $216d2bdc6f281bf6$var$_findSegmentEnd(start, end, points) {
    for(; end > start; end--){
        const point = points[end];
        if (!isNaN(point.x) && !isNaN(point.y)) break;
    }
    return end;
}
function $216d2bdc6f281bf6$var$_getEdge(a, b, prop, fn) {
    if (a && b) return fn(a[prop], b[prop]);
    return a ? a[prop] : b ? b[prop] : 0;
}
function $216d2bdc6f281bf6$var$_createBoundaryLine(boundary, line) {
    let points = [];
    let _loop = false;
    if ((0, $84f61e7391a78632$export$8b22cf2602fb60ce)(boundary)) {
        _loop = true;
        points = boundary;
    } else points = $216d2bdc6f281bf6$var$_pointsFromSegments(boundary, line);
    return points.length ? new $216d2bdc6f281bf6$export$55e463fa7bcd3469({
        points: points,
        options: {
            tension: 0
        },
        _loop: _loop,
        _fullLoop: _loop
    }) : null;
}
function $216d2bdc6f281bf6$var$_shouldApplyFill(source) {
    return source && source.fill !== false;
}
function $216d2bdc6f281bf6$var$_resolveTarget(sources, index, propagate) {
    const source = sources[index];
    let fill = source.fill;
    const visited = [
        index
    ];
    let target;
    if (!propagate) return fill;
    while(fill !== false && visited.indexOf(fill) === -1){
        if (!(0, $84f61e7391a78632$export$39b482c5e57630a8)(fill)) return fill;
        target = sources[fill];
        if (!target) return false;
        if (target.visible) return fill;
        visited.push(fill);
        fill = target.fill;
    }
    return false;
}
function $216d2bdc6f281bf6$var$_decodeFill(line, index, count) {
    const fill = $216d2bdc6f281bf6$var$parseFillOption(line);
    if ((0, $84f61e7391a78632$export$23f2a1d2818174ef)(fill)) return isNaN(fill.value) ? false : fill;
    let target = parseFloat(fill);
    if ((0, $84f61e7391a78632$export$39b482c5e57630a8)(target) && Math.floor(target) === target) return $216d2bdc6f281bf6$var$decodeTargetIndex(fill[0], index, target, count);
    return [
        'origin',
        'start',
        'end',
        'stack',
        'shape'
    ].indexOf(fill) >= 0 && fill;
}
function $216d2bdc6f281bf6$var$decodeTargetIndex(firstCh, index, target, count) {
    if (firstCh === '-' || firstCh === '+') target = index + target;
    if (target === index || target < 0 || target >= count) return false;
    return target;
}
function $216d2bdc6f281bf6$var$_getTargetPixel(fill, scale) {
    let pixel = null;
    if (fill === 'start') pixel = scale.bottom;
    else if (fill === 'end') pixel = scale.top;
    else if ((0, $84f61e7391a78632$export$23f2a1d2818174ef)(fill)) pixel = scale.getPixelForValue(fill.value);
    else if (scale.getBasePixel) pixel = scale.getBasePixel();
    return pixel;
}
function $216d2bdc6f281bf6$var$_getTargetValue(fill, scale, startValue) {
    let value;
    if (fill === 'start') value = startValue;
    else if (fill === 'end') value = scale.options.reverse ? scale.min : scale.max;
    else if ((0, $84f61e7391a78632$export$23f2a1d2818174ef)(fill)) value = fill.value;
    else value = scale.getBaseValue();
    return value;
}
function $216d2bdc6f281bf6$var$parseFillOption(line) {
    const options = line.options;
    const fillOption = options.fill;
    let fill = (0, $84f61e7391a78632$export$90a7f3efeed30595)(fillOption && fillOption.target, fillOption);
    if (fill === undefined) fill = !!options.backgroundColor;
    if (fill === false || fill === null) return false;
    if (fill === true) return 'origin';
    return fill;
}
function $216d2bdc6f281bf6$var$_buildStackLine(source) {
    const { scale: scale, index: index, line: line } = source;
    const points = [];
    const segments = line.segments;
    const sourcePoints = line.points;
    const linesBelow = $216d2bdc6f281bf6$var$getLinesBelow(scale, index);
    linesBelow.push($216d2bdc6f281bf6$var$_createBoundaryLine({
        x: null,
        y: scale.bottom
    }, line));
    for(let i = 0; i < segments.length; i++){
        const segment = segments[i];
        for(let j = segment.start; j <= segment.end; j++)$216d2bdc6f281bf6$var$addPointsBelow(points, sourcePoints[j], linesBelow);
    }
    return new $216d2bdc6f281bf6$export$55e463fa7bcd3469({
        points: points,
        options: {}
    });
}
function $216d2bdc6f281bf6$var$getLinesBelow(scale, index) {
    const below = [];
    const metas = scale.getMatchingVisibleMetas('line');
    for(let i = 0; i < metas.length; i++){
        const meta = metas[i];
        if (meta.index === index) break;
        if (!meta.hidden) below.unshift(meta.dataset);
    }
    return below;
}
function $216d2bdc6f281bf6$var$addPointsBelow(points, sourcePoint, linesBelow) {
    const postponed = [];
    for(let j = 0; j < linesBelow.length; j++){
        const line = linesBelow[j];
        const { first: first, last: last, point: point } = $216d2bdc6f281bf6$var$findPoint(line, sourcePoint, 'x');
        if (!point || first && last) continue;
        if (first) postponed.unshift(point);
        else {
            points.push(point);
            if (!last) break;
        }
    }
    points.push(...postponed);
}
function $216d2bdc6f281bf6$var$findPoint(line, sourcePoint, property) {
    const point = line.interpolate(sourcePoint, property);
    if (!point) return {};
    const pointValue = point[property];
    const segments = line.segments;
    const linePoints = line.points;
    let first = false;
    let last = false;
    for(let i = 0; i < segments.length; i++){
        const segment = segments[i];
        const firstValue = linePoints[segment.start][property];
        const lastValue = linePoints[segment.end][property];
        if ((0, $84f61e7391a78632$export$21579262ef46735b)(pointValue, firstValue, lastValue)) {
            first = pointValue === firstValue;
            last = pointValue === lastValue;
            break;
        }
    }
    return {
        first: first,
        last: last,
        point: point
    };
}
class $216d2bdc6f281bf6$var$simpleArc {
    constructor(opts){
        this.x = opts.x;
        this.y = opts.y;
        this.radius = opts.radius;
    }
    pathSegment(ctx, bounds, opts) {
        const { x: x, y: y, radius: radius } = this;
        bounds = bounds || {
            start: 0,
            end: (0, $84f61e7391a78632$export$971d5caa766a69d7)
        };
        ctx.arc(x, y, radius, bounds.end, bounds.start, true);
        return !opts.bounds;
    }
    interpolate(point) {
        const { x: x, y: y, radius: radius } = this;
        const angle = point.angle;
        return {
            x: x + Math.cos(angle) * radius,
            y: y + Math.sin(angle) * radius,
            angle: angle
        };
    }
}
function $216d2bdc6f281bf6$var$_getTarget(source) {
    const { chart: chart, fill: fill, line: line } = source;
    if ((0, $84f61e7391a78632$export$39b482c5e57630a8)(fill)) return $216d2bdc6f281bf6$var$getLineByIndex(chart, fill);
    if (fill === 'stack') return $216d2bdc6f281bf6$var$_buildStackLine(source);
    if (fill === 'shape') return true;
    const boundary = $216d2bdc6f281bf6$var$computeBoundary(source);
    if (boundary instanceof $216d2bdc6f281bf6$var$simpleArc) return boundary;
    return $216d2bdc6f281bf6$var$_createBoundaryLine(boundary, line);
}
function $216d2bdc6f281bf6$var$getLineByIndex(chart, index) {
    const meta = chart.getDatasetMeta(index);
    const visible = meta && chart.isDatasetVisible(index);
    return visible ? meta.dataset : null;
}
function $216d2bdc6f281bf6$var$computeBoundary(source) {
    const scale = source.scale || {};
    if (scale.getPointPositionForValue) return $216d2bdc6f281bf6$var$computeCircularBoundary(source);
    return $216d2bdc6f281bf6$var$computeLinearBoundary(source);
}
function $216d2bdc6f281bf6$var$computeLinearBoundary(source) {
    const { scale: scale = {}, fill: fill } = source;
    const pixel = $216d2bdc6f281bf6$var$_getTargetPixel(fill, scale);
    if ((0, $84f61e7391a78632$export$39b482c5e57630a8)(pixel)) {
        const horizontal = scale.isHorizontal();
        return {
            x: horizontal ? pixel : null,
            y: horizontal ? null : pixel
        };
    }
    return null;
}
function $216d2bdc6f281bf6$var$computeCircularBoundary(source) {
    const { scale: scale, fill: fill } = source;
    const options = scale.options;
    const length = scale.getLabels().length;
    const start = options.reverse ? scale.max : scale.min;
    const value = $216d2bdc6f281bf6$var$_getTargetValue(fill, scale, start);
    const target = [];
    if (options.grid.circular) {
        const center = scale.getPointPositionForValue(0, start);
        return new $216d2bdc6f281bf6$var$simpleArc({
            x: center.x,
            y: center.y,
            radius: scale.getDistanceFromCenterForValue(value)
        });
    }
    for(let i = 0; i < length; ++i)target.push(scale.getPointPositionForValue(i, value));
    return target;
}
function $216d2bdc6f281bf6$var$_drawfill(ctx, source, area) {
    const target = $216d2bdc6f281bf6$var$_getTarget(source);
    const { chart: chart, index: index, line: line, scale: scale, axis: axis } = source;
    const lineOpts = line.options;
    const fillOption = lineOpts.fill;
    const color = lineOpts.backgroundColor;
    const { above: above = color, below: below = color } = fillOption || {};
    const meta = chart.getDatasetMeta(index);
    const clip = (0, $84f61e7391a78632$export$995eb9fca571757)(chart, meta);
    if (target && line.points.length) {
        (0, $84f61e7391a78632$export$8743009a87fcb00f)(ctx, area);
        $216d2bdc6f281bf6$var$doFill(ctx, {
            line: line,
            target: target,
            above: above,
            below: below,
            area: area,
            scale: scale,
            axis: axis,
            clip: clip
        });
        (0, $84f61e7391a78632$export$3d8c2f653ac9d0b9)(ctx);
    }
}
function $216d2bdc6f281bf6$var$doFill(ctx, cfg) {
    const { line: line, target: target, above: above, below: below, area: area, scale: scale, clip: clip } = cfg;
    const property = line._loop ? 'angle' : cfg.axis;
    ctx.save();
    if (property === 'x' && below !== above) {
        $216d2bdc6f281bf6$var$clipVertical(ctx, target, area.top);
        $216d2bdc6f281bf6$var$fill(ctx, {
            line: line,
            target: target,
            color: above,
            scale: scale,
            property: property,
            clip: clip
        });
        ctx.restore();
        ctx.save();
        $216d2bdc6f281bf6$var$clipVertical(ctx, target, area.bottom);
    }
    $216d2bdc6f281bf6$var$fill(ctx, {
        line: line,
        target: target,
        color: below,
        scale: scale,
        property: property,
        clip: clip
    });
    ctx.restore();
}
function $216d2bdc6f281bf6$var$clipVertical(ctx, target, clipY) {
    const { segments: segments, points: points } = target;
    let first = true;
    let lineLoop = false;
    ctx.beginPath();
    for (const segment of segments){
        const { start: start, end: end } = segment;
        const firstPoint = points[start];
        const lastPoint = points[$216d2bdc6f281bf6$var$_findSegmentEnd(start, end, points)];
        if (first) {
            ctx.moveTo(firstPoint.x, firstPoint.y);
            first = false;
        } else {
            ctx.lineTo(firstPoint.x, clipY);
            ctx.lineTo(firstPoint.x, firstPoint.y);
        }
        lineLoop = !!target.pathSegment(ctx, segment, {
            move: lineLoop
        });
        if (lineLoop) ctx.closePath();
        else ctx.lineTo(lastPoint.x, clipY);
    }
    ctx.lineTo(target.first().x, clipY);
    ctx.closePath();
    ctx.clip();
}
function $216d2bdc6f281bf6$var$fill(ctx, cfg) {
    const { line: line, target: target, property: property, color: color, scale: scale, clip: clip } = cfg;
    const segments = $216d2bdc6f281bf6$var$_segments(line, target, property);
    for (const { source: src, target: tgt, start: start, end: end } of segments){
        const { style: { backgroundColor: backgroundColor = color } = {} } = src;
        const notShape = target !== true;
        ctx.save();
        ctx.fillStyle = backgroundColor;
        $216d2bdc6f281bf6$var$clipBounds(ctx, scale, clip, notShape && $216d2bdc6f281bf6$var$_getBounds(property, start, end));
        ctx.beginPath();
        const lineLoop = !!line.pathSegment(ctx, src);
        let loop;
        if (notShape) {
            if (lineLoop) ctx.closePath();
            else $216d2bdc6f281bf6$var$interpolatedLineTo(ctx, target, end, property);
            const targetLoop = !!target.pathSegment(ctx, tgt, {
                move: lineLoop,
                reverse: true
            });
            loop = lineLoop && targetLoop;
            if (!loop) $216d2bdc6f281bf6$var$interpolatedLineTo(ctx, target, start, property);
        }
        ctx.closePath();
        ctx.fill(loop ? 'evenodd' : 'nonzero');
        ctx.restore();
    }
}
function $216d2bdc6f281bf6$var$clipBounds(ctx, scale, clip, bounds) {
    const chartArea = scale.chart.chartArea;
    const { property: property, start: start, end: end } = bounds || {};
    if (property === 'x' || property === 'y') {
        let left, top, right, bottom;
        if (property === 'x') {
            left = start;
            top = chartArea.top;
            right = end;
            bottom = chartArea.bottom;
        } else {
            left = chartArea.left;
            top = start;
            right = chartArea.right;
            bottom = end;
        }
        ctx.beginPath();
        if (clip) {
            left = Math.max(left, clip.left);
            right = Math.min(right, clip.right);
            top = Math.max(top, clip.top);
            bottom = Math.min(bottom, clip.bottom);
        }
        ctx.rect(left, top, right - left, bottom - top);
        ctx.clip();
    }
}
function $216d2bdc6f281bf6$var$interpolatedLineTo(ctx, target, point, property) {
    const interpolatedPoint = target.interpolate(point, property);
    if (interpolatedPoint) ctx.lineTo(interpolatedPoint.x, interpolatedPoint.y);
}
var $216d2bdc6f281bf6$export$d19ba4d812bed757 = {
    id: 'filler',
    afterDatasetsUpdate (chart, _args, options) {
        const count = (chart.data.datasets || []).length;
        const sources = [];
        let meta, i, line, source;
        for(i = 0; i < count; ++i){
            meta = chart.getDatasetMeta(i);
            line = meta.dataset;
            source = null;
            if (line && line.options && line instanceof $216d2bdc6f281bf6$export$55e463fa7bcd3469) source = {
                visible: chart.isDatasetVisible(i),
                index: i,
                fill: $216d2bdc6f281bf6$var$_decodeFill(line, i, count),
                chart: chart,
                axis: meta.controller.options.indexAxis,
                scale: meta.vScale,
                line: line
            };
            meta.$filler = source;
            sources.push(source);
        }
        for(i = 0; i < count; ++i){
            source = sources[i];
            if (!source || source.fill === false) continue;
            source.fill = $216d2bdc6f281bf6$var$_resolveTarget(sources, i, options.propagate);
        }
    },
    beforeDraw (chart, _args, options) {
        const draw = options.drawTime === 'beforeDraw';
        const metasets = chart.getSortedVisibleDatasetMetas();
        const area = chart.chartArea;
        for(let i = metasets.length - 1; i >= 0; --i){
            const source = metasets[i].$filler;
            if (!source) continue;
            source.line.updateControlPoints(area, source.axis);
            if (draw && source.fill) $216d2bdc6f281bf6$var$_drawfill(chart.ctx, source, area);
        }
    },
    beforeDatasetsDraw (chart, _args, options) {
        if (options.drawTime !== 'beforeDatasetsDraw') return;
        const metasets = chart.getSortedVisibleDatasetMetas();
        for(let i = metasets.length - 1; i >= 0; --i){
            const source = metasets[i].$filler;
            if ($216d2bdc6f281bf6$var$_shouldApplyFill(source)) $216d2bdc6f281bf6$var$_drawfill(chart.ctx, source, chart.chartArea);
        }
    },
    beforeDatasetDraw (chart, args, options) {
        const source = args.meta.$filler;
        if (!$216d2bdc6f281bf6$var$_shouldApplyFill(source) || options.drawTime !== 'beforeDatasetDraw') return;
        $216d2bdc6f281bf6$var$_drawfill(chart.ctx, source, chart.chartArea);
    },
    defaults: {
        propagate: true,
        drawTime: 'beforeDatasetDraw'
    }
};
const $216d2bdc6f281bf6$var$getBoxSize = (labelOpts, fontSize)=>{
    let { boxHeight: boxHeight = fontSize, boxWidth: boxWidth = fontSize } = labelOpts;
    if (labelOpts.usePointStyle) {
        boxHeight = Math.min(boxHeight, fontSize);
        boxWidth = labelOpts.pointStyleWidth || Math.min(boxWidth, fontSize);
    }
    return {
        boxWidth: boxWidth,
        boxHeight: boxHeight,
        itemHeight: Math.max(fontSize, boxHeight)
    };
};
const $216d2bdc6f281bf6$var$itemsEqual = (a, b)=>a !== null && b !== null && a.datasetIndex === b.datasetIndex && a.index === b.index;
class $216d2bdc6f281bf6$var$Legend extends $216d2bdc6f281bf6$export$db77ccec0bb4ccac {
    constructor(config){
        super();
        this._added = false;
        this.legendHitBoxes = [];
        this._hoveredItem = null;
        this.doughnutMode = false;
        this.chart = config.chart;
        this.options = config.options;
        this.ctx = config.ctx;
        this.legendItems = undefined;
        this.columnSizes = undefined;
        this.lineWidths = undefined;
        this.maxHeight = undefined;
        this.maxWidth = undefined;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.height = undefined;
        this.width = undefined;
        this._margins = undefined;
        this.position = undefined;
        this.weight = undefined;
        this.fullSize = undefined;
    }
    update(maxWidth, maxHeight, margins) {
        this.maxWidth = maxWidth;
        this.maxHeight = maxHeight;
        this._margins = margins;
        this.setDimensions();
        this.buildLabels();
        this.fit();
    }
    setDimensions() {
        if (this.isHorizontal()) {
            this.width = this.maxWidth;
            this.left = this._margins.left;
            this.right = this.width;
        } else {
            this.height = this.maxHeight;
            this.top = this._margins.top;
            this.bottom = this.height;
        }
    }
    buildLabels() {
        const labelOpts = this.options.labels || {};
        let legendItems = (0, $84f61e7391a78632$export$3722cfe417b6ed86)(labelOpts.generateLabels, [
            this.chart
        ], this) || [];
        if (labelOpts.filter) legendItems = legendItems.filter((item)=>labelOpts.filter(item, this.chart.data));
        if (labelOpts.sort) legendItems = legendItems.sort((a, b)=>labelOpts.sort(a, b, this.chart.data));
        if (this.options.reverse) legendItems.reverse();
        this.legendItems = legendItems;
    }
    fit() {
        const { options: options, ctx: ctx } = this;
        if (!options.display) {
            this.width = this.height = 0;
            return;
        }
        const labelOpts = options.labels;
        const labelFont = (0, $84f61e7391a78632$export$34aec0b863436764)(labelOpts.font);
        const fontSize = labelFont.size;
        const titleHeight = this._computeTitleHeight();
        const { boxWidth: boxWidth, itemHeight: itemHeight } = $216d2bdc6f281bf6$var$getBoxSize(labelOpts, fontSize);
        let width, height;
        ctx.font = labelFont.string;
        if (this.isHorizontal()) {
            width = this.maxWidth;
            height = this._fitRows(titleHeight, fontSize, boxWidth, itemHeight) + 10;
        } else {
            height = this.maxHeight;
            width = this._fitCols(titleHeight, labelFont, boxWidth, itemHeight) + 10;
        }
        this.width = Math.min(width, options.maxWidth || this.maxWidth);
        this.height = Math.min(height, options.maxHeight || this.maxHeight);
    }
    _fitRows(titleHeight, fontSize, boxWidth, itemHeight) {
        const { ctx: ctx, maxWidth: maxWidth, options: { labels: { padding: padding } } } = this;
        const hitboxes = this.legendHitBoxes = [];
        const lineWidths = this.lineWidths = [
            0
        ];
        const lineHeight = itemHeight + padding;
        let totalHeight = titleHeight;
        ctx.textAlign = 'left';
        ctx.textBaseline = 'middle';
        let row = -1;
        let top = -lineHeight;
        this.legendItems.forEach((legendItem, i)=>{
            const itemWidth = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;
            if (i === 0 || lineWidths[lineWidths.length - 1] + itemWidth + 2 * padding > maxWidth) {
                totalHeight += lineHeight;
                lineWidths[lineWidths.length - (i > 0 ? 0 : 1)] = 0;
                top += lineHeight;
                row++;
            }
            hitboxes[i] = {
                left: 0,
                top: top,
                row: row,
                width: itemWidth,
                height: itemHeight
            };
            lineWidths[lineWidths.length - 1] += itemWidth + padding;
        });
        return totalHeight;
    }
    _fitCols(titleHeight, labelFont, boxWidth, _itemHeight) {
        const { ctx: ctx, maxHeight: maxHeight, options: { labels: { padding: padding } } } = this;
        const hitboxes = this.legendHitBoxes = [];
        const columnSizes = this.columnSizes = [];
        const heightLimit = maxHeight - titleHeight;
        let totalWidth = padding;
        let currentColWidth = 0;
        let currentColHeight = 0;
        let left = 0;
        let col = 0;
        this.legendItems.forEach((legendItem, i)=>{
            const { itemWidth: itemWidth, itemHeight: itemHeight } = $216d2bdc6f281bf6$var$calculateItemSize(boxWidth, labelFont, ctx, legendItem, _itemHeight);
            if (i > 0 && currentColHeight + itemHeight + 2 * padding > heightLimit) {
                totalWidth += currentColWidth + padding;
                columnSizes.push({
                    width: currentColWidth,
                    height: currentColHeight
                });
                left += currentColWidth + padding;
                col++;
                currentColWidth = currentColHeight = 0;
            }
            hitboxes[i] = {
                left: left,
                top: currentColHeight,
                col: col,
                width: itemWidth,
                height: itemHeight
            };
            currentColWidth = Math.max(currentColWidth, itemWidth);
            currentColHeight += itemHeight + padding;
        });
        totalWidth += currentColWidth;
        columnSizes.push({
            width: currentColWidth,
            height: currentColHeight
        });
        return totalWidth;
    }
    adjustHitBoxes() {
        if (!this.options.display) return;
        const titleHeight = this._computeTitleHeight();
        const { legendHitBoxes: hitboxes, options: { align: align, labels: { padding: padding }, rtl: rtl } } = this;
        const rtlHelper = (0, $84f61e7391a78632$export$91c6e00c14e7e6fd)(rtl, this.left, this.width);
        if (this.isHorizontal()) {
            let row = 0;
            let left = (0, $84f61e7391a78632$export$ce26c07117d59d6a)(align, this.left + padding, this.right - this.lineWidths[row]);
            for (const hitbox of hitboxes){
                if (row !== hitbox.row) {
                    row = hitbox.row;
                    left = (0, $84f61e7391a78632$export$ce26c07117d59d6a)(align, this.left + padding, this.right - this.lineWidths[row]);
                }
                hitbox.top += this.top + titleHeight + padding;
                hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(left), hitbox.width);
                left += hitbox.width + padding;
            }
        } else {
            let col = 0;
            let top = (0, $84f61e7391a78632$export$ce26c07117d59d6a)(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
            for (const hitbox of hitboxes){
                if (hitbox.col !== col) {
                    col = hitbox.col;
                    top = (0, $84f61e7391a78632$export$ce26c07117d59d6a)(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
                }
                hitbox.top = top;
                hitbox.left += this.left + padding;
                hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(hitbox.left), hitbox.width);
                top += hitbox.height + padding;
            }
        }
    }
    isHorizontal() {
        return this.options.position === 'top' || this.options.position === 'bottom';
    }
    draw() {
        if (this.options.display) {
            const ctx = this.ctx;
            (0, $84f61e7391a78632$export$8743009a87fcb00f)(ctx, this);
            this._draw();
            (0, $84f61e7391a78632$export$3d8c2f653ac9d0b9)(ctx);
        }
    }
    _draw() {
        const { options: opts, columnSizes: columnSizes, lineWidths: lineWidths, ctx: ctx } = this;
        const { align: align, labels: labelOpts } = opts;
        const defaultColor = (0, $84f61e7391a78632$export$4368d992c4eafac0).color;
        const rtlHelper = (0, $84f61e7391a78632$export$91c6e00c14e7e6fd)(opts.rtl, this.left, this.width);
        const labelFont = (0, $84f61e7391a78632$export$34aec0b863436764)(labelOpts.font);
        const { padding: padding } = labelOpts;
        const fontSize = labelFont.size;
        const halfFontSize = fontSize / 2;
        let cursor;
        this.drawTitle();
        ctx.textAlign = rtlHelper.textAlign('left');
        ctx.textBaseline = 'middle';
        ctx.lineWidth = 0.5;
        ctx.font = labelFont.string;
        const { boxWidth: boxWidth, boxHeight: boxHeight, itemHeight: itemHeight } = $216d2bdc6f281bf6$var$getBoxSize(labelOpts, fontSize);
        const drawLegendBox = function(x, y, legendItem) {
            if (isNaN(boxWidth) || boxWidth <= 0 || isNaN(boxHeight) || boxHeight < 0) return;
            ctx.save();
            const lineWidth = (0, $84f61e7391a78632$export$90a7f3efeed30595)(legendItem.lineWidth, 1);
            ctx.fillStyle = (0, $84f61e7391a78632$export$90a7f3efeed30595)(legendItem.fillStyle, defaultColor);
            ctx.lineCap = (0, $84f61e7391a78632$export$90a7f3efeed30595)(legendItem.lineCap, 'butt');
            ctx.lineDashOffset = (0, $84f61e7391a78632$export$90a7f3efeed30595)(legendItem.lineDashOffset, 0);
            ctx.lineJoin = (0, $84f61e7391a78632$export$90a7f3efeed30595)(legendItem.lineJoin, 'miter');
            ctx.lineWidth = lineWidth;
            ctx.strokeStyle = (0, $84f61e7391a78632$export$90a7f3efeed30595)(legendItem.strokeStyle, defaultColor);
            ctx.setLineDash((0, $84f61e7391a78632$export$90a7f3efeed30595)(legendItem.lineDash, []));
            if (labelOpts.usePointStyle) {
                const drawOptions = {
                    radius: boxHeight * Math.SQRT2 / 2,
                    pointStyle: legendItem.pointStyle,
                    rotation: legendItem.rotation,
                    borderWidth: lineWidth
                };
                const centerX = rtlHelper.xPlus(x, boxWidth / 2);
                const centerY = y + halfFontSize;
                (0, $84f61e7391a78632$export$158acd800e1ef08b)(ctx, drawOptions, centerX, centerY, labelOpts.pointStyleWidth && boxWidth);
            } else {
                const yBoxTop = y + Math.max((fontSize - boxHeight) / 2, 0);
                const xBoxLeft = rtlHelper.leftForLtr(x, boxWidth);
                const borderRadius = (0, $84f61e7391a78632$export$9fa96a7d116ea3ce)(legendItem.borderRadius);
                ctx.beginPath();
                if (Object.values(borderRadius).some((v)=>v !== 0)) (0, $84f61e7391a78632$export$d66dc83d8cfc8dd)(ctx, {
                    x: xBoxLeft,
                    y: yBoxTop,
                    w: boxWidth,
                    h: boxHeight,
                    radius: borderRadius
                });
                else ctx.rect(xBoxLeft, yBoxTop, boxWidth, boxHeight);
                ctx.fill();
                if (lineWidth !== 0) ctx.stroke();
            }
            ctx.restore();
        };
        const fillText = function(x, y, legendItem) {
            (0, $84f61e7391a78632$export$dc98b0b04f4c7758)(ctx, legendItem.text, x, y + itemHeight / 2, labelFont, {
                strikethrough: legendItem.hidden,
                textAlign: rtlHelper.textAlign(legendItem.textAlign)
            });
        };
        const isHorizontal = this.isHorizontal();
        const titleHeight = this._computeTitleHeight();
        if (isHorizontal) cursor = {
            x: (0, $84f61e7391a78632$export$ce26c07117d59d6a)(align, this.left + padding, this.right - lineWidths[0]),
            y: this.top + padding + titleHeight,
            line: 0
        };
        else cursor = {
            x: this.left + padding,
            y: (0, $84f61e7391a78632$export$ce26c07117d59d6a)(align, this.top + titleHeight + padding, this.bottom - columnSizes[0].height),
            line: 0
        };
        (0, $84f61e7391a78632$export$9d398bebfec1c039)(this.ctx, opts.textDirection);
        const lineHeight = itemHeight + padding;
        this.legendItems.forEach((legendItem, i)=>{
            ctx.strokeStyle = legendItem.fontColor;
            ctx.fillStyle = legendItem.fontColor;
            const textWidth = ctx.measureText(legendItem.text).width;
            const textAlign = rtlHelper.textAlign(legendItem.textAlign || (legendItem.textAlign = labelOpts.textAlign));
            const width = boxWidth + halfFontSize + textWidth;
            let x = cursor.x;
            let y = cursor.y;
            rtlHelper.setWidth(this.width);
            if (isHorizontal) {
                if (i > 0 && x + width + padding > this.right) {
                    y = cursor.y += lineHeight;
                    cursor.line++;
                    x = cursor.x = (0, $84f61e7391a78632$export$ce26c07117d59d6a)(align, this.left + padding, this.right - lineWidths[cursor.line]);
                }
            } else if (i > 0 && y + lineHeight > this.bottom) {
                x = cursor.x = x + columnSizes[cursor.line].width + padding;
                cursor.line++;
                y = cursor.y = (0, $84f61e7391a78632$export$ce26c07117d59d6a)(align, this.top + titleHeight + padding, this.bottom - columnSizes[cursor.line].height);
            }
            const realX = rtlHelper.x(x);
            drawLegendBox(realX, y, legendItem);
            x = (0, $84f61e7391a78632$export$890c4ad488842ce7)(textAlign, x + boxWidth + halfFontSize, isHorizontal ? x + width : this.right, opts.rtl);
            fillText(rtlHelper.x(x), y, legendItem);
            if (isHorizontal) cursor.x += width + padding;
            else if (typeof legendItem.text !== 'string') {
                const fontLineHeight = labelFont.lineHeight;
                cursor.y += $216d2bdc6f281bf6$var$calculateLegendItemHeight(legendItem, fontLineHeight) + padding;
            } else cursor.y += lineHeight;
        });
        (0, $84f61e7391a78632$export$24baa2b76016ce0e)(this.ctx, opts.textDirection);
    }
    drawTitle() {
        const opts = this.options;
        const titleOpts = opts.title;
        const titleFont = (0, $84f61e7391a78632$export$34aec0b863436764)(titleOpts.font);
        const titlePadding = (0, $84f61e7391a78632$export$a9c23c6ac3fc3eca)(titleOpts.padding);
        if (!titleOpts.display) return;
        const rtlHelper = (0, $84f61e7391a78632$export$91c6e00c14e7e6fd)(opts.rtl, this.left, this.width);
        const ctx = this.ctx;
        const position = titleOpts.position;
        const halfFontSize = titleFont.size / 2;
        const topPaddingPlusHalfFontSize = titlePadding.top + halfFontSize;
        let y;
        let left = this.left;
        let maxWidth = this.width;
        if (this.isHorizontal()) {
            maxWidth = Math.max(...this.lineWidths);
            y = this.top + topPaddingPlusHalfFontSize;
            left = (0, $84f61e7391a78632$export$ce26c07117d59d6a)(opts.align, left, this.right - maxWidth);
        } else {
            const maxHeight = this.columnSizes.reduce((acc, size)=>Math.max(acc, size.height), 0);
            y = topPaddingPlusHalfFontSize + (0, $84f61e7391a78632$export$ce26c07117d59d6a)(opts.align, this.top, this.bottom - maxHeight - opts.labels.padding - this._computeTitleHeight());
        }
        const x = (0, $84f61e7391a78632$export$ce26c07117d59d6a)(position, left, left + maxWidth);
        ctx.textAlign = rtlHelper.textAlign((0, $84f61e7391a78632$export$3c2fa207a37baaea)(position));
        ctx.textBaseline = 'middle';
        ctx.strokeStyle = titleOpts.color;
        ctx.fillStyle = titleOpts.color;
        ctx.font = titleFont.string;
        (0, $84f61e7391a78632$export$dc98b0b04f4c7758)(ctx, titleOpts.text, x, y, titleFont);
    }
    _computeTitleHeight() {
        const titleOpts = this.options.title;
        const titleFont = (0, $84f61e7391a78632$export$34aec0b863436764)(titleOpts.font);
        const titlePadding = (0, $84f61e7391a78632$export$a9c23c6ac3fc3eca)(titleOpts.padding);
        return titleOpts.display ? titleFont.lineHeight + titlePadding.height : 0;
    }
    _getLegendItemAt(x, y) {
        let i, hitBox, lh;
        if ((0, $84f61e7391a78632$export$21579262ef46735b)(x, this.left, this.right) && (0, $84f61e7391a78632$export$21579262ef46735b)(y, this.top, this.bottom)) {
            lh = this.legendHitBoxes;
            for(i = 0; i < lh.length; ++i){
                hitBox = lh[i];
                if ((0, $84f61e7391a78632$export$21579262ef46735b)(x, hitBox.left, hitBox.left + hitBox.width) && (0, $84f61e7391a78632$export$21579262ef46735b)(y, hitBox.top, hitBox.top + hitBox.height)) return this.legendItems[i];
            }
        }
        return null;
    }
    handleEvent(e) {
        const opts = this.options;
        if (!$216d2bdc6f281bf6$var$isListened(e.type, opts)) return;
        const hoveredItem = this._getLegendItemAt(e.x, e.y);
        if (e.type === 'mousemove' || e.type === 'mouseout') {
            const previous = this._hoveredItem;
            const sameItem = $216d2bdc6f281bf6$var$itemsEqual(previous, hoveredItem);
            if (previous && !sameItem) (0, $84f61e7391a78632$export$3722cfe417b6ed86)(opts.onLeave, [
                e,
                previous,
                this
            ], this);
            this._hoveredItem = hoveredItem;
            if (hoveredItem && !sameItem) (0, $84f61e7391a78632$export$3722cfe417b6ed86)(opts.onHover, [
                e,
                hoveredItem,
                this
            ], this);
        } else if (hoveredItem) (0, $84f61e7391a78632$export$3722cfe417b6ed86)(opts.onClick, [
            e,
            hoveredItem,
            this
        ], this);
    }
}
function $216d2bdc6f281bf6$var$calculateItemSize(boxWidth, labelFont, ctx, legendItem, _itemHeight) {
    const itemWidth = $216d2bdc6f281bf6$var$calculateItemWidth(legendItem, boxWidth, labelFont, ctx);
    const itemHeight = $216d2bdc6f281bf6$var$calculateItemHeight(_itemHeight, legendItem, labelFont.lineHeight);
    return {
        itemWidth: itemWidth,
        itemHeight: itemHeight
    };
}
function $216d2bdc6f281bf6$var$calculateItemWidth(legendItem, boxWidth, labelFont, ctx) {
    let legendItemText = legendItem.text;
    if (legendItemText && typeof legendItemText !== 'string') legendItemText = legendItemText.reduce((a, b)=>a.length > b.length ? a : b);
    return boxWidth + labelFont.size / 2 + ctx.measureText(legendItemText).width;
}
function $216d2bdc6f281bf6$var$calculateItemHeight(_itemHeight, legendItem, fontLineHeight) {
    let itemHeight = _itemHeight;
    if (typeof legendItem.text !== 'string') itemHeight = $216d2bdc6f281bf6$var$calculateLegendItemHeight(legendItem, fontLineHeight);
    return itemHeight;
}
function $216d2bdc6f281bf6$var$calculateLegendItemHeight(legendItem, fontLineHeight) {
    const labelHeight = legendItem.text ? legendItem.text.length : 0;
    return fontLineHeight * labelHeight;
}
function $216d2bdc6f281bf6$var$isListened(type, opts) {
    if ((type === 'mousemove' || type === 'mouseout') && (opts.onHover || opts.onLeave)) return true;
    if (opts.onClick && (type === 'click' || type === 'mouseup')) return true;
    return false;
}
var $216d2bdc6f281bf6$export$ed247974535929c7 = {
    id: 'legend',
    _element: $216d2bdc6f281bf6$var$Legend,
    start (chart, _args, options) {
        const legend = chart.legend = new $216d2bdc6f281bf6$var$Legend({
            ctx: chart.ctx,
            options: options,
            chart: chart
        });
        $216d2bdc6f281bf6$export$1ecca0613f5e56d2.configure(chart, legend, options);
        $216d2bdc6f281bf6$export$1ecca0613f5e56d2.addBox(chart, legend);
    },
    stop (chart) {
        $216d2bdc6f281bf6$export$1ecca0613f5e56d2.removeBox(chart, chart.legend);
        delete chart.legend;
    },
    beforeUpdate (chart, _args, options) {
        const legend = chart.legend;
        $216d2bdc6f281bf6$export$1ecca0613f5e56d2.configure(chart, legend, options);
        legend.options = options;
    },
    afterUpdate (chart) {
        const legend = chart.legend;
        legend.buildLabels();
        legend.adjustHitBoxes();
    },
    afterEvent (chart, args) {
        if (!args.replay) chart.legend.handleEvent(args.event);
    },
    defaults: {
        display: true,
        position: 'top',
        align: 'center',
        fullSize: true,
        reverse: false,
        weight: 1000,
        onClick (e, legendItem, legend) {
            const index = legendItem.datasetIndex;
            const ci = legend.chart;
            if (ci.isDatasetVisible(index)) {
                ci.hide(index);
                legendItem.hidden = true;
            } else {
                ci.show(index);
                legendItem.hidden = false;
            }
        },
        onHover: null,
        onLeave: null,
        labels: {
            color: (ctx)=>ctx.chart.options.color,
            boxWidth: 40,
            padding: 10,
            generateLabels (chart) {
                const datasets = chart.data.datasets;
                const { labels: { usePointStyle: usePointStyle, pointStyle: pointStyle, textAlign: textAlign, color: color, useBorderRadius: useBorderRadius, borderRadius: borderRadius } } = chart.legend.options;
                return chart._getSortedDatasetMetas().map((meta)=>{
                    const style = meta.controller.getStyle(usePointStyle ? 0 : undefined);
                    const borderWidth = (0, $84f61e7391a78632$export$a9c23c6ac3fc3eca)(style.borderWidth);
                    return {
                        text: datasets[meta.index].label,
                        fillStyle: style.backgroundColor,
                        fontColor: color,
                        hidden: !meta.visible,
                        lineCap: style.borderCapStyle,
                        lineDash: style.borderDash,
                        lineDashOffset: style.borderDashOffset,
                        lineJoin: style.borderJoinStyle,
                        lineWidth: (borderWidth.width + borderWidth.height) / 4,
                        strokeStyle: style.borderColor,
                        pointStyle: pointStyle || style.pointStyle,
                        rotation: style.rotation,
                        textAlign: textAlign || style.textAlign,
                        borderRadius: useBorderRadius && (borderRadius || style.borderRadius),
                        datasetIndex: meta.index
                    };
                }, this);
            }
        },
        title: {
            color: (ctx)=>ctx.chart.options.color,
            display: false,
            position: 'center',
            text: ''
        }
    },
    descriptors: {
        _scriptable: (name)=>!name.startsWith('on'),
        labels: {
            _scriptable: (name)=>![
                    'generateLabels',
                    'filter',
                    'sort'
                ].includes(name)
        }
    }
};
class $216d2bdc6f281bf6$var$Title extends $216d2bdc6f281bf6$export$db77ccec0bb4ccac {
    constructor(config){
        super();
        this.chart = config.chart;
        this.options = config.options;
        this.ctx = config.ctx;
        this._padding = undefined;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.width = undefined;
        this.height = undefined;
        this.position = undefined;
        this.weight = undefined;
        this.fullSize = undefined;
    }
    update(maxWidth, maxHeight) {
        const opts = this.options;
        this.left = 0;
        this.top = 0;
        if (!opts.display) {
            this.width = this.height = this.right = this.bottom = 0;
            return;
        }
        this.width = this.right = maxWidth;
        this.height = this.bottom = maxHeight;
        const lineCount = (0, $84f61e7391a78632$export$8b22cf2602fb60ce)(opts.text) ? opts.text.length : 1;
        this._padding = (0, $84f61e7391a78632$export$a9c23c6ac3fc3eca)(opts.padding);
        const textSize = lineCount * (0, $84f61e7391a78632$export$34aec0b863436764)(opts.font).lineHeight + this._padding.height;
        if (this.isHorizontal()) this.height = textSize;
        else this.width = textSize;
    }
    isHorizontal() {
        const pos = this.options.position;
        return pos === 'top' || pos === 'bottom';
    }
    _drawArgs(offset) {
        const { top: top, left: left, bottom: bottom, right: right, options: options } = this;
        const align = options.align;
        let rotation = 0;
        let maxWidth, titleX, titleY;
        if (this.isHorizontal()) {
            titleX = (0, $84f61e7391a78632$export$ce26c07117d59d6a)(align, left, right);
            titleY = top + offset;
            maxWidth = right - left;
        } else {
            if (options.position === 'left') {
                titleX = left + offset;
                titleY = (0, $84f61e7391a78632$export$ce26c07117d59d6a)(align, bottom, top);
                rotation = (0, $84f61e7391a78632$export$56c0d5a1e737357d) * -0.5;
            } else {
                titleX = right - offset;
                titleY = (0, $84f61e7391a78632$export$ce26c07117d59d6a)(align, top, bottom);
                rotation = (0, $84f61e7391a78632$export$56c0d5a1e737357d) * 0.5;
            }
            maxWidth = bottom - top;
        }
        return {
            titleX: titleX,
            titleY: titleY,
            maxWidth: maxWidth,
            rotation: rotation
        };
    }
    draw() {
        const ctx = this.ctx;
        const opts = this.options;
        if (!opts.display) return;
        const fontOpts = (0, $84f61e7391a78632$export$34aec0b863436764)(opts.font);
        const lineHeight = fontOpts.lineHeight;
        const offset = lineHeight / 2 + this._padding.top;
        const { titleX: titleX, titleY: titleY, maxWidth: maxWidth, rotation: rotation } = this._drawArgs(offset);
        (0, $84f61e7391a78632$export$dc98b0b04f4c7758)(ctx, opts.text, 0, 0, fontOpts, {
            color: opts.color,
            maxWidth: maxWidth,
            rotation: rotation,
            textAlign: (0, $84f61e7391a78632$export$3c2fa207a37baaea)(opts.align),
            textBaseline: 'middle',
            translation: [
                titleX,
                titleY
            ]
        });
    }
}
function $216d2bdc6f281bf6$var$createTitle(chart, titleOpts) {
    const title = new $216d2bdc6f281bf6$var$Title({
        ctx: chart.ctx,
        options: titleOpts,
        chart: chart
    });
    $216d2bdc6f281bf6$export$1ecca0613f5e56d2.configure(chart, title, titleOpts);
    $216d2bdc6f281bf6$export$1ecca0613f5e56d2.addBox(chart, title);
    chart.titleBlock = title;
}
var $216d2bdc6f281bf6$export$f99233281efd08a0 = {
    id: 'title',
    _element: $216d2bdc6f281bf6$var$Title,
    start (chart, _args, options) {
        $216d2bdc6f281bf6$var$createTitle(chart, options);
    },
    stop (chart) {
        const titleBlock = chart.titleBlock;
        $216d2bdc6f281bf6$export$1ecca0613f5e56d2.removeBox(chart, titleBlock);
        delete chart.titleBlock;
    },
    beforeUpdate (chart, _args, options) {
        const title = chart.titleBlock;
        $216d2bdc6f281bf6$export$1ecca0613f5e56d2.configure(chart, title, options);
        title.options = options;
    },
    defaults: {
        align: 'center',
        display: false,
        font: {
            weight: 'bold'
        },
        fullSize: true,
        padding: 10,
        position: 'top',
        text: '',
        weight: 2000
    },
    defaultRoutes: {
        color: 'color'
    },
    descriptors: {
        _scriptable: true,
        _indexable: false
    }
};
const $216d2bdc6f281bf6$var$map = new WeakMap();
var $216d2bdc6f281bf6$export$d5c56664638992a4 = {
    id: 'subtitle',
    start (chart, _args, options) {
        const title = new $216d2bdc6f281bf6$var$Title({
            ctx: chart.ctx,
            options: options,
            chart: chart
        });
        $216d2bdc6f281bf6$export$1ecca0613f5e56d2.configure(chart, title, options);
        $216d2bdc6f281bf6$export$1ecca0613f5e56d2.addBox(chart, title);
        $216d2bdc6f281bf6$var$map.set(chart, title);
    },
    stop (chart) {
        $216d2bdc6f281bf6$export$1ecca0613f5e56d2.removeBox(chart, $216d2bdc6f281bf6$var$map.get(chart));
        $216d2bdc6f281bf6$var$map.delete(chart);
    },
    beforeUpdate (chart, _args, options) {
        const title = $216d2bdc6f281bf6$var$map.get(chart);
        $216d2bdc6f281bf6$export$1ecca0613f5e56d2.configure(chart, title, options);
        title.options = options;
    },
    defaults: {
        align: 'center',
        display: false,
        font: {
            weight: 'normal'
        },
        fullSize: true,
        padding: 0,
        position: 'top',
        text: '',
        weight: 1500
    },
    defaultRoutes: {
        color: 'color'
    },
    descriptors: {
        _scriptable: true,
        _indexable: false
    }
};
const $216d2bdc6f281bf6$var$positioners = {
    average (items) {
        if (!items.length) return false;
        let i, len;
        let xSet = new Set();
        let y = 0;
        let count = 0;
        for(i = 0, len = items.length; i < len; ++i){
            const el = items[i].element;
            if (el && el.hasValue()) {
                const pos = el.tooltipPosition();
                xSet.add(pos.x);
                y += pos.y;
                ++count;
            }
        }
        if (count === 0 || xSet.size === 0) return false;
        const xAverage = [
            ...xSet
        ].reduce((a, b)=>a + b) / xSet.size;
        return {
            x: xAverage,
            y: y / count
        };
    },
    nearest (items, eventPosition) {
        if (!items.length) return false;
        let x = eventPosition.x;
        let y = eventPosition.y;
        let minDistance = Number.POSITIVE_INFINITY;
        let i, len, nearestElement;
        for(i = 0, len = items.length; i < len; ++i){
            const el = items[i].element;
            if (el && el.hasValue()) {
                const center = el.getCenterPoint();
                const d = (0, $84f61e7391a78632$export$cf2f7c5792f80b46)(eventPosition, center);
                if (d < minDistance) {
                    minDistance = d;
                    nearestElement = el;
                }
            }
        }
        if (nearestElement) {
            const tp = nearestElement.tooltipPosition();
            x = tp.x;
            y = tp.y;
        }
        return {
            x: x,
            y: y
        };
    }
};
function $216d2bdc6f281bf6$var$pushOrConcat(base, toPush) {
    if (toPush) {
        if ((0, $84f61e7391a78632$export$8b22cf2602fb60ce)(toPush)) Array.prototype.push.apply(base, toPush);
        else base.push(toPush);
    }
    return base;
}
function $216d2bdc6f281bf6$var$splitNewlines(str) {
    if ((typeof str === 'string' || str instanceof String) && str.indexOf('\n') > -1) return str.split('\n');
    return str;
}
function $216d2bdc6f281bf6$var$createTooltipItem(chart, item) {
    const { element: element, datasetIndex: datasetIndex, index: index } = item;
    const controller = chart.getDatasetMeta(datasetIndex).controller;
    const { label: label, value: value } = controller.getLabelAndValue(index);
    return {
        chart: chart,
        label: label,
        parsed: controller.getParsed(index),
        raw: chart.data.datasets[datasetIndex].data[index],
        formattedValue: value,
        dataset: controller.getDataset(),
        dataIndex: index,
        datasetIndex: datasetIndex,
        element: element
    };
}
function $216d2bdc6f281bf6$var$getTooltipSize(tooltip, options) {
    const ctx = tooltip.chart.ctx;
    const { body: body, footer: footer, title: title } = tooltip;
    const { boxWidth: boxWidth, boxHeight: boxHeight } = options;
    const bodyFont = (0, $84f61e7391a78632$export$34aec0b863436764)(options.bodyFont);
    const titleFont = (0, $84f61e7391a78632$export$34aec0b863436764)(options.titleFont);
    const footerFont = (0, $84f61e7391a78632$export$34aec0b863436764)(options.footerFont);
    const titleLineCount = title.length;
    const footerLineCount = footer.length;
    const bodyLineItemCount = body.length;
    const padding = (0, $84f61e7391a78632$export$a9c23c6ac3fc3eca)(options.padding);
    let height = padding.height;
    let width = 0;
    let combinedBodyLength = body.reduce((count, bodyItem)=>count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length, 0);
    combinedBodyLength += tooltip.beforeBody.length + tooltip.afterBody.length;
    if (titleLineCount) height += titleLineCount * titleFont.lineHeight + (titleLineCount - 1) * options.titleSpacing + options.titleMarginBottom;
    if (combinedBodyLength) {
        const bodyLineHeight = options.displayColors ? Math.max(boxHeight, bodyFont.lineHeight) : bodyFont.lineHeight;
        height += bodyLineItemCount * bodyLineHeight + (combinedBodyLength - bodyLineItemCount) * bodyFont.lineHeight + (combinedBodyLength - 1) * options.bodySpacing;
    }
    if (footerLineCount) height += options.footerMarginTop + footerLineCount * footerFont.lineHeight + (footerLineCount - 1) * options.footerSpacing;
    let widthPadding = 0;
    const maxLineWidth = function(line) {
        width = Math.max(width, ctx.measureText(line).width + widthPadding);
    };
    ctx.save();
    ctx.font = titleFont.string;
    (0, $84f61e7391a78632$export$d66501df72047452)(tooltip.title, maxLineWidth);
    ctx.font = bodyFont.string;
    (0, $84f61e7391a78632$export$d66501df72047452)(tooltip.beforeBody.concat(tooltip.afterBody), maxLineWidth);
    widthPadding = options.displayColors ? boxWidth + 2 + options.boxPadding : 0;
    (0, $84f61e7391a78632$export$d66501df72047452)(body, (bodyItem)=>{
        (0, $84f61e7391a78632$export$d66501df72047452)(bodyItem.before, maxLineWidth);
        (0, $84f61e7391a78632$export$d66501df72047452)(bodyItem.lines, maxLineWidth);
        (0, $84f61e7391a78632$export$d66501df72047452)(bodyItem.after, maxLineWidth);
    });
    widthPadding = 0;
    ctx.font = footerFont.string;
    (0, $84f61e7391a78632$export$d66501df72047452)(tooltip.footer, maxLineWidth);
    ctx.restore();
    width += padding.width;
    return {
        width: width,
        height: height
    };
}
function $216d2bdc6f281bf6$var$determineYAlign(chart, size) {
    const { y: y, height: height } = size;
    if (y < height / 2) return 'top';
    else if (y > chart.height - height / 2) return 'bottom';
    return 'center';
}
function $216d2bdc6f281bf6$var$doesNotFitWithAlign(xAlign, chart, options, size) {
    const { x: x, width: width } = size;
    const caret = options.caretSize + options.caretPadding;
    if (xAlign === 'left' && x + width + caret > chart.width) return true;
    if (xAlign === 'right' && x - width - caret < 0) return true;
}
function $216d2bdc6f281bf6$var$determineXAlign(chart, options, size, yAlign) {
    const { x: x, width: width } = size;
    const { width: chartWidth, chartArea: { left: left, right: right } } = chart;
    let xAlign = 'center';
    if (yAlign === 'center') xAlign = x <= (left + right) / 2 ? 'left' : 'right';
    else if (x <= width / 2) xAlign = 'left';
    else if (x >= chartWidth - width / 2) xAlign = 'right';
    if ($216d2bdc6f281bf6$var$doesNotFitWithAlign(xAlign, chart, options, size)) xAlign = 'center';
    return xAlign;
}
function $216d2bdc6f281bf6$var$determineAlignment(chart, options, size) {
    const yAlign = size.yAlign || options.yAlign || $216d2bdc6f281bf6$var$determineYAlign(chart, size);
    return {
        xAlign: size.xAlign || options.xAlign || $216d2bdc6f281bf6$var$determineXAlign(chart, options, size, yAlign),
        yAlign: yAlign
    };
}
function $216d2bdc6f281bf6$var$alignX(size, xAlign) {
    let { x: x, width: width } = size;
    if (xAlign === 'right') x -= width;
    else if (xAlign === 'center') x -= width / 2;
    return x;
}
function $216d2bdc6f281bf6$var$alignY(size, yAlign, paddingAndSize) {
    let { y: y, height: height } = size;
    if (yAlign === 'top') y += paddingAndSize;
    else if (yAlign === 'bottom') y -= height + paddingAndSize;
    else y -= height / 2;
    return y;
}
function $216d2bdc6f281bf6$var$getBackgroundPoint(options, size, alignment, chart) {
    const { caretSize: caretSize, caretPadding: caretPadding, cornerRadius: cornerRadius } = options;
    const { xAlign: xAlign, yAlign: yAlign } = alignment;
    const paddingAndSize = caretSize + caretPadding;
    const { topLeft: topLeft, topRight: topRight, bottomLeft: bottomLeft, bottomRight: bottomRight } = (0, $84f61e7391a78632$export$9fa96a7d116ea3ce)(cornerRadius);
    let x = $216d2bdc6f281bf6$var$alignX(size, xAlign);
    const y = $216d2bdc6f281bf6$var$alignY(size, yAlign, paddingAndSize);
    if (yAlign === 'center') {
        if (xAlign === 'left') x += paddingAndSize;
        else if (xAlign === 'right') x -= paddingAndSize;
    } else if (xAlign === 'left') x -= Math.max(topLeft, bottomLeft) + caretSize;
    else if (xAlign === 'right') x += Math.max(topRight, bottomRight) + caretSize;
    return {
        x: (0, $84f61e7391a78632$export$25ce5a424b770e84)(x, 0, chart.width - size.width),
        y: (0, $84f61e7391a78632$export$25ce5a424b770e84)(y, 0, chart.height - size.height)
    };
}
function $216d2bdc6f281bf6$var$getAlignedX(tooltip, align, options) {
    const padding = (0, $84f61e7391a78632$export$a9c23c6ac3fc3eca)(options.padding);
    return align === 'center' ? tooltip.x + tooltip.width / 2 : align === 'right' ? tooltip.x + tooltip.width - padding.right : tooltip.x + padding.left;
}
function $216d2bdc6f281bf6$var$getBeforeAfterBodyLines(callback) {
    return $216d2bdc6f281bf6$var$pushOrConcat([], $216d2bdc6f281bf6$var$splitNewlines(callback));
}
function $216d2bdc6f281bf6$var$createTooltipContext(parent, tooltip, tooltipItems) {
    return (0, $84f61e7391a78632$export$35e795649ee09318)(parent, {
        tooltip: tooltip,
        tooltipItems: tooltipItems,
        type: 'tooltip'
    });
}
function $216d2bdc6f281bf6$var$overrideCallbacks(callbacks, context) {
    const override = context && context.dataset && context.dataset.tooltip && context.dataset.tooltip.callbacks;
    return override ? callbacks.override(override) : callbacks;
}
const $216d2bdc6f281bf6$var$defaultCallbacks = {
    beforeTitle: (0, $84f61e7391a78632$export$53a70dd1ebbae346),
    title (tooltipItems) {
        if (tooltipItems.length > 0) {
            const item = tooltipItems[0];
            const labels = item.chart.data.labels;
            const labelCount = labels ? labels.length : 0;
            if (this && this.options && this.options.mode === 'dataset') return item.dataset.label || '';
            else if (item.label) return item.label;
            else if (labelCount > 0 && item.dataIndex < labelCount) return labels[item.dataIndex];
        }
        return '';
    },
    afterTitle: (0, $84f61e7391a78632$export$53a70dd1ebbae346),
    beforeBody: (0, $84f61e7391a78632$export$53a70dd1ebbae346),
    beforeLabel: (0, $84f61e7391a78632$export$53a70dd1ebbae346),
    label (tooltipItem) {
        if (this && this.options && this.options.mode === 'dataset') return tooltipItem.label + ': ' + tooltipItem.formattedValue || tooltipItem.formattedValue;
        let label = tooltipItem.dataset.label || '';
        if (label) label += ': ';
        const value = tooltipItem.formattedValue;
        if (!(0, $84f61e7391a78632$export$342063e11d6c3cad)(value)) label += value;
        return label;
    },
    labelColor (tooltipItem) {
        const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
        const options = meta.controller.getStyle(tooltipItem.dataIndex);
        return {
            borderColor: options.borderColor,
            backgroundColor: options.backgroundColor,
            borderWidth: options.borderWidth,
            borderDash: options.borderDash,
            borderDashOffset: options.borderDashOffset,
            borderRadius: 0
        };
    },
    labelTextColor () {
        return this.options.bodyColor;
    },
    labelPointStyle (tooltipItem) {
        const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
        const options = meta.controller.getStyle(tooltipItem.dataIndex);
        return {
            pointStyle: options.pointStyle,
            rotation: options.rotation
        };
    },
    afterLabel: (0, $84f61e7391a78632$export$53a70dd1ebbae346),
    afterBody: (0, $84f61e7391a78632$export$53a70dd1ebbae346),
    beforeFooter: (0, $84f61e7391a78632$export$53a70dd1ebbae346),
    footer: (0, $84f61e7391a78632$export$53a70dd1ebbae346),
    afterFooter: (0, $84f61e7391a78632$export$53a70dd1ebbae346)
};
function $216d2bdc6f281bf6$var$invokeCallbackWithFallback(callbacks, name, ctx, arg) {
    const result = callbacks[name].call(ctx, arg);
    if (typeof result === 'undefined') return $216d2bdc6f281bf6$var$defaultCallbacks[name].call(ctx, arg);
    return result;
}
class $216d2bdc6f281bf6$var$Tooltip extends $216d2bdc6f281bf6$export$db77ccec0bb4ccac {
    static positioners = $216d2bdc6f281bf6$var$positioners;
    constructor(config){
        super();
        this.opacity = 0;
        this._active = [];
        this._eventPosition = undefined;
        this._size = undefined;
        this._cachedAnimations = undefined;
        this._tooltipItems = [];
        this.$animations = undefined;
        this.$context = undefined;
        this.chart = config.chart;
        this.options = config.options;
        this.dataPoints = undefined;
        this.title = undefined;
        this.beforeBody = undefined;
        this.body = undefined;
        this.afterBody = undefined;
        this.footer = undefined;
        this.xAlign = undefined;
        this.yAlign = undefined;
        this.x = undefined;
        this.y = undefined;
        this.height = undefined;
        this.width = undefined;
        this.caretX = undefined;
        this.caretY = undefined;
        this.labelColors = undefined;
        this.labelPointStyles = undefined;
        this.labelTextColors = undefined;
    }
    initialize(options) {
        this.options = options;
        this._cachedAnimations = undefined;
        this.$context = undefined;
    }
    _resolveAnimations() {
        const cached = this._cachedAnimations;
        if (cached) return cached;
        const chart = this.chart;
        const options = this.options.setContext(this.getContext());
        const opts = options.enabled && chart.options.animation && options.animations;
        const animations = new $216d2bdc6f281bf6$export$8ab227dac26677d(this.chart, opts);
        if (opts._cacheable) this._cachedAnimations = Object.freeze(animations);
        return animations;
    }
    getContext() {
        return this.$context || (this.$context = $216d2bdc6f281bf6$var$createTooltipContext(this.chart.getContext(), this, this._tooltipItems));
    }
    getTitle(context, options) {
        const { callbacks: callbacks } = options;
        const beforeTitle = $216d2bdc6f281bf6$var$invokeCallbackWithFallback(callbacks, 'beforeTitle', this, context);
        const title = $216d2bdc6f281bf6$var$invokeCallbackWithFallback(callbacks, 'title', this, context);
        const afterTitle = $216d2bdc6f281bf6$var$invokeCallbackWithFallback(callbacks, 'afterTitle', this, context);
        let lines = [];
        lines = $216d2bdc6f281bf6$var$pushOrConcat(lines, $216d2bdc6f281bf6$var$splitNewlines(beforeTitle));
        lines = $216d2bdc6f281bf6$var$pushOrConcat(lines, $216d2bdc6f281bf6$var$splitNewlines(title));
        lines = $216d2bdc6f281bf6$var$pushOrConcat(lines, $216d2bdc6f281bf6$var$splitNewlines(afterTitle));
        return lines;
    }
    getBeforeBody(tooltipItems, options) {
        return $216d2bdc6f281bf6$var$getBeforeAfterBodyLines($216d2bdc6f281bf6$var$invokeCallbackWithFallback(options.callbacks, 'beforeBody', this, tooltipItems));
    }
    getBody(tooltipItems, options) {
        const { callbacks: callbacks } = options;
        const bodyItems = [];
        (0, $84f61e7391a78632$export$d66501df72047452)(tooltipItems, (context)=>{
            const bodyItem = {
                before: [],
                lines: [],
                after: []
            };
            const scoped = $216d2bdc6f281bf6$var$overrideCallbacks(callbacks, context);
            $216d2bdc6f281bf6$var$pushOrConcat(bodyItem.before, $216d2bdc6f281bf6$var$splitNewlines($216d2bdc6f281bf6$var$invokeCallbackWithFallback(scoped, 'beforeLabel', this, context)));
            $216d2bdc6f281bf6$var$pushOrConcat(bodyItem.lines, $216d2bdc6f281bf6$var$invokeCallbackWithFallback(scoped, 'label', this, context));
            $216d2bdc6f281bf6$var$pushOrConcat(bodyItem.after, $216d2bdc6f281bf6$var$splitNewlines($216d2bdc6f281bf6$var$invokeCallbackWithFallback(scoped, 'afterLabel', this, context)));
            bodyItems.push(bodyItem);
        });
        return bodyItems;
    }
    getAfterBody(tooltipItems, options) {
        return $216d2bdc6f281bf6$var$getBeforeAfterBodyLines($216d2bdc6f281bf6$var$invokeCallbackWithFallback(options.callbacks, 'afterBody', this, tooltipItems));
    }
    getFooter(tooltipItems, options) {
        const { callbacks: callbacks } = options;
        const beforeFooter = $216d2bdc6f281bf6$var$invokeCallbackWithFallback(callbacks, 'beforeFooter', this, tooltipItems);
        const footer = $216d2bdc6f281bf6$var$invokeCallbackWithFallback(callbacks, 'footer', this, tooltipItems);
        const afterFooter = $216d2bdc6f281bf6$var$invokeCallbackWithFallback(callbacks, 'afterFooter', this, tooltipItems);
        let lines = [];
        lines = $216d2bdc6f281bf6$var$pushOrConcat(lines, $216d2bdc6f281bf6$var$splitNewlines(beforeFooter));
        lines = $216d2bdc6f281bf6$var$pushOrConcat(lines, $216d2bdc6f281bf6$var$splitNewlines(footer));
        lines = $216d2bdc6f281bf6$var$pushOrConcat(lines, $216d2bdc6f281bf6$var$splitNewlines(afterFooter));
        return lines;
    }
    _createItems(options) {
        const active = this._active;
        const data = this.chart.data;
        const labelColors = [];
        const labelPointStyles = [];
        const labelTextColors = [];
        let tooltipItems = [];
        let i, len;
        for(i = 0, len = active.length; i < len; ++i)tooltipItems.push($216d2bdc6f281bf6$var$createTooltipItem(this.chart, active[i]));
        if (options.filter) tooltipItems = tooltipItems.filter((element, index, array)=>options.filter(element, index, array, data));
        if (options.itemSort) tooltipItems = tooltipItems.sort((a, b)=>options.itemSort(a, b, data));
        (0, $84f61e7391a78632$export$d66501df72047452)(tooltipItems, (context)=>{
            const scoped = $216d2bdc6f281bf6$var$overrideCallbacks(options.callbacks, context);
            labelColors.push($216d2bdc6f281bf6$var$invokeCallbackWithFallback(scoped, 'labelColor', this, context));
            labelPointStyles.push($216d2bdc6f281bf6$var$invokeCallbackWithFallback(scoped, 'labelPointStyle', this, context));
            labelTextColors.push($216d2bdc6f281bf6$var$invokeCallbackWithFallback(scoped, 'labelTextColor', this, context));
        });
        this.labelColors = labelColors;
        this.labelPointStyles = labelPointStyles;
        this.labelTextColors = labelTextColors;
        this.dataPoints = tooltipItems;
        return tooltipItems;
    }
    update(changed, replay) {
        const options = this.options.setContext(this.getContext());
        const active = this._active;
        let properties;
        let tooltipItems = [];
        if (!active.length) {
            if (this.opacity !== 0) properties = {
                opacity: 0
            };
        } else {
            const position = $216d2bdc6f281bf6$var$positioners[options.position].call(this, active, this._eventPosition);
            tooltipItems = this._createItems(options);
            this.title = this.getTitle(tooltipItems, options);
            this.beforeBody = this.getBeforeBody(tooltipItems, options);
            this.body = this.getBody(tooltipItems, options);
            this.afterBody = this.getAfterBody(tooltipItems, options);
            this.footer = this.getFooter(tooltipItems, options);
            const size = this._size = $216d2bdc6f281bf6$var$getTooltipSize(this, options);
            const positionAndSize = Object.assign({}, position, size);
            const alignment = $216d2bdc6f281bf6$var$determineAlignment(this.chart, options, positionAndSize);
            const backgroundPoint = $216d2bdc6f281bf6$var$getBackgroundPoint(options, positionAndSize, alignment, this.chart);
            this.xAlign = alignment.xAlign;
            this.yAlign = alignment.yAlign;
            properties = {
                opacity: 1,
                x: backgroundPoint.x,
                y: backgroundPoint.y,
                width: size.width,
                height: size.height,
                caretX: position.x,
                caretY: position.y
            };
        }
        this._tooltipItems = tooltipItems;
        this.$context = undefined;
        if (properties) this._resolveAnimations().update(this, properties);
        if (changed && options.external) options.external.call(this, {
            chart: this.chart,
            tooltip: this,
            replay: replay
        });
    }
    drawCaret(tooltipPoint, ctx, size, options) {
        const caretPosition = this.getCaretPosition(tooltipPoint, size, options);
        ctx.lineTo(caretPosition.x1, caretPosition.y1);
        ctx.lineTo(caretPosition.x2, caretPosition.y2);
        ctx.lineTo(caretPosition.x3, caretPosition.y3);
    }
    getCaretPosition(tooltipPoint, size, options) {
        const { xAlign: xAlign, yAlign: yAlign } = this;
        const { caretSize: caretSize, cornerRadius: cornerRadius } = options;
        const { topLeft: topLeft, topRight: topRight, bottomLeft: bottomLeft, bottomRight: bottomRight } = (0, $84f61e7391a78632$export$9fa96a7d116ea3ce)(cornerRadius);
        const { x: ptX, y: ptY } = tooltipPoint;
        const { width: width, height: height } = size;
        let x1, x2, x3, y1, y2, y3;
        if (yAlign === 'center') {
            y2 = ptY + height / 2;
            if (xAlign === 'left') {
                x1 = ptX;
                x2 = x1 - caretSize;
                y1 = y2 + caretSize;
                y3 = y2 - caretSize;
            } else {
                x1 = ptX + width;
                x2 = x1 + caretSize;
                y1 = y2 - caretSize;
                y3 = y2 + caretSize;
            }
            x3 = x1;
        } else {
            if (xAlign === 'left') x2 = ptX + Math.max(topLeft, bottomLeft) + caretSize;
            else if (xAlign === 'right') x2 = ptX + width - Math.max(topRight, bottomRight) - caretSize;
            else x2 = this.caretX;
            if (yAlign === 'top') {
                y1 = ptY;
                y2 = y1 - caretSize;
                x1 = x2 - caretSize;
                x3 = x2 + caretSize;
            } else {
                y1 = ptY + height;
                y2 = y1 + caretSize;
                x1 = x2 + caretSize;
                x3 = x2 - caretSize;
            }
            y3 = y1;
        }
        return {
            x1: x1,
            x2: x2,
            x3: x3,
            y1: y1,
            y2: y2,
            y3: y3
        };
    }
    drawTitle(pt, ctx, options) {
        const title = this.title;
        const length = title.length;
        let titleFont, titleSpacing, i;
        if (length) {
            const rtlHelper = (0, $84f61e7391a78632$export$91c6e00c14e7e6fd)(options.rtl, this.x, this.width);
            pt.x = $216d2bdc6f281bf6$var$getAlignedX(this, options.titleAlign, options);
            ctx.textAlign = rtlHelper.textAlign(options.titleAlign);
            ctx.textBaseline = 'middle';
            titleFont = (0, $84f61e7391a78632$export$34aec0b863436764)(options.titleFont);
            titleSpacing = options.titleSpacing;
            ctx.fillStyle = options.titleColor;
            ctx.font = titleFont.string;
            for(i = 0; i < length; ++i){
                ctx.fillText(title[i], rtlHelper.x(pt.x), pt.y + titleFont.lineHeight / 2);
                pt.y += titleFont.lineHeight + titleSpacing;
                if (i + 1 === length) pt.y += options.titleMarginBottom - titleSpacing;
            }
        }
    }
    _drawColorBox(ctx, pt, i, rtlHelper, options) {
        const labelColor = this.labelColors[i];
        const labelPointStyle = this.labelPointStyles[i];
        const { boxHeight: boxHeight, boxWidth: boxWidth } = options;
        const bodyFont = (0, $84f61e7391a78632$export$34aec0b863436764)(options.bodyFont);
        const colorX = $216d2bdc6f281bf6$var$getAlignedX(this, 'left', options);
        const rtlColorX = rtlHelper.x(colorX);
        const yOffSet = boxHeight < bodyFont.lineHeight ? (bodyFont.lineHeight - boxHeight) / 2 : 0;
        const colorY = pt.y + yOffSet;
        if (options.usePointStyle) {
            const drawOptions = {
                radius: Math.min(boxWidth, boxHeight) / 2,
                pointStyle: labelPointStyle.pointStyle,
                rotation: labelPointStyle.rotation,
                borderWidth: 1
            };
            const centerX = rtlHelper.leftForLtr(rtlColorX, boxWidth) + boxWidth / 2;
            const centerY = colorY + boxHeight / 2;
            ctx.strokeStyle = options.multiKeyBackground;
            ctx.fillStyle = options.multiKeyBackground;
            (0, $84f61e7391a78632$export$1fbe638ecf81657e)(ctx, drawOptions, centerX, centerY);
            ctx.strokeStyle = labelColor.borderColor;
            ctx.fillStyle = labelColor.backgroundColor;
            (0, $84f61e7391a78632$export$1fbe638ecf81657e)(ctx, drawOptions, centerX, centerY);
        } else {
            ctx.lineWidth = (0, $84f61e7391a78632$export$23f2a1d2818174ef)(labelColor.borderWidth) ? Math.max(...Object.values(labelColor.borderWidth)) : labelColor.borderWidth || 1;
            ctx.strokeStyle = labelColor.borderColor;
            ctx.setLineDash(labelColor.borderDash || []);
            ctx.lineDashOffset = labelColor.borderDashOffset || 0;
            const outerX = rtlHelper.leftForLtr(rtlColorX, boxWidth);
            const innerX = rtlHelper.leftForLtr(rtlHelper.xPlus(rtlColorX, 1), boxWidth - 2);
            const borderRadius = (0, $84f61e7391a78632$export$9fa96a7d116ea3ce)(labelColor.borderRadius);
            if (Object.values(borderRadius).some((v)=>v !== 0)) {
                ctx.beginPath();
                ctx.fillStyle = options.multiKeyBackground;
                (0, $84f61e7391a78632$export$d66dc83d8cfc8dd)(ctx, {
                    x: outerX,
                    y: colorY,
                    w: boxWidth,
                    h: boxHeight,
                    radius: borderRadius
                });
                ctx.fill();
                ctx.stroke();
                ctx.fillStyle = labelColor.backgroundColor;
                ctx.beginPath();
                (0, $84f61e7391a78632$export$d66dc83d8cfc8dd)(ctx, {
                    x: innerX,
                    y: colorY + 1,
                    w: boxWidth - 2,
                    h: boxHeight - 2,
                    radius: borderRadius
                });
                ctx.fill();
            } else {
                ctx.fillStyle = options.multiKeyBackground;
                ctx.fillRect(outerX, colorY, boxWidth, boxHeight);
                ctx.strokeRect(outerX, colorY, boxWidth, boxHeight);
                ctx.fillStyle = labelColor.backgroundColor;
                ctx.fillRect(innerX, colorY + 1, boxWidth - 2, boxHeight - 2);
            }
        }
        ctx.fillStyle = this.labelTextColors[i];
    }
    drawBody(pt, ctx, options) {
        const { body: body } = this;
        const { bodySpacing: bodySpacing, bodyAlign: bodyAlign, displayColors: displayColors, boxHeight: boxHeight, boxWidth: boxWidth, boxPadding: boxPadding } = options;
        const bodyFont = (0, $84f61e7391a78632$export$34aec0b863436764)(options.bodyFont);
        let bodyLineHeight = bodyFont.lineHeight;
        let xLinePadding = 0;
        const rtlHelper = (0, $84f61e7391a78632$export$91c6e00c14e7e6fd)(options.rtl, this.x, this.width);
        const fillLineOfText = function(line) {
            ctx.fillText(line, rtlHelper.x(pt.x + xLinePadding), pt.y + bodyLineHeight / 2);
            pt.y += bodyLineHeight + bodySpacing;
        };
        const bodyAlignForCalculation = rtlHelper.textAlign(bodyAlign);
        let bodyItem, textColor, lines, i, j, ilen, jlen;
        ctx.textAlign = bodyAlign;
        ctx.textBaseline = 'middle';
        ctx.font = bodyFont.string;
        pt.x = $216d2bdc6f281bf6$var$getAlignedX(this, bodyAlignForCalculation, options);
        ctx.fillStyle = options.bodyColor;
        (0, $84f61e7391a78632$export$d66501df72047452)(this.beforeBody, fillLineOfText);
        xLinePadding = displayColors && bodyAlignForCalculation !== 'right' ? bodyAlign === 'center' ? boxWidth / 2 + boxPadding : boxWidth + 2 + boxPadding : 0;
        for(i = 0, ilen = body.length; i < ilen; ++i){
            bodyItem = body[i];
            textColor = this.labelTextColors[i];
            ctx.fillStyle = textColor;
            (0, $84f61e7391a78632$export$d66501df72047452)(bodyItem.before, fillLineOfText);
            lines = bodyItem.lines;
            if (displayColors && lines.length) {
                this._drawColorBox(ctx, pt, i, rtlHelper, options);
                bodyLineHeight = Math.max(bodyFont.lineHeight, boxHeight);
            }
            for(j = 0, jlen = lines.length; j < jlen; ++j){
                fillLineOfText(lines[j]);
                bodyLineHeight = bodyFont.lineHeight;
            }
            (0, $84f61e7391a78632$export$d66501df72047452)(bodyItem.after, fillLineOfText);
        }
        xLinePadding = 0;
        bodyLineHeight = bodyFont.lineHeight;
        (0, $84f61e7391a78632$export$d66501df72047452)(this.afterBody, fillLineOfText);
        pt.y -= bodySpacing;
    }
    drawFooter(pt, ctx, options) {
        const footer = this.footer;
        const length = footer.length;
        let footerFont, i;
        if (length) {
            const rtlHelper = (0, $84f61e7391a78632$export$91c6e00c14e7e6fd)(options.rtl, this.x, this.width);
            pt.x = $216d2bdc6f281bf6$var$getAlignedX(this, options.footerAlign, options);
            pt.y += options.footerMarginTop;
            ctx.textAlign = rtlHelper.textAlign(options.footerAlign);
            ctx.textBaseline = 'middle';
            footerFont = (0, $84f61e7391a78632$export$34aec0b863436764)(options.footerFont);
            ctx.fillStyle = options.footerColor;
            ctx.font = footerFont.string;
            for(i = 0; i < length; ++i){
                ctx.fillText(footer[i], rtlHelper.x(pt.x), pt.y + footerFont.lineHeight / 2);
                pt.y += footerFont.lineHeight + options.footerSpacing;
            }
        }
    }
    drawBackground(pt, ctx, tooltipSize, options) {
        const { xAlign: xAlign, yAlign: yAlign } = this;
        const { x: x, y: y } = pt;
        const { width: width, height: height } = tooltipSize;
        const { topLeft: topLeft, topRight: topRight, bottomLeft: bottomLeft, bottomRight: bottomRight } = (0, $84f61e7391a78632$export$9fa96a7d116ea3ce)(options.cornerRadius);
        ctx.fillStyle = options.backgroundColor;
        ctx.strokeStyle = options.borderColor;
        ctx.lineWidth = options.borderWidth;
        ctx.beginPath();
        ctx.moveTo(x + topLeft, y);
        if (yAlign === 'top') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + width - topRight, y);
        ctx.quadraticCurveTo(x + width, y, x + width, y + topRight);
        if (yAlign === 'center' && xAlign === 'right') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + width, y + height - bottomRight);
        ctx.quadraticCurveTo(x + width, y + height, x + width - bottomRight, y + height);
        if (yAlign === 'bottom') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + bottomLeft, y + height);
        ctx.quadraticCurveTo(x, y + height, x, y + height - bottomLeft);
        if (yAlign === 'center' && xAlign === 'left') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x, y + topLeft);
        ctx.quadraticCurveTo(x, y, x + topLeft, y);
        ctx.closePath();
        ctx.fill();
        if (options.borderWidth > 0) ctx.stroke();
    }
    _updateAnimationTarget(options) {
        const chart = this.chart;
        const anims = this.$animations;
        const animX = anims && anims.x;
        const animY = anims && anims.y;
        if (animX || animY) {
            const position = $216d2bdc6f281bf6$var$positioners[options.position].call(this, this._active, this._eventPosition);
            if (!position) return;
            const size = this._size = $216d2bdc6f281bf6$var$getTooltipSize(this, options);
            const positionAndSize = Object.assign({}, position, this._size);
            const alignment = $216d2bdc6f281bf6$var$determineAlignment(chart, options, positionAndSize);
            const point = $216d2bdc6f281bf6$var$getBackgroundPoint(options, positionAndSize, alignment, chart);
            if (animX._to !== point.x || animY._to !== point.y) {
                this.xAlign = alignment.xAlign;
                this.yAlign = alignment.yAlign;
                this.width = size.width;
                this.height = size.height;
                this.caretX = position.x;
                this.caretY = position.y;
                this._resolveAnimations().update(this, point);
            }
        }
    }
    _willRender() {
        return !!this.opacity;
    }
    draw(ctx) {
        const options = this.options.setContext(this.getContext());
        let opacity = this.opacity;
        if (!opacity) return;
        this._updateAnimationTarget(options);
        const tooltipSize = {
            width: this.width,
            height: this.height
        };
        const pt = {
            x: this.x,
            y: this.y
        };
        opacity = Math.abs(opacity) < 1e-3 ? 0 : opacity;
        const padding = (0, $84f61e7391a78632$export$a9c23c6ac3fc3eca)(options.padding);
        const hasTooltipContent = this.title.length || this.beforeBody.length || this.body.length || this.afterBody.length || this.footer.length;
        if (options.enabled && hasTooltipContent) {
            ctx.save();
            ctx.globalAlpha = opacity;
            this.drawBackground(pt, ctx, tooltipSize, options);
            (0, $84f61e7391a78632$export$9d398bebfec1c039)(ctx, options.textDirection);
            pt.y += padding.top;
            this.drawTitle(pt, ctx, options);
            this.drawBody(pt, ctx, options);
            this.drawFooter(pt, ctx, options);
            (0, $84f61e7391a78632$export$24baa2b76016ce0e)(ctx, options.textDirection);
            ctx.restore();
        }
    }
    getActiveElements() {
        return this._active || [];
    }
    setActiveElements(activeElements, eventPosition) {
        const lastActive = this._active;
        const active = activeElements.map(({ datasetIndex: datasetIndex, index: index })=>{
            const meta = this.chart.getDatasetMeta(datasetIndex);
            if (!meta) throw new Error('Cannot find a dataset at index ' + datasetIndex);
            return {
                datasetIndex: datasetIndex,
                element: meta.data[index],
                index: index
            };
        });
        const changed = !(0, $84f61e7391a78632$export$f38c853ae54ed474)(lastActive, active);
        const positionChanged = this._positionChanged(active, eventPosition);
        if (changed || positionChanged) {
            this._active = active;
            this._eventPosition = eventPosition;
            this._ignoreReplayEvents = true;
            this.update(true);
        }
    }
    handleEvent(e, replay, inChartArea = true) {
        if (replay && this._ignoreReplayEvents) return false;
        this._ignoreReplayEvents = false;
        const options = this.options;
        const lastActive = this._active || [];
        const active = this._getActiveElements(e, lastActive, replay, inChartArea);
        const positionChanged = this._positionChanged(active, e);
        const changed = replay || !(0, $84f61e7391a78632$export$f38c853ae54ed474)(active, lastActive) || positionChanged;
        if (changed) {
            this._active = active;
            if (options.enabled || options.external) {
                this._eventPosition = {
                    x: e.x,
                    y: e.y
                };
                this.update(true, replay);
            }
        }
        return changed;
    }
    _getActiveElements(e, lastActive, replay, inChartArea) {
        const options = this.options;
        if (e.type === 'mouseout') return [];
        if (!inChartArea) return lastActive.filter((i)=>this.chart.data.datasets[i.datasetIndex] && this.chart.getDatasetMeta(i.datasetIndex).controller.getParsed(i.index) !== undefined);
        const active = this.chart.getElementsAtEventForMode(e, options.mode, options, replay);
        if (options.reverse) active.reverse();
        return active;
    }
    _positionChanged(active, e) {
        const { caretX: caretX, caretY: caretY, options: options } = this;
        const position = $216d2bdc6f281bf6$var$positioners[options.position].call(this, active, e);
        return position !== false && (caretX !== position.x || caretY !== position.y);
    }
}
var $216d2bdc6f281bf6$export$28c660c63b792dea = {
    id: 'tooltip',
    _element: $216d2bdc6f281bf6$var$Tooltip,
    positioners: $216d2bdc6f281bf6$var$positioners,
    afterInit (chart, _args, options) {
        if (options) chart.tooltip = new $216d2bdc6f281bf6$var$Tooltip({
            chart: chart,
            options: options
        });
    },
    beforeUpdate (chart, _args, options) {
        if (chart.tooltip) chart.tooltip.initialize(options);
    },
    reset (chart, _args, options) {
        if (chart.tooltip) chart.tooltip.initialize(options);
    },
    afterDraw (chart) {
        const tooltip = chart.tooltip;
        if (tooltip && tooltip._willRender()) {
            const args = {
                tooltip: tooltip
            };
            if (chart.notifyPlugins('beforeTooltipDraw', {
                ...args,
                cancelable: true
            }) === false) return;
            tooltip.draw(chart.ctx);
            chart.notifyPlugins('afterTooltipDraw', args);
        }
    },
    afterEvent (chart, args) {
        if (chart.tooltip) {
            const useFinalPosition = args.replay;
            if (chart.tooltip.handleEvent(args.event, useFinalPosition, args.inChartArea)) args.changed = true;
        }
    },
    defaults: {
        enabled: true,
        external: null,
        position: 'average',
        backgroundColor: 'rgba(0,0,0,0.8)',
        titleColor: '#fff',
        titleFont: {
            weight: 'bold'
        },
        titleSpacing: 2,
        titleMarginBottom: 6,
        titleAlign: 'left',
        bodyColor: '#fff',
        bodySpacing: 2,
        bodyFont: {},
        bodyAlign: 'left',
        footerColor: '#fff',
        footerSpacing: 2,
        footerMarginTop: 6,
        footerFont: {
            weight: 'bold'
        },
        footerAlign: 'left',
        padding: 6,
        caretPadding: 2,
        caretSize: 5,
        cornerRadius: 6,
        boxHeight: (ctx, opts)=>opts.bodyFont.size,
        boxWidth: (ctx, opts)=>opts.bodyFont.size,
        multiKeyBackground: '#fff',
        displayColors: true,
        boxPadding: 0,
        borderColor: 'rgba(0,0,0,0)',
        borderWidth: 0,
        animation: {
            duration: 400,
            easing: 'easeOutQuart'
        },
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'width',
                    'height',
                    'caretX',
                    'caretY'
                ]
            },
            opacity: {
                easing: 'linear',
                duration: 200
            }
        },
        callbacks: $216d2bdc6f281bf6$var$defaultCallbacks
    },
    defaultRoutes: {
        bodyFont: 'font',
        footerFont: 'font',
        titleFont: 'font'
    },
    descriptors: {
        _scriptable: (name)=>name !== 'filter' && name !== 'itemSort' && name !== 'external',
        _indexable: false,
        callbacks: {
            _scriptable: false,
            _indexable: false
        },
        animation: {
            _fallback: false
        },
        animations: {
            _fallback: 'animation'
        }
    },
    additionalOptionScopes: [
        'interaction'
    ]
};
var $216d2bdc6f281bf6$export$8b3ca321c77fdea6 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Colors: $216d2bdc6f281bf6$export$c537fa0d021d010b,
    Decimation: $216d2bdc6f281bf6$export$be17f937e9aa7533,
    Filler: $216d2bdc6f281bf6$export$d19ba4d812bed757,
    Legend: $216d2bdc6f281bf6$export$ed247974535929c7,
    SubTitle: $216d2bdc6f281bf6$export$d5c56664638992a4,
    Title: $216d2bdc6f281bf6$export$f99233281efd08a0,
    Tooltip: $216d2bdc6f281bf6$export$28c660c63b792dea
});
const $216d2bdc6f281bf6$var$addIfString = (labels, raw, index, addedLabels)=>{
    if (typeof raw === 'string') {
        index = labels.push(raw) - 1;
        addedLabels.unshift({
            index: index,
            label: raw
        });
    } else if (isNaN(raw)) index = null;
    return index;
};
function $216d2bdc6f281bf6$var$findOrAddLabel(labels, raw, index, addedLabels) {
    const first = labels.indexOf(raw);
    if (first === -1) return $216d2bdc6f281bf6$var$addIfString(labels, raw, index, addedLabels);
    const last = labels.lastIndexOf(raw);
    return first !== last ? index : first;
}
const $216d2bdc6f281bf6$var$validIndex = (index, max)=>index === null ? null : (0, $84f61e7391a78632$export$25ce5a424b770e84)(Math.round(index), 0, max);
function $216d2bdc6f281bf6$var$_getLabelForValue(value) {
    const labels = this.getLabels();
    if (value >= 0 && value < labels.length) return labels[value];
    return value;
}
class $216d2bdc6f281bf6$export$29e663ba4d09fe7 extends $216d2bdc6f281bf6$export$d60cfc58d3c358b6 {
    static id = 'category';
    static defaults = {
        ticks: {
            callback: $216d2bdc6f281bf6$var$_getLabelForValue
        }
    };
    constructor(cfg){
        super(cfg);
        this._startValue = undefined;
        this._valueRange = 0;
        this._addedLabels = [];
    }
    init(scaleOptions) {
        const added = this._addedLabels;
        if (added.length) {
            const labels = this.getLabels();
            for (const { index: index, label: label } of added)if (labels[index] === label) labels.splice(index, 1);
            this._addedLabels = [];
        }
        super.init(scaleOptions);
    }
    parse(raw, index) {
        if ((0, $84f61e7391a78632$export$342063e11d6c3cad)(raw)) return null;
        const labels = this.getLabels();
        index = isFinite(index) && labels[index] === raw ? index : $216d2bdc6f281bf6$var$findOrAddLabel(labels, raw, (0, $84f61e7391a78632$export$90a7f3efeed30595)(index, raw), this._addedLabels);
        return $216d2bdc6f281bf6$var$validIndex(index, labels.length - 1);
    }
    determineDataLimits() {
        const { minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let { min: min, max: max } = this.getMinMax(true);
        if (this.options.bounds === 'ticks') {
            if (!minDefined) min = 0;
            if (!maxDefined) max = this.getLabels().length - 1;
        }
        this.min = min;
        this.max = max;
    }
    buildTicks() {
        const min = this.min;
        const max = this.max;
        const offset = this.options.offset;
        const ticks = [];
        let labels = this.getLabels();
        labels = min === 0 && max === labels.length - 1 ? labels : labels.slice(min, max + 1);
        this._valueRange = Math.max(labels.length - (offset ? 0 : 1), 1);
        this._startValue = this.min - (offset ? 0.5 : 0);
        for(let value = min; value <= max; value++)ticks.push({
            value: value
        });
        return ticks;
    }
    getLabelForValue(value) {
        return $216d2bdc6f281bf6$var$_getLabelForValue.call(this, value);
    }
    configure() {
        super.configure();
        if (!this.isHorizontal()) this._reversePixels = !this._reversePixels;
    }
    getPixelForValue(value) {
        if (typeof value !== 'number') value = this.parse(value);
        return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
    }
    getPixelForTick(index) {
        const ticks = this.ticks;
        if (index < 0 || index > ticks.length - 1) return null;
        return this.getPixelForValue(ticks[index].value);
    }
    getValueForPixel(pixel) {
        return Math.round(this._startValue + this.getDecimalForPixel(pixel) * this._valueRange);
    }
    getBasePixel() {
        return this.bottom;
    }
}
function $216d2bdc6f281bf6$var$generateTicks$1(generationOptions, dataRange) {
    const ticks = [];
    const MIN_SPACING = 1e-14;
    const { bounds: bounds, step: step, min: min, max: max, precision: precision, count: count, maxTicks: maxTicks, maxDigits: maxDigits, includeBounds: includeBounds } = generationOptions;
    const unit = step || 1;
    const maxSpaces = maxTicks - 1;
    const { min: rmin, max: rmax } = dataRange;
    const minDefined = !(0, $84f61e7391a78632$export$342063e11d6c3cad)(min);
    const maxDefined = !(0, $84f61e7391a78632$export$342063e11d6c3cad)(max);
    const countDefined = !(0, $84f61e7391a78632$export$342063e11d6c3cad)(count);
    const minSpacing = (rmax - rmin) / (maxDigits + 1);
    let spacing = (0, $84f61e7391a78632$export$b9a6b53f9be3734)((rmax - rmin) / maxSpaces / unit) * unit;
    let factor, niceMin, niceMax, numSpaces;
    if (spacing < MIN_SPACING && !minDefined && !maxDefined) return [
        {
            value: rmin
        },
        {
            value: rmax
        }
    ];
    numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
    if (numSpaces > maxSpaces) spacing = (0, $84f61e7391a78632$export$b9a6b53f9be3734)(numSpaces * spacing / maxSpaces / unit) * unit;
    if (!(0, $84f61e7391a78632$export$342063e11d6c3cad)(precision)) {
        factor = Math.pow(10, precision);
        spacing = Math.ceil(spacing * factor) / factor;
    }
    if (bounds === 'ticks') {
        niceMin = Math.floor(rmin / spacing) * spacing;
        niceMax = Math.ceil(rmax / spacing) * spacing;
    } else {
        niceMin = rmin;
        niceMax = rmax;
    }
    if (minDefined && maxDefined && step && (0, $84f61e7391a78632$export$a05254e7c3aeba6e)((max - min) / step, spacing / 1000)) {
        numSpaces = Math.round(Math.min((max - min) / spacing, maxTicks));
        spacing = (max - min) / numSpaces;
        niceMin = min;
        niceMax = max;
    } else if (countDefined) {
        niceMin = minDefined ? min : niceMin;
        niceMax = maxDefined ? max : niceMax;
        numSpaces = count - 1;
        spacing = (niceMax - niceMin) / numSpaces;
    } else {
        numSpaces = (niceMax - niceMin) / spacing;
        if ((0, $84f61e7391a78632$export$23ebac1979863676)(numSpaces, Math.round(numSpaces), spacing / 1000)) numSpaces = Math.round(numSpaces);
        else numSpaces = Math.ceil(numSpaces);
    }
    const decimalPlaces = Math.max((0, $84f61e7391a78632$export$91477dc880baac21)(spacing), (0, $84f61e7391a78632$export$91477dc880baac21)(niceMin));
    factor = Math.pow(10, (0, $84f61e7391a78632$export$342063e11d6c3cad)(precision) ? decimalPlaces : precision);
    niceMin = Math.round(niceMin * factor) / factor;
    niceMax = Math.round(niceMax * factor) / factor;
    let j = 0;
    if (minDefined) {
        if (includeBounds && niceMin !== min) {
            ticks.push({
                value: min
            });
            if (niceMin < min) j++;
            if ((0, $84f61e7391a78632$export$23ebac1979863676)(Math.round((niceMin + j * spacing) * factor) / factor, min, $216d2bdc6f281bf6$var$relativeLabelSize(min, minSpacing, generationOptions))) j++;
        } else if (niceMin < min) j++;
    }
    for(; j < numSpaces; ++j){
        const tickValue = Math.round((niceMin + j * spacing) * factor) / factor;
        if (maxDefined && tickValue > max) break;
        ticks.push({
            value: tickValue
        });
    }
    if (maxDefined && includeBounds && niceMax !== max) {
        if (ticks.length && (0, $84f61e7391a78632$export$23ebac1979863676)(ticks[ticks.length - 1].value, max, $216d2bdc6f281bf6$var$relativeLabelSize(max, minSpacing, generationOptions))) ticks[ticks.length - 1].value = max;
        else ticks.push({
            value: max
        });
    } else if (!maxDefined || niceMax === max) ticks.push({
        value: niceMax
    });
    return ticks;
}
function $216d2bdc6f281bf6$var$relativeLabelSize(value, minSpacing, { horizontal: horizontal, minRotation: minRotation }) {
    const rad = (0, $84f61e7391a78632$export$625550452a3fa3ec)(minRotation);
    const ratio = (horizontal ? Math.sin(rad) : Math.cos(rad)) || 0.001;
    const length = 0.75 * minSpacing * ('' + value).length;
    return Math.min(minSpacing / ratio, length);
}
class $216d2bdc6f281bf6$var$LinearScaleBase extends $216d2bdc6f281bf6$export$d60cfc58d3c358b6 {
    constructor(cfg){
        super(cfg);
        this.start = undefined;
        this.end = undefined;
        this._startValue = undefined;
        this._endValue = undefined;
        this._valueRange = 0;
    }
    parse(raw, index) {
        if ((0, $84f61e7391a78632$export$342063e11d6c3cad)(raw)) return null;
        if ((typeof raw === 'number' || raw instanceof Number) && !isFinite(+raw)) return null;
        return +raw;
    }
    handleTickRangeOptions() {
        const { beginAtZero: beginAtZero } = this.options;
        const { minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let { min: min, max: max } = this;
        const setMin = (v)=>min = minDefined ? min : v;
        const setMax = (v)=>max = maxDefined ? max : v;
        if (beginAtZero) {
            const minSign = (0, $84f61e7391a78632$export$2408f22a0fab9ae5)(min);
            const maxSign = (0, $84f61e7391a78632$export$2408f22a0fab9ae5)(max);
            if (minSign < 0 && maxSign < 0) setMax(0);
            else if (minSign > 0 && maxSign > 0) setMin(0);
        }
        if (min === max) {
            let offset = max === 0 ? 1 : Math.abs(max * 0.05);
            setMax(max + offset);
            if (!beginAtZero) setMin(min - offset);
        }
        this.min = min;
        this.max = max;
    }
    getTickLimit() {
        const tickOpts = this.options.ticks;
        let { maxTicksLimit: maxTicksLimit, stepSize: stepSize } = tickOpts;
        let maxTicks;
        if (stepSize) {
            maxTicks = Math.ceil(this.max / stepSize) - Math.floor(this.min / stepSize) + 1;
            if (maxTicks > 1000) {
                console.warn(`scales.${this.id}.ticks.stepSize: ${stepSize} would result generating up to ${maxTicks} ticks. Limiting to 1000.`);
                maxTicks = 1000;
            }
        } else {
            maxTicks = this.computeTickLimit();
            maxTicksLimit = maxTicksLimit || 11;
        }
        if (maxTicksLimit) maxTicks = Math.min(maxTicksLimit, maxTicks);
        return maxTicks;
    }
    computeTickLimit() {
        return Number.POSITIVE_INFINITY;
    }
    buildTicks() {
        const opts = this.options;
        const tickOpts = opts.ticks;
        let maxTicks = this.getTickLimit();
        maxTicks = Math.max(2, maxTicks);
        const numericGeneratorOptions = {
            maxTicks: maxTicks,
            bounds: opts.bounds,
            min: opts.min,
            max: opts.max,
            precision: tickOpts.precision,
            step: tickOpts.stepSize,
            count: tickOpts.count,
            maxDigits: this._maxDigits(),
            horizontal: this.isHorizontal(),
            minRotation: tickOpts.minRotation || 0,
            includeBounds: tickOpts.includeBounds !== false
        };
        const dataRange = this._range || this;
        const ticks = $216d2bdc6f281bf6$var$generateTicks$1(numericGeneratorOptions, dataRange);
        if (opts.bounds === 'ticks') (0, $84f61e7391a78632$export$a33b77bbdbb8366c)(ticks, this, 'value');
        if (opts.reverse) {
            ticks.reverse();
            this.start = this.max;
            this.end = this.min;
        } else {
            this.start = this.min;
            this.end = this.max;
        }
        return ticks;
    }
    configure() {
        const ticks = this.ticks;
        let start = this.min;
        let end = this.max;
        super.configure();
        if (this.options.offset && ticks.length) {
            const offset = (end - start) / Math.max(ticks.length - 1, 1) / 2;
            start -= offset;
            end += offset;
        }
        this._startValue = start;
        this._endValue = end;
        this._valueRange = end - start;
    }
    getLabelForValue(value) {
        return (0, $84f61e7391a78632$export$ae1af26003f05816)(value, this.chart.options.locale, this.options.ticks.format);
    }
}
class $216d2bdc6f281bf6$export$e7f4e5e8656f0b93 extends $216d2bdc6f281bf6$var$LinearScaleBase {
    static id = 'linear';
    static defaults = {
        ticks: {
            callback: (0, $84f61e7391a78632$export$9f4f30ee63539e24).formatters.numeric
        }
    };
    determineDataLimits() {
        const { min: min, max: max } = this.getMinMax(true);
        this.min = (0, $84f61e7391a78632$export$39b482c5e57630a8)(min) ? min : 0;
        this.max = (0, $84f61e7391a78632$export$39b482c5e57630a8)(max) ? max : 1;
        this.handleTickRangeOptions();
    }
    computeTickLimit() {
        const horizontal = this.isHorizontal();
        const length = horizontal ? this.width : this.height;
        const minRotation = (0, $84f61e7391a78632$export$625550452a3fa3ec)(this.options.ticks.minRotation);
        const ratio = (horizontal ? Math.sin(minRotation) : Math.cos(minRotation)) || 0.001;
        const tickFont = this._resolveTickFontOptions(0);
        return Math.ceil(length / Math.min(40, tickFont.lineHeight / ratio));
    }
    getPixelForValue(value) {
        return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
    }
    getValueForPixel(pixel) {
        return this._startValue + this.getDecimalForPixel(pixel) * this._valueRange;
    }
}
const $216d2bdc6f281bf6$var$log10Floor = (v)=>Math.floor((0, $84f61e7391a78632$export$faec65b429be379)(v));
const $216d2bdc6f281bf6$var$changeExponent = (v, m)=>Math.pow(10, $216d2bdc6f281bf6$var$log10Floor(v) + m);
function $216d2bdc6f281bf6$var$isMajor(tickVal) {
    const remain = tickVal / Math.pow(10, $216d2bdc6f281bf6$var$log10Floor(tickVal));
    return remain === 1;
}
function $216d2bdc6f281bf6$var$steps(min, max, rangeExp) {
    const rangeStep = Math.pow(10, rangeExp);
    const start = Math.floor(min / rangeStep);
    const end = Math.ceil(max / rangeStep);
    return end - start;
}
function $216d2bdc6f281bf6$var$startExp(min, max) {
    const range = max - min;
    let rangeExp = $216d2bdc6f281bf6$var$log10Floor(range);
    while($216d2bdc6f281bf6$var$steps(min, max, rangeExp) > 10)rangeExp++;
    while($216d2bdc6f281bf6$var$steps(min, max, rangeExp) < 10)rangeExp--;
    return Math.min(rangeExp, $216d2bdc6f281bf6$var$log10Floor(min));
}
function $216d2bdc6f281bf6$var$generateTicks(generationOptions, { min: min, max: max }) {
    min = (0, $84f61e7391a78632$export$c4ce752e73470fba)(generationOptions.min, min);
    const ticks = [];
    const minExp = $216d2bdc6f281bf6$var$log10Floor(min);
    let exp = $216d2bdc6f281bf6$var$startExp(min, max);
    let precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;
    const stepSize = Math.pow(10, exp);
    const base = minExp > exp ? Math.pow(10, minExp) : 0;
    const start = Math.round((min - base) * precision) / precision;
    const offset = Math.floor((min - base) / stepSize / 10) * stepSize * 10;
    let significand = Math.floor((start - offset) / Math.pow(10, exp));
    let value = (0, $84f61e7391a78632$export$c4ce752e73470fba)(generationOptions.min, Math.round((base + offset + significand * Math.pow(10, exp)) * precision) / precision);
    while(value < max){
        ticks.push({
            value: value,
            major: $216d2bdc6f281bf6$var$isMajor(value),
            significand: significand
        });
        if (significand >= 10) significand = significand < 15 ? 15 : 20;
        else significand++;
        if (significand >= 20) {
            exp++;
            significand = 2;
            precision = exp >= 0 ? 1 : precision;
        }
        value = Math.round((base + offset + significand * Math.pow(10, exp)) * precision) / precision;
    }
    const lastTick = (0, $84f61e7391a78632$export$c4ce752e73470fba)(generationOptions.max, value);
    ticks.push({
        value: lastTick,
        major: $216d2bdc6f281bf6$var$isMajor(lastTick),
        significand: significand
    });
    return ticks;
}
class $216d2bdc6f281bf6$export$85295eaf7cb3ac3e extends $216d2bdc6f281bf6$export$d60cfc58d3c358b6 {
    static id = 'logarithmic';
    static defaults = {
        ticks: {
            callback: (0, $84f61e7391a78632$export$9f4f30ee63539e24).formatters.logarithmic,
            major: {
                enabled: true
            }
        }
    };
    constructor(cfg){
        super(cfg);
        this.start = undefined;
        this.end = undefined;
        this._startValue = undefined;
        this._valueRange = 0;
    }
    parse(raw, index) {
        const value = $216d2bdc6f281bf6$var$LinearScaleBase.prototype.parse.apply(this, [
            raw,
            index
        ]);
        if (value === 0) {
            this._zero = true;
            return undefined;
        }
        return (0, $84f61e7391a78632$export$39b482c5e57630a8)(value) && value > 0 ? value : null;
    }
    determineDataLimits() {
        const { min: min, max: max } = this.getMinMax(true);
        this.min = (0, $84f61e7391a78632$export$39b482c5e57630a8)(min) ? Math.max(0, min) : null;
        this.max = (0, $84f61e7391a78632$export$39b482c5e57630a8)(max) ? Math.max(0, max) : null;
        if (this.options.beginAtZero) this._zero = true;
        if (this._zero && this.min !== this._suggestedMin && !(0, $84f61e7391a78632$export$39b482c5e57630a8)(this._userMin)) this.min = min === $216d2bdc6f281bf6$var$changeExponent(this.min, 0) ? $216d2bdc6f281bf6$var$changeExponent(this.min, -1) : $216d2bdc6f281bf6$var$changeExponent(this.min, 0);
        this.handleTickRangeOptions();
    }
    handleTickRangeOptions() {
        const { minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let min = this.min;
        let max = this.max;
        const setMin = (v)=>min = minDefined ? min : v;
        const setMax = (v)=>max = maxDefined ? max : v;
        if (min === max) {
            if (min <= 0) {
                setMin(1);
                setMax(10);
            } else {
                setMin($216d2bdc6f281bf6$var$changeExponent(min, -1));
                setMax($216d2bdc6f281bf6$var$changeExponent(max, 1));
            }
        }
        if (min <= 0) setMin($216d2bdc6f281bf6$var$changeExponent(max, -1));
        if (max <= 0) setMax($216d2bdc6f281bf6$var$changeExponent(min, 1));
        this.min = min;
        this.max = max;
    }
    buildTicks() {
        const opts = this.options;
        const generationOptions = {
            min: this._userMin,
            max: this._userMax
        };
        const ticks = $216d2bdc6f281bf6$var$generateTicks(generationOptions, this);
        if (opts.bounds === 'ticks') (0, $84f61e7391a78632$export$a33b77bbdbb8366c)(ticks, this, 'value');
        if (opts.reverse) {
            ticks.reverse();
            this.start = this.max;
            this.end = this.min;
        } else {
            this.start = this.min;
            this.end = this.max;
        }
        return ticks;
    }
    getLabelForValue(value) {
        return value === undefined ? '0' : (0, $84f61e7391a78632$export$ae1af26003f05816)(value, this.chart.options.locale, this.options.ticks.format);
    }
    configure() {
        const start = this.min;
        super.configure();
        this._startValue = (0, $84f61e7391a78632$export$faec65b429be379)(start);
        this._valueRange = (0, $84f61e7391a78632$export$faec65b429be379)(this.max) - (0, $84f61e7391a78632$export$faec65b429be379)(start);
    }
    getPixelForValue(value) {
        if (value === undefined || value === 0) value = this.min;
        if (value === null || isNaN(value)) return NaN;
        return this.getPixelForDecimal(value === this.min ? 0 : ((0, $84f61e7391a78632$export$faec65b429be379)(value) - this._startValue) / this._valueRange);
    }
    getValueForPixel(pixel) {
        const decimal = this.getDecimalForPixel(pixel);
        return Math.pow(10, this._startValue + decimal * this._valueRange);
    }
}
function $216d2bdc6f281bf6$var$getTickBackdropHeight(opts) {
    const tickOpts = opts.ticks;
    if (tickOpts.display && opts.display) {
        const padding = (0, $84f61e7391a78632$export$a9c23c6ac3fc3eca)(tickOpts.backdropPadding);
        return (0, $84f61e7391a78632$export$90a7f3efeed30595)(tickOpts.font && tickOpts.font.size, (0, $84f61e7391a78632$export$4368d992c4eafac0).font.size) + padding.height;
    }
    return 0;
}
function $216d2bdc6f281bf6$var$measureLabelSize(ctx, font, label) {
    label = (0, $84f61e7391a78632$export$8b22cf2602fb60ce)(label) ? label : [
        label
    ];
    return {
        w: (0, $84f61e7391a78632$export$c03999cb2f36933f)(ctx, font.string, label),
        h: label.length * font.lineHeight
    };
}
function $216d2bdc6f281bf6$var$determineLimits(angle, pos, size, min, max) {
    if (angle === min || angle === max) return {
        start: pos - size / 2,
        end: pos + size / 2
    };
    else if (angle < min || angle > max) return {
        start: pos - size,
        end: pos
    };
    return {
        start: pos,
        end: pos + size
    };
}
function $216d2bdc6f281bf6$var$fitWithPointLabels(scale) {
    const orig = {
        l: scale.left + scale._padding.left,
        r: scale.right - scale._padding.right,
        t: scale.top + scale._padding.top,
        b: scale.bottom - scale._padding.bottom
    };
    const limits = Object.assign({}, orig);
    const labelSizes = [];
    const padding = [];
    const valueCount = scale._pointLabels.length;
    const pointLabelOpts = scale.options.pointLabels;
    const additionalAngle = pointLabelOpts.centerPointLabels ? (0, $84f61e7391a78632$export$56c0d5a1e737357d) / valueCount : 0;
    for(let i = 0; i < valueCount; i++){
        const opts = pointLabelOpts.setContext(scale.getPointLabelContext(i));
        padding[i] = opts.padding;
        const pointPosition = scale.getPointPosition(i, scale.drawingArea + padding[i], additionalAngle);
        const plFont = (0, $84f61e7391a78632$export$34aec0b863436764)(opts.font);
        const textSize = $216d2bdc6f281bf6$var$measureLabelSize(scale.ctx, plFont, scale._pointLabels[i]);
        labelSizes[i] = textSize;
        const angleRadians = (0, $84f61e7391a78632$export$3d12bd131bb975d1)(scale.getIndexAngle(i) + additionalAngle);
        const angle = Math.round((0, $84f61e7391a78632$export$3a6d5c9ae78a2c08)(angleRadians));
        const hLimits = $216d2bdc6f281bf6$var$determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
        const vLimits = $216d2bdc6f281bf6$var$determineLimits(angle, pointPosition.y, textSize.h, 90, 270);
        $216d2bdc6f281bf6$var$updateLimits(limits, orig, angleRadians, hLimits, vLimits);
    }
    scale.setCenterPoint(orig.l - limits.l, limits.r - orig.r, orig.t - limits.t, limits.b - orig.b);
    scale._pointLabelItems = $216d2bdc6f281bf6$var$buildPointLabelItems(scale, labelSizes, padding);
}
function $216d2bdc6f281bf6$var$updateLimits(limits, orig, angle, hLimits, vLimits) {
    const sin = Math.abs(Math.sin(angle));
    const cos = Math.abs(Math.cos(angle));
    let x = 0;
    let y = 0;
    if (hLimits.start < orig.l) {
        x = (orig.l - hLimits.start) / sin;
        limits.l = Math.min(limits.l, orig.l - x);
    } else if (hLimits.end > orig.r) {
        x = (hLimits.end - orig.r) / sin;
        limits.r = Math.max(limits.r, orig.r + x);
    }
    if (vLimits.start < orig.t) {
        y = (orig.t - vLimits.start) / cos;
        limits.t = Math.min(limits.t, orig.t - y);
    } else if (vLimits.end > orig.b) {
        y = (vLimits.end - orig.b) / cos;
        limits.b = Math.max(limits.b, orig.b + y);
    }
}
function $216d2bdc6f281bf6$var$createPointLabelItem(scale, index, itemOpts) {
    const outerDistance = scale.drawingArea;
    const { extra: extra, additionalAngle: additionalAngle, padding: padding, size: size } = itemOpts;
    const pointLabelPosition = scale.getPointPosition(index, outerDistance + extra + padding, additionalAngle);
    const angle = Math.round((0, $84f61e7391a78632$export$3a6d5c9ae78a2c08)((0, $84f61e7391a78632$export$3d12bd131bb975d1)(pointLabelPosition.angle + (0, $84f61e7391a78632$export$7f8ddf7c7c20b3cd))));
    const y = $216d2bdc6f281bf6$var$yForAngle(pointLabelPosition.y, size.h, angle);
    const textAlign = $216d2bdc6f281bf6$var$getTextAlignForAngle(angle);
    const left = $216d2bdc6f281bf6$var$leftForTextAlign(pointLabelPosition.x, size.w, textAlign);
    return {
        visible: true,
        x: pointLabelPosition.x,
        y: y,
        textAlign: textAlign,
        left: left,
        top: y,
        right: left + size.w,
        bottom: y + size.h
    };
}
function $216d2bdc6f281bf6$var$isNotOverlapped(item, area) {
    if (!area) return true;
    const { left: left, top: top, right: right, bottom: bottom } = item;
    const apexesInArea = (0, $84f61e7391a78632$export$e7094788287c5e9b)({
        x: left,
        y: top
    }, area) || (0, $84f61e7391a78632$export$e7094788287c5e9b)({
        x: left,
        y: bottom
    }, area) || (0, $84f61e7391a78632$export$e7094788287c5e9b)({
        x: right,
        y: top
    }, area) || (0, $84f61e7391a78632$export$e7094788287c5e9b)({
        x: right,
        y: bottom
    }, area);
    return !apexesInArea;
}
function $216d2bdc6f281bf6$var$buildPointLabelItems(scale, labelSizes, padding) {
    const items = [];
    const valueCount = scale._pointLabels.length;
    const opts = scale.options;
    const { centerPointLabels: centerPointLabels, display: display } = opts.pointLabels;
    const itemOpts = {
        extra: $216d2bdc6f281bf6$var$getTickBackdropHeight(opts) / 2,
        additionalAngle: centerPointLabels ? (0, $84f61e7391a78632$export$56c0d5a1e737357d) / valueCount : 0
    };
    let area;
    for(let i = 0; i < valueCount; i++){
        itemOpts.padding = padding[i];
        itemOpts.size = labelSizes[i];
        const item = $216d2bdc6f281bf6$var$createPointLabelItem(scale, i, itemOpts);
        items.push(item);
        if (display === 'auto') {
            item.visible = $216d2bdc6f281bf6$var$isNotOverlapped(item, area);
            if (item.visible) area = item;
        }
    }
    return items;
}
function $216d2bdc6f281bf6$var$getTextAlignForAngle(angle) {
    if (angle === 0 || angle === 180) return 'center';
    else if (angle < 180) return 'left';
    return 'right';
}
function $216d2bdc6f281bf6$var$leftForTextAlign(x, w, align) {
    if (align === 'right') x -= w;
    else if (align === 'center') x -= w / 2;
    return x;
}
function $216d2bdc6f281bf6$var$yForAngle(y, h, angle) {
    if (angle === 90 || angle === 270) y -= h / 2;
    else if (angle > 270 || angle < 90) y -= h;
    return y;
}
function $216d2bdc6f281bf6$var$drawPointLabelBox(ctx, opts, item) {
    const { left: left, top: top, right: right, bottom: bottom } = item;
    const { backdropColor: backdropColor } = opts;
    if (!(0, $84f61e7391a78632$export$342063e11d6c3cad)(backdropColor)) {
        const borderRadius = (0, $84f61e7391a78632$export$9fa96a7d116ea3ce)(opts.borderRadius);
        const padding = (0, $84f61e7391a78632$export$a9c23c6ac3fc3eca)(opts.backdropPadding);
        ctx.fillStyle = backdropColor;
        const backdropLeft = left - padding.left;
        const backdropTop = top - padding.top;
        const backdropWidth = right - left + padding.width;
        const backdropHeight = bottom - top + padding.height;
        if (Object.values(borderRadius).some((v)=>v !== 0)) {
            ctx.beginPath();
            (0, $84f61e7391a78632$export$d66dc83d8cfc8dd)(ctx, {
                x: backdropLeft,
                y: backdropTop,
                w: backdropWidth,
                h: backdropHeight,
                radius: borderRadius
            });
            ctx.fill();
        } else ctx.fillRect(backdropLeft, backdropTop, backdropWidth, backdropHeight);
    }
}
function $216d2bdc6f281bf6$var$drawPointLabels(scale, labelCount) {
    const { ctx: ctx, options: { pointLabels: pointLabels } } = scale;
    for(let i = labelCount - 1; i >= 0; i--){
        const item = scale._pointLabelItems[i];
        if (!item.visible) continue;
        const optsAtIndex = pointLabels.setContext(scale.getPointLabelContext(i));
        $216d2bdc6f281bf6$var$drawPointLabelBox(ctx, optsAtIndex, item);
        const plFont = (0, $84f61e7391a78632$export$34aec0b863436764)(optsAtIndex.font);
        const { x: x, y: y, textAlign: textAlign } = item;
        (0, $84f61e7391a78632$export$dc98b0b04f4c7758)(ctx, scale._pointLabels[i], x, y + plFont.lineHeight / 2, plFont, {
            color: optsAtIndex.color,
            textAlign: textAlign,
            textBaseline: 'middle'
        });
    }
}
function $216d2bdc6f281bf6$var$pathRadiusLine(scale, radius, circular, labelCount) {
    const { ctx: ctx } = scale;
    if (circular) ctx.arc(scale.xCenter, scale.yCenter, radius, 0, (0, $84f61e7391a78632$export$971d5caa766a69d7));
    else {
        let pointPosition = scale.getPointPosition(0, radius);
        ctx.moveTo(pointPosition.x, pointPosition.y);
        for(let i = 1; i < labelCount; i++){
            pointPosition = scale.getPointPosition(i, radius);
            ctx.lineTo(pointPosition.x, pointPosition.y);
        }
    }
}
function $216d2bdc6f281bf6$var$drawRadiusLine(scale, gridLineOpts, radius, labelCount, borderOpts) {
    const ctx = scale.ctx;
    const circular = gridLineOpts.circular;
    const { color: color, lineWidth: lineWidth } = gridLineOpts;
    if (!circular && !labelCount || !color || !lineWidth || radius < 0) return;
    ctx.save();
    ctx.strokeStyle = color;
    ctx.lineWidth = lineWidth;
    ctx.setLineDash(borderOpts.dash || []);
    ctx.lineDashOffset = borderOpts.dashOffset;
    ctx.beginPath();
    $216d2bdc6f281bf6$var$pathRadiusLine(scale, radius, circular, labelCount);
    ctx.closePath();
    ctx.stroke();
    ctx.restore();
}
function $216d2bdc6f281bf6$var$createPointLabelContext(parent, index, label) {
    return (0, $84f61e7391a78632$export$35e795649ee09318)(parent, {
        label: label,
        index: index,
        type: 'pointLabel'
    });
}
class $216d2bdc6f281bf6$export$cfafc36d95386d38 extends $216d2bdc6f281bf6$var$LinearScaleBase {
    static id = 'radialLinear';
    static defaults = {
        display: true,
        animate: true,
        position: 'chartArea',
        angleLines: {
            display: true,
            lineWidth: 1,
            borderDash: [],
            borderDashOffset: 0.0
        },
        grid: {
            circular: false
        },
        startAngle: 0,
        ticks: {
            showLabelBackdrop: true,
            callback: (0, $84f61e7391a78632$export$9f4f30ee63539e24).formatters.numeric
        },
        pointLabels: {
            backdropColor: undefined,
            backdropPadding: 2,
            display: true,
            font: {
                size: 10
            },
            callback (label) {
                return label;
            },
            padding: 5,
            centerPointLabels: false
        }
    };
    static defaultRoutes = {
        'angleLines.color': 'borderColor',
        'pointLabels.color': 'color',
        'ticks.color': 'color'
    };
    static descriptors = {
        angleLines: {
            _fallback: 'grid'
        }
    };
    constructor(cfg){
        super(cfg);
        this.xCenter = undefined;
        this.yCenter = undefined;
        this.drawingArea = undefined;
        this._pointLabels = [];
        this._pointLabelItems = [];
    }
    setDimensions() {
        const padding = this._padding = (0, $84f61e7391a78632$export$a9c23c6ac3fc3eca)($216d2bdc6f281bf6$var$getTickBackdropHeight(this.options) / 2);
        const w = this.width = this.maxWidth - padding.width;
        const h = this.height = this.maxHeight - padding.height;
        this.xCenter = Math.floor(this.left + w / 2 + padding.left);
        this.yCenter = Math.floor(this.top + h / 2 + padding.top);
        this.drawingArea = Math.floor(Math.min(w, h) / 2);
    }
    determineDataLimits() {
        const { min: min, max: max } = this.getMinMax(false);
        this.min = (0, $84f61e7391a78632$export$39b482c5e57630a8)(min) && !isNaN(min) ? min : 0;
        this.max = (0, $84f61e7391a78632$export$39b482c5e57630a8)(max) && !isNaN(max) ? max : 0;
        this.handleTickRangeOptions();
    }
    computeTickLimit() {
        return Math.ceil(this.drawingArea / $216d2bdc6f281bf6$var$getTickBackdropHeight(this.options));
    }
    generateTickLabels(ticks) {
        $216d2bdc6f281bf6$var$LinearScaleBase.prototype.generateTickLabels.call(this, ticks);
        this._pointLabels = this.getLabels().map((value, index)=>{
            const label = (0, $84f61e7391a78632$export$3722cfe417b6ed86)(this.options.pointLabels.callback, [
                value,
                index
            ], this);
            return label || label === 0 ? label : '';
        }).filter((v, i)=>this.chart.getDataVisibility(i));
    }
    fit() {
        const opts = this.options;
        if (opts.display && opts.pointLabels.display) $216d2bdc6f281bf6$var$fitWithPointLabels(this);
        else this.setCenterPoint(0, 0, 0, 0);
    }
    setCenterPoint(leftMovement, rightMovement, topMovement, bottomMovement) {
        this.xCenter += Math.floor((leftMovement - rightMovement) / 2);
        this.yCenter += Math.floor((topMovement - bottomMovement) / 2);
        this.drawingArea -= Math.min(this.drawingArea / 2, Math.max(leftMovement, rightMovement, topMovement, bottomMovement));
    }
    getIndexAngle(index) {
        const angleMultiplier = (0, $84f61e7391a78632$export$971d5caa766a69d7) / (this._pointLabels.length || 1);
        const startAngle = this.options.startAngle || 0;
        return (0, $84f61e7391a78632$export$3d12bd131bb975d1)(index * angleMultiplier + (0, $84f61e7391a78632$export$625550452a3fa3ec)(startAngle));
    }
    getDistanceFromCenterForValue(value) {
        if ((0, $84f61e7391a78632$export$342063e11d6c3cad)(value)) return NaN;
        const scalingFactor = this.drawingArea / (this.max - this.min);
        if (this.options.reverse) return (this.max - value) * scalingFactor;
        return (value - this.min) * scalingFactor;
    }
    getValueForDistanceFromCenter(distance) {
        if ((0, $84f61e7391a78632$export$342063e11d6c3cad)(distance)) return NaN;
        const scaledDistance = distance / (this.drawingArea / (this.max - this.min));
        return this.options.reverse ? this.max - scaledDistance : this.min + scaledDistance;
    }
    getPointLabelContext(index) {
        const pointLabels = this._pointLabels || [];
        if (index >= 0 && index < pointLabels.length) {
            const pointLabel = pointLabels[index];
            return $216d2bdc6f281bf6$var$createPointLabelContext(this.getContext(), index, pointLabel);
        }
    }
    getPointPosition(index, distanceFromCenter, additionalAngle = 0) {
        const angle = this.getIndexAngle(index) - (0, $84f61e7391a78632$export$7f8ddf7c7c20b3cd) + additionalAngle;
        return {
            x: Math.cos(angle) * distanceFromCenter + this.xCenter,
            y: Math.sin(angle) * distanceFromCenter + this.yCenter,
            angle: angle
        };
    }
    getPointPositionForValue(index, value) {
        return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
    }
    getBasePosition(index) {
        return this.getPointPositionForValue(index || 0, this.getBaseValue());
    }
    getPointLabelPosition(index) {
        const { left: left, top: top, right: right, bottom: bottom } = this._pointLabelItems[index];
        return {
            left: left,
            top: top,
            right: right,
            bottom: bottom
        };
    }
    drawBackground() {
        const { backgroundColor: backgroundColor, grid: { circular: circular } } = this.options;
        if (backgroundColor) {
            const ctx = this.ctx;
            ctx.save();
            ctx.beginPath();
            $216d2bdc6f281bf6$var$pathRadiusLine(this, this.getDistanceFromCenterForValue(this._endValue), circular, this._pointLabels.length);
            ctx.closePath();
            ctx.fillStyle = backgroundColor;
            ctx.fill();
            ctx.restore();
        }
    }
    drawGrid() {
        const ctx = this.ctx;
        const opts = this.options;
        const { angleLines: angleLines, grid: grid, border: border } = opts;
        const labelCount = this._pointLabels.length;
        let i, offset, position;
        if (opts.pointLabels.display) $216d2bdc6f281bf6$var$drawPointLabels(this, labelCount);
        if (grid.display) this.ticks.forEach((tick, index)=>{
            if (index !== 0 || index === 0 && this.min < 0) {
                offset = this.getDistanceFromCenterForValue(tick.value);
                const context = this.getContext(index);
                const optsAtIndex = grid.setContext(context);
                const optsAtIndexBorder = border.setContext(context);
                $216d2bdc6f281bf6$var$drawRadiusLine(this, optsAtIndex, offset, labelCount, optsAtIndexBorder);
            }
        });
        if (angleLines.display) {
            ctx.save();
            for(i = labelCount - 1; i >= 0; i--){
                const optsAtIndex = angleLines.setContext(this.getPointLabelContext(i));
                const { color: color, lineWidth: lineWidth } = optsAtIndex;
                if (!lineWidth || !color) continue;
                ctx.lineWidth = lineWidth;
                ctx.strokeStyle = color;
                ctx.setLineDash(optsAtIndex.borderDash);
                ctx.lineDashOffset = optsAtIndex.borderDashOffset;
                offset = this.getDistanceFromCenterForValue(opts.reverse ? this.min : this.max);
                position = this.getPointPosition(i, offset);
                ctx.beginPath();
                ctx.moveTo(this.xCenter, this.yCenter);
                ctx.lineTo(position.x, position.y);
                ctx.stroke();
            }
            ctx.restore();
        }
    }
    drawBorder() {}
    drawLabels() {
        const ctx = this.ctx;
        const opts = this.options;
        const tickOpts = opts.ticks;
        if (!tickOpts.display) return;
        const startAngle = this.getIndexAngle(0);
        let offset, width;
        ctx.save();
        ctx.translate(this.xCenter, this.yCenter);
        ctx.rotate(startAngle);
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        this.ticks.forEach((tick, index)=>{
            if (index === 0 && this.min >= 0 && !opts.reverse) return;
            const optsAtIndex = tickOpts.setContext(this.getContext(index));
            const tickFont = (0, $84f61e7391a78632$export$34aec0b863436764)(optsAtIndex.font);
            offset = this.getDistanceFromCenterForValue(this.ticks[index].value);
            if (optsAtIndex.showLabelBackdrop) {
                ctx.font = tickFont.string;
                width = ctx.measureText(tick.label).width;
                ctx.fillStyle = optsAtIndex.backdropColor;
                const padding = (0, $84f61e7391a78632$export$a9c23c6ac3fc3eca)(optsAtIndex.backdropPadding);
                ctx.fillRect(-width / 2 - padding.left, -offset - tickFont.size / 2 - padding.top, width + padding.width, tickFont.size + padding.height);
            }
            (0, $84f61e7391a78632$export$dc98b0b04f4c7758)(ctx, tick.label, 0, -offset, tickFont, {
                color: optsAtIndex.color,
                strokeColor: optsAtIndex.textStrokeColor,
                strokeWidth: optsAtIndex.textStrokeWidth
            });
        });
        ctx.restore();
    }
    drawTitle() {}
}
const $216d2bdc6f281bf6$var$INTERVALS = {
    millisecond: {
        common: true,
        size: 1,
        steps: 1000
    },
    second: {
        common: true,
        size: 1000,
        steps: 60
    },
    minute: {
        common: true,
        size: 60000,
        steps: 60
    },
    hour: {
        common: true,
        size: 3600000,
        steps: 24
    },
    day: {
        common: true,
        size: 86400000,
        steps: 30
    },
    week: {
        common: false,
        size: 604800000,
        steps: 4
    },
    month: {
        common: true,
        size: 2.628e9,
        steps: 12
    },
    quarter: {
        common: false,
        size: 7.884e9,
        steps: 4
    },
    year: {
        common: true,
        size: 3.154e10
    }
};
const $216d2bdc6f281bf6$var$UNITS = /* #__PURE__ */ Object.keys($216d2bdc6f281bf6$var$INTERVALS);
function $216d2bdc6f281bf6$var$sorter(a, b) {
    return a - b;
}
function $216d2bdc6f281bf6$var$parse(scale, input) {
    if ((0, $84f61e7391a78632$export$342063e11d6c3cad)(input)) return null;
    const adapter = scale._adapter;
    const { parser: parser, round: round, isoWeekday: isoWeekday } = scale._parseOpts;
    let value = input;
    if (typeof parser === 'function') value = parser(value);
    if (!(0, $84f61e7391a78632$export$39b482c5e57630a8)(value)) value = typeof parser === 'string' ? adapter.parse(value, parser) : adapter.parse(value);
    if (value === null) return null;
    if (round) value = round === 'week' && ((0, $84f61e7391a78632$export$d141bba7fdc215a3)(isoWeekday) || isoWeekday === true) ? adapter.startOf(value, 'isoWeek', isoWeekday) : adapter.startOf(value, round);
    return +value;
}
function $216d2bdc6f281bf6$var$determineUnitForAutoTicks(minUnit, min, max, capacity) {
    const ilen = $216d2bdc6f281bf6$var$UNITS.length;
    for(let i = $216d2bdc6f281bf6$var$UNITS.indexOf(minUnit); i < ilen - 1; ++i){
        const interval = $216d2bdc6f281bf6$var$INTERVALS[$216d2bdc6f281bf6$var$UNITS[i]];
        const factor = interval.steps ? interval.steps : Number.MAX_SAFE_INTEGER;
        if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) return $216d2bdc6f281bf6$var$UNITS[i];
    }
    return $216d2bdc6f281bf6$var$UNITS[ilen - 1];
}
function $216d2bdc6f281bf6$var$determineUnitForFormatting(scale, numTicks, minUnit, min, max) {
    for(let i = $216d2bdc6f281bf6$var$UNITS.length - 1; i >= $216d2bdc6f281bf6$var$UNITS.indexOf(minUnit); i--){
        const unit = $216d2bdc6f281bf6$var$UNITS[i];
        if ($216d2bdc6f281bf6$var$INTERVALS[unit].common && scale._adapter.diff(max, min, unit) >= numTicks - 1) return unit;
    }
    return $216d2bdc6f281bf6$var$UNITS[minUnit ? $216d2bdc6f281bf6$var$UNITS.indexOf(minUnit) : 0];
}
function $216d2bdc6f281bf6$var$determineMajorUnit(unit) {
    for(let i = $216d2bdc6f281bf6$var$UNITS.indexOf(unit) + 1, ilen = $216d2bdc6f281bf6$var$UNITS.length; i < ilen; ++i){
        if ($216d2bdc6f281bf6$var$INTERVALS[$216d2bdc6f281bf6$var$UNITS[i]].common) return $216d2bdc6f281bf6$var$UNITS[i];
    }
}
function $216d2bdc6f281bf6$var$addTick(ticks, time, timestamps) {
    if (!timestamps) ticks[time] = true;
    else if (timestamps.length) {
        const { lo: lo, hi: hi } = (0, $84f61e7391a78632$export$f96d196f7728bb5)(timestamps, time);
        const timestamp = timestamps[lo] >= time ? timestamps[lo] : timestamps[hi];
        ticks[timestamp] = true;
    }
}
function $216d2bdc6f281bf6$var$setMajorTicks(scale, ticks, map, majorUnit) {
    const adapter = scale._adapter;
    const first = +adapter.startOf(ticks[0].value, majorUnit);
    const last = ticks[ticks.length - 1].value;
    let major, index;
    for(major = first; major <= last; major = +adapter.add(major, 1, majorUnit)){
        index = map[major];
        if (index >= 0) ticks[index].major = true;
    }
    return ticks;
}
function $216d2bdc6f281bf6$var$ticksFromTimestamps(scale, values, majorUnit) {
    const ticks = [];
    const map = {};
    const ilen = values.length;
    let i, value;
    for(i = 0; i < ilen; ++i){
        value = values[i];
        map[value] = i;
        ticks.push({
            value: value,
            major: false
        });
    }
    return ilen === 0 || !majorUnit ? ticks : $216d2bdc6f281bf6$var$setMajorTicks(scale, ticks, map, majorUnit);
}
class $216d2bdc6f281bf6$export$a894c72689ff3ec extends $216d2bdc6f281bf6$export$d60cfc58d3c358b6 {
    static id = 'time';
    static defaults = {
        bounds: 'data',
        adapters: {},
        time: {
            parser: false,
            unit: false,
            round: false,
            isoWeekday: false,
            minUnit: 'millisecond',
            displayFormats: {}
        },
        ticks: {
            source: 'auto',
            callback: false,
            major: {
                enabled: false
            }
        }
    };
    constructor(props){
        super(props);
        this._cache = {
            data: [],
            labels: [],
            all: []
        };
        this._unit = 'day';
        this._majorUnit = undefined;
        this._offsets = {};
        this._normalized = false;
        this._parseOpts = undefined;
    }
    init(scaleOpts, opts = {}) {
        const time = scaleOpts.time || (scaleOpts.time = {});
        const adapter = this._adapter = new $216d2bdc6f281bf6$export$f32766ea09ec8bc4._date(scaleOpts.adapters.date);
        adapter.init(opts);
        (0, $84f61e7391a78632$export$555508cbc6add439)(time.displayFormats, adapter.formats());
        this._parseOpts = {
            parser: time.parser,
            round: time.round,
            isoWeekday: time.isoWeekday
        };
        super.init(scaleOpts);
        this._normalized = opts.normalized;
    }
    parse(raw, index) {
        if (raw === undefined) return null;
        return $216d2bdc6f281bf6$var$parse(this, raw);
    }
    beforeLayout() {
        super.beforeLayout();
        this._cache = {
            data: [],
            labels: [],
            all: []
        };
    }
    determineDataLimits() {
        const options = this.options;
        const adapter = this._adapter;
        const unit = options.time.unit || 'day';
        let { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        function _applyBounds(bounds) {
            if (!minDefined && !isNaN(bounds.min)) min = Math.min(min, bounds.min);
            if (!maxDefined && !isNaN(bounds.max)) max = Math.max(max, bounds.max);
        }
        if (!minDefined || !maxDefined) {
            _applyBounds(this._getLabelBounds());
            if (options.bounds !== 'ticks' || options.ticks.source !== 'labels') _applyBounds(this.getMinMax(false));
        }
        min = (0, $84f61e7391a78632$export$39b482c5e57630a8)(min) && !isNaN(min) ? min : +adapter.startOf(Date.now(), unit);
        max = (0, $84f61e7391a78632$export$39b482c5e57630a8)(max) && !isNaN(max) ? max : +adapter.endOf(Date.now(), unit) + 1;
        this.min = Math.min(min, max - 1);
        this.max = Math.max(min + 1, max);
    }
    _getLabelBounds() {
        const arr = this.getLabelTimestamps();
        let min = Number.POSITIVE_INFINITY;
        let max = Number.NEGATIVE_INFINITY;
        if (arr.length) {
            min = arr[0];
            max = arr[arr.length - 1];
        }
        return {
            min: min,
            max: max
        };
    }
    buildTicks() {
        const options = this.options;
        const timeOpts = options.time;
        const tickOpts = options.ticks;
        const timestamps = tickOpts.source === 'labels' ? this.getLabelTimestamps() : this._generate();
        if (options.bounds === 'ticks' && timestamps.length) {
            this.min = this._userMin || timestamps[0];
            this.max = this._userMax || timestamps[timestamps.length - 1];
        }
        const min = this.min;
        const max = this.max;
        const ticks = (0, $84f61e7391a78632$export$2ed0fc6709e59212)(timestamps, min, max);
        this._unit = timeOpts.unit || (tickOpts.autoSkip ? $216d2bdc6f281bf6$var$determineUnitForAutoTicks(timeOpts.minUnit, this.min, this.max, this._getLabelCapacity(min)) : $216d2bdc6f281bf6$var$determineUnitForFormatting(this, ticks.length, timeOpts.minUnit, this.min, this.max));
        this._majorUnit = !tickOpts.major.enabled || this._unit === 'year' ? undefined : $216d2bdc6f281bf6$var$determineMajorUnit(this._unit);
        this.initOffsets(timestamps);
        if (options.reverse) ticks.reverse();
        return $216d2bdc6f281bf6$var$ticksFromTimestamps(this, ticks, this._majorUnit);
    }
    afterAutoSkip() {
        if (this.options.offsetAfterAutoskip) this.initOffsets(this.ticks.map((tick)=>+tick.value));
    }
    initOffsets(timestamps = []) {
        let start = 0;
        let end = 0;
        let first, last;
        if (this.options.offset && timestamps.length) {
            first = this.getDecimalForValue(timestamps[0]);
            if (timestamps.length === 1) start = 1 - first;
            else start = (this.getDecimalForValue(timestamps[1]) - first) / 2;
            last = this.getDecimalForValue(timestamps[timestamps.length - 1]);
            if (timestamps.length === 1) end = last;
            else end = (last - this.getDecimalForValue(timestamps[timestamps.length - 2])) / 2;
        }
        const limit = timestamps.length < 3 ? 0.5 : 0.25;
        start = (0, $84f61e7391a78632$export$25ce5a424b770e84)(start, 0, limit);
        end = (0, $84f61e7391a78632$export$25ce5a424b770e84)(end, 0, limit);
        this._offsets = {
            start: start,
            end: end,
            factor: 1 / (start + 1 + end)
        };
    }
    _generate() {
        const adapter = this._adapter;
        const min = this.min;
        const max = this.max;
        const options = this.options;
        const timeOpts = options.time;
        const minor = timeOpts.unit || $216d2bdc6f281bf6$var$determineUnitForAutoTicks(timeOpts.minUnit, min, max, this._getLabelCapacity(min));
        const stepSize = (0, $84f61e7391a78632$export$90a7f3efeed30595)(options.ticks.stepSize, 1);
        const weekday = minor === 'week' ? timeOpts.isoWeekday : false;
        const hasWeekday = (0, $84f61e7391a78632$export$d141bba7fdc215a3)(weekday) || weekday === true;
        const ticks = {};
        let first = min;
        let time, count;
        if (hasWeekday) first = +adapter.startOf(first, 'isoWeek', weekday);
        first = +adapter.startOf(first, hasWeekday ? 'day' : minor);
        if (adapter.diff(max, min, minor) > 100000 * stepSize) throw new Error(min + ' and ' + max + ' are too far apart with stepSize of ' + stepSize + ' ' + minor);
        const timestamps = options.ticks.source === 'data' && this.getDataTimestamps();
        for(time = first, count = 0; time < max; time = +adapter.add(time, stepSize, minor), count++)$216d2bdc6f281bf6$var$addTick(ticks, time, timestamps);
        if (time === max || options.bounds === 'ticks' || count === 1) $216d2bdc6f281bf6$var$addTick(ticks, time, timestamps);
        return Object.keys(ticks).sort($216d2bdc6f281bf6$var$sorter).map((x)=>+x);
    }
    getLabelForValue(value) {
        const adapter = this._adapter;
        const timeOpts = this.options.time;
        if (timeOpts.tooltipFormat) return adapter.format(value, timeOpts.tooltipFormat);
        return adapter.format(value, timeOpts.displayFormats.datetime);
    }
    format(value, format) {
        const options = this.options;
        const formats = options.time.displayFormats;
        const unit = this._unit;
        const fmt = format || formats[unit];
        return this._adapter.format(value, fmt);
    }
    _tickFormatFunction(time, index, ticks, format) {
        const options = this.options;
        const formatter = options.ticks.callback;
        if (formatter) return (0, $84f61e7391a78632$export$3722cfe417b6ed86)(formatter, [
            time,
            index,
            ticks
        ], this);
        const formats = options.time.displayFormats;
        const unit = this._unit;
        const majorUnit = this._majorUnit;
        const minorFormat = unit && formats[unit];
        const majorFormat = majorUnit && formats[majorUnit];
        const tick = ticks[index];
        const major = majorUnit && majorFormat && tick && tick.major;
        return this._adapter.format(time, format || (major ? majorFormat : minorFormat));
    }
    generateTickLabels(ticks) {
        let i, ilen, tick;
        for(i = 0, ilen = ticks.length; i < ilen; ++i){
            tick = ticks[i];
            tick.label = this._tickFormatFunction(tick.value, i, ticks);
        }
    }
    getDecimalForValue(value) {
        return value === null ? NaN : (value - this.min) / (this.max - this.min);
    }
    getPixelForValue(value) {
        const offsets = this._offsets;
        const pos = this.getDecimalForValue(value);
        return this.getPixelForDecimal((offsets.start + pos) * offsets.factor);
    }
    getValueForPixel(pixel) {
        const offsets = this._offsets;
        const pos = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
        return this.min + pos * (this.max - this.min);
    }
    _getLabelSize(label) {
        const ticksOpts = this.options.ticks;
        const tickLabelWidth = this.ctx.measureText(label).width;
        const angle = (0, $84f61e7391a78632$export$625550452a3fa3ec)(this.isHorizontal() ? ticksOpts.maxRotation : ticksOpts.minRotation);
        const cosRotation = Math.cos(angle);
        const sinRotation = Math.sin(angle);
        const tickFontSize = this._resolveTickFontOptions(0).size;
        return {
            w: tickLabelWidth * cosRotation + tickFontSize * sinRotation,
            h: tickLabelWidth * sinRotation + tickFontSize * cosRotation
        };
    }
    _getLabelCapacity(exampleTime) {
        const timeOpts = this.options.time;
        const displayFormats = timeOpts.displayFormats;
        const format = displayFormats[timeOpts.unit] || displayFormats.millisecond;
        const exampleLabel = this._tickFormatFunction(exampleTime, 0, $216d2bdc6f281bf6$var$ticksFromTimestamps(this, [
            exampleTime
        ], this._majorUnit), format);
        const size = this._getLabelSize(exampleLabel);
        const capacity = Math.floor(this.isHorizontal() ? this.width / size.w : this.height / size.h) - 1;
        return capacity > 0 ? capacity : 1;
    }
    getDataTimestamps() {
        let timestamps = this._cache.data || [];
        let i, ilen;
        if (timestamps.length) return timestamps;
        const metas = this.getMatchingVisibleMetas();
        if (this._normalized && metas.length) return this._cache.data = metas[0].controller.getAllParsedValues(this);
        for(i = 0, ilen = metas.length; i < ilen; ++i)timestamps = timestamps.concat(metas[i].controller.getAllParsedValues(this));
        return this._cache.data = this.normalize(timestamps);
    }
    getLabelTimestamps() {
        const timestamps = this._cache.labels || [];
        let i, ilen;
        if (timestamps.length) return timestamps;
        const labels = this.getLabels();
        for(i = 0, ilen = labels.length; i < ilen; ++i)timestamps.push($216d2bdc6f281bf6$var$parse(this, labels[i]));
        return this._cache.labels = this._normalized ? timestamps : this.normalize(timestamps);
    }
    normalize(values) {
        return (0, $84f61e7391a78632$export$71511d61b312f219)(values.sort($216d2bdc6f281bf6$var$sorter));
    }
}
function $216d2bdc6f281bf6$var$interpolate(table, val, reverse) {
    let lo = 0;
    let hi = table.length - 1;
    let prevSource, nextSource, prevTarget, nextTarget;
    if (reverse) {
        if (val >= table[lo].pos && val <= table[hi].pos) ({ lo: lo, hi: hi } = (0, $84f61e7391a78632$export$ef35774e6d314e91)(table, 'pos', val));
        ({ pos: prevSource, time: prevTarget } = table[lo]);
        ({ pos: nextSource, time: nextTarget } = table[hi]);
    } else {
        if (val >= table[lo].time && val <= table[hi].time) ({ lo: lo, hi: hi } = (0, $84f61e7391a78632$export$ef35774e6d314e91)(table, 'time', val));
        ({ time: prevSource, pos: prevTarget } = table[lo]);
        ({ time: nextSource, pos: nextTarget } = table[hi]);
    }
    const span = nextSource - prevSource;
    return span ? prevTarget + (nextTarget - prevTarget) * (val - prevSource) / span : prevTarget;
}
class $216d2bdc6f281bf6$export$85df64a8eb6dc986 extends $216d2bdc6f281bf6$export$a894c72689ff3ec {
    static id = 'timeseries';
    static defaults = $216d2bdc6f281bf6$export$a894c72689ff3ec.defaults;
    constructor(props){
        super(props);
        this._table = [];
        this._minPos = undefined;
        this._tableRange = undefined;
    }
    initOffsets() {
        const timestamps = this._getTimestampsForTable();
        const table = this._table = this.buildLookupTable(timestamps);
        this._minPos = $216d2bdc6f281bf6$var$interpolate(table, this.min);
        this._tableRange = $216d2bdc6f281bf6$var$interpolate(table, this.max) - this._minPos;
        super.initOffsets(timestamps);
    }
    buildLookupTable(timestamps) {
        const { min: min, max: max } = this;
        const items = [];
        const table = [];
        let i, ilen, prev, curr, next;
        for(i = 0, ilen = timestamps.length; i < ilen; ++i){
            curr = timestamps[i];
            if (curr >= min && curr <= max) items.push(curr);
        }
        if (items.length < 2) return [
            {
                time: min,
                pos: 0
            },
            {
                time: max,
                pos: 1
            }
        ];
        for(i = 0, ilen = items.length; i < ilen; ++i){
            next = items[i + 1];
            prev = items[i - 1];
            curr = items[i];
            if (Math.round((next + prev) / 2) !== curr) table.push({
                time: curr,
                pos: i / (ilen - 1)
            });
        }
        return table;
    }
    _generate() {
        const min = this.min;
        const max = this.max;
        let timestamps = super.getDataTimestamps();
        if (!timestamps.includes(min) || !timestamps.length) timestamps.splice(0, 0, min);
        if (!timestamps.includes(max) || timestamps.length === 1) timestamps.push(max);
        return timestamps.sort((a, b)=>a - b);
    }
    _getTimestampsForTable() {
        let timestamps = this._cache.all || [];
        if (timestamps.length) return timestamps;
        const data = this.getDataTimestamps();
        const label = this.getLabelTimestamps();
        if (data.length && label.length) timestamps = this.normalize(data.concat(label));
        else timestamps = data.length ? data : label;
        timestamps = this._cache.all = timestamps;
        return timestamps;
    }
    getDecimalForValue(value) {
        return ($216d2bdc6f281bf6$var$interpolate(this._table, value) - this._minPos) / this._tableRange;
    }
    getValueForPixel(pixel) {
        const offsets = this._offsets;
        const decimal = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
        return $216d2bdc6f281bf6$var$interpolate(this._table, decimal * this._tableRange + this._minPos, true);
    }
}
var $216d2bdc6f281bf6$export$bcac1c16f1530ec2 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    CategoryScale: $216d2bdc6f281bf6$export$29e663ba4d09fe7,
    LinearScale: $216d2bdc6f281bf6$export$e7f4e5e8656f0b93,
    LogarithmicScale: $216d2bdc6f281bf6$export$85295eaf7cb3ac3e,
    RadialLinearScale: $216d2bdc6f281bf6$export$cfafc36d95386d38,
    TimeScale: $216d2bdc6f281bf6$export$a894c72689ff3ec,
    TimeSeriesScale: $216d2bdc6f281bf6$export$85df64a8eb6dc986
});
const $216d2bdc6f281bf6$export$e8959e79e3af550f = [
    $216d2bdc6f281bf6$export$a6506504f799c5d5,
    $216d2bdc6f281bf6$export$7a5d735b2ab6389d,
    $216d2bdc6f281bf6$export$8b3ca321c77fdea6,
    $216d2bdc6f281bf6$export$bcac1c16f1530ec2
];


(0, $216d2bdc6f281bf6$export$acaa6426d77a227e).register(...(0, $216d2bdc6f281bf6$export$e8959e79e3af550f));
var $e24bb3f4f01060dd$export$2e2bcd8739ae039 = (0, $216d2bdc6f281bf6$export$acaa6426d77a227e);


/*!
 * chartjs-adapter-date-fns v3.0.0
 * https://www.chartjs.org
 * (c) 2022 chartjs-adapter-date-fns Contributors
 * Released under the MIT license
 */ 
/**
 * @module constants
 * @summary Useful constants
 * @description
 * Collection of useful date constants.
 *
 * The constants could be imported from `date-fns/constants`:
 *
 * ```ts
 * import { maxTime, minTime } from "./constants/date-fns/constants";
 *
 * function isAllowedTime(time) {
 *   return time <= maxTime && time >= minTime;
 * }
 * ```
 */ /**
 * @constant
 * @name daysInWeek
 * @summary Days in 1 week.
 */ const $8540a44f59a4af84$export$dfd9b671c89acc8e = 7;
const $8540a44f59a4af84$export$3913210603d8e9ae = 365.2425;
const $8540a44f59a4af84$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
const $8540a44f59a4af84$export$4dec998e48f9c246 = -$8540a44f59a4af84$export$81caae6e1cc7a622;
const $8540a44f59a4af84$export$4fad13613e88edc8 = 604800000;
const $8540a44f59a4af84$export$b76b1809a2898f9a = 86400000;
const $8540a44f59a4af84$export$91246f0b9bd9beff = 60000;
const $8540a44f59a4af84$export$7f72910d6dfd237a = 3600000;
const $8540a44f59a4af84$export$397c2d5776aa9055 = 1000;
const $8540a44f59a4af84$export$3633035e63cee86a = 525600;
const $8540a44f59a4af84$export$ab7da2ccd1075c38 = 43200;
const $8540a44f59a4af84$export$2423174df8cd3cd2 = 1440;
const $8540a44f59a4af84$export$f2f5ae5a8e2d8f9f = 60;
const $8540a44f59a4af84$export$3c58128db900d44e = 3;
const $8540a44f59a4af84$export$80d7e435f744f319 = 12;
const $8540a44f59a4af84$export$4db7641526e3241f = 4;
const $8540a44f59a4af84$export$698aec755e92c695 = 3600;
const $8540a44f59a4af84$export$a77c1a7ebebe2a5a = 60;
const $8540a44f59a4af84$export$815a9362476d2fe3 = $8540a44f59a4af84$export$698aec755e92c695 * 24;
const $8540a44f59a4af84$export$34804a017b31e2fe = $8540a44f59a4af84$export$815a9362476d2fe3 * 7;
const $8540a44f59a4af84$export$7271e9e3478110d1 = $8540a44f59a4af84$export$815a9362476d2fe3 * $8540a44f59a4af84$export$3913210603d8e9ae;
const $8540a44f59a4af84$export$8e6600bbdee7dabb = $8540a44f59a4af84$export$7271e9e3478110d1 / 12;
const $8540a44f59a4af84$export$be1dccf2de902d31 = $8540a44f59a4af84$export$8e6600bbdee7dabb * 3;
const $8540a44f59a4af84$export$2a7b97929c48d47d = Symbol.for("constructDateFrom");


function $abb9adbdb26342b3$export$ead8a1812b171991(date, value) {
    if (typeof date === "function") return date(value);
    if (date && typeof date === "object" && (0, $8540a44f59a4af84$export$2a7b97929c48d47d) in date) return date[0, $8540a44f59a4af84$export$2a7b97929c48d47d](value);
    if (date instanceof Date) return new date.constructor(value);
    return new Date(value);
}
var // Fallback for modularized imports:
$abb9adbdb26342b3$export$2e2bcd8739ae039 = $abb9adbdb26342b3$export$ead8a1812b171991;



function $231bfb8d72679740$export$e67a095c620b86fe(argument, context) {
    // [TODO] Get rid of `toDate` or `constructFrom`?
    return (0, $abb9adbdb26342b3$export$ead8a1812b171991)(context || argument, argument);
}
var // Fallback for modularized imports:
$231bfb8d72679740$export$2e2bcd8739ae039 = $231bfb8d72679740$export$e67a095c620b86fe;


function $a351150ce2eb3ddb$export$dd412b56f1e4d8aa(date, amount, options) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    if (isNaN(amount)) return (0, $abb9adbdb26342b3$export$ead8a1812b171991)(options?.in || date, NaN);
    // If 0 days, no-op to avoid changing times in the hour before end of DST
    if (!amount) return _date;
    _date.setDate(_date.getDate() + amount);
    return _date;
}
var // Fallback for modularized imports:
$a351150ce2eb3ddb$export$2e2bcd8739ae039 = $a351150ce2eb3ddb$export$dd412b56f1e4d8aa;



function $a1665abf6052bbc9$export$baf757aaf0c95c94(date, amount, options) {
    return (0, $abb9adbdb26342b3$export$ead8a1812b171991)(options?.in || date, +(0, $231bfb8d72679740$export$e67a095c620b86fe)(date) + amount);
}
var // Fallback for modularized imports:
$a1665abf6052bbc9$export$2e2bcd8739ae039 = $a1665abf6052bbc9$export$baf757aaf0c95c94;



function $dada8b88b0873e8d$export$4a4306ad4fa0e5e6(date, amount, options) {
    return (0, $a1665abf6052bbc9$export$baf757aaf0c95c94)(date, amount * (0, $8540a44f59a4af84$export$7f72910d6dfd237a), options);
}
var // Fallback for modularized imports:
$dada8b88b0873e8d$export$2e2bcd8739ae039 = $dada8b88b0873e8d$export$4a4306ad4fa0e5e6;



function $e8dac3cf5df5dbc8$export$2287e3d29250119e(date, amount, options) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    _date.setTime(_date.getTime() + amount * (0, $8540a44f59a4af84$export$91246f0b9bd9beff));
    return _date;
}
var // Fallback for modularized imports:
$e8dac3cf5df5dbc8$export$2e2bcd8739ae039 = $e8dac3cf5df5dbc8$export$2287e3d29250119e;



function $8fcd3b0bf5df7635$export$17c93e242b2d3a22(date, amount, options) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    if (isNaN(amount)) return (0, $abb9adbdb26342b3$export$ead8a1812b171991)(options?.in || date, NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return _date;
    const dayOfMonth = _date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    const endOfDesiredMonth = (0, $abb9adbdb26342b3$export$ead8a1812b171991)(options?.in || date, _date.getTime());
    endOfDesiredMonth.setMonth(_date.getMonth() + amount + 1, 0);
    const daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        _date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return _date;
    }
}
var // Fallback for modularized imports:
$8fcd3b0bf5df7635$export$2e2bcd8739ae039 = $8fcd3b0bf5df7635$export$17c93e242b2d3a22;


function $30e5a3aa581ecd23$export$c252a41d0fbed2ce(date, amount, options) {
    return (0, $8fcd3b0bf5df7635$export$17c93e242b2d3a22)(date, amount * 3, options);
}
var // Fallback for modularized imports:
$30e5a3aa581ecd23$export$2e2bcd8739ae039 = $30e5a3aa581ecd23$export$c252a41d0fbed2ce;


function $ec74b6b01c6372f4$export$3cb31b0df13be68(date, amount, options) {
    return (0, $a1665abf6052bbc9$export$baf757aaf0c95c94)(date, amount * 1000, options);
}
var // Fallback for modularized imports:
$ec74b6b01c6372f4$export$2e2bcd8739ae039 = $ec74b6b01c6372f4$export$3cb31b0df13be68;


function $bce641bd93181421$export$ef501a2bb4f3ee6b(date, amount, options) {
    return (0, $a351150ce2eb3ddb$export$dd412b56f1e4d8aa)(date, amount * 7, options);
}
var // Fallback for modularized imports:
$bce641bd93181421$export$2e2bcd8739ae039 = $bce641bd93181421$export$ef501a2bb4f3ee6b;


function $25460c542fb3bf74$export$3d83eec43f4ea476(date, amount, options) {
    return (0, $8fcd3b0bf5df7635$export$17c93e242b2d3a22)(date, amount * 12, options);
}
var // Fallback for modularized imports:
$25460c542fb3bf74$export$2e2bcd8739ae039 = $25460c542fb3bf74$export$3d83eec43f4ea476;


function $002c8181c95d5119$export$9f53b88e82f64d8d(context, ...dates) {
    const normalize = (0, $abb9adbdb26342b3$export$ead8a1812b171991).bind(null, context || dates.find((date)=>typeof date === "object"));
    return dates.map(normalize);
}



function $92dc0740ffabe180$export$113002b5eff6e430(date) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const utcDate = new Date(Date.UTC(_date.getFullYear(), _date.getMonth(), _date.getDate(), _date.getHours(), _date.getMinutes(), _date.getSeconds(), _date.getMilliseconds()));
    utcDate.setUTCFullYear(_date.getFullYear());
    return +date - +utcDate;
}





function $b6caff0bf13dcaf5$export$63fa379ae8a9ba2(date, options) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$b6caff0bf13dcaf5$export$2e2bcd8739ae039 = $b6caff0bf13dcaf5$export$63fa379ae8a9ba2;


function $737f54e9ffaddc15$export$4a02e9c37dab4871(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, $002c8181c95d5119$export$9f53b88e82f64d8d)(options?.in, laterDate, earlierDate);
    const laterStartOfDay = (0, $b6caff0bf13dcaf5$export$63fa379ae8a9ba2)(laterDate_);
    const earlierStartOfDay = (0, $b6caff0bf13dcaf5$export$63fa379ae8a9ba2)(earlierDate_);
    const laterTimestamp = +laterStartOfDay - (0, $92dc0740ffabe180$export$113002b5eff6e430)(laterStartOfDay);
    const earlierTimestamp = +earlierStartOfDay - (0, $92dc0740ffabe180$export$113002b5eff6e430)(earlierStartOfDay);
    // Round the number of days to the nearest integer because the number of
    // milliseconds in a day is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round((laterTimestamp - earlierTimestamp) / (0, $8540a44f59a4af84$export$b76b1809a2898f9a));
}
var // Fallback for modularized imports:
$737f54e9ffaddc15$export$2e2bcd8739ae039 = $737f54e9ffaddc15$export$4a02e9c37dab4871;


function $21c2b10d84e6b5ad$export$86415ebf4eb36b8c(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, $002c8181c95d5119$export$9f53b88e82f64d8d)(options?.in, laterDate, earlierDate);
    const sign = $21c2b10d84e6b5ad$var$compareLocalAsc(laterDate_, earlierDate_);
    const difference = Math.abs((0, $737f54e9ffaddc15$export$4a02e9c37dab4871)(laterDate_, earlierDate_));
    laterDate_.setDate(laterDate_.getDate() - sign * difference);
    // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
    // If so, result must be decreased by 1 in absolute value
    const isLastDayNotFull = Number($21c2b10d84e6b5ad$var$compareLocalAsc(laterDate_, earlierDate_) === -sign);
    const result = sign * (difference - isLastDayNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}
// Like `compareAsc` but uses local time not UTC, which is needed
// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function $21c2b10d84e6b5ad$var$compareLocalAsc(laterDate, earlierDate) {
    const diff = laterDate.getFullYear() - earlierDate.getFullYear() || laterDate.getMonth() - earlierDate.getMonth() || laterDate.getDate() - earlierDate.getDate() || laterDate.getHours() - earlierDate.getHours() || laterDate.getMinutes() - earlierDate.getMinutes() || laterDate.getSeconds() - earlierDate.getSeconds() || laterDate.getMilliseconds() - earlierDate.getMilliseconds();
    if (diff < 0) return -1;
    if (diff > 0) return 1;
    // Return 0 if diff is 0; return NaN if diff is NaN
    return diff;
}
var // Fallback for modularized imports:
$21c2b10d84e6b5ad$export$2e2bcd8739ae039 = $21c2b10d84e6b5ad$export$86415ebf4eb36b8c;

function $495af4000bb18bf7$export$b6474a47258c1211(method) {
    return (number)=>{
        const round = method ? Math[method] : Math.trunc;
        const result = round(number);
        // Prevent negative zero
        return result === 0 ? 0 : result;
    };
}




function $f1e71fcc3bd0bed6$export$5436ca250d4d6872(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, $002c8181c95d5119$export$9f53b88e82f64d8d)(options?.in, laterDate, earlierDate);
    const diff = (+laterDate_ - +earlierDate_) / (0, $8540a44f59a4af84$export$7f72910d6dfd237a);
    return (0, $495af4000bb18bf7$export$b6474a47258c1211)(options?.roundingMethod)(diff);
}
var // Fallback for modularized imports:
$f1e71fcc3bd0bed6$export$2e2bcd8739ae039 = $f1e71fcc3bd0bed6$export$5436ca250d4d6872;


function $b7913fc338fe28ad$export$7be94d13716b4bf6(laterDate, earlierDate) {
    return +(0, $231bfb8d72679740$export$e67a095c620b86fe)(laterDate) - +(0, $231bfb8d72679740$export$e67a095c620b86fe)(earlierDate);
}
var // Fallback for modularized imports:
$b7913fc338fe28ad$export$2e2bcd8739ae039 = $b7913fc338fe28ad$export$7be94d13716b4bf6;




function $67e743be56b112ce$export$d904251335be481a(dateLeft, dateRight, options) {
    const diff = (0, $b7913fc338fe28ad$export$7be94d13716b4bf6)(dateLeft, dateRight) / (0, $8540a44f59a4af84$export$91246f0b9bd9beff);
    return (0, $495af4000bb18bf7$export$b6474a47258c1211)(options?.roundingMethod)(diff);
}
var // Fallback for modularized imports:
$67e743be56b112ce$export$2e2bcd8739ae039 = $67e743be56b112ce$export$d904251335be481a;



function $e9cff913190bd013$export$fe114145ae75d197(dateLeft, dateRight) {
    const diff = +(0, $231bfb8d72679740$export$e67a095c620b86fe)(dateLeft) - +(0, $231bfb8d72679740$export$e67a095c620b86fe)(dateRight);
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    // Return 0 if diff is 0; return NaN if diff is NaN
    return diff;
}
var // Fallback for modularized imports:
$e9cff913190bd013$export$2e2bcd8739ae039 = $e9cff913190bd013$export$fe114145ae75d197;



function $8aa264ebd3f03841$export$489984ac7c996389(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, $002c8181c95d5119$export$9f53b88e82f64d8d)(options?.in, laterDate, earlierDate);
    const yearsDiff = laterDate_.getFullYear() - earlierDate_.getFullYear();
    const monthsDiff = laterDate_.getMonth() - earlierDate_.getMonth();
    return yearsDiff * 12 + monthsDiff;
}
var // Fallback for modularized imports:
$8aa264ebd3f03841$export$2e2bcd8739ae039 = $8aa264ebd3f03841$export$489984ac7c996389;



function $b6a2419fd0059687$export$eb9a03f0e9aa6cea(date, options) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    _date.setHours(23, 59, 59, 999);
    return _date;
}
var // Fallback for modularized imports:
$b6a2419fd0059687$export$2e2bcd8739ae039 = $b6a2419fd0059687$export$eb9a03f0e9aa6cea;



function $e58340063d97ab50$export$a2258d9c4118825c(date, options) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    const month = _date.getMonth();
    _date.setFullYear(_date.getFullYear(), month + 1, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}
var // Fallback for modularized imports:
$e58340063d97ab50$export$2e2bcd8739ae039 = $e58340063d97ab50$export$a2258d9c4118825c;



function $d2050f4e5c1a3003$export$c817d0312007ea5e(date, options) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    return +(0, $b6a2419fd0059687$export$eb9a03f0e9aa6cea)(_date, options) === +(0, $e58340063d97ab50$export$a2258d9c4118825c)(_date, options);
}
var // Fallback for modularized imports:
$d2050f4e5c1a3003$export$2e2bcd8739ae039 = $d2050f4e5c1a3003$export$c817d0312007ea5e;


function $4bb5df50b9b59298$export$fc1ed482c2861792(laterDate, earlierDate, options) {
    const [laterDate_, workingLaterDate, earlierDate_] = (0, $002c8181c95d5119$export$9f53b88e82f64d8d)(options?.in, laterDate, laterDate, earlierDate);
    const sign = (0, $e9cff913190bd013$export$fe114145ae75d197)(workingLaterDate, earlierDate_);
    const difference = Math.abs((0, $8aa264ebd3f03841$export$489984ac7c996389)(workingLaterDate, earlierDate_));
    if (difference < 1) return 0;
    if (workingLaterDate.getMonth() === 1 && workingLaterDate.getDate() > 27) workingLaterDate.setDate(30);
    workingLaterDate.setMonth(workingLaterDate.getMonth() - sign * difference);
    let isLastMonthNotFull = (0, $e9cff913190bd013$export$fe114145ae75d197)(workingLaterDate, earlierDate_) === -sign;
    if ((0, $d2050f4e5c1a3003$export$c817d0312007ea5e)(laterDate_) && difference === 1 && (0, $e9cff913190bd013$export$fe114145ae75d197)(laterDate_, earlierDate_) === 1) isLastMonthNotFull = false;
    const result = sign * (difference - +isLastMonthNotFull);
    return result === 0 ? 0 : result;
}
var // Fallback for modularized imports:
$4bb5df50b9b59298$export$2e2bcd8739ae039 = $4bb5df50b9b59298$export$fc1ed482c2861792;



function $03f220a44a4339e3$export$74b5c4055a405552(laterDate, earlierDate, options) {
    const diff = (0, $4bb5df50b9b59298$export$fc1ed482c2861792)(laterDate, earlierDate, options) / 3;
    return (0, $495af4000bb18bf7$export$b6474a47258c1211)(options?.roundingMethod)(diff);
}
var // Fallback for modularized imports:
$03f220a44a4339e3$export$2e2bcd8739ae039 = $03f220a44a4339e3$export$74b5c4055a405552;



function $e9186d0161460806$export$c1889aec51783710(laterDate, earlierDate, options) {
    const diff = (0, $b7913fc338fe28ad$export$7be94d13716b4bf6)(laterDate, earlierDate) / 1000;
    return (0, $495af4000bb18bf7$export$b6474a47258c1211)(options?.roundingMethod)(diff);
}
var // Fallback for modularized imports:
$e9186d0161460806$export$2e2bcd8739ae039 = $e9186d0161460806$export$c1889aec51783710;



function $84f21af906303191$export$b5147a91dc40ddb7(laterDate, earlierDate, options) {
    const diff = (0, $21c2b10d84e6b5ad$export$86415ebf4eb36b8c)(laterDate, earlierDate, options) / 7;
    return (0, $495af4000bb18bf7$export$b6474a47258c1211)(options?.roundingMethod)(diff);
}
var // Fallback for modularized imports:
$84f21af906303191$export$2e2bcd8739ae039 = $84f21af906303191$export$b5147a91dc40ddb7;




function $539ce3f7450453a1$export$c06dce8b38891685(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, $002c8181c95d5119$export$9f53b88e82f64d8d)(options?.in, laterDate, earlierDate);
    return laterDate_.getFullYear() - earlierDate_.getFullYear();
}
var // Fallback for modularized imports:
$539ce3f7450453a1$export$2e2bcd8739ae039 = $539ce3f7450453a1$export$c06dce8b38891685;


function $bf315c5624a2ab0b$export$ed6bf486f68899ca(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, $002c8181c95d5119$export$9f53b88e82f64d8d)(options?.in, laterDate, earlierDate);
    // -1 if the left date is earlier than the right date
    // 2023-12-31 - 2024-01-01 = -1
    const sign = (0, $e9cff913190bd013$export$fe114145ae75d197)(laterDate_, earlierDate_);
    // First calculate the difference in calendar years
    // 2024-01-01 - 2023-12-31 = 1 year
    const diff = Math.abs((0, $539ce3f7450453a1$export$c06dce8b38891685)(laterDate_, earlierDate_));
    // Now we need to calculate if the difference is full. To do that we set
    // both dates to the same year and check if the both date's month and day
    // form a full year.
    laterDate_.setFullYear(1584);
    earlierDate_.setFullYear(1584);
    // For it to be true, when the later date is indeed later than the earlier date
    // (2026-02-01 - 2023-12-10 = 3 years), the difference is full if
    // the normalized later date is also later than the normalized earlier date.
    // In our example, 1584-02-01 is earlier than 1584-12-10, so the difference
    // is partial, hence we need to subtract 1 from the difference 3 - 1 = 2.
    const partial = (0, $e9cff913190bd013$export$fe114145ae75d197)(laterDate_, earlierDate_) === -sign;
    const result = sign * (diff - +partial);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}
var // Fallback for modularized imports:
$bf315c5624a2ab0b$export$2e2bcd8739ae039 = $bf315c5624a2ab0b$export$ed6bf486f68899ca;


function $49e734d34adabd84$export$95ae95d2176c5f0(date, options) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    _date.setMinutes(59, 59, 999);
    return _date;
}
var // Fallback for modularized imports:
$49e734d34adabd84$export$2e2bcd8739ae039 = $49e734d34adabd84$export$95ae95d2176c5f0;


function $9dff17d493896adc$export$a06a772fc63bff07(date, options) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    _date.setSeconds(59, 999);
    return _date;
}
var // Fallback for modularized imports:
$9dff17d493896adc$export$2e2bcd8739ae039 = $9dff17d493896adc$export$a06a772fc63bff07;


function $28fe4daca8fe3005$export$5f53493861eef879(date, options) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    const currentMonth = _date.getMonth();
    const month = currentMonth - currentMonth % 3 + 3;
    _date.setMonth(month, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}
var // Fallback for modularized imports:
$28fe4daca8fe3005$export$2e2bcd8739ae039 = $28fe4daca8fe3005$export$5f53493861eef879;


function $ee0c9831f430316e$export$ef560ab2fa7b52a2(date, options) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    _date.setMilliseconds(999);
    return _date;
}
var // Fallback for modularized imports:
$ee0c9831f430316e$export$2e2bcd8739ae039 = $ee0c9831f430316e$export$ef560ab2fa7b52a2;

let $39440020b58e1ef8$var$defaultOptions = {};
function $39440020b58e1ef8$export$430a3269e24b912e() {
    return $39440020b58e1ef8$var$defaultOptions;
}
function $39440020b58e1ef8$export$95365be1b0704abc(newOptions) {
    $39440020b58e1ef8$var$defaultOptions = newOptions;
}



function $d53308c42f1e4c62$export$ef8b6d9133084f4e(date, options) {
    const defaultOptions = (0, $39440020b58e1ef8$export$430a3269e24b912e)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    _date.setDate(_date.getDate() + diff);
    _date.setHours(23, 59, 59, 999);
    return _date;
}
var // Fallback for modularized imports:
$d53308c42f1e4c62$export$2e2bcd8739ae039 = $d53308c42f1e4c62$export$ef8b6d9133084f4e;


function $6cbfdc6d008595cd$export$8b7aa55c66d5569e(date, options) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    const year = _date.getFullYear();
    _date.setFullYear(year + 1, 0, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}
var // Fallback for modularized imports:
$6cbfdc6d008595cd$export$2e2bcd8739ae039 = $6cbfdc6d008595cd$export$8b7aa55c66d5569e;

const $0bc92389da5ca8f2$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
const $0bc92389da5ca8f2$export$2c14ff85d6318973 = (token, count, options)=>{
    let result;
    const tokenValue = $0bc92389da5ca8f2$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};


function $46af55383084911e$export$38e44e97ce4dbb7d(args) {
    return (options = {})=>{
        // TODO: Remove String()
        const width = options.width ? String(options.width) : args.defaultWidth;
        const format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}


const $63c01f9040a729a9$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
const $63c01f9040a729a9$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $63c01f9040a729a9$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $63c01f9040a729a9$export$cbf60ecb96cbb82f = {
    date: (0, $46af55383084911e$export$38e44e97ce4dbb7d)({
        formats: $63c01f9040a729a9$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $46af55383084911e$export$38e44e97ce4dbb7d)({
        formats: $63c01f9040a729a9$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $46af55383084911e$export$38e44e97ce4dbb7d)({
        formats: $63c01f9040a729a9$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


const $f529b3bee3f6d835$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
const $f529b3bee3f6d835$export$8fbbfd65594f46a0 = (token, _date, _baseDate, _options)=>$f529b3bee3f6d835$var$formatRelativeLocale[token];


/**
 * The localize function argument callback which allows to convert raw value to
 * the actual type.
 *
 * @param value - The value to convert
 *
 * @returns The converted value
 */ /**
 * The map of localized values for each width.
 */ /**
 * The index type of the locale unit value. It types conversion of units of
 * values that don't start at 0 (i.e. quarters).
 */ /**
 * Converts the unit value to the tuple of values.
 */ /**
 * The tuple of localized era values. The first element represents BC,
 * the second element represents AD.
 */ /**
 * The tuple of localized quarter values. The first element represents Q1.
 */ /**
 * The tuple of localized day values. The first element represents Sunday.
 */ /**
 * The tuple of localized month values. The first element represents January.
 */ function $39a1e2b6239b09b3$export$63596d6ee8878b25(args) {
    return (value, options)=>{
        const context = options?.context ? String(options.context) : "standalone";
        let valuesArray;
        if (context === "formatting" && args.formattingValues) {
            const defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            const width = options?.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            const defaultWidth = args.defaultWidth;
            const width = options?.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[width] || args.values[defaultWidth];
        }
        const index = args.argumentCallback ? args.argumentCallback(value) : value;
        // @ts-expect-error - For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}


const $eb9cac2ee97a0b54$var$eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
const $eb9cac2ee97a0b54$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $eb9cac2ee97a0b54$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
const $eb9cac2ee97a0b54$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
const $eb9cac2ee97a0b54$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
const $eb9cac2ee97a0b54$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
const $eb9cac2ee97a0b54$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    const rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
const $eb9cac2ee97a0b54$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $eb9cac2ee97a0b54$var$ordinalNumber,
    era: (0, $39a1e2b6239b09b3$export$63596d6ee8878b25)({
        values: $eb9cac2ee97a0b54$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $39a1e2b6239b09b3$export$63596d6ee8878b25)({
        values: $eb9cac2ee97a0b54$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $39a1e2b6239b09b3$export$63596d6ee8878b25)({
        values: $eb9cac2ee97a0b54$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $39a1e2b6239b09b3$export$63596d6ee8878b25)({
        values: $eb9cac2ee97a0b54$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $39a1e2b6239b09b3$export$63596d6ee8878b25)({
        values: $eb9cac2ee97a0b54$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $eb9cac2ee97a0b54$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


function $e4df69a5a2d494a3$export$1430a0f35710914d(args) {
    return (string, options = {})=>{
        const width = options.width;
        const matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        const matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        const key = Array.isArray(parsePatterns) ? $e4df69a5a2d494a3$var$findIndex(parsePatterns, (pattern)=>pattern.test(matchedString)) : $e4df69a5a2d494a3$var$findKey(parsePatterns, (pattern)=>pattern.test(matchedString));
        let value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $e4df69a5a2d494a3$var$findKey(object, predicate) {
    for(const key in object){
        if (Object.prototype.hasOwnProperty.call(object, key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $e4df69a5a2d494a3$var$findIndex(array, predicate) {
    for(let key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}


function $2594a2c0202dabc6$export$fdaf2fd6d7edde95(args) {
    return (string, options = {})=>{
        const matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        let value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        // [TODO] I challenge you to fix the type
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}


const $d2fa28259adb3ab1$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const $d2fa28259adb3ab1$var$parseOrdinalNumberPattern = /\d+/i;
const $d2fa28259adb3ab1$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
const $d2fa28259adb3ab1$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
const $d2fa28259adb3ab1$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
const $d2fa28259adb3ab1$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $d2fa28259adb3ab1$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
const $d2fa28259adb3ab1$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $d2fa28259adb3ab1$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
const $d2fa28259adb3ab1$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
const $d2fa28259adb3ab1$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
const $d2fa28259adb3ab1$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
const $d2fa28259adb3ab1$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $2594a2c0202dabc6$export$fdaf2fd6d7edde95)({
        matchPattern: $d2fa28259adb3ab1$var$matchOrdinalNumberPattern,
        parsePattern: $d2fa28259adb3ab1$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $e4df69a5a2d494a3$export$1430a0f35710914d)({
        matchPatterns: $d2fa28259adb3ab1$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d2fa28259adb3ab1$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $e4df69a5a2d494a3$export$1430a0f35710914d)({
        matchPatterns: $d2fa28259adb3ab1$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d2fa28259adb3ab1$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $e4df69a5a2d494a3$export$1430a0f35710914d)({
        matchPatterns: $d2fa28259adb3ab1$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d2fa28259adb3ab1$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $e4df69a5a2d494a3$export$1430a0f35710914d)({
        matchPatterns: $d2fa28259adb3ab1$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d2fa28259adb3ab1$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $e4df69a5a2d494a3$export$1430a0f35710914d)({
        matchPatterns: $d2fa28259adb3ab1$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $d2fa28259adb3ab1$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


const $cd0c27002eb93234$export$137380d9ce54f7f = {
    code: "en-US",
    formatDistance: (0, $0bc92389da5ca8f2$export$2c14ff85d6318973),
    formatLong: (0, $63c01f9040a729a9$export$cbf60ecb96cbb82f),
    formatRelative: (0, $f529b3bee3f6d835$export$8fbbfd65594f46a0),
    localize: (0, $eb9cac2ee97a0b54$export$b3bd0bc58e36cd63),
    match: (0, $d2fa28259adb3ab1$export$4659b591c19bdf3d),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var // Fallback for modularized imports:
$cd0c27002eb93234$export$2e2bcd8739ae039 = $cd0c27002eb93234$export$137380d9ce54f7f;





function $29cc086f79701cd9$export$f91e89d3d0406102(date, options) {
    const date_ = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    date_.setFullYear(date_.getFullYear(), 0, 1);
    date_.setHours(0, 0, 0, 0);
    return date_;
}
var // Fallback for modularized imports:
$29cc086f79701cd9$export$2e2bcd8739ae039 = $29cc086f79701cd9$export$f91e89d3d0406102;



function $306b88ce50904f9c$export$d3b42cd8452deec(date, options) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    const diff = (0, $737f54e9ffaddc15$export$4a02e9c37dab4871)(_date, (0, $29cc086f79701cd9$export$f91e89d3d0406102)(_date));
    const dayOfYear = diff + 1;
    return dayOfYear;
}
var // Fallback for modularized imports:
$306b88ce50904f9c$export$2e2bcd8739ae039 = $306b88ce50904f9c$export$d3b42cd8452deec;





function $61f11f7a26b3ab78$export$42c81a444fbfb5d4(date, options) {
    const defaultOptions = (0, $39440020b58e1ef8$export$430a3269e24b912e)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    _date.setDate(_date.getDate() - diff);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$61f11f7a26b3ab78$export$2e2bcd8739ae039 = $61f11f7a26b3ab78$export$42c81a444fbfb5d4;


function $1c9d32c6cb108460$export$6173213f95a4431e(date, options) {
    return (0, $61f11f7a26b3ab78$export$42c81a444fbfb5d4)(date, {
        ...options,
        weekStartsOn: 1
    });
}
var // Fallback for modularized imports:
$1c9d32c6cb108460$export$2e2bcd8739ae039 = $1c9d32c6cb108460$export$6173213f95a4431e;






function $c95dff76bf2f692a$export$3dbc52535f6f8fcc(date, options) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    const year = _date.getFullYear();
    const fourthOfJanuaryOfNextYear = (0, $abb9adbdb26342b3$export$ead8a1812b171991)(_date, 0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $1c9d32c6cb108460$export$6173213f95a4431e)(fourthOfJanuaryOfNextYear);
    const fourthOfJanuaryOfThisYear = (0, $abb9adbdb26342b3$export$ead8a1812b171991)(_date, 0);
    fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $1c9d32c6cb108460$export$6173213f95a4431e)(fourthOfJanuaryOfThisYear);
    if (_date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (_date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
var // Fallback for modularized imports:
$c95dff76bf2f692a$export$2e2bcd8739ae039 = $c95dff76bf2f692a$export$3dbc52535f6f8fcc;



function $3b2e6199275b27d6$export$236bdfa374eb69a9(date, options) {
    const year = (0, $c95dff76bf2f692a$export$3dbc52535f6f8fcc)(date, options);
    const fourthOfJanuary = (0, $abb9adbdb26342b3$export$ead8a1812b171991)(options?.in || date, 0);
    fourthOfJanuary.setFullYear(year, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    return (0, $1c9d32c6cb108460$export$6173213f95a4431e)(fourthOfJanuary);
}
var // Fallback for modularized imports:
$3b2e6199275b27d6$export$2e2bcd8739ae039 = $3b2e6199275b27d6$export$236bdfa374eb69a9;



function $83e11b0db4cec366$export$7cabdc5698b63e2f(date, options) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    const diff = +(0, $1c9d32c6cb108460$export$6173213f95a4431e)(_date) - +(0, $3b2e6199275b27d6$export$236bdfa374eb69a9)(_date);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / (0, $8540a44f59a4af84$export$4fad13613e88edc8)) + 1;
}
var // Fallback for modularized imports:
$83e11b0db4cec366$export$2e2bcd8739ae039 = $83e11b0db4cec366$export$7cabdc5698b63e2f;











function $0170e230c8468ebb$export$12d572480ceb6e58(date, options) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    const year = _date.getFullYear();
    const defaultOptions = (0, $39440020b58e1ef8$export$430a3269e24b912e)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const firstWeekOfNextYear = (0, $abb9adbdb26342b3$export$ead8a1812b171991)(options?.in || date, 0);
    firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $61f11f7a26b3ab78$export$42c81a444fbfb5d4)(firstWeekOfNextYear, options);
    const firstWeekOfThisYear = (0, $abb9adbdb26342b3$export$ead8a1812b171991)(options?.in || date, 0);
    firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $61f11f7a26b3ab78$export$42c81a444fbfb5d4)(firstWeekOfThisYear, options);
    if (+_date >= +startOfNextYear) return year + 1;
    else if (+_date >= +startOfThisYear) return year;
    else return year - 1;
}
var // Fallback for modularized imports:
$0170e230c8468ebb$export$2e2bcd8739ae039 = $0170e230c8468ebb$export$12d572480ceb6e58;



function $ac7640a7ade5a435$export$bb7b45bb8e74da0f(date, options) {
    const defaultOptions = (0, $39440020b58e1ef8$export$430a3269e24b912e)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const year = (0, $0170e230c8468ebb$export$12d572480ceb6e58)(date, options);
    const firstWeek = (0, $abb9adbdb26342b3$export$ead8a1812b171991)(options?.in || date, 0);
    firstWeek.setFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setHours(0, 0, 0, 0);
    const _date = (0, $61f11f7a26b3ab78$export$42c81a444fbfb5d4)(firstWeek, options);
    return _date;
}
var // Fallback for modularized imports:
$ac7640a7ade5a435$export$2e2bcd8739ae039 = $ac7640a7ade5a435$export$bb7b45bb8e74da0f;



function $11b38d723fd57381$export$efe19b760242b2fc(date, options) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    const diff = +(0, $61f11f7a26b3ab78$export$42c81a444fbfb5d4)(_date, options) - +(0, $ac7640a7ade5a435$export$bb7b45bb8e74da0f)(_date, options);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / (0, $8540a44f59a4af84$export$4fad13613e88edc8)) + 1;
}
var // Fallback for modularized imports:
$11b38d723fd57381$export$2e2bcd8739ae039 = $11b38d723fd57381$export$efe19b760242b2fc;



function $03d75ed55eeb99fa$export$c8306e720e213c0f(number, targetLength) {
    const sign = number < 0 ? "-" : "";
    const output = Math.abs(number).toString().padStart(targetLength, "0");
    return sign + output;
}



const $71a5e81f1193b7a8$export$b0d4b338e1516f13 = {
    // Year
    y (date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        const signedYear = date.getFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M (date, token) {
        const month = date.getMonth();
        return token === "M" ? String(month + 1) : (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(month + 1, 2);
    },
    // Day of the month
    d (date, token) {
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(date.getDate(), token.length);
    },
    // AM or PM
    a (date, token) {
        const dayPeriodEnumValue = date.getHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h (date, token) {
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(date.getHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H (date, token) {
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(date.getHours(), token.length);
    },
    // Minute
    m (date, token) {
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(date.getMinutes(), token.length);
    },
    // Second
    s (date, token) {
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(date.getSeconds(), token.length);
    },
    // Fraction of second
    S (date, token) {
        const numberOfDigits = token.length;
        const milliseconds = date.getMilliseconds();
        const fractionalSeconds = Math.trunc(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(fractionalSeconds, token.length);
    }
};


const $008fe800ab658844$var$dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
const $008fe800ab658844$export$fe98a034cfb96d55 = {
    // Era
    G: function(date, token, localize) {
        const era = date.getFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            const signedYear = date.getFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            const year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return (0, $71a5e81f1193b7a8$export$b0d4b338e1516f13).y(date, token);
    },
    // Local week-numbering year
    Y: function(date, token, localize, options) {
        const signedWeekYear = (0, $0170e230c8468ebb$export$12d572480ceb6e58)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            const twoDigitYear = weekYear % 100;
            return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function(date, token) {
        const isoWeekYear = (0, $c95dff76bf2f692a$export$3dbc52535f6f8fcc)(date);
        // Padding
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function(date, token) {
        const year = date.getFullYear();
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(year, token.length);
    },
    // Quarter
    Q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            case "M":
            case "MM":
                return (0, $71a5e81f1193b7a8$export$b0d4b338e1516f13).M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function(date, token, localize, options) {
        const week = (0, $11b38d723fd57381$export$efe19b760242b2fc)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(week, token.length);
    },
    // ISO week of year
    I: function(date, token, localize) {
        const isoWeek = (0, $83e11b0db4cec366$export$7cabdc5698b63e2f)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(isoWeek, token.length);
    },
    // Day of the month
    d: function(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getDate(), {
            unit: "date"
        });
        return (0, $71a5e81f1193b7a8$export$b0d4b338e1516f13).d(date, token);
    },
    // Day of year
    D: function(date, token, localize) {
        const dayOfYear = (0, $306b88ce50904f9c$export$d3b42cd8452deec)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(dayOfYear, token.length);
    },
    // Day of week
    E: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        const isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function(date, token, localize) {
        const hours = date.getHours();
        const dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $008fe800ab658844$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $008fe800ab658844$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $008fe800ab658844$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $008fe800ab658844$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $008fe800ab658844$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $008fe800ab658844$var$dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function(date, token, localize) {
        if (token === "ho") {
            let hours = date.getHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return (0, $71a5e81f1193b7a8$export$b0d4b338e1516f13).h(date, token);
    },
    // Hour [0-23]
    H: function(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getHours(), {
            unit: "hour"
        });
        return (0, $71a5e81f1193b7a8$export$b0d4b338e1516f13).H(date, token);
    },
    // Hour [0-11]
    K: function(date, token, localize) {
        const hours = date.getHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(hours, token.length);
    },
    // Hour [1-24]
    k: function(date, token, localize) {
        let hours = date.getHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(hours, token.length);
    },
    // Minute
    m: function(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getMinutes(), {
            unit: "minute"
        });
        return (0, $71a5e81f1193b7a8$export$b0d4b338e1516f13).m(date, token);
    },
    // Second
    s: function(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getSeconds(), {
            unit: "second"
        });
        return (0, $71a5e81f1193b7a8$export$b0d4b338e1516f13).s(date, token);
    },
    // Fraction of second
    S: function(date, token) {
        return (0, $71a5e81f1193b7a8$export$b0d4b338e1516f13).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return $008fe800ab658844$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                return $008fe800ab658844$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return $008fe800ab658844$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return $008fe800ab658844$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                return $008fe800ab658844$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return $008fe800ab658844$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + $008fe800ab658844$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + $008fe800ab658844$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + $008fe800ab658844$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + $008fe800ab658844$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function(date, token, _localize) {
        const timestamp = Math.trunc(+date / 1000);
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function(date, token, _localize) {
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(+date, token.length);
    }
};
function $008fe800ab658844$var$formatTimezoneShort(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = Math.trunc(absOffset / 60);
    const minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    return sign + String(hours) + delimiter + (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(minutes, 2);
}
function $008fe800ab658844$var$formatTimezoneWithOptionalMinutes(offset, delimiter) {
    if (offset % 60 === 0) {
        const sign = offset > 0 ? "-" : "+";
        return sign + (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(Math.abs(offset) / 60, 2);
    }
    return $008fe800ab658844$var$formatTimezone(offset, delimiter);
}
function $008fe800ab658844$var$formatTimezone(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(Math.trunc(absOffset / 60), 2);
    const minutes = (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}


const $54cd66db3e5e74df$var$dateLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
const $54cd66db3e5e74df$var$timeLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
const $54cd66db3e5e74df$var$dateTimeLongFormatter = (pattern, formatLong)=>{
    const matchResult = pattern.match(/(P+)(p+)?/) || [];
    const datePattern = matchResult[1];
    const timePattern = matchResult[2];
    if (!timePattern) return $54cd66db3e5e74df$var$dateLongFormatter(pattern, formatLong);
    let dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", $54cd66db3e5e74df$var$dateLongFormatter(datePattern, formatLong)).replace("{{time}}", $54cd66db3e5e74df$var$timeLongFormatter(timePattern, formatLong));
};
const $54cd66db3e5e74df$export$70cc8fd02856fd58 = {
    p: $54cd66db3e5e74df$var$timeLongFormatter,
    P: $54cd66db3e5e74df$var$dateTimeLongFormatter
};


const $7e8a5b0b77bf77b9$var$dayOfYearTokenRE = /^D+$/;
const $7e8a5b0b77bf77b9$var$weekYearTokenRE = /^Y+$/;
const $7e8a5b0b77bf77b9$var$throwTokens = [
    "D",
    "DD",
    "YY",
    "YYYY"
];
function $7e8a5b0b77bf77b9$export$c6cc36aa33304772(token) {
    return $7e8a5b0b77bf77b9$var$dayOfYearTokenRE.test(token);
}
function $7e8a5b0b77bf77b9$export$c6b49d6dceb604a1(token) {
    return $7e8a5b0b77bf77b9$var$weekYearTokenRE.test(token);
}
function $7e8a5b0b77bf77b9$export$f5f38f90ecaaf879(token, format, input) {
    const _message = $7e8a5b0b77bf77b9$var$message(token, format, input);
    console.warn(_message);
    if ($7e8a5b0b77bf77b9$var$throwTokens.includes(token)) throw new RangeError(_message);
}
function $7e8a5b0b77bf77b9$var$message(token, format, input) {
    const subject = token[0] === "Y" ? "years" : "days of the month";
    return `Use \`${token.toLowerCase()}\` instead of \`${token}\` (in \`${format}\`) for formatting ${subject} to the input \`${input}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}


/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param value - The value to check
 *
 * @returns True if the given value is a date
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */ function $1896b5e28554d57b$export$871608497c498473(value) {
    return value instanceof Date || typeof value === "object" && Object.prototype.toString.call(value) === "[object Date]";
}
var // Fallback for modularized imports:
$1896b5e28554d57b$export$2e2bcd8739ae039 = $1896b5e28554d57b$export$871608497c498473;



function $f2a682b251363bc2$export$1ea939691cdc45b8(date) {
    return !(!(0, $1896b5e28554d57b$export$871608497c498473)(date) && typeof date !== "number" || isNaN(+(0, $231bfb8d72679740$export$e67a095c620b86fe)(date)));
}
var // Fallback for modularized imports:
$f2a682b251363bc2$export$2e2bcd8739ae039 = $f2a682b251363bc2$export$1ea939691cdc45b8;



// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const $303ba10db2c74ab4$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const $303ba10db2c74ab4$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const $303ba10db2c74ab4$var$escapedStringRegExp = /^'([^]*?)'?$/;
const $303ba10db2c74ab4$var$doubleQuoteRegExp = /''/g;
const $303ba10db2c74ab4$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $303ba10db2c74ab4$export$d9468344d3651243(date, formatStr, options) {
    const defaultOptions = (0, $39440020b58e1ef8$export$430a3269e24b912e)();
    const locale = options?.locale ?? defaultOptions.locale ?? (0, $cd0c27002eb93234$export$137380d9ce54f7f);
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const originalDate = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    if (!(0, $f2a682b251363bc2$export$1ea939691cdc45b8)(originalDate)) throw new RangeError("Invalid time value");
    let parts = formatStr.match($303ba10db2c74ab4$var$longFormattingTokensRegExp).map((substring)=>{
        const firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            const longFormatter = (0, $54cd66db3e5e74df$export$70cc8fd02856fd58)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($303ba10db2c74ab4$var$formattingTokensRegExp).map((substring)=>{
        // Replace two single quote characters with one single quote character
        if (substring === "''") return {
            isToken: false,
            value: "'"
        };
        const firstCharacter = substring[0];
        if (firstCharacter === "'") return {
            isToken: false,
            value: $303ba10db2c74ab4$var$cleanEscapedString(substring)
        };
        if ((0, $008fe800ab658844$export$fe98a034cfb96d55)[firstCharacter]) return {
            isToken: true,
            value: substring
        };
        if (firstCharacter.match($303ba10db2c74ab4$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return {
            isToken: false,
            value: substring
        };
    });
    // invoke localize preprocessor (only for french locales at the moment)
    if (locale.localize.preprocessor) parts = locale.localize.preprocessor(originalDate, parts);
    const formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    return parts.map((part)=>{
        if (!part.isToken) return part.value;
        const token = part.value;
        if (!options?.useAdditionalWeekYearTokens && (0, $7e8a5b0b77bf77b9$export$c6b49d6dceb604a1)(token) || !options?.useAdditionalDayOfYearTokens && (0, $7e8a5b0b77bf77b9$export$c6cc36aa33304772)(token)) (0, $7e8a5b0b77bf77b9$export$f5f38f90ecaaf879)(token, formatStr, String(date));
        const formatter = (0, $008fe800ab658844$export$fe98a034cfb96d55)[token[0]];
        return formatter(originalDate, token, locale.localize, formatterOptions);
    }).join("");
}
function $303ba10db2c74ab4$var$cleanEscapedString(input) {
    const matched = input.match($303ba10db2c74ab4$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($303ba10db2c74ab4$var$doubleQuoteRegExp, "'");
}
var // Fallback for modularized imports:
$303ba10db2c74ab4$export$2e2bcd8739ae039 = $303ba10db2c74ab4$export$d9468344d3651243;






function $f3e2f0f906df8397$export$430a3269e24b912e() {
    return Object.assign({}, (0, $39440020b58e1ef8$export$430a3269e24b912e)());
}
var // Fallback for modularized imports:
$f3e2f0f906df8397$export$2e2bcd8739ae039 = $f3e2f0f906df8397$export$430a3269e24b912e;





function $59425df5ba0b4bea$export$9cb09a71b7d66923(date, constructor) {
    const date_ = $59425df5ba0b4bea$var$isConstructor(constructor) ? new constructor(0) : (0, $abb9adbdb26342b3$export$ead8a1812b171991)(constructor, 0);
    date_.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
    date_.setHours(date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
    return date_;
}
function $59425df5ba0b4bea$var$isConstructor(constructor) {
    return typeof constructor === "function" && constructor.prototype?.constructor === constructor;
}
var // Fallback for modularized imports:
$59425df5ba0b4bea$export$2e2bcd8739ae039 = $59425df5ba0b4bea$export$9cb09a71b7d66923;


const $2c074b7ab8cd2d6d$var$TIMEZONE_UNIT_PRIORITY = 10;
class $2c074b7ab8cd2d6d$export$81d53e3678089a6 {
    subPriority = 0;
    validate(_utcDate, _options) {
        return true;
    }
}
class $2c074b7ab8cd2d6d$export$9a09e32dd4990fd5 extends $2c074b7ab8cd2d6d$export$81d53e3678089a6 {
    constructor(value, validateValue, setValue, priority, subPriority){
        super();
        this.value = value;
        this.validateValue = validateValue;
        this.setValue = setValue;
        this.priority = priority;
        if (subPriority) this.subPriority = subPriority;
    }
    validate(date, options) {
        return this.validateValue(date, this.value, options);
    }
    set(date, flags, options) {
        return this.setValue(date, flags, this.value, options);
    }
}
class $2c074b7ab8cd2d6d$export$8be15fe85ad72f86 extends $2c074b7ab8cd2d6d$export$81d53e3678089a6 {
    priority = $2c074b7ab8cd2d6d$var$TIMEZONE_UNIT_PRIORITY;
    subPriority = -1;
    constructor(context, reference){
        super();
        this.context = context || ((date)=>(0, $abb9adbdb26342b3$export$ead8a1812b171991)(reference, date));
    }
    set(date, flags) {
        if (flags.timestampIsSet) return date;
        return (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, (0, $59425df5ba0b4bea$export$9cb09a71b7d66923)(date, this.context));
    }
}



class $bc2b96d39fc4c3d8$export$7acfa6ed01010e37 {
    run(dateString, token, match, options) {
        const result = this.parse(dateString, token, match, options);
        if (!result) return null;
        return {
            setter: new (0, $2c074b7ab8cd2d6d$export$9a09e32dd4990fd5)(result.value, this.validate, this.set, this.priority, this.subPriority),
            rest: result.rest
        };
    }
    validate(_utcDate, _value, _options) {
        return true;
    }
}


class $db0c34f9a22bf78d$export$8e5a1d3f85a9688 extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 140;
    parse(dateString, token, match) {
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return match.era(dateString, {
                    width: "abbreviated"
                }) || match.era(dateString, {
                    width: "narrow"
                });
            // A, B
            case "GGGGG":
                return match.era(dateString, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return match.era(dateString, {
                    width: "wide"
                }) || match.era(dateString, {
                    width: "abbreviated"
                }) || match.era(dateString, {
                    width: "narrow"
                });
        }
    }
    set(date, flags, value) {
        flags.era = value;
        date.setFullYear(value, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "R",
        "u",
        "t",
        "T"
    ];
}




const $90ea69bf2b625c49$export$c123ee06d9da8480 = {
    month: /^(1[0-2]|0?\d)/,
    date: /^(3[0-1]|[0-2]?\d)/,
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    week: /^(5[0-3]|[0-4]?\d)/,
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    hour11h: /^(1[0-1]|0?\d)/,
    hour12h: /^(1[0-2]|0?\d)/,
    minute: /^[0-5]?\d/,
    second: /^[0-5]?\d/,
    singleDigit: /^\d/,
    twoDigits: /^\d{1,2}/,
    threeDigits: /^\d{1,3}/,
    fourDigits: /^\d{1,4}/,
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    twoDigitsSigned: /^-?\d{1,2}/,
    threeDigitsSigned: /^-?\d{1,3}/,
    fourDigitsSigned: /^-?\d{1,4}/
};
const $90ea69bf2b625c49$export$a7ee192b982af9c1 = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};


function $7caea2161b2082cf$export$4f84e3a82c7b538(parseFnResult, mapFn) {
    if (!parseFnResult) return parseFnResult;
    return {
        value: mapFn(parseFnResult.value),
        rest: parseFnResult.rest
    };
}
function $7caea2161b2082cf$export$cc7cc9e2a3ff9388(pattern, dateString) {
    const matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    return {
        value: parseInt(matchResult[0], 10),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $7caea2161b2082cf$export$6497f4c0ecdfba8e(pattern, dateString) {
    const matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    // Input is 'Z'
    if (matchResult[0] === "Z") return {
        value: 0,
        rest: dateString.slice(1)
    };
    const sign = matchResult[1] === "+" ? 1 : -1;
    const hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    const minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    const seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * (0, $8540a44f59a4af84$export$7f72910d6dfd237a) + minutes * (0, $8540a44f59a4af84$export$91246f0b9bd9beff) + seconds * (0, $8540a44f59a4af84$export$397c2d5776aa9055)),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $7caea2161b2082cf$export$d931c43c4608a164(dateString) {
    return $7caea2161b2082cf$export$cc7cc9e2a3ff9388((0, $90ea69bf2b625c49$export$c123ee06d9da8480).anyDigitsSigned, dateString);
}
function $7caea2161b2082cf$export$513bb01536146ab6(n, dateString) {
    switch(n){
        case 1:
            return $7caea2161b2082cf$export$cc7cc9e2a3ff9388((0, $90ea69bf2b625c49$export$c123ee06d9da8480).singleDigit, dateString);
        case 2:
            return $7caea2161b2082cf$export$cc7cc9e2a3ff9388((0, $90ea69bf2b625c49$export$c123ee06d9da8480).twoDigits, dateString);
        case 3:
            return $7caea2161b2082cf$export$cc7cc9e2a3ff9388((0, $90ea69bf2b625c49$export$c123ee06d9da8480).threeDigits, dateString);
        case 4:
            return $7caea2161b2082cf$export$cc7cc9e2a3ff9388((0, $90ea69bf2b625c49$export$c123ee06d9da8480).fourDigits, dateString);
        default:
            return $7caea2161b2082cf$export$cc7cc9e2a3ff9388(new RegExp("^\\d{1," + n + "}"), dateString);
    }
}
function $7caea2161b2082cf$export$2c9307b2e29c533c(n, dateString) {
    switch(n){
        case 1:
            return $7caea2161b2082cf$export$cc7cc9e2a3ff9388((0, $90ea69bf2b625c49$export$c123ee06d9da8480).singleDigitSigned, dateString);
        case 2:
            return $7caea2161b2082cf$export$cc7cc9e2a3ff9388((0, $90ea69bf2b625c49$export$c123ee06d9da8480).twoDigitsSigned, dateString);
        case 3:
            return $7caea2161b2082cf$export$cc7cc9e2a3ff9388((0, $90ea69bf2b625c49$export$c123ee06d9da8480).threeDigitsSigned, dateString);
        case 4:
            return $7caea2161b2082cf$export$cc7cc9e2a3ff9388((0, $90ea69bf2b625c49$export$c123ee06d9da8480).fourDigitsSigned, dateString);
        default:
            return $7caea2161b2082cf$export$cc7cc9e2a3ff9388(new RegExp("^-?\\d{1," + n + "}"), dateString);
    }
}
function $7caea2161b2082cf$export$fb506d2676e7f207(dayPeriod) {
    switch(dayPeriod){
        case "morning":
            return 4;
        case "evening":
            return 17;
        case "pm":
        case "noon":
        case "afternoon":
            return 12;
        case "am":
        case "midnight":
        case "night":
        default:
            return 0;
    }
}
function $7caea2161b2082cf$export$29126f735cbf69f7(twoDigitYear, currentYear) {
    const isCommonEra = currentYear > 0;
    // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    const absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    let result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        const rangeEnd = absCurrentYear + 50;
        const rangeEndCentury = Math.trunc(rangeEnd / 100) * 100;
        const isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
function $7caea2161b2082cf$export$3d50627710b84d75(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}


class $66195bae0f19f15a$export$48d352de7cd4a988 extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 130;
    incompatibleTokens = [
        "Y",
        "R",
        "u",
        "w",
        "I",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
    parse(dateString, token, match) {
        const valueCallback = (year)=>({
                year: year,
                isTwoDigitYear: token === "yy"
            });
        switch(token){
            case "y":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)((0, $7caea2161b2082cf$export$513bb01536146ab6)(4, dateString), valueCallback);
            case "yo":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "year"
                }), valueCallback);
            default:
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)((0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString), valueCallback);
        }
    }
    validate(_date, value) {
        return value.isTwoDigitYear || value.year > 0;
    }
    set(date, flags, value) {
        const currentYear = date.getFullYear();
        if (value.isTwoDigitYear) {
            const normalizedTwoDigitYear = (0, $7caea2161b2082cf$export$29126f735cbf69f7)(value.year, currentYear);
            date.setFullYear(normalizedTwoDigitYear, 0, 1);
            date.setHours(0, 0, 0, 0);
            return date;
        }
        const year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
        date.setFullYear(year, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
}






class $9fda39b31cab7345$export$b8ef38dfcf05d5db extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 130;
    parse(dateString, token, match) {
        const valueCallback = (year)=>({
                year: year,
                isTwoDigitYear: token === "YY"
            });
        switch(token){
            case "Y":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)((0, $7caea2161b2082cf$export$513bb01536146ab6)(4, dateString), valueCallback);
            case "Yo":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "year"
                }), valueCallback);
            default:
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)((0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString), valueCallback);
        }
    }
    validate(_date, value) {
        return value.isTwoDigitYear || value.year > 0;
    }
    set(date, flags, value, options) {
        const currentYear = (0, $0170e230c8468ebb$export$12d572480ceb6e58)(date, options);
        if (value.isTwoDigitYear) {
            const normalizedTwoDigitYear = (0, $7caea2161b2082cf$export$29126f735cbf69f7)(value.year, currentYear);
            date.setFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
            date.setHours(0, 0, 0, 0);
            return (0, $61f11f7a26b3ab78$export$42c81a444fbfb5d4)(date, options);
        }
        const year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
        date.setFullYear(year, 0, options.firstWeekContainsDate);
        date.setHours(0, 0, 0, 0);
        return (0, $61f11f7a26b3ab78$export$42c81a444fbfb5d4)(date, options);
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "Q",
        "q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "i",
        "t",
        "T"
    ];
}






class $1a189db5f2a1065c$export$951d1df011fde06f extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 130;
    parse(dateString, token) {
        if (token === "R") return (0, $7caea2161b2082cf$export$2c9307b2e29c533c)(4, dateString);
        return (0, $7caea2161b2082cf$export$2c9307b2e29c533c)(token.length, dateString);
    }
    set(date, _flags, value) {
        const firstWeekOfYear = (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, 0);
        firstWeekOfYear.setFullYear(value, 0, 4);
        firstWeekOfYear.setHours(0, 0, 0, 0);
        return (0, $1c9d32c6cb108460$export$6173213f95a4431e)(firstWeekOfYear);
    }
    incompatibleTokens = [
        "G",
        "y",
        "Y",
        "u",
        "Q",
        "q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "e",
        "c",
        "t",
        "T"
    ];
}




class $c3854b7a937037cd$export$bad9d2ea38e8f1a extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 130;
    parse(dateString, token) {
        if (token === "u") return (0, $7caea2161b2082cf$export$2c9307b2e29c533c)(4, dateString);
        return (0, $7caea2161b2082cf$export$2c9307b2e29c533c)(token.length, dateString);
    }
    set(date, _flags, value) {
        date.setFullYear(value, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "G",
        "y",
        "Y",
        "R",
        "w",
        "I",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}




class $d1988bf983127f3e$export$5cb0f701186dde1d extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 120;
    parse(dateString, token, match) {
        switch(token){
            // 1, 2, 3, 4
            case "Q":
            case "QQ":
                return (0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return match.ordinalNumber(dateString, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return match.quarter(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return match.quarter(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 4;
    }
    set(date, _flags, value) {
        date.setMonth((value - 1) * 3, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}




class $62b79555ac1f33b0$export$300c0c2990e20e6d extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 120;
    parse(dateString, token, match) {
        switch(token){
            // 1, 2, 3, 4
            case "q":
            case "qq":
                return (0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return match.ordinalNumber(dateString, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return match.quarter(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return match.quarter(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 4;
    }
    set(date, _flags, value) {
        date.setMonth((value - 1) * 3, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "Q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}





class $44a198f4e488a239$export$400dd8b40ef138a3 extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "L",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
    priority = 110;
    parse(dateString, token, match) {
        const valueCallback = (value)=>value - 1;
        switch(token){
            // 1, 2, ..., 12
            case "M":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)((0, $7caea2161b2082cf$export$cc7cc9e2a3ff9388)((0, $90ea69bf2b625c49$export$c123ee06d9da8480).month, dateString), valueCallback);
            // 01, 02, ..., 12
            case "MM":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)((0, $7caea2161b2082cf$export$513bb01536146ab6)(2, dateString), valueCallback);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "month"
                }), valueCallback);
            // Jan, Feb, ..., Dec
            case "MMM":
                return match.month(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return match.month(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        date.setMonth(value, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
}





class $f7643ab884280f91$export$1d7eaa53eaa5deba extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 110;
    parse(dateString, token, match) {
        const valueCallback = (value)=>value - 1;
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)((0, $7caea2161b2082cf$export$cc7cc9e2a3ff9388)((0, $90ea69bf2b625c49$export$c123ee06d9da8480).month, dateString), valueCallback);
            // 01, 02, ..., 12
            case "LL":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)((0, $7caea2161b2082cf$export$513bb01536146ab6)(2, dateString), valueCallback);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "month"
                }), valueCallback);
            // Jan, Feb, ..., Dec
            case "LLL":
                return match.month(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return match.month(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        date.setMonth(value, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "M",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}




function $66c7729eb95aa501$export$4b3066ce4afafd88(date, week, options) {
    const date_ = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    const diff = (0, $11b38d723fd57381$export$efe19b760242b2fc)(date_, options) - week;
    date_.setDate(date_.getDate() - diff * 7);
    return (0, $231bfb8d72679740$export$e67a095c620b86fe)(date_, options?.in);
}
var // Fallback for modularized imports:
$66c7729eb95aa501$export$2e2bcd8739ae039 = $66c7729eb95aa501$export$4b3066ce4afafd88;






class $0da9b6c0b13ee7fd$export$c4005ffc174e07c0 extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 100;
    parse(dateString, token, match) {
        switch(token){
            case "w":
                return (0, $7caea2161b2082cf$export$cc7cc9e2a3ff9388)((0, $90ea69bf2b625c49$export$c123ee06d9da8480).week, dateString);
            case "wo":
                return match.ordinalNumber(dateString, {
                    unit: "week"
                });
            default:
                return (0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 53;
    }
    set(date, _flags, value, options) {
        return (0, $61f11f7a26b3ab78$export$42c81a444fbfb5d4)((0, $66c7729eb95aa501$export$4b3066ce4afafd88)(date, value, options), options);
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "i",
        "t",
        "T"
    ];
}




function $d0815b4ed45bc80a$export$6542bebf6be94082(date, week, options) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    const diff = (0, $83e11b0db4cec366$export$7cabdc5698b63e2f)(_date, options) - week;
    _date.setDate(_date.getDate() - diff * 7);
    return _date;
}
var // Fallback for modularized imports:
$d0815b4ed45bc80a$export$2e2bcd8739ae039 = $d0815b4ed45bc80a$export$6542bebf6be94082;






class $6803ee1ef2b46eaa$export$6fc8dbedd560a6af extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 100;
    parse(dateString, token, match) {
        switch(token){
            case "I":
                return (0, $7caea2161b2082cf$export$cc7cc9e2a3ff9388)((0, $90ea69bf2b625c49$export$c123ee06d9da8480).week, dateString);
            case "Io":
                return match.ordinalNumber(dateString, {
                    unit: "week"
                });
            default:
                return (0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 53;
    }
    set(date, _flags, value) {
        return (0, $1c9d32c6cb108460$export$6173213f95a4431e)((0, $d0815b4ed45bc80a$export$6542bebf6be94082)(date, value));
    }
    incompatibleTokens = [
        "y",
        "Y",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "e",
        "c",
        "t",
        "T"
    ];
}





const $e06f3f7fc9153746$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
const $e06f3f7fc9153746$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
class $e06f3f7fc9153746$export$e8d4b28a20981dd2 extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 90;
    subPriority = 1;
    parse(dateString, token, match) {
        switch(token){
            case "d":
                return (0, $7caea2161b2082cf$export$cc7cc9e2a3ff9388)((0, $90ea69bf2b625c49$export$c123ee06d9da8480).date, dateString);
            case "do":
                return match.ordinalNumber(dateString, {
                    unit: "date"
                });
            default:
                return (0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(date, value) {
        const year = date.getFullYear();
        const isLeapYear = (0, $7caea2161b2082cf$export$3d50627710b84d75)(year);
        const month = date.getMonth();
        if (isLeapYear) return value >= 1 && value <= $e06f3f7fc9153746$var$DAYS_IN_MONTH_LEAP_YEAR[month];
        else return value >= 1 && value <= $e06f3f7fc9153746$var$DAYS_IN_MONTH[month];
    }
    set(date, _flags, value) {
        date.setDate(value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}





class $6b2b75646543924f$export$6cfe0d613455f615 extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 90;
    subpriority = 1;
    parse(dateString, token, match) {
        switch(token){
            case "D":
            case "DD":
                return (0, $7caea2161b2082cf$export$cc7cc9e2a3ff9388)((0, $90ea69bf2b625c49$export$c123ee06d9da8480).dayOfYear, dateString);
            case "Do":
                return match.ordinalNumber(dateString, {
                    unit: "date"
                });
            default:
                return (0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(date, value) {
        const year = date.getFullYear();
        const isLeapYear = (0, $7caea2161b2082cf$export$3d50627710b84d75)(year);
        if (isLeapYear) return value >= 1 && value <= 366;
        else return value >= 1 && value <= 365;
    }
    set(date, _flags, value) {
        date.setMonth(0, value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "E",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}





function $13939a537621d91b$export$b04fdcda82decc6c(date, day, options) {
    const defaultOptions = (0, $39440020b58e1ef8$export$430a3269e24b912e)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const date_ = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    const currentDay = date_.getDay();
    const remainder = day % 7;
    const dayIndex = (remainder + 7) % 7;
    const delta = 7 - weekStartsOn;
    const diff = day < 0 || day > 6 ? day - (currentDay + delta) % 7 : (dayIndex + delta) % 7 - (currentDay + delta) % 7;
    return (0, $a351150ce2eb3ddb$export$dd412b56f1e4d8aa)(date_, diff, options);
}
var // Fallback for modularized imports:
$13939a537621d91b$export$2e2bcd8739ae039 = $13939a537621d91b$export$b04fdcda82decc6c;



class $9c29ecc5d15fe12f$export$1b03c8b76262f7bd extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 90;
    parse(dateString, token, match) {
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, $13939a537621d91b$export$b04fdcda82decc6c)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}





class $fff6beaa36b4d0e5$export$44d1c127ab42c480 extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 90;
    parse(dateString, token, match, options) {
        const valueCallback = (value)=>{
            // We want here floor instead of trunc, so we get -7 for value 0 instead of 0
            const wholeWeekDays = Math.floor((value - 1) / 7) * 7;
            return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
        };
        switch(token){
            // 3
            case "e":
            case "ee":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)((0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString), valueCallback);
            // 3rd
            case "eo":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "day"
                }), valueCallback);
            // Tue
            case "eee":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, $13939a537621d91b$export$b04fdcda82decc6c)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "E",
        "i",
        "c",
        "t",
        "T"
    ];
}





class $1516c9543f7b6045$export$e447a647caaaec1d extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 90;
    parse(dateString, token, match, options) {
        const valueCallback = (value)=>{
            // We want here floor instead of trunc, so we get -7 for value 0 instead of 0
            const wholeWeekDays = Math.floor((value - 1) / 7) * 7;
            return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
        };
        switch(token){
            // 3
            case "c":
            case "cc":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)((0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString), valueCallback);
            // 3rd
            case "co":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "day"
                }), valueCallback);
            // Tue
            case "ccc":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, $13939a537621d91b$export$b04fdcda82decc6c)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "E",
        "i",
        "e",
        "t",
        "T"
    ];
}




function $6f80ca66d6710e40$export$c514f4c1a8ed5e9e(date, options) {
    const day = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in).getDay();
    return day === 0 ? 7 : day;
}
var // Fallback for modularized imports:
$6f80ca66d6710e40$export$2e2bcd8739ae039 = $6f80ca66d6710e40$export$c514f4c1a8ed5e9e;



function $87a68208fbd57247$export$1fd9df65adb0d1aa(date, day, options) {
    const date_ = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    const currentDay = (0, $6f80ca66d6710e40$export$c514f4c1a8ed5e9e)(date_, options);
    const diff = day - currentDay;
    return (0, $a351150ce2eb3ddb$export$dd412b56f1e4d8aa)(date_, diff, options);
}
var // Fallback for modularized imports:
$87a68208fbd57247$export$2e2bcd8739ae039 = $87a68208fbd57247$export$1fd9df65adb0d1aa;




class $6410865f895f2a05$export$693fb1e525095b2a extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 90;
    parse(dateString, token, match) {
        const valueCallback = (value)=>{
            if (value === 0) return 7;
            return value;
        };
        switch(token){
            // 2
            case "i":
            case "ii":
                return (0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString);
            // 2nd
            case "io":
                return match.ordinalNumber(dateString, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)(match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // T
            case "iiiii":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)(match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // Tu
            case "iiiiii":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)(match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // Tuesday
            case "iiii":
            default:
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)(match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 7;
    }
    set(date, _flags, value) {
        date = (0, $87a68208fbd57247$export$1fd9df65adb0d1aa)(date, value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "y",
        "Y",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "E",
        "e",
        "c",
        "t",
        "T"
    ];
}




class $d5f00db985cb1985$export$8d1e08492351df91 extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 80;
    parse(dateString, token, match) {
        switch(token){
            case "a":
            case "aa":
            case "aaa":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaaa":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, $7caea2161b2082cf$export$fb506d2676e7f207)(value), 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "b",
        "B",
        "H",
        "k",
        "t",
        "T"
    ];
}




class $40ef93898dc5fd94$export$73ca2bd0a17d273 extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 80;
    parse(dateString, token, match) {
        switch(token){
            case "b":
            case "bb":
            case "bbb":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbbb":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, $7caea2161b2082cf$export$fb506d2676e7f207)(value), 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "B",
        "H",
        "k",
        "t",
        "T"
    ];
}




class $74a8f7a92cf7f4b7$export$bb9212adf05373db extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 80;
    parse(dateString, token, match) {
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBBB":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, $7caea2161b2082cf$export$fb506d2676e7f207)(value), 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "b",
        "t",
        "T"
    ];
}





class $c4e91a5550a4af76$export$8a04050a727a1756 extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "h":
                return (0, $7caea2161b2082cf$export$cc7cc9e2a3ff9388)((0, $90ea69bf2b625c49$export$c123ee06d9da8480).hour12h, dateString);
            case "ho":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 12;
    }
    set(date, _flags, value) {
        const isPM = date.getHours() >= 12;
        if (isPM && value < 12) date.setHours(value + 12, 0, 0, 0);
        else if (!isPM && value === 12) date.setHours(0, 0, 0, 0);
        else date.setHours(value, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "H",
        "K",
        "k",
        "t",
        "T"
    ];
}





class $04e380d05021e0e6$export$e56f4dea2c3e56dd extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "H":
                return (0, $7caea2161b2082cf$export$cc7cc9e2a3ff9388)((0, $90ea69bf2b625c49$export$c123ee06d9da8480).hour23h, dateString);
            case "Ho":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 23;
    }
    set(date, _flags, value) {
        date.setHours(value, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "b",
        "h",
        "K",
        "k",
        "t",
        "T"
    ];
}





class $b7df994bc976acad$export$cbbe855312f87d77 extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "K":
                return (0, $7caea2161b2082cf$export$cc7cc9e2a3ff9388)((0, $90ea69bf2b625c49$export$c123ee06d9da8480).hour11h, dateString);
            case "Ko":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        const isPM = date.getHours() >= 12;
        if (isPM && value < 12) date.setHours(value + 12, 0, 0, 0);
        else date.setHours(value, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "h",
        "H",
        "k",
        "t",
        "T"
    ];
}





class $2a786c11f89b58f4$export$6008046d2b34b6a5 extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "k":
                return (0, $7caea2161b2082cf$export$cc7cc9e2a3ff9388)((0, $90ea69bf2b625c49$export$c123ee06d9da8480).hour24h, dateString);
            case "ko":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 24;
    }
    set(date, _flags, value) {
        const hours = value <= 24 ? value % 24 : value;
        date.setHours(hours, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "b",
        "h",
        "H",
        "K",
        "t",
        "T"
    ];
}





class $fccac2a30b38ae4c$export$2b52670d9e2be53 extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 60;
    parse(dateString, token, match) {
        switch(token){
            case "m":
                return (0, $7caea2161b2082cf$export$cc7cc9e2a3ff9388)((0, $90ea69bf2b625c49$export$c123ee06d9da8480).minute, dateString);
            case "mo":
                return match.ordinalNumber(dateString, {
                    unit: "minute"
                });
            default:
                return (0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 59;
    }
    set(date, _flags, value) {
        date.setMinutes(value, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "t",
        "T"
    ];
}





class $1cf805ecbd4f0c4e$export$94d46d540cf1366a extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 50;
    parse(dateString, token, match) {
        switch(token){
            case "s":
                return (0, $7caea2161b2082cf$export$cc7cc9e2a3ff9388)((0, $90ea69bf2b625c49$export$c123ee06d9da8480).second, dateString);
            case "so":
                return match.ordinalNumber(dateString, {
                    unit: "second"
                });
            default:
                return (0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 59;
    }
    set(date, _flags, value) {
        date.setSeconds(value, 0);
        return date;
    }
    incompatibleTokens = [
        "t",
        "T"
    ];
}




class $93458d2bd887c060$export$b8e6f8b2d70893b1 extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 30;
    parse(dateString, token) {
        const valueCallback = (value)=>Math.trunc(value * Math.pow(10, -token.length + 3));
        return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)((0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString), valueCallback);
    }
    set(date, _flags, value) {
        date.setMilliseconds(value);
        return date;
    }
    incompatibleTokens = [
        "t",
        "T"
    ];
}







class $8e1ac7071c05f7b7$export$104d901d49fea29b extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 10;
    parse(dateString, token) {
        switch(token){
            case "X":
                return (0, $7caea2161b2082cf$export$6497f4c0ecdfba8e)((0, $90ea69bf2b625c49$export$a7ee192b982af9c1).basicOptionalMinutes, dateString);
            case "XX":
                return (0, $7caea2161b2082cf$export$6497f4c0ecdfba8e)((0, $90ea69bf2b625c49$export$a7ee192b982af9c1).basic, dateString);
            case "XXXX":
                return (0, $7caea2161b2082cf$export$6497f4c0ecdfba8e)((0, $90ea69bf2b625c49$export$a7ee192b982af9c1).basicOptionalSeconds, dateString);
            case "XXXXX":
                return (0, $7caea2161b2082cf$export$6497f4c0ecdfba8e)((0, $90ea69bf2b625c49$export$a7ee192b982af9c1).extendedOptionalSeconds, dateString);
            case "XXX":
            default:
                return (0, $7caea2161b2082cf$export$6497f4c0ecdfba8e)((0, $90ea69bf2b625c49$export$a7ee192b982af9c1).extended, dateString);
        }
    }
    set(date, flags, value) {
        if (flags.timestampIsSet) return date;
        return (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, date.getTime() - (0, $92dc0740ffabe180$export$113002b5eff6e430)(date) - value);
    }
    incompatibleTokens = [
        "t",
        "T",
        "x"
    ];
}







class $817e75c4dd06b66a$export$12910e5204b52b9 extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 10;
    parse(dateString, token) {
        switch(token){
            case "x":
                return (0, $7caea2161b2082cf$export$6497f4c0ecdfba8e)((0, $90ea69bf2b625c49$export$a7ee192b982af9c1).basicOptionalMinutes, dateString);
            case "xx":
                return (0, $7caea2161b2082cf$export$6497f4c0ecdfba8e)((0, $90ea69bf2b625c49$export$a7ee192b982af9c1).basic, dateString);
            case "xxxx":
                return (0, $7caea2161b2082cf$export$6497f4c0ecdfba8e)((0, $90ea69bf2b625c49$export$a7ee192b982af9c1).basicOptionalSeconds, dateString);
            case "xxxxx":
                return (0, $7caea2161b2082cf$export$6497f4c0ecdfba8e)((0, $90ea69bf2b625c49$export$a7ee192b982af9c1).extendedOptionalSeconds, dateString);
            case "xxx":
            default:
                return (0, $7caea2161b2082cf$export$6497f4c0ecdfba8e)((0, $90ea69bf2b625c49$export$a7ee192b982af9c1).extended, dateString);
        }
    }
    set(date, flags, value) {
        if (flags.timestampIsSet) return date;
        return (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, date.getTime() - (0, $92dc0740ffabe180$export$113002b5eff6e430)(date) - value);
    }
    incompatibleTokens = [
        "t",
        "T",
        "X"
    ];
}





class $a7e39061a4ba0a45$export$2cd8bf877a05e96 extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 40;
    parse(dateString) {
        return (0, $7caea2161b2082cf$export$d931c43c4608a164)(dateString);
    }
    set(date, _flags, value) {
        return [
            (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, value * 1000),
            {
                timestampIsSet: true
            }
        ];
    }
    incompatibleTokens = "*";
}





class $dff03ff1496c0b81$export$6d8f69c6906d6368 extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 20;
    parse(dateString) {
        return (0, $7caea2161b2082cf$export$d931c43c4608a164)(dateString);
    }
    set(date, _flags, value) {
        return [
            (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, value),
            {
                timestampIsSet: true
            }
        ];
    }
    incompatibleTokens = "*";
}


const $5cf2b811a6ff5b69$export$19131010e7fd8373 = {
    G: new (0, $db0c34f9a22bf78d$export$8e5a1d3f85a9688)(),
    y: new (0, $66195bae0f19f15a$export$48d352de7cd4a988)(),
    Y: new (0, $9fda39b31cab7345$export$b8ef38dfcf05d5db)(),
    R: new (0, $1a189db5f2a1065c$export$951d1df011fde06f)(),
    u: new (0, $c3854b7a937037cd$export$bad9d2ea38e8f1a)(),
    Q: new (0, $d1988bf983127f3e$export$5cb0f701186dde1d)(),
    q: new (0, $62b79555ac1f33b0$export$300c0c2990e20e6d)(),
    M: new (0, $44a198f4e488a239$export$400dd8b40ef138a3)(),
    L: new (0, $f7643ab884280f91$export$1d7eaa53eaa5deba)(),
    w: new (0, $0da9b6c0b13ee7fd$export$c4005ffc174e07c0)(),
    I: new (0, $6803ee1ef2b46eaa$export$6fc8dbedd560a6af)(),
    d: new (0, $e06f3f7fc9153746$export$e8d4b28a20981dd2)(),
    D: new (0, $6b2b75646543924f$export$6cfe0d613455f615)(),
    E: new (0, $9c29ecc5d15fe12f$export$1b03c8b76262f7bd)(),
    e: new (0, $fff6beaa36b4d0e5$export$44d1c127ab42c480)(),
    c: new (0, $1516c9543f7b6045$export$e447a647caaaec1d)(),
    i: new (0, $6410865f895f2a05$export$693fb1e525095b2a)(),
    a: new (0, $d5f00db985cb1985$export$8d1e08492351df91)(),
    b: new (0, $40ef93898dc5fd94$export$73ca2bd0a17d273)(),
    B: new (0, $74a8f7a92cf7f4b7$export$bb9212adf05373db)(),
    h: new (0, $c4e91a5550a4af76$export$8a04050a727a1756)(),
    H: new (0, $04e380d05021e0e6$export$e56f4dea2c3e56dd)(),
    K: new (0, $b7df994bc976acad$export$cbbe855312f87d77)(),
    k: new (0, $2a786c11f89b58f4$export$6008046d2b34b6a5)(),
    m: new (0, $fccac2a30b38ae4c$export$2b52670d9e2be53)(),
    s: new (0, $1cf805ecbd4f0c4e$export$94d46d540cf1366a)(),
    S: new (0, $93458d2bd887c060$export$b8e6f8b2d70893b1)(),
    X: new (0, $8e1ac7071c05f7b7$export$104d901d49fea29b)(),
    x: new (0, $817e75c4dd06b66a$export$12910e5204b52b9)(),
    t: new (0, $a7e39061a4ba0a45$export$2cd8bf877a05e96)(),
    T: new (0, $dff03ff1496c0b81$export$6d8f69c6906d6368)()
};


/**
 * The {@link parse} function options.
 */ // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const $8abb93379891fb3e$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const $8abb93379891fb3e$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const $8abb93379891fb3e$var$escapedStringRegExp = /^'([^]*?)'?$/;
const $8abb93379891fb3e$var$doubleQuoteRegExp = /''/g;
const $8abb93379891fb3e$var$notWhitespaceRegExp = /\S/;
const $8abb93379891fb3e$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $8abb93379891fb3e$export$98e6a39c04603d36(dateStr, formatStr, referenceDate, options) {
    const invalidDate = ()=>(0, $abb9adbdb26342b3$export$ead8a1812b171991)(options?.in || referenceDate, NaN);
    const defaultOptions = (0, $f3e2f0f906df8397$export$430a3269e24b912e)();
    const locale = options?.locale ?? defaultOptions.locale ?? (0, $cd0c27002eb93234$export$137380d9ce54f7f);
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    if (!formatStr) return dateStr ? invalidDate() : (0, $231bfb8d72679740$export$e67a095c620b86fe)(referenceDate, options?.in);
    const subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    // If timezone isn't specified, it will try to use the context or
    // the reference date and fallback to the system time zone.
    const setters = [
        new (0, $2c074b7ab8cd2d6d$export$8be15fe85ad72f86)(options?.in, referenceDate)
    ];
    const tokens = formatStr.match($8abb93379891fb3e$var$longFormattingTokensRegExp).map((substring)=>{
        const firstCharacter = substring[0];
        if (firstCharacter in (0, $54cd66db3e5e74df$export$70cc8fd02856fd58)) {
            const longFormatter = (0, $54cd66db3e5e74df$export$70cc8fd02856fd58)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($8abb93379891fb3e$var$formattingTokensRegExp);
    const usedTokens = [];
    for (let token of tokens){
        if (!options?.useAdditionalWeekYearTokens && (0, $7e8a5b0b77bf77b9$export$c6b49d6dceb604a1)(token)) (0, $7e8a5b0b77bf77b9$export$f5f38f90ecaaf879)(token, formatStr, dateStr);
        if (!options?.useAdditionalDayOfYearTokens && (0, $7e8a5b0b77bf77b9$export$c6cc36aa33304772)(token)) (0, $7e8a5b0b77bf77b9$export$f5f38f90ecaaf879)(token, formatStr, dateStr);
        const firstCharacter = token[0];
        const parser = (0, $5cf2b811a6ff5b69$export$19131010e7fd8373)[firstCharacter];
        if (parser) {
            const { incompatibleTokens: incompatibleTokens } = parser;
            if (Array.isArray(incompatibleTokens)) {
                const incompatibleToken = usedTokens.find((usedToken)=>incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter);
                if (incompatibleToken) throw new RangeError(`The format string mustn't contain \`${incompatibleToken.fullToken}\` and \`${token}\` at the same time`);
            } else if (parser.incompatibleTokens === "*" && usedTokens.length > 0) throw new RangeError(`The format string mustn't contain \`${token}\` and any other token at the same time`);
            usedTokens.push({
                token: firstCharacter,
                fullToken: token
            });
            const parseResult = parser.run(dateStr, token, locale.match, subFnOptions);
            if (!parseResult) return invalidDate();
            setters.push(parseResult.setter);
            dateStr = parseResult.rest;
        } else {
            if (firstCharacter.match($8abb93379891fb3e$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
            // Replace two single quote characters with one single quote character
            if (token === "''") token = "'";
            else if (firstCharacter === "'") token = $8abb93379891fb3e$var$cleanEscapedString(token);
            // Cut token from string, or, if string doesn't match the token, return Invalid Date
            if (dateStr.indexOf(token) === 0) dateStr = dateStr.slice(token.length);
            else return invalidDate();
        }
    }
    // Check if the remaining input contains something other than whitespace
    if (dateStr.length > 0 && $8abb93379891fb3e$var$notWhitespaceRegExp.test(dateStr)) return invalidDate();
    const uniquePrioritySetters = setters.map((setter)=>setter.priority).sort((a, b)=>b - a).filter((priority, index, array)=>array.indexOf(priority) === index).map((priority)=>setters.filter((setter)=>setter.priority === priority).sort((a, b)=>b.subPriority - a.subPriority)).map((setterArray)=>setterArray[0]);
    let date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(referenceDate, options?.in);
    if (isNaN(+date)) return invalidDate();
    const flags = {};
    for (const setter of uniquePrioritySetters){
        if (!setter.validate(date, subFnOptions)) return invalidDate();
        const result = setter.set(date, flags, subFnOptions);
        // Result is tuple (date, flags)
        if (Array.isArray(result)) {
            date = result[0];
            Object.assign(flags, result[1]);
        // Result is date
        } else date = result;
    }
    return date;
}
function $8abb93379891fb3e$var$cleanEscapedString(input) {
    return input.match($8abb93379891fb3e$var$escapedStringRegExp)[1].replace($8abb93379891fb3e$var$doubleQuoteRegExp, "'");
}
var // Fallback for modularized imports:
$8abb93379891fb3e$export$2e2bcd8739ae039 = $8abb93379891fb3e$export$98e6a39c04603d36;




function $a92bacc669eda25d$export$4393d2ccbbedb219(argument, options) {
    const invalidDate = ()=>(0, $abb9adbdb26342b3$export$ead8a1812b171991)(options?.in, NaN);
    const additionalDigits = options?.additionalDigits ?? 2;
    const dateStrings = $a92bacc669eda25d$var$splitDateString(argument);
    let date;
    if (dateStrings.date) {
        const parseYearResult = $a92bacc669eda25d$var$parseYear(dateStrings.date, additionalDigits);
        date = $a92bacc669eda25d$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(+date)) return invalidDate();
    const timestamp = +date;
    let time = 0;
    let offset;
    if (dateStrings.time) {
        time = $a92bacc669eda25d$var$parseTime(dateStrings.time);
        if (isNaN(time)) return invalidDate();
    }
    if (dateStrings.timezone) {
        offset = $a92bacc669eda25d$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return invalidDate();
    } else {
        const tmpDate = new Date(timestamp + time);
        const result = (0, $231bfb8d72679740$export$e67a095c620b86fe)(0, options?.in);
        result.setFullYear(tmpDate.getUTCFullYear(), tmpDate.getUTCMonth(), tmpDate.getUTCDate());
        result.setHours(tmpDate.getUTCHours(), tmpDate.getUTCMinutes(), tmpDate.getUTCSeconds(), tmpDate.getUTCMilliseconds());
        return result;
    }
    return (0, $231bfb8d72679740$export$e67a095c620b86fe)(timestamp + time + offset, options?.in);
}
const $a92bacc669eda25d$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
const $a92bacc669eda25d$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
const $a92bacc669eda25d$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
const $a92bacc669eda25d$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $a92bacc669eda25d$var$splitDateString(dateString) {
    const dateStrings = {};
    const array = dateString.split($a92bacc669eda25d$var$patterns.dateTimeDelimiter);
    let timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($a92bacc669eda25d$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($a92bacc669eda25d$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        const token = $a92bacc669eda25d$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], "");
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $a92bacc669eda25d$var$parseYear(dateString, additionalDigits) {
    const regex = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + additionalDigits) + "})|(\\d{2}|[+-]\\d{" + (2 + additionalDigits) + "})$)");
    const captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ""
    };
    const year = captures[1] ? parseInt(captures[1]) : null;
    const century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $a92bacc669eda25d$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    const captures = dateString.match($a92bacc669eda25d$var$dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    const isWeekDate = !!captures[4];
    const dayOfYear = $a92bacc669eda25d$var$parseDateUnit(captures[1]);
    const month = $a92bacc669eda25d$var$parseDateUnit(captures[2]) - 1;
    const day = $a92bacc669eda25d$var$parseDateUnit(captures[3]);
    const week = $a92bacc669eda25d$var$parseDateUnit(captures[4]);
    const dayOfWeek = $a92bacc669eda25d$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$a92bacc669eda25d$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $a92bacc669eda25d$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        const date = new Date(0);
        if (!$a92bacc669eda25d$var$validateDate(year, month, day) || !$a92bacc669eda25d$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $a92bacc669eda25d$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $a92bacc669eda25d$var$parseTime(timeString) {
    const captures = timeString.match($a92bacc669eda25d$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    const hours = $a92bacc669eda25d$var$parseTimeUnit(captures[1]);
    const minutes = $a92bacc669eda25d$var$parseTimeUnit(captures[2]);
    const seconds = $a92bacc669eda25d$var$parseTimeUnit(captures[3]);
    if (!$a92bacc669eda25d$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * (0, $8540a44f59a4af84$export$7f72910d6dfd237a) + minutes * (0, $8540a44f59a4af84$export$91246f0b9bd9beff) + seconds * 1000;
}
function $a92bacc669eda25d$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(",", ".")) || 0;
}
function $a92bacc669eda25d$var$parseTimezone(timezoneString) {
    if (timezoneString === "Z") return 0;
    const captures = timezoneString.match($a92bacc669eda25d$var$timezoneRegex);
    if (!captures) return 0;
    const sign = captures[1] === "+" ? -1 : 1;
    const hours = parseInt(captures[2]);
    const minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$a92bacc669eda25d$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * (0, $8540a44f59a4af84$export$7f72910d6dfd237a) + minutes * (0, $8540a44f59a4af84$export$91246f0b9bd9beff));
}
function $a92bacc669eda25d$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    const date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    const fourthOfJanuaryDay = date.getUTCDay() || 7;
    const diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
const $a92bacc669eda25d$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $a92bacc669eda25d$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $a92bacc669eda25d$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($a92bacc669eda25d$var$daysInMonths[month] || ($a92bacc669eda25d$var$isLeapYearIndex(year) ? 29 : 28));
}
function $a92bacc669eda25d$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($a92bacc669eda25d$var$isLeapYearIndex(year) ? 366 : 365);
}
function $a92bacc669eda25d$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $a92bacc669eda25d$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $a92bacc669eda25d$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}
var // Fallback for modularized imports:
$a92bacc669eda25d$export$2e2bcd8739ae039 = $a92bacc669eda25d$export$4393d2ccbbedb219;


function $d153613108f3ff12$export$24f91f68e7c9d9d5(date, options) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    _date.setMinutes(0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$d153613108f3ff12$export$2e2bcd8739ae039 = $d153613108f3ff12$export$24f91f68e7c9d9d5;


function $d1ad424e56672364$export$c66440458c6aa793(date, options) {
    const date_ = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    date_.setSeconds(0, 0);
    return date_;
}
var // Fallback for modularized imports:
$d1ad424e56672364$export$2e2bcd8739ae039 = $d1ad424e56672364$export$c66440458c6aa793;


function $c0b4ec5551eca4c9$export$a5a3b454ada2268e(date, options) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    _date.setDate(1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$c0b4ec5551eca4c9$export$2e2bcd8739ae039 = $c0b4ec5551eca4c9$export$a5a3b454ada2268e;


function $c922a15e7d8774a7$export$69be7267a042ecb3(date, options) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    const currentMonth = _date.getMonth();
    const month = currentMonth - currentMonth % 3;
    _date.setMonth(month, 1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$c922a15e7d8774a7$export$2e2bcd8739ae039 = $c922a15e7d8774a7$export$69be7267a042ecb3;


function $fec0f854199fab32$export$66c51f9715fdbff5(date, options) {
    const date_ = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    date_.setMilliseconds(0);
    return date_;
}
var // Fallback for modularized imports:
$fec0f854199fab32$export$2e2bcd8739ae039 = $fec0f854199fab32$export$66c51f9715fdbff5;


const $4c7ca2525ef80a8f$var$FORMATS = {
    datetime: 'MMM d, yyyy, h:mm:ss aaaa',
    millisecond: 'h:mm:ss.SSS aaaa',
    second: 'h:mm:ss aaaa',
    minute: 'h:mm aaaa',
    hour: 'ha',
    day: 'MMM d',
    week: 'PP',
    month: 'MMM yyyy',
    quarter: 'qqq - yyyy',
    year: 'yyyy'
};
(0, $216d2bdc6f281bf6$export$f32766ea09ec8bc4)._date.override({
    _id: 'date-fns',
    formats: function() {
        return $4c7ca2525ef80a8f$var$FORMATS;
    },
    parse: function(value, fmt) {
        if (value === null || typeof value === 'undefined') return null;
        const type = typeof value;
        if (type === 'number' || value instanceof Date) value = (0, $231bfb8d72679740$export$e67a095c620b86fe)(value);
        else if (type === 'string') {
            if (typeof fmt === 'string') value = (0, $8abb93379891fb3e$export$98e6a39c04603d36)(value, fmt, new Date(), this.options);
            else value = (0, $a92bacc669eda25d$export$4393d2ccbbedb219)(value, this.options);
        }
        return (0, $f2a682b251363bc2$export$1ea939691cdc45b8)(value) ? value.getTime() : null;
    },
    format: function(time, fmt) {
        return (0, $303ba10db2c74ab4$export$d9468344d3651243)(time, fmt, this.options);
    },
    add: function(time, amount, unit) {
        switch(unit){
            case 'millisecond':
                return (0, $a1665abf6052bbc9$export$baf757aaf0c95c94)(time, amount);
            case 'second':
                return (0, $ec74b6b01c6372f4$export$3cb31b0df13be68)(time, amount);
            case 'minute':
                return (0, $e8dac3cf5df5dbc8$export$2287e3d29250119e)(time, amount);
            case 'hour':
                return (0, $dada8b88b0873e8d$export$4a4306ad4fa0e5e6)(time, amount);
            case 'day':
                return (0, $a351150ce2eb3ddb$export$dd412b56f1e4d8aa)(time, amount);
            case 'week':
                return (0, $bce641bd93181421$export$ef501a2bb4f3ee6b)(time, amount);
            case 'month':
                return (0, $8fcd3b0bf5df7635$export$17c93e242b2d3a22)(time, amount);
            case 'quarter':
                return (0, $30e5a3aa581ecd23$export$c252a41d0fbed2ce)(time, amount);
            case 'year':
                return (0, $25460c542fb3bf74$export$3d83eec43f4ea476)(time, amount);
            default:
                return time;
        }
    },
    diff: function(max, min, unit) {
        switch(unit){
            case 'millisecond':
                return (0, $b7913fc338fe28ad$export$7be94d13716b4bf6)(max, min);
            case 'second':
                return (0, $e9186d0161460806$export$c1889aec51783710)(max, min);
            case 'minute':
                return (0, $67e743be56b112ce$export$d904251335be481a)(max, min);
            case 'hour':
                return (0, $f1e71fcc3bd0bed6$export$5436ca250d4d6872)(max, min);
            case 'day':
                return (0, $21c2b10d84e6b5ad$export$86415ebf4eb36b8c)(max, min);
            case 'week':
                return (0, $84f21af906303191$export$b5147a91dc40ddb7)(max, min);
            case 'month':
                return (0, $4bb5df50b9b59298$export$fc1ed482c2861792)(max, min);
            case 'quarter':
                return (0, $03f220a44a4339e3$export$74b5c4055a405552)(max, min);
            case 'year':
                return (0, $bf315c5624a2ab0b$export$ed6bf486f68899ca)(max, min);
            default:
                return 0;
        }
    },
    startOf: function(time, unit, weekday) {
        switch(unit){
            case 'second':
                return (0, $fec0f854199fab32$export$66c51f9715fdbff5)(time);
            case 'minute':
                return (0, $d1ad424e56672364$export$c66440458c6aa793)(time);
            case 'hour':
                return (0, $d153613108f3ff12$export$24f91f68e7c9d9d5)(time);
            case 'day':
                return (0, $b6caff0bf13dcaf5$export$63fa379ae8a9ba2)(time);
            case 'week':
                return (0, $61f11f7a26b3ab78$export$42c81a444fbfb5d4)(time);
            case 'isoWeek':
                return (0, $61f11f7a26b3ab78$export$42c81a444fbfb5d4)(time, {
                    weekStartsOn: +weekday
                });
            case 'month':
                return (0, $c0b4ec5551eca4c9$export$a5a3b454ada2268e)(time);
            case 'quarter':
                return (0, $c922a15e7d8774a7$export$69be7267a042ecb3)(time);
            case 'year':
                return (0, $29cc086f79701cd9$export$f91e89d3d0406102)(time);
            default:
                return time;
        }
    },
    endOf: function(time, unit) {
        switch(unit){
            case 'second':
                return (0, $ee0c9831f430316e$export$ef560ab2fa7b52a2)(time);
            case 'minute':
                return (0, $9dff17d493896adc$export$a06a772fc63bff07)(time);
            case 'hour':
                return (0, $49e734d34adabd84$export$95ae95d2176c5f0)(time);
            case 'day':
                return (0, $b6a2419fd0059687$export$eb9a03f0e9aa6cea)(time);
            case 'week':
                return (0, $d53308c42f1e4c62$export$ef8b6d9133084f4e)(time);
            case 'month':
                return (0, $e58340063d97ab50$export$a2258d9c4118825c)(time);
            case 'quarter':
                return (0, $28fe4daca8fe3005$export$5f53493861eef879)(time);
            case 'year':
                return (0, $6cbfdc6d008595cd$export$8b7aa55c66d5569e)(time);
            default:
                return time;
        }
    }
});






/**
 * @param {DataPoint[]} data
 * @returns {[number, number]} [min, max]
 */ function $c95c45af3fcfd77e$var$getValueRange(data) {
    /**
	 * @param {number} val
	 * @param {number} step
	 * @returns {number}
	 */ function limit(val, step) {
        const exp = Math.floor(Math.log10(val));
        const fac = 10 ** exp;
        val = val / fac;
        val = Math.floor(val);
        val = (val + step) * fac;
        return val;
    }
    const sortedValues = data.map((d)=>d.value).sort((a, b)=>a - b);
    let min = sortedValues[0];
    min = min < 0 ? limit(min, 0) : 0;
    let max = sortedValues[sortedValues.length - 1];
    max = limit(max, 1);
    return [
        min,
        max
    ];
}
/**
 * @typedef {Object} ExportDeviceDetails
 * @property {string} type
 * @property {string} serialNumber
 */ /**
 * @typedef {Object} LineChartConfig
 * @property {number} [limit]
 * @property {(from: Date, to: Date, format: "csv"|"json"|"xlsx") => Promise<DataPoint[]|Blob>} getData
 * @property {string} [label]
 * @property {string} [unit]
 * @property {ExportDeviceDetails} [device]
 *
 * @typedef {Object} DataPoint
 * @property {string} timestamp
 * @property {number} value
 *
 * @param {LineChartConfig} cfg
 */ function $c95c45af3fcfd77e$export$88642ec15bb62ae0(cfg) {
    const localizedDays = (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
        deDE: "Tag(e)",
        enGB: "day(s)",
        frFR: "jour(s)",
        svSE: "dag(ar)"
    });
    const timeRangeSelect = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).select({
        options: [
            (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).option(`1 ${localizedDays}`, "1", true),
            (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).option(`2 ${localizedDays}`, "2"),
            (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).option(`3 ${localizedDays}`, "3"),
            (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).option(`5 ${localizedDays}`, "5"),
            (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).option(`7 ${localizedDays}`, "7"),
            (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).option(`14 ${localizedDays}`, "14"),
            (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).option(`31 ${localizedDays}`, "31")
        ],
        onInput: draw
    });
    const endDateInput = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).dateInput({
        onChange: draw
    });
    /**
	 * @returns {[Date, Date]} [from, to]
	 */ const getDateRange = ()=>{
        const msPerDay = 86400000;
        const to = new Date(endDateInput.getDate().getTime() + msPerDay);
        const from = new Date(to.getTime() - +timeRangeSelect.getValue() * msPerDay);
        return [
            from,
            to
        ];
    };
    const chartCanvas = document.createElement("canvas");
    const chartOptions = {};
    /** @type {Chart} */ const chart = new (0, $e24bb3f4f01060dd$export$2e2bcd8739ae039)(chartCanvas, {
        type: "line",
        data: {
            labels: [],
            datasets: []
        },
        options: {
            animation: false,
            ...chartOptions
        }
    });
    const exportFormatSelect = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).select({
        options: [
            (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).option("CSV", "csv"),
            (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).option("XLSX", "xlsx", true)
        ]
    });
    const content = document.createElement("div");
    content.className = "chart-content";
    content.append((0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).field({
        styles: [
            "is-grouped"
        ]
    }, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).field({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).label((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
        enGB: "Time interval",
        deDE: "Zeitintervall",
        frFR: "Intervalle de temps",
        svSE: "Tidsintervall"
    })), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({}, timeRangeSelect.element)), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).field({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).label((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
        enGB: "Until",
        deDE: "Bis",
        frFR: "Jusqu'\xe0",
        svSE: "Tills"
    })), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({}, endDateInput.element))), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).field({
        styles: (0, $1d17319f79c68be8$export$d70a5ce4bc79c42d) ? [
            "is-hidden"
        ] : [
            "has-addons"
        ]
    }, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({}, exportFormatSelect.element), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).button({
        styles: [
            "is-primary"
        ],
        onClick: onClickExport
    }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
        enGB: "Export",
        deDE: "Export",
        frFR: "Exporter",
        svSE: "Exportera"
    })))), chartCanvas);
    const progress = document.createElement("progress");
    progress.className = "progress is-small is-primary";
    progress.max = 100;
    const overlay = document.createElement("div");
    overlay.className = "chart-overlay is-hidden";
    const container = document.createElement("div");
    container.className = "chart-container";
    container.append(content, overlay);
    async function draw() {
        overlay.replaceChildren(progress);
        overlay.classList.remove("is-hidden");
        const [from, to] = getDateRange();
        const data = await cfg.getData(from, to, "json");
        if (data instanceof Blob) return;
        chart.data.labels = data.map((data)=>data.timestamp);
        setChartDataset(data);
        setChartOptions(data, from, to);
        chart.update("none"); // Update wthout animation
        overlay.classList.add("is-hidden");
    }
    async function onClickExport() {
        const [from, to] = getDateRange();
        const format = exportFormatSelect.getValue();
        if (format !== "csv" && format !== "xlsx") throw "invalid export format";
        const blob = await cfg.getData(from, to, format);
        if (!(blob instanceof Blob)) throw "expected blob";
        const file = new File([
            blob
        ], `export.${format}`, {
            type: format === "csv" ? "text/csv" : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });
        (0, $820877bea407f5fe$export$24422be91ad4011f)(file);
    }
    /**
	 * @param {DataPoint[]} data
	 */ function setChartDataset(data) {
        const values = data.map((data)=>data.value);
        const hue = getComputedStyle(document.documentElement).getPropertyValue("--bulma-primary-h");
        const saturation = getComputedStyle(document.documentElement).getPropertyValue("--bulma-primary-s");
        const lightness = getComputedStyle(document.documentElement).getPropertyValue("--bulma-primary-l");
        chart.data.datasets = [
            {
                label: cfg.unit || "?",
                type: "line",
                data: values,
                backgroundColor: `hsla(${hue}, ${saturation}, ${lightness}, 0.2)`,
                borderColor: `hsl(${hue}, ${saturation}, ${lightness})`,
                fill: true,
                spanGaps: false,
                stepped: "before"
            }
        ];
    }
    /**
	 * @param {DataPoint[]} data
	 * @param {Date} from
	 * @param {Date} to
	 */ function setChartOptions(data, from, to) {
        const [yMin, yMax] = $c95c45af3fcfd77e$var$getValueRange(data);
        chart.options = {
            responsive: true,
            maintainAspectRatio: true,
            locale: (0, $093d22e30b803c56$export$162ce11d62a1ca51).id,
            scales: {
                x: {
                    display: true,
                    type: "time",
                    min: from.getTime(),
                    max: to.getTime(),
                    time: {
                        tooltipFormat: "MMM d Y - HH:mm",
                        unit: to.getTime() - from.getTime() <= 172800000 ? "hour" : "day",
                        displayFormats: {
                            hour: "HH.mm"
                        }
                    }
                },
                y: {
                    title: {
                        display: true,
                        text: cfg.unit || "?"
                    },
                    display: true,
                    min: yMin,
                    max: yMax,
                    ticks: {
                        color: "#000000"
                    }
                }
            },
            plugins: {
                legend: {
                    position: "top",
                    display: false,
                    labels: {
                        color: "#FFFFFF"
                    }
                },
                tooltip: {
                    enabled: true,
                    yAlign: "bottom",
                    callbacks: {
                        /**
						 * @typedef {Object} TooltipContextDataset
						 * @property {string} [label]
						 */ /**
						 * @typedef {Object} TooltipContextParsed
						 * @property {number | string} [x]
						 * @property {number | string} [y]
						 */ /**
						 * @typedef {Object} TooltipContext
						 * @property {TooltipContextDataset} dataset
						 * @property {TooltipContextParsed} parsed
						 */ /**
						 * @param {TooltipContext} context
						 */ label: (context)=>{
                            let label = context.dataset.label || "";
                            if (context.parsed.y !== null) label = `${context.parsed.y} ${cfg.unit || "?"}`;
                            return label;
                        }
                    }
                }
            }
        };
    }
    return {
        element: container,
        mount: draw
    };
}






/**
 * @type {import('navigo').Handler}
 */ async function $023fd85b9845aa5f$export$5eacbdba33a4a55b(ctx) {
    if (!ctx || !ctx.data || !ctx.data.imsi) throw "missing ctx.data.imsi";
    const sim = (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).farmcamSims[ctx.data.imsi];
    const remainingDataChart = (0, $c95c45af3fcfd77e$export$88642ec15bb62ae0)({
        label: (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
            enGB: "Remaining data",
            deDE: "Verbleibende Daten",
            frFR: "Donn\xe9es restantes",
            svSE: "\xc5terst\xe5ende data"
        }),
        unit: "MB",
        device: {
            type: "FarmCam SIM",
            serialNumber: sim.Imsi
        },
        getData: getRemainingData
    });
    await (0, $b4e14b6b8da86996$export$8390d50e515c191d)((0, $62f894d94fb7061c$export$4b0227fa4b29008b)("large", (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).title(sim.Metadata.Name), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).subtitle(`IMSI: ${sim.Imsi}`), document.createElement("hr"), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).title((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
        deDE: "Verbleibende Daten",
        enGB: "Remaining data",
        frFR: "Donn\xe9es restantes",
        svSE: "\xc5terst\xe5ende data"
    }), "is-5"), remainingDataChart.element, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).buttons((0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).button({
        onClick: ()=>(0, $b4e14b6b8da86996$export$5375cda95f0b0eb4).jump(`/devices?id=${sim.Imsi}`),
        styles: [
            "is-primary"
        ]
    }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.back))));
    remainingDataChart.mount();
    /**
	 * @param {Date} from
	 * @param {Date} to
	 * @param {"csv"|"json"|"xlsx"} format
	 * @returns {Promise<import('../device/device_log_chart').DataPoint[]|Blob>}
	 */ async function getRemainingData(from, to, format) {
        const res = await (0, $85e6b33e9fd1129e$export$4ae75616531cb2b8)(sim.Imsi, {
            from: from.toISOString(),
            to: to.toISOString(),
            format: format
        });
        if (res instanceof Blob) return res;
        else return res.map((log)=>({
                value: log.RemainingData ? Math.round(log.RemainingData / 1e6) : 0,
                timestamp: log.Timestamp
            }));
    }
}










/**
 * DEPRECATED
 * @param {Subscription} sub 
 * @param {import("../api/prices").Price[]} prices 
 * @param {"EUR"|"SEK"} currency
 * @param {boolean} isOwner
 */ function $b01f22cb9334aa3d$export$b5d7b3b664095c3(sub, prices, currency, isOwner) {
    const subSelect = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).select({
        disabled: !isOwner,
        onInput: onSelectSubscription,
        options: [
            (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).option("None", "", sub.PriceIds.Next === ""),
            ...prices.map((p)=>(0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).option(p.Name, p.Id, sub.PriceIds.Next === p.Id))
        ]
    });
    const priceInfo = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).input({
        type: "text",
        isReadonly: true,
        styles: [
            'is-static'
        ]
    });
    function onSelectSubscription() {
        const priceId = subSelect.getValue();
        if (priceId === "") priceInfo.setValue((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
            enGB: `0 ${currency} per month`,
            deDE: `0 ${currency} pro Monat`,
            frFR: `0 ${currency} par mois`,
            svSE: `0 ${currency} per m\xe5nad`
        }));
        else prices.find((price)=>price.Id === priceId)?.toString().then((s)=>priceInfo.setValue(s));
    }
    onSelectSubscription();
    const element = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).field({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).label((0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.subscription), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({}, subSelect.element), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({}, priceInfo.element));
    return {
        element: element,
        getPriceId: ()=>subSelect.getValue(),
        setPriceId: subSelect.setValue.bind(subSelect.element)
    };
}
/**
 * DEPRECATED
 * @param {DeviceMetadata} meta
 */ function $b01f22cb9334aa3d$export$c52b6e40375164c0(meta) {
    // Create local copy to avoid changes to be reflected on devices page before
    // next auto-refresh
    const access = Array.from(meta.Access);
    const notify = Array.from(meta.Notify || []);
    /** @type {(email: string) => HTMLTableRowElement} */ const newRow = (email)=>{
        const notificationsOnIcon = (0, $1abc8d719eea79cd$export$e1dd10d13c5a06).icon({
            id: "notifications",
            onClick: ()=>{
                (0, $820877bea407f5fe$export$225ffb4bcef29a56)(notify, email);
                notificationsOnIcon.replaceWith(notificationsOffIcon);
            }
        });
        const notificationsOffIcon = (0, $1abc8d719eea79cd$export$e1dd10d13c5a06).icon({
            id: "notifications_off",
            onClick: ()=>{
                (0, $820877bea407f5fe$export$69b94c46bed08c28)(notify, email);
                notificationsOffIcon.replaceWith(notificationsOnIcon);
            }
        });
        const ownerIcon = (0, $1abc8d719eea79cd$export$e1dd10d13c5a06).icon({
            id: "star"
        });
        const removeUserIcon = (0, $1abc8d719eea79cd$export$e1dd10d13c5a06).icon({
            id: "close",
            onClick: ()=>{
                (0, $820877bea407f5fe$export$225ffb4bcef29a56)(access, email);
                (0, $820877bea407f5fe$export$225ffb4bcef29a56)(notify, email);
                row.remove();
            }
        });
        const row = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).tableRow({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).tableDataCell(email), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).tableDataCell(notify.includes(email) ? notificationsOnIcon : notificationsOffIcon), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).tableDataCell(email === meta.OwnerEmail ? ownerIcon : removeUserIcon));
        return row;
    };
    const emailInput = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).input({
        type: "text",
        placeholder: (0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.email
    });
    const onClickInvite = ()=>{
        const email = emailInput.getValue().trim().toLowerCase();
        emailInput.setValue("");
        if (access.includes(email)) return;
        (0, $820877bea407f5fe$export$69b94c46bed08c28)(access, email);
        userTable.tBodies[0].insertRow(access.indexOf(email)).replaceWith(newRow(email));
    };
    const userTable = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).table({
        classList: [
            "is-fullwidth"
        ],
        body: access.map((email)=>newRow(email))
    });
    const element = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).field({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).label((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
        enGB: "Sharing",
        deDE: "Teilen",
        frFR: "Partage",
        svSE: "Delning"
    })), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).field({
        styles: [
            "has-addons"
        ]
    }, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({
        styles: [
            "is-expanded"
        ]
    }, emailInput.element), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).button({
        styles: [
            'is-primary'
        ],
        onClick: onClickInvite
    }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
        enGB: "Invite",
        deDE: "Einladen",
        frFR: "Inviter",
        svSE: "Bjud in"
    })))), userTable);
    return {
        element: element,
        getAccess: ()=>[
                ...access
            ],
        getNotify: ()=>[
                ...notify
            ]
    };
}
/**
 * DEPRECATED
 * @param {DeviceMetadata} meta
 */ function $b01f22cb9334aa3d$export$113fbad7a8f79300(meta) {
    const allTags = (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).getDeviceTags().filter((tag)=>!$b01f22cb9334aa3d$var$isReservedTag(tag));
    const deviceTags = meta.Tags?.filter((tag)=>!$b01f22cb9334aa3d$var$isReservedTag(tag)) || [];
    /** @type {(tag: string) => HTMLDivElement} */ const tagControl = (tag)=>{
        const selected = deviceTags.includes(tag);
        const selectedTag = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).tagWithAddon({
            content: tag,
            color: "is-primary"
        }, {
            content: (0, $1abc8d719eea79cd$export$e1dd10d13c5a06).icon({
                id: "remove"
            }),
            onClick: ()=>{
                (0, $820877bea407f5fe$export$225ffb4bcef29a56)(deviceTags, tag);
                selectedTag.replaceWith(deselectedTag);
            }
        });
        const deselectedTag = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).tagWithAddon({
            content: tag
        }, {
            content: (0, $1abc8d719eea79cd$export$e1dd10d13c5a06).icon({
                id: "add"
            }),
            onClick: ()=>{
                (0, $820877bea407f5fe$export$69b94c46bed08c28)(deviceTags, tag);
                deselectedTag.replaceWith(selectedTag);
            }
        });
        return (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({}, selected ? selectedTag : deselectedTag);
    };
    const tagInput = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).input({
        type: "text",
        placeholder: "New tag"
    });
    const onClickAdd = ()=>{
        const tag = tagInput.getValue();
        tagInput.setValue("");
        if (deviceTags.includes(tag)) return;
        (0, $820877bea407f5fe$export$69b94c46bed08c28)(allTags, tag);
        (0, $820877bea407f5fe$export$69b94c46bed08c28)(deviceTags, tag);
        tagsField.replaceChildren(...allTags.map((tag)=>tagControl(tag)));
    };
    const tagsField = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).field({
        styles: [
            "is-grouped",
            "is-grouped-multiline"
        ]
    }, ...allTags.map((tag)=>tagControl(tag)));
    const element = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).field({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).label((0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.tags), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).field({
        styles: [
            "has-addons"
        ]
    }, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({
        styles: [
            "is-expanded"
        ]
    }, tagInput.element), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).button({
        styles: [
            'is-primary'
        ],
        onClick: onClickAdd
    }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.add))), tagsField);
    return {
        element: element,
        getValue: ()=>[
                ...deviceTags
            ]
    };
}
/**
 * DEPRECATED
 * @param {string} name 
 */ function $b01f22cb9334aa3d$export$b6f1a49de680b8fc(name) {
    const nameInput = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).input({
        type: "text",
        value: name
    });
    const element = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).field({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).label((0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.name), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({}, nameInput.element));
    return {
        element: element,
        getValue: ()=>nameInput.getValue()
    };
}
/**
 * DEPRECATED
 * @param {DeviceMetadata} meta
 * @param {boolean} isOwner 
 */ function $b01f22cb9334aa3d$export$1b5a05bb5c2dadb2(meta, isOwner) {
    const ownerSelect = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).select({
        disabled: !isOwner,
        options: meta.Access.map((email)=>(0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).option(email, email, email === meta.OwnerEmail))
    });
    const element = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).field({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).label((0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.owner), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({}, ownerSelect.element));
    return {
        element: element,
        getValue: ()=>ownerSelect.getValue()
    };
}
/**
 * @param {string} tag 
 * @returns {boolean}
 */ function $b01f22cb9334aa3d$var$isReservedTag(tag) {
    const productTags = [
        "FarmCam SIM",
        "FenceAlarm",
        "FenceAlarm2",
        "SmartPlug",
        "SmartPlug2"
    ];
    if (productTags.includes(tag)) return true;
    return /.+@.+\..+/.test(tag);
}






/**
 * @param {string} productName 
 * @param {() => void} unregister 
 */ function $ab051bb815711afd$export$41b98bdd4d492efc(productName, unregister) {
    (0, $b4e14b6b8da86996$export$96e4b36520c26a2c).open({
        header: (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
            enGB: `Unregister ${productName}`,
            deDE: `${productName} abmelden`,
            frFR: `D\xe9senregistrer ${productName}`,
            svSE: `Avregistrera ${productName}`
        }),
        body: [
            (0, $00995e7d83a33b33$export$13f9d3c4397c4713).paragraph((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
                enGB: `Confirm that you wish to unregister your ${productName}. Any remaining subscription time will be lost.`,
                deDE: `Best\xe4tigen Sie, dass Sie Ihr ${productName} abmelden m\xf6chten. Jede verbleibende Abonnementzeit geht verloren.`,
                frFR: `Confirmez que vous souhaitez annuler l'enregistrement de votre ${productName}. Toute p\xe9riode d'abonnement restante sera perdue.`,
                svSE: `Bekr\xe4fta att du vill avregistrera din ${productName}. Eventuell \xe5terst\xe5ende prenumerationstid kommer att g\xe5 f\xf6rlorad.`
            }))
        ],
        footer: [
            (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).button({
                onClick: unregister,
                styles: [
                    'is-danger'
                ]
            }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.unregister)
        ]
    });
}








/**
 * @type {import('navigo').Handler}
 */ async function $4b1c2404e48b4d55$export$2075b11bd097590f(ctx) {
    if (!ctx || !ctx.data || !ctx.data.imsi) throw "missing ctx.data.imsi";
    const fcs = (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).farmcamSims[ctx.data.imsi];
    const user = await (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).getActiveUser();
    const currency = user.Country === "SE" ? "SEK" : "EUR";
    const isOwner = user.Email === fcs.Metadata.OwnerEmail;
    const { FarmcamSimSmall: FarmcamSimSmall, FarmcamSimMedium: FarmcamSimMedium, FarmcamSimLarge: FarmcamSimLarge, FarmcamSimExtraData: FarmcamSimExtraData } = await (0, $26a5802c7b7183d2$export$41303c5fee299aff)();
    const subscription = (0, $b01f22cb9334aa3d$export$b5d7b3b664095c3)(fcs.Subscription, [
        FarmcamSimSmall,
        FarmcamSimMedium,
        FarmcamSimLarge
    ], currency, isOwner);
    const sharing = (0, $b01f22cb9334aa3d$export$c52b6e40375164c0)(fcs.Metadata);
    const tags = (0, $b01f22cb9334aa3d$export$113fbad7a8f79300)(fcs.Metadata);
    const name = (0, $b01f22cb9334aa3d$export$b6f1a49de680b8fc)(fcs.Metadata.Name);
    const owner = (0, $b01f22cb9334aa3d$export$1b5a05bb5c2dadb2)(fcs.Metadata, isOwner);
    const save = ()=>{
        (0, $85e6b33e9fd1129e$export$69cc339365cb68a4)(fcs.Imsi, {
            PriceId: subscription.getPriceId(),
            Name: name.getValue(),
            Access: sharing.getAccess(),
            Notify: sharing.getNotify(),
            Tags: tags.getValue(),
            Owner: owner.getValue()
        }).then((fcs)=>{
            (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).farmcamSims[fcs.Imsi] = fcs;
            (0, $b4e14b6b8da86996$export$5375cda95f0b0eb4).jump(`/devices?id=${fcs.Imsi}`);
        }).catch((0, $62f894d94fb7061c$export$6badb0ecde4e0bd0)).finally((0, $b4e14b6b8da86996$export$d91ec774a0e3eb9e));
    };
    const unregister = ()=>{
        (0, $b4e14b6b8da86996$export$850e0ce216eef646)();
        (0, $85e6b33e9fd1129e$export$4d294e620db04cb8)(fcs.Imsi).then(()=>{
            delete (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).farmcamSims[fcs.Imsi];
            (0, $b4e14b6b8da86996$export$5375cda95f0b0eb4).jump("/devices");
        }).catch((0, $62f894d94fb7061c$export$6badb0ecde4e0bd0)).finally((0, $b4e14b6b8da86996$export$d91ec774a0e3eb9e));
    };
    (0, $b4e14b6b8da86996$export$8390d50e515c191d)((0, $62f894d94fb7061c$export$4b0227fa4b29008b)("small", (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).title(`FarmCam SIM ${fcs.Metadata.Name}`, "is-4"), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).subtitle(`IMSI: ${fcs.Imsi}`, "is-6"), $4b1c2404e48b4d55$var$buyExtraDataField(ctx, fcs, FarmcamSimExtraData), subscription.element, sharing.element, tags.element, name.element, owner.element, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).buttons((0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).button({
        onClick: save,
        styles: [
            "is-primary"
        ]
    }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.save), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).button({
        styles: [
            "is-primary"
        ],
        onClick: ()=>(0, $b4e14b6b8da86996$export$5375cda95f0b0eb4).jump(`/devices?id=${fcs.Imsi}`)
    }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.back), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).button({
        disabled: !isOwner,
        onClick: ()=>(0, $ab051bb815711afd$export$41b98bdd4d492efc)("FarmCam SIM", unregister),
        styles: [
            "is-danger"
        ]
    }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.unregister))));
}
/**
 * @param {import('navigo').Match} ctx
 * @param {FarmcamSim} fcs
 * @param {import('../api/prices').Price} price
 */ function $4b1c2404e48b4d55$var$buyExtraDataField(ctx, fcs, price) {
    const root = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).field({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).label((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
        enGB: `Remaining data: ${(0, $820877bea407f5fe$export$93320de5093983a2)(fcs.RemainingData)}`,
        deDE: `Verbleibende Daten: ${(0, $820877bea407f5fe$export$93320de5093983a2)(fcs.RemainingData)}`,
        frFR: `Donn\xe9es restantes : ${(0, $820877bea407f5fe$export$93320de5093983a2)(fcs.RemainingData)}`,
        svSE: `\xc5terst\xe5ende data: ${(0, $820877bea407f5fe$export$93320de5093983a2)(fcs.RemainingData)}`
    })), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).button({
        disabled: !fcs.Subscription.PriceIds.Current,
        onClick: onClickBuyExtraData,
        styles: [
            "is-primary"
        ]
    }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
        enGB: "Buy extra data",
        deDE: "Zus\xe4tzliche Daten kaufen",
        frFR: "Acheter des donn\xe9es suppl\xe9mentaires",
        svSE: "K\xf6p extra data"
    }))));
    async function onClickBuyExtraData() {
        (0, $b4e14b6b8da86996$export$96e4b36520c26a2c).open({
            header: (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
                enGB: "Buy extra data",
                deDE: "Zus\xe4tzliche Daten kaufen",
                frFR: "Acheter des donn\xe9es suppl\xe9mentaires",
                svSE: "K\xf6p extra data"
            }),
            body: [
                (0, $00995e7d83a33b33$export$13f9d3c4397c4713).paragraph((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
                    enGB: `Confirm your purchase of 1 GB additional data for ${await price.toString()} ex VAT`,
                    deDE: `Best\xe4tigen Sie Ihren Kauf von 1 GB zus\xe4tzlichen Daten f\xfcr ${await price.toString()} ohne MwSt.`,
                    frFR: `Confirmez votre achat de 1 Go de donn\xe9es suppl\xe9mentaires pour ${await price.toString()} HTVA`,
                    svSE: `Bekr\xe4fta ditt k\xf6p av 1 GB extra data f\xf6r ${await price.toString()} ex moms`
                }))
            ],
            footer: [
                (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).button({
                    onClick: onClickConfirm,
                    styles: [
                        "is-primary"
                    ]
                }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.confirm)
            ]
        });
    }
    async function onClickConfirm() {
        (0, $b4e14b6b8da86996$export$850e0ce216eef646)();
        (0, $85e6b33e9fd1129e$export$f10f79f76bbb768f)(fcs.Imsi).then(()=>$4b1c2404e48b4d55$export$2075b11bd097590f(ctx)).catch((0, $62f894d94fb7061c$export$6badb0ecde4e0bd0)).finally((0, $b4e14b6b8da86996$export$d91ec774a0e3eb9e));
    }
    return root;
}






/**
 * @param {string} imsi 
 * @param {string} name 
 * @returns {Promise<FarmcamSim>}
 */ async function $5779f4e5cbc7b8d2$export$64b1c2759152d740(imsi, name) {
    const res = await (0, $5ca15832b8c5d5ea$export$299ba2dee77727e9)(`/users/${(await (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).getActiveUser()).Id}/farmcam-sims`, {
        body: JSON.stringify({
            Imsi: imsi,
            Name: name
        })
    });
    if (!res.ok) throw await (0, $1fb5d845307c571c$export$f00cf23da648bc9b)(res);
    return res.json();
}









/**
 * @type {import("navigo").Handler}
 */ function $03873b678c48e3cc$export$f338cc65b1624067(ctx) {
    const scan = ()=>{
        (0, $1d17319f79c68be8$export$7564757b89ba44f1)((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
            enGB: "Scan the IMSI barcode. If the barcode is not recognized, enter the IMSI manually.",
            deDE: "Scannen Sie den IMSI-Strichcode. Wenn der Barcode nicht erkannt wird, geben Sie die IMSI manuell ein.",
            frFR: "Scannez le code-barres IMSI. Si le code-barres n'est pas reconnu, saisissez l'IMSI manuellement.",
            svSE: "Skanna IMSI-streckkoden. Om streckkoden inte k\xe4nns igen anger du IMSI manuellt."
        })).then((code)=>{
            if (!code) return;
            imsi.setValue(code);
        });
    };
    const imsi = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).input({
        type: "text"
    });
    const name = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).input({
        type: "text"
    });
    (0, $b4e14b6b8da86996$export$8390d50e515c191d)((0, $62f894d94fb7061c$export$4b0227fa4b29008b)("small", (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).level((0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).levelLeft((0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).levelItem((0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).title((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
        enGB: "Register FarmCam SIM",
        deDE: "Registrieren FarmCam SIM",
        frFR: "Enregistrez FarmCam SIM",
        svSE: "Registrera FarmCam SIM"
    }), "is-4"))), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).levelRight((0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).levelItem((0, $1abc8d719eea79cd$export$e1dd10d13c5a06).icon({
        id: "help",
        onClick: ()=>window.open((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
                enGB: "https://support.luda.farm/en/support/solutions/folders/140001297",
                deDE: "https://support.luda.farm/de/support/solutions/folders/140001297",
                frFR: "https://support.luda.farm/fr/support/solutions/folders/140001297",
                svSE: "https://support.luda.farm/sv-SE/support/solutions/folders/140001297"
            }), "_blank")
    })))), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).field({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).label("IMSI"), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).field({
        styles: (0, $1d17319f79c68be8$export$d70a5ce4bc79c42d) ? [
            "has-addons"
        ] : undefined
    }, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({
        styles: [
            "is-expanded"
        ]
    }, imsi.element), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({
        hidden: !(0, $1d17319f79c68be8$export$d70a5ce4bc79c42d)
    }, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).button({
        onClick: scan
    }, (0, $1abc8d719eea79cd$export$e1dd10d13c5a06).icon({
        id: "barcode",
        alignment: "right"
    }))))), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).field({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).label((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
        enGB: "Choose a name for your device",
        deDE: "W\xe4hlen Sie einen Namen f\xfcr Ihr Ger\xe4t",
        frFR: "Choisissez un nom pour votre appareil",
        svSE: "V\xe4lj ett namn f\xf6r din enhet"
    })), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({}, name.element)), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).field({
        styles: [
            "is-grouped"
        ]
    }, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).button({
        onClick: onClickRegister,
        styles: [
            "is-primary"
        ]
    }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.register)), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).button({
        onClick: ()=>(0, $b4e14b6b8da86996$export$5375cda95f0b0eb4).jump("/devices/register"),
        styles: [
            "is-primary"
        ]
    }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.back)))));
    function onClickRegister() {
        (0, $b4e14b6b8da86996$export$850e0ce216eef646)();
        (0, $5779f4e5cbc7b8d2$export$64b1c2759152d740)(imsi.getValue(), name.getValue()).then((sim)=>{
            (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).farmcamSims[sim.Imsi] = sim;
            (0, $b4e14b6b8da86996$export$5375cda95f0b0eb4).jump("/devices" + (0, $820877bea407f5fe$export$89a7e74069fbb7af)({
                id: sim.Imsi
            }));
        }).finally((0, $b4e14b6b8da86996$export$d91ec774a0e3eb9e));
    }
}






/**
 * @returns {Promise<any>}
 */ async function $06080a0822a84457$export$432f698644f45d1() {
    const res = await (0, $5ca15832b8c5d5ea$export$3988ae62b71be9a3)(`/admin/stats`);
    if (!res.ok) throw await (0, $1fb5d845307c571c$export$f00cf23da648bc9b)(res);
    return await res.json();
}
/**
 * @param {("farmcamsim"|"fencealarm"|"fencealarm2"|"smartplug"|"smartplug2"|"user")} key
 * @param {string} value
 * @returns {Promise<User>}
 */ async function $06080a0822a84457$export$c4a2249e3be1ab76(key, value) {
    const res = await (0, $5ca15832b8c5d5ea$export$3988ae62b71be9a3)(`/admin/impersonate?key=${key}&value=${value}`);
    if (!res.ok) throw await (0, $1fb5d845307c571c$export$f00cf23da648bc9b)(res);
    return await res.json();
}







async function $2732ce926bbb4091$export$e5a937db4458395(ctx) {
    if (!ctx.data?.imei) throw "missing ctx.data.imei";
    const page = (0, $75d47fd8903c7af6$export$90a44edba14e47be)({
        fa: await (0, $9711acd2da3d5569$export$eb45d485f0b29de2)(ctx.data.imei),
        loading: false,
        trialDays: ""
    });
    const onClickAddTrial = ()=>{
        page.loading = true;
        (0, $9711acd2da3d5569$export$b7007e151dbf0c70)(page.fa.Imei, +page.trialDays).then((fa)=>{
            page.fa = fa;
        }).catch((0, $62f894d94fb7061c$export$6badb0ecde4e0bd0)).finally(()=>{
            page.loading = false;
        });
    };
    const onClickCancelSubscription = ()=>{
        page.loading = true;
        (0, $9711acd2da3d5569$export$f65d65e9fd92caad)(page.fa.Imei).then((fa)=>{
            page.fa = fa;
        }).catch((0, $62f894d94fb7061c$export$6badb0ecde4e0bd0)).finally(()=>{
            page.loading = false;
        });
    };
    const onClickImpersonate = ()=>{
        page.loading = true;
        (0, $06080a0822a84457$export$c4a2249e3be1ab76)("fencealarm", page.fa.Imei).then((user)=>(0, $bfc59006cf644cf7$export$ca000e230c0caa3e).startImpersonating(user)).then(()=>(0, $b4e14b6b8da86996$export$5375cda95f0b0eb4).jump("/devices")).catch((0, $62f894d94fb7061c$export$6badb0ecde4e0bd0)).finally(()=>{
            page.loading = false;
        });
    };
    return (0, $e47741cb5fbbb614$export$4b0227fa4b29008b)({
        size: "narrow"
    }, (0, $01d3af8f1b8eef63$export$80e4b313e5e6b30d)({
        class: "breadcrumb"
    }, (0, $01d3af8f1b8eef63$export$b5023c870cb34848)((0, $01d3af8f1b8eef63$export$19caeaf7d9d84644)((0, $01d3af8f1b8eef63$export$407448d2b89b1813)({
        onclick: ()=>(0, $b4e14b6b8da86996$export$5375cda95f0b0eb4).jump("/admin")
    }, "Admin")), (0, $01d3af8f1b8eef63$export$19caeaf7d9d84644)((0, $01d3af8f1b8eef63$export$407448d2b89b1813)("FenceAlarm")))), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
        class: "buttons"
    }, (0, $01d3af8f1b8eef63$export$2ba01fb71ed41cb6)({
        class: ()=>page.loading ? "button is-primary is-loading" : "button is-primary",
        disabled: ()=>page.loading,
        onclick: onClickImpersonate
    }, "Impersonate owner"), (0, $01d3af8f1b8eef63$export$2ba01fb71ed41cb6)({
        class: ()=>page.loading ? "button is-primary is-loading" : "button is-primary",
        disabled: ()=>page.loading,
        onclick: onClickCancelSubscription
    }, "Cancel subscription")), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
        class: "field has-addons"
    }, (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
        class: "control is-expanded"
    }, (0, $01d3af8f1b8eef63$export$b7e3ae3d7c15e42e)({
        class: "input",
        oninput: (e)=>{
            page.trialDays = e.target.value.replace(/\D/g, "");
            e.target.value = page.trialDays;
        },
        placeholder: "Days"
    })), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
        class: "control"
    }, (0, $01d3af8f1b8eef63$export$2ba01fb71ed41cb6)({
        class: ()=>page.loading ? "button is-primary is-loading" : "button is-primary",
        disabled: ()=>page.fa === null || page.loading,
        onclick: onClickAddTrial
    }, "Add trial"))), (0, $01d3af8f1b8eef63$export$b4adb3f464574dcf)(), (0, $01d3af8f1b8eef63$export$2af2ac64526e2aa9)({
        class: "is-tiny-mobile"
    }, ()=>JSON.stringify(page.fa, null, 2)));
}









/**
 * @type {import('navigo').Handler}
 */ async function $fcaa56487d5a303a$export$eaf6b67947c3990e(ctx) {
    if (!ctx || !ctx.data || !ctx.data.imei) throw "missing ctx.data.imei";
    const fa = (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).fencealarms[ctx.data.imei];
    const voltageChart = (0, $c95c45af3fcfd77e$export$88642ec15bb62ae0)({
        label: (0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.voltage,
        unit: "Volt",
        device: {
            type: "FenceAlarm",
            serialNumber: fa.Imei
        },
        getData: getVoltage
    });
    await (0, $b4e14b6b8da86996$export$8390d50e515c191d)((0, $62f894d94fb7061c$export$4b0227fa4b29008b)("large", (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).title(fa.Metadata.Name), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).subtitle(`IMEI: ${fa.Imei}`), document.createElement("hr"), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).title((0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.voltage, "is-5"), voltageChart.element, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).buttons((0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).button({
        onClick: ()=>(0, $b4e14b6b8da86996$export$5375cda95f0b0eb4).jump(`/devices?id=${fa.Imei}`),
        styles: [
            "is-primary"
        ]
    }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.back))));
    voltageChart.mount();
    /**
	 * @param {Date} from
	 * @param {Date} to
	 * @param {"csv"|"json"|"xlsx"} format
	 * @returns {Promise<import('../device/device_log_chart').DataPoint[]|Blob>}
	 */ async function getVoltage(from, to, format) {
        const res = await (0, $9711acd2da3d5569$export$c51e99cff56b63ce)(fa.Imei, {
            from: from.toISOString(),
            to: to.toISOString(),
            format: format
        });
        if (res instanceof Blob) return res;
        else return res.map((log)=>({
                value: log.Voltage,
                timestamp: log.Timestamp
            }));
    }
}











/**
 * @type {import('navigo').Handler}
 */ async function $923c6e19f10de8cd$export$c50a4a29f5fa0ed1(ctx) {
    if (!ctx || !ctx.data || !ctx.data.imei) throw "missing ctx.data.imei";
    const fa = (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).fencealarms[ctx.data.imei];
    const user = await (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).getActiveUser();
    const currency = user.Country === "SE" ? "SEK" : "EUR";
    const isOwner = user.Email === fa.Metadata.OwnerEmail;
    const { FencealarmMonth: FencealarmMonth, FencealarmYear: FencealarmYear } = await (0, $26a5802c7b7183d2$export$41303c5fee299aff)();
    const voltageAlarm = $923c6e19f10de8cd$var$voltageAlarmField(fa);
    const calibration = $923c6e19f10de8cd$var$calibrationField(fa);
    const subscription = (0, $b01f22cb9334aa3d$export$b5d7b3b664095c3)(fa.Subscription, [
        FencealarmMonth,
        FencealarmYear
    ], currency, isOwner);
    const sharing = (0, $b01f22cb9334aa3d$export$c52b6e40375164c0)(fa.Metadata);
    const tags = (0, $b01f22cb9334aa3d$export$113fbad7a8f79300)(fa.Metadata);
    const name = (0, $b01f22cb9334aa3d$export$b6f1a49de680b8fc)(fa.Metadata.Name);
    const owner = (0, $b01f22cb9334aa3d$export$1b5a05bb5c2dadb2)(fa.Metadata, isOwner);
    const save = ()=>{
        (0, $b4e14b6b8da86996$export$850e0ce216eef646)();
        (0, $9711acd2da3d5569$export$3424602516fb6a32)(fa.Imei, {
            VoltageAlarm: {
                Enabled: voltageAlarm.isEnabled(),
                AlarmLevel: voltageAlarm.getThreshold()
            },
            Calibration: {
                Enabled: calibration.isEnabled(),
                ExpectedVoltage: calibration.getVoltage()
            },
            PriceId: subscription.getPriceId(),
            Name: name.getValue(),
            Access: sharing.getAccess(),
            Notify: sharing.getNotify(),
            Tags: tags.getValue(),
            Owner: owner.getValue()
        }).then((fa)=>{
            (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).fencealarms[fa.Imei] = fa;
            (0, $b4e14b6b8da86996$export$5375cda95f0b0eb4).jump(`/devices?id=${fa.Imei}`);
        }).catch((0, $62f894d94fb7061c$export$6badb0ecde4e0bd0)).finally((0, $b4e14b6b8da86996$export$d91ec774a0e3eb9e));
    };
    const unregister = ()=>{
        (0, $b4e14b6b8da86996$export$850e0ce216eef646)(), (0, $9711acd2da3d5569$export$d3d611f163395585)(fa.Imei).then(()=>{
            delete (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).fencealarms[fa.Imei];
            (0, $b4e14b6b8da86996$export$5375cda95f0b0eb4).jump("/devices");
        }).catch((0, $62f894d94fb7061c$export$6badb0ecde4e0bd0)).finally((0, $b4e14b6b8da86996$export$d91ec774a0e3eb9e));
    };
    (0, $b4e14b6b8da86996$export$8390d50e515c191d)((0, $62f894d94fb7061c$export$4b0227fa4b29008b)("small", (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).title(`FenceAlarm ${fa.Metadata.Name}`, "is-4"), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).subtitle(`IMEI: ${fa.Imei}`, "is-6"), voltageAlarm.element, calibration.element, subscription.element, sharing.element, tags.element, name.element, owner.element, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).buttons((0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).button({
        onClick: save,
        styles: [
            "is-primary"
        ]
    }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.save), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).button({
        onClick: ()=>(0, $b4e14b6b8da86996$export$5375cda95f0b0eb4).jump(`/devices?id=${fa.Imei}`),
        styles: [
            "is-primary"
        ]
    }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.back), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).button({
        disabled: !isOwner,
        onClick: ()=>(0, $ab051bb815711afd$export$41b98bdd4d492efc)("FenceAlarm", unregister),
        styles: [
            "is-danger"
        ]
    }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.unregister))));
}
/**
 * @param {Fencealarm} fa
 */ function $923c6e19f10de8cd$var$voltageAlarmField(fa) {
    const isSubscribed = fa.Subscription.PriceIds.Current !== "" || Date.now() < new Date(fa.Subscription.ExpiresAt).getTime();
    const onOffSelect = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).select({
        disabled: !isSubscribed,
        options: [
            (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).option((0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.on, "on", isSubscribed && fa.VoltageAlarm.Enabled),
            (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).option((0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.off, "off", !isSubscribed || !fa.VoltageAlarm.Enabled)
        ]
    });
    /** @type {(level: number) => HTMLOptionElement} */ const thresholdOption = (threshold)=>(0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).option(`${threshold} V`, threshold.toString(), threshold === fa.Config.AlarmLevel);
    const thresholdSelect = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).select({
        options: [
            thresholdOption(2000),
            thresholdOption(3000),
            thresholdOption(4000),
            thresholdOption(5000),
            thresholdOption(6000),
            thresholdOption(7000),
            thresholdOption(8000)
        ]
    });
    const element = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).field({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).label((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
        enGB: "Voltage alarm",
        deDE: "Spannungsalarm",
        frFR: "Alarme de tension",
        svSE: "Sp\xe4nningslarm"
    })), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).field({
        styles: [
            "is-grouped"
        ]
    }, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({}, onOffSelect.element), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({}, thresholdSelect.element)));
    return {
        element: element,
        isEnabled: ()=>onOffSelect.getValue() === "on",
        getThreshold: ()=>+thresholdSelect.getValue()
    };
}
/**
 * @param {Fencealarm} fa
 */ function $923c6e19f10de8cd$var$calibrationField(fa) {
    const onOffSelect = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).select({
        options: [
            (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).option((0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.on, "on", fa.Calibration.ScalingFactor > 1),
            (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).option((0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.off, "off", fa.Calibration.ScalingFactor === 1)
        ]
    });
    const expectedVoltage = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).input({
        type: "text",
        placeholder: (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
            enGB: "Expected voltage",
            deDE: "Erwartete Spannung",
            frFR: "Tension attendue",
            svSE: "F\xf6rv\xe4ntad sp\xe4nning"
        }),
        value: fa.Calibration.ScalingFactor > 1 ? fa.Calibration.ExpectedVoltage.toString() : ""
    });
    const field = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).field({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).label((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
        enGB: "Calibration",
        deDE: "Kalibrierung",
        frFR: "Calibrage",
        svSE: "Kalibrering"
    })), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).field({
        styles: [
            "is-grouped"
        ]
    }, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({}, onOffSelect.element), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({}, expectedVoltage.element)));
    return {
        element: field,
        isEnabled: ()=>onOffSelect.getValue() === "on",
        getVoltage: ()=>+expectedVoltage.getValue()
    };
}






/**
 * @param {string} imei 
 * @param {string} name 
 * @returns {Promise<Fencealarm>}
 */ async function $9f10ca319f99abda$export$2147f4a35ca6f9d5(imei, name) {
    const res = await (0, $5ca15832b8c5d5ea$export$299ba2dee77727e9)(`/users/${(await (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).getActiveUser()).Id}/fencealarms`, {
        body: JSON.stringify({
            Imei: imei,
            Name: name
        })
    });
    if (!res.ok) throw await (0, $1fb5d845307c571c$export$f00cf23da648bc9b)(res);
    return res.json();
}









/**
 * @type {import("navigo").Handler}
 */ function $ad9322608265fad6$export$f42f16a7fbcea33a() {
    const scan = ()=>{
        (0, $1d17319f79c68be8$export$7564757b89ba44f1)((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
            enGB: "Scan the IMEI barcode. If the barcode is not recognized, enter the IMEI manually.",
            deDE: "Scannen Sie den IMEI-Strichcode. Wenn der Barcode nicht erkannt wird, geben Sie die IMEI manuell ein.",
            frFR: "Scannez le code-barres IMEI. Si le code-barres n'est pas reconnu, saisissez l'IMEI manuellement.",
            svSE: "Skanna streckkoden f\xf6r IMEI. Om streckkoden inte k\xe4nns igen anger du IMEI manuellt."
        })).then((code)=>{
            if (!code) return;
            imei.setValue(code);
        });
    };
    const imei = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).input({
        type: "text"
    });
    const name = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).input({
        type: "text"
    });
    (0, $b4e14b6b8da86996$export$8390d50e515c191d)((0, $62f894d94fb7061c$export$4b0227fa4b29008b)("small", (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).level((0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).levelLeft((0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).levelItem((0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).title((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
        enGB: "Register FenceAlarm",
        deDE: "Registrieren FenceAlarm",
        frFR: "Enregistrez FenceAlarm",
        svSE: "Registrera FenceAlarm"
    }), "is-4"))), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).levelRight((0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).levelItem((0, $1abc8d719eea79cd$export$e1dd10d13c5a06).icon({
        id: "help",
        onClick: ()=>window.open((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
                enGB: "https://support.luda.farm/en/support/solutions/folders/14000129703",
                deDE: "https://support.luda.farm/de/support/solutions/folders/14000129703",
                frFR: "https://support.luda.farm/fr/support/solutions/folders/14000129703",
                svSE: "https://support.luda.farm/sv-SE/support/solutions/folders/14000129703"
            }), "_blank")
    })))), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).field({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).label("IMEI"), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).field({
        styles: (0, $1d17319f79c68be8$export$d70a5ce4bc79c42d) ? [
            "has-addons"
        ] : undefined
    }, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({
        styles: [
            "is-expanded"
        ]
    }, imei.element), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({
        hidden: !(0, $1d17319f79c68be8$export$d70a5ce4bc79c42d)
    }, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).button({
        onClick: scan
    }, (0, $1abc8d719eea79cd$export$e1dd10d13c5a06).icon({
        id: "barcode",
        alignment: "right"
    }))))), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).field({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).label((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
        enGB: "Choose a name for your device",
        deDE: "W\xe4hlen Sie einen Namen f\xfcr Ihr Ger\xe4t",
        frFR: "Choisissez un nom pour votre appareil",
        svSE: "V\xe4lj ett namn f\xf6r din enhet"
    })), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({}, name.element)), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).field({
        styles: [
            "is-grouped"
        ]
    }, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).button({
        onClick: onClickRegister,
        styles: [
            "is-primary"
        ]
    }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.register)), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).button({
        onClick: ()=>(0, $b4e14b6b8da86996$export$5375cda95f0b0eb4).jump("/devices/register"),
        styles: [
            "is-primary"
        ]
    }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.back)))));
    function onClickRegister() {
        (0, $b4e14b6b8da86996$export$850e0ce216eef646)();
        (0, $9f10ca319f99abda$export$2147f4a35ca6f9d5)(imei.getValue(), name.getValue()).then((fa)=>{
            (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).fencealarms[fa.Imei] = fa;
            (0, $b4e14b6b8da86996$export$5375cda95f0b0eb4).jump("/devices" + (0, $820877bea407f5fe$export$89a7e74069fbb7af)({
                id: fa.Imei
            }));
        }).finally((0, $b4e14b6b8da86996$export$d91ec774a0e3eb9e));
    }
}












async function $865d7751aa44085b$export$65871cdad673f4d5(imei, days) {
    const res = await (0, $5ca15832b8c5d5ea$export$327f7b26ebf455db)(`/fencealarm2s/${imei}/trial`, {
        body: JSON.stringify({
            Days: days
        })
    });
    if (!res.ok) throw (0, $1fb5d845307c571c$export$f00cf23da648bc9b)(res);
    return res.json();
}


async function $15abd1f8aa5f0cdf$export$514f615059d1e082(ctx) {
    if (!ctx.data?.imei) throw "missing ctx.data.imei";
    const page = (0, $75d47fd8903c7af6$export$90a44edba14e47be)({
        fa2: await (0, $e02c85f02889dc78$export$c94d5c2644851db2)(ctx.data.imei),
        fota: {
            checksum: "",
            url: "coap://<host>:5683/<fw>"
        },
        loading: false,
        trial: {
            days: ""
        }
    });
    const onClickAddTrial = ()=>{
        page.loading = true;
        (0, $865d7751aa44085b$export$65871cdad673f4d5)(page.fa2.Imei, +page.trial.days).then((fa2)=>{
            page.fa2 = fa2;
        }).catch((0, $62f894d94fb7061c$export$6badb0ecde4e0bd0)).finally(()=>{
            page.loading = false;
        });
    };
    const onClickImpersonate = ()=>{
        page.loading = true;
        (0, $06080a0822a84457$export$c4a2249e3be1ab76)("fencealarm2", page.fa2.Imei).then((user)=>(0, $bfc59006cf644cf7$export$ca000e230c0caa3e).startImpersonating(user)).then(()=>(0, $b4e14b6b8da86996$export$5375cda95f0b0eb4).jump("/devices")).catch((0, $62f894d94fb7061c$export$6badb0ecde4e0bd0)).finally(()=>{
            page.loading = false;
        });
    };
    const onClickUploadFota = ()=>{
        page.loading = true;
        (0, $e02c85f02889dc78$export$d003b69284bad423)(page.fa2.Imei, {
            Checksum: page.fota.checksum,
            Url: page.fota.url
        }).catch((0, $62f894d94fb7061c$export$6badb0ecde4e0bd0)).finally(()=>{
            page.loading = false;
        });
    };
    return (0, $e47741cb5fbbb614$export$4b0227fa4b29008b)({
        size: "narrow"
    }, (0, $01d3af8f1b8eef63$export$80e4b313e5e6b30d)({
        class: "breadcrumb"
    }, (0, $01d3af8f1b8eef63$export$b5023c870cb34848)((0, $01d3af8f1b8eef63$export$19caeaf7d9d84644)((0, $01d3af8f1b8eef63$export$407448d2b89b1813)({
        onclick: ()=>(0, $b4e14b6b8da86996$export$5375cda95f0b0eb4).jump("/admin")
    }, "Admin")), (0, $01d3af8f1b8eef63$export$19caeaf7d9d84644)((0, $01d3af8f1b8eef63$export$407448d2b89b1813)("FenceAlarm2")))), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
        class: "buttons"
    }, (0, $01d3af8f1b8eef63$export$2ba01fb71ed41cb6)({
        class: ()=>page.loading ? "button is-primary is-loading" : "button is-primary",
        disabled: ()=>page.loading,
        onclick: onClickImpersonate
    }, "Impersonate owner")), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
        class: "field has-addons"
    }, (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
        class: "control is-expanded"
    }, (0, $01d3af8f1b8eef63$export$b7e3ae3d7c15e42e)({
        class: "input",
        oninput: (e)=>{
            page.trial.days = e.target.value.replace(/\D/g, "");
            e.target.value = page.trial.days;
        },
        placeholder: "Days"
    })), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
        class: "control"
    }, (0, $01d3af8f1b8eef63$export$2ba01fb71ed41cb6)({
        class: ()=>page.loading ? "button is-primary is-loading" : "button is-primary",
        disabled: ()=>page.loading,
        onclick: onClickAddTrial
    }, "Add trial"))), (0, $01d3af8f1b8eef63$export$b4adb3f464574dcf)(), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
        class: "field"
    }, (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
        class: "control"
    }, (0, $01d3af8f1b8eef63$export$b7e3ae3d7c15e42e)({
        class: "input",
        oninput: (e)=>{
            page.fota.url = e.target.value;
        },
        value: ()=>page.fota.url
    }))), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
        class: "field"
    }, (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
        class: "control"
    }, (0, $01d3af8f1b8eef63$export$b7e3ae3d7c15e42e)({
        class: "input",
        oninput: (e)=>{
            page.fota.checksum = e.target.value;
        },
        placeholder: "Checksum"
    }, ()=>page.fota.checksum))), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
        class: "field"
    }, (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
        class: "control"
    }, (0, $01d3af8f1b8eef63$export$2ba01fb71ed41cb6)({
        class: ()=>page.loading ? "button is-primary is-loading" : "button is-primary",
        disabled: ()=>page.loading,
        onclick: onClickUploadFota
    }, "Upload FOTA config"))), (0, $01d3af8f1b8eef63$export$b4adb3f464574dcf)(), (0, $01d3af8f1b8eef63$export$2af2ac64526e2aa9)({
        class: "is-tiny-mobile"
    }, ()=>JSON.stringify(page.fa2, null, 2)));
}









/**
 * @type {import('navigo').Handler}
 */ async function $33c6fd7908b7dc89$export$264a6a03855ffdf6(ctx) {
    if (!ctx || !ctx.data || !ctx.data.imei) throw "missing ctx.data.imei";
    const fa2 = (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).fencealarm2s[ctx.data.imei];
    const voltageChart = (0, $c95c45af3fcfd77e$export$88642ec15bb62ae0)({
        label: (0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.voltage,
        unit: "Volt",
        device: {
            type: "FenceAlarm2",
            serialNumber: fa2.Imei
        },
        getData: getVoltage
    });
    await (0, $b4e14b6b8da86996$export$8390d50e515c191d)((0, $62f894d94fb7061c$export$4b0227fa4b29008b)("large", (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).title(fa2.Metadata.Name), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).subtitle(`IMEI: ${fa2.Imei}`), document.createElement("hr"), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).title((0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.voltage, "is-5"), voltageChart.element, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).buttons((0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).button({
        onClick: ()=>(0, $b4e14b6b8da86996$export$5375cda95f0b0eb4).jump(`/devices?id=${fa2.Imei}`),
        styles: [
            "is-primary"
        ]
    }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.back))));
    voltageChart.mount();
    /**
	 * @param {Date} from
	 * @param {Date} to
	 * @param {"csv"|"json"|"xlsx"} format
	 * @returns {Promise<import('../device/device_log_chart').DataPoint[]|Blob>}
	 */ async function getVoltage(from, to, format) {
        const res = await (0, $e02c85f02889dc78$export$ccbacfa6860d6eff)(fa2.Imei, {
            from: from.toISOString(),
            to: to.toISOString(),
            format: format
        });
        if (res instanceof Blob) return res;
        else return res.map((log)=>({
                value: log.Voltage,
                timestamp: log.Timestamp
            }));
    }
}





/**
 * @param {string} imei 
 */ async function $a30be86220d949d5$export$21c5e64758096230(imei) {
    const res = await (0, $5ca15832b8c5d5ea$export$1d2f21e549771e67)(`/fencealarm2s/${imei}`);
    if (!res.ok) throw await (0, $1fb5d845307c571c$export$f00cf23da648bc9b)(res);
}
/**
 * @typedef {Object} PutFencealarm2Body
 * @property {PutFencealarm2BodyVoltageAlarm} VoltageAlarm
 * @property {PutDeviceMetadata} Metadata
 * @property {string} Subscription
 * 
 * @typedef {Object} PutFencealarm2BodyVoltageAlarm
 * @property {boolean} Enabled
 * @property {number} Threshold
 * 
 * @typedef {Object} PutDeviceMetadata
 * @property {string[]} Access
 * @property {string[]} Notify
 * @property {string[]} Tags
 * @property {string} Name
 * @property {string} Owner
 * 
 * @param {string} imei 
 * @param {PutFencealarm2Body} body 
 */ async function $a30be86220d949d5$export$402d85a64fa7472f(imei, body) {
    const res = await (0, $5ca15832b8c5d5ea$export$327f7b26ebf455db)(`/fencealarm2s/${imei}`, {
        body: JSON.stringify(body)
    });
    if (!res.ok) throw await (0, $1fb5d845307c571c$export$f00cf23da648bc9b)(res);
    return res.json();
}









/**
 * @type {import('navigo').Handler}
 */ async function $d642dbca17452284$export$f105b8f7080dc9b6(ctx) {
    if (!ctx || !ctx.data || !ctx.data.imei) throw "missing ctx.data.imei";
    const fa2 = (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).fencealarm2s[ctx.data.imei];
    const user = await (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).getActiveUser();
    const currency = user.Country === "SE" ? "SEK" : "EUR";
    const isOwner = user.Email === fa2.Metadata.OwnerEmail;
    const { Fencealarm2Month: Fencealarm2Month, Fencealarm2Year: Fencealarm2Year } = await (0, $26a5802c7b7183d2$export$41303c5fee299aff)();
    const voltageAlarm = $d642dbca17452284$var$voltageAlarmField(fa2);
    const subscription = (0, $b01f22cb9334aa3d$export$b5d7b3b664095c3)(fa2.Subscription, [
        Fencealarm2Month,
        Fencealarm2Year
    ], currency, isOwner);
    const sharing = (0, $b01f22cb9334aa3d$export$c52b6e40375164c0)(fa2.Metadata);
    const tags = (0, $b01f22cb9334aa3d$export$113fbad7a8f79300)(fa2.Metadata);
    const name = (0, $b01f22cb9334aa3d$export$b6f1a49de680b8fc)(fa2.Metadata.Name);
    const owner = (0, $b01f22cb9334aa3d$export$1b5a05bb5c2dadb2)(fa2.Metadata, isOwner);
    const save = ()=>{
        (0, $b4e14b6b8da86996$export$850e0ce216eef646)();
        (0, $a30be86220d949d5$export$402d85a64fa7472f)(fa2.Imei, {
            VoltageAlarm: {
                Enabled: voltageAlarm.isEnabled(),
                Threshold: +voltageAlarm.getThreshold()
            },
            Metadata: {
                Access: sharing.getAccess(),
                Notify: sharing.getNotify(),
                Tags: tags.getValue(),
                Name: name.getValue(),
                Owner: owner.getValue()
            },
            Subscription: subscription.getPriceId()
        }).then((fa2)=>{
            (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).fencealarm2s[fa2.Imei] = fa2;
            (0, $b4e14b6b8da86996$export$5375cda95f0b0eb4).jump(`/devices?id=${fa2.Imei}`);
        }).catch((0, $62f894d94fb7061c$export$6badb0ecde4e0bd0)).finally((0, $b4e14b6b8da86996$export$d91ec774a0e3eb9e));
    };
    const unregister = ()=>{
        (0, $b4e14b6b8da86996$export$850e0ce216eef646)();
        (0, $a30be86220d949d5$export$21c5e64758096230)(fa2.Imei).then(()=>{
            delete (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).fencealarm2s[fa2.Imei];
            (0, $b4e14b6b8da86996$export$5375cda95f0b0eb4).jump("/devices");
        }).catch((0, $62f894d94fb7061c$export$6badb0ecde4e0bd0)).finally((0, $b4e14b6b8da86996$export$d91ec774a0e3eb9e));
    };
    (0, $b4e14b6b8da86996$export$8390d50e515c191d)((0, $62f894d94fb7061c$export$4b0227fa4b29008b)("small", (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).title(`FenceAlarm2 - ${fa2.Metadata.Name}`, "is-4"), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).subtitle(`IMEI: ${fa2.Imei}`, "is-6"), voltageAlarm.element, subscription.element, sharing.element, tags.element, name.element, owner.element, document.createElement("hr"), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).buttons((0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).button({
        onClick: save,
        styles: [
            "is-primary"
        ]
    }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.save), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).button({
        onClick: ()=>(0, $b4e14b6b8da86996$export$5375cda95f0b0eb4).jump(`/devices?id=${fa2.Imei}`),
        styles: [
            "is-primary"
        ]
    }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.back), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).button({
        disabled: !isOwner,
        onClick: ()=>(0, $ab051bb815711afd$export$41b98bdd4d492efc)("FenceAlarm2", unregister),
        styles: [
            "is-danger"
        ]
    }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.unregister))));
}
/**
 * @param {Fencealarm2} fa2
 */ function $d642dbca17452284$var$voltageAlarmField(fa2) {
    const isSubscribed = fa2.Subscription.PriceIds.Current !== "" || Date.now() < new Date(fa2.Subscription.ExpiresAt).getTime();
    const onOffSelect = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).select({
        disabled: !isSubscribed,
        options: [
            (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).option((0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.on, "on", isSubscribed && fa2.VoltageAlarm.Enabled),
            (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).option((0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.off, "off", !isSubscribed || !fa2.VoltageAlarm.Enabled)
        ]
    });
    let selectedAlarmLevel = fa2.Config_v0_3.AlarmLevel;
    if (fa2.PendingResponse_v0_3 && fa2.PendingResponse_v0_3.Config) selectedAlarmLevel = fa2.PendingResponse_v0_3.Config.AlarmLevel;
    const alarmLevelSelect = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).select({
        options: Array.from({
            length: 7
        }, (_, i)=>(i + 2) * 1000).map((i)=>(0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).option(`${i} V`, i.toString(), i === selectedAlarmLevel))
    });
    const element = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).field({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).label((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
        enGB: "Voltage alarm",
        deDE: "Spannungsalarm",
        frFR: "Alarme de tension",
        svSE: "Sp\xe4nningslarm"
    })), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).field({
        styles: [
            "is-grouped"
        ]
    }, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({}, onOffSelect.element), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({}, alarmLevelSelect.element)));
    return {
        element: element,
        isEnabled: ()=>onOffSelect.getValue() === "on",
        getThreshold: ()=>alarmLevelSelect.getValue()
    };
}






/**
 * @param {string} imei 
 * @param {string} name 
 * @returns {Promise<Fencealarm2>}
 */ async function $5e6d13485e6c5101$export$efdc3b7c3818e894(imei, name) {
    const res = await (0, $5ca15832b8c5d5ea$export$299ba2dee77727e9)(`/users/${(await (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).getActiveUser()).Id}/fencealarm2s`, {
        body: JSON.stringify({
            Imei: imei,
            Name: name
        })
    });
    if (!res.ok) throw await (0, $1fb5d845307c571c$export$f00cf23da648bc9b)(res);
    return res.json();
}









/**
 * @type {import("navigo").Handler}
 */ function $f03ad35c8320b7fa$export$ef64baa32f7512e2() {
    const scan = ()=>{
        (0, $1d17319f79c68be8$export$7564757b89ba44f1)((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
            enGB: "Scan the IMEI barcode. If the barcode is not recognized, enter the IMEI manually.",
            deDE: "Scannen Sie den IMEI-Strichcode. Wenn der Barcode nicht erkannt wird, geben Sie die IMEI manuell ein.",
            frFR: "Scannez le code-barres IMEI. Si le code-barres n'est pas reconnu, saisissez l'IMEI manuellement.",
            svSE: "Skanna streckkoden f\xf6r IMEI. Om streckkoden inte k\xe4nns igen anger du IMEI manuellt."
        })).then((code)=>{
            if (!code) return;
            imei.setValue(code);
        });
    };
    const imei = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).input({
        type: "text"
    });
    const name = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).input({
        type: "text"
    });
    (0, $b4e14b6b8da86996$export$8390d50e515c191d)((0, $62f894d94fb7061c$export$4b0227fa4b29008b)("small", (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).level((0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).levelLeft((0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).levelItem((0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).title((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
        enGB: "Register FenceAlarm2",
        deDE: "Registrieren FenceAlarm2",
        frFR: "Enregistrez FenceAlarm2",
        svSE: "Registrera FenceAlarm2"
    }), "is-4"))), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).levelRight((0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).levelItem((0, $1abc8d719eea79cd$export$e1dd10d13c5a06).icon({
        id: "help",
        onClick: ()=>window.open((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
                enGB: "https://support.luda.farm/en/support/solutions/folders/14000129703",
                deDE: "https://support.luda.farm/de/support/solutions/folders/14000129703",
                frFR: "https://support.luda.farm/fr/support/solutions/folders/14000129703",
                svSE: "https://support.luda.farm/sv-SE/support/solutions/folders/14000129703"
            }), "_blank")
    })))), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).field({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).label("IMEI"), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).field({
        styles: (0, $1d17319f79c68be8$export$d70a5ce4bc79c42d) ? [
            "has-addons"
        ] : undefined
    }, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({
        styles: [
            "is-expanded"
        ]
    }, imei.element), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({
        hidden: !(0, $1d17319f79c68be8$export$d70a5ce4bc79c42d)
    }, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).button({
        onClick: scan
    }, (0, $1abc8d719eea79cd$export$e1dd10d13c5a06).icon({
        id: "qr_code_2",
        alignment: "right"
    }))))), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).field({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).label((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
        enGB: "Choose a name for your device",
        deDE: "W\xe4hlen Sie einen Namen f\xfcr Ihr Ger\xe4t",
        frFR: "Choisissez un nom pour votre appareil",
        svSE: "V\xe4lj ett namn f\xf6r din enhet"
    })), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({}, name.element)), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).field({
        styles: [
            "is-grouped"
        ]
    }, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).button({
        onClick: onClickRegister,
        styles: [
            "is-primary"
        ]
    }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.register)), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).button({
        onClick: ()=>(0, $b4e14b6b8da86996$export$5375cda95f0b0eb4).jump("/devices/register"),
        styles: [
            "is-primary"
        ]
    }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.back)))));
    function onClickRegister() {
        (0, $b4e14b6b8da86996$export$850e0ce216eef646)();
        (0, $5e6d13485e6c5101$export$efdc3b7c3818e894)(imei.getValue(), name.getValue()).then((fa2)=>{
            (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).fencealarm2s[fa2.Imei] = fa2;
            (0, $b4e14b6b8da86996$export$5375cda95f0b0eb4).jump("/devices" + (0, $820877bea407f5fe$export$89a7e74069fbb7af)({
                id: fa2.Imei
            }));
            (0, $62f894d94fb7061c$export$73e19c0339806233)();
        }).finally((0, $b4e14b6b8da86996$export$d91ec774a0e3eb9e));
    }
}












/**
 * @param {string} id 
 */ async function $ca0eecf8f22a8802$export$cdb95d66ca8c6a64(id) {
    const res = await (0, $5ca15832b8c5d5ea$export$1d2f21e549771e67)(`/notices/${id}`);
    if (!res.ok) throw await (0, $1fb5d845307c571c$export$f00cf23da648bc9b)(res);
}
/**
 * @param {boolean} isPublic 
 * @returns {Promise<Notice[]>}
 */ async function $ca0eecf8f22a8802$export$191a53f0baf42f68(isPublic) {
    const url = isPublic ? "/notices?public" : "/notices";
    const res = await (0, $5ca15832b8c5d5ea$export$3988ae62b71be9a3)(url);
    if (!res.ok) throw (0, $1fb5d845307c571c$export$f00cf23da648bc9b)(res);
    return res.json();
}
/**
 * 
 * @param {Object} notice
 * @param {boolean} notice.Public
 * @param {string} notice.English
 * @param {string} notice.French
 * @param {string} notice.German
 * @param {string} notice.Swedish
 * @returns 
 */ async function $ca0eecf8f22a8802$export$8a28dad93982a3c0(notice) {
    const res = await (0, $5ca15832b8c5d5ea$export$299ba2dee77727e9)("/notices", {
        body: JSON.stringify(notice)
    });
    if (!res.ok) throw (0, $1fb5d845307c571c$export$f00cf23da648bc9b)(res);
    return res.json();
}


/**
 * @type {import('navigo').Handler}
 */ async function $ee33a905b5218ffb$export$3fc57ce5e4ed10c9(ctx) {
    const notices = await (0, $ca0eecf8f22a8802$export$191a53f0baf42f68)(false);
    const english = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).input({
        type: "text"
    });
    const french = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).input({
        type: "text"
    });
    const german = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).input({
        type: "text"
    });
    const swedish = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).input({
        type: "text"
    });
    const isPublic = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).checkbox({
        text: "Public"
    });
    /**
	 * @param {Notice} notice
	 */ function newNoticeRow(notice) {
        const row = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).tableRow({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).tableDataCell(notice.English), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).tableDataCell((0, $1abc8d719eea79cd$export$e1dd10d13c5a06).icon({
            id: notice.Public ? "visibility" : "visibility_off"
        })), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).tableDataCell((0, $1abc8d719eea79cd$export$e1dd10d13c5a06).icon({
            id: "content_copy",
            onClick: onClickCopy
        })), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).tableDataCell((0, $1abc8d719eea79cd$export$e1dd10d13c5a06).icon({
            id: "close",
            onClick: onClickDelete
        })));
        function onClickCopy() {
            isPublic.setChecked(notice.Public);
            english.setValue(notice.English);
            french.setValue(notice.French);
            german.setValue(notice.German);
            swedish.setValue(notice.Swedish);
        }
        function onClickDelete() {
            (0, $b4e14b6b8da86996$export$850e0ce216eef646)();
            (0, $ca0eecf8f22a8802$export$cdb95d66ca8c6a64)(notice.Id).then(()=>row.remove()).catch((0, $62f894d94fb7061c$export$6badb0ecde4e0bd0)).finally((0, $b4e14b6b8da86996$export$d91ec774a0e3eb9e));
        }
        return row;
    }
    (0, $b4e14b6b8da86996$export$8390d50e515c191d)((0, $62f894d94fb7061c$export$4b0227fa4b29008b)("large", (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).breadcrumb((0, $00995e7d83a33b33$export$13f9d3c4397c4713).anchor({
        onClick: ()=>(0, $b4e14b6b8da86996$export$5375cda95f0b0eb4).jump("/admin")
    }, "Admin"), (0, $00995e7d83a33b33$export$13f9d3c4397c4713).anchor({}, "Notices")), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).table({
        classList: [
            "is-fullwidth"
        ],
        body: notices.map(newNoticeRow)
    }), document.createElement("hr"), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).field({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).label("English"), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({}, english.element)), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).field({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).label("French"), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({}, french.element)), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).field({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).label("German"), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({}, german.element)), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).field({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).label("Swedish"), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({}, swedish.element)), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).field({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({}, isPublic.element)), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).field({
        styles: [
            "is-grouped",
            "is-grouped-multiline"
        ]
    }, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).button({
        onClick: onClickSave,
        styles: [
            "is-primary"
        ]
    }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.save)), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).button({
        onClick: onClickClear,
        styles: [
            "is-primary"
        ]
    }, "Clear")))));
    async function onClickClear() {
        isPublic.setChecked(false);
        english.setValue("");
        french.setValue("");
        german.setValue("");
        swedish.setValue("");
    }
    async function onClickSave() {
        (0, $b4e14b6b8da86996$export$850e0ce216eef646)();
        (0, $ca0eecf8f22a8802$export$8a28dad93982a3c0)({
            Public: isPublic.isChecked(),
            English: english.getValue(),
            French: french.getValue(),
            German: german.getValue(),
            Swedish: swedish.getValue()
        }).then((notice)=>$ee33a905b5218ffb$export$3fc57ce5e4ed10c9(ctx)).catch((0, $62f894d94fb7061c$export$6badb0ecde4e0bd0)).finally((0, $b4e14b6b8da86996$export$d91ec774a0e3eb9e));
    }
}







async function $6cfab0c934c7a79b$export$2ff8a5b59054623b() {
    let notices = await (0, $ca0eecf8f22a8802$export$191a53f0baf42f68)(true);
    const noticeIds = notices.map((n)=>n.Id);
    // cleanup read notice ids
    /** @type {string[]} */ let readNoticeIds = JSON.parse(await (0, $744d2dad838f829a$export$f92dfeb71e9bb569)("read-notice-ids") || "[]");
    readNoticeIds = readNoticeIds.filter((id)=>noticeIds.includes(id));
    await (0, $744d2dad838f829a$export$8a8216c44337cd5)("read-notice-ids", JSON.stringify(readNoticeIds));
    // remove read notices
    notices = notices.filter((n)=>!readNoticeIds.includes(n.Id));
    return (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).section({
        hidden: notices.length < 1
    }, ...notices.map((n)=>$6cfab0c934c7a79b$var$noticeCard(n)));
}
/**
 * @param {Notice} notice 
 */ function $6cfab0c934c7a79b$var$noticeCard(notice) {
    const setRead = async ()=>{
        const parent = card.parentElement;
        if (!parent) return;
        // add to read ids
        const readNoticeIds = JSON.parse(await (0, $744d2dad838f829a$export$f92dfeb71e9bb569)("read-notice-ids") || "[]");
        readNoticeIds.push(notice.Id);
        await (0, $744d2dad838f829a$export$8a8216c44337cd5)("read-notice-ids", JSON.stringify(readNoticeIds));
        // remove card and hide section if empty
        card.remove();
        if (!parent.hasChildNodes()) parent.classList.add("is-hidden");
    };
    const card = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).card((0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).cardHeader({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).cardHeaderTitle((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
        enGB: notice.English,
        deDE: notice.German,
        frFR: notice.French,
        svSE: notice.Swedish
    })), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).cardHeaderIcon((0, $1abc8d719eea79cd$export$e1dd10d13c5a06).icon({
        id: "close",
        onClick: setRead
    }))));
    return card;
}


var $f993037a9863bffd$exports = {};
!function(t, n) {
    $f993037a9863bffd$exports = n();
}("undefined" != typeof self ? self : $f993037a9863bffd$exports, function() {
    return function() {
        "use strict";
        var t = {
            407: function(t, n, e) {
                e.d(n, {
                    default: function() {
                        return N;
                    }
                });
                var o = /([:*])(\w+)/g, r = /\*/g, i = /\/\?/g;
                function a(t) {
                    return void 0 === t && (t = "/"), v() ? location.pathname + location.search + location.hash : t;
                }
                function s(t) {
                    return t.replace(/\/+$/, "").replace(/^\/+/, "");
                }
                function c(t) {
                    return "string" == typeof t;
                }
                function u(t) {
                    return t && t.indexOf("#") >= 0 && t.split("#").pop() || "";
                }
                function h(t) {
                    var n = s(t).split(/\?(.*)?$/);
                    return [
                        s(n[0]),
                        n.slice(1).join("")
                    ];
                }
                function f(t) {
                    for(var n = {}, e = t.split("&"), o = 0; o < e.length; o++){
                        var r = e[o].split("=");
                        if ("" !== r[0]) {
                            var i = decodeURIComponent(r[0]);
                            n[i] ? (Array.isArray(n[i]) || (n[i] = [
                                n[i]
                            ]), n[i].push(decodeURIComponent(r[1] || ""))) : n[i] = decodeURIComponent(r[1] || "");
                        }
                    }
                    return n;
                }
                function l(t, n) {
                    var e, a = h(s(t.currentLocationPath)), l = a[0], p = a[1], d = "" === p ? null : f(p), v = [];
                    if (c(n.path)) {
                        if (e = "(?:/^|^)" + s(n.path).replace(o, function(t, n, e) {
                            return v.push(e), "([^/]+)";
                        }).replace(r, "?(?:.*)").replace(i, "/?([^/]+|)") + "$", "" === s(n.path) && "" === s(l)) return {
                            url: l,
                            queryString: p,
                            hashString: u(t.to),
                            route: n,
                            data: null,
                            params: d
                        };
                    } else e = n.path;
                    var g = new RegExp(e, ""), m = l.match(g);
                    if (m) {
                        var y = c(n.path) ? function(t, n) {
                            return 0 === n.length ? null : t ? t.slice(1, t.length).reduce(function(t, e, o) {
                                return null === t && (t = {}), t[n[o]] = decodeURIComponent(e), t;
                            }, null) : null;
                        }(m, v) : m.groups ? m.groups : m.slice(1);
                        return {
                            url: s(l.replace(new RegExp("^" + t.instance.root), "")),
                            queryString: p,
                            hashString: u(t.to),
                            route: n,
                            data: y,
                            params: d
                        };
                    }
                    return !1;
                }
                function p() {
                    return !("undefined" == typeof window || !window.history || !window.history.pushState);
                }
                function d(t, n) {
                    return void 0 === t[n] || !0 === t[n];
                }
                function v() {
                    return "undefined" != typeof window;
                }
                function g(t, n) {
                    return void 0 === t && (t = []), void 0 === n && (n = {}), t.filter(function(t) {
                        return t;
                    }).forEach(function(t) {
                        [
                            "before",
                            "after",
                            "already",
                            "leave"
                        ].forEach(function(e) {
                            t[e] && (n[e] || (n[e] = []), n[e].push(t[e]));
                        });
                    }), n;
                }
                function m(t, n, e) {
                    var o = n || {}, r = 0;
                    !function n() {
                        t[r] ? Array.isArray(t[r]) ? (t.splice.apply(t, [
                            r,
                            1
                        ].concat(t[r][0](o) ? t[r][1] : t[r][2])), n()) : t[r](o, function(t) {
                            void 0 === t || !0 === t ? (r += 1, n()) : e && e(o);
                        }) : e && e(o);
                    }();
                }
                function y(t, n) {
                    void 0 === t.currentLocationPath && (t.currentLocationPath = t.to = a(t.instance.root)), t.currentLocationPath = t.instance._checkForAHash(t.currentLocationPath), n();
                }
                function _(t, n) {
                    for(var e = 0; e < t.instance.routes.length; e++){
                        var o = l(t, t.instance.routes[e]);
                        if (o && (t.matches || (t.matches = []), t.matches.push(o), "ONE" === t.resolveOptions.strategy)) return void n();
                    }
                    n();
                }
                function k(t, n) {
                    t.navigateOptions && (void 0 !== t.navigateOptions.shouldResolve && console.warn('"shouldResolve" is deprecated. Please check the documentation.'), void 0 !== t.navigateOptions.silent && console.warn('"silent" is deprecated. Please check the documentation.')), n();
                }
                function O(t, n) {
                    !0 === t.navigateOptions.force ? (t.instance._setCurrent([
                        t.instance._pathToMatchObject(t.to)
                    ]), n(!1)) : n();
                }
                m.if = function(t, n, e) {
                    return Array.isArray(n) || (n = [
                        n
                    ]), Array.isArray(e) || (e = [
                        e
                    ]), [
                        t,
                        n,
                        e
                    ];
                };
                var w = v(), L = p();
                function b(t, n) {
                    if (d(t.navigateOptions, "updateBrowserURL")) {
                        var e = ("/" + t.to).replace(/\/\//g, "/"), o = w && t.resolveOptions && !0 === t.resolveOptions.hash;
                        L ? (history[t.navigateOptions.historyAPIMethod || "pushState"](t.navigateOptions.stateObj || {}, t.navigateOptions.title || "", o ? "#" + e : e), location && location.hash && (t.instance.__freezeListening = !0, setTimeout(function() {
                            if (!o) {
                                var n = location.hash;
                                location.hash = "", location.hash = n;
                            }
                            t.instance.__freezeListening = !1;
                        }, 1))) : w && (window.location.href = t.to);
                    }
                    n();
                }
                function A(t, n) {
                    var e = t.instance;
                    e.lastResolved() ? m(e.lastResolved().map(function(n) {
                        return function(e, o) {
                            if (n.route.hooks && n.route.hooks.leave) {
                                var r = !1, i = t.instance.matchLocation(n.route.path, t.currentLocationPath, !1);
                                r = "*" !== n.route.path ? !i : !(t.matches && t.matches.find(function(t) {
                                    return n.route.path === t.route.path;
                                })), d(t.navigateOptions, "callHooks") && r ? m(n.route.hooks.leave.map(function(n) {
                                    return function(e, o) {
                                        return n(function(n) {
                                            !1 === n ? t.instance.__markAsClean(t) : o();
                                        }, t.matches && t.matches.length > 0 ? 1 === t.matches.length ? t.matches[0] : t.matches : void 0);
                                    };
                                }).concat([
                                    function() {
                                        return o();
                                    }
                                ])) : o();
                            } else o();
                        };
                    }), {}, function() {
                        return n();
                    }) : n();
                }
                function P(t, n) {
                    d(t.navigateOptions, "updateState") && t.instance._setCurrent(t.matches), n();
                }
                var R = [
                    function(t, n) {
                        var e = t.instance.lastResolved();
                        if (e && e[0] && e[0].route === t.match.route && e[0].url === t.match.url && e[0].queryString === t.match.queryString) return e.forEach(function(n) {
                            n.route.hooks && n.route.hooks.already && d(t.navigateOptions, "callHooks") && n.route.hooks.already.forEach(function(n) {
                                return n(t.match);
                            });
                        }), void n(!1);
                        n();
                    },
                    function(t, n) {
                        t.match.route.hooks && t.match.route.hooks.before && d(t.navigateOptions, "callHooks") ? m(t.match.route.hooks.before.map(function(n) {
                            return function(e, o) {
                                return n(function(n) {
                                    !1 === n ? t.instance.__markAsClean(t) : o();
                                }, t.match);
                            };
                        }).concat([
                            function() {
                                return n();
                            }
                        ])) : n();
                    },
                    function(t, n) {
                        d(t.navigateOptions, "callHandler") && t.match.route.handler(t.match), t.instance.updatePageLinks(), n();
                    },
                    function(t, n) {
                        t.match.route.hooks && t.match.route.hooks.after && d(t.navigateOptions, "callHooks") && t.match.route.hooks.after.forEach(function(n) {
                            return n(t.match);
                        }), n();
                    }
                ], S = [
                    A,
                    function(t, n) {
                        var e = t.instance._notFoundRoute;
                        if (e) {
                            t.notFoundHandled = !0;
                            var o = h(t.currentLocationPath), r = o[0], i = o[1], a = u(t.to);
                            e.path = s(r);
                            var c = {
                                url: e.path,
                                queryString: i,
                                hashString: a,
                                data: null,
                                route: e,
                                params: "" !== i ? f(i) : null
                            };
                            t.matches = [
                                c
                            ], t.match = c;
                        }
                        n();
                    },
                    m.if(function(t) {
                        return t.notFoundHandled;
                    }, R.concat([
                        P
                    ]), [
                        function(t, n) {
                            t.resolveOptions && !1 !== t.resolveOptions.noMatchWarning && void 0 !== t.resolveOptions.noMatchWarning || console.warn('Navigo: "' + t.currentLocationPath + "\" didn't match any of the registered routes."), n();
                        },
                        function(t, n) {
                            t.instance._setCurrent(null), n();
                        }
                    ])
                ];
                function E() {
                    return (E = Object.assign || function(t) {
                        for(var n = 1; n < arguments.length; n++){
                            var e = arguments[n];
                            for(var o in e)Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
                        }
                        return t;
                    }).apply(this, arguments);
                }
                function x(t, n) {
                    var e = 0;
                    A(t, function o() {
                        e !== t.matches.length ? m(R, E({}, t, {
                            match: t.matches[e]
                        }), function() {
                            e += 1, o();
                        }) : P(t, n);
                    });
                }
                function H(t) {
                    t.instance.__markAsClean(t);
                }
                function j() {
                    return (j = Object.assign || function(t) {
                        for(var n = 1; n < arguments.length; n++){
                            var e = arguments[n];
                            for(var o in e)Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
                        }
                        return t;
                    }).apply(this, arguments);
                }
                var C = "[data-navigo]";
                function N(t, n) {
                    var e, o = n || {
                        strategy: "ONE",
                        hash: !1,
                        noMatchWarning: !1,
                        linksSelector: C
                    }, r = this, i = "/", d = null, w = [], L = !1, A = p(), P = v();
                    function R(t) {
                        return t.indexOf("#") >= 0 && (t = !0 === o.hash ? t.split("#")[1] || "/" : t.split("#")[0]), t;
                    }
                    function E(t) {
                        return s(i + "/" + s(t));
                    }
                    function N(t, n, e, o) {
                        return t = c(t) ? E(t) : t, {
                            name: o || s(String(t)),
                            path: t,
                            handler: n,
                            hooks: g(e)
                        };
                    }
                    function U(t, n) {
                        if (!r.__dirty) {
                            r.__dirty = !0, t = t ? s(i) + "/" + s(t) : void 0;
                            var e = {
                                instance: r,
                                to: t,
                                currentLocationPath: t,
                                navigateOptions: {},
                                resolveOptions: j({}, o, n)
                            };
                            return m([
                                y,
                                _,
                                m.if(function(t) {
                                    var n = t.matches;
                                    return n && n.length > 0;
                                }, x, S)
                            ], e, H), !!e.matches && e.matches;
                        }
                        r.__waiting.push(function() {
                            return r.resolve(t, n);
                        });
                    }
                    function q(t, n) {
                        if (r.__dirty) r.__waiting.push(function() {
                            return r.navigate(t, n);
                        });
                        else {
                            r.__dirty = !0, t = s(i) + "/" + s(t);
                            var e = {
                                instance: r,
                                to: t,
                                navigateOptions: n || {},
                                resolveOptions: n && n.resolveOptions ? n.resolveOptions : o,
                                currentLocationPath: R(t)
                            };
                            m([
                                k,
                                O,
                                _,
                                m.if(function(t) {
                                    var n = t.matches;
                                    return n && n.length > 0;
                                }, x, S),
                                b,
                                H
                            ], e, H);
                        }
                    }
                    function F() {
                        if (P) return (P ? [].slice.call(document.querySelectorAll(o.linksSelector || C)) : []).forEach(function(t) {
                            "false" !== t.getAttribute("data-navigo") && "_blank" !== t.getAttribute("target") ? t.hasListenerAttached || (t.hasListenerAttached = !0, t.navigoHandler = function(n) {
                                if ((n.ctrlKey || n.metaKey) && "a" === n.target.tagName.toLowerCase()) return !1;
                                var e = t.getAttribute("href");
                                if (null == e) return !1;
                                if (e.match(/^(http|https)/) && "undefined" != typeof URL) try {
                                    var o = new URL(e);
                                    e = o.pathname + o.search;
                                } catch (t) {}
                                var i = function(t) {
                                    if (!t) return {};
                                    var n, e = t.split(","), o = {};
                                    return e.forEach(function(t) {
                                        var e = t.split(":").map(function(t) {
                                            return t.replace(/(^ +| +$)/g, "");
                                        });
                                        switch(e[0]){
                                            case "historyAPIMethod":
                                                o.historyAPIMethod = e[1];
                                                break;
                                            case "resolveOptionsStrategy":
                                                n || (n = {}), n.strategy = e[1];
                                                break;
                                            case "resolveOptionsHash":
                                                n || (n = {}), n.hash = "true" === e[1];
                                                break;
                                            case "updateBrowserURL":
                                            case "callHandler":
                                            case "updateState":
                                            case "force":
                                                o[e[0]] = "true" === e[1];
                                        }
                                    }), n && (o.resolveOptions = n), o;
                                }(t.getAttribute("data-navigo-options"));
                                L || (n.preventDefault(), n.stopPropagation(), r.navigate(s(e), i));
                            }, t.addEventListener("click", t.navigoHandler)) : t.hasListenerAttached && t.removeEventListener("click", t.navigoHandler);
                        }), r;
                    }
                    function I(t, n, e) {
                        var o = w.find(function(n) {
                            return n.name === t;
                        }), r = null;
                        if (o) {
                            if (r = o.path, n) for(var a in n)r = r.replace(":" + a, n[a]);
                            r = r.match(/^\//) ? r : "/" + r;
                        }
                        return r && e && !e.includeRoot && (r = r.replace(new RegExp("^/" + i), "")), r;
                    }
                    function M(t) {
                        var n = h(s(t)), o = n[0], r = n[1], i = "" === r ? null : f(r);
                        return {
                            url: o,
                            queryString: r,
                            hashString: u(t),
                            route: N(o, function() {}, [
                                e
                            ], o),
                            data: null,
                            params: i
                        };
                    }
                    function T(t, n, e) {
                        return "string" == typeof n && (n = z(n)), n ? (n.hooks[t] || (n.hooks[t] = []), n.hooks[t].push(e), function() {
                            n.hooks[t] = n.hooks[t].filter(function(t) {
                                return t !== e;
                            });
                        }) : (console.warn("Route doesn't exists: " + n), function() {});
                    }
                    function z(t) {
                        return "string" == typeof t ? w.find(function(n) {
                            return n.name === E(t);
                        }) : w.find(function(n) {
                            return n.handler === t;
                        });
                    }
                    t ? i = s(t) : console.warn('Navigo requires a root path in its constructor. If not provided will use "/" as default.'), this.root = i, this.routes = w, this.destroyed = L, this.current = d, this.__freezeListening = !1, this.__waiting = [], this.__dirty = !1, this.__markAsClean = function(t) {
                        t.instance.__dirty = !1, t.instance.__waiting.length > 0 && t.instance.__waiting.shift()();
                    }, this.on = function(t, n, o) {
                        var r = this;
                        return "object" != typeof t || t instanceof RegExp ? ("function" == typeof t && (o = n, n = t, t = i), w.push(N(t, n, [
                            e,
                            o
                        ])), this) : (Object.keys(t).forEach(function(n) {
                            if ("function" == typeof t[n]) r.on(n, t[n]);
                            else {
                                var o = t[n], i = o.uses, a = o.as, s = o.hooks;
                                w.push(N(n, i, [
                                    e,
                                    s
                                ], a));
                            }
                        }), this);
                    }, this.off = function(t) {
                        return this.routes = w = w.filter(function(n) {
                            return c(t) ? s(n.path) !== s(t) : "function" == typeof t ? t !== n.handler : String(n.path) !== String(t);
                        }), this;
                    }, this.resolve = U, this.navigate = q, this.navigateByName = function(t, n, e) {
                        var o = I(t, n);
                        return null !== o && (q(o.replace(new RegExp("^/?" + i), ""), e), !0);
                    }, this.destroy = function() {
                        this.routes = w = [], A && window.removeEventListener("popstate", this.__popstateListener), this.destroyed = L = !0;
                    }, this.notFound = function(t, n) {
                        return r._notFoundRoute = N("*", t, [
                            e,
                            n
                        ], "__NOT_FOUND__"), this;
                    }, this.updatePageLinks = F, this.link = function(t) {
                        return "/" + i + "/" + s(t);
                    }, this.hooks = function(t) {
                        return e = t, this;
                    }, this.extractGETParameters = function(t) {
                        return h(R(t));
                    }, this.lastResolved = function() {
                        return d;
                    }, this.generate = I, this.getLinkPath = function(t) {
                        return t.getAttribute("href");
                    }, this.match = function(t) {
                        var n = {
                            instance: r,
                            currentLocationPath: t,
                            to: t,
                            navigateOptions: {},
                            resolveOptions: o
                        };
                        return _(n, function() {}), !!n.matches && n.matches;
                    }, this.matchLocation = function(t, n, e) {
                        void 0 === n || void 0 !== e && !e || (n = E(n));
                        var o = {
                            instance: r,
                            to: n,
                            currentLocationPath: n
                        };
                        return y(o, function() {}), "string" == typeof t && (t = void 0 === e || e ? E(t) : t), l(o, {
                            name: String(t),
                            path: t,
                            handler: function() {},
                            hooks: {}
                        }) || !1;
                    }, this.getCurrentLocation = function() {
                        return M(s(a(i)).replace(new RegExp("^" + i), ""));
                    }, this.addBeforeHook = T.bind(this, "before"), this.addAfterHook = T.bind(this, "after"), this.addAlreadyHook = T.bind(this, "already"), this.addLeaveHook = T.bind(this, "leave"), this.getRoute = z, this._pathToMatchObject = M, this._clean = s, this._checkForAHash = R, this._setCurrent = function(t) {
                        return d = r.current = t;
                    }, (function() {
                        A && (this.__popstateListener = function() {
                            r.__freezeListening || U();
                        }, window.addEventListener("popstate", this.__popstateListener));
                    }).call(this), F.call(this);
                }
            }
        }, n = {};
        function e(o) {
            if (n[o]) return n[o].exports;
            var r = n[o] = {
                exports: {}
            };
            return t[o](r, r.exports, e), r.exports;
        }
        return e.d = function(t, n) {
            for(var o in n)e.o(n, o) && !e.o(t, o) && Object.defineProperty(t, o, {
                enumerable: !0,
                get: n[o]
            });
        }, e.o = function(t, n) {
            return Object.prototype.hasOwnProperty.call(t, n);
        }, e(407);
    }().default;
});


class $e817d3341cf3ea9c$export$55185c17a0fcbe46 {
    #jumpToClosestParent(path) {
        if (path === "") {
            window.location.href = window.location.origin;
            return;
        }
        const parent = path.split("/").slice(0, -1).join("/");
        const match = this.#navigo.match(parent);
        if (!match) {
            this.#jumpToClosestParent(parent);
            return;
        }
        this.jump(parent);
    }
    down(target) {
        target = window.location.pathname + target;
        this.jump(target);
    }
    jump(target) {
        this.#navigo.navigate(target);
    }
    registerRoute(path, Route, hooks) {
        const routeHandler = (match)=>{
            if (!this.routeContext) throw "missing route context";
            const route = new Route(this.routeContext);
            if (!match) throw "prepare route: match is undefined";
            const prepareRoute = new Promise((resolve)=>{
                this.mountRoute(route.ChildDom);
                setTimeout(()=>{
                    route.refresh(match).then(resolve);
                }, 200);
            });
            if (this.routeContext) this.routeContext.loadingScreen.waitFor(prepareRoute);
        };
        this.#navigo.on(path, routeHandler, hooks);
    }
    registerRouteDEPRECATED(path, page, hooks) {
        const routeHandler = (match)=>{
            const prepareRoute = new Promise((resolve)=>{
                page(match);
                resolve(true);
            });
            if (this.routeContext) this.routeContext.loadingScreen.waitFor(prepareRoute);
        };
        this.#navigo.on(path, routeHandler, hooks);
    }
    resolve() {
        this.#navigo.resolve();
    }
    up() {
        const hasHistory = window.history.length > 1 && document.referrer.startsWith(window.location.origin);
        const isLocalhost = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
        if (hasHistory || isLocalhost && !document.referrer) {
            window.history.back();
            return;
        }
        this.#jumpToClosestParent(window.location.pathname);
    }
    #navigo;
    mountRoute;
    routeContext;
    constructor(args){
        this.#navigo = new (0, (/*@__PURE__*/$parcel$interopDefault($f993037a9863bffd$exports)))(args.rootPath);
        this.#navigo.notFound(args.notFoundHandler);
        this.mountRoute = args.mountRoute;
    }
}






/**
 * @param {string} imei 
 * @param {string} name 
 * @returns {Promise<Smartplug>}
 */ async function $bf30d54feb273d81$export$9f8a78404f6a4402(imei, name) {
    const res = await (0, $5ca15832b8c5d5ea$export$299ba2dee77727e9)(`/users/${(await (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).getActiveUser()).Id}/smartplugs`, {
        body: JSON.stringify({
            Imei: imei,
            Name: name
        })
    });
    if (!res.ok) throw await (0, $1fb5d845307c571c$export$f00cf23da648bc9b)(res);
    return res.json();
}









/**
 * @type {import("navigo").Handler}
 */ function $95286bbf49011b6d$export$3d3c90e1eea7f2cc(ctx) {
    const scan = ()=>{
        (0, $1d17319f79c68be8$export$7564757b89ba44f1)((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
            enGB: "Scan the IMEI barcode. If the barcode is not recognized, enter the IMEI manually.",
            deDE: "Scannen Sie den IMEI-Strichcode. Wenn der Barcode nicht erkannt wird, geben Sie die IMEI manuell ein.",
            frFR: "Scannez le code-barres IMEI. Si le code-barres n'est pas reconnu, saisissez l'IMEI manuellement.",
            svSE: "Skanna streckkoden f\xf6r IMEI. Om streckkoden inte k\xe4nns igen anger du IMEI manuellt."
        })).then((code)=>{
            if (!code) return;
            imei.setValue(code);
        });
    };
    const imei = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).input({
        type: "text"
    });
    const name = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).input({
        type: "text"
    });
    (0, $b4e14b6b8da86996$export$8390d50e515c191d)((0, $62f894d94fb7061c$export$4b0227fa4b29008b)("small", (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).level((0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).levelLeft((0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).levelItem((0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).title((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
        enGB: "Register SmartPlug",
        deDE: "Registrieren SmartPlug",
        frFR: "Enregistrez SmartPlug",
        svSE: "Registrera SmartPlug"
    }), "is-4"))), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).levelRight((0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).levelItem((0, $1abc8d719eea79cd$export$e1dd10d13c5a06).icon({
        id: "help",
        onClick: ()=>window.open((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
                enGB: "https://support.luda.farm/en/support/solutions/folders/14000129704",
                deDE: "https://support.luda.farm/de/support/solutions/folders/14000129704",
                frFR: "https://support.luda.farm/fr/support/solutions/folders/14000129704",
                svSE: "https://support.luda.farm/sv-SE/support/solutions/folders/14000129704"
            }), "_blank")
    })))), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).field({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).label("IMEI"), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).field({
        styles: (0, $1d17319f79c68be8$export$d70a5ce4bc79c42d) ? [
            "has-addons"
        ] : undefined
    }, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({
        styles: [
            "is-expanded"
        ]
    }, imei.element), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({
        hidden: !(0, $1d17319f79c68be8$export$d70a5ce4bc79c42d)
    }, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).button({
        onClick: scan
    }, (0, $1abc8d719eea79cd$export$e1dd10d13c5a06).icon({
        id: "barcode",
        alignment: "right"
    }))))), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).field({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).label((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
        enGB: "Choose a name for your device",
        deDE: "W\xe4hlen Sie einen Namen f\xfcr Ihr Ger\xe4t",
        frFR: "Choisissez un nom pour votre appareil",
        svSE: "V\xe4lj ett namn f\xf6r din enhet"
    })), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({}, name.element)), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).field({
        styles: [
            "is-grouped"
        ]
    }, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).button({
        onClick: onClickRegister,
        styles: [
            "is-primary"
        ]
    }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.register)), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).button({
        onClick: ()=>(0, $b4e14b6b8da86996$export$5375cda95f0b0eb4).jump("/devices/register"),
        styles: [
            "is-primary"
        ]
    }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.back)))));
    function onClickRegister() {
        (0, $b4e14b6b8da86996$export$850e0ce216eef646)();
        (0, $bf30d54feb273d81$export$9f8a78404f6a4402)(imei.getValue(), name.getValue()).then((sp)=>{
            (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).smartplugs[sp.Imei] = sp;
            (0, $b4e14b6b8da86996$export$5375cda95f0b0eb4).jump("/devices" + (0, $820877bea407f5fe$export$89a7e74069fbb7af)({
                id: sp.Imei
            }));
            (0, $62f894d94fb7061c$export$73e19c0339806233)();
        }).finally((0, $b4e14b6b8da86996$export$d91ec774a0e3eb9e));
    }
}







/**
 * @type {Smartplug}
 */ const $be06f1cd2a78b4e0$export$9e1e0b58798888f1 = {
    Imei: "",
    LastUplinkAt: "",
    Consumption: 0,
    Load: 0,
    Temperature: 0,
    SignalStrength: 0,
    PowerEnabled: false,
    BeepEnabled: false,
    OfflineAlarm: {
        Enabled: false,
        Triggered: false
    },
    PowerFailureAlarm: {
        Enabled: false,
        Triggered: false
    },
    LoadAlarm: {
        Enabled: false,
        Lower: 0,
        Upper: 0,
        Triggered: false
    },
    TemperatureRangeAlarm: {
        Enabled: false,
        Lower: 0,
        Upper: 0,
        Triggered: false
    },
    Thermostat: {
        Enabled: false,
        Triggers: []
    },
    Timer: {
        Enabled: false,
        On: [],
        Off: []
    },
    Metadata: {
        OwnerEmail: "",
        Name: "",
        Tags: [],
        Access: [],
        Notify: []
    },
    Subscription: {
        ExpiresAt: "",
        PriceIds: {
            Current: "",
            Next: ""
        },
        Trialing: false
    }
};


class $5ec653cd26c41bd6$export$ef40ba64e7c086a8 {
    async #addTrial() {
        const req = this.#ctx.api.put(`/smartplugs/${this.#reactive.smartplug.Imei}/trial`);
        req.setJsonBody({
            Days: +this.#trialDays
        });
        req.setSignedInUserAuth();
        const res = await this.#ctx.loadingScreen.waitFor(req.do());
        if (res.ok) {
            this.#reactive.smartplug = await res.json();
            this.#trialDays = "";
        }
    }
    async #cancelSubscription() {
        const req = this.#ctx.api.delete(`/smartplugs/${this.#reactive.smartplug.Imei}/subscription`);
        req.setSignedInUserAuth();
        const res = await this.#ctx.loadingScreen.waitFor(req.do());
        if (res.ok) this.#reactive.smartplug = await res.json();
    }
    async #impersonate() {
        const req = this.#ctx.api.get(`/admin/impersonate?key=smartplug&value=${this.#reactive.smartplug.Imei}`);
        req.setSignedInUserAuth();
        const res = await this.#ctx.loadingScreen.waitFor(req.do());
        if (res.ok) {
            (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).startImpersonating(await res.json());
            this.#ctx.router.jump(`/devices?id=${this.#reactive.smartplug.Imei}`);
        }
    }
    async refresh(match) {
        if (!match.data?.imei) throw "missing path param: imei";
        const imei = match.data.imei;
        const req = this.#ctx.api.get(`/smartplugs/${imei}`);
        req.setSignedInUserAuth();
        const res = await req.do();
        if (res.ok) this.#reactive.smartplug = await res.json();
    }
    #ctx;
    #reactive = (0, $75d47fd8903c7af6$export$90a44edba14e47be)({
        smartplug: (0, $be06f1cd2a78b4e0$export$9e1e0b58798888f1)
    });
    #trialDays = "";
    ChildDom;
    constructor(ctx){
        this.#ctx = ctx;
        this.ChildDom = (0, $e47741cb5fbbb614$export$4b0227fa4b29008b)({
            size: "wide"
        }, (0, $01d3af8f1b8eef63$export$80e4b313e5e6b30d)({
            class: "breadcrumb"
        }, (0, $01d3af8f1b8eef63$export$b5023c870cb34848)((0, $01d3af8f1b8eef63$export$19caeaf7d9d84644)((0, $01d3af8f1b8eef63$export$407448d2b89b1813)({
            onclick: ()=>(0, $b4e14b6b8da86996$export$5375cda95f0b0eb4).jump("/admin")
        }, "Admin")), (0, $01d3af8f1b8eef63$export$19caeaf7d9d84644)((0, $01d3af8f1b8eef63$export$407448d2b89b1813)("SmartPlug")))), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "buttons"
        }, (0, $01d3af8f1b8eef63$export$2ba01fb71ed41cb6)({
            class: "button is-primary",
            onclick: ()=>this.#impersonate()
        }, "Impersonate owner"), (0, $01d3af8f1b8eef63$export$2ba01fb71ed41cb6)({
            class: "button is-primary",
            onclick: ()=>this.#cancelSubscription()
        }, "Cancel subscription")), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "field has-addons"
        }, (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "control"
        }, (0, $01d3af8f1b8eef63$export$b7e3ae3d7c15e42e)({
            class: "input",
            oninput: (e)=>{
                if (!(e.target instanceof HTMLInputElement)) return;
                this.#trialDays = e.target.value.replace(/\D/g, "");
                e.target.value = this.#trialDays;
            },
            placeholder: "Days"
        })), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "control"
        }, (0, $01d3af8f1b8eef63$export$2ba01fb71ed41cb6)({
            class: "button is-primary",
            onclick: ()=>this.#addTrial()
        }, "Add trial"))), (0, $01d3af8f1b8eef63$export$b4adb3f464574dcf)(), (0, $01d3af8f1b8eef63$export$2af2ac64526e2aa9)({
            class: "is-tiny-mobile"
        }, ()=>JSON.stringify(this.#reactive.smartplug, null, 2)));
    }
}









/**
 * @type {import('navigo').Handler}
 */ async function $10153412815efc31$export$e2d14fb705b7b352(ctx) {
    if (!ctx || !ctx.data || !ctx.data.imei) throw "missing ctx.data.imei";
    const sp = (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).smartplugs[ctx.data.imei];
    const consumptionChart = (0, $c95c45af3fcfd77e$export$88642ec15bb62ae0)({
        label: (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
            enGB: "Consumption",
            deDE: "Verbrauch",
            frFR: "Consommation",
            svSE: "F\xf6rbrukning"
        }),
        unit: "Wh",
        device: {
            type: "SmartPlug",
            serialNumber: sp.Imei
        },
        getData: getConsumption
    });
    const loadChart = (0, $c95c45af3fcfd77e$export$88642ec15bb62ae0)({
        label: (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
            enGB: "Load",
            deDE: "Belastung",
            frFR: "Charge",
            svSE: "Last"
        }),
        unit: "W",
        device: {
            type: "SmartPlug",
            serialNumber: sp.Imei
        },
        getData: getLoad
    });
    const temperatureChart = (0, $c95c45af3fcfd77e$export$88642ec15bb62ae0)({
        label: (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
            enGB: "Temperature",
            deDE: "Temperatur",
            frFR: "Temp\xe9rature",
            svSE: "Temperatur"
        }),
        unit: "\xb0C",
        device: {
            type: "SmartPlug",
            serialNumber: sp.Imei
        },
        getData: getTemperature
    });
    (0, $b4e14b6b8da86996$export$8390d50e515c191d)((0, $62f894d94fb7061c$export$4b0227fa4b29008b)("large", (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).title(sp.Metadata.Name), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).subtitle(`IMEI: ${sp.Imei}`), document.createElement("hr"), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).title((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
        enGB: "Consumption",
        deDE: "Verbrauch",
        frFR: "Consommation",
        svSE: "F\xf6rbrukning"
    }), "is-5"), consumptionChart.element, document.createElement("hr"), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).title((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
        enGB: "Load",
        deDE: "Belastung",
        frFR: "Charge",
        svSE: "Last"
    }), "is-5"), loadChart.element, document.createElement("hr"), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).title((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
        enGB: "Temperature",
        deDE: "Temperatur",
        frFR: "Temp\xe9rature",
        svSE: "Temperatur"
    }), "is-5"), temperatureChart.element, document.createElement("hr"), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).buttons((0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).button({
        onClick: ()=>(0, $b4e14b6b8da86996$export$5375cda95f0b0eb4).jump(`/devices?id=${sp.Imei}`),
        styles: [
            "is-primary"
        ]
    }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.back))));
    consumptionChart.mount();
    loadChart.mount();
    temperatureChart.mount();
    /**
	 * @param {Date} from
	 * @param {Date} to
	 * @param {"csv"|"json"|"xlsx"} format
	 * @returns {Promise<import('../device/device_log_chart').DataPoint[]|Blob>}
	 */ async function getConsumption(from, to, format) {
        const res = await (0, $56e57e5ddb2fa934$export$3cd0c4873726c28)(sp.Imei, {
            from: from.toISOString(),
            to: to.toISOString(),
            format: format
        });
        if (res instanceof Blob) return res;
        else return res.map((log)=>({
                value: log.Consumption,
                timestamp: log.Timestamp
            }));
    }
    /**
	 * @param {Date} from
	 * @param {Date} to
	 * @param {"csv"|"json"|"xlsx"} format
	 * @returns {Promise<import('../device/device_log_chart').DataPoint[]|Blob>}
	 */ async function getLoad(from, to, format) {
        const res = await (0, $56e57e5ddb2fa934$export$2ef7c30a294cc491)(sp.Imei, {
            from: from.toISOString(),
            to: to.toISOString(),
            format: format
        });
        if (res instanceof Blob) return res;
        else return res.map((log)=>({
                value: log.Load,
                timestamp: log.Timestamp
            }));
    }
    /**
	 * @param {Date} from
	 * @param {Date} to
	 * @param {"csv"|"json"|"xlsx"} format
	 * @returns {Promise<import('../device/device_log_chart').DataPoint[]|Blob>}
	 */ async function getTemperature(from, to, format) {
        const res = await (0, $56e57e5ddb2fa934$export$ec780333b296bb7)(sp.Imei, {
            from: from.toISOString(),
            to: to.toISOString(),
            format: format
        });
        if (res instanceof Blob) return res;
        else return res.map((log)=>({
                value: log.Temperature,
                timestamp: log.Timestamp
            }));
    }
}













/**
 * @type {import('navigo').Handler}
 */ async function $ff17f5778500d951$export$c6bfd9ad00ad21f9(ctx) {
    if (!ctx || !ctx.data || !ctx.data.imei) throw "missing ctx.data.imei";
    const sp = (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).smartplugs[ctx.data.imei];
    const user = await (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).getActiveUser();
    const currency = user.Country === "SE" ? "SEK" : "EUR";
    const isOwner = user.Email === sp.Metadata.OwnerEmail;
    const { SmartplugMonth: SmartplugMonth, SmartplugYear: SmartplugYear } = await (0, $26a5802c7b7183d2$export$41303c5fee299aff)();
    const beep = $ff17f5778500d951$var$soundSignalField(sp);
    const powerFailureAlarm = $ff17f5778500d951$var$powerFailureAlarmField(sp);
    const loadAlarm = $ff17f5778500d951$var$loadAlarmField(sp);
    const temperatureAlarm = $ff17f5778500d951$var$temperatureAlarmField(sp);
    const timer = $ff17f5778500d951$var$timerField(sp);
    const thermostat = $ff17f5778500d951$var$thermostatField(sp);
    const subscription = (0, $b01f22cb9334aa3d$export$b5d7b3b664095c3)(sp.Subscription, [
        SmartplugMonth,
        SmartplugYear
    ], currency, isOwner);
    const sharing = (0, $b01f22cb9334aa3d$export$c52b6e40375164c0)(sp.Metadata);
    const tags = (0, $b01f22cb9334aa3d$export$113fbad7a8f79300)(sp.Metadata);
    const name = (0, $b01f22cb9334aa3d$export$b6f1a49de680b8fc)(sp.Metadata.Name);
    const owner = (0, $b01f22cb9334aa3d$export$1b5a05bb5c2dadb2)(sp.Metadata, isOwner);
    (0, $b4e14b6b8da86996$export$8390d50e515c191d)((0, $62f894d94fb7061c$export$4b0227fa4b29008b)("small", (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).title(`SmartPlug - ${sp.Metadata.Name}`, "is-4"), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).subtitle(`IMEI: ${sp.Imei}`, "is-6"), $ff17f5778500d951$var$consumptionField(ctx, sp), beep.element, powerFailureAlarm.element, loadAlarm.element, temperatureAlarm.element, timer.element, thermostat.element, subscription.element, sharing.element, tags.element, name.element, owner.element, document.createElement("hr"), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).buttons((0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).button({
        onClick: onClickSave,
        styles: [
            "is-primary"
        ]
    }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.save), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).button({
        onClick: ()=>(0, $b4e14b6b8da86996$export$5375cda95f0b0eb4).jump(`/devices?id=${sp.Imei}`),
        styles: [
            "is-primary"
        ]
    }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.back), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).button({
        disabled: !isOwner,
        onClick: ()=>(0, $ab051bb815711afd$export$41b98bdd4d492efc)("SmartPlug", unregister),
        styles: [
            "is-danger"
        ]
    }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.unregister))));
    async function onClickSave() {
        (0, $b4e14b6b8da86996$export$850e0ce216eef646)();
        (0, $56e57e5ddb2fa934$export$2e14eb8cf6f2e1c1)(sp.Imei, {
            BeepEnabled: beep.isOn(),
            PowerFailureAlarmEnabled: powerFailureAlarm.isOn(),
            LoadAlarm: {
                Enabled: loadAlarm.isOn(),
                Lower: loadAlarm.getLower(),
                Upper: loadAlarm.getUpper()
            },
            TemperatureRangeAlarm: {
                Enabled: temperatureAlarm.isOn(),
                Lower: temperatureAlarm.getLower(),
                Upper: temperatureAlarm.getUpper()
            },
            Timer: {
                Enabled: timer.isOn(),
                Off: timer.getOffSchedules(),
                On: timer.getOnSchedules()
            },
            Thermostat: {
                Enabled: thermostat.isOn(),
                Triggers: thermostat.getTriggers()
            },
            PriceId: subscription.getPriceId(),
            Access: sharing.getAccess(),
            Notify: sharing.getNotify(),
            Tags: tags.getValue(),
            Name: name.getValue(),
            Owner: owner.getValue()
        }).then((sp)=>{
            (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).smartplugs[sp.Imei] = sp;
            (0, $b4e14b6b8da86996$export$5375cda95f0b0eb4).jump(`/devices?id=${sp.Imei}`);
        }).catch((0, $62f894d94fb7061c$export$6badb0ecde4e0bd0)).finally((0, $b4e14b6b8da86996$export$d91ec774a0e3eb9e));
    }
    function unregister() {
        (0, $b4e14b6b8da86996$export$850e0ce216eef646)();
        (0, $56e57e5ddb2fa934$export$54f51a31d8fbc449)(sp.Imei).then(()=>{
            delete (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).smartplugs[sp.Imei];
            (0, $b4e14b6b8da86996$export$5375cda95f0b0eb4).jump("/devices");
        }).catch((0, $62f894d94fb7061c$export$6badb0ecde4e0bd0)).finally((0, $b4e14b6b8da86996$export$d91ec774a0e3eb9e));
    }
}
/**
 * @param {Smartplug} sp
 */ function $ff17f5778500d951$var$soundSignalField(sp) {
    const select = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).select({
        options: [
            (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).option((0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.on, "on", sp.BeepEnabled),
            (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).option((0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.off, "off", !sp.BeepEnabled)
        ]
    });
    const field = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).field({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).label((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
        enGB: "Device sound signal",
        deDE: "Ger\xe4tetonsignal",
        frFR: "Signal sonore de l'appareil",
        svSE: "Enhet ljudsignal"
    })), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({}, select.element));
    return {
        element: field,
        isOn: ()=>select.getValue() === "on"
    };
}
/**
 * @param {Smartplug} sp
 */ function $ff17f5778500d951$var$powerFailureAlarmField(sp) {
    const isSubscribed = sp.Subscription.PriceIds.Current !== "" || Date.now() < new Date(sp.Subscription.ExpiresAt).getTime();
    const select = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).select({
        disabled: !isSubscribed,
        options: [
            (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).option((0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.on, "on", isSubscribed && sp.PowerFailureAlarm.Enabled),
            (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).option((0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.off, "off", !isSubscribed || !sp.PowerFailureAlarm.Enabled)
        ]
    });
    const field = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).field({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).label((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
        enGB: "Power failure alarm",
        deDE: "Alarm bei Stromausfall",
        frFR: "Alarme de panne de courant",
        svSE: "Str\xf6mavbrottslarm"
    })), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({}, select.element));
    return {
        element: field,
        isOn: ()=>select.getValue() === "on"
    };
}
/**
 * @param {import('navigo').Match} ctx
 * @param {Smartplug} sp
 */ function $ff17f5778500d951$var$consumptionField(ctx, sp) {
    const field = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).field({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).label((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
        enGB: `Power consumption: ${sp.Consumption} Wh`,
        deDE: `Stromverbrauch: ${sp.Consumption} Wh`,
        frFR: `Consommation \xe9lectrique : ${sp.Consumption} Wh`,
        svSE: `Str\xf6mf\xf6rbrukning: ${sp.Consumption} Wh`
    })), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).button({
        onClick: onClickReset,
        styles: [
            "is-primary"
        ]
    }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
        enGB: "Reset",
        deDE: "Zur\xfccksetzen",
        frFR: "R\xe9initialiser",
        svSE: "\xc5terst\xe4ll"
    }))));
    async function onClickReset() {
        (0, $b4e14b6b8da86996$export$850e0ce216eef646)();
        (0, $56e57e5ddb2fa934$export$ced0acecfaf2dace)(sp.Imei).then((newSp)=>{
            (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).smartplugs[sp.Imei] = newSp;
            $ff17f5778500d951$export$c6bfd9ad00ad21f9(ctx);
        }).catch((0, $62f894d94fb7061c$export$6badb0ecde4e0bd0)).finally((0, $b4e14b6b8da86996$export$d91ec774a0e3eb9e));
    }
    return field;
}
/**
 * @param {Smartplug} sp
 */ function $ff17f5778500d951$var$loadAlarmField(sp) {
    const isSubscribed = sp.Subscription.PriceIds.Current !== "" || Date.now() < new Date(sp.Subscription.ExpiresAt).getTime();
    const onOff = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).select({
        disabled: !isSubscribed,
        options: [
            (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).option((0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.on, "on", isSubscribed && sp.LoadAlarm.Enabled),
            (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).option((0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.off, "off", !isSubscribed || !sp.LoadAlarm.Enabled)
        ]
    });
    const lower = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).input({
        type: "text",
        onInput: ()=>{
            const rawLower = lower.getValue();
            if (!rawLower) return;
            const sanitizedLower = rawLower.replace(/(?!^)-|[^-\d]/g, "");
            if (sanitizedLower.length < 2) {
                lower.setValue(sanitizedLower);
                return;
            }
            const parsedLower = +sanitizedLower;
            if (parsedLower < 0) {
                lower.setValue("0");
                return;
            }
            const rawUpper = upper.getValue();
            const parsedUpper = rawUpper ? +rawUpper : 3700;
            if (parsedLower >= parsedUpper) {
                lower.setValue((parsedUpper - 1).toString());
                return;
            }
            lower.setValue(parsedLower.toString());
        }
    });
    const upper = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).input({
        type: "text",
        onInput: ()=>{
            const rawUpper = upper.getValue();
            if (!rawUpper) return;
            const sanitizedUpper = rawUpper.replace(/(?!^)-|[^-\d]/g, "");
            if (sanitizedUpper.length < 2) {
                upper.setValue(sanitizedUpper);
                return;
            }
            const parsedUpper = +sanitizedUpper;
            if (parsedUpper > 3700) {
                upper.setValue("3700");
                return;
            }
            const rawLower = lower.getValue();
            const parsedLower = rawLower ? +rawLower : 0;
            if (parsedUpper <= parsedLower) {
                upper.setValue((parsedLower + 1).toString());
                return;
            }
            upper.setValue(parsedUpper.toString());
        }
    });
    const openEditModal = ()=>{
        (0, $b4e14b6b8da86996$export$96e4b36520c26a2c).open({
            header: (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
                enGB: "Edit load alarm",
                deDE: "Lastalarm bearbeiten",
                frFR: "Modifier l'alarme de charge",
                svSE: "Redigiera lastlarm"
            }),
            body: [
                (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).field({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).label((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
                    enGB: "Lowest expected load (min 0 W)",
                    deDE: "Niedrigste erwartete Last (min 0 W)",
                    frFR: "Charge attendue la plus faible (min 0 W)",
                    svSE: "L\xe4gsta f\xf6rv\xe4ntade belastning (min 0 W)"
                })), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({}, lower.element)),
                (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).field({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).label((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
                    enGB: "Highest expected load (max 3700 W)",
                    deDE: "H\xf6chste erwartete Last (max. 3700 W)",
                    frFR: "Charge maximale pr\xe9vue (max. 3700 W)",
                    svSE: "H\xf6gsta f\xf6rv\xe4ntade belastning (max 3700 W)"
                })), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({}, upper.element))
            ],
            footer: [
                (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).button({
                    onClick: ()=>(0, $b4e14b6b8da86996$export$96e4b36520c26a2c).close(),
                    styles: [
                        "is-primary"
                    ]
                }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.done)
            ]
        });
    };
    const field = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).field({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).label((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
        enGB: "Load alarm",
        deDE: "Lastalarm",
        frFR: "Alarme de charge",
        svSE: "Lastlarm"
    })), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).field({
        styles: [
            "is-grouped"
        ]
    }, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({}, onOff.element), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).button({
        onClick: openEditModal,
        styles: [
            "is-primary"
        ]
    }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.edit)), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).input({
        type: "text",
        value: `${sp.LoadAlarm.Lower} - ${sp.LoadAlarm.Upper} W`,
        styles: [
            "is-static"
        ]
    }).element)));
    return {
        element: field,
        isOn: ()=>onOff.getValue() === "on",
        getLower: ()=>+lower.getValue(),
        getUpper: ()=>+upper.getValue()
    };
}
/**
 * @param {Smartplug} sp
 */ function $ff17f5778500d951$var$temperatureAlarmField(sp) {
    const isSubscribed = sp.Subscription.PriceIds.Current !== "" || Date.now() < new Date(sp.Subscription.ExpiresAt).getTime();
    const onOff = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).select({
        disabled: !isSubscribed,
        options: [
            (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).option((0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.on, "on", isSubscribed && sp.TemperatureRangeAlarm.Enabled),
            (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).option((0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.off, "off", !isSubscribed || !sp.TemperatureRangeAlarm.Enabled)
        ]
    });
    const lower = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).input({
        type: "text",
        onInput: ()=>{
            const rawLower = lower.getValue();
            if (!rawLower) return;
            const sanitizedLower = rawLower.replace(/(?!^)-|[^-\d]/g, "");
            if (sanitizedLower.length < 2) {
                lower.setValue(sanitizedLower);
                return;
            }
            const parsedLower = +sanitizedLower;
            if (parsedLower < -20) {
                lower.setValue("-20");
                return;
            }
            const rawUpper = upper.getValue();
            const parsedUpper = rawUpper ? +rawUpper : 70;
            if (parsedLower >= parsedUpper) {
                lower.setValue((parsedUpper - 1).toString());
                return;
            }
            lower.setValue(parsedLower.toString());
        }
    });
    const upper = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).input({
        type: "text",
        onInput: ()=>{
            const rawUpper = upper.getValue();
            if (!rawUpper) return;
            const sanitizedUpper = rawUpper.replace(/(?!^)-|[^-\d]/g, "");
            if (sanitizedUpper.length < 2) {
                upper.setValue(sanitizedUpper);
                return;
            }
            const parsedUpper = +sanitizedUpper;
            if (parsedUpper > 70) {
                upper.setValue("70");
                return;
            }
            const rawLower = lower.getValue();
            const parsedLower = rawLower ? +rawLower : -20;
            if (parsedUpper <= parsedLower) {
                upper.setValue((parsedLower + 1).toString());
                return;
            }
            upper.setValue(parsedUpper.toString());
        }
    });
    const openEditModal = ()=>{
        (0, $b4e14b6b8da86996$export$96e4b36520c26a2c).open({
            header: (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
                enGB: "Edit temperature alarm",
                deDE: "Temperaturalarm bearbeiten",
                frFR: "Modifier l'alarme de temp\xe9rature",
                svSE: "Redigera temperaturlarm"
            }),
            body: [
                (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).field({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({}, lower.element), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).help((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
                    enGB: "Enter the lowest expected temperature (min -20 \xb0C)",
                    deDE: "Geben Sie die niedrigste erwartete Temperatur ein (min. -20 \xb0C)",
                    frFR: "Saisir la temp\xe9rature minimale pr\xe9vue (min -20 \xb0C)",
                    svSE: "Ange den l\xe4gsta f\xf6rv\xe4ntade temperaturen (min -20 \xb0C)"
                }))),
                (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).field({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({}, upper.element), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).help((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
                    enGB: "Enter the highest expected temperature (max 70 \xb0C)",
                    deDE: "Geben Sie die h\xf6chste erwartete Temperatur ein (max. 70 \xb0C)",
                    frFR: "Saisir la temp\xe9rature la plus \xe9lev\xe9e pr\xe9vue (max 70 \xb0C)",
                    svSE: "Ange den h\xf6gsta f\xf6rv\xe4ntade temperaturen (max 70 \xb0C)"
                })))
            ],
            footer: [
                (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).button({
                    onClick: ()=>(0, $b4e14b6b8da86996$export$96e4b36520c26a2c).close(),
                    styles: [
                        "is-primary"
                    ]
                }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.done)
            ]
        });
    };
    const field = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).field({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).label((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
        enGB: "Temperature alarm",
        deDE: "Temperaturalarm",
        frFR: "Alarme de temp\xe9rature",
        svSE: "Temperaturelarm"
    })), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).field({
        styles: [
            "is-grouped"
        ]
    }, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({}, onOff.element), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).button({
        onClick: openEditModal,
        styles: [
            "is-primary"
        ]
    }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.edit)), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).input({
        type: "text",
        value: `${sp.TemperatureRangeAlarm.Lower} - ${sp.TemperatureRangeAlarm.Upper} \xb0C`,
        styles: [
            "is-static"
        ]
    }).element)));
    return {
        element: field,
        isOn: ()=>onOff.getValue() === "on",
        getLower: ()=>+lower.getValue(),
        getUpper: ()=>+upper.getValue()
    };
}
/**
 * @param {Smartplug} sp
 */ function $ff17f5778500d951$var$timerField(sp) {
    const isSubscribed = sp.Subscription.PriceIds.Current !== "" || Date.now() < new Date(sp.Subscription.ExpiresAt).getTime();
    const onOff = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).select({
        disabled: !isSubscribed,
        options: [
            (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).option((0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.on, "on", isSubscribed && sp.Timer.Enabled),
            (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).option((0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.off, "off", !isSubscribed || !sp.Timer.Enabled)
        ]
    });
    const action = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).select({
        options: [
            (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).option((0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.turnOn, "on"),
            (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).option((0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.turnOff, "off")
        ]
    });
    const time = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).timeInput();
    const days = [
        (0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.monday,
        (0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.tuesday,
        (0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.wednesday,
        (0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.thursday,
        (0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.friday,
        (0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.saturday,
        (0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.sunday
    ].map((day)=>(0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).checkbox({
            text: day.substring(0, 2)
        }));
    const addRule = ()=>{
        const [hour, minute] = time.getUtc().split(":");
        const dayIndices = days.map((checkbox, i)=>checkbox.isChecked() ? (i + 1) % 7 : -1).filter((i)=>i >= 0);
        const a = action.getValue();
        if (a !== "on" && a !== "off") throw `invalid action: ${action}`;
        table.insertRow(new $ff17f5778500d951$var$TimerRuleRow(table, +hour, +minute, dayIndices, a));
        (0, $b4e14b6b8da86996$export$96e4b36520c26a2c).close();
    };
    const openNewRuleModal = ()=>{
        (0, $b4e14b6b8da86996$export$96e4b36520c26a2c).open({
            header: (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
                enGB: "New timer rule",
                deDE: "Neue Timer-Regel",
                frFR: "Nouvelle r\xe8gle pour le minuteur",
                svSE: "Ny timerregel"
            }),
            body: [
                (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).field({
                    styles: [
                        "is-grouped"
                    ]
                }, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).field({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).label((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
                    enGB: "Action",
                    deDE: "Aktion",
                    frFR: "Action",
                    svSE: "\xc5tg\xe4rd"
                })), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({}, action.element)), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).field({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).label((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
                    enGB: "Time",
                    deDE: "Zeit",
                    frFR: "Temps",
                    svSE: "Tid"
                })), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({}, time.element))),
                (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).field({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).label((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
                    enGB: "Days",
                    deDE: "Tage",
                    frFR: "Jours",
                    svSE: "Dagar"
                })), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).checkboxes(...days.map((day)=>day.element))))
            ],
            footer: [
                (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).button({
                    onClick: addRule,
                    styles: [
                        "is-primary"
                    ]
                }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.add),
                (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).button({
                    onClick: ()=>(0, $b4e14b6b8da86996$export$96e4b36520c26a2c).close(),
                    styles: [
                        "is-danger"
                    ]
                }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.cancel)
            ]
        });
    };
    const table = new $ff17f5778500d951$var$TimerRulesTable(sp);
    const field = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).field({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).label((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
        enGB: "Timer",
        deDE: "Timer",
        frFR: "Minuteur",
        svSE: "Timer"
    })), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).field({
        styles: [
            "is-grouped"
        ]
    }, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({}, onOff.element), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).button({
        onClick: openNewRuleModal,
        styles: [
            "is-primary"
        ]
    }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
        enGB: "Add rule",
        deDE: "Regel hinzuf\xfcgen",
        frFR: "Ajouter une r\xe8gle",
        svSE: "L\xe4gg till regel"
    })))), table.element);
    return {
        element: field,
        getOffSchedules: ()=>table.offSchedules,
        getOnSchedules: ()=>table.onSchedules,
        isOn: ()=>onOff.getValue() === "on"
    };
}
/**
 * @param {Smartplug} sp
 */ function $ff17f5778500d951$var$thermostatField(sp) {
    const isSubscribed = sp.Subscription.PriceIds.Current !== "" || Date.now() < new Date(sp.Subscription.ExpiresAt).getTime();
    const onOff = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).select({
        disabled: !isSubscribed,
        options: [
            (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).option((0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.on, "on", isSubscribed && sp.Thermostat.Enabled),
            (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).option((0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.off, "off", !isSubscribed || !sp.Thermostat.Enabled)
        ]
    });
    const action = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).select({
        options: [
            (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).option((0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.turnOn, "on"),
            (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).option((0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.turnOff, "off")
        ]
    });
    const direction = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).select({
        options: [
            (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).option("Above", "above"),
            (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).option("Below", "below")
        ]
    });
    const temperature = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).input({
        type: "text"
    });
    const days = [
        (0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.monday,
        (0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.tuesday,
        (0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.wednesday,
        (0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.thursday,
        (0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.friday,
        (0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.saturday,
        (0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.sunday
    ].map((day)=>(0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).checkbox({
            text: day.substring(0, 2)
        }));
    const addRule = ()=>{
        const d = direction.getValue();
        if (d !== "above" && d !== "below") throw `invalid thermostat rule direction: ${d}`;
        const a = action.getValue();
        if (a !== "on" && a !== "off") throw `invalid action: ${action}`;
        const dayIndices = days.map((checkbox, i)=>checkbox.isChecked() ? (i + 1) % 7 : -1).filter((i)=>i >= 0);
        table.insertRow(new $ff17f5778500d951$var$ThermostatRuleRow(table, d, +temperature.getValue(), a, dayIndices));
        (0, $b4e14b6b8da86996$export$96e4b36520c26a2c).close();
    };
    const openNewRuleModal = ()=>{
        (0, $b4e14b6b8da86996$export$96e4b36520c26a2c).open({
            header: (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
                enGB: "New thermostat rule",
                deDE: "Neue Thermostatregel",
                frFR: "Nouvelle r\xe8gle du thermostat",
                svSE: "Ny termostatregel"
            }),
            body: [
                (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).field({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).label((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
                    enGB: "Action",
                    deDE: "Aktion",
                    frFR: "Action",
                    svSE: "\xc5tg\xe4rd"
                })), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({}, action.element)),
                (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).label((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
                    enGB: "Temperature (-20 - 70 \xb0C)",
                    deDE: "Temperatur (-20 - 70 \xb0C)",
                    frFR: "Temp\xe9rature (-20 - 70 \xb0C)",
                    svSE: "Temperatur (-20 - 70 \xb0C)"
                })),
                (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).field({
                    styles: [
                        "is-grouped"
                    ]
                }, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({}, direction.element), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({}, temperature.element)),
                (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).field({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).label((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
                    enGB: "Days",
                    deDE: "Tage",
                    frFR: "Jours",
                    svSE: "Dagar"
                })), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).checkboxes(...days.map((day)=>day.element))))
            ],
            footer: [
                (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).button({
                    onClick: addRule,
                    styles: [
                        "is-primary"
                    ]
                }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.add),
                (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).button({
                    onClick: ()=>(0, $b4e14b6b8da86996$export$96e4b36520c26a2c).close(),
                    styles: [
                        "is-danger"
                    ]
                }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.cancel)
            ]
        });
    };
    const table = new $ff17f5778500d951$var$ThermostatRulesTable(sp);
    const field = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).field({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).label((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
        enGB: "Thermostat",
        deDE: "Thermostat",
        frFR: "Thermostat",
        svSE: "Termostat"
    })), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).field({
        styles: [
            "is-grouped"
        ]
    }, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({}, onOff.element), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).button({
        onClick: openNewRuleModal,
        styles: [
            "is-primary"
        ]
    }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
        enGB: "Add rule",
        deDE: "Regel hinzuf\xfcgen",
        frFR: "Ajouter une r\xe8gle",
        svSE: "L\xe4gg till regel"
    })))), table.element);
    return {
        element: field,
        getTriggers: ()=>table.triggers,
        isOn: ()=>onOff.getValue() === "on"
    };
}
class $ff17f5778500d951$var$TimerRulesTable {
    /**
	 * @type {TimerRuleRow[]}
	 */ rows = [];
    /**
	 * @param {Smartplug} sp
	 */ constructor(sp){
        if (!sp.Timer.On) sp.Timer.On = [];
        sp.Timer.On.forEach((cron)=>this.rows.push($ff17f5778500d951$var$TimerRuleRow.fromCron(this, cron, "on")));
        if (!sp.Timer.Off) sp.Timer.Off = [];
        sp.Timer.Off.forEach((cron)=>this.rows.push($ff17f5778500d951$var$TimerRuleRow.fromCron(this, cron, "off")));
        this.rows.sort($ff17f5778500d951$var$TimerRuleRow.ascending);
        this.element = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).table({
            classList: [
                "is-fullwidth"
            ],
            body: this.rows.map((row)=>row.element)
        });
    }
    get offSchedules() {
        return this.rows.filter((row)=>row.action === "off").map((row)=>row.schedule);
    }
    get onSchedules() {
        return this.rows.filter((row)=>row.action === "on").map((row)=>row.schedule);
    }
    /**
	 * @param {TimerRuleRow} row
	 */ insertRow(row) {
        // calculate index
        let i = 0;
        while(this.rows[i] && $ff17f5778500d951$var$TimerRuleRow.ascending(this.rows[i], row) < 1)i++;
        // update model
        this.rows.splice(i, 0, row);
        // update view
        this.element.insertRow(i).replaceWith(row.element);
    }
    /**
	 * @param {TimerRuleRow} row
	 */ removeRow(row) {
        const i = this.rows.indexOf(row);
        this.rows.splice(i, 1);
        row.element.remove();
    }
}
class $ff17f5778500d951$var$TimerRuleRow {
    /**
	 * @param {TimerRulesTable} parent
	 * @param {number} hour
	 * @param {number} minute
	 * @param {number[]} days
	 * @param {"on"|"off"} action
	 */ constructor(parent, hour, minute, days, action){
        this.hour = hour;
        this.minute = Math.ceil(minute / 5) * 5 % 60;
        this.days = days;
        this.action = action;
        const deleteIcon = (0, $1abc8d719eea79cd$export$e1dd10d13c5a06).icon({
            id: "close",
            onClick: ()=>parent.removeRow(this)
        });
        const date = new Date();
        date.setUTCHours(this.hour);
        date.setUTCMinutes(this.minute);
        const time = (0, $093d22e30b803c56$export$162ce11d62a1ca51).kitchenTimeString(date);
        this.element = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).tableRow({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).tableDataCell(time), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).tableDataCell(`${days.map((day)=>(0, $820877bea407f5fe$export$b42dcb51e2659f75)(day).substring(0, 2)).join(" ")}`), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).tableDataCell(action), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).tableDataCell(deleteIcon));
    }
    get schedule() {
        return `${this.minute} ${this.hour} ${this.days.join(",")}`;
    }
    /**
	 * @param {TimerRuleRow} a
	 * @param {TimerRuleRow} b
	 * @returns {number}
	 */ static ascending(a, b) {
        if (a.hour !== b.hour) return a.hour - b.hour;
        if (a.minute !== b.minute) return a.minute - b.minute;
        return a.action === "on" ? -1 : 1;
    }
    /**
	 * @param {TimerRulesTable} table
	 * @param {string} cron // minute hour days
	 * @param {"on"|"off"} action
	 * @returns {TimerRuleRow}
	 */ static fromCron(table, cron, action) {
        const [minute, hour, days] = cron.split(" ");
        return new $ff17f5778500d951$var$TimerRuleRow(table, +hour, +minute, days.split(",").map(Number), action);
    }
}
class $ff17f5778500d951$var$ThermostatRulesTable {
    /**
	 * @type {ThermostatRuleRow[]}
	 */ rows = [];
    /**
	 * @param {Smartplug} sp
	 */ constructor(sp){
        if (!sp.Thermostat.Triggers) sp.Thermostat.Triggers = [];
        sp.Thermostat.Triggers.forEach((trigger)=>this.rows.push(new $ff17f5778500d951$var$ThermostatRuleRow(this, trigger.Above ? "above" : "below", trigger.Temperature, trigger.SetPowerEnabled ? "on" : "off", trigger.Days)));
        this.rows.sort($ff17f5778500d951$var$ThermostatRuleRow.ascending);
        this.element = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).table({
            classList: [
                "is-fullwidth"
            ],
            body: this.rows.map((row)=>row.element)
        });
    }
    get triggers() {
        return this.rows.map((row)=>row.toTrigger());
    }
    /**
	 * @param {ThermostatRuleRow} row
	 */ insertRow(row) {
        // calculate index
        let i = 0;
        while(this.rows[i] && $ff17f5778500d951$var$ThermostatRuleRow.ascending(this.rows[i], row) < 1)i++;
        // update model
        this.rows.splice(i, 0, row);
        // update view
        this.element.insertRow(i).replaceWith(row.element);
    }
    /**
	 * @param {ThermostatRuleRow} row
	 */ removeRow(row) {
        const i = this.rows.indexOf(row);
        this.rows.splice(i, 1);
        row.element.remove();
    }
}
class $ff17f5778500d951$var$ThermostatRuleRow {
    /**
	 * @param {ThermostatRulesTable} parent
	 * @param {"above"|"below"} direction
	 * @param {number} temperature
	 * @param {"on"|"off"} action
	 * @param {number[]} days
	 */ constructor(parent, direction, temperature, action, days){
        this.direction = direction;
        this.temperature = temperature;
        this.action = action;
        this.days = days;
        const deleteIcon = (0, $1abc8d719eea79cd$export$e1dd10d13c5a06).icon({
            id: "close",
            onClick: ()=>parent.removeRow(this)
        });
        this.element = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).tableRow({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).tableDataCell(direction), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).tableDataCell(temperature.toString()), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).tableDataCell(action), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).tableDataCell(`${days.map((day)=>(0, $820877bea407f5fe$export$b42dcb51e2659f75)(day).substring(0, 2)).join(" ")}`), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).tableDataCell(deleteIcon));
    }
    toTrigger() {
        return {
            Days: this.days,
            Above: this.direction === "above",
            Temperature: this.temperature,
            SetPowerEnabled: this.action === "on"
        };
    }
    /**
	 * @param {ThermostatRuleRow} a
	 * @param {ThermostatRuleRow} b
	 * @returns {number}
	 */ static ascending(a, b) {
        return a.temperature - b.temperature;
    }
}






const $028343f488f45b6c$export$55ca078da7d4a4ee = {
    ConnectionLost: false,
    Consumption: 0,
    ConsumptionNotification: {
        Enabled: false,
        Triggered: false,
        Threshold: 0
    },
    DeviceConfig: {
        Beep: false,
        LoadAlarm: {
            Enabled: false,
            Lower: 0,
            Upper: 0
        },
        OutputPower: false
    },
    Firmware: "",
    Fota: {
        Approved: false,
        Filename: ""
    },
    TargetConfig: {
        Beep: false,
        LoadAlarm: {
            Enabled: false,
            Lower: 0,
            Upper: 0
        },
        OutputPower: false
    },
    Imei: "",
    Imsi: "",
    LastUploadAt: "",
    Load: 0,
    Metadata: {
        OwnerEmail: "",
        Name: "",
        Tags: [
            ""
        ],
        Access: [
            ""
        ],
        Notify: [
            ""
        ]
    },
    PowerFailureNotification: {
        Enabled: false,
        Triggered: false
    },
    SignalStrength: 0,
    Subscription: {
        ExpiresAt: "",
        PriceIds: {
            Current: "",
            Next: ""
        },
        Trialing: false
    },
    Timer: {
        Enabled: false,
        Rules: [
            {
                Action: "turn_on",
                Schedule: "0 0 1,2,3,4,5,6,7",
                Timezone: "Europe/Stockholm"
            }
        ]
    }
};


class $2d420dd298924539$export$763773f95838f192 {
    async #addTrial() {
        const req = this.#ctx.api.post(`/smartplug2s/${this.#reactive.sp2.Imei}/trial`);
        req.setJsonBody({
            Days: this.#reactive.trialDays
        });
        req.setSignedInUserAuth();
        const res = await this.#ctx.loadingScreen.waitFor(req.do());
        if (res.ok) this.#reactive.sp2 = await res.json();
    }
    async #getSmartplug2(imei) {
        const req = this.#ctx.api.get(`/smartplug2s/${imei}`);
        req.setSignedInUserAuth();
        const res = await this.#ctx.loadingScreen.waitFor(req.do());
        if (res.ok) this.#reactive.sp2 = await res.json();
    }
    async #impersonateOwner() {
        const imei = this.#reactive.sp2.Imei;
        const req = this.#ctx.api.get(`/admin/impersonate?key=smartplug2&value=${imei}`);
        req.setSignedInUserAuth();
        const res = await this.#ctx.loadingScreen.waitFor(req.do());
        if (res.ok) {
            (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).startImpersonating(await res.json());
            this.#ctx.router.jump(`/devices?id=${imei}`);
        }
    }
    async refresh(match) {
        if (!match?.data?.imei) throw "missing path param: imei";
        const imei = match.data.imei;
        await this.#getSmartplug2(imei);
    }
    #ctx;
    #reactive = (0, $75d47fd8903c7af6$export$90a44edba14e47be)({
        sp2: (0, $028343f488f45b6c$export$55ca078da7d4a4ee),
        trialDays: 0
    });
    #trialField = ()=>(0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "field is-grouped"
        }, (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "control is-expanded"
        }, (0, $01d3af8f1b8eef63$export$b7e3ae3d7c15e42e)({
            class: "input",
            inputMode: "numeric",
            oninput: (e)=>{
                if (!(e.target instanceof HTMLInputElement)) return;
                this.#reactive.trialDays = +e.target.value;
            },
            pattern: "[1-9][0-9]*",
            placeholder: "Days",
            type: "text"
        })), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "control"
        }, (0, $01d3af8f1b8eef63$export$2ba01fb71ed41cb6)({
            class: "button is-primary is-fullwidth",
            disabled: ()=>this.#reactive.trialDays < 1,
            onclick: ()=>this.#addTrial()
        }, "Add Trial")));
    ChildDom;
    constructor(ctx){
        this.#ctx = ctx;
        this.ChildDom = (0, $e47741cb5fbbb614$export$4b0227fa4b29008b)({
            size: "narrow"
        }, (0, $01d3af8f1b8eef63$export$448e4850cad7c7b0)({
            class: "title is-4"
        }, "SmartPlug2 Admin"), (0, $01d3af8f1b8eef63$export$ffb5f4729a158638)({
            class: "subtitle is-6"
        }, ()=>`IMEI ${this.#reactive.sp2.Imei}`), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "buttons"
        }, (0, $01d3af8f1b8eef63$export$2ba01fb71ed41cb6)({
            class: "button is-primary is-fullwidth",
            onclick: ()=>this.#ctx.router.down("/factory-reset")
        }, "Factory Reset"), (0, $01d3af8f1b8eef63$export$2ba01fb71ed41cb6)({
            class: "button is-primary is-fullwidth",
            onclick: ()=>this.#ctx.router.down("/fota")
        }, "FOTA"), (0, $01d3af8f1b8eef63$export$2ba01fb71ed41cb6)({
            class: "button is-primary is-fullwidth",
            onclick: ()=>this.#impersonateOwner()
        }, "Impersonate Owner"), (0, $01d3af8f1b8eef63$export$2ba01fb71ed41cb6)({
            class: "button is-primary is-fullwidth",
            onclick: ()=>this.#ctx.router.jump(`/factory/smartplug2/${this.#reactive.sp2.Imei}/commands`)
        }, "Send Command")), this.#trialField, (0, $01d3af8f1b8eef63$export$2af2ac64526e2aa9)({
            class: "is-tiny-mobile"
        }, ()=>JSON.stringify(this.#reactive.sp2, null, 2)));
    }
}





class $1d048916aceaba52$export$b4b994913925bd7e {
    async #onClickSend() {
        const req = this.#ctx.api.post(`/smartplug2s/${this.#reactive.imei}/cmds`);
        req.setJsonBody({
            CmdType: 0xaa
        });
        req.setSignedInUserAuth();
        const res = await this.#ctx.loadingScreen.waitFor(req.do());
        if (res.ok) this.#ctx.router.up();
        else this.#ctx.error.setText(await res.text());
    }
    async refresh(match) {
        if (!match.data?.imei) throw "missing path param: imei";
        this.#reactive.imei = match.data.imei;
    }
    #ctx;
    #reactive = (0, $75d47fd8903c7af6$export$90a44edba14e47be)({
        imei: ""
    });
    ChildDom;
    constructor(ctx){
        this.#ctx = ctx;
        this.ChildDom = (0, $e47741cb5fbbb614$export$4b0227fa4b29008b)({
            size: "narrow"
        }, (0, $01d3af8f1b8eef63$export$448e4850cad7c7b0)({
            class: "title is-4"
        }, "SmartPlug2 - Get Firmware"), (0, $01d3af8f1b8eef63$export$ffb5f4729a158638)({
            class: "subtitle is-6"
        }, ()=>`IMEI ${this.#reactive.imei}`), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "buttons"
        }, (0, $01d3af8f1b8eef63$export$2ba01fb71ed41cb6)({
            class: "button is-primary",
            onclick: ()=>this.#onClickSend()
        }, "Send command"), (0, $01d3af8f1b8eef63$export$2ba01fb71ed41cb6)({
            class: "button is-danger",
            onclick: ()=>this.#ctx.router.up()
        }, "Back")));
    }
}





class $13b5455f0badc26e$export$8fa709b0c81fd217 {
    async #onClickSend() {
        const req = this.#ctx.api.post(`/smartplug2s/${this.#reactive.imei}/cmds`);
        req.setJsonBody({
            CmdType: 0xa9
        });
        req.setSignedInUserAuth();
        const res = await this.#ctx.loadingScreen.waitFor(req.do());
        if (res.ok) this.#ctx.router.up();
        else this.#ctx.error.setText(await res.text());
    }
    async refresh(match) {
        if (!match.data?.imei) throw "missing path param: imei";
        this.#reactive.imei = match.data.imei;
    }
    #ctx;
    #reactive = (0, $75d47fd8903c7af6$export$90a44edba14e47be)({
        imei: ""
    });
    ChildDom;
    constructor(ctx){
        this.#ctx = ctx;
        this.ChildDom = (0, $e47741cb5fbbb614$export$4b0227fa4b29008b)({
            size: "narrow"
        }, (0, $01d3af8f1b8eef63$export$448e4850cad7c7b0)({
            class: "title is-4"
        }, "SmartPlug2 - Get IMSI"), (0, $01d3af8f1b8eef63$export$ffb5f4729a158638)({
            class: "subtitle is-6"
        }, ()=>`IMEI ${this.#reactive.imei}`), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "buttons"
        }, (0, $01d3af8f1b8eef63$export$2ba01fb71ed41cb6)({
            class: "button is-primary",
            onclick: ()=>this.#onClickSend()
        }, "Send command"), (0, $01d3af8f1b8eef63$export$2ba01fb71ed41cb6)({
            class: "button is-danger",
            onclick: ()=>this.#ctx.router.up()
        }, "Back")));
    }
}





class $932eaea913f3b65c$export$a0a0e176524a64a3 {
    async #onClickSend() {
        const req = this.#ctx.api.post(`/smartplug2s/${this.#reactive.imei}/cmds`);
        req.setJsonBody({
            CmdType: 0xa2
        });
        req.setSignedInUserAuth();
        const res = await this.#ctx.loadingScreen.waitFor(req.do());
        if (res.ok) this.#ctx.router.up();
        else this.#ctx.error.setText(await res.text());
    }
    async refresh(match) {
        if (!match.data?.imei) throw "missing path param: imei";
        this.#reactive.imei = match.data.imei;
    }
    #ctx;
    #reactive = (0, $75d47fd8903c7af6$export$90a44edba14e47be)({
        imei: ""
    });
    ChildDom;
    constructor(ctx){
        this.#ctx = ctx;
        this.ChildDom = (0, $e47741cb5fbbb614$export$4b0227fa4b29008b)({
            size: "narrow"
        }, (0, $01d3af8f1b8eef63$export$448e4850cad7c7b0)({
            class: "title is-4"
        }, "SmartPlug2 - Get Status"), (0, $01d3af8f1b8eef63$export$ffb5f4729a158638)({
            class: "subtitle is-6"
        }, ()=>`IMEI ${this.#reactive.imei}`), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "buttons"
        }, (0, $01d3af8f1b8eef63$export$2ba01fb71ed41cb6)({
            class: "button is-primary",
            onclick: ()=>this.#onClickSend()
        }, "Send command"), (0, $01d3af8f1b8eef63$export$2ba01fb71ed41cb6)({
            class: "button is-danger",
            onclick: ()=>this.#ctx.router.up()
        }, "Back")));
    }
}





class $02e22fcc04c0651e$export$def93f6827894543 {
    #onChangeEnabled(e) {
        if (!(e.target instanceof HTMLSelectElement)) return;
        this.#enabled = +e.target.value;
    }
    async #onClickSend() {
        const req = this.#ctx.api.post(`/smartplug2s/${this.#reactive.imei}/cmds`);
        req.setJsonBody({
            CmdData: {
                Enabled: this.#enabled
            },
            CmdType: 0xa3
        });
        req.setSignedInUserAuth();
        const res = await this.#ctx.loadingScreen.waitFor(req.do());
        if (res.ok) this.#ctx.router.up();
        else this.#ctx.error.setText(await res.text());
    }
    async refresh(match) {
        if (!match.data?.imei) throw "missing path param: imei";
        this.#reactive.imei = match.data.imei;
    }
    #ctx;
    #enabled = 0;
    #reactive = (0, $75d47fd8903c7af6$export$90a44edba14e47be)({
        imei: ""
    });
    ChildDom;
    constructor(ctx){
        this.#ctx = ctx;
        this.ChildDom = (0, $e47741cb5fbbb614$export$4b0227fa4b29008b)({
            size: "narrow"
        }, (0, $01d3af8f1b8eef63$export$448e4850cad7c7b0)({
            class: "title is-4"
        }, "SmartPlug2 - Set Beep"), (0, $01d3af8f1b8eef63$export$ffb5f4729a158638)({
            class: "subtitle is-6"
        }, ()=>`IMEI ${this.#reactive.imei}`), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "field"
        }, (0, $01d3af8f1b8eef63$export$1237798dc640739a)({
            class: "label"
        }, "Enabled"), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "control"
        }, (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "select"
        }, (0, $01d3af8f1b8eef63$export$2e6c959c16ff56b8)({
            onchange: (e)=>this.#onChangeEnabled(e)
        }, (0, $01d3af8f1b8eef63$export$a75d1723e6bda2ec)({
            value: "0"
        }, "0x00"), (0, $01d3af8f1b8eef63$export$a75d1723e6bda2ec)({
            value: "1"
        }, "0x01"))))), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "buttons"
        }, (0, $01d3af8f1b8eef63$export$2ba01fb71ed41cb6)({
            class: "button is-primary",
            onclick: ()=>this.#onClickSend()
        }, "Send command"), (0, $01d3af8f1b8eef63$export$2ba01fb71ed41cb6)({
            class: "button is-danger",
            onclick: ()=>this.#ctx.router.up()
        }, "Back")));
    }
}






class $10f7bb9b74801a59$export$8b5cc62853ca8b14 {
    async #listFirmwares() {
        const req = this.#ctx.api.get("/firmwares/smartplug2");
        req.setSignedInUserAuth();
        const res = await this.#ctx.loadingScreen.waitFor(req.do());
        if (!res.ok) {
            this.#ctx.error.setText(await res.text());
            return;
        }
        this.#reactive.firmwares = await res.json();
        if (this.#reactive.firmwares.length) this.#firmware = this.#reactive.firmwares[0];
    }
    async #onClickSend() {
        const req = this.#ctx.api.post(`/smartplug2s/${this.#reactive.imei}/cmds`);
        const fwUrl = `https://${(0, $46d03d54faf4cdf4$export$e506a1d27d1eaa20).sp2gwHost}/firmwares/${this.#firmware}`;
        req.setJsonBody({
            CmdData: {
                Url: fwUrl
            },
            CmdType: 0xac
        });
        req.setSignedInUserAuth();
        const res = await this.#ctx.loadingScreen.waitFor(req.do());
        if (res.ok) this.#ctx.router.up();
        else this.#ctx.error.setText(await res.text());
    }
    #onSelectFirmware(e) {
        if (!(e.target instanceof HTMLSelectElement)) return;
        this.#firmware = e.target.value;
    }
    async refresh(match) {
        if (!match.data?.imei) throw "missing path param: imei";
        this.#reactive.imei = match.data.imei;
        this.#listFirmwares();
    }
    #ctx;
    #firmware = "";
    #reactive = (0, $75d47fd8903c7af6$export$90a44edba14e47be)({
        firmwares: [
            ""
        ],
        imei: ""
    });
    ChildDom;
    constructor(ctx){
        this.#ctx = ctx;
        this.ChildDom = (0, $e47741cb5fbbb614$export$4b0227fa4b29008b)({
            size: "narrow"
        }, (0, $01d3af8f1b8eef63$export$448e4850cad7c7b0)({
            class: "title is-4"
        }, "SmartPlug2 - Set Firmware"), (0, $01d3af8f1b8eef63$export$ffb5f4729a158638)({
            class: "subtitle is-6"
        }, ()=>`IMEI ${this.#reactive.imei}`), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "field"
        }, (0, $01d3af8f1b8eef63$export$1237798dc640739a)({
            class: "label"
        }, "Firmware"), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "control"
        }, (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "select"
        }, ()=>(0, $01d3af8f1b8eef63$export$2e6c959c16ff56b8)({
                onchange: (e)=>this.#onSelectFirmware(e)
            }, this.#reactive.firmwares.map((filename)=>(0, $01d3af8f1b8eef63$export$a75d1723e6bda2ec)({
                    value: filename
                }, filename)))))), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "buttons"
        }, (0, $01d3af8f1b8eef63$export$2ba01fb71ed41cb6)({
            class: "button is-primary",
            onclick: ()=>this.#onClickSend()
        }, "Send command"), (0, $01d3af8f1b8eef63$export$2ba01fb71ed41cb6)({
            class: "button is-danger",
            onclick: ()=>this.#ctx.router.up()
        }, "Back")));
    }
}





class $c3385788c5d5eaad$export$81c4e74f8c5aeea8 {
    #onChangeEnabled(e) {
        if (!(e.target instanceof HTMLSelectElement)) return;
        this.#enabled = +e.target.value;
    }
    async #onClickSend() {
        const req = this.#ctx.api.post(`/smartplug2s/${this.#reactive.imei}/cmds`);
        req.setJsonBody({
            CmdData: {
                Enabled: this.#enabled,
                Lower: +this.#lower,
                Upper: +this.#upper
            },
            CmdType: 0xa6
        });
        req.setSignedInUserAuth();
        const res = await this.#ctx.loadingScreen.waitFor(req.do());
        if (res.ok) this.#ctx.router.up();
        else this.#ctx.error.setText(await res.text());
    }
    #onInputLower(e) {
        if (!(e.target instanceof HTMLInputElement)) return;
        this.#lower = e.target.value;
        this.#validateRange();
    }
    #onInputUpper(e) {
        if (!(e.target instanceof HTMLInputElement)) return;
        this.#upper = e.target.value;
        this.#validateRange();
    }
    #validateRange() {
        const lower = Number(this.#lower);
        if (!Number.isInteger(lower)) {
            this.#reactive.rangeHelpText = "Lower value must be an integer";
            return false;
        }
        if (lower < 0) {
            this.#reactive.rangeHelpText = "Lower value must be non-negative";
            return false;
        }
        const upper = Number(this.#upper);
        if (!Number.isInteger(upper)) {
            this.#reactive.rangeHelpText = "Upper value must be an integer";
            return false;
        }
        if (upper > 4000) {
            this.#reactive.rangeHelpText = "Upper value must not be greater than 4000";
            return false;
        }
        if (lower >= upper) {
            this.#reactive.rangeHelpText = "Lower value must be strictly lower than upper value";
            return false;
        }
        this.#reactive.rangeHelpText = "";
        return true;
    }
    async refresh(match) {
        this.#reactive.rangeHelpText = "";
        if (!match.data?.imei) throw "missing path param: imei";
        this.#reactive.imei = match.data.imei;
    }
    #ctx;
    #enabled = 0;
    #lower = "0";
    #reactive = (0, $75d47fd8903c7af6$export$90a44edba14e47be)({
        rangeHelpText: "",
        imei: ""
    });
    #upper = "4000";
    ChildDom;
    constructor(ctx){
        this.#ctx = ctx;
        this.ChildDom = (0, $e47741cb5fbbb614$export$4b0227fa4b29008b)({
            size: "narrow"
        }, (0, $01d3af8f1b8eef63$export$448e4850cad7c7b0)({
            class: "title is-4"
        }, "SmartPlug2 - Set Load Alarm"), (0, $01d3af8f1b8eef63$export$ffb5f4729a158638)({
            class: "subtitle is-6"
        }, ()=>`IMEI ${this.#reactive.imei}`), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "field"
        }, (0, $01d3af8f1b8eef63$export$1237798dc640739a)({
            class: "label"
        }, "Enabled"), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "control"
        }, (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "select"
        }, (0, $01d3af8f1b8eef63$export$2e6c959c16ff56b8)({
            onchange: (e)=>this.#onChangeEnabled(e)
        }, (0, $01d3af8f1b8eef63$export$a75d1723e6bda2ec)({
            value: "0"
        }, "0x00"), (0, $01d3af8f1b8eef63$export$a75d1723e6bda2ec)({
            value: "1"
        }, "0x01"))))), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "field"
        }, (0, $01d3af8f1b8eef63$export$1237798dc640739a)({
            class: "label"
        }, "Range"), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "field has-addons"
        }, (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "control"
        }, (0, $01d3af8f1b8eef63$export$b7e3ae3d7c15e42e)({
            class: "input",
            oninput: (e)=>this.#onInputLower(e),
            type: "tel",
            value: "0"
        })), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "control"
        }, (0, $01d3af8f1b8eef63$export$afc1bfabebaf28a2)({
            class: "button is-static"
        }, "\u2013")), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "control"
        }, (0, $01d3af8f1b8eef63$export$b7e3ae3d7c15e42e)({
            class: "input",
            oninput: (e)=>this.#onInputUpper(e),
            type: "tel",
            value: "4000"
        })), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "control"
        }, (0, $01d3af8f1b8eef63$export$afc1bfabebaf28a2)({
            class: "button is-static"
        }, "W"))), (0, $01d3af8f1b8eef63$export$ffb5f4729a158638)({
            class: ()=>this.#reactive.rangeHelpText ? "help is-danger" : "is-hidden"
        }, ()=>this.#reactive.rangeHelpText)), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "buttons mt-5"
        }, (0, $01d3af8f1b8eef63$export$2ba01fb71ed41cb6)({
            class: "button is-primary",
            onclick: ()=>this.#onClickSend()
        }, "Send command"), (0, $01d3af8f1b8eef63$export$2ba01fb71ed41cb6)({
            class: "button is-danger",
            onclick: ()=>this.#ctx.router.up()
        }, "Back")));
    }
}





class $92a80bd938ac62eb$export$85bbeacb1e558988 {
    #onChangeEnabled(e) {
        if (!(e.target instanceof HTMLSelectElement)) return;
        this.#enabled = +e.target.value;
    }
    async #onClickSend() {
        const req = this.#ctx.api.post(`/smartplug2s/${this.#reactive.imei}/cmds`);
        req.setJsonBody({
            CmdData: {
                Enabled: this.#enabled
            },
            CmdType: 0xa1
        });
        req.setSignedInUserAuth();
        const res = await this.#ctx.loadingScreen.waitFor(req.do());
        if (res.ok) this.#ctx.router.up();
        else this.#ctx.error.setText(await res.text());
    }
    async refresh(match) {
        if (!match.data?.imei) throw "missing path param: imei";
        this.#reactive.imei = match.data.imei;
    }
    #ctx;
    #enabled = 0;
    #reactive = (0, $75d47fd8903c7af6$export$90a44edba14e47be)({
        imei: ""
    });
    ChildDom;
    constructor(ctx){
        this.#ctx = ctx;
        this.ChildDom = (0, $e47741cb5fbbb614$export$4b0227fa4b29008b)({
            size: "narrow"
        }, (0, $01d3af8f1b8eef63$export$448e4850cad7c7b0)({
            class: "title is-4"
        }, "SmartPlug2 - Set Output Power"), (0, $01d3af8f1b8eef63$export$ffb5f4729a158638)({
            class: "subtitle is-6"
        }, ()=>`IMEI ${this.#reactive.imei}`), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "field"
        }, (0, $01d3af8f1b8eef63$export$1237798dc640739a)({
            class: "label"
        }, "Enabled"), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "control"
        }, (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "select"
        }, (0, $01d3af8f1b8eef63$export$2e6c959c16ff56b8)({
            onchange: (e)=>this.#onChangeEnabled(e)
        }, (0, $01d3af8f1b8eef63$export$a75d1723e6bda2ec)({
            value: "0"
        }, "0x00"), (0, $01d3af8f1b8eef63$export$a75d1723e6bda2ec)({
            value: "1"
        }, "0x01"))))), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "buttons"
        }, (0, $01d3af8f1b8eef63$export$2ba01fb71ed41cb6)({
            class: "button is-primary",
            onclick: ()=>this.#onClickSend()
        }, "Send command"), (0, $01d3af8f1b8eef63$export$2ba01fb71ed41cb6)({
            class: "button is-danger",
            onclick: ()=>this.#ctx.router.up()
        }, "Back")));
    }
}







class $f58c51c1a61b9100$export$df5b88f0fecf4aef {
    async #getSp2(imei) {
        this.#ctx.error.clear();
        const req = this.#ctx.api.get(`/smartplug2s/${imei}`);
        req.setSignedInUserAuth();
        const res = await this.#ctx.loadingScreen.waitFor(req.do());
        if (res.ok) {
            this.#ctx.error.clear();
            this.#reactive.sp2 = await res.json();
        } else this.#ctx.error.setText(await res.text());
    }
    #onClickRefresh() {
        this.#getSp2(this.#reactive.sp2.Imei);
    }
    async refresh(match) {
        if (!match?.data?.imei) throw "missing path param: imei";
        const imei = match.data.imei;
        this.#getSp2(imei);
    }
    #ctx;
    #reactive = (0, $75d47fd8903c7af6$export$90a44edba14e47be)({
        sp2: (0, $028343f488f45b6c$export$55ca078da7d4a4ee)
    });
    ChildDom;
    constructor(ctx){
        this.#ctx = ctx;
        this.ChildDom = (0, $e47741cb5fbbb614$export$4b0227fa4b29008b)({
            size: "narrow"
        }, (0, $01d3af8f1b8eef63$export$448e4850cad7c7b0)({
            class: "title is-4"
        }, "SmartPlug2 Commands"), (0, $01d3af8f1b8eef63$export$ffb5f4729a158638)({
            class: "subtitle is-6"
        }, ()=>`IMEI ${this.#reactive.sp2.Imei}`), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "field"
        }, (0, $01d3af8f1b8eef63$export$1237798dc640739a)({
            class: "label"
        }, ()=>`Last activity: ${(0, $093d22e30b803c56$export$d6acfab709ab64b)(this.#reactive.sp2.LastUploadAt)}`)), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "field"
        }, (0, $01d3af8f1b8eef63$export$1237798dc640739a)({
            class: "label"
        }, ()=>`Load: ${this.#reactive.sp2.Load} W`)), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "field"
        }, (0, $01d3af8f1b8eef63$export$1237798dc640739a)({
            class: "label"
        }, ()=>`Signal strength: ${this.#reactive.sp2.SignalStrength}%`)), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "buttons"
        }, (0, $01d3af8f1b8eef63$export$2ba01fb71ed41cb6)({
            class: "button is-primary is-fullwidth",
            onclick: ()=>this.#ctx.router.down("/set-output-power")
        }, "Set Output Power (A1)"), (0, $01d3af8f1b8eef63$export$2ba01fb71ed41cb6)({
            class: "button is-primary is-fullwidth",
            onclick: ()=>this.#ctx.router.down("/get-status")
        }, "Get Status (A2)"), (0, $01d3af8f1b8eef63$export$2ba01fb71ed41cb6)({
            class: "button is-primary is-fullwidth",
            onclick: ()=>this.#ctx.router.down("/set-beep")
        }, "Set Beep (A3)"), (0, $01d3af8f1b8eef63$export$2ba01fb71ed41cb6)({
            class: "button is-primary is-fullwidth",
            onclick: ()=>this.#ctx.router.down("/set-load-alarm")
        }, "Set Load Alarm (A6)"), (0, $01d3af8f1b8eef63$export$2ba01fb71ed41cb6)({
            class: "button is-primary is-fullwidth",
            onclick: ()=>this.#ctx.router.down("/get-imsi")
        }, "Get IMSI (A9)"), (0, $01d3af8f1b8eef63$export$2ba01fb71ed41cb6)({
            class: "button is-primary is-fullwidth",
            onclick: ()=>this.#ctx.router.down("/get-fw")
        }, "Get Firmware (AA)"), (0, $01d3af8f1b8eef63$export$2ba01fb71ed41cb6)({
            class: "button is-primary is-fullwidth",
            onclick: ()=>this.#ctx.router.down("/set-fw")
        }, "Set Firmware (AC)"), (0, $01d3af8f1b8eef63$export$2ba01fb71ed41cb6)({
            class: "button is-primary",
            onclick: ()=>this.#onClickRefresh()
        }, "Refresh"), (0, $01d3af8f1b8eef63$export$2ba01fb71ed41cb6)({
            class: "button is-danger",
            onclick: ()=>this.#ctx.router.up()
        }, "Back")));
    }
}






class $c06c704695069218$export$3399e6b2f1da25c4 {
    async #listFiles() {
        this.#reactive.helpText = "";
        const req = this.#ctx.api.get("/firmwares/smartplug2");
        req.setSignedInUserAuth();
        const res = await req.do();
        if (res.ok) this.#reactive.filenames = await res.json();
        else {
            this.#reactive.filenames = [];
            this.#reactive.helpText = await res.text();
        }
    }
    #onChangeSelectedFile(e) {
        if (!(e.target instanceof HTMLInputElement)) return;
        if (!e.target.files?.length) return;
        if (e.target.files.length < 1) return;
        this.#selectedFile = e.target.files[0];
        this.#reactive.helpText = "";
    }
    async #uploadFile() {
        this.#reactive.helpText = "";
        if (!this.#selectedFile) {
            this.#reactive.helpText = "you must select a file first";
            return;
        }
        const req = this.#ctx.api.put(`/firmwares/smartplug2/${this.#selectedFile.name}`);
        req.setSignedInUserAuth();
        req.setBody(this.#selectedFile);
        const res = await this.#ctx.loadingScreen.waitFor(req.do());
        if (res.ok) {
            this.#reactive.filenames = await res.json();
            this.#reactive.helpText = "Ok";
        } else this.#reactive.helpText = await res.text();
    }
    async refresh() {
        await this.#listFiles();
    }
    #ctx;
    #deviceBox = ()=>(0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "box"
        }, (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "field"
        }, (0, $01d3af8f1b8eef63$export$1237798dc640739a)({
            class: "label"
        }, "IMEI"), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "field has-addons"
        }, (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "control is-expanded"
        }, (0, $01d3af8f1b8eef63$export$b7e3ae3d7c15e42e)({
            class: "input",
            onchange: (e)=>{
                if (!(e.target instanceof HTMLInputElement)) return;
                this.#imei = e.target.value;
            },
            type: "text"
        })), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "control"
        }, (0, $01d3af8f1b8eef63$export$2ba01fb71ed41cb6)({
            class: "button is-primary"
        }, "Clear")))), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "buttons"
        }, (0, $01d3af8f1b8eef63$export$2ba01fb71ed41cb6)({
            class: "button is-primary is-fullwidth",
            onclick: ()=>this.#ctx.router.jump(`/smartplug2/${this.#imei}/provision`)
        }, "Provision"), (0, $01d3af8f1b8eef63$export$2ba01fb71ed41cb6)({
            class: "button is-primary is-fullwidth",
            onclick: ()=>this.#ctx.router.jump(`/smartplug2/${this.#imei}/commands`)
        }, "Send Command")));
    #firmwareBox = ()=>(0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "box"
        }, (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "field"
        }, (0, $01d3af8f1b8eef63$export$1237798dc640739a)({
            class: "label"
        }, "Stored files"), ()=>(0, $01d3af8f1b8eef63$export$159d9494db57879b)({
                class: "tags"
            }, this.#reactive.filenames.map((filename)=>(0, $01d3af8f1b8eef63$export$afc1bfabebaf28a2)({
                    class: "tag"
                }, filename))), (0, $01d3af8f1b8eef63$export$ffb5f4729a158638)({
            class: "help"
        }, `Let's Encrypt CA: https://${(0, $46d03d54faf4cdf4$export$e506a1d27d1eaa20).sp2gwHost}/firmwares/{filename}`), (0, $01d3af8f1b8eef63$export$ffb5f4729a158638)({
            class: "help"
        }, `Self-signed CA: https://${(0, $46d03d54faf4cdf4$export$e506a1d27d1eaa20).sp2gwSelfSignedHost}/firmwares/{filename}`)), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "field"
        }, (0, $01d3af8f1b8eef63$export$1237798dc640739a)({
            class: "label"
        }, "Select file to upload"), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "field has-addons"
        }, (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "control is-expanded"
        }, (0, $01d3af8f1b8eef63$export$b7e3ae3d7c15e42e)({
            class: "input",
            onchange: (e)=>this.#onChangeSelectedFile(e),
            type: "file"
        })), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "control"
        }, (0, $01d3af8f1b8eef63$export$2ba01fb71ed41cb6)({
            class: "button is-primary",
            onclick: ()=>this.#uploadFile()
        }, "Upload"))), (0, $01d3af8f1b8eef63$export$ffb5f4729a158638)({
            class: ()=>this.#reactive.helpText === "Ok" ? "help is-success" : "help is-danger"
        }, ()=>this.#reactive.helpText)));
    #imei = "";
    #reactive = (0, $75d47fd8903c7af6$export$90a44edba14e47be)({
        filenames: [
            ""
        ],
        helpText: ""
    });
    #selectedFile;
    ChildDom;
    constructor(ctx){
        this.#ctx = ctx;
        this.ChildDom = (0, $2055f4ca6115a910$export$f48b751f41069b9b)({
            size: "narrow"
        }, this.#deviceBox, this.#firmwareBox);
    }
}





class $bce34944013670ff$export$7983a1e379efc9f5 {
    async #factoryReset() {
        this.#ctx.error.clear();
        const req = this.#ctx.api.put(`/smartplug2s/${this.#reactive.imei}/factory-reset`);
        req.setSignedInUserAuth();
        const res = await this.#ctx.loadingScreen.waitFor(req.do());
        if (res.ok) this.#ctx.router.up();
        else this.#ctx.error.setText(await res.text());
    }
    async refresh(match) {
        if (!match?.data?.imei) throw "missing path param: imei";
        this.#reactive.imei = match.data.imei;
    }
    #ctx;
    #reactive = (0, $75d47fd8903c7af6$export$90a44edba14e47be)({
        imei: ""
    });
    ChildDom;
    constructor(ctx){
        this.#ctx = ctx;
        this.ChildDom = (0, $e47741cb5fbbb614$export$4b0227fa4b29008b)({
            size: "narrow"
        }, (0, $01d3af8f1b8eef63$export$448e4850cad7c7b0)({
            class: "title is-4"
        }, "SmartPlug2 Factory Reset"), (0, $01d3af8f1b8eef63$export$ffb5f4729a158638)({
            class: "subtitle is-6"
        }, ()=>`IMEI ${this.#reactive.imei}`), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "block"
        }, (0, $01d3af8f1b8eef63$export$ffb5f4729a158638)("Resetting only affects the information kept about the ", "device in My.Luda.Farm. That is, it cancels any ", "subscription, removes all users from the device, and ", "enables the initial trial period, among other things. It ", "does not affect the hardware.")), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "buttons"
        }, (0, $01d3af8f1b8eef63$export$2ba01fb71ed41cb6)({
            class: "button is-primary",
            onclick: ()=>this.#factoryReset()
        }, "Reset"), (0, $01d3af8f1b8eef63$export$2ba01fb71ed41cb6)({
            class: "button is-primary",
            onclick: ()=>this.#ctx.router.up()
        }, "Back")));
    }
}






class $1fea2c9473c4db7a$export$30b4f9ad07dd2eb5 {
    async #getSmartplug2(imei) {
        const req = this.#ctx.api.get(`/smartplug2s/${imei}`);
        req.setSignedInUserAuth();
        const res = await this.#ctx.loadingScreen.waitFor(req.do());
        if (res.ok) this.#reactive.sp2 = await res.json();
    }
    async #listFirmwares() {
        const req = this.#ctx.api.get("/firmwares/smartplug2");
        req.setSignedInUserAuth();
        const res = await this.#ctx.loadingScreen.waitFor(req.do());
        if (!res.ok) {
            this.#ctx.error.setText(await res.text());
            return;
        }
        this.#reactive.firmwares = await res.json();
        if (this.#reactive.firmwares.length) this.#data.selectedFile = this.#reactive.firmwares[0];
    }
    async #putSp2() {
        const req = this.#ctx.api.put(`/smartplug2s/${this.#reactive.sp2.Imei}`);
        req.setJsonBody(this.#reactive.sp2);
        req.setSignedInUserAuth();
        const res = await this.#ctx.loadingScreen.waitFor(req.do());
        if (res.ok) this.#reactive.sp2 = await res.json();
    }
    async #uploadFotaConfig() {
        this.#reactive.sp2.Fota.Approved = this.#data.requireUserApproval;
        this.#reactive.sp2.Fota.Filename = this.#data.selectedFile;
        await this.#putSp2();
    }
    async refresh(match) {
        if (!match?.data?.imei) throw "missing path param: imei";
        const imei = match.data.imei;
        await this.#getSmartplug2(imei);
        await this.#listFirmwares();
        this.#ctx.error.clear();
    }
    #ctx;
    #data = {
        requireUserApproval: true,
        selectedFile: ""
    };
    #firmwareSelect = ()=>(0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "select"
        }, ()=>(0, $01d3af8f1b8eef63$export$2e6c959c16ff56b8)({
                onchange: (e)=>{
                    if (!(e.target instanceof HTMLSelectElement)) return;
                    this.#data.selectedFile = e.target.value;
                }
            }, this.#reactive.firmwares.map((filename)=>(0, $01d3af8f1b8eef63$export$a75d1723e6bda2ec)({
                    value: filename
                }, filename))));
    #reactive = (0, $75d47fd8903c7af6$export$90a44edba14e47be)({
        firmwares: [
            ""
        ],
        sp2: (0, $028343f488f45b6c$export$55ca078da7d4a4ee)
    });
    #userApprovalSelect = ()=>(0, $01d3af8f1b8eef63$export$2e6c959c16ff56b8)({
            onchange: (e)=>{
                if (!(e.target instanceof HTMLSelectElement)) return;
                this.#data.requireUserApproval = !!e.target.value;
            }
        }, (0, $01d3af8f1b8eef63$export$a75d1723e6bda2ec)({
            value: "true"
        }, "Yes"), (0, $01d3af8f1b8eef63$export$a75d1723e6bda2ec)({
            value: ""
        }, "No"));
    ChildDom;
    constructor(ctx){
        this.#ctx = ctx;
        this.ChildDom = (0, $e47741cb5fbbb614$export$4b0227fa4b29008b)({
            size: "narrow"
        }, (0, $01d3af8f1b8eef63$export$448e4850cad7c7b0)({
            class: "title is-4"
        }, "SmartPlug2 FOTA"), (0, $01d3af8f1b8eef63$export$ffb5f4729a158638)({
            class: "subtitle is-6"
        }, ()=>`IMEI ${this.#reactive.sp2.Imei}`), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "field"
        }, (0, $01d3af8f1b8eef63$export$1237798dc640739a)({
            class: "label"
        }, "Current Firmware"), (0, $01d3af8f1b8eef63$export$afc1bfabebaf28a2)({
            class: "tag is-medium"
        }, ()=>this.#reactive.sp2.Firmware)), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "field"
        }, (0, $01d3af8f1b8eef63$export$1237798dc640739a)({
            class: "label"
        }, "Target Firmware"), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "control"
        }, this.#firmwareSelect)), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "field"
        }, (0, $01d3af8f1b8eef63$export$1237798dc640739a)({
            class: "label"
        }, "Require User Approval"), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "control"
        }, (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "select"
        }, this.#userApprovalSelect))), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "buttons mt-5"
        }, (0, $01d3af8f1b8eef63$export$2ba01fb71ed41cb6)({
            class: "button is-primary",
            onclick: ()=>this.#uploadFotaConfig()
        }, "Upload"), (0, $01d3af8f1b8eef63$export$2ba01fb71ed41cb6)({
            class: "button is-danger",
            onclick: ()=>this.#ctx.router.up()
        }, "Back")));
    }
}








class $09613cb0ab15ef4d$var$LoadChart {
    #draw() {
        if (!this.#dataset.length) return;
        const lowerBoundMs = this.#reactive.centerTimeMs - this.#reactive.zoomRadiusHours * 3600000;
        const upperBoundMs = this.#reactive.centerTimeMs + this.#reactive.zoomRadiusHours * 3600000;
        let from = 0;
        while(from < this.#dataset.length - 1 && +new Date(this.#dataset[from].Timestamp) < lowerBoundMs)from++;
        let to = this.#dataset.length - 1;
        while(to > from && +new Date(this.#dataset[to].Timestamp) > upperBoundMs)to--;
        if (!this.#drawing) window.requestAnimationFrame(()=>{
            this.#updateData(from, to);
            this.#updateOptions(from, to);
            this.#chart.update("none"); // update without animation
            this.#drawing = false;
        });
        this.#drawing = true;
    }
    #onDateInput(e) {
        if (!(e.target instanceof HTMLInputElement)) return;
        this.#reactive.centerTimeMs = +e.target.value;
        this.#draw();
    }
    #onZoomInput(e) {
        if (!(e.target instanceof HTMLInputElement)) return;
        // Slider uses negative values to reverse direction
        this.#reactive.zoomRadiusHours = -1 * +e.target.value;
        this.#draw();
    }
    #updateData(from, to) {
        const hue = getComputedStyle(document.documentElement).getPropertyValue("--bulma-primary-h");
        const saturation = getComputedStyle(document.documentElement).getPropertyValue("--bulma-primary-s");
        const lightness = getComputedStyle(document.documentElement).getPropertyValue("--bulma-primary-l");
        this.#chart.data.datasets = [
            {
                backgroundColor: `hsla(${hue}, ${saturation}, ${lightness}, 0.2)`,
                borderColor: `hsl(${hue}, ${saturation}, ${lightness})`,
                data: this.#dataset.slice(from, to).map((datapoint)=>datapoint.Value),
                label: "W",
                type: "scatter"
            }
        ];
        this.#chart.data.labels = this.#dataset.slice(from, to).map((datapoint)=>datapoint.Timestamp);
    }
    #updateOptions(fromIndex, toIndex) {
        const from = new Date(this.#dataset[fromIndex].Timestamp);
        let to = new Date(this.#dataset[toIndex].Timestamp);
        // Include the time uptil now, if the zoom interval should include it,
        // even if there are no data points. This is to clearly show that the
        // device is not communicating.
        // The -2 times zoom is because zoom is stored as a negative ms value
        // for the sake of the slider behaviour.
        const now = new Date();
        if (+from + -2 * this.#reactive.zoomRadiusHours >= +now) to = now;
        this.#chart.options = {
            animation: false,
            locale: "en-GB",
            maintainAspectRatio: true,
            plugins: {
                legend: {
                    display: false,
                    labels: {
                        color: "#FFFFFF"
                    },
                    position: "top"
                },
                tooltip: {
                    callbacks: {
                        label: (tooltip)=>{
                            return `${tooltip.parsed.y} W`;
                        },
                        title: (tooltip)=>{
                            return (0, $093d22e30b803c56$export$162ce11d62a1ca51).dateTimeString(tooltip[0].parsed.x);
                        }
                    },
                    enabled: true,
                    yAlign: "bottom"
                }
            },
            responsive: true,
            scales: {
                x: {
                    display: true,
                    type: "time",
                    min: +from,
                    max: +to,
                    time: {
                        displayFormats: {
                            hour: "HH:mm"
                        },
                        unit: +to - +from <= 172800000 ? "hour" : "day"
                    }
                },
                y: {
                    title: {
                        display: true,
                        text: "W"
                    },
                    display: true,
                    min: 0,
                    max: this.#ceilingWatt,
                    ticks: {
                        color: "#000000"
                    }
                }
            }
        };
    }
    #ceilingWatt;
    #chart;
    #dataset;
    #drawing = false;
    #reactive = (0, $75d47fd8903c7af6$export$90a44edba14e47be)({
        centerTimeMs: 0,
        zoomRadiusHours: 12
    });
    constructor(container, dataset){
        this.#ceilingWatt = Math.max(...dataset.map((point)=>point.Value), 1);
        this.#ceilingWatt = Math.ceil(this.#ceilingWatt * 1.2);
        const maxDateTime = new Date();
        maxDateTime.setHours(12, 0, 0, 0);
        const minDateTime = new Date(dataset[0].Timestamp);
        minDateTime.setHours(12, 0, 0, 0);
        this.#reactive.centerTimeMs = +maxDateTime;
        const chartCanvas = (0, $01d3af8f1b8eef63$export$67ea982130081db)();
        container.replaceChildren(chartCanvas, (0, $01d3af8f1b8eef63$export$ffb5f4729a158638)({
            class: "title is-6"
        }, ()=>`${(0, $093d22e30b803c56$export$162ce11d62a1ca51).dateString(this.#reactive.centerTimeMs)} \xb1 ${this.#reactive.zoomRadiusHours} hours`), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "field"
        }, (0, $01d3af8f1b8eef63$export$1237798dc640739a)({
            class: "label"
        }, "Time"), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "control"
        }, (0, $01d3af8f1b8eef63$export$b7e3ae3d7c15e42e)({
            class: "slider is-fullwidth",
            max: +maxDateTime,
            min: +minDateTime,
            oninput: (e)=>this.#onDateInput(e),
            step: 86400000,
            type: "range",
            value: +maxDateTime
        }))), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "field"
        }, (0, $01d3af8f1b8eef63$export$1237798dc640739a)({
            class: "label"
        }, "Zoom"), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "control"
        }, (0, $01d3af8f1b8eef63$export$b7e3ae3d7c15e42e)({
            // slider values are negative to reverse direction
            class: "slider is-fullwidth",
            max: -12,
            min: -168,
            oninput: (e)=>this.#onZoomInput(e),
            step: 6,
            type: "range",
            value: -12
        }))));
        this.#chart = new (0, $216d2bdc6f281bf6$export$acaa6426d77a227e)(chartCanvas, {
            data: {
                datasets: []
            },
            type: "scatter"
        });
        this.#dataset = dataset;
        this.#draw();
    }
}
class $09613cb0ab15ef4d$export$5a20d7b75f983ef7 {
    async #getLoad(imei) {
        const req = this.#ctx.api.get(`/smartplug2s/${imei}/load`);
        req.setSignedInUserAuth();
        const res = await req.do();
        if (res.ok) return await res.json();
        else return [];
    }
    async #getSp2(imei) {
        const req = this.#ctx.api.get(`/smartplug2s/${imei}`);
        req.setSignedInUserAuth();
        const res = await req.do();
        if (res.ok) this.#reactive.sp2 = await res.json();
    }
    async refresh(match) {
        if (!match?.data?.imei) throw "missing path param: imei";
        const imei = match.data.imei;
        await this.#getSp2(imei);
        new $09613cb0ab15ef4d$var$LoadChart(this.#loadChartContainer, await this.#getLoad(imei));
    }
    #ctx;
    #loadChartContainer = (0, $01d3af8f1b8eef63$export$159d9494db57879b)();
    #reactive = (0, $75d47fd8903c7af6$export$90a44edba14e47be)({
        sp2: (0, $028343f488f45b6c$export$55ca078da7d4a4ee)
    });
    ChildDom;
    constructor(ctx){
        this.#ctx = ctx;
        this.ChildDom = (0, $e47741cb5fbbb614$export$4b0227fa4b29008b)({
            size: "wide"
        }, (0, $01d3af8f1b8eef63$export$448e4850cad7c7b0)({
            class: "title is-4"
        }, ()=>this.#reactive.sp2.Metadata.Name), (0, $01d3af8f1b8eef63$export$ffb5f4729a158638)({
            class: "subtitle is-6"
        }, "SmartPlug2"), (0, $01d3af8f1b8eef63$export$b4adb3f464574dcf)(), // h2({ class: "title is-5" }, t("sp2LogsPage.consumptionHeader")),
        // hr(),
        (0, $01d3af8f1b8eef63$export$a943aa9a0fca3f0b)({
            class: "title is-5"
        }, (0, $093d22e30b803c56$export$625550452a3fa3ec)("sp2LogsPage.loadHeader")), this.#loadChartContainer, (0, $01d3af8f1b8eef63$export$b4adb3f464574dcf)(), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "field"
        }, (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "control"
        }, (0, $01d3af8f1b8eef63$export$2ba01fb71ed41cb6)({
            class: "button is-primary",
            onclick: ()=>this.#ctx.router.jump(`/devices?id=${this.#reactive.sp2.Imei}`)
        }, (0, $093d22e30b803c56$export$625550452a3fa3ec)("sp2LogsPage.backButton")))));
    }
}





class $4af087a6d6aa0cbc$export$20463a7433df84f6 {
    #onClickCopy() {
        navigator.clipboard.writeText(this.#reactive.mqttPassword).then(()=>{
            this.#reactive.helpStatus = "is-success";
            this.#reactive.helpText = "Copied to clipboard";
        }).catch(()=>{
            this.#reactive.helpStatus = "is-danger";
            this.#reactive.helpText = "Copy failed";
        });
    }
    async #provision() {
        this.#reactive.helpText = "";
        const req = this.#ctx.api.put(`/smartplug2s/${this.#reactive.imei}/provision`);
        req.setSignedInUserAuth();
        const res = await req.do();
        if (res.ok) this.#reactive.mqttPassword = await res.json();
        else {
            this.#reactive.helpStatus = "is-danger";
            this.#reactive.helpText = `${res.status}: ${await res.text()}`;
        }
    }
    async refresh(match) {
        if (!match?.data?.imei) throw "missing path param: imei";
        this.#reactive.imei = match.data.imei;
        await this.#provision();
    }
    #ctx;
    #reactive = (0, $75d47fd8903c7af6$export$90a44edba14e47be)({
        helpStatus: "",
        helpText: "",
        imei: "",
        mqttPassword: ""
    });
    ChildDom;
    constructor(ctx){
        this.#ctx = ctx;
        this.ChildDom = (0, $e47741cb5fbbb614$export$4b0227fa4b29008b)({
            size: "narrow"
        }, (0, $01d3af8f1b8eef63$export$448e4850cad7c7b0)({
            class: "title is-4"
        }, ()=>this.#reactive.imei), (0, $01d3af8f1b8eef63$export$ffb5f4729a158638)({
            class: "subtitle is-6"
        }, "SmartPlug2"), (0, $01d3af8f1b8eef63$export$ffb5f4729a158638)({
            class: ()=>`help ${this.#reactive.helpStatus}`
        }, ()=>this.#reactive.helpText), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "field"
        }, (0, $01d3af8f1b8eef63$export$1237798dc640739a)({
            class: "label"
        }, "Assigned MQTT password"), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "field has-addons"
        }, (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "control is-expanded"
        }, (0, $01d3af8f1b8eef63$export$b7e3ae3d7c15e42e)({
            class: "input",
            disabled: true,
            type: "text",
            value: ()=>this.#reactive.mqttPassword
        })), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "control"
        }, (0, $01d3af8f1b8eef63$export$2ba01fb71ed41cb6)({
            class: "button is-primary",
            disabled: ()=>this.#reactive.mqttPassword === "",
            onclick: ()=>this.#onClickCopy()
        }, "Copy")))), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "buttons"
        }, (0, $01d3af8f1b8eef63$export$2ba01fb71ed41cb6)({
            class: "button is-primary is-fullwidth",
            onclick: ()=>this.#ctx.router.jump(`/smartplug2/${this.#reactive.imei}/test`)
        }, "Test"), (0, $01d3af8f1b8eef63$export$2ba01fb71ed41cb6)({
            class: "button is-primary is-fullwidth",
            onclick: ()=>this.#ctx.router.jump("/factory/smartplug2")
        }, "Back")));
    }
}










/**
 * @type {import("navigo").Handler}
 */ function $0008090773e1daad$export$ac86a722f7b1b5e0(ctx) {
    const imei = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).input({
        type: "text"
    });
    const name = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).input({
        type: "text"
    });
    (0, $b4e14b6b8da86996$export$8390d50e515c191d)((0, $62f894d94fb7061c$export$4b0227fa4b29008b)("small", (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).level((0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).levelLeft((0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).levelItem((0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).title((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
        enGB: "Register SmartPlug2",
        deDE: "Registrieren SmartPlug2",
        frFR: "Enregistrez SmartPlug2",
        svSE: "Registrera SmartPlug2"
    }), "is-4"))), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).levelRight((0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).levelItem((0, $1abc8d719eea79cd$export$e1dd10d13c5a06).icon({
        id: "help",
        onClick: ()=>window.open((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
                enGB: "https://support.luda.farm/en/support/solutions/folders/14000131500",
                deDE: "https://support.luda.farm/de/support/solutions/folders/14000131500",
                frFR: "https://support.luda.farm/fr/support/solutions/folders/14000131500",
                svSE: "https://support.luda.farm/sv-SE/support/solutions/folders/14000131500"
            }), "_blank")
    })))), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).field({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).label("IMEI"), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).field({
        styles: (0, $1d17319f79c68be8$export$d70a5ce4bc79c42d) ? [
            "has-addons"
        ] : undefined
    }, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({
        styles: [
            "is-expanded"
        ]
    }, imei.element), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({
        hidden: !(0, $1d17319f79c68be8$export$d70a5ce4bc79c42d)
    }, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).button({
        onClick: onClickScan
    }, (0, $1abc8d719eea79cd$export$e1dd10d13c5a06).icon({
        id: "barcode",
        alignment: "right"
    }))))), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).field({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).label((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
        enGB: "Choose a name for your device",
        deDE: "W\xe4hlen Sie einen Namen f\xfcr Ihr Ger\xe4t",
        frFR: "Choisissez un nom pour votre appareil",
        svSE: "V\xe4lj ett namn f\xf6r din enhet"
    })), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({}, name.element)), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).field({
        styles: [
            "is-grouped"
        ]
    }, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).button({
        onClick: onClickRegister,
        styles: [
            "is-primary"
        ]
    }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.register)), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).button({
        onClick: ()=>(0, $b4e14b6b8da86996$export$5375cda95f0b0eb4).jump("/devices/register"),
        styles: [
            "is-primary"
        ]
    }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.back)))));
    async function onClickRegister() {
        (0, $b4e14b6b8da86996$export$850e0ce216eef646)();
        try {
            const user = await (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).getActiveUser();
            let sp2 = await (0, $a2c9d757b6a615a4$export$9939c525af0c5106)(imei.getValue());
            sp2.Metadata.Access = [
                user.Email
            ];
            sp2.Metadata.Name = name.getValue();
            sp2.Metadata.OwnerEmail = user.Email;
            sp2 = await (0, $a2c9d757b6a615a4$export$5a951ad2fc2aa5f7)(sp2);
            (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).smartplug2s[sp2.Imei] = sp2;
            (0, $b4e14b6b8da86996$export$5375cda95f0b0eb4).jump(`/smartplug2/${sp2.Imei}`);
            (0, $62f894d94fb7061c$export$73e19c0339806233)();
        } catch (e) {
            (0, $62f894d94fb7061c$export$6badb0ecde4e0bd0)(e);
        } finally{
            (0, $b4e14b6b8da86996$export$d91ec774a0e3eb9e)();
        }
    }
    async function onClickScan() {
        (0, $1d17319f79c68be8$export$7564757b89ba44f1)((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
            enGB: "Scan the IMEI barcode. If the barcode is not recognized, enter the IMEI manually.",
            deDE: "Scannen Sie den IMEI-Strichcode. Wenn der Barcode nicht erkannt wird, geben Sie die IMEI manuell ein.",
            frFR: "Scannez le code-barres IMEI. Si le code-barres n'est pas reconnu, saisissez l'IMEI manuellement.",
            svSE: "Skanna streckkoden f\xf6r IMEI. Om streckkoden inte k\xe4nns igen anger du IMEI manuellt."
        })).then((code)=>{
            if (!code) return;
            imei.setValue(code);
        });
    }
}








class $dda1b05e597ad7c5$export$e58e8ff5ff4cac19 {
    toString() {
        switch(this.name){
            case "":
                return `0 ${this.currency}`;
            case "FarmCam SIM Extra Data":
                return `${this.amount} ${this.currency}`;
            case "FarmCam SIM Small (100 MB)":
            case "FarmCam SIM Medium (250 MB)":
            case "FarmCam SIM Large (2 GB)":
            case "FenceAlarm+ Month":
            case "SmartPlug Control+ Month":
            case "SmartPlug2 Month":
                return (0, $093d22e30b803c56$export$625550452a3fa3ec)("price.monthly", {
                    amount: `${this.amount}`,
                    currency: this.currency
                })();
            case "FenceAlarm+ Year":
            case "SmartPlug Control+ Year":
            case "SmartPlug2 Year":
                return (0, $093d22e30b803c56$export$625550452a3fa3ec)("price.yearly", {
                    amount: `${this.amount}`,
                    currency: this.currency
                })();
            case "SMS":
                return `${this.amount} ${this.currency}`;
            default:
                throw `no price with name: ${this.name}`;
        }
    }
    amount;
    currency;
    id;
    name;
    constructor(country, price){
        if (price) this.amount = country === "SE" ? price.Sek : price.Eur;
        else this.amount = 0;
        this.currency = country === "SE" ? "SEK" : "EUR";
        this.id = price ? price.Id : "";
        this.name = price ? price.Name : "";
    }
}
const $dda1b05e597ad7c5$export$bb4975b32c2ee1cf = (async ()=>{
    const res = await (0, $5ca15832b8c5d5ea$export$3988ae62b71be9a3)("/prices", {
        timeout: 20000
    });
    if (!res.ok) throw await (0, $1fb5d845307c571c$export$f00cf23da648bc9b)(res);
    return await res.json();
})();




/**
 *  @type {User}
 */ const $899ea1d287a31322$export$c355710e4e9adea1 = {
    AccountType: "",
    Country: "",
    CustomerId: "",
    Email: "",
    EmailNotifications: {
        Billing: false,
        Device: false,
        Marketing: false
    },
    Id: "",
    Locale: "en-GB",
    Phone: "",
    PushNotifications: {
        Enabled: false,
        Tokens: []
    },
    SmsNotifications: {
        Balance: 0,
        Enabled: false
    }
};







function $9c11f20b137708f8$export$b6f1a49de680b8fc(args) {
    return (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
        class: "field"
    }, (0, $01d3af8f1b8eef63$export$1237798dc640739a)({
        class: "label"
    }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
        enGB: "Name",
        deDE: "Name",
        frFR: "Nom",
        svSE: "Namn"
    })), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
        class: "control"
    }, (0, $01d3af8f1b8eef63$export$b7e3ae3d7c15e42e)({
        class: "input",
        oninput: (e)=>{
            if (!(e.target instanceof HTMLInputElement)) return;
            args.setName(e.target.value);
        },
        type: "text",
        value: ()=>args.getName()
    })));
}




function $62bb7bb99eb117ab$export$1b5a05bb5c2dadb2(args) {
    return (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
        class: "field"
    }, (0, $01d3af8f1b8eef63$export$1237798dc640739a)({
        class: "label"
    }, (0, $093d22e30b803c56$export$625550452a3fa3ec)("deviceSettingsPage.ownerLabel")), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
        class: "control"
    }, (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
        class: "select"
    }, ()=>(0, $01d3af8f1b8eef63$export$2e6c959c16ff56b8)({
            disabled: ()=>args.isDisabled(),
            onchange: (e)=>{
                if (!(e.target instanceof HTMLSelectElement)) return;
                args.setOwner(e.target.value);
            },
            value: ()=>args.getOwner()
        }, args.getAccess().map((email)=>(0, $01d3af8f1b8eef63$export$a75d1723e6bda2ec)({
                selected: email === args.getOwner(),
                text: email,
                value: email
            }))))));
}







function $c59b042e8b46f21f$export$c52b6e40375164c0(args) {
    const email = (0, $259ccf8ca7c2ca99$export$2e2bcd8739ae039).state("");
    return (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
        class: "field"
    }, (0, $01d3af8f1b8eef63$export$1237798dc640739a)({
        class: "label"
    }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
        enGB: "Share",
        deDE: "Teilen",
        frFR: "Partager",
        svSE: "Dela"
    })), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
        class: "field has-addons"
    }, (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
        class: "control is-expanded"
    }, (0, $01d3af8f1b8eef63$export$b7e3ae3d7c15e42e)({
        class: "input",
        oninput: (e)=>{
            if (!(e.target instanceof HTMLInputElement)) return;
            email.val = e.target.value;
        },
        placeholder: (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
            enGB: "Email",
            deDE: "E-Mail",
            frFR: "E-mail",
            svSE: "E-post"
        }),
        type: "email"
    })), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
        class: "control"
    }, (0, $01d3af8f1b8eef63$export$2ba01fb71ed41cb6)({
        class: "button is-primary",
        onclick: ()=>{
            args.setAccess((0, $32a329fb73bfcadd$export$2b602f2290961f2e)(args.getAccess(), email.val));
            email.val = "";
        }
    }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
        enGB: "Invite",
        deDE: "Einladen",
        frFR: "Inviter",
        svSE: "Bjud in"
    })))), (0, $01d3af8f1b8eef63$export$9852986a3ec5f6a0)({
        class: "table is-fullwidth"
    }, ()=>(0, $01d3af8f1b8eef63$export$7cdd536eaa8f163c)(args.getAccess().map((email)=>(0, $01d3af8f1b8eef63$export$72451b88a72ad9c2)((0, $01d3af8f1b8eef63$export$2beef8af2014e5c6)(email), (0, $01d3af8f1b8eef63$export$2beef8af2014e5c6)(()=>(0, $32a329fb73bfcadd$export$5d254a84db9b349c)(args.getNotify(), email) ? (0, $6ca74af0140fbc39$export$234fe0565be67471)({
                    id: "notifications",
                    onclick: ()=>{
                        args.setNotify((0, $32a329fb73bfcadd$export$410a12b43f8fbe6f)(args.getNotify(), email));
                    }
                }) : (0, $6ca74af0140fbc39$export$234fe0565be67471)({
                    id: "notifications_off",
                    onclick: ()=>{
                        args.setNotify((0, $32a329fb73bfcadd$export$2b602f2290961f2e)(args.getNotify(), email));
                    }
                })), (0, $01d3af8f1b8eef63$export$2beef8af2014e5c6)(email === args.getOwner() ? (0, $6ca74af0140fbc39$export$234fe0565be67471)({
                id: "star"
            }) : (0, $6ca74af0140fbc39$export$234fe0565be67471)({
                id: "close",
                onclick: ()=>{
                    args.setAccess((0, $32a329fb73bfcadd$export$410a12b43f8fbe6f)(args.getAccess(), email));
                }
            })))))));
}





function $6d92fe2a5c5aae79$export$b5d7b3b664095c3(args) {
    const priceInfo = (0, $259ccf8ca7c2ca99$export$2e2bcd8739ae039).derive(()=>args.getPrices()[args.getPriceId()].toString());
    return (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
        class: "field"
    }, (0, $01d3af8f1b8eef63$export$1237798dc640739a)({
        class: "label"
    }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
        enGB: "Subscription",
        deDE: "Abonnement",
        frFR: "Abonnement",
        svSE: "Prenumeration"
    })), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
        class: "control"
    }, (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
        class: "select"
    }, (0, $01d3af8f1b8eef63$export$2e6c959c16ff56b8)({
        disabled: ()=>args.isDisabled(),
        onchange: async (e)=>{
            if (!(e.target instanceof HTMLSelectElement)) return;
            args.setPriceId(e.target.value);
        }
    }, (0, $01d3af8f1b8eef63$export$a75d1723e6bda2ec)({
        text: (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
            enGB: "None",
            deDE: "Keines",
            frFR: "Aucun",
            svSE: "Ingen"
        }),
        value: ""
    }), ...Object.entries(args.getPrices).map(([id, price])=>(0, $01d3af8f1b8eef63$export$a75d1723e6bda2ec)({
            value: id,
            text: price.name
        }))))), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
        class: "control"
    }, (0, $01d3af8f1b8eef63$export$b7e3ae3d7c15e42e)({
        class: "input is-static",
        value: priceInfo
    })));
}








function $4bf1c2785aa2a886$var$isReservedTag(tag) {
    const productTags = [
        "FarmCam SIM",
        "FenceAlarm",
        "FenceAlarm2",
        "SmartPlug",
        "SmartPlug2"
    ];
    if (productTags.includes(tag)) return true;
    // Check if email
    return /.+@.+\..+/.test(tag);
}
function $4bf1c2785aa2a886$var$selectedDeviceTagControl(args, tag) {
    return (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
        class: "control"
    }, (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
        class: "tags has-addons"
    }, (0, $01d3af8f1b8eef63$export$afc1bfabebaf28a2)({
        class: "tag is-primary"
    }, tag), (0, $01d3af8f1b8eef63$export$afc1bfabebaf28a2)({
        class: "tag"
    }, (0, $6ca74af0140fbc39$export$234fe0565be67471)({
        id: "remove",
        onclick: ()=>{
            args.setTags((0, $32a329fb73bfcadd$export$410a12b43f8fbe6f)(args.getTags(), tag));
        }
    }))));
}
function $4bf1c2785aa2a886$export$113fbad7a8f79300(args) {
    const allTags = (0, $259ccf8ca7c2ca99$export$2e2bcd8739ae039).state((0, $bfc59006cf644cf7$export$ca000e230c0caa3e).getDeviceTags());
    const tag = (0, $259ccf8ca7c2ca99$export$2e2bcd8739ae039).state("");
    return (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
        class: "field"
    }, (0, $01d3af8f1b8eef63$export$1237798dc640739a)({
        class: "label"
    }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
        enGB: "Tags",
        deDE: "Tags",
        frFR: "Tags",
        svSE: "Taggar"
    })), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
        class: "field has-addons"
    }, (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
        class: "control is-expanded"
    }, (0, $01d3af8f1b8eef63$export$b7e3ae3d7c15e42e)({
        class: "input",
        oninput: (e)=>{
            if (!(e.target instanceof HTMLInputElement)) return;
            tag.val = e.target.value;
        },
        type: "text",
        value: tag
    })), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
        class: "control"
    }, (0, $01d3af8f1b8eef63$export$2ba01fb71ed41cb6)({
        class: "button is-primary",
        onclick: ()=>{
            args.setTags((0, $32a329fb73bfcadd$export$2b602f2290961f2e)(args.getTags(), tag.val));
            allTags.val = (0, $32a329fb73bfcadd$export$2b602f2290961f2e)(allTags.val, tag.val);
            tag.val = "";
        }
    }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
        enGB: "Add",
        deDE: "Hinzuf\xfcgen",
        frFR: "Ajouter",
        svSE: "L\xe4gg till"
    })))), ()=>(0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "field is-grouped is-grouped-multiline"
        }, allTags.val.filter((tag)=>!$4bf1c2785aa2a886$var$isReservedTag(tag)).map((tag)=>(0, $32a329fb73bfcadd$export$5d254a84db9b349c)(args.getTags(), tag) ? $4bf1c2785aa2a886$var$selectedDeviceTagControl(args, tag) : $4bf1c2785aa2a886$var$unselectedDeviceTagControl(args, tag))));
}
function $4bf1c2785aa2a886$var$unselectedDeviceTagControl(args, tag) {
    return (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
        class: "control"
    }, (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
        class: "tags has-addons"
    }, (0, $01d3af8f1b8eef63$export$afc1bfabebaf28a2)({
        class: "tag"
    }, tag), (0, $01d3af8f1b8eef63$export$afc1bfabebaf28a2)({
        class: "tag"
    }, (0, $6ca74af0140fbc39$export$234fe0565be67471)({
        id: "add",
        onclick: ()=>{
            args.setTags((0, $32a329fb73bfcadd$export$2b602f2290961f2e)(args.getTags(), tag));
        }
    }))));
}



function $da6fdc79cd40bd96$export$51b7d17e138bbb85(args) {
    return (0, $e47741cb5fbbb614$export$4b0227fa4b29008b)({
        size: "narrow"
    }, (0, $01d3af8f1b8eef63$export$448e4850cad7c7b0)({
        class: "title is-4"
    }, args.deviceType), (0, $01d3af8f1b8eef63$export$a943aa9a0fca3f0b)({
        class: "subtitle is-6"
    }, ()=>`${args.deviceIdType} ${args.getDeviceId()}`), (0, $9c11f20b137708f8$export$b6f1a49de680b8fc)({
        getName: args.getName,
        setName: args.setName
    }), (0, $62bb7bb99eb117ab$export$1b5a05bb5c2dadb2)({
        getAccess: args.getAccess,
        getOwner: args.getOwner,
        isDisabled: ()=>!args.isOwner(),
        setOwner: args.setOwner
    }), (0, $c59b042e8b46f21f$export$c52b6e40375164c0)({
        getAccess: args.getAccess,
        getNotify: args.getNotify,
        getOwner: args.getOwner,
        setAccess: args.setAccess,
        setNotify: args.setNotify
    }), (0, $4bf1c2785aa2a886$export$113fbad7a8f79300)({
        getTags: args.getTags,
        setTags: args.setTags
    }), (0, $6d92fe2a5c5aae79$export$b5d7b3b664095c3)({
        getPriceId: args.getPriceId,
        isDisabled: ()=>!args.isOwner(),
        getPrices: args.getPrices,
        setPriceId: args.setPriceId
    }), (0, $01d3af8f1b8eef63$export$b4adb3f464574dcf)(), ...args.fields, (0, $01d3af8f1b8eef63$export$b4adb3f464574dcf)(), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
        class: "buttons"
    }, (0, $01d3af8f1b8eef63$export$2ba01fb71ed41cb6)({
        class: "button is-primary",
        onclick: ()=>args.save()
    }, (0, $093d22e30b803c56$export$625550452a3fa3ec)("deviceSettingsPage.saveButton")), (0, $01d3af8f1b8eef63$export$2ba01fb71ed41cb6)({
        class: "button is-primary",
        onclick: ()=>args.ctx.router.jump(`/devices?id=${args.getDeviceId()}`)
    }, (0, $093d22e30b803c56$export$625550452a3fa3ec)("deviceSettingsPage.backButton")), (0, $01d3af8f1b8eef63$export$2ba01fb71ed41cb6)({
        class: "button is-danger",
        onclick: ()=>{
            (0, $b4e14b6b8da86996$export$96e4b36520c26a2c).open({
                header: (0, $093d22e30b803c56$export$625550452a3fa3ec)("deviceSettingsPage.confirmUnregistrationModal.header")(),
                body: [
                    (0, $01d3af8f1b8eef63$export$ffb5f4729a158638)((0, $093d22e30b803c56$export$625550452a3fa3ec)("deviceUnregistrationDisclaimer"))
                ],
                footer: [
                    (0, $01d3af8f1b8eef63$export$2ba01fb71ed41cb6)({
                        class: "button is-danger",
                        onclick: ()=>{
                            args.unregister().finally((0, $b4e14b6b8da86996$export$96e4b36520c26a2c).close);
                        }
                    }, (0, $093d22e30b803c56$export$625550452a3fa3ec)("deviceSettingsPage.confirmUnregistrationModal.confirmButton")),
                    (0, $01d3af8f1b8eef63$export$2ba01fb71ed41cb6)({
                        class: "button",
                        onclick: ()=>(0, $b4e14b6b8da86996$export$96e4b36520c26a2c).close()
                    }, (0, $093d22e30b803c56$export$625550452a3fa3ec)("deviceSettingsPage.confirmUnregistrationModal.cancelButton"))
                ]
            });
        }
    }, (0, $093d22e30b803c56$export$625550452a3fa3ec)("deviceSettingsPage.unregisterButton"))), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
        class: "field"
    }, (0, $01d3af8f1b8eef63$export$ffb5f4729a158638)({
        class: ()=>args.getHelpText() === "Ok" ? "help is-success" : "help is-danger"
    }, ()=>args.getHelpText())));
}





function $6ab86165a313df6b$export$db3fd954f82bc5df(cfg) {
    return (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
        class: "select"
    }, (0, $01d3af8f1b8eef63$export$2e6c959c16ff56b8)({
        disabled: cfg.disabled || false,
        onchange: (e)=>{
            if (!(e.target instanceof HTMLSelectElement)) return;
            cfg.setOn(e.target.value === "on");
        }
    }, (0, $01d3af8f1b8eef63$export$a75d1723e6bda2ec)({
        value: "off",
        selected: ()=>!cfg.isOn()
    }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
        enGB: "Off",
        deDE: "Aus",
        frFR: "\xc9teint",
        svSE: "Av"
    })), (0, $01d3af8f1b8eef63$export$a75d1723e6bda2ec)({
        value: "on",
        selected: ()=>cfg.isOn()
    }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
        enGB: "On",
        deDE: "Ein",
        frFR: "Allum\xe9",
        svSE: "P\xe5"
    }))));
}
function $6ab86165a313df6b$export$6717d4976fbfa3b2(cfg) {
    return (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
        class: "select"
    }, (0, $01d3af8f1b8eef63$export$2e6c959c16ff56b8)({
        disabled: ()=>cfg.disabled,
        onchange: (e)=>{
            cfg.on = e.target.value === "on";
        }
    }, (0, $01d3af8f1b8eef63$export$a75d1723e6bda2ec)({
        value: "off",
        selected: ()=>!cfg.on
    }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
        enGB: "Off",
        deDE: "Aus",
        frFR: "\xc9teint",
        svSE: "Av"
    })), (0, $01d3af8f1b8eef63$export$a75d1723e6bda2ec)({
        value: "on",
        selected: ()=>cfg.on
    }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
        enGB: "On",
        deDE: "Ein",
        frFR: "Allum\xe9",
        svSE: "P\xe5"
    }))));
}




class $8297bd499f454863$export$b79bc3536207ad4c {
    #approveFota() {
        this.#reactive.sp2.Fota.Approved = true;
        this.#save();
    }
    #openCreateTimerRuleModal() {
        const days = [
            false,
            false,
            false,
            false,
            false,
            false,
            false
        ];
        let action = "turn_on";
        let time = "00:00";
        const createRule = ()=>{
            const [hour, minute] = time.split(":");
            const dow = days.map((day, i)=>day ? i : -1).filter((i)=>i > -1).join(",");
            const newRule = {
                Action: action,
                Schedule: `${+minute} ${+hour} ${dow}`,
                Timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
            };
            this.#reactive.sp2.Timer.Rules = [
                ...this.#reactive.sp2.Timer.Rules,
                newRule
            ];
            (0, $b4e14b6b8da86996$export$96e4b36520c26a2c).close();
        };
        (0, $b4e14b6b8da86996$export$96e4b36520c26a2c).open({
            header: (0, $093d22e30b803c56$export$625550452a3fa3ec)("sp2SettingsPage.createTimerRuleModal.header")(),
            body: [
                (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
                    class: "field is-grouped"
                }, (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
                    class: "field"
                }, (0, $01d3af8f1b8eef63$export$1237798dc640739a)({
                    class: "label"
                }, (0, $093d22e30b803c56$export$625550452a3fa3ec)("sp2SettingsPage.createTimerRuleModal.actionLabel")), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
                    class: "control"
                }, (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
                    class: "select"
                }, (0, $01d3af8f1b8eef63$export$2e6c959c16ff56b8)({
                    onchange: (e)=>{
                        if (!(e.target instanceof HTMLSelectElement)) return;
                        action = e.target.value;
                    }
                }, (0, $01d3af8f1b8eef63$export$a75d1723e6bda2ec)({
                    value: "turn_on"
                }, (0, $093d22e30b803c56$export$625550452a3fa3ec)("sp2SettingsPage.createTimerRuleModal.actionOptions.turnOn")), (0, $01d3af8f1b8eef63$export$a75d1723e6bda2ec)({
                    value: "turn_off"
                }, (0, $093d22e30b803c56$export$625550452a3fa3ec)("sp2SettingsPage.createTimerRuleModal.actionOptions.turnOff")))))), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
                    class: "field"
                }, (0, $01d3af8f1b8eef63$export$1237798dc640739a)({
                    class: "label"
                }, (0, $093d22e30b803c56$export$625550452a3fa3ec)("sp2SettingsPage.createTimerRuleModal.timeLabel")), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
                    class: "control"
                }, (0, $01d3af8f1b8eef63$export$b7e3ae3d7c15e42e)({
                    class: "input",
                    oninput: (e)=>{
                        if (!(e.target instanceof HTMLInputElement)) return;
                        time = e.target.value;
                    },
                    type: "time",
                    value: time
                })))),
                (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
                    class: "field"
                }, (0, $01d3af8f1b8eef63$export$1237798dc640739a)({
                    class: "label"
                }, (0, $093d22e30b803c56$export$625550452a3fa3ec)("sp2SettingsPage.createTimerRuleModal.daysLabel")), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
                    class: "control"
                }, (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
                    class: "checkboxes"
                }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).weekdays().map((_day, i, weekdays)=>(0, $01d3af8f1b8eef63$export$1237798dc640739a)({
                        class: "checkbox"
                    }, (0, $01d3af8f1b8eef63$export$b7e3ae3d7c15e42e)({
                        type: "checkbox",
                        checked: days[i],
                        onchange: (e)=>{
                            if (!(e.target instanceof HTMLInputElement)) return;
                            days[(i + 1) % 7] = e.target.checked;
                        }
                    }), ` ${weekdays[(i + 1) % 7].substring(0, 2)}`)))))
            ],
            footer: [
                (0, $01d3af8f1b8eef63$export$2ba01fb71ed41cb6)({
                    class: "button is-primary",
                    onclick: createRule
                }, (0, $093d22e30b803c56$export$625550452a3fa3ec)("sp2SettingsPage.createTimerRuleModal.createButton")),
                (0, $01d3af8f1b8eef63$export$2ba01fb71ed41cb6)({
                    class: "button",
                    onclick: (0, $b4e14b6b8da86996$export$96e4b36520c26a2c).close
                }, (0, $093d22e30b803c56$export$625550452a3fa3ec)("sp2SettingsPage.createTimerRuleModal.cancelButton"))
            ]
        });
    }
    async #resetPowerConsumption() {
        this.#reactive.sp2.Consumption = 0;
        this.#save;
    }
    async #save() {
        this.#reactive.helpText = "";
        const req = this.#ctx.api.put(`/smartplug2s/${this.#reactive.sp2.Imei}`);
        req.setJsonBody(this.#reactive.sp2);
        req.setSignedInUserAuth();
        const res = await this.#ctx.loadingScreen.waitFor(req.do());
        if (res.ok) {
            this.#reactive.sp2 = await res.json();
            this.#reactive.helpText = "Ok";
        } else this.#reactive.helpText = await res.text();
    }
    async #unregister() {
        this.#reactive.sp2.Metadata.OwnerEmail = "";
        this.#save();
        this.#ctx.router.jump("/devices");
    }
    async refresh(match) {
        if (!match?.data?.imei) throw "missing path param: imei";
        this.#reactive.helpText = "";
        this.#reactive.activeUser = await (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).getActiveUser();
        this.#reactive.signedInUser = await (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).getSignedInUser();
        const { Smartplug2Month: Smartplug2Month, Smartplug2Year: Smartplug2Year } = await (0, $26a5802c7b7183d2$export$41303c5fee299aff)();
        this.#reactive.prices = {
            [Smartplug2Month.Id]: new (0, $dda1b05e597ad7c5$export$e58e8ff5ff4cac19)(this.#reactive.activeUser.Country, Smartplug2Month),
            [Smartplug2Year.Id]: new (0, $dda1b05e597ad7c5$export$e58e8ff5ff4cac19)(this.#reactive.activeUser.Country, Smartplug2Year),
            "": new (0, $dda1b05e597ad7c5$export$e58e8ff5ff4cac19)(this.#reactive.activeUser.Country)
        };
        const req = this.#ctx.api.get(`/smartplug2s/${match.data.imei}`);
        req.setSignedInUserAuth();
        const res = await this.#ctx.loadingScreen.waitFor(req.do());
        if (res.ok) {
            const sp2 = await res.json();
            this.#reactive.sp2 = sp2;
            this.#reactive.isOwner = sp2.Metadata.OwnerEmail === this.#reactive.signedInUser.Email;
            this.#reactive.hasActiveSubscription = sp2.Subscription.Trialing || !!sp2.Subscription.PriceIds.Current;
        }
    }
    #consumptionField = ()=>(0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "field"
        }, (0, $01d3af8f1b8eef63$export$1237798dc640739a)({
            class: "label"
        }, (0, $093d22e30b803c56$export$625550452a3fa3ec)("sp2SettingsPage.consumptionField.label")), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "field is-grouped"
        }, (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "control"
        }, (0, $01d3af8f1b8eef63$export$2ba01fb71ed41cb6)({
            class: "button is-primary",
            onclick: ()=>this.#resetPowerConsumption
        }, (0, $093d22e30b803c56$export$625550452a3fa3ec)("sp2SettingsPage.consumptionField.resetButton"))), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "control"
        }, (0, $01d3af8f1b8eef63$export$b7e3ae3d7c15e42e)({
            class: "input is-static",
            value: ()=>`${this.#reactive.sp2.Consumption} Wh`
        }))));
    #ctx;
    #deviceBeepField = ()=>(0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "field"
        }, (0, $01d3af8f1b8eef63$export$1237798dc640739a)({
            class: "label"
        }, (0, $093d22e30b803c56$export$625550452a3fa3ec)("sp2SettingsPage.deviceBeepLabel")), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "control"
        }, (0, $6ab86165a313df6b$export$db3fd954f82bc5df)({
            isOn: ()=>this.#reactive.sp2.TargetConfig.Beep,
            setOn: (on)=>this.#reactive.sp2.TargetConfig.Beep = on
        })));
    #fotaField = ()=>(0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "field"
        }, (0, $01d3af8f1b8eef63$export$1237798dc640739a)({
            class: "label"
        }, (0, $093d22e30b803c56$export$625550452a3fa3ec)("configureSp2Page.fotaLabel")), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "control"
        }, (0, $01d3af8f1b8eef63$export$2ba01fb71ed41cb6)({
            class: "button is-primary",
            disabled: !this.#reactive.sp2.Fota.Filename,
            onclick: ()=>this.#approveFota()
        }, ()=>this.#reactive.sp2.Fota.Filename ? (0, $093d22e30b803c56$export$625550452a3fa3ec)("configureSp2Page.fotaButton.update")() : (0, $093d22e30b803c56$export$625550452a3fa3ec)("configureSp2Page.fotaButton.latestVersion")())));
    #powerFailureField = ()=>(0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "field"
        }, (0, $01d3af8f1b8eef63$export$1237798dc640739a)({
            class: "label"
        }, (0, $093d22e30b803c56$export$625550452a3fa3ec)("sp2SettingsPage.powerFailureLabel")), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "control"
        }, (0, $6ab86165a313df6b$export$db3fd954f82bc5df)({
            isOn: ()=>this.#reactive.sp2.PowerFailureNotification.Enabled,
            setOn: (on)=>this.#reactive.sp2.PowerFailureNotification.Enabled = on
        })));
    #powerLoadField = ()=>(0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "field"
        }, (0, $01d3af8f1b8eef63$export$1237798dc640739a)({
            class: "label"
        }, (0, $093d22e30b803c56$export$625550452a3fa3ec)("sp2SettingsPage.powerLoadLabel")), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "field is-grouped"
        }, (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "control is-expanded"
        }, (0, $6ab86165a313df6b$export$db3fd954f82bc5df)({
            isOn: ()=>this.#reactive.sp2.TargetConfig.LoadAlarm.Enabled,
            setOn: (on)=>this.#reactive.sp2.TargetConfig.LoadAlarm.Enabled = on
        })), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: ()=>this.#reactive.sp2.TargetConfig.LoadAlarm.Enabled ? "field has-addons" : "is-hidden"
        }, (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "control is-expanded"
        }, (0, $01d3af8f1b8eef63$export$b7e3ae3d7c15e42e)({
            class: "input",
            oninput: (e)=>{
                if (!(e.target instanceof HTMLInputElement)) return;
                this.#reactive.sp2.TargetConfig.LoadAlarm.Lower = +e.target.value;
            },
            value: ()=>this.#reactive.sp2.TargetConfig.LoadAlarm.Lower
        })), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "control"
        }, (0, $01d3af8f1b8eef63$export$2ba01fb71ed41cb6)({
            class: "button is-static"
        }, "\u2013")), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "control is-expanded"
        }, (0, $01d3af8f1b8eef63$export$b7e3ae3d7c15e42e)({
            class: "input",
            oninput: (e)=>{
                if (!(e.target instanceof HTMLInputElement)) return;
                this.#reactive.sp2.TargetConfig.LoadAlarm.Upper = +e.target.value;
            },
            value: ()=>this.#reactive.sp2.TargetConfig.LoadAlarm.Upper
        })), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "control"
        }, (0, $01d3af8f1b8eef63$export$2ba01fb71ed41cb6)({
            class: "button is-static"
        }, "W")))));
    #reactive = (0, $75d47fd8903c7af6$export$90a44edba14e47be)({
        activeUser: (0, $899ea1d287a31322$export$c355710e4e9adea1),
        hasActiveSubscription: false,
        helpText: "",
        isOwner: false,
        prices: {
            "": new (0, $dda1b05e597ad7c5$export$e58e8ff5ff4cac19)("")
        },
        signedInUser: (0, $899ea1d287a31322$export$c355710e4e9adea1),
        sp2: (0, $028343f488f45b6c$export$55ca078da7d4a4ee)
    });
    #timerField = ()=>(0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "field"
        }, (0, $01d3af8f1b8eef63$export$1237798dc640739a)({
            class: "label"
        }, (0, $093d22e30b803c56$export$625550452a3fa3ec)("sp2SettingsPage.timerField.label")), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "field is-grouped"
        }, (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "control"
        }, (0, $6ab86165a313df6b$export$db3fd954f82bc5df)({
            isOn: ()=>this.#reactive.sp2.Timer.Enabled,
            setOn: (on)=>this.#reactive.sp2.Timer.Enabled = on
        })), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: ()=>this.#reactive.sp2.Timer.Enabled ? "control" : "is-hidden"
        }, (0, $01d3af8f1b8eef63$export$2ba01fb71ed41cb6)({
            class: "button is-primary",
            onclick: ()=>this.#openCreateTimerRuleModal()
        }, (0, $093d22e30b803c56$export$625550452a3fa3ec)("sp2SettingsPage.timerField.createRuleButton")))), (0, $01d3af8f1b8eef63$export$9852986a3ec5f6a0)({
            class: ()=>this.#reactive.sp2.Timer.Enabled ? "table" : "is-hidden"
        }, ()=>(0, $01d3af8f1b8eef63$export$7cdd536eaa8f163c)(this.#reactive.sp2.Timer.Rules.map(this.#timerRuleTableRow))));
    #timerRuleTableRow = (rule, i)=>{
        const [minutes, hours, dow] = rule.Schedule.split(" ");
        const removeRule = ()=>{
            this.#reactive.sp2.Timer.Rules = this.#reactive.sp2.Timer.Rules.slice(0, i).concat(this.#reactive.sp2.Timer.Rules.slice(i + 1));
        };
        return (0, $01d3af8f1b8eef63$export$72451b88a72ad9c2)((0, $01d3af8f1b8eef63$export$2beef8af2014e5c6)(`${hours.padStart(2, "0")}:${minutes.padStart(2, "0")}`), (0, $01d3af8f1b8eef63$export$2beef8af2014e5c6)(dow.split(",").map((i)=>i === "0" ? 7 : +i).sort().map((i)=>(0, $093d22e30b803c56$export$162ce11d62a1ca51).weekdays()[i % 7].substring(0, 2)).join(" ")), (0, $01d3af8f1b8eef63$export$2beef8af2014e5c6)(rule.Action === "turn_on" ? (0, $093d22e30b803c56$export$625550452a3fa3ec)("sp2SettingsPage.timerField.ruleTableActions.turnOn") : (0, $093d22e30b803c56$export$625550452a3fa3ec)("sp2SettingsPage.timerField.ruleTableActions.turnOff")), (0, $01d3af8f1b8eef63$export$2beef8af2014e5c6)((0, $6ca74af0140fbc39$export$234fe0565be67471)({
            id: "close",
            onclick: removeRule
        })));
    };
    ChildDom;
    constructor(ctx){
        this.#ctx = ctx;
        this.ChildDom = (0, $da6fdc79cd40bd96$export$51b7d17e138bbb85)({
            ctx: this.#ctx,
            deviceIdType: "IMEI",
            deviceType: "SmartPlug2",
            fields: [
                this.#consumptionField,
                this.#deviceBeepField,
                this.#powerFailureField,
                this.#powerLoadField,
                this.#timerField,
                this.#fotaField
            ],
            getAccess: ()=>this.#reactive.sp2.Metadata.Access,
            getDeviceId: ()=>this.#reactive.sp2.Imei,
            getHelpText: ()=>this.#reactive.helpText,
            getName: ()=>this.#reactive.sp2.Metadata.Name,
            getNotify: ()=>this.#reactive.sp2.Metadata.Notify,
            getOwner: ()=>this.#reactive.sp2.Metadata.OwnerEmail,
            getPriceId: ()=>this.#reactive.sp2.Subscription.PriceIds.Next,
            getPrices: ()=>this.#reactive.prices,
            getSignedInUser: ()=>this.#reactive.signedInUser,
            getTags: ()=>this.#reactive.sp2.Metadata.Tags,
            isOwner: ()=>this.#reactive.isOwner,
            save: ()=>this.#save(),
            setAccess: (emails)=>this.#reactive.sp2.Metadata.Access = emails,
            setName: (name)=>this.#reactive.sp2.Metadata.Name = name,
            setNotify: (emails)=>this.#reactive.sp2.Metadata.Notify = emails,
            setOwner: (email)=>this.#reactive.sp2.Metadata.OwnerEmail = email,
            setPriceId: (priceId)=>this.#reactive.sp2.Subscription.PriceIds.Next = priceId,
            setTags: (tags)=>this.#reactive.sp2.Metadata.Tags = tags,
            unregister: ()=>this.#unregister()
        });
    }
}









class $bbfbc0513280cc0c$export$9173d18d49443e0e {
    async #saveChanges() {
        const oldLocale = this.#reactive.user.Locale;
        const req = this.#ctx.api.put(`/users/${this.#reactive.user.Id}`);
        req.setJsonBody({
            Email: this.#reactive.user.Email,
            Phone: this.#reactive.user.Phone,
            Locale: this.#reactive.user.Locale,
            EmailNotifications: {
                Billing: this.#reactive.user.EmailNotifications.Billing,
                Device: this.#reactive.user.EmailNotifications.Device,
                Marketing: this.#reactive.user.EmailNotifications.Marketing
            },
            PushNotifications: this.#reactive.user.PushNotifications.Enabled,
            SmsNotifications: this.#reactive.user.SmsNotifications.Enabled
        });
        req.setSignedInUserAuth();
        const res = await this.#ctx.loadingScreen.waitFor(req.do());
        if (res.ok) {
            const user = await res.json();
            (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).setUser(user);
            this.#reactive.user = user;
            if (user.Locale !== oldLocale) location.reload();
            this.#reactive.help.success = true;
            this.#reactive.help.text = (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
                enGB: "Changes have been saved",
                deDE: "\xc4nderungen wurden gespeichert",
                frFR: "Les modifications ont \xe9t\xe9 enregistr\xe9es",
                svSE: "\xc4ndringarna har sparats"
            });
        } else if (res.status === 400) {
            const err = await res.text();
            this.#reactive.help.success = false;
            this.#reactive.help.text = (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
                enGB: `Save failed: ${err}`,
                deDE: `Speichern fehlgeschlagen: ${err}`,
                frFR: `\xc9chec de l'enregistrement : ${err}`,
                svSE: `Spara misslyckades: ${err}`
            });
        }
    }
    async refresh(_) {
        this.#reactive.user = await (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).getActiveUser();
    }
    #ctx;
    #reactive = (0, $75d47fd8903c7af6$export$90a44edba14e47be)({
        help: {
            success: true,
            text: ""
        },
        user: (0, $899ea1d287a31322$export$c355710e4e9adea1)
    });
    ChildDom;
    constructor(ctx){
        this.#ctx = ctx;
        this.ChildDom = (0, $e47741cb5fbbb614$export$4b0227fa4b29008b)({
            size: "narrow"
        }, (0, $01d3af8f1b8eef63$export$448e4850cad7c7b0)({
            class: "title"
        }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
            enGB: "Account settings",
            deDE: "Kontoeinstellungen",
            frFR: "Param\xe8tres du compte",
            svSE: "Kontoinst\xe4llningar"
        })), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "field"
        }, (0, $01d3af8f1b8eef63$export$1237798dc640739a)({
            class: "label"
        }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
            enGB: "Email",
            deDE: "E-Mail",
            frFR: "E-mail",
            svSE: "E-post"
        })), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "control"
        }, (0, $01d3af8f1b8eef63$export$b7e3ae3d7c15e42e)({
            class: "input",
            oninput: (e)=>{
                if (!(e.target instanceof HTMLInputElement)) return;
                this.#reactive.user.Email = e.target.value;
            },
            value: ()=>this.#reactive.user.Email
        }))), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "field"
        }, (0, $01d3af8f1b8eef63$export$1237798dc640739a)({
            class: "label"
        }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
            enGB: "Phone",
            deDE: "Telefon",
            frFR: "T\xe9l\xe9phone",
            svSE: "Telefon"
        })), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "control"
        }, (0, $01d3af8f1b8eef63$export$b7e3ae3d7c15e42e)({
            class: "input",
            oninput: (e)=>{
                if (!(e.target instanceof HTMLInputElement)) return;
                this.#reactive.user.Phone = e.target.value;
            },
            value: ()=>this.#reactive.user.Phone
        }))), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "field"
        }, (0, $01d3af8f1b8eef63$export$1237798dc640739a)({
            class: "label"
        }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
            enGB: "Language",
            deDE: "Sprache",
            frFR: "Langue",
            svSE: "Spr\xe5k"
        })), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "control"
        }, (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "select"
        }, (0, $01d3af8f1b8eef63$export$2e6c959c16ff56b8)({
            onchange: (e)=>{
                if (!(e.target instanceof HTMLSelectElement)) return;
                switch(e.target?.value){
                    case "de-DE":
                    case "en-GB":
                    case "fr-FR":
                    case "sv-SE":
                        break;
                    default:
                        return;
                }
                this.#reactive.user.Locale = e.target.value;
            }
        }, [
            [
                "de-DE",
                "Deutsch"
            ],
            [
                "en-GB",
                "English"
            ],
            [
                "fr-FR",
                "Fran\xe7ais"
            ],
            [
                "sv-SE",
                "Svenska"
            ]
        ].map((lang)=>(0, $01d3af8f1b8eef63$export$a75d1723e6bda2ec)({
                selected: ()=>this.#reactive.user.Locale === lang[0],
                value: lang[0]
            }, lang[1])))))), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "field"
        }, (0, $01d3af8f1b8eef63$export$1237798dc640739a)({
            class: "label"
        }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
            enGB: "Notifications",
            deDE: "Benachrichtigungen",
            frFR: "Notifications",
            svSE: "Aviseringar"
        })), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "control"
        }, (0, $01d3af8f1b8eef63$export$1237798dc640739a)({
            class: "checkbox"
        }, (0, $01d3af8f1b8eef63$export$b7e3ae3d7c15e42e)({
            checked: ()=>this.#reactive.user.EmailNotifications.Device,
            onchange: (e)=>{
                if (!(e.target instanceof HTMLInputElement)) return;
                this.#reactive.user.EmailNotifications.Device = e.target.checked;
            },
            type: "checkbox"
        }), (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
            // deliberate initial space due to formatting
            enGB: " Email",
            deDE: " E-Mail",
            frFR: " E-mail",
            svSE: " E-post"
        }))), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "control"
        }, (0, $01d3af8f1b8eef63$export$1237798dc640739a)({
            class: "checkbox"
        }, (0, $01d3af8f1b8eef63$export$b7e3ae3d7c15e42e)({
            checked: ()=>this.#reactive.user.PushNotifications.Enabled,
            onchange: (e)=>{
                if (!(e.target instanceof HTMLInputElement)) return;
                this.#reactive.user.PushNotifications.Enabled = e.target.checked;
            },
            type: "checkbox"
        }), // deliberate initial space due to formatting
        " Push")), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "control"
        }, (0, $01d3af8f1b8eef63$export$1237798dc640739a)({
            class: "checkbox"
        }, (0, $01d3af8f1b8eef63$export$b7e3ae3d7c15e42e)({
            checked: ()=>this.#reactive.user.SmsNotifications.Balance > 0 && this.#reactive.user.SmsNotifications.Enabled,
            disabled: ()=>this.#reactive.user.SmsNotifications.Balance < 1,
            onchange: (e)=>{
                if (!(e.target instanceof HTMLInputElement)) return;
                this.#reactive.user.SmsNotifications.Enabled = e.target.checked;
            },
            type: "checkbox"
        }), // deliberate initial space due to formatting
        ()=>` SMS - ${this.#reactive.user.SmsNotifications.Balance}`)), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "control"
        }, (0, $01d3af8f1b8eef63$export$2ba01fb71ed41cb6)({
            class: "button is-text",
            onclick: ()=>$bbfbc0513280cc0c$var$openNewsletterLink()
        }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
            enGB: "Sign up for the newsletter",
            deDE: "F\xfcr den Newsletter anmelden",
            frFR: "S'inscrire \xe0 la newsletter",
            svSE: "Anm\xe4l dig till nyhetsbrevet"
        })))), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "field is-grouped is-grouped-multiline"
        }, (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "control"
        }, (0, $01d3af8f1b8eef63$export$2ba01fb71ed41cb6)({
            class: "button is-primary",
            onclick: ()=>this.#saveChanges()
        }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
            enGB: "Save",
            deDE: "Speichern",
            frFR: "Enregistrer",
            svSE: "Spara"
        }))), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "control"
        }, (0, $01d3af8f1b8eef63$export$2ba01fb71ed41cb6)({
            class: "button is-primary",
            onclick: ()=>{
                this.#ctx.router.jump("/account/buy-sms");
            }
        }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
            enGB: "Buy SMS",
            deDE: "SMS kaufen",
            frFR: "Acheter des SMS",
            svSE: "K\xf6p SMS"
        }))), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "control"
        }, (0, $01d3af8f1b8eef63$export$2ba01fb71ed41cb6)({
            class: "button is-danger",
            onclick: ()=>{
                this.#ctx.router.jump("/account/delete");
            }
        }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
            enGB: "Delete account",
            deDE: "Konto l\xf6schen",
            frFR: "Supprimer le compte",
            svSE: "Radera konto"
        })))), (0, $01d3af8f1b8eef63$export$ffb5f4729a158638)({
            class: ()=>`help ${this.#reactive.help.success ? "is-success" : "is-danger"}`
        }, ()=>this.#reactive.help.text));
    }
}
function $bbfbc0513280cc0c$var$openNewsletterLink() {
    const link = (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
        enGB: "https://www.luda.farm/pages/newsletter",
        deDE: "https://www.luda.farm/de/pages/newsletter",
        frFR: "https://www.luda.farm/fr/pages/newsletter",
        svSE: "https://www.luda.farm/sv/pages/newsletter"
    });
    window.open(link, "_blank", "noopener,noreferrer");
}








class $fefa727a2ea4375d$export$cddce1836c22e22d {
    async #deleteUser() {
        const req = this.#ctx.api.delete(`/users/${this.#reactive.user.Id}`);
        req.setSignedInUserAuth();
        const res = await this.#ctx.loadingScreen.waitFor(req.do());
        if (res.ok) {
            (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).signOut();
            this.#ctx.router.jump("/sign-in");
        } else if (res.status === 403) {
            const err = await res.text();
            this.#reactive.helpText = err;
        }
    }
    async refresh(_) {
        this.#reactive.user = await (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).getActiveUser();
    }
    #ctx;
    #reactive = (0, $75d47fd8903c7af6$export$90a44edba14e47be)({
        helpText: "",
        user: (0, $899ea1d287a31322$export$c355710e4e9adea1)
    });
    ChildDom;
    constructor(ctx){
        this.#ctx = ctx;
        this.ChildDom = (0, $e47741cb5fbbb614$export$4b0227fa4b29008b)({
            size: "narrow"
        }, (0, $01d3af8f1b8eef63$export$448e4850cad7c7b0)({
            class: "title"
        }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
            enGB: "Confirm account deletion",
            deDE: "Kontol\xf6schung best\xe4tigen",
            frFR: "Confirmer la suppression du compte",
            svSE: "Bekr\xe4fta radering av konto"
        })), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "field"
        }, (0, $01d3af8f1b8eef63$export$ffb5f4729a158638)((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
            enGB: "By clicking confirm you agree to cancelling all active subscriptions owned by this account without a refund and the immediate deletion of all data associated with the account. Note that some data, such as data regarding financial transactions, may be kept in accordance with currently applicable law.",
            deDE: "Durch Best\xe4tigen erkl\xe4ren Sie sich mit der k\xfcndigungsfreien Beendigung aller mit diesem Konto verkn\xfcpften Abonnements ohne R\xfcckerstattung sowie der sofortigen L\xf6schung aller Kontodaten einverstanden. Bitte beachten Sie, dass bestimmte Daten, wie z. B. Finanztransaktionen, gem\xe4\xdf geltendem Recht aufbewahrt werden k\xf6nnen.",
            frFR: "En cliquant sur confirmer, vous acceptez l'annulation sans remboursement de tous les abonnements actifs li\xe9s \xe0 ce compte et la suppression imm\xe9diate de toutes les donn\xe9es associ\xe9es. Veuillez noter que certaines donn\xe9es, telles que celles relatives aux transactions financi\xe8res, peuvent \xeatre conserv\xe9es conform\xe9ment \xe0 la loi en vigueur.",
            svSE: "Genom att bekr\xe4fta godk\xe4nner du att alla aktiva prenumerationer kopplade till kontot avslutas utan \xe5terbetalning, samt att all data kopplad till kontot raderas omedelbart. Notera att viss data, s\xe5som uppgifter om finansiella transaktioner, kan komma att lagras i enlighet med g\xe4llande lagstiftning."
        }))), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "field is-grouped is-multiline"
        }, (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "control"
        }, (0, $01d3af8f1b8eef63$export$2ba01fb71ed41cb6)({
            class: "button is-danger",
            onclick: ()=>this.#deleteUser()
        }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
            enGB: "Confirm",
            deDE: "Best\xe4tigen",
            frFR: "Confirmer",
            svSE: "Bekr\xe4fta"
        }))), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "control",
            onclick: ()=>{
                this.#ctx.router.jump("/account");
            }
        }, (0, $01d3af8f1b8eef63$export$2ba01fb71ed41cb6)({
            class: "button"
        }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
            enGB: "Back",
            deDE: "Zur\xfcck",
            frFR: "Retour",
            svSE: "Tillbaka"
        })))), (0, $01d3af8f1b8eef63$export$ffb5f4729a158638)({
            class: "help is-danger"
        }, ()=>this.#reactive.helpText));
    }
}









class $703755f1453b1d22$export$2036bcb1969c94e4 {
    async #confirmPurchase() {
        const req = this.#ctx.api.post(`/users/${this.#reactive.user.Id}/sms`);
        req.setSignedInUserAuth();
        const res = await this.#ctx.loadingScreen.waitFor(req.do());
        if (res.ok) {
            const user = await res.json();
            (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).setUser(user);
            this.#ctx.router.jump("/account");
        }
    }
    async refresh(_) {
        this.#reactive.user = await (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).getActiveUser();
        const { Sms: Sms } = await (0, $26a5802c7b7183d2$export$41303c5fee299aff)();
        this.#reactive.amount = this.#reactive.user.Country === "SE" ? Sms.Sek : Sms.Eur;
        this.#reactive.currency = this.#reactive.user.Country === "SE" ? "SEK" : "EUR";
    }
    #ctx;
    #reactive = (0, $75d47fd8903c7af6$export$90a44edba14e47be)({
        amount: 0,
        currency: "",
        user: (0, $899ea1d287a31322$export$c355710e4e9adea1)
    });
    ChildDom;
    constructor(ctx){
        this.#ctx = ctx;
        this.ChildDom = (0, $e47741cb5fbbb614$export$4b0227fa4b29008b)({
            size: "narrow"
        }, (0, $01d3af8f1b8eef63$export$448e4850cad7c7b0)({
            class: "title"
        }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
            enGB: "Confirm SMS purchase",
            deDE: "SMS-Kauf best\xe4tigen",
            frFR: "Confirmer l'achat de SMS",
            svSE: "Bekr\xe4fta k\xf6p av SMS"
        })), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "field"
        }, (0, $01d3af8f1b8eef63$export$ffb5f4729a158638)(()=>(0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
                enGB: `By clicking confirm you agree to the purchase and immediate delivery of 100 SMS for receiving notifications. The amount to be paid is ${this.#reactive.amount} ${this.#reactive.currency} ex VAT and will be included on your next invoice.`,
                deDE: `Durch Klicken auf Best\xe4tigen stimmen Sie dem Kauf und der sofortigen Lieferung von 100 SMS f\xfcr den Empfang von Benachrichtigungen zu. Der zu zahlende Betrag betr\xe4gt ${this.#reactive.amount} ${this.#reactive.currency} zzgl. MwSt. und wird auf Ihrer n\xe4chsten Rechnung ausgewiesen.`,
                frFR: `En cliquant sur confirmer, vous acceptez l'achat et la livraison imm\xe9diate de 100 SMS pour la r\xe9ception de notifications. Le montant \xe0 payer est de ${this.#reactive.amount} ${this.#reactive.currency} HT et sera inclus sur votre prochaine facture.`,
                svSE: `Genom att klicka p\xe5 bekr\xe4fta godk\xe4nner du k\xf6pet och omedelbar leverans av 100 SMS f\xf6r aviseringar. Beloppet som ska betalas \xe4r ${this.#reactive.amount} ${this.#reactive.currency} exkl. moms och kommer att debiteras p\xe5 din n\xe4sta faktura.`
            }))), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "field is-grouped is-multiline"
        }, (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "control"
        }, (0, $01d3af8f1b8eef63$export$2ba01fb71ed41cb6)({
            class: "button is-primary",
            onclick: ()=>this.#confirmPurchase()
        }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
            enGB: "Confirm",
            deDE: "Best\xe4tigen",
            frFR: "Confirmer",
            svSE: "Bekr\xe4fta"
        }))), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "control",
            onclick: ()=>{
                this.#ctx.router.jump("/account");
            }
        }, (0, $01d3af8f1b8eef63$export$2ba01fb71ed41cb6)({
            class: "button"
        }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
            enGB: "Back",
            deDE: "Zur\xfcck",
            frFR: "Retour",
            svSE: "Tillbaka"
        })))));
    }
}






/**
 * @param {string} field 
 * @param {string} target
 * @returns {Promise<User[]>}
 */ async function $5614c952f8dd1cc2$export$e9e0f62b7393cb65(field, target) {
    const res = await (0, $5ca15832b8c5d5ea$export$3988ae62b71be9a3)(`/users?field=${field}&target=${target}`);
    if (!res.ok) throw await (0, $1fb5d845307c571c$export$f00cf23da648bc9b)(res);
    return res.json();
}
/**
 * @typedef {Object} CreateAccountParams
 * @property {string} email
 * @property {string} password
 * @property {string} country
 * @property {string} name
 * @property {string} addr1
 * @property {string} addr2
 * @property {string} postalCode
 * @property {string} town
 * @property {string} vatin
 */ /**
 * @param {CreateAccountParams} args 
 */ async function $5614c952f8dd1cc2$export$402fbb8c0ae400db(args) {
    const res = await (0, $5ca15832b8c5d5ea$export$299ba2dee77727e9)("/users", {
        body: JSON.stringify({
            Email: args.email,
            Password: args.password,
            Country: args.country,
            Locale: (0, $093d22e30b803c56$export$162ce11d62a1ca51).id,
            Name: args.name,
            Addr1: args.addr1,
            Addr2: args.addr2,
            PostalCode: args.postalCode,
            Town: args.town,
            Vatin: args.vatin
        })
    });
    if (!res.ok) throw await (0, $1fb5d845307c571c$export$f00cf23da648bc9b)(res);
}






function $1f4e8f7c268ef906$export$2b2be10320b3138e() {
    const email = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).input({
        type: "email"
    });
    const password = (0, $62f894d94fb7061c$export$48d6f7351f788047)();
    const country = (0, $62f894d94fb7061c$export$a9bf4c2a13f1ac95)();
    const name = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).input({
        type: "text"
    });
    const addr1 = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).input({
        type: "text"
    });
    const addr2 = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).input({
        type: "text"
    });
    const postalCode = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).input({
        type: "text"
    });
    const town = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).input({
        type: "text"
    });
    const vatin = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).input({
        type: "text"
    });
    const onclickCreateAccount = ()=>{
        (0, $b4e14b6b8da86996$export$850e0ce216eef646)();
        (0, $5614c952f8dd1cc2$export$402fbb8c0ae400db)({
            email: email.getValue(),
            password: password.getValue(),
            country: country.getValue(),
            name: name.getValue(),
            addr1: addr1.getValue(),
            addr2: addr2.getValue(),
            postalCode: postalCode.getValue(),
            town: town.getValue(),
            vatin: vatin.getValue()
        }).then(()=>{
            if ((0, $46d03d54faf4cdf4$export$e506a1d27d1eaa20).appId === "test.my.luda.farm") (0, $b4e14b6b8da86996$export$5375cda95f0b0eb4).jump("/sign-in");
            else (0, $b4e14b6b8da86996$export$5375cda95f0b0eb4).jump(`/verify-account?email=${email.getValue()}`);
        }).finally((0, $b4e14b6b8da86996$export$d91ec774a0e3eb9e));
    };
    (0, $b4e14b6b8da86996$export$8390d50e515c191d)((0, $62f894d94fb7061c$export$4b0227fa4b29008b)("small", (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).title((0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.createAccount), document.createElement("hr"), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).title((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
        enGB: "Step 1: Enter the required account details.",
        deDE: "Schritt 1: Geben Sie die erforderlichen Kontodaten ein.",
        frFR: "\xc9tape 1 : Saisir les informations requises sur le compte.",
        svSE: "Steg 1: Ange de n\xf6dv\xe4ndiga kontouppgifterna."
    }), "is-6"), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).field({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).label((0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.email), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({}, email.element)), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).field({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).label((0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.password), password.element), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).field({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).label((0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.country), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({}, country.element)), document.createElement("hr"), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).title((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
        enGB: "Step 2 (optional): Add additional information to be included on your invoices. You may skip this step and add the details later via the billing menu. ",
        deDE: "Schritt 2 (optional): F\xfcgen Sie zus\xe4tzliche Informationen hinzu, die auf Ihren Rechnungen erscheinen sollen. Sie k\xf6nnen diesen Schritt \xfcberspringen und die Details sp\xe4ter \xfcber das Rechnungsmen\xfc hinzuf\xfcgen. ",
        frFR: "\xc9tape 2 (facultative) : Ajoutez des informations suppl\xe9mentaires \xe0 inclure dans vos factures. Vous pouvez sauter cette \xe9tape et ajouter les d\xe9tails plus tard via le menu de facturation. ",
        svSE: "Steg 2 (valfritt): L\xe4gg till ytterligare information som ska finnas med p\xe5 dina fakturor. Du kan hoppa \xf6ver det h\xe4r steget och l\xe4gga till informationen senare via betalningsmenyn. "
    }), "is-6"), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).field({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).label((0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.name), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({}, name.element)), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).field({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).label((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
        enGB: "Address line 1",
        deDE: "Adresszeile 1",
        frFR: "Adresse ligne 1",
        svSE: "Adressrad 1"
    })), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({}, addr1.element)), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).field({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).label((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
        enGB: "Address line 2",
        deDE: "Adresszeile 2",
        frFR: "Adresse ligne 2",
        svSE: "Adressrad 2"
    })), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({}, addr2.element)), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).field({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).label((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
        enGB: "Postal code",
        deDE: "Postleitzahl",
        frFR: "Code postal",
        svSE: "Postnummer"
    })), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({}, postalCode.element)), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).field({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).label((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
        enGB: "Town",
        deDE: "Stadt",
        frFR: "Ville",
        svSE: "Ort"
    })), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({}, town.element)), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).field({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).label((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
        enGB: "EU VAT identification number",
        deDE: "EU-USt-IdNr.",
        frFR: "Num\xe9ro d'identification \xe0 la TVA de l'UE",
        svSE: "EU VAT-nummer"
    })), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({}, vatin.element)), document.createElement("hr"), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).buttons((0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).button({
        onClick: onclickCreateAccount,
        styles: [
            "is-primary"
        ]
    }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.createAccount), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).button({
        onClick: ()=>(0, $b4e14b6b8da86996$export$5375cda95f0b0eb4).jump("/sign-in"),
        styles: [
            "is-primary"
        ]
    }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.cancel))));
}





/**
 * @param {string} email 
 * @param {string} password 
 * @param {string} verificationCode 
 */ async function $2cbe64b95feb2e86$export$de4b64eddb9c2b98(email, password, verificationCode) {
    const res = await (0, $5ca15832b8c5d5ea$export$327f7b26ebf455db)("/password", {
        body: JSON.stringify({
            Email: email,
            Password: password,
            VerificationCode: verificationCode
        })
    });
    if (!res.ok) throw await (0, $1fb5d845307c571c$export$f00cf23da648bc9b)(res);
}




/**
 * @param {string} email 
 */ async function $73165573c1cf3547$export$fa789d461ee63605(email) {
    const res = await (0, $5ca15832b8c5d5ea$export$327f7b26ebf455db)("/send-verification-code", {
        body: JSON.stringify({
            Email: email
        })
    });
    if (!res.ok) throw await (0, $1fb5d845307c571c$export$f00cf23da648bc9b)(res);
}





function $7b0f0753d23a5bbe$export$de4f09346a474704() {
    const email = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).input({
        type: "email"
    });
    const verificationCode = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).input({
        type: "text"
    });
    const password = (0, $62f894d94fb7061c$export$48d6f7351f788047)();
    function onClickSendVerificationCode() {
        (0, $b4e14b6b8da86996$export$850e0ce216eef646)();
        (0, $73165573c1cf3547$export$fa789d461ee63605)(email.getValue()).then((0, $62f894d94fb7061c$export$73e19c0339806233)).finally((0, $b4e14b6b8da86996$export$d91ec774a0e3eb9e));
    }
    function onClickSave() {
        (0, $b4e14b6b8da86996$export$850e0ce216eef646)();
        (0, $2cbe64b95feb2e86$export$de4b64eddb9c2b98)(email.getValue(), password.getValue(), verificationCode.getValue()).then(()=>(0, $b4e14b6b8da86996$export$5375cda95f0b0eb4).jump("/sign-in")).catch((0, $62f894d94fb7061c$export$6badb0ecde4e0bd0)).finally((0, $b4e14b6b8da86996$export$d91ec774a0e3eb9e));
    }
    (0, $b4e14b6b8da86996$export$8390d50e515c191d)((0, $62f894d94fb7061c$export$4b0227fa4b29008b)("small", (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).title((0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.resetPassword), document.createElement("hr"), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).title((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
        enGB: "Step 1: Request a verification code. If you cannot find the code in your inbox, please check your spam folder. Requesting a new verification code will invalidate any previously issued codes.",
        deDE: "Schritt 1: Fordern Sie einen Verifizierungscode an. Wenn Sie den Code nicht in Ihrem Posteingang finden, \xfcberpr\xfcfen Sie bitte Ihren Spam-Ordner. Wenn Sie einen neuen Verifizierungscode anfordern, werden alle zuvor ausgestellten Codes ung\xfcltig.",
        frFR: "\xc9tape 1 : Demander un code de v\xe9rification. Si vous ne trouvez pas le code dans votre bo\xeete de r\xe9ception, v\xe9rifiez votre dossier de courrier ind\xe9sirable. La demande d'un nouveau code de v\xe9rification invalidera tous les codes pr\xe9c\xe9demment \xe9mis.",
        svSE: "Steg 1: Beg\xe4r en verifieringskod. Om du inte hittar koden i din inkorg, kontrollera din skr\xe4ppostmapp. Om du beg\xe4r en ny verifieringskod kommer alla tidigare utf\xe4rdade koder att ogiltigf\xf6rklaras."
    }), "is-6"), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).field({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).label((0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.email), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({}, email.element)), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).buttons((0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).button({
        onClick: onClickSendVerificationCode,
        styles: [
            "is-primary"
        ]
    }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
        enGB: "Send verification code",
        deDE: "Best\xe4tigungscode senden",
        frFR: "Envoyer le code de v\xe9rification",
        svSE: "Skicka verifieringskod"
    }))), document.createElement("hr"), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).title((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
        enGB: "Step 2: Enter the verification code and choose a new password.",
        deDE: "Schritt 2: Geben Sie den Best\xe4tigungscode ein und w\xe4hlen Sie ein neues Passwort.",
        frFR: "\xc9tape 2 : Saisissez le code de v\xe9rification et choisissez un nouveau mot de passe.",
        svSE: "Steg 2: Ange verifieringskoden och v\xe4lj ett nytt l\xf6senord."
    }), "is-6"), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).field({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).label((0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.verificationCode), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({}, verificationCode.element)), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).field({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).label((0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.password), password.element), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).buttons((0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).button({
        onClick: onClickSave,
        styles: [
            "is-primary"
        ]
    }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.save), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).button({
        onClick: ()=>(0, $b4e14b6b8da86996$export$5375cda95f0b0eb4).jump("/sign-in"),
        styles: [
            "is-primary"
        ]
    }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.cancel))));
}







/**
 * @param {string} email
 * @param {string} password
 */ async function $bb70c195159f62e5$export$9670d83f11d4b64a(email, password) {
    const res = await (0, $5ca15832b8c5d5ea$export$327f7b26ebf455db)("/sign-in", {
        body: JSON.stringify({
            Email: email,
            Password: password,
            ClientTheme: (0, $46d03d54faf4cdf4$export$e506a1d27d1eaa20).brand
        })
    });
    if (!res.ok) throw await (0, $1fb5d845307c571c$export$f00cf23da648bc9b)(res);
    /** @type {Auth} */ const { User: User, Token: Token } = await res.json();
    await (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).setUser(User);
    await (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).setToken(Token);
}






function $fa3a5fe17cfe0327$export$f150117fa567a868() {
    const email = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).input({
        type: "email"
    });
    const password = (0, $62f894d94fb7061c$export$48d6f7351f788047)();
    const onclickSignIn = ()=>{
        (0, $b4e14b6b8da86996$export$850e0ce216eef646)();
        (0, $bb70c195159f62e5$export$9670d83f11d4b64a)(email.getValue(), password.getValue()).then(()=>(0, $bfc59006cf644cf7$export$ca000e230c0caa3e).loadDevices()).then(()=>(0, $bfc59006cf644cf7$export$ca000e230c0caa3e).getSignedInUser()).then((user)=>{
            if (user.AccountType === "smartplug2-factory") (0, $b4e14b6b8da86996$export$5375cda95f0b0eb4).jump("/factory/smartplug2");
            else (0, $b4e14b6b8da86996$export$5375cda95f0b0eb4).jump("/devices");
        }).finally((0, $b4e14b6b8da86996$export$d91ec774a0e3eb9e));
    };
    (0, $b4e14b6b8da86996$export$8390d50e515c191d)((0, $62f894d94fb7061c$export$4b0227fa4b29008b)("small", (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).title((0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.signIn), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).field({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).label((0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.email), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({}, email.element)), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).field({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).label((0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.password), password.element), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).buttons((0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).button({
        onClick: onclickSignIn,
        styles: [
            "is-fullwidth",
            "is-primary"
        ]
    }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.signIn), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).button({
        onClick: ()=>(0, $b4e14b6b8da86996$export$5375cda95f0b0eb4).jump("/create-account"),
        styles: [
            "is-fullwidth",
            "is-primary",
            "is-small"
        ]
    }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.createAccount), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).button({
        onClick: ()=>(0, $b4e14b6b8da86996$export$5375cda95f0b0eb4).jump("/reset-password"),
        styles: [
            "is-fullwidth",
            "is-primary",
            "is-small"
        ]
    }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.resetPassword), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).button({
        onClick: ()=>(0, $b4e14b6b8da86996$export$5375cda95f0b0eb4).jump("/verify-account"),
        styles: [
            "is-fullwidth",
            "is-primary",
            "is-small"
        ]
    }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.verifyAccount))));
}









async function $029bbdfef69be952$export$7d0f10f273c0438a() {
    const user = await (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).getActiveUser();
    const res = await (0, $5ca15832b8c5d5ea$export$1d2f21e549771e67)(`/users/${user.Id}`);
    if (!res.ok) throw await (0, $1fb5d845307c571c$export$f00cf23da648bc9b)(res);
}
/**
 * @param {string} userId
 * @returns {Promise<User>}
 */ async function $029bbdfef69be952$export$7cbf767827cd68ba(userId) {
    const res = await (0, $5ca15832b8c5d5ea$export$3988ae62b71be9a3)(`/users/${userId}`);
    if (!res.ok) throw await (0, $1fb5d845307c571c$export$f00cf23da648bc9b)(res);
    return res.json();
}
/**
 * @param {PutUserParams} args
 */ async function $029bbdfef69be952$export$16edcaea489c14d3(args) {
    const user = await (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).getActiveUser();
    const res = await (0, $5ca15832b8c5d5ea$export$327f7b26ebf455db)(`/users/${user.Id}`, {
        body: JSON.stringify(args)
    });
    if (!res.ok) throw await (0, $1fb5d845307c571c$export$f00cf23da648bc9b)(res);
    return res.json();
}
/**
 * Only admin access
 * @param {string} userId 
 * @param {string} email 
 * @returns {Promise<User>}
 */ async function $029bbdfef69be952$export$2e6a7d38aeb8551a(userId, email) {
    const res = await (0, $5ca15832b8c5d5ea$export$327f7b26ebf455db)(`/users/${userId}/email`, {
        body: JSON.stringify({
            Email: email
        })
    });
    if (!res.ok) throw await (0, $1fb5d845307c571c$export$f00cf23da648bc9b)(res);
    return res.json();
}
/**
 * Only admin access
 * @param {string} userId 
 * @returns {Promise<User>}
 */ async function $029bbdfef69be952$export$c67a7c8a997a1014(userId) {
    const res = await (0, $5ca15832b8c5d5ea$export$327f7b26ebf455db)(`/users/${userId}/verify-email`);
    if (!res.ok) throw await (0, $1fb5d845307c571c$export$f00cf23da648bc9b)(res);
    return res.json();
}







async function $a6cb54bc05218585$export$7447ddec82e37c51(ctx) {
    const loading = (0, $259ccf8ca7c2ca99$export$2e2bcd8739ae039).state(false);
    const query = (0, $259ccf8ca7c2ca99$export$2e2bcd8739ae039).state("");
    /** @type {import("vanjs-core").State<User[]>} */ const users = (0, $259ccf8ca7c2ca99$export$2e2bcd8739ae039).state([]);
    const onClickSearch = ()=>{
        loading.val = true;
        (0, $5614c952f8dd1cc2$export$e9e0f62b7393cb65)("email", query.val).then((result)=>{
            if (result.length === 1) (0, $b4e14b6b8da86996$export$5375cda95f0b0eb4).jump(`/admin/user/${result[0].Id}`);
            else users.val = result;
        }).catch((0, $62f894d94fb7061c$export$6badb0ecde4e0bd0)).finally(()=>{
            loading.val = false;
        });
    };
    return (0, $e47741cb5fbbb614$export$4b0227fa4b29008b)({
        size: "narrow"
    }, (0, $01d3af8f1b8eef63$export$80e4b313e5e6b30d)({
        class: "breadcrumb"
    }, (0, $01d3af8f1b8eef63$export$b5023c870cb34848)((0, $01d3af8f1b8eef63$export$19caeaf7d9d84644)((0, $01d3af8f1b8eef63$export$407448d2b89b1813)({
        onclick: ()=>(0, $b4e14b6b8da86996$export$5375cda95f0b0eb4).jump("/admin")
    }, "Admin")), (0, $01d3af8f1b8eef63$export$19caeaf7d9d84644)((0, $01d3af8f1b8eef63$export$407448d2b89b1813)("User")))), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
        class: "field has-addons"
    }, (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
        class: "control is-expanded"
    }, (0, $01d3af8f1b8eef63$export$b7e3ae3d7c15e42e)({
        class: "input",
        oninput: (e)=>{
            query.val = e.target.value;
        },
        placeholder: "Email"
    })), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
        class: "control"
    }, (0, $01d3af8f1b8eef63$export$2ba01fb71ed41cb6)({
        class: ()=>loading.val ? "button is-primary is-loading" : "button is-primary",
        disabled: ()=>loading.val,
        onclick: onClickSearch
    }, "Search"))), (0, $01d3af8f1b8eef63$export$9852986a3ec5f6a0)({
        class: "table is-fullwidth is-striped"
    }, ()=>(0, $01d3af8f1b8eef63$export$7cdd536eaa8f163c)(users.val.map((user)=>(0, $01d3af8f1b8eef63$export$72451b88a72ad9c2)((0, $01d3af8f1b8eef63$export$2beef8af2014e5c6)((0, $01d3af8f1b8eef63$export$407448d2b89b1813)({
                onclick: ()=>(0, $b4e14b6b8da86996$export$5375cda95f0b0eb4).jump(`/admin/user/${user.Id}`)
            }, user.Email)))))));
}
async function $a6cb54bc05218585$export$b4bd6d55cc9ce0e1(ctx) {
    if (!ctx || !ctx.data || !ctx.data.id) throw "missing ctx.data.id";
    const page = (0, $75d47fd8903c7af6$export$90a44edba14e47be)({
        email: "",
        loading: false,
        user: await (0, $029bbdfef69be952$export$7cbf767827cd68ba)(ctx.data.id)
    });
    function onClickImpersonate() {
        page.loading = true;
        (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).startImpersonating(page.user).then(()=>(0, $b4e14b6b8da86996$export$5375cda95f0b0eb4).jump("/devices")).catch((0, $62f894d94fb7061c$export$6badb0ecde4e0bd0)).finally(()=>{
            page.loading = false;
        });
    }
    function onClickSaveEmail() {
        page.loading = true;
        (0, $029bbdfef69be952$export$2e6a7d38aeb8551a)(page.user.Id, page.email).then((user)=>{
            page.user = user;
            (0, $62f894d94fb7061c$export$73e19c0339806233)();
        }).catch((0, $62f894d94fb7061c$export$6badb0ecde4e0bd0)).finally(()=>{
            page.loading = false;
        });
    }
    function onClickVerifyUser() {
        page.loading = true;
        (0, $029bbdfef69be952$export$c67a7c8a997a1014)(page.user.Id).then((user)=>{
            page.user = user;
            (0, $62f894d94fb7061c$export$73e19c0339806233)();
        }).catch((0, $62f894d94fb7061c$export$6badb0ecde4e0bd0)).finally(()=>{
            page.loading = false;
        });
    }
    return (0, $e47741cb5fbbb614$export$4b0227fa4b29008b)({
        size: "narrow"
    }, (0, $01d3af8f1b8eef63$export$80e4b313e5e6b30d)({
        class: "breadcrumb"
    }, (0, $01d3af8f1b8eef63$export$b5023c870cb34848)((0, $01d3af8f1b8eef63$export$19caeaf7d9d84644)((0, $01d3af8f1b8eef63$export$407448d2b89b1813)({
        onclick: ()=>(0, $b4e14b6b8da86996$export$5375cda95f0b0eb4).jump("/admin")
    }, "Admin")), (0, $01d3af8f1b8eef63$export$19caeaf7d9d84644)((0, $01d3af8f1b8eef63$export$407448d2b89b1813)({
        onclick: ()=>(0, $b4e14b6b8da86996$export$5375cda95f0b0eb4).jump("/admin/user")
    }, "User")), (0, $01d3af8f1b8eef63$export$19caeaf7d9d84644)((0, $01d3af8f1b8eef63$export$407448d2b89b1813)(page.user.Email)))), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
        class: "buttons"
    }, (0, $01d3af8f1b8eef63$export$2ba01fb71ed41cb6)({
        class: ()=>page.loading ? "button is-primary is-loading" : "button is-primary",
        disabled: ()=>page.loading,
        onclick: onClickImpersonate
    }, "Impersonate"), (0, $01d3af8f1b8eef63$export$2ba01fb71ed41cb6)({
        class: ()=>page.loading ? "button is-primary is-loading" : "button is-primary",
        disabled: ()=>page.loading,
        onclick: ()=>window.open(`${(0, $46d03d54faf4cdf4$export$e506a1d27d1eaa20).stripeBaseUrl}/customers/${page.user.CustomerId}`, "_blank")
    }, "Stripe"), (0, $01d3af8f1b8eef63$export$2ba01fb71ed41cb6)({
        class: ()=>page.loading ? "button is-primary is-loading" : "button is-primary",
        disabled: ()=>page.loading,
        onclick: onClickVerifyUser
    }, "Verify")), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
        class: "field has-addons"
    }, (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
        class: "control"
    }, (0, $01d3af8f1b8eef63$export$b7e3ae3d7c15e42e)({
        class: "input",
        oninput: (e)=>{
            page.email = e.target.value;
        },
        placeholder: "new email",
        value: ()=>page.email
    })), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
        class: "control"
    }, (0, $01d3af8f1b8eef63$export$2ba01fb71ed41cb6)({
        class: ()=>page.loading ? "button is-primary is-loading" : "button is-primary",
        disabled: ()=>page.loading,
        onclick: onClickSaveEmail
    }, "Save"))), (0, $01d3af8f1b8eef63$export$2af2ac64526e2aa9)({
        class: "is-tiny-mobile"
    }, ()=>JSON.stringify(page.user, null, 2)));
}






/**
 * @param {string} email
 * @param {string} code
 */ async function $4b2c791de29643ad$export$1a974f1e1986c706(email, code) {
    const res = await (0, $5ca15832b8c5d5ea$export$327f7b26ebf455db)(`/verify-email`, {
        body: JSON.stringify({
            Email: email,
            VerificationCode: code
        })
    });
    if (!res.ok) throw await (0, $1fb5d845307c571c$export$f00cf23da648bc9b)(res);
}






/**
 * @param {import("navigo").Match | undefined} ctx
 */ function $99ee0c4dd1affd10$export$cc5b19a94aa6c250(ctx) {
    const email = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).input({
        type: "email",
        value: ctx?.params?.email
    });
    if (ctx?.params?.email) {
        // Update browser url, remove email from query params
        delete ctx.params.email;
        window.history.replaceState(null, "", ctx.url);
    }
    const verificationCode = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).input({
        type: "text"
    });
    function onClickVerify() {
        (0, $b4e14b6b8da86996$export$850e0ce216eef646)();
        (0, $4b2c791de29643ad$export$1a974f1e1986c706)(email.getValue(), verificationCode.getValue()).then(()=>{
            (0, $b4e14b6b8da86996$export$5375cda95f0b0eb4).jump(`/sign-in${(0, $820877bea407f5fe$export$89a7e74069fbb7af)({
                email: email.getValue()
            })}`);
        }).finally((0, $b4e14b6b8da86996$export$d91ec774a0e3eb9e));
    }
    const onclickResend = ()=>{
        (0, $b4e14b6b8da86996$export$850e0ce216eef646)();
        (0, $73165573c1cf3547$export$fa789d461ee63605)(email.getValue()).then((0, $62f894d94fb7061c$export$73e19c0339806233)).finally((0, $b4e14b6b8da86996$export$d91ec774a0e3eb9e));
    };
    (0, $b4e14b6b8da86996$export$8390d50e515c191d)((0, $62f894d94fb7061c$export$4b0227fa4b29008b)("small", (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).title((0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.verifyAccount), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).title((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
        enGB: "If you cannot find the verification code email in your inbox, please check your spam folder. Requesting a new verification code will invalidate all previously issued codes.",
        deDE: "Wenn Sie die E-Mail mit dem Verifizierungscode nicht in Ihrem Posteingang finden, \xfcberpr\xfcfen Sie bitte Ihren Spam-Ordner. Wenn Sie einen neuen Verifizierungscode anfordern, werden alle zuvor ausgestellten Codes ung\xfcltig.",
        frFR: "Si vous ne trouvez pas le code de v\xe9rification dans votre bo\xeete de r\xe9ception, veuillez v\xe9rifier votre dossier de courrier ind\xe9sirable. La demande d'un nouveau code de v\xe9rification invalidera tous les codes pr\xe9c\xe9demment \xe9mis.",
        svSE: "Om du inte hittar e-postmeddelandet med verifieringskoden i din inkorg, kontrollera din skr\xe4ppostmapp. Om du beg\xe4r en ny verifieringskod kommer alla tidigare utf\xe4rdade koder att ogiltigf\xf6rklaras."
    }), "is-6"), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).field({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).label((0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.email), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({}, email.element)), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).field({}, (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).label((0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.verificationCode), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).control({}, verificationCode.element)), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).buttons((0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).button({
        onClick: onclickResend,
        styles: [
            "is-primary"
        ]
    }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
        enGB: "Send new verification code",
        deDE: "Neuen Verifizierungscode senden",
        frFR: "Envoyer un nouveau code de v\xe9rification",
        svSE: "Skicka ny verifieringskod"
    }))), document.createElement("hr"), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).buttons((0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).button({
        onClick: onClickVerify,
        styles: [
            "is-primary"
        ]
    }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.confirm), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).button({
        onClick: ()=>(0, $b4e14b6b8da86996$export$5375cda95f0b0eb4).jump("/sign-in"),
        styles: [
            "is-primary"
        ]
    }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.cancel))));
}





async function $2bf615888d3a6bbe$export$1689915c29e5bc8(_ctx) {
    return (0, $62f894d94fb7061c$export$4b0227fa4b29008b)("large", (0, $01d3af8f1b8eef63$export$448e4850cad7c7b0)({
        class: "title"
    }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
        enGB: "Warranties",
        deDE: "Garantien",
        frFR: "Garanties",
        svSE: "Garantier"
    })), (0, $01d3af8f1b8eef63$export$ffb5f4729a158638)((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
        enGB: "The extended warranty period is always included; product registration is no longer necessary to receive it.",
        deDE: "Die erweiterte Garantiezeit ist immer inbegriffen; eine Produktregistrierung ist nicht l\xe4nger notwendig, um sie zu erhalten.",
        frFR: "La p\xe9riode de garantie prolong\xe9e est toujours incluse ; l'enregistrement du produit n'est plus n\xe9cessaire pour en b\xe9n\xe9ficier.",
        svSE: "Den ut\xf6kade garantitiden ing\xe5r alltid; produktregistrering \xe4r inte l\xe4ngre n\xf6dv\xe4ndig f\xf6r att f\xe5 den."
    })), (0, $01d3af8f1b8eef63$export$479ac0420f53ed26)(), (0, $01d3af8f1b8eef63$export$ffb5f4729a158638)((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
        enGB: "However, a valid proof of purchase is still required when a warranty claim is made. A valid proof of purchase must contain the vendor, date, and proof that payment has been made.",
        deDE: "Ein g\xfcltiger Kaufbeleg ist jedoch weiterhin erforderlich, wenn ein Garantieanspruch geltend gemacht wird. Ein g\xfcltiger Kaufbeleg muss den Verk\xe4ufer, das Datum und einen Zahlungsnachweis enthalten.",
        frFR: "Cependant, une preuve d'achat valide est toujours requise lors d'une r\xe9clamation au titre de la garantie. Une preuve d'achat valide doit contenir le fournisseur, la date et la preuve que le paiement a \xe9t\xe9 effectu\xe9.",
        svSE: "Ett giltigt k\xf6pbevis kr\xe4vs dock fortfarande n\xe4r ett garantianspr\xe5k g\xf6rs. Ett giltigt k\xf6pbevis m\xe5ste inneh\xe5lla s\xe4ljaren, datumet och bevis p\xe5 att betalning har gjorts."
    })));
}





function $29200b5e0c1497dc$export$53a0910f038337bd(c) {
    if (!(c instanceof HTMLElement)) throw "ChildDom is not an html element";
    if (!c.isConnected) throw "ChildDom is not connected";
    requestAnimationFrame(()=>{
        requestAnimationFrame(()=>{
            c.scrollIntoView({
                behavior: "smooth",
                block: "center",
                inline: "center"
            });
        });
    });
}
function $29200b5e0c1497dc$export$f5d3771428a1f489() {
    requestAnimationFrame(()=>{
        requestAnimationFrame(()=>{
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
        });
    });
}


class $37e4bedd8b6e8d0f$export$b0bceea2ea86179a {
    // Sets visibility to hidden.
    clear() {
        this.#reactive.text = "";
    }
    // Set the displayed text and scroll the notification into view.
    setText(text) {
        this.#reactive.text = text;
        (0, $29200b5e0c1497dc$export$53a0910f038337bd)(this.ChildDom);
    }
    #reactive = (0, $75d47fd8903c7af6$export$90a44edba14e47be)({
        text: ""
    });
    ChildDom;
    constructor(){
        this.ChildDom = (0, $01d3af8f1b8eef63$export$fe2e36411d703b3d)({
            class: "section"
        }, (0, $01d3af8f1b8eef63$export$bba2aacf8566461b)({
            class: ()=>this.#reactive.text ? "message is-danger" : "is-hidden"
        }, (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "message-header"
        }, (0, $01d3af8f1b8eef63$export$ffb5f4729a158638)("Error"), (0, $01d3af8f1b8eef63$export$2ba01fb71ed41cb6)({
            class: "delete",
            onclick: ()=>this.clear()
        })), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "message-body"
        }, ()=>this.#reactive.text)));
    }
}





class $2e1cba98144dc6bb$export$e2b0760399e6dece {
    /**
	 * @template T
	 * @param {Promise<T>} p
	 * @returns {Promise<T>}
	 */ async waitFor(p) {
        this.#reactive.count++;
        return p.finally(()=>{
            this.#reactive.count--;
        });
    }
    #reactive = (0, $75d47fd8903c7af6$export$90a44edba14e47be)({
        count: 0
    });
    ChildDom;
    constructor(){
        this.ChildDom = (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: ()=>this.#reactive.count > 0 ? "modal is-active" : "modal"
        }, (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "modal-background"
        }), (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "modal-content"
        }, (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "box"
        }, (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "level"
        }, (0, $01d3af8f1b8eef63$export$159d9494db57879b)({
            class: "level-item"
        }, (0, $01d3af8f1b8eef63$export$2ba01fb71ed41cb6)({
            class: "button is-white is-large is-loading",
            disabled: true
        }), (0, $01d3af8f1b8eef63$export$2ba01fb71ed41cb6)({
            class: "button is-danger",
            onclick: ()=>{
                this.#reactive.count = 0;
                window.history.back();
            }
        }, (0, $093d22e30b803c56$export$625550452a3fa3ec)("loadingScreen.abortButton")))))));
    }
}





var $gJCIb = parcelRequire("gJCIb");



const $5787d4f2e2e8ff32$export$aecba48a5f780a75 = (0, $gJCIb.registerPlugin)('AppLauncher', {
    web: ()=>(parcelRequire("6jpYe")).then((m)=>new m.AppLauncherWeb())
});







/**
 * @param {string} [returnUrl]
 * @returns {Promise<string>}
 */ async function $63ebd3cb465d1b1a$export$776b50dd35ff8711(returnUrl) {
    const user = await (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).getActiveUser();
    let path = `/users/${user.Id}/billing`;
    if (returnUrl) path += `?return-url=${encodeURIComponent(returnUrl)}`;
    const res = await (0, $5ca15832b8c5d5ea$export$3988ae62b71be9a3)(path);
    if (!res.ok) throw await (0, $1fb5d845307c571c$export$f00cf23da648bc9b)(res);
    return res.json();
}







async function $47bf247eb1c33a5a$var$openBillingPortal() {
    (0, $b4e14b6b8da86996$export$850e0ce216eef646)();
    const returnUrl = (0, $1d17319f79c68be8$export$d70a5ce4bc79c42d) ? `${(0, $46d03d54faf4cdf4$export$e506a1d27d1eaa20).baseUrl}/redirect?uri=${encodeURIComponent((await (0, $fc70cc85372c45fc$export$86fbec116b87613f).getInfo()).id + "://")}` : undefined;
    (0, $63ebd3cb465d1b1a$export$776b50dd35ff8711)(returnUrl).then((url)=>{
        if (0, $1d17319f79c68be8$export$d70a5ce4bc79c42d) (0, $5787d4f2e2e8ff32$export$aecba48a5f780a75).openUrl({
            url: url
        }).catch(()=>window.open(url, "_blank"));
        else window.open(url, "_blank");
    }).finally((0, $b4e14b6b8da86996$export$d91ec774a0e3eb9e));
}
/**
 * @param {string} theme
 * @returns
 */ async function $47bf247eb1c33a5a$export$58733aaf927c3bbe(theme) {
    const isSignedIn = await (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).isSignedIn();
    const user = await (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).getSignedInUser();
    return (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).navbar({
        theme: theme,
        brand: [
            (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).navbarItem({}, (0, $259ccf8ca7c2ca99$export$2e2bcd8739ae039).tags.figure({
                class: "image"
            }, (0, $259ccf8ca7c2ca99$export$2e2bcd8739ae039).tags.img({
                src: (0, $46d03d54faf4cdf4$export$555f04397502546)["logo.png"]
            })))
        ],
        start: [
            (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).navbarItem({
                hidden: !isSignedIn,
                onClick: ()=>(0, $b4e14b6b8da86996$export$5375cda95f0b0eb4).jump("/devices")
            }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
                enGB: "Devices",
                deDE: "Ger\xe4te",
                frFR: "Appareils",
                svSE: "Enheter"
            })),
            (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).navbarItem({
                hidden: !isSignedIn,
                onClick: ()=>(0, $b4e14b6b8da86996$export$5375cda95f0b0eb4).jump("/account")
            }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
                enGB: "Account",
                deDE: "Konto",
                frFR: "Compte",
                svSE: "Konto"
            })),
            (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).navbarItem({
                hidden: !isSignedIn,
                onClick: $47bf247eb1c33a5a$var$openBillingPortal
            }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.billing),
            (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).navbarItem({
                hidden: !isSignedIn,
                onClick: ()=>(0, $b4e14b6b8da86996$export$5375cda95f0b0eb4).jump("/warranties")
            }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.warranties),
            (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).navbarItem({
                href: (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
                    enGB: "https://support.luda.farm/en/support/solutions/14000076272",
                    deDE: "https://support.luda.farm/de/support/solutions/14000076272",
                    frFR: "https://support.luda.farm/fr/support/solutions/14000076272",
                    svSE: "https://support.luda.farm/sv-SE/support/solutions/14000076272"
                }),
                target: "_blank"
            }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
                enGB: "Support",
                deDE: "Support",
                frFR: "Support",
                svSE: "Support"
            }))
        ],
        end: [
            (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).navbarItem({
                hidden: user.AccountType !== "admin",
                onClick: ()=>(0, $b4e14b6b8da86996$export$5375cda95f0b0eb4).jump("/admin")
            }, "Admin"),
            (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).navbarDropdown((0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.language, $47bf247eb1c33a5a$var$setLocaleNavbarItem("English", "en-GB"), $47bf247eb1c33a5a$var$setLocaleNavbarItem("Deutsch", "de-DE"), $47bf247eb1c33a5a$var$setLocaleNavbarItem("Fran\xe7ais", "fr-FR"), $47bf247eb1c33a5a$var$setLocaleNavbarItem("Svenska", "sv-SE")),
            (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).navbarItem({
                hidden: isSignedIn,
                onClick: ()=>(0, $b4e14b6b8da86996$export$5375cda95f0b0eb4).jump("/sign-in")
            }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).strings.signIn),
            (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).navbarItem({
                hidden: !isSignedIn || (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).isImpersonating(),
                onClick: $47bf247eb1c33a5a$var$signOut
            }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
                enGB: "Sign out",
                deDE: "Abmelden",
                frFR: "Se d\xe9connecter",
                svSE: "Logga ut"
            })),
            (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).navbarItem({
                hidden: !isSignedIn || !(0, $bfc59006cf644cf7$export$ca000e230c0caa3e).isImpersonating(),
                onClick: $47bf247eb1c33a5a$var$stopImpersonating
            }, "Stop impersonating")
        ]
    });
}
/**
 * @param {string} text
 * @param {Locale} id
 */ function $47bf247eb1c33a5a$var$setLocaleNavbarItem(text, id) {
    const setLocale = async ()=>{
        const user = await (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).getSignedInUser();
        user.Locale = id;
        await (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).setUser(user);
        (0, $093d22e30b803c56$export$162ce11d62a1ca51).update();
        location.reload();
    };
    return (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).navbarItem({
        onClick: setLocale
    }, text);
}
async function $47bf247eb1c33a5a$var$signOut() {
    await (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).signOut();
    (0, $b4e14b6b8da86996$export$5375cda95f0b0eb4).jump("/sign-in");
}
async function $47bf247eb1c33a5a$var$stopImpersonating() {
    const user = await (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).getActiveUser();
    await (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).stopImpersonate();
    (0, $b4e14b6b8da86996$export$5375cda95f0b0eb4).jump(`/admin/user/${user.Id}`);
}






function $667035053528aa06$export$54aa6ad87bc1ccdf() {
    (0, $b4e14b6b8da86996$export$8390d50e515c191d)((0, $62f894d94fb7061c$export$4b0227fa4b29008b)("small", (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).title((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
        enGB: "Page not found",
        deDE: "Seite nicht gefunden",
        frFR: "Page non trouv\xe9e",
        svSE: "Sidan hittades inte"
    })), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).buttons((0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).button({
        onClick: ()=>window.history.back(),
        styles: [
            "is-primary"
        ]
    }, (0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
        enGB: "Return to previous page",
        deDE: "Zur\xfcck zur vorherigen Seite",
        frFR: "Retourner \xe0 la page pr\xe9c\xe9dente",
        svSE: "\xc5terv\xe4nd till f\xf6reg\xe5ende sida"
    })))));
}







/**
 * @type {import('navigo').Handler}
 */ function $c5ee9d71404d146f$var$mount(ctx) {
    const uri = ctx && ctx.params && ctx.params.uri ? ctx.params.uri : "/devices";
    (0, $b4e14b6b8da86996$export$8390d50e515c191d)((0, $62f894d94fb7061c$export$4b0227fa4b29008b)("small", (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).title((0, $093d22e30b803c56$export$162ce11d62a1ca51).string({
        enGB: "Redirecting to app...",
        deDE: "Wird zur App weitergeleitet...",
        frFR: "Redirige vers l'application...",
        svSE: "Omdirigerar till appen..."
    }), "is-6")));
    $c5ee9d71404d146f$var$timeout = setTimeout($c5ee9d71404d146f$var$redirect(uri), 100);
}
function $c5ee9d71404d146f$var$onUnmount() {
    clearTimeout($c5ee9d71404d146f$var$timeout);
}
/**
 * @param {string} uri 
 */ function $c5ee9d71404d146f$var$redirect(uri) {
    return ()=>{
        const a = (0, $00995e7d83a33b33$export$13f9d3c4397c4713).anchor({
            href: uri
        });
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    };
}
const $c5ee9d71404d146f$export$2d3f8d507b48559 = {
    mount: $c5ee9d71404d146f$var$mount,
    onUnmount: $c5ee9d71404d146f$var$onUnmount
};
/** @type {NodeJS.Timeout} */ let $c5ee9d71404d146f$var$timeout;


(0, $46d03d54faf4cdf4$export$b38182bb7e976415)();
const $b4e14b6b8da86996$export$4dd468714b60fb1 = document.createElement("div");
$b4e14b6b8da86996$export$4dd468714b60fb1.className = "app-container";
if (0, $1d17319f79c68be8$export$f0e9209d1b946997) $b4e14b6b8da86996$export$4dd468714b60fb1.classList.add("is-android");
const $b4e14b6b8da86996$var$loadingScreen = document.createElement("div");
$b4e14b6b8da86996$var$loadingScreen.className = "pageloader is-active";
const $b4e14b6b8da86996$var$error = new (0, $37e4bedd8b6e8d0f$export$b0bceea2ea86179a)();
const $b4e14b6b8da86996$export$96e4b36520c26a2c = (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).modalCard();
const $b4e14b6b8da86996$var$loadingScreen2 = new (0, $2e1cba98144dc6bb$export$e2b0760399e6dece)();
(0, $259ccf8ca7c2ca99$export$2e2bcd8739ae039).add(document.body, $b4e14b6b8da86996$export$4dd468714b60fb1, $b4e14b6b8da86996$var$error.ChildDom, $b4e14b6b8da86996$var$loadingScreen, $b4e14b6b8da86996$export$96e4b36520c26a2c.element, $b4e14b6b8da86996$var$loadingScreen2.ChildDom);
const $b4e14b6b8da86996$export$5375cda95f0b0eb4 = new (0, $e817d3341cf3ea9c$export$55185c17a0fcbe46)({
    notFoundHandler: (0, $667035053528aa06$export$54aa6ad87bc1ccdf),
    mountRoute: $b4e14b6b8da86996$export$8390d50e515c191d,
    rootPath: "/"
});
$b4e14b6b8da86996$export$5375cda95f0b0eb4.routeContext = {
    api: new (0, $b6a0b7007b404cc4$export$bf71da7aebe9ddc1)((0, $46d03d54faf4cdf4$export$e506a1d27d1eaa20).apiHost, ()=>$b4e14b6b8da86996$export$5375cda95f0b0eb4.jump("/connection-error")),
    error: $b4e14b6b8da86996$var$error,
    loadingScreen: $b4e14b6b8da86996$var$loadingScreen2,
    router: $b4e14b6b8da86996$export$5375cda95f0b0eb4,
    sp2gw: new (0, $b6a0b7007b404cc4$export$bf71da7aebe9ddc1)((0, $46d03d54faf4cdf4$export$e506a1d27d1eaa20).sp2gwHost, ()=>$b4e14b6b8da86996$export$5375cda95f0b0eb4.jump("/connection-error"))
};
$b4e14b6b8da86996$export$5375cda95f0b0eb4.registerRoute("/account", (0, $bbfbc0513280cc0c$export$9173d18d49443e0e));
$b4e14b6b8da86996$export$5375cda95f0b0eb4.registerRoute("/account/buy-sms", (0, $703755f1453b1d22$export$2036bcb1969c94e4));
$b4e14b6b8da86996$export$5375cda95f0b0eb4.registerRoute("/account/delete", (0, $fefa727a2ea4375d$export$cddce1836c22e22d));
$b4e14b6b8da86996$export$5375cda95f0b0eb4.registerRoute("/admin", (0, $bfef550b573ada6a$export$b25f57c16f88d7e0));
$b4e14b6b8da86996$export$5375cda95f0b0eb4.registerRoute("/admin/farmcam-sim/:imsi", (0, $64507ffd9a2bdb57$export$3e1e7910c6da7b17));
$b4e14b6b8da86996$export$5375cda95f0b0eb4.registerRouteDEPRECATED("/admin/fencealarm/:imei", $b4e14b6b8da86996$var$handler((0, $2732ce926bbb4091$export$e5a937db4458395)));
$b4e14b6b8da86996$export$5375cda95f0b0eb4.registerRouteDEPRECATED("/admin/fencealarm2/:imei", $b4e14b6b8da86996$var$handler((0, $15abd1f8aa5f0cdf$export$514f615059d1e082)));
$b4e14b6b8da86996$export$5375cda95f0b0eb4.registerRouteDEPRECATED("/admin/notices", (0, $ee33a905b5218ffb$export$3fc57ce5e4ed10c9));
$b4e14b6b8da86996$export$5375cda95f0b0eb4.registerRoute("/admin/smartplug/:imei", (0, $5ec653cd26c41bd6$export$ef40ba64e7c086a8));
$b4e14b6b8da86996$export$5375cda95f0b0eb4.registerRoute("/admin/smartplug2/:imei", (0, $2d420dd298924539$export$763773f95838f192));
$b4e14b6b8da86996$export$5375cda95f0b0eb4.registerRoute("/admin/smartplug2/:imei/factory-reset", (0, $bce34944013670ff$export$7983a1e379efc9f5));
$b4e14b6b8da86996$export$5375cda95f0b0eb4.registerRoute("/admin/smartplug2/:imei/fota", (0, $1fea2c9473c4db7a$export$30b4f9ad07dd2eb5));
$b4e14b6b8da86996$export$5375cda95f0b0eb4.registerRouteDEPRECATED("/admin/user", $b4e14b6b8da86996$var$handler((0, $a6cb54bc05218585$export$7447ddec82e37c51)));
$b4e14b6b8da86996$export$5375cda95f0b0eb4.registerRouteDEPRECATED("/admin/user/:id", $b4e14b6b8da86996$var$handler((0, $a6cb54bc05218585$export$b4bd6d55cc9ce0e1)));
$b4e14b6b8da86996$export$5375cda95f0b0eb4.registerRouteDEPRECATED("/connection-error", (0, $1fb5d845307c571c$export$17fa54b11a8d3e34));
$b4e14b6b8da86996$export$5375cda95f0b0eb4.registerRouteDEPRECATED("/create-account", (0, $1f4e8f7c268ef906$export$2b2be10320b3138e));
$b4e14b6b8da86996$export$5375cda95f0b0eb4.registerRouteDEPRECATED("/devices", (0, $148bc2e0664352dc$export$d5ac705d10f5fe4f), {
    leave: (0, $148bc2e0664352dc$export$131337a3dd506b19)
});
$b4e14b6b8da86996$export$5375cda95f0b0eb4.registerRouteDEPRECATED("/devices/register", (0, $3718c958b5f34043$export$5f16fb988359c87d));
$b4e14b6b8da86996$export$5375cda95f0b0eb4.registerRouteDEPRECATED("/devices/register/farmcam-sim", (0, $03873b678c48e3cc$export$f338cc65b1624067));
$b4e14b6b8da86996$export$5375cda95f0b0eb4.registerRouteDEPRECATED("/devices/register/fencealarm", (0, $ad9322608265fad6$export$f42f16a7fbcea33a));
$b4e14b6b8da86996$export$5375cda95f0b0eb4.registerRouteDEPRECATED("/devices/register/fencealarm2", (0, $f03ad35c8320b7fa$export$ef64baa32f7512e2));
$b4e14b6b8da86996$export$5375cda95f0b0eb4.registerRouteDEPRECATED("/devices/register/smartplug", (0, $95286bbf49011b6d$export$3d3c90e1eea7f2cc));
$b4e14b6b8da86996$export$5375cda95f0b0eb4.registerRouteDEPRECATED("/devices/register/smartplug2", (0, $0008090773e1daad$export$ac86a722f7b1b5e0));
$b4e14b6b8da86996$export$5375cda95f0b0eb4.registerRoute("/factory/smartplug2", (0, $c06c704695069218$export$3399e6b2f1da25c4));
$b4e14b6b8da86996$export$5375cda95f0b0eb4.registerRoute("/factory/smartplug2/:imei/commands", (0, $f58c51c1a61b9100$export$df5b88f0fecf4aef));
$b4e14b6b8da86996$export$5375cda95f0b0eb4.registerRoute("/factory/smartplug2/:imei/commands/get-fw", (0, $1d048916aceaba52$export$b4b994913925bd7e));
$b4e14b6b8da86996$export$5375cda95f0b0eb4.registerRoute("/factory/smartplug2/:imei/commands/get-imsi", (0, $13b5455f0badc26e$export$8fa709b0c81fd217));
$b4e14b6b8da86996$export$5375cda95f0b0eb4.registerRoute("/factory/smartplug2/:imei/commands/get-status", (0, $932eaea913f3b65c$export$a0a0e176524a64a3));
$b4e14b6b8da86996$export$5375cda95f0b0eb4.registerRoute("/factory/smartplug2/:imei/commands/set-beep", (0, $02e22fcc04c0651e$export$def93f6827894543));
$b4e14b6b8da86996$export$5375cda95f0b0eb4.registerRoute("/factory/smartplug2/:imei/commands/set-fw", (0, $10f7bb9b74801a59$export$8b5cc62853ca8b14));
$b4e14b6b8da86996$export$5375cda95f0b0eb4.registerRoute("/factory/smartplug2/:imei/commands/set-load-alarm", (0, $c3385788c5d5eaad$export$81c4e74f8c5aeea8));
$b4e14b6b8da86996$export$5375cda95f0b0eb4.registerRoute("/factory/smartplug2/:imei/commands/set-output-power", (0, $92a80bd938ac62eb$export$85bbeacb1e558988));
$b4e14b6b8da86996$export$5375cda95f0b0eb4.registerRoute("/factory/smartplug2/:imei/provision", (0, $4af087a6d6aa0cbc$export$20463a7433df84f6));
$b4e14b6b8da86996$export$5375cda95f0b0eb4.registerRouteDEPRECATED("/farmcam-sim/:imsi", (0, $4b1c2404e48b4d55$export$2075b11bd097590f));
$b4e14b6b8da86996$export$5375cda95f0b0eb4.registerRouteDEPRECATED("/farmcam-sim/:imsi/logs", (0, $023fd85b9845aa5f$export$5eacbdba33a4a55b));
$b4e14b6b8da86996$export$5375cda95f0b0eb4.registerRouteDEPRECATED("/fencealarm/:imei", (0, $923c6e19f10de8cd$export$c50a4a29f5fa0ed1));
$b4e14b6b8da86996$export$5375cda95f0b0eb4.registerRouteDEPRECATED("/fencealarm/:imei/logs", (0, $fcaa56487d5a303a$export$eaf6b67947c3990e));
$b4e14b6b8da86996$export$5375cda95f0b0eb4.registerRouteDEPRECATED("/fencealarm2/:imei", (0, $d642dbca17452284$export$f105b8f7080dc9b6));
$b4e14b6b8da86996$export$5375cda95f0b0eb4.registerRouteDEPRECATED("/fencealarm2/:imei/logs", (0, $33c6fd7908b7dc89$export$264a6a03855ffdf6));
$b4e14b6b8da86996$export$5375cda95f0b0eb4.registerRouteDEPRECATED("/redirect", (0, $c5ee9d71404d146f$export$2d3f8d507b48559).mount, {
    leave: (0, $c5ee9d71404d146f$export$2d3f8d507b48559).onUnmount
});
$b4e14b6b8da86996$export$5375cda95f0b0eb4.registerRouteDEPRECATED("/reset-password", (0, $7b0f0753d23a5bbe$export$de4f09346a474704));
$b4e14b6b8da86996$export$5375cda95f0b0eb4.registerRouteDEPRECATED("/sign-in", (0, $fa3a5fe17cfe0327$export$f150117fa567a868));
$b4e14b6b8da86996$export$5375cda95f0b0eb4.registerRouteDEPRECATED("/smartplug/:imei", (0, $ff17f5778500d951$export$c6bfd9ad00ad21f9));
$b4e14b6b8da86996$export$5375cda95f0b0eb4.registerRouteDEPRECATED("/smartplug/:imei/logs", (0, $10153412815efc31$export$e2d14fb705b7b352));
$b4e14b6b8da86996$export$5375cda95f0b0eb4.registerRoute("/smartplug2/:imei", (0, $8297bd499f454863$export$b79bc3536207ad4c));
$b4e14b6b8da86996$export$5375cda95f0b0eb4.registerRoute("/smartplug2/:imei/logs", (0, $09613cb0ab15ef4d$export$5a20d7b75f983ef7));
$b4e14b6b8da86996$export$5375cda95f0b0eb4.registerRouteDEPRECATED("/verify-account", (0, $99ee0c4dd1affd10$export$cc5b19a94aa6c250));
$b4e14b6b8da86996$export$5375cda95f0b0eb4.registerRouteDEPRECATED("/warranties", $b4e14b6b8da86996$var$handler((0, $2bf615888d3a6bbe$export$1689915c29e5bc8)));
$b4e14b6b8da86996$var$init();
function $b4e14b6b8da86996$export$d91ec774a0e3eb9e() {
    $b4e14b6b8da86996$var$loadingScreen.classList.remove("is-active");
}
async function $b4e14b6b8da86996$var$init() {
    setTimeout(()=>(0, $e5872e05a705af44$export$8717f78bb40a9548).hide(), 600);
    await (0, $093d22e30b803c56$export$162ce11d62a1ca51).update();
    await (0, $1d17319f79c68be8$export$a6277d66d891fee0)();
    if (0, $1d17319f79c68be8$export$d70a5ce4bc79c42d) {
        (0, $1d17319f79c68be8$export$e66a2914cd52b9ef)();
        /**
		 * It takes a while for the app to pick up the initial notification which we need before
		 * before navigating to devices. This will give the notification time to load before
		 * proceeding.
		 */ if (!(0, $1d17319f79c68be8$export$273fb6590fc80197).getValue("appFinishedLoading")) // ToDo: Check if 500 ms can be decreased
        await (0, $820877bea407f5fe$export$1391212d75b2ee65)(500);
    }
    const preloads = [
        (0, $26a5802c7b7183d2$export$41303c5fee299aff)()
    ];
    (0, $1d17319f79c68be8$export$273fb6590fc80197).setValue("appFinishedLoading", true);
    if (await (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).isSignedIn()) {
        preloads.push((0, $1cfcaaa9e36e40b3$export$c542b5e295206b2a)().then((0, $bfc59006cf644cf7$export$ca000e230c0caa3e).loadDevices));
        switch(window.location.pathname){
            case "/":
            case "/create-account":
            case "/devices":
            case "/reset-password":
            case "/sign-in":
            case "/verify-account":
                {
                    const imei = (0, $1d17319f79c68be8$export$974358a537b1f4c)()?.data?.Imei;
                    const user = await (0, $bfc59006cf644cf7$export$ca000e230c0caa3e).getSignedInUser();
                    if (imei) window.history.replaceState(null, "", `/devices?id=${imei}`);
                    else if (user.AccountType === "smartplug2-factory") window.history.replaceState(null, "", "/factory/smartplug2");
                    else window.history.replaceState(null, "", "/devices");
                }
        }
    } else switch(window.location.pathname){
        case "/create-account":
        case "/reset-password":
        case "/sign-in":
        case "/smartplug2-provisioning":
        case "/verify-account":
            break;
        default:
            window.history.replaceState(null, "", "/sign-in");
    }
    await Promise.all(preloads).catch(()=>{
        window.history.pushState(null, "", "/connection-error");
    });
    $b4e14b6b8da86996$export$5375cda95f0b0eb4.resolve();
}
function $b4e14b6b8da86996$export$850e0ce216eef646() {
    $b4e14b6b8da86996$var$loadingScreen.classList.add("is-active");
    $b4e14b6b8da86996$export$96e4b36520c26a2c.close();
    const job = ()=>$b4e14b6b8da86996$export$d91ec774a0e3eb9e();
    setTimeout(job, 30000);
}
function $b4e14b6b8da86996$var$handler(getRoot) {
    return (match)=>{
        if (!match) return;
        getRoot(match).then((root)=>$b4e14b6b8da86996$export$8390d50e515c191d(root));
    };
}
function $b4e14b6b8da86996$export$8390d50e515c191d(childDom) {
    const mountPageContent = async (childDom)=>{
        $b4e14b6b8da86996$export$4dd468714b60fb1.replaceChildren(await (0, $47bf247eb1c33a5a$export$58733aaf927c3bbe)((0, $46d03d54faf4cdf4$export$e506a1d27d1eaa20).navbarTheme), await (0, $6cfab0c934c7a79b$export$2ff8a5b59054623b)(), (0, $6d068560d6a0dc33$export$9bf88dd34cb662bf).hero(childDom));
    };
    mountPageContent(childDom).finally($b4e14b6b8da86996$export$d91ec774a0e3eb9e);
}


//# sourceMappingURL=workdir.e9bf1991.js.map
